
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("dQwsT", function(module, exports) {
'use strict';

module.exports = (parcelRequire("8lYuY"));

});
parcelRegister("8lYuY", function(module, exports) {
$parcel$export(module.exports, "Children", () => $614f36a12f92b3f7$export$dca3b0875bd9a954, (v) => $614f36a12f92b3f7$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $614f36a12f92b3f7$export$16fa2f45be04daa8, (v) => $614f36a12f92b3f7$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $614f36a12f92b3f7$export$ffb0004e005737fa, (v) => $614f36a12f92b3f7$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $614f36a12f92b3f7$export$e2c29f18771995cb, (v) => $614f36a12f92b3f7$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $614f36a12f92b3f7$export$221d75b3f55bb0bd, (v) => $614f36a12f92b3f7$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $614f36a12f92b3f7$export$5f8d39834fd61797, (v) => $614f36a12f92b3f7$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $614f36a12f92b3f7$export$74bf444e3cd11ea5, (v) => $614f36a12f92b3f7$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $614f36a12f92b3f7$export$ae55be85d98224ed, (v) => $614f36a12f92b3f7$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $614f36a12f92b3f7$export$3ba232387fd5d6dd, (v) => $614f36a12f92b3f7$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $614f36a12f92b3f7$export$e530037191fcd5d7, (v) => $614f36a12f92b3f7$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $614f36a12f92b3f7$export$fd42f52fd3ae1109, (v) => $614f36a12f92b3f7$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $614f36a12f92b3f7$export$c8a8987d4410bf2d, (v) => $614f36a12f92b3f7$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $614f36a12f92b3f7$export$d38cd72104c1f0e9, (v) => $614f36a12f92b3f7$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $614f36a12f92b3f7$export$7d1e3a5e95ceca43, (v) => $614f36a12f92b3f7$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $614f36a12f92b3f7$export$257a8862b851cb5b, (v) => $614f36a12f92b3f7$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $614f36a12f92b3f7$export$a8257692ac88316c, (v) => $614f36a12f92b3f7$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $614f36a12f92b3f7$export$488013bae63b21da, (v) => $614f36a12f92b3f7$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $614f36a12f92b3f7$export$7c73462e0d25e514, (v) => $614f36a12f92b3f7$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $614f36a12f92b3f7$export$7568632d0d33d16d, (v) => $614f36a12f92b3f7$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $614f36a12f92b3f7$export$88948ce120ea2619, (v) => $614f36a12f92b3f7$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $614f36a12f92b3f7$export$35808ee640e87ca7, (v) => $614f36a12f92b3f7$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $614f36a12f92b3f7$export$fae74005e78b1a27, (v) => $614f36a12f92b3f7$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $614f36a12f92b3f7$export$dc8fbce3eb94dc1e, (v) => $614f36a12f92b3f7$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $614f36a12f92b3f7$export$6a7bc4e911dc01cf, (v) => $614f36a12f92b3f7$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $614f36a12f92b3f7$export$6d9c69b0de29b591, (v) => $614f36a12f92b3f7$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $614f36a12f92b3f7$export$f680877a34711e37, (v) => $614f36a12f92b3f7$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $614f36a12f92b3f7$export$d5a552a76deda3c2, (v) => $614f36a12f92b3f7$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $614f36a12f92b3f7$export$aaabe4eda9ed9969, (v) => $614f36a12f92b3f7$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $614f36a12f92b3f7$export$e5c5a5f917a5871c, (v) => $614f36a12f92b3f7$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $614f36a12f92b3f7$export$1538c33de8887b59, (v) => $614f36a12f92b3f7$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $614f36a12f92b3f7$export$13e3392192263954, (v) => $614f36a12f92b3f7$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $614f36a12f92b3f7$export$b8f5890fc79d6aca, (v) => $614f36a12f92b3f7$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $614f36a12f92b3f7$export$60241385465d0a34, (v) => $614f36a12f92b3f7$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $614f36a12f92b3f7$export$306c0aa65ff9ec16, (v) => $614f36a12f92b3f7$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $614f36a12f92b3f7$export$7b286972b8d8ccbf, (v) => $614f36a12f92b3f7$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $614f36a12f92b3f7$export$83d89fbfd8236492, (v) => $614f36a12f92b3f7$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $614f36a12f92b3f7$export$dca3b0875bd9a954;
var $614f36a12f92b3f7$export$16fa2f45be04daa8;
var $614f36a12f92b3f7$export$ffb0004e005737fa;
var $614f36a12f92b3f7$export$e2c29f18771995cb;
var $614f36a12f92b3f7$export$221d75b3f55bb0bd;
var $614f36a12f92b3f7$export$5f8d39834fd61797;
var $614f36a12f92b3f7$export$74bf444e3cd11ea5;
var $614f36a12f92b3f7$export$ae55be85d98224ed;
var $614f36a12f92b3f7$export$3ba232387fd5d6dd;
var $614f36a12f92b3f7$export$e530037191fcd5d7;
var $614f36a12f92b3f7$export$fd42f52fd3ae1109;
var $614f36a12f92b3f7$export$c8a8987d4410bf2d;
var $614f36a12f92b3f7$export$d38cd72104c1f0e9;
var $614f36a12f92b3f7$export$7d1e3a5e95ceca43;
var $614f36a12f92b3f7$export$257a8862b851cb5b;
var $614f36a12f92b3f7$export$a8257692ac88316c;
var $614f36a12f92b3f7$export$488013bae63b21da;
var $614f36a12f92b3f7$export$7c73462e0d25e514;
var $614f36a12f92b3f7$export$7568632d0d33d16d;
var $614f36a12f92b3f7$export$88948ce120ea2619;
var $614f36a12f92b3f7$export$35808ee640e87ca7;
var $614f36a12f92b3f7$export$fae74005e78b1a27;
var $614f36a12f92b3f7$export$dc8fbce3eb94dc1e;
var $614f36a12f92b3f7$export$6a7bc4e911dc01cf;
var $614f36a12f92b3f7$export$6d9c69b0de29b591;
var $614f36a12f92b3f7$export$f680877a34711e37;
var $614f36a12f92b3f7$export$d5a552a76deda3c2;
var $614f36a12f92b3f7$export$aaabe4eda9ed9969;
var $614f36a12f92b3f7$export$e5c5a5f917a5871c;
var $614f36a12f92b3f7$export$1538c33de8887b59;
var $614f36a12f92b3f7$export$13e3392192263954;
var $614f36a12f92b3f7$export$b8f5890fc79d6aca;
var $614f36a12f92b3f7$export$60241385465d0a34;
var $614f36a12f92b3f7$export$306c0aa65ff9ec16;
var $614f36a12f92b3f7$export$7b286972b8d8ccbf;
var $614f36a12f92b3f7$export$83d89fbfd8236492;
'use strict';
var $614f36a12f92b3f7$var$l = Symbol.for("react.element"), $614f36a12f92b3f7$var$n = Symbol.for("react.portal"), $614f36a12f92b3f7$var$p = Symbol.for("react.fragment"), $614f36a12f92b3f7$var$q = Symbol.for("react.strict_mode"), $614f36a12f92b3f7$var$r = Symbol.for("react.profiler"), $614f36a12f92b3f7$var$t = Symbol.for("react.provider"), $614f36a12f92b3f7$var$u = Symbol.for("react.context"), $614f36a12f92b3f7$var$v = Symbol.for("react.forward_ref"), $614f36a12f92b3f7$var$w = Symbol.for("react.suspense"), $614f36a12f92b3f7$var$x = Symbol.for("react.memo"), $614f36a12f92b3f7$var$y = Symbol.for("react.lazy"), $614f36a12f92b3f7$var$z = Symbol.iterator;
function $614f36a12f92b3f7$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $614f36a12f92b3f7$var$z && a[$614f36a12f92b3f7$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $614f36a12f92b3f7$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $614f36a12f92b3f7$var$C = Object.assign, $614f36a12f92b3f7$var$D = {};
function $614f36a12f92b3f7$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $614f36a12f92b3f7$var$D;
    this.updater = e || $614f36a12f92b3f7$var$B;
}
$614f36a12f92b3f7$var$E.prototype.isReactComponent = {};
$614f36a12f92b3f7$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$614f36a12f92b3f7$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $614f36a12f92b3f7$var$F() {}
$614f36a12f92b3f7$var$F.prototype = $614f36a12f92b3f7$var$E.prototype;
function $614f36a12f92b3f7$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $614f36a12f92b3f7$var$D;
    this.updater = e || $614f36a12f92b3f7$var$B;
}
var $614f36a12f92b3f7$var$H = $614f36a12f92b3f7$var$G.prototype = new $614f36a12f92b3f7$var$F;
$614f36a12f92b3f7$var$H.constructor = $614f36a12f92b3f7$var$G;
$614f36a12f92b3f7$var$C($614f36a12f92b3f7$var$H, $614f36a12f92b3f7$var$E.prototype);
$614f36a12f92b3f7$var$H.isPureReactComponent = !0;
var $614f36a12f92b3f7$var$I = Array.isArray, $614f36a12f92b3f7$var$J = Object.prototype.hasOwnProperty, $614f36a12f92b3f7$var$K = {
    current: null
}, $614f36a12f92b3f7$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $614f36a12f92b3f7$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$614f36a12f92b3f7$var$J.call(b, d) && !$614f36a12f92b3f7$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $614f36a12f92b3f7$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $614f36a12f92b3f7$var$K.current
    };
}
function $614f36a12f92b3f7$var$N(a, b) {
    return {
        $$typeof: $614f36a12f92b3f7$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $614f36a12f92b3f7$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $614f36a12f92b3f7$var$l;
}
function $614f36a12f92b3f7$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $614f36a12f92b3f7$var$P = /\/+/g;
function $614f36a12f92b3f7$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $614f36a12f92b3f7$var$escape("" + a.key) : b.toString(36);
}
function $614f36a12f92b3f7$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $614f36a12f92b3f7$var$l:
                case $614f36a12f92b3f7$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $614f36a12f92b3f7$var$Q(h, 0) : d, $614f36a12f92b3f7$var$I(c) ? (e = "", null != a && (e = a.replace($614f36a12f92b3f7$var$P, "$&/") + "/"), $614f36a12f92b3f7$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($614f36a12f92b3f7$var$O(c) && (c = $614f36a12f92b3f7$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($614f36a12f92b3f7$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($614f36a12f92b3f7$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $614f36a12f92b3f7$var$Q(k, g);
        h += $614f36a12f92b3f7$var$R(k, b, e, f, c);
    }
    else if (f = $614f36a12f92b3f7$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $614f36a12f92b3f7$var$Q(k, g++), h += $614f36a12f92b3f7$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $614f36a12f92b3f7$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $614f36a12f92b3f7$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $614f36a12f92b3f7$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $614f36a12f92b3f7$var$U = {
    current: null
}, $614f36a12f92b3f7$var$V = {
    transition: null
}, $614f36a12f92b3f7$var$W = {
    ReactCurrentDispatcher: $614f36a12f92b3f7$var$U,
    ReactCurrentBatchConfig: $614f36a12f92b3f7$var$V,
    ReactCurrentOwner: $614f36a12f92b3f7$var$K
};
function $614f36a12f92b3f7$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$614f36a12f92b3f7$export$dca3b0875bd9a954 = {
    map: $614f36a12f92b3f7$var$S,
    forEach: function(a, b, e) {
        $614f36a12f92b3f7$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $614f36a12f92b3f7$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $614f36a12f92b3f7$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$614f36a12f92b3f7$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$614f36a12f92b3f7$export$16fa2f45be04daa8 = $614f36a12f92b3f7$var$E;
$614f36a12f92b3f7$export$ffb0004e005737fa = $614f36a12f92b3f7$var$p;
$614f36a12f92b3f7$export$e2c29f18771995cb = $614f36a12f92b3f7$var$r;
$614f36a12f92b3f7$export$221d75b3f55bb0bd = $614f36a12f92b3f7$var$G;
$614f36a12f92b3f7$export$5f8d39834fd61797 = $614f36a12f92b3f7$var$q;
$614f36a12f92b3f7$export$74bf444e3cd11ea5 = $614f36a12f92b3f7$var$w;
$614f36a12f92b3f7$export$ae55be85d98224ed = $614f36a12f92b3f7$var$W;
$614f36a12f92b3f7$export$3ba232387fd5d6dd = $614f36a12f92b3f7$var$X;
$614f36a12f92b3f7$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $614f36a12f92b3f7$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $614f36a12f92b3f7$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$614f36a12f92b3f7$var$J.call(b, f) && !$614f36a12f92b3f7$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $614f36a12f92b3f7$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$614f36a12f92b3f7$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $614f36a12f92b3f7$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $614f36a12f92b3f7$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$614f36a12f92b3f7$export$c8a8987d4410bf2d = $614f36a12f92b3f7$var$M;
$614f36a12f92b3f7$export$d38cd72104c1f0e9 = function(a) {
    var b = $614f36a12f92b3f7$var$M.bind(null, a);
    b.type = a;
    return b;
};
$614f36a12f92b3f7$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$614f36a12f92b3f7$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $614f36a12f92b3f7$var$v,
        render: a
    };
};
$614f36a12f92b3f7$export$a8257692ac88316c = $614f36a12f92b3f7$var$O;
$614f36a12f92b3f7$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $614f36a12f92b3f7$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $614f36a12f92b3f7$var$T
    };
};
$614f36a12f92b3f7$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $614f36a12f92b3f7$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$614f36a12f92b3f7$export$7568632d0d33d16d = function(a) {
    var b = $614f36a12f92b3f7$var$V.transition;
    $614f36a12f92b3f7$var$V.transition = {};
    try {
        a();
    } finally{
        $614f36a12f92b3f7$var$V.transition = b;
    }
};
$614f36a12f92b3f7$export$88948ce120ea2619 = $614f36a12f92b3f7$var$X;
$614f36a12f92b3f7$export$35808ee640e87ca7 = function(a, b) {
    return $614f36a12f92b3f7$var$U.current.useCallback(a, b);
};
$614f36a12f92b3f7$export$fae74005e78b1a27 = function(a) {
    return $614f36a12f92b3f7$var$U.current.useContext(a);
};
$614f36a12f92b3f7$export$dc8fbce3eb94dc1e = function() {};
$614f36a12f92b3f7$export$6a7bc4e911dc01cf = function(a) {
    return $614f36a12f92b3f7$var$U.current.useDeferredValue(a);
};
$614f36a12f92b3f7$export$6d9c69b0de29b591 = function(a, b) {
    return $614f36a12f92b3f7$var$U.current.useEffect(a, b);
};
$614f36a12f92b3f7$export$f680877a34711e37 = function() {
    return $614f36a12f92b3f7$var$U.current.useId();
};
$614f36a12f92b3f7$export$d5a552a76deda3c2 = function(a, b, e) {
    return $614f36a12f92b3f7$var$U.current.useImperativeHandle(a, b, e);
};
$614f36a12f92b3f7$export$aaabe4eda9ed9969 = function(a, b) {
    return $614f36a12f92b3f7$var$U.current.useInsertionEffect(a, b);
};
$614f36a12f92b3f7$export$e5c5a5f917a5871c = function(a, b) {
    return $614f36a12f92b3f7$var$U.current.useLayoutEffect(a, b);
};
$614f36a12f92b3f7$export$1538c33de8887b59 = function(a, b) {
    return $614f36a12f92b3f7$var$U.current.useMemo(a, b);
};
$614f36a12f92b3f7$export$13e3392192263954 = function(a, b, e) {
    return $614f36a12f92b3f7$var$U.current.useReducer(a, b, e);
};
$614f36a12f92b3f7$export$b8f5890fc79d6aca = function(a) {
    return $614f36a12f92b3f7$var$U.current.useRef(a);
};
$614f36a12f92b3f7$export$60241385465d0a34 = function(a) {
    return $614f36a12f92b3f7$var$U.current.useState(a);
};
$614f36a12f92b3f7$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $614f36a12f92b3f7$var$U.current.useSyncExternalStore(a, b, e);
};
$614f36a12f92b3f7$export$7b286972b8d8ccbf = function() {
    return $614f36a12f92b3f7$var$U.current.useTransition();
};
$614f36a12f92b3f7$export$83d89fbfd8236492 = "18.3.1";

});


parcelRegister("bNpl0", function(module, exports) {
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $8967ecdc07562ec4$export$ae55be85d98224ed, (v) => $8967ecdc07562ec4$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $8967ecdc07562ec4$export$d39a5bbd09211389, (v) => $8967ecdc07562ec4$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $8967ecdc07562ec4$export$882461b6382ed46c, (v) => $8967ecdc07562ec4$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $8967ecdc07562ec4$export$466bfc07425424d5, (v) => $8967ecdc07562ec4$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $8967ecdc07562ec4$export$cd75ccfd720a3cd4, (v) => $8967ecdc07562ec4$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $8967ecdc07562ec4$export$fa8d919ba61d84db, (v) => $8967ecdc07562ec4$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $8967ecdc07562ec4$export$757ceba2d55c277e, (v) => $8967ecdc07562ec4$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $8967ecdc07562ec4$export$b3890eb0ae9dca99, (v) => $8967ecdc07562ec4$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $8967ecdc07562ec4$export$502457920280e6be, (v) => $8967ecdc07562ec4$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $8967ecdc07562ec4$export$c78a37762a8d58e1, (v) => $8967ecdc07562ec4$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $8967ecdc07562ec4$export$dc54d992c10e8a18, (v) => $8967ecdc07562ec4$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $8967ecdc07562ec4$export$83d89fbfd8236492, (v) => $8967ecdc07562ec4$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.profiling.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8967ecdc07562ec4$export$ae55be85d98224ed;
var $8967ecdc07562ec4$export$d39a5bbd09211389;
var $8967ecdc07562ec4$export$882461b6382ed46c;
var $8967ecdc07562ec4$export$466bfc07425424d5;
var $8967ecdc07562ec4$export$cd75ccfd720a3cd4;
var $8967ecdc07562ec4$export$fa8d919ba61d84db;
var $8967ecdc07562ec4$export$757ceba2d55c277e;
var $8967ecdc07562ec4$export$b3890eb0ae9dca99;
var $8967ecdc07562ec4$export$502457920280e6be;
var $8967ecdc07562ec4$export$c78a37762a8d58e1;
var $8967ecdc07562ec4$export$dc54d992c10e8a18;
var $8967ecdc07562ec4$export$83d89fbfd8236492;
'use strict';
/* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === 'function') __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';

var $dQwsT = parcelRequire("dQwsT");

var $LXjOh = parcelRequire("LXjOh");
function $8967ecdc07562ec4$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $8967ecdc07562ec4$var$da = new Set, $8967ecdc07562ec4$var$ea = {};
function $8967ecdc07562ec4$var$fa(a, b) {
    $8967ecdc07562ec4$var$ha(a, b);
    $8967ecdc07562ec4$var$ha(a + "Capture", b);
}
function $8967ecdc07562ec4$var$ha(a, b) {
    $8967ecdc07562ec4$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$8967ecdc07562ec4$var$da.add(b[a]);
}
var $8967ecdc07562ec4$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $8967ecdc07562ec4$var$ja = Object.prototype.hasOwnProperty, $8967ecdc07562ec4$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $8967ecdc07562ec4$var$la = {}, $8967ecdc07562ec4$var$ma = {};
function $8967ecdc07562ec4$var$na(a) {
    if ($8967ecdc07562ec4$var$ja.call($8967ecdc07562ec4$var$ma, a)) return !0;
    if ($8967ecdc07562ec4$var$ja.call($8967ecdc07562ec4$var$la, a)) return !1;
    if ($8967ecdc07562ec4$var$ka.test(a)) return $8967ecdc07562ec4$var$ma[a] = !0;
    $8967ecdc07562ec4$var$la[a] = !0;
    return !1;
}
function $8967ecdc07562ec4$var$oa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $8967ecdc07562ec4$var$pa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $8967ecdc07562ec4$var$oa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $8967ecdc07562ec4$var$qa(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $8967ecdc07562ec4$var$t = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $8967ecdc07562ec4$var$t[a] = new $8967ecdc07562ec4$var$qa(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $8967ecdc07562ec4$var$t[b] = new $8967ecdc07562ec4$var$qa(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $8967ecdc07562ec4$var$t[a] = new $8967ecdc07562ec4$var$qa(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $8967ecdc07562ec4$var$t[a] = new $8967ecdc07562ec4$var$qa(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $8967ecdc07562ec4$var$t[a] = new $8967ecdc07562ec4$var$qa(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $8967ecdc07562ec4$var$t[a] = new $8967ecdc07562ec4$var$qa(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $8967ecdc07562ec4$var$t[a] = new $8967ecdc07562ec4$var$qa(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $8967ecdc07562ec4$var$t[a] = new $8967ecdc07562ec4$var$qa(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $8967ecdc07562ec4$var$t[a] = new $8967ecdc07562ec4$var$qa(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $8967ecdc07562ec4$var$ra = /[\-:]([a-z])/g;
function $8967ecdc07562ec4$var$ta(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($8967ecdc07562ec4$var$ra, $8967ecdc07562ec4$var$ta);
    $8967ecdc07562ec4$var$t[b] = new $8967ecdc07562ec4$var$qa(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($8967ecdc07562ec4$var$ra, $8967ecdc07562ec4$var$ta);
    $8967ecdc07562ec4$var$t[b] = new $8967ecdc07562ec4$var$qa(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($8967ecdc07562ec4$var$ra, $8967ecdc07562ec4$var$ta);
    $8967ecdc07562ec4$var$t[b] = new $8967ecdc07562ec4$var$qa(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $8967ecdc07562ec4$var$t[a] = new $8967ecdc07562ec4$var$qa(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$8967ecdc07562ec4$var$t.xlinkHref = new $8967ecdc07562ec4$var$qa("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $8967ecdc07562ec4$var$t[a] = new $8967ecdc07562ec4$var$qa(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $8967ecdc07562ec4$var$ua(a, b, c, d) {
    var e = $8967ecdc07562ec4$var$t.hasOwnProperty(b) ? $8967ecdc07562ec4$var$t[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $8967ecdc07562ec4$var$pa(b, c, e, d) && (c = null), d || null === e ? $8967ecdc07562ec4$var$na(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $8967ecdc07562ec4$var$va = $dQwsT.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $8967ecdc07562ec4$var$wa = Symbol.for("react.element"), $8967ecdc07562ec4$var$xa = Symbol.for("react.portal"), $8967ecdc07562ec4$var$ya = Symbol.for("react.fragment"), $8967ecdc07562ec4$var$za = Symbol.for("react.strict_mode"), $8967ecdc07562ec4$var$Aa = Symbol.for("react.profiler"), $8967ecdc07562ec4$var$Ba = Symbol.for("react.provider"), $8967ecdc07562ec4$var$Ca = Symbol.for("react.context"), $8967ecdc07562ec4$var$Da = Symbol.for("react.forward_ref"), $8967ecdc07562ec4$var$Ea = Symbol.for("react.suspense"), $8967ecdc07562ec4$var$Fa = Symbol.for("react.suspense_list"), $8967ecdc07562ec4$var$Ga = Symbol.for("react.memo"), $8967ecdc07562ec4$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $8967ecdc07562ec4$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $8967ecdc07562ec4$var$Ja = Symbol.iterator;
function $8967ecdc07562ec4$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $8967ecdc07562ec4$var$Ja && a[$8967ecdc07562ec4$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $8967ecdc07562ec4$var$u = Object.assign, $8967ecdc07562ec4$var$La;
function $8967ecdc07562ec4$var$Ma(a) {
    if (void 0 === $8967ecdc07562ec4$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $8967ecdc07562ec4$var$La = b && b[1] || "";
    }
    return "\n" + $8967ecdc07562ec4$var$La + a;
}
var $8967ecdc07562ec4$var$Na = !1;
function $8967ecdc07562ec4$var$Oa(a, b) {
    if (!a || $8967ecdc07562ec4$var$Na) return "";
    $8967ecdc07562ec4$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $8967ecdc07562ec4$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $8967ecdc07562ec4$var$Ma(a) : "";
}
function $8967ecdc07562ec4$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $8967ecdc07562ec4$var$Ma(a.type);
        case 16:
            return $8967ecdc07562ec4$var$Ma("Lazy");
        case 13:
            return $8967ecdc07562ec4$var$Ma("Suspense");
        case 19:
            return $8967ecdc07562ec4$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $8967ecdc07562ec4$var$Oa(a.type, !1), a;
        case 11:
            return a = $8967ecdc07562ec4$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $8967ecdc07562ec4$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $8967ecdc07562ec4$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $8967ecdc07562ec4$var$ya:
            return "Fragment";
        case $8967ecdc07562ec4$var$xa:
            return "Portal";
        case $8967ecdc07562ec4$var$Aa:
            return "Profiler";
        case $8967ecdc07562ec4$var$za:
            return "StrictMode";
        case $8967ecdc07562ec4$var$Ea:
            return "Suspense";
        case $8967ecdc07562ec4$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $8967ecdc07562ec4$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $8967ecdc07562ec4$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $8967ecdc07562ec4$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $8967ecdc07562ec4$var$Ga:
            return b = a.displayName || null, null !== b ? b : $8967ecdc07562ec4$var$Qa(a.type) || "Memo";
        case $8967ecdc07562ec4$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $8967ecdc07562ec4$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $8967ecdc07562ec4$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $8967ecdc07562ec4$var$Qa(b);
        case 8:
            return b === $8967ecdc07562ec4$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $8967ecdc07562ec4$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $8967ecdc07562ec4$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $8967ecdc07562ec4$var$Ua(a) {
    var b = $8967ecdc07562ec4$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $8967ecdc07562ec4$var$Va(a) {
    a._valueTracker || (a._valueTracker = $8967ecdc07562ec4$var$Ua(a));
}
function $8967ecdc07562ec4$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $8967ecdc07562ec4$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $8967ecdc07562ec4$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $8967ecdc07562ec4$var$Ya(a, b) {
    var c = b.checked;
    return $8967ecdc07562ec4$var$u({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $8967ecdc07562ec4$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $8967ecdc07562ec4$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $8967ecdc07562ec4$var$$a(a, b) {
    b = b.checked;
    null != b && $8967ecdc07562ec4$var$ua(a, "checked", b, !1);
}
function $8967ecdc07562ec4$var$ab(a, b) {
    $8967ecdc07562ec4$var$$a(a, b);
    var c = $8967ecdc07562ec4$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $8967ecdc07562ec4$var$bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $8967ecdc07562ec4$var$bb(a, b.type, $8967ecdc07562ec4$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $8967ecdc07562ec4$var$cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $8967ecdc07562ec4$var$bb(a, b, c) {
    if ("number" !== b || $8967ecdc07562ec4$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $8967ecdc07562ec4$var$db = Array.isArray;
function $8967ecdc07562ec4$var$eb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $8967ecdc07562ec4$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $8967ecdc07562ec4$var$fb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($8967ecdc07562ec4$var$p(91));
    return $8967ecdc07562ec4$var$u({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $8967ecdc07562ec4$var$gb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($8967ecdc07562ec4$var$p(92));
            if ($8967ecdc07562ec4$var$db(c)) {
                if (1 < c.length) throw Error($8967ecdc07562ec4$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $8967ecdc07562ec4$var$Sa(c)
    };
}
function $8967ecdc07562ec4$var$hb(a, b) {
    var c = $8967ecdc07562ec4$var$Sa(b.value), d = $8967ecdc07562ec4$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $8967ecdc07562ec4$var$ib(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $8967ecdc07562ec4$var$jb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $8967ecdc07562ec4$var$kb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $8967ecdc07562ec4$var$jb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $8967ecdc07562ec4$var$mb, $8967ecdc07562ec4$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $8967ecdc07562ec4$var$mb = $8967ecdc07562ec4$var$mb || document.createElement("div");
        $8967ecdc07562ec4$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $8967ecdc07562ec4$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $8967ecdc07562ec4$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $8967ecdc07562ec4$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $8967ecdc07562ec4$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($8967ecdc07562ec4$var$pb).forEach(function(a) {
    $8967ecdc07562ec4$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $8967ecdc07562ec4$var$pb[b] = $8967ecdc07562ec4$var$pb[a];
    });
});
function $8967ecdc07562ec4$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $8967ecdc07562ec4$var$pb.hasOwnProperty(a) && $8967ecdc07562ec4$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $8967ecdc07562ec4$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $8967ecdc07562ec4$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $8967ecdc07562ec4$var$tb = $8967ecdc07562ec4$var$u({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $8967ecdc07562ec4$var$ub(a, b) {
    if (b) {
        if ($8967ecdc07562ec4$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($8967ecdc07562ec4$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($8967ecdc07562ec4$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($8967ecdc07562ec4$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($8967ecdc07562ec4$var$p(62));
    }
}
function $8967ecdc07562ec4$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $8967ecdc07562ec4$var$wb = null;
function $8967ecdc07562ec4$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $8967ecdc07562ec4$var$yb = null, $8967ecdc07562ec4$var$zb = null, $8967ecdc07562ec4$var$Ab = null;
function $8967ecdc07562ec4$var$Bb(a) {
    if (a = $8967ecdc07562ec4$var$Cb(a)) {
        if ("function" !== typeof $8967ecdc07562ec4$var$yb) throw Error($8967ecdc07562ec4$var$p(280));
        var b = a.stateNode;
        b && (b = $8967ecdc07562ec4$var$Db(b), $8967ecdc07562ec4$var$yb(a.stateNode, a.type, b));
    }
}
function $8967ecdc07562ec4$var$Eb(a) {
    $8967ecdc07562ec4$var$zb ? $8967ecdc07562ec4$var$Ab ? $8967ecdc07562ec4$var$Ab.push(a) : $8967ecdc07562ec4$var$Ab = [
        a
    ] : $8967ecdc07562ec4$var$zb = a;
}
function $8967ecdc07562ec4$var$Fb() {
    if ($8967ecdc07562ec4$var$zb) {
        var a = $8967ecdc07562ec4$var$zb, b = $8967ecdc07562ec4$var$Ab;
        $8967ecdc07562ec4$var$Ab = $8967ecdc07562ec4$var$zb = null;
        $8967ecdc07562ec4$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$8967ecdc07562ec4$var$Bb(b[a]);
    }
}
function $8967ecdc07562ec4$var$Gb(a, b) {
    return a(b);
}
function $8967ecdc07562ec4$var$Hb() {}
var $8967ecdc07562ec4$var$Ib = !1;
function $8967ecdc07562ec4$var$Jb(a, b, c) {
    if ($8967ecdc07562ec4$var$Ib) return a(b, c);
    $8967ecdc07562ec4$var$Ib = !0;
    try {
        return $8967ecdc07562ec4$var$Gb(a, b, c);
    } finally{
        if ($8967ecdc07562ec4$var$Ib = !1, null !== $8967ecdc07562ec4$var$zb || null !== $8967ecdc07562ec4$var$Ab) $8967ecdc07562ec4$var$Hb(), $8967ecdc07562ec4$var$Fb();
    }
}
function $8967ecdc07562ec4$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $8967ecdc07562ec4$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($8967ecdc07562ec4$var$p(231, b, typeof c));
    return c;
}
var $8967ecdc07562ec4$var$Lb = !1;
if ($8967ecdc07562ec4$var$ia) try {
    var $8967ecdc07562ec4$var$Mb = {};
    Object.defineProperty($8967ecdc07562ec4$var$Mb, "passive", {
        get: function() {
            $8967ecdc07562ec4$var$Lb = !0;
        }
    });
    window.addEventListener("test", $8967ecdc07562ec4$var$Mb, $8967ecdc07562ec4$var$Mb);
    window.removeEventListener("test", $8967ecdc07562ec4$var$Mb, $8967ecdc07562ec4$var$Mb);
} catch (a) {
    $8967ecdc07562ec4$var$Lb = !1;
}
function $8967ecdc07562ec4$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var $8967ecdc07562ec4$var$Ob = !1, $8967ecdc07562ec4$var$Pb = null, $8967ecdc07562ec4$var$Qb = !1, $8967ecdc07562ec4$var$Rb = null, $8967ecdc07562ec4$var$Sb = {
    onError: function(a) {
        $8967ecdc07562ec4$var$Ob = !0;
        $8967ecdc07562ec4$var$Pb = a;
    }
};
function $8967ecdc07562ec4$var$Tb(a, b, c, d, e, f, g, h, k) {
    $8967ecdc07562ec4$var$Ob = !1;
    $8967ecdc07562ec4$var$Pb = null;
    $8967ecdc07562ec4$var$Nb.apply($8967ecdc07562ec4$var$Sb, arguments);
}
function $8967ecdc07562ec4$var$Ub(a, b, c, d, e, f, g, h, k) {
    $8967ecdc07562ec4$var$Tb.apply(this, arguments);
    if ($8967ecdc07562ec4$var$Ob) {
        if ($8967ecdc07562ec4$var$Ob) {
            var l = $8967ecdc07562ec4$var$Pb;
            $8967ecdc07562ec4$var$Ob = !1;
            $8967ecdc07562ec4$var$Pb = null;
        } else throw Error($8967ecdc07562ec4$var$p(198));
        $8967ecdc07562ec4$var$Qb || ($8967ecdc07562ec4$var$Qb = !0, $8967ecdc07562ec4$var$Rb = l);
    }
}
function $8967ecdc07562ec4$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $8967ecdc07562ec4$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $8967ecdc07562ec4$var$Xb(a) {
    if ($8967ecdc07562ec4$var$Vb(a) !== a) throw Error($8967ecdc07562ec4$var$p(188));
}
function $8967ecdc07562ec4$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $8967ecdc07562ec4$var$Vb(a);
        if (null === b) throw Error($8967ecdc07562ec4$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $8967ecdc07562ec4$var$Xb(e), a;
                if (f === d) return $8967ecdc07562ec4$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($8967ecdc07562ec4$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($8967ecdc07562ec4$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($8967ecdc07562ec4$var$p(190));
    }
    if (3 !== c.tag) throw Error($8967ecdc07562ec4$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $8967ecdc07562ec4$var$Zb(a) {
    a = $8967ecdc07562ec4$var$Yb(a);
    return null !== a ? $8967ecdc07562ec4$var$$b(a) : null;
}
function $8967ecdc07562ec4$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $8967ecdc07562ec4$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $8967ecdc07562ec4$var$ac = $LXjOh.unstable_scheduleCallback, $8967ecdc07562ec4$var$bc = $LXjOh.unstable_cancelCallback, $8967ecdc07562ec4$var$cc = $LXjOh.unstable_shouldYield, $8967ecdc07562ec4$var$dc = $LXjOh.unstable_requestPaint, $8967ecdc07562ec4$var$A = $LXjOh.unstable_now, $8967ecdc07562ec4$var$ec = $LXjOh.unstable_getCurrentPriorityLevel, $8967ecdc07562ec4$var$fc = $LXjOh.unstable_ImmediatePriority, $8967ecdc07562ec4$var$gc = $LXjOh.unstable_UserBlockingPriority, $8967ecdc07562ec4$var$hc = $LXjOh.unstable_NormalPriority, $8967ecdc07562ec4$var$ic = $LXjOh.unstable_LowPriority, $8967ecdc07562ec4$var$jc = $LXjOh.unstable_IdlePriority, $8967ecdc07562ec4$var$kc = null, $8967ecdc07562ec4$var$lc = null, $8967ecdc07562ec4$var$B = null, $8967ecdc07562ec4$var$mc = "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__;
function $8967ecdc07562ec4$var$nc(a, b) {
    if ($8967ecdc07562ec4$var$lc && "function" === typeof $8967ecdc07562ec4$var$lc.onCommitFiberRoot) try {
        var c = 128 === (a.current.flags & 128);
        switch(b){
            case 1:
                var d = $8967ecdc07562ec4$var$fc;
                break;
            case 4:
                d = $8967ecdc07562ec4$var$gc;
                break;
            case 16:
                d = $8967ecdc07562ec4$var$hc;
                break;
            case 536870912:
                d = $8967ecdc07562ec4$var$jc;
                break;
            default:
                d = $8967ecdc07562ec4$var$hc;
        }
        $8967ecdc07562ec4$var$lc.onCommitFiberRoot($8967ecdc07562ec4$var$kc, a, d, c);
    } catch (e) {}
}
function $8967ecdc07562ec4$var$oc(a) {
    $8967ecdc07562ec4$var$B = a;
}
function $8967ecdc07562ec4$var$pc() {
    for(var a = new Map, b = 1, c = 0; 31 > c; c++){
        var d = $8967ecdc07562ec4$var$qc(b);
        a.set(b, d);
        b *= 2;
    }
    return a;
}
function $8967ecdc07562ec4$var$rc() {
    null !== $8967ecdc07562ec4$var$B && "function" === typeof $8967ecdc07562ec4$var$B.markCommitStopped && $8967ecdc07562ec4$var$B.markCommitStopped();
}
function $8967ecdc07562ec4$var$sc(a) {
    null !== $8967ecdc07562ec4$var$B && "function" === typeof $8967ecdc07562ec4$var$B.markComponentRenderStarted && $8967ecdc07562ec4$var$B.markComponentRenderStarted(a);
}
function $8967ecdc07562ec4$var$tc() {
    null !== $8967ecdc07562ec4$var$B && "function" === typeof $8967ecdc07562ec4$var$B.markComponentRenderStopped && $8967ecdc07562ec4$var$B.markComponentRenderStopped();
}
function $8967ecdc07562ec4$var$uc(a) {
    null !== $8967ecdc07562ec4$var$B && "function" === typeof $8967ecdc07562ec4$var$B.markComponentLayoutEffectUnmountStarted && $8967ecdc07562ec4$var$B.markComponentLayoutEffectUnmountStarted(a);
}
function $8967ecdc07562ec4$var$vc() {
    null !== $8967ecdc07562ec4$var$B && "function" === typeof $8967ecdc07562ec4$var$B.markComponentLayoutEffectUnmountStopped && $8967ecdc07562ec4$var$B.markComponentLayoutEffectUnmountStopped();
}
function $8967ecdc07562ec4$var$wc(a) {
    null !== $8967ecdc07562ec4$var$B && "function" === typeof $8967ecdc07562ec4$var$B.markRenderStarted && $8967ecdc07562ec4$var$B.markRenderStarted(a);
}
function $8967ecdc07562ec4$var$xc() {
    null !== $8967ecdc07562ec4$var$B && "function" === typeof $8967ecdc07562ec4$var$B.markRenderStopped && $8967ecdc07562ec4$var$B.markRenderStopped();
}
function $8967ecdc07562ec4$var$yc(a, b) {
    null !== $8967ecdc07562ec4$var$B && "function" === typeof $8967ecdc07562ec4$var$B.markStateUpdateScheduled && $8967ecdc07562ec4$var$B.markStateUpdateScheduled(a, b);
}
var $8967ecdc07562ec4$var$Ac = Math.clz32 ? Math.clz32 : $8967ecdc07562ec4$var$zc, $8967ecdc07562ec4$var$Bc = Math.log, $8967ecdc07562ec4$var$Cc = Math.LN2;
function $8967ecdc07562ec4$var$zc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($8967ecdc07562ec4$var$Bc(a) / $8967ecdc07562ec4$var$Cc | 0) | 0;
}
function $8967ecdc07562ec4$var$qc(a) {
    if (a & 1) return "Sync";
    if (a & 2) return "InputContinuousHydration";
    if (a & 4) return "InputContinuous";
    if (a & 8) return "DefaultHydration";
    if (a & 16) return "Default";
    if (a & 32) return "TransitionHydration";
    if (a & 4194240) return "Transition";
    if (a & 130023424) return "Retry";
    if (a & 134217728) return "SelectiveHydration";
    if (a & 268435456) return "IdleHydration";
    if (a & 536870912) return "Idle";
    if (a & 1073741824) return "Offscreen";
}
var $8967ecdc07562ec4$var$Dc = 64, $8967ecdc07562ec4$var$Ec = 4194304;
function $8967ecdc07562ec4$var$Fc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $8967ecdc07562ec4$var$Gc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $8967ecdc07562ec4$var$Fc(h) : (f &= g, 0 !== f && (d = $8967ecdc07562ec4$var$Fc(f)));
    } else g = c & ~e, 0 !== g ? d = $8967ecdc07562ec4$var$Fc(g) : 0 !== f && (d = $8967ecdc07562ec4$var$Fc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $8967ecdc07562ec4$var$Ac(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $8967ecdc07562ec4$var$Hc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $8967ecdc07562ec4$var$Ic(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $8967ecdc07562ec4$var$Ac(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $8967ecdc07562ec4$var$Hc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $8967ecdc07562ec4$var$Jc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $8967ecdc07562ec4$var$Kc() {
    var a = $8967ecdc07562ec4$var$Dc;
    $8967ecdc07562ec4$var$Dc <<= 1;
    0 === ($8967ecdc07562ec4$var$Dc & 4194240) && ($8967ecdc07562ec4$var$Dc = 64);
    return a;
}
function $8967ecdc07562ec4$var$Lc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $8967ecdc07562ec4$var$Mc(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $8967ecdc07562ec4$var$Ac(b);
    a[b] = c;
}
function $8967ecdc07562ec4$var$Nc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $8967ecdc07562ec4$var$Ac(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $8967ecdc07562ec4$var$Oc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $8967ecdc07562ec4$var$Ac(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
function $8967ecdc07562ec4$var$Pc(a, b, c) {
    if ($8967ecdc07562ec4$var$mc) for(a = a.pendingUpdatersLaneMap; 0 < c;){
        var d = 31 - $8967ecdc07562ec4$var$Ac(c), e = 1 << d;
        a[d].add(b);
        c &= ~e;
    }
}
function $8967ecdc07562ec4$var$Qc(a, b) {
    if ($8967ecdc07562ec4$var$mc) for(var c = a.pendingUpdatersLaneMap, d = a.memoizedUpdaters; 0 < b;){
        var e = 31 - $8967ecdc07562ec4$var$Ac(b);
        a = 1 << e;
        e = c[e];
        0 < e.size && (e.forEach(function(a) {
            var b = a.alternate;
            null !== b && d.has(b) || d.add(a);
        }), e.clear());
        b &= ~a;
    }
}
var $8967ecdc07562ec4$var$E = 0;
function $8967ecdc07562ec4$var$Rc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $8967ecdc07562ec4$var$Sc, $8967ecdc07562ec4$var$Tc, $8967ecdc07562ec4$var$Uc, $8967ecdc07562ec4$var$Vc, $8967ecdc07562ec4$var$Wc, $8967ecdc07562ec4$var$Xc = !1, $8967ecdc07562ec4$var$Yc = [], $8967ecdc07562ec4$var$Zc = null, $8967ecdc07562ec4$var$$c = null, $8967ecdc07562ec4$var$ad = null, $8967ecdc07562ec4$var$bd = new Map, $8967ecdc07562ec4$var$cd = new Map, $8967ecdc07562ec4$var$dd = [], $8967ecdc07562ec4$var$ed = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $8967ecdc07562ec4$var$fd(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $8967ecdc07562ec4$var$Zc = null;
            break;
        case "dragenter":
        case "dragleave":
            $8967ecdc07562ec4$var$$c = null;
            break;
        case "mouseover":
        case "mouseout":
            $8967ecdc07562ec4$var$ad = null;
            break;
        case "pointerover":
        case "pointerout":
            $8967ecdc07562ec4$var$bd.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $8967ecdc07562ec4$var$cd.delete(b.pointerId);
    }
}
function $8967ecdc07562ec4$var$gd(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $8967ecdc07562ec4$var$Cb(b), null !== b && $8967ecdc07562ec4$var$Tc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $8967ecdc07562ec4$var$hd(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $8967ecdc07562ec4$var$Zc = $8967ecdc07562ec4$var$gd($8967ecdc07562ec4$var$Zc, a, b, c, d, e), !0;
        case "dragenter":
            return $8967ecdc07562ec4$var$$c = $8967ecdc07562ec4$var$gd($8967ecdc07562ec4$var$$c, a, b, c, d, e), !0;
        case "mouseover":
            return $8967ecdc07562ec4$var$ad = $8967ecdc07562ec4$var$gd($8967ecdc07562ec4$var$ad, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $8967ecdc07562ec4$var$bd.set(f, $8967ecdc07562ec4$var$gd($8967ecdc07562ec4$var$bd.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $8967ecdc07562ec4$var$cd.set(f, $8967ecdc07562ec4$var$gd($8967ecdc07562ec4$var$cd.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $8967ecdc07562ec4$var$id(a) {
    var b = $8967ecdc07562ec4$var$jd(a.target);
    if (null !== b) {
        var c = $8967ecdc07562ec4$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $8967ecdc07562ec4$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $8967ecdc07562ec4$var$Wc(a.priority, function() {
                        $8967ecdc07562ec4$var$Uc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $8967ecdc07562ec4$var$kd(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $8967ecdc07562ec4$var$ld(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $8967ecdc07562ec4$var$wb = d;
            c.target.dispatchEvent(d);
            $8967ecdc07562ec4$var$wb = null;
        } else return b = $8967ecdc07562ec4$var$Cb(c), null !== b && $8967ecdc07562ec4$var$Tc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $8967ecdc07562ec4$var$md(a, b, c) {
    $8967ecdc07562ec4$var$kd(a) && c.delete(b);
}
function $8967ecdc07562ec4$var$nd() {
    $8967ecdc07562ec4$var$Xc = !1;
    null !== $8967ecdc07562ec4$var$Zc && $8967ecdc07562ec4$var$kd($8967ecdc07562ec4$var$Zc) && ($8967ecdc07562ec4$var$Zc = null);
    null !== $8967ecdc07562ec4$var$$c && $8967ecdc07562ec4$var$kd($8967ecdc07562ec4$var$$c) && ($8967ecdc07562ec4$var$$c = null);
    null !== $8967ecdc07562ec4$var$ad && $8967ecdc07562ec4$var$kd($8967ecdc07562ec4$var$ad) && ($8967ecdc07562ec4$var$ad = null);
    $8967ecdc07562ec4$var$bd.forEach($8967ecdc07562ec4$var$md);
    $8967ecdc07562ec4$var$cd.forEach($8967ecdc07562ec4$var$md);
}
function $8967ecdc07562ec4$var$od(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $8967ecdc07562ec4$var$Xc || ($8967ecdc07562ec4$var$Xc = !0, $LXjOh.unstable_scheduleCallback($LXjOh.unstable_NormalPriority, $8967ecdc07562ec4$var$nd)));
}
function $8967ecdc07562ec4$var$pd(a) {
    function b(b) {
        return $8967ecdc07562ec4$var$od(b, a);
    }
    if (0 < $8967ecdc07562ec4$var$Yc.length) {
        $8967ecdc07562ec4$var$od($8967ecdc07562ec4$var$Yc[0], a);
        for(var c = 1; c < $8967ecdc07562ec4$var$Yc.length; c++){
            var d = $8967ecdc07562ec4$var$Yc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $8967ecdc07562ec4$var$Zc && $8967ecdc07562ec4$var$od($8967ecdc07562ec4$var$Zc, a);
    null !== $8967ecdc07562ec4$var$$c && $8967ecdc07562ec4$var$od($8967ecdc07562ec4$var$$c, a);
    null !== $8967ecdc07562ec4$var$ad && $8967ecdc07562ec4$var$od($8967ecdc07562ec4$var$ad, a);
    $8967ecdc07562ec4$var$bd.forEach(b);
    $8967ecdc07562ec4$var$cd.forEach(b);
    for(c = 0; c < $8967ecdc07562ec4$var$dd.length; c++)d = $8967ecdc07562ec4$var$dd[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $8967ecdc07562ec4$var$dd.length && (c = $8967ecdc07562ec4$var$dd[0], null === c.blockedOn);)$8967ecdc07562ec4$var$id(c), null === c.blockedOn && $8967ecdc07562ec4$var$dd.shift();
}
var $8967ecdc07562ec4$var$qd = $8967ecdc07562ec4$var$va.ReactCurrentBatchConfig, $8967ecdc07562ec4$var$rd = !0;
function $8967ecdc07562ec4$var$sd(a, b, c, d) {
    var e = $8967ecdc07562ec4$var$E, f = $8967ecdc07562ec4$var$qd.transition;
    $8967ecdc07562ec4$var$qd.transition = null;
    try {
        $8967ecdc07562ec4$var$E = 1, $8967ecdc07562ec4$var$td(a, b, c, d);
    } finally{
        $8967ecdc07562ec4$var$E = e, $8967ecdc07562ec4$var$qd.transition = f;
    }
}
function $8967ecdc07562ec4$var$ud(a, b, c, d) {
    var e = $8967ecdc07562ec4$var$E, f = $8967ecdc07562ec4$var$qd.transition;
    $8967ecdc07562ec4$var$qd.transition = null;
    try {
        $8967ecdc07562ec4$var$E = 4, $8967ecdc07562ec4$var$td(a, b, c, d);
    } finally{
        $8967ecdc07562ec4$var$E = e, $8967ecdc07562ec4$var$qd.transition = f;
    }
}
function $8967ecdc07562ec4$var$td(a, b, c, d) {
    if ($8967ecdc07562ec4$var$rd) {
        var e = $8967ecdc07562ec4$var$ld(a, b, c, d);
        if (null === e) $8967ecdc07562ec4$var$vd(a, b, d, $8967ecdc07562ec4$var$wd, c), $8967ecdc07562ec4$var$fd(a, d);
        else if ($8967ecdc07562ec4$var$hd(e, a, b, c, d)) d.stopPropagation();
        else if ($8967ecdc07562ec4$var$fd(a, d), b & 4 && -1 < $8967ecdc07562ec4$var$ed.indexOf(a)) {
            for(; null !== e;){
                var f = $8967ecdc07562ec4$var$Cb(e);
                null !== f && $8967ecdc07562ec4$var$Sc(f);
                f = $8967ecdc07562ec4$var$ld(a, b, c, d);
                null === f && $8967ecdc07562ec4$var$vd(a, b, d, $8967ecdc07562ec4$var$wd, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $8967ecdc07562ec4$var$vd(a, b, d, null, c);
    }
}
var $8967ecdc07562ec4$var$wd = null;
function $8967ecdc07562ec4$var$ld(a, b, c, d) {
    $8967ecdc07562ec4$var$wd = null;
    a = $8967ecdc07562ec4$var$xb(d);
    a = $8967ecdc07562ec4$var$jd(a);
    if (null !== a) {
        if (b = $8967ecdc07562ec4$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $8967ecdc07562ec4$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $8967ecdc07562ec4$var$wd = a;
    return null;
}
function $8967ecdc07562ec4$var$xd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($8967ecdc07562ec4$var$ec()){
                case $8967ecdc07562ec4$var$fc:
                    return 1;
                case $8967ecdc07562ec4$var$gc:
                    return 4;
                case $8967ecdc07562ec4$var$hc:
                case $8967ecdc07562ec4$var$ic:
                    return 16;
                case $8967ecdc07562ec4$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $8967ecdc07562ec4$var$yd = null, $8967ecdc07562ec4$var$zd = null, $8967ecdc07562ec4$var$Ad = null;
function $8967ecdc07562ec4$var$Bd() {
    if ($8967ecdc07562ec4$var$Ad) return $8967ecdc07562ec4$var$Ad;
    var a, b = $8967ecdc07562ec4$var$zd, c = b.length, d, e = "value" in $8967ecdc07562ec4$var$yd ? $8967ecdc07562ec4$var$yd.value : $8967ecdc07562ec4$var$yd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $8967ecdc07562ec4$var$Ad = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $8967ecdc07562ec4$var$Cd(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $8967ecdc07562ec4$var$Dd() {
    return !0;
}
function $8967ecdc07562ec4$var$Ed() {
    return !1;
}
function $8967ecdc07562ec4$var$Fd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $8967ecdc07562ec4$var$Dd : $8967ecdc07562ec4$var$Ed;
        this.isPropagationStopped = $8967ecdc07562ec4$var$Ed;
        return this;
    }
    $8967ecdc07562ec4$var$u(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $8967ecdc07562ec4$var$Dd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $8967ecdc07562ec4$var$Dd);
        },
        persist: function() {},
        isPersistent: $8967ecdc07562ec4$var$Dd
    });
    return b;
}
var $8967ecdc07562ec4$var$Gd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $8967ecdc07562ec4$var$Hd = $8967ecdc07562ec4$var$Fd($8967ecdc07562ec4$var$Gd), $8967ecdc07562ec4$var$Id = $8967ecdc07562ec4$var$u({}, $8967ecdc07562ec4$var$Gd, {
    view: 0,
    detail: 0
}), $8967ecdc07562ec4$var$Jd = $8967ecdc07562ec4$var$Fd($8967ecdc07562ec4$var$Id), $8967ecdc07562ec4$var$Kd, $8967ecdc07562ec4$var$Ld, $8967ecdc07562ec4$var$Md, $8967ecdc07562ec4$var$Od = $8967ecdc07562ec4$var$u({}, $8967ecdc07562ec4$var$Id, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $8967ecdc07562ec4$var$Nd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $8967ecdc07562ec4$var$Md && ($8967ecdc07562ec4$var$Md && "mousemove" === a.type ? ($8967ecdc07562ec4$var$Kd = a.screenX - $8967ecdc07562ec4$var$Md.screenX, $8967ecdc07562ec4$var$Ld = a.screenY - $8967ecdc07562ec4$var$Md.screenY) : $8967ecdc07562ec4$var$Ld = $8967ecdc07562ec4$var$Kd = 0, $8967ecdc07562ec4$var$Md = a);
        return $8967ecdc07562ec4$var$Kd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $8967ecdc07562ec4$var$Ld;
    }
}), $8967ecdc07562ec4$var$Pd = $8967ecdc07562ec4$var$Fd($8967ecdc07562ec4$var$Od), $8967ecdc07562ec4$var$Qd = $8967ecdc07562ec4$var$u({}, $8967ecdc07562ec4$var$Od, {
    dataTransfer: 0
}), $8967ecdc07562ec4$var$Rd = $8967ecdc07562ec4$var$Fd($8967ecdc07562ec4$var$Qd), $8967ecdc07562ec4$var$Sd = $8967ecdc07562ec4$var$u({}, $8967ecdc07562ec4$var$Id, {
    relatedTarget: 0
}), $8967ecdc07562ec4$var$Td = $8967ecdc07562ec4$var$Fd($8967ecdc07562ec4$var$Sd), $8967ecdc07562ec4$var$Ud = $8967ecdc07562ec4$var$u({}, $8967ecdc07562ec4$var$Gd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $8967ecdc07562ec4$var$Vd = $8967ecdc07562ec4$var$Fd($8967ecdc07562ec4$var$Ud), $8967ecdc07562ec4$var$Wd = $8967ecdc07562ec4$var$u({}, $8967ecdc07562ec4$var$Gd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $8967ecdc07562ec4$var$Xd = $8967ecdc07562ec4$var$Fd($8967ecdc07562ec4$var$Wd), $8967ecdc07562ec4$var$Yd = $8967ecdc07562ec4$var$u({}, $8967ecdc07562ec4$var$Gd, {
    data: 0
}), $8967ecdc07562ec4$var$Zd = $8967ecdc07562ec4$var$Fd($8967ecdc07562ec4$var$Yd), $8967ecdc07562ec4$var$$d = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $8967ecdc07562ec4$var$ae = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $8967ecdc07562ec4$var$be = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $8967ecdc07562ec4$var$ce(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $8967ecdc07562ec4$var$be[a]) ? !!b[a] : !1;
}
function $8967ecdc07562ec4$var$Nd() {
    return $8967ecdc07562ec4$var$ce;
}
var $8967ecdc07562ec4$var$de = $8967ecdc07562ec4$var$u({}, $8967ecdc07562ec4$var$Id, {
    key: function(a) {
        if (a.key) {
            var b = $8967ecdc07562ec4$var$$d[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $8967ecdc07562ec4$var$Cd(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $8967ecdc07562ec4$var$ae[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $8967ecdc07562ec4$var$Nd,
    charCode: function(a) {
        return "keypress" === a.type ? $8967ecdc07562ec4$var$Cd(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $8967ecdc07562ec4$var$Cd(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $8967ecdc07562ec4$var$ee = $8967ecdc07562ec4$var$Fd($8967ecdc07562ec4$var$de), $8967ecdc07562ec4$var$fe = $8967ecdc07562ec4$var$u({}, $8967ecdc07562ec4$var$Od, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $8967ecdc07562ec4$var$ge = $8967ecdc07562ec4$var$Fd($8967ecdc07562ec4$var$fe), $8967ecdc07562ec4$var$he = $8967ecdc07562ec4$var$u({}, $8967ecdc07562ec4$var$Id, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $8967ecdc07562ec4$var$Nd
}), $8967ecdc07562ec4$var$ie = $8967ecdc07562ec4$var$Fd($8967ecdc07562ec4$var$he), $8967ecdc07562ec4$var$je = $8967ecdc07562ec4$var$u({}, $8967ecdc07562ec4$var$Gd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $8967ecdc07562ec4$var$ke = $8967ecdc07562ec4$var$Fd($8967ecdc07562ec4$var$je), $8967ecdc07562ec4$var$le = $8967ecdc07562ec4$var$u({}, $8967ecdc07562ec4$var$Od, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $8967ecdc07562ec4$var$me = $8967ecdc07562ec4$var$Fd($8967ecdc07562ec4$var$le), $8967ecdc07562ec4$var$ne = [
    9,
    13,
    27,
    32
], $8967ecdc07562ec4$var$oe = $8967ecdc07562ec4$var$ia && "CompositionEvent" in window, $8967ecdc07562ec4$var$pe = null;
$8967ecdc07562ec4$var$ia && "documentMode" in document && ($8967ecdc07562ec4$var$pe = document.documentMode);
var $8967ecdc07562ec4$var$qe = $8967ecdc07562ec4$var$ia && "TextEvent" in window && !$8967ecdc07562ec4$var$pe, $8967ecdc07562ec4$var$re = $8967ecdc07562ec4$var$ia && (!$8967ecdc07562ec4$var$oe || $8967ecdc07562ec4$var$pe && 8 < $8967ecdc07562ec4$var$pe && 11 >= $8967ecdc07562ec4$var$pe), $8967ecdc07562ec4$var$se = String.fromCharCode(32), $8967ecdc07562ec4$var$te = !1;
function $8967ecdc07562ec4$var$ue(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $8967ecdc07562ec4$var$ne.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $8967ecdc07562ec4$var$ve(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $8967ecdc07562ec4$var$we = !1;
function $8967ecdc07562ec4$var$xe(a, b) {
    switch(a){
        case "compositionend":
            return $8967ecdc07562ec4$var$ve(b);
        case "keypress":
            if (32 !== b.which) return null;
            $8967ecdc07562ec4$var$te = !0;
            return $8967ecdc07562ec4$var$se;
        case "textInput":
            return a = b.data, a === $8967ecdc07562ec4$var$se && $8967ecdc07562ec4$var$te ? null : a;
        default:
            return null;
    }
}
function $8967ecdc07562ec4$var$ye(a, b) {
    if ($8967ecdc07562ec4$var$we) return "compositionend" === a || !$8967ecdc07562ec4$var$oe && $8967ecdc07562ec4$var$ue(a, b) ? (a = $8967ecdc07562ec4$var$Bd(), $8967ecdc07562ec4$var$Ad = $8967ecdc07562ec4$var$zd = $8967ecdc07562ec4$var$yd = null, $8967ecdc07562ec4$var$we = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $8967ecdc07562ec4$var$re && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $8967ecdc07562ec4$var$ze = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $8967ecdc07562ec4$var$Ae(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$8967ecdc07562ec4$var$ze[a.type] : "textarea" === b ? !0 : !1;
}
function $8967ecdc07562ec4$var$Be(a, b, c, d) {
    $8967ecdc07562ec4$var$Eb(d);
    b = $8967ecdc07562ec4$var$Ce(b, "onChange");
    0 < b.length && (c = new $8967ecdc07562ec4$var$Hd("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $8967ecdc07562ec4$var$De = null, $8967ecdc07562ec4$var$Ee = null;
function $8967ecdc07562ec4$var$Fe(a) {
    $8967ecdc07562ec4$var$Ge(a, 0);
}
function $8967ecdc07562ec4$var$He(a) {
    var b = $8967ecdc07562ec4$var$Ie(a);
    if ($8967ecdc07562ec4$var$Wa(b)) return a;
}
function $8967ecdc07562ec4$var$Je(a, b) {
    if ("change" === a) return b;
}
var $8967ecdc07562ec4$var$Ke = !1;
if ($8967ecdc07562ec4$var$ia) {
    var $8967ecdc07562ec4$var$Le;
    if ($8967ecdc07562ec4$var$ia) {
        var $8967ecdc07562ec4$var$Me = "oninput" in document;
        if (!$8967ecdc07562ec4$var$Me) {
            var $8967ecdc07562ec4$var$Ne = document.createElement("div");
            $8967ecdc07562ec4$var$Ne.setAttribute("oninput", "return;");
            $8967ecdc07562ec4$var$Me = "function" === typeof $8967ecdc07562ec4$var$Ne.oninput;
        }
        $8967ecdc07562ec4$var$Le = $8967ecdc07562ec4$var$Me;
    } else $8967ecdc07562ec4$var$Le = !1;
    $8967ecdc07562ec4$var$Ke = $8967ecdc07562ec4$var$Le && (!document.documentMode || 9 < document.documentMode);
}
function $8967ecdc07562ec4$var$Oe() {
    $8967ecdc07562ec4$var$De && ($8967ecdc07562ec4$var$De.detachEvent("onpropertychange", $8967ecdc07562ec4$var$Pe), $8967ecdc07562ec4$var$Ee = $8967ecdc07562ec4$var$De = null);
}
function $8967ecdc07562ec4$var$Pe(a) {
    if ("value" === a.propertyName && $8967ecdc07562ec4$var$He($8967ecdc07562ec4$var$Ee)) {
        var b = [];
        $8967ecdc07562ec4$var$Be(b, $8967ecdc07562ec4$var$Ee, a, $8967ecdc07562ec4$var$xb(a));
        $8967ecdc07562ec4$var$Jb($8967ecdc07562ec4$var$Fe, b);
    }
}
function $8967ecdc07562ec4$var$Qe(a, b, c) {
    "focusin" === a ? ($8967ecdc07562ec4$var$Oe(), $8967ecdc07562ec4$var$De = b, $8967ecdc07562ec4$var$Ee = c, $8967ecdc07562ec4$var$De.attachEvent("onpropertychange", $8967ecdc07562ec4$var$Pe)) : "focusout" === a && $8967ecdc07562ec4$var$Oe();
}
function $8967ecdc07562ec4$var$Re(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $8967ecdc07562ec4$var$He($8967ecdc07562ec4$var$Ee);
}
function $8967ecdc07562ec4$var$Se(a, b) {
    if ("click" === a) return $8967ecdc07562ec4$var$He(b);
}
function $8967ecdc07562ec4$var$Te(a, b) {
    if ("input" === a || "change" === a) return $8967ecdc07562ec4$var$He(b);
}
function $8967ecdc07562ec4$var$Ue(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $8967ecdc07562ec4$var$Ve = "function" === typeof Object.is ? Object.is : $8967ecdc07562ec4$var$Ue;
function $8967ecdc07562ec4$var$We(a, b) {
    if ($8967ecdc07562ec4$var$Ve(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$8967ecdc07562ec4$var$ja.call(b, e) || !$8967ecdc07562ec4$var$Ve(a[e], b[e])) return !1;
    }
    return !0;
}
function $8967ecdc07562ec4$var$Xe(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $8967ecdc07562ec4$var$Ye(a, b) {
    var c = $8967ecdc07562ec4$var$Xe(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $8967ecdc07562ec4$var$Xe(c);
    }
}
function $8967ecdc07562ec4$var$Ze(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $8967ecdc07562ec4$var$Ze(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $8967ecdc07562ec4$var$$e() {
    for(var a = window, b = $8967ecdc07562ec4$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $8967ecdc07562ec4$var$Xa(a.document);
    }
    return b;
}
function $8967ecdc07562ec4$var$af(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $8967ecdc07562ec4$var$bf(a) {
    var b = $8967ecdc07562ec4$var$$e(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $8967ecdc07562ec4$var$Ze(c.ownerDocument.documentElement, c)) {
        if (null !== d && $8967ecdc07562ec4$var$af(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $8967ecdc07562ec4$var$Ye(c, f);
                var g = $8967ecdc07562ec4$var$Ye(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $8967ecdc07562ec4$var$cf = $8967ecdc07562ec4$var$ia && "documentMode" in document && 11 >= document.documentMode, $8967ecdc07562ec4$var$df = null, $8967ecdc07562ec4$var$ef = null, $8967ecdc07562ec4$var$ff = null, $8967ecdc07562ec4$var$gf = !1;
function $8967ecdc07562ec4$var$hf(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $8967ecdc07562ec4$var$gf || null == $8967ecdc07562ec4$var$df || $8967ecdc07562ec4$var$df !== $8967ecdc07562ec4$var$Xa(d) || (d = $8967ecdc07562ec4$var$df, "selectionStart" in d && $8967ecdc07562ec4$var$af(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $8967ecdc07562ec4$var$ff && $8967ecdc07562ec4$var$We($8967ecdc07562ec4$var$ff, d) || ($8967ecdc07562ec4$var$ff = d, d = $8967ecdc07562ec4$var$Ce($8967ecdc07562ec4$var$ef, "onSelect"), 0 < d.length && (b = new $8967ecdc07562ec4$var$Hd("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $8967ecdc07562ec4$var$df)));
}
function $8967ecdc07562ec4$var$jf(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $8967ecdc07562ec4$var$kf = {
    animationend: $8967ecdc07562ec4$var$jf("Animation", "AnimationEnd"),
    animationiteration: $8967ecdc07562ec4$var$jf("Animation", "AnimationIteration"),
    animationstart: $8967ecdc07562ec4$var$jf("Animation", "AnimationStart"),
    transitionend: $8967ecdc07562ec4$var$jf("Transition", "TransitionEnd")
}, $8967ecdc07562ec4$var$lf = {}, $8967ecdc07562ec4$var$mf = {};
$8967ecdc07562ec4$var$ia && ($8967ecdc07562ec4$var$mf = document.createElement("div").style, "AnimationEvent" in window || (delete $8967ecdc07562ec4$var$kf.animationend.animation, delete $8967ecdc07562ec4$var$kf.animationiteration.animation, delete $8967ecdc07562ec4$var$kf.animationstart.animation), "TransitionEvent" in window || delete $8967ecdc07562ec4$var$kf.transitionend.transition);
function $8967ecdc07562ec4$var$nf(a) {
    if ($8967ecdc07562ec4$var$lf[a]) return $8967ecdc07562ec4$var$lf[a];
    if (!$8967ecdc07562ec4$var$kf[a]) return a;
    var b = $8967ecdc07562ec4$var$kf[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $8967ecdc07562ec4$var$mf) return $8967ecdc07562ec4$var$lf[a] = b[c];
    return a;
}
var $8967ecdc07562ec4$var$of = $8967ecdc07562ec4$var$nf("animationend"), $8967ecdc07562ec4$var$pf = $8967ecdc07562ec4$var$nf("animationiteration"), $8967ecdc07562ec4$var$qf = $8967ecdc07562ec4$var$nf("animationstart"), $8967ecdc07562ec4$var$rf = $8967ecdc07562ec4$var$nf("transitionend"), $8967ecdc07562ec4$var$sf = new Map, $8967ecdc07562ec4$var$tf = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $8967ecdc07562ec4$var$uf(a, b) {
    $8967ecdc07562ec4$var$sf.set(a, b);
    $8967ecdc07562ec4$var$fa(b, [
        a
    ]);
}
for(var $8967ecdc07562ec4$var$vf = 0; $8967ecdc07562ec4$var$vf < $8967ecdc07562ec4$var$tf.length; $8967ecdc07562ec4$var$vf++){
    var $8967ecdc07562ec4$var$wf = $8967ecdc07562ec4$var$tf[$8967ecdc07562ec4$var$vf], $8967ecdc07562ec4$var$xf = $8967ecdc07562ec4$var$wf.toLowerCase(), $8967ecdc07562ec4$var$yf = $8967ecdc07562ec4$var$wf[0].toUpperCase() + $8967ecdc07562ec4$var$wf.slice(1);
    $8967ecdc07562ec4$var$uf($8967ecdc07562ec4$var$xf, "on" + $8967ecdc07562ec4$var$yf);
}
$8967ecdc07562ec4$var$uf($8967ecdc07562ec4$var$of, "onAnimationEnd");
$8967ecdc07562ec4$var$uf($8967ecdc07562ec4$var$pf, "onAnimationIteration");
$8967ecdc07562ec4$var$uf($8967ecdc07562ec4$var$qf, "onAnimationStart");
$8967ecdc07562ec4$var$uf("dblclick", "onDoubleClick");
$8967ecdc07562ec4$var$uf("focusin", "onFocus");
$8967ecdc07562ec4$var$uf("focusout", "onBlur");
$8967ecdc07562ec4$var$uf($8967ecdc07562ec4$var$rf, "onTransitionEnd");
$8967ecdc07562ec4$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$8967ecdc07562ec4$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$8967ecdc07562ec4$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$8967ecdc07562ec4$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$8967ecdc07562ec4$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$8967ecdc07562ec4$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$8967ecdc07562ec4$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$8967ecdc07562ec4$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$8967ecdc07562ec4$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$8967ecdc07562ec4$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $8967ecdc07562ec4$var$zf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $8967ecdc07562ec4$var$Af = new Set("cancel close invalid load scroll toggle".split(" ").concat($8967ecdc07562ec4$var$zf));
function $8967ecdc07562ec4$var$Bf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $8967ecdc07562ec4$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $8967ecdc07562ec4$var$Ge(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $8967ecdc07562ec4$var$Bf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $8967ecdc07562ec4$var$Bf(e, h, l);
                f = k;
            }
        }
    }
    if ($8967ecdc07562ec4$var$Qb) throw a = $8967ecdc07562ec4$var$Rb, $8967ecdc07562ec4$var$Qb = !1, $8967ecdc07562ec4$var$Rb = null, a;
}
function $8967ecdc07562ec4$var$F(a, b) {
    var c = b[$8967ecdc07562ec4$var$Cf];
    void 0 === c && (c = b[$8967ecdc07562ec4$var$Cf] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($8967ecdc07562ec4$var$Df(b, a, 2, !1), c.add(d));
}
function $8967ecdc07562ec4$var$Ef(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $8967ecdc07562ec4$var$Df(c, a, d, b);
}
var $8967ecdc07562ec4$var$Ff = "_reactListening" + Math.random().toString(36).slice(2);
function $8967ecdc07562ec4$var$Gf(a) {
    if (!a[$8967ecdc07562ec4$var$Ff]) {
        a[$8967ecdc07562ec4$var$Ff] = !0;
        $8967ecdc07562ec4$var$da.forEach(function(b) {
            "selectionchange" !== b && ($8967ecdc07562ec4$var$Af.has(b) || $8967ecdc07562ec4$var$Ef(b, !1, a), $8967ecdc07562ec4$var$Ef(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$8967ecdc07562ec4$var$Ff] || (b[$8967ecdc07562ec4$var$Ff] = !0, $8967ecdc07562ec4$var$Ef("selectionchange", !1, b));
    }
}
function $8967ecdc07562ec4$var$Df(a, b, c, d) {
    switch($8967ecdc07562ec4$var$xd(b)){
        case 1:
            var e = $8967ecdc07562ec4$var$sd;
            break;
        case 4:
            e = $8967ecdc07562ec4$var$ud;
            break;
        default:
            e = $8967ecdc07562ec4$var$td;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$8967ecdc07562ec4$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $8967ecdc07562ec4$var$vd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $8967ecdc07562ec4$var$jd(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $8967ecdc07562ec4$var$Jb(function() {
        var d = f, e = $8967ecdc07562ec4$var$xb(c), g = [];
        a: {
            var h = $8967ecdc07562ec4$var$sf.get(a);
            if (void 0 !== h) {
                var k = $8967ecdc07562ec4$var$Hd, m = a;
                switch(a){
                    case "keypress":
                        if (0 === $8967ecdc07562ec4$var$Cd(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $8967ecdc07562ec4$var$ee;
                        break;
                    case "focusin":
                        m = "focus";
                        k = $8967ecdc07562ec4$var$Td;
                        break;
                    case "focusout":
                        m = "blur";
                        k = $8967ecdc07562ec4$var$Td;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $8967ecdc07562ec4$var$Td;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $8967ecdc07562ec4$var$Pd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $8967ecdc07562ec4$var$Rd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $8967ecdc07562ec4$var$ie;
                        break;
                    case $8967ecdc07562ec4$var$of:
                    case $8967ecdc07562ec4$var$pf:
                    case $8967ecdc07562ec4$var$qf:
                        k = $8967ecdc07562ec4$var$Vd;
                        break;
                    case $8967ecdc07562ec4$var$rf:
                        k = $8967ecdc07562ec4$var$ke;
                        break;
                    case "scroll":
                        k = $8967ecdc07562ec4$var$Jd;
                        break;
                    case "wheel":
                        k = $8967ecdc07562ec4$var$me;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $8967ecdc07562ec4$var$Xd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $8967ecdc07562ec4$var$ge;
                }
                var w = 0 !== (b & 4), C = !w && "scroll" === a, x = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var y = d, v; null !== y;){
                    v = y;
                    var D = v.stateNode;
                    5 === v.tag && null !== D && (v = D, null !== x && (D = $8967ecdc07562ec4$var$Kb(y, x), null != D && w.push($8967ecdc07562ec4$var$Hf(y, D, v))));
                    if (C) break;
                    y = y.return;
                }
                0 < w.length && (h = new k(h, m, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $8967ecdc07562ec4$var$wb && (m = c.relatedTarget || c.fromElement) && ($8967ecdc07562ec4$var$jd(m) || m[$8967ecdc07562ec4$var$If])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (m = c.relatedTarget || c.toElement, k = d, m = m ? $8967ecdc07562ec4$var$jd(m) : null, null !== m && (C = $8967ecdc07562ec4$var$Vb(m), m !== C || 5 !== m.tag && 6 !== m.tag)) m = null;
                    } else k = null, m = d;
                    if (k !== m) {
                        w = $8967ecdc07562ec4$var$Pd;
                        D = "onMouseLeave";
                        x = "onMouseEnter";
                        y = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = $8967ecdc07562ec4$var$ge, D = "onPointerLeave", x = "onPointerEnter", y = "pointer";
                        C = null == k ? h : $8967ecdc07562ec4$var$Ie(k);
                        v = null == m ? h : $8967ecdc07562ec4$var$Ie(m);
                        h = new w(D, y + "leave", k, c, e);
                        h.target = C;
                        h.relatedTarget = v;
                        D = null;
                        $8967ecdc07562ec4$var$jd(e) === d && (w = new w(x, y + "enter", m, c, e), w.target = v, w.relatedTarget = C, D = w);
                        C = D;
                        if (k && m) b: {
                            w = k;
                            x = m;
                            y = 0;
                            for(v = w; v; v = $8967ecdc07562ec4$var$Jf(v))y++;
                            v = 0;
                            for(D = x; D; D = $8967ecdc07562ec4$var$Jf(D))v++;
                            for(; 0 < y - v;)w = $8967ecdc07562ec4$var$Jf(w), y--;
                            for(; 0 < v - y;)x = $8967ecdc07562ec4$var$Jf(x), v--;
                            for(; y--;){
                                if (w === x || null !== x && w === x.alternate) break b;
                                w = $8967ecdc07562ec4$var$Jf(w);
                                x = $8967ecdc07562ec4$var$Jf(x);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && $8967ecdc07562ec4$var$Kf(g, h, k, w, !1);
                        null !== m && null !== C && $8967ecdc07562ec4$var$Kf(g, C, m, w, !0);
                    }
                }
            }
            a: {
                h = d ? $8967ecdc07562ec4$var$Ie(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var ca = $8967ecdc07562ec4$var$Je;
                else if ($8967ecdc07562ec4$var$Ae(h)) {
                    if ($8967ecdc07562ec4$var$Ke) ca = $8967ecdc07562ec4$var$Te;
                    else {
                        ca = $8967ecdc07562ec4$var$Re;
                        var R = $8967ecdc07562ec4$var$Qe;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (ca = $8967ecdc07562ec4$var$Se);
                if (ca && (ca = ca(a, d))) {
                    $8967ecdc07562ec4$var$Be(g, ca, c, e);
                    break a;
                }
                R && R(a, h, d);
                "focusout" === a && (R = h._wrapperState) && R.controlled && "number" === h.type && $8967ecdc07562ec4$var$bb(h, "number", h.value);
            }
            R = d ? $8967ecdc07562ec4$var$Ie(d) : window;
            switch(a){
                case "focusin":
                    if ($8967ecdc07562ec4$var$Ae(R) || "true" === R.contentEditable) $8967ecdc07562ec4$var$df = R, $8967ecdc07562ec4$var$ef = d, $8967ecdc07562ec4$var$ff = null;
                    break;
                case "focusout":
                    $8967ecdc07562ec4$var$ff = $8967ecdc07562ec4$var$ef = $8967ecdc07562ec4$var$df = null;
                    break;
                case "mousedown":
                    $8967ecdc07562ec4$var$gf = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $8967ecdc07562ec4$var$gf = !1;
                    $8967ecdc07562ec4$var$hf(g, c, e);
                    break;
                case "selectionchange":
                    if ($8967ecdc07562ec4$var$cf) break;
                case "keydown":
                case "keyup":
                    $8967ecdc07562ec4$var$hf(g, c, e);
            }
            var sa;
            if ($8967ecdc07562ec4$var$oe) b: {
                switch(a){
                    case "compositionstart":
                        var V = "onCompositionStart";
                        break b;
                    case "compositionend":
                        V = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        V = "onCompositionUpdate";
                        break b;
                }
                V = void 0;
            }
            else $8967ecdc07562ec4$var$we ? $8967ecdc07562ec4$var$ue(a, c) && (V = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (V = "onCompositionStart");
            V && ($8967ecdc07562ec4$var$re && "ko" !== c.locale && ($8967ecdc07562ec4$var$we || "onCompositionStart" !== V ? "onCompositionEnd" === V && $8967ecdc07562ec4$var$we && (sa = $8967ecdc07562ec4$var$Bd()) : ($8967ecdc07562ec4$var$yd = e, $8967ecdc07562ec4$var$zd = "value" in $8967ecdc07562ec4$var$yd ? $8967ecdc07562ec4$var$yd.value : $8967ecdc07562ec4$var$yd.textContent, $8967ecdc07562ec4$var$we = !0)), R = $8967ecdc07562ec4$var$Ce(d, V), 0 < R.length && (V = new $8967ecdc07562ec4$var$Zd(V, a, null, c, e), g.push({
                event: V,
                listeners: R
            }), sa ? V.data = sa : (sa = $8967ecdc07562ec4$var$ve(c), null !== sa && (V.data = sa))));
            if (sa = $8967ecdc07562ec4$var$qe ? $8967ecdc07562ec4$var$xe(a, c) : $8967ecdc07562ec4$var$ye(a, c)) d = $8967ecdc07562ec4$var$Ce(d, "onBeforeInput"), 0 < d.length && (e = new $8967ecdc07562ec4$var$Zd("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = sa);
        }
        $8967ecdc07562ec4$var$Ge(g, b);
    });
}
function $8967ecdc07562ec4$var$Hf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $8967ecdc07562ec4$var$Ce(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $8967ecdc07562ec4$var$Kb(a, c), null != f && d.unshift($8967ecdc07562ec4$var$Hf(a, f, e)), f = $8967ecdc07562ec4$var$Kb(a, b), null != f && d.push($8967ecdc07562ec4$var$Hf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $8967ecdc07562ec4$var$Jf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $8967ecdc07562ec4$var$Kf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $8967ecdc07562ec4$var$Kb(c, f), null != k && g.unshift($8967ecdc07562ec4$var$Hf(c, k, h))) : e || (k = $8967ecdc07562ec4$var$Kb(c, f), null != k && g.push($8967ecdc07562ec4$var$Hf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $8967ecdc07562ec4$var$Lf = /\r\n?/g, $8967ecdc07562ec4$var$Mf = /\u0000|\uFFFD/g;
function $8967ecdc07562ec4$var$Nf(a) {
    return ("string" === typeof a ? a : "" + a).replace($8967ecdc07562ec4$var$Lf, "\n").replace($8967ecdc07562ec4$var$Mf, "");
}
function $8967ecdc07562ec4$var$Of(a, b, c) {
    b = $8967ecdc07562ec4$var$Nf(b);
    if ($8967ecdc07562ec4$var$Nf(a) !== b && c) throw Error($8967ecdc07562ec4$var$p(425));
}
function $8967ecdc07562ec4$var$Pf() {}
var $8967ecdc07562ec4$var$Qf = null, $8967ecdc07562ec4$var$Rf = null;
function $8967ecdc07562ec4$var$Sf(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $8967ecdc07562ec4$var$Tf = "function" === typeof setTimeout ? setTimeout : void 0, $8967ecdc07562ec4$var$Uf = "function" === typeof clearTimeout ? clearTimeout : void 0, $8967ecdc07562ec4$var$Vf = "function" === typeof Promise ? Promise : void 0, $8967ecdc07562ec4$var$Xf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $8967ecdc07562ec4$var$Vf ? function(a) {
    return $8967ecdc07562ec4$var$Vf.resolve(null).then(a).catch($8967ecdc07562ec4$var$Wf);
} : $8967ecdc07562ec4$var$Tf;
function $8967ecdc07562ec4$var$Wf(a) {
    setTimeout(function() {
        throw a;
    });
}
function $8967ecdc07562ec4$var$Yf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $8967ecdc07562ec4$var$pd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $8967ecdc07562ec4$var$pd(b);
}
function $8967ecdc07562ec4$var$Zf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $8967ecdc07562ec4$var$$f(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $8967ecdc07562ec4$var$ag = Math.random().toString(36).slice(2), $8967ecdc07562ec4$var$bg = "__reactFiber$" + $8967ecdc07562ec4$var$ag, $8967ecdc07562ec4$var$cg = "__reactProps$" + $8967ecdc07562ec4$var$ag, $8967ecdc07562ec4$var$If = "__reactContainer$" + $8967ecdc07562ec4$var$ag, $8967ecdc07562ec4$var$Cf = "__reactEvents$" + $8967ecdc07562ec4$var$ag, $8967ecdc07562ec4$var$dg = "__reactListeners$" + $8967ecdc07562ec4$var$ag, $8967ecdc07562ec4$var$eg = "__reactHandles$" + $8967ecdc07562ec4$var$ag;
function $8967ecdc07562ec4$var$jd(a) {
    var b = a[$8967ecdc07562ec4$var$bg];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$8967ecdc07562ec4$var$If] || c[$8967ecdc07562ec4$var$bg]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $8967ecdc07562ec4$var$$f(a); null !== a;){
                if (c = a[$8967ecdc07562ec4$var$bg]) return c;
                a = $8967ecdc07562ec4$var$$f(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $8967ecdc07562ec4$var$Cb(a) {
    a = a[$8967ecdc07562ec4$var$bg] || a[$8967ecdc07562ec4$var$If];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $8967ecdc07562ec4$var$Ie(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($8967ecdc07562ec4$var$p(33));
}
function $8967ecdc07562ec4$var$Db(a) {
    return a[$8967ecdc07562ec4$var$cg] || null;
}
var $8967ecdc07562ec4$var$fg = [], $8967ecdc07562ec4$var$gg = -1;
function $8967ecdc07562ec4$var$hg(a) {
    return {
        current: a
    };
}
function $8967ecdc07562ec4$var$G(a) {
    0 > $8967ecdc07562ec4$var$gg || (a.current = $8967ecdc07562ec4$var$fg[$8967ecdc07562ec4$var$gg], $8967ecdc07562ec4$var$fg[$8967ecdc07562ec4$var$gg] = null, $8967ecdc07562ec4$var$gg--);
}
function $8967ecdc07562ec4$var$H(a, b) {
    $8967ecdc07562ec4$var$gg++;
    $8967ecdc07562ec4$var$fg[$8967ecdc07562ec4$var$gg] = a.current;
    a.current = b;
}
var $8967ecdc07562ec4$var$ig = {}, $8967ecdc07562ec4$var$I = $8967ecdc07562ec4$var$hg($8967ecdc07562ec4$var$ig), $8967ecdc07562ec4$var$jg = $8967ecdc07562ec4$var$hg(!1), $8967ecdc07562ec4$var$kg = $8967ecdc07562ec4$var$ig;
function $8967ecdc07562ec4$var$lg(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $8967ecdc07562ec4$var$ig;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $8967ecdc07562ec4$var$mg(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $8967ecdc07562ec4$var$ng() {
    $8967ecdc07562ec4$var$G($8967ecdc07562ec4$var$jg);
    $8967ecdc07562ec4$var$G($8967ecdc07562ec4$var$I);
}
function $8967ecdc07562ec4$var$og(a, b, c) {
    if ($8967ecdc07562ec4$var$I.current !== $8967ecdc07562ec4$var$ig) throw Error($8967ecdc07562ec4$var$p(168));
    $8967ecdc07562ec4$var$H($8967ecdc07562ec4$var$I, b);
    $8967ecdc07562ec4$var$H($8967ecdc07562ec4$var$jg, c);
}
function $8967ecdc07562ec4$var$pg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($8967ecdc07562ec4$var$p(108, $8967ecdc07562ec4$var$Ra(a) || "Unknown", e));
    return $8967ecdc07562ec4$var$u({}, c, d);
}
function $8967ecdc07562ec4$var$qg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $8967ecdc07562ec4$var$ig;
    $8967ecdc07562ec4$var$kg = $8967ecdc07562ec4$var$I.current;
    $8967ecdc07562ec4$var$H($8967ecdc07562ec4$var$I, a);
    $8967ecdc07562ec4$var$H($8967ecdc07562ec4$var$jg, $8967ecdc07562ec4$var$jg.current);
    return !0;
}
function $8967ecdc07562ec4$var$rg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($8967ecdc07562ec4$var$p(169));
    c ? (a = $8967ecdc07562ec4$var$pg(a, b, $8967ecdc07562ec4$var$kg), d.__reactInternalMemoizedMergedChildContext = a, $8967ecdc07562ec4$var$G($8967ecdc07562ec4$var$jg), $8967ecdc07562ec4$var$G($8967ecdc07562ec4$var$I), $8967ecdc07562ec4$var$H($8967ecdc07562ec4$var$I, a)) : $8967ecdc07562ec4$var$G($8967ecdc07562ec4$var$jg);
    $8967ecdc07562ec4$var$H($8967ecdc07562ec4$var$jg, c);
}
var $8967ecdc07562ec4$var$sg = null, $8967ecdc07562ec4$var$tg = !1, $8967ecdc07562ec4$var$ug = !1;
function $8967ecdc07562ec4$var$vg(a) {
    null === $8967ecdc07562ec4$var$sg ? $8967ecdc07562ec4$var$sg = [
        a
    ] : $8967ecdc07562ec4$var$sg.push(a);
}
function $8967ecdc07562ec4$var$wg(a) {
    $8967ecdc07562ec4$var$tg = !0;
    $8967ecdc07562ec4$var$vg(a);
}
function $8967ecdc07562ec4$var$xg() {
    if (!$8967ecdc07562ec4$var$ug && null !== $8967ecdc07562ec4$var$sg) {
        $8967ecdc07562ec4$var$ug = !0;
        var a = 0, b = $8967ecdc07562ec4$var$E;
        try {
            var c = $8967ecdc07562ec4$var$sg;
            for($8967ecdc07562ec4$var$E = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $8967ecdc07562ec4$var$sg = null;
            $8967ecdc07562ec4$var$tg = !1;
        } catch (e) {
            throw null !== $8967ecdc07562ec4$var$sg && ($8967ecdc07562ec4$var$sg = $8967ecdc07562ec4$var$sg.slice(a + 1)), $8967ecdc07562ec4$var$ac($8967ecdc07562ec4$var$fc, $8967ecdc07562ec4$var$xg), e;
        } finally{
            $8967ecdc07562ec4$var$E = b, $8967ecdc07562ec4$var$ug = !1;
        }
    }
    return null;
}
var $8967ecdc07562ec4$var$yg = [], $8967ecdc07562ec4$var$zg = 0, $8967ecdc07562ec4$var$Ag = null, $8967ecdc07562ec4$var$Bg = 0, $8967ecdc07562ec4$var$Cg = [], $8967ecdc07562ec4$var$Dg = 0, $8967ecdc07562ec4$var$Eg = null, $8967ecdc07562ec4$var$Fg = 1, $8967ecdc07562ec4$var$Gg = "";
function $8967ecdc07562ec4$var$Hg(a, b) {
    $8967ecdc07562ec4$var$yg[$8967ecdc07562ec4$var$zg++] = $8967ecdc07562ec4$var$Bg;
    $8967ecdc07562ec4$var$yg[$8967ecdc07562ec4$var$zg++] = $8967ecdc07562ec4$var$Ag;
    $8967ecdc07562ec4$var$Ag = a;
    $8967ecdc07562ec4$var$Bg = b;
}
function $8967ecdc07562ec4$var$Ig(a, b, c) {
    $8967ecdc07562ec4$var$Cg[$8967ecdc07562ec4$var$Dg++] = $8967ecdc07562ec4$var$Fg;
    $8967ecdc07562ec4$var$Cg[$8967ecdc07562ec4$var$Dg++] = $8967ecdc07562ec4$var$Gg;
    $8967ecdc07562ec4$var$Cg[$8967ecdc07562ec4$var$Dg++] = $8967ecdc07562ec4$var$Eg;
    $8967ecdc07562ec4$var$Eg = a;
    var d = $8967ecdc07562ec4$var$Fg;
    a = $8967ecdc07562ec4$var$Gg;
    var e = 32 - $8967ecdc07562ec4$var$Ac(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $8967ecdc07562ec4$var$Ac(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $8967ecdc07562ec4$var$Fg = 1 << 32 - $8967ecdc07562ec4$var$Ac(b) + e | c << e | d;
        $8967ecdc07562ec4$var$Gg = f + a;
    } else $8967ecdc07562ec4$var$Fg = 1 << f | c << e | d, $8967ecdc07562ec4$var$Gg = a;
}
function $8967ecdc07562ec4$var$Jg(a) {
    null !== a.return && ($8967ecdc07562ec4$var$Hg(a, 1), $8967ecdc07562ec4$var$Ig(a, 1, 0));
}
function $8967ecdc07562ec4$var$Kg(a) {
    for(; a === $8967ecdc07562ec4$var$Ag;)$8967ecdc07562ec4$var$Ag = $8967ecdc07562ec4$var$yg[--$8967ecdc07562ec4$var$zg], $8967ecdc07562ec4$var$yg[$8967ecdc07562ec4$var$zg] = null, $8967ecdc07562ec4$var$Bg = $8967ecdc07562ec4$var$yg[--$8967ecdc07562ec4$var$zg], $8967ecdc07562ec4$var$yg[$8967ecdc07562ec4$var$zg] = null;
    for(; a === $8967ecdc07562ec4$var$Eg;)$8967ecdc07562ec4$var$Eg = $8967ecdc07562ec4$var$Cg[--$8967ecdc07562ec4$var$Dg], $8967ecdc07562ec4$var$Cg[$8967ecdc07562ec4$var$Dg] = null, $8967ecdc07562ec4$var$Gg = $8967ecdc07562ec4$var$Cg[--$8967ecdc07562ec4$var$Dg], $8967ecdc07562ec4$var$Cg[$8967ecdc07562ec4$var$Dg] = null, $8967ecdc07562ec4$var$Fg = $8967ecdc07562ec4$var$Cg[--$8967ecdc07562ec4$var$Dg], $8967ecdc07562ec4$var$Cg[$8967ecdc07562ec4$var$Dg] = null;
}
var $8967ecdc07562ec4$var$Lg = null, $8967ecdc07562ec4$var$Mg = null, $8967ecdc07562ec4$var$J = !1, $8967ecdc07562ec4$var$Ng = null;
function $8967ecdc07562ec4$var$Og(a, b) {
    var c = $8967ecdc07562ec4$var$Pg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $8967ecdc07562ec4$var$Qg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $8967ecdc07562ec4$var$Lg = a, $8967ecdc07562ec4$var$Mg = $8967ecdc07562ec4$var$Zf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $8967ecdc07562ec4$var$Lg = a, $8967ecdc07562ec4$var$Mg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $8967ecdc07562ec4$var$Eg ? {
                id: $8967ecdc07562ec4$var$Fg,
                overflow: $8967ecdc07562ec4$var$Gg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $8967ecdc07562ec4$var$Pg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $8967ecdc07562ec4$var$Lg = a, $8967ecdc07562ec4$var$Mg = null, !0) : !1;
        default:
            return !1;
    }
}
function $8967ecdc07562ec4$var$Rg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $8967ecdc07562ec4$var$Sg(a) {
    if ($8967ecdc07562ec4$var$J) {
        var b = $8967ecdc07562ec4$var$Mg;
        if (b) {
            var c = b;
            if (!$8967ecdc07562ec4$var$Qg(a, b)) {
                if ($8967ecdc07562ec4$var$Rg(a)) throw Error($8967ecdc07562ec4$var$p(418));
                b = $8967ecdc07562ec4$var$Zf(c.nextSibling);
                var d = $8967ecdc07562ec4$var$Lg;
                b && $8967ecdc07562ec4$var$Qg(a, b) ? $8967ecdc07562ec4$var$Og(d, c) : (a.flags = a.flags & -4097 | 2, $8967ecdc07562ec4$var$J = !1, $8967ecdc07562ec4$var$Lg = a);
            }
        } else {
            if ($8967ecdc07562ec4$var$Rg(a)) throw Error($8967ecdc07562ec4$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $8967ecdc07562ec4$var$J = !1;
            $8967ecdc07562ec4$var$Lg = a;
        }
    }
}
function $8967ecdc07562ec4$var$Tg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $8967ecdc07562ec4$var$Lg = a;
}
function $8967ecdc07562ec4$var$Ug(a) {
    if (a !== $8967ecdc07562ec4$var$Lg) return !1;
    if (!$8967ecdc07562ec4$var$J) return $8967ecdc07562ec4$var$Tg(a), $8967ecdc07562ec4$var$J = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$8967ecdc07562ec4$var$Sf(a.type, a.memoizedProps));
    if (b && (b = $8967ecdc07562ec4$var$Mg)) {
        if ($8967ecdc07562ec4$var$Rg(a)) throw $8967ecdc07562ec4$var$Vg(), Error($8967ecdc07562ec4$var$p(418));
        for(; b;)$8967ecdc07562ec4$var$Og(a, b), b = $8967ecdc07562ec4$var$Zf(b.nextSibling);
    }
    $8967ecdc07562ec4$var$Tg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($8967ecdc07562ec4$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $8967ecdc07562ec4$var$Mg = $8967ecdc07562ec4$var$Zf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $8967ecdc07562ec4$var$Mg = null;
        }
    } else $8967ecdc07562ec4$var$Mg = $8967ecdc07562ec4$var$Lg ? $8967ecdc07562ec4$var$Zf(a.stateNode.nextSibling) : null;
    return !0;
}
function $8967ecdc07562ec4$var$Vg() {
    for(var a = $8967ecdc07562ec4$var$Mg; a;)a = $8967ecdc07562ec4$var$Zf(a.nextSibling);
}
function $8967ecdc07562ec4$var$Wg() {
    $8967ecdc07562ec4$var$Mg = $8967ecdc07562ec4$var$Lg = null;
    $8967ecdc07562ec4$var$J = !1;
}
function $8967ecdc07562ec4$var$Xg(a) {
    null === $8967ecdc07562ec4$var$Ng ? $8967ecdc07562ec4$var$Ng = [
        a
    ] : $8967ecdc07562ec4$var$Ng.push(a);
}
var $8967ecdc07562ec4$var$Yg = $8967ecdc07562ec4$var$va.ReactCurrentBatchConfig;
function $8967ecdc07562ec4$var$Zg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($8967ecdc07562ec4$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($8967ecdc07562ec4$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($8967ecdc07562ec4$var$p(284));
        if (!c._owner) throw Error($8967ecdc07562ec4$var$p(290, a));
    }
    return a;
}
function $8967ecdc07562ec4$var$$g(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($8967ecdc07562ec4$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $8967ecdc07562ec4$var$ah(a) {
    var b = a._init;
    return b(a._payload);
}
function $8967ecdc07562ec4$var$bh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $8967ecdc07562ec4$var$ch(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $8967ecdc07562ec4$var$dh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $8967ecdc07562ec4$var$ya) return n(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $8967ecdc07562ec4$var$Ha && $8967ecdc07562ec4$var$ah(f) === b.type)) return d = e(b, c.props), d.ref = $8967ecdc07562ec4$var$Zg(a, b, c), d.return = a, d;
        d = $8967ecdc07562ec4$var$eh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $8967ecdc07562ec4$var$Zg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $8967ecdc07562ec4$var$fh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $8967ecdc07562ec4$var$gh(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $8967ecdc07562ec4$var$dh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $8967ecdc07562ec4$var$wa:
                    return c = $8967ecdc07562ec4$var$eh(b.type, b.key, b.props, null, a.mode, c), c.ref = $8967ecdc07562ec4$var$Zg(a, null, b), c.return = a, c;
                case $8967ecdc07562ec4$var$xa:
                    return b = $8967ecdc07562ec4$var$fh(b, a.mode, c), b.return = a, b;
                case $8967ecdc07562ec4$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($8967ecdc07562ec4$var$db(b) || $8967ecdc07562ec4$var$Ka(b)) return b = $8967ecdc07562ec4$var$gh(b, a.mode, c, null), b.return = a, b;
            $8967ecdc07562ec4$var$$g(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $8967ecdc07562ec4$var$wa:
                    return c.key === e ? k(a, b, c, d) : null;
                case $8967ecdc07562ec4$var$xa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $8967ecdc07562ec4$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($8967ecdc07562ec4$var$db(c) || $8967ecdc07562ec4$var$Ka(c)) return null !== e ? null : n(a, b, c, d, null);
            $8967ecdc07562ec4$var$$g(a, c);
        }
        return null;
    }
    function z(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $8967ecdc07562ec4$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $8967ecdc07562ec4$var$xa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $8967ecdc07562ec4$var$Ha:
                    var f = d._init;
                    return z(a, b, c, f(d._payload), e);
            }
            if ($8967ecdc07562ec4$var$db(d) || $8967ecdc07562ec4$var$Ka(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            $8967ecdc07562ec4$var$$g(b, d);
        }
        return null;
    }
    function m(e, g, h, k) {
        for(var l = null, v = null, n = g, m = g = 0, y = null; null !== n && m < h.length; m++){
            n.index > m ? (y = n, n = null) : y = n.sibling;
            var x = r(e, n, h[m], k);
            if (null === x) {
                null === n && (n = y);
                break;
            }
            a && n && null === x.alternate && b(e, n);
            g = f(x, g, m);
            null === v ? l = x : v.sibling = x;
            v = x;
            n = y;
        }
        if (m === h.length) return c(e, n), $8967ecdc07562ec4$var$J && $8967ecdc07562ec4$var$Hg(e, m), l;
        if (null === n) {
            for(; m < h.length; m++)n = q(e, h[m], k), null !== n && (g = f(n, g, m), null === v ? l = n : v.sibling = n, v = n);
            $8967ecdc07562ec4$var$J && $8967ecdc07562ec4$var$Hg(e, m);
            return l;
        }
        for(n = d(e, n); m < h.length; m++)y = z(n, e, m, h[m], k), null !== y && (a && null !== y.alternate && n.delete(null === y.key ? m : y.key), g = f(y, g, m), null === v ? l = y : v.sibling = y, v = y);
        a && n.forEach(function(a) {
            return b(e, a);
        });
        $8967ecdc07562ec4$var$J && $8967ecdc07562ec4$var$Hg(e, m);
        return l;
    }
    function w(e, g, h, k) {
        var l = $8967ecdc07562ec4$var$Ka(h);
        if ("function" !== typeof l) throw Error($8967ecdc07562ec4$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($8967ecdc07562ec4$var$p(151));
        for(var n = l = null, m = g, v = g = 0, y = null, x = h.next(); null !== m && !x.done; v++, x = h.next()){
            m.index > v ? (y = m, m = null) : y = m.sibling;
            var w = r(e, m, x.value, k);
            if (null === w) {
                null === m && (m = y);
                break;
            }
            a && m && null === w.alternate && b(e, m);
            g = f(w, g, v);
            null === n ? l = w : n.sibling = w;
            n = w;
            m = y;
        }
        if (x.done) return c(e, m), $8967ecdc07562ec4$var$J && $8967ecdc07562ec4$var$Hg(e, v), l;
        if (null === m) {
            for(; !x.done; v++, x = h.next())x = q(e, x.value, k), null !== x && (g = f(x, g, v), null === n ? l = x : n.sibling = x, n = x);
            $8967ecdc07562ec4$var$J && $8967ecdc07562ec4$var$Hg(e, v);
            return l;
        }
        for(m = d(e, m); !x.done; v++, x = h.next())x = z(m, e, v, x.value, k), null !== x && (a && null !== x.alternate && m.delete(null === x.key ? v : x.key), g = f(x, g, v), null === n ? l = x : n.sibling = x, n = x);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $8967ecdc07562ec4$var$J && $8967ecdc07562ec4$var$Hg(e, v);
        return l;
    }
    function C(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $8967ecdc07562ec4$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $8967ecdc07562ec4$var$wa:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $8967ecdc07562ec4$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $8967ecdc07562ec4$var$Ha && $8967ecdc07562ec4$var$ah(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $8967ecdc07562ec4$var$Zg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $8967ecdc07562ec4$var$ya ? (d = $8967ecdc07562ec4$var$gh(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $8967ecdc07562ec4$var$eh(f.type, f.key, f.props, null, a.mode, h), h.ref = $8967ecdc07562ec4$var$Zg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $8967ecdc07562ec4$var$xa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $8967ecdc07562ec4$var$fh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $8967ecdc07562ec4$var$Ha:
                    return l = f._init, C(a, d, l(f._payload), h);
            }
            if ($8967ecdc07562ec4$var$db(f)) return m(a, d, f, h);
            if ($8967ecdc07562ec4$var$Ka(f)) return w(a, d, f, h);
            $8967ecdc07562ec4$var$$g(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $8967ecdc07562ec4$var$dh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return C;
}
var $8967ecdc07562ec4$var$hh = $8967ecdc07562ec4$var$bh(!0), $8967ecdc07562ec4$var$ih = $8967ecdc07562ec4$var$bh(!1), $8967ecdc07562ec4$var$jh = $8967ecdc07562ec4$var$hg(null), $8967ecdc07562ec4$var$kh = null, $8967ecdc07562ec4$var$lh = null, $8967ecdc07562ec4$var$mh = null;
function $8967ecdc07562ec4$var$nh() {
    $8967ecdc07562ec4$var$mh = $8967ecdc07562ec4$var$lh = $8967ecdc07562ec4$var$kh = null;
}
function $8967ecdc07562ec4$var$oh(a) {
    var b = $8967ecdc07562ec4$var$jh.current;
    $8967ecdc07562ec4$var$G($8967ecdc07562ec4$var$jh);
    a._currentValue = b;
}
function $8967ecdc07562ec4$var$ph(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $8967ecdc07562ec4$var$qh(a, b) {
    $8967ecdc07562ec4$var$kh = a;
    $8967ecdc07562ec4$var$mh = $8967ecdc07562ec4$var$lh = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($8967ecdc07562ec4$var$rh = !0), a.firstContext = null);
}
function $8967ecdc07562ec4$var$sh(a) {
    var b = a._currentValue;
    if ($8967ecdc07562ec4$var$mh !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $8967ecdc07562ec4$var$lh) {
            if (null === $8967ecdc07562ec4$var$kh) throw Error($8967ecdc07562ec4$var$p(308));
            $8967ecdc07562ec4$var$lh = a;
            $8967ecdc07562ec4$var$kh.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $8967ecdc07562ec4$var$lh = $8967ecdc07562ec4$var$lh.next = a;
    }
    return b;
}
var $8967ecdc07562ec4$var$th = null;
function $8967ecdc07562ec4$var$uh(a) {
    null === $8967ecdc07562ec4$var$th ? $8967ecdc07562ec4$var$th = [
        a
    ] : $8967ecdc07562ec4$var$th.push(a);
}
function $8967ecdc07562ec4$var$vh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $8967ecdc07562ec4$var$uh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $8967ecdc07562ec4$var$wh(a, d);
}
function $8967ecdc07562ec4$var$wh(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $8967ecdc07562ec4$var$xh = !1;
function $8967ecdc07562ec4$var$yh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $8967ecdc07562ec4$var$zh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $8967ecdc07562ec4$var$Ah(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $8967ecdc07562ec4$var$Bh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($8967ecdc07562ec4$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $8967ecdc07562ec4$var$wh(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $8967ecdc07562ec4$var$uh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $8967ecdc07562ec4$var$wh(a, c);
}
function $8967ecdc07562ec4$var$Ch(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $8967ecdc07562ec4$var$Oc(a, c);
    }
}
function $8967ecdc07562ec4$var$Dh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $8967ecdc07562ec4$var$Eh(a, b, c, d) {
    var e = a.updateQueue;
    $8967ecdc07562ec4$var$xh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        null !== n && (n = n.updateQueue, h = n.lastBaseUpdate, h !== g && (null === h ? n.firstBaseUpdate = l : h.next = l, n.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        n = l = k = null;
        h = f;
        do {
            var r = h.lane, z = h.eventTime;
            if ((d & r) === r) {
                null !== n && (n = n.next = {
                    eventTime: z,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var m = a, w = h;
                    r = b;
                    z = c;
                    switch(w.tag){
                        case 1:
                            m = w.payload;
                            if ("function" === typeof m) {
                                q = m.call(z, q, r);
                                break a;
                            }
                            q = m;
                            break a;
                        case 3:
                            m.flags = m.flags & -65537 | 128;
                        case 0:
                            m = w.payload;
                            r = "function" === typeof m ? m.call(z, q, r) : m;
                            if (null === r || void 0 === r) break a;
                            q = $8967ecdc07562ec4$var$u({}, q, r);
                            break a;
                        case 2:
                            $8967ecdc07562ec4$var$xh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else z = {
                eventTime: z,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === n ? (l = n = z, k = q) : n = n.next = z, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $8967ecdc07562ec4$var$Fh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $8967ecdc07562ec4$var$Gh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($8967ecdc07562ec4$var$p(191, e));
            e.call(d);
        }
    }
}
var $8967ecdc07562ec4$var$Hh = {}, $8967ecdc07562ec4$var$Ih = $8967ecdc07562ec4$var$hg($8967ecdc07562ec4$var$Hh), $8967ecdc07562ec4$var$Jh = $8967ecdc07562ec4$var$hg($8967ecdc07562ec4$var$Hh), $8967ecdc07562ec4$var$Kh = $8967ecdc07562ec4$var$hg($8967ecdc07562ec4$var$Hh);
function $8967ecdc07562ec4$var$Lh(a) {
    if (a === $8967ecdc07562ec4$var$Hh) throw Error($8967ecdc07562ec4$var$p(174));
    return a;
}
function $8967ecdc07562ec4$var$Mh(a, b) {
    $8967ecdc07562ec4$var$H($8967ecdc07562ec4$var$Kh, b);
    $8967ecdc07562ec4$var$H($8967ecdc07562ec4$var$Jh, a);
    $8967ecdc07562ec4$var$H($8967ecdc07562ec4$var$Ih, $8967ecdc07562ec4$var$Hh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $8967ecdc07562ec4$var$kb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $8967ecdc07562ec4$var$kb(b, a);
    }
    $8967ecdc07562ec4$var$G($8967ecdc07562ec4$var$Ih);
    $8967ecdc07562ec4$var$H($8967ecdc07562ec4$var$Ih, b);
}
function $8967ecdc07562ec4$var$Nh() {
    $8967ecdc07562ec4$var$G($8967ecdc07562ec4$var$Ih);
    $8967ecdc07562ec4$var$G($8967ecdc07562ec4$var$Jh);
    $8967ecdc07562ec4$var$G($8967ecdc07562ec4$var$Kh);
}
function $8967ecdc07562ec4$var$Oh(a) {
    $8967ecdc07562ec4$var$Lh($8967ecdc07562ec4$var$Kh.current);
    var b = $8967ecdc07562ec4$var$Lh($8967ecdc07562ec4$var$Ih.current);
    var c = $8967ecdc07562ec4$var$kb(b, a.type);
    b !== c && ($8967ecdc07562ec4$var$H($8967ecdc07562ec4$var$Jh, a), $8967ecdc07562ec4$var$H($8967ecdc07562ec4$var$Ih, c));
}
function $8967ecdc07562ec4$var$Ph(a) {
    $8967ecdc07562ec4$var$Jh.current === a && ($8967ecdc07562ec4$var$G($8967ecdc07562ec4$var$Ih), $8967ecdc07562ec4$var$G($8967ecdc07562ec4$var$Jh));
}
var $8967ecdc07562ec4$var$L = $8967ecdc07562ec4$var$hg(0);
function $8967ecdc07562ec4$var$Qh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $8967ecdc07562ec4$var$Rh = [];
function $8967ecdc07562ec4$var$Sh() {
    for(var a = 0; a < $8967ecdc07562ec4$var$Rh.length; a++)$8967ecdc07562ec4$var$Rh[a]._workInProgressVersionPrimary = null;
    $8967ecdc07562ec4$var$Rh.length = 0;
}
var $8967ecdc07562ec4$var$Th = $8967ecdc07562ec4$var$va.ReactCurrentDispatcher, $8967ecdc07562ec4$var$Uh = $8967ecdc07562ec4$var$va.ReactCurrentBatchConfig, $8967ecdc07562ec4$var$Vh = 0, $8967ecdc07562ec4$var$M = null, $8967ecdc07562ec4$var$N = null, $8967ecdc07562ec4$var$O = null, $8967ecdc07562ec4$var$Wh = !1, $8967ecdc07562ec4$var$Xh = !1, $8967ecdc07562ec4$var$Yh = 0, $8967ecdc07562ec4$var$Zh = 0;
function $8967ecdc07562ec4$var$P() {
    throw Error($8967ecdc07562ec4$var$p(321));
}
function $8967ecdc07562ec4$var$$h(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$8967ecdc07562ec4$var$Ve(a[c], b[c])) return !1;
    return !0;
}
function $8967ecdc07562ec4$var$ai(a, b, c, d, e, f) {
    $8967ecdc07562ec4$var$Vh = f;
    $8967ecdc07562ec4$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $8967ecdc07562ec4$var$Th.current = null === a || null === a.memoizedState ? $8967ecdc07562ec4$var$bi : $8967ecdc07562ec4$var$ci;
    a = c(d, e);
    if ($8967ecdc07562ec4$var$Xh) {
        f = 0;
        do {
            $8967ecdc07562ec4$var$Xh = !1;
            $8967ecdc07562ec4$var$Yh = 0;
            if (25 <= f) throw Error($8967ecdc07562ec4$var$p(301));
            f += 1;
            $8967ecdc07562ec4$var$O = $8967ecdc07562ec4$var$N = null;
            b.updateQueue = null;
            $8967ecdc07562ec4$var$Th.current = $8967ecdc07562ec4$var$di;
            a = c(d, e);
        }while ($8967ecdc07562ec4$var$Xh);
    }
    $8967ecdc07562ec4$var$Th.current = $8967ecdc07562ec4$var$ei;
    b = null !== $8967ecdc07562ec4$var$N && null !== $8967ecdc07562ec4$var$N.next;
    $8967ecdc07562ec4$var$Vh = 0;
    $8967ecdc07562ec4$var$O = $8967ecdc07562ec4$var$N = $8967ecdc07562ec4$var$M = null;
    $8967ecdc07562ec4$var$Wh = !1;
    if (b) throw Error($8967ecdc07562ec4$var$p(300));
    return a;
}
function $8967ecdc07562ec4$var$fi() {
    var a = 0 !== $8967ecdc07562ec4$var$Yh;
    $8967ecdc07562ec4$var$Yh = 0;
    return a;
}
function $8967ecdc07562ec4$var$gi() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $8967ecdc07562ec4$var$O ? $8967ecdc07562ec4$var$M.memoizedState = $8967ecdc07562ec4$var$O = a : $8967ecdc07562ec4$var$O = $8967ecdc07562ec4$var$O.next = a;
    return $8967ecdc07562ec4$var$O;
}
function $8967ecdc07562ec4$var$hi() {
    if (null === $8967ecdc07562ec4$var$N) {
        var a = $8967ecdc07562ec4$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $8967ecdc07562ec4$var$N.next;
    var b = null === $8967ecdc07562ec4$var$O ? $8967ecdc07562ec4$var$M.memoizedState : $8967ecdc07562ec4$var$O.next;
    if (null !== b) $8967ecdc07562ec4$var$O = b, $8967ecdc07562ec4$var$N = a;
    else {
        if (null === a) throw Error($8967ecdc07562ec4$var$p(310));
        $8967ecdc07562ec4$var$N = a;
        a = {
            memoizedState: $8967ecdc07562ec4$var$N.memoizedState,
            baseState: $8967ecdc07562ec4$var$N.baseState,
            baseQueue: $8967ecdc07562ec4$var$N.baseQueue,
            queue: $8967ecdc07562ec4$var$N.queue,
            next: null
        };
        null === $8967ecdc07562ec4$var$O ? $8967ecdc07562ec4$var$M.memoizedState = $8967ecdc07562ec4$var$O = a : $8967ecdc07562ec4$var$O = $8967ecdc07562ec4$var$O.next = a;
    }
    return $8967ecdc07562ec4$var$O;
}
function $8967ecdc07562ec4$var$ii(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $8967ecdc07562ec4$var$ji(a) {
    var b = $8967ecdc07562ec4$var$hi(), c = b.queue;
    if (null === c) throw Error($8967ecdc07562ec4$var$p(311));
    c.lastRenderedReducer = a;
    var d = $8967ecdc07562ec4$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var n = l.lane;
            if (($8967ecdc07562ec4$var$Vh & n) === n) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: n,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $8967ecdc07562ec4$var$M.lanes |= n;
                $8967ecdc07562ec4$var$Fh |= n;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $8967ecdc07562ec4$var$Ve(d, b.memoizedState) || ($8967ecdc07562ec4$var$rh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $8967ecdc07562ec4$var$M.lanes |= f, $8967ecdc07562ec4$var$Fh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $8967ecdc07562ec4$var$ki(a) {
    var b = $8967ecdc07562ec4$var$hi(), c = b.queue;
    if (null === c) throw Error($8967ecdc07562ec4$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $8967ecdc07562ec4$var$Ve(f, b.memoizedState) || ($8967ecdc07562ec4$var$rh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $8967ecdc07562ec4$var$li() {}
function $8967ecdc07562ec4$var$mi(a, b) {
    var c = $8967ecdc07562ec4$var$M, d = $8967ecdc07562ec4$var$hi(), e = b(), f = !$8967ecdc07562ec4$var$Ve(d.memoizedState, e);
    f && (d.memoizedState = e, $8967ecdc07562ec4$var$rh = !0);
    d = d.queue;
    $8967ecdc07562ec4$var$ni($8967ecdc07562ec4$var$oi.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $8967ecdc07562ec4$var$O && $8967ecdc07562ec4$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $8967ecdc07562ec4$var$pi(9, $8967ecdc07562ec4$var$qi.bind(null, c, d, e, b), void 0, null);
        if (null === $8967ecdc07562ec4$var$Q) throw Error($8967ecdc07562ec4$var$p(349));
        0 !== ($8967ecdc07562ec4$var$Vh & 30) || $8967ecdc07562ec4$var$ri(c, b, e);
    }
    return e;
}
function $8967ecdc07562ec4$var$ri(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $8967ecdc07562ec4$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $8967ecdc07562ec4$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $8967ecdc07562ec4$var$qi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $8967ecdc07562ec4$var$si(b) && $8967ecdc07562ec4$var$ti(a);
}
function $8967ecdc07562ec4$var$oi(a, b, c) {
    return c(function() {
        $8967ecdc07562ec4$var$si(b) && $8967ecdc07562ec4$var$ti(a);
    });
}
function $8967ecdc07562ec4$var$si(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$8967ecdc07562ec4$var$Ve(a, c);
    } catch (d) {
        return !0;
    }
}
function $8967ecdc07562ec4$var$ti(a) {
    var b = $8967ecdc07562ec4$var$wh(a, 1);
    null !== b && $8967ecdc07562ec4$var$ui(b, a, 1, -1);
}
function $8967ecdc07562ec4$var$vi(a) {
    var b = $8967ecdc07562ec4$var$gi();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $8967ecdc07562ec4$var$ii,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $8967ecdc07562ec4$var$wi.bind(null, $8967ecdc07562ec4$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $8967ecdc07562ec4$var$pi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $8967ecdc07562ec4$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $8967ecdc07562ec4$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $8967ecdc07562ec4$var$xi() {
    return $8967ecdc07562ec4$var$hi().memoizedState;
}
function $8967ecdc07562ec4$var$Ai(a, b, c, d) {
    var e = $8967ecdc07562ec4$var$gi();
    $8967ecdc07562ec4$var$M.flags |= a;
    e.memoizedState = $8967ecdc07562ec4$var$pi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $8967ecdc07562ec4$var$Bi(a, b, c, d) {
    var e = $8967ecdc07562ec4$var$hi();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $8967ecdc07562ec4$var$N) {
        var g = $8967ecdc07562ec4$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $8967ecdc07562ec4$var$$h(d, g.deps)) {
            e.memoizedState = $8967ecdc07562ec4$var$pi(b, c, f, d);
            return;
        }
    }
    $8967ecdc07562ec4$var$M.flags |= a;
    e.memoizedState = $8967ecdc07562ec4$var$pi(1 | b, c, f, d);
}
function $8967ecdc07562ec4$var$Ci(a, b) {
    return $8967ecdc07562ec4$var$Ai(8390656, 8, a, b);
}
function $8967ecdc07562ec4$var$ni(a, b) {
    return $8967ecdc07562ec4$var$Bi(2048, 8, a, b);
}
function $8967ecdc07562ec4$var$Di(a, b) {
    return $8967ecdc07562ec4$var$Bi(4, 2, a, b);
}
function $8967ecdc07562ec4$var$Ei(a, b) {
    return $8967ecdc07562ec4$var$Bi(4, 4, a, b);
}
function $8967ecdc07562ec4$var$Fi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $8967ecdc07562ec4$var$Gi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $8967ecdc07562ec4$var$Bi(4, 4, $8967ecdc07562ec4$var$Fi.bind(null, b, a), c);
}
function $8967ecdc07562ec4$var$Hi() {}
function $8967ecdc07562ec4$var$Ii(a, b) {
    var c = $8967ecdc07562ec4$var$hi();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $8967ecdc07562ec4$var$$h(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $8967ecdc07562ec4$var$Ji(a, b) {
    var c = $8967ecdc07562ec4$var$hi();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $8967ecdc07562ec4$var$$h(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $8967ecdc07562ec4$var$Ki(a, b, c) {
    if (0 === ($8967ecdc07562ec4$var$Vh & 21)) return a.baseState && (a.baseState = !1, $8967ecdc07562ec4$var$rh = !0), a.memoizedState = c;
    $8967ecdc07562ec4$var$Ve(c, b) || (c = $8967ecdc07562ec4$var$Kc(), $8967ecdc07562ec4$var$M.lanes |= c, $8967ecdc07562ec4$var$Fh |= c, a.baseState = !0);
    return b;
}
function $8967ecdc07562ec4$var$Li(a, b) {
    var c = $8967ecdc07562ec4$var$E;
    $8967ecdc07562ec4$var$E = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $8967ecdc07562ec4$var$Uh.transition;
    $8967ecdc07562ec4$var$Uh.transition = {};
    try {
        a(!1), b();
    } finally{
        $8967ecdc07562ec4$var$E = c, $8967ecdc07562ec4$var$Uh.transition = d;
    }
}
function $8967ecdc07562ec4$var$Mi() {
    return $8967ecdc07562ec4$var$hi().memoizedState;
}
function $8967ecdc07562ec4$var$Ni(a, b, c) {
    var d = $8967ecdc07562ec4$var$Oi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($8967ecdc07562ec4$var$Pi(a)) $8967ecdc07562ec4$var$Qi(b, c);
    else if (c = $8967ecdc07562ec4$var$vh(a, b, c, d), null !== c) {
        var e = $8967ecdc07562ec4$var$Ri();
        $8967ecdc07562ec4$var$ui(c, a, d, e);
        $8967ecdc07562ec4$var$Si(c, b, d);
    }
    $8967ecdc07562ec4$var$yc(a, d);
}
function $8967ecdc07562ec4$var$wi(a, b, c) {
    var d = $8967ecdc07562ec4$var$Oi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($8967ecdc07562ec4$var$Pi(a)) $8967ecdc07562ec4$var$Qi(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($8967ecdc07562ec4$var$Ve(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $8967ecdc07562ec4$var$uh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $8967ecdc07562ec4$var$vh(a, b, e, d);
        null !== c && (e = $8967ecdc07562ec4$var$Ri(), $8967ecdc07562ec4$var$ui(c, a, d, e), $8967ecdc07562ec4$var$Si(c, b, d));
    }
    $8967ecdc07562ec4$var$yc(a, d);
}
function $8967ecdc07562ec4$var$Pi(a) {
    var b = a.alternate;
    return a === $8967ecdc07562ec4$var$M || null !== b && b === $8967ecdc07562ec4$var$M;
}
function $8967ecdc07562ec4$var$Qi(a, b) {
    $8967ecdc07562ec4$var$Xh = $8967ecdc07562ec4$var$Wh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $8967ecdc07562ec4$var$Si(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $8967ecdc07562ec4$var$Oc(a, c);
    }
}
var $8967ecdc07562ec4$var$ei = {
    readContext: $8967ecdc07562ec4$var$sh,
    useCallback: $8967ecdc07562ec4$var$P,
    useContext: $8967ecdc07562ec4$var$P,
    useEffect: $8967ecdc07562ec4$var$P,
    useImperativeHandle: $8967ecdc07562ec4$var$P,
    useInsertionEffect: $8967ecdc07562ec4$var$P,
    useLayoutEffect: $8967ecdc07562ec4$var$P,
    useMemo: $8967ecdc07562ec4$var$P,
    useReducer: $8967ecdc07562ec4$var$P,
    useRef: $8967ecdc07562ec4$var$P,
    useState: $8967ecdc07562ec4$var$P,
    useDebugValue: $8967ecdc07562ec4$var$P,
    useDeferredValue: $8967ecdc07562ec4$var$P,
    useTransition: $8967ecdc07562ec4$var$P,
    useMutableSource: $8967ecdc07562ec4$var$P,
    useSyncExternalStore: $8967ecdc07562ec4$var$P,
    useId: $8967ecdc07562ec4$var$P,
    unstable_isNewReconciler: !1
}, $8967ecdc07562ec4$var$bi = {
    readContext: $8967ecdc07562ec4$var$sh,
    useCallback: function(a, b) {
        $8967ecdc07562ec4$var$gi().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $8967ecdc07562ec4$var$sh,
    useEffect: $8967ecdc07562ec4$var$Ci,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $8967ecdc07562ec4$var$Ai(4194308, 4, $8967ecdc07562ec4$var$Fi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $8967ecdc07562ec4$var$Ai(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $8967ecdc07562ec4$var$Ai(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $8967ecdc07562ec4$var$gi();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $8967ecdc07562ec4$var$gi();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $8967ecdc07562ec4$var$Ni.bind(null, $8967ecdc07562ec4$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $8967ecdc07562ec4$var$gi();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $8967ecdc07562ec4$var$vi,
    useDebugValue: $8967ecdc07562ec4$var$Hi,
    useDeferredValue: function(a) {
        return $8967ecdc07562ec4$var$gi().memoizedState = a;
    },
    useTransition: function() {
        var a = $8967ecdc07562ec4$var$vi(!1), b = a[0];
        a = $8967ecdc07562ec4$var$Li.bind(null, a[1]);
        $8967ecdc07562ec4$var$gi().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $8967ecdc07562ec4$var$M, e = $8967ecdc07562ec4$var$gi();
        if ($8967ecdc07562ec4$var$J) {
            if (void 0 === c) throw Error($8967ecdc07562ec4$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $8967ecdc07562ec4$var$Q) throw Error($8967ecdc07562ec4$var$p(349));
            0 !== ($8967ecdc07562ec4$var$Vh & 30) || $8967ecdc07562ec4$var$ri(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $8967ecdc07562ec4$var$Ci($8967ecdc07562ec4$var$oi.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $8967ecdc07562ec4$var$pi(9, $8967ecdc07562ec4$var$qi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $8967ecdc07562ec4$var$gi(), b = $8967ecdc07562ec4$var$Q.identifierPrefix;
        if ($8967ecdc07562ec4$var$J) {
            var c = $8967ecdc07562ec4$var$Gg;
            var d = $8967ecdc07562ec4$var$Fg;
            c = (d & ~(1 << 32 - $8967ecdc07562ec4$var$Ac(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $8967ecdc07562ec4$var$Yh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $8967ecdc07562ec4$var$Zh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $8967ecdc07562ec4$var$ci = {
    readContext: $8967ecdc07562ec4$var$sh,
    useCallback: $8967ecdc07562ec4$var$Ii,
    useContext: $8967ecdc07562ec4$var$sh,
    useEffect: $8967ecdc07562ec4$var$ni,
    useImperativeHandle: $8967ecdc07562ec4$var$Gi,
    useInsertionEffect: $8967ecdc07562ec4$var$Di,
    useLayoutEffect: $8967ecdc07562ec4$var$Ei,
    useMemo: $8967ecdc07562ec4$var$Ji,
    useReducer: $8967ecdc07562ec4$var$ji,
    useRef: $8967ecdc07562ec4$var$xi,
    useState: function() {
        return $8967ecdc07562ec4$var$ji($8967ecdc07562ec4$var$ii);
    },
    useDebugValue: $8967ecdc07562ec4$var$Hi,
    useDeferredValue: function(a) {
        var b = $8967ecdc07562ec4$var$hi();
        return $8967ecdc07562ec4$var$Ki(b, $8967ecdc07562ec4$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $8967ecdc07562ec4$var$ji($8967ecdc07562ec4$var$ii)[0], b = $8967ecdc07562ec4$var$hi().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $8967ecdc07562ec4$var$li,
    useSyncExternalStore: $8967ecdc07562ec4$var$mi,
    useId: $8967ecdc07562ec4$var$Mi,
    unstable_isNewReconciler: !1
}, $8967ecdc07562ec4$var$di = {
    readContext: $8967ecdc07562ec4$var$sh,
    useCallback: $8967ecdc07562ec4$var$Ii,
    useContext: $8967ecdc07562ec4$var$sh,
    useEffect: $8967ecdc07562ec4$var$ni,
    useImperativeHandle: $8967ecdc07562ec4$var$Gi,
    useInsertionEffect: $8967ecdc07562ec4$var$Di,
    useLayoutEffect: $8967ecdc07562ec4$var$Ei,
    useMemo: $8967ecdc07562ec4$var$Ji,
    useReducer: $8967ecdc07562ec4$var$ki,
    useRef: $8967ecdc07562ec4$var$xi,
    useState: function() {
        return $8967ecdc07562ec4$var$ki($8967ecdc07562ec4$var$ii);
    },
    useDebugValue: $8967ecdc07562ec4$var$Hi,
    useDeferredValue: function(a) {
        var b = $8967ecdc07562ec4$var$hi();
        return null === $8967ecdc07562ec4$var$N ? b.memoizedState = a : $8967ecdc07562ec4$var$Ki(b, $8967ecdc07562ec4$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $8967ecdc07562ec4$var$ki($8967ecdc07562ec4$var$ii)[0], b = $8967ecdc07562ec4$var$hi().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $8967ecdc07562ec4$var$li,
    useSyncExternalStore: $8967ecdc07562ec4$var$mi,
    useId: $8967ecdc07562ec4$var$Mi,
    unstable_isNewReconciler: !1
}, $8967ecdc07562ec4$var$Ti = $LXjOh.unstable_now, $8967ecdc07562ec4$var$Ui = 0, $8967ecdc07562ec4$var$Vi = -1, $8967ecdc07562ec4$var$Wi = -1, $8967ecdc07562ec4$var$Xi = -1, $8967ecdc07562ec4$var$Yi = !1, $8967ecdc07562ec4$var$Zi = !1;
function $8967ecdc07562ec4$var$$i(a, b) {
    if (0 <= $8967ecdc07562ec4$var$Wi) {
        var c = $8967ecdc07562ec4$var$Ti() - $8967ecdc07562ec4$var$Wi;
        a.actualDuration += c;
        b && (a.selfBaseDuration = c);
        $8967ecdc07562ec4$var$Wi = -1;
    }
}
function $8967ecdc07562ec4$var$aj(a) {
    if (0 <= $8967ecdc07562ec4$var$Vi) {
        var b = $8967ecdc07562ec4$var$Ti() - $8967ecdc07562ec4$var$Vi;
        $8967ecdc07562ec4$var$Vi = -1;
        for(a = a.return; null !== a;){
            switch(a.tag){
                case 3:
                    a.stateNode.effectDuration += b;
                    return;
                case 12:
                    a.stateNode.effectDuration += b;
                    return;
            }
            a = a.return;
        }
    }
}
function $8967ecdc07562ec4$var$bj(a) {
    if (0 <= $8967ecdc07562ec4$var$Xi) {
        var b = $8967ecdc07562ec4$var$Ti() - $8967ecdc07562ec4$var$Xi;
        $8967ecdc07562ec4$var$Xi = -1;
        for(a = a.return; null !== a;){
            switch(a.tag){
                case 3:
                    a = a.stateNode;
                    null !== a && (a.passiveEffectDuration += b);
                    return;
                case 12:
                    a = a.stateNode;
                    null !== a && (a.passiveEffectDuration += b);
                    return;
            }
            a = a.return;
        }
    }
}
function $8967ecdc07562ec4$var$cj() {
    $8967ecdc07562ec4$var$Vi = $8967ecdc07562ec4$var$Ti();
}
function $8967ecdc07562ec4$var$dj(a) {
    for(var b = a.child; b;)a.actualDuration += b.actualDuration, b = b.sibling;
}
function $8967ecdc07562ec4$var$ej(a, b) {
    if (a && a.defaultProps) {
        b = $8967ecdc07562ec4$var$u({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $8967ecdc07562ec4$var$fj(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $8967ecdc07562ec4$var$u({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $8967ecdc07562ec4$var$gj = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $8967ecdc07562ec4$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $8967ecdc07562ec4$var$Ri(), e = $8967ecdc07562ec4$var$Oi(a), f = $8967ecdc07562ec4$var$Ah(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $8967ecdc07562ec4$var$Bh(a, f, e);
        null !== b && ($8967ecdc07562ec4$var$ui(b, a, e, d), $8967ecdc07562ec4$var$Ch(b, a, e));
        $8967ecdc07562ec4$var$yc(a, e);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $8967ecdc07562ec4$var$Ri(), e = $8967ecdc07562ec4$var$Oi(a), f = $8967ecdc07562ec4$var$Ah(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $8967ecdc07562ec4$var$Bh(a, f, e);
        null !== b && ($8967ecdc07562ec4$var$ui(b, a, e, d), $8967ecdc07562ec4$var$Ch(b, a, e));
        $8967ecdc07562ec4$var$yc(a, e);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $8967ecdc07562ec4$var$Ri(), d = $8967ecdc07562ec4$var$Oi(a), e = $8967ecdc07562ec4$var$Ah(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $8967ecdc07562ec4$var$Bh(a, e, d);
        null !== b && ($8967ecdc07562ec4$var$ui(b, a, d, c), $8967ecdc07562ec4$var$Ch(b, a, d));
        null !== $8967ecdc07562ec4$var$B && "function" === typeof $8967ecdc07562ec4$var$B.markForceUpdateScheduled && $8967ecdc07562ec4$var$B.markForceUpdateScheduled(a, d);
    }
};
function $8967ecdc07562ec4$var$hj(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$8967ecdc07562ec4$var$We(c, d) || !$8967ecdc07562ec4$var$We(e, f) : !0;
}
function $8967ecdc07562ec4$var$ij(a, b, c) {
    var d = !1, e = $8967ecdc07562ec4$var$ig;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $8967ecdc07562ec4$var$sh(f) : (e = $8967ecdc07562ec4$var$mg(b) ? $8967ecdc07562ec4$var$kg : $8967ecdc07562ec4$var$I.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $8967ecdc07562ec4$var$lg(a, e) : $8967ecdc07562ec4$var$ig);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $8967ecdc07562ec4$var$gj;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $8967ecdc07562ec4$var$jj(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $8967ecdc07562ec4$var$gj.enqueueReplaceState(b, b.state, null);
}
function $8967ecdc07562ec4$var$kj(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $8967ecdc07562ec4$var$yh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $8967ecdc07562ec4$var$sh(f) : (f = $8967ecdc07562ec4$var$mg(b) ? $8967ecdc07562ec4$var$kg : $8967ecdc07562ec4$var$I.current, e.context = $8967ecdc07562ec4$var$lg(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($8967ecdc07562ec4$var$fj(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $8967ecdc07562ec4$var$gj.enqueueReplaceState(e, e.state, null), $8967ecdc07562ec4$var$Eh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $8967ecdc07562ec4$var$lj(a, b) {
    try {
        var c = "", d = b;
        do c += $8967ecdc07562ec4$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $8967ecdc07562ec4$var$mj(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $8967ecdc07562ec4$var$nj(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $8967ecdc07562ec4$var$oj = "function" === typeof WeakMap ? WeakMap : Map;
function $8967ecdc07562ec4$var$pj(a, b, c) {
    c = $8967ecdc07562ec4$var$Ah(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $8967ecdc07562ec4$var$qj || ($8967ecdc07562ec4$var$qj = !0, $8967ecdc07562ec4$var$rj = d);
        $8967ecdc07562ec4$var$nj(a, b);
    };
    return c;
}
function $8967ecdc07562ec4$var$sj(a, b, c) {
    c = $8967ecdc07562ec4$var$Ah(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $8967ecdc07562ec4$var$nj(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $8967ecdc07562ec4$var$nj(a, b);
        "function" !== typeof d && (null === $8967ecdc07562ec4$var$tj ? $8967ecdc07562ec4$var$tj = new Set([
            this
        ]) : $8967ecdc07562ec4$var$tj.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $8967ecdc07562ec4$var$uj(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $8967ecdc07562ec4$var$oj;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), d = $8967ecdc07562ec4$var$vj.bind(null, a, b, c), $8967ecdc07562ec4$var$mc && $8967ecdc07562ec4$var$wj(a, c), b.then(d, d));
}
function $8967ecdc07562ec4$var$xj(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $8967ecdc07562ec4$var$yj(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $8967ecdc07562ec4$var$Ah(-1, 1), b.tag = 2, $8967ecdc07562ec4$var$Bh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $8967ecdc07562ec4$var$zj = $8967ecdc07562ec4$var$va.ReactCurrentOwner, $8967ecdc07562ec4$var$rh = !1;
function $8967ecdc07562ec4$var$Aj(a, b, c, d) {
    b.child = null === a ? $8967ecdc07562ec4$var$ih(b, null, c, d) : $8967ecdc07562ec4$var$hh(b, a.child, c, d);
}
function $8967ecdc07562ec4$var$Bj(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $8967ecdc07562ec4$var$qh(b, e);
    $8967ecdc07562ec4$var$sc(b);
    d = $8967ecdc07562ec4$var$ai(a, b, c, d, f, e);
    c = $8967ecdc07562ec4$var$fi();
    $8967ecdc07562ec4$var$tc();
    if (null !== a && !$8967ecdc07562ec4$var$rh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $8967ecdc07562ec4$var$Cj(a, b, e);
    $8967ecdc07562ec4$var$J && c && $8967ecdc07562ec4$var$Jg(b);
    b.flags |= 1;
    $8967ecdc07562ec4$var$Aj(a, b, d, e);
    return b.child;
}
function $8967ecdc07562ec4$var$Dj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$8967ecdc07562ec4$var$Ej(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $8967ecdc07562ec4$var$Fj(a, b, f, d, e);
        a = $8967ecdc07562ec4$var$eh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $8967ecdc07562ec4$var$We;
        if (c(g, d) && a.ref === b.ref) return $8967ecdc07562ec4$var$Cj(a, b, e);
    }
    b.flags |= 1;
    a = $8967ecdc07562ec4$var$ch(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $8967ecdc07562ec4$var$Fj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($8967ecdc07562ec4$var$We(f, d) && a.ref === b.ref) {
            if ($8967ecdc07562ec4$var$rh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($8967ecdc07562ec4$var$rh = !0);
            else return b.lanes = a.lanes, $8967ecdc07562ec4$var$Cj(a, b, e);
        }
    }
    return $8967ecdc07562ec4$var$Gj(a, b, c, d, e);
}
function $8967ecdc07562ec4$var$Hj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $8967ecdc07562ec4$var$H($8967ecdc07562ec4$var$Ij, $8967ecdc07562ec4$var$Jj), $8967ecdc07562ec4$var$Jj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $8967ecdc07562ec4$var$H($8967ecdc07562ec4$var$Ij, $8967ecdc07562ec4$var$Jj), $8967ecdc07562ec4$var$Jj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $8967ecdc07562ec4$var$H($8967ecdc07562ec4$var$Ij, $8967ecdc07562ec4$var$Jj);
            $8967ecdc07562ec4$var$Jj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $8967ecdc07562ec4$var$H($8967ecdc07562ec4$var$Ij, $8967ecdc07562ec4$var$Jj), $8967ecdc07562ec4$var$Jj |= d;
    $8967ecdc07562ec4$var$Aj(a, b, e, c);
    return b.child;
}
function $8967ecdc07562ec4$var$Kj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $8967ecdc07562ec4$var$Gj(a, b, c, d, e) {
    var f = $8967ecdc07562ec4$var$mg(c) ? $8967ecdc07562ec4$var$kg : $8967ecdc07562ec4$var$I.current;
    f = $8967ecdc07562ec4$var$lg(b, f);
    $8967ecdc07562ec4$var$qh(b, e);
    $8967ecdc07562ec4$var$sc(b);
    c = $8967ecdc07562ec4$var$ai(a, b, c, d, f, e);
    d = $8967ecdc07562ec4$var$fi();
    $8967ecdc07562ec4$var$tc();
    if (null !== a && !$8967ecdc07562ec4$var$rh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $8967ecdc07562ec4$var$Cj(a, b, e);
    $8967ecdc07562ec4$var$J && d && $8967ecdc07562ec4$var$Jg(b);
    b.flags |= 1;
    $8967ecdc07562ec4$var$Aj(a, b, c, e);
    return b.child;
}
function $8967ecdc07562ec4$var$Lj(a, b, c, d, e) {
    if ($8967ecdc07562ec4$var$mg(c)) {
        var f = !0;
        $8967ecdc07562ec4$var$qg(b);
    } else f = !1;
    $8967ecdc07562ec4$var$qh(b, e);
    if (null === b.stateNode) $8967ecdc07562ec4$var$Mj(a, b), $8967ecdc07562ec4$var$ij(b, c, d), $8967ecdc07562ec4$var$kj(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $8967ecdc07562ec4$var$sh(l) : (l = $8967ecdc07562ec4$var$mg(c) ? $8967ecdc07562ec4$var$kg : $8967ecdc07562ec4$var$I.current, l = $8967ecdc07562ec4$var$lg(b, l));
        var n = c.getDerivedStateFromProps, q = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $8967ecdc07562ec4$var$jj(b, g, d, l);
        $8967ecdc07562ec4$var$xh = !1;
        var r = b.memoizedState;
        g.state = r;
        $8967ecdc07562ec4$var$Eh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $8967ecdc07562ec4$var$jg.current || $8967ecdc07562ec4$var$xh ? ("function" === typeof n && ($8967ecdc07562ec4$var$fj(b, c, n, d), k = b.memoizedState), (h = $8967ecdc07562ec4$var$xh || $8967ecdc07562ec4$var$hj(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $8967ecdc07562ec4$var$zh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $8967ecdc07562ec4$var$ej(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $8967ecdc07562ec4$var$sh(k) : (k = $8967ecdc07562ec4$var$mg(c) ? $8967ecdc07562ec4$var$kg : $8967ecdc07562ec4$var$I.current, k = $8967ecdc07562ec4$var$lg(b, k));
        var z = c.getDerivedStateFromProps;
        (n = "function" === typeof z || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $8967ecdc07562ec4$var$jj(b, g, d, k);
        $8967ecdc07562ec4$var$xh = !1;
        r = b.memoizedState;
        g.state = r;
        $8967ecdc07562ec4$var$Eh(b, d, g, e);
        var m = b.memoizedState;
        h !== q || r !== m || $8967ecdc07562ec4$var$jg.current || $8967ecdc07562ec4$var$xh ? ("function" === typeof z && ($8967ecdc07562ec4$var$fj(b, c, z, d), m = b.memoizedState), (l = $8967ecdc07562ec4$var$xh || $8967ecdc07562ec4$var$hj(b, c, l, d, r, m, k) || !1) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, m, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, m, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = m), g.props = d, g.state = m, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $8967ecdc07562ec4$var$Nj(a, b, c, d, f, e);
}
function $8967ecdc07562ec4$var$Nj(a, b, c, d, e, f) {
    $8967ecdc07562ec4$var$Kj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $8967ecdc07562ec4$var$rg(b, c, !1), $8967ecdc07562ec4$var$Cj(a, b, f);
    d = b.stateNode;
    $8967ecdc07562ec4$var$zj.current = b;
    if (g && "function" !== typeof c.getDerivedStateFromError) {
        var h = null;
        $8967ecdc07562ec4$var$Wi = -1;
    } else $8967ecdc07562ec4$var$sc(b), h = d.render(), $8967ecdc07562ec4$var$tc();
    b.flags |= 1;
    null !== a && g ? (g = h, b.child = $8967ecdc07562ec4$var$hh(b, a.child, null, f), b.child = $8967ecdc07562ec4$var$hh(b, null, g, f)) : $8967ecdc07562ec4$var$Aj(a, b, h, f);
    b.memoizedState = d.state;
    e && $8967ecdc07562ec4$var$rg(b, c, !0);
    return b.child;
}
function $8967ecdc07562ec4$var$Oj(a) {
    var b = a.stateNode;
    b.pendingContext ? $8967ecdc07562ec4$var$og(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $8967ecdc07562ec4$var$og(a, b.context, !1);
    $8967ecdc07562ec4$var$Mh(a, b.containerInfo);
}
function $8967ecdc07562ec4$var$Rj(a, b, c, d, e) {
    $8967ecdc07562ec4$var$Wg();
    $8967ecdc07562ec4$var$Xg(e);
    b.flags |= 256;
    $8967ecdc07562ec4$var$Aj(a, b, c, d);
    return b.child;
}
var $8967ecdc07562ec4$var$Sj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $8967ecdc07562ec4$var$Tj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $8967ecdc07562ec4$var$Uj(a, b, c) {
    var d = b.pendingProps, e = $8967ecdc07562ec4$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $8967ecdc07562ec4$var$H($8967ecdc07562ec4$var$L, e & 1);
    if (null === a) {
        $8967ecdc07562ec4$var$Sg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g, b.mode & 2 && (f.actualDuration = 0, f.actualStartTime = -1, f.selfBaseDuration = 0, f.treeBaseDuration = 0)) : f = $8967ecdc07562ec4$var$Vj(g, d, 0, null), a = $8967ecdc07562ec4$var$gh(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $8967ecdc07562ec4$var$Tj(c), b.memoizedState = $8967ecdc07562ec4$var$Sj, a) : $8967ecdc07562ec4$var$Wj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $8967ecdc07562ec4$var$Xj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.mode & 2 && (d.actualDuration = 0, d.actualStartTime = -1, d.selfBaseDuration = e.selfBaseDuration, d.treeBaseDuration = e.treeBaseDuration), b.deletions = null) : (d = $8967ecdc07562ec4$var$ch(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $8967ecdc07562ec4$var$ch(h, f) : (f = $8967ecdc07562ec4$var$gh(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $8967ecdc07562ec4$var$Tj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $8967ecdc07562ec4$var$Sj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $8967ecdc07562ec4$var$ch(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $8967ecdc07562ec4$var$Wj(a, b) {
    b = $8967ecdc07562ec4$var$Vj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $8967ecdc07562ec4$var$Yj(a, b, c, d) {
    null !== d && $8967ecdc07562ec4$var$Xg(d);
    $8967ecdc07562ec4$var$hh(b, a.child, null, c);
    a = $8967ecdc07562ec4$var$Wj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $8967ecdc07562ec4$var$Xj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $8967ecdc07562ec4$var$mj(Error($8967ecdc07562ec4$var$p(422))), $8967ecdc07562ec4$var$Yj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $8967ecdc07562ec4$var$Vj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $8967ecdc07562ec4$var$gh(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $8967ecdc07562ec4$var$hh(b, a.child, null, g);
        b.child.memoizedState = $8967ecdc07562ec4$var$Tj(g);
        b.memoizedState = $8967ecdc07562ec4$var$Sj;
        return f;
    }
    if (0 === (b.mode & 1)) return $8967ecdc07562ec4$var$Yj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($8967ecdc07562ec4$var$p(419));
        d = $8967ecdc07562ec4$var$mj(f, d, void 0);
        return $8967ecdc07562ec4$var$Yj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($8967ecdc07562ec4$var$rh || h) {
        d = $8967ecdc07562ec4$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $8967ecdc07562ec4$var$wh(a, e), $8967ecdc07562ec4$var$ui(d, a, e, -1));
        }
        $8967ecdc07562ec4$var$Zj();
        d = $8967ecdc07562ec4$var$mj(Error($8967ecdc07562ec4$var$p(421)));
        return $8967ecdc07562ec4$var$Yj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $8967ecdc07562ec4$var$ak.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $8967ecdc07562ec4$var$Mg = $8967ecdc07562ec4$var$Zf(e.nextSibling);
    $8967ecdc07562ec4$var$Lg = b;
    $8967ecdc07562ec4$var$J = !0;
    $8967ecdc07562ec4$var$Ng = null;
    null !== a && ($8967ecdc07562ec4$var$Cg[$8967ecdc07562ec4$var$Dg++] = $8967ecdc07562ec4$var$Fg, $8967ecdc07562ec4$var$Cg[$8967ecdc07562ec4$var$Dg++] = $8967ecdc07562ec4$var$Gg, $8967ecdc07562ec4$var$Cg[$8967ecdc07562ec4$var$Dg++] = $8967ecdc07562ec4$var$Eg, $8967ecdc07562ec4$var$Fg = a.id, $8967ecdc07562ec4$var$Gg = a.overflow, $8967ecdc07562ec4$var$Eg = b);
    b = $8967ecdc07562ec4$var$Wj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $8967ecdc07562ec4$var$bk(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $8967ecdc07562ec4$var$ph(a.return, b, c);
}
function $8967ecdc07562ec4$var$ck(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $8967ecdc07562ec4$var$dk(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $8967ecdc07562ec4$var$Aj(a, b, d.children, c);
    d = $8967ecdc07562ec4$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $8967ecdc07562ec4$var$bk(a, c, b);
            else if (19 === a.tag) $8967ecdc07562ec4$var$bk(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $8967ecdc07562ec4$var$H($8967ecdc07562ec4$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $8967ecdc07562ec4$var$Qh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $8967ecdc07562ec4$var$ck(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $8967ecdc07562ec4$var$Qh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $8967ecdc07562ec4$var$ck(b, !0, c, null, f);
            break;
        case "together":
            $8967ecdc07562ec4$var$ck(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $8967ecdc07562ec4$var$Mj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $8967ecdc07562ec4$var$Cj(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $8967ecdc07562ec4$var$Wi = -1;
    $8967ecdc07562ec4$var$Fh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($8967ecdc07562ec4$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $8967ecdc07562ec4$var$ch(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $8967ecdc07562ec4$var$ch(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $8967ecdc07562ec4$var$ek(a, b, c) {
    switch(b.tag){
        case 3:
            $8967ecdc07562ec4$var$Oj(b);
            $8967ecdc07562ec4$var$Wg();
            break;
        case 5:
            $8967ecdc07562ec4$var$Oh(b);
            break;
        case 1:
            $8967ecdc07562ec4$var$mg(b.type) && $8967ecdc07562ec4$var$qg(b);
            break;
        case 4:
            $8967ecdc07562ec4$var$Mh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $8967ecdc07562ec4$var$H($8967ecdc07562ec4$var$jh, d._currentValue);
            d._currentValue = e;
            break;
        case 12:
            0 !== (c & b.childLanes) && (b.flags |= 4);
            d = b.stateNode;
            d.effectDuration = 0;
            d.passiveEffectDuration = 0;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $8967ecdc07562ec4$var$H($8967ecdc07562ec4$var$L, $8967ecdc07562ec4$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $8967ecdc07562ec4$var$Uj(a, b, c);
                $8967ecdc07562ec4$var$H($8967ecdc07562ec4$var$L, $8967ecdc07562ec4$var$L.current & 1);
                a = $8967ecdc07562ec4$var$Cj(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $8967ecdc07562ec4$var$H($8967ecdc07562ec4$var$L, $8967ecdc07562ec4$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $8967ecdc07562ec4$var$dk(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $8967ecdc07562ec4$var$H($8967ecdc07562ec4$var$L, $8967ecdc07562ec4$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $8967ecdc07562ec4$var$Hj(a, b, c);
    }
    return $8967ecdc07562ec4$var$Cj(a, b, c);
}
var $8967ecdc07562ec4$var$fk, $8967ecdc07562ec4$var$gk, $8967ecdc07562ec4$var$hk, $8967ecdc07562ec4$var$ik;
$8967ecdc07562ec4$var$fk = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$8967ecdc07562ec4$var$gk = function() {};
$8967ecdc07562ec4$var$hk = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $8967ecdc07562ec4$var$Lh($8967ecdc07562ec4$var$Ih.current);
        var f = null;
        switch(c){
            case "input":
                e = $8967ecdc07562ec4$var$Ya(a, e);
                d = $8967ecdc07562ec4$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $8967ecdc07562ec4$var$u({}, e, {
                    value: void 0
                });
                d = $8967ecdc07562ec4$var$u({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $8967ecdc07562ec4$var$fb(a, e);
                d = $8967ecdc07562ec4$var$fb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $8967ecdc07562ec4$var$Pf);
        }
        $8967ecdc07562ec4$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($8967ecdc07562ec4$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($8967ecdc07562ec4$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $8967ecdc07562ec4$var$F("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$8967ecdc07562ec4$var$ik = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $8967ecdc07562ec4$var$jk(a, b) {
    if (!$8967ecdc07562ec4$var$J) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $8967ecdc07562ec4$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) {
        if (0 !== (a.mode & 2)) {
            for(var e = a.selfBaseDuration, f = a.child; null !== f;)c |= f.lanes | f.childLanes, d |= f.subtreeFlags & 14680064, d |= f.flags & 14680064, e += f.treeBaseDuration, f = f.sibling;
            a.treeBaseDuration = e;
        } else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    } else if (0 !== (a.mode & 2)) {
        e = a.actualDuration;
        f = a.selfBaseDuration;
        for(var g = a.child; null !== g;)c |= g.lanes | g.childLanes, d |= g.subtreeFlags, d |= g.flags, e += g.actualDuration, f += g.treeBaseDuration, g = g.sibling;
        a.actualDuration = e;
        a.treeBaseDuration = f;
    } else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $8967ecdc07562ec4$var$kk(a, b, c) {
    var d = b.pendingProps;
    $8967ecdc07562ec4$var$Kg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $8967ecdc07562ec4$var$S(b), null;
        case 1:
            return $8967ecdc07562ec4$var$mg(b.type) && $8967ecdc07562ec4$var$ng(), $8967ecdc07562ec4$var$S(b), null;
        case 3:
            d = b.stateNode;
            $8967ecdc07562ec4$var$Nh();
            $8967ecdc07562ec4$var$G($8967ecdc07562ec4$var$jg);
            $8967ecdc07562ec4$var$G($8967ecdc07562ec4$var$I);
            $8967ecdc07562ec4$var$Sh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $8967ecdc07562ec4$var$Ug(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $8967ecdc07562ec4$var$Ng && ($8967ecdc07562ec4$var$lk($8967ecdc07562ec4$var$Ng), $8967ecdc07562ec4$var$Ng = null));
            $8967ecdc07562ec4$var$gk(a, b);
            $8967ecdc07562ec4$var$S(b);
            return null;
        case 5:
            $8967ecdc07562ec4$var$Ph(b);
            var e = $8967ecdc07562ec4$var$Lh($8967ecdc07562ec4$var$Kh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $8967ecdc07562ec4$var$hk(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($8967ecdc07562ec4$var$p(166));
                    $8967ecdc07562ec4$var$S(b);
                    return null;
                }
                a = $8967ecdc07562ec4$var$Lh($8967ecdc07562ec4$var$Ih.current);
                if ($8967ecdc07562ec4$var$Ug(b)) {
                    d = b.stateNode;
                    a = b.type;
                    c = b.memoizedProps;
                    d[$8967ecdc07562ec4$var$bg] = b;
                    d[$8967ecdc07562ec4$var$cg] = c;
                    var f = 0 !== (b.mode & 1);
                    switch(a){
                        case "dialog":
                            $8967ecdc07562ec4$var$F("cancel", d);
                            $8967ecdc07562ec4$var$F("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $8967ecdc07562ec4$var$F("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $8967ecdc07562ec4$var$zf.length; e++)$8967ecdc07562ec4$var$F($8967ecdc07562ec4$var$zf[e], d);
                            break;
                        case "source":
                            $8967ecdc07562ec4$var$F("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $8967ecdc07562ec4$var$F("error", d);
                            $8967ecdc07562ec4$var$F("load", d);
                            break;
                        case "details":
                            $8967ecdc07562ec4$var$F("toggle", d);
                            break;
                        case "input":
                            $8967ecdc07562ec4$var$Za(d, c);
                            $8967ecdc07562ec4$var$F("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!c.multiple
                            };
                            $8967ecdc07562ec4$var$F("invalid", d);
                            break;
                        case "textarea":
                            $8967ecdc07562ec4$var$gb(d, c), $8967ecdc07562ec4$var$F("invalid", d);
                    }
                    $8967ecdc07562ec4$var$ub(a, c);
                    e = null;
                    for(var g in c)if (c.hasOwnProperty(g)) {
                        var h = c[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== c.suppressHydrationWarning && $8967ecdc07562ec4$var$Of(d.textContent, h, f), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== c.suppressHydrationWarning && $8967ecdc07562ec4$var$Of(d.textContent, h, f), e = [
                            "children",
                            "" + h
                        ]) : $8967ecdc07562ec4$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $8967ecdc07562ec4$var$F("scroll", d);
                    }
                    switch(a){
                        case "input":
                            $8967ecdc07562ec4$var$Va(d);
                            $8967ecdc07562ec4$var$cb(d, c, !0);
                            break;
                        case "textarea":
                            $8967ecdc07562ec4$var$Va(d);
                            $8967ecdc07562ec4$var$ib(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof c.onClick && (d.onclick = $8967ecdc07562ec4$var$Pf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $8967ecdc07562ec4$var$jb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$8967ecdc07562ec4$var$bg] = b;
                    a[$8967ecdc07562ec4$var$cg] = d;
                    $8967ecdc07562ec4$var$fk(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $8967ecdc07562ec4$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $8967ecdc07562ec4$var$F("cancel", a);
                                $8967ecdc07562ec4$var$F("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $8967ecdc07562ec4$var$F("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $8967ecdc07562ec4$var$zf.length; e++)$8967ecdc07562ec4$var$F($8967ecdc07562ec4$var$zf[e], a);
                                e = d;
                                break;
                            case "source":
                                $8967ecdc07562ec4$var$F("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $8967ecdc07562ec4$var$F("error", a);
                                $8967ecdc07562ec4$var$F("load", a);
                                e = d;
                                break;
                            case "details":
                                $8967ecdc07562ec4$var$F("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $8967ecdc07562ec4$var$Za(a, d);
                                e = $8967ecdc07562ec4$var$Ya(a, d);
                                $8967ecdc07562ec4$var$F("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $8967ecdc07562ec4$var$u({}, d, {
                                    value: void 0
                                });
                                $8967ecdc07562ec4$var$F("invalid", a);
                                break;
                            case "textarea":
                                $8967ecdc07562ec4$var$gb(a, d);
                                e = $8967ecdc07562ec4$var$fb(a, d);
                                $8967ecdc07562ec4$var$F("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $8967ecdc07562ec4$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $8967ecdc07562ec4$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $8967ecdc07562ec4$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $8967ecdc07562ec4$var$ob(a, k) : "number" === typeof k && $8967ecdc07562ec4$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($8967ecdc07562ec4$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $8967ecdc07562ec4$var$F("scroll", a) : null != k && $8967ecdc07562ec4$var$ua(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $8967ecdc07562ec4$var$Va(a);
                                $8967ecdc07562ec4$var$cb(a, d, !1);
                                break;
                            case "textarea":
                                $8967ecdc07562ec4$var$Va(a);
                                $8967ecdc07562ec4$var$ib(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $8967ecdc07562ec4$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $8967ecdc07562ec4$var$eb(a, !!d.multiple, f, !1) : null != d.defaultValue && $8967ecdc07562ec4$var$eb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $8967ecdc07562ec4$var$Pf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $8967ecdc07562ec4$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $8967ecdc07562ec4$var$ik(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($8967ecdc07562ec4$var$p(166));
                a = $8967ecdc07562ec4$var$Lh($8967ecdc07562ec4$var$Kh.current);
                $8967ecdc07562ec4$var$Lh($8967ecdc07562ec4$var$Ih.current);
                if ($8967ecdc07562ec4$var$Ug(b)) {
                    d = b.stateNode;
                    a = b.memoizedProps;
                    d[$8967ecdc07562ec4$var$bg] = b;
                    if (c = d.nodeValue !== a) {
                        if (f = $8967ecdc07562ec4$var$Lg, null !== f) switch(f.tag){
                            case 3:
                                $8967ecdc07562ec4$var$Of(d.nodeValue, a, 0 !== (f.mode & 1));
                                break;
                            case 5:
                                !0 !== f.memoizedProps.suppressHydrationWarning && $8967ecdc07562ec4$var$Of(d.nodeValue, a, 0 !== (f.mode & 1));
                        }
                    }
                    c && (b.flags |= 4);
                } else d = (9 === a.nodeType ? a : a.ownerDocument).createTextNode(d), d[$8967ecdc07562ec4$var$bg] = b, b.stateNode = d;
            }
            $8967ecdc07562ec4$var$S(b);
            return null;
        case 13:
            $8967ecdc07562ec4$var$G($8967ecdc07562ec4$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($8967ecdc07562ec4$var$J && null !== $8967ecdc07562ec4$var$Mg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $8967ecdc07562ec4$var$Vg(), $8967ecdc07562ec4$var$Wg(), b.flags |= 98560, f = !1;
                else if (f = $8967ecdc07562ec4$var$Ug(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($8967ecdc07562ec4$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($8967ecdc07562ec4$var$p(317));
                        f[$8967ecdc07562ec4$var$bg] = b;
                        $8967ecdc07562ec4$var$S(b);
                        0 !== (b.mode & 2) && null !== d && (f = b.child, null !== f && (b.treeBaseDuration -= f.treeBaseDuration));
                    } else $8967ecdc07562ec4$var$Wg(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4, $8967ecdc07562ec4$var$S(b), 0 !== (b.mode & 2) && null !== d && (f = b.child, null !== f && (b.treeBaseDuration -= f.treeBaseDuration));
                    f = !1;
                } else null !== $8967ecdc07562ec4$var$Ng && ($8967ecdc07562ec4$var$lk($8967ecdc07562ec4$var$Ng), $8967ecdc07562ec4$var$Ng = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, 0 !== (b.mode & 2) && $8967ecdc07562ec4$var$dj(b), b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($8967ecdc07562ec4$var$L.current & 1) ? 0 === $8967ecdc07562ec4$var$T && ($8967ecdc07562ec4$var$T = 3) : $8967ecdc07562ec4$var$Zj()));
            null !== b.updateQueue && (b.flags |= 4);
            $8967ecdc07562ec4$var$S(b);
            0 !== (b.mode & 2) && d && (d = b.child, null !== d && (b.treeBaseDuration -= d.treeBaseDuration));
            return null;
        case 4:
            return $8967ecdc07562ec4$var$Nh(), $8967ecdc07562ec4$var$gk(a, b), null === a && $8967ecdc07562ec4$var$Gf(b.stateNode.containerInfo), $8967ecdc07562ec4$var$S(b), null;
        case 10:
            return $8967ecdc07562ec4$var$oh(b.type._context), $8967ecdc07562ec4$var$S(b), null;
        case 17:
            return $8967ecdc07562ec4$var$mg(b.type) && $8967ecdc07562ec4$var$ng(), $8967ecdc07562ec4$var$S(b), null;
        case 19:
            $8967ecdc07562ec4$var$G($8967ecdc07562ec4$var$L);
            f = b.memoizedState;
            if (null === f) return $8967ecdc07562ec4$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $8967ecdc07562ec4$var$jk(f, !1);
                else {
                    if (0 !== $8967ecdc07562ec4$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $8967ecdc07562ec4$var$Qh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $8967ecdc07562ec4$var$jk(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(a = b.child; null !== a;)c = a, g = d, c.flags &= 14680066, f = c.alternate, null === f ? (c.childLanes = 0, c.lanes = g, c.child = null, c.subtreeFlags = 0, c.memoizedProps = null, c.memoizedState = null, c.updateQueue = null, c.dependencies = null, c.stateNode = null, c.selfBaseDuration = 0, c.treeBaseDuration = 0) : (c.childLanes = f.childLanes, c.lanes = f.lanes, c.child = f.child, c.subtreeFlags = 0, c.deletions = null, c.memoizedProps = f.memoizedProps, c.memoizedState = f.memoizedState, c.updateQueue = f.updateQueue, c.type = f.type, g = f.dependencies, c.dependencies = null === g ? null : {
                                lanes: g.lanes,
                                firstContext: g.firstContext
                            }, c.selfBaseDuration = f.selfBaseDuration, c.treeBaseDuration = f.treeBaseDuration), a = a.sibling;
                            $8967ecdc07562ec4$var$H($8967ecdc07562ec4$var$L, $8967ecdc07562ec4$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $8967ecdc07562ec4$var$A() > $8967ecdc07562ec4$var$mk && (b.flags |= 128, d = !0, $8967ecdc07562ec4$var$jk(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $8967ecdc07562ec4$var$Qh(g), null !== a) {
                        if (b.flags |= 128, d = !0, a = a.updateQueue, null !== a && (b.updateQueue = a, b.flags |= 4), $8967ecdc07562ec4$var$jk(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$8967ecdc07562ec4$var$J) return $8967ecdc07562ec4$var$S(b), null;
                    } else 2 * $8967ecdc07562ec4$var$A() - f.renderingStartTime > $8967ecdc07562ec4$var$mk && 1073741824 !== c && (b.flags |= 128, d = !0, $8967ecdc07562ec4$var$jk(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (a = f.last, null !== a ? a.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $8967ecdc07562ec4$var$A(), b.sibling = null, a = $8967ecdc07562ec4$var$L.current, $8967ecdc07562ec4$var$H($8967ecdc07562ec4$var$L, d ? a & 1 | 2 : a & 1), b;
            $8967ecdc07562ec4$var$S(b);
            return null;
        case 22:
        case 23:
            return $8967ecdc07562ec4$var$nk(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($8967ecdc07562ec4$var$Jj & 1073741824) && ($8967ecdc07562ec4$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $8967ecdc07562ec4$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($8967ecdc07562ec4$var$p(156, b.tag));
}
function $8967ecdc07562ec4$var$ok(a, b) {
    $8967ecdc07562ec4$var$Kg(b);
    switch(b.tag){
        case 1:
            return $8967ecdc07562ec4$var$mg(b.type) && $8967ecdc07562ec4$var$ng(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, 0 !== (b.mode & 2) && $8967ecdc07562ec4$var$dj(b), b) : null;
        case 3:
            return $8967ecdc07562ec4$var$Nh(), $8967ecdc07562ec4$var$G($8967ecdc07562ec4$var$jg), $8967ecdc07562ec4$var$G($8967ecdc07562ec4$var$I), $8967ecdc07562ec4$var$Sh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $8967ecdc07562ec4$var$Ph(b), null;
        case 13:
            $8967ecdc07562ec4$var$G($8967ecdc07562ec4$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($8967ecdc07562ec4$var$p(340));
                $8967ecdc07562ec4$var$Wg();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, 0 !== (b.mode & 2) && $8967ecdc07562ec4$var$dj(b), b) : null;
        case 19:
            return $8967ecdc07562ec4$var$G($8967ecdc07562ec4$var$L), null;
        case 4:
            return $8967ecdc07562ec4$var$Nh(), null;
        case 10:
            return $8967ecdc07562ec4$var$oh(b.type._context), null;
        case 22:
        case 23:
            return $8967ecdc07562ec4$var$nk(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $8967ecdc07562ec4$var$pk = !1, $8967ecdc07562ec4$var$qk = !1, $8967ecdc07562ec4$var$rk = "function" === typeof WeakSet ? WeakSet : Set, $8967ecdc07562ec4$var$U = null, $8967ecdc07562ec4$var$sk = null, $8967ecdc07562ec4$var$tk = null;
function $8967ecdc07562ec4$var$uk(a, b) {
    b.props = a.memoizedProps;
    b.state = a.memoizedState;
    if (a.mode & 2) try {
        $8967ecdc07562ec4$var$cj(), b.componentWillUnmount();
    } finally{
        $8967ecdc07562ec4$var$aj(a);
    }
    else b.componentWillUnmount();
}
function $8967ecdc07562ec4$var$vk(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            if (a.mode & 2) try {
                $8967ecdc07562ec4$var$cj(), c(null);
            } finally{
                $8967ecdc07562ec4$var$aj(a);
            }
            else c(null);
        } catch (d) {
            $8967ecdc07562ec4$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $8967ecdc07562ec4$var$wk(a, b, c) {
    try {
        c();
    } catch (d) {
        $8967ecdc07562ec4$var$W(a, b, d);
    }
}
var $8967ecdc07562ec4$var$xk = !1;
function $8967ecdc07562ec4$var$yk(a, b) {
    $8967ecdc07562ec4$var$Qf = $8967ecdc07562ec4$var$rd;
    a = $8967ecdc07562ec4$var$$e();
    if ($8967ecdc07562ec4$var$af(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (D) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, n = 0, q = a, r = null;
                b: for(;;){
                    for(var z;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (z = q.firstChild)) break;
                        r = q;
                        q = z;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++n === d && (k = g);
                        if (null !== (z = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = z;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $8967ecdc07562ec4$var$Rf = {
        focusedElem: a,
        selectionRange: c
    };
    $8967ecdc07562ec4$var$rd = !1;
    for($8967ecdc07562ec4$var$U = b; null !== $8967ecdc07562ec4$var$U;)if (b = $8967ecdc07562ec4$var$U, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $8967ecdc07562ec4$var$U = a;
    else for(; null !== $8967ecdc07562ec4$var$U;){
        b = $8967ecdc07562ec4$var$U;
        try {
            var m = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== m) {
                        var w = m.memoizedProps, C = m.memoizedState, x = b.stateNode, y = x.getSnapshotBeforeUpdate(b.elementType === b.type ? w : $8967ecdc07562ec4$var$ej(b.type, w), C);
                        x.__reactInternalSnapshotBeforeUpdate = y;
                    }
                    break;
                case 3:
                    var v = b.stateNode.containerInfo;
                    1 === v.nodeType ? v.textContent = "" : 9 === v.nodeType && v.documentElement && v.removeChild(v.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($8967ecdc07562ec4$var$p(163));
            }
        } catch (D) {
            $8967ecdc07562ec4$var$W(b, b.return, D);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $8967ecdc07562ec4$var$U = a;
            break;
        }
        $8967ecdc07562ec4$var$U = b.return;
    }
    m = $8967ecdc07562ec4$var$xk;
    $8967ecdc07562ec4$var$xk = !1;
    return m;
}
function $8967ecdc07562ec4$var$zk(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && (0 !== (a & 8) ? null !== $8967ecdc07562ec4$var$B && "function" === typeof $8967ecdc07562ec4$var$B.markComponentPassiveEffectUnmountStarted && $8967ecdc07562ec4$var$B.markComponentPassiveEffectUnmountStarted(b) : 0 !== (a & 4) && $8967ecdc07562ec4$var$uc(b), $8967ecdc07562ec4$var$wk(b, c, f), 0 !== (a & 8) ? null !== $8967ecdc07562ec4$var$B && "function" === typeof $8967ecdc07562ec4$var$B.markComponentPassiveEffectUnmountStopped && $8967ecdc07562ec4$var$B.markComponentPassiveEffectUnmountStopped() : 0 !== (a & 4) && $8967ecdc07562ec4$var$vc());
            }
            e = e.next;
        }while (e !== d);
    }
}
function $8967ecdc07562ec4$var$Ak(a, b) {
    var c = b.updateQueue;
    c = null !== c ? c.lastEffect : null;
    if (null !== c) {
        var d = c = c.next;
        do {
            if ((d.tag & a) === a) {
                0 !== (a & 8) ? null !== $8967ecdc07562ec4$var$B && "function" === typeof $8967ecdc07562ec4$var$B.markComponentPassiveEffectMountStarted && $8967ecdc07562ec4$var$B.markComponentPassiveEffectMountStarted(b) : 0 !== (a & 4) && null !== $8967ecdc07562ec4$var$B && "function" === typeof $8967ecdc07562ec4$var$B.markComponentLayoutEffectMountStarted && $8967ecdc07562ec4$var$B.markComponentLayoutEffectMountStarted(b);
                var e = d.create;
                d.destroy = e();
                0 !== (a & 8) ? null !== $8967ecdc07562ec4$var$B && "function" === typeof $8967ecdc07562ec4$var$B.markComponentPassiveEffectMountStopped && $8967ecdc07562ec4$var$B.markComponentPassiveEffectMountStopped() : 0 !== (a & 4) && null !== $8967ecdc07562ec4$var$B && "function" === typeof $8967ecdc07562ec4$var$B.markComponentLayoutEffectMountStopped && $8967ecdc07562ec4$var$B.markComponentLayoutEffectMountStopped();
            }
            d = d.next;
        }while (d !== c);
    }
}
function $8967ecdc07562ec4$var$Bk(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        if ("function" === typeof b) {
            if (a.mode & 2) try {
                $8967ecdc07562ec4$var$cj(), b(c);
            } finally{
                $8967ecdc07562ec4$var$aj(a);
            }
            else b(c);
        } else b.current = c;
    }
}
function $8967ecdc07562ec4$var$Ck(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $8967ecdc07562ec4$var$Ck(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$8967ecdc07562ec4$var$bg], delete b[$8967ecdc07562ec4$var$cg], delete b[$8967ecdc07562ec4$var$Cf], delete b[$8967ecdc07562ec4$var$dg], delete b[$8967ecdc07562ec4$var$eg]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $8967ecdc07562ec4$var$Dk(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $8967ecdc07562ec4$var$Ek(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $8967ecdc07562ec4$var$Dk(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $8967ecdc07562ec4$var$Fk(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $8967ecdc07562ec4$var$Pf));
    else if (4 !== d && (a = a.child, null !== a)) for($8967ecdc07562ec4$var$Fk(a, b, c), a = a.sibling; null !== a;)$8967ecdc07562ec4$var$Fk(a, b, c), a = a.sibling;
}
function $8967ecdc07562ec4$var$Gk(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($8967ecdc07562ec4$var$Gk(a, b, c), a = a.sibling; null !== a;)$8967ecdc07562ec4$var$Gk(a, b, c), a = a.sibling;
}
var $8967ecdc07562ec4$var$X = null, $8967ecdc07562ec4$var$Hk = !1;
function $8967ecdc07562ec4$var$Ik(a, b, c) {
    for(c = c.child; null !== c;)$8967ecdc07562ec4$var$Jk(a, b, c), c = c.sibling;
}
function $8967ecdc07562ec4$var$Jk(a, b, c) {
    if ($8967ecdc07562ec4$var$lc && "function" === typeof $8967ecdc07562ec4$var$lc.onCommitFiberUnmount) try {
        $8967ecdc07562ec4$var$lc.onCommitFiberUnmount($8967ecdc07562ec4$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $8967ecdc07562ec4$var$qk || $8967ecdc07562ec4$var$vk(c, b);
        case 6:
            var d = $8967ecdc07562ec4$var$X, e = $8967ecdc07562ec4$var$Hk;
            $8967ecdc07562ec4$var$X = null;
            $8967ecdc07562ec4$var$Ik(a, b, c);
            $8967ecdc07562ec4$var$X = d;
            $8967ecdc07562ec4$var$Hk = e;
            null !== $8967ecdc07562ec4$var$X && ($8967ecdc07562ec4$var$Hk ? (a = $8967ecdc07562ec4$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $8967ecdc07562ec4$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $8967ecdc07562ec4$var$X && ($8967ecdc07562ec4$var$Hk ? (a = $8967ecdc07562ec4$var$X, c = c.stateNode, 8 === a.nodeType ? $8967ecdc07562ec4$var$Yf(a.parentNode, c) : 1 === a.nodeType && $8967ecdc07562ec4$var$Yf(a, c), $8967ecdc07562ec4$var$pd(a)) : $8967ecdc07562ec4$var$Yf($8967ecdc07562ec4$var$X, c.stateNode));
            break;
        case 4:
            d = $8967ecdc07562ec4$var$X;
            e = $8967ecdc07562ec4$var$Hk;
            $8967ecdc07562ec4$var$X = c.stateNode.containerInfo;
            $8967ecdc07562ec4$var$Hk = !0;
            $8967ecdc07562ec4$var$Ik(a, b, c);
            $8967ecdc07562ec4$var$X = d;
            $8967ecdc07562ec4$var$Hk = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$8967ecdc07562ec4$var$qk && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $8967ecdc07562ec4$var$wk(c, b, g) : 0 !== (f & 4) && ($8967ecdc07562ec4$var$uc(c), c.mode & 2 ? ($8967ecdc07562ec4$var$cj(), $8967ecdc07562ec4$var$wk(c, b, g), $8967ecdc07562ec4$var$aj(c)) : $8967ecdc07562ec4$var$wk(c, b, g), $8967ecdc07562ec4$var$vc()));
                    e = e.next;
                }while (e !== d);
            }
            $8967ecdc07562ec4$var$Ik(a, b, c);
            break;
        case 1:
            if (!$8967ecdc07562ec4$var$qk && ($8967ecdc07562ec4$var$vk(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                $8967ecdc07562ec4$var$uk(c, d);
            } catch (h) {
                $8967ecdc07562ec4$var$W(c, b, h);
            }
            $8967ecdc07562ec4$var$Ik(a, b, c);
            break;
        case 21:
            $8967ecdc07562ec4$var$Ik(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($8967ecdc07562ec4$var$qk = (d = $8967ecdc07562ec4$var$qk) || null !== c.memoizedState, $8967ecdc07562ec4$var$Ik(a, b, c), $8967ecdc07562ec4$var$qk = d) : $8967ecdc07562ec4$var$Ik(a, b, c);
            break;
        default:
            $8967ecdc07562ec4$var$Ik(a, b, c);
    }
}
function $8967ecdc07562ec4$var$Kk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $8967ecdc07562ec4$var$rk);
        b.forEach(function(b) {
            var d = $8967ecdc07562ec4$var$Lk.bind(null, a, b);
            if (!c.has(b)) {
                c.add(b);
                if ($8967ecdc07562ec4$var$mc) {
                    if (null !== $8967ecdc07562ec4$var$sk && null !== $8967ecdc07562ec4$var$tk) $8967ecdc07562ec4$var$wj($8967ecdc07562ec4$var$tk, $8967ecdc07562ec4$var$sk);
                    else throw Error($8967ecdc07562ec4$var$p(413));
                }
                b.then(d, d);
            }
        });
    }
}
function $8967ecdc07562ec4$var$Mk(a, b, c) {
    $8967ecdc07562ec4$var$sk = c;
    $8967ecdc07562ec4$var$tk = a;
    $8967ecdc07562ec4$var$Nk(b, a);
    $8967ecdc07562ec4$var$tk = $8967ecdc07562ec4$var$sk = null;
}
function $8967ecdc07562ec4$var$Ok(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $8967ecdc07562ec4$var$X = h.stateNode;
                        $8967ecdc07562ec4$var$Hk = !1;
                        break a;
                    case 3:
                        $8967ecdc07562ec4$var$X = h.stateNode.containerInfo;
                        $8967ecdc07562ec4$var$Hk = !0;
                        break a;
                    case 4:
                        $8967ecdc07562ec4$var$X = h.stateNode.containerInfo;
                        $8967ecdc07562ec4$var$Hk = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $8967ecdc07562ec4$var$X) throw Error($8967ecdc07562ec4$var$p(160));
            $8967ecdc07562ec4$var$Jk(f, g, e);
            $8967ecdc07562ec4$var$X = null;
            $8967ecdc07562ec4$var$Hk = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $8967ecdc07562ec4$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$8967ecdc07562ec4$var$Nk(b, a), b = b.sibling;
}
function $8967ecdc07562ec4$var$Nk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $8967ecdc07562ec4$var$Ok(b, a);
            $8967ecdc07562ec4$var$Pk(a);
            if (d & 4) {
                try {
                    $8967ecdc07562ec4$var$zk(3, a, a.return), $8967ecdc07562ec4$var$Ak(3, a);
                } catch (m) {
                    $8967ecdc07562ec4$var$W(a, a.return, m);
                }
                if (a.mode & 2) {
                    try {
                        $8967ecdc07562ec4$var$cj(), $8967ecdc07562ec4$var$zk(5, a, a.return);
                    } catch (m) {
                        $8967ecdc07562ec4$var$W(a, a.return, m);
                    }
                    $8967ecdc07562ec4$var$aj(a);
                } else try {
                    $8967ecdc07562ec4$var$zk(5, a, a.return);
                } catch (m) {
                    $8967ecdc07562ec4$var$W(a, a.return, m);
                }
            }
            break;
        case 1:
            $8967ecdc07562ec4$var$Ok(b, a);
            $8967ecdc07562ec4$var$Pk(a);
            d & 512 && null !== c && $8967ecdc07562ec4$var$vk(c, c.return);
            break;
        case 5:
            $8967ecdc07562ec4$var$Ok(b, a);
            $8967ecdc07562ec4$var$Pk(a);
            d & 512 && null !== c && $8967ecdc07562ec4$var$vk(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $8967ecdc07562ec4$var$ob(e, "");
                } catch (m) {
                    $8967ecdc07562ec4$var$W(a, a.return, m);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $8967ecdc07562ec4$var$$a(e, f);
                    $8967ecdc07562ec4$var$vb(h, g);
                    var l = $8967ecdc07562ec4$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var n = k[g], q = k[g + 1];
                        "style" === n ? $8967ecdc07562ec4$var$sb(e, q) : "dangerouslySetInnerHTML" === n ? $8967ecdc07562ec4$var$nb(e, q) : "children" === n ? $8967ecdc07562ec4$var$ob(e, q) : $8967ecdc07562ec4$var$ua(e, n, q, l);
                    }
                    switch(h){
                        case "input":
                            $8967ecdc07562ec4$var$ab(e, f);
                            break;
                        case "textarea":
                            $8967ecdc07562ec4$var$hb(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var z = f.value;
                            null != z ? $8967ecdc07562ec4$var$eb(e, !!f.multiple, z, !1) : r !== !!f.multiple && (null != f.defaultValue ? $8967ecdc07562ec4$var$eb(e, !!f.multiple, f.defaultValue, !0) : $8967ecdc07562ec4$var$eb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$8967ecdc07562ec4$var$cg] = f;
                } catch (m) {
                    $8967ecdc07562ec4$var$W(a, a.return, m);
                }
            }
            break;
        case 6:
            $8967ecdc07562ec4$var$Ok(b, a);
            $8967ecdc07562ec4$var$Pk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($8967ecdc07562ec4$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (m) {
                    $8967ecdc07562ec4$var$W(a, a.return, m);
                }
            }
            break;
        case 3:
            $8967ecdc07562ec4$var$Ok(b, a);
            $8967ecdc07562ec4$var$Pk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $8967ecdc07562ec4$var$pd(b.containerInfo);
            } catch (m) {
                $8967ecdc07562ec4$var$W(a, a.return, m);
            }
            break;
        case 4:
            $8967ecdc07562ec4$var$Ok(b, a);
            $8967ecdc07562ec4$var$Pk(a);
            break;
        case 13:
            $8967ecdc07562ec4$var$Ok(b, a);
            $8967ecdc07562ec4$var$Pk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($8967ecdc07562ec4$var$Qk = $8967ecdc07562ec4$var$A()));
            d & 4 && $8967ecdc07562ec4$var$Kk(a);
            break;
        case 22:
            n = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($8967ecdc07562ec4$var$qk = (l = $8967ecdc07562ec4$var$qk) || n, $8967ecdc07562ec4$var$Ok(b, a), $8967ecdc07562ec4$var$qk = l) : $8967ecdc07562ec4$var$Ok(b, a);
            $8967ecdc07562ec4$var$Pk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !n && 0 !== (a.mode & 1)) for($8967ecdc07562ec4$var$U = a, n = a.child; null !== n;){
                    for(q = $8967ecdc07562ec4$var$U = n; null !== $8967ecdc07562ec4$var$U;){
                        r = $8967ecdc07562ec4$var$U;
                        z = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                if (r.mode & 2) try {
                                    $8967ecdc07562ec4$var$cj(), $8967ecdc07562ec4$var$zk(4, r, r.return);
                                } finally{
                                    $8967ecdc07562ec4$var$aj(r);
                                }
                                else $8967ecdc07562ec4$var$zk(4, r, r.return);
                                break;
                            case 1:
                                $8967ecdc07562ec4$var$vk(r, r.return);
                                d = r.stateNode;
                                if ("function" === typeof d.componentWillUnmount) {
                                    c = r;
                                    b = r.return;
                                    try {
                                        $8967ecdc07562ec4$var$uk(c, d);
                                    } catch (m) {
                                        $8967ecdc07562ec4$var$W(c, b, m);
                                    }
                                }
                                break;
                            case 5:
                                $8967ecdc07562ec4$var$vk(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $8967ecdc07562ec4$var$Rk(q);
                                    continue;
                                }
                        }
                        null !== z ? (z.return = r, $8967ecdc07562ec4$var$U = z) : $8967ecdc07562ec4$var$Rk(q);
                    }
                    n = n.sibling;
                }
                a: for(n = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === n) {
                            n = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $8967ecdc07562ec4$var$rb("display", g));
                            } catch (m) {
                                $8967ecdc07562ec4$var$W(a, a.return, m);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === n) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (m) {
                            $8967ecdc07562ec4$var$W(a, a.return, m);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        n === q && (n = null);
                        q = q.return;
                    }
                    n === q && (n = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $8967ecdc07562ec4$var$Ok(b, a);
            $8967ecdc07562ec4$var$Pk(a);
            d & 4 && $8967ecdc07562ec4$var$Kk(a);
            break;
        case 21:
            break;
        default:
            $8967ecdc07562ec4$var$Ok(b, a), $8967ecdc07562ec4$var$Pk(a);
    }
}
function $8967ecdc07562ec4$var$Pk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($8967ecdc07562ec4$var$Dk(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($8967ecdc07562ec4$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($8967ecdc07562ec4$var$ob(e, ""), d.flags &= -33);
                    var f = $8967ecdc07562ec4$var$Ek(a);
                    $8967ecdc07562ec4$var$Gk(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $8967ecdc07562ec4$var$Ek(a);
                    $8967ecdc07562ec4$var$Fk(a, h, g);
                    break;
                default:
                    throw Error($8967ecdc07562ec4$var$p(161));
            }
        } catch (k) {
            $8967ecdc07562ec4$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $8967ecdc07562ec4$var$Sk(a, b, c) {
    $8967ecdc07562ec4$var$sk = c;
    $8967ecdc07562ec4$var$tk = b;
    $8967ecdc07562ec4$var$U = a;
    $8967ecdc07562ec4$var$Tk(a, b, c);
    $8967ecdc07562ec4$var$tk = $8967ecdc07562ec4$var$sk = null;
}
function $8967ecdc07562ec4$var$Tk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $8967ecdc07562ec4$var$U;){
        var e = $8967ecdc07562ec4$var$U, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $8967ecdc07562ec4$var$pk;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $8967ecdc07562ec4$var$qk;
                h = $8967ecdc07562ec4$var$pk;
                var l = $8967ecdc07562ec4$var$qk;
                $8967ecdc07562ec4$var$pk = g;
                if (($8967ecdc07562ec4$var$qk = k) && !l) for($8967ecdc07562ec4$var$U = e; null !== $8967ecdc07562ec4$var$U;)g = $8967ecdc07562ec4$var$U, k = g.child, 22 === g.tag && null !== g.memoizedState ? $8967ecdc07562ec4$var$Uk(e) : null !== k ? (k.return = g, $8967ecdc07562ec4$var$U = k) : $8967ecdc07562ec4$var$Uk(e);
                for(; null !== f;)$8967ecdc07562ec4$var$U = f, $8967ecdc07562ec4$var$Tk(f, b, c), f = f.sibling;
                $8967ecdc07562ec4$var$U = e;
                $8967ecdc07562ec4$var$pk = h;
                $8967ecdc07562ec4$var$qk = l;
            }
            $8967ecdc07562ec4$var$Vk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $8967ecdc07562ec4$var$U = f) : $8967ecdc07562ec4$var$Vk(a, b, c);
    }
}
function $8967ecdc07562ec4$var$Vk(a) {
    for(; null !== $8967ecdc07562ec4$var$U;){
        var b = $8967ecdc07562ec4$var$U;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        if (!$8967ecdc07562ec4$var$qk) {
                            if (b.mode & 2) try {
                                $8967ecdc07562ec4$var$cj(), $8967ecdc07562ec4$var$Ak(5, b);
                            } finally{
                                $8967ecdc07562ec4$var$aj(b);
                            }
                            else $8967ecdc07562ec4$var$Ak(5, b);
                        }
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$8967ecdc07562ec4$var$qk) {
                            if (null === c) {
                                if (b.mode & 2) try {
                                    $8967ecdc07562ec4$var$cj(), d.componentDidMount();
                                } finally{
                                    $8967ecdc07562ec4$var$aj(b);
                                }
                                else d.componentDidMount();
                            } else {
                                var e = b.elementType === b.type ? c.memoizedProps : $8967ecdc07562ec4$var$ej(b.type, c.memoizedProps), f = c.memoizedState;
                                if (b.mode & 2) try {
                                    $8967ecdc07562ec4$var$cj(), d.componentDidUpdate(e, f, d.__reactInternalSnapshotBeforeUpdate);
                                } finally{
                                    $8967ecdc07562ec4$var$aj(b);
                                }
                                else d.componentDidUpdate(e, f, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var g = b.updateQueue;
                        null !== g && $8967ecdc07562ec4$var$Gh(b, g, d);
                        break;
                    case 3:
                        var h = b.updateQueue;
                        if (null !== h) {
                            var k = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    k = b.child.stateNode;
                                    break;
                                case 1:
                                    k = b.child.stateNode;
                            }
                            $8967ecdc07562ec4$var$Gh(b, h, k);
                        }
                        break;
                    case 5:
                        var l = b.stateNode;
                        if (null === c && b.flags & 4) {
                            k = l;
                            var n = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    n.autoFocus && k.focus();
                                    break;
                                case "img":
                                    n.src && (k.src = n.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        var q = b.memoizedProps, r = q.onCommit, z = q.onRender, m = b.stateNode.effectDuration;
                        k = $8967ecdc07562ec4$var$Ui;
                        c = null === c ? "mount" : "update";
                        $8967ecdc07562ec4$var$Yi && (c = "nested-update");
                        "function" === typeof z && z(b.memoizedProps.id, c, b.actualDuration, b.treeBaseDuration, b.actualStartTime, k);
                        "function" === typeof r && r(b.memoizedProps.id, c, m, k);
                        $8967ecdc07562ec4$var$Wk(b);
                        var w = b.return;
                        a: for(; null !== w;){
                            switch(w.tag){
                                case 3:
                                    w.stateNode.effectDuration += m;
                                    break a;
                                case 12:
                                    w.stateNode.effectDuration += m;
                                    break a;
                            }
                            w = w.return;
                        }
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var C = b.alternate;
                            if (null !== C) {
                                var x = C.memoizedState;
                                if (null !== x) {
                                    var y = x.dehydrated;
                                    null !== y && $8967ecdc07562ec4$var$pd(y);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($8967ecdc07562ec4$var$p(163));
                }
                $8967ecdc07562ec4$var$qk || b.flags & 512 && $8967ecdc07562ec4$var$Bk(b);
            } catch (v) {
                $8967ecdc07562ec4$var$W(b, b.return, v);
            }
        }
        if (b === a) {
            $8967ecdc07562ec4$var$U = null;
            break;
        }
        k = b.sibling;
        if (null !== k) {
            k.return = b.return;
            $8967ecdc07562ec4$var$U = k;
            break;
        }
        $8967ecdc07562ec4$var$U = b.return;
    }
}
function $8967ecdc07562ec4$var$Rk(a) {
    for(; null !== $8967ecdc07562ec4$var$U;){
        var b = $8967ecdc07562ec4$var$U;
        if (b === a) {
            $8967ecdc07562ec4$var$U = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $8967ecdc07562ec4$var$U = c;
            break;
        }
        $8967ecdc07562ec4$var$U = b.return;
    }
}
function $8967ecdc07562ec4$var$Uk(a) {
    for(; null !== $8967ecdc07562ec4$var$U;){
        var b = $8967ecdc07562ec4$var$U;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    if (b.mode & 2) try {
                        $8967ecdc07562ec4$var$cj();
                        var c = b.return;
                        try {
                            $8967ecdc07562ec4$var$Ak(4, b);
                        } catch (l) {
                            $8967ecdc07562ec4$var$W(b, c, l);
                        }
                    } finally{
                        $8967ecdc07562ec4$var$aj(b);
                    }
                    else {
                        var d = b.return;
                        try {
                            $8967ecdc07562ec4$var$Ak(4, b);
                        } catch (l) {
                            $8967ecdc07562ec4$var$W(b, d, l);
                        }
                    }
                    break;
                case 1:
                    var e = b.stateNode;
                    if ("function" === typeof e.componentDidMount) {
                        var f = b.return;
                        try {
                            e.componentDidMount();
                        } catch (l) {
                            $8967ecdc07562ec4$var$W(b, f, l);
                        }
                    }
                    var g = b.return;
                    try {
                        $8967ecdc07562ec4$var$Bk(b);
                    } catch (l) {
                        $8967ecdc07562ec4$var$W(b, g, l);
                    }
                    break;
                case 5:
                    var h = b.return;
                    try {
                        $8967ecdc07562ec4$var$Bk(b);
                    } catch (l) {
                        $8967ecdc07562ec4$var$W(b, h, l);
                    }
            }
        } catch (l) {
            $8967ecdc07562ec4$var$W(b, b.return, l);
        }
        if (b === a) {
            $8967ecdc07562ec4$var$U = null;
            break;
        }
        var k = b.sibling;
        if (null !== k) {
            k.return = b.return;
            $8967ecdc07562ec4$var$U = k;
            break;
        }
        $8967ecdc07562ec4$var$U = b.return;
    }
}
var $8967ecdc07562ec4$var$Xk = Math.ceil, $8967ecdc07562ec4$var$Yk = $8967ecdc07562ec4$var$va.ReactCurrentDispatcher, $8967ecdc07562ec4$var$Zk = $8967ecdc07562ec4$var$va.ReactCurrentOwner, $8967ecdc07562ec4$var$$k = $8967ecdc07562ec4$var$va.ReactCurrentBatchConfig, $8967ecdc07562ec4$var$K = 0, $8967ecdc07562ec4$var$Q = null, $8967ecdc07562ec4$var$Y = null, $8967ecdc07562ec4$var$Z = 0, $8967ecdc07562ec4$var$Jj = 0, $8967ecdc07562ec4$var$Ij = $8967ecdc07562ec4$var$hg(0), $8967ecdc07562ec4$var$T = 0, $8967ecdc07562ec4$var$al = null, $8967ecdc07562ec4$var$Fh = 0, $8967ecdc07562ec4$var$bl = 0, $8967ecdc07562ec4$var$cl = 0, $8967ecdc07562ec4$var$dl = null, $8967ecdc07562ec4$var$el = null, $8967ecdc07562ec4$var$Qk = 0, $8967ecdc07562ec4$var$mk = Infinity, $8967ecdc07562ec4$var$fl = null, $8967ecdc07562ec4$var$qj = !1, $8967ecdc07562ec4$var$rj = null, $8967ecdc07562ec4$var$tj = null, $8967ecdc07562ec4$var$gl = !1, $8967ecdc07562ec4$var$hl = null, $8967ecdc07562ec4$var$il = 0, $8967ecdc07562ec4$var$jl = [], $8967ecdc07562ec4$var$kl = 0, $8967ecdc07562ec4$var$ll = null, $8967ecdc07562ec4$var$ml = -1, $8967ecdc07562ec4$var$nl = 0;
function $8967ecdc07562ec4$var$Ri() {
    return 0 !== ($8967ecdc07562ec4$var$K & 6) ? $8967ecdc07562ec4$var$A() : -1 !== $8967ecdc07562ec4$var$ml ? $8967ecdc07562ec4$var$ml : $8967ecdc07562ec4$var$ml = $8967ecdc07562ec4$var$A();
}
function $8967ecdc07562ec4$var$Oi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($8967ecdc07562ec4$var$K & 2) && 0 !== $8967ecdc07562ec4$var$Z) return $8967ecdc07562ec4$var$Z & -$8967ecdc07562ec4$var$Z;
    if (null !== $8967ecdc07562ec4$var$Yg.transition) return 0 === $8967ecdc07562ec4$var$nl && ($8967ecdc07562ec4$var$nl = $8967ecdc07562ec4$var$Kc()), $8967ecdc07562ec4$var$nl;
    a = $8967ecdc07562ec4$var$E;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $8967ecdc07562ec4$var$xd(a.type);
    return a;
}
function $8967ecdc07562ec4$var$ui(a, b, c, d) {
    if (50 < $8967ecdc07562ec4$var$kl) throw $8967ecdc07562ec4$var$kl = 0, $8967ecdc07562ec4$var$ll = null, Error($8967ecdc07562ec4$var$p(185));
    $8967ecdc07562ec4$var$Mc(a, c, d);
    if (0 === ($8967ecdc07562ec4$var$K & 2) || a !== $8967ecdc07562ec4$var$Q) $8967ecdc07562ec4$var$mc && $8967ecdc07562ec4$var$Pc(a, b, c), a === $8967ecdc07562ec4$var$Q && (0 === ($8967ecdc07562ec4$var$K & 2) && ($8967ecdc07562ec4$var$bl |= c), 4 === $8967ecdc07562ec4$var$T && $8967ecdc07562ec4$var$ol(a, $8967ecdc07562ec4$var$Z)), $8967ecdc07562ec4$var$pl(a, d), 1 === c && 0 === $8967ecdc07562ec4$var$K && 0 === (b.mode & 1) && ($8967ecdc07562ec4$var$mk = $8967ecdc07562ec4$var$A() + 500, $8967ecdc07562ec4$var$tg && $8967ecdc07562ec4$var$xg());
}
function $8967ecdc07562ec4$var$pl(a, b) {
    var c = a.callbackNode;
    $8967ecdc07562ec4$var$Ic(a, b);
    var d = $8967ecdc07562ec4$var$Gc(a, a === $8967ecdc07562ec4$var$Q ? $8967ecdc07562ec4$var$Z : 0);
    if (0 === d) null !== c && $8967ecdc07562ec4$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $8967ecdc07562ec4$var$bc(c);
        if (1 === b) 0 === a.tag ? $8967ecdc07562ec4$var$wg($8967ecdc07562ec4$var$ql.bind(null, a)) : $8967ecdc07562ec4$var$vg($8967ecdc07562ec4$var$ql.bind(null, a)), $8967ecdc07562ec4$var$Xf(function() {
            0 === ($8967ecdc07562ec4$var$K & 6) && $8967ecdc07562ec4$var$xg();
        }), c = null;
        else {
            switch($8967ecdc07562ec4$var$Rc(d)){
                case 1:
                    c = $8967ecdc07562ec4$var$fc;
                    break;
                case 4:
                    c = $8967ecdc07562ec4$var$gc;
                    break;
                case 16:
                    c = $8967ecdc07562ec4$var$hc;
                    break;
                case 536870912:
                    c = $8967ecdc07562ec4$var$jc;
                    break;
                default:
                    c = $8967ecdc07562ec4$var$hc;
            }
            c = $8967ecdc07562ec4$var$rl(c, $8967ecdc07562ec4$var$sl.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $8967ecdc07562ec4$var$sl(a, b) {
    $8967ecdc07562ec4$var$Zi = $8967ecdc07562ec4$var$Yi = !1;
    $8967ecdc07562ec4$var$ml = -1;
    $8967ecdc07562ec4$var$nl = 0;
    if (0 !== ($8967ecdc07562ec4$var$K & 6)) throw Error($8967ecdc07562ec4$var$p(327));
    var c = a.callbackNode;
    if ($8967ecdc07562ec4$var$tl() && a.callbackNode !== c) return null;
    var d = $8967ecdc07562ec4$var$Gc(a, a === $8967ecdc07562ec4$var$Q ? $8967ecdc07562ec4$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $8967ecdc07562ec4$var$ul(a, d);
    else {
        b = d;
        var e = $8967ecdc07562ec4$var$K;
        $8967ecdc07562ec4$var$K |= 2;
        var f = $8967ecdc07562ec4$var$vl();
        if ($8967ecdc07562ec4$var$Q !== a || $8967ecdc07562ec4$var$Z !== b) {
            if ($8967ecdc07562ec4$var$mc) {
                var g = a.memoizedUpdaters;
                0 < g.size && ($8967ecdc07562ec4$var$wj(a, $8967ecdc07562ec4$var$Z), g.clear());
                $8967ecdc07562ec4$var$Qc(a, b);
            }
            $8967ecdc07562ec4$var$fl = null;
            $8967ecdc07562ec4$var$mk = $8967ecdc07562ec4$var$A() + 500;
            $8967ecdc07562ec4$var$wl(a, b);
        }
        $8967ecdc07562ec4$var$wc(b);
        for(;;)try {
            $8967ecdc07562ec4$var$xl();
            break;
        } catch (h) {
            $8967ecdc07562ec4$var$yl(a, h);
        }
        $8967ecdc07562ec4$var$nh();
        $8967ecdc07562ec4$var$Yk.current = f;
        $8967ecdc07562ec4$var$K = e;
        null !== $8967ecdc07562ec4$var$Y ? (null !== $8967ecdc07562ec4$var$B && "function" === typeof $8967ecdc07562ec4$var$B.markRenderYielded && $8967ecdc07562ec4$var$B.markRenderYielded(), b = 0) : ($8967ecdc07562ec4$var$xc(), $8967ecdc07562ec4$var$Q = null, $8967ecdc07562ec4$var$Z = 0, b = $8967ecdc07562ec4$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $8967ecdc07562ec4$var$Jc(a), 0 !== e && (d = e, b = $8967ecdc07562ec4$var$zl(a, e)));
        if (1 === b) throw c = $8967ecdc07562ec4$var$al, $8967ecdc07562ec4$var$wl(a, 0), $8967ecdc07562ec4$var$ol(a, d), $8967ecdc07562ec4$var$pl(a, $8967ecdc07562ec4$var$A()), c;
        if (6 === b) $8967ecdc07562ec4$var$ol(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$8967ecdc07562ec4$var$Al(e) && (b = $8967ecdc07562ec4$var$ul(a, d), 2 === b && (f = $8967ecdc07562ec4$var$Jc(a), 0 !== f && (d = f, b = $8967ecdc07562ec4$var$zl(a, f))), 1 === b)) throw c = $8967ecdc07562ec4$var$al, $8967ecdc07562ec4$var$wl(a, 0), $8967ecdc07562ec4$var$ol(a, d), $8967ecdc07562ec4$var$pl(a, $8967ecdc07562ec4$var$A()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($8967ecdc07562ec4$var$p(345));
                case 2:
                    $8967ecdc07562ec4$var$Cl(a, $8967ecdc07562ec4$var$el, $8967ecdc07562ec4$var$fl);
                    break;
                case 3:
                    $8967ecdc07562ec4$var$ol(a, d);
                    if ((d & 130023424) === d && (b = $8967ecdc07562ec4$var$Qk + 500 - $8967ecdc07562ec4$var$A(), 10 < b)) {
                        if (0 !== $8967ecdc07562ec4$var$Gc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $8967ecdc07562ec4$var$Ri();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $8967ecdc07562ec4$var$Tf($8967ecdc07562ec4$var$Cl.bind(null, a, $8967ecdc07562ec4$var$el, $8967ecdc07562ec4$var$fl), b);
                        break;
                    }
                    $8967ecdc07562ec4$var$Cl(a, $8967ecdc07562ec4$var$el, $8967ecdc07562ec4$var$fl);
                    break;
                case 4:
                    $8967ecdc07562ec4$var$ol(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;)g = 31 - $8967ecdc07562ec4$var$Ac(d), f = 1 << g, g = b[g], g > e && (e = g), d &= ~f;
                    d = e;
                    d = $8967ecdc07562ec4$var$A() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $8967ecdc07562ec4$var$Xk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $8967ecdc07562ec4$var$Tf($8967ecdc07562ec4$var$Cl.bind(null, a, $8967ecdc07562ec4$var$el, $8967ecdc07562ec4$var$fl), d);
                        break;
                    }
                    $8967ecdc07562ec4$var$Cl(a, $8967ecdc07562ec4$var$el, $8967ecdc07562ec4$var$fl);
                    break;
                case 5:
                    $8967ecdc07562ec4$var$Cl(a, $8967ecdc07562ec4$var$el, $8967ecdc07562ec4$var$fl);
                    break;
                default:
                    throw Error($8967ecdc07562ec4$var$p(329));
            }
        }
    }
    $8967ecdc07562ec4$var$pl(a, $8967ecdc07562ec4$var$A());
    return a.callbackNode === c ? $8967ecdc07562ec4$var$sl.bind(null, a) : null;
}
function $8967ecdc07562ec4$var$zl(a, b) {
    var c = $8967ecdc07562ec4$var$dl;
    a.current.memoizedState.isDehydrated && ($8967ecdc07562ec4$var$wl(a, b).flags |= 256);
    a = $8967ecdc07562ec4$var$ul(a, b);
    2 !== a && (b = $8967ecdc07562ec4$var$el, $8967ecdc07562ec4$var$el = c, null !== b && $8967ecdc07562ec4$var$lk(b));
    return a;
}
function $8967ecdc07562ec4$var$lk(a) {
    null === $8967ecdc07562ec4$var$el ? $8967ecdc07562ec4$var$el = a : $8967ecdc07562ec4$var$el.push.apply($8967ecdc07562ec4$var$el, a);
}
function $8967ecdc07562ec4$var$Al(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$8967ecdc07562ec4$var$Ve(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $8967ecdc07562ec4$var$ol(a, b) {
    b &= ~$8967ecdc07562ec4$var$cl;
    b &= ~$8967ecdc07562ec4$var$bl;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $8967ecdc07562ec4$var$Ac(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $8967ecdc07562ec4$var$ql(a) {
    $8967ecdc07562ec4$var$Yi = $8967ecdc07562ec4$var$Zi;
    $8967ecdc07562ec4$var$Zi = !1;
    if (0 !== ($8967ecdc07562ec4$var$K & 6)) throw Error($8967ecdc07562ec4$var$p(327));
    $8967ecdc07562ec4$var$tl();
    var b = $8967ecdc07562ec4$var$Gc(a, 0);
    if (0 === (b & 1)) return $8967ecdc07562ec4$var$pl(a, $8967ecdc07562ec4$var$A()), null;
    var c = $8967ecdc07562ec4$var$ul(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $8967ecdc07562ec4$var$Jc(a);
        0 !== d && (b = d, c = $8967ecdc07562ec4$var$zl(a, d));
    }
    if (1 === c) throw c = $8967ecdc07562ec4$var$al, $8967ecdc07562ec4$var$wl(a, 0), $8967ecdc07562ec4$var$ol(a, b), $8967ecdc07562ec4$var$pl(a, $8967ecdc07562ec4$var$A()), c;
    if (6 === c) throw Error($8967ecdc07562ec4$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $8967ecdc07562ec4$var$Cl(a, $8967ecdc07562ec4$var$el, $8967ecdc07562ec4$var$fl);
    $8967ecdc07562ec4$var$pl(a, $8967ecdc07562ec4$var$A());
    return null;
}
function $8967ecdc07562ec4$var$Dl(a, b) {
    var c = $8967ecdc07562ec4$var$K;
    $8967ecdc07562ec4$var$K |= 1;
    try {
        return a(b);
    } finally{
        $8967ecdc07562ec4$var$K = c, 0 === $8967ecdc07562ec4$var$K && ($8967ecdc07562ec4$var$mk = $8967ecdc07562ec4$var$A() + 500, $8967ecdc07562ec4$var$tg && $8967ecdc07562ec4$var$xg());
    }
}
function $8967ecdc07562ec4$var$El(a) {
    null !== $8967ecdc07562ec4$var$hl && 0 === $8967ecdc07562ec4$var$hl.tag && 0 === ($8967ecdc07562ec4$var$K & 6) && $8967ecdc07562ec4$var$tl();
    var b = $8967ecdc07562ec4$var$K;
    $8967ecdc07562ec4$var$K |= 1;
    var c = $8967ecdc07562ec4$var$$k.transition, d = $8967ecdc07562ec4$var$E;
    try {
        if ($8967ecdc07562ec4$var$$k.transition = null, $8967ecdc07562ec4$var$E = 1, a) return a();
    } finally{
        $8967ecdc07562ec4$var$E = d, $8967ecdc07562ec4$var$$k.transition = c, $8967ecdc07562ec4$var$K = b, 0 === ($8967ecdc07562ec4$var$K & 6) && $8967ecdc07562ec4$var$xg();
    }
}
function $8967ecdc07562ec4$var$nk() {
    $8967ecdc07562ec4$var$Jj = $8967ecdc07562ec4$var$Ij.current;
    $8967ecdc07562ec4$var$G($8967ecdc07562ec4$var$Ij);
}
function $8967ecdc07562ec4$var$wl(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $8967ecdc07562ec4$var$Uf(c));
    if (null !== $8967ecdc07562ec4$var$Y) for(c = $8967ecdc07562ec4$var$Y.return; null !== c;){
        var d = c;
        $8967ecdc07562ec4$var$Kg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $8967ecdc07562ec4$var$ng();
                break;
            case 3:
                $8967ecdc07562ec4$var$Nh();
                $8967ecdc07562ec4$var$G($8967ecdc07562ec4$var$jg);
                $8967ecdc07562ec4$var$G($8967ecdc07562ec4$var$I);
                $8967ecdc07562ec4$var$Sh();
                break;
            case 5:
                $8967ecdc07562ec4$var$Ph(d);
                break;
            case 4:
                $8967ecdc07562ec4$var$Nh();
                break;
            case 13:
                $8967ecdc07562ec4$var$G($8967ecdc07562ec4$var$L);
                break;
            case 19:
                $8967ecdc07562ec4$var$G($8967ecdc07562ec4$var$L);
                break;
            case 10:
                $8967ecdc07562ec4$var$oh(d.type._context);
                break;
            case 22:
            case 23:
                $8967ecdc07562ec4$var$nk();
        }
        c = c.return;
    }
    $8967ecdc07562ec4$var$Q = a;
    $8967ecdc07562ec4$var$Y = a = $8967ecdc07562ec4$var$ch(a.current, null);
    $8967ecdc07562ec4$var$Z = $8967ecdc07562ec4$var$Jj = b;
    $8967ecdc07562ec4$var$T = 0;
    $8967ecdc07562ec4$var$al = null;
    $8967ecdc07562ec4$var$cl = $8967ecdc07562ec4$var$bl = $8967ecdc07562ec4$var$Fh = 0;
    $8967ecdc07562ec4$var$el = $8967ecdc07562ec4$var$dl = null;
    if (null !== $8967ecdc07562ec4$var$th) {
        for(b = 0; b < $8967ecdc07562ec4$var$th.length; b++)if (c = $8967ecdc07562ec4$var$th[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $8967ecdc07562ec4$var$th = null;
    }
    return a;
}
function $8967ecdc07562ec4$var$yl(a, b) {
    do {
        var c = $8967ecdc07562ec4$var$Y;
        try {
            $8967ecdc07562ec4$var$nh();
            $8967ecdc07562ec4$var$Th.current = $8967ecdc07562ec4$var$ei;
            if ($8967ecdc07562ec4$var$Wh) {
                for(var d = $8967ecdc07562ec4$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $8967ecdc07562ec4$var$Wh = !1;
            }
            $8967ecdc07562ec4$var$Vh = 0;
            $8967ecdc07562ec4$var$O = $8967ecdc07562ec4$var$N = $8967ecdc07562ec4$var$M = null;
            $8967ecdc07562ec4$var$Xh = !1;
            $8967ecdc07562ec4$var$Yh = 0;
            $8967ecdc07562ec4$var$Zk.current = null;
            if (null === c || null === c.return) {
                $8967ecdc07562ec4$var$T = 1;
                $8967ecdc07562ec4$var$al = b;
                $8967ecdc07562ec4$var$Y = null;
                break;
            }
            c.mode & 2 && $8967ecdc07562ec4$var$$i(c, !0);
            $8967ecdc07562ec4$var$tc();
            if (null !== b && "object" === typeof b && "function" === typeof b.then) {
                var f = b;
                null !== $8967ecdc07562ec4$var$B && "function" === typeof $8967ecdc07562ec4$var$B.markComponentSuspended && $8967ecdc07562ec4$var$B.markComponentSuspended(c, f, $8967ecdc07562ec4$var$Z);
            } else null !== $8967ecdc07562ec4$var$B && "function" === typeof $8967ecdc07562ec4$var$B.markComponentErrored && $8967ecdc07562ec4$var$B.markComponentErrored(c, b, $8967ecdc07562ec4$var$Z);
            a: {
                var g = a, h = c.return, k = c;
                f = b;
                b = $8967ecdc07562ec4$var$Z;
                k.flags |= 32768;
                $8967ecdc07562ec4$var$mc && $8967ecdc07562ec4$var$wj(g, b);
                if (null !== f && "object" === typeof f && "function" === typeof f.then) {
                    var l = f, n = k, q = n.tag;
                    if (0 === (n.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = n.alternate;
                        r ? (n.updateQueue = r.updateQueue, n.memoizedState = r.memoizedState, n.lanes = r.lanes) : (n.updateQueue = null, n.memoizedState = null);
                    }
                    var z = $8967ecdc07562ec4$var$xj(h);
                    if (null !== z) {
                        z.flags &= -257;
                        $8967ecdc07562ec4$var$yj(z, h, k, g, b);
                        z.mode & 1 && $8967ecdc07562ec4$var$uj(g, l, b);
                        b = z;
                        f = l;
                        var m = b.updateQueue;
                        if (null === m) {
                            var w = new Set;
                            w.add(f);
                            b.updateQueue = w;
                        } else m.add(f);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $8967ecdc07562ec4$var$uj(g, l, b);
                            $8967ecdc07562ec4$var$Zj();
                            break a;
                        }
                        f = Error($8967ecdc07562ec4$var$p(426));
                    }
                } else if ($8967ecdc07562ec4$var$J && k.mode & 1) {
                    var C = $8967ecdc07562ec4$var$xj(h);
                    if (null !== C) {
                        0 === (C.flags & 65536) && (C.flags |= 256);
                        $8967ecdc07562ec4$var$yj(C, h, k, g, b);
                        $8967ecdc07562ec4$var$Xg($8967ecdc07562ec4$var$lj(f, k));
                        break a;
                    }
                }
                g = f = $8967ecdc07562ec4$var$lj(f, k);
                4 !== $8967ecdc07562ec4$var$T && ($8967ecdc07562ec4$var$T = 2);
                null === $8967ecdc07562ec4$var$dl ? $8967ecdc07562ec4$var$dl = [
                    g
                ] : $8967ecdc07562ec4$var$dl.push(g);
                g = h;
                do {
                    switch(g.tag){
                        case 3:
                            g.flags |= 65536;
                            b &= -b;
                            g.lanes |= b;
                            var x = $8967ecdc07562ec4$var$pj(g, f, b);
                            $8967ecdc07562ec4$var$Dh(g, x);
                            break a;
                        case 1:
                            k = f;
                            var y = g.type, v = g.stateNode;
                            if (0 === (g.flags & 128) && ("function" === typeof y.getDerivedStateFromError || null !== v && "function" === typeof v.componentDidCatch && (null === $8967ecdc07562ec4$var$tj || !$8967ecdc07562ec4$var$tj.has(v)))) {
                                g.flags |= 65536;
                                b &= -b;
                                g.lanes |= b;
                                var D = $8967ecdc07562ec4$var$sj(g, k, b);
                                $8967ecdc07562ec4$var$Dh(g, D);
                                break a;
                            }
                    }
                    g = g.return;
                }while (null !== g);
            }
            $8967ecdc07562ec4$var$Fl(c);
        } catch (ca) {
            b = ca;
            $8967ecdc07562ec4$var$Y === c && null !== c && ($8967ecdc07562ec4$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $8967ecdc07562ec4$var$vl() {
    var a = $8967ecdc07562ec4$var$Yk.current;
    $8967ecdc07562ec4$var$Yk.current = $8967ecdc07562ec4$var$ei;
    return null === a ? $8967ecdc07562ec4$var$ei : a;
}
function $8967ecdc07562ec4$var$Zj() {
    if (0 === $8967ecdc07562ec4$var$T || 3 === $8967ecdc07562ec4$var$T || 2 === $8967ecdc07562ec4$var$T) $8967ecdc07562ec4$var$T = 4;
    null === $8967ecdc07562ec4$var$Q || 0 === ($8967ecdc07562ec4$var$Fh & 268435455) && 0 === ($8967ecdc07562ec4$var$bl & 268435455) || $8967ecdc07562ec4$var$ol($8967ecdc07562ec4$var$Q, $8967ecdc07562ec4$var$Z);
}
function $8967ecdc07562ec4$var$ul(a, b) {
    var c = $8967ecdc07562ec4$var$K;
    $8967ecdc07562ec4$var$K |= 2;
    var d = $8967ecdc07562ec4$var$vl();
    if ($8967ecdc07562ec4$var$Q !== a || $8967ecdc07562ec4$var$Z !== b) {
        if ($8967ecdc07562ec4$var$mc) {
            var e = a.memoizedUpdaters;
            0 < e.size && ($8967ecdc07562ec4$var$wj(a, $8967ecdc07562ec4$var$Z), e.clear());
            $8967ecdc07562ec4$var$Qc(a, b);
        }
        $8967ecdc07562ec4$var$fl = null;
        $8967ecdc07562ec4$var$wl(a, b);
    }
    $8967ecdc07562ec4$var$wc(b);
    for(;;)try {
        $8967ecdc07562ec4$var$Gl();
        break;
    } catch (f) {
        $8967ecdc07562ec4$var$yl(a, f);
    }
    $8967ecdc07562ec4$var$nh();
    $8967ecdc07562ec4$var$K = c;
    $8967ecdc07562ec4$var$Yk.current = d;
    if (null !== $8967ecdc07562ec4$var$Y) throw Error($8967ecdc07562ec4$var$p(261));
    $8967ecdc07562ec4$var$xc();
    $8967ecdc07562ec4$var$Q = null;
    $8967ecdc07562ec4$var$Z = 0;
    return $8967ecdc07562ec4$var$T;
}
function $8967ecdc07562ec4$var$Gl() {
    for(; null !== $8967ecdc07562ec4$var$Y;)$8967ecdc07562ec4$var$Hl($8967ecdc07562ec4$var$Y);
}
function $8967ecdc07562ec4$var$xl() {
    for(; null !== $8967ecdc07562ec4$var$Y && !$8967ecdc07562ec4$var$cc();)$8967ecdc07562ec4$var$Hl($8967ecdc07562ec4$var$Y);
}
function $8967ecdc07562ec4$var$Hl(a) {
    var b = a.alternate;
    0 !== (a.mode & 2) ? ($8967ecdc07562ec4$var$Wi = $8967ecdc07562ec4$var$Ti(), 0 > a.actualStartTime && (a.actualStartTime = $8967ecdc07562ec4$var$Ti()), b = $8967ecdc07562ec4$var$Il(b, a, $8967ecdc07562ec4$var$Jj), $8967ecdc07562ec4$var$$i(a, !0)) : b = $8967ecdc07562ec4$var$Il(b, a, $8967ecdc07562ec4$var$Jj);
    a.memoizedProps = a.pendingProps;
    null === b ? $8967ecdc07562ec4$var$Fl(a) : $8967ecdc07562ec4$var$Y = b;
    $8967ecdc07562ec4$var$Zk.current = null;
}
function $8967ecdc07562ec4$var$Fl(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (0 === (b.mode & 2)) c = $8967ecdc07562ec4$var$kk(c, b, $8967ecdc07562ec4$var$Jj);
            else {
                var d = b;
                $8967ecdc07562ec4$var$Wi = $8967ecdc07562ec4$var$Ti();
                0 > d.actualStartTime && (d.actualStartTime = $8967ecdc07562ec4$var$Ti());
                c = $8967ecdc07562ec4$var$kk(c, b, $8967ecdc07562ec4$var$Jj);
                $8967ecdc07562ec4$var$$i(b, !1);
            }
            if (null !== c) {
                $8967ecdc07562ec4$var$Y = c;
                return;
            }
        } else {
            c = $8967ecdc07562ec4$var$ok(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $8967ecdc07562ec4$var$Y = c;
                return;
            }
            if (0 !== (b.mode & 2)) {
                $8967ecdc07562ec4$var$$i(b, !1);
                c = b.actualDuration;
                for(d = b.child; null !== d;)c += d.actualDuration, d = d.sibling;
                b.actualDuration = c;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $8967ecdc07562ec4$var$T = 6;
                $8967ecdc07562ec4$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $8967ecdc07562ec4$var$Y = b;
            return;
        }
        $8967ecdc07562ec4$var$Y = b = a;
    }while (null !== b);
    0 === $8967ecdc07562ec4$var$T && ($8967ecdc07562ec4$var$T = 5);
}
function $8967ecdc07562ec4$var$Cl(a, b, c) {
    var d = $8967ecdc07562ec4$var$E, e = $8967ecdc07562ec4$var$$k.transition;
    try {
        $8967ecdc07562ec4$var$$k.transition = null, $8967ecdc07562ec4$var$E = 1, $8967ecdc07562ec4$var$Jl(a, b, c, d);
    } finally{
        $8967ecdc07562ec4$var$$k.transition = e, $8967ecdc07562ec4$var$E = d;
    }
    return null;
}
function $8967ecdc07562ec4$var$Jl(a, b, c, d) {
    do $8967ecdc07562ec4$var$tl();
    while (null !== $8967ecdc07562ec4$var$hl);
    if (0 !== ($8967ecdc07562ec4$var$K & 6)) throw Error($8967ecdc07562ec4$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    null !== $8967ecdc07562ec4$var$B && "function" === typeof $8967ecdc07562ec4$var$B.markCommitStarted && $8967ecdc07562ec4$var$B.markCommitStarted(e);
    if (null === c) return $8967ecdc07562ec4$var$rc(), null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($8967ecdc07562ec4$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $8967ecdc07562ec4$var$Nc(a, f);
    a === $8967ecdc07562ec4$var$Q && ($8967ecdc07562ec4$var$Y = $8967ecdc07562ec4$var$Q = null, $8967ecdc07562ec4$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $8967ecdc07562ec4$var$gl || ($8967ecdc07562ec4$var$gl = !0, $8967ecdc07562ec4$var$rl($8967ecdc07562ec4$var$hc, function() {
        $8967ecdc07562ec4$var$tl();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $8967ecdc07562ec4$var$$k.transition;
        $8967ecdc07562ec4$var$$k.transition = null;
        var g = $8967ecdc07562ec4$var$E;
        $8967ecdc07562ec4$var$E = 1;
        var h = $8967ecdc07562ec4$var$K;
        $8967ecdc07562ec4$var$K |= 4;
        $8967ecdc07562ec4$var$Zk.current = null;
        $8967ecdc07562ec4$var$yk(a, c);
        $8967ecdc07562ec4$var$Ui = $8967ecdc07562ec4$var$Ti();
        $8967ecdc07562ec4$var$Mk(a, c, e);
        $8967ecdc07562ec4$var$bf($8967ecdc07562ec4$var$Rf);
        $8967ecdc07562ec4$var$rd = !!$8967ecdc07562ec4$var$Qf;
        $8967ecdc07562ec4$var$Rf = $8967ecdc07562ec4$var$Qf = null;
        a.current = c;
        null !== $8967ecdc07562ec4$var$B && "function" === typeof $8967ecdc07562ec4$var$B.markLayoutEffectsStarted && $8967ecdc07562ec4$var$B.markLayoutEffectsStarted(e);
        $8967ecdc07562ec4$var$Sk(c, a, e);
        null !== $8967ecdc07562ec4$var$B && "function" === typeof $8967ecdc07562ec4$var$B.markLayoutEffectsStopped && $8967ecdc07562ec4$var$B.markLayoutEffectsStopped();
        $8967ecdc07562ec4$var$dc();
        $8967ecdc07562ec4$var$K = h;
        $8967ecdc07562ec4$var$E = g;
        $8967ecdc07562ec4$var$$k.transition = f;
    } else a.current = c, $8967ecdc07562ec4$var$Ui = $8967ecdc07562ec4$var$Ti();
    $8967ecdc07562ec4$var$gl && ($8967ecdc07562ec4$var$gl = !1, $8967ecdc07562ec4$var$hl = a, $8967ecdc07562ec4$var$il = e);
    f = a.pendingLanes;
    0 === f && ($8967ecdc07562ec4$var$tj = null);
    $8967ecdc07562ec4$var$nc(c.stateNode, d);
    $8967ecdc07562ec4$var$mc && a.memoizedUpdaters.clear();
    $8967ecdc07562ec4$var$pl(a, $8967ecdc07562ec4$var$A());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($8967ecdc07562ec4$var$qj) throw $8967ecdc07562ec4$var$qj = !1, a = $8967ecdc07562ec4$var$rj, $8967ecdc07562ec4$var$rj = null, a;
    0 !== ($8967ecdc07562ec4$var$il & 1) && 0 !== a.tag && $8967ecdc07562ec4$var$tl();
    f = a.pendingLanes;
    0 !== (f & 1) ? ($8967ecdc07562ec4$var$Zi = !0, a === $8967ecdc07562ec4$var$ll ? $8967ecdc07562ec4$var$kl++ : ($8967ecdc07562ec4$var$kl = 0, $8967ecdc07562ec4$var$ll = a)) : $8967ecdc07562ec4$var$kl = 0;
    $8967ecdc07562ec4$var$xg();
    $8967ecdc07562ec4$var$rc();
    return null;
}
function $8967ecdc07562ec4$var$tl() {
    if (null !== $8967ecdc07562ec4$var$hl) {
        var a = $8967ecdc07562ec4$var$Rc($8967ecdc07562ec4$var$il), b = $8967ecdc07562ec4$var$$k.transition, c = $8967ecdc07562ec4$var$E;
        try {
            $8967ecdc07562ec4$var$$k.transition = null;
            $8967ecdc07562ec4$var$E = 16 > a ? 16 : a;
            if (null === $8967ecdc07562ec4$var$hl) var d = !1;
            else {
                a = $8967ecdc07562ec4$var$hl;
                var e = $8967ecdc07562ec4$var$il;
                $8967ecdc07562ec4$var$hl = null;
                $8967ecdc07562ec4$var$il = 0;
                if (0 !== ($8967ecdc07562ec4$var$K & 6)) throw Error($8967ecdc07562ec4$var$p(331));
                null !== $8967ecdc07562ec4$var$B && "function" === typeof $8967ecdc07562ec4$var$B.markPassiveEffectsStarted && $8967ecdc07562ec4$var$B.markPassiveEffectsStarted(e);
                e = $8967ecdc07562ec4$var$K;
                $8967ecdc07562ec4$var$K |= 4;
                for($8967ecdc07562ec4$var$U = a.current; null !== $8967ecdc07562ec4$var$U;){
                    var f = $8967ecdc07562ec4$var$U, g = f.child;
                    if (0 !== ($8967ecdc07562ec4$var$U.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($8967ecdc07562ec4$var$U = l; null !== $8967ecdc07562ec4$var$U;){
                                    var n = $8967ecdc07562ec4$var$U, q = n;
                                    switch(q.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            q.mode & 2 ? ($8967ecdc07562ec4$var$Xi = $8967ecdc07562ec4$var$Ti(), $8967ecdc07562ec4$var$zk(8, q, f), $8967ecdc07562ec4$var$bj(q)) : $8967ecdc07562ec4$var$zk(8, q, f);
                                    }
                                    var r = n.child;
                                    if (null !== r) r.return = n, $8967ecdc07562ec4$var$U = r;
                                    else for(; null !== $8967ecdc07562ec4$var$U;){
                                        n = $8967ecdc07562ec4$var$U;
                                        var z = n.sibling, m = n.return;
                                        $8967ecdc07562ec4$var$Ck(n);
                                        if (n === l) {
                                            $8967ecdc07562ec4$var$U = null;
                                            break;
                                        }
                                        if (null !== z) {
                                            z.return = m;
                                            $8967ecdc07562ec4$var$U = z;
                                            break;
                                        }
                                        $8967ecdc07562ec4$var$U = m;
                                    }
                                }
                            }
                            var w = f.alternate;
                            if (null !== w) {
                                var C = w.child;
                                if (null !== C) {
                                    w.child = null;
                                    do {
                                        var x = C.sibling;
                                        C.sibling = null;
                                        C = x;
                                    }while (null !== C);
                                }
                            }
                            $8967ecdc07562ec4$var$U = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $8967ecdc07562ec4$var$U = g;
                    else b: for(; null !== $8967ecdc07562ec4$var$U;){
                        f = $8967ecdc07562ec4$var$U;
                        if (0 !== (f.flags & 2048)) switch(k = f, k.tag){
                            case 0:
                            case 11:
                            case 15:
                                k.mode & 2 ? ($8967ecdc07562ec4$var$Xi = $8967ecdc07562ec4$var$Ti(), $8967ecdc07562ec4$var$zk(9, k, k.return), $8967ecdc07562ec4$var$bj(k)) : $8967ecdc07562ec4$var$zk(9, k, k.return);
                        }
                        var y = f.sibling;
                        if (null !== y) {
                            y.return = f.return;
                            $8967ecdc07562ec4$var$U = y;
                            break b;
                        }
                        $8967ecdc07562ec4$var$U = f.return;
                    }
                }
                var v = a.current;
                for($8967ecdc07562ec4$var$U = v; null !== $8967ecdc07562ec4$var$U;){
                    g = $8967ecdc07562ec4$var$U;
                    var D = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== D) D.return = g, $8967ecdc07562ec4$var$U = D;
                    else b: for(g = v; null !== $8967ecdc07562ec4$var$U;){
                        h = $8967ecdc07562ec4$var$U;
                        if (0 !== (h.flags & 2048)) try {
                            switch(l = h, l.tag){
                                case 0:
                                case 11:
                                case 15:
                                    if (l.mode & 2) {
                                        $8967ecdc07562ec4$var$Xi = $8967ecdc07562ec4$var$Ti();
                                        try {
                                            $8967ecdc07562ec4$var$Ak(9, l);
                                        } finally{
                                            $8967ecdc07562ec4$var$bj(l);
                                        }
                                    } else $8967ecdc07562ec4$var$Ak(9, l);
                            }
                        } catch (Pj) {
                            $8967ecdc07562ec4$var$W(h, h.return, Pj);
                        }
                        if (h === g) {
                            $8967ecdc07562ec4$var$U = null;
                            break b;
                        }
                        var ca = h.sibling;
                        if (null !== ca) {
                            ca.return = h.return;
                            $8967ecdc07562ec4$var$U = ca;
                            break b;
                        }
                        $8967ecdc07562ec4$var$U = h.return;
                    }
                }
                v = $8967ecdc07562ec4$var$jl;
                $8967ecdc07562ec4$var$jl = [];
                for(D = 0; D < v.length; D++){
                    var R = v[D];
                    if (0 !== (R.flags & 4)) switch(R.tag){
                        case 12:
                            var sa = R.stateNode.passiveEffectDuration, V = R.memoizedProps, Bl = V.id, yi = V.onPostCommit;
                            ca = $8967ecdc07562ec4$var$Ui;
                            var zi = null === R.alternate ? "mount" : "update";
                            $8967ecdc07562ec4$var$Yi && (zi = "nested-update");
                            "function" === typeof yi && yi(Bl, zi, sa, ca);
                            var lb = R.return;
                            b: for(; null !== lb;){
                                switch(lb.tag){
                                    case 3:
                                        lb.stateNode.passiveEffectDuration += sa;
                                        break b;
                                    case 12:
                                        lb.stateNode.passiveEffectDuration += sa;
                                        break b;
                                }
                                lb = lb.return;
                            }
                    }
                }
                null !== $8967ecdc07562ec4$var$B && "function" === typeof $8967ecdc07562ec4$var$B.markPassiveEffectsStopped && $8967ecdc07562ec4$var$B.markPassiveEffectsStopped();
                $8967ecdc07562ec4$var$K = e;
                $8967ecdc07562ec4$var$xg();
                if ($8967ecdc07562ec4$var$lc && "function" === typeof $8967ecdc07562ec4$var$lc.onPostCommitFiberRoot) try {
                    $8967ecdc07562ec4$var$lc.onPostCommitFiberRoot($8967ecdc07562ec4$var$kc, a);
                } catch (Pj) {}
                var Qj = a.current.stateNode;
                Qj.effectDuration = 0;
                Qj.passiveEffectDuration = 0;
                d = !0;
            }
            return d;
        } finally{
            $8967ecdc07562ec4$var$E = c, $8967ecdc07562ec4$var$$k.transition = b;
        }
    }
    return !1;
}
function $8967ecdc07562ec4$var$Wk(a) {
    $8967ecdc07562ec4$var$jl.push(a);
    $8967ecdc07562ec4$var$gl || ($8967ecdc07562ec4$var$gl = !0, $8967ecdc07562ec4$var$rl($8967ecdc07562ec4$var$hc, function() {
        $8967ecdc07562ec4$var$tl();
        return null;
    }));
}
function $8967ecdc07562ec4$var$Kl(a, b, c) {
    b = $8967ecdc07562ec4$var$lj(c, b);
    b = $8967ecdc07562ec4$var$pj(a, b, 1);
    a = $8967ecdc07562ec4$var$Bh(a, b, 1);
    b = $8967ecdc07562ec4$var$Ri();
    null !== a && ($8967ecdc07562ec4$var$Mc(a, 1, b), $8967ecdc07562ec4$var$pl(a, b));
}
function $8967ecdc07562ec4$var$W(a, b, c) {
    if (3 === a.tag) $8967ecdc07562ec4$var$Kl(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $8967ecdc07562ec4$var$Kl(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $8967ecdc07562ec4$var$tj || !$8967ecdc07562ec4$var$tj.has(d))) {
                a = $8967ecdc07562ec4$var$lj(c, a);
                a = $8967ecdc07562ec4$var$sj(b, a, 1);
                b = $8967ecdc07562ec4$var$Bh(b, a, 1);
                a = $8967ecdc07562ec4$var$Ri();
                null !== b && ($8967ecdc07562ec4$var$Mc(b, 1, a), $8967ecdc07562ec4$var$pl(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $8967ecdc07562ec4$var$vj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $8967ecdc07562ec4$var$Ri();
    a.pingedLanes |= a.suspendedLanes & c;
    $8967ecdc07562ec4$var$Q === a && ($8967ecdc07562ec4$var$Z & c) === c && (4 === $8967ecdc07562ec4$var$T || 3 === $8967ecdc07562ec4$var$T && ($8967ecdc07562ec4$var$Z & 130023424) === $8967ecdc07562ec4$var$Z && 500 > $8967ecdc07562ec4$var$A() - $8967ecdc07562ec4$var$Qk ? $8967ecdc07562ec4$var$wl(a, 0) : $8967ecdc07562ec4$var$cl |= c);
    $8967ecdc07562ec4$var$pl(a, b);
}
function $8967ecdc07562ec4$var$Ll(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $8967ecdc07562ec4$var$Ec, $8967ecdc07562ec4$var$Ec <<= 1, 0 === ($8967ecdc07562ec4$var$Ec & 130023424) && ($8967ecdc07562ec4$var$Ec = 4194304)));
    var c = $8967ecdc07562ec4$var$Ri();
    a = $8967ecdc07562ec4$var$wh(a, b);
    null !== a && ($8967ecdc07562ec4$var$Mc(a, b, c), $8967ecdc07562ec4$var$pl(a, c));
}
function $8967ecdc07562ec4$var$ak(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $8967ecdc07562ec4$var$Ll(a, c);
}
function $8967ecdc07562ec4$var$Lk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($8967ecdc07562ec4$var$p(314));
    }
    null !== d && d.delete(b);
    $8967ecdc07562ec4$var$Ll(a, c);
}
var $8967ecdc07562ec4$var$Il;
$8967ecdc07562ec4$var$Il = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $8967ecdc07562ec4$var$jg.current) $8967ecdc07562ec4$var$rh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $8967ecdc07562ec4$var$rh = !1, $8967ecdc07562ec4$var$ek(a, b, c);
            $8967ecdc07562ec4$var$rh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $8967ecdc07562ec4$var$rh = !1, $8967ecdc07562ec4$var$J && 0 !== (b.flags & 1048576) && $8967ecdc07562ec4$var$Ig(b, $8967ecdc07562ec4$var$Bg, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $8967ecdc07562ec4$var$Mj(a, b);
            a = b.pendingProps;
            var e = $8967ecdc07562ec4$var$lg(b, $8967ecdc07562ec4$var$I.current);
            $8967ecdc07562ec4$var$qh(b, c);
            $8967ecdc07562ec4$var$sc(b);
            e = $8967ecdc07562ec4$var$ai(null, b, d, a, e, c);
            var f = $8967ecdc07562ec4$var$fi();
            $8967ecdc07562ec4$var$tc();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $8967ecdc07562ec4$var$mg(d) ? (f = !0, $8967ecdc07562ec4$var$qg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $8967ecdc07562ec4$var$yh(b), e.updater = $8967ecdc07562ec4$var$gj, b.stateNode = e, e._reactInternals = b, $8967ecdc07562ec4$var$kj(b, d, a, c), b = $8967ecdc07562ec4$var$Nj(null, b, d, !0, f, c)) : (b.tag = 0, $8967ecdc07562ec4$var$J && f && $8967ecdc07562ec4$var$Jg(b), $8967ecdc07562ec4$var$Aj(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $8967ecdc07562ec4$var$Mj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $8967ecdc07562ec4$var$Ml(d);
                a = $8967ecdc07562ec4$var$ej(d, a);
                switch(e){
                    case 0:
                        b = $8967ecdc07562ec4$var$Gj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $8967ecdc07562ec4$var$Lj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $8967ecdc07562ec4$var$Bj(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $8967ecdc07562ec4$var$Dj(null, b, d, $8967ecdc07562ec4$var$ej(d.type, a), c);
                        break a;
                }
                throw Error($8967ecdc07562ec4$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $8967ecdc07562ec4$var$ej(d, e), $8967ecdc07562ec4$var$Gj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $8967ecdc07562ec4$var$ej(d, e), $8967ecdc07562ec4$var$Lj(a, b, d, e, c);
        case 3:
            a: {
                $8967ecdc07562ec4$var$Oj(b);
                if (null === a) throw Error($8967ecdc07562ec4$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $8967ecdc07562ec4$var$zh(a, b);
                $8967ecdc07562ec4$var$Eh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $8967ecdc07562ec4$var$lj(Error($8967ecdc07562ec4$var$p(423)), b);
                        b = $8967ecdc07562ec4$var$Rj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $8967ecdc07562ec4$var$lj(Error($8967ecdc07562ec4$var$p(424)), b);
                        b = $8967ecdc07562ec4$var$Rj(a, b, d, c, e);
                        break a;
                    } else for($8967ecdc07562ec4$var$Mg = $8967ecdc07562ec4$var$Zf(b.stateNode.containerInfo.firstChild), $8967ecdc07562ec4$var$Lg = b, $8967ecdc07562ec4$var$J = !0, $8967ecdc07562ec4$var$Ng = null, c = $8967ecdc07562ec4$var$ih(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $8967ecdc07562ec4$var$Wg();
                    if (d === e) {
                        b = $8967ecdc07562ec4$var$Cj(a, b, c);
                        break a;
                    }
                    $8967ecdc07562ec4$var$Aj(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $8967ecdc07562ec4$var$Oh(b), null === a && $8967ecdc07562ec4$var$Sg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $8967ecdc07562ec4$var$Sf(d, e) ? g = null : null !== f && $8967ecdc07562ec4$var$Sf(d, f) && (b.flags |= 32), $8967ecdc07562ec4$var$Kj(a, b), $8967ecdc07562ec4$var$Aj(a, b, g, c), b.child;
        case 6:
            return null === a && $8967ecdc07562ec4$var$Sg(b), null;
        case 13:
            return $8967ecdc07562ec4$var$Uj(a, b, c);
        case 4:
            return $8967ecdc07562ec4$var$Mh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $8967ecdc07562ec4$var$hh(b, null, d, c) : $8967ecdc07562ec4$var$Aj(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $8967ecdc07562ec4$var$ej(d, e), $8967ecdc07562ec4$var$Bj(a, b, d, e, c);
        case 7:
            return $8967ecdc07562ec4$var$Aj(a, b, b.pendingProps, c), b.child;
        case 8:
            return $8967ecdc07562ec4$var$Aj(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return b.flags |= 4, d = b.stateNode, d.effectDuration = 0, d.passiveEffectDuration = 0, $8967ecdc07562ec4$var$Aj(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $8967ecdc07562ec4$var$H($8967ecdc07562ec4$var$jh, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($8967ecdc07562ec4$var$Ve(f.value, g)) {
                        if (f.children === e.children && !$8967ecdc07562ec4$var$jg.current) {
                            b = $8967ecdc07562ec4$var$Cj(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $8967ecdc07562ec4$var$Ah(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var n = l.pending;
                                            null === n ? k.next = k : (k.next = n.next, n.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $8967ecdc07562ec4$var$ph(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($8967ecdc07562ec4$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $8967ecdc07562ec4$var$ph(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $8967ecdc07562ec4$var$Aj(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $8967ecdc07562ec4$var$qh(b, c), e = $8967ecdc07562ec4$var$sh(e), $8967ecdc07562ec4$var$sc(b), d = d(e), $8967ecdc07562ec4$var$tc(), b.flags |= 1, $8967ecdc07562ec4$var$Aj(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $8967ecdc07562ec4$var$ej(d, b.pendingProps), e = $8967ecdc07562ec4$var$ej(d.type, e), $8967ecdc07562ec4$var$Dj(a, b, d, e, c);
        case 15:
            return $8967ecdc07562ec4$var$Fj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $8967ecdc07562ec4$var$ej(d, e), $8967ecdc07562ec4$var$Mj(a, b), b.tag = 1, $8967ecdc07562ec4$var$mg(d) ? (a = !0, $8967ecdc07562ec4$var$qg(b)) : a = !1, $8967ecdc07562ec4$var$qh(b, c), $8967ecdc07562ec4$var$ij(b, d, e), $8967ecdc07562ec4$var$kj(b, d, e, c), $8967ecdc07562ec4$var$Nj(null, b, d, !0, a, c);
        case 19:
            return $8967ecdc07562ec4$var$dk(a, b, c);
        case 22:
            return $8967ecdc07562ec4$var$Hj(a, b, c);
    }
    throw Error($8967ecdc07562ec4$var$p(156, b.tag));
};
function $8967ecdc07562ec4$var$wj(a, b) {
    $8967ecdc07562ec4$var$mc && a.memoizedUpdaters.forEach(function(c) {
        $8967ecdc07562ec4$var$Pc(a, c, b);
    });
}
function $8967ecdc07562ec4$var$rl(a, b) {
    return $8967ecdc07562ec4$var$ac(a, b);
}
function $8967ecdc07562ec4$var$Nl(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
    this.actualDuration = 0;
    this.actualStartTime = -1;
    this.treeBaseDuration = this.selfBaseDuration = 0;
}
function $8967ecdc07562ec4$var$Pg(a, b, c, d) {
    return new $8967ecdc07562ec4$var$Nl(a, b, c, d);
}
function $8967ecdc07562ec4$var$Ej(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $8967ecdc07562ec4$var$Ml(a) {
    if ("function" === typeof a) return $8967ecdc07562ec4$var$Ej(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $8967ecdc07562ec4$var$Da) return 11;
        if (a === $8967ecdc07562ec4$var$Ga) return 14;
    }
    return 2;
}
function $8967ecdc07562ec4$var$ch(a, b) {
    var c = a.alternate;
    null === c ? (c = $8967ecdc07562ec4$var$Pg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null, c.actualDuration = 0, c.actualStartTime = -1);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    c.selfBaseDuration = a.selfBaseDuration;
    c.treeBaseDuration = a.treeBaseDuration;
    return c;
}
function $8967ecdc07562ec4$var$eh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $8967ecdc07562ec4$var$Ej(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $8967ecdc07562ec4$var$ya:
            return $8967ecdc07562ec4$var$gh(c.children, e, f, b);
        case $8967ecdc07562ec4$var$za:
            g = 8;
            e |= 8;
            break;
        case $8967ecdc07562ec4$var$Aa:
            return a = $8967ecdc07562ec4$var$Pg(12, c, b, e | 2), a.elementType = $8967ecdc07562ec4$var$Aa, a.lanes = f, a.stateNode = {
                effectDuration: 0,
                passiveEffectDuration: 0
            }, a;
        case $8967ecdc07562ec4$var$Ea:
            return a = $8967ecdc07562ec4$var$Pg(13, c, b, e), a.elementType = $8967ecdc07562ec4$var$Ea, a.lanes = f, a;
        case $8967ecdc07562ec4$var$Fa:
            return a = $8967ecdc07562ec4$var$Pg(19, c, b, e), a.elementType = $8967ecdc07562ec4$var$Fa, a.lanes = f, a;
        case $8967ecdc07562ec4$var$Ia:
            return $8967ecdc07562ec4$var$Vj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $8967ecdc07562ec4$var$Ba:
                    g = 10;
                    break a;
                case $8967ecdc07562ec4$var$Ca:
                    g = 9;
                    break a;
                case $8967ecdc07562ec4$var$Da:
                    g = 11;
                    break a;
                case $8967ecdc07562ec4$var$Ga:
                    g = 14;
                    break a;
                case $8967ecdc07562ec4$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($8967ecdc07562ec4$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $8967ecdc07562ec4$var$Pg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $8967ecdc07562ec4$var$gh(a, b, c, d) {
    a = $8967ecdc07562ec4$var$Pg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $8967ecdc07562ec4$var$Vj(a, b, c, d) {
    a = $8967ecdc07562ec4$var$Pg(22, a, d, b);
    a.elementType = $8967ecdc07562ec4$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $8967ecdc07562ec4$var$dh(a, b, c) {
    a = $8967ecdc07562ec4$var$Pg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $8967ecdc07562ec4$var$fh(a, b, c) {
    b = $8967ecdc07562ec4$var$Pg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $8967ecdc07562ec4$var$Ol(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $8967ecdc07562ec4$var$Lc(0);
    this.expirationTimes = $8967ecdc07562ec4$var$Lc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $8967ecdc07562ec4$var$Lc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
    this.passiveEffectDuration = this.effectDuration = 0;
    this.memoizedUpdaters = new Set;
    a = this.pendingUpdatersLaneMap = [];
    for(b = 0; 31 > b; b++)a.push(new Set);
}
function $8967ecdc07562ec4$var$Pl(a, b, c, d, e, f, g, h, k) {
    a = new $8967ecdc07562ec4$var$Ol(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    $8967ecdc07562ec4$var$mc && (b |= 2);
    f = $8967ecdc07562ec4$var$Pg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $8967ecdc07562ec4$var$yh(f);
    return a;
}
function $8967ecdc07562ec4$var$Ql(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $8967ecdc07562ec4$var$xa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $8967ecdc07562ec4$var$Rl(a) {
    if (!a) return $8967ecdc07562ec4$var$ig;
    a = a._reactInternals;
    a: {
        if ($8967ecdc07562ec4$var$Vb(a) !== a || 1 !== a.tag) throw Error($8967ecdc07562ec4$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($8967ecdc07562ec4$var$mg(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($8967ecdc07562ec4$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($8967ecdc07562ec4$var$mg(c)) return $8967ecdc07562ec4$var$pg(a, c, b);
    }
    return b;
}
function $8967ecdc07562ec4$var$Sl(a, b, c, d, e, f, g, h, k) {
    a = $8967ecdc07562ec4$var$Pl(c, d, !0, a, e, f, g, h, k);
    a.context = $8967ecdc07562ec4$var$Rl(null);
    c = a.current;
    d = $8967ecdc07562ec4$var$Ri();
    e = $8967ecdc07562ec4$var$Oi(c);
    f = $8967ecdc07562ec4$var$Ah(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $8967ecdc07562ec4$var$Bh(c, f, e);
    a.current.lanes = e;
    $8967ecdc07562ec4$var$Mc(a, e, d);
    $8967ecdc07562ec4$var$pl(a, d);
    return a;
}
function $8967ecdc07562ec4$var$Tl(a, b, c, d) {
    var e = b.current, f = $8967ecdc07562ec4$var$Ri(), g = $8967ecdc07562ec4$var$Oi(e);
    null !== $8967ecdc07562ec4$var$B && "function" === typeof $8967ecdc07562ec4$var$B.markRenderScheduled && $8967ecdc07562ec4$var$B.markRenderScheduled(g);
    c = $8967ecdc07562ec4$var$Rl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $8967ecdc07562ec4$var$Ah(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $8967ecdc07562ec4$var$Bh(e, b, g);
    null !== a && ($8967ecdc07562ec4$var$ui(a, e, g, f), $8967ecdc07562ec4$var$Ch(a, e, g));
    return g;
}
function $8967ecdc07562ec4$var$Ul(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $8967ecdc07562ec4$var$Vl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $8967ecdc07562ec4$var$Wl(a, b) {
    $8967ecdc07562ec4$var$Vl(a, b);
    (a = a.alternate) && $8967ecdc07562ec4$var$Vl(a, b);
}
function $8967ecdc07562ec4$var$Xl() {
    return null;
}
var $8967ecdc07562ec4$var$Yl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $8967ecdc07562ec4$var$Zl(a) {
    this._internalRoot = a;
}
$8967ecdc07562ec4$var$$l.prototype.render = $8967ecdc07562ec4$var$Zl.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($8967ecdc07562ec4$var$p(409));
    $8967ecdc07562ec4$var$Tl(a, b, null, null);
};
$8967ecdc07562ec4$var$$l.prototype.unmount = $8967ecdc07562ec4$var$Zl.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $8967ecdc07562ec4$var$El(function() {
            $8967ecdc07562ec4$var$Tl(null, a, null, null);
        });
        b[$8967ecdc07562ec4$var$If] = null;
    }
};
function $8967ecdc07562ec4$var$$l(a) {
    this._internalRoot = a;
}
$8967ecdc07562ec4$var$$l.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $8967ecdc07562ec4$var$Vc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $8967ecdc07562ec4$var$dd.length && 0 !== b && b < $8967ecdc07562ec4$var$dd[c].priority; c++);
        $8967ecdc07562ec4$var$dd.splice(c, 0, a);
        0 === c && $8967ecdc07562ec4$var$id(a);
    }
};
function $8967ecdc07562ec4$var$am(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $8967ecdc07562ec4$var$bm(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $8967ecdc07562ec4$var$cm() {}
function $8967ecdc07562ec4$var$dm(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $8967ecdc07562ec4$var$Ul(g);
                f.call(a);
            };
        }
        var g = $8967ecdc07562ec4$var$Sl(b, d, a, 0, null, !1, !1, "", $8967ecdc07562ec4$var$cm);
        a._reactRootContainer = g;
        a[$8967ecdc07562ec4$var$If] = g.current;
        $8967ecdc07562ec4$var$Gf(8 === a.nodeType ? a.parentNode : a);
        $8967ecdc07562ec4$var$El();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $8967ecdc07562ec4$var$Ul(k);
            h.call(a);
        };
    }
    var k = $8967ecdc07562ec4$var$Pl(a, 0, !1, null, null, !1, !1, "", $8967ecdc07562ec4$var$cm);
    a._reactRootContainer = k;
    a[$8967ecdc07562ec4$var$If] = k.current;
    $8967ecdc07562ec4$var$Gf(8 === a.nodeType ? a.parentNode : a);
    $8967ecdc07562ec4$var$El(function() {
        $8967ecdc07562ec4$var$Tl(b, k, c, d);
    });
    return k;
}
function $8967ecdc07562ec4$var$em(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $8967ecdc07562ec4$var$Ul(g);
                h.call(a);
            };
        }
        $8967ecdc07562ec4$var$Tl(b, g, a, e);
    } else g = $8967ecdc07562ec4$var$dm(c, b, a, e, d);
    return $8967ecdc07562ec4$var$Ul(g);
}
$8967ecdc07562ec4$var$Sc = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $8967ecdc07562ec4$var$Fc(b.pendingLanes);
                0 !== c && ($8967ecdc07562ec4$var$Oc(b, c | 1), $8967ecdc07562ec4$var$pl(b, $8967ecdc07562ec4$var$A()), 0 === ($8967ecdc07562ec4$var$K & 6) && ($8967ecdc07562ec4$var$mk = $8967ecdc07562ec4$var$A() + 500, $8967ecdc07562ec4$var$xg()));
            }
            break;
        case 13:
            $8967ecdc07562ec4$var$El(function() {
                var b = $8967ecdc07562ec4$var$wh(a, 1);
                if (null !== b) {
                    var c = $8967ecdc07562ec4$var$Ri();
                    $8967ecdc07562ec4$var$ui(b, a, 1, c);
                }
            }), $8967ecdc07562ec4$var$Wl(a, 1);
    }
};
$8967ecdc07562ec4$var$Tc = function(a) {
    if (13 === a.tag) {
        var b = $8967ecdc07562ec4$var$wh(a, 134217728);
        if (null !== b) {
            var c = $8967ecdc07562ec4$var$Ri();
            $8967ecdc07562ec4$var$ui(b, a, 134217728, c);
        }
        $8967ecdc07562ec4$var$Wl(a, 134217728);
    }
};
$8967ecdc07562ec4$var$Uc = function(a) {
    if (13 === a.tag) {
        var b = $8967ecdc07562ec4$var$Oi(a), c = $8967ecdc07562ec4$var$wh(a, b);
        if (null !== c) {
            var d = $8967ecdc07562ec4$var$Ri();
            $8967ecdc07562ec4$var$ui(c, a, b, d);
        }
        $8967ecdc07562ec4$var$Wl(a, b);
    }
};
$8967ecdc07562ec4$var$Vc = function() {
    return $8967ecdc07562ec4$var$E;
};
$8967ecdc07562ec4$var$Wc = function(a, b) {
    var c = $8967ecdc07562ec4$var$E;
    try {
        return $8967ecdc07562ec4$var$E = a, b();
    } finally{
        $8967ecdc07562ec4$var$E = c;
    }
};
$8967ecdc07562ec4$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $8967ecdc07562ec4$var$ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $8967ecdc07562ec4$var$Db(d);
                        if (!e) throw Error($8967ecdc07562ec4$var$p(90));
                        $8967ecdc07562ec4$var$Wa(d);
                        $8967ecdc07562ec4$var$ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $8967ecdc07562ec4$var$hb(a, c);
            break;
        case "select":
            b = c.value, null != b && $8967ecdc07562ec4$var$eb(a, !!c.multiple, b, !1);
    }
};
$8967ecdc07562ec4$var$Gb = $8967ecdc07562ec4$var$Dl;
$8967ecdc07562ec4$var$Hb = $8967ecdc07562ec4$var$El;
var $8967ecdc07562ec4$var$fm = {
    usingClientEntryPoint: !1,
    Events: [
        $8967ecdc07562ec4$var$Cb,
        $8967ecdc07562ec4$var$Ie,
        $8967ecdc07562ec4$var$Db,
        $8967ecdc07562ec4$var$Eb,
        $8967ecdc07562ec4$var$Fb,
        $8967ecdc07562ec4$var$Dl
    ]
}, $8967ecdc07562ec4$var$gm = {
    findFiberByHostInstance: $8967ecdc07562ec4$var$jd,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
(function(a) {
    if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
    var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (b.isDisabled || !b.supportsFiber) return !0;
    try {
        a = $8967ecdc07562ec4$var$u({}, a, {
            getLaneLabelMap: $8967ecdc07562ec4$var$pc,
            injectProfilingHooks: $8967ecdc07562ec4$var$oc
        }), $8967ecdc07562ec4$var$kc = b.inject(a), $8967ecdc07562ec4$var$lc = b;
    } catch (c) {}
    return b.checkDCE ? !0 : !1;
})({
    bundleType: $8967ecdc07562ec4$var$gm.bundleType,
    version: $8967ecdc07562ec4$var$gm.version,
    rendererPackageName: $8967ecdc07562ec4$var$gm.rendererPackageName,
    rendererConfig: $8967ecdc07562ec4$var$gm.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $8967ecdc07562ec4$var$va.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $8967ecdc07562ec4$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $8967ecdc07562ec4$var$gm.findFiberByHostInstance || $8967ecdc07562ec4$var$Xl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
});
$8967ecdc07562ec4$export$ae55be85d98224ed = $8967ecdc07562ec4$var$fm;
$8967ecdc07562ec4$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$8967ecdc07562ec4$var$am(b)) throw Error($8967ecdc07562ec4$var$p(200));
    return $8967ecdc07562ec4$var$Ql(a, b, null, c);
};
$8967ecdc07562ec4$export$882461b6382ed46c = function(a, b) {
    if (!$8967ecdc07562ec4$var$am(a)) throw Error($8967ecdc07562ec4$var$p(299));
    var c = !1, d = "", e = $8967ecdc07562ec4$var$Yl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $8967ecdc07562ec4$var$Pl(a, 1, !1, null, null, c, !1, d, e);
    a[$8967ecdc07562ec4$var$If] = b.current;
    $8967ecdc07562ec4$var$Gf(8 === a.nodeType ? a.parentNode : a);
    return new $8967ecdc07562ec4$var$Zl(b);
};
$8967ecdc07562ec4$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($8967ecdc07562ec4$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($8967ecdc07562ec4$var$p(268, a));
    }
    a = $8967ecdc07562ec4$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$8967ecdc07562ec4$export$cd75ccfd720a3cd4 = function(a) {
    return $8967ecdc07562ec4$var$El(a);
};
$8967ecdc07562ec4$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$8967ecdc07562ec4$var$bm(b)) throw Error($8967ecdc07562ec4$var$p(200));
    return $8967ecdc07562ec4$var$em(null, a, b, !0, c);
};
$8967ecdc07562ec4$export$757ceba2d55c277e = function(a, b, c) {
    if (!$8967ecdc07562ec4$var$am(a)) throw Error($8967ecdc07562ec4$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $8967ecdc07562ec4$var$Yl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $8967ecdc07562ec4$var$Sl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$8967ecdc07562ec4$var$If] = b.current;
    $8967ecdc07562ec4$var$Gf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $8967ecdc07562ec4$var$$l(b);
};
$8967ecdc07562ec4$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$8967ecdc07562ec4$var$bm(b)) throw Error($8967ecdc07562ec4$var$p(200));
    return $8967ecdc07562ec4$var$em(null, a, b, !1, c);
};
$8967ecdc07562ec4$export$502457920280e6be = function(a) {
    if (!$8967ecdc07562ec4$var$bm(a)) throw Error($8967ecdc07562ec4$var$p(40));
    return a._reactRootContainer ? ($8967ecdc07562ec4$var$El(function() {
        $8967ecdc07562ec4$var$em(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$8967ecdc07562ec4$var$If] = null;
        });
    }), !0) : !1;
};
$8967ecdc07562ec4$export$c78a37762a8d58e1 = $8967ecdc07562ec4$var$Dl;
$8967ecdc07562ec4$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$8967ecdc07562ec4$var$bm(c)) throw Error($8967ecdc07562ec4$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($8967ecdc07562ec4$var$p(38));
    return $8967ecdc07562ec4$var$em(a, b, c, !1, d);
};
$8967ecdc07562ec4$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";
/* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === 'function') __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());

});
parcelRegister("LXjOh", function(module, exports) {
'use strict';

module.exports = (parcelRequire("c1yAu"));

});
parcelRegister("c1yAu", function(module, exports) {
$parcel$export(module.exports, "unstable_now", () => $8c106868832723d9$export$c4744153514ff05d, (v) => $8c106868832723d9$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $8c106868832723d9$export$3e506c1ccc9cc1a7, (v) => $8c106868832723d9$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $8c106868832723d9$export$e26fe2ed2fa76875, (v) => $8c106868832723d9$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $8c106868832723d9$export$502329bbf4b505b1, (v) => $8c106868832723d9$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $8c106868832723d9$export$6e3807111c4874c4, (v) => $8c106868832723d9$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $8c106868832723d9$export$c27134553091fb3a, (v) => $8c106868832723d9$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $8c106868832723d9$export$33ee1acdc04fd2a2, (v) => $8c106868832723d9$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $8c106868832723d9$export$b00a404bbd5edef2, (v) => $8c106868832723d9$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $8c106868832723d9$export$8352ce38b91d0c62, (v) => $8c106868832723d9$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $8c106868832723d9$export$d66a1c1c77bd778b, (v) => $8c106868832723d9$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $8c106868832723d9$export$d3dfb8e4810cb555, (v) => $8c106868832723d9$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $8c106868832723d9$export$839f9183b0465a69, (v) => $8c106868832723d9$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $8c106868832723d9$export$72fdf0e06517287b, (v) => $8c106868832723d9$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $8c106868832723d9$export$4b844e58a3e414b4, (v) => $8c106868832723d9$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $8c106868832723d9$export$816d2913ae6b83b1, (v) => $8c106868832723d9$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $8c106868832723d9$export$61bcfe829111a1d0, (v) => $8c106868832723d9$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $8c106868832723d9$export$7ee8c9beb337bc3f, (v) => $8c106868832723d9$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $8c106868832723d9$export$b5836b71941fa3ed, (v) => $8c106868832723d9$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $8c106868832723d9$export$cf845f2c119da08a, (v) => $8c106868832723d9$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8c106868832723d9$export$c4744153514ff05d;
var $8c106868832723d9$export$3e506c1ccc9cc1a7;
var $8c106868832723d9$export$e26fe2ed2fa76875;
var $8c106868832723d9$export$502329bbf4b505b1;
var $8c106868832723d9$export$6e3807111c4874c4;
var $8c106868832723d9$export$c27134553091fb3a;
var $8c106868832723d9$export$33ee1acdc04fd2a2;
var $8c106868832723d9$export$b00a404bbd5edef2;
var $8c106868832723d9$export$8352ce38b91d0c62;
var $8c106868832723d9$export$d66a1c1c77bd778b;
var $8c106868832723d9$export$d3dfb8e4810cb555;
var $8c106868832723d9$export$839f9183b0465a69;
var $8c106868832723d9$export$72fdf0e06517287b;
var $8c106868832723d9$export$4b844e58a3e414b4;
var $8c106868832723d9$export$816d2913ae6b83b1;
var $8c106868832723d9$export$61bcfe829111a1d0;
var $8c106868832723d9$export$7ee8c9beb337bc3f;
var $8c106868832723d9$export$b5836b71941fa3ed;
var $8c106868832723d9$export$cf845f2c119da08a;
'use strict';
function $8c106868832723d9$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $8c106868832723d9$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $8c106868832723d9$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $8c106868832723d9$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $8c106868832723d9$var$g(C, c)) n < e && 0 > $8c106868832723d9$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $8c106868832723d9$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $8c106868832723d9$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $8c106868832723d9$var$l = performance;
    $8c106868832723d9$export$c4744153514ff05d = function() {
        return $8c106868832723d9$var$l.now();
    };
} else {
    var $8c106868832723d9$var$p = Date, $8c106868832723d9$var$q = $8c106868832723d9$var$p.now();
    $8c106868832723d9$export$c4744153514ff05d = function() {
        return $8c106868832723d9$var$p.now() - $8c106868832723d9$var$q;
    };
}
var $8c106868832723d9$var$r = [], $8c106868832723d9$var$t = [], $8c106868832723d9$var$u = 1, $8c106868832723d9$var$v = null, $8c106868832723d9$var$y = 3, $8c106868832723d9$var$z = !1, $8c106868832723d9$var$A = !1, $8c106868832723d9$var$B = !1, $8c106868832723d9$var$D = "function" === typeof setTimeout ? setTimeout : null, $8c106868832723d9$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $8c106868832723d9$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $8c106868832723d9$var$G(a) {
    for(var b = $8c106868832723d9$var$h($8c106868832723d9$var$t); null !== b;){
        if (null === b.callback) $8c106868832723d9$var$k($8c106868832723d9$var$t);
        else if (b.startTime <= a) $8c106868832723d9$var$k($8c106868832723d9$var$t), b.sortIndex = b.expirationTime, $8c106868832723d9$var$f($8c106868832723d9$var$r, b);
        else break;
        b = $8c106868832723d9$var$h($8c106868832723d9$var$t);
    }
}
function $8c106868832723d9$var$H(a) {
    $8c106868832723d9$var$B = !1;
    $8c106868832723d9$var$G(a);
    if (!$8c106868832723d9$var$A) {
        if (null !== $8c106868832723d9$var$h($8c106868832723d9$var$r)) $8c106868832723d9$var$A = !0, $8c106868832723d9$var$I($8c106868832723d9$var$J);
        else {
            var b = $8c106868832723d9$var$h($8c106868832723d9$var$t);
            null !== b && $8c106868832723d9$var$K($8c106868832723d9$var$H, b.startTime - a);
        }
    }
}
function $8c106868832723d9$var$J(a, b) {
    $8c106868832723d9$var$A = !1;
    $8c106868832723d9$var$B && ($8c106868832723d9$var$B = !1, $8c106868832723d9$var$E($8c106868832723d9$var$L), $8c106868832723d9$var$L = -1);
    $8c106868832723d9$var$z = !0;
    var c = $8c106868832723d9$var$y;
    try {
        $8c106868832723d9$var$G(b);
        for($8c106868832723d9$var$v = $8c106868832723d9$var$h($8c106868832723d9$var$r); null !== $8c106868832723d9$var$v && (!($8c106868832723d9$var$v.expirationTime > b) || a && !$8c106868832723d9$var$M());){
            var d = $8c106868832723d9$var$v.callback;
            if ("function" === typeof d) {
                $8c106868832723d9$var$v.callback = null;
                $8c106868832723d9$var$y = $8c106868832723d9$var$v.priorityLevel;
                var e = d($8c106868832723d9$var$v.expirationTime <= b);
                b = $8c106868832723d9$export$c4744153514ff05d();
                "function" === typeof e ? $8c106868832723d9$var$v.callback = e : $8c106868832723d9$var$v === $8c106868832723d9$var$h($8c106868832723d9$var$r) && $8c106868832723d9$var$k($8c106868832723d9$var$r);
                $8c106868832723d9$var$G(b);
            } else $8c106868832723d9$var$k($8c106868832723d9$var$r);
            $8c106868832723d9$var$v = $8c106868832723d9$var$h($8c106868832723d9$var$r);
        }
        if (null !== $8c106868832723d9$var$v) var w = !0;
        else {
            var m = $8c106868832723d9$var$h($8c106868832723d9$var$t);
            null !== m && $8c106868832723d9$var$K($8c106868832723d9$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $8c106868832723d9$var$v = null, $8c106868832723d9$var$y = c, $8c106868832723d9$var$z = !1;
    }
}
var $8c106868832723d9$var$N = !1, $8c106868832723d9$var$O = null, $8c106868832723d9$var$L = -1, $8c106868832723d9$var$P = 5, $8c106868832723d9$var$Q = -1;
function $8c106868832723d9$var$M() {
    return $8c106868832723d9$export$c4744153514ff05d() - $8c106868832723d9$var$Q < $8c106868832723d9$var$P ? !1 : !0;
}
function $8c106868832723d9$var$R() {
    if (null !== $8c106868832723d9$var$O) {
        var a = $8c106868832723d9$export$c4744153514ff05d();
        $8c106868832723d9$var$Q = a;
        var b = !0;
        try {
            b = $8c106868832723d9$var$O(!0, a);
        } finally{
            b ? $8c106868832723d9$var$S() : ($8c106868832723d9$var$N = !1, $8c106868832723d9$var$O = null);
        }
    } else $8c106868832723d9$var$N = !1;
}
var $8c106868832723d9$var$S;
if ("function" === typeof $8c106868832723d9$var$F) $8c106868832723d9$var$S = function() {
    $8c106868832723d9$var$F($8c106868832723d9$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $8c106868832723d9$var$T = new MessageChannel, $8c106868832723d9$var$U = $8c106868832723d9$var$T.port2;
    $8c106868832723d9$var$T.port1.onmessage = $8c106868832723d9$var$R;
    $8c106868832723d9$var$S = function() {
        $8c106868832723d9$var$U.postMessage(null);
    };
} else $8c106868832723d9$var$S = function() {
    $8c106868832723d9$var$D($8c106868832723d9$var$R, 0);
};
function $8c106868832723d9$var$I(a) {
    $8c106868832723d9$var$O = a;
    $8c106868832723d9$var$N || ($8c106868832723d9$var$N = !0, $8c106868832723d9$var$S());
}
function $8c106868832723d9$var$K(a, b) {
    $8c106868832723d9$var$L = $8c106868832723d9$var$D(function() {
        a($8c106868832723d9$export$c4744153514ff05d());
    }, b);
}
$8c106868832723d9$export$3e506c1ccc9cc1a7 = 5;
$8c106868832723d9$export$e26fe2ed2fa76875 = 1;
$8c106868832723d9$export$502329bbf4b505b1 = 4;
$8c106868832723d9$export$6e3807111c4874c4 = 3;
$8c106868832723d9$export$c27134553091fb3a = null;
$8c106868832723d9$export$33ee1acdc04fd2a2 = 2;
$8c106868832723d9$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$8c106868832723d9$export$8352ce38b91d0c62 = function() {
    $8c106868832723d9$var$A || $8c106868832723d9$var$z || ($8c106868832723d9$var$A = !0, $8c106868832723d9$var$I($8c106868832723d9$var$J));
};
$8c106868832723d9$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $8c106868832723d9$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$8c106868832723d9$export$d3dfb8e4810cb555 = function() {
    return $8c106868832723d9$var$y;
};
$8c106868832723d9$export$839f9183b0465a69 = function() {
    return $8c106868832723d9$var$h($8c106868832723d9$var$r);
};
$8c106868832723d9$export$72fdf0e06517287b = function(a) {
    switch($8c106868832723d9$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $8c106868832723d9$var$y;
    }
    var c = $8c106868832723d9$var$y;
    $8c106868832723d9$var$y = b;
    try {
        return a();
    } finally{
        $8c106868832723d9$var$y = c;
    }
};
$8c106868832723d9$export$4b844e58a3e414b4 = function() {};
$8c106868832723d9$export$816d2913ae6b83b1 = function() {};
$8c106868832723d9$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $8c106868832723d9$var$y;
    $8c106868832723d9$var$y = a;
    try {
        return b();
    } finally{
        $8c106868832723d9$var$y = c;
    }
};
$8c106868832723d9$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $8c106868832723d9$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $8c106868832723d9$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $8c106868832723d9$var$f($8c106868832723d9$var$t, a), null === $8c106868832723d9$var$h($8c106868832723d9$var$r) && a === $8c106868832723d9$var$h($8c106868832723d9$var$t) && ($8c106868832723d9$var$B ? ($8c106868832723d9$var$E($8c106868832723d9$var$L), $8c106868832723d9$var$L = -1) : $8c106868832723d9$var$B = !0, $8c106868832723d9$var$K($8c106868832723d9$var$H, c - d))) : (a.sortIndex = e, $8c106868832723d9$var$f($8c106868832723d9$var$r, a), $8c106868832723d9$var$A || $8c106868832723d9$var$z || ($8c106868832723d9$var$A = !0, $8c106868832723d9$var$I($8c106868832723d9$var$J)));
    return a;
};
$8c106868832723d9$export$b5836b71941fa3ed = $8c106868832723d9$var$M;
$8c106868832723d9$export$cf845f2c119da08a = function(a) {
    var b = $8c106868832723d9$var$y;
    return function() {
        var c = $8c106868832723d9$var$y;
        $8c106868832723d9$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $8c106868832723d9$var$y = c;
        }
    };
};

});



parcelRegister("b0qLu", function(module, exports) {
$parcel$export(module.exports, "Buffer", () => $803474bfb07b045d$export$a143d493d941bafc, (v) => $803474bfb07b045d$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $803474bfb07b045d$export$e4cf37d7f6fb9e0a, (v) => $803474bfb07b045d$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $803474bfb07b045d$export$f99ded8fe4b79145, (v) => $803474bfb07b045d$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $803474bfb07b045d$export$599f31c3813fae4d, (v) => $803474bfb07b045d$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $803474bfb07b045d$export$a143d493d941bafc;
var $803474bfb07b045d$export$e4cf37d7f6fb9e0a;
var $803474bfb07b045d$export$f99ded8fe4b79145;
var $803474bfb07b045d$export$599f31c3813fae4d;
'use strict';

var $e9UD0 = parcelRequire("e9UD0");

var $cqJSK = parcelRequire("cqJSK");
const $803474bfb07b045d$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$803474bfb07b045d$export$a143d493d941bafc = $803474bfb07b045d$var$Buffer;
$803474bfb07b045d$export$e4cf37d7f6fb9e0a = $803474bfb07b045d$var$SlowBuffer;
$803474bfb07b045d$export$f99ded8fe4b79145 = 50;
const $803474bfb07b045d$var$K_MAX_LENGTH = 0x7fffffff;
$803474bfb07b045d$export$599f31c3813fae4d = $803474bfb07b045d$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $803474bfb07b045d$var$Buffer.TYPED_ARRAY_SUPPORT = $803474bfb07b045d$var$typedArraySupport();
if (!$803474bfb07b045d$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $803474bfb07b045d$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($803474bfb07b045d$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$803474bfb07b045d$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($803474bfb07b045d$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$803474bfb07b045d$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $803474bfb07b045d$var$createBuffer(length) {
    if (length > $803474bfb07b045d$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $803474bfb07b045d$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $803474bfb07b045d$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $803474bfb07b045d$var$allocUnsafe(arg);
    }
    return $803474bfb07b045d$var$from(arg, encodingOrOffset, length);
}
$803474bfb07b045d$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $803474bfb07b045d$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $803474bfb07b045d$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $803474bfb07b045d$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($803474bfb07b045d$var$isInstance(value, ArrayBuffer) || value && $803474bfb07b045d$var$isInstance(value.buffer, ArrayBuffer)) return $803474bfb07b045d$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($803474bfb07b045d$var$isInstance(value, SharedArrayBuffer) || value && $803474bfb07b045d$var$isInstance(value.buffer, SharedArrayBuffer))) return $803474bfb07b045d$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $803474bfb07b045d$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $803474bfb07b045d$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $803474bfb07b045d$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $803474bfb07b045d$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $803474bfb07b045d$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($803474bfb07b045d$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($803474bfb07b045d$var$Buffer, Uint8Array);
function $803474bfb07b045d$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $803474bfb07b045d$var$alloc(size, fill, encoding) {
    $803474bfb07b045d$var$assertSize(size);
    if (size <= 0) return $803474bfb07b045d$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $803474bfb07b045d$var$createBuffer(size).fill(fill, encoding) : $803474bfb07b045d$var$createBuffer(size).fill(fill);
    return $803474bfb07b045d$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $803474bfb07b045d$var$Buffer.alloc = function(size, fill, encoding) {
    return $803474bfb07b045d$var$alloc(size, fill, encoding);
};
function $803474bfb07b045d$var$allocUnsafe(size) {
    $803474bfb07b045d$var$assertSize(size);
    return $803474bfb07b045d$var$createBuffer(size < 0 ? 0 : $803474bfb07b045d$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $803474bfb07b045d$var$Buffer.allocUnsafe = function(size) {
    return $803474bfb07b045d$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $803474bfb07b045d$var$Buffer.allocUnsafeSlow = function(size) {
    return $803474bfb07b045d$var$allocUnsafe(size);
};
function $803474bfb07b045d$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$803474bfb07b045d$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $803474bfb07b045d$var$byteLength(string, encoding) | 0;
    let buf = $803474bfb07b045d$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $803474bfb07b045d$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $803474bfb07b045d$var$checked(array.length) | 0;
    const buf = $803474bfb07b045d$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $803474bfb07b045d$var$fromArrayView(arrayView) {
    if ($803474bfb07b045d$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $803474bfb07b045d$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $803474bfb07b045d$var$fromArrayLike(arrayView);
}
function $803474bfb07b045d$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $803474bfb07b045d$var$Buffer.prototype);
    return buf;
}
function $803474bfb07b045d$var$fromObject(obj) {
    if ($803474bfb07b045d$var$Buffer.isBuffer(obj)) {
        const len = $803474bfb07b045d$var$checked(obj.length) | 0;
        const buf = $803474bfb07b045d$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $803474bfb07b045d$var$numberIsNaN(obj.length)) return $803474bfb07b045d$var$createBuffer(0);
        return $803474bfb07b045d$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $803474bfb07b045d$var$fromArrayLike(obj.data);
}
function $803474bfb07b045d$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $803474bfb07b045d$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $803474bfb07b045d$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $803474bfb07b045d$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $803474bfb07b045d$var$Buffer.alloc(+length);
}
$803474bfb07b045d$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $803474bfb07b045d$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$803474bfb07b045d$var$Buffer.compare = function compare(a, b) {
    if ($803474bfb07b045d$var$isInstance(a, Uint8Array)) a = $803474bfb07b045d$var$Buffer.from(a, a.offset, a.byteLength);
    if ($803474bfb07b045d$var$isInstance(b, Uint8Array)) b = $803474bfb07b045d$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$803474bfb07b045d$var$Buffer.isBuffer(a) || !$803474bfb07b045d$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$803474bfb07b045d$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$803474bfb07b045d$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $803474bfb07b045d$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $803474bfb07b045d$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($803474bfb07b045d$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$803474bfb07b045d$var$Buffer.isBuffer(buf)) buf = $803474bfb07b045d$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$803474bfb07b045d$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $803474bfb07b045d$var$byteLength(string, encoding) {
    if ($803474bfb07b045d$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $803474bfb07b045d$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $803474bfb07b045d$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $803474bfb07b045d$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $803474bfb07b045d$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$803474bfb07b045d$var$Buffer.byteLength = $803474bfb07b045d$var$byteLength;
function $803474bfb07b045d$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $803474bfb07b045d$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $803474bfb07b045d$var$utf8Slice(this, start, end);
        case 'ascii':
            return $803474bfb07b045d$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $803474bfb07b045d$var$latin1Slice(this, start, end);
        case 'base64':
            return $803474bfb07b045d$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $803474bfb07b045d$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$803474bfb07b045d$var$Buffer.prototype._isBuffer = true;
function $803474bfb07b045d$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$803474bfb07b045d$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$803474bfb07b045d$var$swap(this, i, i + 1);
    return this;
};
$803474bfb07b045d$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $803474bfb07b045d$var$swap(this, i, i + 3);
        $803474bfb07b045d$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$803474bfb07b045d$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $803474bfb07b045d$var$swap(this, i, i + 7);
        $803474bfb07b045d$var$swap(this, i + 1, i + 6);
        $803474bfb07b045d$var$swap(this, i + 2, i + 5);
        $803474bfb07b045d$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$803474bfb07b045d$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $803474bfb07b045d$var$utf8Slice(this, 0, length);
    return $803474bfb07b045d$var$slowToString.apply(this, arguments);
};
$803474bfb07b045d$var$Buffer.prototype.toLocaleString = $803474bfb07b045d$var$Buffer.prototype.toString;
$803474bfb07b045d$var$Buffer.prototype.equals = function equals(b) {
    if (!$803474bfb07b045d$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $803474bfb07b045d$var$Buffer.compare(this, b) === 0;
};
$803474bfb07b045d$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $803474bfb07b045d$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($803474bfb07b045d$var$customInspectSymbol) $803474bfb07b045d$var$Buffer.prototype[$803474bfb07b045d$var$customInspectSymbol] = $803474bfb07b045d$var$Buffer.prototype.inspect;
$803474bfb07b045d$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($803474bfb07b045d$var$isInstance(target, Uint8Array)) target = $803474bfb07b045d$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$803474bfb07b045d$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $803474bfb07b045d$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($803474bfb07b045d$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $803474bfb07b045d$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($803474bfb07b045d$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $803474bfb07b045d$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $803474bfb07b045d$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $803474bfb07b045d$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$803474bfb07b045d$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$803474bfb07b045d$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $803474bfb07b045d$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$803474bfb07b045d$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $803474bfb07b045d$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $803474bfb07b045d$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($803474bfb07b045d$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $803474bfb07b045d$var$utf8Write(buf, string, offset, length) {
    return $803474bfb07b045d$var$blitBuffer($803474bfb07b045d$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $803474bfb07b045d$var$asciiWrite(buf, string, offset, length) {
    return $803474bfb07b045d$var$blitBuffer($803474bfb07b045d$var$asciiToBytes(string), buf, offset, length);
}
function $803474bfb07b045d$var$base64Write(buf, string, offset, length) {
    return $803474bfb07b045d$var$blitBuffer($803474bfb07b045d$var$base64ToBytes(string), buf, offset, length);
}
function $803474bfb07b045d$var$ucs2Write(buf, string, offset, length) {
    return $803474bfb07b045d$var$blitBuffer($803474bfb07b045d$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$803474bfb07b045d$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $803474bfb07b045d$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $803474bfb07b045d$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $803474bfb07b045d$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $803474bfb07b045d$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $803474bfb07b045d$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$803474bfb07b045d$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $803474bfb07b045d$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $e9UD0.fromByteArray(buf);
    else return $e9UD0.fromByteArray(buf.slice(start, end));
}
function $803474bfb07b045d$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $803474bfb07b045d$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $803474bfb07b045d$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $803474bfb07b045d$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $803474bfb07b045d$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $803474bfb07b045d$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $803474bfb07b045d$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $803474bfb07b045d$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $803474bfb07b045d$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $803474bfb07b045d$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $803474bfb07b045d$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$803474bfb07b045d$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $803474bfb07b045d$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $803474bfb07b045d$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$803474bfb07b045d$var$Buffer.prototype.readUintLE = $803474bfb07b045d$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $803474bfb07b045d$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$803474bfb07b045d$var$Buffer.prototype.readUintBE = $803474bfb07b045d$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $803474bfb07b045d$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$803474bfb07b045d$var$Buffer.prototype.readUint8 = $803474bfb07b045d$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $803474bfb07b045d$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$803474bfb07b045d$var$Buffer.prototype.readUint16LE = $803474bfb07b045d$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $803474bfb07b045d$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$803474bfb07b045d$var$Buffer.prototype.readUint16BE = $803474bfb07b045d$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $803474bfb07b045d$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$803474bfb07b045d$var$Buffer.prototype.readUint32LE = $803474bfb07b045d$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $803474bfb07b045d$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$803474bfb07b045d$var$Buffer.prototype.readUint32BE = $803474bfb07b045d$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $803474bfb07b045d$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$803474bfb07b045d$var$Buffer.prototype.readBigUInt64LE = $803474bfb07b045d$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $803474bfb07b045d$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $803474bfb07b045d$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$803474bfb07b045d$var$Buffer.prototype.readBigUInt64BE = $803474bfb07b045d$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $803474bfb07b045d$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $803474bfb07b045d$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$803474bfb07b045d$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $803474bfb07b045d$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$803474bfb07b045d$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $803474bfb07b045d$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$803474bfb07b045d$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $803474bfb07b045d$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$803474bfb07b045d$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $803474bfb07b045d$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$803474bfb07b045d$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $803474bfb07b045d$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$803474bfb07b045d$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $803474bfb07b045d$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$803474bfb07b045d$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $803474bfb07b045d$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$803474bfb07b045d$var$Buffer.prototype.readBigInt64LE = $803474bfb07b045d$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $803474bfb07b045d$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $803474bfb07b045d$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$803474bfb07b045d$var$Buffer.prototype.readBigInt64BE = $803474bfb07b045d$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $803474bfb07b045d$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $803474bfb07b045d$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$803474bfb07b045d$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $803474bfb07b045d$var$checkOffset(offset, 4, this.length);
    return $cqJSK.read(this, offset, true, 23, 4);
};
$803474bfb07b045d$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $803474bfb07b045d$var$checkOffset(offset, 4, this.length);
    return $cqJSK.read(this, offset, false, 23, 4);
};
$803474bfb07b045d$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $803474bfb07b045d$var$checkOffset(offset, 8, this.length);
    return $cqJSK.read(this, offset, true, 52, 8);
};
$803474bfb07b045d$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $803474bfb07b045d$var$checkOffset(offset, 8, this.length);
    return $cqJSK.read(this, offset, false, 52, 8);
};
function $803474bfb07b045d$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$803474bfb07b045d$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$803474bfb07b045d$var$Buffer.prototype.writeUintLE = $803474bfb07b045d$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $803474bfb07b045d$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$803474bfb07b045d$var$Buffer.prototype.writeUintBE = $803474bfb07b045d$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $803474bfb07b045d$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$803474bfb07b045d$var$Buffer.prototype.writeUint8 = $803474bfb07b045d$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $803474bfb07b045d$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$803474bfb07b045d$var$Buffer.prototype.writeUint16LE = $803474bfb07b045d$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $803474bfb07b045d$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$803474bfb07b045d$var$Buffer.prototype.writeUint16BE = $803474bfb07b045d$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $803474bfb07b045d$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$803474bfb07b045d$var$Buffer.prototype.writeUint32LE = $803474bfb07b045d$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $803474bfb07b045d$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$803474bfb07b045d$var$Buffer.prototype.writeUint32BE = $803474bfb07b045d$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $803474bfb07b045d$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $803474bfb07b045d$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $803474bfb07b045d$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $803474bfb07b045d$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $803474bfb07b045d$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$803474bfb07b045d$var$Buffer.prototype.writeBigUInt64LE = $803474bfb07b045d$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $803474bfb07b045d$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$803474bfb07b045d$var$Buffer.prototype.writeBigUInt64BE = $803474bfb07b045d$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $803474bfb07b045d$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$803474bfb07b045d$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $803474bfb07b045d$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$803474bfb07b045d$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $803474bfb07b045d$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$803474bfb07b045d$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $803474bfb07b045d$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$803474bfb07b045d$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $803474bfb07b045d$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$803474bfb07b045d$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $803474bfb07b045d$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$803474bfb07b045d$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $803474bfb07b045d$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$803474bfb07b045d$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $803474bfb07b045d$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$803474bfb07b045d$var$Buffer.prototype.writeBigInt64LE = $803474bfb07b045d$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $803474bfb07b045d$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$803474bfb07b045d$var$Buffer.prototype.writeBigInt64BE = $803474bfb07b045d$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $803474bfb07b045d$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $803474bfb07b045d$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $803474bfb07b045d$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $803474bfb07b045d$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $cqJSK.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$803474bfb07b045d$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $803474bfb07b045d$var$writeFloat(this, value, offset, true, noAssert);
};
$803474bfb07b045d$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $803474bfb07b045d$var$writeFloat(this, value, offset, false, noAssert);
};
function $803474bfb07b045d$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $803474bfb07b045d$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $cqJSK.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$803474bfb07b045d$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $803474bfb07b045d$var$writeDouble(this, value, offset, true, noAssert);
};
$803474bfb07b045d$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $803474bfb07b045d$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$803474bfb07b045d$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$803474bfb07b045d$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$803474bfb07b045d$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$803474bfb07b045d$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $803474bfb07b045d$var$Buffer.isBuffer(val) ? val : $803474bfb07b045d$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $803474bfb07b045d$var$errors = {};
function $803474bfb07b045d$var$E(sym, getMessage, Base) {
    $803474bfb07b045d$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$803474bfb07b045d$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$803474bfb07b045d$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$803474bfb07b045d$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $803474bfb07b045d$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $803474bfb07b045d$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $803474bfb07b045d$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $803474bfb07b045d$var$checkBounds(buf, offset, byteLength) {
    $803474bfb07b045d$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $803474bfb07b045d$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $803474bfb07b045d$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $803474bfb07b045d$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $803474bfb07b045d$var$checkBounds(buf, offset, byteLength);
}
function $803474bfb07b045d$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $803474bfb07b045d$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $803474bfb07b045d$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $803474bfb07b045d$var$validateNumber(value, type);
        throw new $803474bfb07b045d$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $803474bfb07b045d$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $803474bfb07b045d$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $803474bfb07b045d$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $803474bfb07b045d$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($803474bfb07b045d$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $803474bfb07b045d$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $803474bfb07b045d$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $803474bfb07b045d$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $803474bfb07b045d$var$base64ToBytes(str) {
    return $e9UD0.toByteArray($803474bfb07b045d$var$base64clean(str));
}
function $803474bfb07b045d$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $803474bfb07b045d$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $803474bfb07b045d$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $803474bfb07b045d$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $803474bfb07b045d$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $803474bfb07b045d$var$BufferBigIntNotDefined : fn;
}
function $803474bfb07b045d$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("e9UD0", function(module, exports) {
$parcel$export(module.exports, "toByteArray", () => $a4edd51fab2e5618$export$d622b2ad8d90c771, (v) => $a4edd51fab2e5618$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $a4edd51fab2e5618$export$6100ba28696e12de, (v) => $a4edd51fab2e5618$export$6100ba28696e12de = v);
var $a4edd51fab2e5618$export$a48f0734ac7c2329;
var $a4edd51fab2e5618$export$d622b2ad8d90c771;
var $a4edd51fab2e5618$export$6100ba28696e12de;
'use strict';
$a4edd51fab2e5618$export$a48f0734ac7c2329 = $a4edd51fab2e5618$var$byteLength;
$a4edd51fab2e5618$export$d622b2ad8d90c771 = $a4edd51fab2e5618$var$toByteArray;
$a4edd51fab2e5618$export$6100ba28696e12de = $a4edd51fab2e5618$var$fromByteArray;
var $a4edd51fab2e5618$var$lookup = [];
var $a4edd51fab2e5618$var$revLookup = [];
var $a4edd51fab2e5618$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $a4edd51fab2e5618$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $a4edd51fab2e5618$var$i = 0, $a4edd51fab2e5618$var$len = $a4edd51fab2e5618$var$code.length; $a4edd51fab2e5618$var$i < $a4edd51fab2e5618$var$len; ++$a4edd51fab2e5618$var$i){
    $a4edd51fab2e5618$var$lookup[$a4edd51fab2e5618$var$i] = $a4edd51fab2e5618$var$code[$a4edd51fab2e5618$var$i];
    $a4edd51fab2e5618$var$revLookup[$a4edd51fab2e5618$var$code.charCodeAt($a4edd51fab2e5618$var$i)] = $a4edd51fab2e5618$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$a4edd51fab2e5618$var$revLookup['-'.charCodeAt(0)] = 62;
$a4edd51fab2e5618$var$revLookup['_'.charCodeAt(0)] = 63;
function $a4edd51fab2e5618$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $a4edd51fab2e5618$var$byteLength(b64) {
    var lens = $a4edd51fab2e5618$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $a4edd51fab2e5618$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $a4edd51fab2e5618$var$toByteArray(b64) {
    var tmp;
    var lens = $a4edd51fab2e5618$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $a4edd51fab2e5618$var$Arr($a4edd51fab2e5618$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $a4edd51fab2e5618$var$revLookup[b64.charCodeAt(i)] << 18 | $a4edd51fab2e5618$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $a4edd51fab2e5618$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $a4edd51fab2e5618$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $a4edd51fab2e5618$var$revLookup[b64.charCodeAt(i)] << 2 | $a4edd51fab2e5618$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $a4edd51fab2e5618$var$revLookup[b64.charCodeAt(i)] << 10 | $a4edd51fab2e5618$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $a4edd51fab2e5618$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $a4edd51fab2e5618$var$tripletToBase64(num) {
    return $a4edd51fab2e5618$var$lookup[num >> 18 & 0x3F] + $a4edd51fab2e5618$var$lookup[num >> 12 & 0x3F] + $a4edd51fab2e5618$var$lookup[num >> 6 & 0x3F] + $a4edd51fab2e5618$var$lookup[num & 0x3F];
}
function $a4edd51fab2e5618$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($a4edd51fab2e5618$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $a4edd51fab2e5618$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($a4edd51fab2e5618$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($a4edd51fab2e5618$var$lookup[tmp >> 2] + $a4edd51fab2e5618$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($a4edd51fab2e5618$var$lookup[tmp >> 10] + $a4edd51fab2e5618$var$lookup[tmp >> 4 & 0x3F] + $a4edd51fab2e5618$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("cqJSK", function(module, exports) {
$parcel$export(module.exports, "read", () => $90cb80f35a1a44a3$export$aafa59e2e03f2942, (v) => $90cb80f35a1a44a3$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $90cb80f35a1a44a3$export$68d8715fc104d294, (v) => $90cb80f35a1a44a3$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $90cb80f35a1a44a3$export$aafa59e2e03f2942;
var $90cb80f35a1a44a3$export$68d8715fc104d294;
$90cb80f35a1a44a3$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$90cb80f35a1a44a3$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("6ANHb", function(module, exports) {
/*
 * Copyright Joyent, Inc. and other Node contributors.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to permit
 * persons to whom the Software is furnished to do so, subject to the
 * following conditions:
 *
 * The above copyright notice and this permission notice shall be included
 * in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 * OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
 * NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
 * OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
 * USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ 'use strict';

var $lJaLF = parcelRequire("lJaLF");
function Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.host = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.query = null;
    this.pathname = null;
    this.path = null;
    this.href = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
/*
 * define these here so at least they only have to be
 * compiled once on the first module load.
 */ var protocolPattern = /^([a-z0-9.+-]+:)/i, portPattern = /:[0-9]*$/, // Special case for a simple path URL
simplePathPattern = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/, /*
   * RFC 2396: characters reserved for delimiting URLs.
   * We actually just auto-escape these.
   */ delims = [
    '<',
    '>',
    '"',
    '`',
    ' ',
    '\r',
    '\n',
    '\t'
], // RFC 2396: characters not allowed for various reasons.
unwise = [
    '{',
    '}',
    '|',
    '\\',
    '^',
    '`'
].concat(delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
autoEscape = [
    '\''
].concat(unwise), /*
   * Characters that are never ever allowed in a hostname.
   * Note that any invalid chars are also handled, but these
   * are the ones that are *expected* to be seen, so we fast-path
   * them.
   */ nonHostChars = [
    '%',
    '/',
    '?',
    ';',
    '#'
].concat(autoEscape), hostEndingChars = [
    '/',
    '?',
    '#'
], hostnameMaxLen = 255, hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
unsafeProtocol = {
    javascript: true,
    'javascript:': true
}, // protocols that never have a hostname.
hostlessProtocol = {
    javascript: true,
    'javascript:': true
}, // protocols that always contain a // bit.
slashedProtocol = {
    http: true,
    https: true,
    ftp: true,
    gopher: true,
    file: true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
};

var $lfpea = parcelRequire("lfpea");
function urlParse(url, parseQueryString, slashesDenoteHost) {
    if (url && typeof url === 'object' && url instanceof Url) return url;
    var u = new Url();
    u.parse(url, parseQueryString, slashesDenoteHost);
    return u;
}
Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
    if (typeof url !== 'string') throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
    /*
   * Copy chrome, IE, opera backslash-handling behavior.
   * Back slashes before the query string get converted to forward slashes
   * See: https://code.google.com/p/chromium/issues/detail?id=25916
   */ var queryIndex = url.indexOf('?'), splitter = queryIndex !== -1 && queryIndex < url.indexOf('#') ? '?' : '#', uSplit = url.split(splitter), slashRegex = /\\/g;
    uSplit[0] = uSplit[0].replace(slashRegex, '/');
    url = uSplit.join(splitter);
    var rest = url;
    /*
   * trim before proceeding.
   * This is to support parse stuff like "  http://foo.com  \n"
   */ rest = rest.trim();
    if (!slashesDenoteHost && url.split('#').length === 1) {
        // Try fast path regexp
        var simplePath = simplePathPattern.exec(rest);
        if (simplePath) {
            this.path = rest;
            this.href = rest;
            this.pathname = simplePath[1];
            if (simplePath[2]) {
                this.search = simplePath[2];
                if (parseQueryString) this.query = $lfpea.parse(this.search.substr(1));
                else this.query = this.search.substr(1);
            } else if (parseQueryString) {
                this.search = '';
                this.query = {};
            }
            return this;
        }
    }
    var proto = protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto.length);
    }
    /*
   * figure out if it's got a host
   * user@server is *always* interpreted as a hostname, and url
   * resolution will treat //foo/bar as host=foo,path=bar because that's
   * how the browser resolves relative URLs.
   */ if (slashesDenoteHost || proto || rest.match(/^\/\/[^@/]+@[^@/]+/)) {
        var slashes = rest.substr(0, 2) === '//';
        if (slashes && !(proto && hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
        /*
     * there's a hostname.
     * the first instance of /, ?, ;, or # ends the host.
     *
     * If there is an @ in the hostname, then non-host chars *are* allowed
     * to the left of the last @ sign, unless some host-ending character
     * comes *before* the @-sign.
     * URLs are obnoxious.
     *
     * ex:
     * http://a@b@c/ => user:a@b host:c
     * http://a@b?@c => user:a host:c path:/?@c
     */ /*
     * v0.12 TODO(isaacs): This is not quite how Chrome does things.
     * Review our test case against browsers more comprehensively.
     */ // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(var i = 0; i < hostEndingChars.length; i++){
            var hec = rest.indexOf(hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        /*
     * at this point, either we have an explicit point where the
     * auth portion cannot go past, or the last @ char is the decider.
     */ var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf('@');
        else /*
       * atSign must be in auth portion.
       * http://a@b/c@d => host:b auth:a path:/c@d
       */ atSign = rest.lastIndexOf('@', hostEnd);
        /*
     * Now we have a portion which is definitely the auth.
     * Pull that off.
     */ if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = decodeURIComponent(auth);
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(var i = 0; i < nonHostChars.length; i++){
            var hec = rest.indexOf(nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost();
        /*
     * we've indicated that there is a hostname,
     * so even if it's empty, it has to be present.
     */ this.hostname = this.hostname || '';
        /*
     * if hostname begins with [ and ends with ]
     * assume that it's an IPv6 address.
     */ var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(var i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match(hostnamePartPattern)) {
                    var newpart = '';
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) /*
               * we replace non-ASCII char with a temporary placeholder
               * we need this to make sure size of hostname is not
               * broken by replacing non-ASCII by nothing
               */ newpart += 'x';
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match(hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match(hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = '/' + notHost.join('.') + rest;
                        this.hostname = validParts.join('.');
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > hostnameMaxLen) this.hostname = '';
        else // hostnames are always lower case.
        this.hostname = this.hostname.toLowerCase();
        if (!ipv6Hostname) /*
       * IDNA Support: Returns a punycoded representation of "domain".
       * It only converts parts of the domain name that
       * have non-ASCII characters, i.e. it doesn't matter if
       * you call it with a domain that already is ASCII-only.
       */ this.hostname = $lJaLF.toASCII(this.hostname);
        var p = this.port ? ':' + this.port : '';
        var h = this.hostname || '';
        this.host = h + p;
        this.href += this.host;
        /*
     * strip [ and ] from the hostname
     * the host field still retains them, though
     */ if (ipv6Hostname) {
            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
            if (rest[0] !== '/') rest = '/' + rest;
        }
    }
    /*
   * now rest is set to the post-host stuff.
   * chop off any delim chars.
   */ if (!unsafeProtocol[lowerProto]) /*
     * First, make 100% sure that any "autoEscape" chars get
     * escaped, even if encodeURIComponent doesn't think they
     * need to be.
     */ for(var i = 0, l = autoEscape.length; i < l; i++){
        var ae = autoEscape[i];
        if (rest.indexOf(ae) === -1) continue;
        var esc = encodeURIComponent(ae);
        if (esc === ae) esc = escape(ae);
        rest = rest.split(ae).join(esc);
    }
    // chop off from the tail first.
    var hash = rest.indexOf('#');
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf('?');
    if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString) this.query = $lfpea.parse(this.query);
        rest = rest.slice(0, qm);
    } else if (parseQueryString) {
        // no query string, but parseQueryString still requested
        this.search = '';
        this.query = {};
    }
    if (rest) this.pathname = rest;
    if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = '/';
    // to support http.request
    if (this.pathname || this.search) {
        var p = this.pathname || '';
        var s = this.search || '';
        this.path = p + s;
    }
    // finally, reconstruct the href based on what has been validated.
    this.href = this.format();
    return this;
};
// format a parsed object into a url string
function urlFormat(obj) {
    /*
   * ensure it's an object, and not a string url.
   * If it's an obj, this is a no-op.
   * this way, you can call url_format() on strings
   * to clean up potentially wonky urls.
   */ if (typeof obj === 'string') obj = urlParse(obj);
    if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
    return obj.format();
}
Url.prototype.format = function() {
    var auth = this.auth || '';
    if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ':');
        auth += '@';
    }
    var protocol = this.protocol || '', pathname = this.pathname || '', hash = this.hash || '', host = false, query = '';
    if (this.host) host = auth + this.host;
    else if (this.hostname) {
        host = auth + (this.hostname.indexOf(':') === -1 ? this.hostname : '[' + this.hostname + ']');
        if (this.port) host += ':' + this.port;
    }
    if (this.query && typeof this.query === 'object' && Object.keys(this.query).length) query = $lfpea.stringify(this.query, {
        arrayFormat: 'repeat',
        addQueryPrefix: false
    });
    var search = this.search || query && '?' + query || '';
    if (protocol && protocol.substr(-1) !== ':') protocol += ':';
    /*
   * only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
   * unless they had them to begin with.
   */ if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
        host = '//' + (host || '');
        if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
    } else if (!host) host = '';
    if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
    if (search && search.charAt(0) !== '?') search = '?' + search;
    pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
    });
    search = search.replace('#', '%23');
    return protocol + host + pathname + search + hash;
};
function urlResolve(source, relative) {
    return urlParse(source, false, true).resolve(relative);
}
Url.prototype.resolve = function(relative) {
    return this.resolveObject(urlParse(relative, false, true)).format();
};
function urlResolveObject(source, relative) {
    if (!source) return relative;
    return urlParse(source, false, true).resolveObject(relative);
}
Url.prototype.resolveObject = function(relative) {
    if (typeof relative === 'string') {
        var rel = new Url();
        rel.parse(relative, false, true);
        relative = rel;
    }
    var result = new Url();
    var tkeys = Object.keys(this);
    for(var tk = 0; tk < tkeys.length; tk++){
        var tkey = tkeys[tk];
        result[tkey] = this[tkey];
    }
    /*
   * hash is always overridden, no matter what.
   * even href="" will remove it.
   */ result.hash = relative.hash;
    // if the relative url is empty, then there's nothing left to do here.
    if (relative.href === '') {
        result.href = result.format();
        return result;
    }
    // hrefs like //foo/bar always cut to the protocol.
    if (relative.slashes && !relative.protocol) {
        // take everything except the protocol from relative
        var rkeys = Object.keys(relative);
        for(var rk = 0; rk < rkeys.length; rk++){
            var rkey = rkeys[rk];
            if (rkey !== 'protocol') result[rkey] = relative[rkey];
        }
        // urlParse appends trailing / to urls like http://www.example.com
        if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
            result.pathname = '/';
            result.path = result.pathname;
        }
        result.href = result.format();
        return result;
    }
    if (relative.protocol && relative.protocol !== result.protocol) {
        /*
     * if it's a known url protocol, then changing
     * the protocol does weird things
     * first, if it's not file:, then we MUST have a host,
     * and if there was a path
     * to begin with, then we MUST have a path.
     * if it is file:, then the host is dropped,
     * because that's known to be hostless.
     * anything else is assumed to be absolute.
     */ if (!slashedProtocol[relative.protocol]) {
            var keys = Object.keys(relative);
            for(var v = 0; v < keys.length; v++){
                var k = keys[v];
                result[k] = relative[k];
            }
            result.href = result.format();
            return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !hostlessProtocol[relative.protocol]) {
            var relPath = (relative.pathname || '').split('/');
            while(relPath.length && !(relative.host = relPath.shift()));
            if (!relative.host) relative.host = '';
            if (!relative.hostname) relative.hostname = '';
            if (relPath[0] !== '') relPath.unshift('');
            if (relPath.length < 2) relPath.unshift('');
            result.pathname = relPath.join('/');
        } else result.pathname = relative.pathname;
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || '';
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        // to support http.request
        if (result.pathname || result.search) {
            var p = result.pathname || '';
            var s = result.search || '';
            result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
    }
    var isSourceAbs = result.pathname && result.pathname.charAt(0) === '/', isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === '/', mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split('/') || [], relPath = relative.pathname && relative.pathname.split('/') || [], psychotic = result.protocol && !slashedProtocol[result.protocol];
    /*
   * if the url is a non-slashed url, then relative
   * links like ../.. should be able
   * to crawl up to the hostname, as well.  This is strange.
   * result.protocol has already been set by now.
   * Later on, put the first path part into the host field.
   */ if (psychotic) {
        result.hostname = '';
        result.port = null;
        if (result.host) {
            if (srcPath[0] === '') srcPath[0] = result.host;
            else srcPath.unshift(result.host);
        }
        result.host = '';
        if (relative.protocol) {
            relative.hostname = null;
            relative.port = null;
            if (relative.host) {
                if (relPath[0] === '') relPath[0] = relative.host;
                else relPath.unshift(relative.host);
            }
            relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
    }
    if (isRelAbs) {
        // it's absolute.
        result.host = relative.host || relative.host === '' ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === '' ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
    // fall through to the dot-handling below.
    } else if (relPath.length) {
        /*
     * it's relative
     * throw away the existing file, and take the new path instead.
     */ if (!srcPath) srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
    } else if (relative.search != null) {
        /*
     * just pull out the search.
     * like href='?foo'.
     * Put this after the other two cases because it simplifies the booleans
     */ if (psychotic) {
            result.host = srcPath.shift();
            result.hostname = result.host;
            /*
       * occationaly the auth can get stuck only in host
       * this especially happens in cases like
       * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
       */ var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
            if (authInHost) {
                result.auth = authInHost.shift();
                result.hostname = authInHost.shift();
                result.host = result.hostname;
            }
        }
        result.search = relative.search;
        result.query = relative.query;
        // to support http.request
        if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
        result.href = result.format();
        return result;
    }
    if (!srcPath.length) {
        /*
     * no path at all.  easy.
     * we've already handled the other stuff above.
     */ result.pathname = null;
        // to support http.request
        if (result.search) result.path = '/' + result.search;
        else result.path = null;
        result.href = result.format();
        return result;
    }
    /*
   * if a url ENDs in . or .., then it must get a trailing slash.
   * however, if it ends in anything else non-slashy,
   * then it must NOT get a trailing slash.
   */ var last = srcPath.slice(-1)[0];
    var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === '.' || last === '..') || last === '';
    /*
   * strip single dots, resolve double dots to parent dir
   * if the path tries to go above the root, `up` ends up > 0
   */ var up = 0;
    for(var i = srcPath.length; i >= 0; i--){
        last = srcPath[i];
        if (last === '.') srcPath.splice(i, 1);
        else if (last === '..') {
            srcPath.splice(i, 1);
            up++;
        } else if (up) {
            srcPath.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift('..');
    if (mustEndAbs && srcPath[0] !== '' && (!srcPath[0] || srcPath[0].charAt(0) !== '/')) srcPath.unshift('');
    if (hasTrailingSlash && srcPath.join('/').substr(-1) !== '/') srcPath.push('');
    var isAbsolute = srcPath[0] === '' || srcPath[0] && srcPath[0].charAt(0) === '/';
    // put the host back
    if (psychotic) {
        result.hostname = isAbsolute ? '' : srcPath.length ? srcPath.shift() : '';
        result.host = result.hostname;
        /*
     * occationaly the auth can get stuck only in host
     * this especially happens in cases like
     * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
     */ var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
        if (authInHost) {
            result.auth = authInHost.shift();
            result.hostname = authInHost.shift();
            result.host = result.hostname;
        }
    }
    mustEndAbs = mustEndAbs || result.host && srcPath.length;
    if (mustEndAbs && !isAbsolute) srcPath.unshift('');
    if (srcPath.length > 0) result.pathname = srcPath.join('/');
    else {
        result.pathname = null;
        result.path = null;
    }
    // to support request.http
    if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
    result.auth = relative.auth || result.auth;
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
};
Url.prototype.parseHost = function() {
    var host = this.host;
    var port = portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ':') this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;
exports.Url = Url;

});
parcelRegister("lJaLF", function(module, exports) {
(function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof $parcel$global == 'object' && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = '-', /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        'overflow': 'Overflow: input needs wider integers to process',
        'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
        'invalid-input': 'Invalid input'
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw new RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split('@');
        var result = '';
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + '@';
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, '\x2E');
        var labels = string.split('.');
        var encoded = map(labels, fn).join('.');
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = '';
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join('');
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error('not-basic');
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error('invalid-input');
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error('overflow');
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error('overflow');
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error('overflow');
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error('overflow');
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error('overflow');
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join('');
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? 'xn--' + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ 'version': '1.4.1',
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ 'ucs2': {
            'decode': ucs2decode,
            'encode': ucs2encode
        },
        'decode': decode,
        'encode': encode,
        'toASCII': toASCII,
        'toUnicode': toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) define('punycode', function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) // in Node.js, io.js, or RingoJS v0.8.0+
        freeModule.exports = punycode;
        else // in Narwhal or RingoJS v0.7.0-
        for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else // in Rhino or a web browser
    root.punycode = punycode;
})(this);

});

parcelRegister("lfpea", function(module, exports) {
'use strict';

var $4bSzc = parcelRequire("4bSzc");

var $bO86R = parcelRequire("bO86R");

var $gyqRl = parcelRequire("gyqRl");
module.exports = {
    formats: $gyqRl,
    parse: $bO86R,
    stringify: $4bSzc
};

});
parcelRegister("4bSzc", function(module, exports) {
'use strict';

var $cpPlJ = parcelRequire("cpPlJ");

var $abKVc = parcelRequire("abKVc");

var $gyqRl = parcelRequire("gyqRl");
var $30d2844d04a41a5b$var$has = Object.prototype.hasOwnProperty;
var $30d2844d04a41a5b$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $30d2844d04a41a5b$var$isArray = Array.isArray;
var $30d2844d04a41a5b$var$push = Array.prototype.push;
var $30d2844d04a41a5b$var$pushToArray = function(arr, valueOrArray) {
    $30d2844d04a41a5b$var$push.apply(arr, $30d2844d04a41a5b$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $30d2844d04a41a5b$var$toISO = Date.prototype.toISOString;
var $30d2844d04a41a5b$var$defaultFormat = $gyqRl.default;
var $30d2844d04a41a5b$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    commaRoundTrip: false,
    delimiter: '&',
    encode: true,
    encodeDotInKeys: false,
    encoder: $abKVc.encode,
    encodeValuesOnly: false,
    filter: void 0,
    format: $30d2844d04a41a5b$var$defaultFormat,
    formatter: $gyqRl.formatters[$30d2844d04a41a5b$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $30d2844d04a41a5b$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $30d2844d04a41a5b$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean' || typeof v === 'symbol' || typeof v === 'bigint';
};
var $30d2844d04a41a5b$var$sentinel = {};
var $30d2844d04a41a5b$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($30d2844d04a41a5b$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) throw new RangeError('Cyclic object value');
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($30d2844d04a41a5b$var$sentinel) === 'undefined') step = 0;
    }
    if (typeof filter === 'function') obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === 'comma' && $30d2844d04a41a5b$var$isArray(obj)) obj = $abKVc.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $30d2844d04a41a5b$var$defaults.encoder, charset, 'key', format) : prefix;
        obj = '';
    }
    if ($30d2844d04a41a5b$var$isNonNullishPrimitive(obj) || $abKVc.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $30d2844d04a41a5b$var$defaults.encoder, charset, 'key', format);
            return [
                formatter(keyValue) + '=' + formatter(encoder(obj, $30d2844d04a41a5b$var$defaults.encoder, charset, 'value', format))
            ];
        }
        return [
            formatter(prefix) + '=' + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === 'undefined') return values;
    var objKeys;
    if (generateArrayPrefix === 'comma' && $30d2844d04a41a5b$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $abKVc.maybeMap(obj, encoder);
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(',') || null : void 0
            }
        ];
    } else if ($30d2844d04a41a5b$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var encodedPrefix = encodeDotInKeys ? String(prefix).replace(/\./g, '%2E') : String(prefix);
    var adjustedPrefix = commaRoundTrip && $30d2844d04a41a5b$var$isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;
    if (allowEmptyArrays && $30d2844d04a41a5b$var$isArray(obj) && obj.length === 0) return adjustedPrefix + '[]';
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === 'object' && key && typeof key.value !== 'undefined' ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var encodedKey = allowDots && encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
        var keyPrefix = $30d2844d04a41a5b$var$isArray(obj) ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');
        sideChannel.set(object, step);
        var valueSideChannel = $cpPlJ();
        valueSideChannel.set($30d2844d04a41a5b$var$sentinel, sideChannel);
        $30d2844d04a41a5b$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, generateArrayPrefix === 'comma' && encodeValuesOnly && $30d2844d04a41a5b$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $30d2844d04a41a5b$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $30d2844d04a41a5b$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') throw new TypeError('Encoder has to be a function.');
    var charset = opts.charset || $30d2844d04a41a5b$var$defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    var format = $gyqRl.default;
    if (typeof opts.format !== 'undefined') {
        if (!$30d2844d04a41a5b$var$has.call($gyqRl.formatters, opts.format)) throw new TypeError('Unknown format option provided.');
        format = opts.format;
    }
    var formatter = $gyqRl.formatters[format];
    var filter = $30d2844d04a41a5b$var$defaults.filter;
    if (typeof opts.filter === 'function' || $30d2844d04a41a5b$var$isArray(opts.filter)) filter = opts.filter;
    var arrayFormat;
    if (opts.arrayFormat in $30d2844d04a41a5b$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if ('indices' in opts) arrayFormat = opts.indices ? 'indices' : 'repeat';
    else arrayFormat = $30d2844d04a41a5b$var$defaults.arrayFormat;
    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : $30d2844d04a41a5b$var$defaults.allowDots : !!opts.allowDots;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : $30d2844d04a41a5b$var$defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $30d2844d04a41a5b$var$defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $30d2844d04a41a5b$var$defaults.charsetSentinel,
        commaRoundTrip: !!opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? $30d2844d04a41a5b$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : $30d2844d04a41a5b$var$defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : $30d2844d04a41a5b$var$defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : $30d2844d04a41a5b$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : $30d2844d04a41a5b$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : $30d2844d04a41a5b$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : $30d2844d04a41a5b$var$defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $30d2844d04a41a5b$var$defaults.strictNullHandling
    };
};
module.exports = function(object, opts) {
    var obj = object;
    var options = $30d2844d04a41a5b$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if ($30d2844d04a41a5b$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== 'object' || obj === null) return '';
    var generateArrayPrefix = $30d2844d04a41a5b$var$arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $cpPlJ();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        var value = obj[key];
        if (options.skipNulls && value === null) continue;
        $30d2844d04a41a5b$var$pushToArray(keys, $30d2844d04a41a5b$var$stringify(value, key, generateArrayPrefix, commaRoundTrip, options.allowEmptyArrays, options.strictNullHandling, options.skipNulls, options.encodeDotInKeys, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';
    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += 'utf8=%26%2310003%3B&';
        else // encodeURIComponent('✓')
        prefix += 'utf8=%E2%9C%93&';
    }
    return joined.length > 0 ? prefix + joined : '';
};

});
parcelRegister("cpPlJ", function(module, exports) {
'use strict';

var $lERDT = parcelRequire("lERDT");

var $ketYk = parcelRequire("ketYk");

var $f2hBX = parcelRequire("f2hBX");

var $fZWd6 = parcelRequire("fZWd6");

var $cLdOG = parcelRequire("cLdOG");
var $909fa6c4734402e7$var$makeChannel = $cLdOG || $fZWd6 || $f2hBX;
/** @type {import('.')} */ module.exports = function getSideChannel() {
    /** @typedef {ReturnType<typeof getSideChannel>} Channel */ /** @type {Channel | undefined} */ var $channelData;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $lERDT('Side channel does not contain ' + $ketYk(key));
        },
        'delete': function(key) {
            return !!$channelData && $channelData['delete'](key);
        },
        get: function(key) {
            return $channelData && $channelData.get(key);
        },
        has: function(key) {
            return !!$channelData && $channelData.has(key);
        },
        set: function(key, value) {
            if (!$channelData) $channelData = $909fa6c4734402e7$var$makeChannel();
            $channelData.set(key, value);
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
};

});
parcelRegister("lERDT", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("ketYk", function(module, exports) {
var $ebac5d45e9fd305a$var$hasMap = typeof Map === 'function' && Map.prototype;
var $ebac5d45e9fd305a$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $ebac5d45e9fd305a$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var $ebac5d45e9fd305a$var$mapSize = $ebac5d45e9fd305a$var$hasMap && $ebac5d45e9fd305a$var$mapSizeDescriptor && typeof $ebac5d45e9fd305a$var$mapSizeDescriptor.get === 'function' ? $ebac5d45e9fd305a$var$mapSizeDescriptor.get : null;
var $ebac5d45e9fd305a$var$mapForEach = $ebac5d45e9fd305a$var$hasMap && Map.prototype.forEach;
var $ebac5d45e9fd305a$var$hasSet = typeof Set === 'function' && Set.prototype;
var $ebac5d45e9fd305a$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $ebac5d45e9fd305a$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var $ebac5d45e9fd305a$var$setSize = $ebac5d45e9fd305a$var$hasSet && $ebac5d45e9fd305a$var$setSizeDescriptor && typeof $ebac5d45e9fd305a$var$setSizeDescriptor.get === 'function' ? $ebac5d45e9fd305a$var$setSizeDescriptor.get : null;
var $ebac5d45e9fd305a$var$setForEach = $ebac5d45e9fd305a$var$hasSet && Set.prototype.forEach;
var $ebac5d45e9fd305a$var$hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var $ebac5d45e9fd305a$var$weakMapHas = $ebac5d45e9fd305a$var$hasWeakMap ? WeakMap.prototype.has : null;
var $ebac5d45e9fd305a$var$hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var $ebac5d45e9fd305a$var$weakSetHas = $ebac5d45e9fd305a$var$hasWeakSet ? WeakSet.prototype.has : null;
var $ebac5d45e9fd305a$var$hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var $ebac5d45e9fd305a$var$weakRefDeref = $ebac5d45e9fd305a$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $ebac5d45e9fd305a$var$booleanValueOf = Boolean.prototype.valueOf;
var $ebac5d45e9fd305a$var$objectToString = Object.prototype.toString;
var $ebac5d45e9fd305a$var$functionToString = Function.prototype.toString;
var $ebac5d45e9fd305a$var$$match = String.prototype.match;
var $ebac5d45e9fd305a$var$$slice = String.prototype.slice;
var $ebac5d45e9fd305a$var$$replace = String.prototype.replace;
var $ebac5d45e9fd305a$var$$toUpperCase = String.prototype.toUpperCase;
var $ebac5d45e9fd305a$var$$toLowerCase = String.prototype.toLowerCase;
var $ebac5d45e9fd305a$var$$test = RegExp.prototype.test;
var $ebac5d45e9fd305a$var$$concat = Array.prototype.concat;
var $ebac5d45e9fd305a$var$$join = Array.prototype.join;
var $ebac5d45e9fd305a$var$$arrSlice = Array.prototype.slice;
var $ebac5d45e9fd305a$var$$floor = Math.floor;
var $ebac5d45e9fd305a$var$bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var $ebac5d45e9fd305a$var$gOPS = Object.getOwnPropertySymbols;
var $ebac5d45e9fd305a$var$symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var $ebac5d45e9fd305a$var$hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var $ebac5d45e9fd305a$var$toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === $ebac5d45e9fd305a$var$hasShammedSymbols ? 'object' : 'symbol') ? Symbol.toStringTag : null;
var $ebac5d45e9fd305a$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $ebac5d45e9fd305a$var$gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $ebac5d45e9fd305a$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $ebac5d45e9fd305a$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$ebac5d45e9fd305a$var$$floor(-num) : $ebac5d45e9fd305a$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $ebac5d45e9fd305a$var$$slice.call(str, intStr.length + 1);
            return $ebac5d45e9fd305a$var$$replace.call(intStr, sepRegex, '$&_') + '.' + $ebac5d45e9fd305a$var$$replace.call($ebac5d45e9fd305a$var$$replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $ebac5d45e9fd305a$var$$replace.call(str, sepRegex, '$&_');
}

var $luYXS = parcelRequire("luYXS");
var $ebac5d45e9fd305a$var$inspectCustom = $luYXS.custom;
var $ebac5d45e9fd305a$var$inspectSymbol = $ebac5d45e9fd305a$var$isSymbol($ebac5d45e9fd305a$var$inspectCustom) ? $ebac5d45e9fd305a$var$inspectCustom : null;
var $ebac5d45e9fd305a$var$quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var $ebac5d45e9fd305a$var$quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};
module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($ebac5d45e9fd305a$var$has(opts, 'quoteStyle') && !$ebac5d45e9fd305a$var$has($ebac5d45e9fd305a$var$quotes, opts.quoteStyle)) throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($ebac5d45e9fd305a$var$has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number' ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $ebac5d45e9fd305a$var$has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    if ($ebac5d45e9fd305a$var$has(opts, 'indent') && opts.indent !== null && opts.indent !== '\t' && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($ebac5d45e9fd305a$var$has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === 'undefined') return 'undefined';
    if (obj === null) return 'null';
    if (typeof obj === 'boolean') return obj ? 'true' : 'false';
    if (typeof obj === 'string') return $ebac5d45e9fd305a$var$inspectString(obj, opts);
    if (typeof obj === 'number') {
        if (obj === 0) return Infinity / obj > 0 ? '0' : '-0';
        var str = String(obj);
        return numericSeparator ? $ebac5d45e9fd305a$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? $ebac5d45e9fd305a$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') return $ebac5d45e9fd305a$var$isArray(obj) ? '[Array]' : '[Object]';
    var indent = $ebac5d45e9fd305a$var$getIndent(opts, depth);
    if (typeof seen === 'undefined') seen = [];
    else if ($ebac5d45e9fd305a$var$indexOf(seen, obj) >= 0) return '[Circular]';
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $ebac5d45e9fd305a$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($ebac5d45e9fd305a$var$has(opts, 'quoteStyle')) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === 'function' && !$ebac5d45e9fd305a$var$isRegExp(obj)) {
        var name = $ebac5d45e9fd305a$var$nameOf(obj);
        var keys = $ebac5d45e9fd305a$var$arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $ebac5d45e9fd305a$var$$join.call(keys, ', ') + ' }' : '');
    }
    if ($ebac5d45e9fd305a$var$isSymbol(obj)) {
        var symString = $ebac5d45e9fd305a$var$hasShammedSymbols ? $ebac5d45e9fd305a$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : $ebac5d45e9fd305a$var$symToString.call(obj);
        return typeof obj === 'object' && !$ebac5d45e9fd305a$var$hasShammedSymbols ? $ebac5d45e9fd305a$var$markBoxed(symString) : symString;
    }
    if ($ebac5d45e9fd305a$var$isElement(obj)) {
        var s = '<' + $ebac5d45e9fd305a$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += ' ' + attrs[i].name + '=' + $ebac5d45e9fd305a$var$wrapQuotes($ebac5d45e9fd305a$var$quote(attrs[i].value), 'double', opts);
        s += '>';
        if (obj.childNodes && obj.childNodes.length) s += '...';
        s += '</' + $ebac5d45e9fd305a$var$$toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if ($ebac5d45e9fd305a$var$isArray(obj)) {
        if (obj.length === 0) return '[]';
        var xs = $ebac5d45e9fd305a$var$arrObjKeys(obj, inspect);
        if (indent && !$ebac5d45e9fd305a$var$singleLineValues(xs)) return '[' + $ebac5d45e9fd305a$var$indentedJoin(xs, indent) + ']';
        return '[ ' + $ebac5d45e9fd305a$var$$join.call(xs, ', ') + ' ]';
    }
    if ($ebac5d45e9fd305a$var$isError(obj)) {
        var parts = $ebac5d45e9fd305a$var$arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !$ebac5d45e9fd305a$var$isEnumerable.call(obj, 'cause')) return '{ [' + String(obj) + '] ' + $ebac5d45e9fd305a$var$$join.call($ebac5d45e9fd305a$var$$concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        if (parts.length === 0) return '[' + String(obj) + ']';
        return '{ [' + String(obj) + '] ' + $ebac5d45e9fd305a$var$$join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if ($ebac5d45e9fd305a$var$inspectSymbol && typeof obj[$ebac5d45e9fd305a$var$inspectSymbol] === 'function' && $luYXS) return $luYXS(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') return obj.inspect();
    }
    if ($ebac5d45e9fd305a$var$isMap(obj)) {
        var mapParts = [];
        if ($ebac5d45e9fd305a$var$mapForEach) $ebac5d45e9fd305a$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return $ebac5d45e9fd305a$var$collectionOf('Map', $ebac5d45e9fd305a$var$mapSize.call(obj), mapParts, indent);
    }
    if ($ebac5d45e9fd305a$var$isSet(obj)) {
        var setParts = [];
        if ($ebac5d45e9fd305a$var$setForEach) $ebac5d45e9fd305a$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $ebac5d45e9fd305a$var$collectionOf('Set', $ebac5d45e9fd305a$var$setSize.call(obj), setParts, indent);
    }
    if ($ebac5d45e9fd305a$var$isWeakMap(obj)) return $ebac5d45e9fd305a$var$weakCollectionOf('WeakMap');
    if ($ebac5d45e9fd305a$var$isWeakSet(obj)) return $ebac5d45e9fd305a$var$weakCollectionOf('WeakSet');
    if ($ebac5d45e9fd305a$var$isWeakRef(obj)) return $ebac5d45e9fd305a$var$weakCollectionOf('WeakRef');
    if ($ebac5d45e9fd305a$var$isNumber(obj)) return $ebac5d45e9fd305a$var$markBoxed(inspect(Number(obj)));
    if ($ebac5d45e9fd305a$var$isBigInt(obj)) return $ebac5d45e9fd305a$var$markBoxed(inspect($ebac5d45e9fd305a$var$bigIntValueOf.call(obj)));
    if ($ebac5d45e9fd305a$var$isBoolean(obj)) return $ebac5d45e9fd305a$var$markBoxed($ebac5d45e9fd305a$var$booleanValueOf.call(obj));
    if ($ebac5d45e9fd305a$var$isString(obj)) return $ebac5d45e9fd305a$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== 'undefined' && obj === window) return '{ [object Window] }';
    if (typeof globalThis !== 'undefined' && obj === globalThis || typeof $parcel$global !== 'undefined' && obj === $parcel$global) return '{ [object globalThis] }';
    if (!$ebac5d45e9fd305a$var$isDate(obj) && !$ebac5d45e9fd305a$var$isRegExp(obj)) {
        var ys = $ebac5d45e9fd305a$var$arrObjKeys(obj, inspect);
        var isPlainObject = $ebac5d45e9fd305a$var$gPO ? $ebac5d45e9fd305a$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && $ebac5d45e9fd305a$var$toStringTag && Object(obj) === obj && $ebac5d45e9fd305a$var$toStringTag in obj ? $ebac5d45e9fd305a$var$$slice.call($ebac5d45e9fd305a$var$toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $ebac5d45e9fd305a$var$$join.call($ebac5d45e9fd305a$var$$concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) return tag + '{}';
        if (indent) return tag + '{' + $ebac5d45e9fd305a$var$indentedJoin(ys, indent) + '}';
        return tag + '{ ' + $ebac5d45e9fd305a$var$$join.call(ys, ', ') + ' }';
    }
    return String(obj);
};
function $ebac5d45e9fd305a$var$wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = $ebac5d45e9fd305a$var$quotes[style];
    return quoteChar + s + quoteChar;
}
function $ebac5d45e9fd305a$var$quote(s) {
    return $ebac5d45e9fd305a$var$$replace.call(String(s), /"/g, '&quot;');
}
function $ebac5d45e9fd305a$var$canTrustToString(obj) {
    return !$ebac5d45e9fd305a$var$toStringTag || !(typeof obj === 'object' && ($ebac5d45e9fd305a$var$toStringTag in obj || typeof obj[$ebac5d45e9fd305a$var$toStringTag] !== 'undefined'));
}
function $ebac5d45e9fd305a$var$isArray(obj) {
    return $ebac5d45e9fd305a$var$toStr(obj) === '[object Array]' && $ebac5d45e9fd305a$var$canTrustToString(obj);
}
function $ebac5d45e9fd305a$var$isDate(obj) {
    return $ebac5d45e9fd305a$var$toStr(obj) === '[object Date]' && $ebac5d45e9fd305a$var$canTrustToString(obj);
}
function $ebac5d45e9fd305a$var$isRegExp(obj) {
    return $ebac5d45e9fd305a$var$toStr(obj) === '[object RegExp]' && $ebac5d45e9fd305a$var$canTrustToString(obj);
}
function $ebac5d45e9fd305a$var$isError(obj) {
    return $ebac5d45e9fd305a$var$toStr(obj) === '[object Error]' && $ebac5d45e9fd305a$var$canTrustToString(obj);
}
function $ebac5d45e9fd305a$var$isString(obj) {
    return $ebac5d45e9fd305a$var$toStr(obj) === '[object String]' && $ebac5d45e9fd305a$var$canTrustToString(obj);
}
function $ebac5d45e9fd305a$var$isNumber(obj) {
    return $ebac5d45e9fd305a$var$toStr(obj) === '[object Number]' && $ebac5d45e9fd305a$var$canTrustToString(obj);
}
function $ebac5d45e9fd305a$var$isBoolean(obj) {
    return $ebac5d45e9fd305a$var$toStr(obj) === '[object Boolean]' && $ebac5d45e9fd305a$var$canTrustToString(obj);
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $ebac5d45e9fd305a$var$isSymbol(obj) {
    if ($ebac5d45e9fd305a$var$hasShammedSymbols) return obj && typeof obj === 'object' && obj instanceof Symbol;
    if (typeof obj === 'symbol') return true;
    if (!obj || typeof obj !== 'object' || !$ebac5d45e9fd305a$var$symToString) return false;
    try {
        $ebac5d45e9fd305a$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $ebac5d45e9fd305a$var$isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !$ebac5d45e9fd305a$var$bigIntValueOf) return false;
    try {
        $ebac5d45e9fd305a$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $ebac5d45e9fd305a$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $ebac5d45e9fd305a$var$has(obj, key) {
    return $ebac5d45e9fd305a$var$hasOwn.call(obj, key);
}
function $ebac5d45e9fd305a$var$toStr(obj) {
    return $ebac5d45e9fd305a$var$objectToString.call(obj);
}
function $ebac5d45e9fd305a$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $ebac5d45e9fd305a$var$$match.call($ebac5d45e9fd305a$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $ebac5d45e9fd305a$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $ebac5d45e9fd305a$var$isMap(x) {
    if (!$ebac5d45e9fd305a$var$mapSize || !x || typeof x !== 'object') return false;
    try {
        $ebac5d45e9fd305a$var$mapSize.call(x);
        try {
            $ebac5d45e9fd305a$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $ebac5d45e9fd305a$var$isWeakMap(x) {
    if (!$ebac5d45e9fd305a$var$weakMapHas || !x || typeof x !== 'object') return false;
    try {
        $ebac5d45e9fd305a$var$weakMapHas.call(x, $ebac5d45e9fd305a$var$weakMapHas);
        try {
            $ebac5d45e9fd305a$var$weakSetHas.call(x, $ebac5d45e9fd305a$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $ebac5d45e9fd305a$var$isWeakRef(x) {
    if (!$ebac5d45e9fd305a$var$weakRefDeref || !x || typeof x !== 'object') return false;
    try {
        $ebac5d45e9fd305a$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $ebac5d45e9fd305a$var$isSet(x) {
    if (!$ebac5d45e9fd305a$var$setSize || !x || typeof x !== 'object') return false;
    try {
        $ebac5d45e9fd305a$var$setSize.call(x);
        try {
            $ebac5d45e9fd305a$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $ebac5d45e9fd305a$var$isWeakSet(x) {
    if (!$ebac5d45e9fd305a$var$weakSetHas || !x || typeof x !== 'object') return false;
    try {
        $ebac5d45e9fd305a$var$weakSetHas.call(x, $ebac5d45e9fd305a$var$weakSetHas);
        try {
            $ebac5d45e9fd305a$var$weakMapHas.call(x, $ebac5d45e9fd305a$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $ebac5d45e9fd305a$var$isElement(x) {
    if (!x || typeof x !== 'object') return false;
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) return true;
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}
function $ebac5d45e9fd305a$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return $ebac5d45e9fd305a$var$inspectString($ebac5d45e9fd305a$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = $ebac5d45e9fd305a$var$quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $ebac5d45e9fd305a$var$$replace.call($ebac5d45e9fd305a$var$$replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, $ebac5d45e9fd305a$var$lowbyte);
    return $ebac5d45e9fd305a$var$wrapQuotes(s, 'single', opts);
}
function $ebac5d45e9fd305a$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) return '\\' + x;
    return '\\x' + (n < 0x10 ? '0' : '') + $ebac5d45e9fd305a$var$$toUpperCase.call(n.toString(16));
}
function $ebac5d45e9fd305a$var$markBoxed(str) {
    return 'Object(' + str + ')';
}
function $ebac5d45e9fd305a$var$weakCollectionOf(type) {
    return type + ' { ? }';
}
function $ebac5d45e9fd305a$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $ebac5d45e9fd305a$var$indentedJoin(entries, indent) : $ebac5d45e9fd305a$var$$join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}
function $ebac5d45e9fd305a$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($ebac5d45e9fd305a$var$indexOf(xs[i], '\n') >= 0) return false;
    }
    return true;
}
function $ebac5d45e9fd305a$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') baseIndent = '\t';
    else if (typeof opts.indent === 'number' && opts.indent > 0) baseIndent = $ebac5d45e9fd305a$var$$join.call(Array(opts.indent + 1), ' ');
    else return null;
    return {
        base: baseIndent,
        prev: $ebac5d45e9fd305a$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $ebac5d45e9fd305a$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return '';
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $ebac5d45e9fd305a$var$$join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}
function $ebac5d45e9fd305a$var$arrObjKeys(obj, inspect) {
    var isArr = $ebac5d45e9fd305a$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $ebac5d45e9fd305a$var$has(obj, i) ? inspect(obj[i], obj) : '';
    }
    var syms = typeof $ebac5d45e9fd305a$var$gOPS === 'function' ? $ebac5d45e9fd305a$var$gOPS(obj) : [];
    var symMap;
    if ($ebac5d45e9fd305a$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap['$' + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$ebac5d45e9fd305a$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($ebac5d45e9fd305a$var$hasShammedSymbols && symMap['$' + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($ebac5d45e9fd305a$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        else xs.push(key + ': ' + inspect(obj[key], obj));
    }
    if (typeof $ebac5d45e9fd305a$var$gOPS === 'function') {
        for(var j = 0; j < syms.length; j++)if ($ebac5d45e9fd305a$var$isEnumerable.call(obj, syms[j])) xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
    }
    return xs;
}

});
parcelRegister("luYXS", function(module, exports) {
"use strict";

});


parcelRegister("f2hBX", function(module, exports) {
'use strict';

var $ketYk = parcelRequire("ketYk");

var $lERDT = parcelRequire("lERDT");
/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list.
* By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('./list.d.ts').listGetNode} */ // eslint-disable-next-line consistent-return
var $af24b42570c64888$var$listGetNode = function(list, key, isDelete) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    // eslint-disable-next-line eqeqeq
    for(; (curr = prev.next) != null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        if (!isDelete) {
            // eslint-disable-next-line no-extra-parens
            curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
            list.next = curr; // eslint-disable-line no-param-reassign
        }
        return curr;
    }
};
/** @type {import('./list.d.ts').listGet} */ var $af24b42570c64888$var$listGet = function(objects, key) {
    if (!objects) return void 0;
    var node = $af24b42570c64888$var$listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('./list.d.ts').listSet} */ var $af24b42570c64888$var$listSet = function(objects, key, value) {
    var node = $af24b42570c64888$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('./list.d.ts').listHas} */ var $af24b42570c64888$var$listHas = function(objects, key) {
    if (!objects) return false;
    return !!$af24b42570c64888$var$listGetNode(objects, key);
};
/** @type {import('./list.d.ts').listDelete} */ // eslint-disable-next-line consistent-return
var $af24b42570c64888$var$listDelete = function(objects, key) {
    if (objects) return $af24b42570c64888$var$listGetNode(objects, key, true);
};
/** @type {import('.')} */ module.exports = function getSideChannelList() {
    /** @typedef {ReturnType<typeof getSideChannelList>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {import('./list.d.ts').RootNode<V, K> | undefined} */ var $o;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $lERDT('Side channel does not contain ' + $ketYk(key));
        },
        'delete': function(key) {
            var root = $o && $o.next;
            var deletedNode = $af24b42570c64888$var$listDelete($o, key);
            if (deletedNode && root && root === deletedNode) $o = void 0;
            return !!deletedNode;
        },
        get: function(key) {
            return $af24b42570c64888$var$listGet($o, key);
        },
        has: function(key) {
            return $af24b42570c64888$var$listHas($o, key);
        },
        set: function(key, value) {
            if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
            $o = {
                next: void 0
            };
            // eslint-disable-next-line no-extra-parens
            $af24b42570c64888$var$listSet(/** @type {NonNullable<typeof $o>} */ $o, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
};

});

parcelRegister("fZWd6", function(module, exports) {
'use strict';

var $6veyu = parcelRequire("6veyu");

var $g3lHM = parcelRequire("g3lHM");

var $ketYk = parcelRequire("ketYk");

var $lERDT = parcelRequire("lERDT");
var $ba59b4dc869be67e$var$$Map = $6veyu('%Map%', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => V} */ var $ba59b4dc869be67e$var$$mapGet = $g3lHM('Map.prototype.get', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K, value: V) => void} */ var $ba59b4dc869be67e$var$$mapSet = $g3lHM('Map.prototype.set', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $ba59b4dc869be67e$var$$mapHas = $g3lHM('Map.prototype.has', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $ba59b4dc869be67e$var$$mapDelete = $g3lHM('Map.prototype.delete', true);
/** @type {<K, V>(thisArg: Map<K, V>) => number} */ var $ba59b4dc869be67e$var$$mapSize = $g3lHM('Map.prototype.size', true);
/** @type {import('.')} */ module.exports = !!$ba59b4dc869be67e$var$$Map && /** @type {Exclude<import('.'), false>} */ function getSideChannelMap() {
    /** @typedef {ReturnType<typeof getSideChannelMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {Map<K, V> | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $lERDT('Side channel does not contain ' + $ketYk(key));
        },
        'delete': function(key) {
            if ($m) {
                var result = $ba59b4dc869be67e$var$$mapDelete($m, key);
                if ($ba59b4dc869be67e$var$$mapSize($m) === 0) $m = void 0;
                return result;
            }
            return false;
        },
        get: function(key) {
            if ($m) return $ba59b4dc869be67e$var$$mapGet($m, key);
        },
        has: function(key) {
            if ($m) return $ba59b4dc869be67e$var$$mapHas($m, key);
            return false;
        },
        set: function(key, value) {
            if (!$m) // @ts-expect-error TS can't handle narrowing a variable inside a closure
            $m = new $ba59b4dc869be67e$var$$Map();
            $ba59b4dc869be67e$var$$mapSet($m, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why TS is erroring here
    return channel;
};

});
parcelRegister("6veyu", function(module, exports) {
'use strict';
var $4bc0edba276301f6$var$undefined1;

var $jC3Fm = parcelRequire("jC3Fm");

var $eL28X = parcelRequire("eL28X");

var $FOjNg = parcelRequire("FOjNg");

var $aOfvL = parcelRequire("aOfvL");

var $h0msM = parcelRequire("h0msM");

var $lERDT = parcelRequire("lERDT");

var $6Obuy = parcelRequire("6Obuy");
var $4bc0edba276301f6$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $4bc0edba276301f6$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $4bc0edba276301f6$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};
var $4bc0edba276301f6$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($4bc0edba276301f6$var$$gOPD) try {
    $4bc0edba276301f6$var$$gOPD({}, '');
} catch (e) {
    $4bc0edba276301f6$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $4bc0edba276301f6$var$throwTypeError = function() {
    throw new $lERDT();
};
var $4bc0edba276301f6$var$ThrowTypeError = $4bc0edba276301f6$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $4bc0edba276301f6$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $4bc0edba276301f6$var$$gOPD(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $4bc0edba276301f6$var$throwTypeError;
        }
    }
}() : $4bc0edba276301f6$var$throwTypeError;

var $4bc0edba276301f6$var$hasSymbols = (parcelRequire("iO7RV"))();

var $4bc0edba276301f6$var$hasProto = (parcelRequire("lMY3D"))();
var $4bc0edba276301f6$var$getProto = Object.getPrototypeOf || ($4bc0edba276301f6$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $4bc0edba276301f6$var$needsEval = {};
var $4bc0edba276301f6$var$TypedArray = typeof Uint8Array === 'undefined' || !$4bc0edba276301f6$var$getProto ? undefined : $4bc0edba276301f6$var$getProto(Uint8Array);
var $4bc0edba276301f6$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $4bc0edba276301f6$var$hasSymbols && $4bc0edba276301f6$var$getProto ? $4bc0edba276301f6$var$getProto([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $4bc0edba276301f6$var$needsEval,
    '%AsyncGenerator%': $4bc0edba276301f6$var$needsEval,
    '%AsyncGeneratorFunction%': $4bc0edba276301f6$var$needsEval,
    '%AsyncIteratorPrototype%': $4bc0edba276301f6$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $jC3Fm,
    '%eval%': eval,
    '%EvalError%': $eL28X,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $4bc0edba276301f6$var$$Function,
    '%GeneratorFunction%': $4bc0edba276301f6$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $4bc0edba276301f6$var$hasSymbols && $4bc0edba276301f6$var$getProto ? $4bc0edba276301f6$var$getProto($4bc0edba276301f6$var$getProto([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$4bc0edba276301f6$var$hasSymbols || !$4bc0edba276301f6$var$getProto ? undefined : $4bc0edba276301f6$var$getProto(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': Object,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $FOjNg,
    '%ReferenceError%': $aOfvL,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$4bc0edba276301f6$var$hasSymbols || !$4bc0edba276301f6$var$getProto ? undefined : $4bc0edba276301f6$var$getProto(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $4bc0edba276301f6$var$hasSymbols && $4bc0edba276301f6$var$getProto ? $4bc0edba276301f6$var$getProto(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $4bc0edba276301f6$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $h0msM,
    '%ThrowTypeError%': $4bc0edba276301f6$var$ThrowTypeError,
    '%TypedArray%': $4bc0edba276301f6$var$TypedArray,
    '%TypeError%': $lERDT,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $6Obuy,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};
if ($4bc0edba276301f6$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $4bc0edba276301f6$var$errorProto = $4bc0edba276301f6$var$getProto($4bc0edba276301f6$var$getProto(e));
    $4bc0edba276301f6$var$INTRINSICS['%Error.prototype%'] = $4bc0edba276301f6$var$errorProto;
}
var $4bc0edba276301f6$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $4bc0edba276301f6$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $4bc0edba276301f6$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $4bc0edba276301f6$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $4bc0edba276301f6$var$getProto) value = $4bc0edba276301f6$var$getProto(gen.prototype);
    }
    $4bc0edba276301f6$var$INTRINSICS[name] = value;
    return value;
};
var $4bc0edba276301f6$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $9H3MS = parcelRequire("9H3MS");

var $6NEhK = parcelRequire("6NEhK");
var $4bc0edba276301f6$var$$concat = $9H3MS.call(Function.call, Array.prototype.concat);
var $4bc0edba276301f6$var$$spliceApply = $9H3MS.call(Function.apply, Array.prototype.splice);
var $4bc0edba276301f6$var$$replace = $9H3MS.call(Function.call, String.prototype.replace);
var $4bc0edba276301f6$var$$strSlice = $9H3MS.call(Function.call, String.prototype.slice);
var $4bc0edba276301f6$var$$exec = $9H3MS.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $4bc0edba276301f6$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $4bc0edba276301f6$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $4bc0edba276301f6$var$stringToPath = function stringToPath(string) {
    var first = $4bc0edba276301f6$var$$strSlice(string, 0, 1);
    var last = $4bc0edba276301f6$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $h0msM('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $h0msM('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $4bc0edba276301f6$var$$replace(string, $4bc0edba276301f6$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $4bc0edba276301f6$var$$replace(subString, $4bc0edba276301f6$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $4bc0edba276301f6$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($6NEhK($4bc0edba276301f6$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $4bc0edba276301f6$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($6NEhK($4bc0edba276301f6$var$INTRINSICS, intrinsicName)) {
        var value = $4bc0edba276301f6$var$INTRINSICS[intrinsicName];
        if (value === $4bc0edba276301f6$var$needsEval) value = $4bc0edba276301f6$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $lERDT('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $h0msM('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $lERDT('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $lERDT('"allowMissing" argument must be a boolean');
    if ($4bc0edba276301f6$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $h0msM('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $4bc0edba276301f6$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $4bc0edba276301f6$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $4bc0edba276301f6$var$$spliceApply(parts, $4bc0edba276301f6$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $4bc0edba276301f6$var$$strSlice(part, 0, 1);
        var last = $4bc0edba276301f6$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $h0msM('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($6NEhK($4bc0edba276301f6$var$INTRINSICS, intrinsicRealName)) value = $4bc0edba276301f6$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $lERDT('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($4bc0edba276301f6$var$$gOPD && i + 1 >= parts.length) {
                var desc = $4bc0edba276301f6$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $6NEhK(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $4bc0edba276301f6$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("jC3Fm", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("eL28X", function(module, exports) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("FOjNg", function(module, exports) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("aOfvL", function(module, exports) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("h0msM", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("6Obuy", function(module, exports) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("iO7RV", function(module, exports) {
'use strict';
var $db130013c75e8567$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $lhzCW = parcelRequire("lhzCW");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $db130013c75e8567$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $db130013c75e8567$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $lhzCW();
};

});
parcelRegister("lhzCW", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("lMY3D", function(module, exports) {
'use strict';
var $fdccaae2f395da75$var$test = {
    __proto__: null,
    foo: {}
};
// @ts-expect-error: TS errors on an inherited property for some reason
var $fdccaae2f395da75$var$result = {
    __proto__: $fdccaae2f395da75$var$test
}.foo === $fdccaae2f395da75$var$test.foo && !($fdccaae2f395da75$var$test instanceof Object);
/** @type {import('.')} */ module.exports = function hasProto() {
    return $fdccaae2f395da75$var$result;
};

});

parcelRegister("9H3MS", function(module, exports) {
'use strict';

var $cLxwc = parcelRequire("cLxwc");
module.exports = Function.prototype.bind || $cLxwc;

});
parcelRegister("cLxwc", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $94b3dfdbf8115895$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $94b3dfdbf8115895$var$toStr = Object.prototype.toString;
var $94b3dfdbf8115895$var$max = Math.max;
var $94b3dfdbf8115895$var$funcType = '[object Function]';
var $94b3dfdbf8115895$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $94b3dfdbf8115895$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $94b3dfdbf8115895$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $94b3dfdbf8115895$var$toStr.apply(target) !== $94b3dfdbf8115895$var$funcType) throw new TypeError($94b3dfdbf8115895$var$ERROR_MESSAGE + target);
    var args = $94b3dfdbf8115895$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $94b3dfdbf8115895$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $94b3dfdbf8115895$var$concatty(args, arguments));
    };
    var boundLength = $94b3dfdbf8115895$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $94b3dfdbf8115895$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("6NEhK", function(module, exports) {
'use strict';
var $4f36917e8acbb4ac$var$call = Function.prototype.call;
var $4f36917e8acbb4ac$var$$hasOwn = Object.prototype.hasOwnProperty;

var $9H3MS = parcelRequire("9H3MS");
/** @type {import('.')} */ module.exports = $9H3MS.call($4f36917e8acbb4ac$var$call, $4f36917e8acbb4ac$var$$hasOwn);

});


parcelRegister("g3lHM", function(module, exports) {
'use strict';

var $6veyu = parcelRequire("6veyu");

var $7B814 = parcelRequire("7B814");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $bafdc35caf87828c$var$$indexOf = $7B814([
    $6veyu('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $6veyu(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $bafdc35caf87828c$var$$indexOf(name, '.prototype.') > -1) return $7B814(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};

});
parcelRegister("7B814", function(module, exports) {
'use strict';

var $9H3MS = parcelRequire("9H3MS");

var $lERDT = parcelRequire("lERDT");

var $fWXTo = parcelRequire("fWXTo");

var $ju0jq = parcelRequire("ju0jq");
/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $lERDT('a function is required');
    return $ju0jq($9H3MS, $fWXTo, args);
};

});
parcelRegister("fWXTo", function(module, exports) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("ju0jq", function(module, exports) {
'use strict';

var $9H3MS = parcelRequire("9H3MS");

var $4pZHe = parcelRequire("4pZHe");

var $fWXTo = parcelRequire("fWXTo");

var $cIZ3K = parcelRequire("cIZ3K");
/** @type {import('./actualApply')} */ module.exports = $cIZ3K || $9H3MS.call($fWXTo, $4pZHe);

});
parcelRegister("4pZHe", function(module, exports) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("cIZ3K", function(module, exports) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

});





parcelRegister("cLdOG", function(module, exports) {
'use strict';

var $6veyu = parcelRequire("6veyu");

var $g3lHM = parcelRequire("g3lHM");

var $ketYk = parcelRequire("ketYk");

var $fZWd6 = parcelRequire("fZWd6");

var $lERDT = parcelRequire("lERDT");
var $94a497784ad47f77$var$$WeakMap = $6veyu('%WeakMap%', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => V} */ var $94a497784ad47f77$var$$weakMapGet = $g3lHM('WeakMap.prototype.get', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K, value: V) => void} */ var $94a497784ad47f77$var$$weakMapSet = $g3lHM('WeakMap.prototype.set', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $94a497784ad47f77$var$$weakMapHas = $g3lHM('WeakMap.prototype.has', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $94a497784ad47f77$var$$weakMapDelete = $g3lHM('WeakMap.prototype.delete', true);
/** @type {import('.')} */ module.exports = $94a497784ad47f77$var$$WeakMap ? /** @type {Exclude<import('.'), false>} */ function getSideChannelWeakMap() {
    /** @typedef {ReturnType<typeof getSideChannelWeakMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {WeakMap<K & object, V> | undefined} */ var $wm;
    /** @type {Channel | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $lERDT('Side channel does not contain ' + $ketYk(key));
        },
        'delete': function(key) {
            if ($94a497784ad47f77$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $94a497784ad47f77$var$$weakMapDelete($wm, key);
            } else if ($fZWd6) {
                if ($m) return $m['delete'](key);
            }
            return false;
        },
        get: function(key) {
            if ($94a497784ad47f77$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $94a497784ad47f77$var$$weakMapGet($wm, key);
            }
            return $m && $m.get(key);
        },
        has: function(key) {
            if ($94a497784ad47f77$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $94a497784ad47f77$var$$weakMapHas($wm, key);
            }
            return !!$m && $m.has(key);
        },
        set: function(key, value) {
            if ($94a497784ad47f77$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if (!$wm) $wm = new $94a497784ad47f77$var$$WeakMap();
                $94a497784ad47f77$var$$weakMapSet($wm, key, value);
            } else if ($fZWd6) {
                if (!$m) $m = $fZWd6();
                // eslint-disable-next-line no-extra-parens
                /** @type {NonNullable<typeof $m>} */ $m.set(key, value);
            }
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
} : $fZWd6;

});


parcelRegister("abKVc", function(module, exports) {
'use strict';

var $gyqRl = parcelRequire("gyqRl");
var $76af5420d59caef7$var$has = Object.prototype.hasOwnProperty;
var $76af5420d59caef7$var$isArray = Array.isArray;
var $76af5420d59caef7$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    return array;
}();
var $76af5420d59caef7$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($76af5420d59caef7$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== 'undefined') compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $76af5420d59caef7$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? {
        __proto__: null
    } : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== 'undefined') obj[i] = source[i];
    return obj;
};
var $76af5420d59caef7$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== 'object' && typeof source !== 'function') {
        if ($76af5420d59caef7$var$isArray(target)) target.push(source);
        else if (target && typeof target === 'object') {
            if (options && (options.plainObjects || options.allowPrototypes) || !$76af5420d59caef7$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== 'object') return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($76af5420d59caef7$var$isArray(target) && !$76af5420d59caef7$var$isArray(source)) mergeTarget = $76af5420d59caef7$var$arrayToObject(target, options);
    if ($76af5420d59caef7$var$isArray(target) && $76af5420d59caef7$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($76af5420d59caef7$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($76af5420d59caef7$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $76af5420d59caef7$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $76af5420d59caef7$var$decode = function(str, defaultDecoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $76af5420d59caef7$var$limit = 1024;
/* eslint operator-linebreak: [2, "before"] */ var $76af5420d59caef7$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === 'symbol') string = Symbol.prototype.toString.call(str);
    else if (typeof str !== 'string') string = String(str);
    if (charset === 'iso-8859-1') return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
    });
    var out = '';
    for(var j = 0; j < string.length; j += $76af5420d59caef7$var$limit){
        var segment = string.length >= $76af5420d59caef7$var$limit ? string.slice(j, j + $76af5420d59caef7$var$limit) : string;
        var arr = [];
        for(var i = 0; i < segment.length; ++i){
            var c = segment.charCodeAt(i);
            if (c === 0x2D // -
             || c === 0x2E // .
             || c === 0x5F // _
             || c === 0x7E // ~
             || c >= 0x30 && c <= 0x39 // 0-9
             || c >= 0x41 && c <= 0x5A // a-z
             || c >= 0x61 && c <= 0x7A // A-Z
             || format === $gyqRl.RFC1738 && (c === 0x28 || c === 0x29) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }
            if (c < 0x80) {
                arr[arr.length] = $76af5420d59caef7$var$hexTable[c];
                continue;
            }
            if (c < 0x800) {
                arr[arr.length] = $76af5420d59caef7$var$hexTable[0xC0 | c >> 6] + $76af5420d59caef7$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = $76af5420d59caef7$var$hexTable[0xE0 | c >> 12] + $76af5420d59caef7$var$hexTable[0x80 | c >> 6 & 0x3F] + $76af5420d59caef7$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            i += 1;
            c = 0x10000 + ((c & 0x3FF) << 10 | segment.charCodeAt(i) & 0x3FF);
            arr[arr.length] = $76af5420d59caef7$var$hexTable[0xF0 | c >> 18] + $76af5420d59caef7$var$hexTable[0x80 | c >> 12 & 0x3F] + $76af5420d59caef7$var$hexTable[0x80 | c >> 6 & 0x3F] + $76af5420d59caef7$var$hexTable[0x80 | c & 0x3F];
        }
        out += arr.join('');
    }
    return out;
};
var $76af5420d59caef7$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: 'o'
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $76af5420d59caef7$var$compactQueue(queue);
    return value;
};
var $76af5420d59caef7$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};
var $76af5420d59caef7$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $76af5420d59caef7$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
var $76af5420d59caef7$var$maybeMap = function maybeMap(val, fn) {
    if ($76af5420d59caef7$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
module.exports = {
    arrayToObject: $76af5420d59caef7$var$arrayToObject,
    assign: $76af5420d59caef7$var$assign,
    combine: $76af5420d59caef7$var$combine,
    compact: $76af5420d59caef7$var$compact,
    decode: $76af5420d59caef7$var$decode,
    encode: $76af5420d59caef7$var$encode,
    isBuffer: $76af5420d59caef7$var$isBuffer,
    isRegExp: $76af5420d59caef7$var$isRegExp,
    maybeMap: $76af5420d59caef7$var$maybeMap,
    merge: $76af5420d59caef7$var$merge
};

});
parcelRegister("gyqRl", function(module, exports) {
'use strict';
var $c0d4a80a298d5833$var$replace = String.prototype.replace;
var $c0d4a80a298d5833$var$percentTwenties = /%20/g;
var $c0d4a80a298d5833$var$Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};
module.exports = {
    'default': $c0d4a80a298d5833$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $c0d4a80a298d5833$var$replace.call(value, $c0d4a80a298d5833$var$percentTwenties, '+');
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $c0d4a80a298d5833$var$Format.RFC1738,
    RFC3986: $c0d4a80a298d5833$var$Format.RFC3986
};

});



parcelRegister("bO86R", function(module, exports) {
'use strict';

var $abKVc = parcelRequire("abKVc");
var $898aa7a6aab4e394$var$has = Object.prototype.hasOwnProperty;
var $898aa7a6aab4e394$var$isArray = Array.isArray;
var $898aa7a6aab4e394$var$defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: $abKVc.decode,
    delimiter: '&',
    depth: 5,
    duplicates: 'combine',
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictNullHandling: false,
    throwOnLimitExceeded: false
};
var $898aa7a6aab4e394$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $898aa7a6aab4e394$var$parseArrayValue = function(val, options, currentArrayLength) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) return val.split(',');
    if (options.throwOnLimitExceeded && currentArrayLength >= options.arrayLimit) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $898aa7a6aab4e394$var$isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $898aa7a6aab4e394$var$charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')
var $898aa7a6aab4e394$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, options.throwOnLimitExceeded ? limit + 1 : limit);
    if (options.throwOnLimitExceeded && parts.length > limit) throw new RangeError('Parameter limit exceeded. Only ' + limit + ' parameter' + (limit === 1 ? '' : 's') + ' allowed.');
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf('utf8=') === 0) {
            if (parts[i] === $898aa7a6aab4e394$var$charsetSentinel) charset = 'utf-8';
            else if (parts[i] === $898aa7a6aab4e394$var$isoSentinel) charset = 'iso-8859-1';
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
        var key;
        var val;
        if (pos === -1) {
            key = options.decoder(part, $898aa7a6aab4e394$var$defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), $898aa7a6aab4e394$var$defaults.decoder, charset, 'key');
            val = $abKVc.maybeMap($898aa7a6aab4e394$var$parseArrayValue(part.slice(pos + 1), options, $898aa7a6aab4e394$var$isArray(obj[key]) ? obj[key].length : 0), function(encodedVal) {
                return options.decoder(encodedVal, $898aa7a6aab4e394$var$defaults.decoder, charset, 'value');
            });
        }
        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') val = $898aa7a6aab4e394$var$interpretNumericEntities(String(val));
        if (part.indexOf('[]=') > -1) val = $898aa7a6aab4e394$var$isArray(val) ? [
            val
        ] : val;
        var existing = $898aa7a6aab4e394$var$has.call(obj, key);
        if (existing && options.duplicates === 'combine') obj[key] = $abKVc.combine(obj[key], val);
        else if (!existing || options.duplicates === 'last') obj[key] = val;
    }
    return obj;
};
var $898aa7a6aab4e394$var$parseObject = function(chain, val, options, valuesParsed) {
    var currentArrayLength = 0;
    if (chain.length > 0 && chain[chain.length - 1] === '[]') {
        var parentKey = chain.slice(0, -1).join('');
        currentArrayLength = Array.isArray(val) && val[parentKey] ? val[parentKey].length : 0;
    }
    var leaf = valuesParsed ? val : $898aa7a6aab4e394$var$parseArrayValue(val, options, currentArrayLength);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === '[]' && options.parseArrays) obj = options.allowEmptyArrays && (leaf === '' || options.strictNullHandling && leaf === null) ? [] : $abKVc.combine([], leaf);
        else {
            obj = options.plainObjects ? {
                __proto__: null
            } : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            if (!options.parseArrays && decodedRoot === '') obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (decodedRoot !== '__proto__') obj[decodedRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $898aa7a6aab4e394$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $898aa7a6aab4e394$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $898aa7a6aab4e394$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, check strictDepth option for throw, else just add whatever is left
    if (segment) {
        if (options.strictDepth === true) throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
        keys.push('[' + key.slice(segment.index) + ']');
    }
    return $898aa7a6aab4e394$var$parseObject(keys, val, options, valuesParsed);
};
var $898aa7a6aab4e394$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $898aa7a6aab4e394$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') throw new TypeError('Decoder has to be a function.');
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    if (typeof opts.throwOnLimitExceeded !== 'undefined' && typeof opts.throwOnLimitExceeded !== 'boolean') throw new TypeError('`throwOnLimitExceeded` option must be a boolean');
    var charset = typeof opts.charset === 'undefined' ? $898aa7a6aab4e394$var$defaults.charset : opts.charset;
    var duplicates = typeof opts.duplicates === 'undefined' ? $898aa7a6aab4e394$var$defaults.duplicates : opts.duplicates;
    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') throw new TypeError('The duplicates option must be either combine, first, or last');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : $898aa7a6aab4e394$var$defaults.allowDots : !!opts.allowDots;
    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $898aa7a6aab4e394$var$defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : $898aa7a6aab4e394$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : $898aa7a6aab4e394$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : $898aa7a6aab4e394$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $898aa7a6aab4e394$var$defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : $898aa7a6aab4e394$var$defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : $898aa7a6aab4e394$var$defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : $898aa7a6aab4e394$var$defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || $abKVc.isRegExp(opts.delimiter) ? opts.delimiter : $898aa7a6aab4e394$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === 'number' || opts.depth === false ? +opts.depth : $898aa7a6aab4e394$var$defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : $898aa7a6aab4e394$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : $898aa7a6aab4e394$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : $898aa7a6aab4e394$var$defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : $898aa7a6aab4e394$var$defaults.strictDepth,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $898aa7a6aab4e394$var$defaults.strictNullHandling,
        throwOnLimitExceeded: typeof opts.throwOnLimitExceeded === 'boolean' ? opts.throwOnLimitExceeded : false
    };
};
module.exports = function(str, opts) {
    var options = $898aa7a6aab4e394$var$normalizeParseOptions(opts);
    if (str === '' || str === null || typeof str === 'undefined') return options.plainObjects ? {
        __proto__: null
    } : {};
    var tempObj = typeof str === 'string' ? $898aa7a6aab4e394$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? {
        __proto__: null
    } : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $898aa7a6aab4e394$var$parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = $abKVc.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $abKVc.compact(obj);
};

});



parcelRegister("b4CpS", function(module, exports) {
"use strict";
var $80fdde224c996618$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $80fdde224c996618$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $80fdde224c996618$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Storage = module.exports.Log = module.exports.EventLogger = module.exports.Diagnostics = void 0;



Object.defineProperty(module.exports, "Diagnostics", {
    enumerable: true,
    get: function() {
        return (parcelRequire("gEK5A")).Diagnostics;
    }
});

var $1RMMl = parcelRequire("1RMMl");
Object.defineProperty(module.exports, "EventLogger", {
    enumerable: true,
    get: function() {
        return $1RMMl.EventLogger;
    }
});

Object.defineProperty(module.exports, "Log", {
    enumerable: true,
    get: function() {
        return (parcelRequire("69t28")).Log;
    }
});


Object.defineProperty(module.exports, "Storage", {
    enumerable: true,
    get: function() {
        return (parcelRequire("cn2J1")).Storage;
    }
});

$80fdde224c996618$var$__exportStar((parcelRequire("jEilP")), module.exports);

$80fdde224c996618$var$__exportStar((parcelRequire("foCb2")), module.exports);

$80fdde224c996618$var$__exportStar((parcelRequire("exBU4")), module.exports);

$80fdde224c996618$var$__exportStar((parcelRequire("9RNM8")), module.exports);

$80fdde224c996618$var$__exportStar((parcelRequire("gEK5A")), module.exports);

$80fdde224c996618$var$__exportStar((parcelRequire("8Q4td")), module.exports);

$80fdde224c996618$var$__exportStar((parcelRequire("1wXH6")), module.exports);

$80fdde224c996618$var$__exportStar((parcelRequire("ATVsX")), module.exports);

$80fdde224c996618$var$__exportStar((parcelRequire("dxE3d")), module.exports);

$80fdde224c996618$var$__exportStar((parcelRequire("legJs")), module.exports);

$80fdde224c996618$var$__exportStar((parcelRequire("7w1Zp")), module.exports);

$80fdde224c996618$var$__exportStar((parcelRequire("69t28")), module.exports);

$80fdde224c996618$var$__exportStar((parcelRequire("lmFrl")), module.exports);

$80fdde224c996618$var$__exportStar((parcelRequire("8XS5H")), module.exports);

$80fdde224c996618$var$__exportStar((parcelRequire("7GnX2")), module.exports);

$80fdde224c996618$var$__exportStar((parcelRequire("8ePXw")), module.exports);

$80fdde224c996618$var$__exportStar((parcelRequire("9imDx")), module.exports);

$80fdde224c996618$var$__exportStar((parcelRequire("cw4S6")), module.exports);

$80fdde224c996618$var$__exportStar((parcelRequire("hQOsi")), module.exports);

$80fdde224c996618$var$__exportStar((parcelRequire("gXcI4")), module.exports);

$80fdde224c996618$var$__exportStar((parcelRequire("15QTg")), module.exports);

$80fdde224c996618$var$__exportStar((parcelRequire("fpOrS")), module.exports);

$80fdde224c996618$var$__exportStar((parcelRequire("baLHY")), module.exports);

$80fdde224c996618$var$__exportStar((parcelRequire("93F2z")), module.exports);

$80fdde224c996618$var$__exportStar((parcelRequire("9yVDo")), module.exports);

$80fdde224c996618$var$__exportStar((parcelRequire("i6PKv")), module.exports);

$80fdde224c996618$var$__exportStar((parcelRequire("kD2yV")), module.exports);

$80fdde224c996618$var$__exportStar((parcelRequire("97ecK")), module.exports);

$80fdde224c996618$var$__exportStar((parcelRequire("aCCOX")), module.exports);

$80fdde224c996618$var$__exportStar((parcelRequire("7K3On")), module.exports);

$80fdde224c996618$var$__exportStar((parcelRequire("3BALq")), module.exports);

$80fdde224c996618$var$__exportStar((parcelRequire("5ANbE")), module.exports);

$80fdde224c996618$var$__exportStar((parcelRequire("cn2J1")), module.exports);

$80fdde224c996618$var$__exportStar((parcelRequire("80pji")), module.exports);

$80fdde224c996618$var$__exportStar((parcelRequire("ijNyO")), module.exports);

$80fdde224c996618$var$__exportStar((parcelRequire("8VIUL")), module.exports);

$80fdde224c996618$var$__exportStar((parcelRequire("1lhbi")), module.exports);

$80fdde224c996618$var$__exportStar((parcelRequire("lnUhG")), module.exports);

$80fdde224c996618$var$__exportStar((parcelRequire("1b4nC")), module.exports);

$80fdde224c996618$var$__exportStar((parcelRequire("3Sk5Y")), module.exports);
Object.assign((0, (parcelRequire("jEilP"))._getStatsigGlobal)(), {
    Log: (parcelRequire("69t28")).Log,
    SDK_VERSION: (parcelRequire("kD2yV")).SDK_VERSION
});

});
parcelRegister("jEilP", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ var $e4dffce815ff707b$var$_a, $e4dffce815ff707b$var$_b, $e4dffce815ff707b$var$_c;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getInstance = module.exports._getStatsigGlobalFlag = module.exports._getStatsigGlobal = void 0;

var $69t28 = parcelRequire("69t28");
const $e4dffce815ff707b$var$_getStatsigGlobal = ()=>{
    // Avoid ReferenceError, which is happening with Cloudflare pages
    try {
        return typeof __STATSIG__ !== 'undefined' ? __STATSIG__ : $e4dffce815ff707b$var$statsigGlobal;
    } catch (e) {
        return $e4dffce815ff707b$var$statsigGlobal;
    }
};
module.exports._getStatsigGlobal = $e4dffce815ff707b$var$_getStatsigGlobal;
const $e4dffce815ff707b$var$_getStatsigGlobalFlag = (flag)=>{
    return (0, module.exports._getStatsigGlobal)()[flag];
};
module.exports._getStatsigGlobalFlag = $e4dffce815ff707b$var$_getStatsigGlobalFlag;
const $e4dffce815ff707b$var$_getInstance = (sdkKey)=>{
    const gbl = (0, module.exports._getStatsigGlobal)();
    if (!sdkKey) {
        if (gbl.instances && Object.keys(gbl.instances).length > 1) $69t28.Log.warn('Call made to Statsig global instance without an SDK key but there is more than one client instance. If you are using mulitple clients, please specify the SDK key.');
        return gbl.firstInstance;
    }
    return gbl.instances && gbl.instances[sdkKey];
};
module.exports._getInstance = $e4dffce815ff707b$var$_getInstance;
const $e4dffce815ff707b$var$GLOBAL_KEY = '__STATSIG__';
const $e4dffce815ff707b$var$_window = typeof window !== 'undefined' ? window : {};
const $e4dffce815ff707b$var$_global = typeof $parcel$global !== 'undefined' ? $parcel$global : {};
const $e4dffce815ff707b$var$_globalThis = typeof globalThis !== 'undefined' ? globalThis : {};
const $e4dffce815ff707b$var$statsigGlobal = ($e4dffce815ff707b$var$_c = ($e4dffce815ff707b$var$_b = ($e4dffce815ff707b$var$_a = $e4dffce815ff707b$var$_window[$e4dffce815ff707b$var$GLOBAL_KEY]) !== null && $e4dffce815ff707b$var$_a !== void 0 ? $e4dffce815ff707b$var$_a : $e4dffce815ff707b$var$_global[$e4dffce815ff707b$var$GLOBAL_KEY]) !== null && $e4dffce815ff707b$var$_b !== void 0 ? $e4dffce815ff707b$var$_b : $e4dffce815ff707b$var$_globalThis[$e4dffce815ff707b$var$GLOBAL_KEY]) !== null && $e4dffce815ff707b$var$_c !== void 0 ? $e4dffce815ff707b$var$_c : {
    instance: module.exports._getInstance
};
$e4dffce815ff707b$var$_window[$e4dffce815ff707b$var$GLOBAL_KEY] = $e4dffce815ff707b$var$statsigGlobal;
$e4dffce815ff707b$var$_global[$e4dffce815ff707b$var$GLOBAL_KEY] = $e4dffce815ff707b$var$statsigGlobal;
$e4dffce815ff707b$var$_globalThis[$e4dffce815ff707b$var$GLOBAL_KEY] = $e4dffce815ff707b$var$statsigGlobal;

});
parcelRegister("69t28", function(module, exports) {
"use strict";
/* eslint-disable no-console */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Log = module.exports.LogLevel = void 0;
// intentionally spaced for formatting
const $47aa1ac8ab5ba985$var$DEBUG = ' DEBUG ';
const $47aa1ac8ab5ba985$var$_INFO = '  INFO ';
const $47aa1ac8ab5ba985$var$_WARN = '  WARN ';
const $47aa1ac8ab5ba985$var$ERROR = ' ERROR ';
function $47aa1ac8ab5ba985$var$addTag(args) {
    args.unshift('[Statsig]');
    return args; // ['[Statsig]', ...args];
}
module.exports.LogLevel = {
    None: 0,
    Error: 1,
    Warn: 2,
    Info: 3,
    Debug: 4
};
class $47aa1ac8ab5ba985$var$Log {
    static info(...args) {
        if ($47aa1ac8ab5ba985$var$Log.level >= module.exports.LogLevel.Info) console.info($47aa1ac8ab5ba985$var$_INFO, ...$47aa1ac8ab5ba985$var$addTag(args));
    }
    static debug(...args) {
        if ($47aa1ac8ab5ba985$var$Log.level >= module.exports.LogLevel.Debug) console.debug($47aa1ac8ab5ba985$var$DEBUG, ...$47aa1ac8ab5ba985$var$addTag(args));
    }
    static warn(...args) {
        if ($47aa1ac8ab5ba985$var$Log.level >= module.exports.LogLevel.Warn) console.warn($47aa1ac8ab5ba985$var$_WARN, ...$47aa1ac8ab5ba985$var$addTag(args));
    }
    static error(...args) {
        if ($47aa1ac8ab5ba985$var$Log.level >= module.exports.LogLevel.Error) console.error($47aa1ac8ab5ba985$var$ERROR, ...$47aa1ac8ab5ba985$var$addTag(args));
    }
}
module.exports.Log = $47aa1ac8ab5ba985$var$Log;
$47aa1ac8ab5ba985$var$Log.level = module.exports.LogLevel.Warn;

});


parcelRegister("gEK5A", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Diagnostics = void 0;
const $c204221bb275870c$var$MARKER_MAP = new Map();
const $c204221bb275870c$var$ACT_START = 'start';
const $c204221bb275870c$var$ACT_END = 'end';
const $c204221bb275870c$var$DIAGNOSTICS_EVENT = 'statsig::diagnostics';
module.exports.Diagnostics = {
    _getMarkers: (sdkKey)=>{
        return $c204221bb275870c$var$MARKER_MAP.get(sdkKey);
    },
    _markInitOverallStart: (sdkKey)=>{
        $c204221bb275870c$var$_addMarker(sdkKey, $c204221bb275870c$var$_createMarker({}, $c204221bb275870c$var$ACT_START, 'overall'));
    },
    _markInitOverallEnd: (sdkKey, success, evaluationDetails)=>{
        $c204221bb275870c$var$_addMarker(sdkKey, $c204221bb275870c$var$_createMarker({
            success: success,
            error: success ? undefined : {
                name: 'InitializeError',
                message: 'Failed to initialize'
            },
            evaluationDetails: evaluationDetails
        }, $c204221bb275870c$var$ACT_END, 'overall'));
    },
    _markInitNetworkReqStart: (sdkKey, data)=>{
        $c204221bb275870c$var$_addMarker(sdkKey, $c204221bb275870c$var$_createMarker(data, $c204221bb275870c$var$ACT_START, 'initialize', 'network_request'));
    },
    _markInitNetworkReqEnd: (sdkKey, data)=>{
        $c204221bb275870c$var$_addMarker(sdkKey, $c204221bb275870c$var$_createMarker(data, $c204221bb275870c$var$ACT_END, 'initialize', 'network_request'));
    },
    _markInitProcessStart: (sdkKey)=>{
        $c204221bb275870c$var$_addMarker(sdkKey, $c204221bb275870c$var$_createMarker({}, $c204221bb275870c$var$ACT_START, 'initialize', 'process'));
    },
    _markInitProcessEnd: (sdkKey, data)=>{
        $c204221bb275870c$var$_addMarker(sdkKey, $c204221bb275870c$var$_createMarker(data, $c204221bb275870c$var$ACT_END, 'initialize', 'process'));
    },
    _clearMarkers: (sdkKey)=>{
        $c204221bb275870c$var$MARKER_MAP.delete(sdkKey);
    },
    _formatError (e) {
        if (!(e && typeof e === 'object')) return;
        return {
            code: $c204221bb275870c$var$_safeGetField(e, 'code'),
            name: $c204221bb275870c$var$_safeGetField(e, 'name'),
            message: $c204221bb275870c$var$_safeGetField(e, 'message')
        };
    },
    _getDiagnosticsData (res, attempt, body, e) {
        var _a;
        return {
            success: (res === null || res === void 0 ? void 0 : res.ok) === true,
            statusCode: res === null || res === void 0 ? void 0 : res.status,
            sdkRegion: (_a = res === null || res === void 0 ? void 0 : res.headers) === null || _a === void 0 ? void 0 : _a.get('x-statsig-region'),
            isDelta: body.includes('"is_delta":true') === true ? true : undefined,
            attempt: attempt,
            error: module.exports.Diagnostics._formatError(e)
        };
    },
    _enqueueDiagnosticsEvent (user, logger, sdk, options) {
        const markers = module.exports.Diagnostics._getMarkers(sdk);
        if (markers == null || markers.length <= 0) return -1;
        const overallInitDuration = markers[markers.length - 1].timestamp - markers[0].timestamp;
        module.exports.Diagnostics._clearMarkers(sdk);
        const event = $c204221bb275870c$var$_makeDiagnosticsEvent(user, {
            context: 'initialize',
            markers: markers.slice(),
            statsigOptions: options
        });
        logger.enqueue(event);
        return overallInitDuration;
    }
};
function $c204221bb275870c$var$_createMarker(data, action, key, step) {
    return Object.assign({
        key: key,
        action: action,
        step: step,
        timestamp: Date.now()
    }, data);
}
function $c204221bb275870c$var$_makeDiagnosticsEvent(user, data) {
    const latencyEvent = {
        eventName: $c204221bb275870c$var$DIAGNOSTICS_EVENT,
        user: user,
        value: null,
        metadata: data,
        time: Date.now()
    };
    return latencyEvent;
}
function $c204221bb275870c$var$_addMarker(sdkKey, marker) {
    var _a;
    const markers = (_a = $c204221bb275870c$var$MARKER_MAP.get(sdkKey)) !== null && _a !== void 0 ? _a : [];
    markers.push(marker);
    $c204221bb275870c$var$MARKER_MAP.set(sdkKey, markers);
}
function $c204221bb275870c$var$_safeGetField(data, field) {
    if (field in data) return data[field];
    return undefined;
}

});

parcelRegister("1RMMl", function(module, exports) {
"use strict";
var $15c0941b57079a54$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventLogger = void 0;

var $foCb2 = parcelRequire("foCb2");

var $legJs = parcelRequire("legJs");

var $69t28 = parcelRequire("69t28");

var $8XS5H = parcelRequire("8XS5H");

var $cw4S6 = parcelRequire("cw4S6");

var $i6PKv = parcelRequire("i6PKv");

var $97ecK = parcelRequire("97ecK");

var $cn2J1 = parcelRequire("cn2J1");

var $8VIUL = parcelRequire("8VIUL");

var $lnUhG = parcelRequire("lnUhG");
const $15c0941b57079a54$var$DEFAULT_QUEUE_SIZE = 100;
const $15c0941b57079a54$var$DEFAULT_FLUSH_INTERVAL_MS = 10000;
const $15c0941b57079a54$var$MAX_DEDUPER_KEYS = 1000;
const $15c0941b57079a54$var$DEDUPER_WINDOW_DURATION_MS = 600000;
const $15c0941b57079a54$var$MAX_FAILED_LOGS = 500;
const $15c0941b57079a54$var$QUICK_FLUSH_WINDOW_MS = 200;
const $15c0941b57079a54$var$EVENT_LOGGER_MAP = {};
class $15c0941b57079a54$var$EventLogger {
    static _safeFlushAndForget(sdkKey) {
        var _a;
        (_a = $15c0941b57079a54$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a.flush().catch(()=>{
        // noop
        });
    }
    static _safeRetryFailedLogs(sdkKey) {
        var _a;
        (_a = $15c0941b57079a54$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a._retryFailedLogs();
    }
    setLogEventCompressionMode(mode) {
        this._network.setLogEventCompressionMode(mode);
    }
    setLoggingEnabled(loggingEnabled) {
        if (this._loggingEnabled === 'disabled' && loggingEnabled !== 'disabled') {
            // load any pre consented events into memory
            const storageKey = this._getStorageKey();
            const events = (0, $cn2J1._getObjectFromStorage)(storageKey);
            if (events) this._queue.push(...events);
            $cn2J1.Storage.removeItem(storageKey);
        }
        this._loggingEnabled = loggingEnabled;
    }
    enqueue(event) {
        if (!this._shouldLogEvent(event)) return;
        this._normalizeAndAppendEvent(event);
        this._quickFlushIfNeeded();
        if (this._queue.length > this._maxQueueSize) $15c0941b57079a54$var$EventLogger._safeFlushAndForget(this._sdkKey);
    }
    incrementNonExposureCount(name) {
        var _a;
        const current = (_a = this._nonExposedChecks[name]) !== null && _a !== void 0 ? _a : 0;
        this._nonExposedChecks[name] = current + 1;
    }
    reset() {
        // attempt to flush any remaining events
        this.flush().catch(()=>{
        // noop
        });
        this._lastExposureTimeMap = {};
    }
    start() {
        var _a;
        const isServerEnv = (0, $cw4S6._isServerEnv)();
        if (isServerEnv && ((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always') return;
        $15c0941b57079a54$var$EVENT_LOGGER_MAP[this._sdkKey] = this;
        if (!isServerEnv) (0, $lnUhG._subscribeToVisiblityChanged)((visibility)=>{
            if (visibility === 'background') $15c0941b57079a54$var$EventLogger._safeFlushAndForget(this._sdkKey);
            else if (visibility === 'foreground') $15c0941b57079a54$var$EventLogger._safeRetryFailedLogs(this._sdkKey);
        });
        this._retryFailedLogs();
        this._startBackgroundFlushInterval();
    }
    stop() {
        return $15c0941b57079a54$var$__awaiter(this, void 0, void 0, function*() {
            if (this._flushIntervalId) {
                clearInterval(this._flushIntervalId);
                this._flushIntervalId = null;
            }
            delete $15c0941b57079a54$var$EVENT_LOGGER_MAP[this._sdkKey];
            yield this.flush();
        });
    }
    flush() {
        return $15c0941b57079a54$var$__awaiter(this, void 0, void 0, function*() {
            this._appendAndResetNonExposedChecks();
            if (this._queue.length === 0) return;
            const events = this._queue;
            this._queue = [];
            yield this._sendEvents(events);
        });
    }
    /**
     * We 'Quick Flush' following the very first event enqueued
     * within the quick flush window
     */ _quickFlushIfNeeded() {
        if (this._hasRunQuickFlush) return;
        this._hasRunQuickFlush = true;
        if (Date.now() - this._creationTime > $15c0941b57079a54$var$QUICK_FLUSH_WINDOW_MS) return;
        setTimeout(()=>$15c0941b57079a54$var$EventLogger._safeFlushAndForget(this._sdkKey), $15c0941b57079a54$var$QUICK_FLUSH_WINDOW_MS);
    }
    _shouldLogEvent(event) {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always' && (0, $cw4S6._isServerEnv)()) return false;
        if (!(0, $i6PKv._isExposureEvent)(event)) return true;
        const user = event.user ? event.user : {
            statsigEnvironment: undefined
        };
        const userKey = (0, $foCb2._getUserStorageKey)(this._sdkKey, user);
        const metadata = event.metadata ? event.metadata : {};
        const key = [
            event.eventName,
            userKey,
            metadata['gate'],
            metadata['config'],
            metadata['ruleID'],
            metadata['allocatedExperiment'],
            metadata['parameterName'],
            String(metadata['isExplicitParameter']),
            metadata['reason']
        ].join('|');
        const previous = this._lastExposureTimeMap[key];
        const now = Date.now();
        if (previous && now - previous < $15c0941b57079a54$var$DEDUPER_WINDOW_DURATION_MS) return false;
        if (Object.keys(this._lastExposureTimeMap).length > $15c0941b57079a54$var$MAX_DEDUPER_KEYS) this._lastExposureTimeMap = {};
        this._lastExposureTimeMap[key] = now;
        return true;
    }
    _sendEvents(events) {
        return $15c0941b57079a54$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            if (this._loggingEnabled === 'disabled') {
                this._saveFailedLogsToStorage(events);
                return false;
            }
            try {
                const isClosing = (0, $lnUhG._isUnloading)();
                const shouldUseBeacon = isClosing && this._network.isBeaconSupported() && ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.networkOverrideFunc) == null;
                this._emitter({
                    name: 'pre_logs_flushed',
                    events: events
                });
                const response = shouldUseBeacon ? this._sendEventsViaBeacon(events) : yield this._sendEventsViaPost(events);
                if (response.success) {
                    this._emitter({
                        name: 'logs_flushed',
                        events: events
                    });
                    return true;
                } else {
                    $69t28.Log.warn('Failed to flush events.');
                    this._saveFailedLogsToStorage(events);
                    return false;
                }
            } catch (_c) {
                $69t28.Log.warn('Failed to flush events.');
                return false;
            }
        });
    }
    _sendEventsViaPost(events) {
        return $15c0941b57079a54$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield this._network.post(this._getRequestData(events));
            const code = (_a = result === null || result === void 0 ? void 0 : result.code) !== null && _a !== void 0 ? _a : -1;
            return {
                success: code >= 200 && code < 300
            };
        });
    }
    _sendEventsViaBeacon(events) {
        return {
            success: this._network.beacon(this._getRequestData(events))
        };
    }
    _getRequestData(events) {
        return {
            sdkKey: this._sdkKey,
            data: {
                events: events
            },
            urlConfig: this._logEventUrlConfig,
            retries: 3,
            isCompressable: true,
            params: {
                [$8XS5H.NetworkParam.EventCount]: String(events.length)
            },
            credentials: 'same-origin'
        };
    }
    _saveFailedLogsToStorage(events) {
        while(events.length > $15c0941b57079a54$var$MAX_FAILED_LOGS)events.shift();
        const storageKey = this._getStorageKey();
        try {
            const savedEvents = this._getFailedLogsFromStorage(storageKey);
            (0, $cn2J1._setObjectInStorage)(storageKey, [
                ...savedEvents,
                ...events
            ]);
        } catch (_a) {
            $69t28.Log.warn('Unable to save failed logs to storage');
        }
    }
    _getFailedLogsFromStorage(storageKey) {
        let savedEvents = [];
        try {
            const retrieved = (0, $cn2J1._getObjectFromStorage)(storageKey);
            if (Array.isArray(retrieved)) savedEvents = retrieved;
            return savedEvents;
        } catch (_a) {
            return [];
        }
    }
    _retryFailedLogs() {
        const storageKey = this._getStorageKey();
        (()=>$15c0941b57079a54$var$__awaiter(this, void 0, void 0, function*() {
                if (!$cn2J1.Storage.isReady()) yield $cn2J1.Storage.isReadyResolver();
                const events = (0, $cn2J1._getObjectFromStorage)(storageKey);
                if (!events) return;
                $cn2J1.Storage.removeItem(storageKey);
                yield this._sendEvents(events);
            }))().catch(()=>{
            $69t28.Log.warn('Failed to flush stored logs');
        });
    }
    _getStorageKey() {
        return `statsig.failed_logs.${(0, $legJs._DJB2)(this._sdkKey)}`;
    }
    _normalizeAndAppendEvent(event) {
        if (event.user) {
            event.user = Object.assign({}, event.user);
            delete event.user.privateAttributes;
        }
        const extras = {};
        const currentPage = this._getCurrentPageUrl();
        if (currentPage) extras.statsigMetadata = {
            currentPage: currentPage
        };
        const final = Object.assign(Object.assign({}, event), extras);
        $69t28.Log.debug('Enqueued Event:', final);
        this._queue.push(final);
    }
    _appendAndResetNonExposedChecks() {
        if (Object.keys(this._nonExposedChecks).length === 0) return;
        this._normalizeAndAppendEvent({
            eventName: 'statsig::non_exposed_checks',
            user: null,
            time: Date.now(),
            metadata: {
                checks: Object.assign({}, this._nonExposedChecks)
            }
        });
        this._nonExposedChecks = {};
    }
    _getCurrentPageUrl() {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.includeCurrentPageUrlWithEvents) === false) return;
        return (0, $cw4S6._getCurrentPageUrlSafe)();
    }
    _startBackgroundFlushInterval() {
        var _a, _b;
        const flushInterval = (_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingIntervalMs) !== null && _b !== void 0 ? _b : $15c0941b57079a54$var$DEFAULT_FLUSH_INTERVAL_MS;
        const intervalId = setInterval(()=>{
            const logger = $15c0941b57079a54$var$EVENT_LOGGER_MAP[this._sdkKey];
            if (!logger || logger._flushIntervalId !== intervalId) clearInterval(intervalId);
            else $15c0941b57079a54$var$EventLogger._safeFlushAndForget(this._sdkKey);
        }, flushInterval);
        this._flushIntervalId = intervalId;
    }
    constructor(_sdkKey, _emitter, _network, _options){
        var _a, _b;
        this._sdkKey = _sdkKey;
        this._emitter = _emitter;
        this._network = _network;
        this._options = _options;
        this._queue = [];
        this._lastExposureTimeMap = {};
        this._nonExposedChecks = {};
        this._hasRunQuickFlush = false;
        this._creationTime = Date.now();
        this._loggingEnabled = (_a = _options === null || _options === void 0 ? void 0 : _options.loggingEnabled) !== null && _a !== void 0 ? _a : (_options === null || _options === void 0 ? void 0 : _options.disableLogging) === true ? $97ecK.LoggingEnabledOption.disabled : $97ecK.LoggingEnabledOption.browserOnly;
        if ((_options === null || _options === void 0 ? void 0 : _options.loggingEnabled) && _options.disableLogging !== undefined) $69t28.Log.warn('Detected both loggingEnabled and disableLogging options. loggingEnabled takes precedence - please remove disableLogging.');
        this._maxQueueSize = (_b = _options === null || _options === void 0 ? void 0 : _options.loggingBufferMaxSize) !== null && _b !== void 0 ? _b : $15c0941b57079a54$var$DEFAULT_QUEUE_SIZE;
        const config = _options === null || _options === void 0 ? void 0 : _options.networkConfig;
        this._logEventUrlConfig = new $8VIUL.UrlConfiguration($8XS5H.Endpoint._rgstr, config === null || config === void 0 ? void 0 : config.logEventUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.logEventFallbackUrls);
    }
}
module.exports.EventLogger = $15c0941b57079a54$var$EventLogger;

});
parcelRegister("foCb2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getStorageKey = module.exports._getUserStorageKey = void 0;

var $legJs = parcelRequire("legJs");
function $b356b614fa1922b2$var$_getUserStorageKey(sdkKey, user, customKeyGenerator) {
    var _a;
    if (customKeyGenerator) return customKeyGenerator(sdkKey, user);
    const cids = user && user.customIDs ? user.customIDs : {};
    const parts = [
        `uid:${(_a = user === null || user === void 0 ? void 0 : user.userID) !== null && _a !== void 0 ? _a : ''}`,
        `cids:${Object.keys(cids).sort((leftKey, rightKey)=>leftKey.localeCompare(rightKey)).map((key)=>`${key}-${cids[key]}`).join(',')}`,
        `k:${sdkKey}`
    ];
    return (0, $legJs._DJB2)(parts.join('|'));
}
module.exports._getUserStorageKey = $b356b614fa1922b2$var$_getUserStorageKey;
function $b356b614fa1922b2$var$_getStorageKey(sdkKey, user, customKeyGenerator) {
    if (user) return $b356b614fa1922b2$var$_getUserStorageKey(sdkKey, user, customKeyGenerator);
    return (0, $legJs._DJB2)(`k:${sdkKey}`);
}
module.exports._getStorageKey = $b356b614fa1922b2$var$_getStorageKey;

});
parcelRegister("legJs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getSortedObject = module.exports._DJB2Object = module.exports._DJB2 = void 0;

var $ijNyO = parcelRequire("ijNyO");
const $f747e272c36220d8$var$_DJB2 = (value)=>{
    let hash = 0;
    for(let i = 0; i < value.length; i++){
        const character = value.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash; // Convert to 32bit integer
    }
    return String(hash >>> 0);
};
module.exports._DJB2 = $f747e272c36220d8$var$_DJB2;
const $f747e272c36220d8$var$_DJB2Object = (value, maxLevels)=>{
    return (0, module.exports._DJB2)(JSON.stringify((0, module.exports._getSortedObject)(value, maxLevels)));
};
module.exports._DJB2Object = $f747e272c36220d8$var$_DJB2Object;
const $f747e272c36220d8$var$_getSortedObject = (object, maxDepth)=>{
    if (object == null) return null;
    const keys = Object.keys(object).sort();
    const sortedObject = {};
    keys.forEach((key)=>{
        const value = object[key];
        if (maxDepth === 0 || (0, $ijNyO._typeOf)(value) !== 'object') {
            sortedObject[key] = value;
            return;
        }
        sortedObject[key] = (0, module.exports._getSortedObject)(value, maxDepth != null ? maxDepth - 1 : maxDepth);
    });
    return sortedObject;
};
module.exports._getSortedObject = $f747e272c36220d8$var$_getSortedObject;

});
parcelRegister("ijNyO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isTypeMatch = module.exports._typeOf = void 0;
function $d560720a94860e03$var$_typeOf(input) {
    return Array.isArray(input) ? 'array' : typeof input;
}
module.exports._typeOf = $d560720a94860e03$var$_typeOf;
function $d560720a94860e03$var$_isTypeMatch(a, b) {
    const typeOf = (x)=>Array.isArray(x) ? 'array' : x === null ? 'null' : typeof x;
    return typeOf(a) === typeOf(b);
}
module.exports._isTypeMatch = $d560720a94860e03$var$_isTypeMatch;

});



parcelRegister("8XS5H", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkParam = module.exports.NetworkDefault = module.exports.Endpoint = void 0;
module.exports.Endpoint = {
    _initialize: 'initialize',
    _rgstr: 'rgstr',
    _download_config_specs: 'download_config_specs'
};
module.exports.NetworkDefault = {
    [module.exports.Endpoint._rgstr]: 'https://prodregistryv2.org/v1',
    [module.exports.Endpoint._initialize]: 'https://featureassets.org/v1',
    [module.exports.Endpoint._download_config_specs]: 'https://api.statsigcdn.com/v1'
};
module.exports.NetworkParam = {
    EventCount: 'ec',
    SdkKey: 'k',
    SdkType: 'st',
    SdkVersion: 'sv',
    Time: 't',
    SessionID: 'sid',
    StatsigEncoded: 'se',
    IsGzipped: 'gz'
};

});

parcelRegister("cw4S6", function(module, exports) {

var $aVaWD = parcelRequire("aVaWD");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getUnloadEvent = module.exports._getCurrentPageUrlSafe = module.exports._addDocumentEventListenerSafe = module.exports._addWindowEventListenerSafe = module.exports._isServerEnv = module.exports._getDocumentSafe = module.exports._getWindowSafe = void 0;
const $91cc409ae31fddf2$var$_getWindowSafe = ()=>{
    return typeof window !== 'undefined' ? window : null;
};
module.exports._getWindowSafe = $91cc409ae31fddf2$var$_getWindowSafe;
const $91cc409ae31fddf2$var$_getDocumentSafe = ()=>{
    var _a;
    const win = (0, module.exports._getWindowSafe)();
    return (_a = win === null || win === void 0 ? void 0 : win.document) !== null && _a !== void 0 ? _a : null;
};
module.exports._getDocumentSafe = $91cc409ae31fddf2$var$_getDocumentSafe;
const $91cc409ae31fddf2$var$_isServerEnv = ()=>{
    if ((0, module.exports._getDocumentSafe)() !== null) return false;
    const isNode = typeof $aVaWD !== 'undefined' && $aVaWD.versions != null && $aVaWD.versions.node != null;
    const isVercel = typeof EdgeRuntime === 'string';
    return isVercel || isNode;
};
module.exports._isServerEnv = $91cc409ae31fddf2$var$_isServerEnv;
const $91cc409ae31fddf2$var$_addWindowEventListenerSafe = (key, listener)=>{
    const win = (0, module.exports._getWindowSafe)();
    if (typeof (win === null || win === void 0 ? void 0 : win.addEventListener) === 'function') win.addEventListener(key, listener);
};
module.exports._addWindowEventListenerSafe = $91cc409ae31fddf2$var$_addWindowEventListenerSafe;
const $91cc409ae31fddf2$var$_addDocumentEventListenerSafe = (key, listener)=>{
    const doc = (0, module.exports._getDocumentSafe)();
    if (typeof (doc === null || doc === void 0 ? void 0 : doc.addEventListener) === 'function') doc.addEventListener(key, listener);
};
module.exports._addDocumentEventListenerSafe = $91cc409ae31fddf2$var$_addDocumentEventListenerSafe;
const $91cc409ae31fddf2$var$_getCurrentPageUrlSafe = ()=>{
    var _a;
    try {
        return (_a = (0, module.exports._getWindowSafe)()) === null || _a === void 0 ? void 0 : _a.location.href.split(/[?#]/)[0];
    } catch (_b) {
        return;
    }
};
module.exports._getCurrentPageUrlSafe = $91cc409ae31fddf2$var$_getCurrentPageUrlSafe;
const $91cc409ae31fddf2$var$_getUnloadEvent = ()=>{
    const win = (0, module.exports._getWindowSafe)();
    if (!win) return 'beforeunload';
    const eventType = 'onpagehide' in win ? 'pagehide' : 'beforeunload';
    return eventType;
};
module.exports._getUnloadEvent = $91cc409ae31fddf2$var$_getUnloadEvent;

});
parcelRegister("aVaWD", function(module, exports) {
// shim for using process in browser
var $7f37b7a73c434c00$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $7f37b7a73c434c00$var$cachedSetTimeout;
var $7f37b7a73c434c00$var$cachedClearTimeout;
function $7f37b7a73c434c00$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $7f37b7a73c434c00$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $7f37b7a73c434c00$var$cachedSetTimeout = setTimeout;
        else $7f37b7a73c434c00$var$cachedSetTimeout = $7f37b7a73c434c00$var$defaultSetTimout;
    } catch (e) {
        $7f37b7a73c434c00$var$cachedSetTimeout = $7f37b7a73c434c00$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $7f37b7a73c434c00$var$cachedClearTimeout = clearTimeout;
        else $7f37b7a73c434c00$var$cachedClearTimeout = $7f37b7a73c434c00$var$defaultClearTimeout;
    } catch (e) {
        $7f37b7a73c434c00$var$cachedClearTimeout = $7f37b7a73c434c00$var$defaultClearTimeout;
    }
})();
function $7f37b7a73c434c00$var$runTimeout(fun) {
    if ($7f37b7a73c434c00$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($7f37b7a73c434c00$var$cachedSetTimeout === $7f37b7a73c434c00$var$defaultSetTimout || !$7f37b7a73c434c00$var$cachedSetTimeout) && setTimeout) {
        $7f37b7a73c434c00$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $7f37b7a73c434c00$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $7f37b7a73c434c00$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $7f37b7a73c434c00$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $7f37b7a73c434c00$var$runClearTimeout(marker) {
    if ($7f37b7a73c434c00$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($7f37b7a73c434c00$var$cachedClearTimeout === $7f37b7a73c434c00$var$defaultClearTimeout || !$7f37b7a73c434c00$var$cachedClearTimeout) && clearTimeout) {
        $7f37b7a73c434c00$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $7f37b7a73c434c00$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $7f37b7a73c434c00$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $7f37b7a73c434c00$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $7f37b7a73c434c00$var$queue = [];
var $7f37b7a73c434c00$var$draining = false;
var $7f37b7a73c434c00$var$currentQueue;
var $7f37b7a73c434c00$var$queueIndex = -1;
function $7f37b7a73c434c00$var$cleanUpNextTick() {
    if (!$7f37b7a73c434c00$var$draining || !$7f37b7a73c434c00$var$currentQueue) return;
    $7f37b7a73c434c00$var$draining = false;
    if ($7f37b7a73c434c00$var$currentQueue.length) $7f37b7a73c434c00$var$queue = $7f37b7a73c434c00$var$currentQueue.concat($7f37b7a73c434c00$var$queue);
    else $7f37b7a73c434c00$var$queueIndex = -1;
    if ($7f37b7a73c434c00$var$queue.length) $7f37b7a73c434c00$var$drainQueue();
}
function $7f37b7a73c434c00$var$drainQueue() {
    if ($7f37b7a73c434c00$var$draining) return;
    var timeout = $7f37b7a73c434c00$var$runTimeout($7f37b7a73c434c00$var$cleanUpNextTick);
    $7f37b7a73c434c00$var$draining = true;
    var len = $7f37b7a73c434c00$var$queue.length;
    while(len){
        $7f37b7a73c434c00$var$currentQueue = $7f37b7a73c434c00$var$queue;
        $7f37b7a73c434c00$var$queue = [];
        while(++$7f37b7a73c434c00$var$queueIndex < len)if ($7f37b7a73c434c00$var$currentQueue) $7f37b7a73c434c00$var$currentQueue[$7f37b7a73c434c00$var$queueIndex].run();
        $7f37b7a73c434c00$var$queueIndex = -1;
        len = $7f37b7a73c434c00$var$queue.length;
    }
    $7f37b7a73c434c00$var$currentQueue = null;
    $7f37b7a73c434c00$var$draining = false;
    $7f37b7a73c434c00$var$runClearTimeout(timeout);
}
$7f37b7a73c434c00$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $7f37b7a73c434c00$var$queue.push(new $7f37b7a73c434c00$var$Item(fun, args));
    if ($7f37b7a73c434c00$var$queue.length === 1 && !$7f37b7a73c434c00$var$draining) $7f37b7a73c434c00$var$runTimeout($7f37b7a73c434c00$var$drainQueue);
};
// v8 likes predictible objects
function $7f37b7a73c434c00$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$7f37b7a73c434c00$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$7f37b7a73c434c00$var$process.title = 'browser';
$7f37b7a73c434c00$var$process.browser = true;
$7f37b7a73c434c00$var$process.env = {};
$7f37b7a73c434c00$var$process.argv = [];
$7f37b7a73c434c00$var$process.version = ''; // empty string to avoid regexp issues
$7f37b7a73c434c00$var$process.versions = {};
function $7f37b7a73c434c00$var$noop() {}
$7f37b7a73c434c00$var$process.on = $7f37b7a73c434c00$var$noop;
$7f37b7a73c434c00$var$process.addListener = $7f37b7a73c434c00$var$noop;
$7f37b7a73c434c00$var$process.once = $7f37b7a73c434c00$var$noop;
$7f37b7a73c434c00$var$process.off = $7f37b7a73c434c00$var$noop;
$7f37b7a73c434c00$var$process.removeListener = $7f37b7a73c434c00$var$noop;
$7f37b7a73c434c00$var$process.removeAllListeners = $7f37b7a73c434c00$var$noop;
$7f37b7a73c434c00$var$process.emit = $7f37b7a73c434c00$var$noop;
$7f37b7a73c434c00$var$process.prependListener = $7f37b7a73c434c00$var$noop;
$7f37b7a73c434c00$var$process.prependOnceListener = $7f37b7a73c434c00$var$noop;
$7f37b7a73c434c00$var$process.listeners = function(name) {
    return [];
};
$7f37b7a73c434c00$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$7f37b7a73c434c00$var$process.cwd = function() {
    return '/';
};
$7f37b7a73c434c00$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$7f37b7a73c434c00$var$process.umask = function() {
    return 0;
};

});


parcelRegister("i6PKv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._createLayerParameterExposure = module.exports._createConfigExposure = module.exports._mapExposures = module.exports._createGateExposure = module.exports._isExposureEvent = void 0;
const $d2f0edd2deb5000b$var$CONFIG_EXPOSURE_NAME = 'statsig::config_exposure';
const $d2f0edd2deb5000b$var$GATE_EXPOSURE_NAME = 'statsig::gate_exposure';
const $d2f0edd2deb5000b$var$LAYER_EXPOSURE_NAME = 'statsig::layer_exposure';
const $d2f0edd2deb5000b$var$_createExposure = (eventName, user, details, metadata, secondaryExposures)=>{
    if (details.bootstrapMetadata) metadata['bootstrapMetadata'] = details.bootstrapMetadata;
    return {
        eventName: eventName,
        user: user,
        value: null,
        metadata: $d2f0edd2deb5000b$var$_addEvaluationDetailsToMetadata(details, metadata),
        secondaryExposures: secondaryExposures,
        time: Date.now()
    };
};
const $d2f0edd2deb5000b$var$_isExposureEvent = ({ eventName: eventName })=>{
    return eventName === $d2f0edd2deb5000b$var$GATE_EXPOSURE_NAME || eventName === $d2f0edd2deb5000b$var$CONFIG_EXPOSURE_NAME || eventName === $d2f0edd2deb5000b$var$LAYER_EXPOSURE_NAME;
};
module.exports._isExposureEvent = $d2f0edd2deb5000b$var$_isExposureEvent;
const $d2f0edd2deb5000b$var$_createGateExposure = (user, gate, exposureMapping)=>{
    var _a, _b, _c;
    const metadata = {
        gate: gate.name,
        gateValue: String(gate.value),
        ruleID: gate.ruleID
    };
    if (((_a = gate.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = gate.__evaluation.version;
    return $d2f0edd2deb5000b$var$_createExposure($d2f0edd2deb5000b$var$GATE_EXPOSURE_NAME, user, gate.details, metadata, $d2f0edd2deb5000b$var$_mapExposures((_c = (_b = gate.__evaluation) === null || _b === void 0 ? void 0 : _b.secondary_exposures) !== null && _c !== void 0 ? _c : [], exposureMapping));
};
module.exports._createGateExposure = $d2f0edd2deb5000b$var$_createGateExposure;
function $d2f0edd2deb5000b$var$_mapExposures(exposures, exposureMapping) {
    return exposures.map((exposure)=>{
        if (typeof exposure === 'string') return (exposureMapping !== null && exposureMapping !== void 0 ? exposureMapping : {})[exposure];
        return exposure;
    }).filter((exposure)=>exposure != null);
}
module.exports._mapExposures = $d2f0edd2deb5000b$var$_mapExposures;
const $d2f0edd2deb5000b$var$_createConfigExposure = (user, config, exposureMapping)=>{
    var _a, _b, _c, _d;
    const metadata = {
        config: config.name,
        ruleID: config.ruleID
    };
    if (((_a = config.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = config.__evaluation.version;
    if (((_b = config.__evaluation) === null || _b === void 0 ? void 0 : _b.passed) != null) metadata['rulePassed'] = String(config.__evaluation.passed);
    return $d2f0edd2deb5000b$var$_createExposure($d2f0edd2deb5000b$var$CONFIG_EXPOSURE_NAME, user, config.details, metadata, $d2f0edd2deb5000b$var$_mapExposures((_d = (_c = config.__evaluation) === null || _c === void 0 ? void 0 : _c.secondary_exposures) !== null && _d !== void 0 ? _d : [], exposureMapping));
};
module.exports._createConfigExposure = $d2f0edd2deb5000b$var$_createConfigExposure;
const $d2f0edd2deb5000b$var$_createLayerParameterExposure = (user, layer, parameterName, exposureMapping)=>{
    var _a, _b, _c, _d, _e, _f, _g;
    const evaluation = layer.__evaluation;
    const isExplicit = ((_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.explicit_parameters) === null || _a === void 0 ? void 0 : _a.includes(parameterName)) === true;
    let allocatedExperiment = '';
    let secondaryExposures = (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.undelegated_secondary_exposures) !== null && _b !== void 0 ? _b : [];
    if (isExplicit) {
        allocatedExperiment = (_c = evaluation.allocated_experiment_name) !== null && _c !== void 0 ? _c : '';
        secondaryExposures = (_d = evaluation.secondary_exposures) !== null && _d !== void 0 ? _d : [];
    }
    const parameterRuleIDs = (_e = layer.__evaluation) === null || _e === void 0 ? void 0 : _e.parameter_rule_ids;
    const metadata = {
        config: layer.name,
        parameterName: parameterName,
        ruleID: (_f = parameterRuleIDs === null || parameterRuleIDs === void 0 ? void 0 : parameterRuleIDs[parameterName]) !== null && _f !== void 0 ? _f : layer.ruleID,
        allocatedExperiment: allocatedExperiment,
        isExplicitParameter: String(isExplicit)
    };
    if (((_g = layer.__evaluation) === null || _g === void 0 ? void 0 : _g.version) != null) metadata['configVersion'] = layer.__evaluation.version;
    return $d2f0edd2deb5000b$var$_createExposure($d2f0edd2deb5000b$var$LAYER_EXPOSURE_NAME, user, layer.details, metadata, $d2f0edd2deb5000b$var$_mapExposures(secondaryExposures, exposureMapping));
};
module.exports._createLayerParameterExposure = $d2f0edd2deb5000b$var$_createLayerParameterExposure;
const $d2f0edd2deb5000b$var$_addEvaluationDetailsToMetadata = (details, metadata)=>{
    metadata['reason'] = details.reason;
    if (details.lcut) metadata['lcut'] = String(details.lcut);
    if (details.receivedAt) metadata['receivedAt'] = String(details.receivedAt);
    return metadata;
};

});

parcelRegister("97ecK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoggingEnabledOption = module.exports.LogEventCompressionMode = void 0;
module.exports.LogEventCompressionMode = {
    /** Do not compress request bodies */ Disabled: 'd',
    /** Compress request bodies unless a network proxy is configured */ Enabled: 'e',
    /** Always compress request bodies, even when a proxy is configured */ Forced: 'f'
};
module.exports.LoggingEnabledOption = {
    disabled: 'disabled',
    browserOnly: 'browser-only',
    always: 'always'
};

});

parcelRegister("cn2J1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._setObjectInStorage = module.exports._getObjectFromStorage = module.exports.Storage = void 0;

var $69t28 = parcelRequire("69t28");

var $cw4S6 = parcelRequire("cw4S6");
const $9019bf307c935a76$var$inMemoryStore = {};
const $9019bf307c935a76$var$_inMemoryProvider = {
    isReady: ()=>true,
    isReadyResolver: ()=>null,
    getProviderName: ()=>'InMemory',
    getItem: (key)=>$9019bf307c935a76$var$inMemoryStore[key] ? $9019bf307c935a76$var$inMemoryStore[key] : null,
    setItem: (key, value)=>{
        $9019bf307c935a76$var$inMemoryStore[key] = value;
    },
    removeItem: (key)=>{
        delete $9019bf307c935a76$var$inMemoryStore[key];
    },
    getAllKeys: ()=>Object.keys($9019bf307c935a76$var$inMemoryStore)
};
let $9019bf307c935a76$var$_localStorageProvider = null;
try {
    const win = (0, $cw4S6._getWindowSafe)();
    if (win && win.localStorage && typeof win.localStorage.getItem === 'function') $9019bf307c935a76$var$_localStorageProvider = {
        isReady: ()=>true,
        isReadyResolver: ()=>null,
        getProviderName: ()=>'LocalStorage',
        getItem: (key)=>win.localStorage.getItem(key),
        setItem: (key, value)=>win.localStorage.setItem(key, value),
        removeItem: (key)=>win.localStorage.removeItem(key),
        getAllKeys: ()=>Object.keys(win.localStorage)
    };
} catch (error) {
    $69t28.Log.warn('Failed to setup localStorageProvider.');
}
let $9019bf307c935a76$var$_main = $9019bf307c935a76$var$_localStorageProvider !== null && $9019bf307c935a76$var$_localStorageProvider !== void 0 ? $9019bf307c935a76$var$_localStorageProvider : $9019bf307c935a76$var$_inMemoryProvider;
let $9019bf307c935a76$var$_current = $9019bf307c935a76$var$_main;
function $9019bf307c935a76$var$_inMemoryBreaker(action) {
    try {
        return action();
    } catch (error) {
        if (error instanceof Error && error.name === 'SecurityError') {
            module.exports.Storage._setProvider($9019bf307c935a76$var$_inMemoryProvider);
            return null;
        }
        throw error;
    }
}
module.exports.Storage = {
    isReady: ()=>$9019bf307c935a76$var$_current.isReady(),
    isReadyResolver: ()=>$9019bf307c935a76$var$_current.isReadyResolver(),
    getProviderName: ()=>$9019bf307c935a76$var$_current.getProviderName(),
    getItem: (key)=>$9019bf307c935a76$var$_inMemoryBreaker(()=>$9019bf307c935a76$var$_current.getItem(key)),
    setItem: (key, value)=>$9019bf307c935a76$var$_inMemoryBreaker(()=>$9019bf307c935a76$var$_current.setItem(key, value)),
    removeItem: (key)=>$9019bf307c935a76$var$_current.removeItem(key),
    getAllKeys: ()=>$9019bf307c935a76$var$_current.getAllKeys(),
    // StorageProviderManagment
    _setProvider: (newProvider)=>{
        $9019bf307c935a76$var$_main = newProvider;
        $9019bf307c935a76$var$_current = newProvider;
    },
    _setDisabled: (isDisabled)=>{
        if (isDisabled) $9019bf307c935a76$var$_current = $9019bf307c935a76$var$_inMemoryProvider;
        else $9019bf307c935a76$var$_current = $9019bf307c935a76$var$_main;
    }
};
function $9019bf307c935a76$var$_getObjectFromStorage(key) {
    const value = module.exports.Storage.getItem(key);
    try {
        return JSON.parse(value !== null && value !== void 0 ? value : 'null');
    } catch (e) {
        $69t28.Log.error(`Failed to parse value for key "${key}"`);
        return null;
    }
}
module.exports._getObjectFromStorage = $9019bf307c935a76$var$_getObjectFromStorage;
function $9019bf307c935a76$var$_setObjectInStorage(key, obj) {
    module.exports.Storage.setItem(key, JSON.stringify(obj));
}
module.exports._setObjectInStorage = $9019bf307c935a76$var$_setObjectInStorage;

});

parcelRegister("8VIUL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UrlConfiguration = void 0;

var $legJs = parcelRequire("legJs");

var $8XS5H = parcelRequire("8XS5H");
const $68067cb661e9e22c$var$ENDPOINT_DNS_KEY_MAP = {
    [$8XS5H.Endpoint._initialize]: 'i',
    [$8XS5H.Endpoint._rgstr]: 'e',
    [$8XS5H.Endpoint._download_config_specs]: 'd'
};
class $68067cb661e9e22c$var$UrlConfiguration {
    getUrl() {
        var _a;
        return (_a = this.customUrl) !== null && _a !== void 0 ? _a : this.defaultUrl;
    }
    getChecksum() {
        var _a;
        const fallbacks = ((_a = this.fallbackUrls) !== null && _a !== void 0 ? _a : []).sort().join(',');
        return (0, $legJs._DJB2)(this.customUrl + fallbacks);
    }
    constructor(endpoint, customUrl, customApi, fallbackUrls){
        this.customUrl = null;
        this.fallbackUrls = null;
        this.endpoint = endpoint;
        this.endpointDnsKey = $68067cb661e9e22c$var$ENDPOINT_DNS_KEY_MAP[endpoint];
        if (customUrl) this.customUrl = customUrl;
        if (!customUrl && customApi) this.customUrl = customApi.endsWith('/') ? `${customApi}${endpoint}` : `${customApi}/${endpoint}`;
        if (fallbackUrls) this.fallbackUrls = fallbackUrls;
        const defaultApi = $8XS5H.NetworkDefault[endpoint];
        this.defaultUrl = `${defaultApi}/${endpoint}`;
    }
}
module.exports.UrlConfiguration = $68067cb661e9e22c$var$UrlConfiguration;

});

parcelRegister("lnUhG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._notifyVisibilityChanged = module.exports._subscribeToVisiblityChanged = module.exports._isUnloading = module.exports._isCurrentlyVisible = void 0;

var $cw4S6 = parcelRequire("cw4S6");
const $f91767d316df9be0$var$FOREGROUND = 'foreground';
const $f91767d316df9be0$var$BACKGROUND = 'background';
const $f91767d316df9be0$var$LISTENERS = [];
let $f91767d316df9be0$var$current = $f91767d316df9be0$var$FOREGROUND;
let $f91767d316df9be0$var$isUnloading = false;
const $f91767d316df9be0$var$_isCurrentlyVisible = ()=>{
    return $f91767d316df9be0$var$current === $f91767d316df9be0$var$FOREGROUND;
};
module.exports._isCurrentlyVisible = $f91767d316df9be0$var$_isCurrentlyVisible;
const $f91767d316df9be0$var$_isUnloading = ()=>$f91767d316df9be0$var$isUnloading;
module.exports._isUnloading = $f91767d316df9be0$var$_isUnloading;
const $f91767d316df9be0$var$_subscribeToVisiblityChanged = (listener)=>{
    $f91767d316df9be0$var$LISTENERS.unshift(listener);
};
module.exports._subscribeToVisiblityChanged = $f91767d316df9be0$var$_subscribeToVisiblityChanged;
const $f91767d316df9be0$var$_notifyVisibilityChanged = (visibility)=>{
    if (visibility === $f91767d316df9be0$var$current) return;
    $f91767d316df9be0$var$current = visibility;
    $f91767d316df9be0$var$LISTENERS.forEach((l)=>l(visibility));
};
module.exports._notifyVisibilityChanged = $f91767d316df9be0$var$_notifyVisibilityChanged;
(0, $cw4S6._addWindowEventListenerSafe)('focus', ()=>{
    $f91767d316df9be0$var$isUnloading = false;
    (0, module.exports._notifyVisibilityChanged)($f91767d316df9be0$var$FOREGROUND);
});
(0, $cw4S6._addWindowEventListenerSafe)('blur', ()=>(0, module.exports._notifyVisibilityChanged)($f91767d316df9be0$var$BACKGROUND));
(0, $cw4S6._addDocumentEventListenerSafe)('visibilitychange', ()=>{
    (0, module.exports._notifyVisibilityChanged)(document.visibilityState === 'visible' ? $f91767d316df9be0$var$FOREGROUND : $f91767d316df9be0$var$BACKGROUND);
});
(0, $cw4S6._addWindowEventListenerSafe)((0, $cw4S6._getUnloadEvent)(), ()=>{
    $f91767d316df9be0$var$isUnloading = true;
    (0, module.exports._notifyVisibilityChanged)($f91767d316df9be0$var$BACKGROUND);
});

});


parcelRegister("kD2yV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigMetadataProvider = module.exports.SDK_VERSION = void 0;
module.exports.SDK_VERSION = '3.30.2';
let $f04970031c59d840$var$metadata = {
    sdkVersion: module.exports.SDK_VERSION,
    sdkType: 'js-mono'
};
module.exports.StatsigMetadataProvider = {
    get: ()=>$f04970031c59d840$var$metadata,
    add: (additions)=>{
        $f04970031c59d840$var$metadata = Object.assign(Object.assign({}, $f04970031c59d840$var$metadata), additions);
    }
};

});

parcelRegister("exBU4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("9RNM8", function(module, exports) {
"use strict";
var $72efaca03258728b$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeDataAdapterResult = module.exports.DataAdapterCore = void 0;

var $69t28 = parcelRequire("69t28");

var $fpOrS = parcelRequire("fpOrS");

var $5ANbE = parcelRequire("5ANbE");

var $cn2J1 = parcelRequire("cn2J1");

var $80pji = parcelRequire("80pji");
const $72efaca03258728b$var$CACHE_LIMIT = 10;
const $72efaca03258728b$var$MAX_CACHE_WRITE_ATTEMPTS = 8;
class $72efaca03258728b$var$DataAdapterCore {
    attach(sdkKey, options, _network) {
        this._sdkKey = sdkKey;
        this._options = options;
    }
    getDataSync(user) {
        const normalized = user && (0, $5ANbE._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        const inMem = this._inMemoryCache.get(cacheKey, normalized);
        if (inMem && this._getIsCacheValueValid(inMem)) return inMem;
        const cache = this._loadFromCache(cacheKey);
        if (cache && this._getIsCacheValueValid(cache)) {
            this._inMemoryCache.add(cacheKey, cache, this._cacheLimit);
            return this._inMemoryCache.get(cacheKey, normalized);
        }
        return null;
    }
    setData(data, user) {
        const normalized = user && (0, $5ANbE._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        this._inMemoryCache.add(cacheKey, $72efaca03258728b$var$_makeDataAdapterResult('Bootstrap', data, null, normalized), this._cacheLimit);
    }
    _getIsCacheValueValid(current) {
        return current.stableID == null || current.stableID === $fpOrS.StableID.get(this._getSdkKey());
    }
    _getDataAsyncImpl(current, user, options) {
        return $72efaca03258728b$var$__awaiter(this, void 0, void 0, function*() {
            if (!$cn2J1.Storage.isReady()) yield $cn2J1.Storage.isReadyResolver();
            const cache = current !== null && current !== void 0 ? current : this.getDataSync(user);
            const ops = [
                this._fetchAndPrepFromNetwork(cache, user, options)
            ];
            if (options === null || options === void 0 ? void 0 : options.timeoutMs) ops.push(new Promise((r)=>setTimeout(r, options.timeoutMs)).then(()=>{
                $69t28.Log.debug('Fetching latest value timed out');
                return null;
            }));
            return yield Promise.race(ops);
        });
    }
    _prefetchDataImpl(user, options) {
        return $72efaca03258728b$var$__awaiter(this, void 0, void 0, function*() {
            const normalized = user && (0, $5ANbE._normalizeUser)(user, this._options);
            const cacheKey = this._getCacheKey(normalized);
            const result = yield this._getDataAsyncImpl(null, normalized, options);
            if (result) this._inMemoryCache.add(cacheKey, Object.assign(Object.assign({}, result), {
                source: 'Prefetch'
            }), this._cacheLimit);
        });
    }
    _fetchAndPrepFromNetwork(cachedResult, user, options) {
        return $72efaca03258728b$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cachedData = (_a = cachedResult === null || cachedResult === void 0 ? void 0 : cachedResult.data) !== null && _a !== void 0 ? _a : null;
            const isCacheValidFor204 = cachedResult != null && this._isCachedResultValidFor204(cachedResult, user);
            const latest = yield this._fetchFromNetwork(cachedData, user, options, isCacheValidFor204);
            if (!latest) {
                $69t28.Log.debug('No response returned for latest value');
                return null;
            }
            const response = (0, $80pji._typedJsonParse)(latest, 'has_updates', 'Response');
            const sdkKey = this._getSdkKey();
            const stableID = $fpOrS.StableID.get(sdkKey);
            let result = null;
            if ((response === null || response === void 0 ? void 0 : response.has_updates) === true) result = $72efaca03258728b$var$_makeDataAdapterResult('Network', latest, stableID, user);
            else if (cachedData && (response === null || response === void 0 ? void 0 : response.has_updates) === false) result = $72efaca03258728b$var$_makeDataAdapterResult('NetworkNotModified', cachedData, stableID, user);
            else return null;
            const cacheKey = this._getCacheKey(user);
            this._inMemoryCache.add(cacheKey, result, this._cacheLimit);
            this._writeToCache(cacheKey, result);
            return result;
        });
    }
    _getSdkKey() {
        if (this._sdkKey != null) return this._sdkKey;
        $69t28.Log.error(`${this._adapterName} is not attached to a Client`);
        return '';
    }
    _loadFromCache(cacheKey) {
        var _a;
        const cache = (_a = $cn2J1.Storage.getItem) === null || _a === void 0 ? void 0 : _a.call($cn2J1.Storage, cacheKey);
        if (cache == null) return null;
        const result = (0, $80pji._typedJsonParse)(cache, 'source', 'Cached Result');
        return result ? Object.assign(Object.assign({}, result), {
            source: 'Cache'
        }) : null;
    }
    _writeToCache(cacheKey, result) {
        const resultString = JSON.stringify(result);
        for(let i = 0; i < $72efaca03258728b$var$MAX_CACHE_WRITE_ATTEMPTS; i++)try {
            $cn2J1.Storage.setItem(cacheKey, resultString);
            break;
        } catch (error) {
            if (!(error instanceof Error) || !(error.toString().includes('QuotaExceededError') || error.toString().includes('QUOTA_EXCEEDED_ERR')) || this._cacheLimit <= 1) throw error;
            this._cacheLimit = Math.ceil(this._cacheLimit / 2);
            this._runLocalStorageCacheEviction(cacheKey, this._cacheLimit - 1);
        }
        this._runLocalStorageCacheEviction(cacheKey);
    }
    _runLocalStorageCacheEviction(cacheKey, cacheLimit = this._cacheLimit) {
        var _a;
        const lastModifiedTimeMap = (_a = (0, $cn2J1._getObjectFromStorage)(this._lastModifiedStoreKey)) !== null && _a !== void 0 ? _a : {};
        lastModifiedTimeMap[cacheKey] = Date.now();
        const evictableKeys = $72efaca03258728b$var$_getEvictableKeys(lastModifiedTimeMap, cacheLimit);
        for (const evictable of evictableKeys){
            delete lastModifiedTimeMap[evictable];
            $cn2J1.Storage.removeItem(evictable);
        }
        (0, $cn2J1._setObjectInStorage)(this._lastModifiedStoreKey, lastModifiedTimeMap);
    }
    constructor(_adapterName, _cacheSuffix){
        this._adapterName = _adapterName;
        this._cacheSuffix = _cacheSuffix;
        this._options = null;
        this._sdkKey = null;
        this._cacheLimit = $72efaca03258728b$var$CACHE_LIMIT;
        this._lastModifiedStoreKey = `statsig.last_modified_time.${_cacheSuffix}`;
        this._inMemoryCache = new $72efaca03258728b$var$InMemoryCache();
    }
}
module.exports.DataAdapterCore = $72efaca03258728b$var$DataAdapterCore;
function $72efaca03258728b$var$_makeDataAdapterResult(source, data, stableID, user) {
    return {
        source: source,
        data: data,
        receivedAt: Date.now(),
        stableID: stableID,
        fullUserHash: (0, $5ANbE._getFullUserHash)(user)
    };
}
module.exports._makeDataAdapterResult = $72efaca03258728b$var$_makeDataAdapterResult;
class $72efaca03258728b$var$InMemoryCache {
    get(cacheKey, user) {
        var _a;
        const result = this._data[cacheKey];
        const cached = result === null || result === void 0 ? void 0 : result.stableID;
        const provided = (_a = user === null || user === void 0 ? void 0 : user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (provided && cached && provided !== cached) {
            $69t28.Log.warn("'StatsigUser.customIDs.stableID' mismatch");
            return null;
        }
        return result;
    }
    add(cacheKey, value, cacheLimit) {
        const evictableKeys = $72efaca03258728b$var$_getEvictableKeys(this._data, cacheLimit - 1);
        for (const evictable of evictableKeys)delete this._data[evictable];
        this._data[cacheKey] = value;
    }
    merge(values) {
        this._data = Object.assign(Object.assign({}, this._data), values);
    }
    constructor(){
        this._data = {};
    }
}
function $72efaca03258728b$var$_getEvictableKeys(data, limit) {
    const keys = Object.keys(data);
    if (keys.length <= limit) return [];
    if (limit === 0) return keys;
    return keys.sort((keyA, keyB)=>{
        const valueA = data[keyA];
        const valueB = data[keyB];
        if (typeof valueA === 'object' && typeof valueB === 'object') return valueA.receivedAt - valueB.receivedAt;
        return valueA - valueB;
    }).slice(0, keys.length - limit);
}

});
parcelRegister("fpOrS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getCookieName = module.exports.StableID = void 0;

var $foCb2 = parcelRequire("foCb2");

var $69t28 = parcelRequire("69t28");

var $cw4S6 = parcelRequire("cw4S6");

var $cn2J1 = parcelRequire("cn2J1");

var $1lhbi = parcelRequire("1lhbi");
const $b39052df2e5d3c82$var$PROMISE_MAP = {};
const $b39052df2e5d3c82$var$COOKIE_ENABLED_MAP = {};
const $b39052df2e5d3c82$var$DISABLED_MAP = {};
module.exports.StableID = {
    cookiesEnabled: false,
    randomID: Math.random().toString(36),
    get: (sdkKey)=>{
        if ($b39052df2e5d3c82$var$DISABLED_MAP[sdkKey]) return null;
        if ($b39052df2e5d3c82$var$PROMISE_MAP[sdkKey] != null) return $b39052df2e5d3c82$var$PROMISE_MAP[sdkKey];
        let stableID = null;
        stableID = $b39052df2e5d3c82$var$_loadFromCookie(sdkKey);
        if (stableID != null) {
            $b39052df2e5d3c82$var$PROMISE_MAP[sdkKey] = stableID;
            $b39052df2e5d3c82$var$_persistToStorage(stableID, sdkKey);
            return stableID;
        }
        stableID = $b39052df2e5d3c82$var$_loadFromStorage(sdkKey);
        if (stableID == null) stableID = (0, $1lhbi.getUUID)();
        $b39052df2e5d3c82$var$_persistToStorage(stableID, sdkKey);
        $b39052df2e5d3c82$var$_persistToCookie(stableID, sdkKey);
        $b39052df2e5d3c82$var$PROMISE_MAP[sdkKey] = stableID;
        return stableID;
    },
    setOverride: (override, sdkKey)=>{
        $b39052df2e5d3c82$var$PROMISE_MAP[sdkKey] = override;
        $b39052df2e5d3c82$var$_persistToStorage(override, sdkKey);
        $b39052df2e5d3c82$var$_persistToCookie(override, sdkKey);
    },
    _setCookiesEnabled: (sdkKey, cookiesEnabled)=>{
        $b39052df2e5d3c82$var$COOKIE_ENABLED_MAP[sdkKey] = cookiesEnabled;
    },
    _setDisabled: (sdkKey, disabled)=>{
        $b39052df2e5d3c82$var$DISABLED_MAP[sdkKey] = disabled;
    }
};
function $b39052df2e5d3c82$var$_getStableIDStorageKey(sdkKey) {
    return `statsig.stable_id.${(0, $foCb2._getStorageKey)(sdkKey)}`;
}
function $b39052df2e5d3c82$var$_persistToStorage(stableID, sdkKey) {
    const storageKey = $b39052df2e5d3c82$var$_getStableIDStorageKey(sdkKey);
    try {
        (0, $cn2J1._setObjectInStorage)(storageKey, stableID);
    } catch (e) {
        $69t28.Log.warn('Failed to save StableID to storage');
    }
}
function $b39052df2e5d3c82$var$_loadFromStorage(sdkKey) {
    const storageKey = $b39052df2e5d3c82$var$_getStableIDStorageKey(sdkKey);
    return (0, $cn2J1._getObjectFromStorage)(storageKey);
}
function $b39052df2e5d3c82$var$_loadFromCookie(sdkKey) {
    if (!$b39052df2e5d3c82$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $cw4S6._getDocumentSafe)() == null) return null;
    const cookies = document.cookie.split(';');
    for (const cookie of cookies){
        const [key, value] = cookie.trim().split('=');
        if (key === $b39052df2e5d3c82$var$getCookieName(sdkKey)) return decodeURIComponent(value);
    }
    return null;
}
function $b39052df2e5d3c82$var$_persistToCookie(stableID, sdkKey) {
    if (!$b39052df2e5d3c82$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $cw4S6._getDocumentSafe)() == null) return;
    const expiryDate = new Date();
    expiryDate.setFullYear(expiryDate.getFullYear() + 1);
    document.cookie = `${$b39052df2e5d3c82$var$getCookieName(sdkKey)}=${encodeURIComponent(stableID)}; expires=${expiryDate.toUTCString()}; path=/`;
}
function $b39052df2e5d3c82$var$getCookieName(sdkKey) {
    return `statsig.stable_id.${(0, $foCb2._getStorageKey)(sdkKey)}`;
}
module.exports.getCookieName = $b39052df2e5d3c82$var$getCookieName;

});
parcelRegister("1lhbi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getUUID = void 0;
function $0fa5146c362a3f84$var$getUUID() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
    let d = new Date().getTime();
    let d2 = typeof performance !== 'undefined' && performance.now && performance.now() * 1000 || 0;
    const y = '89ab'[Math.floor(Math.random() * 4)];
    return `xxxxxxxx-xxxx-4xxx-${y}xxx-xxxxxxxxxxxx`.replace(/[xy]/g, (c)=>{
        let r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === 'x' ? r : r & 0x7 | 0x8).toString(16);
    });
}
module.exports.getUUID = $0fa5146c362a3f84$var$getUUID;

});


parcelRegister("5ANbE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getFullUserHash = module.exports._normalizeUser = void 0;

var $legJs = parcelRequire("legJs");

var $69t28 = parcelRequire("69t28");
function $4126780e597715de$var$_normalizeUser(original, options, fallbackEnvironment) {
    try {
        const copy = JSON.parse(JSON.stringify(original));
        if (options != null && options.environment != null) copy.statsigEnvironment = options.environment;
        else if (fallbackEnvironment != null) copy.statsigEnvironment = {
            tier: fallbackEnvironment
        };
        return copy;
    } catch (error) {
        $69t28.Log.error('Failed to JSON.stringify user');
        return {
            statsigEnvironment: undefined
        };
    }
}
module.exports._normalizeUser = $4126780e597715de$var$_normalizeUser;
function $4126780e597715de$var$_getFullUserHash(user) {
    return user ? (0, $legJs._DJB2Object)(user) : null;
}
module.exports._getFullUserHash = $4126780e597715de$var$_getFullUserHash;

});

parcelRegister("80pji", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._typedJsonParse = void 0;

var $69t28 = parcelRequire("69t28");
/**
 *
 * @param {string} data The values to parse into T
 * @param {string} guard A field that must exists on the parsed object for the parse to be valid
 * @param {string} error An error to print via Log.error() when parsing fails
 * @returns {T | null} The parse object T or null if it failed
 */ function $5d41f4e06b888de3$var$_typedJsonParse(data, guard, typeName) {
    try {
        const result = JSON.parse(data);
        if (result && typeof result === 'object' && guard in result) return result;
    } catch (_a) {
    // noop
    }
    $69t28.Log.error(`Failed to parse ${typeName}`);
    return null;
}
module.exports._typedJsonParse = $5d41f4e06b888de3$var$_typedJsonParse;

});


parcelRegister("8Q4td", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("1wXH6", function(module, exports) {
"use strict";
var $11d7159e5edf5611$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorBoundary = module.exports.EXCEPTION_ENDPOINT = void 0;

var $69t28 = parcelRequire("69t28");

var $hQOsi = parcelRequire("hQOsi");

var $kD2yV = parcelRequire("kD2yV");
module.exports.EXCEPTION_ENDPOINT = 'https://statsigapi.net/v1/sdk_exception';
const $11d7159e5edf5611$var$UNKNOWN_ERROR = '[Statsig] UnknownError';
class $11d7159e5edf5611$var$ErrorBoundary {
    wrap(instance, namePrefix) {
        try {
            const obj = instance;
            $11d7159e5edf5611$var$_getAllInstanceMethodNames(obj).forEach((name)=>{
                const original = obj[name];
                if ('$EB' in original) return;
                obj[name] = (...args)=>{
                    return this._capture(namePrefix ? `${namePrefix}:${name}` : name, ()=>original.apply(instance, args));
                };
                obj[name].$EB = true;
            });
        } catch (err) {
            this._onError('eb:wrap', err);
        }
    }
    logError(tag, error) {
        this._onError(tag, error);
    }
    getLastSeenErrorAndReset() {
        const tempError = this._lastSeenError;
        this._lastSeenError = undefined;
        return tempError !== null && tempError !== void 0 ? tempError : null;
    }
    attachErrorIfNoneExists(error) {
        if (this._lastSeenError) return;
        this._lastSeenError = $11d7159e5edf5611$var$_resolveError(error);
    }
    _capture(tag, task) {
        try {
            const res = task();
            if (res && res instanceof Promise) return res.catch((err)=>this._onError(tag, err));
            return res;
        } catch (error) {
            this._onError(tag, error);
            return null;
        }
    }
    _onError(tag, error) {
        try {
            $69t28.Log.warn(`Caught error in ${tag}`, {
                error: error
            });
            const impl = ()=>$11d7159e5edf5611$var$__awaiter(this, void 0, void 0, function*() {
                    var _a, _b, _c, _d, _e, _f, _g;
                    const unwrapped = error ? error : Error($11d7159e5edf5611$var$UNKNOWN_ERROR);
                    const isError = unwrapped instanceof Error;
                    const name = isError ? unwrapped.name : 'No Name';
                    const resolvedError = $11d7159e5edf5611$var$_resolveError(unwrapped);
                    this._lastSeenError = resolvedError;
                    if (this._seen.has(name)) return;
                    this._seen.add(name);
                    if ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.preventAllNetworkTraffic) {
                        (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                            name: 'error',
                            error: error,
                            tag: tag
                        });
                        return;
                    }
                    const sdkType = $hQOsi.SDKType._get(this._sdkKey);
                    const statsigMetadata = $kD2yV.StatsigMetadataProvider.get();
                    const info = isError ? unwrapped.stack : $11d7159e5edf5611$var$_getDescription(unwrapped);
                    const body = Object.assign({
                        tag: tag,
                        exception: name,
                        info: info,
                        statsigOptions: $11d7159e5edf5611$var$_getStatsigOptionLoggingCopy(this._options)
                    }, Object.assign(Object.assign({}, statsigMetadata), {
                        sdkType: sdkType
                    }));
                    const func = (_f = (_e = (_d = this._options) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.networkOverrideFunc) !== null && _f !== void 0 ? _f : fetch;
                    yield func(module.exports.EXCEPTION_ENDPOINT, {
                        method: 'POST',
                        headers: {
                            'STATSIG-API-KEY': this._sdkKey,
                            'STATSIG-SDK-TYPE': String(sdkType),
                            'STATSIG-SDK-VERSION': String(statsigMetadata.sdkVersion),
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(body)
                    });
                    (_g = this._emitter) === null || _g === void 0 || _g.call(this, {
                        name: 'error',
                        error: error,
                        tag: tag
                    });
                });
            impl().then(()=>{
            /* noop */ }).catch(()=>{
            /* noop */ });
        } catch (_error) {
        /* noop */ }
    }
    constructor(_sdkKey, _options, _emitter, _lastSeenError){
        this._sdkKey = _sdkKey;
        this._options = _options;
        this._emitter = _emitter;
        this._lastSeenError = _lastSeenError;
        this._seen = new Set();
    }
}
module.exports.ErrorBoundary = $11d7159e5edf5611$var$ErrorBoundary;
function $11d7159e5edf5611$var$_resolveError(error) {
    if (error instanceof Error) return error;
    else if (typeof error === 'string') return new Error(error);
    else return new Error('An unknown error occurred.');
}
function $11d7159e5edf5611$var$_getDescription(obj) {
    try {
        return JSON.stringify(obj);
    } catch (_a) {
        return $11d7159e5edf5611$var$UNKNOWN_ERROR;
    }
}
function $11d7159e5edf5611$var$_getAllInstanceMethodNames(instance) {
    const names = new Set();
    let proto = Object.getPrototypeOf(instance);
    while(proto && proto !== Object.prototype){
        Object.getOwnPropertyNames(proto).filter((prop)=>typeof (proto === null || proto === void 0 ? void 0 : proto[prop]) === 'function').forEach((name)=>names.add(name));
        proto = Object.getPrototypeOf(proto);
    }
    return Array.from(names);
}
function $11d7159e5edf5611$var$_getStatsigOptionLoggingCopy(options) {
    if (!options) return {};
    const loggingCopy = {};
    Object.keys(options).forEach((key)=>{
        const option = key;
        const value = options[option];
        const valueType = typeof value;
        switch(valueType){
            case 'number':
            case 'bigint':
            case 'boolean':
                loggingCopy[String(option)] = value;
                break;
            case 'string':
                if (value.length < 50) loggingCopy[String(option)] = value;
                else loggingCopy[String(option)] = 'set';
                break;
            case 'object':
                if (option === 'environment') loggingCopy['environment'] = value;
                else if (option === 'networkConfig') loggingCopy['networkConfig'] = value;
                else loggingCopy[String(option)] = value != null ? 'set' : 'unset';
                break;
            default:
        }
    });
    return loggingCopy;
}

});
parcelRegister("hQOsi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKType = void 0;
const $cfee6e686bad228a$var$SDK_CLIENT = {};
let $cfee6e686bad228a$var$suffix;
module.exports.SDKType = {
    _get: (sdkKey)=>{
        var _a;
        return ((_a = $cfee6e686bad228a$var$SDK_CLIENT[sdkKey]) !== null && _a !== void 0 ? _a : 'js-mono') + ($cfee6e686bad228a$var$suffix !== null && $cfee6e686bad228a$var$suffix !== void 0 ? $cfee6e686bad228a$var$suffix : '');
    },
    _setClientType (sdkKey, client) {
        $cfee6e686bad228a$var$SDK_CLIENT[sdkKey] = client;
    },
    _setBindingType (binding) {
        if (!$cfee6e686bad228a$var$suffix || $cfee6e686bad228a$var$suffix === '-react') $cfee6e686bad228a$var$suffix = '-' + binding;
    }
};

});


parcelRegister("ATVsX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("dxE3d", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("7w1Zp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("lmFrl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createMemoKey = module.exports.MemoPrefix = void 0;
module.exports.MemoPrefix = {
    _gate: 'g',
    _dynamicConfig: 'c',
    _experiment: 'e',
    _configList: 'cl',
    _layer: 'l',
    _paramStore: 'p'
};
const $f8dbcc30ba8e8135$var$EXIST_KEYS = new Set([]);
const $f8dbcc30ba8e8135$var$DO_NOT_MEMO_KEYS = new Set([
    // Add keys that if exist, should not be memoized
    'userPersistedValues'
]);
function $f8dbcc30ba8e8135$var$createMemoKey(prefix, name, options) {
    let cacheKey = `${prefix}|${name}`;
    if (!options) return cacheKey;
    for (const key of Object.keys(options)){
        if ($f8dbcc30ba8e8135$var$DO_NOT_MEMO_KEYS.has(key)) return undefined;
        if ($f8dbcc30ba8e8135$var$EXIST_KEYS.has(key)) cacheKey += `|${key}=true`;
        else cacheKey += `|${key}=${options[key]}`;
    }
    return cacheKey;
}
module.exports.createMemoKey = $f8dbcc30ba8e8135$var$createMemoKey;

});

parcelRegister("7GnX2", function(module, exports) {
"use strict";
var $597f08df22350785$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkCore = void 0;

var $jEilP = parcelRequire("jEilP");

var $jEilP = parcelRequire("jEilP");

var $gEK5A = parcelRequire("gEK5A");

var $69t28 = parcelRequire("69t28");

var $8XS5H = parcelRequire("8XS5H");

var $2vAL0 = parcelRequire("2vAL0");

var $3Sk5Y = parcelRequire("3Sk5Y");

var $hQOsi = parcelRequire("hQOsi");

var $cw4S6 = parcelRequire("cw4S6");

var $gXcI4 = parcelRequire("gXcI4");

var $fpOrS = parcelRequire("fpOrS");

var $93F2z = parcelRequire("93F2z");

var $kD2yV = parcelRequire("kD2yV");

var $97ecK = parcelRequire("97ecK");

var $lnUhG = parcelRequire("lnUhG");
const $597f08df22350785$var$DEFAULT_TIMEOUT_MS = 10000;
const $597f08df22350785$var$BACKOFF_BASE_MS = 500;
const $597f08df22350785$var$BACKOFF_MAX_MS = 30000;
const $597f08df22350785$var$RATE_LIMIT_WINDOW_MS = 1000;
const $597f08df22350785$var$RATE_LIMIT_MAX_REQ_COUNT = 50;
const $597f08df22350785$var$LEAK_RATE = $597f08df22350785$var$RATE_LIMIT_MAX_REQ_COUNT / $597f08df22350785$var$RATE_LIMIT_WINDOW_MS;
const $597f08df22350785$var$RETRYABLE_CODES = new Set([
    408,
    500,
    502,
    503,
    504,
    522,
    524,
    599
]);
class $597f08df22350785$var$NetworkCore {
    setLogEventCompressionMode(mode) {
        this._options.logEventCompressionMode = mode;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(this._fallbackResolver);
        this._fallbackResolver.setErrorBoundary(errorBoundary);
    }
    isBeaconSupported() {
        return typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function';
    }
    getLastUsedInitUrlAndReset() {
        const tempUrl = this._lastUsedInitUrl;
        this._lastUsedInitUrl = null;
        return tempUrl;
    }
    beacon(args) {
        if (!$597f08df22350785$var$_ensureValidSdkKey(args)) return false;
        const argsInternal = this._getInternalRequestArgs('POST', args);
        const url = this._getPopulatedURL(argsInternal);
        const nav = navigator;
        return nav.sendBeacon.bind(nav)(url, argsInternal.body);
    }
    post(args) {
        return $597f08df22350785$var$__awaiter(this, void 0, void 0, function*() {
            const argsInternal = this._getInternalRequestArgs('POST', args);
            this._tryEncodeBody(argsInternal);
            yield this._tryToCompressBody(argsInternal);
            return this._sendRequest(argsInternal);
        });
    }
    get(args) {
        const argsInternal = this._getInternalRequestArgs('GET', args);
        return this._sendRequest(argsInternal);
    }
    _sendRequest(args) {
        return $597f08df22350785$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d;
            if (!$597f08df22350785$var$_ensureValidSdkKey(args)) return null;
            if (this._netConfig.preventAllNetworkTraffic) return null;
            const { method: method, body: body, retries: retries, attempt: attempt } = args;
            const endpoint = args.urlConfig.endpoint;
            if (this._isRateLimited(endpoint)) {
                $69t28.Log.warn(`Request to ${endpoint} was blocked because you are making requests too frequently.`);
                return null;
            }
            const currentAttempt = attempt !== null && attempt !== void 0 ? attempt : 1;
            let reqTimedOut = false;
            const populatedUrl = this._getPopulatedURL(args);
            let response = null;
            const keepalive = (0, $lnUhG._isUnloading)();
            try {
                const config = {
                    method: method,
                    body: body,
                    headers: Object.assign({}, args.headers),
                    priority: args.priority,
                    keepalive: keepalive
                };
                $597f08df22350785$var$_tryMarkInitStart(args, currentAttempt);
                const bucket = this._leakyBucket[endpoint];
                if (bucket) {
                    bucket.lastRequestTime = Date.now();
                    this._leakyBucket[endpoint] = bucket;
                }
                const func = (_a = this._netConfig.networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch;
                let timeoutId;
                response = yield Promise.race([
                    func(populatedUrl, config).finally(()=>clearTimeout(timeoutId)),
                    new Promise((_, reject)=>{
                        timeoutId = setTimeout(()=>{
                            reqTimedOut = true;
                            reject(new Error(`Timeout of ${this._timeout}ms expired.`));
                        }, this._timeout);
                    })
                ]);
                if (!response.ok) {
                    const text = yield response.text().catch(()=>'No Text');
                    const err = new Error(`NetworkError: ${populatedUrl} ${text}`);
                    err.name = 'NetworkError';
                    throw err;
                }
                const text = yield response.text();
                $597f08df22350785$var$_tryMarkInitEnd(args, response, currentAttempt, text);
                this._fallbackResolver.tryBumpExpiryTime(args.sdkKey, args.urlConfig);
                return {
                    body: text,
                    code: response.status
                };
            } catch (error) {
                const errorMessage = $597f08df22350785$var$_getErrorMessage(error);
                const timedOut = $597f08df22350785$var$_didTimeout(errorMessage !== null && errorMessage !== void 0 ? errorMessage : '', reqTimedOut);
                $597f08df22350785$var$_tryMarkInitEnd(args, response, currentAttempt, '', error);
                const fallbackUpdated = yield this._fallbackResolver.tryFetchUpdatedFallbackInfo(args.sdkKey, args.urlConfig, errorMessage, timedOut);
                if (fallbackUpdated) args.fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
                if (!retries || currentAttempt > retries || !$597f08df22350785$var$RETRYABLE_CODES.has((_b = response === null || response === void 0 ? void 0 : response.status) !== null && _b !== void 0 ? _b : 500)) {
                    (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                        name: 'error',
                        error: error,
                        tag: $93F2z.ErrorTag.NetworkError,
                        requestArgs: args
                    });
                    const formattedErrorMsg = `A networking error occurred during ${method} request to ${populatedUrl}.`;
                    $69t28.Log.error(formattedErrorMsg, errorMessage, error);
                    (_d = this._errorBoundary) === null || _d === void 0 || _d.attachErrorIfNoneExists(formattedErrorMsg);
                    return null;
                }
                yield $597f08df22350785$var$_exponentialBackoff(currentAttempt);
                return this._sendRequest(Object.assign(Object.assign({}, args), {
                    retries: retries,
                    attempt: currentAttempt + 1
                }));
            }
        });
    }
    _getLogEventCompressionMode(options) {
        // Handle backward compatibility for deprecated disableCompression flag
        let compressionMode = options === null || options === void 0 ? void 0 : options.logEventCompressionMode;
        if (!compressionMode && (options === null || options === void 0 ? void 0 : options.disableCompression) === true) compressionMode = $97ecK.LogEventCompressionMode.Disabled;
        // Default to enabled if unset
        if (!compressionMode) compressionMode = $97ecK.LogEventCompressionMode.Enabled;
        return compressionMode;
    }
    _isRateLimited(endpoint) {
        var _a;
        const now = Date.now();
        const bucket = (_a = this._leakyBucket[endpoint]) !== null && _a !== void 0 ? _a : {
            count: 0,
            lastRequestTime: now
        };
        const elapsed = now - bucket.lastRequestTime;
        const leakedRequests = Math.floor(elapsed * $597f08df22350785$var$LEAK_RATE);
        bucket.count = Math.max(0, bucket.count - leakedRequests);
        if (bucket.count >= $597f08df22350785$var$RATE_LIMIT_MAX_REQ_COUNT) return true;
        bucket.count += 1;
        bucket.lastRequestTime = now;
        this._leakyBucket[endpoint] = bucket;
        return false;
    }
    _getPopulatedURL(args) {
        var _a;
        const url = (_a = args.fallbackUrl) !== null && _a !== void 0 ? _a : args.urlConfig.getUrl();
        if (args.urlConfig.endpoint === $8XS5H.Endpoint._initialize || args.urlConfig.endpoint === $8XS5H.Endpoint._download_config_specs) this._lastUsedInitUrl = url;
        const params = Object.assign({
            [$8XS5H.NetworkParam.SdkKey]: args.sdkKey,
            [$8XS5H.NetworkParam.SdkType]: $hQOsi.SDKType._get(args.sdkKey),
            [$8XS5H.NetworkParam.SdkVersion]: $kD2yV.SDK_VERSION,
            [$8XS5H.NetworkParam.Time]: String(Date.now()),
            [$8XS5H.NetworkParam.SessionID]: $gXcI4.SessionID.get(args.sdkKey)
        }, args.params);
        const query = Object.keys(params).map((key)=>{
            return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
        }).join('&');
        return `${url}${query ? `?${query}` : ''}`;
    }
    _tryEncodeBody(args) {
        var _a;
        const win = (0, $cw4S6._getWindowSafe)();
        const body = args.body;
        if (!args.isStatsigEncodable || this._options.disableStatsigEncoding || typeof body !== 'string' || (0, $jEilP._getStatsigGlobalFlag)('no-encode') != null || !(win === null || win === void 0 ? void 0 : win.btoa)) return;
        try {
            args.body = win.btoa(body).split('').reverse().join('');
            args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                [$8XS5H.NetworkParam.StatsigEncoded]: '1'
            });
        } catch (e) {
            $69t28.Log.warn(`Request encoding failed for ${args.urlConfig.getUrl()}`, e);
        }
    }
    _tryToCompressBody(args) {
        return $597f08df22350785$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const body = args.body;
            if (typeof body !== 'string' || !$597f08df22350785$var$_allowCompression(args, this._options)) return;
            try {
                const bytes = new TextEncoder().encode(body);
                const stream = new CompressionStream('gzip');
                const writer = stream.writable.getWriter();
                writer.write(bytes).catch($69t28.Log.error);
                writer.close().catch($69t28.Log.error);
                const reader = stream.readable.getReader();
                const chunks = [];
                let result;
                // eslint-disable-next-line no-await-in-loop
                while(!(result = yield reader.read()).done)chunks.push(result.value);
                const totalLength = chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
                const combined = new Uint8Array(totalLength);
                let offset = 0;
                for (const chunk of chunks){
                    combined.set(chunk, offset);
                    offset += chunk.length;
                }
                args.body = combined;
                args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                    [$8XS5H.NetworkParam.IsGzipped]: '1'
                });
            } catch (e) {
                $69t28.Log.warn(`Request compression failed for ${args.urlConfig.getUrl()}`, e);
            }
        });
    }
    _getInternalRequestArgs(method, args) {
        const fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
        const result = Object.assign(Object.assign({}, args), {
            method: method,
            fallbackUrl: fallbackUrl
        });
        if ('data' in args) $597f08df22350785$var$_populateRequestBody(result, args.data);
        return result;
    }
    constructor(options, _emitter){
        this._emitter = _emitter;
        this._errorBoundary = null;
        this._timeout = $597f08df22350785$var$DEFAULT_TIMEOUT_MS;
        this._netConfig = {};
        this._options = {};
        this._leakyBucket = {};
        this._lastUsedInitUrl = null;
        if (options) this._options = options;
        if (this._options.networkConfig) this._netConfig = this._options.networkConfig;
        if (this._netConfig.networkTimeoutMs) this._timeout = this._netConfig.networkTimeoutMs;
        this._fallbackResolver = new $2vAL0.NetworkFallbackResolver(this._options);
        this.setLogEventCompressionMode(this._getLogEventCompressionMode(options));
    }
}
module.exports.NetworkCore = $597f08df22350785$var$NetworkCore;
const $597f08df22350785$var$_ensureValidSdkKey = (args)=>{
    if (!args.sdkKey) {
        $69t28.Log.warn('Unable to make request without an SDK key');
        return false;
    }
    return true;
};
const $597f08df22350785$var$_populateRequestBody = (args, data)=>{
    const { sdkKey: sdkKey, fallbackUrl: fallbackUrl } = args;
    const stableID = $fpOrS.StableID.get(sdkKey);
    const sessionID = $gXcI4.SessionID.get(sdkKey);
    const sdkType = $hQOsi.SDKType._get(sdkKey);
    args.body = JSON.stringify(Object.assign(Object.assign({}, data), {
        statsigMetadata: Object.assign(Object.assign({}, $kD2yV.StatsigMetadataProvider.get()), {
            stableID: stableID,
            sessionID: sessionID,
            sdkType: sdkType,
            fallbackUrl: fallbackUrl
        })
    }));
};
function $597f08df22350785$var$_allowCompression(args, options) {
    if (!args.isCompressable) return false;
    // Never compress if 'no-compress' is set globally or required APIs are unavailable
    if ((0, $jEilP._getStatsigGlobalFlag)('no-compress') != null || typeof CompressionStream === 'undefined' || typeof TextEncoder === 'undefined') return false;
    const isProxy = args.urlConfig.customUrl != null || args.urlConfig.fallbackUrls != null;
    const flagEnabled = $3Sk5Y.SDKFlags.get(args.sdkKey, 'enable_log_event_compression') === true;
    switch(options.logEventCompressionMode){
        case $97ecK.LogEventCompressionMode.Disabled:
            return false;
        case $97ecK.LogEventCompressionMode.Enabled:
            // Only compress through proxy if flag is explicitly on
            if (isProxy && !flagEnabled) return false;
            return true;
        case $97ecK.LogEventCompressionMode.Forced:
            return true;
        default:
            return false;
    }
}
function $597f08df22350785$var$_getErrorMessage(error) {
    if (typeof error === 'string') return error;
    if (error instanceof Error) return `${error.name}: ${error.message}`;
    return 'Unknown Error';
}
function $597f08df22350785$var$_didTimeout(errorMsg, abortedByTimeout) {
    const timeout = errorMsg.includes('Timeout'); // probably not needed but just in case
    return timeout || abortedByTimeout;
}
function $597f08df22350785$var$_tryMarkInitStart(args, attempt) {
    if (args.urlConfig.endpoint !== $8XS5H.Endpoint._initialize) return;
    $gEK5A.Diagnostics._markInitNetworkReqStart(args.sdkKey, {
        attempt: attempt
    });
}
function $597f08df22350785$var$_tryMarkInitEnd(args, response, attempt, body, err) {
    if (args.urlConfig.endpoint !== $8XS5H.Endpoint._initialize) return;
    $gEK5A.Diagnostics._markInitNetworkReqEnd(args.sdkKey, $gEK5A.Diagnostics._getDiagnosticsData(response, attempt, body, err));
}
function $597f08df22350785$var$_exponentialBackoff(attempt) {
    return $597f08df22350785$var$__awaiter(this, void 0, void 0, function*() {
        // 1*1*1000 1s
        // 2*2*1000 4s
        // 3*3*1000 9s
        // 4*4*1000 16s
        // 5*5*1000 25s
        yield new Promise((r)=>setTimeout(r, Math.min($597f08df22350785$var$BACKOFF_BASE_MS * (attempt * attempt), $597f08df22350785$var$BACKOFF_MAX_MS)));
    });
}

});
parcelRegister("2vAL0", function(module, exports) {
"use strict";
var $1d3afd37ba42c9d1$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isDomainFailure = module.exports.NetworkFallbackResolver = void 0;

var $EqMVr = parcelRequire("EqMVr");

var $legJs = parcelRequire("legJs");

var $69t28 = parcelRequire("69t28");

var $cn2J1 = parcelRequire("cn2J1");
const $1d3afd37ba42c9d1$var$DEFAULT_TTL_MS = 604800000; // 7 days
const $1d3afd37ba42c9d1$var$COOLDOWN_TIME_MS = 14400000; // 4 hours
class $1d3afd37ba42c9d1$var$NetworkFallbackResolver {
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
    }
    tryBumpExpiryTime(sdkKey, urlConfig) {
        var _a;
        const info = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint];
        if (!info) return;
        info.expiryTime = Date.now() + $1d3afd37ba42c9d1$var$DEFAULT_TTL_MS;
        $1d3afd37ba42c9d1$var$_tryWriteFallbackInfoToCache(sdkKey, Object.assign(Object.assign({}, this._fallbackInfo), {
            [urlConfig.endpoint]: info
        }));
    }
    getActiveFallbackUrl(sdkKey, urlConfig) {
        var _a, _b;
        if (urlConfig.customUrl != null && urlConfig.fallbackUrls != null) return null;
        let info = this._fallbackInfo;
        if (info == null) {
            info = (_a = $1d3afd37ba42c9d1$var$_readFallbackInfoFromCache(sdkKey)) !== null && _a !== void 0 ? _a : {};
            this._fallbackInfo = info;
        }
        const entry = info[urlConfig.endpoint];
        if (!entry || Date.now() > ((_b = entry.expiryTime) !== null && _b !== void 0 ? _b : 0) || urlConfig.getChecksum() !== entry.urlConfigChecksum) {
            delete info[urlConfig.endpoint];
            this._fallbackInfo = info;
            $1d3afd37ba42c9d1$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
            return null;
        }
        if (entry.url) return entry.url;
        return null;
    }
    tryFetchUpdatedFallbackInfo(sdkKey, urlConfig, errorMessage, timedOut) {
        return $1d3afd37ba42c9d1$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            try {
                if (!$1d3afd37ba42c9d1$var$_isDomainFailure(errorMessage, timedOut)) return false;
                const canUseNetworkFallbacks = urlConfig.customUrl == null && urlConfig.fallbackUrls == null;
                const urls = canUseNetworkFallbacks ? yield this._tryFetchFallbackUrlsFromNetwork(urlConfig) : urlConfig.fallbackUrls;
                const newUrl = this._pickNewFallbackUrl((_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint], urls);
                if (!newUrl) return false;
                this._updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl);
                return true;
            } catch (error) {
                (_b = this._errorBoundary) === null || _b === void 0 || _b.logError('tryFetchUpdatedFallbackInfo', error);
                return false;
            }
        });
    }
    _updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl) {
        var _a, _b, _c;
        const newFallbackInfo = {
            urlConfigChecksum: urlConfig.getChecksum(),
            url: newUrl,
            expiryTime: Date.now() + $1d3afd37ba42c9d1$var$DEFAULT_TTL_MS,
            previous: []
        };
        const endpoint = urlConfig.endpoint;
        const previousInfo = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[endpoint];
        if (previousInfo) newFallbackInfo.previous.push(...previousInfo.previous);
        if (newFallbackInfo.previous.length > 10) newFallbackInfo.previous = [];
        const previousUrl = (_c = (_b = this._fallbackInfo) === null || _b === void 0 ? void 0 : _b[endpoint]) === null || _c === void 0 ? void 0 : _c.url;
        if (previousUrl != null) newFallbackInfo.previous.push(previousUrl);
        this._fallbackInfo = Object.assign(Object.assign({}, this._fallbackInfo), {
            [endpoint]: newFallbackInfo
        });
        $1d3afd37ba42c9d1$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
    }
    _tryFetchFallbackUrlsFromNetwork(urlConfig) {
        return $1d3afd37ba42c9d1$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cooldown = this._dnsQueryCooldowns[urlConfig.endpoint];
            if (cooldown && Date.now() < cooldown) return null;
            this._dnsQueryCooldowns[urlConfig.endpoint] = Date.now() + $1d3afd37ba42c9d1$var$COOLDOWN_TIME_MS;
            const result = [];
            const records = yield (0, $EqMVr._fetchTxtRecords)((_a = this._networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch);
            const path = $1d3afd37ba42c9d1$var$_extractPathFromUrl(urlConfig.defaultUrl);
            for (const record of records){
                if (!record.startsWith(urlConfig.endpointDnsKey + '=')) continue;
                const parts = record.split('=');
                if (parts.length > 1) {
                    let baseUrl = parts[1];
                    if (baseUrl.endsWith('/')) baseUrl = baseUrl.slice(0, -1);
                    result.push(`https://${baseUrl}${path}`);
                }
            }
            return result;
        });
    }
    _pickNewFallbackUrl(currentFallbackInfo, urls) {
        var _a;
        if (urls == null) return null;
        const previouslyUsed = new Set((_a = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.previous) !== null && _a !== void 0 ? _a : []);
        const currentFallbackUrl = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.url;
        let found = null;
        for (const loopUrl of urls){
            const url = loopUrl.endsWith('/') ? loopUrl.slice(0, -1) : loopUrl;
            if (!previouslyUsed.has(loopUrl) && url !== currentFallbackUrl) {
                found = url;
                break;
            }
        }
        return found;
    }
    constructor(options){
        var _a;
        this._fallbackInfo = null;
        this._errorBoundary = null;
        this._dnsQueryCooldowns = {};
        this._networkOverrideFunc = (_a = options.networkConfig) === null || _a === void 0 ? void 0 : _a.networkOverrideFunc;
    }
}
module.exports.NetworkFallbackResolver = $1d3afd37ba42c9d1$var$NetworkFallbackResolver;
function $1d3afd37ba42c9d1$var$_isDomainFailure(errorMsg, timedOut) {
    var _a;
    const lowerErrorMsg = (_a = errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.toLowerCase()) !== null && _a !== void 0 ? _a : '';
    return timedOut || lowerErrorMsg.includes('uncaught exception') || lowerErrorMsg.includes('failed to fetch') || lowerErrorMsg.includes('networkerror when attempting to fetch resource');
}
module.exports._isDomainFailure = $1d3afd37ba42c9d1$var$_isDomainFailure;
function $1d3afd37ba42c9d1$var$_getFallbackInfoStorageKey(sdkKey) {
    return `statsig.network_fallback.${(0, $legJs._DJB2)(sdkKey)}`;
}
function $1d3afd37ba42c9d1$var$_tryWriteFallbackInfoToCache(sdkKey, info) {
    const hashKey = $1d3afd37ba42c9d1$var$_getFallbackInfoStorageKey(sdkKey);
    if (!info || Object.keys(info).length === 0) {
        $cn2J1.Storage.removeItem(hashKey);
        return;
    }
    $cn2J1.Storage.setItem(hashKey, JSON.stringify(info));
}
function $1d3afd37ba42c9d1$var$_readFallbackInfoFromCache(sdkKey) {
    const hashKey = $1d3afd37ba42c9d1$var$_getFallbackInfoStorageKey(sdkKey);
    const data = $cn2J1.Storage.getItem(hashKey);
    if (!data) return null;
    try {
        return JSON.parse(data);
    } catch (_a) {
        $69t28.Log.error('Failed to parse FallbackInfo');
        return null;
    }
}
function $1d3afd37ba42c9d1$var$_extractPathFromUrl(urlString) {
    try {
        const url = new URL(urlString);
        return url.pathname;
    } catch (error) {
        return null;
    }
}

});
parcelRegister("EqMVr", function(module, exports) {
"use strict";
var $0798841aa4293f9a$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fetchTxtRecords = void 0;
// See example: https://github.com/statsig-io/private-js-client-monorepo/pull/340
const $0798841aa4293f9a$var$FEATURE_ASSETS_DNS_QUERY = new Uint8Array([
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x0d,
    0x66,
    0x65,
    0x61,
    0x74,
    0x75,
    0x72,
    0x65,
    0x61,
    0x73,
    0x73,
    0x65,
    0x74,
    0x73,
    0x03,
    0x6f,
    0x72,
    0x67,
    0x00,
    0x00,
    0x10,
    0x00,
    0x01
]);
const $0798841aa4293f9a$var$DNS_QUERY_ENDPOINT = 'https://cloudflare-dns.com/dns-query';
const $0798841aa4293f9a$var$DOMAIN_CHARS = [
    'i',
    'e',
    'd'
];
const $0798841aa4293f9a$var$MAX_START_LOOKUP = 200;
function $0798841aa4293f9a$var$_fetchTxtRecords(networkFunc) {
    return $0798841aa4293f9a$var$__awaiter(this, void 0, void 0, function*() {
        const response = yield networkFunc($0798841aa4293f9a$var$DNS_QUERY_ENDPOINT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/dns-message',
                Accept: 'application/dns-message'
            },
            body: $0798841aa4293f9a$var$FEATURE_ASSETS_DNS_QUERY
        });
        if (!response.ok) {
            const err = new Error('Failed to fetch TXT records from DNS');
            err.name = 'DnsTxtFetchError';
            throw err;
        }
        const data = yield response.arrayBuffer();
        const bytes = new Uint8Array(data);
        return $0798841aa4293f9a$var$_parseDnsResponse(bytes);
    });
}
module.exports._fetchTxtRecords = $0798841aa4293f9a$var$_fetchTxtRecords;
function $0798841aa4293f9a$var$_parseDnsResponse(input) {
    // loop until we find the first valid domain char. One of [i=, e=, d=]
    const start = input.findIndex((byte, index)=>index < $0798841aa4293f9a$var$MAX_START_LOOKUP && String.fromCharCode(byte) === '=' && $0798841aa4293f9a$var$DOMAIN_CHARS.includes(String.fromCharCode(input[index - 1])));
    if (start === -1) {
        const err = new Error('Failed to parse TXT records from DNS');
        err.name = 'DnsTxtParseError';
        throw err;
    }
    // decode the remaining bytes as a string
    let result = '';
    for(let i = start - 1; i < input.length; i++)result += String.fromCharCode(input[i]);
    return result.split(',');
}

});


parcelRegister("3Sk5Y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKFlags = void 0;
const $2d2600c0e3755e7b$var$FLAGMAP = {};
module.exports.SDKFlags = {
    setFlags: (sdkKey, flags)=>{
        $2d2600c0e3755e7b$var$FLAGMAP[sdkKey] = flags;
    },
    get: (sdkKey, flagKey)=>{
        var _a, _b;
        return (_b = (_a = $2d2600c0e3755e7b$var$FLAGMAP[sdkKey]) === null || _a === void 0 ? void 0 : _a[flagKey]) !== null && _b !== void 0 ? _b : false;
    }
};

});

parcelRegister("gXcI4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigSession = module.exports.SessionID = void 0;

var $jEilP = parcelRequire("jEilP");

var $foCb2 = parcelRequire("foCb2");

var $69t28 = parcelRequire("69t28");

var $cn2J1 = parcelRequire("cn2J1");

var $1lhbi = parcelRequire("1lhbi");
const $c57c03ef01b8babc$var$MAX_SESSION_IDLE_TIME = 1800000; // 30 minutes
const $c57c03ef01b8babc$var$MAX_SESSION_AGE = 14400000; // 4 hours
const $c57c03ef01b8babc$var$PROMISE_MAP = {};
module.exports.SessionID = {
    get: (sdkKey)=>{
        return module.exports.StatsigSession.get(sdkKey).data.sessionID;
    }
};
module.exports.StatsigSession = {
    get: (sdkKey)=>{
        if ($c57c03ef01b8babc$var$PROMISE_MAP[sdkKey] == null) $c57c03ef01b8babc$var$PROMISE_MAP[sdkKey] = $c57c03ef01b8babc$var$_loadSession(sdkKey);
        const session = $c57c03ef01b8babc$var$PROMISE_MAP[sdkKey];
        return $c57c03ef01b8babc$var$_bumpSession(session);
    },
    overrideInitialSessionID: (override, sdkKey)=>{
        $c57c03ef01b8babc$var$PROMISE_MAP[sdkKey] = $c57c03ef01b8babc$var$_overrideSessionId(override, sdkKey);
    }
};
function $c57c03ef01b8babc$var$_loadSession(sdkKey) {
    let data = $c57c03ef01b8babc$var$_loadFromStorage(sdkKey);
    const now = Date.now();
    if (!data) data = {
        sessionID: (0, $1lhbi.getUUID)(),
        startTime: now,
        lastUpdate: now
    };
    return {
        data: data,
        sdkKey: sdkKey
    };
}
function $c57c03ef01b8babc$var$_overrideSessionId(override, sdkKey) {
    const now = Date.now();
    return {
        data: {
            sessionID: override,
            startTime: now,
            lastUpdate: now
        },
        sdkKey: sdkKey
    };
}
function $c57c03ef01b8babc$var$_bumpSession(session) {
    const now = Date.now();
    const data = session.data;
    const sdkKey = session.sdkKey;
    if ($c57c03ef01b8babc$var$_isIdle(data) || $c57c03ef01b8babc$var$_hasRunTooLong(data)) {
        data.sessionID = (0, $1lhbi.getUUID)();
        data.startTime = now;
        const client = __STATSIG__ === null || __STATSIG__ === void 0 ? void 0 : __STATSIG__.instance(sdkKey);
        if (client) client.$emt({
            name: 'session_expired'
        });
    }
    data.lastUpdate = now;
    $c57c03ef01b8babc$var$_persistToStorage(data, session.sdkKey);
    clearTimeout(session.idleTimeoutID);
    clearTimeout(session.ageTimeoutID);
    const lifetime = now - data.startTime;
    session.idleTimeoutID = $c57c03ef01b8babc$var$_createSessionTimeout(sdkKey, $c57c03ef01b8babc$var$MAX_SESSION_IDLE_TIME);
    session.ageTimeoutID = $c57c03ef01b8babc$var$_createSessionTimeout(sdkKey, $c57c03ef01b8babc$var$MAX_SESSION_AGE - lifetime);
    return session;
}
function $c57c03ef01b8babc$var$_createSessionTimeout(sdkKey, duration) {
    return setTimeout(()=>{
        var _a;
        const client = (_a = (0, $jEilP._getStatsigGlobal)()) === null || _a === void 0 ? void 0 : _a.instance(sdkKey);
        if (client) client.$emt({
            name: 'session_expired'
        });
    }, duration);
}
function $c57c03ef01b8babc$var$_isIdle({ lastUpdate: lastUpdate }) {
    return Date.now() - lastUpdate > $c57c03ef01b8babc$var$MAX_SESSION_IDLE_TIME;
}
function $c57c03ef01b8babc$var$_hasRunTooLong({ startTime: startTime }) {
    return Date.now() - startTime > $c57c03ef01b8babc$var$MAX_SESSION_AGE;
}
function $c57c03ef01b8babc$var$_getSessionIDStorageKey(sdkKey) {
    return `statsig.session_id.${(0, $foCb2._getStorageKey)(sdkKey)}`;
}
function $c57c03ef01b8babc$var$_persistToStorage(session, sdkKey) {
    const storageKey = $c57c03ef01b8babc$var$_getSessionIDStorageKey(sdkKey);
    try {
        (0, $cn2J1._setObjectInStorage)(storageKey, session);
    } catch (e) {
        $69t28.Log.warn('Failed to save SessionID');
    }
}
function $c57c03ef01b8babc$var$_loadFromStorage(sdkKey) {
    const storageKey = $c57c03ef01b8babc$var$_getSessionIDStorageKey(sdkKey);
    return (0, $cn2J1._getObjectFromStorage)(storageKey);
}

});

parcelRegister("93F2z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorTag = void 0;
module.exports.ErrorTag = {
    NetworkError: 'NetworkError'
};

});


parcelRegister("8ePXw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("9imDx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("15QTg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fastApproxSizeOf = void 0;
const $0cbf48ff0b3329fa$var$CURLY_AND_SQUARE_BRACKET_SIZE = 2; // [] for array, {} for object
const $0cbf48ff0b3329fa$var$APPROX_ADDITIONAL_SIZE = 1; // additional size for comma and stuff
const $0cbf48ff0b3329fa$var$_fastApproxSizeOf = (obj, max)=>{
    let size = 0;
    const keys = Object.keys(obj);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const value = obj[key];
        size += key.length;
        if (typeof value === 'object' && value !== null) size += (0, module.exports._fastApproxSizeOf)(value, max) + $0cbf48ff0b3329fa$var$CURLY_AND_SQUARE_BRACKET_SIZE;
        else size += String(value).length + $0cbf48ff0b3329fa$var$APPROX_ADDITIONAL_SIZE;
        if (size >= max) // exit early if we've exceeded the max
        return size;
    }
    return size;
};
module.exports._fastApproxSizeOf = $0cbf48ff0b3329fa$var$_fastApproxSizeOf;

});

parcelRegister("baLHY", function(module, exports) {
"use strict";
var $8225a2be17b475d0$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClientBase = void 0;

var $jEilP = parcelRequire("jEilP");

var $jEilP = parcelRequire("jEilP");

var $1wXH6 = parcelRequire("1wXH6");

var $1RMMl = parcelRequire("1RMMl");

var $69t28 = parcelRequire("69t28");

var $lmFrl = parcelRequire("lmFrl");

var $cw4S6 = parcelRequire("cw4S6");

var $gXcI4 = parcelRequire("gXcI4");

var $fpOrS = parcelRequire("fpOrS");

var $97ecK = parcelRequire("97ecK");

var $cn2J1 = parcelRequire("cn2J1");
const $8225a2be17b475d0$var$MAX_MEMO_CACHE_SIZE = 3000;
class $8225a2be17b475d0$var$StatsigClientBase {
    /**
     * Updates runtime configuration options for the SDK, allowing toggling of certain behaviors such as logging and storage to comply with user preferences or regulations such as GDPR.
     *
     * @param {StatsigRuntimeMutableOptions} options - The configuration options that dictate the runtime behavior of the SDK.
     */ updateRuntimeOptions(options) {
        if (options.loggingEnabled) {
            this._options.loggingEnabled = options.loggingEnabled;
            this._logger.setLoggingEnabled(options.loggingEnabled);
        } else if (options.disableLogging != null) {
            this._options.disableLogging = options.disableLogging;
            this._logger.setLoggingEnabled(options.disableLogging ? 'disabled' : 'browser-only');
        }
        if (options.disableStorage != null) {
            this._options.disableStorage = options.disableStorage;
            $cn2J1.Storage._setDisabled(options.disableStorage);
        }
        if (options.enableCookies != null) {
            this._options.enableCookies = options.enableCookies;
            $fpOrS.StableID._setCookiesEnabled(this._sdkKey, options.enableCookies);
        }
        if (options.logEventCompressionMode) this._logger.setLogEventCompressionMode(options.logEventCompressionMode);
        else if (options.disableCompression) this._logger.setLogEventCompressionMode($97ecK.LogEventCompressionMode.Disabled);
    }
    /**
     * Flushes any currently queued events.
     */ flush() {
        return this._logger.flush();
    }
    /**
     * Gracefully shuts down the SDK, ensuring that all pending events are send before the SDK stops.
     * This function emits a 'pre_shutdown' event and then waits for the logger to complete its shutdown process.
     *
     * @returns {Promise<void>} A promise that resolves when all shutdown procedures, including logging shutdown, have been completed.
     */ shutdown() {
        return $8225a2be17b475d0$var$__awaiter(this, void 0, void 0, function*() {
            this.$emt({
                name: 'pre_shutdown'
            });
            this._setStatus('Uninitialized', null);
            this._initializePromise = null;
            yield this._logger.stop();
        });
    }
    /**
     * Subscribes a callback function to a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     * Once subscribed, the listener callback will be invoked whenever the specified event is emitted.
     *
     * @param {StatsigClientEventName} event - The name of the event to subscribe to, or '*' to subscribe to all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to execute when the event occurs. The function receives event-specific data as its parameter.
     * @see {@link off} for unsubscribing from events.
     */ on(event, listener) {
        if (!this._listeners[event]) this._listeners[event] = [];
        this._listeners[event].push(listener);
    }
    /**
     * Unsubscribes a previously registered callback function from a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     *
     * @param {StatsigClientEventName} event - The name of the event from which to unsubscribe, or '*' to unsubscribe from all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to remove from the event's notification list.
     * @see {@link on} for subscribing to events.
     */ off(event, listener) {
        if (this._listeners[event]) {
            const index = this._listeners[event].indexOf(listener);
            if (index !== -1) this._listeners[event].splice(index, 1);
        }
    }
    $on(event, listener) {
        listener.__isInternal = true;
        this.on(event, listener);
    }
    $emt(event) {
        var _a;
        const barrier = (listener)=>{
            try {
                listener(event);
            } catch (error) {
                if (listener.__isInternal === true) {
                    this._errorBoundary.logError(`__emit:${event.name}`, error);
                    return;
                }
                $69t28.Log.error(`An error occurred in a StatsigClientEvent listener. This is not an issue with Statsig.`, event);
            }
        };
        if (this._listeners[event.name]) this._listeners[event.name].forEach((l)=>barrier(l));
        (_a = this._listeners['*']) === null || _a === void 0 || _a.forEach(barrier);
    }
    _setStatus(newStatus, values) {
        this.loadingStatus = newStatus;
        this._memoCache = {};
        this.$emt({
            name: 'values_updated',
            status: newStatus,
            values: values
        });
    }
    _enqueueExposure(name, exposure, options) {
        if ((options === null || options === void 0 ? void 0 : options.disableExposureLog) === true) {
            this._logger.incrementNonExposureCount(name);
            return;
        }
        this._logger.enqueue(exposure);
    }
    _memoize(prefix, fn) {
        return (name, options)=>{
            if (this._options.disableEvaluationMemoization) return fn(name, options);
            const memoKey = (0, $lmFrl.createMemoKey)(prefix, name, options);
            if (!memoKey) return fn(name, options);
            if (!(memoKey in this._memoCache)) {
                if (Object.keys(this._memoCache).length >= $8225a2be17b475d0$var$MAX_MEMO_CACHE_SIZE) this._memoCache = {};
                this._memoCache[memoKey] = fn(name, options);
            }
            return this._memoCache[memoKey];
        };
    }
    constructor(sdkKey, adapter, network, options){
        var _a, _b, _c, _d;
        this.loadingStatus = 'Uninitialized';
        this._initializePromise = null;
        this._listeners = {};
        const emitter = this.$emt.bind(this);
        (options === null || options === void 0 ? void 0 : options.logLevel) != null && ($69t28.Log.level = options.logLevel);
        (options === null || options === void 0 ? void 0 : options.disableStorage) && $cn2J1.Storage._setDisabled(true);
        (options === null || options === void 0 ? void 0 : options.initialSessionID) && $gXcI4.StatsigSession.overrideInitialSessionID(options.initialSessionID, sdkKey);
        (options === null || options === void 0 ? void 0 : options.storageProvider) && $cn2J1.Storage._setProvider(options.storageProvider);
        (options === null || options === void 0 ? void 0 : options.enableCookies) && $fpOrS.StableID._setCookiesEnabled(sdkKey, options.enableCookies);
        (options === null || options === void 0 ? void 0 : options.disableStableID) && $fpOrS.StableID._setDisabled(sdkKey, true);
        this._sdkKey = sdkKey;
        this._options = options !== null && options !== void 0 ? options : {};
        this._memoCache = {};
        this.overrideAdapter = (_a = options === null || options === void 0 ? void 0 : options.overrideAdapter) !== null && _a !== void 0 ? _a : null;
        this._logger = new $1RMMl.EventLogger(sdkKey, emitter, network, options);
        this._errorBoundary = new $1wXH6.ErrorBoundary(sdkKey, options, emitter);
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(adapter);
        this._errorBoundary.wrap(this._logger);
        network.setErrorBoundary(this._errorBoundary);
        this.dataAdapter = adapter;
        this.dataAdapter.attach(sdkKey, options, network);
        this.storageProvider = $cn2J1.Storage;
        (_d = (_c = (_b = this.overrideAdapter) === null || _b === void 0 ? void 0 : _b.loadFromStorage) === null || _c === void 0 ? void 0 : _c.call(_b)) === null || _d === void 0 || _d.catch((e)=>this._errorBoundary.logError('OA::loadFromStorage', e));
        this._primeReadyRipcord();
        $8225a2be17b475d0$var$_assignGlobalInstance(sdkKey, this);
    }
}
module.exports.StatsigClientBase = $8225a2be17b475d0$var$StatsigClientBase;
function $8225a2be17b475d0$var$_assignGlobalInstance(sdkKey, client) {
    var _a;
    if ((0, $cw4S6._isServerEnv)()) return;
    const statsigGlobal = (0, $jEilP._getStatsigGlobal)();
    const instances = (_a = statsigGlobal.instances) !== null && _a !== void 0 ? _a : {};
    const inst = client;
    if (instances[sdkKey] != null) $69t28.Log.warn('Creating multiple Statsig clients with the same SDK key can lead to unexpected behavior. Multi-instance support requires different SDK keys.');
    instances[sdkKey] = inst;
    if (!statsigGlobal.firstInstance) statsigGlobal.firstInstance = inst;
    statsigGlobal.instances = instances;
    __STATSIG__ = statsigGlobal;
}

});

parcelRegister("9yVDo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataAdapterCachePrefix = void 0;
module.exports.DataAdapterCachePrefix = 'statsig.cached';

});

parcelRegister("aCCOX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("7K3On", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeTypedGet = module.exports._mergeOverride = module.exports._makeLayer = module.exports._makeExperiment = module.exports._makeDynamicConfig = module.exports._makeFeatureGate = void 0;

var $69t28 = parcelRequire("69t28");

var $ijNyO = parcelRequire("ijNyO");
function $5a2fc92d67b56e20$var$_makeEvaluation(name, details, evaluation, value) {
    var _a;
    return {
        name: name,
        details: details,
        ruleID: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.rule_id) !== null && _a !== void 0 ? _a : '',
        __evaluation: evaluation,
        value: value
    };
}
function $5a2fc92d67b56e20$var$_makeFeatureGate(name, details, evaluation) {
    var _a;
    return Object.assign(Object.assign({}, $5a2fc92d67b56e20$var$_makeEvaluation(name, details, evaluation, (evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) === true)), {
        idType: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeFeatureGate = $5a2fc92d67b56e20$var$_makeFeatureGate;
function $5a2fc92d67b56e20$var$_makeDynamicConfig(name, details, evaluation) {
    var _a, _b;
    const value = (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _a !== void 0 ? _a : {};
    return Object.assign(Object.assign({}, $5a2fc92d67b56e20$var$_makeEvaluation(name, details, evaluation, value)), {
        idType: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _b !== void 0 ? _b : null,
        get: $5a2fc92d67b56e20$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value)
    });
}
module.exports._makeDynamicConfig = $5a2fc92d67b56e20$var$_makeDynamicConfig;
function $5a2fc92d67b56e20$var$_makeExperiment(name, details, evaluation) {
    var _a;
    const result = $5a2fc92d67b56e20$var$_makeDynamicConfig(name, details, evaluation);
    return Object.assign(Object.assign({}, result), {
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeExperiment = $5a2fc92d67b56e20$var$_makeExperiment;
function $5a2fc92d67b56e20$var$_makeLayer(name, details, evaluation, exposeFunc) {
    var _a, _b;
    return Object.assign(Object.assign({}, $5a2fc92d67b56e20$var$_makeEvaluation(name, details, evaluation, undefined)), {
        get: $5a2fc92d67b56e20$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value, exposeFunc),
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null,
        __value: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _b !== void 0 ? _b : {}
    });
}
module.exports._makeLayer = $5a2fc92d67b56e20$var$_makeLayer;
function $5a2fc92d67b56e20$var$_mergeOverride(original, overridden, value, exposeFunc) {
    return Object.assign(Object.assign(Object.assign({}, original), overridden), {
        get: $5a2fc92d67b56e20$var$_makeTypedGet(original.name, value, exposeFunc)
    });
}
module.exports._mergeOverride = $5a2fc92d67b56e20$var$_mergeOverride;
function $5a2fc92d67b56e20$var$_makeTypedGet(name, value, exposeFunc) {
    return (param, fallback)=>{
        var _a;
        const found = (_a = value === null || value === void 0 ? void 0 : value[param]) !== null && _a !== void 0 ? _a : null;
        if (found == null) return fallback !== null && fallback !== void 0 ? fallback : null;
        if (fallback != null && !(0, $ijNyO._isTypeMatch)(found, fallback)) {
            $69t28.Log.warn(`Parameter type mismatch. '${name}.${param}' was found to be type '${typeof found}' but fallback/return type is '${typeof fallback}'. See https://docs.statsig.com/client/javascript-sdk/#typed-getters`);
            return fallback !== null && fallback !== void 0 ? fallback : null;
        }
        exposeFunc === null || exposeFunc === void 0 || exposeFunc(param);
        return found;
    };
}
module.exports._makeTypedGet = $5a2fc92d67b56e20$var$_makeTypedGet;

});

parcelRegister("3BALq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("1b4nC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = module.exports.createUpdateDetails = void 0;
const $0dba3747e821a8f1$var$createUpdateDetails = (success, source, initDuration, error, sourceUrl, warnings)=>{
    return {
        duration: initDuration,
        source: source,
        success: success,
        error: error,
        sourceUrl: sourceUrl,
        warnings: warnings
    };
};
module.exports.createUpdateDetails = $0dba3747e821a8f1$var$createUpdateDetails;
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = {
    NO_NETWORK_DATA: 'No data was returned from the network. This may be due to a network timeout if a timeout value was specified in the options or ad blocker error.'
};

});


parcelRegister("dEf6I", function(module, exports) {
$parcel$export(module.exports, "__extends", () => $9efabacde9d92ef9$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__assign", () => $9efabacde9d92ef9$export$18ce0697a983be9b);
$parcel$export(module.exports, "__rest", () => $9efabacde9d92ef9$export$3c9a16f847548506);
$parcel$export(module.exports, "__awaiter", () => $9efabacde9d92ef9$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $9efabacde9d92ef9$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__values", () => $9efabacde9d92ef9$export$19a8beecd37a4c45);
$parcel$export(module.exports, "__read", () => $9efabacde9d92ef9$export$8d051b38c9118094);
$parcel$export(module.exports, "__spread", () => $9efabacde9d92ef9$export$afc72e2116322959);
$parcel$export(module.exports, "__spreadArrays", () => $9efabacde9d92ef9$export$6388937ca91ccae8);
$parcel$export(module.exports, "__spreadArray", () => $9efabacde9d92ef9$export$1216008129fb82ed);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $9efabacde9d92ef9$var$extendStatics = function(d, b) {
    $9efabacde9d92ef9$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $9efabacde9d92ef9$var$extendStatics(d, b);
};
function $9efabacde9d92ef9$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $9efabacde9d92ef9$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $9efabacde9d92ef9$export$18ce0697a983be9b = function() {
    $9efabacde9d92ef9$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9efabacde9d92ef9$export$18ce0697a983be9b.apply(this, arguments);
};
function $9efabacde9d92ef9$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $9efabacde9d92ef9$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $9efabacde9d92ef9$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $9efabacde9d92ef9$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $9efabacde9d92ef9$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $9efabacde9d92ef9$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $9efabacde9d92ef9$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $9efabacde9d92ef9$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $9efabacde9d92ef9$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $9efabacde9d92ef9$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $9efabacde9d92ef9$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $9efabacde9d92ef9$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $9efabacde9d92ef9$export$45d3717a4c69092e(o, m, p);
}
function $9efabacde9d92ef9$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $9efabacde9d92ef9$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $9efabacde9d92ef9$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($9efabacde9d92ef9$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $9efabacde9d92ef9$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $9efabacde9d92ef9$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $9efabacde9d92ef9$export$10c90e4f7922046c(v) {
    return this instanceof $9efabacde9d92ef9$export$10c90e4f7922046c ? (this.v = v, this) : new $9efabacde9d92ef9$export$10c90e4f7922046c(v);
}
function $9efabacde9d92ef9$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $9efabacde9d92ef9$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $9efabacde9d92ef9$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $9efabacde9d92ef9$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $9efabacde9d92ef9$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $9efabacde9d92ef9$export$19a8beecd37a4c45 === "function" ? $9efabacde9d92ef9$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $9efabacde9d92ef9$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $9efabacde9d92ef9$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $9efabacde9d92ef9$var$ownKeys = function(o) {
    $9efabacde9d92ef9$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $9efabacde9d92ef9$var$ownKeys(o);
};
function $9efabacde9d92ef9$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $9efabacde9d92ef9$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $9efabacde9d92ef9$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $9efabacde9d92ef9$var$__setModuleDefault(result, mod);
    return result;
}
function $9efabacde9d92ef9$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $9efabacde9d92ef9$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $9efabacde9d92ef9$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $9efabacde9d92ef9$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $9efabacde9d92ef9$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $9efabacde9d92ef9$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $9efabacde9d92ef9$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $9efabacde9d92ef9$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $9efabacde9d92ef9$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $9efabacde9d92ef9$export$2e2bcd8739ae039 = {
    __extends: $9efabacde9d92ef9$export$a8ba968b8961cb8a,
    __assign: $9efabacde9d92ef9$export$18ce0697a983be9b,
    __rest: $9efabacde9d92ef9$export$3c9a16f847548506,
    __decorate: $9efabacde9d92ef9$export$29e00dfd3077644b,
    __param: $9efabacde9d92ef9$export$d5ad3fd78186038f,
    __esDecorate: $9efabacde9d92ef9$export$3a84e1ae4e97e9b0,
    __runInitializers: $9efabacde9d92ef9$export$d831c04e792af3d,
    __propKey: $9efabacde9d92ef9$export$6a2a36740a146cb8,
    __setFunctionName: $9efabacde9d92ef9$export$d1a06452d3489bc7,
    __metadata: $9efabacde9d92ef9$export$f1db080c865becb9,
    __awaiter: $9efabacde9d92ef9$export$1050f835b63b671e,
    __generator: $9efabacde9d92ef9$export$67ebef60e6f28a6,
    __createBinding: $9efabacde9d92ef9$export$45d3717a4c69092e,
    __exportStar: $9efabacde9d92ef9$export$f33643c0debef087,
    __values: $9efabacde9d92ef9$export$19a8beecd37a4c45,
    __read: $9efabacde9d92ef9$export$8d051b38c9118094,
    __spread: $9efabacde9d92ef9$export$afc72e2116322959,
    __spreadArrays: $9efabacde9d92ef9$export$6388937ca91ccae8,
    __spreadArray: $9efabacde9d92ef9$export$1216008129fb82ed,
    __await: $9efabacde9d92ef9$export$10c90e4f7922046c,
    __asyncGenerator: $9efabacde9d92ef9$export$e427f37a30a4de9b,
    __asyncDelegator: $9efabacde9d92ef9$export$bbd80228419bb833,
    __asyncValues: $9efabacde9d92ef9$export$e3b29a3d6162315f,
    __makeTemplateObject: $9efabacde9d92ef9$export$4fb47efe1390b86f,
    __importStar: $9efabacde9d92ef9$export$c21735bcef00d192,
    __importDefault: $9efabacde9d92ef9$export$da59b14a69baef04,
    __classPrivateFieldGet: $9efabacde9d92ef9$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $9efabacde9d92ef9$export$d40a35129aaff81f,
    __classPrivateFieldIn: $9efabacde9d92ef9$export$81fdc39f203e4e04,
    __addDisposableResource: $9efabacde9d92ef9$export$88ac25d8e944e405,
    __disposeResources: $9efabacde9d92ef9$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $9efabacde9d92ef9$export$889dfb5d17574b0b
};

});

parcelRegister("dcDKw", function(module, exports) {
$parcel$export(module.exports, "ApolloLink", () => ApolloLink);
$parcel$export(module.exports, "execute", () => execute);
$parcel$export(module.exports, "Observable", () => (parcelRequire("hmiPI")).default);

var $hmiPI = parcelRequire("hmiPI");

var $ldpX0 = parcelRequire("ldpX0");

var $dEf6I = parcelRequire("dEf6I");

var $bXCDP = parcelRequire("bXCDP");
function validateOperation(operation) {
    var OPERATION_FIELDS = [
        'query',
        'operationName',
        'variables',
        'extensions',
        'context'
    ];
    for(var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++){
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) throw new (0, $ldpX0.InvariantError)(2);
    }
    return operation;
}
var LinkError = function(_super) {
    (0, $dEf6I.__extends)(LinkError, _super);
    function LinkError(message, link) {
        var _this = _super.call(this, message) || this;
        _this.link = link;
        return _this;
    }
    return LinkError;
}(Error);
function isTerminating(link) {
    return link.request.length <= 1;
}
function toPromise(observable) {
    var completed = false;
    return new Promise(function(resolve, reject) {
        observable.subscribe({
            next: function(data) {
                if (completed) ;
                else {
                    completed = true;
                    resolve(data);
                }
            },
            error: reject
        });
    });
}
var makePromise = toPromise;
function fromPromise(promise) {
    return new (0, $hmiPI.default)(function(observer) {
        promise.then(function(value) {
            observer.next(value);
            observer.complete();
        }).catch(observer.error.bind(observer));
    });
}
function fromError(errorValue) {
    return new (0, $hmiPI.default)(function(observer) {
        observer.error(errorValue);
    });
}
function transformOperation(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query
    };
    if (!transformedOperation.operationName) transformedOperation.operationName = typeof transformedOperation.query !== 'string' ? (0, $bXCDP.getOperationName)(transformedOperation.query) : '';
    return transformedOperation;
}
function createOperation(starting, operation) {
    var context = (0, $dEf6I.__assign)({}, starting);
    var setContext = function(next) {
        if (typeof next === 'function') context = (0, $dEf6I.__assign)({}, context, next(context));
        else context = (0, $dEf6I.__assign)({}, context, next);
    };
    var getContext = function() {
        return (0, $dEf6I.__assign)({}, context);
    };
    Object.defineProperty(operation, 'setContext', {
        enumerable: false,
        value: setContext
    });
    Object.defineProperty(operation, 'getContext', {
        enumerable: false,
        value: getContext
    });
    Object.defineProperty(operation, 'toKey', {
        enumerable: false,
        value: function() {
            return getKey(operation);
        }
    });
    return operation;
}
function getKey(operation) {
    var query = operation.query, variables = operation.variables, operationName = operation.operationName;
    return JSON.stringify([
        operationName,
        query,
        variables
    ]);
}
function passthrough(op, forward) {
    return forward ? forward(op) : (0, $hmiPI.default).of();
}
function toLink(handler) {
    return typeof handler === 'function' ? new ApolloLink(handler) : handler;
}
function empty() {
    return new ApolloLink(function() {
        return (0, $hmiPI.default).of();
    });
}
function from(links) {
    if (links.length === 0) return empty();
    return links.map(toLink).reduce(function(x, y) {
        return x.concat(y);
    });
}
function split(test, left, right) {
    var leftLink = toLink(left);
    var rightLink = toLink(right || new ApolloLink(passthrough));
    if (isTerminating(leftLink) && isTerminating(rightLink)) return new ApolloLink(function(operation) {
        return test(operation) ? leftLink.request(operation) || (0, $hmiPI.default).of() : rightLink.request(operation) || (0, $hmiPI.default).of();
    });
    else return new ApolloLink(function(operation, forward) {
        return test(operation) ? leftLink.request(operation, forward) || (0, $hmiPI.default).of() : rightLink.request(operation, forward) || (0, $hmiPI.default).of();
    });
}
var concat = function(first, second) {
    var firstLink = toLink(first);
    if (isTerminating(firstLink)) return firstLink;
    var nextLink = toLink(second);
    if (isTerminating(nextLink)) return new ApolloLink(function(operation) {
        return firstLink.request(operation, function(op) {
            return nextLink.request(op) || (0, $hmiPI.default).of();
        }) || (0, $hmiPI.default).of();
    });
    else return new ApolloLink(function(operation, forward) {
        return firstLink.request(operation, function(op) {
            return nextLink.request(op, forward) || (0, $hmiPI.default).of();
        }) || (0, $hmiPI.default).of();
    });
};
var ApolloLink = function() {
    function ApolloLink(request) {
        if (request) this.request = request;
    }
    ApolloLink.prototype.split = function(test, left, right) {
        return this.concat(split(test, left, right || new ApolloLink(passthrough)));
    };
    ApolloLink.prototype.concat = function(next) {
        return concat(this, next);
    };
    ApolloLink.prototype.request = function(operation, forward) {
        throw new (0, $ldpX0.InvariantError)(1);
    };
    ApolloLink.empty = empty;
    ApolloLink.from = from;
    ApolloLink.split = split;
    ApolloLink.execute = execute;
    return ApolloLink;
}();
function execute(link, operation) {
    return link.request(createOperation(operation.context, transformOperation(validateOperation(operation)))) || (0, $hmiPI.default).of();
}

});
parcelRegister("hmiPI", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca331997ed901a26$export$2e2bcd8739ae039);

var $jca9a = parcelRequire("jca9a");
var $ca331997ed901a26$export$77cea355fa80b5f4 = (0, (/*@__PURE__*/$parcel$interopDefault($jca9a)));
var $ca331997ed901a26$export$2e2bcd8739ae039 = $ca331997ed901a26$export$77cea355fa80b5f4;

});
parcelRegister("jca9a", function(module, exports) {

module.exports = (parcelRequire("hYmAk")).Observable;

});
parcelRegister("hYmAk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Observable = void 0;
function $d1598f3029bdb91b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d1598f3029bdb91b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $d1598f3029bdb91b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d1598f3029bdb91b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d1598f3029bdb91b$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
// === Symbol Support ===
var $d1598f3029bdb91b$var$hasSymbols = function() {
    return typeof Symbol === 'function';
};
var $d1598f3029bdb91b$var$hasSymbol = function(name) {
    return $d1598f3029bdb91b$var$hasSymbols() && Boolean(Symbol[name]);
};
var $d1598f3029bdb91b$var$getSymbol = function(name) {
    return $d1598f3029bdb91b$var$hasSymbol(name) ? Symbol[name] : '@@' + name;
};
if ($d1598f3029bdb91b$var$hasSymbols() && !$d1598f3029bdb91b$var$hasSymbol('observable')) Symbol.observable = Symbol('observable');
var $d1598f3029bdb91b$var$SymbolIterator = $d1598f3029bdb91b$var$getSymbol('iterator');
var $d1598f3029bdb91b$var$SymbolObservable = $d1598f3029bdb91b$var$getSymbol('observable');
var $d1598f3029bdb91b$var$SymbolSpecies = $d1598f3029bdb91b$var$getSymbol('species'); // === Abstract Operations ===
function $d1598f3029bdb91b$var$getMethod(obj, key) {
    var value = obj[key];
    if (value == null) return undefined;
    if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
    return value;
}
function $d1598f3029bdb91b$var$getSpecies(obj) {
    var ctor = obj.constructor;
    if (ctor !== undefined) {
        ctor = ctor[$d1598f3029bdb91b$var$SymbolSpecies];
        if (ctor === null) ctor = undefined;
    }
    return ctor !== undefined ? ctor : $d1598f3029bdb91b$var$Observable;
}
function $d1598f3029bdb91b$var$isObservable(x) {
    return x instanceof $d1598f3029bdb91b$var$Observable; // SPEC: Brand check
}
function $d1598f3029bdb91b$var$hostReportError(e) {
    if ($d1598f3029bdb91b$var$hostReportError.log) $d1598f3029bdb91b$var$hostReportError.log(e);
    else setTimeout(function() {
        throw e;
    });
}
function $d1598f3029bdb91b$var$enqueue(fn) {
    Promise.resolve().then(function() {
        try {
            fn();
        } catch (e) {
            $d1598f3029bdb91b$var$hostReportError(e);
        }
    });
}
function $d1598f3029bdb91b$var$cleanupSubscription(subscription) {
    var cleanup = subscription._cleanup;
    if (cleanup === undefined) return;
    subscription._cleanup = undefined;
    if (!cleanup) return;
    try {
        if (typeof cleanup === 'function') cleanup();
        else {
            var unsubscribe = $d1598f3029bdb91b$var$getMethod(cleanup, 'unsubscribe');
            if (unsubscribe) unsubscribe.call(cleanup);
        }
    } catch (e) {
        $d1598f3029bdb91b$var$hostReportError(e);
    }
}
function $d1598f3029bdb91b$var$closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._queue = undefined;
    subscription._state = 'closed';
}
function $d1598f3029bdb91b$var$flushSubscription(subscription) {
    var queue = subscription._queue;
    if (!queue) return;
    subscription._queue = undefined;
    subscription._state = 'ready';
    for(var i = 0; i < queue.length; ++i){
        $d1598f3029bdb91b$var$notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === 'closed') break;
    }
}
function $d1598f3029bdb91b$var$notifySubscription(subscription, type, value) {
    subscription._state = 'running';
    var observer = subscription._observer;
    try {
        var m = $d1598f3029bdb91b$var$getMethod(observer, type);
        switch(type){
            case 'next':
                if (m) m.call(observer, value);
                break;
            case 'error':
                $d1598f3029bdb91b$var$closeSubscription(subscription);
                if (m) m.call(observer, value);
                else throw value;
                break;
            case 'complete':
                $d1598f3029bdb91b$var$closeSubscription(subscription);
                if (m) m.call(observer);
                break;
        }
    } catch (e) {
        $d1598f3029bdb91b$var$hostReportError(e);
    }
    if (subscription._state === 'closed') $d1598f3029bdb91b$var$cleanupSubscription(subscription);
    else if (subscription._state === 'running') subscription._state = 'ready';
}
function $d1598f3029bdb91b$var$onNotify(subscription, type, value) {
    if (subscription._state === 'closed') return;
    if (subscription._state === 'buffering') {
        subscription._queue.push({
            type: type,
            value: value
        });
        return;
    }
    if (subscription._state !== 'ready') {
        subscription._state = 'buffering';
        subscription._queue = [
            {
                type: type,
                value: value
            }
        ];
        $d1598f3029bdb91b$var$enqueue(function() {
            return $d1598f3029bdb91b$var$flushSubscription(subscription);
        });
        return;
    }
    $d1598f3029bdb91b$var$notifySubscription(subscription, type, value);
}
var $d1598f3029bdb91b$var$Subscription = /*#__PURE__*/ function() {
    function Subscription(observer, subscriber) {
        $d1598f3029bdb91b$var$_classCallCheck(this, Subscription);
        // ASSERT: observer is an object
        // ASSERT: subscriber is callable
        this._cleanup = undefined;
        this._observer = observer;
        this._queue = undefined;
        this._state = 'initializing';
        var subscriptionObserver = new $d1598f3029bdb91b$var$SubscriptionObserver(this);
        try {
            this._cleanup = subscriber.call(undefined, subscriptionObserver);
        } catch (e) {
            subscriptionObserver.error(e);
        }
        if (this._state === 'initializing') this._state = 'ready';
    }
    $d1598f3029bdb91b$var$_createClass(Subscription, [
        {
            key: "unsubscribe",
            value: function unsubscribe() {
                if (this._state !== 'closed') {
                    $d1598f3029bdb91b$var$closeSubscription(this);
                    $d1598f3029bdb91b$var$cleanupSubscription(this);
                }
            }
        },
        {
            key: "closed",
            get: function() {
                return this._state === 'closed';
            }
        }
    ]);
    return Subscription;
}();
var $d1598f3029bdb91b$var$SubscriptionObserver = /*#__PURE__*/ function() {
    function SubscriptionObserver(subscription) {
        $d1598f3029bdb91b$var$_classCallCheck(this, SubscriptionObserver);
        this._subscription = subscription;
    }
    $d1598f3029bdb91b$var$_createClass(SubscriptionObserver, [
        {
            key: "next",
            value: function next(value) {
                $d1598f3029bdb91b$var$onNotify(this._subscription, 'next', value);
            }
        },
        {
            key: "error",
            value: function error(value) {
                $d1598f3029bdb91b$var$onNotify(this._subscription, 'error', value);
            }
        },
        {
            key: "complete",
            value: function complete() {
                $d1598f3029bdb91b$var$onNotify(this._subscription, 'complete');
            }
        },
        {
            key: "closed",
            get: function() {
                return this._subscription._state === 'closed';
            }
        }
    ]);
    return SubscriptionObserver;
}();
var $d1598f3029bdb91b$var$Observable = /*#__PURE__*/ function() {
    function Observable(subscriber) {
        $d1598f3029bdb91b$var$_classCallCheck(this, Observable);
        if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
        if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
        this._subscriber = subscriber;
    }
    $d1598f3029bdb91b$var$_createClass(Observable, [
        {
            key: "subscribe",
            value: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) observer = {
                    next: observer,
                    error: arguments[1],
                    complete: arguments[2]
                };
                return new $d1598f3029bdb91b$var$Subscription(observer, this._subscriber);
            }
        },
        {
            key: "forEach",
            value: function forEach(fn) {
                var _this = this;
                return new Promise(function(resolve, reject) {
                    if (typeof fn !== 'function') {
                        reject(new TypeError(fn + ' is not a function'));
                        return;
                    }
                    function done() {
                        subscription.unsubscribe();
                        resolve();
                    }
                    var subscription = _this.subscribe({
                        next: function(value) {
                            try {
                                fn(value, done);
                            } catch (e) {
                                reject(e);
                                subscription.unsubscribe();
                            }
                        },
                        error: reject,
                        complete: resolve
                    });
                });
            }
        },
        {
            key: "map",
            value: function map(fn) {
                var _this2 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $d1598f3029bdb91b$var$getSpecies(this);
                return new C(function(observer) {
                    return _this2.subscribe({
                        next: function(value) {
                            try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "filter",
            value: function filter(fn) {
                var _this3 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $d1598f3029bdb91b$var$getSpecies(this);
                return new C(function(observer) {
                    return _this3.subscribe({
                        next: function(value) {
                            try {
                                if (!fn(value)) return;
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "reduce",
            value: function reduce(fn) {
                var _this4 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $d1598f3029bdb91b$var$getSpecies(this);
                var hasSeed = arguments.length > 1;
                var hasValue = false;
                var seed = arguments[1];
                var acc = seed;
                return new C(function(observer) {
                    return _this4.subscribe({
                        next: function(value) {
                            var first = !hasValue;
                            hasValue = true;
                            if (!first || hasSeed) try {
                                acc = fn(acc, value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            else acc = value;
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
                            observer.next(acc);
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "concat",
            value: function concat() {
                var _this5 = this;
                for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
                var C = $d1598f3029bdb91b$var$getSpecies(this);
                return new C(function(observer) {
                    var subscription;
                    var index = 0;
                    function startNext(next) {
                        subscription = next.subscribe({
                            next: function(v) {
                                observer.next(v);
                            },
                            error: function(e) {
                                observer.error(e);
                            },
                            complete: function() {
                                if (index === sources.length) {
                                    subscription = undefined;
                                    observer.complete();
                                } else startNext(C.from(sources[index++]));
                            }
                        });
                    }
                    startNext(_this5);
                    return function() {
                        if (subscription) {
                            subscription.unsubscribe();
                            subscription = undefined;
                        }
                    };
                });
            }
        },
        {
            key: "flatMap",
            value: function flatMap(fn) {
                var _this6 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $d1598f3029bdb91b$var$getSpecies(this);
                return new C(function(observer) {
                    var subscriptions = [];
                    var outer = _this6.subscribe({
                        next: function(value) {
                            if (fn) try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            var inner = C.from(value).subscribe({
                                next: function(value) {
                                    observer.next(value);
                                },
                                error: function(e) {
                                    observer.error(e);
                                },
                                complete: function() {
                                    var i = subscriptions.indexOf(inner);
                                    if (i >= 0) subscriptions.splice(i, 1);
                                    completeIfDone();
                                }
                            });
                            subscriptions.push(inner);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            completeIfDone();
                        }
                    });
                    function completeIfDone() {
                        if (outer.closed && subscriptions.length === 0) observer.complete();
                    }
                    return function() {
                        subscriptions.forEach(function(s) {
                            return s.unsubscribe();
                        });
                        outer.unsubscribe();
                    };
                });
            }
        },
        {
            key: $d1598f3029bdb91b$var$SymbolObservable,
            value: function() {
                return this;
            }
        }
    ], [
        {
            key: "from",
            value: function from(x) {
                var C = typeof this === 'function' ? this : Observable;
                if (x == null) throw new TypeError(x + ' is not an object');
                var method = $d1598f3029bdb91b$var$getMethod(x, $d1598f3029bdb91b$var$SymbolObservable);
                if (method) {
                    var observable = method.call(x);
                    if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
                    if ($d1598f3029bdb91b$var$isObservable(observable) && observable.constructor === C) return observable;
                    return new C(function(observer) {
                        return observable.subscribe(observer);
                    });
                }
                if ($d1598f3029bdb91b$var$hasSymbol('iterator')) {
                    method = $d1598f3029bdb91b$var$getMethod(x, $d1598f3029bdb91b$var$SymbolIterator);
                    if (method) return new C(function(observer) {
                        $d1598f3029bdb91b$var$enqueue(function() {
                            if (observer.closed) return;
                            var _iteratorNormalCompletion = true;
                            var _didIteratorError = false;
                            var _iteratorError = undefined;
                            try {
                                for(var _iterator = method.call(x)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _item = _step.value;
                                    observer.next(_item);
                                    if (observer.closed) return;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) _iterator.return();
                                } finally{
                                    if (_didIteratorError) throw _iteratorError;
                                }
                            }
                            observer.complete();
                        });
                    });
                }
                if (Array.isArray(x)) return new C(function(observer) {
                    $d1598f3029bdb91b$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < x.length; ++i){
                            observer.next(x[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
                throw new TypeError(x + ' is not observable');
            }
        },
        {
            key: "of",
            value: function of() {
                for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
                var C = typeof this === 'function' ? this : Observable;
                return new C(function(observer) {
                    $d1598f3029bdb91b$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < items.length; ++i){
                            observer.next(items[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
            }
        },
        {
            key: $d1598f3029bdb91b$var$SymbolSpecies,
            get: function() {
                return this;
            }
        }
    ]);
    return Observable;
}();
module.exports.Observable = $d1598f3029bdb91b$var$Observable;
if ($d1598f3029bdb91b$var$hasSymbols()) Object.defineProperty($d1598f3029bdb91b$var$Observable, Symbol('extensions'), {
    value: {
        symbol: $d1598f3029bdb91b$var$SymbolObservable,
        hostReportError: $d1598f3029bdb91b$var$hostReportError
    },
    configurable: true
});

});



parcelRegister("ldpX0", function(module, exports) {
$parcel$export(module.exports, "InvariantError", () => $f71ef121ccd308f0$export$cea12affaee22fe8);

var $dEf6I = parcelRequire("dEf6I");

var $aVaWD = parcelRequire("aVaWD");
var $f71ef121ccd308f0$var$genericMessage = "Invariant Violation";
var $f71ef121ccd308f0$var$_a = Object.setPrototypeOf, $f71ef121ccd308f0$var$setPrototypeOf = $f71ef121ccd308f0$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $f71ef121ccd308f0$var$_a;
var $f71ef121ccd308f0$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $dEf6I.__extends)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $f71ef121ccd308f0$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $f71ef121ccd308f0$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $f71ef121ccd308f0$var$genericMessage;
        $f71ef121ccd308f0$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $f71ef121ccd308f0$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $f71ef121ccd308f0$export$cea12affaee22fe8(message);
}
function $f71ef121ccd308f0$var$wrapConsoleMethod(method) {
    return function() {
        return console[method].apply(console, arguments);
    };
}
(function(invariant) {
    invariant.warn = $f71ef121ccd308f0$var$wrapConsoleMethod("warn");
    invariant.error = $f71ef121ccd308f0$var$wrapConsoleMethod("error");
})($f71ef121ccd308f0$export$f5708dca728d7177 || ($f71ef121ccd308f0$export$f5708dca728d7177 = {}));
// Code that uses ts-invariant with rollup-plugin-invariant may want to
// import this process stub to avoid errors evaluating process.env.NODE_ENV.
// However, because most ESM-to-CJS compilers will rewrite the process import
// as tsInvariant.process, which prevents proper replacement by minifiers, we
// also attempt to define the stub globally when it is not already defined.
var $f71ef121ccd308f0$export$e54fe5b0f43758f7 = {
    env: {}
};
if (typeof $aVaWD === "object") $f71ef121ccd308f0$export$e54fe5b0f43758f7 = $aVaWD;
else try {
    // Using Function to evaluate this assignment in global scope also escapes
    // the strict mode of the current module, thereby allowing the assignment.
    // Inspired by https://github.com/facebook/regenerator/pull/369.
    Function("stub", "process = stub")($f71ef121ccd308f0$export$e54fe5b0f43758f7);
} catch (atLeastWeTried) {
// The assignment can fail if a Content Security Policy heavy-handedly
// forbids Function usage. In those environments, developers should take
// extra care to replace process.env.NODE_ENV in their production builds,
// or define an appropriate global.process polyfill.
}
var $f71ef121ccd308f0$var$invariant$1 = $f71ef121ccd308f0$export$f5708dca728d7177;
var $f71ef121ccd308f0$export$2e2bcd8739ae039 = $f71ef121ccd308f0$var$invariant$1;

});

parcelRegister("bXCDP", function(module, exports) {
$parcel$export(module.exports, "argumentsObjectFromField", () => $8b532dca706696ae$export$3f5a60fb6a781b4f);
$parcel$export(module.exports, "resultKeyNameFromField", () => $8b532dca706696ae$export$7d1ad22471852218);
$parcel$export(module.exports, "isField", () => $8b532dca706696ae$export$fb56ad75dd311c12);
$parcel$export(module.exports, "isInlineFragment", () => $8b532dca706696ae$export$22a1cdafaf27bcff);
$parcel$export(module.exports, "shouldInclude", () => $8b532dca706696ae$export$3dc388a5f013b4a5);
$parcel$export(module.exports, "hasDirectives", () => $8b532dca706696ae$export$2dafb573e282fe8d);
$parcel$export(module.exports, "hasClientExports", () => $8b532dca706696ae$export$8d1e9e5bbfa5d09a);
$parcel$export(module.exports, "getOperationDefinition", () => $8b532dca706696ae$export$7a5b1fa979d2c158);
$parcel$export(module.exports, "getOperationName", () => $8b532dca706696ae$export$41bca9dc6871dd4e);
$parcel$export(module.exports, "getFragmentDefinitions", () => $8b532dca706696ae$export$5320a7ba9466a3df);
$parcel$export(module.exports, "getMainDefinition", () => $8b532dca706696ae$export$f431198736b7f96d);
$parcel$export(module.exports, "createFragmentMap", () => $8b532dca706696ae$export$193789b4c8246dd4);
$parcel$export(module.exports, "getDefaultValues", () => $8b532dca706696ae$export$84c19026e616569e);
$parcel$export(module.exports, "removeConnectionDirectiveFromDocument", () => $8b532dca706696ae$export$74985f3324559867);
$parcel$export(module.exports, "buildQueryFromSelectionSet", () => $8b532dca706696ae$export$57c368c23873f32b);
$parcel$export(module.exports, "removeClientSetsFromDocument", () => $8b532dca706696ae$export$8eae69e876ee321e);
$parcel$export(module.exports, "canUseWeakMap", () => $8b532dca706696ae$export$772fbc04a0ad4ce9);
$parcel$export(module.exports, "cloneDeep", () => $8b532dca706696ae$export$629a2bd3f5a49ecc);
$parcel$export(module.exports, "tryFunctionOrLogError", () => $8b532dca706696ae$export$50a91acae4904909);
$parcel$export(module.exports, "graphQLResultHasError", () => $8b532dca706696ae$export$b4df399e879e53ab);
$parcel$export(module.exports, "mergeDeep", () => $8b532dca706696ae$export$dd702b3c8240390c);
$parcel$export(module.exports, "mergeDeepArray", () => $8b532dca706696ae$export$160070228be94b08);

var $kx5XW = parcelRequire("kx5XW");

var $9YXqx = parcelRequire("9YXqx");

var $dEf6I = parcelRequire("dEf6I");

var $4ZPM2 = parcelRequire("4ZPM2");

var $brWF5 = parcelRequire("brWF5");

var $aVaWD = parcelRequire("aVaWD");
function $8b532dca706696ae$export$dc071f102752d0eb(value) {
    return [
        'StringValue',
        'BooleanValue',
        'EnumValue'
    ].indexOf(value.kind) > -1;
}
function $8b532dca706696ae$export$3ff5e9927c3257c6(value) {
    return [
        'IntValue',
        'FloatValue'
    ].indexOf(value.kind) > -1;
}
function $8b532dca706696ae$var$isStringValue(value) {
    return value.kind === 'StringValue';
}
function $8b532dca706696ae$var$isBooleanValue(value) {
    return value.kind === 'BooleanValue';
}
function $8b532dca706696ae$var$isIntValue(value) {
    return value.kind === 'IntValue';
}
function $8b532dca706696ae$var$isFloatValue(value) {
    return value.kind === 'FloatValue';
}
function $8b532dca706696ae$var$isVariable(value) {
    return value.kind === 'Variable';
}
function $8b532dca706696ae$var$isObjectValue(value) {
    return value.kind === 'ObjectValue';
}
function $8b532dca706696ae$var$isListValue(value) {
    return value.kind === 'ListValue';
}
function $8b532dca706696ae$var$isEnumValue(value) {
    return value.kind === 'EnumValue';
}
function $8b532dca706696ae$var$isNullValue(value) {
    return value.kind === 'NullValue';
}
function $8b532dca706696ae$export$a1dab82d368d6525(argObj, name, value, variables) {
    if ($8b532dca706696ae$var$isIntValue(value) || $8b532dca706696ae$var$isFloatValue(value)) argObj[name.value] = Number(value.value);
    else if ($8b532dca706696ae$var$isBooleanValue(value) || $8b532dca706696ae$var$isStringValue(value)) argObj[name.value] = value.value;
    else if ($8b532dca706696ae$var$isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function(obj) {
            return $8b532dca706696ae$export$a1dab82d368d6525(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    } else if ($8b532dca706696ae$var$isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    } else if ($8b532dca706696ae$var$isListValue(value)) argObj[name.value] = value.values.map(function(listValue) {
        var nestedArgArrayObj = {};
        $8b532dca706696ae$export$a1dab82d368d6525(nestedArgArrayObj, name, listValue, variables);
        return nestedArgArrayObj[name.value];
    });
    else if ($8b532dca706696ae$var$isEnumValue(value)) argObj[name.value] = value.value;
    else if ($8b532dca706696ae$var$isNullValue(value)) argObj[name.value] = null;
    else throw new (0, $9YXqx.InvariantError)(17);
}
function $8b532dca706696ae$export$54be8689c65f3b56(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function(directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) directive.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return $8b532dca706696ae$export$a1dab82d368d6525(directivesObj[directive.name.value], name, value, variables);
            });
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $8b532dca706696ae$export$a1dab82d368d6525(argObj, name, value, variables);
        });
    }
    return $8b532dca706696ae$export$3cdb6c178b88cabe(field.name.value, argObj, directivesObj);
}
var $8b532dca706696ae$var$KNOWN_DIRECTIVES = [
    'connection',
    'include',
    'skip',
    'client',
    'rest',
    'export'
];
function $8b532dca706696ae$export$3cdb6c178b88cabe(fieldName, args, directives) {
    if (directives && directives['connection'] && directives['connection']['key']) {
        if (directives['connection']['filter'] && directives['connection']['filter'].length > 0) {
            var filterKeys = directives['connection']['filter'] ? directives['connection']['filter'] : [];
            filterKeys.sort();
            var queryArgs_1 = args;
            var filteredArgs_1 = {};
            filterKeys.forEach(function(key) {
                filteredArgs_1[key] = queryArgs_1[key];
            });
            return directives['connection']['key'] + "(" + JSON.stringify(filteredArgs_1) + ")";
        } else return directives['connection']['key'];
    }
    var completeFieldName = fieldName;
    if (args) {
        var stringifiedArgs = (0, (/*@__PURE__*/$parcel$interopDefault($4ZPM2)))(args);
        completeFieldName += "(" + stringifiedArgs + ")";
    }
    if (directives) Object.keys(directives).forEach(function(key) {
        if ($8b532dca706696ae$var$KNOWN_DIRECTIVES.indexOf(key) !== -1) return;
        if (directives[key] && Object.keys(directives[key]).length) completeFieldName += "@" + key + "(" + JSON.stringify(directives[key]) + ")";
        else completeFieldName += "@" + key;
    });
    return completeFieldName;
}
function $8b532dca706696ae$export$3f5a60fb6a781b4f(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $8b532dca706696ae$export$a1dab82d368d6525(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function $8b532dca706696ae$export$7d1ad22471852218(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function $8b532dca706696ae$export$fb56ad75dd311c12(selection) {
    return selection.kind === 'Field';
}
function $8b532dca706696ae$export$22a1cdafaf27bcff(selection) {
    return selection.kind === 'InlineFragment';
}
function $8b532dca706696ae$export$e33b89a9aa87695(idObject) {
    return idObject && idObject.type === 'id' && typeof idObject.generated === 'boolean';
}
function $8b532dca706696ae$export$b124f125e34d720a(idConfig, generated) {
    if (generated === void 0) generated = false;
    return (0, $dEf6I.__assign)({
        type: 'id',
        generated: generated
    }, typeof idConfig === 'string' ? {
        id: idConfig,
        typename: undefined
    } : idConfig);
}
function $8b532dca706696ae$export$226c1c6d1a5b660a(jsonObject) {
    return jsonObject != null && typeof jsonObject === 'object' && jsonObject.type === 'json';
}
function $8b532dca706696ae$var$defaultValueFromVariable(node) {
    throw new (0, $9YXqx.InvariantError)(18);
}
function $8b532dca706696ae$export$b3db129ed867b445(node, onVariable) {
    if (onVariable === void 0) onVariable = $8b532dca706696ae$var$defaultValueFromVariable;
    switch(node.kind){
        case 'Variable':
            return onVariable(node);
        case 'NullValue':
            return null;
        case 'IntValue':
            return parseInt(node.value, 10);
        case 'FloatValue':
            return parseFloat(node.value);
        case 'ListValue':
            return node.values.map(function(v) {
                return $8b532dca706696ae$export$b3db129ed867b445(v, onVariable);
            });
        case 'ObjectValue':
            var value = {};
            for(var _i = 0, _a = node.fields; _i < _a.length; _i++){
                var field = _a[_i];
                value[field.name.value] = $8b532dca706696ae$export$b3db129ed867b445(field.value, onVariable);
            }
            return value;
        default:
            return node.value;
    }
}
function $8b532dca706696ae$export$2a7f471142984a91(field, variables) {
    if (field.directives && field.directives.length) {
        var directiveObj_1 = {};
        field.directives.forEach(function(directive) {
            directiveObj_1[directive.name.value] = $8b532dca706696ae$export$3f5a60fb6a781b4f(directive, variables);
        });
        return directiveObj_1;
    }
    return null;
}
function $8b532dca706696ae$export$3dc388a5f013b4a5(selection, variables) {
    if (variables === void 0) variables = {};
    return $8b532dca706696ae$export$b7bdffb7e6f1ef53(selection.directives).every(function(_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === 'Variable') {
            evaledValue = variables[ifArgument.value.name.value];
            (0, $9YXqx.invariant)(evaledValue !== void 0, 13);
        } else evaledValue = ifArgument.value.value;
        return directive.name.value === 'skip' ? !evaledValue : evaledValue;
    });
}
function $8b532dca706696ae$export$1b217de6ce18b9a(doc) {
    var names = [];
    (0, $kx5XW.visit)(doc, {
        Directive: function(node) {
            names.push(node.name.value);
        }
    });
    return names;
}
function $8b532dca706696ae$export$2dafb573e282fe8d(names, doc) {
    return $8b532dca706696ae$export$1b217de6ce18b9a(doc).some(function(name) {
        return names.indexOf(name) > -1;
    });
}
function $8b532dca706696ae$export$8d1e9e5bbfa5d09a(document) {
    return document && $8b532dca706696ae$export$2dafb573e282fe8d([
        'client'
    ], document) && $8b532dca706696ae$export$2dafb573e282fe8d([
        'export'
    ], document);
}
function $8b532dca706696ae$var$isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === 'skip' || value === 'include';
}
function $8b532dca706696ae$export$b7bdffb7e6f1ef53(directives) {
    return directives ? directives.filter($8b532dca706696ae$var$isInclusionDirective).map(function(directive) {
        var directiveArguments = directive.arguments;
        var directiveName = directive.name.value;
        (0, $9YXqx.invariant)(directiveArguments && directiveArguments.length === 1, 14);
        var ifArgument = directiveArguments[0];
        (0, $9YXqx.invariant)(ifArgument.name && ifArgument.name.value === 'if', 15);
        var ifValue = ifArgument.value;
        (0, $9YXqx.invariant)(ifValue && (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), 16);
        return {
            directive: directive,
            ifArgument: ifArgument
        };
    }) : [];
}
function $8b532dca706696ae$export$abbf37c7cf644e41(document, fragmentName) {
    var actualFragmentName = fragmentName;
    var fragments = [];
    document.definitions.forEach(function(definition) {
        if (definition.kind === 'OperationDefinition') throw new (0, $9YXqx.InvariantError)(11);
        if (definition.kind === 'FragmentDefinition') fragments.push(definition);
    });
    if (typeof actualFragmentName === 'undefined') {
        (0, $9YXqx.invariant)(fragments.length === 1, 12);
        actualFragmentName = fragments[0].name.value;
    }
    var query = (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, document), {
        definitions: (0, $dEf6I.__spreadArrays)([
            {
                kind: 'OperationDefinition',
                operation: 'query',
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'FragmentSpread',
                            name: {
                                kind: 'Name',
                                value: actualFragmentName
                            }
                        }
                    ]
                }
            }
        ], document.definitions)
    });
    return query;
}
function $8b532dca706696ae$export$e6e34fd1f2686227(target) {
    var sources = [];
    for(var _i = 1; _i < arguments.length; _i++)sources[_i - 1] = arguments[_i];
    sources.forEach(function(source) {
        if (typeof source === 'undefined' || source === null) return;
        Object.keys(source).forEach(function(key) {
            target[key] = source[key];
        });
    });
    return target;
}
function $8b532dca706696ae$export$a92e7a440b22bdf0(doc) {
    $8b532dca706696ae$export$a7d0d8111d2386df(doc);
    var mutationDef = doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition' && definition.operation === 'mutation';
    })[0];
    (0, $9YXqx.invariant)(mutationDef, 1);
    return mutationDef;
}
function $8b532dca706696ae$export$a7d0d8111d2386df(doc) {
    (0, $9YXqx.invariant)(doc && doc.kind === 'Document', 2);
    var operations = doc.definitions.filter(function(d) {
        return d.kind !== 'FragmentDefinition';
    }).map(function(definition) {
        if (definition.kind !== 'OperationDefinition') throw new (0, $9YXqx.InvariantError)(3);
        return definition;
    });
    (0, $9YXqx.invariant)(operations.length <= 1, 4);
    return doc;
}
function $8b532dca706696ae$export$7a5b1fa979d2c158(doc) {
    $8b532dca706696ae$export$a7d0d8111d2386df(doc);
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition';
    })[0];
}
function $8b532dca706696ae$export$78a8e95d8d43ad7f(document) {
    var def = $8b532dca706696ae$export$7a5b1fa979d2c158(document);
    (0, $9YXqx.invariant)(def, 5);
    return def;
}
function $8b532dca706696ae$export$41bca9dc6871dd4e(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition' && definition.name;
    }).map(function(x) {
        return x.name.value;
    })[0] || null;
}
function $8b532dca706696ae$export$5320a7ba9466a3df(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'FragmentDefinition';
    });
}
function $8b532dca706696ae$export$d96b2213c1b9d3a9(doc) {
    var queryDef = $8b532dca706696ae$export$7a5b1fa979d2c158(doc);
    (0, $9YXqx.invariant)(queryDef && queryDef.operation === 'query', 6);
    return queryDef;
}
function $8b532dca706696ae$export$772111caef41b3f5(doc) {
    (0, $9YXqx.invariant)(doc.kind === 'Document', 7);
    (0, $9YXqx.invariant)(doc.definitions.length <= 1, 8);
    var fragmentDef = doc.definitions[0];
    (0, $9YXqx.invariant)(fragmentDef.kind === 'FragmentDefinition', 9);
    return fragmentDef;
}
function $8b532dca706696ae$export$f431198736b7f96d(queryDoc) {
    $8b532dca706696ae$export$a7d0d8111d2386df(queryDoc);
    var fragmentDefinition;
    for(var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++){
        var definition = _a[_i];
        if (definition.kind === 'OperationDefinition') {
            var operation = definition.operation;
            if (operation === 'query' || operation === 'mutation' || operation === 'subscription') return definition;
        }
        if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) fragmentDefinition = definition;
    }
    if (fragmentDefinition) return fragmentDefinition;
    throw new (0, $9YXqx.InvariantError)(10);
}
function $8b532dca706696ae$export$193789b4c8246dd4(fragments) {
    if (fragments === void 0) fragments = [];
    var symTable = {};
    fragments.forEach(function(fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function $8b532dca706696ae$export$84c19026e616569e(definition) {
    if (definition && definition.variableDefinitions && definition.variableDefinitions.length) {
        var defaultValues = definition.variableDefinitions.filter(function(_a) {
            var defaultValue = _a.defaultValue;
            return defaultValue;
        }).map(function(_a) {
            var variable = _a.variable, defaultValue = _a.defaultValue;
            var defaultValueObj = {};
            $8b532dca706696ae$export$a1dab82d368d6525(defaultValueObj, variable.name, defaultValue);
            return defaultValueObj;
        });
        return $8b532dca706696ae$export$e6e34fd1f2686227.apply(void 0, (0, $dEf6I.__spreadArrays)([
            {}
        ], defaultValues));
    }
    return {};
}
function $8b532dca706696ae$export$55ead6c9e4eac970(operation) {
    var names = new Set();
    if (operation.variableDefinitions) for(var _i = 0, _a = operation.variableDefinitions; _i < _a.length; _i++){
        var definition = _a[_i];
        names.add(definition.variable.name.value);
    }
    return names;
}
function $8b532dca706696ae$var$filterInPlace(array, test, context) {
    var target = 0;
    array.forEach(function(elem, i) {
        if (test.call(this, elem, i, array)) array[target++] = elem;
    }, context);
    array.length = target;
    return array;
}
var $8b532dca706696ae$var$TYPENAME_FIELD = {
    kind: 'Field',
    name: {
        kind: 'Name',
        value: '__typename'
    }
};
function $8b532dca706696ae$var$isEmpty(op, fragments) {
    return op.selectionSet.selections.every(function(selection) {
        return selection.kind === 'FragmentSpread' && $8b532dca706696ae$var$isEmpty(fragments[selection.name.value], fragments);
    });
}
function $8b532dca706696ae$var$nullIfDocIsEmpty(doc) {
    return $8b532dca706696ae$var$isEmpty($8b532dca706696ae$export$7a5b1fa979d2c158(doc) || $8b532dca706696ae$export$772111caef41b3f5(doc), $8b532dca706696ae$export$193789b4c8246dd4($8b532dca706696ae$export$5320a7ba9466a3df(doc))) ? null : doc;
}
function $8b532dca706696ae$var$getDirectiveMatcher(directives) {
    return function directiveMatcher(directive) {
        return directives.some(function(dir) {
            return dir.name && dir.name === directive.name.value || dir.test && dir.test(directive);
        });
    };
}
function $8b532dca706696ae$export$e5ae0530da5fe96c(directives, doc) {
    var variablesInUse = Object.create(null);
    var variablesToRemove = [];
    var fragmentSpreadsInUse = Object.create(null);
    var fragmentSpreadsToRemove = [];
    var modifiedDoc = $8b532dca706696ae$var$nullIfDocIsEmpty((0, $kx5XW.visit)(doc, {
        Variable: {
            enter: function(node, _key, parent) {
                if (parent.kind !== 'VariableDefinition') variablesInUse[node.name.value] = true;
            }
        },
        Field: {
            enter: function(node) {
                if (directives && node.directives) {
                    var shouldRemoveField = directives.some(function(directive) {
                        return directive.remove;
                    });
                    if (shouldRemoveField && node.directives && node.directives.some($8b532dca706696ae$var$getDirectiveMatcher(directives))) {
                        if (node.arguments) node.arguments.forEach(function(arg) {
                            if (arg.value.kind === 'Variable') variablesToRemove.push({
                                name: arg.value.name.value
                            });
                        });
                        if (node.selectionSet) $8b532dca706696ae$var$getAllFragmentSpreadsFromSelectionSet(node.selectionSet).forEach(function(frag) {
                            fragmentSpreadsToRemove.push({
                                name: frag.name.value
                            });
                        });
                        return null;
                    }
                }
            }
        },
        FragmentSpread: {
            enter: function(node) {
                fragmentSpreadsInUse[node.name.value] = true;
            }
        },
        Directive: {
            enter: function(node) {
                if ($8b532dca706696ae$var$getDirectiveMatcher(directives)(node)) return null;
            }
        }
    }));
    if (modifiedDoc && $8b532dca706696ae$var$filterInPlace(variablesToRemove, function(v) {
        return !variablesInUse[v.name];
    }).length) modifiedDoc = $8b532dca706696ae$export$ecd5bb739c4a8b38(variablesToRemove, modifiedDoc);
    if (modifiedDoc && $8b532dca706696ae$var$filterInPlace(fragmentSpreadsToRemove, function(fs) {
        return !fragmentSpreadsInUse[fs.name];
    }).length) modifiedDoc = $8b532dca706696ae$export$7c9d17c333033c13(fragmentSpreadsToRemove, modifiedDoc);
    return modifiedDoc;
}
function $8b532dca706696ae$export$43b332f87950a467(doc) {
    return (0, $kx5XW.visit)($8b532dca706696ae$export$a7d0d8111d2386df(doc), {
        SelectionSet: {
            enter: function(node, _key, parent) {
                if (parent && parent.kind === 'OperationDefinition') return;
                var selections = node.selections;
                if (!selections) return;
                var skip = selections.some(function(selection) {
                    return $8b532dca706696ae$export$fb56ad75dd311c12(selection) && (selection.name.value === '__typename' || selection.name.value.lastIndexOf('__', 0) === 0);
                });
                if (skip) return;
                var field = parent;
                if ($8b532dca706696ae$export$fb56ad75dd311c12(field) && field.directives && field.directives.some(function(d) {
                    return d.name.value === 'export';
                })) return;
                return (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, node), {
                    selections: (0, $dEf6I.__spreadArrays)(selections, [
                        $8b532dca706696ae$var$TYPENAME_FIELD
                    ])
                });
            }
        }
    });
}
var $8b532dca706696ae$var$connectionRemoveConfig = {
    test: function(directive) {
        var willRemove = directive.name.value === 'connection';
        if (willRemove) !directive.arguments || directive.arguments.some(function(arg) {
            return arg.name.value === 'key';
        });
        return willRemove;
    }
};
function $8b532dca706696ae$export$74985f3324559867(doc) {
    return $8b532dca706696ae$export$e5ae0530da5fe96c([
        $8b532dca706696ae$var$connectionRemoveConfig
    ], $8b532dca706696ae$export$a7d0d8111d2386df(doc));
}
function $8b532dca706696ae$var$hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    return selectionSet && selectionSet.selections && selectionSet.selections.some(function(selection) {
        return $8b532dca706696ae$var$hasDirectivesInSelection(directives, selection, nestedCheck);
    });
}
function $8b532dca706696ae$var$hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    if (!$8b532dca706696ae$export$fb56ad75dd311c12(selection)) return true;
    if (!selection.directives) return false;
    return selection.directives.some($8b532dca706696ae$var$getDirectiveMatcher(directives)) || nestedCheck && $8b532dca706696ae$var$hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck);
}
function $8b532dca706696ae$export$deed3420cb5d2e1d(directives, doc) {
    $8b532dca706696ae$export$a7d0d8111d2386df(doc);
    var parentPath;
    return $8b532dca706696ae$var$nullIfDocIsEmpty((0, $kx5XW.visit)(doc, {
        SelectionSet: {
            enter: function(node, _key, _parent, path) {
                var currentPath = path.join('-');
                if (!parentPath || currentPath === parentPath || !currentPath.startsWith(parentPath)) {
                    if (node.selections) {
                        var selectionsWithDirectives = node.selections.filter(function(selection) {
                            return $8b532dca706696ae$var$hasDirectivesInSelection(directives, selection);
                        });
                        if ($8b532dca706696ae$var$hasDirectivesInSelectionSet(directives, node, false)) parentPath = currentPath;
                        return (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, node), {
                            selections: selectionsWithDirectives
                        });
                    } else return null;
                }
            }
        }
    }));
}
function $8b532dca706696ae$var$getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function(aConfig) {
            return argument.value && argument.value.kind === 'Variable' && argument.value.name && (aConfig.name === argument.value.name.value || aConfig.test && aConfig.test(argument));
        });
    };
}
function $8b532dca706696ae$export$ecd5bb739c4a8b38(config, doc) {
    var argMatcher = $8b532dca706696ae$var$getArgumentMatcher(config);
    return $8b532dca706696ae$var$nullIfDocIsEmpty((0, $kx5XW.visit)(doc, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, node), {
                    variableDefinitions: node.variableDefinitions.filter(function(varDef) {
                        return !config.some(function(arg) {
                            return arg.name === varDef.variable.name.value;
                        });
                    })
                });
            }
        },
        Field: {
            enter: function(node) {
                var shouldRemoveField = config.some(function(argConfig) {
                    return argConfig.remove;
                });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    node.arguments.forEach(function(arg) {
                        if (argMatcher(arg)) argMatchCount_1 += 1;
                    });
                    if (argMatchCount_1 === 1) return null;
                }
            }
        },
        Argument: {
            enter: function(node) {
                if (argMatcher(node)) return null;
            }
        }
    }));
}
function $8b532dca706696ae$export$7c9d17c333033c13(config, doc) {
    function enter(node) {
        if (config.some(function(def) {
            return def.name === node.name.value;
        })) return null;
    }
    return $8b532dca706696ae$var$nullIfDocIsEmpty((0, $kx5XW.visit)(doc, {
        FragmentSpread: {
            enter: enter
        },
        FragmentDefinition: {
            enter: enter
        }
    }));
}
function $8b532dca706696ae$var$getAllFragmentSpreadsFromSelectionSet(selectionSet) {
    var allFragments = [];
    selectionSet.selections.forEach(function(selection) {
        if (($8b532dca706696ae$export$fb56ad75dd311c12(selection) || $8b532dca706696ae$export$22a1cdafaf27bcff(selection)) && selection.selectionSet) $8b532dca706696ae$var$getAllFragmentSpreadsFromSelectionSet(selection.selectionSet).forEach(function(frag) {
            return allFragments.push(frag);
        });
        else if (selection.kind === 'FragmentSpread') allFragments.push(selection);
    });
    return allFragments;
}
function $8b532dca706696ae$export$57c368c23873f32b(document) {
    var definition = $8b532dca706696ae$export$f431198736b7f96d(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === 'query') return document;
    var modifiedDoc = (0, $kx5XW.visit)(document, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, node), {
                    operation: 'query'
                });
            }
        }
    });
    return modifiedDoc;
}
function $8b532dca706696ae$export$8eae69e876ee321e(document) {
    $8b532dca706696ae$export$a7d0d8111d2386df(document);
    var modifiedDoc = $8b532dca706696ae$export$e5ae0530da5fe96c([
        {
            test: function(directive) {
                return directive.name.value === 'client';
            },
            remove: true
        }
    ], document);
    if (modifiedDoc) modifiedDoc = (0, $kx5XW.visit)(modifiedDoc, {
        FragmentDefinition: {
            enter: function(node) {
                if (node.selectionSet) {
                    var isTypenameOnly = node.selectionSet.selections.every(function(selection) {
                        return $8b532dca706696ae$export$fb56ad75dd311c12(selection) && selection.name.value === '__typename';
                    });
                    if (isTypenameOnly) return null;
                }
            }
        }
    });
    return modifiedDoc;
}
var $8b532dca706696ae$export$772fbc04a0ad4ce9 = typeof WeakMap === 'function' && !(typeof navigator === 'object' && navigator.product === 'ReactNative');
var $8b532dca706696ae$var$toString = Object.prototype.toString;
function $8b532dca706696ae$export$629a2bd3f5a49ecc(value) {
    return $8b532dca706696ae$var$cloneDeepHelper(value, new Map());
}
function $8b532dca706696ae$var$cloneDeepHelper(val, seen) {
    switch($8b532dca706696ae$var$toString.call(val)){
        case "[object Array]":
            if (seen.has(val)) return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function(child, i) {
                copy_1[i] = $8b532dca706696ae$var$cloneDeepHelper(child, seen);
            });
            return copy_1;
        case "[object Object]":
            if (seen.has(val)) return seen.get(val);
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function(key) {
                copy_2[key] = $8b532dca706696ae$var$cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        default:
            return val;
    }
}
function $8b532dca706696ae$export$4bd44a2aa29d3d6e() {
    if (typeof $aVaWD !== 'undefined' && "production") return "production";
    return 'development';
}
function $8b532dca706696ae$export$f0cb0fda19c18b37(env) {
    return $8b532dca706696ae$export$4bd44a2aa29d3d6e() === env;
}
function $8b532dca706696ae$export$f15d00aa73aafac4() {
    return $8b532dca706696ae$export$f0cb0fda19c18b37('production') === true;
}
function $8b532dca706696ae$export$df77466336fe5355() {
    return $8b532dca706696ae$export$f0cb0fda19c18b37('development') === true;
}
function $8b532dca706696ae$export$410cbc2864fa25b5() {
    return $8b532dca706696ae$export$f0cb0fda19c18b37('test') === true;
}
function $8b532dca706696ae$export$50a91acae4904909(f) {
    try {
        return f();
    } catch (e) {
        if (console.error) console.error(e);
    }
}
function $8b532dca706696ae$export$b4df399e879e53ab(result) {
    return result.errors && result.errors.length;
}
function $8b532dca706696ae$var$deepFreeze(o) {
    Object.freeze(o);
    Object.getOwnPropertyNames(o).forEach(function(prop) {
        if (o[prop] !== null && (typeof o[prop] === 'object' || typeof o[prop] === 'function') && !Object.isFrozen(o[prop])) $8b532dca706696ae$var$deepFreeze(o[prop]);
    });
    return o;
}
function $8b532dca706696ae$export$7f9c177735b71f18(obj) {
    if ($8b532dca706696ae$export$df77466336fe5355() || $8b532dca706696ae$export$410cbc2864fa25b5()) {
        var symbolIsPolyfilled = typeof Symbol === 'function' && typeof Symbol('') === 'string';
        if (!symbolIsPolyfilled) return $8b532dca706696ae$var$deepFreeze(obj);
    }
    return obj;
}
var $8b532dca706696ae$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $8b532dca706696ae$export$dd702b3c8240390c() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    return $8b532dca706696ae$export$160070228be94b08(sources);
}
function $8b532dca706696ae$export$160070228be94b08(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var pastCopies = [];
        target = $8b532dca706696ae$var$shallowCopyForMerge(target, pastCopies);
        for(var i = 1; i < count; ++i)target = $8b532dca706696ae$var$mergeHelper(target, sources[i], pastCopies);
    }
    return target;
}
function $8b532dca706696ae$var$isObject(obj) {
    return obj !== null && typeof obj === 'object';
}
function $8b532dca706696ae$var$mergeHelper(target, source, pastCopies) {
    if ($8b532dca706696ae$var$isObject(source) && $8b532dca706696ae$var$isObject(target)) {
        if (Object.isExtensible && !Object.isExtensible(target)) target = $8b532dca706696ae$var$shallowCopyForMerge(target, pastCopies);
        Object.keys(source).forEach(function(sourceKey) {
            var sourceValue = source[sourceKey];
            if ($8b532dca706696ae$var$hasOwnProperty.call(target, sourceKey)) {
                var targetValue = target[sourceKey];
                if (sourceValue !== targetValue) target[sourceKey] = $8b532dca706696ae$var$mergeHelper($8b532dca706696ae$var$shallowCopyForMerge(targetValue, pastCopies), sourceValue, pastCopies);
            } else target[sourceKey] = sourceValue;
        });
        return target;
    }
    return source;
}
function $8b532dca706696ae$var$shallowCopyForMerge(value, pastCopies) {
    if (value !== null && typeof value === 'object' && pastCopies.indexOf(value) < 0) {
        if (Array.isArray(value)) value = value.slice(0);
        else value = (0, $dEf6I.__assign)({
            __proto__: Object.getPrototypeOf(value)
        }, value);
        pastCopies.push(value);
    }
    return value;
}
var $8b532dca706696ae$var$haveWarned = Object.create({});
function $8b532dca706696ae$export$49d47c8e549bfaf9(msg, type) {
    if (type === void 0) type = 'warn';
    if (!$8b532dca706696ae$export$f15d00aa73aafac4() && !$8b532dca706696ae$var$haveWarned[msg]) {
        if (!$8b532dca706696ae$export$410cbc2864fa25b5()) $8b532dca706696ae$var$haveWarned[msg] = true;
        if (type === 'error') console.error(msg);
        else console.warn(msg);
    }
}
function $8b532dca706696ae$export$c54efeba029d4fe8(data) {
    return JSON.parse(JSON.stringify(data));
}

});
parcelRegister("kx5XW", function(module, exports) {
$parcel$export(module.exports, "BREAK", () => $ef2b8468e3dc3509$export$a89c95c098ac2a58);
$parcel$export(module.exports, "visit", () => $ef2b8468e3dc3509$export$bf638b60ea8b89b7);

var $jPgXJ = parcelRequire("jPgXJ");

var $bZ4GO = parcelRequire("bZ4GO");
var $ef2b8468e3dc3509$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        'definitions'
    ],
    OperationDefinition: [
        'name',
        'variableDefinitions',
        'directives',
        'selectionSet'
    ],
    VariableDefinition: [
        'variable',
        'type',
        'defaultValue',
        'directives'
    ],
    Variable: [
        'name'
    ],
    SelectionSet: [
        'selections'
    ],
    Field: [
        'alias',
        'name',
        'arguments',
        'directives',
        'selectionSet'
    ],
    Argument: [
        'name',
        'value'
    ],
    FragmentSpread: [
        'name',
        'directives'
    ],
    InlineFragment: [
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    FragmentDefinition: [
        'name',
        // or removed in the future.
        'variableDefinitions',
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        'values'
    ],
    ObjectValue: [
        'fields'
    ],
    ObjectField: [
        'name',
        'value'
    ],
    Directive: [
        'name',
        'arguments'
    ],
    NamedType: [
        'name'
    ],
    ListType: [
        'type'
    ],
    NonNullType: [
        'type'
    ],
    SchemaDefinition: [
        'description',
        'directives',
        'operationTypes'
    ],
    OperationTypeDefinition: [
        'type'
    ],
    ScalarTypeDefinition: [
        'description',
        'name',
        'directives'
    ],
    ObjectTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    FieldDefinition: [
        'description',
        'name',
        'arguments',
        'type',
        'directives'
    ],
    InputValueDefinition: [
        'description',
        'name',
        'type',
        'defaultValue',
        'directives'
    ],
    InterfaceTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeDefinition: [
        'description',
        'name',
        'directives',
        'types'
    ],
    EnumTypeDefinition: [
        'description',
        'name',
        'directives',
        'values'
    ],
    EnumValueDefinition: [
        'description',
        'name',
        'directives'
    ],
    InputObjectTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    DirectiveDefinition: [
        'description',
        'name',
        'arguments',
        'locations'
    ],
    SchemaExtension: [
        'directives',
        'operationTypes'
    ],
    ScalarTypeExtension: [
        'name',
        'directives'
    ],
    ObjectTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    InterfaceTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeExtension: [
        'name',
        'directives',
        'types'
    ],
    EnumTypeExtension: [
        'name',
        'directives',
        'values'
    ],
    InputObjectTypeExtension: [
        'name',
        'directives',
        'fields'
    ]
};
var $ef2b8468e3dc3509$export$a89c95c098ac2a58 = Object.freeze({});
function $ef2b8468e3dc3509$export$bf638b60ea8b89b7(root, visitor) {
    var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $ef2b8468e3dc3509$export$4fcd777a40ccf407;
    /* eslint-disable no-undef-init */ var stack = undefined;
    var inArray = Array.isArray(root);
    var keys = [
        root
    ];
    var index = -1;
    var edits = [];
    var node = undefined;
    var key = undefined;
    var parent = undefined;
    var path = [];
    var ancestors = [];
    var newRoot = root;
    /* eslint-enable no-undef-init */ do {
        index++;
        var isLeaving = index === keys.length;
        var isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) node = node.slice();
                else {
                    var clone = {};
                    for(var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++){
                        var k = _Object$keys2[_i2];
                        clone[k] = node[k];
                    }
                    node = clone;
                }
                var editOffset = 0;
                for(var ii = 0; ii < edits.length; ii++){
                    var editKey = edits[ii][0];
                    var editValue = edits[ii][1];
                    if (inArray) editKey -= editOffset;
                    if (inArray && editValue === null) {
                        node.splice(editKey, 1);
                        editOffset++;
                    } else node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else {
            key = parent ? inArray ? index : keys[index] : undefined;
            node = parent ? parent[key] : newRoot;
            if (node === null || node === undefined) continue;
            if (parent) path.push(key);
        }
        var result = void 0;
        if (!Array.isArray(node)) {
            if (!(0, $bZ4GO.isNode)(node)) throw new Error("Invalid AST Node: ".concat((0, $jPgXJ.default)(node), "."));
            var visitFn = $ef2b8468e3dc3509$export$c9c25cca74db6e70(visitor, node.kind, isLeaving);
            if (visitFn) {
                result = visitFn.call(visitor, node, key, parent, path, ancestors);
                if (result === $ef2b8468e3dc3509$export$a89c95c098ac2a58) break;
                if (result === false) {
                    if (!isLeaving) {
                        path.pop();
                        continue;
                    }
                } else if (result !== undefined) {
                    edits.push([
                        key,
                        result
                    ]);
                    if (!isLeaving) {
                        if ((0, $bZ4GO.isNode)(result)) node = result;
                        else {
                            path.pop();
                            continue;
                        }
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _visitorKeys$node$kin;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_visitorKeys$node$kin = visitorKeys[node.kind]) !== null && _visitorKeys$node$kin !== void 0 ? _visitorKeys$node$kin : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) newRoot = edits[edits.length - 1][1];
    return newRoot;
}
function $ef2b8468e3dc3509$export$728beebeea393478(visitors) {
    var skipping = new Array(visitors.length);
    return {
        enter: function enter(node) {
            for(var i = 0; i < visitors.length; i++)if (skipping[i] == null) {
                var fn = $ef2b8468e3dc3509$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ false);
                if (fn) {
                    var result = fn.apply(visitors[i], arguments);
                    if (result === false) skipping[i] = node;
                    else if (result === $ef2b8468e3dc3509$export$a89c95c098ac2a58) skipping[i] = $ef2b8468e3dc3509$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            }
        },
        leave: function leave(node) {
            for(var i = 0; i < visitors.length; i++){
                if (skipping[i] == null) {
                    var fn = $ef2b8468e3dc3509$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ true);
                    if (fn) {
                        var result = fn.apply(visitors[i], arguments);
                        if (result === $ef2b8468e3dc3509$export$a89c95c098ac2a58) skipping[i] = $ef2b8468e3dc3509$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    }
                } else if (skipping[i] === node) skipping[i] = null;
            }
        }
    };
}
function $ef2b8468e3dc3509$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    var kindVisitor = visitor[kind];
    if (kindVisitor) {
        if (!isLeaving && typeof kindVisitor === 'function') // { Kind() {} }
        return kindVisitor;
        var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
        if (typeof kindSpecificVisitor === 'function') // { Kind: { enter() {}, leave() {} } }
        return kindSpecificVisitor;
    } else {
        var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
        if (specificVisitor) {
            if (typeof specificVisitor === 'function') // { enter() {}, leave() {} }
            return specificVisitor;
            var specificKindVisitor = specificVisitor[kind];
            if (typeof specificKindVisitor === 'function') // { enter: { Kind() {} }, leave: { Kind() {} } }
            return specificKindVisitor;
        }
    }
}

});
parcelRegister("jPgXJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $e6eff01bac404f73$export$2e2bcd8739ae039);

var $kbawo = parcelRequire("kbawo");
function $e6eff01bac404f73$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $e6eff01bac404f73$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $e6eff01bac404f73$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $e6eff01bac404f73$var$_typeof(obj);
}
var $e6eff01bac404f73$var$MAX_ARRAY_LENGTH = 10;
var $e6eff01bac404f73$var$MAX_RECURSIVE_DEPTH = 2;
function $e6eff01bac404f73$export$2e2bcd8739ae039(value) {
    return $e6eff01bac404f73$var$formatValue(value, []);
}
function $e6eff01bac404f73$var$formatValue(value, seenValues) {
    switch($e6eff01bac404f73$var$_typeof(value)){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? "[function ".concat(value.name, "]") : '[function]';
        case 'object':
            if (value === null) return 'null';
            return $e6eff01bac404f73$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $e6eff01bac404f73$var$formatObjectValue(value, previouslySeenValues) {
    if (previouslySeenValues.indexOf(value) !== -1) return '[Circular]';
    var seenValues = [].concat(previouslySeenValues, [
        value
    ]);
    var customInspectFn = $e6eff01bac404f73$var$getCustomFn(value);
    if (customInspectFn !== undefined) {
        var customValue = customInspectFn.call(value); // check for infinite recursion
        if (customValue !== value) return typeof customValue === 'string' ? customValue : $e6eff01bac404f73$var$formatValue(customValue, seenValues);
    } else if (Array.isArray(value)) return $e6eff01bac404f73$var$formatArray(value, seenValues);
    return $e6eff01bac404f73$var$formatObject(value, seenValues);
}
function $e6eff01bac404f73$var$formatObject(object, seenValues) {
    var keys = Object.keys(object);
    if (keys.length === 0) return '{}';
    if (seenValues.length > $e6eff01bac404f73$var$MAX_RECURSIVE_DEPTH) return '[' + $e6eff01bac404f73$var$getObjectTag(object) + ']';
    var properties = keys.map(function(key) {
        var value = $e6eff01bac404f73$var$formatValue(object[key], seenValues);
        return key + ': ' + value;
    });
    return '{ ' + properties.join(', ') + ' }';
}
function $e6eff01bac404f73$var$formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > $e6eff01bac404f73$var$MAX_RECURSIVE_DEPTH) return '[Array]';
    var len = Math.min($e6eff01bac404f73$var$MAX_ARRAY_LENGTH, array.length);
    var remaining = array.length - len;
    var items = [];
    for(var i = 0; i < len; ++i)items.push($e6eff01bac404f73$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push("... ".concat(remaining, " more items"));
    return '[' + items.join(', ') + ']';
}
function $e6eff01bac404f73$var$getCustomFn(object) {
    var customInspectFn = object[String((0, $kbawo.default))];
    if (typeof customInspectFn === 'function') return customInspectFn;
    if (typeof object.inspect === 'function') return object.inspect;
}
function $e6eff01bac404f73$var$getObjectTag(object) {
    var tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        var name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}

});
parcelRegister("kbawo", function(module, exports) {
$parcel$export(module.exports, "default", () => $eb0cff13e0f45bb5$export$2e2bcd8739ae039);
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $eb0cff13e0f45bb5$var$nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;
var $eb0cff13e0f45bb5$export$2e2bcd8739ae039 = $eb0cff13e0f45bb5$var$nodejsCustomInspectSymbol;

});


parcelRegister("bZ4GO", function(module, exports) {
$parcel$export(module.exports, "Location", () => $8b9907773fa80855$export$18a2be9195644f38);
$parcel$export(module.exports, "Token", () => $8b9907773fa80855$export$50792b0e93539fde);
$parcel$export(module.exports, "isNode", () => $8b9907773fa80855$export$8ee0fc9ee280b4ee);

var $ee1TB = parcelRequire("ee1TB");
var $8b9907773fa80855$export$18a2be9195644f38 = /*#__PURE__*/ function() {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ function Location(startToken, endToken, source) {
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    var _proto = Location.prototype;
    _proto.toJSON = function toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    };
    return Location;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $ee1TB.default)($8b9907773fa80855$export$18a2be9195644f38);
var $8b9907773fa80855$export$50792b0e93539fde = /*#__PURE__*/ function() {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ function Token(kind, start, end, line, column, prev, value) {
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column;
        this.value = value;
        this.prev = prev;
        this.next = null;
    }
    var _proto2 = Token.prototype;
    _proto2.toJSON = function toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    };
    return Token;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $ee1TB.default)($8b9907773fa80855$export$50792b0e93539fde);
function $8b9907773fa80855$export$8ee0fc9ee280b4ee(maybeNode) {
    return maybeNode != null && typeof maybeNode.kind === 'string';
} /**
 * The list of all possible AST node types.
 */ 

});
parcelRegister("ee1TB", function(module, exports) {
$parcel$export(module.exports, "default", () => $a5b3d7f4c35ef3b3$export$2e2bcd8739ae039);

var $74pnf = parcelRequire("74pnf");

var $kbawo = parcelRequire("kbawo");
function $a5b3d7f4c35ef3b3$export$2e2bcd8739ae039(classObject) {
    var fn = classObject.prototype.toJSON;
    typeof fn === 'function' || (0, $74pnf.default)(0);
    classObject.prototype.inspect = fn; // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2317')
    if (0, $kbawo.default) classObject.prototype[0, $kbawo.default] = fn;
}

});
parcelRegister("74pnf", function(module, exports) {
$parcel$export(module.exports, "default", () => $525c96e0c1d47afe$export$2e2bcd8739ae039);
function $525c96e0c1d47afe$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message != null ? message : 'Unexpected invariant triggered.');
}

});




parcelRegister("9YXqx", function(module, exports) {
$parcel$export(module.exports, "InvariantError", () => $7447d0a25b57c65a$export$cea12affaee22fe8);
$parcel$export(module.exports, "invariant", () => $7447d0a25b57c65a$export$f5708dca728d7177);

var $dEf6I = parcelRequire("dEf6I");

var $aVaWD = parcelRequire("aVaWD");
var $7447d0a25b57c65a$var$genericMessage = "Invariant Violation";
var $7447d0a25b57c65a$var$_a = Object.setPrototypeOf, $7447d0a25b57c65a$var$setPrototypeOf = $7447d0a25b57c65a$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $7447d0a25b57c65a$var$_a;
var $7447d0a25b57c65a$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $dEf6I.__extends)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $7447d0a25b57c65a$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $7447d0a25b57c65a$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $7447d0a25b57c65a$var$genericMessage;
        $7447d0a25b57c65a$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $7447d0a25b57c65a$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $7447d0a25b57c65a$export$cea12affaee22fe8(message);
}
function $7447d0a25b57c65a$var$wrapConsoleMethod(method) {
    return function() {
        return console[method].apply(console, arguments);
    };
}
(function(invariant) {
    invariant.warn = $7447d0a25b57c65a$var$wrapConsoleMethod("warn");
    invariant.error = $7447d0a25b57c65a$var$wrapConsoleMethod("error");
})($7447d0a25b57c65a$export$f5708dca728d7177 || ($7447d0a25b57c65a$export$f5708dca728d7177 = {}));
// Code that uses ts-invariant with rollup-plugin-invariant may want to
// import this process stub to avoid errors evaluating process.env.NODE_ENV.
// However, because most ESM-to-CJS compilers will rewrite the process import
// as tsInvariant.process, which prevents proper replacement by minifiers, we
// also attempt to define the stub globally when it is not already defined.
var $7447d0a25b57c65a$export$e54fe5b0f43758f7 = {
    env: {}
};
if (typeof $aVaWD === "object") $7447d0a25b57c65a$export$e54fe5b0f43758f7 = $aVaWD;
else try {
    // Using Function to evaluate this assignment in global scope also escapes
    // the strict mode of the current module, thereby allowing the assignment.
    // Inspired by https://github.com/facebook/regenerator/pull/369.
    Function("stub", "process = stub")($7447d0a25b57c65a$export$e54fe5b0f43758f7);
} catch (atLeastWeTried) {
// The assignment can fail if a Content Security Policy heavy-handedly
// forbids Function usage. In those environments, developers should take
// extra care to replace process.env.NODE_ENV in their production builds,
// or define an appropriate global.process polyfill.
}
var $7447d0a25b57c65a$var$invariant$1 = $7447d0a25b57c65a$export$f5708dca728d7177;
var $7447d0a25b57c65a$export$2e2bcd8739ae039 = $7447d0a25b57c65a$var$invariant$1;

});

parcelRegister("4ZPM2", function(module, exports) {
'use strict';
module.exports = function(data, opts) {
    if (!opts) opts = {};
    if (typeof opts === 'function') opts = {
        cmp: opts
    };
    var cycles = typeof opts.cycles === 'boolean' ? opts.cycles : false;
    var cmp = opts.cmp && function(f) {
        return function(node) {
            return function(a, b) {
                var aobj = {
                    key: a,
                    value: node[a]
                };
                var bobj = {
                    key: b,
                    value: node[b]
                };
                return f(aobj, bobj);
            };
        };
    }(opts.cmp);
    var seen = [];
    return function stringify(node) {
        if (node && node.toJSON && typeof node.toJSON === 'function') node = node.toJSON();
        if (node === undefined) return;
        if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
        if (typeof node !== 'object') return JSON.stringify(node);
        var i, out;
        if (Array.isArray(node)) {
            out = '[';
            for(i = 0; i < node.length; i++){
                if (i) out += ',';
                out += stringify(node[i]) || 'null';
            }
            return out + ']';
        }
        if (node === null) return 'null';
        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify('__cycle__');
            throw new TypeError('Converting circular structure to JSON');
        }
        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = '';
        for(i = 0; i < keys.length; i++){
            var key = keys[i];
            var value = stringify(node[key]);
            if (!value) continue;
            if (out) out += ',';
            out += JSON.stringify(key) + ':' + value;
        }
        seen.splice(seenIndex, 1);
        return '{' + out + '}';
    }(data);
};

});

parcelRegister("brWF5", function(module, exports) {
$parcel$export(module.exports, "equal", () => $855fb8530a3533d0$export$411ce8e5a71e3069);
var $855fb8530a3533d0$var$_a = Object.prototype, $855fb8530a3533d0$var$toString = $855fb8530a3533d0$var$_a.toString, $855fb8530a3533d0$var$hasOwnProperty = $855fb8530a3533d0$var$_a.hasOwnProperty;
var $855fb8530a3533d0$var$previousComparisons = new Map();
/**
 * Performs a deep equality check on two JavaScript values, tolerating cycles.
 */ function $855fb8530a3533d0$export$411ce8e5a71e3069(a, b) {
    try {
        return $855fb8530a3533d0$var$check(a, b);
    } finally{
        $855fb8530a3533d0$var$previousComparisons.clear();
    }
}
function $855fb8530a3533d0$var$check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) return true;
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    var aTag = $855fb8530a3533d0$var$toString.call(a);
    var bTag = $855fb8530a3533d0$var$toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) return false;
    switch(aTag){
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length) return false;
        // Fall through to object case...
        case '[object Object]':
            if ($855fb8530a3533d0$var$previouslyCompared(a, b)) return true;
            var aKeys = Object.keys(a);
            var bKeys = Object.keys(b);
            // If `a` and `b` have a different number of enumerable keys, they
            // must be different.
            var keyCount = aKeys.length;
            if (keyCount !== bKeys.length) return false;
            // Now make sure they have the same keys.
            for(var k = 0; k < keyCount; ++k){
                if (!$855fb8530a3533d0$var$hasOwnProperty.call(b, aKeys[k])) return false;
            }
            // Finally, check deep equality of all child properties.
            for(var k = 0; k < keyCount; ++k){
                var key = aKeys[k];
                if (!$855fb8530a3533d0$var$check(a[key], b[key])) return false;
            }
            return true;
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a) return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == "" + b;
        case '[object Map]':
        case '[object Set]':
            if (a.size !== b.size) return false;
            if ($855fb8530a3533d0$var$previouslyCompared(a, b)) return true;
            var aIterator = a.entries();
            var isMap = aTag === '[object Map]';
            while(true){
                var info = aIterator.next();
                if (info.done) break;
                // If a instanceof Set, aValue === aKey.
                var _a = info.value, aKey = _a[0], aValue = _a[1];
                // So this works the same way for both Set and Map.
                if (!b.has(aKey)) return false;
                // However, we care about deep equality of values only when dealing
                // with Map structures.
                if (isMap && !$855fb8530a3533d0$var$check(aValue, b.get(aKey))) return false;
            }
            return true;
    }
    // Otherwise the values are not equal.
    return false;
}
function $855fb8530a3533d0$var$previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    var bSet = $855fb8530a3533d0$var$previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b)) return true;
    } else $855fb8530a3533d0$var$previousComparisons.set(a, bSet = new Set);
    bSet.add(b);
    return false;
}
var $855fb8530a3533d0$export$2e2bcd8739ae039 = $855fb8530a3533d0$export$411ce8e5a71e3069;

});



parcelRegister("gmmZy", function(module, exports) {
$parcel$export(module.exports, "default", () => $be90891e648311ab$export$2e2bcd8739ae039);
/* global window */ 
var $3m81H = parcelRequire("3m81H");
var root;
if (typeof self !== 'undefined') root = self;
else if (typeof window !== 'undefined') root = window;
else if (typeof $parcel$global !== 'undefined') root = $parcel$global;
else root = module;
var result = (0, $3m81H.default)(root);
var $be90891e648311ab$export$2e2bcd8739ae039 = result;

});
parcelRegister("3m81H", function(module, exports) {
$parcel$export(module.exports, "default", () => $2719a712aebbf5aa$export$2e2bcd8739ae039);
function $2719a712aebbf5aa$export$2e2bcd8739ae039(root) {
    var result;
    var Symbol = root.Symbol;
    if (typeof Symbol === 'function') {
        if (Symbol.observable) result = Symbol.observable;
        else {
            result = Symbol('observable');
            Symbol.observable = result;
        }
    } else result = '@@observable';
    return result;
}

});


parcelRegister("hpR1p", function(module, exports) {

let $cadde67c9db2059c$var$load = (parcelRequire("8NRjA"))(5);
module.exports = $cadde67c9db2059c$var$load("3PWlp").then(()=>parcelRequire('lyVNO'));

});
parcelRegister("8NRjA", function(module, exports) {
"use strict";


let $668c4191bf0f19dc$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("5D1RZ")).shardUrl((parcelRequire("f4Iyr")).resolve(id), maxShards));
    };
module.exports = $668c4191bf0f19dc$var$load;

});
parcelRegister("5D1RZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $41920b99285d1b8c$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $41920b99285d1b8c$var$getDomainShardIndex;
module.exports.shardUrl = $41920b99285d1b8c$var$shardUrl;
module.exports.shardUrlUnchecked = $41920b99285d1b8c$var$shardUrlUnchecked;
const $41920b99285d1b8c$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $41920b99285d1b8c$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $41920b99285d1b8c$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $41920b99285d1b8c$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $41920b99285d1b8c$var$removeTrailingShard(subdomain) {
    if (!$41920b99285d1b8c$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $41920b99285d1b8c$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$41920b99285d1b8c$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $41920b99285d1b8c$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $41920b99285d1b8c$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $41920b99285d1b8c$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $41920b99285d1b8c$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $41920b99285d1b8c$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $41920b99285d1b8c$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$41920b99285d1b8c$var$globalKeyName]) return url;
    return $41920b99285d1b8c$var$shardUrlUnchecked(url, maxShards);
}
const $41920b99285d1b8c$var$domainShardingKey = module.exports.domainShardingKey = $41920b99285d1b8c$var$globalKeyName;

});

parcelRegister("f4Iyr", function(module, exports) {
$parcel$export(module.exports, "register", () => $af99ca56c6670e17$export$6503ec6e8aabbaf, (v) => $af99ca56c6670e17$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $af99ca56c6670e17$export$f7ad0328861e2f03, (v) => $af99ca56c6670e17$export$f7ad0328861e2f03 = v);
var $af99ca56c6670e17$export$6503ec6e8aabbaf;
var $af99ca56c6670e17$export$f7ad0328861e2f03;
"use strict";
var $af99ca56c6670e17$var$mapping = new Map();
function $af99ca56c6670e17$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$af99ca56c6670e17$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $af99ca56c6670e17$var$resolve(id) {
    var resolved = $af99ca56c6670e17$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$af99ca56c6670e17$export$6503ec6e8aabbaf = $af99ca56c6670e17$var$register;
$af99ca56c6670e17$export$f7ad0328861e2f03 = $af99ca56c6670e17$var$resolve;

});



parcelRegister("3WMIk", function(module, exports) {

let $2dfc93727fd6281e$var$load = (parcelRequire("8NRjA"))(5);
module.exports = $2dfc93727fd6281e$var$load("2dKSW").then(()=>parcelRequire('hWSh2'));

});

parcelRegister("76Etx", function(module, exports) {

let $52c87d7e6bc0d255$var$load = (parcelRequire("8NRjA"))(5);
module.exports = $52c87d7e6bc0d255$var$load("cT6yQ").then(()=>parcelRequire('bhPyK'));

});

parcelRegister("jAaAo", function(module, exports) {

let $e41997439d881cdb$var$load = (parcelRequire("8NRjA"))(5);
module.exports = $e41997439d881cdb$var$load("knPTc").then(()=>parcelRequire('eqvx9'));

});

parcelRegister("fKdKH", function(module, exports) {
$parcel$export(module.exports, "Fragment", () => $b765d1d079113dc9$export$ffb0004e005737fa, (v) => $b765d1d079113dc9$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $b765d1d079113dc9$export$34b9dba7ce09269b, (v) => $b765d1d079113dc9$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $b765d1d079113dc9$export$25062201e9e25d76, (v) => $b765d1d079113dc9$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b765d1d079113dc9$export$ffb0004e005737fa;
var $b765d1d079113dc9$export$34b9dba7ce09269b;
var $b765d1d079113dc9$export$25062201e9e25d76;
'use strict';

var $dQwsT = parcelRequire("dQwsT");
var $b765d1d079113dc9$var$k = Symbol.for("react.element"), $b765d1d079113dc9$var$l = Symbol.for("react.fragment"), $b765d1d079113dc9$var$m = Object.prototype.hasOwnProperty, $b765d1d079113dc9$var$n = $dQwsT.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $b765d1d079113dc9$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $b765d1d079113dc9$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$b765d1d079113dc9$var$m.call(a, b) && !$b765d1d079113dc9$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $b765d1d079113dc9$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $b765d1d079113dc9$var$n.current
    };
}
$b765d1d079113dc9$export$ffb0004e005737fa = $b765d1d079113dc9$var$l;
$b765d1d079113dc9$export$34b9dba7ce09269b = $b765d1d079113dc9$var$q;
$b765d1d079113dc9$export$25062201e9e25d76 = $b765d1d079113dc9$var$q;

});

parcelRegister("2DnMr", function(module, exports) {

let $1eb1ab8a01bc8009$var$load = (parcelRequire("8NRjA"))(5);
module.exports = $1eb1ab8a01bc8009$var$load("4SAe1").then(()=>parcelRequire('hqVI6'));

});

parcelRegister("79Dx6", function(module, exports) {
$parcel$export(module.exports, "STARGATE_PROXY_PATH", () => $8da7d4b05a0111d8$export$5df9262e102d0c32);
$parcel$export(module.exports, "default", () => $8da7d4b05a0111d8$export$2e2bcd8739ae039);

var $1RuJ0 = parcelRequire("1RuJ0");

var $hz4bR = parcelRequire("hz4bR");

var $hOQhQ = parcelRequire("hOQhQ");

var $cWnSW = parcelRequire("cWnSW");

var $dHwqw = parcelRequire("dHwqw");

var $1rUiu = parcelRequire("1rUiu");

var $cDSz8 = parcelRequire("cDSz8");

var $6M7gQ = parcelRequire("6M7gQ");

var $bJILN = parcelRequire("bJILN");

var $kxRFZ = parcelRequire("kxRFZ");

var $fPqPr = parcelRequire("fPqPr");

var $af4kr = parcelRequire("af4kr");

var $dy9Sx = parcelRequire("dy9Sx");

var $5JbDb = parcelRequire("5JbDb");

var $dxiIz = parcelRequire("dxiIz");

var $kk1PE = parcelRequire("kk1PE");

var $ctMxd = parcelRequire("ctMxd");

var $5Akh6 = parcelRequire("5Akh6");

var $gSdvR = parcelRequire("gSdvR");

var $k0wX2 = parcelRequire("k0wX2");

var $49cIJ = parcelRequire("49cIJ");

var $3ohfK = parcelRequire("3ohfK");

var $8thuK = parcelRequire("8thuK");

var $h6jy8 = parcelRequire("h6jy8");
const $8da7d4b05a0111d8$export$5df9262e102d0c32 = '/gateway/api/gasv3/api/v1';
const $8da7d4b05a0111d8$var$LAST_SCREEN_EVENT_STORAGE_KEY = 'last.screen.event';
class $8da7d4b05a0111d8$export$48361b6ed38f1b0 {
    static getCallback(logger) {
        logger = logger || console;
        return (response)=>{
            $8da7d4b05a0111d8$export$48361b6ed38f1b0.callback(response, logger);
        };
    }
    static callback(response, logger) {
        const statusCode = response.getStatusCode();
        if (statusCode >= 200 && statusCode <= 299) response.getEventResponseList().forEach((eventResponse)=>{
            logger.warn('Validation report for event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
        });
        else if (statusCode === 400 || statusCode === 404) {
            logger.warn('GASv3 submission failed with HTTP Status Code %d: %s', response.getStatusCode(), response.getMessage());
            response.getEventResponseList().forEach((eventResponse)=>{
                logger.warn('Event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
            });
        } else {
            logger.log('GASv3 submission failed with HTTP Status Code %d: %s', response.getStatusCode(), response.getMessage());
            response.eventResponseList.forEach((eventResponse)=>{
                logger.debug('Event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
            });
        }
    }
}
class $8da7d4b05a0111d8$export$2e2bcd8739ae039 {
    metadataCallsEnabled(settings) {
        if (typeof settings.disableMetadataCalls === 'boolean') return !settings.disableMetadataCalls;
        return !(0, $49cIJ.TestSupport).isGeminiVREnvironment() && !(0, $49cIJ.TestSupport).areFetchCallsDisabled();
    }
    eventCallsEnabled(settings) {
        if (typeof settings.disableEventCalls === 'boolean') return !settings.disableEventCalls;
        return !(0, $49cIJ.TestSupport).isGeminiVREnvironment() && !(0, $49cIJ.TestSupport).areFetchCallsDisabled();
    }
    setEventValidationMode(eventValidationMode) {
        this._context.context.validationMode = eventValidationMode;
    }
    /**
   * @private
   * @deprecated
   * Please avoid using internal properties. They are not part of the public
   * API and may change without notice.
   *
   * This property has been exposed for backward compatibility with existing
   * tests in external code
   */ get task() {
        return this._task;
    }
    /**
   * @private
   * @deprecated
   * Please avoid using internal properties.
   * They are not part of the public API and may change without notice.
   *
   * This property has been exposed for backward compatibility with existing
   * tests in external code
   */ get _productInfo() {
        return this._internalProductInfo;
    }
    constructor(productInfo, settings = {}){
        this._apdexEvent = void 0;
        this._context = void 0;
        this._eventDelayQueue = void 0;
        this._historyReplaceFn = void 0;
        this._orgInfo = void 0;
        this._pageVisibility = void 0;
        this._internalProductInfo = void 0;
        this._safeSessionStorage = void 0;
        this._sessionTracking = void 0;
        this._tabTracking = void 0;
        this._tenantInfo = void 0;
        this._testingCache = void 0;
        this._uiViewedAttributes = void 0;
        this._uiViewedEvent = void 0;
        this._userInfo = void 0;
        this._originTracing = void 0;
        this._task = void 0;
        this._pageLoadId = void 0;
        this._workspaceInfo = void 0;
        this._aliases = void 0;
        this._groups = void 0;
        this._eventProcessor = void 0;
        this._logger = void 0;
        this._embeddedContext = void 0;
        this._crossProductInteractionTracking = void 0;
        this._useStargate = (useStargate)=>{
            if (useStargate == null) return true;
            return useStargate;
        };
        this._changeInternalUserId = (userId, anonymousId)=>{
            this._eventProcessor.getUser().setUserId(userId);
            if (anonymousId && anonymousId !== this._eventProcessor.getUser().getAnonymousId()) // Setting anonymous id can take a long time. Reading is a lot faster.
            // Only update if it has changed.
            this._eventProcessor.getUser().setAnonymousId(anonymousId);
        };
        this._createSubproductGetter = (subproduct)=>(0, $hOQhQ.default)(subproduct, 'Cannot get subproduct from the callback. Proceeding without it.');
        this._createEmbeddedProductGetter = (embeddedProduct)=>(0, $hOQhQ.default)(embeddedProduct, 'Cannot get embeddedProduct from the callback. Proceeding without it.');
        this._getLastScreenEvent = ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($8da7d4b05a0111d8$var$LAST_SCREEN_EVENT_STORAGE_KEY) || '');
            } catch  {
                this._safeSessionStorage.removeItem($8da7d4b05a0111d8$var$LAST_SCREEN_EVENT_STORAGE_KEY);
                return null;
            }
        };
        this._setLastScreenEvent = (event)=>{
            this._safeSessionStorage.setItem($8da7d4b05a0111d8$var$LAST_SCREEN_EVENT_STORAGE_KEY, JSON.stringify({
                name: event.name,
                attributes: event.attributes
            }));
        };
        this._shouldEventBeDelayed = (event)=>{
            // TODO: this is a temporary restriction for the purposes of the Track All Changes project
            // The delay mechanism has a chance of event loss, which we can only accept for our own data at this point.
            // Once the delay queue implementation has been improved and measured to confirm that it is reliable enough,
            // then we will be able to open it up for other products to use by removing this check.
            if (!event.tags || event.tags.indexOf('measurement') === -1) return false;
            const isEventHighPriority = event.highPriority !== false; // defaults to true if excluded
            return this._eventDelayQueue.isDelayingLowPriorityEvents() && !isEventHighPriority;
        };
        this._fireEvent = (identifier, builtEvent, context, callback)=>{
            switch(builtEvent.eventType){
                case (0, $1RuJ0.eventType).UI:
                case (0, $1RuJ0.eventType).OPERATIONAL:
                case (0, $1RuJ0.eventType).TRACK:
                    return this._eventProcessor.track(identifier, builtEvent, context, callback);
                case (0, $1RuJ0.eventType).SCREEN:
                    return this._eventProcessor.page(identifier, builtEvent, context, callback);
                case (0, $1RuJ0.eventType).IDENTIFY:
                    return this._eventProcessor.identify(identifier, builtEvent, context, callback);
                default:
                    throw new Error(`No handler has been defined for events of type ${builtEvent.eventType}`);
            }
        };
        this._fireDelayedEvent = (identifier, builtEvent, context, userInfo)=>{
            try {
                // User information can change while the delay period is active, so we need to restore the values that
                // were active when the event was originally fired.
                this._changeInternalUserId(userInfo.userId, userInfo.anonymousId);
                builtEvent.tags = [
                    ...builtEvent.tags || [],
                    'sentWithDelay'
                ];
                // The callbacks for delayed events are fired immediately, so there is nothing to pass through for this argument.
                this._fireEvent(identifier, builtEvent, context, undefined);
            } finally{
                this._changeInternalUserId(this._userInfo.userId, this._userInfo.anonymousId);
            }
        };
        this._delayEvent = (identifier, builtEvent, context, userInfo, callback)=>{
            this._eventDelayQueue.push(identifier, builtEvent, context, userInfo);
            // Fire the callback immediately, as we can consider the event successfully processed at this point
            if (callback) callback();
        };
        this._processEvent = (identifier, builtEvent, context, callback)=>{
            this._testingCache.saveEvent(builtEvent);
            if (this._shouldEventBeDelayed(builtEvent)) {
                this._delayEvent(identifier, builtEvent, context, this._userInfo, callback);
                return Promise.resolve();
            } else return this._fireEvent(identifier, builtEvent, context, callback);
        };
        this.setEmbeddedProduct = (embeddedProduct)=>{
            this._internalProductInfo.embeddedProduct = this._createEmbeddedProductGetter(embeddedProduct);
            this.resetUIViewedTimers();
        };
        this.clearEmbeddedProduct = ()=>{
            this._internalProductInfo.embeddedProduct = this._createEmbeddedProductGetter(null);
        };
        this.setSubproduct = (subproduct)=>{
            this._internalProductInfo.subproduct = this._createSubproductGetter(subproduct);
            this.resetUIViewedTimers();
        };
        /**
      * Calling this function in the intialisation of the client in product
      * captures specified 'origin tracing' URL params and fires a single origin landed event
      * <p>
      * This function expects a mapping between the keys for any URL parameters
      *  that should be captured and removed for origin tracing
      * Multiple parameters may be captured simultaneously if multiple key: handler function pairs are provided
      * Each handler function should return an object with two items
      * a) 'originTracingAttributes' - an object that will be added to the 'origin landed' event's attributes under 'originTracing
      * b) 'taskSessionId' (optional) - an Id string that will be added to the tasksessions for any event that fires from the tab, with the key
      *    matching the URL parameter, for the purpose of attributing subsequent analytics event to the origin land.
      * </p>
      * The general use case for this feature is for allowing attributation of user behaviour to a out of product or cross product link,
      * e.g. from a share or email
      *
      * An example calling this function using an external decoding library, with taskSessionId specified to persist
      * analyticsWebClient.setOriginTracingHandlers({
           atlOrigin: encodedOrigin => {
               const { id, product } = OriginTracing.fromEncoded(encodedOrigin);
               return { originTracingAttributes: {'id': id, 'product': product}, taskSessionId: id };
           },
       });
      *
      * @param  {Object} originParamHandlerMapping a dictionary of mappings between origin url param keys and handler functions
      * @this {AnalyticsWebClient}
      */ this.setOriginTracingHandlers = (originParamHandlerMapping)=>{
            const capturedOriginTraces = this._originTracing.handleOriginParameters(originParamHandlerMapping, this._historyReplaceFn);
            Object.keys(capturedOriginTraces).forEach((x)=>{
                if (typeof capturedOriginTraces[x].taskSessionId !== 'undefined') this._task.createTaskSessionWithProvidedId(x, capturedOriginTraces[x].taskSessionId);
            });
            const originAttributes = {};
            Object.keys(capturedOriginTraces).forEach((x)=>{
                if (capturedOriginTraces[x].originTracingAttributes) originAttributes[x] = capturedOriginTraces[x].originTracingAttributes;
                else // eslint-disable-next-line no-console
                console.warn(`Handling method for origin parameter ${x} has not returned any attributes`);
            });
            if (Object.keys(capturedOriginTraces).length > 0) return this.sendOperationalEvent({
                action: 'landed',
                actionSubject: 'origin',
                source: 'webClient',
                attributes: {
                    originTracesLanded: originAttributes
                }
            }, // eslint-disable-next-line @typescript-eslint/no-empty-function
            ()=>{});
            return Promise.resolve();
        };
        this.setTenantInfo = (tenantIdType, tenantId)=>{
            if (!tenantIdType) throw new Error('Missing tenantIdType');
            if (tenantIdType !== (0, $1RuJ0.tenantType).NONE && !tenantId) throw new Error('Missing tenantId');
            if (!(0, $1RuJ0.isType)((0, $1RuJ0.tenantType), tenantIdType)) throw new Error(`Invalid tenantIdType '${tenantIdType}', ` + `must be an tenantType: [${(0, $1RuJ0.objectValues)((0, $1RuJ0.tenantType))}]`);
            this._tenantInfo = {
                tenantIdType: tenantIdType,
                tenantId: tenantId
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.clearTenantInfo = ()=>{
            this._tenantInfo = {};
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.setOrgInfo = (orgId)=>{
            if (!orgId) throw new Error('Missing orgId');
            this._orgInfo = {
                orgId: orgId
            };
        };
        this.clearOrgInfo = ()=>{
            this._orgInfo = {};
        };
        this.setWorkspaceInfo = (workspaceId)=>{
            if (!workspaceId) throw new Error('Missing workspaceId');
            this._workspaceInfo = {
                workspaceId: workspaceId
            };
        };
        this.clearWorkspaceInfo = ()=>{
            this._workspaceInfo = {};
        };
        this.setUserInfo = (userIdType, userId)=>{
            (0, $6M7gQ.validateIdentifyEvent)(userIdType, userId);
            this._changeInternalUserId(userId);
            this._userInfo = {
                userIdType: userIdType,
                userId: userId,
                anonymousId: this._eventProcessor.getUser().getAnonymousId()
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.clearUserInfo = ()=>{
            this._changeInternalUserId(undefined);
            this._userInfo = {
                anonymousId: this._eventProcessor.getUser().getAnonymousId()
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.setAlias = (aliasKeyType, alias)=>{
            if (!aliasKeyType) throw new Error('Missing aliasType');
            if (!(0, $1RuJ0.isType)((0, $1RuJ0.aliasType), aliasKeyType)) throw new Error(`Invalid aliasType '${aliasKeyType}', ` + `must be an aliasType: [${(0, $1RuJ0.objectValues)((0, $1RuJ0.aliasType))}]`);
            this._aliases[aliasKeyType] = alias;
        };
        this.clearAlias = ()=>{
            this._aliases = {};
        };
        this.setGroup = (groupsKeyType, group)=>{
            if (!groupsKeyType) throw new Error('Missing groupType');
            if (!(0, $1RuJ0.isType)((0, $1RuJ0.groupType), groupsKeyType)) throw new Error(`Invalid groupType '${groupsKeyType}', ` + `must be an groupType: [${(0, $1RuJ0.objectValues)((0, $1RuJ0.groupType))}]`);
            this._groups[groupsKeyType] = group;
        };
        this.clearGroup = ()=>{
            this._groups = {};
        };
        this.getAnonymousId = ()=>this._userInfo.anonymousId;
        this.getCurrentSessionId = ()=>this._sessionTracking.getCurrentSessionId();
        this.setUIViewedAttributes = (uiViewedAttributes)=>{
            if (!uiViewedAttributes) throw new Error('Missing uiViewedAttributes');
            if (typeof uiViewedAttributes !== 'object' || Array.isArray(uiViewedAttributes)) throw new Error('Invalid uiViewedAttributes type, should be a non array object');
            this._uiViewedAttributes = {
                ...uiViewedAttributes
            };
        };
        this.getUIViewedAttributes = ()=>{
            return this._uiViewedAttributes;
        };
        this.clearUIViewedAttributes = ()=>{
            this._uiViewedAttributes = {};
        };
        this.appendUIViewedAttributes = (attributes)=>{
            if (!this._uiViewedAttributes) this._uiViewedAttributes = attributes;
            else this._uiViewedAttributes = {
                ...this._uiViewedAttributes,
                ...attributes
            };
        };
        this.sendIdentifyEvent = (userIdType, userId, callback)=>{
            this.setUserInfo(userIdType, userId);
            const builtEvent = {
                userIdType: userIdType,
                eventType: (0, $1RuJ0.eventType).IDENTIFY
            };
            return this._processEvent(userId, builtEvent, this._context, callback);
        };
        /**
     * @deprecated
     * please use {@link sendScreenEvent instead)
     */ this.sendPageEvent = (name, callback)=>{
            return this.sendScreenEvent(name, callback);
        };
        /**
     * send screen event
     * @param event The event / For retrocompatibility event name is still supported here.
     * @param callback
     * @param attributes. Deprecated, will get ignored if using an event object as first param.
     */ this.sendScreenEvent = (event, callback, attributes)=>{
            let screenName;
            let screenAttributes;
            let screenContainers;
            let screenTags;
            if (typeof event === 'object') {
                /* This is for retrocompatibility */ screenName = event.name;
                screenAttributes = event.attributes;
                screenContainers = event.containers;
                screenTags = event.tags;
            } else {
                screenName = event;
                screenAttributes = attributes;
            }
            (0, $6M7gQ.validateScreenEvent)(screenName);
            (0, $6M7gQ.validateContainers)(screenContainers);
            const builtEvent = (0, $1rUiu.buildScreenEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, screenAttributes, // TODO: Remove the as any and move into a place where we know event is an object
            event.nonPrivacySafeAttributes, screenTags, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, event, screenContainers, this._aliases, this._groups);
            const builtEventWithName = {
                name: screenName,
                ...builtEvent
            };
            this._setLastScreenEvent(builtEventWithName);
            return this._processEvent(screenName, builtEventWithName, this._context, (0, $8thuK.default)(callback, builtEventWithName));
        };
        this.sendTrackEvent = (event, callback)=>{
            (0, $6M7gQ.validateTrackEvent)(event);
            const builtEvent = (0, $1rUiu.buildActionEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $1RuJ0.eventType).TRACK, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $1rUiu.buildActionName)(event), builtEvent, this._context, (0, $8thuK.default)(callback, builtEvent));
        };
        this.sendUIEvent = (event, callback)=>{
            (0, $6M7gQ.validateUIEvent)(event);
            const builtEvent = (0, $1rUiu.buildActionEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $1RuJ0.eventType).UI, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $1rUiu.buildActionName)(event), builtEvent, this._context, (0, $8thuK.default)(callback, builtEvent));
        };
        this.sendOperationalEvent = (event, callback)=>{
            (0, $6M7gQ.validateOperationalEvent)(event);
            const builtEvent = (0, $1rUiu.buildActionEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $1RuJ0.eventType).OPERATIONAL, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $1rUiu.buildActionName)(event), builtEvent, this._context, (0, $8thuK.default)(callback, builtEvent));
        };
        this.startUIViewedEvent = (callback)=>{
            this.stopUIViewedEvent();
            this._uiViewedEvent = new (0, $gSdvR.default)(this._internalProductInfo, ()=>({
                    embeddedProduct: this._internalProductInfo.embeddedProduct(),
                    subproduct: this._internalProductInfo.subproduct(),
                    tenantIdType: this._tenantInfo.tenantIdType,
                    tenantId: this._tenantInfo.tenantId,
                    userId: this._userInfo.userId,
                    lastScreenEvent: this._getLastScreenEvent(),
                    attributes: this._uiViewedAttributes
                }), (event)=>this.sendUIEvent(event, callback));
            this._uiViewedEvent.start();
        };
        this.stopUIViewedEvent = ()=>{
            if (this._uiViewedEvent) {
                this._uiViewedEvent.stop();
                this._uiViewedEvent = null;
            }
        };
        this.resetUIViewedTimers = ()=>{
            if (this._uiViewedEvent) this._uiViewedEvent.resetTimers();
        };
        this.startApdexEvent = (apdexEvent)=>{
            this._apdexEvent.start(apdexEvent);
        };
        this.getApdexStart = (apdexEvent)=>this._apdexEvent.getStart(apdexEvent);
        this.stopApdexEvent = (apdexEvent, callback)=>{
            this._apdexEvent.stop(apdexEvent, callback);
        };
        // TODO If we ever make another breaking change, merge these two optional args into an `options` object arg.
        this.startLowPriorityEventDelay = (timeout, callback)=>{
            this._eventDelayQueue.startLowPriorityEventDelay(timeout, callback);
        };
        this.stopLowPriorityEventDelay = ()=>{
            this._eventDelayQueue.stopLowPriorityEventDelay();
        };
        this.onEvent = (_analyticsId, analyticsData)=>{
            if (!analyticsData) throw new Error('Missing analyticsData');
            if (!analyticsData.eventType) throw new Error('Missing analyticsData.eventType');
            if (analyticsData.eventType === (0, $1RuJ0.eventType).TRACK) return this.sendTrackEvent(analyticsData);
            else if (analyticsData.eventType === (0, $1RuJ0.eventType).UI) return this.sendUIEvent(analyticsData);
            else if (analyticsData.eventType === (0, $1RuJ0.eventType).OPERATIONAL) return this.sendOperationalEvent(analyticsData);
            else if (analyticsData.eventType === (0, $1RuJ0.eventType).SCREEN) return this.sendScreenEvent(analyticsData.name, null, analyticsData.attributes);
            else if (analyticsData.eventType === (0, $1RuJ0.eventType).IDENTIFY) return this.sendIdentifyEvent(analyticsData.userIdType, analyticsData.userId);
            throw new Error(`Invalid analyticsData.eventType '${analyticsData.eventType}', ` + `must be an eventType: [${(0, $1RuJ0.objectValues)((0, $1RuJ0.eventType))}]`);
        };
        this.setResponseCallback = (responseCallback)=>{
            this._eventProcessor.setResponseCallback(responseCallback);
        };
        if (!productInfo) throw new Error('Missing productInfo');
        if (!productInfo.env) throw new Error('Missing productInfo.env');
        if (!productInfo.product) throw new Error('Missing productInfo.product');
        if (!(0, $1RuJ0.isType)((0, $1RuJ0.envType), productInfo.env)) throw new Error(`Invalid productInfo.env '${productInfo.env}', ` + `must be an envType: [${(0, $1RuJ0.objectValues)((0, $1RuJ0.envType))}]`);
        if (productInfo.perimeter && !(0, $1RuJ0.isType)((0, $1RuJ0.perimeterType), productInfo.perimeter)) throw new Error(`Invalid productInfo.perimeter '${productInfo.perimeter}', ` + `must be an perimeterType: [${(0, $1RuJ0.objectValues)((0, $1RuJ0.perimeterType))}]`);
        if (!productInfo.origin) productInfo.origin = (0, $1RuJ0.originType).WEB;
        else if (!(0, $1RuJ0.isType)((0, $1RuJ0.originType), productInfo.origin)) throw new Error(`Invalid productInfo.origin '${productInfo.origin}', ` + `must be an originType: [${(0, $1RuJ0.objectValues)((0, $1RuJ0.originType))}]`);
        if (!productInfo.platform) productInfo.platform = productInfo.origin === (0, $1RuJ0.originType).WEB ? (0, $1RuJ0.platformType).WEB : (0, $1RuJ0.platformType).DESKTOP;
        else (0, $6M7gQ.validatePlatform)(productInfo);
        this._logger = settings.logger || console;
        this._internalProductInfo = {
            ...productInfo,
            subproduct: this._createSubproductGetter(productInfo.subproduct),
            embeddedProduct: this._createEmbeddedProductGetter(productInfo.embeddedProduct)
        };
        this._tenantInfo = {};
        this._orgInfo = {};
        this._uiViewedAttributes = {};
        if (productInfo?.embeddedContext) {
            this._embeddedContext = productInfo.embeddedContext;
            if ((0, $dHwqw.isFirstParty)(this._embeddedContext)) this.setUIViewedAttributes({
                embeddedType: this._embeddedContext['embeddedType'],
                embeddedFromProduct: this._embeddedContext['embeddedFromProduct'],
                embeddedFromSubproduct: this._embeddedContext['embeddedFromSubproduct'],
                embeddedFromTopLevelDomain: this._embeddedContext['embeddedFromTopLevelDomain']
            });
            if ((0, $dHwqw.isThirdParty)(this._embeddedContext)) this.setUIViewedAttributes({
                embeddedType: this._embeddedContext['embeddedType'],
                embeddedFromTopLevelDomain: this._embeddedContext['embeddedFromTopLevelDomain']
            });
        }
        this._context = (0, $1rUiu.buildContext)(this._internalProductInfo);
        this._safeSessionStorage = new (0, $dxiIz.default)();
        const _useStargate = this._useStargate(settings.useStargate);
        const apiHost = settings.apiHost || (0, $dy9Sx.selectHost)({
            useStargate: _useStargate,
            env: productInfo.env,
            useLegacyUrl: settings.useLegacyUrl,
            perimeter: productInfo.perimeter,
            ic: productInfo.ic,
            envOverride: productInfo.envOverride
        });
        const apiHostProtocol = settings.apiHostProtocol || 'https';
        const minRetryDelay = settings.minRetryDelay || 1000;
        const maxAttempts = settings.maxRetryAttempts !== undefined && Number.isInteger(settings.maxRetryAttempts) && settings.maxRetryAttempts >= 0 ? settings.maxRetryAttempts + 1 : undefined;
        const retryQueueOptions = {
            maxRetryDelay: 60000,
            minRetryDelay: minRetryDelay,
            backoffFactor: 2,
            flushWaitMs: settings.flushWaitInterval,
            flushBeforeUnload: settings.flushBeforeUnload,
            maxAttempts: maxAttempts
        };
        const retryQueuePrefix = `awc-${productInfo.env}`;
        const xidPromiseGetter = ()=>(0, $h6jy8.XIDPromise)(settings.xidConsent, settings.xidPromiseFn);
        const disableCookiePersistence = settings.disableCookiePersistence || false;
        const metadataClientFactory = settings.metadataClientFactory || (0, $kxRFZ.MetadataClient).Factory;
        const metadataClient = metadataClientFactory(apiHostProtocol, apiHost, productInfo.product);
        this._eventProcessor = new (0, $bJILN.default)({
            apiHost: apiHost,
            apiHostProtocol: apiHostProtocol,
            product: productInfo.product,
            retryQueuePrefix: retryQueuePrefix,
            retryQueueOptions: retryQueueOptions,
            xidPromiseGetter: xidPromiseGetter,
            logger: this._logger,
            metadataClient: metadataClient,
            disableCookiePersistence: disableCookiePersistence,
            responseCallback: $8da7d4b05a0111d8$export$48361b6ed38f1b0.getCallback(this._logger),
            env: productInfo.env,
            perimeter: productInfo.perimeter,
            enableMetadataCalls: this.metadataCallsEnabled(settings),
            enableEventCalls: this.eventCallsEnabled(settings)
        });
        this._userInfo = {
            anonymousId: this._eventProcessor.getUser().getAnonymousId(settings?.customAnonymousIdGenerator)
        };
        this._pageVisibility = new (0, $af4kr.default)();
        this._tabTracking = new (0, $kk1PE.default)();
        this._sessionTracking = new (0, $5JbDb.default)({
            sessionExpiryTime: settings.sessionExpiryTime,
            onNewSessionStarted: settings.onNewSessionStarted
        });
        this._task = new (0, $ctMxd.default)();
        this._originTracing = new (0, $fPqPr.default)();
        // Init Apdex
        this._apdexEvent = new (0, $hz4bR.default)(this.sendOperationalEvent, this._pageVisibility);
        this._historyReplaceFn = typeof settings.historyReplaceFn === 'function' ? settings.historyReplaceFn : (0, $k0wX2.defaultHistoryReplaceFn);
        this._eventDelayQueue = new (0, $cDSz8.default)(this._fireDelayedEvent, settings.delayQueueCompressors || []);
        this._testingCache = new (0, $5Akh6.default)(settings.isSynthetic, settings.enableTestingCache);
        this._pageLoadId = (0, $3ohfK.default)();
        this._workspaceInfo = {};
        this._aliases = {};
        this._groups = {};
        this._crossProductInteractionTracking = new (0, $cWnSW.default)({
            perimeter: productInfo.perimeter,
            product: productInfo.product,
            sendEventCallback: this.sendOperationalEvent,
            historyReplaceFn: this._historyReplaceFn
        });
        this._crossProductInteractionTracking.validateInteractionSession();
    }
}

});
parcelRegister("1RuJ0", function(module, exports) {
$parcel$export(module.exports, "envType", () => $3e22ca96e6621236$export$56ac8ebc9870b1b9);
$parcel$export(module.exports, "eventType", () => $3e22ca96e6621236$export$4c045e605d532c98);
$parcel$export(module.exports, "platformType", () => $3e22ca96e6621236$export$6b4f396210e539f3);
$parcel$export(module.exports, "originType", () => $3e22ca96e6621236$export$f73e9fcd368bb695);
$parcel$export(module.exports, "tenantType", () => $3e22ca96e6621236$export$496f06ac2a964da2);
$parcel$export(module.exports, "productEmbedType", () => $3e22ca96e6621236$export$f49776dca27a2e7c);
$parcel$export(module.exports, "userType", () => $3e22ca96e6621236$export$1827adfd178b4870);
$parcel$export(module.exports, "apdexType", () => $3e22ca96e6621236$export$99b37380a464d794);
$parcel$export(module.exports, "desktopPlatforms", () => $3e22ca96e6621236$export$809831be6c4c6227);
$parcel$export(module.exports, "webPlatforms", () => $3e22ca96e6621236$export$19c579398ad213e7);
$parcel$export(module.exports, "originTracingType", () => $3e22ca96e6621236$export$62a500c02dc63ee);
$parcel$export(module.exports, "objectValues", () => $3e22ca96e6621236$export$ad1854f4a08c15f8);
$parcel$export(module.exports, "isType", () => $3e22ca96e6621236$export$26b9f946b448f23e);
$parcel$export(module.exports, "perimeterType", () => $3e22ca96e6621236$export$bdd41749d2096e4b);
$parcel$export(module.exports, "aliasType", () => $3e22ca96e6621236$export$a8c99e46b781d936);
$parcel$export(module.exports, "groupType", () => $3e22ca96e6621236$export$e73680b18d9b7c6e);
// These types have been converted from frozen objects to enums.
// We cannot change their name, or even capitalise them without breaking API.
var $3e22ca96e6621236$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["LOCAL"] = "local";
    envType["DEV"] = "dev";
    envType["STAGING"] = "staging";
    envType["PROD"] = "prod";
    return envType;
}({});
var $3e22ca96e6621236$export$4c045e605d532c98 = /*#__PURE__*/ function(eventType) {
    eventType["TRACK"] = "track";
    eventType["UI"] = "ui";
    eventType["OPERATIONAL"] = "operational";
    eventType["SCREEN"] = "screen";
    eventType["IDENTIFY"] = "identify";
    return eventType;
}({});
var $3e22ca96e6621236$export$6b4f396210e539f3 = /*#__PURE__*/ function(platformType) {
    platformType["MAC"] = "mac";
    platformType["LINUX"] = "linux";
    platformType["WINDOWS"] = "windows";
    /**
	 *  @deprecated desktop is here for retrocompatibility, please select one of the above OS instead.
	 */ platformType["DESKTOP"] = "desktop";
    platformType["WEB"] = "web";
    platformType["MOBILE_WEB"] = "mobileWeb";
    return platformType;
}({});
var $3e22ca96e6621236$export$f73e9fcd368bb695 = /*#__PURE__*/ function(originType) {
    originType["DESKTOP"] = "desktop";
    originType["WEB"] = "web";
    return originType;
}({});
var $3e22ca96e6621236$export$496f06ac2a964da2 = /*#__PURE__*/ function(tenantType) {
    tenantType["CLOUD_ID"] = "cloudId";
    tenantType["ORG_ID"] = "orgId";
    tenantType["OPSGENIE_CUSTOMER_ID"] = "opsgenieCustomerId";
    tenantType["HALP_TEAM_ID"] = "halpTeamId";
    tenantType["LOOM_ORG_ID"] = "loomOrgId";
    tenantType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    tenantType["TRELLO_WORKSPACE_ID"] = "trelloWorkspaceId";
    tenantType["JA_WORKSPACE_ID"] = "jiraAlignWorkspaceId";
    tenantType["STUDIO_WORKSPACE_ID"] = "studioWorkspaceId";
    tenantType["NONE"] = "none";
    return tenantType;
}({});
var $3e22ca96e6621236$export$f49776dca27a2e7c = /*#__PURE__*/ function(productEmbedType) {
    productEmbedType["FIRST_PARTY"] = "FIRST_PARTY";
    productEmbedType["THIRD_PARTY"] = "THIRD_PARTY";
    return productEmbedType;
}({});
var $3e22ca96e6621236$export$1827adfd178b4870 = /*#__PURE__*/ function(userType) {
    userType["ATLASSIAN_ACCOUNT"] = "atlassianAccount";
    userType["HASHED_EMAIL"] = "hashedEmail";
    userType["LOOM"] = "loom";
    userType["TRELLO"] = "trello";
    userType["OPSGENIE"] = "opsgenie";
    userType["JA_USER_ID"] = "jiraAlign";
    userType["HALP"] = "halp";
    return userType;
}({});
var $3e22ca96e6621236$export$99b37380a464d794 = /*#__PURE__*/ function(apdexType) {
    apdexType["TRANSITION"] = "transition";
    apdexType["INITIAL_LOAD"] = "initialLoad";
    return apdexType;
}({});
const $3e22ca96e6621236$export$809831be6c4c6227 = Object.freeze([
    "desktop",
    "mac",
    "linux",
    "windows"
]);
const $3e22ca96e6621236$export$19c579398ad213e7 = Object.freeze([
    "web",
    "mobileWeb"
]);
var $3e22ca96e6621236$export$62a500c02dc63ee = /*#__PURE__*/ function(originTracingType) {
    originTracingType["ATL_ORIGIN"] = "atlOrigin";
    return originTracingType;
}({});
function $3e22ca96e6621236$export$ad1854f4a08c15f8(object) {
    return Object.values(object);
}
function $3e22ca96e6621236$export$26b9f946b448f23e(type, value) {
    return Object.values(type).indexOf(value) > -1;
}
var $3e22ca96e6621236$export$bdd41749d2096e4b = /*#__PURE__*/ function(perimeterType) {
    perimeterType["C5"] = "c5";
    perimeterType["COMMERCIAL"] = "commercial";
    perimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    perimeterType["FEDRAMP_HIGH"] = "fedramp-high";
    return perimeterType;
}({});
var $3e22ca96e6621236$export$a8c99e46b781d936 = /*#__PURE__*/ function(aliasType) {
    return aliasType;
}({});
var $3e22ca96e6621236$export$e73680b18d9b7c6e = /*#__PURE__*/ function(groupType) {
    groupType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    return groupType;
}({});
var $3e22ca96e6621236$export$12b75c708da5a04b = /*#__PURE__*/ function(envOverrides) {
    return envOverrides;
}({});

});

parcelRegister("hz4bR", function(module, exports) {
$parcel$export(module.exports, "default", () => $74cb4837154ef53b$export$2e2bcd8739ae039);

var $1RuJ0 = parcelRequire("1RuJ0");

var $af4kr = parcelRequire("af4kr");

var $kpXTn = parcelRequire("kpXTn");
class $74cb4837154ef53b$export$2e2bcd8739ae039 {
    start(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        this._startedEvents.set(eventKey, true);
        this._isActiveEvents.set(eventKey, !this._pageVisibility.getIsHidden());
        this._performance.clearMarks(eventStartName);
        this._performance.mark(eventStartName);
    }
    getStart(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return undefined;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        return this._getEventTimingByName(eventStartName);
    }
    stop(event, callback) {
        this._validateStopEvent(event);
        if (!this._performance.isAvailable()) return;
        const apdexFields = this._getApdexFields(event);
        const visibilityFields = this._getVisibilityFields(event);
        this._sendEvent({
            ...event,
            ...apdexFields,
            ...visibilityFields
        }, callback);
    }
    onVisibilityChange(isActive) {
        if (!isActive) {
            this._wasPreviouslyHidden = true;
            Array.from(this._isActiveEvents.keys()).forEach((key)=>this._isActiveEvents.set(key, false));
        }
    }
    constructor(onEvent, pageVisibility){
        this._isActiveEvents = void 0;
        this._onEvent = void 0;
        this._pageVisibility = void 0;
        this._performance = void 0;
        this._startedEvents = void 0;
        this._threshold = void 0;
        this._wasPreviouslyHidden = void 0;
        this._getEventKey = ({ task: task, taskId: taskId })=>taskId ? `${task}.${taskId}` : task;
        this._getEventTimingByName = (name)=>{
            const eventTimings = this._performance.getEntriesByName(name);
            const eventTiming = eventTimings[eventTimings.length - 1];
            return eventTiming;
        };
        this._getApdexFields = (event)=>{
            const apdexTimings = this._getApdexTimings(event);
            const apdexScore = this._calculateApdex({
                duration: apdexTimings.duration,
                threshold: event.threshold
            });
            return {
                ...apdexTimings,
                apdex: apdexScore
            };
        };
        this._getApdexTimings = (event)=>{
            const eventKey = this._getEventKey(event);
            const eventStartName = `${eventKey}-start`;
            const startTime = event.startTime || this._getStartTime(event, eventStartName);
            const stopTime = event.stopTime || this._getStopTime();
            // We do some clean up of the marks and started events
            this._cleanApdexState(eventKey);
            return {
                startTime: startTime,
                stopTime: stopTime,
                duration: stopTime - startTime
            };
        };
        this._getStartTime = (event, eventName)=>{
            let startTime;
            const timeOrigin = this._performance.getTimeOrigin();
            if (event.type === (0, $1RuJ0.apdexType).INITIAL_LOAD) startTime = timeOrigin;
            else {
                const eventTiming = this._getEventTimingByName(eventName);
                startTime = timeOrigin + eventTiming.startTime;
            }
            return startTime;
        };
        this._getStopTime = ()=>this._performance.getTimeOrigin() + this._performance.now();
        this._cleanApdexState = (eventKey)=>{
            this._performance.clearMarks(`${eventKey}-start`);
            this._performance.clearMarks(`${eventKey}-stop`);
            this._startedEvents.delete(eventKey);
        };
        this._getVisibilityFields = (event)=>{
            let isActiveTab;
            /**
       * For initialLoad type:
       * 1. if tab was not ever hidden (!_wasPreviouslyHidden)
       *
       * For transition type:
       * 1. active status is tracked in active events map (_isActiveEvents)
       *
       * For any type, if startTime or stopTime is specified:
       * 1. If currently active (!_isHidden)
       */ if (event.type === (0, $1RuJ0.apdexType).INITIAL_LOAD) isActiveTab = !this._wasPreviouslyHidden;
            else if (event.type === (0, $1RuJ0.apdexType).TRANSITION) {
                const eventKey = this._getEventKey(event);
                isActiveTab = this._isActiveEvents.get(eventKey);
            }
            if (event.startTime || event.stopTime) isActiveTab = !this._pageVisibility.getIsHidden();
            return {
                isActiveTab: isActiveTab
            };
        };
        this._calculateApdex = ({ duration: duration, threshold: threshold = this._threshold })=>{
            let apdex;
            const satisfiedThreshold = threshold;
            const tolerableThreshold = threshold * 4;
            if (duration <= satisfiedThreshold) apdex = 1;
            else if (duration <= tolerableThreshold) apdex = 0.5;
            else apdex = 0;
            return apdex;
        };
        this._validateStartEvent = (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex start event');
            if (!event.task) throw new Error('Missing "task" in Apdex start event');
            if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex start event');
            if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex start event');
        };
        this._validateStopEvent = (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex stop event');
            if (!event.task) throw new Error('Missing "task" in Apdex stop event');
            if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex stop event');
            if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex stop event');
            if (!event.type) throw new Error('Missing "type" in Apdex stop event');
            if (event.type && !(0, $1RuJ0.isType)((0, $1RuJ0.apdexType), event.type)) throw new Error('Invalid "type" in Apdex stop event');
            if (event.threshold && typeof event.threshold !== 'number') throw new Error('Invalid "threshold" in Apdex stop event');
            /*
       * For a transition, if the startTime was not specified,
       * the start event should have been present.
       */ if (!event.startTime && event.type === (0, $1RuJ0.apdexType).TRANSITION) {
                const eventKey = this._getEventKey(event);
                if (!this._startedEvents.has(eventKey)) throw new Error(`Apdex event transition "${eventKey}" was not started`);
            }
            if (event.startTime && !(typeof event.startTime === 'number' && event.startTime >= 0)) throw new Error('Invalid "startTime" in Apdex stop event');
            if (event.stopTime && typeof event.stopTime !== 'number') throw new Error('Invalid "stopTime" in Apdex stop event');
            if (event.stopTime <= event.startTime) throw new Error('"stopTime" should be greater than "startTime" in Apdex stop event');
        };
        this._shouldSendEvent = (event)=>{
            if (!event) return false;
            if (typeof event.apdex !== 'number') return false;
            return true;
        };
        this._sendEvent = (event, callback)=>{
            if (this._shouldSendEvent(event)) this._onEvent({
                source: 'ui',
                action: 'readyForUser',
                actionSubject: 'ui',
                attributes: {
                    ...event.additionalAttributes,
                    task: event.task,
                    taskId: event.taskId,
                    type: event.type,
                    threshold: event.threshold || this._threshold,
                    apdex: event.apdex,
                    startTime: event.startTime,
                    stopTime: event.stopTime,
                    duration: event.duration,
                    isActiveTab: event.isActiveTab
                }
            }, callback);
        };
        if (!onEvent) throw new Error('Missing onEvent callback');
        if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
        if (!(pageVisibility instanceof (0, $af4kr.default))) throw new Error('Invalid pageVisibility, must be PageVisibility class');
        this._startedEvents = new Map();
        this._performance = new (0, $kpXTn.default)();
        this._onEvent = onEvent;
        this._threshold = 1000;
        this._wasPreviouslyHidden = pageVisibility.getIsHidden();
        this._isActiveEvents = new Map();
        this._pageVisibility = pageVisibility;
        this._pageVisibility.addCallback('apdexEvent', (isHidden)=>{
            this.onVisibilityChange(!isHidden);
        });
    }
}

});
parcelRegister("af4kr", function(module, exports) {
$parcel$export(module.exports, "default", () => $a65b9b558fa0f979$export$2e2bcd8739ae039);
class $a65b9b558fa0f979$export$2e2bcd8739ae039 {
    addCallback(name, fn) {
        if (typeof name !== 'string') throw new Error('Invalid name, must be string');
        if (typeof fn !== 'function') throw new Error('Invalid callback, must be function');
        this._callbacks.set(name, fn);
    }
    removeCallback(name) {
        if (this._callbacks.has(name)) this._callbacks.delete(name);
    }
    getIsHidden() {
        return this._isHidden;
    }
    constructor(){
        this._callbacks = void 0;
        this._hidden = void 0;
        this._isHidden = void 0;
        this._visibilityChange = void 0;
        this._bindEventListeners = ()=>{
            document.addEventListener(this._visibilityChange, this._handleVisibilityChange, false);
        };
        this._handleVisibilityChange = ()=>{
            const isHidden = document[this._hidden];
            this._isHidden = isHidden;
            this._callbacks.forEach((callbackFn)=>callbackFn(isHidden));
        };
        this._isHidden = false;
        this._callbacks = new Map();
        this._hidden = undefined;
        this._visibilityChange = undefined;
        if (typeof document !== 'undefined') {
            if (typeof document.hidden !== 'undefined') {
                // Opera 12.10 and Firefox 18 and later support
                this._isHidden = document.hidden;
                this._hidden = 'hidden';
                this._visibilityChange = 'visibilitychange';
            } else if (typeof document.msHidden !== 'undefined') {
                this._isHidden = document.msHidden;
                this._hidden = 'msHidden';
                this._visibilityChange = 'msvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                this._isHidden = document.webkitHidden;
                this._hidden = 'webkitHidden';
                this._visibilityChange = 'webkitvisibilitychange';
            }
            if (typeof document.addEventListener !== 'undefined' && this._hidden !== undefined) this._bindEventListeners();
        }
    }
}

});

parcelRegister("kpXTn", function(module, exports) {
$parcel$export(module.exports, "default", () => $0b171a3b3485a911$export$2e2bcd8739ae039);
class $0b171a3b3485a911$export$2e2bcd8739ae039 {
    clearMarks(...args) {
        if (!this._performance || !this._performance.clearMarks) return;
        this._performance.clearMarks(...args);
    }
    mark(...args) {
        if (!this._performance || !this._performance.mark) return;
        this._performance.mark(...args);
    }
    getEntriesByName(...args) {
        if (!this._performance || !this._performance.getEntriesByName) return [];
        return this._performance.getEntriesByName(...args);
    }
    getTimeOrigin() {
        if (!this._performance || !this._performance.timeOrigin && !this._performance.timing) return 0;
        return this._performance.timeOrigin || this._performance.timing.navigationStart;
    }
    now() {
        if (!this._performance || !this._performance.now) return Date.now ? Date.now() : +new Date();
        return this._performance.now();
    }
    isAvailable() {
        return !!this._performance && !!this._performance.clearMarks && !!this._performance.mark && !!this._performance.getEntriesByName && !!this._performance.timing;
    }
    constructor(){
        this._performance = void 0;
        this._performance = window.performance;
    }
}

});


parcelRegister("hOQhQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $c8da892de8808805$export$2e2bcd8739ae039);
/**
 * Wraps {possibleFn} into a error-safe function and handles cases where {possibleFn}
 * is a function or object
 *
 * @param possibleFn - function that returns and object or the object itself
 * @param errorMessage - error message to log if {possibleFn} is a function and
 *                        throws an error when called
 * @returns {Function}
 */ const $c8da892de8808805$var$isFunction = (possibleFn)=>typeof possibleFn === 'function';
var $c8da892de8808805$export$2e2bcd8739ae039 = (possibleFn, errorMessage)=>{
    return ()=>{
        if ($c8da892de8808805$var$isFunction(possibleFn)) try {
            return possibleFn();
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(`${errorMessage} - ${e instanceof Error ? e.message : String(e)}`);
            return undefined;
        }
        return possibleFn;
    };
};

});

parcelRegister("cWnSW", function(module, exports) {
$parcel$export(module.exports, "default", () => $cddd793f89294160$export$2e2bcd8739ae039);

var $5V4sT = parcelRequire("5V4sT");
var $gIumz = parcelRequire("gIumz");
var $51TEe = parcelRequire("51TEe");

var $1RuJ0 = parcelRequire("1RuJ0");

var $k0wX2 = parcelRequire("k0wX2");
const $cddd793f89294160$var$isCrossProductInteractionAttribute = (_, paramName)=>{
    return paramName === (0, $gIumz.URL_QUERY_PARAM_INTERACTION_SESSION);
};
class $cddd793f89294160$export$2e2bcd8739ae039 {
    getInteractionSession() {
        if (this.isEnabled && this.analyticsCrossProductInteractionClient) return {
            bridge: this.analyticsCrossProductInteractionClient.getBridge(),
            id: this.analyticsCrossProductInteractionClient.getCurrentInteractionSessionId(),
            prevId: this.analyticsCrossProductInteractionClient.getPreviousInteractionSessionId(),
            source: this.analyticsCrossProductInteractionClient.getInteractionSource()
        };
        else return {
            bridge: null,
            id: null,
            prevId: null,
            source: null
        };
    }
    /**
   * Validates the cross product interaction session parameters parsed from the URL (if present)
   * If the Base64-encoded URL does not decode into a valid JSON object
   *
   * This method must be called out of the constructor, as the sendEventCallback we expect here
   * depends on crossProductInteractionTracking.getInteractionSession() so the class must be initialised
   */ validateInteractionSession() {
        if (!this.urlValidation.result) this.sendEventCallback({
            action: 'corrupted',
            actionSubject: 'interactionSession',
            attributes: {
                url: this.urlValidation.url
            },
            source: 'interactionComponent',
            tags: [
                'navigationExperiences'
            ] // InteractionSession events will be registered under this platform product
        });
    }
    constructor(options){
        this.analyticsCrossProductInteractionClient = void 0;
        this.isEnabled = void 0;
        this.urlValidation = void 0;
        this.sendEventCallback = void 0;
        this.validProduct = false;
        this.isEnabled = options.perimeter !== (0, $1RuJ0.perimeterType).FEDRAMP_MODERATE;
        this.urlValidation = {
            result: true,
            url: ''
        };
        this.sendEventCallback = options.sendEventCallback;
        if (this.isEnabled) {
            let bridge;
            let interactionSessionId;
            let interactionSource;
            let interactionSessionOptions;
            this.urlValidation.url = window.location.href;
            // Validate product
            //
            // Various UI components in the page might initialize their own AWC instances but some of those
            // instances might be associated with subordinate products that are of no interest to XPC tracking. We
            // want to avoid XPC meta analytics being fired against uninteresting products.
            //
            // Some products (e.g. Confluence) also have custom URL replace functions passed into AWC settings,
            // and we need to use those to ensure our query parameter is correctly processed.
            //
            // TODO - this is currently the best way we can try and guarantee that the most relevant product's AWC
            // is passing in the options. Down the line we ideally want the relevant products themselves to opt-in
            // to initialising cross product tracking via a flag in their AWC init options.
            this.validProduct = (0, $51TEe.validProducts).includes(options.product);
            if (this.validProduct) {
                // Only parse URL parameters if we are in a valid product
                const crossProductUrlPramater = (0, $k0wX2.default)($cddd793f89294160$var$isCrossProductInteractionAttribute, options.historyReplaceFn);
                const interactionSessionBlob = (0, $gIumz.URL_QUERY_PARAM_INTERACTION_SESSION) in crossProductUrlPramater ? crossProductUrlPramater[0, $gIumz.URL_QUERY_PARAM_INTERACTION_SESSION] : null;
                if (interactionSessionBlob) try {
                    const interactionSession = JSON.parse(atob(interactionSessionBlob));
                    if (interactionSession.bridge && interactionSession.id && interactionSession.source) {
                        // All 3 fields must be present from a valid query param
                        bridge = interactionSession.bridge;
                        interactionSessionId = interactionSession.id;
                        interactionSource = interactionSession.source;
                    } else this.urlValidation.result = false;
                } catch  {
                    // Gracefully fail through if parameter has been corrupted
                    this.urlValidation.result = false;
                }
                interactionSessionOptions = {
                    analyticsEventCallback: this.sendEventCallback,
                    persistedSessionId: interactionSessionId
                };
            }
            // Initialise interaction session client with parsed values if they exist
            this.analyticsCrossProductInteractionClient = new (0, $5V4sT.default)(interactionSessionOptions, bridge, interactionSource);
        }
    }
}

});
parcelRegister("5V4sT", function(module, exports) {
$parcel$export(module.exports, "default", () => $4719c95dfeb2d913$export$2e2bcd8739ae039);

var $g8V8l = parcelRequire("g8V8l");

var $dR5pb = parcelRequire("dR5pb");

var $e1sF4 = parcelRequire("e1sF4");
const $4719c95dfeb2d913$export$b9dd752fb13352ce = 'interactionSession.source';
const $4719c95dfeb2d913$export$e04e3c50573f9af7 = 'interactionSession.bridge';
class $4719c95dfeb2d913$export$2e2bcd8739ae039 {
    constructor(interactionSessionOptions, bridge, interactionSource){
        this.safeSessionStorage = void 0;
        this.interactionSessionTracking = void 0;
        this.isEnabled = void 0;
        this.getCurrentInteractionSessionId = ()=>this.isEnabled && this.interactionSessionTracking ? this.interactionSessionTracking.getCurrentInteractionSessionId() : null;
        this.getPreviousInteractionSessionId = ()=>this.isEnabled && this.interactionSessionTracking ? this.interactionSessionTracking.getPreviousInteractionSessionId() : null;
        this.getBridge = ()=>this.isEnabled && this.safeSessionStorage ? this.safeSessionStorage.getItem($4719c95dfeb2d913$export$e04e3c50573f9af7) : null;
        this.getInteractionSource = ()=>this.isEnabled && this.safeSessionStorage ? this.safeSessionStorage.getItem($4719c95dfeb2d913$export$b9dd752fb13352ce) : null;
        this.isEnabled = !(0, $g8V8l.isFedrampModerate)();
        if (this.isEnabled) {
            // Get singleton interaction session tracking instance
            this.interactionSessionTracking = (0, $dR5pb.default).getInstance();
            let isValidPersistedId = false;
            if (this.interactionSessionTracking) {
                if (interactionSessionOptions) {
                    this.interactionSessionTracking.setAnalyticsCallback(interactionSessionOptions.analyticsEventCallback);
                    isValidPersistedId = this.interactionSessionTracking.setInteractionSessionId(interactionSessionOptions.persistedSessionId);
                }
            }
            this.safeSessionStorage = new (0, $e1sF4.default)();
            // Store other interaction session parameters directly in session storage if ID has been validated
            if (isValidPersistedId) {
                bridge && this.safeSessionStorage.setItem($4719c95dfeb2d913$export$e04e3c50573f9af7, bridge);
                interactionSource && this.safeSessionStorage.setItem($4719c95dfeb2d913$export$b9dd752fb13352ce, interactionSource);
            }
        }
    }
}

});
parcelRegister("g8V8l", function(module, exports) {
$parcel$export(module.exports, "isIsolatedCloud", () => $a7c6638c2dff65e7$export$9186ccba8effc5de);
$parcel$export(module.exports, "isFedrampModerate", () => $a7c6638c2dff65e7$export$104cb891a6e90b3a);
$parcel$export(module.exports, "isolationContextId", () => $a7c6638c2dff65e7$export$839b022803d38d4d);

var $hTUkd = parcelRequire("hTUkd");

var $8sWg0 = parcelRequire("8sWg0");
function $a7c6638c2dff65e7$export$9186ccba8effc5de() {
    if (typeof document === 'undefined') // @ts-ignore
    return globalThis.ssrContext.isInIC;
    const atlCtxCookieValues = (0, $8sWg0.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    // The icDomain check is needed for when federal perimeters are eventually added to Isolated Cloud as well
    return (0, $hTUkd.ISOLATED_CLOUD_PERIMETERS).includes(atlCtxCookieValues.perimeter) && atlCtxCookieValues.icDomain !== undefined;
}
function $a7c6638c2dff65e7$export$104cb891a6e90b3a() {
    if (typeof document === 'undefined') // @ts-ignore
    return globalThis.ssrContext.isInFedramp;
    const atlCtxCookieValues = (0, $8sWg0.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    return atlCtxCookieValues.perimeter === (0, $hTUkd.FEDRAMP_MODERATE);
}
function $a7c6638c2dff65e7$export$80638ee198476daf() {
    if (typeof document === 'undefined') return globalThis.location.hostname;
    const atlCtxCookieValues = (0, $8sWg0.parseAtlCtxCookies)();
    return atlCtxCookieValues?.icDomain;
}
function $a7c6638c2dff65e7$export$839b022803d38d4d() {
    if (typeof document === 'undefined') // @ts-ignore
    return $a7c6638c2dff65e7$export$9186ccba8effc5de() ? globalThis.ssrContext.icName : undefined;
    const atlCtxCookieValues = (0, $8sWg0.parseAtlCtxCookies)();
    return atlCtxCookieValues?.icId;
}
function $a7c6638c2dff65e7$export$9e04105551ffc5c4() {
    if (typeof document === 'undefined') return $a7c6638c2dff65e7$var$cloudEnvironmentSsrLookup();
    return $a7c6638c2dff65e7$var$cloudEnvironmentCookieLookup();
}
function $a7c6638c2dff65e7$var$cloudEnvironmentSsrLookup() {
    // @ts-ignore
    if (globalThis.ssrContext.isInIC === true) return {
        type: 'isolated-cloud',
        perimeter: (0, $hTUkd.COMMERCIAL)
    };
    // @ts-ignore
    if (globalThis.ssrContext.isInFedramp === true) return {
        type: 'non-isolated-cloud',
        perimeter: (0, $hTUkd.FEDRAMP_MODERATE)
    };
    return {
        type: 'non-isolated-cloud',
        perimeter: (0, $hTUkd.COMMERCIAL)
    };
}
function $a7c6638c2dff65e7$var$cloudEnvironmentCookieLookup() {
    // Avoid calling isFedrampModerate() and isIsolatedCloud() here to avoid repeated cookie parsing
    const atlCtxCookieValues = (0, $8sWg0.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return {
        type: 'non-isolated-cloud',
        perimeter: (0, $hTUkd.COMMERCIAL)
    };
    const isIc = (0, $hTUkd.ISOLATED_CLOUD_PERIMETERS).includes(atlCtxCookieValues.perimeter) && atlCtxCookieValues.icDomain !== undefined;
    if (isIc) return {
        type: 'isolated-cloud',
        perimeter: (0, $hTUkd.COMMERCIAL)
    };
    if (atlCtxCookieValues.perimeter === (0, $hTUkd.FEDRAMP_MODERATE)) return {
        type: 'non-isolated-cloud',
        perimeter: (0, $hTUkd.FEDRAMP_MODERATE)
    };
    // If a new cloud environment has been created but not added to this library, return undefined
    return undefined;
}

});
parcelRegister("hTUkd", function(module, exports) {
$parcel$export(module.exports, "FEDRAMP_MODERATE", () => $2261ef70948b55b1$export$ce553301d55c2fd8);
$parcel$export(module.exports, "COMMERCIAL", () => $2261ef70948b55b1$export$f005e2e9f707cb5f);
$parcel$export(module.exports, "ISOLATED_CLOUD_PERIMETERS", () => $2261ef70948b55b1$export$d8347b4aae768c2d);
$parcel$export(module.exports, "ATL_CTX_PERIMETER", () => $2261ef70948b55b1$export$87285944378c596);
$parcel$export(module.exports, "ATL_CTX_ISOLATION_CONTEXT_DOMAIN", () => $2261ef70948b55b1$export$715603e81922c3ec);
$parcel$export(module.exports, "ATL_CTX_ISOLATION_CONTEXT_ID", () => $2261ef70948b55b1$export$a0ffa0598c95dfb7);
const $2261ef70948b55b1$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $2261ef70948b55b1$export$f005e2e9f707cb5f = 'commercial';
const $2261ef70948b55b1$export$a739cd5aac835909 = 'staging';
const $2261ef70948b55b1$export$42dd0cdd351a4a9 = 'prod';
const $2261ef70948b55b1$export$404582bc18fe4d9e = 'dev';
const $2261ef70948b55b1$export$d8347b4aae768c2d = [
    $2261ef70948b55b1$export$f005e2e9f707cb5f
];
const $2261ef70948b55b1$export$b1b1ccc8f3e7f954 = [
    $2261ef70948b55b1$export$f005e2e9f707cb5f,
    $2261ef70948b55b1$export$ce553301d55c2fd8
];
const $2261ef70948b55b1$export$87285944378c596 = 'Atl-Ctx-Perimeter';
const $2261ef70948b55b1$export$715603e81922c3ec = 'Atl-Ctx-Isolation-Context-Domain';
const $2261ef70948b55b1$export$a0ffa0598c95dfb7 = 'Atl-Ctx-Isolation-Context-Id';

});

parcelRegister("8sWg0", function(module, exports) {
$parcel$export(module.exports, "parseAtlCtxCookies", () => $115fd28914d1a815$export$3fa7b7af96286cc9);

var $hTUkd = parcelRequire("hTUkd");
/**
 * Internal helper function used to parse cookie values and extract value of provided cookie name
 * @param {AtlCtxCookieName} cookieName - The name of the cookie to extract
 * @param {string} cookieString - The full cookie string
 * @returns {string | undefined} - The cookie value if present, undefined otherwise
 */ function $115fd28914d1a815$var$getRawCookieValue(cookieName, cookieString) {
    if (!cookieString) return undefined;
    const cookies = cookieString.split(';');
    for (const cookie of cookies){
        const [name, value] = cookie.trim().split('=');
        if (name === cookieName) return value;
    }
    return undefined;
}
function $115fd28914d1a815$export$3fa7b7af96286cc9() {
    const global = globalThis;
    try {
        // HOT-118791: the code below doesn't work on the server, and creates log spam in the catch block - "Cannot read properties of undefined (reading 'cookie')"
        if (typeof globalThis.document === 'undefined') return undefined;
        const cookies = global.document.cookie;
        const perimeter = $115fd28914d1a815$var$getRawCookieValue((0, $hTUkd.ATL_CTX_PERIMETER), cookies);
        if (!perimeter) // Indicative of non-isolated commercial perimeter
        return undefined;
        const icDomain = $115fd28914d1a815$var$getRawCookieValue((0, $hTUkd.ATL_CTX_ISOLATION_CONTEXT_DOMAIN), cookies);
        const icId = $115fd28914d1a815$var$getRawCookieValue((0, $hTUkd.ATL_CTX_ISOLATION_CONTEXT_ID), cookies);
        // The IC Domain and IC Id cookie values are empty strings for non Isolated Cloud
        const emptyIcDomain = !icDomain || icDomain.length === 0;
        const emptyIcId = !icId || icId.length === 0;
        return {
            perimeter: perimeter,
            icDomain: emptyIcDomain ? undefined : icDomain,
            icId: emptyIcId ? undefined : icId
        };
    } catch (e) {
        console.warn('Failed to parse atl-ctx cookies:', e);
        return undefined;
    }
}

});


parcelRegister("dR5pb", function(module, exports) {
$parcel$export(module.exports, "default", () => $cf824fc6ddf1b5a9$export$2e2bcd8739ae039);

var $curF5 = parcelRequire("curF5");
const $cf824fc6ddf1b5a9$export$7bc189309d2ad463 = 'analyticsInteractionSesssionTrackingClient';
class $cf824fc6ddf1b5a9$export$2e2bcd8739ae039 {
    static getInstance() {
        let interactionSessionTracking;
        try {
            // Check if InteractionSessionTracking in global window object
            if ($cf824fc6ddf1b5a9$export$7bc189309d2ad463 in window) interactionSessionTracking = window[$cf824fc6ddf1b5a9$export$7bc189309d2ad463];
            else {
                // Initialise InteractionSessionTracking on global window object
                window[$cf824fc6ddf1b5a9$export$7bc189309d2ad463] = new (0, $curF5.default)();
                interactionSessionTracking = window[$cf824fc6ddf1b5a9$export$7bc189309d2ad463];
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(`Error initialising InteractionSessionTracking - ${error instanceof Error ? error.message : String(error)}`);
        }
        return interactionSessionTracking;
    }
}

});
parcelRegister("curF5", function(module, exports) {
$parcel$export(module.exports, "default", () => $58bf772dcbfc48a9$export$2e2bcd8739ae039);

var $e1sF4 = parcelRequire("e1sF4");
// WARNING: The value of INTERACTION_SESSION_ID_STORAGE_KEY will be used by Analytics Web Client to attach the session ID to events.
// If you change this, you will need to update the Analytics Web Client code as well.
const $58bf772dcbfc48a9$var$INTERACTION_SESSION_ID_STORAGE_KEY = 'interactionSession.id';
const $58bf772dcbfc48a9$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY = 'interactionSession.id.prev';
const $58bf772dcbfc48a9$var$INTERACTION_SESSION_EXPIRY_STORAGE_KEY = 'interactionSession.expiry';
const $58bf772dcbfc48a9$export$285f6bddd927a06d = 1800000; // 30 minutes
const $58bf772dcbfc48a9$export$d050a4cab1b9f734 = 86400000; // 24 hours
const $58bf772dcbfc48a9$export$a92e915d70316eb2 = 5000; // 5 seconds
const $58bf772dcbfc48a9$export$de43760b2dc10c19 = 0.9; // 90% of expiry
const $58bf772dcbfc48a9$var$INTEGER_REGEX = /^\d+$/;
const $58bf772dcbfc48a9$export$5d4c4eab0863aae3 = 'interactionSessionIdUpdated';
class $58bf772dcbfc48a9$export$2e2bcd8739ae039 {
    getCurrentInteractionSessionId() {
        try {
            const { isValidSession: isValidSession, sessionExpiry: sessionExpiry, sessionId: sessionId } = this.getCurrentSessionParams();
            // If we have an existing valid session we can return the sessionId straight away
            if (isValidSession) {
                this.debouncedUpdateSessionExpiry(sessionExpiry);
                return sessionId;
            }
            // To generate a new session ID we must ensure analytics is ready
            if (this.analyticsReady) {
                // Session expiry update must occur before generateNewSessionId. Otherwise we were running
                // into issues of calls attempting to read the session ID before a valid expiry had been set
                this.debouncedUpdateSessionExpiry(sessionExpiry);
                return this.generateNewSessionId();
            }
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error(`Error retrieving interaction session ID - ${err instanceof Error ? err.message : String(err)}`);
        }
        return null;
    }
    getPreviousInteractionSessionId() {
        return this.safeSessionStorage.getItem($58bf772dcbfc48a9$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY);
    }
    setInteractionSessionId(persistedSessionId) {
        if (this.validateSessionId(persistedSessionId)) {
            const currentSessionId = this.safeSessionStorage.getItem($58bf772dcbfc48a9$var$INTERACTION_SESSION_ID_STORAGE_KEY);
            // If we are already on the required session ID, just return true and make no changes
            // This can happen if the persisted session ID in options is the same as the current session ID
            // We noticed this happening in some cases where Confluence's own URL redirect logic was causing
            // race conditions with our URL stripping, resulting in the same query parameter being processed multiple times
            if (currentSessionId === persistedSessionId) return false;
            // Session expiry update must occur before we fire off the dispatchEvent. Otherwise we were running
            // into issues of the event consumer attempting to read the session ID before a valid expiry had been set
            this.debouncedUpdateSessionExpiry(0);
            this.safeSessionStorage.setItem($58bf772dcbfc48a9$var$INTERACTION_SESSION_ID_STORAGE_KEY, persistedSessionId);
            this.safeSessionStorage.removeItem($58bf772dcbfc48a9$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY);
            document.dispatchEvent(new Event($58bf772dcbfc48a9$export$5d4c4eab0863aae3));
            return true;
        }
        return false;
    }
    // Must be called with a valid sendEvent function for other methods to work
    setAnalyticsCallback(sendEventCallback) {
        if (this.analyticsReady) // If we already have a valid callback, don't over-write it
        return;
        if (sendEventCallback && typeof sendEventCallback === 'function') {
            this.sendEventCallback = sendEventCallback;
            this.analyticsReady = true;
        } else this.analyticsReady = false;
    }
    validateSessionId(sessionId) {
        // Check if persisted session ID can parse as valid Unix timestamp
        if (sessionId && $58bf772dcbfc48a9$var$INTEGER_REGEX.test(sessionId)) {
            const sessionAge = Date.now() - parseInt(sessionId, 10);
            // Validate that timestamp is not a future time, and is also within the TTL
            if (sessionAge >= 0 && sessionAge <= $58bf772dcbfc48a9$export$d050a4cab1b9f734) return true;
        }
        return false;
    }
    /*
   * This function retrieves the current session ID and expiry from SessionStorage
   * It runs the necessary checks to ensure the session ID is valid and within expiry
   *
   * It returns the values along with a `validSession` boolean
   */ getCurrentSessionParams() {
        const sessionId = this.safeSessionStorage.getItem($58bf772dcbfc48a9$var$INTERACTION_SESSION_ID_STORAGE_KEY);
        const sessionExpiry = parseInt(this.safeSessionStorage.getItem($58bf772dcbfc48a9$var$INTERACTION_SESSION_EXPIRY_STORAGE_KEY) || '0', 10) || 0;
        if (sessionId && !Number.isNaN(sessionExpiry) && sessionExpiry > Date.now()) return {
            isValidSession: true,
            sessionExpiry: sessionExpiry,
            sessionId: sessionId
        };
        return {
            isValidSession: false,
            sessionExpiry: sessionExpiry,
            sessionId: sessionId
        };
    }
    /*
   * This function sends a GASv3 analytics event indicating the interaction session has started or renewed
   * It requires this.sendEventCallback to be set via Analytics Web Client to a valid operational event sender function
   *
   * Note that Analytics Web Client's callback function will make its own call to getCurrentInteractionSessionId to retrieve the session ID
   * to attach to the event, so a valid session ID/expiry must be retrievable from SessionStorage before this function is called to avoid infinite loops.
   *
   * This is not an ideal solution but it works with the current architecture of Analytics Web Client.
   */ sendInteractionSessionEvent(action) {
        this.sendEventCallback && this.sendEventCallback({
            action: action,
            actionSubject: 'interactionSession',
            source: 'interactionComponent',
            tags: [
                'navigationExperiences'
            ] // InteractionSession events will be registered under this platform product
        });
    }
    constructor(){
        this.safeSessionStorage = void 0;
        this.sessionExpiryTime = void 0;
        this.sessionExpiryDebounce = void 0;
        this.sessionExpiryDebounceThresholdPercentage = void 0;
        this.sessionExpiryDebounceTimer = void 0;
        this.analyticsReady = false;
        // This callback function will be called whenever a new session ID is generated
        // It expects a function that sends an operational analytics event, with
        // the first parameter being set to the action ('started' or 'renewed'), and the second parameter being
        // an InteractionSession object containing the new session ID and previous session ID.
        this.sendEventCallback = void 0;
        this.generateNewSessionId = ()=>{
            if (!this.analyticsReady) return null;
            const currentSessionId = this.safeSessionStorage.getItem($58bf772dcbfc48a9$var$INTERACTION_SESSION_ID_STORAGE_KEY);
            const newSessionId = Date.now().toString();
            this.safeSessionStorage.setItem($58bf772dcbfc48a9$var$INTERACTION_SESSION_ID_STORAGE_KEY, newSessionId);
            const { isValidSession: isValidSession } = this.getCurrentSessionParams();
            if (!isValidSession) // If session is not valid at this point, something has gone wrong with Session Storage access
            // Calling sendInteractionSessionEvent now would result in an infinite loop, so we terminate
            return null;
            if (currentSessionId) {
                // Store a copy of the current session ID so we can link sessions if needed
                this.safeSessionStorage.setItem($58bf772dcbfc48a9$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY, currentSessionId);
                this.sendInteractionSessionEvent('renewed');
            } else this.sendInteractionSessionEvent('started');
            // Event listener is in useCrossProductUrl.tsx to update URL query params
            document.dispatchEvent(new Event($58bf772dcbfc48a9$export$5d4c4eab0863aae3));
            return newSessionId;
        };
        this.updateSessionExpiry = ()=>{
            const expiry = Date.now() + this.sessionExpiryTime;
            this.safeSessionStorage.setItem($58bf772dcbfc48a9$var$INTERACTION_SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
            return expiry;
        };
        this.debouncedUpdateSessionExpiry = (currentExpiry)=>{
            const { updateSessionExpiry: updateSessionExpiry } = this;
            // If the current expiry is out of date by more than 10% of the expiry, update immediately
            if (currentExpiry < Date.now() + this.sessionExpiryDebounceThresholdPercentage * this.sessionExpiryTime) updateSessionExpiry();
            else {
                if (this.sessionExpiryDebounceTimer) clearTimeout(this.sessionExpiryDebounceTimer);
                // @ts-ignore Something wrong with our types... this is legit
                this.sessionExpiryDebounceTimer = setTimeout(()=>{
                    updateSessionExpiry();
                }, this.sessionExpiryDebounce);
            }
        };
        this.sessionExpiryTime = $58bf772dcbfc48a9$export$285f6bddd927a06d;
        this.sessionExpiryDebounce = $58bf772dcbfc48a9$export$a92e915d70316eb2;
        this.sessionExpiryDebounceThresholdPercentage = $58bf772dcbfc48a9$export$de43760b2dc10c19;
        this.safeSessionStorage = new (0, $e1sF4.default)();
    }
}

});
parcelRegister("e1sF4", function(module, exports) {
$parcel$export(module.exports, "default", () => $fdc46737304158e4$export$2e2bcd8739ae039);

var $dVyaZ = parcelRequire("dVyaZ");

var $7obND = parcelRequire("7obND");
class $fdc46737304158e4$export$2e2bcd8739ae039 extends (0, $7obND.default) {
    constructor(options){
        let storageToUse;
        try {
            storageToUse = window.sessionStorage || (0, $dVyaZ.default);
        } catch (err) {
            storageToUse = (0, $dVyaZ.default);
        }
        super(storageToUse, options);
    }
}

});
parcelRegister("dVyaZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $c657da13eea4b646$export$2e2bcd8739ae039);
class $c657da13eea4b646$export$90e3e001bcac59c7 {
    constructor(){
        this.data = {};
        this.length = 0;
        this.setItem = (key, value)=>{
            this.data[key] = value;
            this.length = Object.keys(this.data).length;
            return value;
        };
        this.getItem = (key)=>{
            if (key in this.data) return this.data[key];
            return null;
        };
        this.removeItem = (key)=>{
            if (key in this.data) delete this.data[key];
            this.length = Object.keys(this.data).length;
            return null;
        };
        this.clear = ()=>{
            this.data = {};
            this.length = 0;
        };
        this.key = (index)=>Object.keys(this.data)[index];
    }
}
// eslint-disable-next-line import/no-anonymous-default-export
const $c657da13eea4b646$var$inmemorystorage = new $c657da13eea4b646$export$90e3e001bcac59c7();
var $c657da13eea4b646$export$2e2bcd8739ae039 = $c657da13eea4b646$var$inmemorystorage;

});

parcelRegister("7obND", function(module, exports) {
$parcel$export(module.exports, "default", () => $8d12fd5fb8b837c9$export$2e2bcd8739ae039);
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ 
var $dVyaZ = parcelRequire("dVyaZ");
const $8d12fd5fb8b837c9$export$41c06fdd37b7e9a5 = 'awc';
const $8d12fd5fb8b837c9$export$770aa8bc07b3de03 = 'awcInMemoryStorageFallback';
var $8d12fd5fb8b837c9$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["DEV"] = "dev";
    envType["LOCAL"] = "local";
    envType["PROD"] = "prod";
    envType["STAGING"] = "staging";
    return envType;
}({});
function $8d12fd5fb8b837c9$export$48c17662a6902497(store) {
    const TEST_VALUE = 'test_value';
    if (!store) return false;
    try {
        const key = 'awc.storage.support';
        store.setItem(key, TEST_VALUE);
        const value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}
class $8d12fd5fb8b837c9$export$2e2bcd8739ae039 {
    constructor(storageToUse, options = {}){
        this.prefix = void 0;
        this.store = void 0;
        this.options = void 0;
        this.getStore = ()=>this.store;
        this.getItem = (key)=>this.store.getItem(this.createKey(key));
        this.removeItem = (key)=>this.store.removeItem(this.createKey(key));
        this.setItem = (key, value)=>{
            try {
                this.store.setItem(this.createKey(key), value);
            } catch (err) {
                // Theoretically should only be QuotaExceededError, but keeping 'err' generic
                // https://developer.mozilla.org/en-US/docs/Web/API/Storage/setItem
                this.swapToInMemory();
                this.store.setItem(this.createKey(key), value);
            }
        };
        this.swapToInMemory = ()=>{
            if (this.store === (0, $dVyaZ.default) || typeof window === 'undefined') return;
            const keys = Object.keys(this.store || {});
            let inMemoryStorage;
            if ($8d12fd5fb8b837c9$export$48c17662a6902497(window[$8d12fd5fb8b837c9$export$770aa8bc07b3de03])) inMemoryStorage = window[$8d12fd5fb8b837c9$export$770aa8bc07b3de03];
            else {
                inMemoryStorage = (0, $dVyaZ.default);
                if (!window[$8d12fd5fb8b837c9$export$770aa8bc07b3de03]) // If not already attached to window then attach our instance of InMemoryStorage
                // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
                // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
                window[$8d12fd5fb8b837c9$export$770aa8bc07b3de03] = (0, $dVyaZ.default);
            }
            keys.forEach((key)=>{
                if (key.indexOf(this.getPrefix()) === 0) {
                    const value = this.store.getItem(key);
                    if (value) inMemoryStorage.setItem(key, value);
                }
            });
            this.store = inMemoryStorage;
        };
        this.clear = ()=>this.store.clear();
        this.key = (index)=>this.store.key(index);
        this.getPrefix = ()=>this.prefix;
        this.createKey = (key)=>{
            if (this.prefix) return `${this.getPrefix()}.${key}`;
            return key;
        };
        this.options = options;
        const prefixes = [];
        if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push($8d12fd5fb8b837c9$export$41c06fdd37b7e9a5);
        if (options.envPrefix && options.envPrefix !== "prod") prefixes.push(options.envPrefix);
        this.prefix = prefixes.join('-');
        if ($8d12fd5fb8b837c9$export$48c17662a6902497(storageToUse)) this.store = storageToUse;
        else this.swapToInMemory();
    }
}

});





parcelRegister("gIumz", function(module, exports) {
$parcel$export(module.exports, "URL_QUERY_PARAM_INTERACTION_SESSION", () => $885f680cf8762ff5$export$81d16f1428ce0486);
const $885f680cf8762ff5$export$81d16f1428ce0486 = 'xpis';
const $885f680cf8762ff5$export$2e3999ec51334ffe = (url, bridge, interactionSessionId, product, subProduct)=>{
    const interactionSource = subProduct ? `${product}-${subProduct}` : product;
    const interactionSession = {
        bridge: bridge,
        id: interactionSessionId,
        source: interactionSource
    };
    const paramValueEncoded = btoa(JSON.stringify(interactionSession));
    const urlObj = new URL(url);
    urlObj.searchParams.set($885f680cf8762ff5$export$81d16f1428ce0486, paramValueEncoded);
    return urlObj.toString();
};

});

parcelRegister("51TEe", function(module, exports) {
$parcel$export(module.exports, "validProducts", () => $542caca6abbb1c42$export$b1e8b4360a046e61);
// Add products that will participate in cross-product interaction tracking here
// TODO: Down the line this should ideally be synced with ECS product list but that
// will take significant engineering effort
const $542caca6abbb1c42$export$b1e8b4360a046e61 = [
    'jira',
    'confluence',
    'townsquare',
    'loom'
];

});

parcelRegister("k0wX2", function(module, exports) {
$parcel$export(module.exports, "defaultHistoryReplaceFn", () => $12f38a6f5f7072ab$export$600dd5bf1b049f11);
$parcel$export(module.exports, "default", () => $12f38a6f5f7072ab$export$2e2bcd8739ae039);

var $eRyv5 = parcelRequire("eRyv5");

var $j3v0M = parcelRequire("j3v0M");
const $12f38a6f5f7072ab$export$600dd5bf1b049f11 = (newUrl)=>window.history.replaceState({}, '', newUrl);
const $12f38a6f5f7072ab$var$urlParamExtractor = (isCaptureParam, historyReplaceFn = $12f38a6f5f7072ab$export$600dd5bf1b049f11)=>{
    // Extract target parameters and values from URL if present
    const originalUrl = window.location.href;
    const fragmentHash = window.location.hash;
    const removedFragmentURL = fragmentHash !== '' ? originalUrl.replace(fragmentHash, '') : originalUrl;
    const { url: url, query: query } = (0, $eRyv5.parseUrl)(removedFragmentURL);
    const captureParams = (0, $j3v0M.pickBy)(query, isCaptureParam);
    // Do not modify URL if no matches
    if (Object.keys(captureParams).length > 0) {
        const queryWithoutCaptureParams = (0, $j3v0M.omitBy)(query, isCaptureParam);
        // Replace the URL minus captured parameters
        if (Object.keys(queryWithoutCaptureParams).length > 0) {
            const newUrl = `${url}?${(0, $eRyv5.stringify)(queryWithoutCaptureParams)}${fragmentHash}`;
            historyReplaceFn(newUrl);
        } else historyReplaceFn(`${url}${fragmentHash}`);
    }
    return captureParams;
};
var $12f38a6f5f7072ab$export$2e2bcd8739ae039 = $12f38a6f5f7072ab$var$urlParamExtractor;

});
parcelRegister("eRyv5", function(module, exports) {
$parcel$export(module.exports, "extract", () => $ad20c6fb7bbea59b$export$f9380c9a627682d3, (v) => $ad20c6fb7bbea59b$export$f9380c9a627682d3 = v);
$parcel$export(module.exports, "parse", () => $ad20c6fb7bbea59b$export$98e6a39c04603d36, (v) => $ad20c6fb7bbea59b$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "stringify", () => $ad20c6fb7bbea59b$export$fac44ee5b035f737, (v) => $ad20c6fb7bbea59b$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parseUrl", () => $ad20c6fb7bbea59b$export$7a5253c0f62e0150, (v) => $ad20c6fb7bbea59b$export$7a5253c0f62e0150 = v);
$parcel$export(module.exports, "stringifyUrl", () => $ad20c6fb7bbea59b$export$a8c1621ea79325d3, (v) => $ad20c6fb7bbea59b$export$a8c1621ea79325d3 = v);
$parcel$export(module.exports, "pick", () => $ad20c6fb7bbea59b$export$357523c63a2253b9, (v) => $ad20c6fb7bbea59b$export$357523c63a2253b9 = v);
var $ad20c6fb7bbea59b$export$f9380c9a627682d3;
var $ad20c6fb7bbea59b$export$98e6a39c04603d36;
var $ad20c6fb7bbea59b$export$fac44ee5b035f737;
var $ad20c6fb7bbea59b$export$7a5253c0f62e0150;
var $ad20c6fb7bbea59b$export$a8c1621ea79325d3;
var $ad20c6fb7bbea59b$export$357523c63a2253b9;
var $ad20c6fb7bbea59b$export$44c361b8ec72ef7f;
'use strict';

var $6fRqm = parcelRequire("6fRqm");

var $4Epvw = parcelRequire("4Epvw");

var $7ugwt = parcelRequire("7ugwt");

var $59DMK = parcelRequire("59DMK");
const $ad20c6fb7bbea59b$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $ad20c6fb7bbea59b$var$encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');
function $ad20c6fb7bbea59b$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case 'index':
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $ad20c6fb7bbea59b$var$encode(key, options),
                            '[',
                            index,
                            ']'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $ad20c6fb7bbea59b$var$encode(key, options),
                            '[',
                            $ad20c6fb7bbea59b$var$encode(index, options),
                            ']=',
                            $ad20c6fb7bbea59b$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'bracket':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $ad20c6fb7bbea59b$var$encode(key, options),
                            '[]'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $ad20c6fb7bbea59b$var$encode(key, options),
                            '[]=',
                            $ad20c6fb7bbea59b$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'colon-list-separator':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $ad20c6fb7bbea59b$var$encode(key, options),
                            ':list='
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $ad20c6fb7bbea59b$var$encode(key, options),
                            ':list=',
                            $ad20c6fb7bbea59b$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'comma':
        case 'separator':
        case 'bracket-separator':
            {
                const keyValueSep = options.arrayFormat === 'bracket-separator' ? '[]=' : '=';
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? '' : value;
                        if (result.length === 0) return [
                            [
                                $ad20c6fb7bbea59b$var$encode(key, options),
                                keyValueSep,
                                $ad20c6fb7bbea59b$var$encode(value, options)
                            ].join('')
                        ];
                        return [
                            [
                                result,
                                $ad20c6fb7bbea59b$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        $ad20c6fb7bbea59b$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $ad20c6fb7bbea59b$var$encode(key, options),
                            '=',
                            $ad20c6fb7bbea59b$var$encode(value, options)
                        ].join('')
                    ];
                };
    }
}
function $ad20c6fb7bbea59b$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case 'index':
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'colon-list-separator':
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'comma':
        case 'separator':
            return (key, value, accumulator)=>{
                const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === 'string' && !isArray && $ad20c6fb7bbea59b$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $ad20c6fb7bbea59b$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$ad20c6fb7bbea59b$var$decode(item, options)) : value === null ? value : $ad20c6fb7bbea59b$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case 'bracket-separator':
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, '');
                if (!isArray) {
                    accumulator[key] = value ? $ad20c6fb7bbea59b$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$ad20c6fb7bbea59b$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $ad20c6fb7bbea59b$var$validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) throw new TypeError('arrayFormatSeparator must be single character string');
}
function $ad20c6fb7bbea59b$var$encode(value, options) {
    if (options.encode) return options.strict ? $6fRqm(value) : encodeURIComponent(value);
    return value;
}
function $ad20c6fb7bbea59b$var$decode(value, options) {
    if (options.decode) return $4Epvw(value);
    return value;
}
function $ad20c6fb7bbea59b$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === 'object') return $ad20c6fb7bbea59b$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $ad20c6fb7bbea59b$var$removeHash(input) {
    const hashStart = input.indexOf('#');
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $ad20c6fb7bbea59b$var$getHash(url) {
    let hash = '';
    const hashStart = url.indexOf('#');
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $ad20c6fb7bbea59b$var$extract(input) {
    input = $ad20c6fb7bbea59b$var$removeHash(input);
    const queryStart = input.indexOf('?');
    if (queryStart === -1) return '';
    return input.slice(queryStart + 1);
}
function $ad20c6fb7bbea59b$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) value = value.toLowerCase() === 'true';
    return value;
}
function $ad20c6fb7bbea59b$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ',',
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $ad20c6fb7bbea59b$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $ad20c6fb7bbea59b$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== 'string') return ret;
    query = query.trim().replace(/^[?#&]/, '');
    if (!query) return ret;
    for (const param of query.split('&')){
        if (param === '') continue;
        let [key, value] = $7ugwt(options.decode ? param.replace(/\+/g, ' ') : param, '=');
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            'comma',
            'separator',
            'bracket-separator'
        ].includes(options.arrayFormat) ? value : $ad20c6fb7bbea59b$var$decode(value, options);
        formatter($ad20c6fb7bbea59b$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === 'object' && value !== null) for (const k of Object.keys(value))value[k] = $ad20c6fb7bbea59b$var$parseValue(value[k], options);
        else ret[key] = $ad20c6fb7bbea59b$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $ad20c6fb7bbea59b$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$ad20c6fb7bbea59b$export$f9380c9a627682d3 = $ad20c6fb7bbea59b$var$extract;
$ad20c6fb7bbea59b$export$98e6a39c04603d36 = $ad20c6fb7bbea59b$var$parse;
$ad20c6fb7bbea59b$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return '';
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ','
    }, options);
    $ad20c6fb7bbea59b$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $ad20c6fb7bbea59b$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    const formatter = $ad20c6fb7bbea59b$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return '';
        if (value === null) return $ad20c6fb7bbea59b$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === 'bracket-separator') return $ad20c6fb7bbea59b$var$encode(key, options) + '[]';
            return value.reduce(formatter(key), []).join('&');
        }
        return $ad20c6fb7bbea59b$var$encode(key, options) + '=' + $ad20c6fb7bbea59b$var$encode(value, options);
    }).filter((x)=>x.length > 0).join('&');
};
$ad20c6fb7bbea59b$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $7ugwt(url, '#');
    return Object.assign({
        url: url_.split('?')[0] || '',
        query: $ad20c6fb7bbea59b$var$parse($ad20c6fb7bbea59b$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $ad20c6fb7bbea59b$var$decode(hash, options)
    } : {});
};
$ad20c6fb7bbea59b$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [$ad20c6fb7bbea59b$var$encodeFragmentIdentifier]: true
    }, options);
    const url = $ad20c6fb7bbea59b$var$removeHash(object.url).split('?')[0] || '';
    const queryFromUrl = $ad20c6fb7bbea59b$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $ad20c6fb7bbea59b$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $ad20c6fb7bbea59b$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $ad20c6fb7bbea59b$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[$ad20c6fb7bbea59b$var$encodeFragmentIdentifier] ? $ad20c6fb7bbea59b$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
$ad20c6fb7bbea59b$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [$ad20c6fb7bbea59b$var$encodeFragmentIdentifier]: false
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $ad20c6fb7bbea59b$export$7a5253c0f62e0150(input, options);
    return $ad20c6fb7bbea59b$export$a8c1621ea79325d3({
        url: url,
        query: $59DMK(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$ad20c6fb7bbea59b$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $ad20c6fb7bbea59b$export$357523c63a2253b9(input, exclusionFilter, options);
};

});
parcelRegister("6fRqm", function(module, exports) {
'use strict';
module.exports = (str)=>encodeURIComponent(str).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);

});

parcelRegister("4Epvw", function(module, exports) {
'use strict';
var $362eaf1675b18d33$var$token = '%[a-f0-9]{2}';
var $362eaf1675b18d33$var$singleMatcher = new RegExp('(' + $362eaf1675b18d33$var$token + ')|([^%]+?)', 'gi');
var $362eaf1675b18d33$var$multiMatcher = new RegExp('(' + $362eaf1675b18d33$var$token + ')+', 'gi');
function $362eaf1675b18d33$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(''))
        ];
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], $362eaf1675b18d33$var$decodeComponents(left), $362eaf1675b18d33$var$decodeComponents(right));
}
function $362eaf1675b18d33$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match($362eaf1675b18d33$var$singleMatcher) || [];
        for(var i = 1; i < tokens.length; i++){
            input = $362eaf1675b18d33$var$decodeComponents(tokens, i).join('');
            tokens = input.match($362eaf1675b18d33$var$singleMatcher) || [];
        }
        return input;
    }
}
function $362eaf1675b18d33$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        '%FE%FF': '\uFFFD\uFFFD',
        '%FF%FE': '\uFFFD\uFFFD'
    };
    var match = $362eaf1675b18d33$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = $362eaf1675b18d33$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $362eaf1675b18d33$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap['%C2'] = '\uFFFD';
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
    }
    return input;
}
module.exports = function(encodedURI) {
    if (typeof encodedURI !== 'string') throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
    try {
        encodedURI = encodedURI.replace(/\+/g, ' ');
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return $362eaf1675b18d33$var$customDecodeURIComponent(encodedURI);
    }
};

});

parcelRegister("7ugwt", function(module, exports) {
'use strict';
module.exports = (string, separator)=>{
    if (!(typeof string === 'string' && typeof separator === 'string')) throw new TypeError('Expected the arguments to be of type `string`');
    if (separator === '') return [
        string
    ];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};

});

parcelRegister("59DMK", function(module, exports) {
'use strict';
module.exports = function(obj, predicate) {
    var ret = {};
    var keys = Object.keys(obj);
    var isArr = Array.isArray(predicate);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var val = obj[key];
        if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) ret[key] = val;
    }
    return ret;
};

});


parcelRegister("j3v0M", function(module, exports) {
$parcel$export(module.exports, "mapKeys", () => $1765681414781e6b$export$781522908e4e76a1);
$parcel$export(module.exports, "pick", () => $1765681414781e6b$export$357523c63a2253b9);
$parcel$export(module.exports, "omitBy", () => $1765681414781e6b$export$d7a617dda645b4e3);
$parcel$export(module.exports, "pickBy", () => $1765681414781e6b$export$b460b275d6c6aa0);
$parcel$export(module.exports, "omit", () => $1765681414781e6b$export$30a06c8d3562193f);
$parcel$export(module.exports, "equals", () => $1765681414781e6b$export$e9bab7fafb253603);
$parcel$export(module.exports, "partition", () => $1765681414781e6b$export$b29f828819edca8d);
/* eslint-disable no-return-assign, no-sequences */ // https://www.30secondsofcode.org/js/s/map-keys
const $1765681414781e6b$export$781522908e4e76a1 = (obj, fn)=>Object.keys(obj).reduce((acc, k)=>{
        const key = fn(obj[k], k, obj);
        acc[key] = obj[k];
        return acc;
    }, {});
// https://www.30secondsofcode.org/js/s/pick
const $1765681414781e6b$export$357523c63a2253b9 = (obj, arr)=>arr.reduce((acc, curr)=>(curr in obj && (acc[curr] = obj[curr]), acc), {});
// https://www.30secondsofcode.org/js/s/omit-by
const $1765681414781e6b$export$d7a617dda645b4e3 = (obj, fn)=>Object.keys(obj).filter((k)=>!fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/pick-by
const $1765681414781e6b$export$b460b275d6c6aa0 = (obj, fn)=>Object.keys(obj).filter((k)=>fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/omit
const $1765681414781e6b$export$30a06c8d3562193f = (obj, arr)=>Object.keys(obj).filter((k)=>arr.indexOf(k) < 0).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/equals
const $1765681414781e6b$export$e9bab7fafb253603 = (a, b)=>{
    if (a === b) return true;
    if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
    if (!a || !b || typeof a !== 'object' && typeof b !== 'object') return a === b;
    if (a.prototype !== b.prototype) return false;
    const keys = Object.keys(a);
    if (keys.length !== Object.keys(b).length) return false;
    return keys.every((k)=>$1765681414781e6b$export$e9bab7fafb253603(a[k], b[k]));
};
// https://www.30secondsofcode.org/js/s/partition
const $1765681414781e6b$export$b29f828819edca8d = (arr, fn)=>arr.reduce(// eslint-disable-next-line no-shadow
    (acc, val, i, arr)=>{
        acc[fn(val, i, arr) ? 0 : 1].push(val);
        return acc;
    }, [
        [],
        []
    ]);

});



parcelRegister("dHwqw", function(module, exports) {
$parcel$export(module.exports, "isFirstParty", () => $c16505283dcf089c$export$f56713ced121eb91);
$parcel$export(module.exports, "isThirdParty", () => $c16505283dcf089c$export$ab34f90cc32c8960);

var $1RuJ0 = parcelRequire("1RuJ0");
const $c16505283dcf089c$export$f56713ced121eb91 = (input)=>{
    return input.embeddedType === (0, $1RuJ0.productEmbedType).FIRST_PARTY && input.embeddedFromProduct !== undefined;
};
const $c16505283dcf089c$export$ab34f90cc32c8960 = (input)=>{
    return input.embeddedType === (0, $1RuJ0.productEmbedType).THIRD_PARTY && input.embeddedFromTopLevelDomain !== undefined;
};

});

parcelRegister("1rUiu", function(module, exports) {
$parcel$export(module.exports, "buildActionFields", () => $3204edaf5fa44279$export$655ecf7241feac42);
$parcel$export(module.exports, "buildScreenEvent", () => $3204edaf5fa44279$export$c7d9a5f56acc4b19);
$parcel$export(module.exports, "buildActionName", () => $3204edaf5fa44279$export$9c5623a792efc9b0);
$parcel$export(module.exports, "buildContext", () => $3204edaf5fa44279$export$3a7fe28f9bf4f3d9);
$parcel$export(module.exports, "buildActionEvent", () => $3204edaf5fa44279$export$7bf451af4a8e3dd9);

var $1RuJ0 = parcelRequire("1RuJ0");

var $kz5WF = parcelRequire("kz5WF");
const $3204edaf5fa44279$var$libraryVersion = "0.0.0-use.local";
function $3204edaf5fa44279$var$buildTenantFields(tenantInfo) {
    return {
        tenantIdType: tenantInfo.tenantIdType,
        tenantId: tenantInfo.tenantId
    };
}
function $3204edaf5fa44279$var$buildUserFields(userInfo) {
    return {
        userIdType: userInfo.userIdType
    };
}
function $3204edaf5fa44279$var$buildOrgFields(orgInfo) {
    return {
        orgId: orgInfo.orgId
    };
}
function $3204edaf5fa44279$var$buildWorkspaceFields(workspaceInfo) {
    return {
        workspaceId: workspaceInfo.workspaceId
    };
}
function $3204edaf5fa44279$var$buildAliases(aliases) {
    if ($3204edaf5fa44279$var$isNotEmptyObject(aliases)) return {
        aliases: aliases
    };
    return undefined;
}
function $3204edaf5fa44279$var$buildGroups(groups) {
    if ($3204edaf5fa44279$var$isNotEmptyObject(groups)) return {
        groups: groups
    };
    return undefined;
}
function $3204edaf5fa44279$var$buildEventOverrides(event) {
    if (event.anonymousId) return {
        anonymousId: event.anonymousId
    };
    return {};
}
function $3204edaf5fa44279$var$getProductField(field, override) {
    return override === undefined ? field : override;
}
function $3204edaf5fa44279$var$buildProductFields(productInfo, productOverrides) {
    const overrides = productOverrides || {};
    const env = $3204edaf5fa44279$var$getProductField(productInfo.env, overrides.env);
    const product = $3204edaf5fa44279$var$getProductField(productInfo.product, overrides.product);
    const subproduct = $3204edaf5fa44279$var$getProductField(productInfo.subproduct(), overrides.subproduct);
    const version = $3204edaf5fa44279$var$getProductField(productInfo.version, overrides.version);
    const origin = $3204edaf5fa44279$var$getProductField(productInfo.origin, overrides.origin);
    const platform = $3204edaf5fa44279$var$getProductField(productInfo.platform, overrides.platform);
    const ic = productInfo.ic; // ic should not be overriden once set
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform,
        ic: ic
    };
}
function $3204edaf5fa44279$var$isNotEmptyObject(obj) {
    return (0, $kz5WF.isPlainObject)(obj) && Object.keys(obj).length > 0;
}
function $3204edaf5fa44279$var$buildAttributesWithName(name, attrObject) {
    return $3204edaf5fa44279$var$isNotEmptyObject(attrObject) ? {
        [name]: attrObject
    } : undefined;
}
function $3204edaf5fa44279$var$buildAttributes(attributes) {
    return $3204edaf5fa44279$var$buildAttributesWithName('attributes', attributes);
}
function $3204edaf5fa44279$export$3f5115a568819c1a(containers) {
    const validContainers = {};
    Object.keys(containers).forEach((key)=>{
        const value = containers[key];
        validContainers[key] = {
            id: value.id,
            type: value.type
        };
    });
    return validContainers;
}
function $3204edaf5fa44279$export$f045f238d77c002a(containers) {
    if ($3204edaf5fa44279$var$isNotEmptyObject(containers)) {
        const validContainers = $3204edaf5fa44279$export$3f5115a568819c1a(containers);
        return $3204edaf5fa44279$var$buildAttributesWithName('containers', validContainers);
    }
    return undefined;
}
function $3204edaf5fa44279$export$655ecf7241feac42(event, actionEventType) {
    return {
        containerType: event.containerType,
        containerId: event.containerId,
        source: event.source,
        objectType: event.objectType,
        objectId: event.objectId,
        actionSubject: event.actionSubject,
        action: event.action,
        actionSubjectId: event.actionSubjectId,
        attributes: event.attributes,
        nonPrivacySafeAttributes: event.nonPrivacySafeAttributes,
        tags: event.tags,
        highPriority: event.highPriority,
        eventType: actionEventType,
        ...$3204edaf5fa44279$export$f045f238d77c002a(event.containers)
    };
}
function $3204edaf5fa44279$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes) {
    return $3204edaf5fa44279$var$buildAttributesWithName('nonPrivacySafeAttributes', nonPrivacySafeAttributes);
}
function $3204edaf5fa44279$export$c7d9a5f56acc4b19(productInfo, tenantInfo, userInfo, attributes, nonPrivacySafeAttributes, tags, tabId, sessionId, taskSessions, interactionSession, orgInfo, pageLoadId, workspaceInfo, event, containers, aliases, groups) {
    const productFields = $3204edaf5fa44279$var$buildProductFields(productInfo);
    const tenantFields = $3204edaf5fa44279$var$buildTenantFields(tenantInfo);
    const userFields = $3204edaf5fa44279$var$buildUserFields(userInfo);
    const orgFields = $3204edaf5fa44279$var$buildOrgFields(orgInfo);
    const workspaceFields = $3204edaf5fa44279$var$buildWorkspaceFields(workspaceInfo);
    const overrides = {
        title: '',
        path: '',
        url: '',
        referrer: '',
        search: '',
        eventType: (0, $1RuJ0.eventType).SCREEN
    };
    return {
        ...productFields,
        ...tenantFields,
        ...userFields,
        ...orgFields,
        ...overrides,
        ...$3204edaf5fa44279$var$buildAttributes(attributes),
        ...$3204edaf5fa44279$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes),
        ...$3204edaf5fa44279$export$f045f238d77c002a(containers),
        ...$3204edaf5fa44279$var$buildEventOverrides(event),
        tags: tags,
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        interactionSession: interactionSession,
        pageLoadId: pageLoadId,
        ...workspaceFields,
        ...$3204edaf5fa44279$var$buildAliases(aliases),
        ...$3204edaf5fa44279$var$buildGroups(groups)
    };
}
function $3204edaf5fa44279$export$9c5623a792efc9b0(event) {
    return `${event.actionSubject} ${event.action}`;
}
var $3204edaf5fa44279$export$fbd92247fb4d6159 = /*#__PURE__*/ function(validationMode) {
    validationMode["QUIET"] = "quiet";
    validationMode["STANDARD"] = "standard";
    validationMode["COMPLETE"] = "complete";
    return validationMode;
}({});
function $3204edaf5fa44279$var$getDefaultValidationMode(productInfo) {
    const environment = productInfo.env;
    if (environment === undefined) return "quiet";
    if (environment.includes('prod')) return "quiet";
    return "complete";
}
function $3204edaf5fa44279$export$3a7fe28f9bf4f3d9(productInfo) {
    const screen = window.screen || {};
    return {
        context: {
            locale: productInfo.locale,
            screen: {
                width: screen.width,
                height: screen.height,
                density: window.devicePixelRatio
            },
            library: {
                name: 'analytics.js',
                version: $3204edaf5fa44279$var$libraryVersion
            },
            validationMode: $3204edaf5fa44279$var$getDefaultValidationMode(productInfo)
        }
    };
}
function $3204edaf5fa44279$export$e3d99b4bfec06f6e(event) {
    const { env: env, product: product, subproduct: subproduct, version: version, origin: origin, platform: platform } = event;
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform
    };
}
function $3204edaf5fa44279$export$7bf451af4a8e3dd9(productInfo, tenantInfo, userInfo, event, actionEventType, tabId, sessionId, taskSessions, interactionSession, orgInfo, pageLoadId, workspaceInfo, aliases, groups) {
    const productFields = $3204edaf5fa44279$var$buildProductFields(productInfo, $3204edaf5fa44279$export$e3d99b4bfec06f6e(event));
    const tenantFields = $3204edaf5fa44279$var$buildTenantFields(tenantInfo);
    const orgFields = $3204edaf5fa44279$var$buildOrgFields(orgInfo);
    const workspaceFields = $3204edaf5fa44279$var$buildWorkspaceFields(workspaceInfo);
    const userFields = $3204edaf5fa44279$var$buildUserFields(userInfo);
    const actionFields = $3204edaf5fa44279$export$655ecf7241feac42(event, actionEventType);
    return {
        ...productFields,
        ...tenantFields,
        ...orgFields,
        ...userFields,
        ...actionFields,
        ...$3204edaf5fa44279$var$buildEventOverrides(event),
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        interactionSession: interactionSession,
        pageLoadId: pageLoadId,
        ...workspaceFields,
        ...$3204edaf5fa44279$var$buildAliases(aliases),
        ...$3204edaf5fa44279$var$buildGroups(groups)
    };
}

});
parcelRegister("kz5WF", function(module, exports) {
$parcel$export(module.exports, "isPlainObject", () => $6a5b0dee7e6a9dbc$export$53b83ca8eaab0383);
// Modified from https://github.com/jonschlinkert/is-plain-object/blob/master/index.js
function $6a5b0dee7e6a9dbc$var$isObject(val) {
    return val !== null && typeof val === 'object' && Array.isArray(val) === false;
}
function $6a5b0dee7e6a9dbc$var$isObjectObject(o) {
    return $6a5b0dee7e6a9dbc$var$isObject(o) === true && Object.prototype.toString.call(o) === '[object Object]';
}
function $6a5b0dee7e6a9dbc$export$53b83ca8eaab0383(o) {
    if ($6a5b0dee7e6a9dbc$var$isObjectObject(o) === false) return false;
    // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor !== 'function') return false;
    // If has modified prototype
    const prot = ctor.prototype;
    if ($6a5b0dee7e6a9dbc$var$isObjectObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (!('isPrototypeOf' in prot)) return false;
    // Most likely a plain Object
    return true;
}

});


parcelRegister("cDSz8", function(module, exports) {
$parcel$export(module.exports, "default", () => $464a7b1e7df7e31d$export$2e2bcd8739ae039);

var $d04dC = parcelRequire("d04dC");

var $hR48H = parcelRequire("hR48H");

var $1suhT = parcelRequire("1suhT");
class $464a7b1e7df7e31d$export$2e2bcd8739ae039 {
    constructor(fireDelayedEvent, compressors){
        this.delayQueue = void 0;
        this.delayTimeout = void 0;
        this.delayCallback = void 0;
        this.isDelaying = void 0;
        this.push = (identifier, builtEvent, context, userInfo)=>{
            this.delayQueue.push(identifier, builtEvent, context, userInfo);
        };
        this.startLowPriorityEventDelay = (timeout = (0, $d04dC.DEFAULT_DELAY_TIMEOUT), callback)=>{
            if (Number.isNaN(timeout) || timeout <= 0) throw new Error(`Invalid timeout period: ${timeout}, must be a number greater than 0`);
            if (this.delayTimeout) clearTimeout(this.delayTimeout);
            const delayTimeoutPeriod = timeout ? Math.min(timeout, (0, $d04dC.MAX_DELAY_TIMEOUT)) : (0, $d04dC.MAX_DELAY_TIMEOUT);
            this.delayCallback = callback;
            this.delayTimeout = setTimeout(()=>this.stopLowPriorityEventDelay((0, $1suhT.StopLowPriorityEventDelayReason).TIMEOUT), delayTimeoutPeriod);
            // If the queue is still flushing from a previous delay period, then we should cancel that flush
            // to stop it from negatively impacting the performance of the new critical section
            this.delayQueue.cancelFlush();
            this.isDelaying = true;
        };
        this.stopLowPriorityEventDelay = (reason = (0, $1suhT.StopLowPriorityEventDelayReason).MANUAL)=>{
            if (this.delayTimeout) {
                clearTimeout(this.delayTimeout);
                this.delayTimeout = undefined;
            }
            this.delayQueue.startFlush();
            this.isDelaying = false;
            this.delayCallback?.(reason);
            this.delayCallback = undefined;
        };
        this.isDelayingLowPriorityEvents = ()=>this.isDelaying;
        this.isDelaying = false;
        this.delayQueue = new (0, $hR48H.default)(fireDelayedEvent, compressors);
    }
}

});
parcelRegister("d04dC", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_DELAY_TIMEOUT", () => $49aa3b632ce49e91$export$cf090d5281b5ae06);
$parcel$export(module.exports, "MAX_DELAY_TIMEOUT", () => $49aa3b632ce49e91$export$8575e30be0feb909);
const $49aa3b632ce49e91$export$cf090d5281b5ae06 = 10000;
const $49aa3b632ce49e91$export$8575e30be0feb909 = 30000;

});

parcelRegister("hR48H", function(module, exports) {
$parcel$export(module.exports, "default", () => $5e9414a0a7a27044$export$2e2bcd8739ae039);

var $1rUiu = parcelRequire("1rUiu");

var $j3v0M = parcelRequire("j3v0M");

var $2i3HW = parcelRequire("2i3HW");
// We want to throttle the flush rate so that we don't have a huge upfront performance hit from starting the flush,
// and so that the underlying Segment client has some time to process some events in its queue before more are added.
const $5e9414a0a7a27044$var$FLUSH_BATCH_SIZE = 7; // aligns with the default batch size of Segment's BatchableQueue
const $5e9414a0a7a27044$var$FLUSH_BATCH_BACKOFF_PERIOD = 100;
class $5e9414a0a7a27044$export$2e2bcd8739ae039 {
    constructor(processFn, compressionRules){
        this.compressor = void 0;
        this.eventArgs = void 0;
        this.flushBatchTimeout = void 0;
        this.processFn = void 0;
        this.push = (identifier, builtEvent, context, userInfo)=>{
            this.eventArgs.push({
                identifier: identifier,
                builtEvent: builtEvent,
                context: context,
                userInfo: userInfo
            });
        };
        this.size = ()=>this.eventArgs.length;
        this.startFlush = ()=>{
            try {
                this.eventArgs = this.compressEventArgs(this.eventArgs);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.warn('Failed to perform compression on the delayed analytics events. ' + `Error: ${e.message}. Sending ${this.eventArgs.length} uncompressed events instead`);
            }
            this.flushNextBatch();
        };
        this.cancelFlush = ()=>{
            if (this.flushBatchTimeout) {
                clearTimeout(this.flushBatchTimeout);
                this.flushBatchTimeout = null;
            }
        };
        this.flushNextBatch = ()=>{
            const batch = this.eventArgs.splice(0, $5e9414a0a7a27044$var$FLUSH_BATCH_SIZE);
            batch.forEach((item)=>this.processFn(item.identifier, item.builtEvent, item.context, item.userInfo));
            if (this.eventArgs.length > 0) this.flushBatchTimeout = setTimeout(()=>this.flushNextBatch(), $5e9414a0a7a27044$var$FLUSH_BATCH_BACKOFF_PERIOD);
            else this.flushBatchTimeout = null;
        };
        this.compressEventArgs = (eventArgs)=>{
            const [compressibleEventArgs, incompressibleEventArgs] = (0, $j3v0M.partition)(eventArgs, (args)=>this.compressor.canCompress(args.builtEvent));
            // Events can only be compressed together if they share the same context and user info, since these are top-level
            // fields that need to exist on the fired event and can only be set to a single value.
            // We can achieve this by grouping our events by context prior to passing them to the compressor.
            const contextGroups = compressibleEventArgs.reduce((groups, args)=>{
                const matchingGroup = groups.find((group)=>(0, $j3v0M.equals)(group.userInfo, args.userInfo) && (0, $j3v0M.equals)(group.context, args.context));
                if (matchingGroup) matchingGroup.eventArgs.push(args);
                else groups.push({
                    userInfo: args.userInfo,
                    context: args.context,
                    eventArgs: [
                        args
                    ]
                });
                return groups;
            }, []);
            // Run the compressor on each group
            const allCompressedEventArgs = contextGroups.reduce((acc, group)=>{
                try {
                    const events = group.eventArgs.map((args)=>args.builtEvent);
                    const compressedEvents = this.compressor.compress(events);
                    const compressedEventArgs = compressedEvents.map((compressedEvent)=>({
                            identifier: (0, $1rUiu.buildActionName)(compressedEvent),
                            builtEvent: compressedEvent,
                            userInfo: group.userInfo,
                            context: group.context
                        }));
                    return acc.concat(compressedEventArgs);
                } catch (e) {
                    // If anything goes wrong while compressing this group, then just fall back on the
                    // uncompressed events instead. The event compressor already handles errors with invalid
                    // generator functions or results, but this is an extra layer of defense to prevent data
                    // loss in the event of an unexpected error.
                    // eslint-disable-next-line no-console
                    console.warn('Failed to compress some analytics events. ' + `Error: ${e.message}. Sending ${group.eventArgs.length} uncompressed events instead`);
                    return group.eventArgs;
                }
            }, []);
            incompressibleEventArgs.forEach((args)=>allCompressedEventArgs.push(args));
            return allCompressedEventArgs;
        };
        this.processFn = processFn;
        this.flushBatchTimeout = null;
        this.eventArgs = [];
        this.compressor = new (0, $2i3HW.default)(compressionRules);
    }
}

});
parcelRegister("2i3HW", function(module, exports) {
$parcel$export(module.exports, "default", () => $e88ae25c76d4e3a8$export$2e2bcd8739ae039);
/* eslint-disable implicit-arrow-linebreak */ /* eslint-disable max-classes-per-file */ 
var $1rUiu = parcelRequire("1rUiu");

var $j3v0M = parcelRequire("j3v0M");

var $iCEVW = parcelRequire("iCEVW");
class $e88ae25c76d4e3a8$export$2e2bcd8739ae039 {
    constructor(compressionRules = []){
        this.compressionRules = void 0;
        this.canCompress = (event)=>this.compressionRules.some((compressionRule)=>compressionRule.canCompress(event));
        this.compress = (events)=>{
            const groups = this.createGroups(events);
            return groups.reduce((allCompressedEvents, group)=>{
                const groupCompressedEvents = this.compressGroup(group);
                return allCompressedEvents.concat(groupCompressedEvents);
            }, []);
        };
        this.createGroups = (events)=>// Group events based on contextual fields. These fields are anything that is added by the client itself,
            // rather than passed in by the caller (eg. product, org. and tenant info)
            events.reduce((groups, event)=>{
                const matchingCompressor = this.compressionRules.find((compressor)=>compressor.canCompress(event));
                let contextFields;
                if (matchingCompressor) {
                    const actionFields = (0, $1rUiu.buildActionFields)(event, event.eventType);
                    contextFields = (0, $j3v0M.omit)(event, Object.keys(actionFields));
                }
                const matchingGroup = groups.find((group)=>matchingCompressor === group.compressor && (0, $j3v0M.equals)(contextFields, group.contextFields));
                if (matchingGroup) matchingGroup.events.push(event);
                else groups.push({
                    contextFields: contextFields,
                    compressor: matchingCompressor,
                    events: [
                        event
                    ]
                });
                return groups;
            }, []);
        this.compressGroup = (group)=>{
            // If this group doesn't have any compressor, then the event args are already in their final format
            if (!group.compressor) return group.events;
            try {
                // Run the compressor on the group to generate some new events.
                // The compression function is only expected to return the action fields for each
                // event that it generates, since all other fields are generated by the client.
                const compressedEventActionFields = group.compressor.compress(group.events);
                // Add the context fields to each of the resulting events to inflate them into a full action event
                return compressedEventActionFields.map((actionFields)=>({
                        ...actionFields,
                        ...group.contextFields
                    }));
            } catch (e) {
                // If we fail to compress the events, then just fall back the uncompressed events
                // so that no data is lost. This can happen if the compression function throws an error
                // or returns some invalid event payloads.
                // eslint-disable-next-line no-console
                // console.warn(
                // 	'Failed to compress some analytics events. ' +
                // 		`Error: ${(e as Error).message}. Sending ${
                // 			group.events.length
                // 		} uncompressed events instead`,
                // );
                return group.events;
            }
        };
        if (!Array.isArray(compressionRules)) throw new Error('Event compressors must be constructed with an array of CompressionRules');
        if (!compressionRules.every((rule)=>rule instanceof (0, $iCEVW.CompressionRule))) throw new Error('Event compressors can only be constructed with instances of CompressionRule');
        this.compressionRules = compressionRules;
    }
}

});
parcelRegister("iCEVW", function(module, exports) {
$parcel$export(module.exports, "CompressionRule", () => $4591d86eb1dcf94a$export$89b3253ddfd2e6e8);

var $6M7gQ = parcelRequire("6M7gQ");

var $j3v0M = parcelRequire("j3v0M");
class $4591d86eb1dcf94a$export$89b3253ddfd2e6e8 {
    /**
   * @callback EventPredicate
   * @param {object} event An analytics event
   * @returns {boolean} A flag indicating whether or not the event matches the conditions
   */ /**
   * @callback CompressionFunction
   * @param {Array.<Object>} events A collection of analytics events that match the predicate of this compression rule
   * @returns {Array.<Object>} compressedEvents The compressed analytics events to fire
   */ /**
   * This constructor defines a new rule for compressing analytics events.
   * @param {EventPredicate} predicate
   * @param {CompressionFunction} compressFn
   */ constructor(predicate, compressFn){
        this.compressFn = void 0;
        this.predicate = void 0;
        /**
     * This function returns a flag indicating whether or not this instance is capable of compressing the given event.
     * @param event
     * @returns {boolean}
     */ this.canCompress = (event)=>{
            try {
                return event && (0, $6M7gQ.isActionEventType)(event.eventType) && this.predicate(event);
            } catch (e) {
                return false;
            }
        };
        /**
     * This function compresses as many events in the given collection as possible.<p>
     * Any events in the given collection that do not match the conditions of {@link canCompress} will be left uncompressed and
     * appended to the end of the resulting array.
     *
     * @param events A collection of analytic events to compress
     * @returns {Array.<Object>} The action fields for the resulting compressed events
     */ this.compress = (events)=>{
            const [compatibleEvents, incompatibleEvents] = (0, $j3v0M.partition)(events, (event)=>this.canCompress(event));
            const compressedEvents = this.compressFn(compatibleEvents);
            if (!compressedEvents) throw new Error('No events were returned from the compression function');
            compressedEvents.forEach((event)=>{
                (0, $6M7gQ.validateActionEventType)(event.eventType);
                (0, $6M7gQ.validateActionEvent)(event);
            });
            return compressedEvents.concat(incompatibleEvents);
        };
        if (typeof predicate !== 'function') throw new Error('Invalid predicate, must be a function that accepts an event and returns a boolean');
        if (typeof compressFn !== 'function') throw new Error('Invalid compressFn, must be a function that both accepts and returns an array of events');
        this.predicate = predicate;
        this.compressFn = compressFn;
    }
}

});
parcelRegister("6M7gQ", function(module, exports) {
$parcel$export(module.exports, "validateContainers", () => $4ca73cea16d9d8cf$export$e63ea5d8477971d3);
$parcel$export(module.exports, "isActionEventType", () => $4ca73cea16d9d8cf$export$d19cebda16f7579a);
$parcel$export(module.exports, "validateActionEventType", () => $4ca73cea16d9d8cf$export$4a8d7476662aebcc);
$parcel$export(module.exports, "validateActionEvent", () => $4ca73cea16d9d8cf$export$e0c121325c66ed4c);
$parcel$export(module.exports, "validateScreenEvent", () => $4ca73cea16d9d8cf$export$dc993432a592dc27);
$parcel$export(module.exports, "validateTrackEvent", () => $4ca73cea16d9d8cf$export$8c014fd74b0c8b99);
$parcel$export(module.exports, "validateDwellBaseEvent", () => $4ca73cea16d9d8cf$export$39d6334da9a44984);
$parcel$export(module.exports, "validateUIEvent", () => $4ca73cea16d9d8cf$export$e5bac0930c812e90);
$parcel$export(module.exports, "validateOperationalEvent", () => $4ca73cea16d9d8cf$export$1e561554275607ef);
$parcel$export(module.exports, "validateIdentifyEvent", () => $4ca73cea16d9d8cf$export$c16a4e16aa4026c0);
$parcel$export(module.exports, "validatePlatform", () => $4ca73cea16d9d8cf$export$801b46c35394d316);

var $1RuJ0 = parcelRequire("1RuJ0");

var $kz5WF = parcelRequire("kz5WF");
const $4ca73cea16d9d8cf$var$actionEventTypes = Object.freeze([
    (0, $1RuJ0.eventType).OPERATIONAL,
    (0, $1RuJ0.eventType).TRACK,
    (0, $1RuJ0.eventType).UI
]);
function $4ca73cea16d9d8cf$export$df8ff30e3c960006(container) {
    if (!(0, $kz5WF.isPlainObject)(container)) throw new Error('properties.containers must be an Object');
    if (!('id' in container)) throw new Error("properties.containers is missing field 'id'");
    if (typeof container.id !== 'string') throw new Error('properties.containers.id must be of type String');
    if ('type' in container && typeof container.type !== 'string') throw new Error('properties.containers.type must be of type String');
}
function $4ca73cea16d9d8cf$export$e63ea5d8477971d3(containers) {
    if (!containers) return;
    if (containers && containers.constructor !== Object) throw new Error('properties.containers must be an Object');
    Object.values(containers).forEach((container)=>$4ca73cea16d9d8cf$export$df8ff30e3c960006(container));
}
function $4ca73cea16d9d8cf$export$d19cebda16f7579a(type) {
    switch(type){
        case (0, $1RuJ0.eventType).OPERATIONAL:
        case (0, $1RuJ0.eventType).TRACK:
        case (0, $1RuJ0.eventType).UI:
            return true;
        default:
            return false;
    }
}
function $4ca73cea16d9d8cf$export$4a8d7476662aebcc(type) {
    if (!$4ca73cea16d9d8cf$export$d19cebda16f7579a(type)) throw new Error(`Invalid action event type: ${type}, must be one of: [${$4ca73cea16d9d8cf$var$actionEventTypes}]`);
    return true;
}
function $4ca73cea16d9d8cf$export$e0c121325c66ed4c(event) {
    if (!event) throw new Error('Missing event');
    if (!event.source) throw new Error('Missing event.source');
    if (!event.actionSubject) throw new Error('Missing event.actionSubject');
    if (!event.action) throw new Error('Missing event.action');
    $4ca73cea16d9d8cf$export$e63ea5d8477971d3(event.containers);
}
function $4ca73cea16d9d8cf$export$dc993432a592dc27(name) {
    if (!name) throw new Error('Missing name');
}
function $4ca73cea16d9d8cf$export$8c014fd74b0c8b99(event) {
    $4ca73cea16d9d8cf$export$e0c121325c66ed4c(event);
}
function $4ca73cea16d9d8cf$export$39d6334da9a44984(event) {
    if (!event) throw new Error('Missing event');
    if (!event.source) throw new Error('Missing event.source');
    if (!event.actionSubject) throw new Error('Missing event.actionSubject');
}
function $4ca73cea16d9d8cf$export$e5bac0930c812e90(event) {
    $4ca73cea16d9d8cf$export$e0c121325c66ed4c(event);
}
function $4ca73cea16d9d8cf$export$1e561554275607ef(event) {
    $4ca73cea16d9d8cf$export$e0c121325c66ed4c(event);
}
function $4ca73cea16d9d8cf$export$c16a4e16aa4026c0(userIdType, userId) {
    if (!userIdType) throw new Error('Missing userIdType');
    if (!userId) throw new Error('Missing userId');
    if (!(0, $1RuJ0.isType)((0, $1RuJ0.userType), userIdType)) throw new Error(`Invalid userIdType '${userIdType}', ` + `must be an userType: [${(0, $1RuJ0.objectValues)((0, $1RuJ0.userType))}]`);
}
function $4ca73cea16d9d8cf$export$801b46c35394d316(productInfo) {
    if (!(0, $1RuJ0.isType)((0, $1RuJ0.platformType), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + `must be a platformType: [${(0, $1RuJ0.objectValues)((0, $1RuJ0.platformType))}]`);
    if (productInfo.origin === (0, $1RuJ0.originType).DESKTOP && !(0, $1RuJ0.isType)((0, $1RuJ0.desktopPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + 'must be one of [mac, linux, windows]');
    if (productInfo.origin === (0, $1RuJ0.originType).WEB && !(0, $1RuJ0.isType)((0, $1RuJ0.webPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', must be one of [web, mobileWeb]`);
}

});




parcelRegister("1suhT", function(module, exports) {
$parcel$export(module.exports, "StopLowPriorityEventDelayReason", () => $3cfcbc43fe8127d5$export$fa6e3729c21cb8f);
var $3cfcbc43fe8127d5$export$fa6e3729c21cb8f = /*#__PURE__*/ function(StopLowPriorityEventDelayReason) {
    StopLowPriorityEventDelayReason["TIMEOUT"] = "timeout";
    StopLowPriorityEventDelayReason["MANUAL"] = "manual";
    return StopLowPriorityEventDelayReason;
}({});

});


parcelRegister("bJILN", function(module, exports) {
$parcel$export(module.exports, "default", () => $d55d034e34690aa0$export$2e2bcd8739ae039);

var $flK8f = parcelRequire("flK8f");

var $iEfUI = parcelRequire("iEfUI");

var $3ohfK = parcelRequire("3ohfK");

var $iX7Pg = parcelRequire("iX7Pg");

var $dInNc = parcelRequire("dInNc");

var $2DF8j = parcelRequire("2DF8j");

var $cfUir = parcelRequire("cfUir");

var $8NY6g = parcelRequire("8NY6g");

var $6ViEz = parcelRequire("6ViEz");

var $1emO3 = parcelRequire("1emO3");
class $d55d034e34690aa0$var$AnalyticsAPIResponse {
    isSuccess() {
        return this.success;
    }
    getValidationErrors() {
        return this.validationErrors;
    }
    getMessage() {
        return this.message;
    }
    getCode() {
        return this.code;
    }
    getValidationReports() {
        return this.validationReports === undefined ? null : this.validationReports;
    }
    constructor(success, validationErrors, message, code, validationReports){
        this.success = void 0;
        this.validationErrors = void 0;
        this.message = void 0;
        this.code = void 0;
        this.validationReports = void 0;
        this.success = success;
        this.validationErrors = validationErrors;
        this.message = message;
        this.code = code;
        this.validationReports = validationReports;
    }
}
class $d55d034e34690aa0$var$Message {
    constructor(error){
        this.error = void 0;
        this.error = error;
    }
}
class $d55d034e34690aa0$var$EventValidationReport {
    getMessageId() {
        return this.messageId;
    }
    getResults() {
        return this.results;
    }
    constructor(messageId, results){
        this.messageId = void 0;
        this.results = void 0;
        this.messageId = messageId;
        this.results = results;
    }
}
class $d55d034e34690aa0$export$133650fcdde1b226 {
    isSuccess() {
        return this.success;
    }
    getStatusCode() {
        return this.statusCode;
    }
    getMessage() {
        return this.message;
    }
    getEventResponseList() {
        return this.eventResponseList;
    }
    constructor(success, statusCode, message, eventResponseList){
        this.success = void 0;
        this.statusCode = void 0;
        this.message = void 0;
        this.eventResponseList = void 0;
        this.success = success;
        this.statusCode = statusCode;
        this.message = message;
        this.eventResponseList = eventResponseList;
    }
}
class $d55d034e34690aa0$var$EventResponse {
    getMessageId() {
        return this.messageId;
    }
    getResults() {
        return this.results;
    }
    getSegmentEvent() {
        return this.segmentEvent;
    }
    constructor(messageId, results, segmentEvent){
        this.messageId = void 0;
        this.results = void 0;
        this.segmentEvent = void 0;
        this.messageId = messageId;
        this.results = results;
        this.segmentEvent = segmentEvent;
    }
}
class $d55d034e34690aa0$var$EventValidationResult {
    getType() {
        return this.type;
    }
    getSeverity() {
        return this.severity;
    }
    getPropertyPath() {
        return this.propertyPath;
    }
    getMessage() {
        return this.message;
    }
    constructor(type, severity, propertyPath, message){
        this.type = void 0;
        this.severity = void 0;
        this.propertyPath = void 0;
        this.message = void 0;
        this.type = type;
        this.severity = severity;
        this.propertyPath = propertyPath;
        this.message = message;
    }
}
class $d55d034e34690aa0$export$2e2bcd8739ae039 {
    getUser() {
        return this.user;
    }
    async track(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $8NY6g.SegmentEventTypes).TRACK, builtEvent);
        const eventWithoutMessageId = {
            ...baseEvent,
            type: (0, $8NY6g.SegmentEventTypes).TRACK,
            properties: (0, $1emO3.prepareEventProperties)(builtEvent),
            event: eventName
        };
        const event = {
            ...eventWithoutMessageId,
            messageId: this.createMessageId()
        };
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    async page(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $8NY6g.SegmentEventTypes).PAGE, builtEvent);
        const eventWithoutMessageId = {
            ...baseEvent,
            type: (0, $8NY6g.SegmentEventTypes).PAGE,
            properties: (0, $1emO3.prepareEventProperties)(builtEvent),
            name: eventName
        };
        const event = {
            ...eventWithoutMessageId,
            messageId: this.createMessageId()
        };
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    // Segment uses the identifier to update user id which we have already done in the analyticsWebClient.ts
    async identify(_identifier, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $8NY6g.SegmentEventTypes).IDENTIFY, builtEvent);
        const eventWithoutMessageId = {
            ...baseEvent,
            type: (0, $8NY6g.SegmentEventTypes).IDENTIFY,
            traits: (0, $1emO3.prepareEventProperties)(builtEvent)
        };
        const event = {
            ...eventWithoutMessageId,
            messageId: this.createMessageId()
        };
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    async enqueueEvent(packagedEvent) {
        if (this.options.enableMetadataCalls) this.metadataClient.start(false); // Start the metadata client if needed
        await this.resilienceQueue.addItem(packagedEvent);
    }
    buildBaseEvent(context, type, overrides) {
        const clonedContext = (0, $1emO3.prepareEventProperties)(context);
        const segmentContext = (0, $1emO3.buildContext)(clonedContext);
        return {
            context: segmentContext,
            timestamp: new Date().toISOString(),
            type: type,
            userId: this.user.getUserId(),
            anonymousId: overrides.anonymousId || this.user.getAnonymousId()
        };
    }
    createMessageId() {
        return `ajs-${(0, $3ohfK.default)()}`;
    }
    packageEvent(event) {
        const { apiHost: apiHost, apiHostProtocol: apiHostProtocol } = this.options;
        return {
            headers: {
                'Content-Type': 'text/plain'
            },
            msg: event,
            url: `${apiHostProtocol}://${apiHost}/${event.type.charAt(0)}`
        };
    }
    getEventUrl(metadataInfo) {
        const preferredBatchUrl = metadataInfo?.url ? metadataInfo.url : this.gasv3BatchUrl;
        const finalBatchUrl = this.useUrlFromMetadata ? preferredBatchUrl : this.gasv3BatchUrl;
        const isFallbackUrl = preferredBatchUrl === this.gasv3BatchUrl ? null : finalBatchUrl !== preferredBatchUrl;
        return [
            finalBatchUrl,
            isFallbackUrl
        ];
    }
    cleanLibraryMetadata(obj) {
        // skip if the parameter is not an object
        if (obj === null || typeof obj !== 'object') return;
        for(const key in obj){
            // Skip cleaning up props object and its keys
            // to avoid having to check the existence of the fields in props object
            // and manipulate them to calculate metadata signature in analytics service
            if (key === 'props') continue;
            let value = obj[key];
            // Remove null or undefined values
            if (value === null || value === undefined) delete obj[key];
            else if (typeof value === 'number' && value === 0) delete obj[key];
            else if (Array.isArray(value)) {
                if (value.length === 0) delete obj[key];
                else value.forEach((item)=>{
                    this.cleanLibraryMetadata(item);
                });
            } else if (typeof value === 'object') this.cleanLibraryMetadata(obj[key]);
        }
    }
    async invokeLocalResponseCallbackAsync(items, response, error) {
        const localResponseCallback = this.responseCallback;
        if (localResponseCallback) {
            // If we have a response, we'll parse it and create an AnalyticsAPIResponse from it.
            let analyticsAPIResponse = null;
            if (response) {
                let responseObject;
                try {
                    responseObject = await response.clone().json();
                } catch  {
                // Ignore errors parsing the response, we can't do anything about them
                }
                // Ensure we've got a valid object to work with, filling in any missing
                // properties as best we can.
                responseObject = responseObject || {};
                responseObject.code = Number.parseInt(responseObject.code) > 0 ? Number.parseInt(responseObject.code) : response.status;
                responseObject.success = responseObject.success || responseObject.code >= 200 && responseObject.code <= 299;
                analyticsAPIResponse = new $d55d034e34690aa0$var$AnalyticsAPIResponse(responseObject.success, responseObject.validationErrors || new Map(), new $d55d034e34690aa0$var$Message(responseObject.message?.error || ''), responseObject.code, responseObject.validationReports || null);
            }
            // If we have an error, but it's not an instance of Error (e.g. it's a string), we'll convert it to an Error object.
            if (error && !(error instanceof Error)) error = new Error(String(error));
            const analyticsResponse = $d55d034e34690aa0$var$BatchInterceptor.toAnalyticsResponse(items || [], error || null, // In case 'error' were to be undefined we'll convert it to null.
            analyticsAPIResponse);
            localResponseCallback(analyticsResponse);
        }
    }
    async attachXIDs(items) {
        if (this.xidPromiseCallback) return (0, $iX7Pg.attachXidToMultipleEvents)(items, this.xidPromiseCallback);
        return Promise.resolve(items);
    }
    setResponseCallback(responseCallback) {
        this.responseCallback = responseCallback;
    }
    refreshMetadata(userInfo, tenantInfo) {
        this.metadataClient.userInfo = userInfo;
        this.metadataClient.tenantInfo = tenantInfo;
    }
    constructor(options){
        this.user = void 0;
        this.options = void 0;
        this.resilienceQueue = void 0;
        this.gasv3BatchUrl = void 0;
        this.metrics = void 0;
        this.xidPromiseCallback = void 0;
        this.responseCallback = void 0;
        this.metadataClient = void 0;
        this.useUrlFromMetadata = void 0;
        this.lastSendEventsError = void 0;
        this.lastUrlFallbackError = void 0;
        // Using anonymous function so it can have the BatchFlushCallback type associated with it
        // And to allow it to not need bind when passing through to ResilieceQueue.
        this.sendEvents = async (items, callback)=>{
            if (this.options.enableEventCalls === false) return;
            const httpRetryCount = this.resilienceQueue.getGlobalRetryCount();
            const metricsPayload = this.metrics.getMetricsPayload();
            const eventsWithXID = await this.attachXIDs(items);
            // Calculating sentAt after the XID generation as this may take some time.
            const sentAt = new Date().toISOString();
            const metadataInfo = await this.metadataClient.getMetadataAsync();
            const [eventUrl, isFallbackUrl] = this.getEventUrl(metadataInfo);
            const metadata = {
                ...metricsPayload,
                httpRetryCount: httpRetryCount,
                lastSendEventsErrorReason: this.lastSendEventsError?.message || null,
                // Temporary back-compat
                lastSendEventsError: this.lastSendEventsError,
                lastUrlFallbackError: this.lastUrlFallbackError,
                isUsingFallbackUrl: isFallbackUrl,
                props: metadataInfo?.props || null,
                metadataClientMetrics: this.metadataClient?.metrics || null
            };
            // Remove default values from metadata to save space
            this.cleanLibraryMetadata(metadata);
            const unpackagedEvents = eventsWithXID.map((item)=>{
                item.msg.sentAt = sentAt;
                return item.msg;
            });
            const batchBody = {
                batch: unpackagedEvents,
                sentAt: sentAt,
                metadata: metadata
            };
            try {
                const response = await (0, $cfUir.sendEvents)({
                    url: eventUrl,
                    batch: batchBody,
                    timeout: this.options.requestTimeout
                });
                this.lastSendEventsError = null;
                this.lastUrlFallbackError = null;
                this.metrics.subtractFromMetrics(metricsPayload);
                callback(null, response);
                await this.invokeLocalResponseCallbackAsync(items, response, null);
            } catch (error) {
                // If there's an error, other than one which indicates a temporary problem with the service,
                // we'll stop using the URL from the metadata and fall back to the default URL. After a time
                // we'll fall forward again in case the problem has been resolved.
                if (error instanceof (0, $8NY6g.FetchError) && [
                    429,
                    503
                ].includes(error.statusCode)) // Ignore 429 and 503 errors since they're considered to indicate a temporary
                // issue with the service, rather than a network failure due to blocked requests.
                this.lastSendEventsError = new (0, $8NY6g.LastError)('ServerBusyError', error);
                else {
                    const errorName = error instanceof Error && (0, $8NY6g.ALLOW_LISTED_FETCH_ERROR_NAMES).includes(error.name) ? error.name : 'Unknown';
                    this.lastSendEventsError = new (0, $8NY6g.LastError)(errorName, error);
                    // Handle falling back to the default URL if we're using the metadata URL.
                    this.useUrlFromMetadata = false;
                    // If we're now using the fallback URL, and the last attempt wasn't,
                    // we'll record this as the error that triggered the fallback.
                    const [_, willUseFallbackUrl] = this.getEventUrl(metadataInfo);
                    if (willUseFallbackUrl && willUseFallbackUrl !== isFallbackUrl) this.lastUrlFallbackError = this.lastSendEventsError;
                }
                callback(error, null);
                await this.invokeLocalResponseCallbackAsync(items, null, error);
            }
        };
        this.options = {
            ...options,
            requestTimeout: options.requestTimeout || (0, $dInNc.DEFAULT_REQUEST_TIMEOUT),
            retryQueueOptions: options.retryQueueOptions || {},
            logger: options.logger || console,
            disableCookiePersistence: options.disableCookiePersistence || false,
            env: options.env,
            perimeter: options.perimeter || '',
            enableMetadataCalls: typeof options.enableMetadataCalls === 'boolean' ? options.enableMetadataCalls : true,
            enableEventCalls: typeof options.enableEventCalls === 'boolean' ? options.enableEventCalls : true
        };
        this.user = new (0, $6ViEz.default)(this.options?.disableCookiePersistence);
        this.xidPromiseCallback = options.xidPromiseGetter();
        this.gasv3BatchUrl = `${options.apiHostProtocol}://${options.apiHost}/batch`;
        this.metrics = (0, $iEfUI.default)();
        this.responseCallback = options.responseCallback;
        this.resilienceQueue = (0, $flK8f.default)(options.retryQueuePrefix, options.product, this.options.retryQueueOptions, this.options.logger);
        this.metadataClient = options.metadataClient;
        this.useUrlFromMetadata = true;
        this.lastSendEventsError = null;
        this.lastUrlFallbackError = null;
        setInterval(()=>{
            this.useUrlFromMetadata = true;
        }, 600000);
        this.resilienceQueue.start(this.sendEvents);
    }
}
class $d55d034e34690aa0$var$BatchInterceptor {
    static toAnalyticsResponse(items, error, analyticsAPIResponse) {
        const eventResponseList = [];
        if (analyticsAPIResponse !== null) {
            const [statusCode, success] = [
                analyticsAPIResponse.code,
                analyticsAPIResponse.success
            ];
            if (statusCode >= 200 && statusCode <= 299) {
                analyticsAPIResponse.validationReports?.forEach((report)=>{
                    const matchedEvent = items.find((item)=>item.msg.messageId === report.messageId);
                    if (matchedEvent) eventResponseList.push(new $d55d034e34690aa0$var$EventResponse(matchedEvent.msg.messageId, report.results, matchedEvent.msg));
                });
                return new $d55d034e34690aa0$export$133650fcdde1b226(success, statusCode, (0, $2DF8j.HTTP_STATUS_CODE_MAP).get(statusCode), eventResponseList);
            } else if (statusCode >= 400 && statusCode <= 499) {
                // not exluding "HTTP 429 Too Many Requests error" as it is thrown as an error and handled below
                const errorMessage = analyticsAPIResponse.message?.error !== null ? analyticsAPIResponse.message.error : (0, $2DF8j.HTTP_STATUS_CODE_MAP).has(statusCode) ? (0, $2DF8j.HTTP_STATUS_CODE_MAP).get(statusCode) : (0, $2DF8j.HTTP_STATUS_CODE_MAP).get(-1);
                items.forEach((item)=>{
                    eventResponseList.push(new $d55d034e34690aa0$var$EventResponse(item.msg.messageId, [], item.msg));
                });
                return new $d55d034e34690aa0$export$133650fcdde1b226(success, statusCode, errorMessage, eventResponseList);
            }
        } else if (error?.message) {
            const match = error.message.match($d55d034e34690aa0$var$BatchInterceptor.http_error_regex);
            if (match) {
                items.forEach((item)=>{
                    eventResponseList.push(new $d55d034e34690aa0$var$EventResponse(item.msg.messageId, [], item.msg));
                });
                return new $d55d034e34690aa0$export$133650fcdde1b226(false, Number(match[1]), match[2], eventResponseList);
            }
        }
        items.forEach((item)=>{
            eventResponseList.push(new $d55d034e34690aa0$var$EventResponse(item.msg.messageId, [], item.msg));
        });
        return new $d55d034e34690aa0$export$133650fcdde1b226(false, -1, (0, $2DF8j.HTTP_STATUS_CODE_MAP).get(-1), eventResponseList);
    }
}
$d55d034e34690aa0$var$BatchInterceptor.http_error_regex = /HTTP Error\s([0-9]{3})\s\((.+)\)/;

});
parcelRegister("flK8f", function(module, exports) {
$parcel$export(module.exports, "default", () => $513db2abf04bd52f$export$2e2bcd8739ae039);

var $kbQhy = parcelRequire("kbQhy");

var $5ASKr = parcelRequire("5ASKr");
var $513db2abf04bd52f$export$2e2bcd8739ae039 = (retryQueuePrefix, product, options, logger)=>{
    return new (0, $kbQhy.default)(retryQueuePrefix, product, options || {}, logger);
};

});
parcelRegister("kbQhy", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_POLLING_OPTIONS", () => $956dc0db3b2106c9$export$d219df4fe04c04a7);
$parcel$export(module.exports, "default", () => $956dc0db3b2106c9$export$2e2bcd8739ae039);

var $g56hr = parcelRequire("g56hr");
var $edxbW = parcelRequire("edxbW");

var $guFpw = parcelRequire("guFpw");
var $fIUjT = parcelRequire("fIUjT");
var $isASb = parcelRequire("isASb");

var $iEfUI = parcelRequire("iEfUI");

var $9VNiM = parcelRequire("9VNiM");

var $bIxux = parcelRequire("bIxux");
var $56dlt = parcelRequire("56dlt");

var $5ASKr = parcelRequire("5ASKr");
const $956dc0db3b2106c9$var$ONE_MINUTE = 60000;
const $956dc0db3b2106c9$var$LONG_POLLING_OPTIONS = {
    backoffFactor: 0,
    backoffJitterPercentage: 0,
    flushWaitMs: $956dc0db3b2106c9$var$ONE_MINUTE,
    minRetryDelay: $956dc0db3b2106c9$var$ONE_MINUTE,
    maxRetryDelay: $956dc0db3b2106c9$var$ONE_MINUTE
};
const $956dc0db3b2106c9$export$d219df4fe04c04a7 = {
    backoffFactor: 2,
    backoffJitterPercentage: 0.2,
    batchFlushSize: 7,
    flushBeforeUnload: false,
    flushWaitMs: 500,
    maxAttempts: 10,
    // TODO figure out this number. For indexeddb we are sharing the queue with all tabs
    maxItems: 1000,
    maxRetryDelay: 30000,
    minRetryDelay: 1000
};
class $956dc0db3b2106c9$export$2e2bcd8739ae039 {
    start(flushCallback) {
        this.batchFlushCallback = flushCallback;
        this.longPollingScheduler.schedule();
    }
    stop() {
        this.scheduler.stop();
        this.longPollingScheduler.stop();
    }
    async addItem(item) {
        // Since Jira and Confluence use `.toJSON` on objects that should be strings
        // And expect us to use `JSON.stringify` on these objects,
        // And indexeddb strips these functions from the objects when adding them to the DB,
        // We must run this silly stringify and parse before passing the event to the resilience meechanism.
        // Planning on removing this in v4
        const jsonStringifiedAndParsedItem = JSON.parse(JSON.stringify(item));
        const { numberOfEvictedItems: numberOfEvictedItems } = await this.resilience.addItem(jsonStringifiedAndParsedItem, {}, (0, $isASb.GuardPolicy).EVICT);
        this.scheduler.schedule();
        this.metricsCollector.addToEventCount();
        if (numberOfEvictedItems > 0) this.metricsCollector.addToItemsDiscardedByOverflowCounter(numberOfEvictedItems);
    }
    getGlobalRetryCount() {
        return this.scheduler.getFailureCount();
    }
    async scheduleCallback(done) {
        // Even though we stopped the scheduler, it can be restarted with a call to schedule.
        // This could be triggered by a new event or the longPollingScheduler
        if (this.networkStatus.getNetworkStatus() === (0, $5ASKr.NetworkStatusEnum).OFFLINE) {
            done((0, $56dlt.DoneState).NOOP);
            return;
        }
        try {
            const result = await this.resilience.processItems(this.flush.bind(this), this.options.batchFlushSize);
            done(result);
        } catch (error) {
            if (error.name === (0, $guFpw.CallbackProcessingErrorName)) {
                done((0, $56dlt.DoneState).ERROR);
                return;
            }
        // TODO we can probably log here but throwing is useless as it will just be shallowed by the Scheduler
        // In theory something else should catch all other errors from indexeddb and this should never happen.
        } finally{
            await this.checkEventCountAndReschedule();
        }
    }
    async checkEventCountAndReschedule() {
        const eventWaitingCount = await this.resilience.getItemCount();
        if (eventWaitingCount > 0) this.scheduler.schedule({
            immediate: eventWaitingCount >= this.options.batchFlushSize
        });
    }
    async scheduleLongCallBack(done) {
        // Eventually we will want to send data about how many queues were purged
        const numberOfQueuesPurged = (0, $g56hr.default)(this.queuePrefix);
        this.metricsCollector.addToPurgedQueuesMetrics(numberOfQueuesPurged);
        // Eventually we will want to send data about how attempted reclaims and actual reclaims were made
        const reclaimMetrics = await (0, $edxbW.default)(this.queuePrefix, async (localStorageItems)=>{
            const itemsToAdd = localStorageItems.map((localStorageItem)=>({
                    item: localStorageItem.item,
                    retryAttempts: localStorageItem.attemptNumber,
                    id: localStorageItem.id
                }));
            const { items: addedEvents } = await this.resilience.bulkAddItem(itemsToAdd, (0, $isASb.GuardPolicy).IGNORE);
            if (addedEvents.length === itemsToAdd.length) return {
                status: 'successful'
            };
            else return {
                status: 'partial',
                acceptedItemIds: addedEvents.map((event)=>event.id)
            };
        });
        this.metricsCollector.addToReclaimMetrics(reclaimMetrics);
        // We dont want to flush events from here as there maybe issues with analytics-service
        // Scheduler has all the context and can schedule the next batch accordingly
        await this.checkEventCountAndReschedule();
        done((0, $56dlt.DoneState).SUCCESS);
        this.longPollingScheduler.schedule();
    }
    flush(wrappedItems, otherMetadata) {
        this.metricsCollector.setResilienceMechanism(this.resilience.storeType());
        const { batchFlushCallback: batchFlushCallback } = this;
        if (!batchFlushCallback) throw new Error('batchFlushCallback has not been set. Call PullBatchableQueue#start first.');
        return new Promise((resolve, reject)=>{
            if (wrappedItems.length <= 0) {
                resolve((0, $56dlt.DoneState).NOOP);
                return;
            }
            const items = wrappedItems.map((wrappedItem)=>{
                const item = wrappedItem.item;
                if (wrappedItem.retryAttempts > 0 && item.msg) {
                    if (!item.msg._metadata) item.msg._metadata = {};
                    item.msg._metadata.failedAttempts = wrappedItem.retryAttempts;
                }
                return item;
            });
            batchFlushCallback(items, (error)=>{
                if (error) {
                    if (otherMetadata.numberOfDeletedItems > 0) this.metricsCollector.addToItemsDiscardedByRetryCounter(otherMetadata.numberOfDeletedItems);
                    reject(error);
                } else resolve((0, $56dlt.DoneState).SUCCESS);
            });
        });
    }
    buildOptions(options) {
        return {
            backoffFactor: options?.backoffFactor || $956dc0db3b2106c9$export$d219df4fe04c04a7.backoffFactor,
            backoffJitterPercentage: options?.backoffJitterPercentage !== undefined ? options.backoffJitterPercentage : $956dc0db3b2106c9$export$d219df4fe04c04a7.backoffJitterPercentage,
            batchFlushSize: options?.batchFlushSize || $956dc0db3b2106c9$export$d219df4fe04c04a7.batchFlushSize,
            flushBeforeUnload: options?.flushBeforeUnload || $956dc0db3b2106c9$export$d219df4fe04c04a7.flushBeforeUnload,
            flushWaitMs: options?.flushWaitMs || $956dc0db3b2106c9$export$d219df4fe04c04a7.flushWaitMs,
            maxItems: options?.maxItems || $956dc0db3b2106c9$export$d219df4fe04c04a7.maxItems,
            maxAttempts: options?.maxAttempts || $956dc0db3b2106c9$export$d219df4fe04c04a7.maxAttempts,
            maxRetryDelay: options?.maxRetryDelay || $956dc0db3b2106c9$export$d219df4fe04c04a7.maxRetryDelay,
            minRetryDelay: options?.minRetryDelay || $956dc0db3b2106c9$export$d219df4fe04c04a7.minRetryDelay
        };
    }
    constructor(queuePrefix, product, options, logger){
        this.queuePrefix = void 0;
        this.resilience = void 0;
        this.batchFlushCallback = void 0;
        this.options = void 0;
        this.scheduler = void 0;
        this.longPollingScheduler = void 0;
        this.metricsCollector = void 0;
        this.networkStatus = void 0;
        this.queuePrefix = queuePrefix;
        // Avoiding using options in ResilienceDB at this stage as
        // the options are optimised for the PushBatchableQueue
        this.resilience = new (0, $fIUjT.default)(product, {
            logger: logger,
            maxAttempts: options?.maxAttempts,
            maxEventLimit: options?.maxItems
        });
        this.options = this.buildOptions(options);
        this.scheduler = new (0, $bIxux.default)({
            ...this.options,
            waitInterval: options?.flushBeforeUnload ? 0 : this.options.flushWaitMs
        }, this.scheduleCallback.bind(this));
        this.longPollingScheduler = new (0, $bIxux.default)({
            ...$956dc0db3b2106c9$var$LONG_POLLING_OPTIONS,
            waitInterval: $956dc0db3b2106c9$var$LONG_POLLING_OPTIONS.flushWaitMs
        }, this.scheduleLongCallBack.bind(this));
        this.metricsCollector = (0, $iEfUI.default)();
        this.networkStatus = new (0, $9VNiM.default)((status)=>{
            if (status === (0, $5ASKr.NetworkStatusEnum).OFFLINE) this.scheduler.stop();
            else this.checkEventCountAndReschedule();
        });
    }
}

});
parcelRegister("g56hr", function(module, exports) {
$parcel$export(module.exports, "default", () => $5929765d51c05713$export$2e2bcd8739ae039);

var $2AeS9 = parcelRequire("2AeS9");

var $ecdmN = parcelRequire("ecdmN");
// For more details on this funciton, see https://hello.atlassian.net/wiki/spaces/MEASURE/pages/585086028/Investigation+Local+storage+full
// TL;DR
// If a queue looses its `ack` key in localstorage, it will never get claimed.
// There is a small chance that this can happen.
// This function is to run through queues and clean any that have been orphaned.
// Keys stolen from https://github.com/segmentio/localstorage-retry/blob/master/lib/index.js#L55
const $5929765d51c05713$var$validSuffixs = Object.values((0, $2AeS9.LocalStorageKeySuffix));
var $5929765d51c05713$export$2e2bcd8739ae039 = (prefix)=>{
    if (typeof prefix !== 'string' || prefix.length === 0) // We do not want to start deleting everything in localstorage
    return 0;
    try {
        const queueStates = Object.keys(localStorage).filter((key)=>key && key.startsWith(`${prefix}.`) || false).map((key)=>key.split('.')).filter((splitKeys)=>splitKeys.length === 3 && $5929765d51c05713$var$validSuffixs.includes(splitKeys[2])).reduce((accumulator, currentKeys)=>{
            const [, id, suffix] = currentKeys;
            if (accumulator[id] === undefined) accumulator[id] = {};
            accumulator[id][suffix] = true;
            return accumulator;
        }, {});
        const queuesToPurge = Object.keys(queueStates).filter((id)=>queueStates[id][(0, $2AeS9.LocalStorageKeySuffix).ACK] !== true);
        queuesToPurge.forEach((id)=>{
            const { queue: queue, inProgress: inProgress, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = (0, $ecdmN.createLocalStorageKeys)(prefix, id);
            localStorage.removeItem(inProgress);
            localStorage.removeItem(queue);
            localStorage.removeItem(reclaimStart);
            localStorage.removeItem(reclaimEnd);
        });
        return queuesToPurge.length;
    } catch (_error) {
    // Ignore errors from localStorage.
    }
    return 0;
};

});
parcelRegister("2AeS9", function(module, exports) {
$parcel$export(module.exports, "LocalStorageKeySuffix", () => $0c1692354b4b4c2b$export$ecfa71cbc9b28241);
$parcel$export(module.exports, "Timers", () => $0c1692354b4b4c2b$export$8bb2c1fb2b1765a9);
var $0c1692354b4b4c2b$export$ecfa71cbc9b28241 = /*#__PURE__*/ function(LocalStorageKeySuffix) {
    LocalStorageKeySuffix["IN_PROGRESS"] = "inProgress";
    LocalStorageKeySuffix["QUEUE"] = "queue";
    LocalStorageKeySuffix["RECLAIM_START"] = "reclaimStart";
    LocalStorageKeySuffix["RECLAIM_END"] = "reclaimEnd";
    LocalStorageKeySuffix["ACK"] = "ack";
    return LocalStorageKeySuffix;
}({});
var $0c1692354b4b4c2b$export$8bb2c1fb2b1765a9 = /*#__PURE__*/ function(Timers) {
    Timers[Timers["RECLAIM_TIMEOUT"] = 10000] = "RECLAIM_TIMEOUT";
    Timers[Timers["RECLAIM_WAIT"] = 500] = "RECLAIM_WAIT";
    Timers[Timers["RECLAIM_WAIT_THRESHOLD"] = 2000] = "RECLAIM_WAIT_THRESHOLD";
    return Timers;
}({});

});

parcelRegister("ecdmN", function(module, exports) {
$parcel$export(module.exports, "createLocalStorageKeys", () => $ad91c0b324ed872b$export$8433d54f767cbec5);

var $2AeS9 = parcelRequire("2AeS9");
const $ad91c0b324ed872b$export$8433d54f767cbec5 = (queuePrefix, queueId)=>({
        [(0, $2AeS9.LocalStorageKeySuffix).ACK]: `${queuePrefix}.${queueId}.${(0, $2AeS9.LocalStorageKeySuffix).ACK}`,
        [(0, $2AeS9.LocalStorageKeySuffix).QUEUE]: `${queuePrefix}.${queueId}.${(0, $2AeS9.LocalStorageKeySuffix).QUEUE}`,
        [(0, $2AeS9.LocalStorageKeySuffix).IN_PROGRESS]: `${queuePrefix}.${queueId}.${(0, $2AeS9.LocalStorageKeySuffix).IN_PROGRESS}`,
        [(0, $2AeS9.LocalStorageKeySuffix).RECLAIM_START]: `${queuePrefix}.${queueId}.${(0, $2AeS9.LocalStorageKeySuffix).RECLAIM_START}`,
        [(0, $2AeS9.LocalStorageKeySuffix).RECLAIM_END]: `${queuePrefix}.${queueId}.${(0, $2AeS9.LocalStorageKeySuffix).RECLAIM_END}`
    });

});


parcelRegister("edxbW", function(module, exports) {
$parcel$export(module.exports, "default", () => $cbb2a0c5b88c3ded$export$2e2bcd8739ae039);

var $3ohfK = parcelRequire("3ohfK");

var $2AeS9 = parcelRequire("2AeS9");

var $ecdmN = parcelRequire("ecdmN");
const $cbb2a0c5b88c3ded$var$promisedSetTimeout = (msToWait)=>new Promise((resolve)=>{
        setTimeout(resolve, msToWait);
    });
const $cbb2a0c5b88c3ded$var$findOtherQueues = (queuePrefix)=>{
    try {
        return Object.keys(localStorage).filter((key)=>key.startsWith(queuePrefix)).map((key)=>key.split('.')).filter((split)=>{
            if (split.length === 3 && split[0] === queuePrefix && split[2] === (0, $2AeS9.LocalStorageKeySuffix).ACK) try {
                const ackTimestamp = localStorage.getItem(split.join('.'));
                if (ackTimestamp) {
                    const ackTimestampNumber = parseInt(ackTimestamp);
                    return (0, $2AeS9.Timers).RECLAIM_TIMEOUT + ackTimestampNumber < Date.now();
                }
            } catch  {
            // ignore and drop value
            }
            return false;
        }).map((split)=>split[1]);
    } catch  {
    // Ignore errors from accessing localStorage.
    }
    return [];
};
const $cbb2a0c5b88c3ded$var$tryReclaim = async (options, callback)=>{
    const { ack: ack, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = options.storageKeys;
    const start = Date.now();
    localStorage.setItem(reclaimStart, options.reclaimProcessId);
    localStorage.setItem(ack, start.toString());
    await $cbb2a0c5b88c3ded$var$promisedSetTimeout((0, $2AeS9.Timers).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $2AeS9.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId) throw new Error('Took to long to callback, reclaim abandonded. After reclaimStart.');
    localStorage.setItem(reclaimEnd, options.reclaimProcessId);
    await $cbb2a0c5b88c3ded$var$promisedSetTimeout((0, $2AeS9.Timers).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $2AeS9.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId || localStorage.getItem(reclaimEnd) !== options.reclaimProcessId) throw new Error('Took to long to callback, reclaim abandonded. After reclaimEnd.');
    return $cbb2a0c5b88c3ded$var$reclaim(options, callback);
};
const $cbb2a0c5b88c3ded$var$reclaim = async (options, callback)=>{
    const { queue: queue, inProgress: inProgress } = options.storageKeys;
    // Queue is an array of events while inProgress is an object with a uuid for key
    // Either of these queues may legitimately be missing.
    const eventsInQueue = JSON.parse(localStorage.getItem(queue) || '[]');
    const eventsInProgress = JSON.parse(localStorage.getItem(inProgress) || '{}');
    const arrayOfEventsInProgress = Object.entries(eventsInProgress).map(([key, item])=>{
        const itemWithId = {
            ...item,
            // LocalStorage-retry would add the attemptCounter after failure, rather than
            // as it was being processed
            attemptNumber: item.attemptNumber + 1,
            id: key
        };
        return itemWithId;
    });
    const eventsToProcess = [
        ...eventsInQueue,
        ...arrayOfEventsInProgress
    ];
    if (eventsToProcess.length > 0) {
        const result = await callback(eventsToProcess);
        if (result.status === 'successful') $cbb2a0c5b88c3ded$var$clearLocalStorageKeys(options.storageKeys);
        else if (result.status === 'partial') {
            // Dont delete all events if we are only able to take some of them.
            const leftover = eventsToProcess.filter((event)=>!result.acceptedItemIds.includes(event.id));
            // This way around, we can almost ensure that we wont hit memory quota exceeded errors.
            // However, there is a very small chance that we may lose events if the process exits between these two commands.
            localStorage.removeItem(inProgress);
            localStorage.setItem(queue, JSON.stringify(leftover));
            return {
                fullReclaim: false
            };
        }
    } else $cbb2a0c5b88c3ded$var$clearLocalStorageKeys(options.storageKeys);
    return {
        fullReclaim: true
    };
};
// Exterminate
const $cbb2a0c5b88c3ded$var$clearLocalStorageKeys = (keys)=>{
    // Always good to do queue and inprogress first to reduce duplications
    // and to free up more space in localstorage
    localStorage.removeItem(keys.queue);
    localStorage.removeItem(keys.inProgress);
    localStorage.removeItem(keys.reclaimEnd);
    localStorage.removeItem(keys.reclaimStart);
    // This has to be last or we risk leaving things in localStorage that have to be purged
    localStorage.removeItem(keys.ack);
};
var $cbb2a0c5b88c3ded$export$2e2bcd8739ae039 = async (queuePrefix, callback)=>{
    if (typeof queuePrefix !== 'string' || queuePrefix.length === 0) // We do not want to start deleting everything in localstorage
    return {
        fullReclaims: 0,
        partialReclaims: 0,
        failedReclaims: 0
    };
    const reclaimProcessId = (0, $3ohfK.default)();
    const queuesToReclaim = $cbb2a0c5b88c3ded$var$findOtherQueues(queuePrefix);
    const claims = queuesToReclaim.map((id)=>$cbb2a0c5b88c3ded$var$tryReclaim({
            queuePrefix: queuePrefix,
            reclaimProcessId: reclaimProcessId,
            storageKeys: (0, $ecdmN.createLocalStorageKeys)(queuePrefix, id)
        }, callback));
    const settledClaims = await Promise.allSettled(claims);
    const failedReclaims = settledClaims.filter((claim)=>claim.status === 'rejected');
    const successfulClaims = settledClaims.filter((settledValue)=>settledValue.status === 'fulfilled').map((result)=>result.value);
    const fullReclaims = successfulClaims.filter((claim)=>claim.fullReclaim);
    const partialReclaims = successfulClaims.filter((claim)=>!claim.fullReclaim);
    return {
        failedReclaims: failedReclaims.length,
        partialReclaims: partialReclaims.length,
        fullReclaims: fullReclaims.length
    };
};

});
parcelRegister("3ohfK", function(module, exports) {
$parcel$export(module.exports, "default", () => $1cdeea81e79f4909$export$2e2bcd8739ae039);
// UUID v4 generator with fallback for non-secure contexts
function $1cdeea81e79f4909$export$2e2bcd8739ae039() {
    const g = globalThis;
    try {
        if (g.crypto && typeof g.crypto.randomUUID === 'function') return g.crypto.randomUUID();
    } catch  {
    // ignore and fallback
    }
    // Fallback to Math.random-based v4 UUID
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = Math.floor(Math.random() * 16);
        const v = c === 'x' ? r : r & 0x3 | 0x8; // x => random hex digit; y => set RFC 4122 variant bits (10xx), yielding 8, 9, a, or b
        return v.toString(16);
    });
}

});


parcelRegister("guFpw", function(module, exports) {
$parcel$export(module.exports, "CallbackProcessingErrorName", () => $c242159478f1c3df$export$a409c8de90e11e14);
$parcel$export(module.exports, "default", () => $c242159478f1c3df$export$2e2bcd8739ae039);
const $c242159478f1c3df$export$a409c8de90e11e14 = 'CallbackProcessingError';
class $c242159478f1c3df$export$2e2bcd8739ae039 extends Error {
    constructor(error){
        const messageFromError = error && typeof error === 'object' && 'toString' in error && typeof error.toString === 'function' && error.toString();
        const messageFromString = typeof error === 'string' && error;
        const message = messageFromError || messageFromString || 'Argument passed to CallbackProcessingError was not an Error or string.';
        super(`Error thrown while processing events in callback: ${message}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $c242159478f1c3df$export$2e2bcd8739ae039.prototype);
        this.name = $c242159478f1c3df$export$a409c8de90e11e14;
    }
}

});

parcelRegister("fIUjT", function(module, exports) {
$parcel$export(module.exports, "default", () => $4fc47f93632b4884$export$2e2bcd8739ae039);

var $cDodz = parcelRequire("cDodz");

var $isASb = parcelRequire("isASb");

var $guFpw = parcelRequire("guFpw");
var $4fc47f93632b4884$export$2e2bcd8739ae039 = (0, $cDodz.default);

});
parcelRegister("cDodz", function(module, exports) {
$parcel$export(module.exports, "default", () => $fb8e8e1fcaa5bd66$export$2e2bcd8739ae039);

var $isASb = parcelRequire("isASb");

var $5WrcS = parcelRequire("5WrcS");
var $1AUPJ = parcelRequire("1AUPJ");

var $6LFg1 = parcelRequire("6LFg1");

var $2yCnd = parcelRequire("2yCnd");

var $ckffc = parcelRequire("ckffc");
class $fb8e8e1fcaa5bd66$export$2e2bcd8739ae039 {
    getResilienceMechanism(namespace, options) {
        if (!options.useMemory) try {
            return new (0, $6LFg1.default)(namespace, options);
        } catch (error) {
            if (!(error instanceof (0, $5WrcS.default))) options.logger?.warn('Attempted to create IndexedDbResilience but failed. Using memory instead.');
        }
        return new (0, $2yCnd.default)(this.namespace, options);
    }
    addItem(item, options, policy = (0, $isASb.GuardPolicy).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.addItem(item, options, policy));
    }
    bulkAddItem(itemOptions, policy = (0, $isASb.GuardPolicy).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.bulkAddItem(itemOptions, policy));
    }
    getItems(count) {
        return this.runOrFailOver(()=>this.resilience.getItems(count));
    }
    deleteItems(itemIds) {
        return this.runOrFailOver(()=>this.resilience.deleteItems(itemIds));
    }
    getItemCount() {
        return this.runOrFailOver(()=>this.resilience.getItemCount());
    }
    processItems(processFn, count) {
        return this.runOrFailOver(()=>this.resilience.processItems(processFn, count));
    }
    storeType() {
        return this.resilience.storeType();
    }
    async runOrFailOver(runnable) {
        try {
            return await runnable();
        } catch (error) {
            if ((0, $1AUPJ.shouldIgnoreResilienceDbError)(error)) throw error;
            else if (this.resilience.storeType() === (0, $isASb.StoreType).INDEXEDDB) await this.failOver();
            return runnable();
        }
    }
    async failOver() {
        // Attempt to get any events we can and put them into memory
        const oldResilience = this.resilience;
        const newResilience = new (0, $2yCnd.default)(this.namespace, this.options);
        this.resilience = newResilience;
        try {
            const { items: items } = await oldResilience.getItems(this.options.maxEventLimit);
            if (items.length > 0) {
                const bulkAddItemsResponse = await newResilience.bulkAddItemWrapperType(items, (0, $isASb.GuardPolicy).IGNORE);
                const addedItemIds = bulkAddItemsResponse.items.map((item)=>item.id);
                await oldResilience.deleteItems(addedItemIds);
            }
        } catch (error) {
            this.options.logger.warn('Unexpected error from ResilienceDb, switching to MemoryDb');
        // Dont need to catch. We are just getting events if we can
        }
    }
    constructor(namespace, options = {}){
        this.resilience = void 0;
        this.options = void 0;
        this.namespace = void 0;
        this.namespace = namespace;
        this.options = (0, $ckffc.createOptionsWithDefaults)(options);
        if (!namespace || namespace.length === 0 || typeof namespace !== 'string') throw new Error('Invalid namespace provided');
        this.resilience = this.getResilienceMechanism(namespace, options);
    }
}

});
parcelRegister("isASb", function(module, exports) {
$parcel$export(module.exports, "NAMESPACE_AND_TIME_ADDED_INDEX", () => $c7a572e98d3af34e$export$d21fbb25eb37b5bf);
$parcel$export(module.exports, "RESILIENCE_DB_NAME", () => $c7a572e98d3af34e$export$8cad224051643259);
$parcel$export(module.exports, "RESILIENCE_STORE_NAME", () => $c7a572e98d3af34e$export$3d8420be07b276ab);
$parcel$export(module.exports, "TIME_TO_PROCESS_AFTER_INDEX", () => $c7a572e98d3af34e$export$a512a65455fce2a6);
$parcel$export(module.exports, "TIME_ADDED_INDEX", () => $c7a572e98d3af34e$export$89d9c1ff8ac91862);
$parcel$export(module.exports, "RETRY_INDEX", () => $c7a572e98d3af34e$export$a37d385bcd713809);
$parcel$export(module.exports, "INDEXEDDB_TIMEOUT", () => $c7a572e98d3af34e$export$6d8635fed0e4b14d);
$parcel$export(module.exports, "StoreType", () => $c7a572e98d3af34e$export$39337ab5872e9457);
$parcel$export(module.exports, "GuardPolicy", () => $c7a572e98d3af34e$export$7710d69e6f450f20);
const $c7a572e98d3af34e$export$d21fbb25eb37b5bf = 'namespace-timeAdded';
const $c7a572e98d3af34e$export$8cad224051643259 = 'analytics-web-client';
const $c7a572e98d3af34e$export$3d8420be07b276ab = 'analytics-resilience';
const $c7a572e98d3af34e$export$a512a65455fce2a6 = 'timeToBeProcessedAfter';
const $c7a572e98d3af34e$export$89d9c1ff8ac91862 = 'timeAdded';
const $c7a572e98d3af34e$export$a37d385bcd713809 = 'retryAttempts';
const $c7a572e98d3af34e$export$6d8635fed0e4b14d = 15000;
var $c7a572e98d3af34e$export$39337ab5872e9457 = /*#__PURE__*/ function(StoreType) {
    StoreType["INDEXEDDB"] = "indexeddb";
    StoreType["MEMORY"] = "memory";
    return StoreType;
}({});
var $c7a572e98d3af34e$export$7710d69e6f450f20 = /*#__PURE__*/ function(GuardPolicy) {
    // Adds as many items as possible and IGONRES the rest.
    // Only to be used with BulkAdd
    GuardPolicy["IGNORE"] = "ignore";
    // ABANDON the request if not all items can be added.
    GuardPolicy["ABANDON"] = "abandon";
    // EVICT old items to make room for new items if space is tight.
    GuardPolicy["EVICT"] = "evict";
    return GuardPolicy;
}({});

});

parcelRegister("5WrcS", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad2157df62662bf3$export$2e2bcd8739ae039);
const $ad2157df62662bf3$export$fc14cf6dcea0f8ed = 'NoIndexedDbError';
class $ad2157df62662bf3$export$2e2bcd8739ae039 extends Error {
    constructor(){
        super('window.indexeddb is undefined.');
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $ad2157df62662bf3$export$2e2bcd8739ae039.prototype);
        this.name = $ad2157df62662bf3$export$fc14cf6dcea0f8ed;
    }
}

});

parcelRegister("1AUPJ", function(module, exports) {
$parcel$export(module.exports, "shouldIgnoreResilienceDbError", () => $e1e036222551cae9$export$74101021e0969375);

var $e20oq = parcelRequire("e20oq");

var $guFpw = parcelRequire("guFpw");

var $6rezO = parcelRequire("6rezO");
const $e1e036222551cae9$export$74101021e0969375 = (error)=>{
    if (error && typeof error === 'object' && 'name' in error) {
        const errorWithName = error;
        return typeof errorWithName.name === 'string' && (errorWithName.name === (0, $e20oq.AbandonWriteErrorName) || errorWithName.name === (0, $guFpw.CallbackProcessingErrorName) || errorWithName.name === (0, $6rezO.InvalidPolicyErrorName));
    }
    return false;
};

});
parcelRegister("e20oq", function(module, exports) {
$parcel$export(module.exports, "AbandonWriteErrorName", () => $8375e38b5437675c$export$ba95206613c96b28);
$parcel$export(module.exports, "default", () => $8375e38b5437675c$export$2e2bcd8739ae039);
const $8375e38b5437675c$export$ba95206613c96b28 = 'AbandonWriteError';
class $8375e38b5437675c$export$2e2bcd8739ae039 extends Error {
    constructor(source){
        super(`Event Limit reached. Abandoning write to: ${source}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $8375e38b5437675c$export$2e2bcd8739ae039.prototype);
        this.name = $8375e38b5437675c$export$ba95206613c96b28;
    }
}

});

parcelRegister("6rezO", function(module, exports) {
$parcel$export(module.exports, "InvalidPolicyErrorName", () => $a657a4d6d4998339$export$7e7aee9a953465ec);
$parcel$export(module.exports, "default", () => $a657a4d6d4998339$export$2e2bcd8739ae039);
const $a657a4d6d4998339$export$7e7aee9a953465ec = 'InvalidPolicyError';
class $a657a4d6d4998339$export$2e2bcd8739ae039 extends Error {
    constructor(policy, method){
        super(`Method '${method}' cannot be called with policy '${policy}'.`);
        this.name = $a657a4d6d4998339$export$7e7aee9a953465ec;
    }
}

});


parcelRegister("6LFg1", function(module, exports) {
$parcel$export(module.exports, "default", () => $eb4fd55bc195cd4c$export$2e2bcd8739ae039);

var $isASb = parcelRequire("isASb");

var $fmspQ = parcelRequire("fmspQ");

var $guFpw = parcelRequire("guFpw");
var $6rezO = parcelRequire("6rezO");
var $5WrcS = parcelRequire("5WrcS");
var $1AUPJ = parcelRequire("1AUPJ");

var $aLERp = parcelRequire("aLERp");

var $ckffc = parcelRequire("ckffc");
class $eb4fd55bc195cd4c$export$2e2bcd8739ae039 {
    storeType() {
        return (0, $isASb.StoreType).INDEXEDDB;
    }
    constructor(_namespace, _options = {}){
        this.db = void 0;
        this.logger = void 0;
        this.globalEventLimitGuard = void 0;
        this.options = void 0;
        this.namespace = void 0;
        this.startDB = async ()=>{
            return new Promise(async (resolve, reject)=>{
                if (typeof window !== 'undefined') {
                    const dbTimeout = window.setTimeout(()=>{
                        this.logger.warn('IndexedDB timed out.');
                        reject(new (0, $5WrcS.default)());
                    }, (0, $isASb.INDEXEDDB_TIMEOUT));
                    /*
           * The database version number can never change.
           * An upgrade transaction is limited to only one connection to the database.
           * Once this is done, we cannot open any connections with older versions of the schema.
           * https://www.w3.org/TR/IndexedDB/#upgrade-transaction-construct
           *
           * Due to the nature of how AWC is used (multiple tabs that are very long lived),
           * we will not be able to run version upgrades via indexeddb.
           *
           * This does not mean we cant change what is stored in the tables,
           * this limitation just prevents us from:
           *   - Creating new ObjectStores in this database connection, and
           *   - Creating new indexes on our ObjectStores
           *
           * Any upgrades we wish to run in the future will have to create a new database,
           * and migrate all the data from older databases.
           *
           * This also means any migrations we make will have to be supported until we have evidence
           * that no events are coming from old versions of the database.
           * This may take a long time.
           */ const request = window.indexedDB.open((0, $isASb.RESILIENCE_DB_NAME), 1);
                    request.onupgradeneeded = (event)=>{
                        if (event.oldVersion !== 0) throw new Error('We cannot upgrade the database. Do not do this.');
                        const db = request.result;
                        const store = db.createObjectStore((0, $isASb.RESILIENCE_STORE_NAME), {
                            keyPath: 'id'
                        });
                        store.createIndex((0, $isASb.TIME_TO_PROCESS_AFTER_INDEX), (0, $isASb.TIME_TO_PROCESS_AFTER_INDEX), {
                            unique: false
                        });
                        store.createIndex((0, $isASb.RETRY_INDEX), (0, $isASb.RETRY_INDEX), {
                            unique: false
                        });
                        store.createIndex((0, $isASb.TIME_ADDED_INDEX), (0, $isASb.TIME_ADDED_INDEX), {
                            unique: false
                        });
                        // Compound key index of product - timeAdded.
                        store.createIndex((0, $isASb.NAMESPACE_AND_TIME_ADDED_INDEX), [
                            'namespace',
                            'timeAdded'
                        ], {
                            unique: false
                        });
                    };
                    request.onerror = function() {
                        reject(new (0, $5WrcS.default)());
                    };
                    try {
                        await (0, $ckffc.requestToPromise)(request);
                        return resolve(request.result);
                    } catch (error) {
                        this.logger.warn('IndexedDB failed to initialise.', error);
                        reject(new (0, $5WrcS.default)());
                    } finally{
                        window.clearTimeout(dbTimeout);
                    }
                } else {
                    this.logger.warn("IndexedDB failed to initialise. No 'window' object.");
                    reject(new (0, $5WrcS.default)());
                }
            });
        };
        this.addItem = async (item, options = {}, policy = (0, $isASb.GuardPolicy).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const value = (0, $ckffc.convertToItemWrapper)(item, namespace, options);
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            if (policy === (0, $isASb.GuardPolicy).IGNORE) throw new (0, $6rezO.default)(policy, 'IndexedDbConnector#addItem');
            try {
                if (!value.namespace || value.namespace.length === 0 || typeof value.namespace !== 'string') throw new Error('Namespace not specified');
                // Making space for 1 event, if required.
                const bulkAddResult = await this.globalEventLimitGuard.insertItems(objectStore, [
                    value
                ], policy);
                if (bulkAddResult.items.length === 1) return {
                    item: bulkAddResult.items[0],
                    numberOfEvictedItems: bulkAddResult.numberOfEvictedItems
                };
                // Should never happen as the Policy and EventCountGuard should cause another pathway
                throw new Error(`Incorrect number of items added. Expected: 1, got: ${bulkAddResult.items.length}`);
            } catch (error) {
                if ((0, $1AUPJ.shouldIgnoreResilienceDbError)(error)) throw error;
                logger.log('Failed to add item to table', error);
                throw new Error('Request to add item to table failed');
            }
        };
        this.bulkAddItem = async (itemOptions, policy = (0, $isASb.GuardPolicy).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const items = itemOptions.map(({ item: item, ...options })=>(0, $ckffc.convertToItemWrapper)(item, namespace, options));
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            try {
                return await this.globalEventLimitGuard.insertItems(objectStore, items, policy);
            } catch (error) {
                if ((0, $1AUPJ.shouldIgnoreResilienceDbError)(error)) throw error;
                logger.log('Failed to add item to table', error);
                throw new Error('Request to add item to table failed');
            }
        };
        this.getItems = async (count = (0, $fmspQ.GET_ITEM_COUNT))=>{
            const fixedCount = count > 0 ? count : (0, $fmspQ.GET_ITEM_COUNT);
            const { logger: logger } = this;
            const maxAttempts = this.options.maxAttempts;
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            const timeIndex = objectStore.index((0, $isASb.TIME_TO_PROCESS_AFTER_INDEX));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.openCursor(upperBoundOpenKeyRange);
            const getResult = await new Promise(async (resolve, reject)=>{
                const items = [];
                let numberOfDeletedItems = 0;
                request.onerror = (error)=>{
                    logger.error('Failed to open cursor:', error);
                    reject('Failed to open cursor');
                };
                // Requests for Cursors call onsuccess multiple times and cannot be converted to promises
                request.onsuccess = (event)=>{
                    const cursor = event.target.result;
                    if (cursor) {
                        // Prevent mutation of the value we are returning
                        const value = {
                            ...cursor.value
                        };
                        items.push(value);
                        // Mutations seem to be required for testing indexeddb library
                        const updatedValue = cursor.value;
                        updatedValue.retryAttempts += 1;
                        updatedValue.timeToBeProcessedAfter = Date.now() + (0, $fmspQ.VISIBILITY_TIMEOUT);
                        if (updatedValue.retryAttempts >= maxAttempts) {
                            ++numberOfDeletedItems;
                            const request = cursor.delete();
                            (0, $ckffc.monitorErrorsOnRequest)(request, logger);
                        } else {
                            const request = cursor.update(updatedValue);
                            (0, $ckffc.monitorErrorsOnRequest)(request, logger);
                        }
                        if (items.length < fixedCount) cursor.continue();
                        else resolve({
                            items: items,
                            numberOfDeletedItems: numberOfDeletedItems
                        });
                    } else resolve({
                        items: items,
                        numberOfDeletedItems: numberOfDeletedItems
                    });
                };
            });
            await (0, $ckffc.commitTransaction)(transaction, this.logger);
            return getResult;
        };
        this.deleteItems = async (itemIds)=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            try {
                const deletePromises = itemIds.map((id)=>this.deleteItem(objectStore, id));
                await (0, $ckffc.commitTransaction)(transaction, this.logger);
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn('Failed to delete items from indexeddb.', error);
                throw error;
            }
        };
        this.getItemCount = async ()=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readonly');
            const timeIndex = objectStore.index((0, $isASb.TIME_TO_PROCESS_AFTER_INDEX));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.count(upperBoundOpenKeyRange);
            const event = await (0, $ckffc.requestToPromise)(request);
            await (0, $ckffc.commitTransaction)(transaction, this.logger);
            return event.target.result;
        };
        this.processItems = async (processFn, count = (0, $fmspQ.GET_ITEM_COUNT))=>{
            const { items: items, ...partialResult } = await this.getItems(count);
            try {
                const result = await processFn(items, partialResult);
                const itemIds = items.map((item)=>item.id);
                // We should not await this delete as a rejected promise would get caught by the catch statement
                await this.deleteItems(itemIds);
                return result;
            } catch (error) {
                // Eventually we will need a intermediate class to catch all errors but we should ignore this error
                // This allows libraries beneath to distinguish between a success or failure in processing to update schedulers or anything else
                // To provide back off or any other mechanism to allow what ever is cauing the errors to recover
                throw new (0, $guFpw.default)(error);
            }
        };
        this.deleteItem = async (objectStore, id)=>{
            const { logger: logger } = this;
            try {
                await (0, $ckffc.requestToPromise)(objectStore.delete(id));
            } catch (error) {
                logger.error('Failed to delete item:', id, error);
                throw error;
            }
        };
        this.getObjectStoreAndTransaction = async (mode)=>{
            const transaction = (await this.db).transaction((0, $isASb.RESILIENCE_STORE_NAME), mode);
            const objectStore = transaction.objectStore((0, $isASb.RESILIENCE_STORE_NAME));
            return {
                transaction: transaction,
                objectStore: objectStore
            };
        };
        this.options = (0, $ckffc.createOptionsWithDefaults)(_options);
        this.namespace = _namespace;
        this.logger = this.options.logger;
        if (!window.indexedDB) throw new (0, $5WrcS.default)();
        this.db = this.startDB();
        // We just swallow any errors as we know that these are intermittent errors
        // when switching from indexeddb -> localStorage
        this.db.catch(()=>{});
        /**
     *
     * This class will enforce the number of analytics events we can store in our IndexedDB object store
     * if asked before adding items to the object store.
     */ this.globalEventLimitGuard = new (0, $aLERp.default)(this.options.maxEventLimit, this.namespace, this.logger, this.deleteItem);
    }
}

});
parcelRegister("fmspQ", function(module, exports) {
$parcel$export(module.exports, "GET_ITEM_COUNT", () => $b3f089abc3d7b3d4$export$b6df3d334cec060f);
$parcel$export(module.exports, "VISIBILITY_TIMEOUT", () => $b3f089abc3d7b3d4$export$14ef152a03a4b6ee);
$parcel$export(module.exports, "MAX_ATTEMPTS", () => $b3f089abc3d7b3d4$export$da9ab7b2fd5998e8);
$parcel$export(module.exports, "EVENT_COUNT_LIMIT", () => $b3f089abc3d7b3d4$export$1188664dfff364c8);
const $b3f089abc3d7b3d4$export$b6df3d334cec060f = 7;
const $b3f089abc3d7b3d4$export$14ef152a03a4b6ee = 60000;
const $b3f089abc3d7b3d4$export$da9ab7b2fd5998e8 = 10;
const $b3f089abc3d7b3d4$export$1188664dfff364c8 = 5000;

});

parcelRegister("aLERp", function(module, exports) {
$parcel$export(module.exports, "default", () => $296db2a2f2e1842a$export$2e2bcd8739ae039);

var $isASb = parcelRequire("isASb");

var $e20oq = parcelRequire("e20oq");

var $ckffc = parcelRequire("ckffc");
class $296db2a2f2e1842a$export$2e2bcd8739ae039 {
    /**
   * This function checks the number of events currently in AWC IndexedDB object store and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * The indexed is treated as effectively: partitioned by product and sorted by timeAdded.
   *
   * This function can be re-used when the bulk add functionality is added in IndexedDbConnector.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ async insertItems(objectStore, items, policy = (0, $isASb.GuardPolicy).ABANDON) {
        const itemsToAdd = [
            ...items
        ];
        let numberOfEvictedItems = 0;
        switch(policy){
            case (0, $isASb.GuardPolicy).ABANDON:
                await this.throwIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $isASb.GuardPolicy).EVICT:
                numberOfEvictedItems = await this.evictIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $isASb.GuardPolicy).IGNORE:
                // Removed items from `itemsToAdd` if there is insufficient space
                await this.calculateHowManyEventsWeCanAdd(objectStore, itemsToAdd);
                break;
        }
        const promises = itemsToAdd.map((item)=>(0, $ckffc.requestToPromise)(objectStore.add(item)));
        await Promise.all(promises);
        await (0, $ckffc.commitTransaction)(objectStore.transaction, this.logger);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async throwIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) throw new (0, $e20oq.default)(`Not enough space in IndexedDb. Needed ${requiredSpace} but only had ${freeSpace}`);
    }
    async evictIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) {
            const extraSpace = requiredSpace - freeSpace;
            await this.deleteOldestNEvents(objectStore, extraSpace);
            return extraSpace;
        }
        return 0;
    }
    async calculateHowManyEventsWeCanAdd(objectStore, items) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < items.length) {
            const numberOfItemsToRemove = items.length - freeSpace;
            const start = items.length - numberOfItemsToRemove;
            items.splice(start, numberOfItemsToRemove);
        }
    }
    async calculateFreeSpace(objectStore) {
        const numberOfEventsInDb = await this.getCountofEventsInObjectStore(objectStore);
        return this.eventLimit - numberOfEventsInDb;
    }
    /**
   * This query returns the count of items held in AWC IndexedDB object store per product.
   */ async getCountofEventsInObjectStore(objectStore) {
        const productTimeAddedIndex = objectStore.index((0, $isASb.NAMESPACE_AND_TIME_ADDED_INDEX));
        const keyRangeValues = IDBKeyRange.bound([
            this.namespace,
            0
        ], [
            this.namespace,
            Date.now()
        ]);
        const request = productTimeAddedIndex.count(keyRangeValues);
        const event = await (0, $ckffc.requestToPromise)(request);
        return event.target.result;
    }
    constructor(eventLimit, namespace, logger, deleteItemHandler){
        this.eventLimit = void 0;
        this.namespace = void 0;
        this.logger = void 0;
        this.deleteItemHandler = void 0;
        /**
     * This query fetches the oldest events currently stored in AWC IndexedDb object store
     * and deletes them sequentially
     */ this.deleteOldestNEvents = async (objectStore, count)=>{
            const productTimeAddedIndex = objectStore.index((0, $isASb.NAMESPACE_AND_TIME_ADDED_INDEX));
            const keyRangeValues = IDBKeyRange.bound([
                this.namespace,
                0
            ], [
                this.namespace,
                Date.now()
            ]);
            const getAllRequest = productTimeAddedIndex.getAllKeys(keyRangeValues, count);
            const event = await (0, $ckffc.requestToPromise)(getAllRequest);
            const result = event?.target?.result;
            // Adding extra safety
            if (result && Array.isArray(result) && result.length > 0) try {
                const deletePromises = result.map((item)=>this.deleteItemHandler(objectStore, item));
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn('Failed to delete items from indexeddb.', error);
                throw error;
            }
        };
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error('Event Limit has to be set higher than 1');
        this.namespace = namespace;
        this.logger = logger;
        this.deleteItemHandler = deleteItemHandler;
    }
}

});
parcelRegister("ckffc", function(module, exports) {
$parcel$export(module.exports, "convertToItemWrapper", () => $bf85261cfce5dd09$export$aec476f33d77be11);
$parcel$export(module.exports, "createOptionsWithDefaults", () => $bf85261cfce5dd09$export$ddc6718318090f71);
$parcel$export(module.exports, "requestToPromise", () => $bf85261cfce5dd09$export$85ceed0783e42041);
$parcel$export(module.exports, "commitTransaction", () => $bf85261cfce5dd09$export$feab8418f018df89);
$parcel$export(module.exports, "monitorErrorsOnRequest", () => $bf85261cfce5dd09$export$342d941b6f724995);

var $3ohfK = parcelRequire("3ohfK");

var $fmspQ = parcelRequire("fmspQ");
const $bf85261cfce5dd09$export$aec476f33d77be11 = (item, namespace, { id: id, retryAttempts: retryAttempts, timeToProcessOffset: timeToProcessOffset })=>({
        item: item,
        id: id || (0, $3ohfK.default)(),
        retryAttempts: retryAttempts || 0,
        timeToBeProcessedAfter: Date.now() + (timeToProcessOffset || 0),
        namespace: namespace,
        timeAdded: Date.now()
    });
const $bf85261cfce5dd09$export$ddc6718318090f71 = (options)=>({
        logger: options.logger || console,
        useMemory: options.useMemory || false,
        maxAttempts: options.maxAttempts || (0, $fmspQ.MAX_ATTEMPTS),
        // This is so that we can customise `maxEventLimit`, primarily for testing.
        maxEventLimit: options.maxEventLimit || (0, $fmspQ.EVENT_COUNT_LIMIT)
    });
const $bf85261cfce5dd09$export$85ceed0783e42041 = (request)=>{
    return new Promise((resolve, reject)=>{
        request.onsuccess = (event)=>{
            resolve(event);
        };
        request.onerror = (event)=>{
            reject(event);
        };
    });
};
const $bf85261cfce5dd09$export$2a5213bce1720b42 = (transaction)=>{
    return new Promise((resolve, reject)=>{
        // We will have to see how much cost there is to waiting for the transaction to complete in the real world.
        // In theory in some cases we could return as soon as the request is complete and
        // just monitor errors on transactions with the logger.
        // This maybe more of an issue in Safari and other older browsers where commit isnt available
        // and we would have to wait for the transaction to complete itself.
        transaction.oncomplete = ()=>{
            resolve();
        };
        transaction.onerror = (event)=>{
            reject(event);
        };
        transaction.onabort = (event)=>{
            reject(event);
        };
    });
};
const $bf85261cfce5dd09$export$feab8418f018df89 = (transaction, logger)=>{
    try {
        if (typeof transaction.commit === 'function') transaction.commit();
    } catch (error) {
        logger.error('Failed to force commit transaction:', error);
        throw error;
    }
    return $bf85261cfce5dd09$export$2a5213bce1720b42(transaction);
};
const $bf85261cfce5dd09$export$342d941b6f724995 = (request, logger)=>{
    request.onerror = (event)=>{
        logger.warn('Error thrown from request:', event);
    };
};

});



parcelRegister("2yCnd", function(module, exports) {
$parcel$export(module.exports, "default", () => $3c6f0528c5139f0c$export$2e2bcd8739ae039);

var $isASb = parcelRequire("isASb");

var $fmspQ = parcelRequire("fmspQ");

var $guFpw = parcelRequire("guFpw");
var $6rezO = parcelRequire("6rezO");

var $6Ee6o = parcelRequire("6Ee6o");

var $ckffc = parcelRequire("ckffc");
class $3c6f0528c5139f0c$export$2e2bcd8739ae039 {
    /**
   * This method is used mainly to write new events to MemoryDB and uses the MEMORY_DB_GUARD_POLICY.EVICT_OLDEST_IF_LIMIT_EXECEEDED policy
   * to removes oldest events when limit is reached.
   */ async addItem(item, options = {}, policy = (0, $isASb.GuardPolicy).ABANDON) {
        if (policy === (0, $isASb.GuardPolicy).IGNORE) throw new (0, $6rezO.default)(policy, 'IndexedDbConnector#addItem');
        const storedValue = (0, $ckffc.convertToItemWrapper)(item, this.namespace, options);
        // Delegated responsiblity to event limit guard to insert to memory stored
        const bulkAddItemsResult = await this.globalEventLimitGuard.insertItemsToMemoryStore([
            storedValue
        ], policy);
        return Promise.resolve({
            item: bulkAddItemsResult.items[0],
            numberOfEvictedItems: bulkAddItemsResult.numberOfEvictedItems
        });
    }
    bulkAddItem(itemOptions, policy = (0, $isASb.GuardPolicy).ABANDON) {
        const items = itemOptions.map(({ item: item, ...addOptions })=>(0, $ckffc.convertToItemWrapper)(item, this.namespace, addOptions));
        return this.bulkAddItemWrapperType(items, policy);
    }
    /**
   * This method is used mainly to write events to MemoryDB when unknown errors are thrown from IndexedDB.
   */ bulkAddItemWrapperType(items, policy = (0, $isASb.GuardPolicy).ABANDON) {
        return Promise.resolve(this.globalEventLimitGuard.insertItemsToMemoryStore(items, policy));
    }
    getItems(count = (0, $fmspQ.GET_ITEM_COUNT)) {
        return Promise.resolve(this.synchronousGetItems(count));
    }
    synchronousGetItems(count = (0, $fmspQ.GET_ITEM_COUNT)) {
        const fixedCount = count > 0 ? count : (0, $fmspQ.GET_ITEM_COUNT);
        const now = Date.now();
        const wrappedItems = [];
        const itemsToRemove = [];
        for (let wrappedItem of this.memoryStore){
            if (wrappedItem.timeToBeProcessedAfter <= now) {
                wrappedItems.push({
                    ...wrappedItem
                });
                // Mutates the item in the memoryStore array, but not whats inside of wrappedItems
                wrappedItem.timeToBeProcessedAfter += (0, $fmspQ.VISIBILITY_TIMEOUT);
                wrappedItem.retryAttempts += 1;
                if (wrappedItem.retryAttempts >= this.options.maxAttempts) itemsToRemove.push(wrappedItem);
            }
            if (wrappedItems.length >= fixedCount) break;
        }
        itemsToRemove.forEach((item)=>{
            const index = this.memoryStore.indexOf(item);
            this.memoryStore.splice(index, 1);
        });
        return {
            items: wrappedItems,
            numberOfDeletedItems: itemsToRemove.length
        };
    }
    deleteItems(itemIds) {
        this.memoryStore = this.memoryStore.filter((item)=>!itemIds.includes(item.id));
        return Promise.resolve(void 0);
    }
    getItemCount() {
        const now = Date.now();
        const count = this.memoryStore.filter((item)=>item.timeToBeProcessedAfter <= now).length;
        return Promise.resolve(count);
    }
    async processItems(processFn, count) {
        const { items: items, ...partialGetResult } = this.synchronousGetItems(count);
        const itemIds = items.map((i)=>i.id);
        try {
            const result = await processFn(items, partialGetResult);
            await this.deleteItems(itemIds);
            return result;
        } catch (error) {
            throw new (0, $guFpw.default)(error);
        }
    }
    storeType() {
        return (0, $isASb.StoreType).MEMORY;
    }
    /**
   * This function is adding items to the tail of the memoryStore and as it adds new items it keeps the
   * memory store sorted by timeAdded property. This makes evictions easier and adding elements to
   * memoryStore much faster.
   *
   * @param itemsToAdd
   */ addItems(itemsToAdd) {
        this.memoryStore.push(...itemsToAdd);
        // Sorting everytime, intentionally.
        this.memoryStore.sort(function(a, b) {
            return a.timeAdded - b.timeAdded;
        });
    }
    /**
   * This function checks the number of events currently in AWC MemoryDb and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ evictEventsIfNeeded(eventLimit) {
        const numberOfEventsInDb = this.memoryStore.length;
        // The number of analytics events currently in MemoryDb and
        // the Z events we are proposing to add will exceed our event count limit.
        if (numberOfEventsInDb > eventLimit) {
            const m = numberOfEventsInDb - eventLimit;
            // Removing oldest M events
            this.memoryStore.splice(0, m);
            return m;
        }
        return 0;
    }
    constructor(namespace, options = {}){
        this.memoryStore = void 0;
        this.options = void 0;
        this.globalEventLimitGuard = void 0;
        this.namespace = void 0;
        this.namespace = namespace;
        this.memoryStore = [];
        this.options = (0, $ckffc.createOptionsWithDefaults)(options);
        /**
     * This class will enforce the number of analytics events we can store in our MemoryDb
     */ this.globalEventLimitGuard = new (0, $6Ee6o.default)(this.options.maxEventLimit, {
            addItems: this.addItems.bind(this),
            getItemCount: this.getItemCount.bind(this),
            evictEventsIfNeeded: this.evictEventsIfNeeded.bind(this)
        });
    }
}

});
parcelRegister("6Ee6o", function(module, exports) {
$parcel$export(module.exports, "default", () => $2e73957ad9a2abc0$export$2e2bcd8739ae039);

var $isASb = parcelRequire("isASb");

var $e20oq = parcelRequire("e20oq");
class $2e73957ad9a2abc0$export$2e2bcd8739ae039 {
    async handleAbandonIfLimitWillExceedPolicy(itemsToAdd) {
        const itemCount = await this.memoryItemHandlers.getItemCount();
        if (itemCount + itemsToAdd.length > this.eventLimit) throw new (0, $e20oq.default)((0, $isASb.StoreType).MEMORY);
        this.memoryItemHandlers.addItems(itemsToAdd);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: 0
        };
    }
    handleEvictOldestIfLimitExceededPolicy(itemsToAdd) {
        this.memoryItemHandlers.addItems(itemsToAdd);
        const numberOfEvictedItems = this.memoryItemHandlers.evictEventsIfNeeded(this.eventLimit);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async handleAddAsManyAsPossible(itemsToAdd) {
        const freeSpace = this.eventLimit - await this.memoryItemHandlers.getItemCount();
        const partialEventsToAdd = freeSpace > itemsToAdd.length ? itemsToAdd : itemsToAdd.slice(0, freeSpace);
        this.memoryItemHandlers.addItems(partialEventsToAdd);
        return {
            items: partialEventsToAdd,
            numberOfEvictedItems: 0
        };
    }
    constructor(eventLimit, memoryItemHandlers){
        this.eventLimit = void 0;
        this.memoryItemHandlers = void 0;
        /**
     * Unlike IndexedDb, we cannot take advantage of any index. So we are,
     * treating the memory store as a sorted set when adding items.
     */ this.insertItemsToMemoryStore = (itemsToAdd, policy)=>{
            switch(policy){
                case (0, $isASb.GuardPolicy).ABANDON:
                    return this.handleAbandonIfLimitWillExceedPolicy(itemsToAdd);
                case (0, $isASb.GuardPolicy).EVICT:
                    return Promise.resolve(this.handleEvictOldestIfLimitExceededPolicy(itemsToAdd));
                case (0, $isASb.GuardPolicy).IGNORE:
                    return this.handleAddAsManyAsPossible(itemsToAdd);
            }
        };
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error('Event Limit has to be set higher than 1');
        this.memoryItemHandlers = memoryItemHandlers;
    }
}

});




parcelRegister("iEfUI", function(module, exports) {
$parcel$export(module.exports, "default", () => $9017fa4090ffc956$export$2e2bcd8739ae039);

var $5ASKr = parcelRequire("5ASKr");
class $9017fa4090ffc956$export$4b62ee5120ab50a8 {
    addToItemsDiscardedByRetryCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByRetry += numberOfDeletedEvents;
    }
    addToEventCount() {
        this.eventCount++;
    }
    addToItemsDiscardedByOverflowCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByOverflow += numberOfDeletedEvents;
    }
    setResilienceMechanism(mechanism) {
        this.resilienceMechanism = mechanism;
    }
    /* <Localstorage specific> */ addToReclaimMetrics(reclaimMetrics) {
        this.localstorageNumberOfFullReclaims += reclaimMetrics.fullReclaims;
        this.localstorageNumberOfPartialReclaims += reclaimMetrics.partialReclaims;
        this.localstorageNumberOfFailedReclaims += reclaimMetrics.failedReclaims;
    }
    addToPurgedQueuesMetrics(numberOfQueuesPurged) {
        this.localstorageNumberOfQueuesPurged += numberOfQueuesPurged;
    }
    /* </Localstorage specific> */ subtractFromMetrics(sentMetrics) {
        this.itemsDiscardedByRetry = this.subtractFromCount(this.itemsDiscardedByRetry, sentMetrics.itemsDiscardedByRetry);
        this.eventCount = this.subtractFromCount(this.eventCount, sentMetrics.eventCount);
        this.itemsDiscardedByOverflow = this.subtractFromCount(this.itemsDiscardedByOverflow, sentMetrics.itemsDiscardedByOverflow);
        // Localstorage specific
        this.localstorageNumberOfFullReclaims = this.subtractFromCount(this.localstorageNumberOfFullReclaims, sentMetrics.fullReclaims);
        this.localstorageNumberOfPartialReclaims = this.subtractFromCount(this.localstorageNumberOfPartialReclaims, sentMetrics.partialReclaims);
        this.localstorageNumberOfFailedReclaims = this.subtractFromCount(this.localstorageNumberOfFailedReclaims, sentMetrics.failedReclaims);
        this.localstorageNumberOfQueuesPurged = this.subtractFromCount(this.localstorageNumberOfQueuesPurged, sentMetrics.localstorageQueuesPurged);
    }
    subtractFromCount(count, subtract) {
        return Math.max(count - (subtract || 0), 0);
    }
    getMetricsPayload() {
        return {
            itemsDiscardedByRetry: this.itemsDiscardedByRetry,
            eventCount: this.eventCount,
            itemsDiscardedByOverflow: this.itemsDiscardedByOverflow,
            resilienceMechanism: this.resilienceMechanism,
            // Localstorage specific
            localstorageQueuesPurged: this.localstorageNumberOfQueuesPurged,
            fullReclaims: this.localstorageNumberOfFullReclaims,
            partialReclaims: this.localstorageNumberOfPartialReclaims,
            failedReclaims: this.localstorageNumberOfFailedReclaims
        };
    }
    constructor(){
        // Number of events discarded due to exceeding retry limits.
        this.itemsDiscardedByRetry = 0;
        // Number of events created by the product in current tab.
        this.eventCount = 0;
        // Number of events discarded due to reaching queue max size.
        this.itemsDiscardedByOverflow = 0;
        // Will be used in the future when we get more resilience mechanisms
        this.resilienceMechanism = (0, $5ASKr.ResilienceMechanism).INDEXEDDB;
        /* --- LocalStorage specific metrics --- */ // Emitted by purgeOrphanedQueues to tell us how many queues we have had to clean up due to
        // https://github.com/segmentio/localstorage-retry/pull/17
        this.localstorageNumberOfQueuesPurged = 0;
        // Emitted by reclaimEvents to tell us how many queues were seen in the process of reclaim.
        // We will only emit metrics for queues that are not currently being maintained (i.e. `ack` is not being updated).
        // Queue was found, all events removed and put into resilienceDb.
        this.localstorageNumberOfFullReclaims = 0;
        // Queue was found but not all events were able to be put into resilienceDb.
        this.localstorageNumberOfPartialReclaims = 0;
        // Reclaim failed for a queue and reclaim was abandonded.
        this.localstorageNumberOfFailedReclaims = 0;
    }
}
let $9017fa4090ffc956$var$cachedMetricsClient = null;
var $9017fa4090ffc956$export$2e2bcd8739ae039 = ()=>{
    if (!$9017fa4090ffc956$var$cachedMetricsClient) $9017fa4090ffc956$var$cachedMetricsClient = new $9017fa4090ffc956$export$4b62ee5120ab50a8();
    return $9017fa4090ffc956$var$cachedMetricsClient;
};

});
parcelRegister("5ASKr", function(module, exports) {
$parcel$export(module.exports, "ResilienceMechanism", () => $69034944ea6a3ea8$export$c75161629e3ec34e);
$parcel$export(module.exports, "NetworkStatusEnum", () => $69034944ea6a3ea8$export$ee138fa712d11b84);
var $69034944ea6a3ea8$export$c75161629e3ec34e = /*#__PURE__*/ function(ResilienceMechanism) {
    ResilienceMechanism["INDEXEDDB"] = "indexeddb";
    ResilienceMechanism["MEMORY"] = "memory";
    return ResilienceMechanism;
}({});
var $69034944ea6a3ea8$export$ee138fa712d11b84 = /*#__PURE__*/ function(NetworkStatusEnum) {
    NetworkStatusEnum[NetworkStatusEnum["ONLINE"] = 0] = "ONLINE";
    NetworkStatusEnum[NetworkStatusEnum["OFFLINE"] = 1] = "OFFLINE";
    return NetworkStatusEnum;
}({});

});


parcelRegister("9VNiM", function(module, exports) {
$parcel$export(module.exports, "default", () => $bbea8d77be6827cc$export$2e2bcd8739ae039);

var $5ASKr = parcelRequire("5ASKr");
class $bbea8d77be6827cc$export$2e2bcd8739ae039 {
    removeListeners() {
        if (typeof window !== 'undefined') {
            window.addEventListener('offline', ()=>this._networkChangeCallback((0, $5ASKr.NetworkStatusEnum).OFFLINE));
            window.addEventListener('online', ()=>this._networkChangeCallback((0, $5ASKr.NetworkStatusEnum).ONLINE));
        }
    }
    getNetworkStatus() {
        if (window.navigator.onLine) return (0, $5ASKr.NetworkStatusEnum).ONLINE;
        return (0, $5ASKr.NetworkStatusEnum).OFFLINE;
    }
    constructor(networkChangeCallback){
        this._networkChangeCallback = void 0;
        this._networkChangeCallback = networkChangeCallback;
        if (typeof window !== 'undefined') {
            window.addEventListener('offline', ()=>this._networkChangeCallback((0, $5ASKr.NetworkStatusEnum).OFFLINE));
            window.addEventListener('online', ()=>this._networkChangeCallback((0, $5ASKr.NetworkStatusEnum).ONLINE));
        }
    }
}

});

parcelRegister("bIxux", function(module, exports) {
$parcel$export(module.exports, "default", () => $2c15efeeefc0fd42$export$2e2bcd8739ae039);

var $a58rx = parcelRequire("a58rx");

var $56dlt = parcelRequire("56dlt");
const $2c15efeeefc0fd42$var$SCHEDULER_OPTIONS_DEFAULT = {
    minRetryDelay: 1000,
    maxRetryDelay: 30000,
    backoffFactor: 2,
    backoffJitterPercentage: 0,
    waitInterval: 500,
    callbackTimeoutPeriod: 5000
};
var $2c15efeeefc0fd42$export$8bb92baee001fc60 = /*#__PURE__*/ function(QueuedScheduleTypes) {
    QueuedScheduleTypes[QueuedScheduleTypes["NONE"] = 0] = "NONE";
    QueuedScheduleTypes[QueuedScheduleTypes["IMMEDIATE"] = 1] = "IMMEDIATE";
    QueuedScheduleTypes[QueuedScheduleTypes["WAIT"] = 2] = "WAIT";
    return QueuedScheduleTypes;
}({});
class $2c15efeeefc0fd42$export$2e2bcd8739ae039 {
    constructor(retryOptions, callback){
        this.callback = void 0;
        this.failureCount = void 0;
        this.operationInFlight = void 0;
        this.options = void 0;
        this.queuedSchedule = void 0;
        this.scheduledTimeout = void 0;
        this.callbackTimer = void 0;
        this.schedule = ({ immediate: immediate } = {})=>{
            if (typeof window === 'undefined') return;
            if (this.operationInFlight) {
                if (immediate) this.queuedSchedule = 1;
                else if (this.queuedSchedule !== 1) this.queuedSchedule = 2;
            // Only run immediately if we have no failures
            } else if ((immediate || this.options.waitInterval <= 0) && this.failureCount === 0) {
                this.clearTimeout();
                this.run();
            // Calculate backoff for normal or failure scenario
            } else if (this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.run, this.calculateBackoff());
        };
        this.stop = ()=>{
            this.clearTimeout();
            this.queuedSchedule = 0;
        };
        this.getFailureCount = ()=>this.failureCount;
        this.getCallbackStatus = ()=>{
            return this.callbackTimer.getCallbackStatus();
        };
        this.clearTimeout = ()=>{
            if (typeof window !== 'undefined' && this.scheduledTimeout !== null) {
                window.clearTimeout(this.scheduledTimeout);
                this.scheduledTimeout = null;
            }
        };
        this.run = ()=>{
            this.operationInFlight = true;
            this.clearTimeout();
            try {
                this.callbackTimer.executeCallbackWithTimeout(// callback to execute
                this.callback, // when callback completes, call this function
                this.done, // on timeout, do this instead
                ()=>this.done((0, $56dlt.DoneState).ERROR));
            } catch (err) {
                this.done(err);
            }
        };
        this.done = (state)=>{
            this.operationInFlight = false;
            if (state === (0, $56dlt.DoneState).ERROR || this.callbackTimer.getCallbackStatus() === (0, $a58rx.CallbackStatus).TIMED_OUT) {
                this.failureCount++;
                this.clearTimeout();
            } else if (state === (0, $56dlt.DoneState).SUCCESS) this.failureCount = 0;
            this.processQueuedSchedule();
        };
        this.processQueuedSchedule = ()=>{
            if (this.queuedSchedule !== 0) {
                const immediate = this.queuedSchedule === 1;
                this.queuedSchedule = 0;
                this.schedule({
                    immediate: immediate
                });
            } else if (this.failureCount > 0) // This will schedule tasks when this._done was called with a truthy value
            // For example, when this.callback(this._done) was not called within
            // this.callbackTimeoutPeriod
            this.schedule();
        };
        this.calculateBackoff = ()=>{
            const { minRetryDelay: minRetryDelay, maxRetryDelay: maxRetryDelay, backoffFactor: backoffFactor, backoffJitterPercentage: backoffJitterPercentage, waitInterval: waitInterval } = this.options;
            // Helper for deviation based on a single random sample
            const jitter = (base, symmetric)=>{
                if (!backoffJitterPercentage || base <= 0) return 0;
                const r = (Math.random() - 0.5) * 2;
                const frac = symmetric ? r : Math.abs(r);
                return Math.floor(frac * backoffJitterPercentage * base);
            };
            // No failures: wait interval with positive-only jitter
            if (this.failureCount === 0) return waitInterval + jitter(waitInterval, false);
            // Failures: exponential backoff with symmetric jitter
            const base = Math.min(minRetryDelay * backoffFactor ** this.failureCount, maxRetryDelay);
            const withJitter = base + jitter(base, true);
            return Math.max(minRetryDelay, Math.min(withJitter, maxRetryDelay));
        };
        this.options = {
            minRetryDelay: retryOptions.minRetryDelay || $2c15efeeefc0fd42$var$SCHEDULER_OPTIONS_DEFAULT.minRetryDelay,
            maxRetryDelay: retryOptions.maxRetryDelay || $2c15efeeefc0fd42$var$SCHEDULER_OPTIONS_DEFAULT.maxRetryDelay,
            backoffFactor: retryOptions.backoffFactor || $2c15efeeefc0fd42$var$SCHEDULER_OPTIONS_DEFAULT.backoffFactor,
            backoffJitterPercentage: retryOptions.backoffJitterPercentage || $2c15efeeefc0fd42$var$SCHEDULER_OPTIONS_DEFAULT.backoffJitterPercentage,
            waitInterval: retryOptions.waitInterval !== undefined ? retryOptions.waitInterval : $2c15efeeefc0fd42$var$SCHEDULER_OPTIONS_DEFAULT.waitInterval,
            callbackTimeoutPeriod: retryOptions.callbackTimeoutPeriod || $2c15efeeefc0fd42$var$SCHEDULER_OPTIONS_DEFAULT.callbackTimeoutPeriod
        };
        this.scheduledTimeout = null;
        this.failureCount = 0;
        this.callback = callback;
        this.operationInFlight = false;
        this.queuedSchedule = 0;
        this.callbackTimer = new (0, $a58rx.CallbackWithTimeout)(this.options.callbackTimeoutPeriod);
    }
}

});
parcelRegister("a58rx", function(module, exports) {
$parcel$export(module.exports, "CallbackStatus", () => $8bce76fd749ac49e$export$ef3353088fca369c);
$parcel$export(module.exports, "CallbackWithTimeout", () => $8bce76fd749ac49e$export$590a718599f8f8b3);
var $8bce76fd749ac49e$export$ef3353088fca369c = /*#__PURE__*/ function(CallbackStatus) {
    CallbackStatus["IDLE"] = "idle";
    CallbackStatus["RUNNING"] = "running";
    CallbackStatus["COMPLETED"] = "completed";
    CallbackStatus["TIMED_OUT"] = "timedOut";
    return CallbackStatus;
}({});
var $8bce76fd749ac49e$export$def7d978353eaa0 = /*#__PURE__*/ function(CallbackEvent) {
    CallbackEvent["EXECUTE"] = "execute";
    CallbackEvent["COMPLETE"] = "complete";
    CallbackEvent["TIMEOUT"] = "timeout";
    return CallbackEvent;
}({});
class $8bce76fd749ac49e$export$590a718599f8f8b3 {
    // This is a state machine to control the flow of execution.
    // IDLE -> RUNNING -> COMPLETED
    // IDLE -> RUNNING -> TIMEDOUT
    transitionCallbackStatus(currentStatus, event) {
        switch(currentStatus){
            case "idle":
            case "timedOut":
            case "completed":
                if (event === "execute") this.callbackStatus = "running";
                break;
            case "running":
                switch(event){
                    case "complete":
                        this.callbackStatus = "completed";
                        break;
                    case "timeout":
                        this.callbackStatus = "timedOut";
                        break;
                }
                break;
            default:
                this.callbackStatus = currentStatus;
        }
    }
    // Start a timeout. If this.callback(this._done) does not finish
    // by this.options.callbackTimeoutPeriod time period,
    // we will call done with a true value.
    executeCallbackWithTimeout(callback, onDone, onTimeout) {
        if (typeof window === 'undefined') return;
        this.transitionCallbackStatus(this.callbackStatus, "execute");
        // Setting timeout
        this.timeoutHandle = window.setTimeout(()=>{
            this.transitionCallbackStatus(this.callbackStatus, "timeout");
            onTimeout();
        }, this.timeoutPeriod);
        // Executing callback
        callback((state)=>{
            this.cancelTimeout();
            if (this.getCallbackStatus() !== "timedOut") {
                this.transitionCallbackStatus(this.callbackStatus, "complete");
                onDone(state);
            }
        });
    }
    getCallbackStatus() {
        return this.callbackStatus;
    }
    // This allows us to cancel the timeout function, for example, if the callback finishes before the timeout period
    // or, if the user wants to manually cancel the timeout
    cancelTimeout() {
        if (typeof window !== 'undefined' && this.timeoutPeriod > 0 && this.timeoutHandle) {
            window.clearTimeout(this.timeoutHandle);
            this.timeoutHandle = undefined;
        }
    }
    constructor(timeoutPeriod){
        // Milliseconds to wait
        this.timeoutPeriod = void 0;
        // Tracks the settimeout; so that we can clear the timeout
        this.timeoutHandle = undefined;
        this.callbackStatus = "idle";
        if (timeoutPeriod > 0) {
            this.timeoutPeriod = timeoutPeriod;
            return;
        }
        throw new Error('CallbackWithTimeout requires timeout period higher than 0');
    }
}

});

parcelRegister("56dlt", function(module, exports) {
$parcel$export(module.exports, "DoneState", () => $e2d23383b774af99$export$f93c40fda808dd0c);
// Clients can optionally provide the callbackTimeoutPeriod parameter
var $e2d23383b774af99$export$f93c40fda808dd0c = /*#__PURE__*/ function(DoneState) {
    DoneState[DoneState["NOOP"] = 0] = "NOOP";
    DoneState[DoneState["SUCCESS"] = 1] = "SUCCESS";
    DoneState[DoneState["ERROR"] = 2] = "ERROR";
    return DoneState;
}({});

});




parcelRegister("iX7Pg", function(module, exports) {
$parcel$export(module.exports, "attachXidToMultipleEvents", () => $f776c54067ffee64$export$c21270cab66ab290);

var $8NY6g = parcelRequire("8NY6g");
function $f776c54067ffee64$export$c9c3aaf655d6f275(item, xidCallback) {
    if (!(xidCallback && xidCallback instanceof Function)) return item;
    if (item.msg.type === (0, $8NY6g.SegmentEventTypes).PAGE || item.msg.type === (0, $8NY6g.SegmentEventTypes).TRACK) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.properties = {
            ...item.msg.properties,
            xid: xid
        };
    } else if (item.msg.traits && item.msg.type === (0, $8NY6g.SegmentEventTypes).IDENTIFY) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.traits = {
            ...item.msg.traits,
            xid: xid
        };
    }
    return item;
}
async function $f776c54067ffee64$export$c21270cab66ab290(items, xidItemPromiseCallback) {
    try {
        const xidCallback = await xidItemPromiseCallback;
        return items.map((item)=>$f776c54067ffee64$export$c9c3aaf655d6f275(item, xidCallback));
    } catch (error) {
        return items;
    }
}

});
parcelRegister("8NY6g", function(module, exports) {
$parcel$export(module.exports, "LastError", () => $e1e3e474c8383133$export$a63e16b3351b8c36);
$parcel$export(module.exports, "FetchError", () => $e1e3e474c8383133$export$26e841bcf1aeb894);
$parcel$export(module.exports, "SegmentEventTypes", () => $e1e3e474c8383133$export$ddf929981dc6feb3);
$parcel$export(module.exports, "MetadataResponse", () => $e1e3e474c8383133$export$4b1a5e5486cc0d80);
$parcel$export(module.exports, "ALLOW_LISTED_FETCH_ERROR_NAMES", () => $e1e3e474c8383133$export$96f086dcf574a9e2);
class $e1e3e474c8383133$export$a63e16b3351b8c36 {
    constructor(reason, error){
        this.reason = void 0;
        this.message = void 0;
        this.statusCode = void 0;
        this.reason = reason;
        this.message = error instanceof Error ? error.message : null;
        this.statusCode = error instanceof $e1e3e474c8383133$export$26e841bcf1aeb894 ? error.statusCode : null;
    }
}
var $e1e3e474c8383133$export$ddf929981dc6feb3 = /*#__PURE__*/ function(SegmentEventTypes) {
    SegmentEventTypes["IDENTIFY"] = "identify";
    SegmentEventTypes["PAGE"] = "page";
    // Dont need Screen as page and screen are the same and we only use page
    SegmentEventTypes["TRACK"] = "track";
    return SegmentEventTypes;
}({});
var $e1e3e474c8383133$export$8d8db47b9b0efb63 = /*#__PURE__*/ function(CrossDomainIdentifierType) {
    CrossDomainIdentifierType["XC"] = "xc";
    CrossDomainIdentifierType["UID"] = "uid";
    return CrossDomainIdentifierType;
}({});
var $e1e3e474c8383133$export$2140495465f9e528 = /*#__PURE__*/ function(CrossDomainIdentifierState) {
    CrossDomainIdentifierState["NEW"] = "NEW";
    CrossDomainIdentifierState["CHANGED"] = "CHANGED";
    CrossDomainIdentifierState["EXISTING"] = "EXISTING";
    CrossDomainIdentifierState["TIMEOUT"] = "TIMEOUT";
    CrossDomainIdentifierState["ERROR"] = "ERROR";
    CrossDomainIdentifierState["UNAVAILABLE"] = "UNAVAILABLE";
    CrossDomainIdentifierState["MALFORMED"] = "MALFORMED";
    CrossDomainIdentifierState["UNKNOWN"] = "UNKNOWN";
    return CrossDomainIdentifierState;
}({});
class $e1e3e474c8383133$export$4b1a5e5486cc0d80 {
    static fromJson(json) {
        let isString = (value)=>typeof value === 'string' || value instanceof String;
        const url = isString(json?.url) ? json.url.trim() : '';
        return new $e1e3e474c8383133$export$4b1a5e5486cc0d80(json?.props || null, url.startsWith('http') ? url : null);
    }
    constructor(props, url){
        this.props = void 0;
        this.url = void 0;
        this.props = props;
        this.url = url;
    }
}
class $e1e3e474c8383133$export$26e841bcf1aeb894 extends Error {
    constructor(message, statusCode, statusText){
        super(message);
        this.statusCode = void 0;
        this.statusText = void 0;
        this.statusCode = statusCode;
        this.statusText = statusText;
    }
}
const $e1e3e474c8383133$export$96f086dcf574a9e2 = [
    'FetchError',
    'AbortError',
    'TypeError'
];

});


parcelRegister("dInNc", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_REQUEST_TIMEOUT", () => $42582a9c98082a83$export$9175ce0e1c95daf2);
$parcel$export(module.exports, "DEFAULT_METADATA_REQUEST_TIMEOUT", () => $42582a9c98082a83$export$8fddcd1eff390364);
$parcel$export(module.exports, "DEFAULT_METADATA_REFRESH_INTERVAL", () => $42582a9c98082a83$export$92ed669a3d41dad3);
$parcel$export(module.exports, "DEFAULT_METADATA_MIN_RETRY_DELAY", () => $42582a9c98082a83$export$6649d5c857717efe);
$parcel$export(module.exports, "DEFAULT_METADATA_MAX_RETRY_DELAY", () => $42582a9c98082a83$export$33e7628d3b2c0e2);
$parcel$export(module.exports, "DEFAULT_METADATA_PROPERTY_CHANGE_REFRESH_INTERVAL", () => $42582a9c98082a83$export$6f1c008dd0c3b67e);
const $42582a9c98082a83$export$9175ce0e1c95daf2 = 10000; // 10 seconds
const $42582a9c98082a83$export$8fddcd1eff390364 = 60000; // 60 seconds
const $42582a9c98082a83$export$92ed669a3d41dad3 = 600000; // 10 minutes
const $42582a9c98082a83$export$6649d5c857717efe = 5000; // 5 seconds
const $42582a9c98082a83$export$33e7628d3b2c0e2 = 3600000; // 60 minutes
const $42582a9c98082a83$export$6f1c008dd0c3b67e = 10; // 10 milliseconds

});

parcelRegister("2DF8j", function(module, exports) {
$parcel$export(module.exports, "HTTP_STATUS_CODE_MAP", () => $c524591fddb3fbae$export$ba118f9de1e5ac63);
const $c524591fddb3fbae$export$ba118f9de1e5ac63 = new Map([
    [
        200,
        'OK'
    ],
    [
        400,
        'Bad Request'
    ],
    [
        401,
        'Unauthorized'
    ],
    [
        402,
        'Payment Required'
    ],
    [
        403,
        'Forbidden'
    ],
    [
        404,
        'Not Found'
    ],
    [
        405,
        'Method Not Allowed'
    ],
    [
        406,
        'Not Acceptable'
    ],
    [
        407,
        'Proxy Authentication Required'
    ],
    [
        408,
        'Request Timeout'
    ],
    [
        409,
        'Conflict'
    ],
    [
        410,
        'Gone'
    ],
    [
        411,
        'Length Required'
    ],
    [
        412,
        'Precondition Failed'
    ],
    [
        413,
        'Payload Too Large'
    ],
    [
        414,
        'URI Too Long'
    ],
    [
        415,
        'Unsupported Media Type'
    ],
    [
        416,
        'Requested range not satisfiable'
    ],
    [
        417,
        'Expectation Failed'
    ],
    [
        418,
        "I'm a teapot"
    ],
    [
        422,
        'Unprocessable Entity'
    ],
    [
        423,
        'Locked'
    ],
    [
        424,
        'Failed Dependency'
    ],
    [
        425,
        'Too Early'
    ],
    [
        426,
        'Upgrade Required'
    ],
    [
        428,
        'Precondition Required'
    ],
    [
        429,
        'Too Many Requests'
    ],
    [
        431,
        'Request Header Fields Too Large'
    ],
    [
        451,
        'Unavailable For Legal Reasons'
    ],
    [
        500,
        'Internal Server Error'
    ],
    [
        501,
        'Not Implemented'
    ],
    [
        502,
        'Bad Gateway'
    ],
    [
        503,
        'Service Unavailable'
    ],
    [
        504,
        'Gateway Timeout'
    ],
    [
        505,
        'HTTP Version not supported'
    ],
    [
        506,
        'Variant Also Negotiates'
    ],
    [
        507,
        'Insufficient Storage'
    ],
    [
        508,
        'Loop Detected'
    ],
    [
        509,
        'Bandwidth Limit Exceeded'
    ],
    [
        510,
        'Not Extended'
    ],
    [
        511,
        'Network Authentication Required'
    ],
    [
        -1,
        'Unknown Status'
    ]
]);

});

parcelRegister("cfUir", function(module, exports) {
$parcel$export(module.exports, "sendEvents", () => $dac3c929d90a22a7$export$8e8f0180c1b41fad);

var $8V6O9 = parcelRequire("8V6O9");

var $8NY6g = parcelRequire("8NY6g");
const $dac3c929d90a22a7$export$8e8f0180c1b41fad = async (options)=>{
    const signal = $dac3c929d90a22a7$var$createOrGetAbortController(options)?.signal;
    const corsOptions = $dac3c929d90a22a7$var$getCorsForUrl(options.url);
    const response = await fetch(options.url, {
        method: 'POST',
        // Content-type has to be text/plain in order to prevent unnecessary `OPTIONS` requests.
        headers: {
            'Content-Type': 'text/plain'
        },
        body: JSON.stringify(options.batch),
        signal: signal,
        ...corsOptions
    });
    if (response.status === 429 || response.status >= 500 && response.status < 600) throw new (0, $8NY6g.FetchError)(`HTTP Error ${response.status} (${response.statusText})`, response.status, response.statusText);
    return response;
};
const $dac3c929d90a22a7$var$createOrGetAbortController = (options)=>{
    if (options.abortController) return options.abortController;
    else if (options.timeout) {
        const abortController = new AbortController();
        // After a fetch has completed, calling abort is ignored.
        setTimeout(()=>{
            abortController.abort();
        }, options.timeout);
        return abortController;
    }
    return undefined;
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
const $dac3c929d90a22a7$var$getCorsForUrl = (0, $8V6O9.default)((url)=>{
    const origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: 'cors',
        credentials: 'include'
    };
});

});
parcelRegister("8V6O9", function(module, exports) {
$parcel$export(module.exports, "default", () => $67e8ed7bbb3bb0d2$export$2e2bcd8739ae039);
var $67e8ed7bbb3bb0d2$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $67e8ed7bbb3bb0d2$var$isEqual(first, second) {
    if (first === second) return true;
    if ($67e8ed7bbb3bb0d2$var$safeIsNaN(first) && $67e8ed7bbb3bb0d2$var$safeIsNaN(second)) return true;
    return false;
}
function $67e8ed7bbb3bb0d2$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$67e8ed7bbb3bb0d2$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $67e8ed7bbb3bb0d2$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $67e8ed7bbb3bb0d2$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

});


parcelRegister("6ViEz", function(module, exports) {
$parcel$export(module.exports, "default", () => $7df02ef115eb0be8$export$2e2bcd8739ae039);

var $cPHSs = parcelRequire("cPHSs");

var $bdD5u = parcelRequire("bdD5u");
var $6KzGG = parcelRequire("6KzGG");

var $iF8MW = parcelRequire("iF8MW");

var $3ohfK = parcelRequire("3ohfK");
// Cookie is stale, if anonymousId was generated 7 days ago.
const $7df02ef115eb0be8$var$ANONYMOUS_ID_COOKIE_STALE_DAYS = 7;
const $7df02ef115eb0be8$var$SAFE = 'SAFE';
const $7df02ef115eb0be8$var$UNSAFE = 'UNSAFE';
const $7df02ef115eb0be8$var$NOT_FOUND = 'NOT_FOUND';
const $7df02ef115eb0be8$var$COOKIE = 'COOKIE';
const $7df02ef115eb0be8$var$LOCAL_STORAGE = 'LOCAL_STORAGE';
class $7df02ef115eb0be8$export$2e2bcd8739ae039 {
    getUserId() {
        return this.userId || null;
    }
    setUserId(userId) {
        this.userId = userId;
    }
    getAnonymousId(customAnonymousIdGenerator) {
        /**
     * Prefer localStorage as there cant be duplicate keys, and its faster. Also update cookie, if stale.
     * If not set in localStorage, check cookies. Also set localStorage for future attempts.
     * If not in cookies, generate a new one. Set both cookie and localStorage keys.
     */ return this.getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() || this.getAnonymousIdFromCookieAndUpdateLocalStorage() || this.generateNewAnonymousId(customAnonymousIdGenerator);
    }
    setAnonymousId(anonymousId) {
        const stringifyAnonymosId = JSON.stringify(anonymousId);
        this.cookie.set((0, $bdD5u.AWCCookiesKeys).AJS_ANONYMOUS_ID, stringifyAnonymosId);
        this.lastAnonymousIdCookieUpdate = Date.now();
        return this.store.setItem((0, $bdD5u.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), stringifyAnonymosId);
    }
    getAnonymousIdFromStorage(source) {
        const rawStorageAnonidValue = source === $7df02ef115eb0be8$var$LOCAL_STORAGE ? this.store.getItem((0, $bdD5u.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey()) : this.cookie.get((0, $bdD5u.AWCCookiesKeys).AJS_ANONYMOUS_ID);
        if (rawStorageAnonidValue) {
            const unsafeValue = {
                type: $7df02ef115eb0be8$var$UNSAFE,
                anonymousId: rawStorageAnonidValue
            };
            try {
                const parsedAnonId = JSON.parse(rawStorageAnonidValue);
                if (parsedAnonId && typeof parsedAnonId === 'string') return {
                    type: $7df02ef115eb0be8$var$SAFE,
                    anonymousId: parsedAnonId
                };
                return unsafeValue;
            } catch  {
                /*
         * Segments new Analytics-next client will store strings as strings without stringifing.
         * The legacy Segment client and AWC always stringify and parse cookies and values.
         * If the new Segment analytics-client stores a cookie and local storage value first, it will
         * breaking old clients.
         *
         * Additionally, JSON.parse can cause exceptions to be thrown in some browsers; see AAP-324.
         *
         * Intentionally swalling errors here and returning the original value found in storage to avoid ping-pong.
         */ return unsafeValue;
            }
        }
        return {
            type: $7df02ef115eb0be8$var$NOT_FOUND
        };
    }
    getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() {
        const localStorageValue = this.getAnonymousIdFromStorage($7df02ef115eb0be8$var$LOCAL_STORAGE);
        let shouldUpdateCookie = false;
        if (!this.lastAnonymousIdCookieUpdate || (0, $cPHSs.default)(new Date(), new Date(this.lastAnonymousIdCookieUpdate)) >= $7df02ef115eb0be8$var$ANONYMOUS_ID_COOKIE_STALE_DAYS) shouldUpdateCookie = true;
        switch(localStorageValue.type){
            case $7df02ef115eb0be8$var$SAFE:
                if (shouldUpdateCookie) this.setAnonymousId(localStorageValue.anonymousId);
                return localStorageValue.anonymousId;
            case $7df02ef115eb0be8$var$UNSAFE:
                return localStorageValue.anonymousId;
            case $7df02ef115eb0be8$var$NOT_FOUND:
            default:
                return null;
        }
    }
    getAnonymousIdFromCookieAndUpdateLocalStorage() {
        const cookieValue = this.getAnonymousIdFromStorage($7df02ef115eb0be8$var$COOKIE);
        switch(cookieValue.type){
            case $7df02ef115eb0be8$var$SAFE:
            case $7df02ef115eb0be8$var$UNSAFE:
                this.store.setItem((0, $bdD5u.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), JSON.stringify(cookieValue.anonymousId));
                return cookieValue.anonymousId;
            case $7df02ef115eb0be8$var$NOT_FOUND:
            default:
                return null;
        }
    }
    generateNewAnonymousId(customAnonymousIdGenerator) {
        const generator = typeof customAnonymousIdGenerator === 'function' ? customAnonymousIdGenerator : ()=>{
            return (0, $3ohfK.default)();
        };
        const newAnonId = generator();
        this.setAnonymousId(newAnonId);
        return newAnonId;
    }
    constructor(disableCookiePersistence){
        this.store = void 0;
        this.cookie = void 0;
        this.userId = void 0;
        this.lastAnonymousIdCookieUpdate = void 0;
        this.store = new (0, $iF8MW.default)({
            useStoragePrefix: false
        });
        this.cookie = new (0, $6KzGG.default)(disableCookiePersistence);
    }
}

});
parcelRegister("cPHSs", function(module, exports) {
$parcel$export(module.exports, "default", () => $957c489080254edb$export$2e2bcd8739ae039);

var $kuL0C = parcelRequire("kuL0C");

var $gsgpv = parcelRequire("gsgpv");

var $aHItk = parcelRequire("aHItk");
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $957c489080254edb$var$compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
function $957c489080254edb$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $aHItk.default)(2, arguments);
    var dateLeft = (0, $kuL0C.default)(dirtyDateLeft);
    var dateRight = (0, $kuL0C.default)(dirtyDateRight);
    var sign = $957c489080254edb$var$compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs((0, $gsgpv.default)(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number($957c489080254edb$var$compareLocalAsc(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("kuL0C", function(module, exports) {
$parcel$export(module.exports, "default", () => $eebb12fc7a602c91$export$2e2bcd8739ae039);

var $e7K2l = parcelRequire("e7K2l");

var $aHItk = parcelRequire("aHItk");
function $eebb12fc7a602c91$export$2e2bcd8739ae039(argument) {
    (0, $aHItk.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $e7K2l.default)(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

});
parcelRegister("e7K2l", function(module, exports) {
$parcel$export(module.exports, "default", () => $a4856e1b82df4c07$export$2e2bcd8739ae039);
function $a4856e1b82df4c07$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $a4856e1b82df4c07$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a4856e1b82df4c07$export$2e2bcd8739ae039(o);
}

});

parcelRegister("aHItk", function(module, exports) {
$parcel$export(module.exports, "default", () => $7cb06ac39ecdae8f$export$2e2bcd8739ae039);
function $7cb06ac39ecdae8f$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}

});


parcelRegister("gsgpv", function(module, exports) {
$parcel$export(module.exports, "default", () => $bfabfda58203b7b4$export$2e2bcd8739ae039);

var $2u5SF = parcelRequire("2u5SF");

var $2Dog6 = parcelRequire("2Dog6");

var $aHItk = parcelRequire("aHItk");
var $bfabfda58203b7b4$var$MILLISECONDS_IN_DAY = 86400000;
function $bfabfda58203b7b4$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $aHItk.default)(2, arguments);
    var startOfDayLeft = (0, $2Dog6.default)(dirtyDateLeft);
    var startOfDayRight = (0, $2Dog6.default)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $2u5SF.default)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $2u5SF.default)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $bfabfda58203b7b4$var$MILLISECONDS_IN_DAY);
}

});
parcelRegister("2u5SF", function(module, exports) {
$parcel$export(module.exports, "default", () => $1cf2f1ebb227fcca$export$2e2bcd8739ae039);
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $1cf2f1ebb227fcca$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

});

parcelRegister("2Dog6", function(module, exports) {
$parcel$export(module.exports, "default", () => $1eb20a95f5297f5e$export$2e2bcd8739ae039);

var $kuL0C = parcelRequire("kuL0C");

var $aHItk = parcelRequire("aHItk");
function $1eb20a95f5297f5e$export$2e2bcd8739ae039(dirtyDate) {
    (0, $aHItk.default)(1, arguments);
    var date = (0, $kuL0C.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}

});



parcelRegister("bdD5u", function(module, exports) {
$parcel$export(module.exports, "AWCCookiesKeys", () => $34d759baa22de747$export$202d555a5dbfd90c);
$parcel$export(module.exports, "AllAnalyticsCookies", () => $34d759baa22de747$export$d4cb17942ea57c95);
var $34d759baa22de747$export$202d555a5dbfd90c = /*#__PURE__*/ function(AWCCookiesKeys) {
    AWCCookiesKeys["AWC_TLD_TEST"] = "AWC_TLD_TEST";
    AWCCookiesKeys["AWC_ANALYTICS_DEBUG"] = "AWC_ANALYTICS_DEBUG";
    AWCCookiesKeys["AJS_ANONYMOUS_ID"] = "AJS_ANONYMOUS_ID";
    return AWCCookiesKeys;
}({});
class $34d759baa22de747$var$CookieSchema {
    getAttributes() {
        return this.options;
    }
    getKey() {
        return this.key;
    }
    constructor(key, options){
        this.key = void 0;
        this.options = void 0;
        this.key = key;
        this.options = options;
    }
}
const $34d759baa22de747$var$isSecure = ()=>{
    try {
        return globalThis && globalThis.location && globalThis.location.protocol === 'https:';
    } catch (err) {
        return false;
    }
};
const $34d759baa22de747$export$d4cb17942ea57c95 = {
    ["AWC_TLD_TEST"]: new $34d759baa22de747$var$CookieSchema('__awc_tld_test__', {
        expires: 365,
        secure: $34d759baa22de747$var$isSecure(),
        path: '/'
    }),
    ["AWC_ANALYTICS_DEBUG"]: new $34d759baa22de747$var$CookieSchema('atlassian_analytics_debug', {
        expires: 365,
        secure: $34d759baa22de747$var$isSecure(),
        path: '/'
    }),
    ["AJS_ANONYMOUS_ID"]: new $34d759baa22de747$var$CookieSchema('ajs_anonymous_id', {
        expires: 365,
        secure: $34d759baa22de747$var$isSecure(),
        path: '/'
    })
};

});

parcelRegister("6KzGG", function(module, exports) {
$parcel$export(module.exports, "default", () => $fcd989991a61c497$export$2e2bcd8739ae039);

var $8jInb = parcelRequire("8jInb");

var $bdD5u = parcelRequire("bdD5u");

var $lpcb7 = parcelRequire("lpcb7");

var $4fO1Z = parcelRequire("4fO1Z");
class $fcd989991a61c497$export$2e2bcd8739ae039 {
    set(name, value, options) {
        // no-op
        if (!(0, $bdD5u.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not set.`);
            return;
        }
        return this.cookieLike.set((0, $bdD5u.AllAnalyticsCookies)[name].getKey(), value, {
            ...(0, $bdD5u.AllAnalyticsCookies)[name].getAttributes(),
            // Function is memoized so we only calculate this once per page load
            domain: (0, $4fO1Z.getTld)(),
            ...options
        });
    }
    get(name) {
        if (!(0, $bdD5u.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not fetched.`);
            return;
        }
        return this.cookieLike.get((0, $bdD5u.AllAnalyticsCookies)[name].getKey());
    }
    remove(name, options) {
        if (!(0, $bdD5u.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not removed.`);
            return;
        }
        this.cookieLike.remove((0, $bdD5u.AllAnalyticsCookies)[name].getKey(), {
            ...options
        });
    }
    constructor(disableCookiePersistence){
        this.cookieLike = void 0;
        this.cookieLike = (0, $4fO1Z.canUseCookie)(disableCookiePersistence) ? (0, (/*@__PURE__*/$parcel$interopDefault($8jInb))) : new (0, $lpcb7.default)();
    }
}

});
parcelRegister("8jInb", function(module, exports) {
(function(factory) {
    var registeredInModuleLoader;
    if (typeof define === 'function' && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
    }
    module.exports = factory();
    registeredInModuleLoader = true;
    if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function() {
            window.Cookies = OldCookies;
            return api;
        };
    }
})(function() {
    function extend() {
        var i = 0;
        var result = {};
        for(; i < arguments.length; i++){
            var attributes = arguments[i];
            for(var key in attributes)result[key] = attributes[key];
        }
        return result;
    }
    function decode(s) {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function init(converter) {
        function api() {}
        function set(key, value, attributes) {
            if (typeof document === 'undefined') return;
            attributes = extend({
                path: '/'
            }, api.defaults, attributes);
            if (typeof attributes.expires === 'number') attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
            // We're using "expires" because "max-age" is not supported by IE
            attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
            try {
                var result = JSON.stringify(value);
                if (/^[\{\[]/.test(result)) value = result;
            } catch (e) {}
            value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
            key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var stringifiedAttributes = '';
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += '; ' + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
            }
            return document.cookie = key + '=' + value + stringifiedAttributes;
        }
        function get(key, json) {
            if (typeof document === 'undefined') return;
            var jar = {};
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var i = 0;
            for(; i < cookies.length; i++){
                var parts = cookies[i].split('=');
                var cookie = parts.slice(1).join('=');
                if (!json && cookie.charAt(0) === '"') cookie = cookie.slice(1, -1);
                try {
                    var name = decode(parts[0]);
                    cookie = (converter.read || converter)(cookie, name) || decode(cookie);
                    if (json) try {
                        cookie = JSON.parse(cookie);
                    } catch (e) {}
                    jar[name] = cookie;
                    if (key === name) break;
                } catch (e) {}
            }
            return key ? jar[key] : jar;
        }
        api.set = set;
        api.get = function(key) {
            return get(key, false);
        };
        api.getJSON = function(key) {
            return get(key, true);
        };
        api.remove = function(key, attributes) {
            set(key, '', extend(attributes, {
                expires: -1
            }));
        };
        api.defaults = {};
        api.withConverter = init;
        return api;
    }
    return init(function() {});
});

});

parcelRegister("lpcb7", function(module, exports) {
$parcel$export(module.exports, "default", () => $25f6631d0873257a$export$2e2bcd8739ae039);

var $iF8MW = parcelRequire("iF8MW");
class $25f6631d0873257a$export$2e2bcd8739ae039 {
    set(name, value) {
        this.safeStorage.setItem(name, value);
        return value;
    }
    get(name) {
        const value = this.safeStorage.getItem(name);
        return value || undefined;
    }
    remove(name) {
        this.safeStorage.removeItem(name);
    }
    constructor(){
        this.safeStorage = void 0;
        this.safeStorage = new (0, $iF8MW.default)({
            useStoragePrefix: false
        });
    }
}

});
parcelRegister("iF8MW", function(module, exports) {
$parcel$export(module.exports, "default", () => $f3ef3925c701d6d1$export$2e2bcd8739ae039);

var $9DqcB = parcelRequire("9DqcB");

var $7yCTl = parcelRequire("7yCTl");
class $f3ef3925c701d6d1$export$2e2bcd8739ae039 extends (0, $7yCTl.default) {
    constructor(options){
        let storageToUse;
        try {
            storageToUse = globalThis.localStorage || (0, $9DqcB.default);
        } catch (err) {
            storageToUse = (0, $9DqcB.default);
        }
        super(storageToUse, options);
    }
}

});
parcelRegister("9DqcB", function(module, exports) {
$parcel$export(module.exports, "default", () => $f33a87e73b58c3ac$export$2e2bcd8739ae039);
class $f33a87e73b58c3ac$export$90e3e001bcac59c7 {
    constructor(){
        this._data = {};
        this.length = 0;
        this.setItem = (key, value)=>{
            this._data[key] = value;
            this.length = Object.keys(this._data).length;
            return value;
        };
        this.getItem = (key)=>{
            if (key in this._data) return this._data[key];
            return null;
        };
        this.removeItem = (key)=>{
            if (key in this._data) delete this._data[key];
            this.length = Object.keys(this._data).length;
            return null;
        };
        this.clear = ()=>{
            this._data = {};
            this.length = 0;
        };
        this.key = (index)=>Object.keys(this._data)[index];
    }
}
// eslint-disable-next-line import/no-anonymous-default-export
const $f33a87e73b58c3ac$var$inmemorystorage = new $f33a87e73b58c3ac$export$90e3e001bcac59c7();
var $f33a87e73b58c3ac$export$2e2bcd8739ae039 = $f33a87e73b58c3ac$var$inmemorystorage;

});

parcelRegister("7yCTl", function(module, exports) {
$parcel$export(module.exports, "default", () => $7a85e1d19b4bf934$export$2e2bcd8739ae039);
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ 
var $1RuJ0 = parcelRequire("1RuJ0");

var $9DqcB = parcelRequire("9DqcB");
const $7a85e1d19b4bf934$export$41c06fdd37b7e9a5 = 'awc';
const $7a85e1d19b4bf934$export$770aa8bc07b3de03 = 'awcInMemoryStorageFallback';
function $7a85e1d19b4bf934$export$48c17662a6902497(store) {
    const TEST_VALUE = 'test_value';
    if (!store) return false;
    try {
        const key = 'awc.storage.support';
        store.setItem(key, TEST_VALUE);
        const value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}
class $7a85e1d19b4bf934$export$2e2bcd8739ae039 {
    constructor(storageToUse, options = {}){
        this._prefix = void 0;
        this._store = void 0;
        this.options = void 0;
        this.getStore = ()=>this._store;
        this.getItem = (key)=>this._store.getItem(this.createKey(key));
        this.removeItem = (key)=>this._store.removeItem(this.createKey(key));
        this.setItem = (key, value)=>{
            try {
                this._store.setItem(this.createKey(key), value);
            } catch (err) {
                // Theoretically should only be QuotaExceededError, but keeping 'err' generic
                // https://developer.mozilla.org/en-US/docs/Web/API/Storage/setItem
                this.swapToInMemory();
                this._store.setItem(this.createKey(key), value);
            }
        };
        this.swapToInMemory = ()=>{
            if (this._store === (0, $9DqcB.default) || typeof globalThis === 'undefined') return;
            const keys = Object.keys(this._store || {});
            let inMemoryStorage;
            if ($7a85e1d19b4bf934$export$48c17662a6902497(globalThis[$7a85e1d19b4bf934$export$770aa8bc07b3de03])) inMemoryStorage = globalThis[$7a85e1d19b4bf934$export$770aa8bc07b3de03];
            else {
                inMemoryStorage = (0, $9DqcB.default);
                if (!globalThis[$7a85e1d19b4bf934$export$770aa8bc07b3de03]) // If not already attached to globalThis then attach our instance of InMemoryStorage
                // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
                // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
                globalThis[$7a85e1d19b4bf934$export$770aa8bc07b3de03] = (0, $9DqcB.default);
            }
            keys.forEach((key)=>{
                if (key.indexOf(this.getPrefix()) === 0) {
                    const value = this._store.getItem(key);
                    if (value) inMemoryStorage.setItem(key, value);
                }
            });
            this._store = inMemoryStorage;
        };
        this.clear = ()=>this._store.clear();
        this.key = (index)=>this._store.key(index);
        this.getPrefix = ()=>this._prefix;
        this.createKey = (key)=>{
            if (this._prefix) return `${this.getPrefix()}.${key}`;
            return key;
        };
        this.options = options;
        const prefixes = [];
        if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push($7a85e1d19b4bf934$export$41c06fdd37b7e9a5);
        if (options.envPrefix && options.envPrefix !== (0, $1RuJ0.envType).PROD) prefixes.push(options.envPrefix);
        this._prefix = prefixes.join('-');
        if ($7a85e1d19b4bf934$export$48c17662a6902497(storageToUse)) this._store = storageToUse;
        else this.swapToInMemory();
    }
}

});



parcelRegister("4fO1Z", function(module, exports) {
$parcel$export(module.exports, "canUseCookie", () => $3b177659c797b09a$export$a9330601ee8f4d95);
$parcel$export(module.exports, "getTld", () => $3b177659c797b09a$export$de6821eed3d5f32d);

var $8jInb = parcelRequire("8jInb");

var $8V6O9 = parcelRequire("8V6O9");

var $bdD5u = parcelRequire("bdD5u");
const $3b177659c797b09a$export$a9330601ee8f4d95 = (disableCookiePersistence = false)=>{
    if (disableCookiePersistence) return false;
    return !(location.protocol === 'file:' || location.protocol === 'chrome-extension:');
};
const $3b177659c797b09a$export$eb80e1beaa8dacf8 = (0, $bdD5u.AllAnalyticsCookies).AWC_TLD_TEST.getKey();
const $3b177659c797b09a$export$19164982d36535d8 = 'tld_test';
const $3b177659c797b09a$export$de6821eed3d5f32d = (0, $8V6O9.default)(()=>{
    if (typeof location === 'undefined') return '';
    const { hostname: hostname } = location;
    const splitHostname = hostname.split('.');
    for(let i = 1; i <= splitHostname.length; i++){
        const domainParts = splitHostname.slice(i * -1);
        const domain = `.${domainParts.join('.')}`;
        (0, (/*@__PURE__*/$parcel$interopDefault($8jInb))).set($3b177659c797b09a$export$eb80e1beaa8dacf8, $3b177659c797b09a$export$19164982d36535d8, {
            domain: domain
        });
        if ((0, (/*@__PURE__*/$parcel$interopDefault($8jInb))).get($3b177659c797b09a$export$eb80e1beaa8dacf8) === $3b177659c797b09a$export$19164982d36535d8) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8jInb))).remove($3b177659c797b09a$export$eb80e1beaa8dacf8, {
                domain: domain
            });
            return domain;
        }
    }
    return hostname;
});

});



parcelRegister("1emO3", function(module, exports) {
$parcel$export(module.exports, "buildContext", () => $4b54556ec3f3e859$export$3a7fe28f9bf4f3d9);
$parcel$export(module.exports, "prepareEventProperties", () => $4b54556ec3f3e859$export$44d22e5fb02cc68e);
// @ts-ignore

var $kG7B1 = parcelRequire("kG7B1");
const $4b54556ec3f3e859$export$3a7fe28f9bf4f3d9 = (context)=>{
    return {
        ...context.context,
        userAgent: navigator.userAgent
    };
};
const $4b54556ec3f3e859$export$44d22e5fb02cc68e = (properties)=>{
    const propertiesWithoutUndefined = $4b54556ec3f3e859$var$nestedRemoveUndefinedValues(properties, '$.properties');
    return (0, (/*@__PURE__*/$parcel$interopDefault($kG7B1)))(propertiesWithoutUndefined);
};
// This function will essentially deepClone as well
const $4b54556ec3f3e859$var$nestedRemoveUndefinedValues = (obj, path)=>{
    const recursionDepthLimit = 512;
    const nestedRemoveUndefinedValuesImpl = (source, processedReferences, path, depth)=>{
        if (source === null || typeof source !== 'object') return source;
        // If the level of nesting is egregiously excessive we'll stop processing any further to
        // avoid crashing due to stack exhaustion, instead we return a note object.
        if (depth > recursionDepthLimit) return {
            _depthLimitExceeded: true,
            message: `Object nesting depth limit exceeded at path '${path}' with depth '${depth}'`
        };
        // If this object has already been seen then processing it would create a circular reference,
        // instead we return a note object.
        if (processedReferences.has(source)) {
            const originalPath = processedReferences.get(source);
            return {
                _circularReference: true,
                message: `Circular reference to object at original path '${originalPath}' detected at path '${path}'`,
                originalPath: originalPath
            };
        }
        processedReferences.set(source, path);
        const clone = {};
        Object.keys(source).forEach((key)=>{
            const value = source[key];
            if (value !== undefined) {
                if (Array.isArray(value)) {
                    const newArray = [];
                    value.forEach((v, i)=>{
                        const newValue = nestedRemoveUndefinedValuesImpl(v, processedReferences, `${path}.${key}[${i}]`, depth + 1);
                        if (newValue !== undefined) newArray.push(newValue);
                    });
                    clone[key] = newArray;
                } else {
                    const newValue = nestedRemoveUndefinedValuesImpl(value, processedReferences, `${path}.${key}`, depth + 1);
                    if (newValue !== undefined) clone[key] = newValue;
                }
            }
        });
        processedReferences.delete(source);
        return clone;
    };
    return nestedRemoveUndefinedValuesImpl(obj, new Map(), path, 0);
};

});
parcelRegister("kG7B1", function(module, exports) {
'use strict';

var $fJ6iH = parcelRequire("fJ6iH");
/**
 * Expose `traverse`.
 */ module.exports = $f0dd9f5775ab1645$var$traverse;
/**
 * Recursively traverse an object or array, and convert
 * all ISO date strings parse into Date objects.
 *
 * @param {Object} input - object, array, or string to convert
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $f0dd9f5775ab1645$var$traverse(input, strict) {
    if (strict === undefined) strict = true;
    if (input && typeof input === 'object') return $f0dd9f5775ab1645$var$traverseObject(input, strict);
    else if (Array.isArray(input)) return $f0dd9f5775ab1645$var$traverseArray(input, strict);
    else if ($fJ6iH.is(input, strict)) return $fJ6iH.parse(input);
    return input;
}
/**
 * Object traverser helper function.
 *
 * @param {Object} obj - object to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $f0dd9f5775ab1645$var$traverseObject(obj, strict) {
    Object.keys(obj).forEach(function(key) {
        obj[key] = $f0dd9f5775ab1645$var$traverse(obj[key], strict);
    });
    return obj;
}
/**
 * Array traverser helper function
 *
 * @param {Array} arr - array to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Array}
 */ function $f0dd9f5775ab1645$var$traverseArray(arr, strict) {
    arr.forEach(function(value, index) {
        arr[index] = $f0dd9f5775ab1645$var$traverse(value, strict);
    });
    return arr;
}

});
parcelRegister("fJ6iH", function(module, exports) {
$parcel$export(module.exports, "parse", () => $b72ff22c8840a238$export$98e6a39c04603d36, (v) => $b72ff22c8840a238$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "is", () => $b72ff22c8840a238$export$226b3eccf92c9ed9, (v) => $b72ff22c8840a238$export$226b3eccf92c9ed9 = v);
/**
 * Convert an ISO date string to a date. Fallback to native `Date.parse`.
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 *
 * @param {String} iso
 * @return {Date}
 */ var $b72ff22c8840a238$export$98e6a39c04603d36;
/**
 * Checks whether a `string` is an ISO date string. `strict` mode requires that
 * the date string at least have a year, month and date.
 *
 * @param {String} string
 * @param {Boolean} strict
 * @return {Boolean}
 */ var $b72ff22c8840a238$export$226b3eccf92c9ed9;
'use strict';
/**
 * Matcher, slightly modified from:
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 */ var $b72ff22c8840a238$var$matcher = /^(\d{4})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:([ T])(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
$b72ff22c8840a238$export$98e6a39c04603d36 = function(iso) {
    var numericKeys = [
        1,
        5,
        6,
        7,
        11,
        12
    ];
    var arr = $b72ff22c8840a238$var$matcher.exec(iso);
    var offset = 0;
    // fallback to native parsing
    if (!arr) return new Date(iso);
    /* eslint-disable no-cond-assign */ // remove undefined values
    for(var i = 0, val; val = numericKeys[i]; i++)arr[val] = parseInt(arr[val], 10) || 0;
    /* eslint-enable no-cond-assign */ // allow undefined days and months
    arr[2] = parseInt(arr[2], 10) || 1;
    arr[3] = parseInt(arr[3], 10) || 1;
    // month is 0-11
    arr[2]--;
    // allow abitrary sub-second precision
    arr[8] = arr[8] ? (arr[8] + '00').substring(0, 3) : 0;
    // apply timezone if one exists
    if (arr[4] === ' ') offset = new Date().getTimezoneOffset();
    else if (arr[9] !== 'Z' && arr[10]) {
        offset = arr[11] * 60 + arr[12];
        if (arr[10] === '+') offset = 0 - offset;
    }
    var millis = Date.UTC(arr[1], arr[2], arr[3], arr[5], arr[6] + offset, arr[7], arr[8]);
    return new Date(millis);
};
$b72ff22c8840a238$export$226b3eccf92c9ed9 = function(string, strict) {
    if (typeof string !== 'string') return false;
    if (strict && /^\d{4}-\d{2}-\d{2}/.test(string) === false) return false;
    return $b72ff22c8840a238$var$matcher.test(string);
};

});




parcelRegister("kxRFZ", function(module, exports) {
$parcel$export(module.exports, "MetadataClient", () => $6572b008ef5144c2$export$1ac223ae496131c9);

var $9VNiM = parcelRequire("9VNiM");

var $kbQhy = parcelRequire("kbQhy");

var $bIxux = parcelRequire("bIxux");
var $56dlt = parcelRequire("56dlt");

var $5ASKr = parcelRequire("5ASKr");

var $dy9Sx = parcelRequire("dy9Sx");

var $49cIJ = parcelRequire("49cIJ");

var $dInNc = parcelRequire("dInNc");

var $lJTLf = parcelRequire("lJTLf");

var $8NY6g = parcelRequire("8NY6g");
var $6572b008ef5144c2$var$_MetadataClient;
class $6572b008ef5144c2$export$1ac223ae496131c9 {
    /**
   * Starts the metadata client. This will start the scheduler and begin
   * fetching metadata.
   *
   * @param allowRestart - If false, the client will not be restarted if it has already been stopped
   *						 by a call to stop().
   */ start(allowRestart) {
        if (this._isEnabled || this._hasBeenStopped && !allowRestart) return;
        this._isEnabled = true;
        this.startNetworkStatusMonitor();
        setTimeout(()=>{
            this._scheduler.schedule({
                immediate: true
            });
        }, $6572b008ef5144c2$export$1ac223ae496131c9.INITIAL_REFRESH_DELAY);
    }
    stop() {
        if (!this._isEnabled) return;
        this._hasBeenStopped = true;
        this._isEnabled = false;
        this.stopNetworkStatusMonitor();
        this._scheduler.stop();
        this._fetchAbortController?.abort();
        this.resetPropertyChangeRefresh();
    }
    startNetworkStatusMonitor() {
        if (this._networkStatus) return;
        this._networkStatus = new (0, $9VNiM.default)((status)=>{
            if (status === (0, $5ASKr.NetworkStatusEnum).OFFLINE) this._scheduler.stop();
            else if (this._isEnabled) this._scheduler.schedule({
                immediate: this._metadataInfo === null
            });
        });
    }
    stopNetworkStatusMonitor() {
        if (this._networkStatus) {
            this._networkStatus.removeListeners();
            this._networkStatus = null;
        }
    }
    async refreshMetadataAsync() {
        if ((0, $49cIJ.TestSupport).areFetchCallsDisabled() || !this._isEnabled) return Promise.resolve();
        this._fetchAbortController?.abort();
        this._fetchAbortController = new AbortController();
        const fetchAbortSignal = this._fetchAbortController.signal;
        this._lastFetchRequestCount = this._scheduler.getFailureCount();
        await (0, $lJTLf.fetchMetadata)(this._url, {
            product: this._product,
            userInfo: this._userInfo,
            tenantInfo: this._tenantInfo
        }, (0, $dInNc.DEFAULT_METADATA_REQUEST_TIMEOUT), fetchAbortSignal).then(async (response)=>{
            const metadata = await response.json();
            this._metadataInfo = (0, $8NY6g.MetadataResponse).fromJson(metadata);
            this._lastFetchRequestCount++;
            this._requestStatus = 'FETCHED';
            this._lastErrorReason = null;
        }).catch((error)=>{
            if (fetchAbortSignal.aborted) // This request was aborted, so we don't need to handle it.
            return;
            this._requestStatus = 'FAILED';
            if (error instanceof (0, $8NY6g.FetchError) && [
                429,
                503
            ].includes(error.statusCode)) this._lastErrorReason = 'ServerBusyError';
            else this._lastErrorReason = error instanceof Error && (0, $8NY6g.ALLOW_LISTED_FETCH_ERROR_NAMES).includes(error.name) ? error.name : 'Unknown';
            throw error;
        });
    }
    getMetadataAsync() {
        return Promise.resolve(this._metadataInfo);
    }
    get status() {
        return this._requestStatus;
    }
    get lastErrorReason() {
        return this._lastErrorReason;
    }
    get lastFetchRequestCount() {
        return this._lastFetchRequestCount;
    }
    get userInfo() {
        return this._userInfo;
    }
    set userInfo(userInfo) {
        if (this._userInfo?.userId === userInfo?.userId && this._userInfo?.userIdType === userInfo?.userIdType) return;
        this._userInfo = userInfo;
        this.schedulePropertyChangeRefresh();
    }
    get tenantInfo() {
        return this._tenantInfo;
    }
    set tenantInfo(tenantInfo) {
        if (this._tenantInfo?.tenantId === tenantInfo?.tenantId && this._tenantInfo?.tenantIdType === tenantInfo?.tenantIdType) return;
        this._tenantInfo = tenantInfo;
        this.schedulePropertyChangeRefresh();
    }
    get metrics() {
        return {
            host: this._metadataHost,
            status: this.status,
            lastErrorReason: this.lastErrorReason,
            lastRefreshRequestCount: this.lastFetchRequestCount
        };
    }
    async scheduleCallback(done) {
        if (this._networkStatus?.getNetworkStatus() === (0, $5ASKr.NetworkStatusEnum).OFFLINE) {
            done((0, $56dlt.DoneState).NOOP);
            return;
        }
        try {
            await this.refreshMetadataAsync();
            done((0, $56dlt.DoneState).SUCCESS);
            this._scheduler.schedule();
        } catch (error) {
            done((0, $56dlt.DoneState).ERROR);
        }
    }
    /**
   * Schedules a refresh of the metadata when the user or tenant info changes. There is
   * a short delay to allow for multiple changes to be batched together, such as when the
   * callers sets the user info and tenant info in quick succession.
   */ schedulePropertyChangeRefresh() {
        if (!this._isEnabled) return;
        this.resetPropertyChangeRefresh();
        this._propertyChangeRefreshTimeout = setTimeout(()=>{
            this.resetPropertyChangeRefresh();
            this._scheduler.schedule({
                immediate: true
            });
        }, (0, $dInNc.DEFAULT_METADATA_PROPERTY_CHANGE_REFRESH_INTERVAL));
    }
    resetPropertyChangeRefresh() {
        if (this._propertyChangeRefreshTimeout) {
            clearTimeout(this._propertyChangeRefreshTimeout);
            this._propertyChangeRefreshTimeout = null;
        }
    }
    buildOptions(options) {
        return {
            backoffFactor: options?.backoffFactor || (0, $kbQhy.DEFAULT_POLLING_OPTIONS).backoffFactor,
            backoffJitterPercentage: options?.backoffJitterPercentage !== undefined ? options.backoffJitterPercentage : (0, $kbQhy.DEFAULT_POLLING_OPTIONS).backoffJitterPercentage,
            batchFlushSize: options?.batchFlushSize || (0, $kbQhy.DEFAULT_POLLING_OPTIONS).batchFlushSize,
            flushBeforeUnload: options?.flushBeforeUnload || (0, $kbQhy.DEFAULT_POLLING_OPTIONS).flushBeforeUnload,
            flushWaitMs: options?.flushWaitMs || (0, $kbQhy.DEFAULT_POLLING_OPTIONS).flushWaitMs,
            maxItems: options?.maxItems || (0, $kbQhy.DEFAULT_POLLING_OPTIONS).maxItems,
            maxAttempts: options?.maxAttempts || (0, $kbQhy.DEFAULT_POLLING_OPTIONS).maxAttempts,
            maxRetryDelay: options?.maxRetryDelay || (0, $kbQhy.DEFAULT_POLLING_OPTIONS).maxRetryDelay,
            minRetryDelay: options?.minRetryDelay || (0, $kbQhy.DEFAULT_POLLING_OPTIONS).minRetryDelay
        };
    }
    constructor(apiHostProtocol, apiHost, product){
        this._userInfo = void 0;
        this._tenantInfo = void 0;
        this._url = void 0;
        this._metadataHost = void 0;
        this._product = void 0;
        this._metadataInfo = void 0;
        this._requestStatus = void 0;
        this._lastFetchRequestCount = void 0;
        this._options = void 0;
        this._scheduler = void 0;
        this._networkStatus = void 0;
        this._lastErrorReason = void 0;
        this._fetchAbortController = void 0;
        this._hasBeenStopped = void 0;
        this._isEnabled = void 0;
        this._propertyChangeRefreshTimeout = void 0;
        this._userInfo = {
            anonymousId: ''
        };
        this._tenantInfo = {};
        this._url = `${apiHostProtocol}://${apiHost}/metadata`;
        this._product = product;
        this._metadataInfo = null;
        this._requestStatus = 'PENDING';
        this._lastFetchRequestCount = 0;
        this._lastErrorReason = null;
        this._fetchAbortController = null;
        this._hasBeenStopped = false;
        this._isEnabled = false;
        this._propertyChangeRefreshTimeout = null;
        const isStargateProxy = (0, $dy9Sx.isStargateProxyPath)({
            apiHost: apiHost
        });
        this._metadataHost = isStargateProxy ? 'PRODUCT_HOST' : apiHost;
        this._options = this.buildOptions({
            backoffFactor: 2,
            backoffJitterPercentage: 0.8,
            batchFlushSize: 7,
            flushBeforeUnload: false,
            flushWaitMs: 500,
            maxAttempts: 10,
            maxItems: 1000,
            minRetryDelay: (0, $dInNc.DEFAULT_METADATA_MIN_RETRY_DELAY),
            maxRetryDelay: (0, $dInNc.DEFAULT_METADATA_MAX_RETRY_DELAY)
        });
        this._scheduler = new (0, $bIxux.default)({
            ...this._options,
            waitInterval: (0, $dInNc.DEFAULT_METADATA_REFRESH_INTERVAL)
        }, this.scheduleCallback.bind(this));
        this._networkStatus = null;
    }
}
$6572b008ef5144c2$var$_MetadataClient = $6572b008ef5144c2$export$1ac223ae496131c9;
$6572b008ef5144c2$export$1ac223ae496131c9.INITIAL_REFRESH_DELAY = 1;
$6572b008ef5144c2$export$1ac223ae496131c9.Factory = (apiHostProtocol, apiHost, product)=>{
    return new $6572b008ef5144c2$var$_MetadataClient(apiHostProtocol, apiHost, product);
};

});
parcelRegister("dy9Sx", function(module, exports) {
$parcel$export(module.exports, "selectHost", () => $fba1c43c15edfa63$export$18c0b81944902eae);
$parcel$export(module.exports, "isStargateProxyPath", () => $fba1c43c15edfa63$export$83a9dd8d74be72c);

var $1RuJ0 = parcelRequire("1RuJ0");
const $fba1c43c15edfa63$var$PROD_HOST = 'as.atlassian.com/api/v1';
const $fba1c43c15edfa63$var$STARGATE_PROD_HOST = 'api-private.atlassian.com/gasv3/api/v1';
const $fba1c43c15edfa63$var$STAGING_HOST = 'as.staging.atl-paas.net/api/v1';
const $fba1c43c15edfa63$var$STARGATE_STAGING_HOST = 'api-private.stg.atlassian.com/gasv3/api/v1';
const $fba1c43c15edfa63$var$FEDRAMP_STAGING_HOST = 'as.staging.atl-paas-us-gov-mod.net/api/v1';
const $fba1c43c15edfa63$var$FEDRAMP_PROD_HOST = 'as.atlassian-us-gov-mod.com/api/v1';
const $fba1c43c15edfa63$var$STARGATE_FEDRAMP_STAGING_HOST = 'api.stg.atlassian-us-gov-mod.com/gasv3/api/v1';
const $fba1c43c15edfa63$var$STARGATE_FEDRAMP_PROD_HOST = 'api.atlassian-us-gov-mod.com/gasv3/api/v1';
const $fba1c43c15edfa63$var$STARGATE_PROXY_PATH = '/gateway/api/gasv3/api/v1';
const $fba1c43c15edfa63$var$handleFedRampModerate = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, envOverride: envOverride })=>{
    if (env === (0, $1RuJ0.envType).LOCAL || env === (0, $1RuJ0.envType).DEV) throw Error('No LOCAL or DEV environments for FedRAMP.');
    if (env === (0, $1RuJ0.envType).PROD && envOverride) throw Error('Cannot override to FedRAMP Sandbox for Prod.');
    if (!useStargate) return env === (0, $1RuJ0.envType).PROD ? $fba1c43c15edfa63$var$FEDRAMP_PROD_HOST : $fba1c43c15edfa63$var$FEDRAMP_STAGING_HOST;
    if (useLegacyUrl) return env === (0, $1RuJ0.envType).PROD ? $fba1c43c15edfa63$var$STARGATE_FEDRAMP_PROD_HOST : $fba1c43c15edfa63$var$STARGATE_FEDRAMP_STAGING_HOST;
    /**
	 * Stargate proxy path now needs to be the default to work around browser restrictions with cookies.
	 * For more details, see:
	 *  - https://experimentation-platform.atlassian.net/browse/MHD-326, and
	 *  - https://hello.atlassian.net/wiki/spaces/I/pages/1217206437/api-private+is+broken+is+your+product+impacted
	 */ return window.location.host + $fba1c43c15edfa63$var$STARGATE_PROXY_PATH;
};
const $fba1c43c15edfa63$var$handleCommercial = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl })=>{
    if (!useStargate) return env === (0, $1RuJ0.envType).PROD ? $fba1c43c15edfa63$var$PROD_HOST : $fba1c43c15edfa63$var$STAGING_HOST;
    if (useLegacyUrl) return env === (0, $1RuJ0.envType).PROD ? $fba1c43c15edfa63$var$STARGATE_PROD_HOST : $fba1c43c15edfa63$var$STARGATE_STAGING_HOST;
    /**
	 * Stargate proxy path now needs to be the default to work around browser restrictions with cookies.
	 * For more details, see:
	 *  - https://experimentation-platform.atlassian.net/browse/MHD-326, and
	 *  - https://hello.atlassian.net/wiki/spaces/I/pages/1217206437/api-private+is+broken+is+your+product+impacted
	 */ return window.location.host + $fba1c43c15edfa63$var$STARGATE_PROXY_PATH;
};
function $fba1c43c15edfa63$export$18c0b81944902eae({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, perimeter: perimeter, ic: ic, envOverride: envOverride }) {
    if (ic) {
        if (useLegacyUrl) throw Error('IC is set but useLegacyUrl is true.');
        throw Error('IC is set but no apiHost provided.');
    }
    if (perimeter === (0, $1RuJ0.perimeterType).FEDRAMP_MODERATE) return $fba1c43c15edfa63$var$handleFedRampModerate({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl,
        envOverride: envOverride
    });
    return $fba1c43c15edfa63$var$handleCommercial({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl
    });
}
function $fba1c43c15edfa63$export$83a9dd8d74be72c({ apiHost: apiHost }) {
    return apiHost === window.location.host + $fba1c43c15edfa63$var$STARGATE_PROXY_PATH;
}

});

parcelRegister("49cIJ", function(module, exports) {
$parcel$export(module.exports, "TestSupport", () => $e0af56d23e9a1151$export$44b578549c42d779);
class $e0af56d23e9a1151$export$44b578549c42d779 {
    static isGeminiVREnvironment() {
        try {
            for(const k in globalThis){
                if (k.startsWith('__gemini_') && k.endsWith('__')) return true;
            }
        } catch (e) {
        // ignore
        }
        return false;
    }
    static areMetadataCallsDisabled() {
        return this.areFetchCallsDisabled() || this.getGlobalBooleanProperty($e0af56d23e9a1151$export$44b578549c42d779.DISABLE_METADATA_CALLS_PROPERTY);
    }
    static areEventCallsDisabled() {
        return this.areFetchCallsDisabled() || this.getGlobalBooleanProperty($e0af56d23e9a1151$export$44b578549c42d779.DISABLE_EVENT_CALLS_PROPERTY);
    }
    static areFetchCallsDisabled() {
        return this.getGlobalBooleanProperty($e0af56d23e9a1151$export$44b578549c42d779.DISABLE_FETCH_CALLS_PROPERTY);
    }
    static getSyntheticFlagOverride() {
        return this.getGlobalTriStateProperty($e0af56d23e9a1151$export$44b578549c42d779.SYNTHETIC_FLAG_OVERRIDE_PROPERTY);
    }
    static getGlobalBooleanProperty(propertyName) {
        if (globalThis && globalThis.hasOwnProperty(propertyName)) return globalThis[propertyName] === true;
        return false;
    }
    static getGlobalTriStateProperty(propertyName) {
        if (globalThis && globalThis.hasOwnProperty(propertyName)) {
            const value = globalThis[propertyName];
            if (typeof value === 'boolean') return value;
        }
        return undefined;
    }
}
$e0af56d23e9a1151$export$44b578549c42d779.DISABLE_METADATA_CALLS_PROPERTY = '__awc_disable_metadata_calls__';
$e0af56d23e9a1151$export$44b578549c42d779.DISABLE_EVENT_CALLS_PROPERTY = '__awc_disable_event_calls__';
$e0af56d23e9a1151$export$44b578549c42d779.DISABLE_FETCH_CALLS_PROPERTY = '__awc_disable_fetch_calls__';
$e0af56d23e9a1151$export$44b578549c42d779.SYNTHETIC_FLAG_OVERRIDE_PROPERTY = '__awc_synthetic_flag_override__';

});

parcelRegister("lJTLf", function(module, exports) {
$parcel$export(module.exports, "fetchMetadata", () => $6f0f9cdccbdcbd4a$export$55b0d0261469055);

var $8V6O9 = parcelRequire("8V6O9");

var $8NY6g = parcelRequire("8NY6g");
const $6f0f9cdccbdcbd4a$export$55b0d0261469055 = async (url, params, timeout, signal)=>{
    const requestAbortController = $6f0f9cdccbdcbd4a$var$createRequestAbortController(timeout, signal);
    const corsOptions = $6f0f9cdccbdcbd4a$var$getCorsForUrl(url);
    const metadataUrl = url + '?' + new URLSearchParams({
        product: `${params.product}`,
        userId: `${params.userInfo?.userId || ''}`,
        userIdType: `${params.userInfo?.userIdType || ''}`,
        tenantId: `${params.tenantInfo?.tenantId || ''}`,
        tenantIdType: `${params.tenantInfo?.tenantIdType || ''}`
    }).toString();
    const response = await fetch(metadataUrl, {
        method: 'GET',
        signal: requestAbortController.signal,
        ...corsOptions
    });
    // Response must be a 200 (we expect a JSON response, so 204 is not valid for instance)
    if (response.status !== 200) throw new (0, $8NY6g.FetchError)(`Metadata: HTTP Error ${response.status} (${response.statusText})`, response.status, response.statusText);
    return response;
};
const $6f0f9cdccbdcbd4a$var$createRequestAbortController = (timeout, signal)=>{
    const abortController = new AbortController();
    setTimeout(()=>{
        abortController.abort();
    }, timeout || 30000);
    signal?.addEventListener('abort', ()=>{
        abortController.abort();
    });
    return abortController;
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
const $6f0f9cdccbdcbd4a$var$getCorsForUrl = (0, $8V6O9.default)((url)=>{
    const origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: 'cors',
        credentials: 'include'
    };
});

});


parcelRegister("fPqPr", function(module, exports) {
$parcel$export(module.exports, "default", () => $74fe7afdaa9cbb75$export$2e2bcd8739ae039);

var $1RuJ0 = parcelRequire("1RuJ0");

var $k0wX2 = parcelRequire("k0wX2");
class $74fe7afdaa9cbb75$export$2e2bcd8739ae039 {
    constructor(){
        this._originStore = void 0;
        this.handleOriginParameters = (originParamHandlerMapping, historyReplaceFn)=>{
            // Collect all the parameter labels to be handled
            const originParamLabelList = Object.keys(originParamHandlerMapping);
            if (!(originParamLabelList.length > 0)) throw new Error('Empty parameter mapping provided');
            // Check if the parameter labels are valid. If any invalid labels are found throw an exception.
            const invalidParams = originParamLabelList.filter((x)=>Object.values((0, $1RuJ0.originTracingType)).indexOf(x) < 0);
            if (invalidParams.length > 0) throw new Error(`Invalid Origin Tracing Parameter(s) supplied: ${invalidParams.join()}!`);
            const isCaptureParam = (_, key)=>originParamLabelList.indexOf(key) >= 0;
            // Capture and remove params from URL
            const capturedURLParams = (0, $k0wX2.default)(isCaptureParam, historyReplaceFn);
            // Apply provided handler function to extract origin trace ID from each URL parameter
            const applyHandlerFunction = (key)=>{
                const x = originParamHandlerMapping[key](capturedURLParams[key]);
                return {
                    [key]: x
                };
            };
            const extractedOriginID = Object.keys(capturedURLParams).map(applyHandlerFunction).reduce((accumulator, currentValue)=>Object.assign(accumulator, currentValue), {});
            return extractedOriginID;
        };
        this._originStore = {};
    }
}

});

parcelRegister("5JbDb", function(module, exports) {
$parcel$export(module.exports, "default", () => $6258bdb25d0af708$export$2e2bcd8739ae039);

var $iF8MW = parcelRequire("iF8MW");
// WARNING: The value of SESSION_ID_STORAGE_KEY is relied upon by other Platform packages
// (eg. search-page, product-search-dialog). If you need to change this key, you MUST
// notify the dependant Platform teams and update all dependent packages accordingly.
const $6258bdb25d0af708$var$SESSION_ID_STORAGE_KEY = 'session.id';
const $6258bdb25d0af708$var$SESSION_EXPIRY_STORAGE_KEY = 'session.expiry';
const $6258bdb25d0af708$var$ONLY_NUMBERS_REGEX = /^\d+$/;
const $6258bdb25d0af708$export$285f6bddd927a06d = 1800000; // 30 minutes
const $6258bdb25d0af708$export$a92e915d70316eb2 = 5000; // 5 seconds
const $6258bdb25d0af708$export$de43760b2dc10c19 = 0.9; // 90% of expiry
const $6258bdb25d0af708$export$5702a91a6f42969f = ()=>{};
class $6258bdb25d0af708$export$2e2bcd8739ae039 {
    getCurrentSessionId() {
        const sessionId = this._safeLocalStorage.getItem($6258bdb25d0af708$var$SESSION_ID_STORAGE_KEY);
        const sessionExpiry = parseInt(this._safeLocalStorage.getItem($6258bdb25d0af708$var$SESSION_EXPIRY_STORAGE_KEY) || '0', 10) || 0;
        this._debouncedUpdateSessionExpiry(sessionExpiry);
        if (!sessionId || sessionExpiry <= Date.now() || Number.isNaN(sessionExpiry)) return this._generateNewSessionId();
        // Old versions of sessionId were UUIDs which caused issues for Amplitude which only accepts
        // integers for this field. In these scenarios we want to regenerate the sessionId as an integer
        if (!$6258bdb25d0af708$var$ONLY_NUMBERS_REGEX.test(sessionId)) return this._generateNewSessionId();
        return sessionId;
    }
    constructor(options = {}){
        this._safeLocalStorage = void 0;
        this._sessionExpiryTime = void 0;
        this._sessionExpiryDebounce = void 0;
        this._sessionExpiryDebounceThresholdPercentage = void 0;
        this._sessionExpiryDebounceTimer = void 0;
        this._onNewSessionStarted = void 0;
        this._generateNewSessionId = ()=>{
            const newSessionId = Date.now().toString();
            this._safeLocalStorage.setItem($6258bdb25d0af708$var$SESSION_ID_STORAGE_KEY, newSessionId);
            // COMMENTS-123 - When a new session starts, call the callback if it is given
            this._onNewSessionStarted && this._onNewSessionStarted();
            return newSessionId;
        };
        this._updateSessionExpiry = ()=>{
            const expiry = Date.now() + this._sessionExpiryTime;
            this._safeLocalStorage.setItem($6258bdb25d0af708$var$SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
            return expiry;
        };
        this._debouncedUpdateSessionExpiry = (currentExpiry)=>{
            const { _updateSessionExpiry: _updateSessionExpiry } = this;
            // If the current expiry is out of date by more than 10% of the expiry, update immediately
            if (currentExpiry < Date.now() + this._sessionExpiryDebounceThresholdPercentage * this._sessionExpiryTime) _updateSessionExpiry();
            else {
                if (this._sessionExpiryDebounceTimer) clearTimeout(this._sessionExpiryDebounceTimer);
                // @ts-ignore Something wrong with our types... this is legit
                this._sessionExpiryDebounceTimer = setTimeout(()=>{
                    _updateSessionExpiry();
                }, this._sessionExpiryDebounce);
            }
        };
        this._sessionExpiryTime = options.sessionExpiryTime || $6258bdb25d0af708$export$285f6bddd927a06d;
        this._sessionExpiryDebounce = options.sessionExpiryDebounce || $6258bdb25d0af708$export$a92e915d70316eb2;
        this._sessionExpiryDebounceThresholdPercentage = options.sessionExpiryDebounceThresholdPercentage || $6258bdb25d0af708$export$de43760b2dc10c19;
        this._onNewSessionStarted = options.onNewSessionStarted ? options.onNewSessionStarted : $6258bdb25d0af708$export$5702a91a6f42969f;
        this._safeLocalStorage = new (0, $iF8MW.default)();
    }
}

});

parcelRegister("dxiIz", function(module, exports) {
$parcel$export(module.exports, "default", () => $175b05bc754c4270$export$2e2bcd8739ae039);

var $9DqcB = parcelRequire("9DqcB");

var $7yCTl = parcelRequire("7yCTl");
class $175b05bc754c4270$export$2e2bcd8739ae039 extends (0, $7yCTl.default) {
    constructor(options){
        let storageToUse;
        try {
            storageToUse = globalThis.sessionStorage || (0, $9DqcB.default);
        } catch (err) {
            storageToUse = (0, $9DqcB.default);
        }
        super(storageToUse, options);
    }
}

});

parcelRegister("kk1PE", function(module, exports) {
$parcel$export(module.exports, "default", () => $03170dd043fbeee0$export$2e2bcd8739ae039);

var $dxiIz = parcelRequire("dxiIz");

var $3ohfK = parcelRequire("3ohfK");
const $03170dd043fbeee0$var$STORAGE_KEY = 'tab.id';
class $03170dd043fbeee0$export$2e2bcd8739ae039 {
    getCurrentTabId() {
        let tabId = this._safeSessionStorage.getItem($03170dd043fbeee0$var$STORAGE_KEY);
        if (!tabId) tabId = this._generateNewTabId();
        return tabId;
    }
    constructor(){
        this._safeSessionStorage = void 0;
        this._generateNewTabId = ()=>{
            const newTabId = (0, $3ohfK.default)();
            this._safeSessionStorage.setItem($03170dd043fbeee0$var$STORAGE_KEY, newTabId);
            return newTabId;
        };
        this._safeSessionStorage = new (0, $dxiIz.default)();
    }
}

});

parcelRegister("ctMxd", function(module, exports) {
$parcel$export(module.exports, "default", () => $59052ecae0536576$export$2e2bcd8739ae039);

var $eRyv5 = parcelRequire("eRyv5");

var $1RuJ0 = parcelRequire("1RuJ0");

var $j3v0M = parcelRequire("j3v0M");

var $dxiIz = parcelRequire("dxiIz");

var $k0wX2 = parcelRequire("k0wX2");

var $3ohfK = parcelRequire("3ohfK");
const $59052ecae0536576$var$STORAGE_KEY = 'taskSessions';
const $59052ecae0536576$var$INIT_KEY = 'taskSessionsInit';
const $59052ecae0536576$var$AWC_PARAM_PREFIX = 'awc.';
const $59052ecae0536576$var$TASK_SESSION_RELOAD_TIME = 3000;
class $59052ecae0536576$export$2e2bcd8739ae039 {
    constructor(){
        this._safeSessionStorage = void 0;
        this._taskSessionsNotRecentlyInitialised = (currentTimestamp)=>this._safeSessionStorage.getItem($59052ecae0536576$var$STORAGE_KEY) === null || this._safeSessionStorage.getItem($59052ecae0536576$var$INIT_KEY) === null || parseInt(this._safeSessionStorage.getItem($59052ecae0536576$var$INIT_KEY) || '0', 10) < currentTimestamp - $59052ecae0536576$var$TASK_SESSION_RELOAD_TIME;
        this._removeTaskSessionPrefix = (_, taskSessionName)=>taskSessionName.split($59052ecae0536576$var$AWC_PARAM_PREFIX)[1];
        this._isTaskSessionQueryParam = (_, taskSessionName)=>taskSessionName.startsWith($59052ecae0536576$var$AWC_PARAM_PREFIX);
        this.getAllTaskSessions = ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($59052ecae0536576$var$STORAGE_KEY) || '');
            } catch  {
                return {};
            }
        };
        this._writeToSessionStorage = (taskSessions)=>{
            try {
                this._safeSessionStorage.setItem($59052ecae0536576$var$STORAGE_KEY, JSON.stringify(taskSessions));
            // eslint-disable-next-line no-empty
            } catch  {}
        };
        this._appendTaskSessions = (newTaskSessions)=>{
            const currentState = this.getAllTaskSessions();
            const newState = currentState === null ? newTaskSessions : Object.assign(currentState, newTaskSessions);
            this._writeToSessionStorage(newState);
        };
        this._safelyRemoveKey = (currentState, taskSessionName)=>{
            if (currentState === null) return {};
            delete currentState[taskSessionName];
            return currentState;
        };
        this.createTaskSession = (taskSessionName)=>{
            const taskSessionId = (0, $3ohfK.default)();
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
            return taskSessionId;
        };
        this.createTaskSessionWithProvidedId = (taskSessionName, taskSessionId)=>{
            if (typeof taskSessionId !== 'string') throw new TypeError('invalid taskSessionId, must be string');
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
        };
        this.completeTaskSession = (taskSessionName)=>{
            const currentState = this.getAllTaskSessions();
            const updatedState = this._safelyRemoveKey(currentState, taskSessionName);
            this._writeToSessionStorage(updatedState);
        };
        this.formatTaskSessionQueryString = ({ uri: uri, includedTaskSessions: includedTaskSessions })=>{
            const { url: url, query: query } = (0, $eRyv5.parseUrl)(uri);
            const currentState = this.getAllTaskSessions();
            // Use specified task sessions, otherwise all tasksessions excluding originTracing sessions
            const filteredTaskSessions = includedTaskSessions ? (0, $j3v0M.pick)(currentState, includedTaskSessions) : (0, $j3v0M.omit)(currentState, Object.values((0, $1RuJ0.originTracingType)));
            if (Object.keys(filteredTaskSessions).length === 0) return uri;
            const queryWithTaskSessions = {
                ...(0, $j3v0M.mapKeys)(filteredTaskSessions, (_, taskSessionName)=>$59052ecae0536576$var$AWC_PARAM_PREFIX + taskSessionName),
                ...query
            };
            return `${url}?${(0, $eRyv5.stringify)(queryWithTaskSessions)}`;
        };
        this.stripQueryParameters = ()=>{
            const extractedTaskSessions = (0, $j3v0M.mapKeys)((0, $k0wX2.default)(this._isTaskSessionQueryParam), this._removeTaskSessionPrefix);
            this._appendTaskSessions(extractedTaskSessions);
        };
        const _currentTimestamp = Date.now();
        this._safeSessionStorage = new (0, $dxiIz.default)();
        // Wrapping all sessionStorage calls in try catch to stop any error propogation, taskSessions should gracefully fail.
        try {
            if (this._taskSessionsNotRecentlyInitialised(_currentTimestamp)) {
                this._writeToSessionStorage({});
                this._safeSessionStorage.setItem($59052ecae0536576$var$INIT_KEY, _currentTimestamp.toString());
            }
        // eslint-disable-next-line no-empty
        } catch  {}
    }
}

});

parcelRegister("5Akh6", function(module, exports) {
$parcel$export(module.exports, "default", () => $6d21789c92ab5367$export$2e2bcd8739ae039);

var $8jInb = parcelRequire("8jInb");

var $bdD5u = parcelRequire("bdD5u");

var $49cIJ = parcelRequire("49cIJ");
const $6d21789c92ab5367$var$MAX_CACHE_SIZE = 100;
const $6d21789c92ab5367$var$COOKIE_NAME = (0, $bdD5u.AllAnalyticsCookies).AWC_ANALYTICS_DEBUG.getKey();
const $6d21789c92ab5367$var$DEBUG_TAG = 'synthetic';
class $6d21789c92ab5367$var$TestingCache {
    saveEvent(event) {
        try {
            if (!event) return;
            this.bind();
            this.addSyntheticTag(event);
            this.cache(event);
        } catch  {
        // Ignore errors from testing cache.
        }
    }
    bind() {
        if (!this.shouldCacheEvent() || typeof window === 'undefined' || window.testAnalytics) return;
        window.testAnalytics = {
            eventCache: [],
            events: ()=>window.testAnalytics.eventCache,
            clear: ()=>{
                window.testAnalytics.eventCache = [];
                try {
                    localStorage.removeItem('awc.ui.viewed.last.sent');
                    localStorage.removeItem('awc-staging.ui.viewed.last.sent');
                    localStorage.removeItem('awc-dev.ui.viewed.last.sent');
                    localStorage.removeItem('awc-local.ui.viewed.last.sent');
                } catch  {
                // Ignore errors from localStorage.
                }
            }
        };
    }
    cache(event) {
        if (!this.shouldCacheEvent() || typeof window === 'undefined' || !window.testAnalytics) return;
        if (window.testAnalytics.eventCache.length >= $6d21789c92ab5367$var$MAX_CACHE_SIZE) window.testAnalytics.eventCache = window.testAnalytics.eventCache.slice(1, window.testAnalytics.eventCache.length);
        window.testAnalytics.eventCache.push(event);
    }
    addSyntheticTag(event) {
        if (!this.shouldSetSyntheticFlag()) return;
        if (event.tags instanceof Array) {
            if (!event.tags.includes($6d21789c92ab5367$var$DEBUG_TAG)) event.tags.push($6d21789c92ab5367$var$DEBUG_TAG);
        } else event.tags = [
            $6d21789c92ab5367$var$DEBUG_TAG
        ];
    }
    shouldCacheEvent() {
        return this._enableTestingCache ? this._enableTestingCache : this._isDebugCookieEnabled;
    }
    shouldSetSyntheticFlag() {
        if (this._syntheticFlagOverride !== undefined) return this._syntheticFlagOverride;
        const globalSyntheticOverride = (0, $49cIJ.TestSupport).getSyntheticFlagOverride();
        if (globalSyntheticOverride !== undefined) return globalSyntheticOverride;
        return this.shouldCacheEvent();
    }
    static getDebugCookie() {
        try {
            return JSON.parse((0, (/*@__PURE__*/$parcel$interopDefault($8jInb))).get($6d21789c92ab5367$var$COOKIE_NAME) || 'false') === true;
        } catch  {
            (0, (/*@__PURE__*/$parcel$interopDefault($8jInb))).remove($6d21789c92ab5367$var$COOKIE_NAME);
        }
        return false;
    }
    constructor(syntheticFlagOverride, enableTestingCache){
        this._isDebugCookieEnabled = void 0;
        this._syntheticFlagOverride = void 0;
        this._enableTestingCache = void 0;
        this._syntheticFlagOverride = typeof syntheticFlagOverride === 'boolean' ? syntheticFlagOverride : undefined;
        this._enableTestingCache = typeof enableTestingCache === 'boolean' ? enableTestingCache : undefined;
        this._isDebugCookieEnabled = $6d21789c92ab5367$var$TestingCache.getDebugCookie();
        this.bind();
    }
}
var $6d21789c92ab5367$export$2e2bcd8739ae039 = $6d21789c92ab5367$var$TestingCache;

});

parcelRegister("gSdvR", function(module, exports) {
$parcel$export(module.exports, "default", () => $34bc135cb98d81bf$export$2e2bcd8739ae039);

var $1RuJ0 = parcelRequire("1RuJ0");

var $aue37 = parcelRequire("aue37");

var $iF8MW = parcelRequire("iF8MW");
const $34bc135cb98d81bf$var$DEFAULT_DELAY = 2000; // 2 seconds
const $34bc135cb98d81bf$var$DEFAULT_THROTTLE = 3600000; // 1 hour
const $34bc135cb98d81bf$var$DEFAULT_STORAGE_KEY = 'ui.viewed.last.sent';
const $34bc135cb98d81bf$var$DEFAULT_MALFORMED_UIVIEWED_EVENT = 'malformed.uiviewed.last.sent';
class $34bc135cb98d81bf$export$2e2bcd8739ae039 {
    constructor(productInfo, getContext, onEvent, settings = {}){
        this._blurListener = void 0;
        this._delay = void 0;
        this._focusListener = void 0;
        this._getContext = void 0;
        this._intervalId = void 0;
        this._onEvent = void 0;
        this._product = void 0;
        this._productInfo = void 0;
        this._safeLocalStorage = void 0;
        this._storageKey = void 0;
        this._malformedEventStorageKey = void 0;
        this._throttle = void 0;
        this.start = ()=>{
            this._startInterval();
            this._bindEventListeners();
        };
        this.stop = ()=>{
            this._stopInterval();
            this._unbindEventListeners();
        };
        this.resetTimers = ()=>{
            if (this._intervalId) {
                this.stop();
                this.start();
            }
        };
        this._bindEventListeners = ()=>{
            if (typeof window !== 'undefined') {
                window.addEventListener('focus', this._focusListener);
                window.addEventListener('blur', this._blurListener);
            }
        };
        this._unbindEventListeners = ()=>{
            if (typeof window !== 'undefined') {
                window.removeEventListener('focus', this._focusListener);
                window.removeEventListener('blur', this._blurListener);
            }
        };
        this._startInterval = ()=>{
            clearInterval(this._intervalId);
            this._intervalId = setInterval(this._handleInterval, this._delay);
        };
        this._stopInterval = ()=>{
            if (this._intervalId) {
                clearInterval(this._intervalId);
                this._intervalId = null;
            }
        };
        this._getProductKey = (product, subproduct)=>{
            let productKey = product;
            if (subproduct) productKey += `-${subproduct}`;
            return productKey;
        };
        this._getLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._storageKey) || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            const p = t[productKey] || null;
            return p;
        };
        this._parseLocalStorageData = (key)=>{
            const data = this._safeLocalStorage.getItem(key);
            try {
                return JSON.parse(data || '');
            } catch (error) {
                this._safeLocalStorage.removeItem(key);
                return null;
            }
        };
        this._getMalformedLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._malformedEventStorageKey) || {};
            const finalUserId = userId || 'NOT_SET';
            const finalTenantId = tenantId || 'NOT_SET';
            const u = json[finalUserId] || {};
            const t = u[finalTenantId] || {};
            const p = t[productKey] || null;
            return p;
        };
        this._setLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._storageKey) || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            t[productKey] = Date.now();
            u[tenantId] = t;
            json[userId] = u;
            this._safeLocalStorage.setItem(this._storageKey, JSON.stringify(json));
        };
        this._setMalformedLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._malformedEventStorageKey) || {};
            const finalUserId = userId || 'NOT_SET';
            const finalTenantId = tenantId || 'NOT_SET';
            const u = json[finalUserId] || {};
            const t = u[finalTenantId] || {};
            t[productKey] = Date.now();
            u[finalTenantId] = t;
            json[finalUserId] = u;
            this._safeLocalStorage.setItem(this._malformedEventStorageKey, JSON.stringify(json));
        };
        this._shouldSendEvent = (productKey, tenantIdType, tenantId, userId)=>{
            const document = (0, $aue37.getDocument)();
            if (document && !document.hasFocus()) return 'FocusLost';
            // TENANT OR USER ID NOT SET
            if (tenantIdType !== (0, $1RuJ0.tenantType).NONE && !tenantId || !userId) {
                const sinceLastSent = Date.now() - this._getMalformedLastSentTimestamp(productKey, tenantId, userId);
                if (sinceLastSent === null || sinceLastSent > this._throttle) return 'UserOrTenantIncomplete';
                return 'MalformedUiViewedRateLimited';
            }
            const sinceLastSent = Date.now() - this._getLastSentTimestamp(productKey, tenantId, userId);
            if (sinceLastSent === null || sinceLastSent > this._throttle) return 'EligibleToSend';
            return 'UiViewedRateLimited';
        };
        this._handleInterval = ()=>{
            const { embeddedProduct: embeddedProduct, ...context } = this._getContext();
            this._sendEvent(this._product, context);
            if (embeddedProduct) this._sendEvent(embeddedProduct, context, true);
        };
        this._sendEvent = (product, context, isEmbeddedProduct = false)=>{
            const { subproduct: subproduct, tenantIdType: tenantIdType, tenantId: tenantId, userId: userId, lastScreenEvent: lastScreenEvent, attributes: attributes } = context;
            const productKey = this._getProductKey(product, subproduct);
            const shouldSendEventTriggerStatus = this._shouldSendEvent(productKey, tenantIdType, tenantId, userId);
            switch(shouldSendEventTriggerStatus){
                case 'EligibleToSend':
                    this._setLastSentTimestamp(productKey, tenantId, userId);
                    this._onEvent(this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes, 'ui', 'viewed'));
                    break;
                case 'UserOrTenantIncomplete':
                    this._setMalformedLastSentTimestamp(productKey, tenantId, userId);
                    this._onEvent(this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes, 'malformed', 'uiviewed'));
                    break;
                default:
                    break;
            }
        };
        this._createEvent = (product, subproduct, isEmbeddedProduct, lastScreenEvent, extraAttributes, actionSubject, action)=>{
            const event = {
                product: product,
                source: 'ui',
                action: action,
                actionSubject: actionSubject,
                attributes: extraAttributes
            };
            if (isEmbeddedProduct) {
                // Clear the subproduct and version as they don't relate to the embedded product
                event.subproduct = null;
                event.version = null;
                event.attributes = {
                    ...event.attributes,
                    embeddedInEnv: this._productInfo.env,
                    embeddedInProduct: this._productInfo.product,
                    embeddedInSubproduct: subproduct,
                    embeddedInVersion: this._productInfo.version,
                    embeddedInOrigin: this._productInfo.origin,
                    embeddedInPlatform: this._productInfo.platform
                };
            }
            if (lastScreenEvent) event.attributes = {
                ...event.attributes,
                lastScreenEvent: {
                    name: lastScreenEvent.name,
                    attributes: lastScreenEvent.attributes
                }
            };
            return event;
        };
        if (!productInfo) throw new Error('Missing productInfo');
        if (!productInfo.product) throw new Error('Missing productInfo.product');
        if (!getContext) throw new Error('Missing getContext callback');
        if (typeof getContext !== 'function') throw new Error('Invalid getContext, must be function');
        if (!onEvent) throw new Error('Missing onEvent callback');
        if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
        this._productInfo = productInfo;
        this._product = productInfo.product;
        this._getContext = getContext;
        this._onEvent = onEvent;
        this._delay = settings.delay || $34bc135cb98d81bf$var$DEFAULT_DELAY;
        this._throttle = settings.throttle || $34bc135cb98d81bf$var$DEFAULT_THROTTLE;
        this._storageKey = settings.storageKey || $34bc135cb98d81bf$var$DEFAULT_STORAGE_KEY;
        this._malformedEventStorageKey = settings.malformedStorageKey || $34bc135cb98d81bf$var$DEFAULT_MALFORMED_UIVIEWED_EVENT;
        this._safeLocalStorage = new (0, $iF8MW.default)({
            envPrefix: this._productInfo.env
        });
        this._focusListener = ()=>{
            this._startInterval();
        };
        this._blurListener = ()=>{
            this._stopInterval();
        };
    }
}

});
parcelRegister("aue37", function(module, exports) {
$parcel$export(module.exports, "getDocument", () => $51040ec07a1488ab$export$f65ca476c09acec0);
const $51040ec07a1488ab$export$f65ca476c09acec0 = ()=>{
    if (typeof document !== 'undefined') return document;
    return null;
};

});


parcelRegister("8thuK", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d6ed812f685345d$export$2e2bcd8739ae039);
function $4d6ed812f685345d$export$2e2bcd8739ae039(callback, event) {
    if (!callback || typeof callback !== 'function') return null;
    return ()=>{
        callback(event);
    };
}

});

parcelRegister("h6jy8", function(module, exports) {
$parcel$export(module.exports, "XIDPromise", () => $a5714a07b6bba1e3$export$fbe53bbbe682bcdd);

var $gtIda = parcelRequire("gtIda");
const $a5714a07b6bba1e3$export$fbe53bbbe682bcdd = (xidConsent, xidPromiseFn)=>{
    if (xidConsent && xidPromiseFn && typeof xidPromiseFn === 'function') {
        const timeoutPromise = ()=>{
            return new Promise((resolve)=>{
                setTimeout(()=>resolve(()=>(0, $gtIda.createTimeoutXid)()), (0, $gtIda.XID_TIMEOUT));
            });
        };
        const xidPromise = ()=>{
            return xidPromiseFn().catch(()=>()=>(0, $gtIda.createUnknownXid)());
        };
        return Promise.race([
            xidPromise(),
            timeoutPromise()
        ]);
    }
    return undefined;
};

});
parcelRegister("gtIda", function(module, exports) {
$parcel$export(module.exports, "XID_TIMEOUT", () => $e7ee8e0d726dbca8$export$545bcbd53afabfa3);
$parcel$export(module.exports, "createTimeoutXid", () => $e7ee8e0d726dbca8$export$af4087e36d63846);
$parcel$export(module.exports, "createUnknownXid", () => $e7ee8e0d726dbca8$export$fa341d0c750d705b);

var $7g1UM = parcelRequire("7g1UM");
const $e7ee8e0d726dbca8$export$545bcbd53afabfa3 = 5000;
const $e7ee8e0d726dbca8$export$af4087e36d63846 = ()=>[
        {
            type: (0, $7g1UM.XIDItemType).XC,
            state: 'TIMEOUT'
        },
        {
            type: (0, $7g1UM.XIDItemType).UID,
            state: 'TIMEOUT'
        }
    ];
const $e7ee8e0d726dbca8$export$fa341d0c750d705b = ()=>[
        {
            type: (0, $7g1UM.XIDItemType).XC,
            state: 'UNKNOWN'
        },
        {
            type: (0, $7g1UM.XIDItemType).UID,
            state: 'UNKNOWN'
        }
    ];

});
parcelRegister("7g1UM", function(module, exports) {
$parcel$export(module.exports, "XIDItemType", () => $b7b96a80131c6bbb$export$92ca0438bcb0d396);
var $b7b96a80131c6bbb$export$92ca0438bcb0d396 = /*#__PURE__*/ function(XIDItemType) {
    XIDItemType["XC"] = "xc";
    XIDItemType["UID"] = "uid";
    return XIDItemType;
}({});
var $b7b96a80131c6bbb$export$c9079017d1f5aab9 = /*#__PURE__*/ function(XIDState) {
    XIDState["NEW"] = "NEW";
    XIDState["CHANGED"] = "CHANGED";
    XIDState["EXISTING"] = "EXISTING";
    XIDState["TIMEOUT"] = "TIMEOUT";
    XIDState["ERROR"] = "ERROR";
    XIDState["UNAVAILABLE"] = "UNAVAILABLE";
    XIDState["MALFORMED"] = "MALFORMED";
    XIDState["UNKNOWN"] = "UNKNOWN";
    return XIDState;
}({});

});




parcelRegister("9pfwj", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';

var $jcj59 = parcelRequire("jcj59");

var $f5FWH = parcelRequire("f5FWH");
exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;
exports.Url = Url;
function Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.host = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.query = null;
    this.pathname = null;
    this.path = null;
    this.href = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i, portPattern = /:[0-9]*$/, // Special case for a simple path URL
simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, // RFC 2396: characters reserved for delimiting URLs.
// We actually just auto-escape these.
delims = [
    '<',
    '>',
    '"',
    '`',
    ' ',
    '\r',
    '\n',
    '\t'
], // RFC 2396: characters not allowed for various reasons.
unwise = [
    '{',
    '}',
    '|',
    '\\',
    '^',
    '`'
].concat(delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
autoEscape = [
    '\''
].concat(unwise), // Characters that are never ever allowed in a hostname.
// Note that any invalid chars are also handled, but these
// are the ones that are *expected* to be seen, so we fast-path
// them.
nonHostChars = [
    '%',
    '/',
    '?',
    ';',
    '#'
].concat(autoEscape), hostEndingChars = [
    '/',
    '?',
    '#'
], hostnameMaxLen = 255, hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
unsafeProtocol = {
    'javascript': true,
    'javascript:': true
}, // protocols that never have a hostname.
hostlessProtocol = {
    'javascript': true,
    'javascript:': true
}, // protocols that always contain a // bit.
slashedProtocol = {
    'http': true,
    'https': true,
    'ftp': true,
    'gopher': true,
    'file': true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
};

var $akwht = parcelRequire("akwht");
function urlParse(url, parseQueryString, slashesDenoteHost) {
    if (url && $f5FWH.isObject(url) && url instanceof Url) return url;
    var u = new Url;
    u.parse(url, parseQueryString, slashesDenoteHost);
    return u;
}
Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
    if (!$f5FWH.isString(url)) throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
    // Copy chrome, IE, opera backslash-handling behavior.
    // Back slashes before the query string get converted to forward slashes
    // See: https://code.google.com/p/chromium/issues/detail?id=25916
    var queryIndex = url.indexOf('?'), splitter = queryIndex !== -1 && queryIndex < url.indexOf('#') ? '?' : '#', uSplit = url.split(splitter), slashRegex = /\\/g;
    uSplit[0] = uSplit[0].replace(slashRegex, '/');
    url = uSplit.join(splitter);
    var rest = url;
    // trim before proceeding.
    // This is to support parse stuff like "  http://foo.com  \n"
    rest = rest.trim();
    if (!slashesDenoteHost && url.split('#').length === 1) {
        // Try fast path regexp
        var simplePath = simplePathPattern.exec(rest);
        if (simplePath) {
            this.path = rest;
            this.href = rest;
            this.pathname = simplePath[1];
            if (simplePath[2]) {
                this.search = simplePath[2];
                if (parseQueryString) this.query = $akwht.parse(this.search.substr(1));
                else this.query = this.search.substr(1);
            } else if (parseQueryString) {
                this.search = '';
                this.query = {};
            }
            return this;
        }
    }
    var proto = protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto.length);
    }
    // figure out if it's got a host
    // user@server is *always* interpreted as a hostname, and url
    // resolution will treat //foo/bar as host=foo,path=bar because that's
    // how the browser resolves relative URLs.
    if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
        var slashes = rest.substr(0, 2) === '//';
        if (slashes && !(proto && hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
        // there's a hostname.
        // the first instance of /, ?, ;, or # ends the host.
        //
        // If there is an @ in the hostname, then non-host chars *are* allowed
        // to the left of the last @ sign, unless some host-ending character
        // comes *before* the @-sign.
        // URLs are obnoxious.
        //
        // ex:
        // http://a@b@c/ => user:a@b host:c
        // http://a@b?@c => user:a host:c path:/?@c
        // v0.12 TODO(isaacs): This is not quite how Chrome does things.
        // Review our test case against browsers more comprehensively.
        // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(var i = 0; i < hostEndingChars.length; i++){
            var hec = rest.indexOf(hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // at this point, either we have an explicit point where the
        // auth portion cannot go past, or the last @ char is the decider.
        var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf('@');
        else // atSign must be in auth portion.
        // http://a@b/c@d => host:b auth:a path:/c@d
        atSign = rest.lastIndexOf('@', hostEnd);
        // Now we have a portion which is definitely the auth.
        // Pull that off.
        if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = decodeURIComponent(auth);
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(var i = 0; i < nonHostChars.length; i++){
            var hec = rest.indexOf(nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost();
        // we've indicated that there is a hostname,
        // so even if it's empty, it has to be present.
        this.hostname = this.hostname || '';
        // if hostname begins with [ and ends with ]
        // assume that it's an IPv6 address.
        var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(var i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match(hostnamePartPattern)) {
                    var newpart = '';
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) // we replace non-ASCII char with a temporary placeholder
                    // we need this to make sure size of hostname is not
                    // broken by replacing non-ASCII by nothing
                    newpart += 'x';
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match(hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match(hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = '/' + notHost.join('.') + rest;
                        this.hostname = validParts.join('.');
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > hostnameMaxLen) this.hostname = '';
        else // hostnames are always lower case.
        this.hostname = this.hostname.toLowerCase();
        if (!ipv6Hostname) // IDNA Support: Returns a punycoded representation of "domain".
        // It only converts parts of the domain name that
        // have non-ASCII characters, i.e. it doesn't matter if
        // you call it with a domain that already is ASCII-only.
        this.hostname = $jcj59.toASCII(this.hostname);
        var p = this.port ? ':' + this.port : '';
        var h = this.hostname || '';
        this.host = h + p;
        this.href += this.host;
        // strip [ and ] from the hostname
        // the host field still retains them, though
        if (ipv6Hostname) {
            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
            if (rest[0] !== '/') rest = '/' + rest;
        }
    }
    // now rest is set to the post-host stuff.
    // chop off any delim chars.
    if (!unsafeProtocol[lowerProto]) // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for(var i = 0, l = autoEscape.length; i < l; i++){
        var ae = autoEscape[i];
        if (rest.indexOf(ae) === -1) continue;
        var esc = encodeURIComponent(ae);
        if (esc === ae) esc = escape(ae);
        rest = rest.split(ae).join(esc);
    }
    // chop off from the tail first.
    var hash = rest.indexOf('#');
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf('?');
    if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString) this.query = $akwht.parse(this.query);
        rest = rest.slice(0, qm);
    } else if (parseQueryString) {
        // no query string, but parseQueryString still requested
        this.search = '';
        this.query = {};
    }
    if (rest) this.pathname = rest;
    if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = '/';
    //to support http.request
    if (this.pathname || this.search) {
        var p = this.pathname || '';
        var s = this.search || '';
        this.path = p + s;
    }
    // finally, reconstruct the href based on what has been validated.
    this.href = this.format();
    return this;
};
// format a parsed object into a url string
function urlFormat(obj) {
    // ensure it's an object, and not a string url.
    // If it's an obj, this is a no-op.
    // this way, you can call url_format() on strings
    // to clean up potentially wonky urls.
    if ($f5FWH.isString(obj)) obj = urlParse(obj);
    if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
    return obj.format();
}
Url.prototype.format = function() {
    var auth = this.auth || '';
    if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ':');
        auth += '@';
    }
    var protocol = this.protocol || '', pathname = this.pathname || '', hash = this.hash || '', host = false, query = '';
    if (this.host) host = auth + this.host;
    else if (this.hostname) {
        host = auth + (this.hostname.indexOf(':') === -1 ? this.hostname : '[' + this.hostname + ']');
        if (this.port) host += ':' + this.port;
    }
    if (this.query && $f5FWH.isObject(this.query) && Object.keys(this.query).length) query = $akwht.stringify(this.query);
    var search = this.search || query && '?' + query || '';
    if (protocol && protocol.substr(-1) !== ':') protocol += ':';
    // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
    // unless they had them to begin with.
    if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
        host = '//' + (host || '');
        if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
    } else if (!host) host = '';
    if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
    if (search && search.charAt(0) !== '?') search = '?' + search;
    pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
    });
    search = search.replace('#', '%23');
    return protocol + host + pathname + search + hash;
};
function urlResolve(source, relative) {
    return urlParse(source, false, true).resolve(relative);
}
Url.prototype.resolve = function(relative) {
    return this.resolveObject(urlParse(relative, false, true)).format();
};
function urlResolveObject(source, relative) {
    if (!source) return relative;
    return urlParse(source, false, true).resolveObject(relative);
}
Url.prototype.resolveObject = function(relative) {
    if ($f5FWH.isString(relative)) {
        var rel = new Url();
        rel.parse(relative, false, true);
        relative = rel;
    }
    var result = new Url();
    var tkeys = Object.keys(this);
    for(var tk = 0; tk < tkeys.length; tk++){
        var tkey = tkeys[tk];
        result[tkey] = this[tkey];
    }
    // hash is always overridden, no matter what.
    // even href="" will remove it.
    result.hash = relative.hash;
    // if the relative url is empty, then there's nothing left to do here.
    if (relative.href === '') {
        result.href = result.format();
        return result;
    }
    // hrefs like //foo/bar always cut to the protocol.
    if (relative.slashes && !relative.protocol) {
        // take everything except the protocol from relative
        var rkeys = Object.keys(relative);
        for(var rk = 0; rk < rkeys.length; rk++){
            var rkey = rkeys[rk];
            if (rkey !== 'protocol') result[rkey] = relative[rkey];
        }
        //urlParse appends trailing / to urls like http://www.example.com
        if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) result.path = result.pathname = '/';
        result.href = result.format();
        return result;
    }
    if (relative.protocol && relative.protocol !== result.protocol) {
        // if it's a known url protocol, then changing
        // the protocol does weird things
        // first, if it's not file:, then we MUST have a host,
        // and if there was a path
        // to begin with, then we MUST have a path.
        // if it is file:, then the host is dropped,
        // because that's known to be hostless.
        // anything else is assumed to be absolute.
        if (!slashedProtocol[relative.protocol]) {
            var keys = Object.keys(relative);
            for(var v = 0; v < keys.length; v++){
                var k = keys[v];
                result[k] = relative[k];
            }
            result.href = result.format();
            return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !hostlessProtocol[relative.protocol]) {
            var relPath = (relative.pathname || '').split('/');
            while(relPath.length && !(relative.host = relPath.shift()));
            if (!relative.host) relative.host = '';
            if (!relative.hostname) relative.hostname = '';
            if (relPath[0] !== '') relPath.unshift('');
            if (relPath.length < 2) relPath.unshift('');
            result.pathname = relPath.join('/');
        } else result.pathname = relative.pathname;
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || '';
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        // to support http.request
        if (result.pathname || result.search) {
            var p = result.pathname || '';
            var s = result.search || '';
            result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
    }
    var isSourceAbs = result.pathname && result.pathname.charAt(0) === '/', isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === '/', mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split('/') || [], relPath = relative.pathname && relative.pathname.split('/') || [], psychotic = result.protocol && !slashedProtocol[result.protocol];
    // if the url is a non-slashed url, then relative
    // links like ../.. should be able
    // to crawl up to the hostname, as well.  This is strange.
    // result.protocol has already been set by now.
    // Later on, put the first path part into the host field.
    if (psychotic) {
        result.hostname = '';
        result.port = null;
        if (result.host) {
            if (srcPath[0] === '') srcPath[0] = result.host;
            else srcPath.unshift(result.host);
        }
        result.host = '';
        if (relative.protocol) {
            relative.hostname = null;
            relative.port = null;
            if (relative.host) {
                if (relPath[0] === '') relPath[0] = relative.host;
                else relPath.unshift(relative.host);
            }
            relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
    }
    if (isRelAbs) {
        // it's absolute.
        result.host = relative.host || relative.host === '' ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === '' ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
    // fall through to the dot-handling below.
    } else if (relPath.length) {
        // it's relative
        // throw away the existing file, and take the new path instead.
        if (!srcPath) srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
    } else if (!$f5FWH.isNullOrUndefined(relative.search)) {
        // just pull out the search.
        // like href='?foo'.
        // Put this after the other two cases because it simplifies the booleans
        if (psychotic) {
            result.hostname = result.host = srcPath.shift();
            //occationaly the auth can get stuck only in host
            //this especially happens in cases like
            //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
            var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
            if (authInHost) {
                result.auth = authInHost.shift();
                result.host = result.hostname = authInHost.shift();
            }
        }
        result.search = relative.search;
        result.query = relative.query;
        //to support http.request
        if (!$f5FWH.isNull(result.pathname) || !$f5FWH.isNull(result.search)) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
        result.href = result.format();
        return result;
    }
    if (!srcPath.length) {
        // no path at all.  easy.
        // we've already handled the other stuff above.
        result.pathname = null;
        //to support http.request
        if (result.search) result.path = '/' + result.search;
        else result.path = null;
        result.href = result.format();
        return result;
    }
    // if a url ENDs in . or .., then it must get a trailing slash.
    // however, if it ends in anything else non-slashy,
    // then it must NOT get a trailing slash.
    var last = srcPath.slice(-1)[0];
    var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === '.' || last === '..') || last === '';
    // strip single dots, resolve double dots to parent dir
    // if the path tries to go above the root, `up` ends up > 0
    var up = 0;
    for(var i = srcPath.length; i >= 0; i--){
        last = srcPath[i];
        if (last === '.') srcPath.splice(i, 1);
        else if (last === '..') {
            srcPath.splice(i, 1);
            up++;
        } else if (up) {
            srcPath.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift('..');
    if (mustEndAbs && srcPath[0] !== '' && (!srcPath[0] || srcPath[0].charAt(0) !== '/')) srcPath.unshift('');
    if (hasTrailingSlash && srcPath.join('/').substr(-1) !== '/') srcPath.push('');
    var isAbsolute = srcPath[0] === '' || srcPath[0] && srcPath[0].charAt(0) === '/';
    // put the host back
    if (psychotic) {
        result.hostname = result.host = isAbsolute ? '' : srcPath.length ? srcPath.shift() : '';
        //occationaly the auth can get stuck only in host
        //this especially happens in cases like
        //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
        var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
        if (authInHost) {
            result.auth = authInHost.shift();
            result.host = result.hostname = authInHost.shift();
        }
    }
    mustEndAbs = mustEndAbs || result.host && srcPath.length;
    if (mustEndAbs && !isAbsolute) srcPath.unshift('');
    if (!srcPath.length) {
        result.pathname = null;
        result.path = null;
    } else result.pathname = srcPath.join('/');
    //to support request.http
    if (!$f5FWH.isNull(result.pathname) || !$f5FWH.isNull(result.search)) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
    result.auth = relative.auth || result.auth;
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
};
Url.prototype.parseHost = function() {
    var host = this.host;
    var port = portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ':') this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};

});
parcelRegister("jcj59", function(module, exports) {
(function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof $parcel$global == 'object' && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = '-', /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        'overflow': 'Overflow: input needs wider integers to process',
        'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
        'invalid-input': 'Invalid input'
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split('@');
        var result = '';
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + '@';
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, '\x2E');
        var labels = string.split('.');
        var encoded = map(labels, fn).join('.');
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = '';
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join('');
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * http://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error('not-basic');
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error('invalid-input');
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error('overflow');
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error('overflow');
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error('overflow');
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error('overflow');
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error('overflow');
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join('');
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? 'xn--' + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ 'version': '1.3.2',
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ 'ucs2': {
            'decode': ucs2decode,
            'encode': ucs2encode
        },
        'decode': decode,
        'encode': encode,
        'toASCII': toASCII,
        'toUnicode': toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) define('punycode', function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) freeModule.exports = punycode;
        else for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else root.punycode = punycode;
})(this);

});

parcelRegister("f5FWH", function(module, exports) {
'use strict';
module.exports = {
    isString: function(arg) {
        return typeof arg === 'string';
    },
    isObject: function(arg) {
        return typeof arg === 'object' && arg !== null;
    },
    isNull: function(arg) {
        return arg === null;
    },
    isNullOrUndefined: function(arg) {
        return arg == null;
    }
};

});

parcelRegister("akwht", function(module, exports) {
$parcel$export(module.exports, "parse", () => $7854cfee8cd61bc9$export$98e6a39c04603d36, (v) => $7854cfee8cd61bc9$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "stringify", () => $7854cfee8cd61bc9$export$fac44ee5b035f737, (v) => $7854cfee8cd61bc9$export$fac44ee5b035f737 = v);
var $7854cfee8cd61bc9$export$2f872c0f2117be69;
var $7854cfee8cd61bc9$export$98e6a39c04603d36;
var $7854cfee8cd61bc9$export$c564cdbbe6da493;
var $7854cfee8cd61bc9$export$fac44ee5b035f737;
'use strict';

$7854cfee8cd61bc9$export$2f872c0f2117be69 = $7854cfee8cd61bc9$export$98e6a39c04603d36 = (parcelRequire("31nsb"));

$7854cfee8cd61bc9$export$c564cdbbe6da493 = $7854cfee8cd61bc9$export$fac44ee5b035f737 = (parcelRequire("cGla8"));

});
parcelRegister("31nsb", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function $2333a878183610ad$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
module.exports = function(qs, sep, eq, options) {
    sep = sep || '&';
    eq = eq || '=';
    var obj = {};
    if (typeof qs !== 'string' || qs.length === 0) return obj;
    var regexp = /\+/g;
    qs = qs.split(sep);
    var maxKeys = 1000;
    if (options && typeof options.maxKeys === 'number') maxKeys = options.maxKeys;
    var len = qs.length;
    // maxKeys <= 0 means that we should not limit keys count
    if (maxKeys > 0 && len > maxKeys) len = maxKeys;
    for(var i = 0; i < len; ++i){
        var x = qs[i].replace(regexp, '%20'), idx = x.indexOf(eq), kstr, vstr, k, v;
        if (idx >= 0) {
            kstr = x.substr(0, idx);
            vstr = x.substr(idx + 1);
        } else {
            kstr = x;
            vstr = '';
        }
        k = decodeURIComponent(kstr);
        v = decodeURIComponent(vstr);
        if (!$2333a878183610ad$var$hasOwnProperty(obj, k)) obj[k] = v;
        else if ($2333a878183610ad$var$isArray(obj[k])) obj[k].push(v);
        else obj[k] = [
            obj[k],
            v
        ];
    }
    return obj;
};
var $2333a878183610ad$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === '[object Array]';
};

});

parcelRegister("cGla8", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $93b9d2b9eaea1aaf$var$stringifyPrimitive = function(v) {
    switch(typeof v){
        case 'string':
            return v;
        case 'boolean':
            return v ? 'true' : 'false';
        case 'number':
            return isFinite(v) ? v : '';
        default:
            return '';
    }
};
module.exports = function(obj, sep, eq, name) {
    sep = sep || '&';
    eq = eq || '=';
    if (obj === null) obj = undefined;
    if (typeof obj === 'object') return $93b9d2b9eaea1aaf$var$map($93b9d2b9eaea1aaf$var$objectKeys(obj), function(k) {
        var ks = encodeURIComponent($93b9d2b9eaea1aaf$var$stringifyPrimitive(k)) + eq;
        if ($93b9d2b9eaea1aaf$var$isArray(obj[k])) return $93b9d2b9eaea1aaf$var$map(obj[k], function(v) {
            return ks + encodeURIComponent($93b9d2b9eaea1aaf$var$stringifyPrimitive(v));
        }).join(sep);
        else return ks + encodeURIComponent($93b9d2b9eaea1aaf$var$stringifyPrimitive(obj[k]));
    }).join(sep);
    if (!name) return '';
    return encodeURIComponent($93b9d2b9eaea1aaf$var$stringifyPrimitive(name)) + eq + encodeURIComponent($93b9d2b9eaea1aaf$var$stringifyPrimitive(obj));
};
var $93b9d2b9eaea1aaf$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === '[object Array]';
};
function $93b9d2b9eaea1aaf$var$map(xs, f) {
    if (xs.map) return xs.map(f);
    var res = [];
    for(var i = 0; i < xs.length; i++)res.push(f(xs[i], i));
    return res;
}
var $93b9d2b9eaea1aaf$var$objectKeys = Object.keys || function(obj) {
    var res = [];
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
    return res;
};

});



parcelRegister("6oozB", function(module, exports) {
$parcel$export(module.exports, "useSyncExternalStore", () => $4a780bb62ac4687f$export$306c0aa65ff9ec16, (v) => $4a780bb62ac4687f$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4a780bb62ac4687f$export$306c0aa65ff9ec16;
"use strict";

var $dQwsT = parcelRequire("dQwsT");
function $4a780bb62ac4687f$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $4a780bb62ac4687f$var$objectIs = "function" === typeof Object.is ? Object.is : $4a780bb62ac4687f$var$is, $4a780bb62ac4687f$var$useState = $dQwsT.useState, $4a780bb62ac4687f$var$useEffect = $dQwsT.useEffect, $4a780bb62ac4687f$var$useLayoutEffect = $dQwsT.useLayoutEffect, $4a780bb62ac4687f$var$useDebugValue = $dQwsT.useDebugValue;
function $4a780bb62ac4687f$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $4a780bb62ac4687f$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $4a780bb62ac4687f$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $4a780bb62ac4687f$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $4a780bb62ac4687f$var$useEffect(function() {
        $4a780bb62ac4687f$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $4a780bb62ac4687f$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $4a780bb62ac4687f$var$useDebugValue(value);
    return value;
}
function $4a780bb62ac4687f$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$4a780bb62ac4687f$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $4a780bb62ac4687f$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $4a780bb62ac4687f$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $4a780bb62ac4687f$var$useSyncExternalStore$1 : $4a780bb62ac4687f$var$useSyncExternalStore$2;
$4a780bb62ac4687f$export$306c0aa65ff9ec16 = void 0 !== $dQwsT.useSyncExternalStore ? $dQwsT.useSyncExternalStore : $4a780bb62ac4687f$var$shim;

});

parcelRegister("8FP0N", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $aP01N = parcelRequire("aP01N");
function $6509b8efbc973b67$var$emptyFunction() {}
function $6509b8efbc973b67$var$emptyFunctionWithReset() {}
$6509b8efbc973b67$var$emptyFunctionWithReset.resetWarningCache = $6509b8efbc973b67$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $aP01N) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $6509b8efbc973b67$var$emptyFunctionWithReset,
        resetWarningCache: $6509b8efbc973b67$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("aP01N", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $7e0eb05ebfa4cf16$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $7e0eb05ebfa4cf16$var$ReactPropTypesSecret;

});


parcelRegister("90GGF", function(module, exports) {
$parcel$export(module.exports, "AsyncMode", () => $68f539eb64443dae$export$2b8d127b894957b9, (v) => $68f539eb64443dae$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $68f539eb64443dae$export$cea3a54a6425200c, (v) => $68f539eb64443dae$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $68f539eb64443dae$export$a7c73072b1a182ae, (v) => $68f539eb64443dae$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $68f539eb64443dae$export$9f27bc3417b4524d, (v) => $68f539eb64443dae$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $68f539eb64443dae$export$db77ccec0bb4ccac, (v) => $68f539eb64443dae$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $68f539eb64443dae$export$8392c0c9d3dcbd35, (v) => $68f539eb64443dae$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $68f539eb64443dae$export$ffb0004e005737fa, (v) => $68f539eb64443dae$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $68f539eb64443dae$export$b624eff549462981, (v) => $68f539eb64443dae$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $68f539eb64443dae$export$7897aa7841a5380c, (v) => $68f539eb64443dae$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $68f539eb64443dae$export$602eac185826482c, (v) => $68f539eb64443dae$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $68f539eb64443dae$export$e2c29f18771995cb, (v) => $68f539eb64443dae$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $68f539eb64443dae$export$5f8d39834fd61797, (v) => $68f539eb64443dae$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $68f539eb64443dae$export$74bf444e3cd11ea5, (v) => $68f539eb64443dae$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $68f539eb64443dae$export$92387174baf9b227, (v) => $68f539eb64443dae$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $68f539eb64443dae$export$ec112efeb987d9c6, (v) => $68f539eb64443dae$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $68f539eb64443dae$export$b706b080d889d2c9, (v) => $68f539eb64443dae$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $68f539eb64443dae$export$5be5a87408f70ddc, (v) => $68f539eb64443dae$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $68f539eb64443dae$export$45a5e7f76e0caa8d, (v) => $68f539eb64443dae$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $68f539eb64443dae$export$455c2e768291efa6, (v) => $68f539eb64443dae$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $68f539eb64443dae$export$9522e17588c12572, (v) => $68f539eb64443dae$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $68f539eb64443dae$export$2110ac352bb060b9, (v) => $68f539eb64443dae$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $68f539eb64443dae$export$56885ab8b9c456ab, (v) => $68f539eb64443dae$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $68f539eb64443dae$export$d927fcb6adf8f9de, (v) => $68f539eb64443dae$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $68f539eb64443dae$export$b82d16f27459e05a, (v) => $68f539eb64443dae$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $68f539eb64443dae$export$522c17b4f5e123e8, (v) => $68f539eb64443dae$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $68f539eb64443dae$export$1aabd8a0274ecfd6, (v) => $68f539eb64443dae$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $68f539eb64443dae$export$9b621391a187a31a, (v) => $68f539eb64443dae$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $68f539eb64443dae$export$f5bbd400c2f4426f, (v) => $68f539eb64443dae$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $68f539eb64443dae$export$2b8d127b894957b9;
var $68f539eb64443dae$export$cea3a54a6425200c;
var $68f539eb64443dae$export$a7c73072b1a182ae;
var $68f539eb64443dae$export$9f27bc3417b4524d;
var $68f539eb64443dae$export$db77ccec0bb4ccac;
var $68f539eb64443dae$export$8392c0c9d3dcbd35;
var $68f539eb64443dae$export$ffb0004e005737fa;
var $68f539eb64443dae$export$b624eff549462981;
var $68f539eb64443dae$export$7897aa7841a5380c;
var $68f539eb64443dae$export$602eac185826482c;
var $68f539eb64443dae$export$e2c29f18771995cb;
var $68f539eb64443dae$export$5f8d39834fd61797;
var $68f539eb64443dae$export$74bf444e3cd11ea5;
var $68f539eb64443dae$export$92387174baf9b227;
var $68f539eb64443dae$export$ec112efeb987d9c6;
var $68f539eb64443dae$export$b706b080d889d2c9;
var $68f539eb64443dae$export$5be5a87408f70ddc;
var $68f539eb64443dae$export$45a5e7f76e0caa8d;
var $68f539eb64443dae$export$455c2e768291efa6;
var $68f539eb64443dae$export$9522e17588c12572;
var $68f539eb64443dae$export$2110ac352bb060b9;
var $68f539eb64443dae$export$56885ab8b9c456ab;
var $68f539eb64443dae$export$d927fcb6adf8f9de;
var $68f539eb64443dae$export$b82d16f27459e05a;
var $68f539eb64443dae$export$522c17b4f5e123e8;
var $68f539eb64443dae$export$1aabd8a0274ecfd6;
var $68f539eb64443dae$export$9b621391a187a31a;
var $68f539eb64443dae$export$f5bbd400c2f4426f;
'use strict';
var $68f539eb64443dae$var$b = "function" === typeof Symbol && Symbol.for, $68f539eb64443dae$var$c = $68f539eb64443dae$var$b ? Symbol.for("react.element") : 60103, $68f539eb64443dae$var$d = $68f539eb64443dae$var$b ? Symbol.for("react.portal") : 60106, $68f539eb64443dae$var$e = $68f539eb64443dae$var$b ? Symbol.for("react.fragment") : 60107, $68f539eb64443dae$var$f = $68f539eb64443dae$var$b ? Symbol.for("react.strict_mode") : 60108, $68f539eb64443dae$var$g = $68f539eb64443dae$var$b ? Symbol.for("react.profiler") : 60114, $68f539eb64443dae$var$h = $68f539eb64443dae$var$b ? Symbol.for("react.provider") : 60109, $68f539eb64443dae$var$k = $68f539eb64443dae$var$b ? Symbol.for("react.context") : 60110, $68f539eb64443dae$var$l = $68f539eb64443dae$var$b ? Symbol.for("react.async_mode") : 60111, $68f539eb64443dae$var$m = $68f539eb64443dae$var$b ? Symbol.for("react.concurrent_mode") : 60111, $68f539eb64443dae$var$n = $68f539eb64443dae$var$b ? Symbol.for("react.forward_ref") : 60112, $68f539eb64443dae$var$p = $68f539eb64443dae$var$b ? Symbol.for("react.suspense") : 60113, $68f539eb64443dae$var$q = $68f539eb64443dae$var$b ? Symbol.for("react.suspense_list") : 60120, $68f539eb64443dae$var$r = $68f539eb64443dae$var$b ? Symbol.for("react.memo") : 60115, $68f539eb64443dae$var$t = $68f539eb64443dae$var$b ? Symbol.for("react.lazy") : 60116, $68f539eb64443dae$var$v = $68f539eb64443dae$var$b ? Symbol.for("react.block") : 60121, $68f539eb64443dae$var$w = $68f539eb64443dae$var$b ? Symbol.for("react.fundamental") : 60117, $68f539eb64443dae$var$x = $68f539eb64443dae$var$b ? Symbol.for("react.responder") : 60118, $68f539eb64443dae$var$y = $68f539eb64443dae$var$b ? Symbol.for("react.scope") : 60119;
function $68f539eb64443dae$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $68f539eb64443dae$var$c:
                switch(a = a.type, a){
                    case $68f539eb64443dae$var$l:
                    case $68f539eb64443dae$var$m:
                    case $68f539eb64443dae$var$e:
                    case $68f539eb64443dae$var$g:
                    case $68f539eb64443dae$var$f:
                    case $68f539eb64443dae$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $68f539eb64443dae$var$k:
                            case $68f539eb64443dae$var$n:
                            case $68f539eb64443dae$var$t:
                            case $68f539eb64443dae$var$r:
                            case $68f539eb64443dae$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $68f539eb64443dae$var$d:
                return u;
        }
    }
}
function $68f539eb64443dae$var$A(a) {
    return $68f539eb64443dae$var$z(a) === $68f539eb64443dae$var$m;
}
$68f539eb64443dae$export$2b8d127b894957b9 = $68f539eb64443dae$var$l;
$68f539eb64443dae$export$cea3a54a6425200c = $68f539eb64443dae$var$m;
$68f539eb64443dae$export$a7c73072b1a182ae = $68f539eb64443dae$var$k;
$68f539eb64443dae$export$9f27bc3417b4524d = $68f539eb64443dae$var$h;
$68f539eb64443dae$export$db77ccec0bb4ccac = $68f539eb64443dae$var$c;
$68f539eb64443dae$export$8392c0c9d3dcbd35 = $68f539eb64443dae$var$n;
$68f539eb64443dae$export$ffb0004e005737fa = $68f539eb64443dae$var$e;
$68f539eb64443dae$export$b624eff549462981 = $68f539eb64443dae$var$t;
$68f539eb64443dae$export$7897aa7841a5380c = $68f539eb64443dae$var$r;
$68f539eb64443dae$export$602eac185826482c = $68f539eb64443dae$var$d;
$68f539eb64443dae$export$e2c29f18771995cb = $68f539eb64443dae$var$g;
$68f539eb64443dae$export$5f8d39834fd61797 = $68f539eb64443dae$var$f;
$68f539eb64443dae$export$74bf444e3cd11ea5 = $68f539eb64443dae$var$p;
$68f539eb64443dae$export$92387174baf9b227 = function(a) {
    return $68f539eb64443dae$var$A(a) || $68f539eb64443dae$var$z(a) === $68f539eb64443dae$var$l;
};
$68f539eb64443dae$export$ec112efeb987d9c6 = $68f539eb64443dae$var$A;
$68f539eb64443dae$export$b706b080d889d2c9 = function(a) {
    return $68f539eb64443dae$var$z(a) === $68f539eb64443dae$var$k;
};
$68f539eb64443dae$export$5be5a87408f70ddc = function(a) {
    return $68f539eb64443dae$var$z(a) === $68f539eb64443dae$var$h;
};
$68f539eb64443dae$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $68f539eb64443dae$var$c;
};
$68f539eb64443dae$export$455c2e768291efa6 = function(a) {
    return $68f539eb64443dae$var$z(a) === $68f539eb64443dae$var$n;
};
$68f539eb64443dae$export$9522e17588c12572 = function(a) {
    return $68f539eb64443dae$var$z(a) === $68f539eb64443dae$var$e;
};
$68f539eb64443dae$export$2110ac352bb060b9 = function(a) {
    return $68f539eb64443dae$var$z(a) === $68f539eb64443dae$var$t;
};
$68f539eb64443dae$export$56885ab8b9c456ab = function(a) {
    return $68f539eb64443dae$var$z(a) === $68f539eb64443dae$var$r;
};
$68f539eb64443dae$export$d927fcb6adf8f9de = function(a) {
    return $68f539eb64443dae$var$z(a) === $68f539eb64443dae$var$d;
};
$68f539eb64443dae$export$b82d16f27459e05a = function(a) {
    return $68f539eb64443dae$var$z(a) === $68f539eb64443dae$var$g;
};
$68f539eb64443dae$export$522c17b4f5e123e8 = function(a) {
    return $68f539eb64443dae$var$z(a) === $68f539eb64443dae$var$f;
};
$68f539eb64443dae$export$1aabd8a0274ecfd6 = function(a) {
    return $68f539eb64443dae$var$z(a) === $68f539eb64443dae$var$p;
};
$68f539eb64443dae$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $68f539eb64443dae$var$e || a === $68f539eb64443dae$var$m || a === $68f539eb64443dae$var$g || a === $68f539eb64443dae$var$f || a === $68f539eb64443dae$var$p || a === $68f539eb64443dae$var$q || "object" === typeof a && null !== a && (a.$$typeof === $68f539eb64443dae$var$t || a.$$typeof === $68f539eb64443dae$var$r || a.$$typeof === $68f539eb64443dae$var$h || a.$$typeof === $68f539eb64443dae$var$k || a.$$typeof === $68f539eb64443dae$var$n || a.$$typeof === $68f539eb64443dae$var$w || a.$$typeof === $68f539eb64443dae$var$x || a.$$typeof === $68f539eb64443dae$var$y || a.$$typeof === $68f539eb64443dae$var$v);
};
$68f539eb64443dae$export$f5bbd400c2f4426f = $68f539eb64443dae$var$z;

});

parcelRegister("2wchC", function(module, exports) {
$parcel$export(module.exports, "AsyncMode", () => $1d58191ca8201f1f$export$2b8d127b894957b9, (v) => $1d58191ca8201f1f$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $1d58191ca8201f1f$export$cea3a54a6425200c, (v) => $1d58191ca8201f1f$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $1d58191ca8201f1f$export$a7c73072b1a182ae, (v) => $1d58191ca8201f1f$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $1d58191ca8201f1f$export$9f27bc3417b4524d, (v) => $1d58191ca8201f1f$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $1d58191ca8201f1f$export$db77ccec0bb4ccac, (v) => $1d58191ca8201f1f$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $1d58191ca8201f1f$export$8392c0c9d3dcbd35, (v) => $1d58191ca8201f1f$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $1d58191ca8201f1f$export$ffb0004e005737fa, (v) => $1d58191ca8201f1f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $1d58191ca8201f1f$export$b624eff549462981, (v) => $1d58191ca8201f1f$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $1d58191ca8201f1f$export$7897aa7841a5380c, (v) => $1d58191ca8201f1f$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $1d58191ca8201f1f$export$602eac185826482c, (v) => $1d58191ca8201f1f$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $1d58191ca8201f1f$export$e2c29f18771995cb, (v) => $1d58191ca8201f1f$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $1d58191ca8201f1f$export$5f8d39834fd61797, (v) => $1d58191ca8201f1f$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1d58191ca8201f1f$export$74bf444e3cd11ea5, (v) => $1d58191ca8201f1f$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $1d58191ca8201f1f$export$92387174baf9b227, (v) => $1d58191ca8201f1f$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $1d58191ca8201f1f$export$ec112efeb987d9c6, (v) => $1d58191ca8201f1f$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $1d58191ca8201f1f$export$b706b080d889d2c9, (v) => $1d58191ca8201f1f$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $1d58191ca8201f1f$export$5be5a87408f70ddc, (v) => $1d58191ca8201f1f$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $1d58191ca8201f1f$export$45a5e7f76e0caa8d, (v) => $1d58191ca8201f1f$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $1d58191ca8201f1f$export$455c2e768291efa6, (v) => $1d58191ca8201f1f$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $1d58191ca8201f1f$export$9522e17588c12572, (v) => $1d58191ca8201f1f$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $1d58191ca8201f1f$export$2110ac352bb060b9, (v) => $1d58191ca8201f1f$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $1d58191ca8201f1f$export$56885ab8b9c456ab, (v) => $1d58191ca8201f1f$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $1d58191ca8201f1f$export$d927fcb6adf8f9de, (v) => $1d58191ca8201f1f$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $1d58191ca8201f1f$export$b82d16f27459e05a, (v) => $1d58191ca8201f1f$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $1d58191ca8201f1f$export$522c17b4f5e123e8, (v) => $1d58191ca8201f1f$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $1d58191ca8201f1f$export$1aabd8a0274ecfd6, (v) => $1d58191ca8201f1f$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $1d58191ca8201f1f$export$9b621391a187a31a, (v) => $1d58191ca8201f1f$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $1d58191ca8201f1f$export$f5bbd400c2f4426f, (v) => $1d58191ca8201f1f$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1d58191ca8201f1f$export$2b8d127b894957b9;
var $1d58191ca8201f1f$export$cea3a54a6425200c;
var $1d58191ca8201f1f$export$a7c73072b1a182ae;
var $1d58191ca8201f1f$export$9f27bc3417b4524d;
var $1d58191ca8201f1f$export$db77ccec0bb4ccac;
var $1d58191ca8201f1f$export$8392c0c9d3dcbd35;
var $1d58191ca8201f1f$export$ffb0004e005737fa;
var $1d58191ca8201f1f$export$b624eff549462981;
var $1d58191ca8201f1f$export$7897aa7841a5380c;
var $1d58191ca8201f1f$export$602eac185826482c;
var $1d58191ca8201f1f$export$e2c29f18771995cb;
var $1d58191ca8201f1f$export$5f8d39834fd61797;
var $1d58191ca8201f1f$export$74bf444e3cd11ea5;
var $1d58191ca8201f1f$export$92387174baf9b227;
var $1d58191ca8201f1f$export$ec112efeb987d9c6;
var $1d58191ca8201f1f$export$b706b080d889d2c9;
var $1d58191ca8201f1f$export$5be5a87408f70ddc;
var $1d58191ca8201f1f$export$45a5e7f76e0caa8d;
var $1d58191ca8201f1f$export$455c2e768291efa6;
var $1d58191ca8201f1f$export$9522e17588c12572;
var $1d58191ca8201f1f$export$2110ac352bb060b9;
var $1d58191ca8201f1f$export$56885ab8b9c456ab;
var $1d58191ca8201f1f$export$d927fcb6adf8f9de;
var $1d58191ca8201f1f$export$b82d16f27459e05a;
var $1d58191ca8201f1f$export$522c17b4f5e123e8;
var $1d58191ca8201f1f$export$1aabd8a0274ecfd6;
var $1d58191ca8201f1f$export$9b621391a187a31a;
var $1d58191ca8201f1f$export$f5bbd400c2f4426f;
'use strict';
var $1d58191ca8201f1f$var$b = "function" === typeof Symbol && Symbol.for, $1d58191ca8201f1f$var$c = $1d58191ca8201f1f$var$b ? Symbol.for("react.element") : 60103, $1d58191ca8201f1f$var$d = $1d58191ca8201f1f$var$b ? Symbol.for("react.portal") : 60106, $1d58191ca8201f1f$var$e = $1d58191ca8201f1f$var$b ? Symbol.for("react.fragment") : 60107, $1d58191ca8201f1f$var$f = $1d58191ca8201f1f$var$b ? Symbol.for("react.strict_mode") : 60108, $1d58191ca8201f1f$var$g = $1d58191ca8201f1f$var$b ? Symbol.for("react.profiler") : 60114, $1d58191ca8201f1f$var$h = $1d58191ca8201f1f$var$b ? Symbol.for("react.provider") : 60109, $1d58191ca8201f1f$var$k = $1d58191ca8201f1f$var$b ? Symbol.for("react.context") : 60110, $1d58191ca8201f1f$var$l = $1d58191ca8201f1f$var$b ? Symbol.for("react.async_mode") : 60111, $1d58191ca8201f1f$var$m = $1d58191ca8201f1f$var$b ? Symbol.for("react.concurrent_mode") : 60111, $1d58191ca8201f1f$var$n = $1d58191ca8201f1f$var$b ? Symbol.for("react.forward_ref") : 60112, $1d58191ca8201f1f$var$p = $1d58191ca8201f1f$var$b ? Symbol.for("react.suspense") : 60113, $1d58191ca8201f1f$var$q = $1d58191ca8201f1f$var$b ? Symbol.for("react.suspense_list") : 60120, $1d58191ca8201f1f$var$r = $1d58191ca8201f1f$var$b ? Symbol.for("react.memo") : 60115, $1d58191ca8201f1f$var$t = $1d58191ca8201f1f$var$b ? Symbol.for("react.lazy") : 60116, $1d58191ca8201f1f$var$v = $1d58191ca8201f1f$var$b ? Symbol.for("react.block") : 60121, $1d58191ca8201f1f$var$w = $1d58191ca8201f1f$var$b ? Symbol.for("react.fundamental") : 60117, $1d58191ca8201f1f$var$x = $1d58191ca8201f1f$var$b ? Symbol.for("react.responder") : 60118, $1d58191ca8201f1f$var$y = $1d58191ca8201f1f$var$b ? Symbol.for("react.scope") : 60119;
function $1d58191ca8201f1f$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $1d58191ca8201f1f$var$c:
                switch(a = a.type, a){
                    case $1d58191ca8201f1f$var$l:
                    case $1d58191ca8201f1f$var$m:
                    case $1d58191ca8201f1f$var$e:
                    case $1d58191ca8201f1f$var$g:
                    case $1d58191ca8201f1f$var$f:
                    case $1d58191ca8201f1f$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $1d58191ca8201f1f$var$k:
                            case $1d58191ca8201f1f$var$n:
                            case $1d58191ca8201f1f$var$t:
                            case $1d58191ca8201f1f$var$r:
                            case $1d58191ca8201f1f$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $1d58191ca8201f1f$var$d:
                return u;
        }
    }
}
function $1d58191ca8201f1f$var$A(a) {
    return $1d58191ca8201f1f$var$z(a) === $1d58191ca8201f1f$var$m;
}
$1d58191ca8201f1f$export$2b8d127b894957b9 = $1d58191ca8201f1f$var$l;
$1d58191ca8201f1f$export$cea3a54a6425200c = $1d58191ca8201f1f$var$m;
$1d58191ca8201f1f$export$a7c73072b1a182ae = $1d58191ca8201f1f$var$k;
$1d58191ca8201f1f$export$9f27bc3417b4524d = $1d58191ca8201f1f$var$h;
$1d58191ca8201f1f$export$db77ccec0bb4ccac = $1d58191ca8201f1f$var$c;
$1d58191ca8201f1f$export$8392c0c9d3dcbd35 = $1d58191ca8201f1f$var$n;
$1d58191ca8201f1f$export$ffb0004e005737fa = $1d58191ca8201f1f$var$e;
$1d58191ca8201f1f$export$b624eff549462981 = $1d58191ca8201f1f$var$t;
$1d58191ca8201f1f$export$7897aa7841a5380c = $1d58191ca8201f1f$var$r;
$1d58191ca8201f1f$export$602eac185826482c = $1d58191ca8201f1f$var$d;
$1d58191ca8201f1f$export$e2c29f18771995cb = $1d58191ca8201f1f$var$g;
$1d58191ca8201f1f$export$5f8d39834fd61797 = $1d58191ca8201f1f$var$f;
$1d58191ca8201f1f$export$74bf444e3cd11ea5 = $1d58191ca8201f1f$var$p;
$1d58191ca8201f1f$export$92387174baf9b227 = function(a) {
    return $1d58191ca8201f1f$var$A(a) || $1d58191ca8201f1f$var$z(a) === $1d58191ca8201f1f$var$l;
};
$1d58191ca8201f1f$export$ec112efeb987d9c6 = $1d58191ca8201f1f$var$A;
$1d58191ca8201f1f$export$b706b080d889d2c9 = function(a) {
    return $1d58191ca8201f1f$var$z(a) === $1d58191ca8201f1f$var$k;
};
$1d58191ca8201f1f$export$5be5a87408f70ddc = function(a) {
    return $1d58191ca8201f1f$var$z(a) === $1d58191ca8201f1f$var$h;
};
$1d58191ca8201f1f$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1d58191ca8201f1f$var$c;
};
$1d58191ca8201f1f$export$455c2e768291efa6 = function(a) {
    return $1d58191ca8201f1f$var$z(a) === $1d58191ca8201f1f$var$n;
};
$1d58191ca8201f1f$export$9522e17588c12572 = function(a) {
    return $1d58191ca8201f1f$var$z(a) === $1d58191ca8201f1f$var$e;
};
$1d58191ca8201f1f$export$2110ac352bb060b9 = function(a) {
    return $1d58191ca8201f1f$var$z(a) === $1d58191ca8201f1f$var$t;
};
$1d58191ca8201f1f$export$56885ab8b9c456ab = function(a) {
    return $1d58191ca8201f1f$var$z(a) === $1d58191ca8201f1f$var$r;
};
$1d58191ca8201f1f$export$d927fcb6adf8f9de = function(a) {
    return $1d58191ca8201f1f$var$z(a) === $1d58191ca8201f1f$var$d;
};
$1d58191ca8201f1f$export$b82d16f27459e05a = function(a) {
    return $1d58191ca8201f1f$var$z(a) === $1d58191ca8201f1f$var$g;
};
$1d58191ca8201f1f$export$522c17b4f5e123e8 = function(a) {
    return $1d58191ca8201f1f$var$z(a) === $1d58191ca8201f1f$var$f;
};
$1d58191ca8201f1f$export$1aabd8a0274ecfd6 = function(a) {
    return $1d58191ca8201f1f$var$z(a) === $1d58191ca8201f1f$var$p;
};
$1d58191ca8201f1f$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $1d58191ca8201f1f$var$e || a === $1d58191ca8201f1f$var$m || a === $1d58191ca8201f1f$var$g || a === $1d58191ca8201f1f$var$f || a === $1d58191ca8201f1f$var$p || a === $1d58191ca8201f1f$var$q || "object" === typeof a && null !== a && (a.$$typeof === $1d58191ca8201f1f$var$t || a.$$typeof === $1d58191ca8201f1f$var$r || a.$$typeof === $1d58191ca8201f1f$var$h || a.$$typeof === $1d58191ca8201f1f$var$k || a.$$typeof === $1d58191ca8201f1f$var$n || a.$$typeof === $1d58191ca8201f1f$var$w || a.$$typeof === $1d58191ca8201f1f$var$x || a.$$typeof === $1d58191ca8201f1f$var$y || a.$$typeof === $1d58191ca8201f1f$var$v);
};
$1d58191ca8201f1f$export$f5bbd400c2f4426f = $1d58191ca8201f1f$var$z;

});

parcelRegister("j2cWv", function(module, exports) {

var $hWSn8 = parcelRequire("hWSn8");

var $7cA3U = parcelRequire("7cA3U");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $hWSn8.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $7cA3U;
module.exports = isBuffer;

});
parcelRegister("hWSn8", function(module, exports) {

var $jZxYK = parcelRequire("jZxYK");
/** Detect free variable `self`. */ var $d11207a1447f75f4$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $d11207a1447f75f4$var$root = $jZxYK || $d11207a1447f75f4$var$freeSelf || Function('return this')();
module.exports = $d11207a1447f75f4$var$root;

});
parcelRegister("jZxYK", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $e8de1253a05e90f5$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $e8de1253a05e90f5$var$freeGlobal;

});


parcelRegister("7cA3U", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $53e5a08a39c9af42$var$stubFalse() {
    return false;
}
module.exports = $53e5a08a39c9af42$var$stubFalse;

});


parcelRegister("1QIyT", function(module, exports) {

var $jZxYK = parcelRequire("jZxYK");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $jZxYK.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRegister("dCh9z", function(module, exports) {

var $dT1PE = parcelRequire("dT1PE");

var $drHoi = parcelRequire("drHoi");
/** Used to compose bitmasks for value comparisons. */ var $9e9c214089427052$var$COMPARE_PARTIAL_FLAG = 1, $9e9c214089427052$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $9e9c214089427052$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $dT1PE;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $drHoi(srcValue, objValue, $9e9c214089427052$var$COMPARE_PARTIAL_FLAG | $9e9c214089427052$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = $9e9c214089427052$var$baseIsMatch;

});
parcelRegister("dT1PE", function(module, exports) {

var $i1W8B = parcelRequire("i1W8B");

var $1mSkv = parcelRequire("1mSkv");

var $mlVq3 = parcelRequire("mlVq3");

var $8BOqF = parcelRequire("8BOqF");

var $kxjbZ = parcelRequire("kxjbZ");

var $31v4E = parcelRequire("31v4E");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $a1c1d53a51c23044$var$Stack(entries) {
    var data = this.__data__ = new $i1W8B(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$a1c1d53a51c23044$var$Stack.prototype.clear = $1mSkv;
$a1c1d53a51c23044$var$Stack.prototype['delete'] = $mlVq3;
$a1c1d53a51c23044$var$Stack.prototype.get = $8BOqF;
$a1c1d53a51c23044$var$Stack.prototype.has = $kxjbZ;
$a1c1d53a51c23044$var$Stack.prototype.set = $31v4E;
module.exports = $a1c1d53a51c23044$var$Stack;

});
parcelRegister("i1W8B", function(module, exports) {

var $cF4N5 = parcelRequire("cF4N5");

var $9uTj7 = parcelRequire("9uTj7");

var $aXvUw = parcelRequire("aXvUw");

var $2OUTe = parcelRequire("2OUTe");

var $9GSjq = parcelRequire("9GSjq");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $d2056af42f6476c5$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$d2056af42f6476c5$var$ListCache.prototype.clear = $cF4N5;
$d2056af42f6476c5$var$ListCache.prototype['delete'] = $9uTj7;
$d2056af42f6476c5$var$ListCache.prototype.get = $aXvUw;
$d2056af42f6476c5$var$ListCache.prototype.has = $2OUTe;
$d2056af42f6476c5$var$ListCache.prototype.set = $9GSjq;
module.exports = $d2056af42f6476c5$var$ListCache;

});
parcelRegister("cF4N5", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $937d07af0cab1378$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $937d07af0cab1378$var$listCacheClear;

});

parcelRegister("9uTj7", function(module, exports) {

var $jax0Q = parcelRequire("jax0Q");
/** Used for built-in method references. */ var $6ea1d1487f11b4b4$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $6ea1d1487f11b4b4$var$splice = $6ea1d1487f11b4b4$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $6ea1d1487f11b4b4$var$listCacheDelete(key) {
    var data = this.__data__, index = $jax0Q(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $6ea1d1487f11b4b4$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $6ea1d1487f11b4b4$var$listCacheDelete;

});
parcelRegister("jax0Q", function(module, exports) {

var $7je7Y = parcelRequire("7je7Y");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $df488f22dc7f4e99$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($7je7Y(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $df488f22dc7f4e99$var$assocIndexOf;

});
parcelRegister("7je7Y", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $5525442d79a77743$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $5525442d79a77743$var$eq;

});



parcelRegister("aXvUw", function(module, exports) {

var $jax0Q = parcelRequire("jax0Q");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $7fa82adb3fbc056d$var$listCacheGet(key) {
    var data = this.__data__, index = $jax0Q(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $7fa82adb3fbc056d$var$listCacheGet;

});

parcelRegister("2OUTe", function(module, exports) {

var $jax0Q = parcelRequire("jax0Q");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $20dc617012d33091$var$listCacheHas(key) {
    return $jax0Q(this.__data__, key) > -1;
}
module.exports = $20dc617012d33091$var$listCacheHas;

});

parcelRegister("9GSjq", function(module, exports) {

var $jax0Q = parcelRequire("jax0Q");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $70e22a93cd8d9a01$var$listCacheSet(key, value) {
    var data = this.__data__, index = $jax0Q(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $70e22a93cd8d9a01$var$listCacheSet;

});


parcelRegister("1mSkv", function(module, exports) {

var $i1W8B = parcelRequire("i1W8B");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $0ff1fd4a628cff39$var$stackClear() {
    this.__data__ = new $i1W8B;
    this.size = 0;
}
module.exports = $0ff1fd4a628cff39$var$stackClear;

});

parcelRegister("mlVq3", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $0433100f6f55a730$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
module.exports = $0433100f6f55a730$var$stackDelete;

});

parcelRegister("8BOqF", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $6448e5954b99f3ed$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $6448e5954b99f3ed$var$stackGet;

});

parcelRegister("kxjbZ", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $ef35c6f13fde8b30$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $ef35c6f13fde8b30$var$stackHas;

});

parcelRegister("31v4E", function(module, exports) {

var $i1W8B = parcelRequire("i1W8B");

var $hzybK = parcelRequire("hzybK");

var $eYj3i = parcelRequire("eYj3i");
/** Used as the size to enable large array optimizations. */ var $233991bc25634474$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $233991bc25634474$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $i1W8B) {
        var pairs = data.__data__;
        if (!$hzybK || pairs.length < $233991bc25634474$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $eYj3i(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $233991bc25634474$var$stackSet;

});
parcelRegister("hzybK", function(module, exports) {

var $5SDfn = parcelRequire("5SDfn");

var $hWSn8 = parcelRequire("hWSn8");
/* Built-in method references that are verified to be native. */ var $ccb039a825be9b20$var$Map = $5SDfn($hWSn8, 'Map');
module.exports = $ccb039a825be9b20$var$Map;

});
parcelRegister("5SDfn", function(module, exports) {

var $clyYw = parcelRequire("clyYw");

var $fkIxR = parcelRequire("fkIxR");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $4480708af1436907$var$getNative(object, key) {
    var value = $fkIxR(object, key);
    return $clyYw(value) ? value : undefined;
}
module.exports = $4480708af1436907$var$getNative;

});
parcelRegister("clyYw", function(module, exports) {

var $baf3r = parcelRequire("baf3r");

var $3FvJN = parcelRequire("3FvJN");

var $26Qmy = parcelRequire("26Qmy");

var $ewmRA = parcelRequire("ewmRA");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $0251d916e63e79a1$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $0251d916e63e79a1$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $0251d916e63e79a1$var$funcProto = Function.prototype, $0251d916e63e79a1$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $0251d916e63e79a1$var$funcToString = $0251d916e63e79a1$var$funcProto.toString;
/** Used to check objects for own properties. */ var $0251d916e63e79a1$var$hasOwnProperty = $0251d916e63e79a1$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $0251d916e63e79a1$var$reIsNative = RegExp('^' + $0251d916e63e79a1$var$funcToString.call($0251d916e63e79a1$var$hasOwnProperty).replace($0251d916e63e79a1$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $0251d916e63e79a1$var$baseIsNative(value) {
    if (!$26Qmy(value) || $3FvJN(value)) return false;
    var pattern = $baf3r(value) ? $0251d916e63e79a1$var$reIsNative : $0251d916e63e79a1$var$reIsHostCtor;
    return pattern.test($ewmRA(value));
}
module.exports = $0251d916e63e79a1$var$baseIsNative;

});
parcelRegister("baf3r", function(module, exports) {

var $kvoUC = parcelRequire("kvoUC");

var $26Qmy = parcelRequire("26Qmy");
/** `Object#toString` result references. */ var $820c4e659128c5d5$var$asyncTag = '[object AsyncFunction]', $820c4e659128c5d5$var$funcTag = '[object Function]', $820c4e659128c5d5$var$genTag = '[object GeneratorFunction]', $820c4e659128c5d5$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $820c4e659128c5d5$var$isFunction(value) {
    if (!$26Qmy(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $kvoUC(value);
    return tag == $820c4e659128c5d5$var$funcTag || tag == $820c4e659128c5d5$var$genTag || tag == $820c4e659128c5d5$var$asyncTag || tag == $820c4e659128c5d5$var$proxyTag;
}
module.exports = $820c4e659128c5d5$var$isFunction;

});
parcelRegister("kvoUC", function(module, exports) {

var $3N6ME = parcelRequire("3N6ME");

var $aKNx5 = parcelRequire("aKNx5");

var $ahzTM = parcelRequire("ahzTM");
/** `Object#toString` result references. */ var $eeda06f194d9bb79$var$nullTag = '[object Null]', $eeda06f194d9bb79$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $eeda06f194d9bb79$var$symToStringTag = $3N6ME ? $3N6ME.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $eeda06f194d9bb79$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $eeda06f194d9bb79$var$undefinedTag : $eeda06f194d9bb79$var$nullTag;
    return $eeda06f194d9bb79$var$symToStringTag && $eeda06f194d9bb79$var$symToStringTag in Object(value) ? $aKNx5(value) : $ahzTM(value);
}
module.exports = $eeda06f194d9bb79$var$baseGetTag;

});
parcelRegister("3N6ME", function(module, exports) {

var $hWSn8 = parcelRequire("hWSn8");
/** Built-in value references. */ var $2c2b35cceade0b2c$var$Symbol = $hWSn8.Symbol;
module.exports = $2c2b35cceade0b2c$var$Symbol;

});

parcelRegister("aKNx5", function(module, exports) {

var $3N6ME = parcelRequire("3N6ME");
/** Used for built-in method references. */ var $7d449f69b19d32f6$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7d449f69b19d32f6$var$hasOwnProperty = $7d449f69b19d32f6$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $7d449f69b19d32f6$var$nativeObjectToString = $7d449f69b19d32f6$var$objectProto.toString;
/** Built-in value references. */ var $7d449f69b19d32f6$var$symToStringTag = $3N6ME ? $3N6ME.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $7d449f69b19d32f6$var$getRawTag(value) {
    var isOwn = $7d449f69b19d32f6$var$hasOwnProperty.call(value, $7d449f69b19d32f6$var$symToStringTag), tag = value[$7d449f69b19d32f6$var$symToStringTag];
    try {
        value[$7d449f69b19d32f6$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $7d449f69b19d32f6$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$7d449f69b19d32f6$var$symToStringTag] = tag;
        else delete value[$7d449f69b19d32f6$var$symToStringTag];
    }
    return result;
}
module.exports = $7d449f69b19d32f6$var$getRawTag;

});

parcelRegister("ahzTM", function(module, exports) {
/** Used for built-in method references. */ var $77c7569f2be13c71$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $77c7569f2be13c71$var$nativeObjectToString = $77c7569f2be13c71$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $77c7569f2be13c71$var$objectToString(value) {
    return $77c7569f2be13c71$var$nativeObjectToString.call(value);
}
module.exports = $77c7569f2be13c71$var$objectToString;

});


parcelRegister("26Qmy", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $1894c27238be1348$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = $1894c27238be1348$var$isObject;

});


parcelRegister("3FvJN", function(module, exports) {

var $gnASL = parcelRequire("gnASL");
/** Used to detect methods masquerading as native. */ var $2abdd1d9e6a65a35$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($gnASL && $gnASL.keys && $gnASL.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $2abdd1d9e6a65a35$var$isMasked(func) {
    return !!$2abdd1d9e6a65a35$var$maskSrcKey && $2abdd1d9e6a65a35$var$maskSrcKey in func;
}
module.exports = $2abdd1d9e6a65a35$var$isMasked;

});
parcelRegister("gnASL", function(module, exports) {

var $hWSn8 = parcelRequire("hWSn8");
/** Used to detect overreaching core-js shims. */ var $becb6761615b8a1b$var$coreJsData = $hWSn8["__core-js_shared__"];
module.exports = $becb6761615b8a1b$var$coreJsData;

});


parcelRegister("ewmRA", function(module, exports) {
/** Used for built-in method references. */ var $a925ca03804c092b$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $a925ca03804c092b$var$funcToString = $a925ca03804c092b$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $a925ca03804c092b$var$toSource(func) {
    if (func != null) {
        try {
            return $a925ca03804c092b$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
module.exports = $a925ca03804c092b$var$toSource;

});


parcelRegister("fkIxR", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $b29b4703dffcb949$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $b29b4703dffcb949$var$getValue;

});



parcelRegister("eYj3i", function(module, exports) {

var $6jLJZ = parcelRequire("6jLJZ");

var $f3GJ3 = parcelRequire("f3GJ3");

var $kJX3c = parcelRequire("kJX3c");

var $gEbzi = parcelRequire("gEbzi");

var $aFyMV = parcelRequire("aFyMV");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $ae6572a339cde4b5$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$ae6572a339cde4b5$var$MapCache.prototype.clear = $6jLJZ;
$ae6572a339cde4b5$var$MapCache.prototype['delete'] = $f3GJ3;
$ae6572a339cde4b5$var$MapCache.prototype.get = $kJX3c;
$ae6572a339cde4b5$var$MapCache.prototype.has = $gEbzi;
$ae6572a339cde4b5$var$MapCache.prototype.set = $aFyMV;
module.exports = $ae6572a339cde4b5$var$MapCache;

});
parcelRegister("6jLJZ", function(module, exports) {

var $5xmvV = parcelRequire("5xmvV");

var $i1W8B = parcelRequire("i1W8B");

var $hzybK = parcelRequire("hzybK");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $49998cbf4ec2b178$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $5xmvV,
        'map': new ($hzybK || $i1W8B),
        'string': new $5xmvV
    };
}
module.exports = $49998cbf4ec2b178$var$mapCacheClear;

});
parcelRegister("5xmvV", function(module, exports) {

var $ak57p = parcelRequire("ak57p");

var $gxGna = parcelRequire("gxGna");

var $bc97r = parcelRequire("bc97r");

var $g1rLB = parcelRequire("g1rLB");

var $9cDmN = parcelRequire("9cDmN");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $40817f9fc7d4c139$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$40817f9fc7d4c139$var$Hash.prototype.clear = $ak57p;
$40817f9fc7d4c139$var$Hash.prototype['delete'] = $gxGna;
$40817f9fc7d4c139$var$Hash.prototype.get = $bc97r;
$40817f9fc7d4c139$var$Hash.prototype.has = $g1rLB;
$40817f9fc7d4c139$var$Hash.prototype.set = $9cDmN;
module.exports = $40817f9fc7d4c139$var$Hash;

});
parcelRegister("ak57p", function(module, exports) {

var $42Q02 = parcelRequire("42Q02");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $783fbe178794b9fb$var$hashClear() {
    this.__data__ = $42Q02 ? $42Q02(null) : {};
    this.size = 0;
}
module.exports = $783fbe178794b9fb$var$hashClear;

});
parcelRegister("42Q02", function(module, exports) {

var $5SDfn = parcelRequire("5SDfn");
/* Built-in method references that are verified to be native. */ var $2f1faf5a54b96176$var$nativeCreate = $5SDfn(Object, 'create');
module.exports = $2f1faf5a54b96176$var$nativeCreate;

});


parcelRegister("gxGna", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $c0b098ba5281e2e1$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $c0b098ba5281e2e1$var$hashDelete;

});

parcelRegister("bc97r", function(module, exports) {

var $42Q02 = parcelRequire("42Q02");
/** Used to stand-in for `undefined` hash values. */ var $8267e386701a2931$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $8267e386701a2931$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $8267e386701a2931$var$hasOwnProperty = $8267e386701a2931$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $8267e386701a2931$var$hashGet(key) {
    var data = this.__data__;
    if ($42Q02) {
        var result = data[key];
        return result === $8267e386701a2931$var$HASH_UNDEFINED ? undefined : result;
    }
    return $8267e386701a2931$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $8267e386701a2931$var$hashGet;

});

parcelRegister("g1rLB", function(module, exports) {

var $42Q02 = parcelRequire("42Q02");
/** Used for built-in method references. */ var $baa2473e9301bb8a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $baa2473e9301bb8a$var$hasOwnProperty = $baa2473e9301bb8a$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $baa2473e9301bb8a$var$hashHas(key) {
    var data = this.__data__;
    return $42Q02 ? data[key] !== undefined : $baa2473e9301bb8a$var$hasOwnProperty.call(data, key);
}
module.exports = $baa2473e9301bb8a$var$hashHas;

});

parcelRegister("9cDmN", function(module, exports) {

var $42Q02 = parcelRequire("42Q02");
/** Used to stand-in for `undefined` hash values. */ var $6b33c570c8f914c4$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $6b33c570c8f914c4$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $42Q02 && value === undefined ? $6b33c570c8f914c4$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $6b33c570c8f914c4$var$hashSet;

});



parcelRegister("f3GJ3", function(module, exports) {

var $7wmMB = parcelRequire("7wmMB");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $af6847457c497c2f$var$mapCacheDelete(key) {
    var result = $7wmMB(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $af6847457c497c2f$var$mapCacheDelete;

});
parcelRegister("7wmMB", function(module, exports) {

var $D9G7t = parcelRequire("D9G7t");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $579d31c5103862e3$var$getMapData(map, key) {
    var data = map.__data__;
    return $D9G7t(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
module.exports = $579d31c5103862e3$var$getMapData;

});
parcelRegister("D9G7t", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $075b268d0c0b79e9$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
module.exports = $075b268d0c0b79e9$var$isKeyable;

});



parcelRegister("kJX3c", function(module, exports) {

var $7wmMB = parcelRequire("7wmMB");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $f195d0d91aad72e0$var$mapCacheGet(key) {
    return $7wmMB(this, key).get(key);
}
module.exports = $f195d0d91aad72e0$var$mapCacheGet;

});

parcelRegister("gEbzi", function(module, exports) {

var $7wmMB = parcelRequire("7wmMB");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $c1e95afd71966630$var$mapCacheHas(key) {
    return $7wmMB(this, key).has(key);
}
module.exports = $c1e95afd71966630$var$mapCacheHas;

});

parcelRegister("aFyMV", function(module, exports) {

var $7wmMB = parcelRequire("7wmMB");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $7c48b7e6f70c2f27$var$mapCacheSet(key, value) {
    var data = $7wmMB(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $7c48b7e6f70c2f27$var$mapCacheSet;

});




parcelRegister("drHoi", function(module, exports) {

var $fQSZN = parcelRequire("fQSZN");

var $eyoXy = parcelRequire("eyoXy");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $9c9f747c4a99a7f0$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$eyoXy(value) && !$eyoXy(other)) return value !== value && other !== other;
    return $fQSZN(value, other, bitmask, customizer, $9c9f747c4a99a7f0$var$baseIsEqual, stack);
}
module.exports = $9c9f747c4a99a7f0$var$baseIsEqual;

});
parcelRegister("fQSZN", function(module, exports) {

var $dT1PE = parcelRequire("dT1PE");

var $clHFO = parcelRequire("clHFO");

var $c4oaK = parcelRequire("c4oaK");

var $8TfX8 = parcelRequire("8TfX8");

var $1gSOv = parcelRequire("1gSOv");

var $fbNtz = parcelRequire("fbNtz");

var $j2cWv = parcelRequire("j2cWv");

var $hnUGz = parcelRequire("hnUGz");
/** Used to compose bitmasks for value comparisons. */ var $b8a65f5a31a00fff$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $b8a65f5a31a00fff$var$argsTag = '[object Arguments]', $b8a65f5a31a00fff$var$arrayTag = '[object Array]', $b8a65f5a31a00fff$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $b8a65f5a31a00fff$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b8a65f5a31a00fff$var$hasOwnProperty = $b8a65f5a31a00fff$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $b8a65f5a31a00fff$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $fbNtz(object), othIsArr = $fbNtz(other), objTag = objIsArr ? $b8a65f5a31a00fff$var$arrayTag : $1gSOv(object), othTag = othIsArr ? $b8a65f5a31a00fff$var$arrayTag : $1gSOv(other);
    objTag = objTag == $b8a65f5a31a00fff$var$argsTag ? $b8a65f5a31a00fff$var$objectTag : objTag;
    othTag = othTag == $b8a65f5a31a00fff$var$argsTag ? $b8a65f5a31a00fff$var$objectTag : othTag;
    var objIsObj = objTag == $b8a65f5a31a00fff$var$objectTag, othIsObj = othTag == $b8a65f5a31a00fff$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $j2cWv(object)) {
        if (!$j2cWv(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $dT1PE);
        return objIsArr || $hnUGz(object) ? $clHFO(object, other, bitmask, customizer, equalFunc, stack) : $c4oaK(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $b8a65f5a31a00fff$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $b8a65f5a31a00fff$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $b8a65f5a31a00fff$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $dT1PE);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $dT1PE);
    return $8TfX8(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = $b8a65f5a31a00fff$var$baseIsEqualDeep;

});
parcelRegister("clHFO", function(module, exports) {

var $aRGNf = parcelRequire("aRGNf");

var $8ZKIe = parcelRequire("8ZKIe");

var $hiZsV = parcelRequire("hiZsV");
/** Used to compose bitmasks for value comparisons. */ var $8fd952d84feff28b$var$COMPARE_PARTIAL_FLAG = 1, $8fd952d84feff28b$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $8fd952d84feff28b$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $8fd952d84feff28b$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $8fd952d84feff28b$var$COMPARE_UNORDERED_FLAG ? new $aRGNf : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$8ZKIe(other, function(othValue, othIndex) {
                if (!$hiZsV(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
module.exports = $8fd952d84feff28b$var$equalArrays;

});
parcelRegister("aRGNf", function(module, exports) {

var $eYj3i = parcelRequire("eYj3i");

var $pGlfY = parcelRequire("pGlfY");

var $18GAS = parcelRequire("18GAS");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $7e900c77db35ab47$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $eYj3i;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$7e900c77db35ab47$var$SetCache.prototype.add = $7e900c77db35ab47$var$SetCache.prototype.push = $pGlfY;
$7e900c77db35ab47$var$SetCache.prototype.has = $18GAS;
module.exports = $7e900c77db35ab47$var$SetCache;

});
parcelRegister("pGlfY", function(module, exports) {
/** Used to stand-in for `undefined` hash values. */ var $04d32e1f99716c16$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $04d32e1f99716c16$var$setCacheAdd(value) {
    this.__data__.set(value, $04d32e1f99716c16$var$HASH_UNDEFINED);
    return this;
}
module.exports = $04d32e1f99716c16$var$setCacheAdd;

});

parcelRegister("18GAS", function(module, exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $0d479406a7ba7955$var$setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = $0d479406a7ba7955$var$setCacheHas;

});


parcelRegister("8ZKIe", function(module, exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $68c8415b0023f30a$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = $68c8415b0023f30a$var$arraySome;

});

parcelRegister("hiZsV", function(module, exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $c993cbe730e4dee5$var$cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = $c993cbe730e4dee5$var$cacheHas;

});


parcelRegister("c4oaK", function(module, exports) {

var $3N6ME = parcelRequire("3N6ME");

var $3t08V = parcelRequire("3t08V");

var $7je7Y = parcelRequire("7je7Y");

var $clHFO = parcelRequire("clHFO");

var $5wnuo = parcelRequire("5wnuo");

var $12HSd = parcelRequire("12HSd");
/** Used to compose bitmasks for value comparisons. */ var $8c989be5d0ba9dd2$var$COMPARE_PARTIAL_FLAG = 1, $8c989be5d0ba9dd2$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $8c989be5d0ba9dd2$var$boolTag = '[object Boolean]', $8c989be5d0ba9dd2$var$dateTag = '[object Date]', $8c989be5d0ba9dd2$var$errorTag = '[object Error]', $8c989be5d0ba9dd2$var$mapTag = '[object Map]', $8c989be5d0ba9dd2$var$numberTag = '[object Number]', $8c989be5d0ba9dd2$var$regexpTag = '[object RegExp]', $8c989be5d0ba9dd2$var$setTag = '[object Set]', $8c989be5d0ba9dd2$var$stringTag = '[object String]', $8c989be5d0ba9dd2$var$symbolTag = '[object Symbol]';
var $8c989be5d0ba9dd2$var$arrayBufferTag = '[object ArrayBuffer]', $8c989be5d0ba9dd2$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $8c989be5d0ba9dd2$var$symbolProto = $3N6ME ? $3N6ME.prototype : undefined, $8c989be5d0ba9dd2$var$symbolValueOf = $8c989be5d0ba9dd2$var$symbolProto ? $8c989be5d0ba9dd2$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $8c989be5d0ba9dd2$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $8c989be5d0ba9dd2$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $8c989be5d0ba9dd2$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $3t08V(object), new $3t08V(other))) return false;
            return true;
        case $8c989be5d0ba9dd2$var$boolTag:
        case $8c989be5d0ba9dd2$var$dateTag:
        case $8c989be5d0ba9dd2$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $7je7Y(+object, +other);
        case $8c989be5d0ba9dd2$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $8c989be5d0ba9dd2$var$regexpTag:
        case $8c989be5d0ba9dd2$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $8c989be5d0ba9dd2$var$mapTag:
            var convert = $5wnuo;
        case $8c989be5d0ba9dd2$var$setTag:
            var isPartial = bitmask & $8c989be5d0ba9dd2$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $12HSd);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $8c989be5d0ba9dd2$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $clHFO(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $8c989be5d0ba9dd2$var$symbolTag:
            if ($8c989be5d0ba9dd2$var$symbolValueOf) return $8c989be5d0ba9dd2$var$symbolValueOf.call(object) == $8c989be5d0ba9dd2$var$symbolValueOf.call(other);
    }
    return false;
}
module.exports = $8c989be5d0ba9dd2$var$equalByTag;

});
parcelRegister("3t08V", function(module, exports) {

var $hWSn8 = parcelRequire("hWSn8");
/** Built-in value references. */ var $286430eb281f6657$var$Uint8Array = $hWSn8.Uint8Array;
module.exports = $286430eb281f6657$var$Uint8Array;

});

parcelRegister("5wnuo", function(module, exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $4052295df9b1ee95$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = $4052295df9b1ee95$var$mapToArray;

});

parcelRegister("12HSd", function(module, exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $0c2802aee02151d8$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = $0c2802aee02151d8$var$setToArray;

});


parcelRegister("8TfX8", function(module, exports) {

var $7RhIc = parcelRequire("7RhIc");
/** Used to compose bitmasks for value comparisons. */ var $678fd5ae62db45e8$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $678fd5ae62db45e8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $678fd5ae62db45e8$var$hasOwnProperty = $678fd5ae62db45e8$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $678fd5ae62db45e8$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $678fd5ae62db45e8$var$COMPARE_PARTIAL_FLAG, objProps = $7RhIc(object), objLength = objProps.length, othProps = $7RhIc(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $678fd5ae62db45e8$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
module.exports = $678fd5ae62db45e8$var$equalObjects;

});
parcelRegister("7RhIc", function(module, exports) {

var $gmZWg = parcelRequire("gmZWg");

var $32BHM = parcelRequire("32BHM");

var $8wWbF = parcelRequire("8wWbF");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $5b8b38e0641a62b2$var$getAllKeys(object) {
    return $gmZWg(object, $8wWbF, $32BHM);
}
module.exports = $5b8b38e0641a62b2$var$getAllKeys;

});
parcelRegister("gmZWg", function(module, exports) {

var $9wjbG = parcelRequire("9wjbG");

var $fbNtz = parcelRequire("fbNtz");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $beaebf24d826ca67$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $fbNtz(object) ? result : $9wjbG(result, symbolsFunc(object));
}
module.exports = $beaebf24d826ca67$var$baseGetAllKeys;

});
parcelRegister("9wjbG", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $6ee5fc77384500ee$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $6ee5fc77384500ee$var$arrayPush;

});

parcelRegister("fbNtz", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $b0ee42fdb2c68b6d$var$isArray = Array.isArray;
module.exports = $b0ee42fdb2c68b6d$var$isArray;

});


parcelRegister("32BHM", function(module, exports) {

var $61mzJ = parcelRequire("61mzJ");

var $4Gdri = parcelRequire("4Gdri");
/** Used for built-in method references. */ var $236ece76a27d0e41$var$objectProto = Object.prototype;
/** Built-in value references. */ var $236ece76a27d0e41$var$propertyIsEnumerable = $236ece76a27d0e41$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $236ece76a27d0e41$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $236ece76a27d0e41$var$getSymbols = !$236ece76a27d0e41$var$nativeGetSymbols ? $4Gdri : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $61mzJ($236ece76a27d0e41$var$nativeGetSymbols(object), function(symbol) {
        return $236ece76a27d0e41$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $236ece76a27d0e41$var$getSymbols;

});
parcelRegister("61mzJ", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $4624590c8f3cd07f$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $4624590c8f3cd07f$var$arrayFilter;

});

parcelRegister("4Gdri", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $3685827085c63339$var$stubArray() {
    return [];
}
module.exports = $3685827085c63339$var$stubArray;

});


parcelRegister("8wWbF", function(module, exports) {

var $2h6kh = parcelRequire("2h6kh");

var $kVO3e = parcelRequire("kVO3e");

var $2xBvu = parcelRequire("2xBvu");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $635e72a1cda5f2b9$var$keys(object) {
    return $2xBvu(object) ? $2h6kh(object) : $kVO3e(object);
}
module.exports = $635e72a1cda5f2b9$var$keys;

});
parcelRegister("2h6kh", function(module, exports) {

var $4rwkr = parcelRequire("4rwkr");

var $g325N = parcelRequire("g325N");

var $fbNtz = parcelRequire("fbNtz");

var $j2cWv = parcelRequire("j2cWv");

var $c5rP7 = parcelRequire("c5rP7");

var $hnUGz = parcelRequire("hnUGz");
/** Used for built-in method references. */ var $1a821382be19e13c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $1a821382be19e13c$var$hasOwnProperty = $1a821382be19e13c$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $1a821382be19e13c$var$arrayLikeKeys(value, inherited) {
    var isArr = $fbNtz(value), isArg = !isArr && $g325N(value), isBuff = !isArr && !isArg && $j2cWv(value), isType = !isArr && !isArg && !isBuff && $hnUGz(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $4rwkr(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $1a821382be19e13c$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $c5rP7(key, length)))) result.push(key);
    return result;
}
module.exports = $1a821382be19e13c$var$arrayLikeKeys;

});
parcelRegister("4rwkr", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $33c2c2dc6b7a9723$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $33c2c2dc6b7a9723$var$baseTimes;

});

parcelRegister("g325N", function(module, exports) {

var $ie0kn = parcelRequire("ie0kn");

var $eyoXy = parcelRequire("eyoXy");
/** Used for built-in method references. */ var $baee8cae7b884309$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $baee8cae7b884309$var$hasOwnProperty = $baee8cae7b884309$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $baee8cae7b884309$var$propertyIsEnumerable = $baee8cae7b884309$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $baee8cae7b884309$var$isArguments = $ie0kn(function() {
    return arguments;
}()) ? $ie0kn : function(value) {
    return $eyoXy(value) && $baee8cae7b884309$var$hasOwnProperty.call(value, 'callee') && !$baee8cae7b884309$var$propertyIsEnumerable.call(value, 'callee');
};
module.exports = $baee8cae7b884309$var$isArguments;

});
parcelRegister("ie0kn", function(module, exports) {

var $kvoUC = parcelRequire("kvoUC");

var $eyoXy = parcelRequire("eyoXy");
/** `Object#toString` result references. */ var $d449c9dc4c1581bc$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $d449c9dc4c1581bc$var$baseIsArguments(value) {
    return $eyoXy(value) && $kvoUC(value) == $d449c9dc4c1581bc$var$argsTag;
}
module.exports = $d449c9dc4c1581bc$var$baseIsArguments;

});
parcelRegister("eyoXy", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $a9879a1c10f7cc09$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = $a9879a1c10f7cc09$var$isObjectLike;

});



parcelRegister("c5rP7", function(module, exports) {
/** Used as references for various `Number` constants. */ var $8ccb88d5553c1e40$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $8ccb88d5553c1e40$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $8ccb88d5553c1e40$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $8ccb88d5553c1e40$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $8ccb88d5553c1e40$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $8ccb88d5553c1e40$var$isIndex;

});

parcelRegister("hnUGz", function(module, exports) {

var $qmwE4 = parcelRequire("qmwE4");

var $iSOZZ = parcelRequire("iSOZZ");

var $1QIyT = parcelRequire("1QIyT");
/* Node.js helper references. */ var $ca808e4071c1234c$var$nodeIsTypedArray = $1QIyT && $1QIyT.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $ca808e4071c1234c$var$isTypedArray = $ca808e4071c1234c$var$nodeIsTypedArray ? $iSOZZ($ca808e4071c1234c$var$nodeIsTypedArray) : $qmwE4;
module.exports = $ca808e4071c1234c$var$isTypedArray;

});
parcelRegister("qmwE4", function(module, exports) {

var $kvoUC = parcelRequire("kvoUC");

var $2goBK = parcelRequire("2goBK");

var $eyoXy = parcelRequire("eyoXy");
/** `Object#toString` result references. */ var $04f3e6ece22ef07d$var$argsTag = '[object Arguments]', $04f3e6ece22ef07d$var$arrayTag = '[object Array]', $04f3e6ece22ef07d$var$boolTag = '[object Boolean]', $04f3e6ece22ef07d$var$dateTag = '[object Date]', $04f3e6ece22ef07d$var$errorTag = '[object Error]', $04f3e6ece22ef07d$var$funcTag = '[object Function]', $04f3e6ece22ef07d$var$mapTag = '[object Map]', $04f3e6ece22ef07d$var$numberTag = '[object Number]', $04f3e6ece22ef07d$var$objectTag = '[object Object]', $04f3e6ece22ef07d$var$regexpTag = '[object RegExp]', $04f3e6ece22ef07d$var$setTag = '[object Set]', $04f3e6ece22ef07d$var$stringTag = '[object String]', $04f3e6ece22ef07d$var$weakMapTag = '[object WeakMap]';
var $04f3e6ece22ef07d$var$arrayBufferTag = '[object ArrayBuffer]', $04f3e6ece22ef07d$var$dataViewTag = '[object DataView]', $04f3e6ece22ef07d$var$float32Tag = '[object Float32Array]', $04f3e6ece22ef07d$var$float64Tag = '[object Float64Array]', $04f3e6ece22ef07d$var$int8Tag = '[object Int8Array]', $04f3e6ece22ef07d$var$int16Tag = '[object Int16Array]', $04f3e6ece22ef07d$var$int32Tag = '[object Int32Array]', $04f3e6ece22ef07d$var$uint8Tag = '[object Uint8Array]', $04f3e6ece22ef07d$var$uint8ClampedTag = '[object Uint8ClampedArray]', $04f3e6ece22ef07d$var$uint16Tag = '[object Uint16Array]', $04f3e6ece22ef07d$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $04f3e6ece22ef07d$var$typedArrayTags = {};
$04f3e6ece22ef07d$var$typedArrayTags[$04f3e6ece22ef07d$var$float32Tag] = $04f3e6ece22ef07d$var$typedArrayTags[$04f3e6ece22ef07d$var$float64Tag] = $04f3e6ece22ef07d$var$typedArrayTags[$04f3e6ece22ef07d$var$int8Tag] = $04f3e6ece22ef07d$var$typedArrayTags[$04f3e6ece22ef07d$var$int16Tag] = $04f3e6ece22ef07d$var$typedArrayTags[$04f3e6ece22ef07d$var$int32Tag] = $04f3e6ece22ef07d$var$typedArrayTags[$04f3e6ece22ef07d$var$uint8Tag] = $04f3e6ece22ef07d$var$typedArrayTags[$04f3e6ece22ef07d$var$uint8ClampedTag] = $04f3e6ece22ef07d$var$typedArrayTags[$04f3e6ece22ef07d$var$uint16Tag] = $04f3e6ece22ef07d$var$typedArrayTags[$04f3e6ece22ef07d$var$uint32Tag] = true;
$04f3e6ece22ef07d$var$typedArrayTags[$04f3e6ece22ef07d$var$argsTag] = $04f3e6ece22ef07d$var$typedArrayTags[$04f3e6ece22ef07d$var$arrayTag] = $04f3e6ece22ef07d$var$typedArrayTags[$04f3e6ece22ef07d$var$arrayBufferTag] = $04f3e6ece22ef07d$var$typedArrayTags[$04f3e6ece22ef07d$var$boolTag] = $04f3e6ece22ef07d$var$typedArrayTags[$04f3e6ece22ef07d$var$dataViewTag] = $04f3e6ece22ef07d$var$typedArrayTags[$04f3e6ece22ef07d$var$dateTag] = $04f3e6ece22ef07d$var$typedArrayTags[$04f3e6ece22ef07d$var$errorTag] = $04f3e6ece22ef07d$var$typedArrayTags[$04f3e6ece22ef07d$var$funcTag] = $04f3e6ece22ef07d$var$typedArrayTags[$04f3e6ece22ef07d$var$mapTag] = $04f3e6ece22ef07d$var$typedArrayTags[$04f3e6ece22ef07d$var$numberTag] = $04f3e6ece22ef07d$var$typedArrayTags[$04f3e6ece22ef07d$var$objectTag] = $04f3e6ece22ef07d$var$typedArrayTags[$04f3e6ece22ef07d$var$regexpTag] = $04f3e6ece22ef07d$var$typedArrayTags[$04f3e6ece22ef07d$var$setTag] = $04f3e6ece22ef07d$var$typedArrayTags[$04f3e6ece22ef07d$var$stringTag] = $04f3e6ece22ef07d$var$typedArrayTags[$04f3e6ece22ef07d$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $04f3e6ece22ef07d$var$baseIsTypedArray(value) {
    return $eyoXy(value) && $2goBK(value.length) && !!$04f3e6ece22ef07d$var$typedArrayTags[$kvoUC(value)];
}
module.exports = $04f3e6ece22ef07d$var$baseIsTypedArray;

});
parcelRegister("2goBK", function(module, exports) {
/** Used as references for various `Number` constants. */ var $1a6029fbbc773f23$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $1a6029fbbc773f23$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $1a6029fbbc773f23$var$MAX_SAFE_INTEGER;
}
module.exports = $1a6029fbbc773f23$var$isLength;

});


parcelRegister("iSOZZ", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $dbf4d47238e0501d$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $dbf4d47238e0501d$var$baseUnary;

});



parcelRegister("kVO3e", function(module, exports) {

var $lL06J = parcelRequire("lL06J");

var $c601J = parcelRequire("c601J");
/** Used for built-in method references. */ var $f3cff4a5008caaba$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f3cff4a5008caaba$var$hasOwnProperty = $f3cff4a5008caaba$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $f3cff4a5008caaba$var$baseKeys(object) {
    if (!$lL06J(object)) return $c601J(object);
    var result = [];
    for(var key in Object(object))if ($f3cff4a5008caaba$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
module.exports = $f3cff4a5008caaba$var$baseKeys;

});
parcelRegister("lL06J", function(module, exports) {
/** Used for built-in method references. */ var $fd6e121b853e8950$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $fd6e121b853e8950$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $fd6e121b853e8950$var$objectProto;
    return value === proto;
}
module.exports = $fd6e121b853e8950$var$isPrototype;

});

parcelRegister("c601J", function(module, exports) {

var $1wrPY = parcelRequire("1wrPY");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $8ce610e8b95aef5b$var$nativeKeys = $1wrPY(Object.keys, Object);
module.exports = $8ce610e8b95aef5b$var$nativeKeys;

});
parcelRegister("1wrPY", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $11be5f8278851563$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $11be5f8278851563$var$overArg;

});



parcelRegister("2xBvu", function(module, exports) {

var $baf3r = parcelRequire("baf3r");

var $2goBK = parcelRequire("2goBK");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $1d9bc1e799e4023e$var$isArrayLike(value) {
    return value != null && $2goBK(value.length) && !$baf3r(value);
}
module.exports = $1d9bc1e799e4023e$var$isArrayLike;

});




parcelRegister("1gSOv", function(module, exports) {

var $9doGN = parcelRequire("9doGN");

var $hzybK = parcelRequire("hzybK");

var $2ovXa = parcelRequire("2ovXa");

var $8mcBr = parcelRequire("8mcBr");

var $14wRZ = parcelRequire("14wRZ");

var $kvoUC = parcelRequire("kvoUC");

var $ewmRA = parcelRequire("ewmRA");
/** `Object#toString` result references. */ var $0ed1cde83e3e8b2c$var$mapTag = '[object Map]', $0ed1cde83e3e8b2c$var$objectTag = '[object Object]', $0ed1cde83e3e8b2c$var$promiseTag = '[object Promise]', $0ed1cde83e3e8b2c$var$setTag = '[object Set]', $0ed1cde83e3e8b2c$var$weakMapTag = '[object WeakMap]';
var $0ed1cde83e3e8b2c$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $0ed1cde83e3e8b2c$var$dataViewCtorString = $ewmRA($9doGN), $0ed1cde83e3e8b2c$var$mapCtorString = $ewmRA($hzybK), $0ed1cde83e3e8b2c$var$promiseCtorString = $ewmRA($2ovXa), $0ed1cde83e3e8b2c$var$setCtorString = $ewmRA($8mcBr), $0ed1cde83e3e8b2c$var$weakMapCtorString = $ewmRA($14wRZ);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $0ed1cde83e3e8b2c$var$getTag = $kvoUC;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($9doGN && $0ed1cde83e3e8b2c$var$getTag(new $9doGN(new ArrayBuffer(1))) != $0ed1cde83e3e8b2c$var$dataViewTag || $hzybK && $0ed1cde83e3e8b2c$var$getTag(new $hzybK) != $0ed1cde83e3e8b2c$var$mapTag || $2ovXa && $0ed1cde83e3e8b2c$var$getTag($2ovXa.resolve()) != $0ed1cde83e3e8b2c$var$promiseTag || $8mcBr && $0ed1cde83e3e8b2c$var$getTag(new $8mcBr) != $0ed1cde83e3e8b2c$var$setTag || $14wRZ && $0ed1cde83e3e8b2c$var$getTag(new $14wRZ) != $0ed1cde83e3e8b2c$var$weakMapTag) $0ed1cde83e3e8b2c$var$getTag = function(value) {
    var result = $kvoUC(value), Ctor = result == $0ed1cde83e3e8b2c$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $ewmRA(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $0ed1cde83e3e8b2c$var$dataViewCtorString:
            return $0ed1cde83e3e8b2c$var$dataViewTag;
        case $0ed1cde83e3e8b2c$var$mapCtorString:
            return $0ed1cde83e3e8b2c$var$mapTag;
        case $0ed1cde83e3e8b2c$var$promiseCtorString:
            return $0ed1cde83e3e8b2c$var$promiseTag;
        case $0ed1cde83e3e8b2c$var$setCtorString:
            return $0ed1cde83e3e8b2c$var$setTag;
        case $0ed1cde83e3e8b2c$var$weakMapCtorString:
            return $0ed1cde83e3e8b2c$var$weakMapTag;
    }
    return result;
};
module.exports = $0ed1cde83e3e8b2c$var$getTag;

});
parcelRegister("9doGN", function(module, exports) {

var $5SDfn = parcelRequire("5SDfn");

var $hWSn8 = parcelRequire("hWSn8");
/* Built-in method references that are verified to be native. */ var $01bb3bc94d6195cd$var$DataView = $5SDfn($hWSn8, 'DataView');
module.exports = $01bb3bc94d6195cd$var$DataView;

});

parcelRegister("2ovXa", function(module, exports) {

var $5SDfn = parcelRequire("5SDfn");

var $hWSn8 = parcelRequire("hWSn8");
/* Built-in method references that are verified to be native. */ var $1be69be71fda0a6b$var$Promise = $5SDfn($hWSn8, 'Promise');
module.exports = $1be69be71fda0a6b$var$Promise;

});

parcelRegister("8mcBr", function(module, exports) {

var $5SDfn = parcelRequire("5SDfn");

var $hWSn8 = parcelRequire("hWSn8");
/* Built-in method references that are verified to be native. */ var $615a27770d22fdd3$var$Set = $5SDfn($hWSn8, 'Set');
module.exports = $615a27770d22fdd3$var$Set;

});

parcelRegister("14wRZ", function(module, exports) {

var $5SDfn = parcelRequire("5SDfn");

var $hWSn8 = parcelRequire("hWSn8");
/* Built-in method references that are verified to be native. */ var $0c7fa9725bcb393f$var$WeakMap = $5SDfn($hWSn8, 'WeakMap');
module.exports = $0c7fa9725bcb393f$var$WeakMap;

});





parcelRegister("21GRl", function(module, exports) {

var $2jRqb = parcelRequire("2jRqb");

var $8wWbF = parcelRequire("8wWbF");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $179cebc501375a27$var$getMatchData(object) {
    var result = $8wWbF(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $2jRqb(value)
        ];
    }
    return result;
}
module.exports = $179cebc501375a27$var$getMatchData;

});
parcelRegister("2jRqb", function(module, exports) {

var $26Qmy = parcelRequire("26Qmy");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $1b06cb759a62d687$var$isStrictComparable(value) {
    return value === value && !$26Qmy(value);
}
module.exports = $1b06cb759a62d687$var$isStrictComparable;

});


parcelRegister("4ZAD9", function(module, exports) {

var $hWSn8 = parcelRequire("hWSn8");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $hWSn8.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

parcelRegister("cN8vX", function(module, exports) {

var $aVaWD = parcelRequire("aVaWD");
'use strict';
// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var $9500aa6e984498fb$var$MAX_BYTES = 65536;
// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var $9500aa6e984498fb$var$MAX_UINT32 = 4294967295;

var $dmAgJ = parcelRequire("dmAgJ");
var $9500aa6e984498fb$require$Buffer = $dmAgJ.Buffer;
var $9500aa6e984498fb$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
module.exports = function(size, cb) {
    if ($9500aa6e984498fb$var$crypto && $9500aa6e984498fb$var$crypto.getRandomValues) // browser
    return $9500aa6e984498fb$var$randomBytes(size, cb);
    else {
        if (globalThis.crypto && globalThis.crypto.randomBytes) // tesseract runtime
        return globalThis.crypto.randomBytes(size, cb);
        else // tesseract init time
        throw new Error('No randomBytes() support in current environment.');
    }
};
function $9500aa6e984498fb$var$randomBytes(size, cb) {
    // phantomjs needs to throw
    if (size > $9500aa6e984498fb$var$MAX_UINT32) throw new RangeError('requested too many random bytes');
    var bytes = $9500aa6e984498fb$require$Buffer.allocUnsafe(size);
    if (size > 0) {
        if (size > $9500aa6e984498fb$var$MAX_BYTES) // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
        for(var generated = 0; generated < size; generated += $9500aa6e984498fb$var$MAX_BYTES)// buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        $9500aa6e984498fb$var$crypto.getRandomValues(bytes.slice(generated, generated + $9500aa6e984498fb$var$MAX_BYTES));
        else $9500aa6e984498fb$var$crypto.getRandomValues(bytes);
    }
    if (typeof cb === 'function') return $aVaWD.nextTick(function() {
        cb(null, bytes);
    });
    return bytes;
}

});
parcelRegister("dmAgJ", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $b0qLu = parcelRequire("b0qLu");
var $9ba976a77c7e4c98$var$Buffer = $b0qLu.Buffer;
// alternative to using Object.keys for old browsers
function $9ba976a77c7e4c98$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($9ba976a77c7e4c98$var$Buffer.from && $9ba976a77c7e4c98$var$Buffer.alloc && $9ba976a77c7e4c98$var$Buffer.allocUnsafe && $9ba976a77c7e4c98$var$Buffer.allocUnsafeSlow) module.exports = $b0qLu;
else {
    // Copy properties from require('buffer')
    $9ba976a77c7e4c98$var$copyProps($b0qLu, module.exports);
    module.exports.Buffer = $9ba976a77c7e4c98$var$SafeBuffer;
}
function $9ba976a77c7e4c98$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $9ba976a77c7e4c98$var$Buffer(arg, encodingOrOffset, length);
}
$9ba976a77c7e4c98$var$SafeBuffer.prototype = Object.create($9ba976a77c7e4c98$var$Buffer.prototype);
// Copy static methods from Buffer
$9ba976a77c7e4c98$var$copyProps($9ba976a77c7e4c98$var$Buffer, $9ba976a77c7e4c98$var$SafeBuffer);
$9ba976a77c7e4c98$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $9ba976a77c7e4c98$var$Buffer(arg, encodingOrOffset, length);
};
$9ba976a77c7e4c98$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $9ba976a77c7e4c98$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$9ba976a77c7e4c98$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $9ba976a77c7e4c98$var$Buffer(size);
};
$9ba976a77c7e4c98$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $b0qLu.SlowBuffer(size);
};

});


parcelRegister("4Qxdz", function(module, exports) {
'use strict';

var $jcXeW = parcelRequire("jcXeW");

var $ia0OJ = parcelRequire("ia0OJ");

var $43hsM = parcelRequire("43hsM");

var $fnOyZ = parcelRequire("fnOyZ");

var $h4bOS = parcelRequire("h4bOS");
function $3875c91b32c9e339$var$Hash(hash) {
    $h4bOS.call(this, 'digest');
    this._hash = hash;
}
$jcXeW($3875c91b32c9e339$var$Hash, $h4bOS);
$3875c91b32c9e339$var$Hash.prototype._update = function(data) {
    this._hash.update(data);
};
$3875c91b32c9e339$var$Hash.prototype._final = function() {
    return this._hash.digest();
};
module.exports = function createHash(alg) {
    alg = alg.toLowerCase();
    if (alg === 'md5') return new $ia0OJ();
    if (alg === 'rmd160' || alg === 'ripemd160') return new $43hsM();
    return new $3875c91b32c9e339$var$Hash($fnOyZ(alg));
};

});
parcelRegister("jcXeW", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("ia0OJ", function(module, exports) {
'use strict';

var $jcXeW = parcelRequire("jcXeW");

var $9goGI = parcelRequire("9goGI");

var $dmAgJ = parcelRequire("dmAgJ");
var $d389cb6e60b1bb2a$require$Buffer = $dmAgJ.Buffer;
var $d389cb6e60b1bb2a$var$ARRAY16 = new Array(16);
function $d389cb6e60b1bb2a$var$MD5() {
    $9goGI.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
}
$jcXeW($d389cb6e60b1bb2a$var$MD5, $9goGI);
$d389cb6e60b1bb2a$var$MD5.prototype._update = function() {
    var M = $d389cb6e60b1bb2a$var$ARRAY16;
    for(var i = 0; i < 16; ++i)M[i] = this._block.readInt32LE(i * 4);
    var a = this._a;
    var b = this._b;
    var c = this._c;
    var d = this._d;
    a = $d389cb6e60b1bb2a$var$fnF(a, b, c, d, M[0], 0xd76aa478, 7);
    d = $d389cb6e60b1bb2a$var$fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
    c = $d389cb6e60b1bb2a$var$fnF(c, d, a, b, M[2], 0x242070db, 17);
    b = $d389cb6e60b1bb2a$var$fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
    a = $d389cb6e60b1bb2a$var$fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
    d = $d389cb6e60b1bb2a$var$fnF(d, a, b, c, M[5], 0x4787c62a, 12);
    c = $d389cb6e60b1bb2a$var$fnF(c, d, a, b, M[6], 0xa8304613, 17);
    b = $d389cb6e60b1bb2a$var$fnF(b, c, d, a, M[7], 0xfd469501, 22);
    a = $d389cb6e60b1bb2a$var$fnF(a, b, c, d, M[8], 0x698098d8, 7);
    d = $d389cb6e60b1bb2a$var$fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
    c = $d389cb6e60b1bb2a$var$fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
    b = $d389cb6e60b1bb2a$var$fnF(b, c, d, a, M[11], 0x895cd7be, 22);
    a = $d389cb6e60b1bb2a$var$fnF(a, b, c, d, M[12], 0x6b901122, 7);
    d = $d389cb6e60b1bb2a$var$fnF(d, a, b, c, M[13], 0xfd987193, 12);
    c = $d389cb6e60b1bb2a$var$fnF(c, d, a, b, M[14], 0xa679438e, 17);
    b = $d389cb6e60b1bb2a$var$fnF(b, c, d, a, M[15], 0x49b40821, 22);
    a = $d389cb6e60b1bb2a$var$fnG(a, b, c, d, M[1], 0xf61e2562, 5);
    d = $d389cb6e60b1bb2a$var$fnG(d, a, b, c, M[6], 0xc040b340, 9);
    c = $d389cb6e60b1bb2a$var$fnG(c, d, a, b, M[11], 0x265e5a51, 14);
    b = $d389cb6e60b1bb2a$var$fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
    a = $d389cb6e60b1bb2a$var$fnG(a, b, c, d, M[5], 0xd62f105d, 5);
    d = $d389cb6e60b1bb2a$var$fnG(d, a, b, c, M[10], 0x02441453, 9);
    c = $d389cb6e60b1bb2a$var$fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
    b = $d389cb6e60b1bb2a$var$fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
    a = $d389cb6e60b1bb2a$var$fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
    d = $d389cb6e60b1bb2a$var$fnG(d, a, b, c, M[14], 0xc33707d6, 9);
    c = $d389cb6e60b1bb2a$var$fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
    b = $d389cb6e60b1bb2a$var$fnG(b, c, d, a, M[8], 0x455a14ed, 20);
    a = $d389cb6e60b1bb2a$var$fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
    d = $d389cb6e60b1bb2a$var$fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
    c = $d389cb6e60b1bb2a$var$fnG(c, d, a, b, M[7], 0x676f02d9, 14);
    b = $d389cb6e60b1bb2a$var$fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
    a = $d389cb6e60b1bb2a$var$fnH(a, b, c, d, M[5], 0xfffa3942, 4);
    d = $d389cb6e60b1bb2a$var$fnH(d, a, b, c, M[8], 0x8771f681, 11);
    c = $d389cb6e60b1bb2a$var$fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
    b = $d389cb6e60b1bb2a$var$fnH(b, c, d, a, M[14], 0xfde5380c, 23);
    a = $d389cb6e60b1bb2a$var$fnH(a, b, c, d, M[1], 0xa4beea44, 4);
    d = $d389cb6e60b1bb2a$var$fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
    c = $d389cb6e60b1bb2a$var$fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
    b = $d389cb6e60b1bb2a$var$fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
    a = $d389cb6e60b1bb2a$var$fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
    d = $d389cb6e60b1bb2a$var$fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
    c = $d389cb6e60b1bb2a$var$fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
    b = $d389cb6e60b1bb2a$var$fnH(b, c, d, a, M[6], 0x04881d05, 23);
    a = $d389cb6e60b1bb2a$var$fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
    d = $d389cb6e60b1bb2a$var$fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
    c = $d389cb6e60b1bb2a$var$fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
    b = $d389cb6e60b1bb2a$var$fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
    a = $d389cb6e60b1bb2a$var$fnI(a, b, c, d, M[0], 0xf4292244, 6);
    d = $d389cb6e60b1bb2a$var$fnI(d, a, b, c, M[7], 0x432aff97, 10);
    c = $d389cb6e60b1bb2a$var$fnI(c, d, a, b, M[14], 0xab9423a7, 15);
    b = $d389cb6e60b1bb2a$var$fnI(b, c, d, a, M[5], 0xfc93a039, 21);
    a = $d389cb6e60b1bb2a$var$fnI(a, b, c, d, M[12], 0x655b59c3, 6);
    d = $d389cb6e60b1bb2a$var$fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
    c = $d389cb6e60b1bb2a$var$fnI(c, d, a, b, M[10], 0xffeff47d, 15);
    b = $d389cb6e60b1bb2a$var$fnI(b, c, d, a, M[1], 0x85845dd1, 21);
    a = $d389cb6e60b1bb2a$var$fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
    d = $d389cb6e60b1bb2a$var$fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
    c = $d389cb6e60b1bb2a$var$fnI(c, d, a, b, M[6], 0xa3014314, 15);
    b = $d389cb6e60b1bb2a$var$fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
    a = $d389cb6e60b1bb2a$var$fnI(a, b, c, d, M[4], 0xf7537e82, 6);
    d = $d389cb6e60b1bb2a$var$fnI(d, a, b, c, M[11], 0xbd3af235, 10);
    c = $d389cb6e60b1bb2a$var$fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
    b = $d389cb6e60b1bb2a$var$fnI(b, c, d, a, M[9], 0xeb86d391, 21);
    this._a = this._a + a | 0;
    this._b = this._b + b | 0;
    this._c = this._c + c | 0;
    this._d = this._d + d | 0;
};
$d389cb6e60b1bb2a$var$MD5.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $d389cb6e60b1bb2a$require$Buffer.allocUnsafe(16);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    return buffer;
};
function $d389cb6e60b1bb2a$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $d389cb6e60b1bb2a$var$fnF(a, b, c, d, m, k, s) {
    return $d389cb6e60b1bb2a$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
}
function $d389cb6e60b1bb2a$var$fnG(a, b, c, d, m, k, s) {
    return $d389cb6e60b1bb2a$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
}
function $d389cb6e60b1bb2a$var$fnH(a, b, c, d, m, k, s) {
    return $d389cb6e60b1bb2a$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
}
function $d389cb6e60b1bb2a$var$fnI(a, b, c, d, m, k, s) {
    return $d389cb6e60b1bb2a$var$rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
}
module.exports = $d389cb6e60b1bb2a$var$MD5;

});
parcelRegister("9goGI", function(module, exports) {
'use strict';

var $dmAgJ = parcelRequire("dmAgJ");
var $6be8c232391a3f0b$require$Buffer = $dmAgJ.Buffer;

var $gLoAA = parcelRequire("gLoAA");

var $5GJJl = parcelRequire("5GJJl");
var $6be8c232391a3f0b$require$Transform = $5GJJl.Transform;

var $jcXeW = parcelRequire("jcXeW");
function $6be8c232391a3f0b$var$HashBase(blockSize) {
    $6be8c232391a3f0b$require$Transform.call(this);
    this._block = $6be8c232391a3f0b$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$jcXeW($6be8c232391a3f0b$var$HashBase, $6be8c232391a3f0b$require$Transform);
$6be8c232391a3f0b$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$6be8c232391a3f0b$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
$6be8c232391a3f0b$var$HashBase.prototype.update = function(data, encoding) {
    if (this._finalized) throw new Error('Digest already called');
    var dataBuffer = $gLoAA(data, encoding); // asserts correct input type
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + dataBuffer.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;){
            block[i] = dataBuffer[offset];
            i += 1;
            offset += 1;
        }
        this._update();
        this._blockOffset = 0;
    }
    while(offset < dataBuffer.length){
        block[this._blockOffset] = dataBuffer[offset];
        this._blockOffset += 1;
        offset += 1;
    }
    // update length
    for(var j = 0, carry = dataBuffer.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$6be8c232391a3f0b$var$HashBase.prototype._update = function() {
    throw new Error('_update is not implemented');
};
$6be8c232391a3f0b$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error('Digest already called');
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$6be8c232391a3f0b$var$HashBase.prototype._digest = function() {
    throw new Error('_digest is not implemented');
};
module.exports = $6be8c232391a3f0b$var$HashBase;

});
parcelRegister("gLoAA", function(module, exports) {
'use strict';

var $dmAgJ = parcelRequire("dmAgJ");
var $c3441c086a20100c$require$Buffer = $dmAgJ.Buffer;

var $dXhxR = parcelRequire("dXhxR");
var $c3441c086a20100c$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $c3441c086a20100c$var$useArrayBuffer = $c3441c086a20100c$var$useUint8Array && typeof ArrayBuffer !== 'undefined';
var $c3441c086a20100c$var$isView = $c3441c086a20100c$var$useArrayBuffer && ArrayBuffer.isView;
module.exports = function(thing, encoding) {
    if (typeof thing === 'string' || $c3441c086a20100c$require$Buffer.isBuffer(thing) || $c3441c086a20100c$var$useUint8Array && thing instanceof Uint8Array || $c3441c086a20100c$var$isView && $c3441c086a20100c$var$isView(thing)) return $dXhxR(thing, encoding);
    throw new TypeError('The "data" argument must be a string, a Buffer, a Uint8Array, or a DataView');
};

});
parcelRegister("dXhxR", function(module, exports) {
'use strict';

var $dmAgJ = parcelRequire("dmAgJ");
var $a28e6522d6c91b6f$require$Buffer = $dmAgJ.Buffer;

var $9eJXD = parcelRequire("9eJXD");

var $Jqj8D = parcelRequire("Jqj8D");
var $a28e6522d6c91b6f$var$isView = ArrayBuffer.isView || function isView(obj) {
    try {
        $Jqj8D(obj);
        return true;
    } catch (e) {
        return false;
    }
};
var $a28e6522d6c91b6f$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $a28e6522d6c91b6f$var$useArrayBuffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined';
var $a28e6522d6c91b6f$var$useFromArrayBuffer = $a28e6522d6c91b6f$var$useArrayBuffer && ($a28e6522d6c91b6f$require$Buffer.prototype instanceof Uint8Array || $a28e6522d6c91b6f$require$Buffer.TYPED_ARRAY_SUPPORT);
module.exports = function toBuffer(data, encoding) {
    if ($a28e6522d6c91b6f$require$Buffer.isBuffer(data)) {
        if (data.constructor && !('isBuffer' in data)) // probably a SlowBuffer
        return $a28e6522d6c91b6f$require$Buffer.from(data);
        return data;
    }
    if (typeof data === 'string') return $a28e6522d6c91b6f$require$Buffer.from(data, encoding);
    /*
	 * Wrap any TypedArray instances and DataViews
	 * Makes sense only on engines with full TypedArray support -- let Buffer detect that
	 */ if ($a28e6522d6c91b6f$var$useArrayBuffer && $a28e6522d6c91b6f$var$isView(data)) {
        // Bug in Node.js <6.3.1, which treats this as out-of-bounds
        if (data.byteLength === 0) return $a28e6522d6c91b6f$require$Buffer.alloc(0);
        // When Buffer is based on Uint8Array, we can just construct it from ArrayBuffer
        if ($a28e6522d6c91b6f$var$useFromArrayBuffer) {
            var res = $a28e6522d6c91b6f$require$Buffer.from(data.buffer, data.byteOffset, data.byteLength);
            /*
			 * Recheck result size, as offset/length doesn't work on Node.js <5.10
			 * We just go to Uint8Array case if this fails
			 */ if (res.byteLength === data.byteLength) return res;
        }
        // Convert to Uint8Array bytes and then to Buffer
        var uint8 = data instanceof Uint8Array ? data : new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
        var result = $a28e6522d6c91b6f$require$Buffer.from(uint8);
        /*
		 * Let's recheck that conversion succeeded
		 * We have .length but not .byteLength when useFromArrayBuffer is false
		 */ if (result.length === data.byteLength) return result;
    }
    /*
	 * Uint8Array in engines where Buffer.from might not work with ArrayBuffer, just copy over
	 * Doesn't make sense with other TypedArray instances
	 */ if ($a28e6522d6c91b6f$var$useUint8Array && data instanceof Uint8Array) return $a28e6522d6c91b6f$require$Buffer.from(data);
    var isArr = $9eJXD(data);
    if (isArr) for(var i = 0; i < data.length; i += 1){
        var x = data[i];
        if (typeof x !== 'number' || x < 0 || x > 255 || ~~x !== x // NaN and integer check
        ) throw new RangeError('Array items must be numbers in the range 0-255.');
    }
    /*
	 * Old Buffer polyfill on an engine that doesn't have TypedArray support
	 * Also, this is from a different Buffer polyfill implementation then we have, as instanceof check failed
	 * Convert to our current Buffer implementation
	 */ if (isArr || $a28e6522d6c91b6f$require$Buffer.isBuffer(data) && data.constructor && typeof data.constructor.isBuffer === 'function' && data.constructor.isBuffer(data)) return $a28e6522d6c91b6f$require$Buffer.from(data);
    throw new TypeError('The "data" argument must be a string, an Array, a Buffer, a Uint8Array, or a DataView.');
};

});
parcelRegister("9eJXD", function(module, exports) {
var $6b9912bea7d30722$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $6b9912bea7d30722$var$toString.call(arr) == '[object Array]';
};

});

parcelRegister("Jqj8D", function(module, exports) {
'use strict';

var $lERDT = parcelRequire("lERDT");

var $g3lHM = parcelRequire("g3lHM");
/** @type {undefined | ((thisArg: import('.').TypedArray) => Buffer<ArrayBufferLike>)} */ var $08889c3dc6470bc8$var$$typedArrayBuffer = $g3lHM('TypedArray.prototype.buffer', true);

var $iizC4 = parcelRequire("iizC4");
/** @type {import('.')} */ // node <= 0.10, < 0.11.4 has a nonconfigurable own property instead of a prototype getter
module.exports = $08889c3dc6470bc8$var$$typedArrayBuffer || function typedArrayBuffer(x) {
    if (!$iizC4(x)) throw new $lERDT('Not a Typed Array');
    return x.buffer;
};

});
parcelRegister("iizC4", function(module, exports) {
'use strict';

var $k7rkZ = parcelRequire("k7rkZ");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$k7rkZ(value);
};

});
parcelRegister("k7rkZ", function(module, exports) {
'use strict';

var $kUbac = parcelRequire("kUbac");

var $8vOD9 = parcelRequire("8vOD9");

var $3gB4W = parcelRequire("3gB4W");

var $g3lHM = parcelRequire("g3lHM");

var $8p6Da = parcelRequire("8p6Da");

var $5iUpq = parcelRequire("5iUpq");
var $ea59aac11939dad0$var$$toString = $g3lHM('Object.prototype.toString');

var $ea59aac11939dad0$var$hasToStringTag = (parcelRequire("ie0j1"))();
var $ea59aac11939dad0$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
var $ea59aac11939dad0$var$typedArrays = $8vOD9();
var $ea59aac11939dad0$var$$slice = $g3lHM('String.prototype.slice');
/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $ea59aac11939dad0$var$$indexOf = $g3lHM('Array.prototype.indexOf', true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @typedef {import('./types').Getter} Getter */ /** @type {import('./types').Cache} */ var $ea59aac11939dad0$var$cache = {
    __proto__: null
};
if ($ea59aac11939dad0$var$hasToStringTag && $8p6Da && $5iUpq) $kUbac($ea59aac11939dad0$var$typedArrays, function(typedArray) {
    var arr = new $ea59aac11939dad0$var$g[typedArray]();
    if (Symbol.toStringTag in arr && $5iUpq) {
        var proto = $5iUpq(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $8p6Da(proto, Symbol.toStringTag);
        if (!descriptor && proto) {
            var superProto = $5iUpq(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $8p6Da(superProto, Symbol.toStringTag);
        }
        // @ts-expect-error TODO: fix
        $ea59aac11939dad0$var$cache['$' + typedArray] = $3gB4W(descriptor.get);
    }
});
else $kUbac($ea59aac11939dad0$var$typedArrays, function(typedArray) {
    var arr = new $ea59aac11939dad0$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) $ea59aac11939dad0$var$cache[/** @type {`$${import('.').TypedArrayName}`} */ '$' + typedArray] = /** @type {import('./types').BoundSlice | import('./types').BoundSet} */ // @ts-expect-error TODO FIXME
    $3gB4W(fn);
});
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $ea59aac11939dad0$var$tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
    $kUbac(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $ea59aac11939dad0$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            if ('$' + getter(value) === typedArray) found = /** @type {import('.').TypedArrayName} */ $ea59aac11939dad0$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $ea59aac11939dad0$var$trySlices = function tryAllSlices(value) {
    /** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
    $kUbac(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $ea59aac11939dad0$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            getter(value);
            found = /** @type {import('.').TypedArrayName} */ $ea59aac11939dad0$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== 'object') return false;
    if (!$ea59aac11939dad0$var$hasToStringTag) {
        /** @type {string} */ var tag = $ea59aac11939dad0$var$$slice($ea59aac11939dad0$var$$toString(value), 8, -1);
        if ($ea59aac11939dad0$var$$indexOf($ea59aac11939dad0$var$typedArrays, tag) > -1) return tag;
        if (tag !== 'Object') return false;
        // node < 0.6 hits here on real Typed Arrays
        return $ea59aac11939dad0$var$trySlices(value);
    }
    if (!$8p6Da) return null;
     // unknown engine
    return $ea59aac11939dad0$var$tryTypedArrays(value);
};

});
parcelRegister("kUbac", function(module, exports) {
'use strict';

var $7cqba = parcelRequire("7cqba");
var $f381b277a30f4931$var$toStr = Object.prototype.toString;
var $f381b277a30f4931$var$hasOwnProperty = Object.prototype.hasOwnProperty;
/** @type {<This, A extends readonly unknown[]>(arr: A, iterator: (this: This | void, value: A[number], index: number, arr: A) => void, receiver: This | undefined) => void} */ var $f381b277a30f4931$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($f381b277a30f4931$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
/** @type {<This, S extends string>(string: S, iterator: (this: This | void, value: S[number], index: number, string: S) => void, receiver: This | undefined) => void} */ var $f381b277a30f4931$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
/** @type {<This, O>(obj: O, iterator: (this: This | void, value: O[keyof O], index: keyof O, obj: O) => void, receiver: This | undefined) => void} */ var $f381b277a30f4931$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($f381b277a30f4931$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
/** @type {(x: unknown) => x is readonly unknown[]} */ function $f381b277a30f4931$var$isArray(x) {
    return $f381b277a30f4931$var$toStr.call(x) === '[object Array]';
}
/** @type {import('.')._internal} */ module.exports = function forEach(list, iterator, thisArg) {
    if (!$7cqba(iterator)) throw new TypeError('iterator must be a function');
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($f381b277a30f4931$var$isArray(list)) $f381b277a30f4931$var$forEachArray(list, iterator, receiver);
    else if (typeof list === 'string') $f381b277a30f4931$var$forEachString(list, iterator, receiver);
    else $f381b277a30f4931$var$forEachObject(list, iterator, receiver);
};

});
parcelRegister("7cqba", function(module, exports) {
'use strict';
var $53ddf6063b771174$var$fnToStr = Function.prototype.toString;
var $53ddf6063b771174$var$reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var $53ddf6063b771174$var$badArrayLike;
var $53ddf6063b771174$var$isCallableMarker;
if (typeof $53ddf6063b771174$var$reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
    $53ddf6063b771174$var$badArrayLike = Object.defineProperty({}, 'length', {
        get: function() {
            throw $53ddf6063b771174$var$isCallableMarker;
        }
    });
    $53ddf6063b771174$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $53ddf6063b771174$var$reflectApply(function() {
        throw 42;
    }, null, $53ddf6063b771174$var$badArrayLike);
} catch (_) {
    if (_ !== $53ddf6063b771174$var$isCallableMarker) $53ddf6063b771174$var$reflectApply = null;
}
else $53ddf6063b771174$var$reflectApply = null;
var $53ddf6063b771174$var$constructorRegex = /^\s*class\b/;
var $53ddf6063b771174$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $53ddf6063b771174$var$fnToStr.call(value);
        return $53ddf6063b771174$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $53ddf6063b771174$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($53ddf6063b771174$var$isES6ClassFn(value)) return false;
        $53ddf6063b771174$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $53ddf6063b771174$var$toStr = Object.prototype.toString;
var $53ddf6063b771174$var$objectClass = '[object Object]';
var $53ddf6063b771174$var$fnClass = '[object Function]';
var $53ddf6063b771174$var$genClass = '[object GeneratorFunction]';
var $53ddf6063b771174$var$ddaClass = '[object HTMLAllCollection]'; // IE 11
var $53ddf6063b771174$var$ddaClass2 = '[object HTML document.all class]';
var $53ddf6063b771174$var$ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var $53ddf6063b771174$var$hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $53ddf6063b771174$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $53ddf6063b771174$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === 'object') {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $53ddf6063b771174$var$all = document.all;
    if ($53ddf6063b771174$var$toStr.call($53ddf6063b771174$var$all) === $53ddf6063b771174$var$toStr.call(document.all)) $53ddf6063b771174$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($53ddf6063b771174$var$isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) try {
            var str = $53ddf6063b771174$var$toStr.call(value);
            return (str === $53ddf6063b771174$var$ddaClass || str === $53ddf6063b771174$var$ddaClass2 || str === $53ddf6063b771174$var$ddaClass3 // opera 12.16
             || str === $53ddf6063b771174$var$objectClass // IE 6-8
            ) && value('') == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $53ddf6063b771174$var$reflectApply ? function isCallable(value) {
    if ($53ddf6063b771174$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    try {
        $53ddf6063b771174$var$reflectApply(value, null, $53ddf6063b771174$var$badArrayLike);
    } catch (e) {
        if (e !== $53ddf6063b771174$var$isCallableMarker) return false;
    }
    return !$53ddf6063b771174$var$isES6ClassFn(value) && $53ddf6063b771174$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($53ddf6063b771174$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    if ($53ddf6063b771174$var$hasToStringTag) return $53ddf6063b771174$var$tryFunctionObject(value);
    if ($53ddf6063b771174$var$isES6ClassFn(value)) return false;
    var strClass = $53ddf6063b771174$var$toStr.call(value);
    if (strClass !== $53ddf6063b771174$var$fnClass && strClass !== $53ddf6063b771174$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $53ddf6063b771174$var$tryFunctionObject(value);
};

});


parcelRegister("8vOD9", function(module, exports) {
'use strict';

var $dL4ft = parcelRequire("dL4ft");
var $63287e28cf83e2ba$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $dL4ft.length; i++)if (typeof $63287e28cf83e2ba$var$g[$dL4ft[i]] === 'function') // @ts-expect-error
    out[out.length] = $dL4ft[i];
    return out;
};

});
parcelRegister("dL4ft", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = [
    'Float32Array',
    'Float64Array',
    'Int8Array',
    'Int16Array',
    'Int32Array',
    'Uint8Array',
    'Uint8ClampedArray',
    'Uint16Array',
    'Uint32Array',
    'BigInt64Array',
    'BigUint64Array'
];

});


parcelRegister("3gB4W", function(module, exports) {
'use strict';

var $bJXOm = parcelRequire("bJXOm");

var $7rfzY = parcelRequire("7rfzY");

var $7B814 = parcelRequire("7B814");

var $3IPVY = parcelRequire("3IPVY");
module.exports = function callBind(originalFunction) {
    var func = $7B814(arguments);
    var adjustedLength = originalFunction.length - (arguments.length - 1);
    return $bJXOm(func, 1 + (adjustedLength > 0 ? adjustedLength : 0), true);
};
if ($7rfzY) $7rfzY(module.exports, 'apply', {
    value: $3IPVY
});
else module.exports.apply = $3IPVY;

});
parcelRegister("bJXOm", function(module, exports) {
'use strict';

var $6veyu = parcelRequire("6veyu");

var $cacHW = parcelRequire("cacHW");

var $88c24af6964f7557$var$hasDescriptors = (parcelRequire("fmOor"))();

var $8p6Da = parcelRequire("8p6Da");

var $lERDT = parcelRequire("lERDT");
var $88c24af6964f7557$var$$floor = $6veyu('%Math.floor%');
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== 'function') throw new $lERDT('`fn` is not a function');
    if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $88c24af6964f7557$var$$floor(length) !== length) throw new $lERDT('`length` must be a positive 32-bit integer');
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ('length' in fn && $8p6Da) {
        var desc = $8p6Da(fn, 'length');
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($88c24af6964f7557$var$hasDescriptors) $cacHW(/** @type {Parameters<define>[0]} */ fn, 'length', length, true, true);
        else $cacHW(/** @type {Parameters<define>[0]} */ fn, 'length', length);
    }
    return fn;
};

});
parcelRegister("cacHW", function(module, exports) {
'use strict';

var $7rfzY = parcelRequire("7rfzY");

var $h0msM = parcelRequire("h0msM");

var $lERDT = parcelRequire("lERDT");

var $8p6Da = parcelRequire("8p6Da");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== 'object' && typeof obj !== 'function') throw new $lERDT('`obj` must be an object or a function`');
    if (typeof property !== 'string' && typeof property !== 'symbol') throw new $lERDT('`property` must be a string or a symbol`');
    if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) throw new $lERDT('`nonEnumerable`, if provided, must be a boolean or null');
    if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) throw new $lERDT('`nonWritable`, if provided, must be a boolean or null');
    if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) throw new $lERDT('`nonConfigurable`, if provided, must be a boolean or null');
    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') throw new $lERDT('`loose`, if provided, must be a boolean');
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$8p6Da && $8p6Da(obj, property);
    if ($7rfzY) $7rfzY(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $h0msM('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
};

});
parcelRegister("7rfzY", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $56a723b4a34b5e05$var$$defineProperty = Object.defineProperty || false;
if ($56a723b4a34b5e05$var$$defineProperty) try {
    $56a723b4a34b5e05$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $56a723b4a34b5e05$var$$defineProperty = false;
}
module.exports = $56a723b4a34b5e05$var$$defineProperty;

});

parcelRegister("8p6Da", function(module, exports) {
'use strict';

var $01hb9 = parcelRequire("01hb9");
var $61e5cd43d5f3e926$require$$gOPD = $01hb9;
if ($61e5cd43d5f3e926$require$$gOPD) try {
    $61e5cd43d5f3e926$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $61e5cd43d5f3e926$require$$gOPD = null;
}
module.exports = $61e5cd43d5f3e926$require$$gOPD;

});
parcelRegister("01hb9", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});



parcelRegister("fmOor", function(module, exports) {
'use strict';

var $7rfzY = parcelRequire("7rfzY");
var $b300001c5e8e8d96$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$7rfzY;
};
$b300001c5e8e8d96$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$7rfzY) return null;
    try {
        return $7rfzY([], 'length', {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $b300001c5e8e8d96$var$hasPropertyDescriptors;

});


parcelRegister("3IPVY", function(module, exports) {
'use strict';

var $9H3MS = parcelRequire("9H3MS");

var $4pZHe = parcelRequire("4pZHe");

var $ju0jq = parcelRequire("ju0jq");
/** @type {import('./applyBind')} */ module.exports = function applyBind() {
    return $ju0jq($9H3MS, $4pZHe, arguments);
};

});


parcelRegister("5iUpq", function(module, exports) {
'use strict';

var $dSapP = parcelRequire("dSapP");

var $a36W2 = parcelRequire("a36W2");

var $52R8n = parcelRequire("52R8n");
/** @type {import('.')} */ module.exports = $dSapP ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $dSapP(O);
} : $a36W2 ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $a36W2(O);
} : $52R8n ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $52R8n(O);
} : null;

});
parcelRegister("dSapP", function(module, exports) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

});

parcelRegister("a36W2", function(module, exports) {
'use strict';

var $jHvIT = parcelRequire("jHvIT");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $jHvIT.getPrototypeOf || null;

});
parcelRegister("jHvIT", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});


parcelRegister("52R8n", function(module, exports) {
'use strict';

var $7B814 = parcelRequire("7B814");

var $8p6Da = parcelRequire("8p6Da");
var $3ac65afd5f2d9eae$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $3ac65afd5f2d9eae$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $3ac65afd5f2d9eae$var$desc = !!$3ac65afd5f2d9eae$var$hasProtoAccessor && $8p6Da && $8p6Da(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $3ac65afd5f2d9eae$var$$Object = Object;
var $3ac65afd5f2d9eae$var$$getPrototypeOf = $3ac65afd5f2d9eae$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = $3ac65afd5f2d9eae$var$desc && typeof $3ac65afd5f2d9eae$var$desc.get === 'function' ? $7B814([
    $3ac65afd5f2d9eae$var$desc.get
]) : typeof $3ac65afd5f2d9eae$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $3ac65afd5f2d9eae$var$$getPrototypeOf(value == null ? value : $3ac65afd5f2d9eae$var$$Object(value));
} : false;

});


parcelRegister("ie0j1", function(module, exports) {
'use strict';

var $lhzCW = parcelRequire("lhzCW");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $lhzCW() && !!Symbol.toStringTag;
};

});






parcelRegister("5GJJl", function(module, exports) {

exports = module.exports = (parcelRequire("9ndRN"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("f8joC"));

exports.Duplex = (parcelRequire("cacUu"));

exports.Transform = (parcelRequire("OKhOa"));

exports.PassThrough = (parcelRequire("bgVxg"));

});
parcelRegister("9ndRN", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $aVaWD = parcelRequire("aVaWD");
'use strict';

var $xBkZP = parcelRequire("xBkZP");
/*</replacement>*/ module.exports = $6d3104a7444ea958$var$Readable;

var $5iwsz = parcelRequire("5iwsz");
/*</replacement>*/ /*<replacement>*/ var $6d3104a7444ea958$var$Duplex;
/*</replacement>*/ $6d3104a7444ea958$var$Readable.ReadableState = $6d3104a7444ea958$var$ReadableState;

var $gW4Pg = parcelRequire("gW4Pg");
var $6d3104a7444ea958$require$EE = $gW4Pg.EventEmitter;
var $6d3104a7444ea958$var$EElistenerCount = function(emitter, type) {
    return emitter.listeners(type).length;
};

var $bHNWA = parcelRequire("bHNWA");

var $hF7qG = parcelRequire("hF7qG");
var $6d3104a7444ea958$require$Buffer = $hF7qG.Buffer;
var $6d3104a7444ea958$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $6d3104a7444ea958$var$_uint8ArrayToBuffer(chunk) {
    return $6d3104a7444ea958$require$Buffer.from(chunk);
}
function $6d3104a7444ea958$var$_isUint8Array(obj) {
    return $6d3104a7444ea958$require$Buffer.isBuffer(obj) || obj instanceof $6d3104a7444ea958$var$OurUint8Array;
}

/*</replacement>*/ /*<replacement>*/ var $6d3104a7444ea958$var$util = Object.create((parcelRequire("5mxBc")));

$6d3104a7444ea958$var$util.inherits = (parcelRequire("jcXeW"));

var $luYXS = parcelRequire("luYXS");
var $6d3104a7444ea958$var$debug = void 0;
if ($luYXS && $luYXS.debuglog) $6d3104a7444ea958$var$debug = $luYXS.debuglog('stream');
else $6d3104a7444ea958$var$debug = function() {};

var $bk927 = parcelRequire("bk927");

var $fuIBY = parcelRequire("fuIBY");
var $6d3104a7444ea958$var$StringDecoder;
$6d3104a7444ea958$var$util.inherits($6d3104a7444ea958$var$Readable, $bHNWA);
var $6d3104a7444ea958$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $6d3104a7444ea958$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($5iwsz(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $6d3104a7444ea958$var$ReadableState(options, stream) {
    $6d3104a7444ea958$var$Duplex = $6d3104a7444ea958$var$Duplex || (parcelRequire("cacUu"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $6d3104a7444ea958$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    var hwm = options.highWaterMark;
    var readableHwm = options.readableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $bk927();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$6d3104a7444ea958$var$StringDecoder) $6d3104a7444ea958$var$StringDecoder = (parcelRequire("3vPJ0")).StringDecoder;
        this.decoder = new $6d3104a7444ea958$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $6d3104a7444ea958$var$Readable(options) {
    $6d3104a7444ea958$var$Duplex = $6d3104a7444ea958$var$Duplex || (parcelRequire("cacUu"));
    if (!(this instanceof $6d3104a7444ea958$var$Readable)) return new $6d3104a7444ea958$var$Readable(options);
    this._readableState = new $6d3104a7444ea958$var$ReadableState(options, this);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $bHNWA.call(this);
}
Object.defineProperty($6d3104a7444ea958$var$Readable.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$6d3104a7444ea958$var$Readable.prototype.destroy = $fuIBY.destroy;
$6d3104a7444ea958$var$Readable.prototype._undestroy = $fuIBY.undestroy;
$6d3104a7444ea958$var$Readable.prototype._destroy = function(err, cb) {
    this.push(null);
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$6d3104a7444ea958$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $6d3104a7444ea958$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $6d3104a7444ea958$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$6d3104a7444ea958$var$Readable.prototype.unshift = function(chunk) {
    return $6d3104a7444ea958$var$readableAddChunk(this, chunk, null, true, false);
};
function $6d3104a7444ea958$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $6d3104a7444ea958$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $6d3104a7444ea958$var$chunkInvalid(state, chunk);
        if (er) stream.emit('error', er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $6d3104a7444ea958$require$Buffer.prototype) chunk = $6d3104a7444ea958$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));
                else $6d3104a7444ea958$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) stream.emit('error', new Error('stream.push() after EOF'));
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $6d3104a7444ea958$var$addChunk(stream, state, chunk, false);
                    else $6d3104a7444ea958$var$maybeReadMore(stream, state);
                } else $6d3104a7444ea958$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) state.reading = false;
    }
    return $6d3104a7444ea958$var$needMoreData(state);
}
function $6d3104a7444ea958$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        stream.emit('data', chunk);
        stream.read(0);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $6d3104a7444ea958$var$emitReadable(stream);
    }
    $6d3104a7444ea958$var$maybeReadMore(stream, state);
}
function $6d3104a7444ea958$var$chunkInvalid(state, chunk) {
    var er;
    if (!$6d3104a7444ea958$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    return er;
}
// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function $6d3104a7444ea958$var$needMoreData(state) {
    return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}
$6d3104a7444ea958$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$6d3104a7444ea958$var$Readable.prototype.setEncoding = function(enc) {
    if (!$6d3104a7444ea958$var$StringDecoder) $6d3104a7444ea958$var$StringDecoder = (parcelRequire("3vPJ0")).StringDecoder;
    this._readableState.decoder = new $6d3104a7444ea958$var$StringDecoder(enc);
    this._readableState.encoding = enc;
    return this;
};
// Don't raise the hwm > 8MB
var $6d3104a7444ea958$var$MAX_HWM = 0x800000;
function $6d3104a7444ea958$var$computeNewHighWaterMark(n) {
    if (n >= $6d3104a7444ea958$var$MAX_HWM) n = $6d3104a7444ea958$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $6d3104a7444ea958$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $6d3104a7444ea958$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$6d3104a7444ea958$var$Readable.prototype.read = function(n) {
    $6d3104a7444ea958$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
        $6d3104a7444ea958$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $6d3104a7444ea958$var$endReadable(this);
        else $6d3104a7444ea958$var$emitReadable(this);
        return null;
    }
    n = $6d3104a7444ea958$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $6d3104a7444ea958$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $6d3104a7444ea958$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $6d3104a7444ea958$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $6d3104a7444ea958$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $6d3104a7444ea958$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $6d3104a7444ea958$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $6d3104a7444ea958$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = true;
        n = 0;
    } else state.length -= n;
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $6d3104a7444ea958$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $6d3104a7444ea958$var$onEofChunk(stream, state) {
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    // emit 'readable' now to make sure it gets picked up.
    $6d3104a7444ea958$var$emitReadable(stream);
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $6d3104a7444ea958$var$emitReadable(stream) {
    var state = stream._readableState;
    state.needReadable = false;
    if (!state.emittedReadable) {
        $6d3104a7444ea958$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        if (state.sync) $xBkZP.nextTick($6d3104a7444ea958$var$emitReadable_, stream);
        else $6d3104a7444ea958$var$emitReadable_(stream);
    }
}
function $6d3104a7444ea958$var$emitReadable_(stream) {
    $6d3104a7444ea958$var$debug('emit readable');
    stream.emit('readable');
    $6d3104a7444ea958$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $6d3104a7444ea958$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $xBkZP.nextTick($6d3104a7444ea958$var$maybeReadMore_, stream, state);
    }
}
function $6d3104a7444ea958$var$maybeReadMore_(stream, state) {
    var len = state.length;
    while(!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark){
        $6d3104a7444ea958$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
        else len = state.length;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$6d3104a7444ea958$var$Readable.prototype._read = function(n) {
    this.emit('error', new Error('_read() is not implemented'));
};
$6d3104a7444ea958$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $6d3104a7444ea958$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $aVaWD.stdout && dest !== $aVaWD.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $xBkZP.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $6d3104a7444ea958$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $6d3104a7444ea958$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $6d3104a7444ea958$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $6d3104a7444ea958$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    // If the user pushes more data while we're writing to dest then we'll end up
    // in ondata again. However, we only want to increase awaitDrain once because
    // dest will only emit one 'drain' event for the multiple writes.
    // => Introduce a guard on increasing awaitDrain.
    var increasedAwaitDrain = false;
    src.on('data', ondata);
    function ondata(chunk) {
        $6d3104a7444ea958$var$debug('ondata');
        increasedAwaitDrain = false;
        var ret = dest.write(chunk);
        if (false === ret && !increasedAwaitDrain) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $6d3104a7444ea958$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $6d3104a7444ea958$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
                increasedAwaitDrain = true;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $6d3104a7444ea958$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($6d3104a7444ea958$var$EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
    }
    // Make sure our error handler is attached before userland ones.
    $6d3104a7444ea958$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $6d3104a7444ea958$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $6d3104a7444ea958$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $6d3104a7444ea958$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $6d3104a7444ea958$var$pipeOnDrain(src) {
    return function() {
        var state = src._readableState;
        $6d3104a7444ea958$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $6d3104a7444ea958$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $6d3104a7444ea958$var$flow(src);
        }
    };
}
$6d3104a7444ea958$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $6d3104a7444ea958$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$6d3104a7444ea958$var$Readable.prototype.on = function(ev, fn) {
    var res = $bHNWA.prototype.on.call(this, ev, fn);
    if (ev === 'data') // Start flowing on next tick if stream isn't explicitly paused
    {
        if (this._readableState.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        var state = this._readableState;
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.emittedReadable = false;
            if (!state.reading) $xBkZP.nextTick($6d3104a7444ea958$var$nReadingNextTick, this);
            else if (state.length) $6d3104a7444ea958$var$emitReadable(this);
        }
    }
    return res;
};
$6d3104a7444ea958$var$Readable.prototype.addListener = $6d3104a7444ea958$var$Readable.prototype.on;
function $6d3104a7444ea958$var$nReadingNextTick(self1) {
    $6d3104a7444ea958$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$6d3104a7444ea958$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $6d3104a7444ea958$var$debug('resume');
        state.flowing = true;
        $6d3104a7444ea958$var$resume(this, state);
    }
    return this;
};
function $6d3104a7444ea958$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $xBkZP.nextTick($6d3104a7444ea958$var$resume_, stream, state);
    }
}
function $6d3104a7444ea958$var$resume_(stream, state) {
    if (!state.reading) {
        $6d3104a7444ea958$var$debug('resume read 0');
        stream.read(0);
    }
    state.resumeScheduled = false;
    state.awaitDrain = 0;
    stream.emit('resume');
    $6d3104a7444ea958$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$6d3104a7444ea958$var$Readable.prototype.pause = function() {
    $6d3104a7444ea958$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (false !== this._readableState.flowing) {
        $6d3104a7444ea958$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    return this;
};
function $6d3104a7444ea958$var$flow(stream) {
    var state = stream._readableState;
    $6d3104a7444ea958$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$6d3104a7444ea958$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $6d3104a7444ea958$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $6d3104a7444ea958$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function(method) {
        return function() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $6d3104a7444ea958$var$kProxyEvents.length; n++)stream.on($6d3104a7444ea958$var$kProxyEvents[n], this.emit.bind(this, $6d3104a7444ea958$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $6d3104a7444ea958$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};
Object.defineProperty($6d3104a7444ea958$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._readableState.highWaterMark;
    }
});
// exposed for testing purposes only.
$6d3104a7444ea958$var$Readable._fromList = $6d3104a7444ea958$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $6d3104a7444ea958$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.head.data;
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = $6d3104a7444ea958$var$fromListPartial(n, state.buffer, state.decoder);
    return ret;
}
// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $6d3104a7444ea958$var$fromListPartial(n, list, hasStrings) {
    var ret;
    if (n < list.head.data.length) {
        // slice is the same for buffers and strings
        ret = list.head.data.slice(0, n);
        list.head.data = list.head.data.slice(n);
    } else if (n === list.head.data.length) // first chunk is a perfect match
    ret = list.shift();
    else // result spans more than one buffer
    ret = hasStrings ? $6d3104a7444ea958$var$copyFromBufferString(n, list) : $6d3104a7444ea958$var$copyFromBuffer(n, list);
    return ret;
}
// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $6d3104a7444ea958$var$copyFromBufferString(n, list) {
    var p = list.head;
    var c = 1;
    var ret = p.data;
    n -= ret.length;
    while(p = p.next){
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;
        else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
            if (nb === str.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = str.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $6d3104a7444ea958$var$copyFromBuffer(n, list) {
    var ret = $6d3104a7444ea958$require$Buffer.allocUnsafe(n);
    var p = list.head;
    var c = 1;
    p.data.copy(ret);
    n -= p.data.length;
    while(p = p.next){
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
            if (nb === buf.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = buf.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
function $6d3104a7444ea958$var$endReadable(stream) {
    var state = stream._readableState;
    // If we get here before consuming all the bytes, then that is a
    // bug in node.  Should never happen.
    if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
    if (!state.endEmitted) {
        state.ended = true;
        $xBkZP.nextTick($6d3104a7444ea958$var$endReadableNT, state, stream);
    }
}
function $6d3104a7444ea958$var$endReadableNT(state, stream) {
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
    }
}
function $6d3104a7444ea958$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("xBkZP", function(module, exports) {

var $aVaWD = parcelRequire("aVaWD");
'use strict';
if (typeof $aVaWD === 'undefined' || !$aVaWD.version || $aVaWD.version.indexOf('v0.') === 0 || $aVaWD.version.indexOf('v1.') === 0 && $aVaWD.version.indexOf('v1.8.') !== 0) module.exports = {
    nextTick: $06500ba964f3509b$var$nextTick
};
else module.exports = $aVaWD;
function $06500ba964f3509b$var$nextTick(fn, arg1, arg2, arg3) {
    if (typeof fn !== 'function') throw new TypeError('"callback" argument must be a function');
    var len = arguments.length;
    var args, i;
    switch(len){
        case 0:
        case 1:
            return $aVaWD.nextTick(fn);
        case 2:
            return $aVaWD.nextTick(function afterTickOne() {
                fn.call(null, arg1);
            });
        case 3:
            return $aVaWD.nextTick(function afterTickTwo() {
                fn.call(null, arg1, arg2);
            });
        case 4:
            return $aVaWD.nextTick(function afterTickThree() {
                fn.call(null, arg1, arg2, arg3);
            });
        default:
            args = new Array(len - 1);
            i = 0;
            while(i < args.length)args[i++] = arguments[i];
            return $aVaWD.nextTick(function afterTick() {
                fn.apply(null, args);
            });
    }
}

});

parcelRegister("5iwsz", function(module, exports) {
var $3db7d007c4df0891$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $3db7d007c4df0891$var$toString.call(arr) == '[object Array]';
};

});

parcelRegister("gW4Pg", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $c545ce7100cdb4c6$var$R = typeof Reflect === 'object' ? Reflect : null;
var $c545ce7100cdb4c6$var$ReflectApply = $c545ce7100cdb4c6$var$R && typeof $c545ce7100cdb4c6$var$R.apply === 'function' ? $c545ce7100cdb4c6$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $c545ce7100cdb4c6$var$ReflectOwnKeys;
if ($c545ce7100cdb4c6$var$R && typeof $c545ce7100cdb4c6$var$R.ownKeys === 'function') $c545ce7100cdb4c6$var$ReflectOwnKeys = $c545ce7100cdb4c6$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $c545ce7100cdb4c6$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $c545ce7100cdb4c6$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $c545ce7100cdb4c6$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $c545ce7100cdb4c6$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $c545ce7100cdb4c6$var$EventEmitter() {
    $c545ce7100cdb4c6$var$EventEmitter.init.call(this);
}
module.exports = $c545ce7100cdb4c6$var$EventEmitter;
module.exports.once = $c545ce7100cdb4c6$var$once;
// Backwards-compat with node 0.10.x
$c545ce7100cdb4c6$var$EventEmitter.EventEmitter = $c545ce7100cdb4c6$var$EventEmitter;
$c545ce7100cdb4c6$var$EventEmitter.prototype._events = undefined;
$c545ce7100cdb4c6$var$EventEmitter.prototype._eventsCount = 0;
$c545ce7100cdb4c6$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $c545ce7100cdb4c6$var$defaultMaxListeners = 10;
function $c545ce7100cdb4c6$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($c545ce7100cdb4c6$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $c545ce7100cdb4c6$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $c545ce7100cdb4c6$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $c545ce7100cdb4c6$var$defaultMaxListeners = arg;
    }
});
$c545ce7100cdb4c6$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$c545ce7100cdb4c6$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $c545ce7100cdb4c6$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $c545ce7100cdb4c6$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $c545ce7100cdb4c6$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$c545ce7100cdb4c6$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $c545ce7100cdb4c6$var$_getMaxListeners(this);
};
$c545ce7100cdb4c6$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $c545ce7100cdb4c6$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $c545ce7100cdb4c6$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$c545ce7100cdb4c6$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $c545ce7100cdb4c6$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $c545ce7100cdb4c6$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $c545ce7100cdb4c6$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $c545ce7100cdb4c6$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$c545ce7100cdb4c6$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $c545ce7100cdb4c6$var$_addListener(this, type, listener, false);
};
$c545ce7100cdb4c6$var$EventEmitter.prototype.on = $c545ce7100cdb4c6$var$EventEmitter.prototype.addListener;
$c545ce7100cdb4c6$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $c545ce7100cdb4c6$var$_addListener(this, type, listener, true);
};
function $c545ce7100cdb4c6$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $c545ce7100cdb4c6$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $c545ce7100cdb4c6$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$c545ce7100cdb4c6$var$EventEmitter.prototype.once = function once(type, listener) {
    $c545ce7100cdb4c6$var$checkListener(listener);
    this.on(type, $c545ce7100cdb4c6$var$_onceWrap(this, type, listener));
    return this;
};
$c545ce7100cdb4c6$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $c545ce7100cdb4c6$var$checkListener(listener);
    this.prependListener(type, $c545ce7100cdb4c6$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$c545ce7100cdb4c6$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $c545ce7100cdb4c6$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $c545ce7100cdb4c6$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$c545ce7100cdb4c6$var$EventEmitter.prototype.off = $c545ce7100cdb4c6$var$EventEmitter.prototype.removeListener;
$c545ce7100cdb4c6$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $c545ce7100cdb4c6$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $c545ce7100cdb4c6$var$unwrapListeners(evlistener) : $c545ce7100cdb4c6$var$arrayClone(evlistener, evlistener.length);
}
$c545ce7100cdb4c6$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $c545ce7100cdb4c6$var$_listeners(this, type, true);
};
$c545ce7100cdb4c6$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $c545ce7100cdb4c6$var$_listeners(this, type, false);
};
$c545ce7100cdb4c6$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $c545ce7100cdb4c6$var$listenerCount.call(emitter, type);
};
$c545ce7100cdb4c6$var$EventEmitter.prototype.listenerCount = $c545ce7100cdb4c6$var$listenerCount;
function $c545ce7100cdb4c6$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$c545ce7100cdb4c6$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $c545ce7100cdb4c6$var$ReflectOwnKeys(this._events) : [];
};
function $c545ce7100cdb4c6$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $c545ce7100cdb4c6$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $c545ce7100cdb4c6$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $c545ce7100cdb4c6$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $c545ce7100cdb4c6$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $c545ce7100cdb4c6$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $c545ce7100cdb4c6$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $c545ce7100cdb4c6$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $c545ce7100cdb4c6$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("bHNWA", function(module, exports) {

module.exports = (parcelRequire("gW4Pg")).EventEmitter;

});

parcelRegister("hF7qG", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $b0qLu = parcelRequire("b0qLu");
var $cdbc0752c5deb14b$var$Buffer = $b0qLu.Buffer;
// alternative to using Object.keys for old browsers
function $cdbc0752c5deb14b$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($cdbc0752c5deb14b$var$Buffer.from && $cdbc0752c5deb14b$var$Buffer.alloc && $cdbc0752c5deb14b$var$Buffer.allocUnsafe && $cdbc0752c5deb14b$var$Buffer.allocUnsafeSlow) module.exports = $b0qLu;
else {
    // Copy properties from require('buffer')
    $cdbc0752c5deb14b$var$copyProps($b0qLu, module.exports);
    module.exports.Buffer = $cdbc0752c5deb14b$var$SafeBuffer;
}
function $cdbc0752c5deb14b$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $cdbc0752c5deb14b$var$Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
$cdbc0752c5deb14b$var$copyProps($cdbc0752c5deb14b$var$Buffer, $cdbc0752c5deb14b$var$SafeBuffer);
$cdbc0752c5deb14b$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $cdbc0752c5deb14b$var$Buffer(arg, encodingOrOffset, length);
};
$cdbc0752c5deb14b$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $cdbc0752c5deb14b$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$cdbc0752c5deb14b$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $cdbc0752c5deb14b$var$Buffer(size);
};
$cdbc0752c5deb14b$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $b0qLu.SlowBuffer(size);
};

});

parcelRegister("5mxBc", function(module, exports) {
$parcel$export(module.exports, "isArray", () => $3e7911e142b44df4$export$43bee75e5e14138e, (v) => $3e7911e142b44df4$export$43bee75e5e14138e = v);
$parcel$export(module.exports, "isBoolean", () => $3e7911e142b44df4$export$f9ce7b637dfbe238, (v) => $3e7911e142b44df4$export$f9ce7b637dfbe238 = v);
$parcel$export(module.exports, "isNull", () => $3e7911e142b44df4$export$630801d484da15df, (v) => $3e7911e142b44df4$export$630801d484da15df = v);
$parcel$export(module.exports, "isNullOrUndefined", () => $3e7911e142b44df4$export$bedb7023a7733221, (v) => $3e7911e142b44df4$export$bedb7023a7733221 = v);
$parcel$export(module.exports, "isNumber", () => $3e7911e142b44df4$export$7e4aa119212bc614, (v) => $3e7911e142b44df4$export$7e4aa119212bc614 = v);
$parcel$export(module.exports, "isString", () => $3e7911e142b44df4$export$844ec244b1367d54, (v) => $3e7911e142b44df4$export$844ec244b1367d54 = v);
$parcel$export(module.exports, "isSymbol", () => $3e7911e142b44df4$export$a244864fd9645c7f, (v) => $3e7911e142b44df4$export$a244864fd9645c7f = v);
$parcel$export(module.exports, "isUndefined", () => $3e7911e142b44df4$export$fce6876652108ab, (v) => $3e7911e142b44df4$export$fce6876652108ab = v);
$parcel$export(module.exports, "isRegExp", () => $3e7911e142b44df4$export$49841c62b9eff15, (v) => $3e7911e142b44df4$export$49841c62b9eff15 = v);
$parcel$export(module.exports, "isObject", () => $3e7911e142b44df4$export$a6cdc56e425d0d0a, (v) => $3e7911e142b44df4$export$a6cdc56e425d0d0a = v);
$parcel$export(module.exports, "isDate", () => $3e7911e142b44df4$export$871608497c498473, (v) => $3e7911e142b44df4$export$871608497c498473 = v);
$parcel$export(module.exports, "isError", () => $3e7911e142b44df4$export$e6127cc7fe7395c3, (v) => $3e7911e142b44df4$export$e6127cc7fe7395c3 = v);
$parcel$export(module.exports, "isFunction", () => $3e7911e142b44df4$export$f6e2535fb5126e54, (v) => $3e7911e142b44df4$export$f6e2535fb5126e54 = v);
$parcel$export(module.exports, "isPrimitive", () => $3e7911e142b44df4$export$c3825b437cbdea5c, (v) => $3e7911e142b44df4$export$c3825b437cbdea5c = v);
$parcel$export(module.exports, "isBuffer", () => $3e7911e142b44df4$export$a7884ebc965f8f54, (v) => $3e7911e142b44df4$export$a7884ebc965f8f54 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
var $3e7911e142b44df4$export$43bee75e5e14138e;
var $3e7911e142b44df4$export$f9ce7b637dfbe238;
var $3e7911e142b44df4$export$630801d484da15df;
var $3e7911e142b44df4$export$bedb7023a7733221;
var $3e7911e142b44df4$export$7e4aa119212bc614;
var $3e7911e142b44df4$export$844ec244b1367d54;
var $3e7911e142b44df4$export$a244864fd9645c7f;
var $3e7911e142b44df4$export$fce6876652108ab;
var $3e7911e142b44df4$export$49841c62b9eff15;
var $3e7911e142b44df4$export$a6cdc56e425d0d0a;
var $3e7911e142b44df4$export$871608497c498473;
var $3e7911e142b44df4$export$e6127cc7fe7395c3;
var $3e7911e142b44df4$export$f6e2535fb5126e54;
var $3e7911e142b44df4$export$c3825b437cbdea5c;
var $3e7911e142b44df4$export$a7884ebc965f8f54;
function $3e7911e142b44df4$var$isArray(arg) {
    if (Array.isArray) return Array.isArray(arg);
    return $3e7911e142b44df4$var$objectToString(arg) === '[object Array]';
}
$3e7911e142b44df4$export$43bee75e5e14138e = $3e7911e142b44df4$var$isArray;
function $3e7911e142b44df4$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
$3e7911e142b44df4$export$f9ce7b637dfbe238 = $3e7911e142b44df4$var$isBoolean;
function $3e7911e142b44df4$var$isNull(arg) {
    return arg === null;
}
$3e7911e142b44df4$export$630801d484da15df = $3e7911e142b44df4$var$isNull;
function $3e7911e142b44df4$var$isNullOrUndefined(arg) {
    return arg == null;
}
$3e7911e142b44df4$export$bedb7023a7733221 = $3e7911e142b44df4$var$isNullOrUndefined;
function $3e7911e142b44df4$var$isNumber(arg) {
    return typeof arg === 'number';
}
$3e7911e142b44df4$export$7e4aa119212bc614 = $3e7911e142b44df4$var$isNumber;
function $3e7911e142b44df4$var$isString(arg) {
    return typeof arg === 'string';
}
$3e7911e142b44df4$export$844ec244b1367d54 = $3e7911e142b44df4$var$isString;
function $3e7911e142b44df4$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
$3e7911e142b44df4$export$a244864fd9645c7f = $3e7911e142b44df4$var$isSymbol;
function $3e7911e142b44df4$var$isUndefined(arg) {
    return arg === void 0;
}
$3e7911e142b44df4$export$fce6876652108ab = $3e7911e142b44df4$var$isUndefined;
function $3e7911e142b44df4$var$isRegExp(re) {
    return $3e7911e142b44df4$var$objectToString(re) === '[object RegExp]';
}
$3e7911e142b44df4$export$49841c62b9eff15 = $3e7911e142b44df4$var$isRegExp;
function $3e7911e142b44df4$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
$3e7911e142b44df4$export$a6cdc56e425d0d0a = $3e7911e142b44df4$var$isObject;
function $3e7911e142b44df4$var$isDate(d) {
    return $3e7911e142b44df4$var$objectToString(d) === '[object Date]';
}
$3e7911e142b44df4$export$871608497c498473 = $3e7911e142b44df4$var$isDate;
function $3e7911e142b44df4$var$isError(e) {
    return $3e7911e142b44df4$var$objectToString(e) === '[object Error]' || e instanceof Error;
}
$3e7911e142b44df4$export$e6127cc7fe7395c3 = $3e7911e142b44df4$var$isError;
function $3e7911e142b44df4$var$isFunction(arg) {
    return typeof arg === 'function';
}
$3e7911e142b44df4$export$f6e2535fb5126e54 = $3e7911e142b44df4$var$isFunction;
function $3e7911e142b44df4$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
$3e7911e142b44df4$export$c3825b437cbdea5c = $3e7911e142b44df4$var$isPrimitive;

$3e7911e142b44df4$export$a7884ebc965f8f54 = (parcelRequire("b0qLu")).Buffer.isBuffer;
function $3e7911e142b44df4$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}

});

parcelRegister("bk927", function(module, exports) {
'use strict';
function $83e891be5b05d540$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $hF7qG = parcelRequire("hF7qG");
var $83e891be5b05d540$require$Buffer = $hF7qG.Buffer;

var $luYXS = parcelRequire("luYXS");
function $83e891be5b05d540$var$copyBuffer(src, target, offset) {
    src.copy(target, offset);
}
module.exports = function() {
    function BufferList() {
        $83e891be5b05d540$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    BufferList.prototype.push = function push(v) {
        var entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    };
    BufferList.prototype.unshift = function unshift(v) {
        var entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    };
    BufferList.prototype.shift = function shift() {
        if (this.length === 0) return;
        var ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    };
    BufferList.prototype.clear = function clear() {
        this.head = this.tail = null;
        this.length = 0;
    };
    BufferList.prototype.join = function join(s) {
        if (this.length === 0) return '';
        var p = this.head;
        var ret = '' + p.data;
        while(p = p.next)ret += s + p.data;
        return ret;
    };
    BufferList.prototype.concat = function concat(n) {
        if (this.length === 0) return $83e891be5b05d540$require$Buffer.alloc(0);
        var ret = $83e891be5b05d540$require$Buffer.allocUnsafe(n >>> 0);
        var p = this.head;
        var i = 0;
        while(p){
            $83e891be5b05d540$var$copyBuffer(p.data, ret, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    };
    return BufferList;
}();
if ($luYXS && $luYXS.inspect && $luYXS.inspect.custom) module.exports.prototype[$luYXS.inspect.custom] = function() {
    var obj = $luYXS.inspect({
        length: this.length
    });
    return this.constructor.name + ' ' + obj;
};

});

parcelRegister("fuIBY", function(module, exports) {
'use strict';

var $xBkZP = parcelRequire("xBkZP");
/*</replacement>*/ // undocumented cb() API, needed for core, not for public API
function $b47c434a0e9fb4f8$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $xBkZP.nextTick($b47c434a0e9fb4f8$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $xBkZP.nextTick($b47c434a0e9fb4f8$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $xBkZP.nextTick($b47c434a0e9fb4f8$var$emitErrorNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $xBkZP.nextTick($b47c434a0e9fb4f8$var$emitErrorNT, _this, err);
            }
        } else if (cb) cb(err);
    });
    return this;
}
function $b47c434a0e9fb4f8$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $b47c434a0e9fb4f8$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
module.exports = {
    destroy: $b47c434a0e9fb4f8$var$destroy,
    undestroy: $b47c434a0e9fb4f8$var$undestroy
};

});

parcelRegister("cacUu", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.
'use strict';

var $xBkZP = parcelRequire("xBkZP");
/*</replacement>*/ /*<replacement>*/ var $8db06ee8e22a7e8c$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $8db06ee8e22a7e8c$var$Duplex;

/*<replacement>*/ var $8db06ee8e22a7e8c$var$util = Object.create((parcelRequire("5mxBc")));

$8db06ee8e22a7e8c$var$util.inherits = (parcelRequire("jcXeW"));

var $9ndRN = parcelRequire("9ndRN");

var $f8joC = parcelRequire("f8joC");
$8db06ee8e22a7e8c$var$util.inherits($8db06ee8e22a7e8c$var$Duplex, $9ndRN);
// avoid scope creep, the keys array can then be collected
var $8db06ee8e22a7e8c$var$keys = $8db06ee8e22a7e8c$var$objectKeys($f8joC.prototype);
for(var $8db06ee8e22a7e8c$var$v = 0; $8db06ee8e22a7e8c$var$v < $8db06ee8e22a7e8c$var$keys.length; $8db06ee8e22a7e8c$var$v++){
    var $8db06ee8e22a7e8c$var$method = $8db06ee8e22a7e8c$var$keys[$8db06ee8e22a7e8c$var$v];
    if (!$8db06ee8e22a7e8c$var$Duplex.prototype[$8db06ee8e22a7e8c$var$method]) $8db06ee8e22a7e8c$var$Duplex.prototype[$8db06ee8e22a7e8c$var$method] = $f8joC.prototype[$8db06ee8e22a7e8c$var$method];
}
function $8db06ee8e22a7e8c$var$Duplex(options) {
    if (!(this instanceof $8db06ee8e22a7e8c$var$Duplex)) return new $8db06ee8e22a7e8c$var$Duplex(options);
    $9ndRN.call(this, options);
    $f8joC.call(this, options);
    if (options && options.readable === false) this.readable = false;
    if (options && options.writable === false) this.writable = false;
    this.allowHalfOpen = true;
    if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
    this.once('end', $8db06ee8e22a7e8c$var$onend);
}
Object.defineProperty($8db06ee8e22a7e8c$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// the no-half-open enforcer
function $8db06ee8e22a7e8c$var$onend() {
    // if we allow half-open state, or if the writable side ended,
    // then we're ok.
    if (this.allowHalfOpen || this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $xBkZP.nextTick($8db06ee8e22a7e8c$var$onEndNT, this);
}
function $8db06ee8e22a7e8c$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($8db06ee8e22a7e8c$var$Duplex.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});
$8db06ee8e22a7e8c$var$Duplex.prototype._destroy = function(err, cb) {
    this.push(null);
    this.end();
    $xBkZP.nextTick(cb, err);
};

});
parcelRegister("f8joC", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $xBkZP = parcelRequire("xBkZP");
/*</replacement>*/ module.exports = $b046a60543efd18c$var$Writable;
/* <replacement> */ function $b046a60543efd18c$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $b046a60543efd18c$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $b046a60543efd18c$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $b046a60543efd18c$var$asyncWrite = (0, $xBkZP.nextTick);
/*</replacement>*/ /*<replacement>*/ var $b046a60543efd18c$var$Duplex;
/*</replacement>*/ $b046a60543efd18c$var$Writable.WritableState = $b046a60543efd18c$var$WritableState;

/*<replacement>*/ var $b046a60543efd18c$var$util = Object.create((parcelRequire("5mxBc")));

$b046a60543efd18c$var$util.inherits = (parcelRequire("jcXeW"));

/*</replacement>*/ /*<replacement>*/ var $b046a60543efd18c$var$internalUtil = {
    deprecate: (parcelRequire("kI89L"))
};

var $bHNWA = parcelRequire("bHNWA");

var $hF7qG = parcelRequire("hF7qG");
var $b046a60543efd18c$require$Buffer = $hF7qG.Buffer;
var $b046a60543efd18c$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $b046a60543efd18c$var$_uint8ArrayToBuffer(chunk) {
    return $b046a60543efd18c$require$Buffer.from(chunk);
}
function $b046a60543efd18c$var$_isUint8Array(obj) {
    return $b046a60543efd18c$require$Buffer.isBuffer(obj) || obj instanceof $b046a60543efd18c$var$OurUint8Array;
}

var $fuIBY = parcelRequire("fuIBY");
$b046a60543efd18c$var$util.inherits($b046a60543efd18c$var$Writable, $bHNWA);
function $b046a60543efd18c$var$nop() {}

function $b046a60543efd18c$var$WritableState(options, stream) {
    $b046a60543efd18c$var$Duplex = $b046a60543efd18c$var$Duplex || (parcelRequire("cacUu"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $b046a60543efd18c$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    var hwm = options.highWaterMark;
    var writableHwm = options.writableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $b046a60543efd18c$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $b046a60543efd18c$var$CorkedRequest(this);
}
$b046a60543efd18c$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($b046a60543efd18c$var$WritableState.prototype, 'buffer', {
            get: $b046a60543efd18c$var$internalUtil.deprecate(function() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $b046a60543efd18c$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $b046a60543efd18c$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($b046a60543efd18c$var$Writable, Symbol.hasInstance, {
        value: function(object) {
            if ($b046a60543efd18c$var$realHasInstance.call(this, object)) return true;
            if (this !== $b046a60543efd18c$var$Writable) return false;
            return object && object._writableState instanceof $b046a60543efd18c$var$WritableState;
        }
    });
} else $b046a60543efd18c$var$realHasInstance = function(object) {
    return object instanceof this;
};

function $b046a60543efd18c$var$Writable(options) {
    $b046a60543efd18c$var$Duplex = $b046a60543efd18c$var$Duplex || (parcelRequire("cacUu"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    if (!$b046a60543efd18c$var$realHasInstance.call($b046a60543efd18c$var$Writable, this) && !(this instanceof $b046a60543efd18c$var$Duplex)) return new $b046a60543efd18c$var$Writable(options);
    this._writableState = new $b046a60543efd18c$var$WritableState(options, this);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $bHNWA.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$b046a60543efd18c$var$Writable.prototype.pipe = function() {
    this.emit('error', new Error('Cannot pipe, not readable'));
};
function $b046a60543efd18c$var$writeAfterEnd(stream, cb) {
    var er = new Error('write after end');
    // TODO: defer error events consistently everywhere, not just the cb
    stream.emit('error', er);
    $xBkZP.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $b046a60543efd18c$var$validChunk(stream, state, chunk, cb) {
    var valid = true;
    var er = false;
    if (chunk === null) er = new TypeError('May not write null values to stream');
    else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    if (er) {
        stream.emit('error', er);
        $xBkZP.nextTick(cb, er);
        valid = false;
    }
    return valid;
}
$b046a60543efd18c$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $b046a60543efd18c$var$_isUint8Array(chunk);
    if (isBuf && !$b046a60543efd18c$require$Buffer.isBuffer(chunk)) chunk = $b046a60543efd18c$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $b046a60543efd18c$var$nop;
    if (state.ended) $b046a60543efd18c$var$writeAfterEnd(this, cb);
    else if (isBuf || $b046a60543efd18c$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $b046a60543efd18c$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$b046a60543efd18c$var$Writable.prototype.cork = function() {
    var state = this._writableState;
    state.corked++;
};
$b046a60543efd18c$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $b046a60543efd18c$var$clearBuffer(this, state);
    }
};
$b046a60543efd18c$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
function $b046a60543efd18c$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $b046a60543efd18c$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($b046a60543efd18c$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $b046a60543efd18c$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $b046a60543efd18c$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $b046a60543efd18c$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $b046a60543efd18c$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $b046a60543efd18c$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $xBkZP.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $xBkZP.nextTick($b046a60543efd18c$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
        // this can emit finish, but finish must
        // always follow error
        $b046a60543efd18c$var$finishMaybe(stream, state);
    }
}
function $b046a60543efd18c$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $b046a60543efd18c$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    $b046a60543efd18c$var$onwriteStateUpdate(state);
    if (er) $b046a60543efd18c$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $b046a60543efd18c$var$needFinish(state);
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $b046a60543efd18c$var$clearBuffer(stream, state);
        if (sync) /*<replacement>*/ $b046a60543efd18c$var$asyncWrite($b046a60543efd18c$var$afterWrite, stream, state, finished, cb);
        else $b046a60543efd18c$var$afterWrite(stream, state, finished, cb);
    }
}
function $b046a60543efd18c$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $b046a60543efd18c$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $b046a60543efd18c$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $b046a60543efd18c$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $b046a60543efd18c$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $b046a60543efd18c$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $b046a60543efd18c$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $b046a60543efd18c$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$b046a60543efd18c$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new Error('_write() is not implemented'));
};
$b046a60543efd18c$var$Writable.prototype._writev = null;
$b046a60543efd18c$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $b046a60543efd18c$var$endWritable(this, state, cb);
};
function $b046a60543efd18c$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $b046a60543efd18c$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) stream.emit('error', err);
        state.prefinished = true;
        stream.emit('prefinish');
        $b046a60543efd18c$var$finishMaybe(stream, state);
    });
}
function $b046a60543efd18c$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function') {
            state.pendingcb++;
            state.finalCalled = true;
            $xBkZP.nextTick($b046a60543efd18c$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $b046a60543efd18c$var$finishMaybe(stream, state) {
    var need = $b046a60543efd18c$var$needFinish(state);
    if (need) {
        $b046a60543efd18c$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
        }
    }
    return need;
}
function $b046a60543efd18c$var$endWritable(stream, state, cb) {
    state.ending = true;
    $b046a60543efd18c$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $xBkZP.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $b046a60543efd18c$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($b046a60543efd18c$var$Writable.prototype, 'destroyed', {
    get: function() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$b046a60543efd18c$var$Writable.prototype.destroy = $fuIBY.destroy;
$b046a60543efd18c$var$Writable.prototype._undestroy = $fuIBY.undestroy;
$b046a60543efd18c$var$Writable.prototype._destroy = function(err, cb) {
    this.end();
    cb(err);
};

});
parcelRegister("kI89L", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $f13e3e690ad72555$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $f13e3e690ad72555$var$deprecate(fn, msg) {
    if ($f13e3e690ad72555$var$config('noDeprecation')) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($f13e3e690ad72555$var$config('throwDeprecation')) throw new Error(msg);
            else if ($f13e3e690ad72555$var$config('traceDeprecation')) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $f13e3e690ad72555$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === 'true';
}

});



parcelRegister("3vPJ0", function(module, exports) {
$parcel$export(module.exports, "StringDecoder", () => $28ec63db013687e2$export$63a7aa211a91ed69, (v) => $28ec63db013687e2$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $28ec63db013687e2$export$63a7aa211a91ed69;
'use strict';

var $jjnCw = parcelRequire("jjnCw");
var $28ec63db013687e2$require$Buffer = $jjnCw.Buffer;
/*</replacement>*/ var $28ec63db013687e2$var$isEncoding = $28ec63db013687e2$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $28ec63db013687e2$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $28ec63db013687e2$var$normalizeEncoding(enc) {
    var nenc = $28ec63db013687e2$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($28ec63db013687e2$require$Buffer.isEncoding === $28ec63db013687e2$var$isEncoding || !$28ec63db013687e2$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$28ec63db013687e2$export$63a7aa211a91ed69 = $28ec63db013687e2$var$StringDecoder;
function $28ec63db013687e2$var$StringDecoder(encoding) {
    this.encoding = $28ec63db013687e2$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $28ec63db013687e2$var$utf16Text;
            this.end = $28ec63db013687e2$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $28ec63db013687e2$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $28ec63db013687e2$var$base64Text;
            this.end = $28ec63db013687e2$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $28ec63db013687e2$var$simpleWrite;
            this.end = $28ec63db013687e2$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $28ec63db013687e2$require$Buffer.allocUnsafe(nb);
}
$28ec63db013687e2$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$28ec63db013687e2$var$StringDecoder.prototype.end = $28ec63db013687e2$var$utf8End;
// Returns only complete characters in a Buffer
$28ec63db013687e2$var$StringDecoder.prototype.text = $28ec63db013687e2$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$28ec63db013687e2$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $28ec63db013687e2$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $28ec63db013687e2$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $28ec63db013687e2$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $28ec63db013687e2$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $28ec63db013687e2$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $28ec63db013687e2$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $28ec63db013687e2$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $28ec63db013687e2$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $28ec63db013687e2$var$utf8Text(buf, i) {
    var total = $28ec63db013687e2$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $28ec63db013687e2$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $28ec63db013687e2$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $28ec63db013687e2$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $28ec63db013687e2$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $28ec63db013687e2$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $28ec63db013687e2$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $28ec63db013687e2$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});
parcelRegister("jjnCw", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $b0qLu = parcelRequire("b0qLu");
var $e0f21d32affe20d6$var$Buffer = $b0qLu.Buffer;
// alternative to using Object.keys for old browsers
function $e0f21d32affe20d6$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($e0f21d32affe20d6$var$Buffer.from && $e0f21d32affe20d6$var$Buffer.alloc && $e0f21d32affe20d6$var$Buffer.allocUnsafe && $e0f21d32affe20d6$var$Buffer.allocUnsafeSlow) module.exports = $b0qLu;
else {
    // Copy properties from require('buffer')
    $e0f21d32affe20d6$var$copyProps($b0qLu, module.exports);
    module.exports.Buffer = $e0f21d32affe20d6$var$SafeBuffer;
}
function $e0f21d32affe20d6$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $e0f21d32affe20d6$var$Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
$e0f21d32affe20d6$var$copyProps($e0f21d32affe20d6$var$Buffer, $e0f21d32affe20d6$var$SafeBuffer);
$e0f21d32affe20d6$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $e0f21d32affe20d6$var$Buffer(arg, encodingOrOffset, length);
};
$e0f21d32affe20d6$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $e0f21d32affe20d6$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$e0f21d32affe20d6$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $e0f21d32affe20d6$var$Buffer(size);
};
$e0f21d32affe20d6$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $b0qLu.SlowBuffer(size);
};

});



parcelRegister("OKhOa", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $0988931b65ab8adc$var$Transform;

var $cacUu = parcelRequire("cacUu");

/*<replacement>*/ var $0988931b65ab8adc$var$util = Object.create((parcelRequire("5mxBc")));

$0988931b65ab8adc$var$util.inherits = (parcelRequire("jcXeW"));
/*</replacement>*/ $0988931b65ab8adc$var$util.inherits($0988931b65ab8adc$var$Transform, $cacUu);
function $0988931b65ab8adc$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (!cb) return this.emit('error', new Error('write callback called multiple times'));
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $0988931b65ab8adc$var$Transform(options) {
    if (!(this instanceof $0988931b65ab8adc$var$Transform)) return new $0988931b65ab8adc$var$Transform(options);
    $cacUu.call(this, options);
    this._transformState = {
        afterTransform: $0988931b65ab8adc$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $0988931b65ab8adc$var$prefinish);
}
function $0988931b65ab8adc$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function') this._flush(function(er, data) {
        $0988931b65ab8adc$var$done(_this, er, data);
    });
    else $0988931b65ab8adc$var$done(this, null, null);
}
$0988931b65ab8adc$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $cacUu.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$0988931b65ab8adc$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    throw new Error('_transform() is not implemented');
};
$0988931b65ab8adc$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$0988931b65ab8adc$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$0988931b65ab8adc$var$Transform.prototype._destroy = function(err, cb) {
    var _this2 = this;
    $cacUu.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
        _this2.emit('close');
    });
};
function $0988931b65ab8adc$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) stream.push(data);
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
    if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
    return stream.push(null);
}

});

parcelRegister("bgVxg", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $834dd1b61a6e7bab$var$PassThrough;

var $OKhOa = parcelRequire("OKhOa");

/*<replacement>*/ var $834dd1b61a6e7bab$var$util = Object.create((parcelRequire("5mxBc")));

$834dd1b61a6e7bab$var$util.inherits = (parcelRequire("jcXeW"));
/*</replacement>*/ $834dd1b61a6e7bab$var$util.inherits($834dd1b61a6e7bab$var$PassThrough, $OKhOa);
function $834dd1b61a6e7bab$var$PassThrough(options) {
    if (!(this instanceof $834dd1b61a6e7bab$var$PassThrough)) return new $834dd1b61a6e7bab$var$PassThrough(options);
    $OKhOa.call(this, options);
}
$834dd1b61a6e7bab$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});




parcelRegister("43hsM", function(module, exports) {
'use strict';

var $b0qLu = parcelRequire("b0qLu");
var $2f34fd145e637339$require$Buffer = $b0qLu.Buffer;

var $jcXeW = parcelRequire("jcXeW");

var $gLVBx = parcelRequire("gLVBx");
var $2f34fd145e637339$var$ARRAY16 = new Array(16);
var $2f34fd145e637339$var$zl = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $2f34fd145e637339$var$zr = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $2f34fd145e637339$var$sl = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $2f34fd145e637339$var$sr = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];
var $2f34fd145e637339$var$hl = [
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
];
var $2f34fd145e637339$var$hr = [
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
];
function $2f34fd145e637339$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $2f34fd145e637339$var$fn1(a, b, c, d, e, m, k, s) {
    return $2f34fd145e637339$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function $2f34fd145e637339$var$fn2(a, b, c, d, e, m, k, s) {
    return $2f34fd145e637339$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function $2f34fd145e637339$var$fn3(a, b, c, d, e, m, k, s) {
    return $2f34fd145e637339$var$rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function $2f34fd145e637339$var$fn4(a, b, c, d, e, m, k, s) {
    return $2f34fd145e637339$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function $2f34fd145e637339$var$fn5(a, b, c, d, e, m, k, s) {
    return $2f34fd145e637339$var$rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
function $2f34fd145e637339$var$RIPEMD160() {
    $gLVBx.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
$jcXeW($2f34fd145e637339$var$RIPEMD160, $gLVBx);
$2f34fd145e637339$var$RIPEMD160.prototype._update = function() {
    var words = $2f34fd145e637339$var$ARRAY16;
    for(var j = 0; j < 16; ++j)words[j] = this._block.readInt32LE(j * 4);
    var al = this._a | 0;
    var bl = this._b | 0;
    var cl = this._c | 0;
    var dl = this._d | 0;
    var el = this._e | 0;
    var ar = this._a | 0;
    var br = this._b | 0;
    var cr = this._c | 0;
    var dr = this._d | 0;
    var er = this._e | 0;
    // computation
    for(var i = 0; i < 80; i += 1){
        var tl;
        var tr;
        if (i < 16) {
            tl = $2f34fd145e637339$var$fn1(al, bl, cl, dl, el, words[$2f34fd145e637339$var$zl[i]], $2f34fd145e637339$var$hl[0], $2f34fd145e637339$var$sl[i]);
            tr = $2f34fd145e637339$var$fn5(ar, br, cr, dr, er, words[$2f34fd145e637339$var$zr[i]], $2f34fd145e637339$var$hr[0], $2f34fd145e637339$var$sr[i]);
        } else if (i < 32) {
            tl = $2f34fd145e637339$var$fn2(al, bl, cl, dl, el, words[$2f34fd145e637339$var$zl[i]], $2f34fd145e637339$var$hl[1], $2f34fd145e637339$var$sl[i]);
            tr = $2f34fd145e637339$var$fn4(ar, br, cr, dr, er, words[$2f34fd145e637339$var$zr[i]], $2f34fd145e637339$var$hr[1], $2f34fd145e637339$var$sr[i]);
        } else if (i < 48) {
            tl = $2f34fd145e637339$var$fn3(al, bl, cl, dl, el, words[$2f34fd145e637339$var$zl[i]], $2f34fd145e637339$var$hl[2], $2f34fd145e637339$var$sl[i]);
            tr = $2f34fd145e637339$var$fn3(ar, br, cr, dr, er, words[$2f34fd145e637339$var$zr[i]], $2f34fd145e637339$var$hr[2], $2f34fd145e637339$var$sr[i]);
        } else if (i < 64) {
            tl = $2f34fd145e637339$var$fn4(al, bl, cl, dl, el, words[$2f34fd145e637339$var$zl[i]], $2f34fd145e637339$var$hl[3], $2f34fd145e637339$var$sl[i]);
            tr = $2f34fd145e637339$var$fn2(ar, br, cr, dr, er, words[$2f34fd145e637339$var$zr[i]], $2f34fd145e637339$var$hr[3], $2f34fd145e637339$var$sr[i]);
        } else {
            tl = $2f34fd145e637339$var$fn5(al, bl, cl, dl, el, words[$2f34fd145e637339$var$zl[i]], $2f34fd145e637339$var$hl[4], $2f34fd145e637339$var$sl[i]);
            tr = $2f34fd145e637339$var$fn1(ar, br, cr, dr, er, words[$2f34fd145e637339$var$zr[i]], $2f34fd145e637339$var$hr[4], $2f34fd145e637339$var$sr[i]);
        }
        al = el;
        el = dl;
        dl = $2f34fd145e637339$var$rotl(cl, 10);
        cl = bl;
        bl = tl;
        ar = er;
        er = dr;
        dr = $2f34fd145e637339$var$rotl(cr, 10);
        cr = br;
        br = tr;
    }
    // update state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
$2f34fd145e637339$var$RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset] = 0x80;
    this._blockOffset += 1;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $2f34fd145e637339$require$Buffer.alloc ? $2f34fd145e637339$require$Buffer.alloc(20) : new $2f34fd145e637339$require$Buffer(20); // eslint-disable-line no-buffer-constructor
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
module.exports = $2f34fd145e637339$var$RIPEMD160;

});
parcelRegister("gLVBx", function(module, exports) {
'use strict';

var $dmAgJ = parcelRequire("dmAgJ");
var $c35db827165b8bc2$require$Buffer = $dmAgJ.Buffer;

var $gxhgM = parcelRequire("gxhgM");

var $9062m = parcelRequire("9062m");
var $c35db827165b8bc2$require$Transform = $9062m.Transform;

var $jcXeW = parcelRequire("jcXeW");
function $c35db827165b8bc2$var$HashBase(blockSize) {
    $c35db827165b8bc2$require$Transform.call(this);
    this._block = $c35db827165b8bc2$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$jcXeW($c35db827165b8bc2$var$HashBase, $c35db827165b8bc2$require$Transform);
$c35db827165b8bc2$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$c35db827165b8bc2$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
$c35db827165b8bc2$var$HashBase.prototype.update = function(data, encoding) {
    if (this._finalized) throw new Error('Digest already called');
    var dataBuffer = $gxhgM(data, encoding); // asserts correct input type
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + dataBuffer.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;){
            block[i] = dataBuffer[offset];
            i += 1;
            offset += 1;
        }
        this._update();
        this._blockOffset = 0;
    }
    while(offset < dataBuffer.length){
        block[this._blockOffset] = dataBuffer[offset];
        this._blockOffset += 1;
        offset += 1;
    }
    // update length
    for(var j = 0, carry = dataBuffer.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$c35db827165b8bc2$var$HashBase.prototype._update = function() {
    throw new Error('_update is not implemented');
};
$c35db827165b8bc2$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error('Digest already called');
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$c35db827165b8bc2$var$HashBase.prototype._digest = function() {
    throw new Error('_digest is not implemented');
};
module.exports = $c35db827165b8bc2$var$HashBase;

});
parcelRegister("gxhgM", function(module, exports) {
'use strict';

var $dmAgJ = parcelRequire("dmAgJ");
var $c09d1fd236a78392$require$Buffer = $dmAgJ.Buffer;

var $dXhxR = parcelRequire("dXhxR");
var $c09d1fd236a78392$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $c09d1fd236a78392$var$useArrayBuffer = $c09d1fd236a78392$var$useUint8Array && typeof ArrayBuffer !== 'undefined';
var $c09d1fd236a78392$var$isView = $c09d1fd236a78392$var$useArrayBuffer && ArrayBuffer.isView;
module.exports = function(thing, encoding) {
    if (typeof thing === 'string' || $c09d1fd236a78392$require$Buffer.isBuffer(thing) || $c09d1fd236a78392$var$useUint8Array && thing instanceof Uint8Array || $c09d1fd236a78392$var$isView && $c09d1fd236a78392$var$isView(thing)) return $dXhxR(thing, encoding);
    throw new TypeError('The "data" argument must be a string, a Buffer, a Uint8Array, or a DataView');
};

});

parcelRegister("9062m", function(module, exports) {

exports = module.exports = (parcelRequire("1iqV7"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("eKawg"));

exports.Duplex = (parcelRequire("32Ia4"));

exports.Transform = (parcelRequire("hsHHX"));

exports.PassThrough = (parcelRequire("54FPD"));

});
parcelRegister("1iqV7", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $aVaWD = parcelRequire("aVaWD");
'use strict';

var $xBkZP = parcelRequire("xBkZP");
/*</replacement>*/ module.exports = $0f1c5ab266178d9d$var$Readable;

var $a1YLc = parcelRequire("a1YLc");
/*</replacement>*/ /*<replacement>*/ var $0f1c5ab266178d9d$var$Duplex;
/*</replacement>*/ $0f1c5ab266178d9d$var$Readable.ReadableState = $0f1c5ab266178d9d$var$ReadableState;

var $gW4Pg = parcelRequire("gW4Pg");
var $0f1c5ab266178d9d$require$EE = $gW4Pg.EventEmitter;
var $0f1c5ab266178d9d$var$EElistenerCount = function(emitter, type) {
    return emitter.listeners(type).length;
};

var $paZpb = parcelRequire("paZpb");

var $l4Juy = parcelRequire("l4Juy");
var $0f1c5ab266178d9d$require$Buffer = $l4Juy.Buffer;
var $0f1c5ab266178d9d$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $0f1c5ab266178d9d$var$_uint8ArrayToBuffer(chunk) {
    return $0f1c5ab266178d9d$require$Buffer.from(chunk);
}
function $0f1c5ab266178d9d$var$_isUint8Array(obj) {
    return $0f1c5ab266178d9d$require$Buffer.isBuffer(obj) || obj instanceof $0f1c5ab266178d9d$var$OurUint8Array;
}

/*</replacement>*/ /*<replacement>*/ var $0f1c5ab266178d9d$var$util = Object.create((parcelRequire("5mxBc")));

$0f1c5ab266178d9d$var$util.inherits = (parcelRequire("jcXeW"));

var $luYXS = parcelRequire("luYXS");
var $0f1c5ab266178d9d$var$debug = void 0;
if ($luYXS && $luYXS.debuglog) $0f1c5ab266178d9d$var$debug = $luYXS.debuglog('stream');
else $0f1c5ab266178d9d$var$debug = function() {};

var $9iQgw = parcelRequire("9iQgw");

var $gISOz = parcelRequire("gISOz");
var $0f1c5ab266178d9d$var$StringDecoder;
$0f1c5ab266178d9d$var$util.inherits($0f1c5ab266178d9d$var$Readable, $paZpb);
var $0f1c5ab266178d9d$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $0f1c5ab266178d9d$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($a1YLc(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $0f1c5ab266178d9d$var$ReadableState(options, stream) {
    $0f1c5ab266178d9d$var$Duplex = $0f1c5ab266178d9d$var$Duplex || (parcelRequire("32Ia4"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $0f1c5ab266178d9d$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    var hwm = options.highWaterMark;
    var readableHwm = options.readableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $9iQgw();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$0f1c5ab266178d9d$var$StringDecoder) $0f1c5ab266178d9d$var$StringDecoder = (parcelRequire("bnZ2C")).StringDecoder;
        this.decoder = new $0f1c5ab266178d9d$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $0f1c5ab266178d9d$var$Readable(options) {
    $0f1c5ab266178d9d$var$Duplex = $0f1c5ab266178d9d$var$Duplex || (parcelRequire("32Ia4"));
    if (!(this instanceof $0f1c5ab266178d9d$var$Readable)) return new $0f1c5ab266178d9d$var$Readable(options);
    this._readableState = new $0f1c5ab266178d9d$var$ReadableState(options, this);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $paZpb.call(this);
}
Object.defineProperty($0f1c5ab266178d9d$var$Readable.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$0f1c5ab266178d9d$var$Readable.prototype.destroy = $gISOz.destroy;
$0f1c5ab266178d9d$var$Readable.prototype._undestroy = $gISOz.undestroy;
$0f1c5ab266178d9d$var$Readable.prototype._destroy = function(err, cb) {
    this.push(null);
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$0f1c5ab266178d9d$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $0f1c5ab266178d9d$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $0f1c5ab266178d9d$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$0f1c5ab266178d9d$var$Readable.prototype.unshift = function(chunk) {
    return $0f1c5ab266178d9d$var$readableAddChunk(this, chunk, null, true, false);
};
function $0f1c5ab266178d9d$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $0f1c5ab266178d9d$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $0f1c5ab266178d9d$var$chunkInvalid(state, chunk);
        if (er) stream.emit('error', er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $0f1c5ab266178d9d$require$Buffer.prototype) chunk = $0f1c5ab266178d9d$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));
                else $0f1c5ab266178d9d$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) stream.emit('error', new Error('stream.push() after EOF'));
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $0f1c5ab266178d9d$var$addChunk(stream, state, chunk, false);
                    else $0f1c5ab266178d9d$var$maybeReadMore(stream, state);
                } else $0f1c5ab266178d9d$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) state.reading = false;
    }
    return $0f1c5ab266178d9d$var$needMoreData(state);
}
function $0f1c5ab266178d9d$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        stream.emit('data', chunk);
        stream.read(0);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $0f1c5ab266178d9d$var$emitReadable(stream);
    }
    $0f1c5ab266178d9d$var$maybeReadMore(stream, state);
}
function $0f1c5ab266178d9d$var$chunkInvalid(state, chunk) {
    var er;
    if (!$0f1c5ab266178d9d$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    return er;
}
// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function $0f1c5ab266178d9d$var$needMoreData(state) {
    return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}
$0f1c5ab266178d9d$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$0f1c5ab266178d9d$var$Readable.prototype.setEncoding = function(enc) {
    if (!$0f1c5ab266178d9d$var$StringDecoder) $0f1c5ab266178d9d$var$StringDecoder = (parcelRequire("bnZ2C")).StringDecoder;
    this._readableState.decoder = new $0f1c5ab266178d9d$var$StringDecoder(enc);
    this._readableState.encoding = enc;
    return this;
};
// Don't raise the hwm > 8MB
var $0f1c5ab266178d9d$var$MAX_HWM = 0x800000;
function $0f1c5ab266178d9d$var$computeNewHighWaterMark(n) {
    if (n >= $0f1c5ab266178d9d$var$MAX_HWM) n = $0f1c5ab266178d9d$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $0f1c5ab266178d9d$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $0f1c5ab266178d9d$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$0f1c5ab266178d9d$var$Readable.prototype.read = function(n) {
    $0f1c5ab266178d9d$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
        $0f1c5ab266178d9d$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $0f1c5ab266178d9d$var$endReadable(this);
        else $0f1c5ab266178d9d$var$emitReadable(this);
        return null;
    }
    n = $0f1c5ab266178d9d$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $0f1c5ab266178d9d$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $0f1c5ab266178d9d$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $0f1c5ab266178d9d$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $0f1c5ab266178d9d$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $0f1c5ab266178d9d$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $0f1c5ab266178d9d$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $0f1c5ab266178d9d$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = true;
        n = 0;
    } else state.length -= n;
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $0f1c5ab266178d9d$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $0f1c5ab266178d9d$var$onEofChunk(stream, state) {
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    // emit 'readable' now to make sure it gets picked up.
    $0f1c5ab266178d9d$var$emitReadable(stream);
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $0f1c5ab266178d9d$var$emitReadable(stream) {
    var state = stream._readableState;
    state.needReadable = false;
    if (!state.emittedReadable) {
        $0f1c5ab266178d9d$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        if (state.sync) $xBkZP.nextTick($0f1c5ab266178d9d$var$emitReadable_, stream);
        else $0f1c5ab266178d9d$var$emitReadable_(stream);
    }
}
function $0f1c5ab266178d9d$var$emitReadable_(stream) {
    $0f1c5ab266178d9d$var$debug('emit readable');
    stream.emit('readable');
    $0f1c5ab266178d9d$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $0f1c5ab266178d9d$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $xBkZP.nextTick($0f1c5ab266178d9d$var$maybeReadMore_, stream, state);
    }
}
function $0f1c5ab266178d9d$var$maybeReadMore_(stream, state) {
    var len = state.length;
    while(!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark){
        $0f1c5ab266178d9d$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
        else len = state.length;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$0f1c5ab266178d9d$var$Readable.prototype._read = function(n) {
    this.emit('error', new Error('_read() is not implemented'));
};
$0f1c5ab266178d9d$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $0f1c5ab266178d9d$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $aVaWD.stdout && dest !== $aVaWD.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $xBkZP.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $0f1c5ab266178d9d$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $0f1c5ab266178d9d$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $0f1c5ab266178d9d$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $0f1c5ab266178d9d$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    // If the user pushes more data while we're writing to dest then we'll end up
    // in ondata again. However, we only want to increase awaitDrain once because
    // dest will only emit one 'drain' event for the multiple writes.
    // => Introduce a guard on increasing awaitDrain.
    var increasedAwaitDrain = false;
    src.on('data', ondata);
    function ondata(chunk) {
        $0f1c5ab266178d9d$var$debug('ondata');
        increasedAwaitDrain = false;
        var ret = dest.write(chunk);
        if (false === ret && !increasedAwaitDrain) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $0f1c5ab266178d9d$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $0f1c5ab266178d9d$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
                increasedAwaitDrain = true;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $0f1c5ab266178d9d$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($0f1c5ab266178d9d$var$EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
    }
    // Make sure our error handler is attached before userland ones.
    $0f1c5ab266178d9d$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $0f1c5ab266178d9d$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $0f1c5ab266178d9d$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $0f1c5ab266178d9d$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $0f1c5ab266178d9d$var$pipeOnDrain(src) {
    return function() {
        var state = src._readableState;
        $0f1c5ab266178d9d$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $0f1c5ab266178d9d$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $0f1c5ab266178d9d$var$flow(src);
        }
    };
}
$0f1c5ab266178d9d$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $0f1c5ab266178d9d$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$0f1c5ab266178d9d$var$Readable.prototype.on = function(ev, fn) {
    var res = $paZpb.prototype.on.call(this, ev, fn);
    if (ev === 'data') // Start flowing on next tick if stream isn't explicitly paused
    {
        if (this._readableState.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        var state = this._readableState;
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.emittedReadable = false;
            if (!state.reading) $xBkZP.nextTick($0f1c5ab266178d9d$var$nReadingNextTick, this);
            else if (state.length) $0f1c5ab266178d9d$var$emitReadable(this);
        }
    }
    return res;
};
$0f1c5ab266178d9d$var$Readable.prototype.addListener = $0f1c5ab266178d9d$var$Readable.prototype.on;
function $0f1c5ab266178d9d$var$nReadingNextTick(self1) {
    $0f1c5ab266178d9d$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$0f1c5ab266178d9d$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $0f1c5ab266178d9d$var$debug('resume');
        state.flowing = true;
        $0f1c5ab266178d9d$var$resume(this, state);
    }
    return this;
};
function $0f1c5ab266178d9d$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $xBkZP.nextTick($0f1c5ab266178d9d$var$resume_, stream, state);
    }
}
function $0f1c5ab266178d9d$var$resume_(stream, state) {
    if (!state.reading) {
        $0f1c5ab266178d9d$var$debug('resume read 0');
        stream.read(0);
    }
    state.resumeScheduled = false;
    state.awaitDrain = 0;
    stream.emit('resume');
    $0f1c5ab266178d9d$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$0f1c5ab266178d9d$var$Readable.prototype.pause = function() {
    $0f1c5ab266178d9d$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (false !== this._readableState.flowing) {
        $0f1c5ab266178d9d$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    return this;
};
function $0f1c5ab266178d9d$var$flow(stream) {
    var state = stream._readableState;
    $0f1c5ab266178d9d$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$0f1c5ab266178d9d$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $0f1c5ab266178d9d$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $0f1c5ab266178d9d$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function(method) {
        return function() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $0f1c5ab266178d9d$var$kProxyEvents.length; n++)stream.on($0f1c5ab266178d9d$var$kProxyEvents[n], this.emit.bind(this, $0f1c5ab266178d9d$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $0f1c5ab266178d9d$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};
Object.defineProperty($0f1c5ab266178d9d$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._readableState.highWaterMark;
    }
});
// exposed for testing purposes only.
$0f1c5ab266178d9d$var$Readable._fromList = $0f1c5ab266178d9d$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $0f1c5ab266178d9d$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.head.data;
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = $0f1c5ab266178d9d$var$fromListPartial(n, state.buffer, state.decoder);
    return ret;
}
// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $0f1c5ab266178d9d$var$fromListPartial(n, list, hasStrings) {
    var ret;
    if (n < list.head.data.length) {
        // slice is the same for buffers and strings
        ret = list.head.data.slice(0, n);
        list.head.data = list.head.data.slice(n);
    } else if (n === list.head.data.length) // first chunk is a perfect match
    ret = list.shift();
    else // result spans more than one buffer
    ret = hasStrings ? $0f1c5ab266178d9d$var$copyFromBufferString(n, list) : $0f1c5ab266178d9d$var$copyFromBuffer(n, list);
    return ret;
}
// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $0f1c5ab266178d9d$var$copyFromBufferString(n, list) {
    var p = list.head;
    var c = 1;
    var ret = p.data;
    n -= ret.length;
    while(p = p.next){
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;
        else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
            if (nb === str.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = str.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $0f1c5ab266178d9d$var$copyFromBuffer(n, list) {
    var ret = $0f1c5ab266178d9d$require$Buffer.allocUnsafe(n);
    var p = list.head;
    var c = 1;
    p.data.copy(ret);
    n -= p.data.length;
    while(p = p.next){
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
            if (nb === buf.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = buf.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
function $0f1c5ab266178d9d$var$endReadable(stream) {
    var state = stream._readableState;
    // If we get here before consuming all the bytes, then that is a
    // bug in node.  Should never happen.
    if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
    if (!state.endEmitted) {
        state.ended = true;
        $xBkZP.nextTick($0f1c5ab266178d9d$var$endReadableNT, state, stream);
    }
}
function $0f1c5ab266178d9d$var$endReadableNT(state, stream) {
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
    }
}
function $0f1c5ab266178d9d$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("a1YLc", function(module, exports) {
var $74d921190a8db3e8$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $74d921190a8db3e8$var$toString.call(arr) == '[object Array]';
};

});

parcelRegister("paZpb", function(module, exports) {

module.exports = (parcelRequire("gW4Pg")).EventEmitter;

});

parcelRegister("l4Juy", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $b0qLu = parcelRequire("b0qLu");
var $f57d4270014d53f4$var$Buffer = $b0qLu.Buffer;
// alternative to using Object.keys for old browsers
function $f57d4270014d53f4$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($f57d4270014d53f4$var$Buffer.from && $f57d4270014d53f4$var$Buffer.alloc && $f57d4270014d53f4$var$Buffer.allocUnsafe && $f57d4270014d53f4$var$Buffer.allocUnsafeSlow) module.exports = $b0qLu;
else {
    // Copy properties from require('buffer')
    $f57d4270014d53f4$var$copyProps($b0qLu, module.exports);
    module.exports.Buffer = $f57d4270014d53f4$var$SafeBuffer;
}
function $f57d4270014d53f4$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $f57d4270014d53f4$var$Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
$f57d4270014d53f4$var$copyProps($f57d4270014d53f4$var$Buffer, $f57d4270014d53f4$var$SafeBuffer);
$f57d4270014d53f4$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $f57d4270014d53f4$var$Buffer(arg, encodingOrOffset, length);
};
$f57d4270014d53f4$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $f57d4270014d53f4$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$f57d4270014d53f4$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $f57d4270014d53f4$var$Buffer(size);
};
$f57d4270014d53f4$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $b0qLu.SlowBuffer(size);
};

});

parcelRegister("9iQgw", function(module, exports) {
'use strict';
function $6c5e564eeb2bee71$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $l4Juy = parcelRequire("l4Juy");
var $6c5e564eeb2bee71$require$Buffer = $l4Juy.Buffer;

var $luYXS = parcelRequire("luYXS");
function $6c5e564eeb2bee71$var$copyBuffer(src, target, offset) {
    src.copy(target, offset);
}
module.exports = function() {
    function BufferList() {
        $6c5e564eeb2bee71$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    BufferList.prototype.push = function push(v) {
        var entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    };
    BufferList.prototype.unshift = function unshift(v) {
        var entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    };
    BufferList.prototype.shift = function shift() {
        if (this.length === 0) return;
        var ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    };
    BufferList.prototype.clear = function clear() {
        this.head = this.tail = null;
        this.length = 0;
    };
    BufferList.prototype.join = function join(s) {
        if (this.length === 0) return '';
        var p = this.head;
        var ret = '' + p.data;
        while(p = p.next)ret += s + p.data;
        return ret;
    };
    BufferList.prototype.concat = function concat(n) {
        if (this.length === 0) return $6c5e564eeb2bee71$require$Buffer.alloc(0);
        var ret = $6c5e564eeb2bee71$require$Buffer.allocUnsafe(n >>> 0);
        var p = this.head;
        var i = 0;
        while(p){
            $6c5e564eeb2bee71$var$copyBuffer(p.data, ret, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    };
    return BufferList;
}();
if ($luYXS && $luYXS.inspect && $luYXS.inspect.custom) module.exports.prototype[$luYXS.inspect.custom] = function() {
    var obj = $luYXS.inspect({
        length: this.length
    });
    return this.constructor.name + ' ' + obj;
};

});

parcelRegister("gISOz", function(module, exports) {
'use strict';

var $xBkZP = parcelRequire("xBkZP");
/*</replacement>*/ // undocumented cb() API, needed for core, not for public API
function $c2cb4671b774a1f4$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $xBkZP.nextTick($c2cb4671b774a1f4$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $xBkZP.nextTick($c2cb4671b774a1f4$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $xBkZP.nextTick($c2cb4671b774a1f4$var$emitErrorNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $xBkZP.nextTick($c2cb4671b774a1f4$var$emitErrorNT, _this, err);
            }
        } else if (cb) cb(err);
    });
    return this;
}
function $c2cb4671b774a1f4$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $c2cb4671b774a1f4$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
module.exports = {
    destroy: $c2cb4671b774a1f4$var$destroy,
    undestroy: $c2cb4671b774a1f4$var$undestroy
};

});

parcelRegister("32Ia4", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.
'use strict';

var $xBkZP = parcelRequire("xBkZP");
/*</replacement>*/ /*<replacement>*/ var $2373d09105695609$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $2373d09105695609$var$Duplex;

/*<replacement>*/ var $2373d09105695609$var$util = Object.create((parcelRequire("5mxBc")));

$2373d09105695609$var$util.inherits = (parcelRequire("jcXeW"));

var $1iqV7 = parcelRequire("1iqV7");

var $eKawg = parcelRequire("eKawg");
$2373d09105695609$var$util.inherits($2373d09105695609$var$Duplex, $1iqV7);
// avoid scope creep, the keys array can then be collected
var $2373d09105695609$var$keys = $2373d09105695609$var$objectKeys($eKawg.prototype);
for(var $2373d09105695609$var$v = 0; $2373d09105695609$var$v < $2373d09105695609$var$keys.length; $2373d09105695609$var$v++){
    var $2373d09105695609$var$method = $2373d09105695609$var$keys[$2373d09105695609$var$v];
    if (!$2373d09105695609$var$Duplex.prototype[$2373d09105695609$var$method]) $2373d09105695609$var$Duplex.prototype[$2373d09105695609$var$method] = $eKawg.prototype[$2373d09105695609$var$method];
}
function $2373d09105695609$var$Duplex(options) {
    if (!(this instanceof $2373d09105695609$var$Duplex)) return new $2373d09105695609$var$Duplex(options);
    $1iqV7.call(this, options);
    $eKawg.call(this, options);
    if (options && options.readable === false) this.readable = false;
    if (options && options.writable === false) this.writable = false;
    this.allowHalfOpen = true;
    if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
    this.once('end', $2373d09105695609$var$onend);
}
Object.defineProperty($2373d09105695609$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// the no-half-open enforcer
function $2373d09105695609$var$onend() {
    // if we allow half-open state, or if the writable side ended,
    // then we're ok.
    if (this.allowHalfOpen || this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $xBkZP.nextTick($2373d09105695609$var$onEndNT, this);
}
function $2373d09105695609$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($2373d09105695609$var$Duplex.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});
$2373d09105695609$var$Duplex.prototype._destroy = function(err, cb) {
    this.push(null);
    this.end();
    $xBkZP.nextTick(cb, err);
};

});
parcelRegister("eKawg", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $xBkZP = parcelRequire("xBkZP");
/*</replacement>*/ module.exports = $abbd8582f63903c2$var$Writable;
/* <replacement> */ function $abbd8582f63903c2$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $abbd8582f63903c2$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $abbd8582f63903c2$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $abbd8582f63903c2$var$asyncWrite = (0, $xBkZP.nextTick);
/*</replacement>*/ /*<replacement>*/ var $abbd8582f63903c2$var$Duplex;
/*</replacement>*/ $abbd8582f63903c2$var$Writable.WritableState = $abbd8582f63903c2$var$WritableState;

/*<replacement>*/ var $abbd8582f63903c2$var$util = Object.create((parcelRequire("5mxBc")));

$abbd8582f63903c2$var$util.inherits = (parcelRequire("jcXeW"));

/*</replacement>*/ /*<replacement>*/ var $abbd8582f63903c2$var$internalUtil = {
    deprecate: (parcelRequire("kI89L"))
};

var $paZpb = parcelRequire("paZpb");

var $l4Juy = parcelRequire("l4Juy");
var $abbd8582f63903c2$require$Buffer = $l4Juy.Buffer;
var $abbd8582f63903c2$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $abbd8582f63903c2$var$_uint8ArrayToBuffer(chunk) {
    return $abbd8582f63903c2$require$Buffer.from(chunk);
}
function $abbd8582f63903c2$var$_isUint8Array(obj) {
    return $abbd8582f63903c2$require$Buffer.isBuffer(obj) || obj instanceof $abbd8582f63903c2$var$OurUint8Array;
}

var $gISOz = parcelRequire("gISOz");
$abbd8582f63903c2$var$util.inherits($abbd8582f63903c2$var$Writable, $paZpb);
function $abbd8582f63903c2$var$nop() {}

function $abbd8582f63903c2$var$WritableState(options, stream) {
    $abbd8582f63903c2$var$Duplex = $abbd8582f63903c2$var$Duplex || (parcelRequire("32Ia4"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $abbd8582f63903c2$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    var hwm = options.highWaterMark;
    var writableHwm = options.writableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $abbd8582f63903c2$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $abbd8582f63903c2$var$CorkedRequest(this);
}
$abbd8582f63903c2$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($abbd8582f63903c2$var$WritableState.prototype, 'buffer', {
            get: $abbd8582f63903c2$var$internalUtil.deprecate(function() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $abbd8582f63903c2$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $abbd8582f63903c2$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($abbd8582f63903c2$var$Writable, Symbol.hasInstance, {
        value: function(object) {
            if ($abbd8582f63903c2$var$realHasInstance.call(this, object)) return true;
            if (this !== $abbd8582f63903c2$var$Writable) return false;
            return object && object._writableState instanceof $abbd8582f63903c2$var$WritableState;
        }
    });
} else $abbd8582f63903c2$var$realHasInstance = function(object) {
    return object instanceof this;
};

function $abbd8582f63903c2$var$Writable(options) {
    $abbd8582f63903c2$var$Duplex = $abbd8582f63903c2$var$Duplex || (parcelRequire("32Ia4"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    if (!$abbd8582f63903c2$var$realHasInstance.call($abbd8582f63903c2$var$Writable, this) && !(this instanceof $abbd8582f63903c2$var$Duplex)) return new $abbd8582f63903c2$var$Writable(options);
    this._writableState = new $abbd8582f63903c2$var$WritableState(options, this);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $paZpb.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$abbd8582f63903c2$var$Writable.prototype.pipe = function() {
    this.emit('error', new Error('Cannot pipe, not readable'));
};
function $abbd8582f63903c2$var$writeAfterEnd(stream, cb) {
    var er = new Error('write after end');
    // TODO: defer error events consistently everywhere, not just the cb
    stream.emit('error', er);
    $xBkZP.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $abbd8582f63903c2$var$validChunk(stream, state, chunk, cb) {
    var valid = true;
    var er = false;
    if (chunk === null) er = new TypeError('May not write null values to stream');
    else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    if (er) {
        stream.emit('error', er);
        $xBkZP.nextTick(cb, er);
        valid = false;
    }
    return valid;
}
$abbd8582f63903c2$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $abbd8582f63903c2$var$_isUint8Array(chunk);
    if (isBuf && !$abbd8582f63903c2$require$Buffer.isBuffer(chunk)) chunk = $abbd8582f63903c2$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $abbd8582f63903c2$var$nop;
    if (state.ended) $abbd8582f63903c2$var$writeAfterEnd(this, cb);
    else if (isBuf || $abbd8582f63903c2$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $abbd8582f63903c2$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$abbd8582f63903c2$var$Writable.prototype.cork = function() {
    var state = this._writableState;
    state.corked++;
};
$abbd8582f63903c2$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $abbd8582f63903c2$var$clearBuffer(this, state);
    }
};
$abbd8582f63903c2$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
function $abbd8582f63903c2$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $abbd8582f63903c2$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($abbd8582f63903c2$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $abbd8582f63903c2$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $abbd8582f63903c2$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $abbd8582f63903c2$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $abbd8582f63903c2$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $abbd8582f63903c2$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $xBkZP.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $xBkZP.nextTick($abbd8582f63903c2$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
        // this can emit finish, but finish must
        // always follow error
        $abbd8582f63903c2$var$finishMaybe(stream, state);
    }
}
function $abbd8582f63903c2$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $abbd8582f63903c2$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    $abbd8582f63903c2$var$onwriteStateUpdate(state);
    if (er) $abbd8582f63903c2$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $abbd8582f63903c2$var$needFinish(state);
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $abbd8582f63903c2$var$clearBuffer(stream, state);
        if (sync) /*<replacement>*/ $abbd8582f63903c2$var$asyncWrite($abbd8582f63903c2$var$afterWrite, stream, state, finished, cb);
        else $abbd8582f63903c2$var$afterWrite(stream, state, finished, cb);
    }
}
function $abbd8582f63903c2$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $abbd8582f63903c2$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $abbd8582f63903c2$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $abbd8582f63903c2$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $abbd8582f63903c2$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $abbd8582f63903c2$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $abbd8582f63903c2$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $abbd8582f63903c2$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$abbd8582f63903c2$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new Error('_write() is not implemented'));
};
$abbd8582f63903c2$var$Writable.prototype._writev = null;
$abbd8582f63903c2$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $abbd8582f63903c2$var$endWritable(this, state, cb);
};
function $abbd8582f63903c2$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $abbd8582f63903c2$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) stream.emit('error', err);
        state.prefinished = true;
        stream.emit('prefinish');
        $abbd8582f63903c2$var$finishMaybe(stream, state);
    });
}
function $abbd8582f63903c2$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function') {
            state.pendingcb++;
            state.finalCalled = true;
            $xBkZP.nextTick($abbd8582f63903c2$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $abbd8582f63903c2$var$finishMaybe(stream, state) {
    var need = $abbd8582f63903c2$var$needFinish(state);
    if (need) {
        $abbd8582f63903c2$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
        }
    }
    return need;
}
function $abbd8582f63903c2$var$endWritable(stream, state, cb) {
    state.ending = true;
    $abbd8582f63903c2$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $xBkZP.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $abbd8582f63903c2$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($abbd8582f63903c2$var$Writable.prototype, 'destroyed', {
    get: function() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$abbd8582f63903c2$var$Writable.prototype.destroy = $gISOz.destroy;
$abbd8582f63903c2$var$Writable.prototype._undestroy = $gISOz.undestroy;
$abbd8582f63903c2$var$Writable.prototype._destroy = function(err, cb) {
    this.end();
    cb(err);
};

});


parcelRegister("bnZ2C", function(module, exports) {
$parcel$export(module.exports, "StringDecoder", () => $84a1312fec1ee690$export$63a7aa211a91ed69, (v) => $84a1312fec1ee690$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $84a1312fec1ee690$export$63a7aa211a91ed69;
'use strict';

var $j2S8s = parcelRequire("j2S8s");
var $84a1312fec1ee690$require$Buffer = $j2S8s.Buffer;
/*</replacement>*/ var $84a1312fec1ee690$var$isEncoding = $84a1312fec1ee690$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $84a1312fec1ee690$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $84a1312fec1ee690$var$normalizeEncoding(enc) {
    var nenc = $84a1312fec1ee690$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($84a1312fec1ee690$require$Buffer.isEncoding === $84a1312fec1ee690$var$isEncoding || !$84a1312fec1ee690$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$84a1312fec1ee690$export$63a7aa211a91ed69 = $84a1312fec1ee690$var$StringDecoder;
function $84a1312fec1ee690$var$StringDecoder(encoding) {
    this.encoding = $84a1312fec1ee690$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $84a1312fec1ee690$var$utf16Text;
            this.end = $84a1312fec1ee690$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $84a1312fec1ee690$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $84a1312fec1ee690$var$base64Text;
            this.end = $84a1312fec1ee690$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $84a1312fec1ee690$var$simpleWrite;
            this.end = $84a1312fec1ee690$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $84a1312fec1ee690$require$Buffer.allocUnsafe(nb);
}
$84a1312fec1ee690$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$84a1312fec1ee690$var$StringDecoder.prototype.end = $84a1312fec1ee690$var$utf8End;
// Returns only complete characters in a Buffer
$84a1312fec1ee690$var$StringDecoder.prototype.text = $84a1312fec1ee690$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$84a1312fec1ee690$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $84a1312fec1ee690$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $84a1312fec1ee690$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $84a1312fec1ee690$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $84a1312fec1ee690$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $84a1312fec1ee690$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $84a1312fec1ee690$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $84a1312fec1ee690$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $84a1312fec1ee690$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $84a1312fec1ee690$var$utf8Text(buf, i) {
    var total = $84a1312fec1ee690$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $84a1312fec1ee690$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $84a1312fec1ee690$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $84a1312fec1ee690$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $84a1312fec1ee690$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $84a1312fec1ee690$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $84a1312fec1ee690$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $84a1312fec1ee690$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});
parcelRegister("j2S8s", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $b0qLu = parcelRequire("b0qLu");
var $ddd8326171f269c9$var$Buffer = $b0qLu.Buffer;
// alternative to using Object.keys for old browsers
function $ddd8326171f269c9$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($ddd8326171f269c9$var$Buffer.from && $ddd8326171f269c9$var$Buffer.alloc && $ddd8326171f269c9$var$Buffer.allocUnsafe && $ddd8326171f269c9$var$Buffer.allocUnsafeSlow) module.exports = $b0qLu;
else {
    // Copy properties from require('buffer')
    $ddd8326171f269c9$var$copyProps($b0qLu, module.exports);
    module.exports.Buffer = $ddd8326171f269c9$var$SafeBuffer;
}
function $ddd8326171f269c9$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $ddd8326171f269c9$var$Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
$ddd8326171f269c9$var$copyProps($ddd8326171f269c9$var$Buffer, $ddd8326171f269c9$var$SafeBuffer);
$ddd8326171f269c9$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $ddd8326171f269c9$var$Buffer(arg, encodingOrOffset, length);
};
$ddd8326171f269c9$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $ddd8326171f269c9$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$ddd8326171f269c9$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $ddd8326171f269c9$var$Buffer(size);
};
$ddd8326171f269c9$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $b0qLu.SlowBuffer(size);
};

});



parcelRegister("hsHHX", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $cb66f4aff6e4cd4e$var$Transform;

var $32Ia4 = parcelRequire("32Ia4");

/*<replacement>*/ var $cb66f4aff6e4cd4e$var$util = Object.create((parcelRequire("5mxBc")));

$cb66f4aff6e4cd4e$var$util.inherits = (parcelRequire("jcXeW"));
/*</replacement>*/ $cb66f4aff6e4cd4e$var$util.inherits($cb66f4aff6e4cd4e$var$Transform, $32Ia4);
function $cb66f4aff6e4cd4e$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (!cb) return this.emit('error', new Error('write callback called multiple times'));
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $cb66f4aff6e4cd4e$var$Transform(options) {
    if (!(this instanceof $cb66f4aff6e4cd4e$var$Transform)) return new $cb66f4aff6e4cd4e$var$Transform(options);
    $32Ia4.call(this, options);
    this._transformState = {
        afterTransform: $cb66f4aff6e4cd4e$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $cb66f4aff6e4cd4e$var$prefinish);
}
function $cb66f4aff6e4cd4e$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function') this._flush(function(er, data) {
        $cb66f4aff6e4cd4e$var$done(_this, er, data);
    });
    else $cb66f4aff6e4cd4e$var$done(this, null, null);
}
$cb66f4aff6e4cd4e$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $32Ia4.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$cb66f4aff6e4cd4e$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    throw new Error('_transform() is not implemented');
};
$cb66f4aff6e4cd4e$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$cb66f4aff6e4cd4e$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$cb66f4aff6e4cd4e$var$Transform.prototype._destroy = function(err, cb) {
    var _this2 = this;
    $32Ia4.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
        _this2.emit('close');
    });
};
function $cb66f4aff6e4cd4e$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) stream.push(data);
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
    if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
    return stream.push(null);
}

});

parcelRegister("54FPD", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $3b1dc66ae19431b2$var$PassThrough;

var $hsHHX = parcelRequire("hsHHX");

/*<replacement>*/ var $3b1dc66ae19431b2$var$util = Object.create((parcelRequire("5mxBc")));

$3b1dc66ae19431b2$var$util.inherits = (parcelRequire("jcXeW"));
/*</replacement>*/ $3b1dc66ae19431b2$var$util.inherits($3b1dc66ae19431b2$var$PassThrough, $hsHHX);
function $3b1dc66ae19431b2$var$PassThrough(options) {
    if (!(this instanceof $3b1dc66ae19431b2$var$PassThrough)) return new $3b1dc66ae19431b2$var$PassThrough(options);
    $hsHHX.call(this, options);
}
$3b1dc66ae19431b2$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});




parcelRegister("fnOyZ", function(module, exports) {
'use strict';
module.exports = function SHA(algorithm) {
    var alg = algorithm.toLowerCase();
    var Algorithm = module.exports[alg];
    if (!Algorithm) throw new Error(alg + ' is not supported (we accept pull requests)');
    return new Algorithm();
};

module.exports.sha = (parcelRequire("lsKEs"));

module.exports.sha1 = (parcelRequire("5F0JE"));

module.exports.sha224 = (parcelRequire("9uuVK"));

module.exports.sha256 = (parcelRequire("eiKE0"));

module.exports.sha384 = (parcelRequire("dCLY8"));

module.exports.sha512 = (parcelRequire("7yyFm"));

});
parcelRegister("lsKEs", function(module, exports) {
'use strict';

var $jcXeW = parcelRequire("jcXeW");

var $ffNk6 = parcelRequire("ffNk6");

var $dmAgJ = parcelRequire("dmAgJ");
var $fa006684fca2bad2$require$Buffer = $dmAgJ.Buffer;
var $fa006684fca2bad2$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $fa006684fca2bad2$var$W = new Array(80);
function $fa006684fca2bad2$var$Sha() {
    this.init();
    this._w = $fa006684fca2bad2$var$W;
    $ffNk6.call(this, 64, 56);
}
$jcXeW($fa006684fca2bad2$var$Sha, $ffNk6);
$fa006684fca2bad2$var$Sha.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $fa006684fca2bad2$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $fa006684fca2bad2$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $fa006684fca2bad2$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$fa006684fca2bad2$var$Sha.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)w[i] = w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16];
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $fa006684fca2bad2$var$rotl5(a) + $fa006684fca2bad2$var$ft(s, b, c, d) + e + w[j] + $fa006684fca2bad2$var$K[s] | 0;
        e = d;
        d = c;
        c = $fa006684fca2bad2$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$fa006684fca2bad2$var$Sha.prototype._hash = function() {
    var H = $fa006684fca2bad2$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $fa006684fca2bad2$var$Sha;

});
parcelRegister("ffNk6", function(module, exports) {
'use strict';

var $dmAgJ = parcelRequire("dmAgJ");
var $b1ae8450a1c1eb8d$require$Buffer = $dmAgJ.Buffer;

var $dXhxR = parcelRequire("dXhxR");
// prototype class for hash functions
function $b1ae8450a1c1eb8d$var$Hash(blockSize, finalSize) {
    this._block = $b1ae8450a1c1eb8d$require$Buffer.alloc(blockSize);
    this._finalSize = finalSize;
    this._blockSize = blockSize;
    this._len = 0;
}
$b1ae8450a1c1eb8d$var$Hash.prototype.update = function(data, enc) {
    /* eslint no-param-reassign: 0 */ data = $dXhxR(data, enc || 'utf8');
    var block = this._block;
    var blockSize = this._blockSize;
    var length = data.length;
    var accum = this._len;
    for(var offset = 0; offset < length;){
        var assigned = accum % blockSize;
        var remainder = Math.min(length - offset, blockSize - assigned);
        for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
        accum += remainder;
        offset += remainder;
        if (accum % blockSize === 0) this._update(block);
    }
    this._len += length;
    return this;
};
$b1ae8450a1c1eb8d$var$Hash.prototype.digest = function(enc) {
    var rem = this._len % this._blockSize;
    this._block[rem] = 0x80;
    /*
	 * zero (rem + 1) trailing bits, where (rem + 1) is the smallest
	 * non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
	 */ this._block.fill(0, rem + 1);
    if (rem >= this._finalSize) {
        this._update(this._block);
        this._block.fill(0);
    }
    var bits = this._len * 8;
    // uint32
    if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
    else {
        var lowBits = (bits & 0xffffffff) >>> 0;
        var highBits = (bits - lowBits) / 0x100000000;
        this._block.writeUInt32BE(highBits, this._blockSize - 8);
        this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    }
    this._update(this._block);
    var hash = this._hash();
    return enc ? hash.toString(enc) : hash;
};
$b1ae8450a1c1eb8d$var$Hash.prototype._update = function() {
    throw new Error('_update must be implemented by subclass');
};
module.exports = $b1ae8450a1c1eb8d$var$Hash;

});


parcelRegister("5F0JE", function(module, exports) {
'use strict';

var $jcXeW = parcelRequire("jcXeW");

var $ffNk6 = parcelRequire("ffNk6");

var $dmAgJ = parcelRequire("dmAgJ");
var $41f15a14c78d0713$require$Buffer = $dmAgJ.Buffer;
var $41f15a14c78d0713$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $41f15a14c78d0713$var$W = new Array(80);
function $41f15a14c78d0713$var$Sha1() {
    this.init();
    this._w = $41f15a14c78d0713$var$W;
    $ffNk6.call(this, 64, 56);
}
$jcXeW($41f15a14c78d0713$var$Sha1, $ffNk6);
$41f15a14c78d0713$var$Sha1.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $41f15a14c78d0713$var$rotl1(num) {
    return num << 1 | num >>> 31;
}
function $41f15a14c78d0713$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $41f15a14c78d0713$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $41f15a14c78d0713$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$41f15a14c78d0713$var$Sha1.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)w[i] = $41f15a14c78d0713$var$rotl1(w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16]);
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $41f15a14c78d0713$var$rotl5(a) + $41f15a14c78d0713$var$ft(s, b, c, d) + e + w[j] + $41f15a14c78d0713$var$K[s] | 0;
        e = d;
        d = c;
        c = $41f15a14c78d0713$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$41f15a14c78d0713$var$Sha1.prototype._hash = function() {
    var H = $41f15a14c78d0713$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $41f15a14c78d0713$var$Sha1;

});

parcelRegister("9uuVK", function(module, exports) {
'use strict';

var $jcXeW = parcelRequire("jcXeW");

var $eiKE0 = parcelRequire("eiKE0");

var $ffNk6 = parcelRequire("ffNk6");

var $dmAgJ = parcelRequire("dmAgJ");
var $6e8ee887fc58d9c7$require$Buffer = $dmAgJ.Buffer;
var $6e8ee887fc58d9c7$var$W = new Array(64);
function $6e8ee887fc58d9c7$var$Sha224() {
    this.init();
    this._w = $6e8ee887fc58d9c7$var$W; // new Array(64)
    $ffNk6.call(this, 64, 56);
}
$jcXeW($6e8ee887fc58d9c7$var$Sha224, $eiKE0);
$6e8ee887fc58d9c7$var$Sha224.prototype.init = function() {
    this._a = 0xc1059ed8;
    this._b = 0x367cd507;
    this._c = 0x3070dd17;
    this._d = 0xf70e5939;
    this._e = 0xffc00b31;
    this._f = 0x68581511;
    this._g = 0x64f98fa7;
    this._h = 0xbefa4fa4;
    return this;
};
$6e8ee887fc58d9c7$var$Sha224.prototype._hash = function() {
    var H = $6e8ee887fc58d9c7$require$Buffer.allocUnsafe(28);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    return H;
};
module.exports = $6e8ee887fc58d9c7$var$Sha224;

});
parcelRegister("eiKE0", function(module, exports) {
'use strict';

var $jcXeW = parcelRequire("jcXeW");

var $ffNk6 = parcelRequire("ffNk6");

var $dmAgJ = parcelRequire("dmAgJ");
var $a696edba123d93af$require$Buffer = $dmAgJ.Buffer;
var $a696edba123d93af$var$K = [
    0x428A2F98,
    0x71374491,
    0xB5C0FBCF,
    0xE9B5DBA5,
    0x3956C25B,
    0x59F111F1,
    0x923F82A4,
    0xAB1C5ED5,
    0xD807AA98,
    0x12835B01,
    0x243185BE,
    0x550C7DC3,
    0x72BE5D74,
    0x80DEB1FE,
    0x9BDC06A7,
    0xC19BF174,
    0xE49B69C1,
    0xEFBE4786,
    0x0FC19DC6,
    0x240CA1CC,
    0x2DE92C6F,
    0x4A7484AA,
    0x5CB0A9DC,
    0x76F988DA,
    0x983E5152,
    0xA831C66D,
    0xB00327C8,
    0xBF597FC7,
    0xC6E00BF3,
    0xD5A79147,
    0x06CA6351,
    0x14292967,
    0x27B70A85,
    0x2E1B2138,
    0x4D2C6DFC,
    0x53380D13,
    0x650A7354,
    0x766A0ABB,
    0x81C2C92E,
    0x92722C85,
    0xA2BFE8A1,
    0xA81A664B,
    0xC24B8B70,
    0xC76C51A3,
    0xD192E819,
    0xD6990624,
    0xF40E3585,
    0x106AA070,
    0x19A4C116,
    0x1E376C08,
    0x2748774C,
    0x34B0BCB5,
    0x391C0CB3,
    0x4ED8AA4A,
    0x5B9CCA4F,
    0x682E6FF3,
    0x748F82EE,
    0x78A5636F,
    0x84C87814,
    0x8CC70208,
    0x90BEFFFA,
    0xA4506CEB,
    0xBEF9A3F7,
    0xC67178F2
];
var $a696edba123d93af$var$W = new Array(64);
function $a696edba123d93af$var$Sha256() {
    this.init();
    this._w = $a696edba123d93af$var$W; // new Array(64)
    $ffNk6.call(this, 64, 56);
}
$jcXeW($a696edba123d93af$var$Sha256, $ffNk6);
$a696edba123d93af$var$Sha256.prototype.init = function() {
    this._a = 0x6a09e667;
    this._b = 0xbb67ae85;
    this._c = 0x3c6ef372;
    this._d = 0xa54ff53a;
    this._e = 0x510e527f;
    this._f = 0x9b05688c;
    this._g = 0x1f83d9ab;
    this._h = 0x5be0cd19;
    return this;
};
function $a696edba123d93af$var$ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $a696edba123d93af$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $a696edba123d93af$var$sigma0(x) {
    return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
}
function $a696edba123d93af$var$sigma1(x) {
    return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
}
function $a696edba123d93af$var$gamma0(x) {
    return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
}
function $a696edba123d93af$var$gamma1(x) {
    return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
}
$a696edba123d93af$var$Sha256.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    var f = this._f | 0;
    var g = this._g | 0;
    var h = this._h | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 64; ++i)w[i] = $a696edba123d93af$var$gamma1(w[i - 2]) + w[i - 7] + $a696edba123d93af$var$gamma0(w[i - 15]) + w[i - 16] | 0;
    for(var j = 0; j < 64; ++j){
        var T1 = h + $a696edba123d93af$var$sigma1(e) + $a696edba123d93af$var$ch(e, f, g) + $a696edba123d93af$var$K[j] + w[j] | 0;
        var T2 = $a696edba123d93af$var$sigma0(a) + $a696edba123d93af$var$maj(a, b, c) | 0;
        h = g;
        g = f;
        f = e;
        e = d + T1 | 0;
        d = c;
        c = b;
        b = a;
        a = T1 + T2 | 0;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
    this._f = f + this._f | 0;
    this._g = g + this._g | 0;
    this._h = h + this._h | 0;
};
$a696edba123d93af$var$Sha256.prototype._hash = function() {
    var H = $a696edba123d93af$require$Buffer.allocUnsafe(32);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    H.writeInt32BE(this._h, 28);
    return H;
};
module.exports = $a696edba123d93af$var$Sha256;

});


parcelRegister("dCLY8", function(module, exports) {
'use strict';

var $jcXeW = parcelRequire("jcXeW");

var $7yyFm = parcelRequire("7yyFm");

var $ffNk6 = parcelRequire("ffNk6");

var $dmAgJ = parcelRequire("dmAgJ");
var $9eb4089b939c5566$require$Buffer = $dmAgJ.Buffer;
var $9eb4089b939c5566$var$W = new Array(160);
function $9eb4089b939c5566$var$Sha384() {
    this.init();
    this._w = $9eb4089b939c5566$var$W;
    $ffNk6.call(this, 128, 112);
}
$jcXeW($9eb4089b939c5566$var$Sha384, $7yyFm);
$9eb4089b939c5566$var$Sha384.prototype.init = function() {
    this._ah = 0xcbbb9d5d;
    this._bh = 0x629a292a;
    this._ch = 0x9159015a;
    this._dh = 0x152fecd8;
    this._eh = 0x67332667;
    this._fh = 0x8eb44a87;
    this._gh = 0xdb0c2e0d;
    this._hh = 0x47b5481d;
    this._al = 0xc1059ed8;
    this._bl = 0x367cd507;
    this._cl = 0x3070dd17;
    this._dl = 0xf70e5939;
    this._el = 0xffc00b31;
    this._fl = 0x68581511;
    this._gl = 0x64f98fa7;
    this._hl = 0xbefa4fa4;
    return this;
};
$9eb4089b939c5566$var$Sha384.prototype._hash = function() {
    var H = $9eb4089b939c5566$require$Buffer.allocUnsafe(48);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    return H;
};
module.exports = $9eb4089b939c5566$var$Sha384;

});
parcelRegister("7yyFm", function(module, exports) {
'use strict';

var $jcXeW = parcelRequire("jcXeW");

var $ffNk6 = parcelRequire("ffNk6");

var $dmAgJ = parcelRequire("dmAgJ");
var $5806995589882d7f$require$Buffer = $dmAgJ.Buffer;
var $5806995589882d7f$var$K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
var $5806995589882d7f$var$W = new Array(160);
function $5806995589882d7f$var$Sha512() {
    this.init();
    this._w = $5806995589882d7f$var$W;
    $ffNk6.call(this, 128, 112);
}
$jcXeW($5806995589882d7f$var$Sha512, $ffNk6);
$5806995589882d7f$var$Sha512.prototype.init = function() {
    this._ah = 0x6a09e667;
    this._bh = 0xbb67ae85;
    this._ch = 0x3c6ef372;
    this._dh = 0xa54ff53a;
    this._eh = 0x510e527f;
    this._fh = 0x9b05688c;
    this._gh = 0x1f83d9ab;
    this._hh = 0x5be0cd19;
    this._al = 0xf3bcc908;
    this._bl = 0x84caa73b;
    this._cl = 0xfe94f82b;
    this._dl = 0x5f1d36f1;
    this._el = 0xade682d1;
    this._fl = 0x2b3e6c1f;
    this._gl = 0xfb41bd6b;
    this._hl = 0x137e2179;
    return this;
};
function $5806995589882d7f$var$Ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $5806995589882d7f$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $5806995589882d7f$var$sigma0(x, xl) {
    return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
}
function $5806995589882d7f$var$sigma1(x, xl) {
    return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
}
function $5806995589882d7f$var$Gamma0(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
}
function $5806995589882d7f$var$Gamma0l(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
}
function $5806995589882d7f$var$Gamma1(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
}
function $5806995589882d7f$var$Gamma1l(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
}
function $5806995589882d7f$var$getCarry(a, b) {
    return a >>> 0 < b >>> 0 ? 1 : 0;
}
$5806995589882d7f$var$Sha512.prototype._update = function(M) {
    var w = this._w;
    var ah = this._ah | 0;
    var bh = this._bh | 0;
    var ch = this._ch | 0;
    var dh = this._dh | 0;
    var eh = this._eh | 0;
    var fh = this._fh | 0;
    var gh = this._gh | 0;
    var hh = this._hh | 0;
    var al = this._al | 0;
    var bl = this._bl | 0;
    var cl = this._cl | 0;
    var dl = this._dl | 0;
    var el = this._el | 0;
    var fl = this._fl | 0;
    var gl = this._gl | 0;
    var hl = this._hl | 0;
    for(var i = 0; i < 32; i += 2){
        w[i] = M.readInt32BE(i * 4);
        w[i + 1] = M.readInt32BE(i * 4 + 4);
    }
    for(; i < 160; i += 2){
        var xh = w[i - 30];
        var xl = w[i - 30 + 1];
        var gamma0 = $5806995589882d7f$var$Gamma0(xh, xl);
        var gamma0l = $5806995589882d7f$var$Gamma0l(xl, xh);
        xh = w[i - 4];
        xl = w[i - 4 + 1];
        var gamma1 = $5806995589882d7f$var$Gamma1(xh, xl);
        var gamma1l = $5806995589882d7f$var$Gamma1l(xl, xh);
        // w[i] = gamma0 + w[i - 7] + gamma1 + w[i - 16]
        var Wi7h = w[i - 14];
        var Wi7l = w[i - 14 + 1];
        var Wi16h = w[i - 32];
        var Wi16l = w[i - 32 + 1];
        var Wil = gamma0l + Wi7l | 0;
        var Wih = gamma0 + Wi7h + $5806995589882d7f$var$getCarry(Wil, gamma0l) | 0;
        Wil = Wil + gamma1l | 0;
        Wih = Wih + gamma1 + $5806995589882d7f$var$getCarry(Wil, gamma1l) | 0;
        Wil = Wil + Wi16l | 0;
        Wih = Wih + Wi16h + $5806995589882d7f$var$getCarry(Wil, Wi16l) | 0;
        w[i] = Wih;
        w[i + 1] = Wil;
    }
    for(var j = 0; j < 160; j += 2){
        Wih = w[j];
        Wil = w[j + 1];
        var majh = $5806995589882d7f$var$maj(ah, bh, ch);
        var majl = $5806995589882d7f$var$maj(al, bl, cl);
        var sigma0h = $5806995589882d7f$var$sigma0(ah, al);
        var sigma0l = $5806995589882d7f$var$sigma0(al, ah);
        var sigma1h = $5806995589882d7f$var$sigma1(eh, el);
        var sigma1l = $5806995589882d7f$var$sigma1(el, eh);
        // t1 = h + sigma1 + ch + K[j] + w[j]
        var Kih = $5806995589882d7f$var$K[j];
        var Kil = $5806995589882d7f$var$K[j + 1];
        var chh = $5806995589882d7f$var$Ch(eh, fh, gh);
        var chl = $5806995589882d7f$var$Ch(el, fl, gl);
        var t1l = hl + sigma1l | 0;
        var t1h = hh + sigma1h + $5806995589882d7f$var$getCarry(t1l, hl) | 0;
        t1l = t1l + chl | 0;
        t1h = t1h + chh + $5806995589882d7f$var$getCarry(t1l, chl) | 0;
        t1l = t1l + Kil | 0;
        t1h = t1h + Kih + $5806995589882d7f$var$getCarry(t1l, Kil) | 0;
        t1l = t1l + Wil | 0;
        t1h = t1h + Wih + $5806995589882d7f$var$getCarry(t1l, Wil) | 0;
        // t2 = sigma0 + maj
        var t2l = sigma0l + majl | 0;
        var t2h = sigma0h + majh + $5806995589882d7f$var$getCarry(t2l, sigma0l) | 0;
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        el = dl + t1l | 0;
        eh = dh + t1h + $5806995589882d7f$var$getCarry(el, dl) | 0;
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        al = t1l + t2l | 0;
        ah = t1h + t2h + $5806995589882d7f$var$getCarry(al, t1l) | 0;
    }
    this._al = this._al + al | 0;
    this._bl = this._bl + bl | 0;
    this._cl = this._cl + cl | 0;
    this._dl = this._dl + dl | 0;
    this._el = this._el + el | 0;
    this._fl = this._fl + fl | 0;
    this._gl = this._gl + gl | 0;
    this._hl = this._hl + hl | 0;
    this._ah = this._ah + ah + $5806995589882d7f$var$getCarry(this._al, al) | 0;
    this._bh = this._bh + bh + $5806995589882d7f$var$getCarry(this._bl, bl) | 0;
    this._ch = this._ch + ch + $5806995589882d7f$var$getCarry(this._cl, cl) | 0;
    this._dh = this._dh + dh + $5806995589882d7f$var$getCarry(this._dl, dl) | 0;
    this._eh = this._eh + eh + $5806995589882d7f$var$getCarry(this._el, el) | 0;
    this._fh = this._fh + fh + $5806995589882d7f$var$getCarry(this._fl, fl) | 0;
    this._gh = this._gh + gh + $5806995589882d7f$var$getCarry(this._gl, gl) | 0;
    this._hh = this._hh + hh + $5806995589882d7f$var$getCarry(this._hl, hl) | 0;
};
$5806995589882d7f$var$Sha512.prototype._hash = function() {
    var H = $5806995589882d7f$require$Buffer.allocUnsafe(64);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    writeInt64BE(this._gh, this._gl, 48);
    writeInt64BE(this._hh, this._hl, 56);
    return H;
};
module.exports = $5806995589882d7f$var$Sha512;

});



parcelRegister("h4bOS", function(module, exports) {
'use strict';

var $dmAgJ = parcelRequire("dmAgJ");
var $c6cbfa7de51cb731$require$Buffer = $dmAgJ.Buffer;

var $79Vz3 = parcelRequire("79Vz3");
var $c6cbfa7de51cb731$require$Transform = $79Vz3.Transform;

var $bUuLH = parcelRequire("bUuLH");
var $c6cbfa7de51cb731$require$StringDecoder = $bUuLH.StringDecoder;

var $jcXeW = parcelRequire("jcXeW");
function $c6cbfa7de51cb731$var$CipherBase(hashMode) {
    $c6cbfa7de51cb731$require$Transform.call(this);
    this.hashMode = typeof hashMode === 'string';
    if (this.hashMode) this[hashMode] = this._finalOrDigest;
    else this['final'] = this._finalOrDigest;
    if (this._final) {
        this.__final = this._final;
        this._final = null;
    }
    this._decoder = null;
    this._encoding = null;
}
$jcXeW($c6cbfa7de51cb731$var$CipherBase, $c6cbfa7de51cb731$require$Transform);
var $c6cbfa7de51cb731$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $c6cbfa7de51cb731$var$useArrayBuffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && ArrayBuffer.isView && ($c6cbfa7de51cb731$require$Buffer.prototype instanceof Uint8Array || $c6cbfa7de51cb731$require$Buffer.TYPED_ARRAY_SUPPORT);
function $c6cbfa7de51cb731$var$toBuffer(data, encoding) {
    /*
	 * No need to do anything for exact instance
	 * This is only valid when safe-buffer.Buffer === buffer.Buffer, i.e. when Buffer.from/Buffer.alloc existed
	 */ if (data instanceof $c6cbfa7de51cb731$require$Buffer) return data;
    // Convert strings to Buffer
    if (typeof data === 'string') return $c6cbfa7de51cb731$require$Buffer.from(data, encoding);
    /*
	 * Wrap any TypedArray instances and DataViews
	 * Makes sense only on engines with full TypedArray support -- let Buffer detect that
	 */ if ($c6cbfa7de51cb731$var$useArrayBuffer && ArrayBuffer.isView(data)) {
        // Bug in Node.js <6.3.1, which treats this as out-of-bounds
        if (data.byteLength === 0) return $c6cbfa7de51cb731$require$Buffer.alloc(0);
        var res = $c6cbfa7de51cb731$require$Buffer.from(data.buffer, data.byteOffset, data.byteLength);
        /*
		 * Recheck result size, as offset/length doesn't work on Node.js <5.10
		 * We just go to Uint8Array case if this fails
		 */ if (res.byteLength === data.byteLength) return res;
    }
    /*
	 * Uint8Array in engines where Buffer.from might not work with ArrayBuffer, just copy over
	 * Doesn't make sense with other TypedArray instances
	 */ if ($c6cbfa7de51cb731$var$useUint8Array && data instanceof Uint8Array) return $c6cbfa7de51cb731$require$Buffer.from(data);
    /*
	 * Old Buffer polyfill on an engine that doesn't have TypedArray support
	 * Also, this is from a different Buffer polyfill implementation then we have, as instanceof check failed
	 * Convert to our current Buffer implementation
	 */ if ($c6cbfa7de51cb731$require$Buffer.isBuffer(data) && data.constructor && typeof data.constructor.isBuffer === 'function' && data.constructor.isBuffer(data)) return $c6cbfa7de51cb731$require$Buffer.from(data);
    throw new TypeError('The "data" argument must be of type string or an instance of Buffer, TypedArray, or DataView.');
}
$c6cbfa7de51cb731$var$CipherBase.prototype.update = function(data, inputEnc, outputEnc) {
    var bufferData = $c6cbfa7de51cb731$var$toBuffer(data, inputEnc); // asserts correct input type
    var outData = this._update(bufferData);
    if (this.hashMode) return this;
    if (outputEnc) outData = this._toString(outData, outputEnc);
    return outData;
};
$c6cbfa7de51cb731$var$CipherBase.prototype.setAutoPadding = function() {};
$c6cbfa7de51cb731$var$CipherBase.prototype.getAuthTag = function() {
    throw new Error('trying to get auth tag in unsupported state');
};
$c6cbfa7de51cb731$var$CipherBase.prototype.setAuthTag = function() {
    throw new Error('trying to set auth tag in unsupported state');
};
$c6cbfa7de51cb731$var$CipherBase.prototype.setAAD = function() {
    throw new Error('trying to set aad in unsupported state');
};
$c6cbfa7de51cb731$var$CipherBase.prototype._transform = function(data, _, next) {
    var err;
    try {
        if (this.hashMode) this._update(data);
        else this.push(this._update(data));
    } catch (e) {
        err = e;
    } finally{
        next(err);
    }
};
$c6cbfa7de51cb731$var$CipherBase.prototype._flush = function(done) {
    var err;
    try {
        this.push(this.__final());
    } catch (e) {
        err = e;
    }
    done(err);
};
$c6cbfa7de51cb731$var$CipherBase.prototype._finalOrDigest = function(outputEnc) {
    var outData = this.__final() || $c6cbfa7de51cb731$require$Buffer.alloc(0);
    if (outputEnc) outData = this._toString(outData, outputEnc, true);
    return outData;
};
$c6cbfa7de51cb731$var$CipherBase.prototype._toString = function(value, enc, fin) {
    if (!this._decoder) {
        this._decoder = new $c6cbfa7de51cb731$require$StringDecoder(enc);
        this._encoding = enc;
    }
    if (this._encoding !== enc) throw new Error("can\u2019t switch encodings");
    var out = this._decoder.write(value);
    if (fin) out += this._decoder.end();
    return out;
};
module.exports = $c6cbfa7de51cb731$var$CipherBase;

});
parcelRegister("79Vz3", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $536606c5b6ab2dba$var$Stream;

var $gW4Pg = parcelRequire("gW4Pg");
var $536606c5b6ab2dba$require$EE = $gW4Pg.EventEmitter;

var $jcXeW = parcelRequire("jcXeW");
$jcXeW($536606c5b6ab2dba$var$Stream, $536606c5b6ab2dba$require$EE);

$536606c5b6ab2dba$var$Stream.Readable = (parcelRequire("i0kUt"));

$536606c5b6ab2dba$var$Stream.Writable = (parcelRequire("02VkB"));

$536606c5b6ab2dba$var$Stream.Duplex = (parcelRequire("7acSG"));

$536606c5b6ab2dba$var$Stream.Transform = (parcelRequire("2IDOh"));

$536606c5b6ab2dba$var$Stream.PassThrough = (parcelRequire("gVC8t"));

$536606c5b6ab2dba$var$Stream.finished = (parcelRequire("7vn5t"));

$536606c5b6ab2dba$var$Stream.pipeline = (parcelRequire("k9xhG"));
// Backwards-compat with node 0.4.x
$536606c5b6ab2dba$var$Stream.Stream = $536606c5b6ab2dba$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $536606c5b6ab2dba$var$Stream() {
    $536606c5b6ab2dba$require$EE.call(this);
}
$536606c5b6ab2dba$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($536606c5b6ab2dba$require$EE.listenerCount(this, 'error') === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on('error', onerror);
    dest.on('error', onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});
parcelRegister("i0kUt", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $aVaWD = parcelRequire("aVaWD");
'use strict';
module.exports = $d1b8725c11876b7e$var$Readable;
/*<replacement>*/ var $d1b8725c11876b7e$var$Duplex;
/*</replacement>*/ $d1b8725c11876b7e$var$Readable.ReadableState = $d1b8725c11876b7e$var$ReadableState;

var $gW4Pg = parcelRequire("gW4Pg");
var $d1b8725c11876b7e$require$EE = $gW4Pg.EventEmitter;
var $d1b8725c11876b7e$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $c2Kvz = parcelRequire("c2Kvz");

var $b0qLu = parcelRequire("b0qLu");
var $d1b8725c11876b7e$require$Buffer = $b0qLu.Buffer;
var $d1b8725c11876b7e$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $d1b8725c11876b7e$var$_uint8ArrayToBuffer(chunk) {
    return $d1b8725c11876b7e$require$Buffer.from(chunk);
}
function $d1b8725c11876b7e$var$_isUint8Array(obj) {
    return $d1b8725c11876b7e$require$Buffer.isBuffer(obj) || obj instanceof $d1b8725c11876b7e$var$OurUint8Array;
}

var $luYXS = parcelRequire("luYXS");
var $d1b8725c11876b7e$var$debug;
if ($luYXS && $luYXS.debuglog) $d1b8725c11876b7e$var$debug = $luYXS.debuglog('stream');
else $d1b8725c11876b7e$var$debug = function debug() {};

var $gJP7L = parcelRequire("gJP7L");

var $hRXs2 = parcelRequire("hRXs2");

var $6cilr = parcelRequire("6cilr");
var $d1b8725c11876b7e$var$getHighWaterMark = $6cilr.getHighWaterMark;

var $lEaFc = parcelRequire("lEaFc");
var $d1b8725c11876b7e$require$_require$codes = $lEaFc.codes;
var $d1b8725c11876b7e$var$ERR_INVALID_ARG_TYPE = $d1b8725c11876b7e$require$_require$codes.ERR_INVALID_ARG_TYPE, $d1b8725c11876b7e$var$ERR_STREAM_PUSH_AFTER_EOF = $d1b8725c11876b7e$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $d1b8725c11876b7e$var$ERR_METHOD_NOT_IMPLEMENTED = $d1b8725c11876b7e$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $d1b8725c11876b7e$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $d1b8725c11876b7e$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $d1b8725c11876b7e$var$StringDecoder;
var $d1b8725c11876b7e$var$createReadableStreamAsyncIterator;
var $d1b8725c11876b7e$var$from;

(parcelRequire("jcXeW"))($d1b8725c11876b7e$var$Readable, $c2Kvz);
var $d1b8725c11876b7e$var$errorOrDestroy = $hRXs2.errorOrDestroy;
var $d1b8725c11876b7e$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $d1b8725c11876b7e$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $d1b8725c11876b7e$var$ReadableState(options, stream, isDuplex) {
    $d1b8725c11876b7e$var$Duplex = $d1b8725c11876b7e$var$Duplex || (parcelRequire("7acSG"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $d1b8725c11876b7e$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $d1b8725c11876b7e$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $gJP7L();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$d1b8725c11876b7e$var$StringDecoder) $d1b8725c11876b7e$var$StringDecoder = (parcelRequire("bUuLH")).StringDecoder;
        this.decoder = new $d1b8725c11876b7e$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $d1b8725c11876b7e$var$Readable(options) {
    $d1b8725c11876b7e$var$Duplex = $d1b8725c11876b7e$var$Duplex || (parcelRequire("7acSG"));
    if (!(this instanceof $d1b8725c11876b7e$var$Readable)) return new $d1b8725c11876b7e$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $d1b8725c11876b7e$var$Duplex;
    this._readableState = new $d1b8725c11876b7e$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $c2Kvz.call(this);
}
Object.defineProperty($d1b8725c11876b7e$var$Readable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$d1b8725c11876b7e$var$Readable.prototype.destroy = $hRXs2.destroy;
$d1b8725c11876b7e$var$Readable.prototype._undestroy = $hRXs2.undestroy;
$d1b8725c11876b7e$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$d1b8725c11876b7e$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $d1b8725c11876b7e$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $d1b8725c11876b7e$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$d1b8725c11876b7e$var$Readable.prototype.unshift = function(chunk) {
    return $d1b8725c11876b7e$var$readableAddChunk(this, chunk, null, true, false);
};
function $d1b8725c11876b7e$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $d1b8725c11876b7e$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $d1b8725c11876b7e$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $d1b8725c11876b7e$var$chunkInvalid(state, chunk);
        if (er) $d1b8725c11876b7e$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $d1b8725c11876b7e$require$Buffer.prototype) chunk = $d1b8725c11876b7e$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $d1b8725c11876b7e$var$errorOrDestroy(stream, new $d1b8725c11876b7e$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $d1b8725c11876b7e$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $d1b8725c11876b7e$var$errorOrDestroy(stream, new $d1b8725c11876b7e$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $d1b8725c11876b7e$var$addChunk(stream, state, chunk, false);
                    else $d1b8725c11876b7e$var$maybeReadMore(stream, state);
                } else $d1b8725c11876b7e$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $d1b8725c11876b7e$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $d1b8725c11876b7e$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit('data', chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $d1b8725c11876b7e$var$emitReadable(stream);
    }
    $d1b8725c11876b7e$var$maybeReadMore(stream, state);
}
function $d1b8725c11876b7e$var$chunkInvalid(state, chunk) {
    var er;
    if (!$d1b8725c11876b7e$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new $d1b8725c11876b7e$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer',
        'Uint8Array'
    ], chunk);
    return er;
}
$d1b8725c11876b7e$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$d1b8725c11876b7e$var$Readable.prototype.setEncoding = function(enc) {
    if (!$d1b8725c11876b7e$var$StringDecoder) $d1b8725c11876b7e$var$StringDecoder = (parcelRequire("bUuLH")).StringDecoder;
    var decoder = new $d1b8725c11876b7e$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = '';
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== '') this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $d1b8725c11876b7e$var$MAX_HWM = 0x40000000;
function $d1b8725c11876b7e$var$computeNewHighWaterMark(n) {
    if (n >= $d1b8725c11876b7e$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $d1b8725c11876b7e$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $d1b8725c11876b7e$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $d1b8725c11876b7e$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$d1b8725c11876b7e$var$Readable.prototype.read = function(n) {
    $d1b8725c11876b7e$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $d1b8725c11876b7e$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $d1b8725c11876b7e$var$endReadable(this);
        else $d1b8725c11876b7e$var$emitReadable(this);
        return null;
    }
    n = $d1b8725c11876b7e$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $d1b8725c11876b7e$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $d1b8725c11876b7e$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $d1b8725c11876b7e$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $d1b8725c11876b7e$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $d1b8725c11876b7e$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $d1b8725c11876b7e$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $d1b8725c11876b7e$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $d1b8725c11876b7e$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $d1b8725c11876b7e$var$onEofChunk(stream, state) {
    $d1b8725c11876b7e$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $d1b8725c11876b7e$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $d1b8725c11876b7e$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $d1b8725c11876b7e$var$emitReadable(stream) {
    var state = stream._readableState;
    $d1b8725c11876b7e$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $d1b8725c11876b7e$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $aVaWD.nextTick($d1b8725c11876b7e$var$emitReadable_, stream);
    }
}
function $d1b8725c11876b7e$var$emitReadable_(stream) {
    var state = stream._readableState;
    $d1b8725c11876b7e$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $d1b8725c11876b7e$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $d1b8725c11876b7e$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $aVaWD.nextTick($d1b8725c11876b7e$var$maybeReadMore_, stream, state);
    }
}
function $d1b8725c11876b7e$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $d1b8725c11876b7e$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$d1b8725c11876b7e$var$Readable.prototype._read = function(n) {
    $d1b8725c11876b7e$var$errorOrDestroy(this, new $d1b8725c11876b7e$var$ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};
$d1b8725c11876b7e$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $d1b8725c11876b7e$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $aVaWD.stdout && dest !== $aVaWD.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $aVaWD.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $d1b8725c11876b7e$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $d1b8725c11876b7e$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $d1b8725c11876b7e$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $d1b8725c11876b7e$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $d1b8725c11876b7e$var$debug('ondata');
        var ret = dest.write(chunk);
        $d1b8725c11876b7e$var$debug('dest.write', ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $d1b8725c11876b7e$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $d1b8725c11876b7e$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $d1b8725c11876b7e$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($d1b8725c11876b7e$var$EElistenerCount(dest, 'error') === 0) $d1b8725c11876b7e$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $d1b8725c11876b7e$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $d1b8725c11876b7e$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $d1b8725c11876b7e$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $d1b8725c11876b7e$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $d1b8725c11876b7e$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $d1b8725c11876b7e$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $d1b8725c11876b7e$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $d1b8725c11876b7e$var$flow(src);
        }
    };
}
$d1b8725c11876b7e$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $d1b8725c11876b7e$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$d1b8725c11876b7e$var$Readable.prototype.on = function(ev, fn) {
    var res = $c2Kvz.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $d1b8725c11876b7e$var$debug('on readable', state.length, state.reading);
            if (state.length) $d1b8725c11876b7e$var$emitReadable(this);
            else if (!state.reading) $aVaWD.nextTick($d1b8725c11876b7e$var$nReadingNextTick, this);
        }
    }
    return res;
};
$d1b8725c11876b7e$var$Readable.prototype.addListener = $d1b8725c11876b7e$var$Readable.prototype.on;
$d1b8725c11876b7e$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $c2Kvz.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $aVaWD.nextTick($d1b8725c11876b7e$var$updateReadableListening, this);
    return res;
};
$d1b8725c11876b7e$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $c2Kvz.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $aVaWD.nextTick($d1b8725c11876b7e$var$updateReadableListening, this);
    return res;
};
function $d1b8725c11876b7e$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount('readable') > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount('data') > 0) self1.resume();
}
function $d1b8725c11876b7e$var$nReadingNextTick(self1) {
    $d1b8725c11876b7e$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$d1b8725c11876b7e$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $d1b8725c11876b7e$var$debug('resume');
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $d1b8725c11876b7e$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $d1b8725c11876b7e$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $aVaWD.nextTick($d1b8725c11876b7e$var$resume_, stream, state);
    }
}
function $d1b8725c11876b7e$var$resume_(stream, state) {
    $d1b8725c11876b7e$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $d1b8725c11876b7e$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$d1b8725c11876b7e$var$Readable.prototype.pause = function() {
    $d1b8725c11876b7e$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $d1b8725c11876b7e$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState.paused = true;
    return this;
};
function $d1b8725c11876b7e$var$flow(stream) {
    var state = stream._readableState;
    $d1b8725c11876b7e$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$d1b8725c11876b7e$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $d1b8725c11876b7e$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $d1b8725c11876b7e$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $d1b8725c11876b7e$var$kProxyEvents.length; n++)stream.on($d1b8725c11876b7e$var$kProxyEvents[n], this.emit.bind(this, $d1b8725c11876b7e$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $d1b8725c11876b7e$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === 'function') $d1b8725c11876b7e$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($d1b8725c11876b7e$var$createReadableStreamAsyncIterator === undefined) $d1b8725c11876b7e$var$createReadableStreamAsyncIterator = (parcelRequire("1OAkB"));
    return $d1b8725c11876b7e$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($d1b8725c11876b7e$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($d1b8725c11876b7e$var$Readable.prototype, 'readableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($d1b8725c11876b7e$var$Readable.prototype, 'readableFlowing', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$d1b8725c11876b7e$var$Readable._fromList = $d1b8725c11876b7e$var$fromList;
Object.defineProperty($d1b8725c11876b7e$var$Readable.prototype, 'readableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $d1b8725c11876b7e$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $d1b8725c11876b7e$var$endReadable(stream) {
    var state = stream._readableState;
    $d1b8725c11876b7e$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $aVaWD.nextTick($d1b8725c11876b7e$var$endReadableNT, state, stream);
    }
}
function $d1b8725c11876b7e$var$endReadableNT(state, stream) {
    $d1b8725c11876b7e$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === 'function') $d1b8725c11876b7e$var$Readable.from = function(iterable, opts) {
    if ($d1b8725c11876b7e$var$from === undefined) $d1b8725c11876b7e$var$from = (parcelRequire("hxvZM"));
    return $d1b8725c11876b7e$var$from($d1b8725c11876b7e$var$Readable, iterable, opts);
};
function $d1b8725c11876b7e$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("c2Kvz", function(module, exports) {

module.exports = (parcelRequire("gW4Pg")).EventEmitter;

});

parcelRegister("gJP7L", function(module, exports) {
'use strict';
function $c2f88183ecb5ded6$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c2f88183ecb5ded6$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $c2f88183ecb5ded6$var$ownKeys(Object(source), !0).forEach(function(key) {
            $c2f88183ecb5ded6$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $c2f88183ecb5ded6$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $c2f88183ecb5ded6$var$_defineProperty(obj, key, value) {
    key = $c2f88183ecb5ded6$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c2f88183ecb5ded6$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c2f88183ecb5ded6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $c2f88183ecb5ded6$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $c2f88183ecb5ded6$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c2f88183ecb5ded6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c2f88183ecb5ded6$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $c2f88183ecb5ded6$var$_toPropertyKey(arg) {
    var key = $c2f88183ecb5ded6$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $c2f88183ecb5ded6$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $b0qLu = parcelRequire("b0qLu");
var $c2f88183ecb5ded6$var$Buffer = $b0qLu.Buffer;

var $luYXS = parcelRequire("luYXS");
var $c2f88183ecb5ded6$var$inspect = $luYXS.inspect;
var $c2f88183ecb5ded6$var$custom = $c2f88183ecb5ded6$var$inspect && $c2f88183ecb5ded6$var$inspect.custom || 'inspect';
function $c2f88183ecb5ded6$var$copyBuffer(src, target, offset) {
    $c2f88183ecb5ded6$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $c2f88183ecb5ded6$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $c2f88183ecb5ded6$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $c2f88183ecb5ded6$var$Buffer.alloc(0);
                var ret = $c2f88183ecb5ded6$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $c2f88183ecb5ded6$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $c2f88183ecb5ded6$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $c2f88183ecb5ded6$var$custom,
            value: function value(_, options) {
                return $c2f88183ecb5ded6$var$inspect(this, $c2f88183ecb5ded6$var$_objectSpread($c2f88183ecb5ded6$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("hRXs2", function(module, exports) {

var $aVaWD = parcelRequire("aVaWD");
'use strict';
// undocumented cb() API, needed for core, not for public API
function $d02580b28d7225bc$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $aVaWD.nextTick($d02580b28d7225bc$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $aVaWD.nextTick($d02580b28d7225bc$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $aVaWD.nextTick($d02580b28d7225bc$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $aVaWD.nextTick($d02580b28d7225bc$var$emitErrorAndCloseNT, _this, err);
            } else $aVaWD.nextTick($d02580b28d7225bc$var$emitCloseNT, _this);
        } else if (cb) {
            $aVaWD.nextTick($d02580b28d7225bc$var$emitCloseNT, _this);
            cb(err);
        } else $aVaWD.nextTick($d02580b28d7225bc$var$emitCloseNT, _this);
    });
    return this;
}
function $d02580b28d7225bc$var$emitErrorAndCloseNT(self, err) {
    $d02580b28d7225bc$var$emitErrorNT(self, err);
    $d02580b28d7225bc$var$emitCloseNT(self);
}
function $d02580b28d7225bc$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit('close');
}
function $d02580b28d7225bc$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $d02580b28d7225bc$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
function $d02580b28d7225bc$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit('error', err);
}
module.exports = {
    destroy: $d02580b28d7225bc$var$destroy,
    undestroy: $d02580b28d7225bc$var$undestroy,
    errorOrDestroy: $d02580b28d7225bc$var$errorOrDestroy
};

});

parcelRegister("6cilr", function(module, exports) {
'use strict';

var $483217fc14ba68d3$var$ERR_INVALID_OPT_VALUE = (parcelRequire("lEaFc")).codes.ERR_INVALID_OPT_VALUE;
function $483217fc14ba68d3$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $483217fc14ba68d3$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $483217fc14ba68d3$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : 'highWaterMark';
            throw new $483217fc14ba68d3$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $483217fc14ba68d3$var$getHighWaterMark
};

});
parcelRegister("lEaFc", function(module, exports) {
$parcel$export(module.exports, "codes", () => $fc259af8d8df1764$export$e45cb6485273080e, (v) => $fc259af8d8df1764$export$e45cb6485273080e = v);
var $fc259af8d8df1764$export$e45cb6485273080e;
'use strict';
function $fc259af8d8df1764$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $fc259af8d8df1764$var$codes = {};
function $fc259af8d8df1764$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $fc259af8d8df1764$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $fc259af8d8df1764$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $fc259af8d8df1764$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $fc259af8d8df1764$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $fc259af8d8df1764$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $fc259af8d8df1764$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$fc259af8d8df1764$var$createErrorType('ERR_INVALID_OPT_VALUE', function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$fc259af8d8df1764$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $fc259af8d8df1764$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($fc259af8d8df1764$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($fc259af8d8df1764$var$oneOf(expected, 'type'));
    else {
        var type = $fc259af8d8df1764$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($fc259af8d8df1764$var$oneOf(expected, 'type'));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$fc259af8d8df1764$var$createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
$fc259af8d8df1764$var$createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function(name) {
    return 'The ' + name + ' method is not implemented';
});
$fc259af8d8df1764$var$createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
$fc259af8d8df1764$var$createErrorType('ERR_STREAM_DESTROYED', function(name) {
    return 'Cannot call ' + name + ' after a stream was destroyed';
});
$fc259af8d8df1764$var$createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
$fc259af8d8df1764$var$createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
$fc259af8d8df1764$var$createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
$fc259af8d8df1764$var$createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$fc259af8d8df1764$var$createErrorType('ERR_UNKNOWN_ENCODING', function(arg) {
    return 'Unknown encoding: ' + arg;
}, TypeError);
$fc259af8d8df1764$var$createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
$fc259af8d8df1764$export$e45cb6485273080e = $fc259af8d8df1764$var$codes;

});


parcelRegister("7acSG", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $aVaWD = parcelRequire("aVaWD");
'use strict';
/*<replacement>*/ var $53737573819ff568$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $53737573819ff568$var$Duplex;

var $i0kUt = parcelRequire("i0kUt");

var $02VkB = parcelRequire("02VkB");

(parcelRequire("jcXeW"))($53737573819ff568$var$Duplex, $i0kUt);
// Allow the keys array to be GC'ed.
var $53737573819ff568$var$keys = $53737573819ff568$var$objectKeys($02VkB.prototype);
for(var $53737573819ff568$var$v = 0; $53737573819ff568$var$v < $53737573819ff568$var$keys.length; $53737573819ff568$var$v++){
    var $53737573819ff568$var$method = $53737573819ff568$var$keys[$53737573819ff568$var$v];
    if (!$53737573819ff568$var$Duplex.prototype[$53737573819ff568$var$method]) $53737573819ff568$var$Duplex.prototype[$53737573819ff568$var$method] = $02VkB.prototype[$53737573819ff568$var$method];
}
function $53737573819ff568$var$Duplex(options) {
    if (!(this instanceof $53737573819ff568$var$Duplex)) return new $53737573819ff568$var$Duplex(options);
    $i0kUt.call(this, options);
    $02VkB.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once('end', $53737573819ff568$var$onend);
        }
    }
}
Object.defineProperty($53737573819ff568$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($53737573819ff568$var$Duplex.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($53737573819ff568$var$Duplex.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $53737573819ff568$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $aVaWD.nextTick($53737573819ff568$var$onEndNT, this);
}
function $53737573819ff568$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($53737573819ff568$var$Duplex.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("02VkB", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $aVaWD = parcelRequire("aVaWD");
'use strict';
module.exports = $008ca8d482a71180$var$Writable;
/* <replacement> */ function $008ca8d482a71180$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $008ca8d482a71180$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $008ca8d482a71180$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $008ca8d482a71180$var$Duplex;
/*</replacement>*/ $008ca8d482a71180$var$Writable.WritableState = $008ca8d482a71180$var$WritableState;

/*<replacement>*/ var $008ca8d482a71180$var$internalUtil = {
    deprecate: (parcelRequire("kI89L"))
};

var $c2Kvz = parcelRequire("c2Kvz");

var $b0qLu = parcelRequire("b0qLu");
var $008ca8d482a71180$require$Buffer = $b0qLu.Buffer;
var $008ca8d482a71180$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $008ca8d482a71180$var$_uint8ArrayToBuffer(chunk) {
    return $008ca8d482a71180$require$Buffer.from(chunk);
}
function $008ca8d482a71180$var$_isUint8Array(obj) {
    return $008ca8d482a71180$require$Buffer.isBuffer(obj) || obj instanceof $008ca8d482a71180$var$OurUint8Array;
}

var $hRXs2 = parcelRequire("hRXs2");

var $6cilr = parcelRequire("6cilr");
var $008ca8d482a71180$var$getHighWaterMark = $6cilr.getHighWaterMark;

var $lEaFc = parcelRequire("lEaFc");
var $008ca8d482a71180$require$_require$codes = $lEaFc.codes;
var $008ca8d482a71180$var$ERR_INVALID_ARG_TYPE = $008ca8d482a71180$require$_require$codes.ERR_INVALID_ARG_TYPE, $008ca8d482a71180$var$ERR_METHOD_NOT_IMPLEMENTED = $008ca8d482a71180$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $008ca8d482a71180$var$ERR_MULTIPLE_CALLBACK = $008ca8d482a71180$require$_require$codes.ERR_MULTIPLE_CALLBACK, $008ca8d482a71180$var$ERR_STREAM_CANNOT_PIPE = $008ca8d482a71180$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $008ca8d482a71180$var$ERR_STREAM_DESTROYED = $008ca8d482a71180$require$_require$codes.ERR_STREAM_DESTROYED, $008ca8d482a71180$var$ERR_STREAM_NULL_VALUES = $008ca8d482a71180$require$_require$codes.ERR_STREAM_NULL_VALUES, $008ca8d482a71180$var$ERR_STREAM_WRITE_AFTER_END = $008ca8d482a71180$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $008ca8d482a71180$var$ERR_UNKNOWN_ENCODING = $008ca8d482a71180$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $008ca8d482a71180$var$errorOrDestroy = $hRXs2.errorOrDestroy;

(parcelRequire("jcXeW"))($008ca8d482a71180$var$Writable, $c2Kvz);
function $008ca8d482a71180$var$nop() {}

function $008ca8d482a71180$var$WritableState(options, stream, isDuplex) {
    $008ca8d482a71180$var$Duplex = $008ca8d482a71180$var$Duplex || (parcelRequire("7acSG"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $008ca8d482a71180$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $008ca8d482a71180$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $008ca8d482a71180$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $008ca8d482a71180$var$CorkedRequest(this);
}
$008ca8d482a71180$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($008ca8d482a71180$var$WritableState.prototype, 'buffer', {
            get: $008ca8d482a71180$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $008ca8d482a71180$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $008ca8d482a71180$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($008ca8d482a71180$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($008ca8d482a71180$var$realHasInstance.call(this, object)) return true;
            if (this !== $008ca8d482a71180$var$Writable) return false;
            return object && object._writableState instanceof $008ca8d482a71180$var$WritableState;
        }
    });
} else $008ca8d482a71180$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $008ca8d482a71180$var$Writable(options) {
    $008ca8d482a71180$var$Duplex = $008ca8d482a71180$var$Duplex || (parcelRequire("7acSG"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $008ca8d482a71180$var$Duplex;
    if (!isDuplex && !$008ca8d482a71180$var$realHasInstance.call($008ca8d482a71180$var$Writable, this)) return new $008ca8d482a71180$var$Writable(options);
    this._writableState = new $008ca8d482a71180$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $c2Kvz.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$008ca8d482a71180$var$Writable.prototype.pipe = function() {
    $008ca8d482a71180$var$errorOrDestroy(this, new $008ca8d482a71180$var$ERR_STREAM_CANNOT_PIPE());
};
function $008ca8d482a71180$var$writeAfterEnd(stream, cb) {
    var er = new $008ca8d482a71180$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $008ca8d482a71180$var$errorOrDestroy(stream, er);
    $aVaWD.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $008ca8d482a71180$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $008ca8d482a71180$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== 'string' && !state.objectMode) er = new $008ca8d482a71180$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer'
    ], chunk);
    if (er) {
        $008ca8d482a71180$var$errorOrDestroy(stream, er);
        $aVaWD.nextTick(cb, er);
        return false;
    }
    return true;
}
$008ca8d482a71180$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $008ca8d482a71180$var$_isUint8Array(chunk);
    if (isBuf && !$008ca8d482a71180$require$Buffer.isBuffer(chunk)) chunk = $008ca8d482a71180$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $008ca8d482a71180$var$nop;
    if (state.ending) $008ca8d482a71180$var$writeAfterEnd(this, cb);
    else if (isBuf || $008ca8d482a71180$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $008ca8d482a71180$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$008ca8d482a71180$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$008ca8d482a71180$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $008ca8d482a71180$var$clearBuffer(this, state);
    }
};
$008ca8d482a71180$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new $008ca8d482a71180$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($008ca8d482a71180$var$Writable.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $008ca8d482a71180$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $008ca8d482a71180$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($008ca8d482a71180$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $008ca8d482a71180$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $008ca8d482a71180$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $008ca8d482a71180$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $008ca8d482a71180$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $008ca8d482a71180$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $008ca8d482a71180$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $aVaWD.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $aVaWD.nextTick($008ca8d482a71180$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $008ca8d482a71180$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $008ca8d482a71180$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $008ca8d482a71180$var$finishMaybe(stream, state);
    }
}
function $008ca8d482a71180$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $008ca8d482a71180$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') throw new $008ca8d482a71180$var$ERR_MULTIPLE_CALLBACK();
    $008ca8d482a71180$var$onwriteStateUpdate(state);
    if (er) $008ca8d482a71180$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $008ca8d482a71180$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $008ca8d482a71180$var$clearBuffer(stream, state);
        if (sync) $aVaWD.nextTick($008ca8d482a71180$var$afterWrite, stream, state, finished, cb);
        else $008ca8d482a71180$var$afterWrite(stream, state, finished, cb);
    }
}
function $008ca8d482a71180$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $008ca8d482a71180$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $008ca8d482a71180$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $008ca8d482a71180$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $008ca8d482a71180$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $008ca8d482a71180$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $008ca8d482a71180$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $008ca8d482a71180$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$008ca8d482a71180$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $008ca8d482a71180$var$ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};
$008ca8d482a71180$var$Writable.prototype._writev = null;
$008ca8d482a71180$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $008ca8d482a71180$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($008ca8d482a71180$var$Writable.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $008ca8d482a71180$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $008ca8d482a71180$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $008ca8d482a71180$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit('prefinish');
        $008ca8d482a71180$var$finishMaybe(stream, state);
    });
}
function $008ca8d482a71180$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $aVaWD.nextTick($008ca8d482a71180$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $008ca8d482a71180$var$finishMaybe(stream, state) {
    var need = $008ca8d482a71180$var$needFinish(state);
    if (need) {
        $008ca8d482a71180$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $008ca8d482a71180$var$endWritable(stream, state, cb) {
    state.ending = true;
    $008ca8d482a71180$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $aVaWD.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $008ca8d482a71180$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($008ca8d482a71180$var$Writable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$008ca8d482a71180$var$Writable.prototype.destroy = $hRXs2.destroy;
$008ca8d482a71180$var$Writable.prototype._undestroy = $hRXs2.undestroy;
$008ca8d482a71180$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});


parcelRegister("bUuLH", function(module, exports) {
$parcel$export(module.exports, "StringDecoder", () => $8abccaa2986ed024$export$63a7aa211a91ed69, (v) => $8abccaa2986ed024$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $8abccaa2986ed024$export$63a7aa211a91ed69;
'use strict';

var $dmAgJ = parcelRequire("dmAgJ");
var $8abccaa2986ed024$require$Buffer = $dmAgJ.Buffer;
/*</replacement>*/ var $8abccaa2986ed024$var$isEncoding = $8abccaa2986ed024$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $8abccaa2986ed024$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $8abccaa2986ed024$var$normalizeEncoding(enc) {
    var nenc = $8abccaa2986ed024$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($8abccaa2986ed024$require$Buffer.isEncoding === $8abccaa2986ed024$var$isEncoding || !$8abccaa2986ed024$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$8abccaa2986ed024$export$63a7aa211a91ed69 = $8abccaa2986ed024$var$StringDecoder;
function $8abccaa2986ed024$var$StringDecoder(encoding) {
    this.encoding = $8abccaa2986ed024$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $8abccaa2986ed024$var$utf16Text;
            this.end = $8abccaa2986ed024$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $8abccaa2986ed024$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $8abccaa2986ed024$var$base64Text;
            this.end = $8abccaa2986ed024$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $8abccaa2986ed024$var$simpleWrite;
            this.end = $8abccaa2986ed024$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $8abccaa2986ed024$require$Buffer.allocUnsafe(nb);
}
$8abccaa2986ed024$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$8abccaa2986ed024$var$StringDecoder.prototype.end = $8abccaa2986ed024$var$utf8End;
// Returns only complete characters in a Buffer
$8abccaa2986ed024$var$StringDecoder.prototype.text = $8abccaa2986ed024$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$8abccaa2986ed024$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $8abccaa2986ed024$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $8abccaa2986ed024$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $8abccaa2986ed024$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $8abccaa2986ed024$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $8abccaa2986ed024$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $8abccaa2986ed024$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $8abccaa2986ed024$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $8abccaa2986ed024$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $8abccaa2986ed024$var$utf8Text(buf, i) {
    var total = $8abccaa2986ed024$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $8abccaa2986ed024$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $8abccaa2986ed024$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $8abccaa2986ed024$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $8abccaa2986ed024$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $8abccaa2986ed024$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $8abccaa2986ed024$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $8abccaa2986ed024$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});

parcelRegister("1OAkB", function(module, exports) {

var $aVaWD = parcelRequire("aVaWD");
'use strict';
var $1526a492bc294572$var$_Object$setPrototypeO;
function $1526a492bc294572$var$_defineProperty(obj, key, value) {
    key = $1526a492bc294572$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1526a492bc294572$var$_toPropertyKey(arg) {
    var key = $1526a492bc294572$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $1526a492bc294572$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $7vn5t = parcelRequire("7vn5t");
var $1526a492bc294572$var$kLastResolve = Symbol('lastResolve');
var $1526a492bc294572$var$kLastReject = Symbol('lastReject');
var $1526a492bc294572$var$kError = Symbol('error');
var $1526a492bc294572$var$kEnded = Symbol('ended');
var $1526a492bc294572$var$kLastPromise = Symbol('lastPromise');
var $1526a492bc294572$var$kHandlePromise = Symbol('handlePromise');
var $1526a492bc294572$var$kStream = Symbol('stream');
function $1526a492bc294572$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $1526a492bc294572$var$readAndResolve(iter) {
    var resolve = iter[$1526a492bc294572$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$1526a492bc294572$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$1526a492bc294572$var$kLastPromise] = null;
            iter[$1526a492bc294572$var$kLastResolve] = null;
            iter[$1526a492bc294572$var$kLastReject] = null;
            resolve($1526a492bc294572$var$createIterResult(data, false));
        }
    }
}
function $1526a492bc294572$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $aVaWD.nextTick($1526a492bc294572$var$readAndResolve, iter);
}
function $1526a492bc294572$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$1526a492bc294572$var$kEnded]) {
                resolve($1526a492bc294572$var$createIterResult(undefined, true));
                return;
            }
            iter[$1526a492bc294572$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $1526a492bc294572$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $1526a492bc294572$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($1526a492bc294572$var$_Object$setPrototypeO = {
    get stream () {
        return this[$1526a492bc294572$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$1526a492bc294572$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$1526a492bc294572$var$kEnded]) return Promise.resolve($1526a492bc294572$var$createIterResult(undefined, true));
        if (this[$1526a492bc294572$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $aVaWD.nextTick(function() {
                if (_this[$1526a492bc294572$var$kError]) reject(_this[$1526a492bc294572$var$kError]);
                else resolve($1526a492bc294572$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$1526a492bc294572$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($1526a492bc294572$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$1526a492bc294572$var$kStream].read();
            if (data !== null) return Promise.resolve($1526a492bc294572$var$createIterResult(data, false));
            promise = new Promise(this[$1526a492bc294572$var$kHandlePromise]);
        }
        this[$1526a492bc294572$var$kLastPromise] = promise;
        return promise;
    }
}, $1526a492bc294572$var$_defineProperty($1526a492bc294572$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $1526a492bc294572$var$_defineProperty($1526a492bc294572$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$1526a492bc294572$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($1526a492bc294572$var$createIterResult(undefined, true));
        });
    });
}), $1526a492bc294572$var$_Object$setPrototypeO), $1526a492bc294572$var$AsyncIteratorPrototype);
var $1526a492bc294572$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($1526a492bc294572$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $1526a492bc294572$var$_defineProperty(_Object$create, $1526a492bc294572$var$kStream, {
        value: stream,
        writable: true
    }), $1526a492bc294572$var$_defineProperty(_Object$create, $1526a492bc294572$var$kLastResolve, {
        value: null,
        writable: true
    }), $1526a492bc294572$var$_defineProperty(_Object$create, $1526a492bc294572$var$kLastReject, {
        value: null,
        writable: true
    }), $1526a492bc294572$var$_defineProperty(_Object$create, $1526a492bc294572$var$kError, {
        value: null,
        writable: true
    }), $1526a492bc294572$var$_defineProperty(_Object$create, $1526a492bc294572$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $1526a492bc294572$var$_defineProperty(_Object$create, $1526a492bc294572$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$1526a492bc294572$var$kStream].read();
            if (data) {
                iterator[$1526a492bc294572$var$kLastPromise] = null;
                iterator[$1526a492bc294572$var$kLastResolve] = null;
                iterator[$1526a492bc294572$var$kLastReject] = null;
                resolve($1526a492bc294572$var$createIterResult(data, false));
            } else {
                iterator[$1526a492bc294572$var$kLastResolve] = resolve;
                iterator[$1526a492bc294572$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$1526a492bc294572$var$kLastPromise] = null;
    $7vn5t(stream, function(err) {
        if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
            var reject = iterator[$1526a492bc294572$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$1526a492bc294572$var$kLastPromise] = null;
                iterator[$1526a492bc294572$var$kLastResolve] = null;
                iterator[$1526a492bc294572$var$kLastReject] = null;
                reject(err);
            }
            iterator[$1526a492bc294572$var$kError] = err;
            return;
        }
        var resolve = iterator[$1526a492bc294572$var$kLastResolve];
        if (resolve !== null) {
            iterator[$1526a492bc294572$var$kLastPromise] = null;
            iterator[$1526a492bc294572$var$kLastResolve] = null;
            iterator[$1526a492bc294572$var$kLastReject] = null;
            resolve($1526a492bc294572$var$createIterResult(undefined, true));
        }
        iterator[$1526a492bc294572$var$kEnded] = true;
    });
    stream.on('readable', $1526a492bc294572$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $1526a492bc294572$var$createReadableStreamAsyncIterator;

});
parcelRegister("7vn5t", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $576d5654e93fa86c$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("lEaFc")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $576d5654e93fa86c$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $576d5654e93fa86c$var$noop() {}
function $576d5654e93fa86c$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
function $576d5654e93fa86c$var$eos(stream, opts, callback) {
    if (typeof opts === 'function') return $576d5654e93fa86c$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $576d5654e93fa86c$var$once(callback || $576d5654e93fa86c$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $576d5654e93fa86c$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $576d5654e93fa86c$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on('finish', onfinish);
    };
    if ($576d5654e93fa86c$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (opts.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    return function() {
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
}
module.exports = $576d5654e93fa86c$var$eos;

});


parcelRegister("hxvZM", function(module, exports) {
module.exports = function() {
    throw new Error('Readable.from is not available in the browser');
};

});


parcelRegister("2IDOh", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $1fae9249baff5bf2$var$Transform;

var $lEaFc = parcelRequire("lEaFc");
var $1fae9249baff5bf2$require$_require$codes = $lEaFc.codes;
var $1fae9249baff5bf2$var$ERR_METHOD_NOT_IMPLEMENTED = $1fae9249baff5bf2$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $1fae9249baff5bf2$var$ERR_MULTIPLE_CALLBACK = $1fae9249baff5bf2$require$_require$codes.ERR_MULTIPLE_CALLBACK, $1fae9249baff5bf2$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $1fae9249baff5bf2$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $1fae9249baff5bf2$var$ERR_TRANSFORM_WITH_LENGTH_0 = $1fae9249baff5bf2$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $7acSG = parcelRequire("7acSG");

(parcelRequire("jcXeW"))($1fae9249baff5bf2$var$Transform, $7acSG);
function $1fae9249baff5bf2$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit('error', new $1fae9249baff5bf2$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $1fae9249baff5bf2$var$Transform(options) {
    if (!(this instanceof $1fae9249baff5bf2$var$Transform)) return new $1fae9249baff5bf2$var$Transform(options);
    $7acSG.call(this, options);
    this._transformState = {
        afterTransform: $1fae9249baff5bf2$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $1fae9249baff5bf2$var$prefinish);
}
function $1fae9249baff5bf2$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function' && !this._readableState.destroyed) this._flush(function(er, data) {
        $1fae9249baff5bf2$var$done(_this, er, data);
    });
    else $1fae9249baff5bf2$var$done(this, null, null);
}
$1fae9249baff5bf2$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $7acSG.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$1fae9249baff5bf2$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $1fae9249baff5bf2$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};
$1fae9249baff5bf2$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$1fae9249baff5bf2$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$1fae9249baff5bf2$var$Transform.prototype._destroy = function(err, cb) {
    $7acSG.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $1fae9249baff5bf2$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $1fae9249baff5bf2$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $1fae9249baff5bf2$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("gVC8t", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $032e2fb2495f4980$var$PassThrough;

var $2IDOh = parcelRequire("2IDOh");

(parcelRequire("jcXeW"))($032e2fb2495f4980$var$PassThrough, $2IDOh);
function $032e2fb2495f4980$var$PassThrough(options) {
    if (!(this instanceof $032e2fb2495f4980$var$PassThrough)) return new $032e2fb2495f4980$var$PassThrough(options);
    $2IDOh.call(this, options);
}
$032e2fb2495f4980$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("k9xhG", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';
var $eabe7772f2c0a28d$var$eos;
function $eabe7772f2c0a28d$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $lEaFc = parcelRequire("lEaFc");
var $eabe7772f2c0a28d$require$_require$codes = $lEaFc.codes;
var $eabe7772f2c0a28d$var$ERR_MISSING_ARGS = $eabe7772f2c0a28d$require$_require$codes.ERR_MISSING_ARGS, $eabe7772f2c0a28d$var$ERR_STREAM_DESTROYED = $eabe7772f2c0a28d$require$_require$codes.ERR_STREAM_DESTROYED;
function $eabe7772f2c0a28d$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $eabe7772f2c0a28d$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}

function $eabe7772f2c0a28d$var$destroyer(stream, reading, writing, callback) {
    callback = $eabe7772f2c0a28d$var$once(callback);
    var closed = false;
    stream.on('close', function() {
        closed = true;
    });
    if ($eabe7772f2c0a28d$var$eos === undefined) $eabe7772f2c0a28d$var$eos = (parcelRequire("7vn5t"));
    $eabe7772f2c0a28d$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($eabe7772f2c0a28d$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === 'function') return stream.destroy();
        callback(err || new $eabe7772f2c0a28d$var$ERR_STREAM_DESTROYED('pipe'));
    };
}
function $eabe7772f2c0a28d$var$call(fn) {
    fn();
}
function $eabe7772f2c0a28d$var$pipe(from, to) {
    return from.pipe(to);
}
function $eabe7772f2c0a28d$var$popCallback(streams) {
    if (!streams.length) return $eabe7772f2c0a28d$var$noop;
    if (typeof streams[streams.length - 1] !== 'function') return $eabe7772f2c0a28d$var$noop;
    return streams.pop();
}
function $eabe7772f2c0a28d$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $eabe7772f2c0a28d$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $eabe7772f2c0a28d$var$ERR_MISSING_ARGS('streams');
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $eabe7772f2c0a28d$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($eabe7772f2c0a28d$var$call);
            if (reading) return;
            destroys.forEach($eabe7772f2c0a28d$var$call);
            callback(error);
        });
    });
    return streams.reduce($eabe7772f2c0a28d$var$pipe);
}
module.exports = $eabe7772f2c0a28d$var$pipeline;

});




parcelRegister("iyMeE", function(module, exports) {
'use strict';

var $jcXeW = parcelRequire("jcXeW");

var $lbMRQ = parcelRequire("lbMRQ");

var $h4bOS = parcelRequire("h4bOS");

var $dmAgJ = parcelRequire("dmAgJ");
var $d830d1833fcd6f14$require$Buffer = $dmAgJ.Buffer;

var $hGErU = parcelRequire("hGErU");

var $43hsM = parcelRequire("43hsM");

var $fnOyZ = parcelRequire("fnOyZ");
var $d830d1833fcd6f14$var$ZEROS = $d830d1833fcd6f14$require$Buffer.alloc(128);
function $d830d1833fcd6f14$var$Hmac(alg, key) {
    $h4bOS.call(this, 'digest');
    if (typeof key === 'string') key = $d830d1833fcd6f14$require$Buffer.from(key);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    this._alg = alg;
    this._key = key;
    if (key.length > blocksize) {
        var hash = alg === 'rmd160' ? new $43hsM() : $fnOyZ(alg);
        key = hash.update(key).digest();
    } else if (key.length < blocksize) key = $d830d1833fcd6f14$require$Buffer.concat([
        key,
        $d830d1833fcd6f14$var$ZEROS
    ], blocksize);
    var ipad = this._ipad = $d830d1833fcd6f14$require$Buffer.allocUnsafe(blocksize);
    var opad = this._opad = $d830d1833fcd6f14$require$Buffer.allocUnsafe(blocksize);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = alg === 'rmd160' ? new $43hsM() : $fnOyZ(alg);
    this._hash.update(ipad);
}
$jcXeW($d830d1833fcd6f14$var$Hmac, $h4bOS);
$d830d1833fcd6f14$var$Hmac.prototype._update = function(data) {
    this._hash.update(data);
};
$d830d1833fcd6f14$var$Hmac.prototype._final = function() {
    var h = this._hash.digest();
    var hash = this._alg === 'rmd160' ? new $43hsM() : $fnOyZ(this._alg);
    return hash.update(this._opad).update(h).digest();
};
module.exports = function createHmac(alg, key) {
    alg = alg.toLowerCase();
    if (alg === 'rmd160' || alg === 'ripemd160') return new $d830d1833fcd6f14$var$Hmac('rmd160', key);
    if (alg === 'md5') return new $lbMRQ($hGErU, key);
    return new $d830d1833fcd6f14$var$Hmac(alg, key);
};

});
parcelRegister("lbMRQ", function(module, exports) {
'use strict';

var $jcXeW = parcelRequire("jcXeW");

var $dmAgJ = parcelRequire("dmAgJ");
var $f6d088219bd3aa3d$require$Buffer = $dmAgJ.Buffer;

var $h4bOS = parcelRequire("h4bOS");
var $f6d088219bd3aa3d$var$ZEROS = $f6d088219bd3aa3d$require$Buffer.alloc(128);
var $f6d088219bd3aa3d$var$blocksize = 64;
function $f6d088219bd3aa3d$var$Hmac(alg, key) {
    $h4bOS.call(this, 'digest');
    if (typeof key === 'string') key = $f6d088219bd3aa3d$require$Buffer.from(key);
    this._alg = alg;
    this._key = key;
    if (key.length > $f6d088219bd3aa3d$var$blocksize) key = alg(key);
    else if (key.length < $f6d088219bd3aa3d$var$blocksize) key = $f6d088219bd3aa3d$require$Buffer.concat([
        key,
        $f6d088219bd3aa3d$var$ZEROS
    ], $f6d088219bd3aa3d$var$blocksize);
    var ipad = this._ipad = $f6d088219bd3aa3d$require$Buffer.allocUnsafe($f6d088219bd3aa3d$var$blocksize);
    var opad = this._opad = $f6d088219bd3aa3d$require$Buffer.allocUnsafe($f6d088219bd3aa3d$var$blocksize);
    for(var i = 0; i < $f6d088219bd3aa3d$var$blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = [
        ipad
    ];
}
$jcXeW($f6d088219bd3aa3d$var$Hmac, $h4bOS);
$f6d088219bd3aa3d$var$Hmac.prototype._update = function(data) {
    this._hash.push(data);
};
$f6d088219bd3aa3d$var$Hmac.prototype._final = function() {
    var h = this._alg($f6d088219bd3aa3d$require$Buffer.concat(this._hash));
    return this._alg($f6d088219bd3aa3d$require$Buffer.concat([
        this._opad,
        h
    ]));
};
module.exports = $f6d088219bd3aa3d$var$Hmac;

});

parcelRegister("hGErU", function(module, exports) {

var $ia0OJ = parcelRequire("ia0OJ");
module.exports = function(buffer) {
    return new $ia0OJ().update(buffer).digest();
};

});


parcelRegister("lisa3", function(module, exports) {
module.exports = JSON.parse("{\"sha224WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"RSA-SHA224\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"sha256WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"RSA-SHA256\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"sha384WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"RSA-SHA384\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"sha512WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA512\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA1\":{\"sign\":\"rsa\",\"hash\":\"sha1\",\"id\":\"3021300906052b0e03021a05000414\"},\"ecdsa-with-SHA1\":{\"sign\":\"ecdsa\",\"hash\":\"sha1\",\"id\":\"\"},\"sha256\":{\"sign\":\"ecdsa\",\"hash\":\"sha256\",\"id\":\"\"},\"sha224\":{\"sign\":\"ecdsa\",\"hash\":\"sha224\",\"id\":\"\"},\"sha384\":{\"sign\":\"ecdsa\",\"hash\":\"sha384\",\"id\":\"\"},\"sha512\":{\"sign\":\"ecdsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-SHA1\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-WITH-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-WITH-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-WITH-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-WITH-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-RIPEMD160\":{\"sign\":\"dsa\",\"hash\":\"rmd160\",\"id\":\"\"},\"ripemd160WithRSA\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"RSA-RIPEMD160\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"md5WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"},\"RSA-MD5\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"}}");

});

parcelRegister("fNsfU", function(module, exports) {
'use strict';

var $dmAgJ = parcelRequire("dmAgJ");
var $b8015999bb301fb9$require$Buffer = $dmAgJ.Buffer;

var $gXmAM = parcelRequire("gXmAM");

var $byoLS = parcelRequire("byoLS");

var $hXHsd = parcelRequire("hXHsd");

var $evwPB = parcelRequire("evwPB");
var $b8015999bb301fb9$var$ZERO_BUF;
var $b8015999bb301fb9$var$subtle = $parcel$global.crypto && $parcel$global.crypto.subtle;
var $b8015999bb301fb9$var$toBrowser = {
    sha: 'SHA-1',
    'sha-1': 'SHA-1',
    sha1: 'SHA-1',
    sha256: 'SHA-256',
    'sha-256': 'SHA-256',
    sha384: 'SHA-384',
    'sha-384': 'SHA-384',
    'sha-512': 'SHA-512',
    sha512: 'SHA-512'
};
var $b8015999bb301fb9$var$checks = [];
var $b8015999bb301fb9$var$nextTick;
function $b8015999bb301fb9$var$getNextTick() {
    if ($b8015999bb301fb9$var$nextTick) return $b8015999bb301fb9$var$nextTick;
    if ($parcel$global.process && $parcel$global.process.nextTick) $b8015999bb301fb9$var$nextTick = $parcel$global.process.nextTick;
    else if ($parcel$global.queueMicrotask) $b8015999bb301fb9$var$nextTick = $parcel$global.queueMicrotask;
    else if ($parcel$global.setImmediate) $b8015999bb301fb9$var$nextTick = $parcel$global.setImmediate;
    else $b8015999bb301fb9$var$nextTick = $parcel$global.setTimeout;
    return $b8015999bb301fb9$var$nextTick;
}
function $b8015999bb301fb9$var$browserPbkdf2(password, salt, iterations, length, algo) {
    return $b8015999bb301fb9$var$subtle.importKey('raw', password, {
        name: 'PBKDF2'
    }, false, [
        'deriveBits'
    ]).then(function(key) {
        return $b8015999bb301fb9$var$subtle.deriveBits({
            name: 'PBKDF2',
            salt: salt,
            iterations: iterations,
            hash: {
                name: algo
            }
        }, key, length << 3);
    }).then(function(res) {
        return $b8015999bb301fb9$require$Buffer.from(res);
    });
}
function $b8015999bb301fb9$var$checkNative(algo) {
    if ($parcel$global.process && !$parcel$global.process.browser) return Promise.resolve(false);
    if (!$b8015999bb301fb9$var$subtle || !$b8015999bb301fb9$var$subtle.importKey || !$b8015999bb301fb9$var$subtle.deriveBits) return Promise.resolve(false);
    if ($b8015999bb301fb9$var$checks[algo] !== undefined) return $b8015999bb301fb9$var$checks[algo];
    $b8015999bb301fb9$var$ZERO_BUF = $b8015999bb301fb9$var$ZERO_BUF || $b8015999bb301fb9$require$Buffer.alloc(8);
    var prom = $b8015999bb301fb9$var$browserPbkdf2($b8015999bb301fb9$var$ZERO_BUF, $b8015999bb301fb9$var$ZERO_BUF, 10, 128, algo).then(function() {
        return true;
    }, function() {
        return false;
    });
    $b8015999bb301fb9$var$checks[algo] = prom;
    return prom;
}
function $b8015999bb301fb9$var$resolvePromise(promise, callback) {
    promise.then(function(out) {
        $b8015999bb301fb9$var$getNextTick()(function() {
            callback(null, out);
        });
    }, function(e) {
        $b8015999bb301fb9$var$getNextTick()(function() {
            callback(e);
        });
    });
}
module.exports = function(password, salt, iterations, keylen, digest, callback) {
    if (typeof digest === 'function') {
        callback = digest;
        digest = undefined;
    }
    $gXmAM(iterations, keylen);
    password = $evwPB(password, $byoLS, 'Password');
    salt = $evwPB(salt, $byoLS, 'Salt');
    if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2');
    digest = digest || 'sha1';
    var algo = $b8015999bb301fb9$var$toBrowser[digest.toLowerCase()];
    if (!algo || typeof $parcel$global.Promise !== 'function') {
        $b8015999bb301fb9$var$getNextTick()(function() {
            var out;
            try {
                out = $hXHsd(password, salt, iterations, keylen, digest);
            } catch (e) {
                callback(e);
                return;
            }
            callback(null, out);
        });
        return;
    }
    $b8015999bb301fb9$var$resolvePromise($b8015999bb301fb9$var$checkNative(algo).then(function(resp) {
        if (resp) return $b8015999bb301fb9$var$browserPbkdf2(password, salt, iterations, keylen, algo);
        return $hXHsd(password, salt, iterations, keylen, digest);
    }), callback);
};

});
parcelRegister("gXmAM", function(module, exports) {
'use strict';
var $c583ae618c8a9f1b$var$$isFinite = isFinite;
var $c583ae618c8a9f1b$var$MAX_ALLOC = Math.pow(2, 30) - 1; // default in iojs
module.exports = function(iterations, keylen) {
    if (typeof iterations !== 'number') throw new TypeError('Iterations not a number');
    if (iterations < 0 || !$c583ae618c8a9f1b$var$$isFinite(iterations)) throw new TypeError('Bad iterations');
    if (typeof keylen !== 'number') throw new TypeError('Key length not a number');
    if (keylen < 0 || keylen > $c583ae618c8a9f1b$var$MAX_ALLOC || keylen !== keylen) throw new TypeError('Bad key length');
};

});

parcelRegister("byoLS", function(module, exports) {

var $aVaWD = parcelRequire("aVaWD");
'use strict';
var $869615ba92ca04ea$var$defaultEncoding;
/* istanbul ignore next */ if ($parcel$global.process && $parcel$global.process.browser) $869615ba92ca04ea$var$defaultEncoding = 'utf-8';
else if ($parcel$global.process && $parcel$global.process.version) {
    var $869615ba92ca04ea$var$pVersionMajor = parseInt($aVaWD.version.split('.')[0].slice(1), 10);
    $869615ba92ca04ea$var$defaultEncoding = $869615ba92ca04ea$var$pVersionMajor >= 6 ? 'utf-8' : 'binary';
} else $869615ba92ca04ea$var$defaultEncoding = 'utf-8';
module.exports = $869615ba92ca04ea$var$defaultEncoding;

});

parcelRegister("hXHsd", function(module, exports) {
'use strict';

var $hGErU = parcelRequire("hGErU");

var $43hsM = parcelRequire("43hsM");

var $fnOyZ = parcelRequire("fnOyZ");

var $dmAgJ = parcelRequire("dmAgJ");
var $d139a76c0f33caa4$require$Buffer = $dmAgJ.Buffer;

var $gXmAM = parcelRequire("gXmAM");

var $byoLS = parcelRequire("byoLS");

var $evwPB = parcelRequire("evwPB");
var $d139a76c0f33caa4$var$ZEROS = $d139a76c0f33caa4$require$Buffer.alloc(128);
var $d139a76c0f33caa4$var$sizes = {
    __proto__: null,
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    'sha512-256': 32,
    ripemd160: 20,
    rmd160: 20
};
var $d139a76c0f33caa4$var$mapping = {
    __proto__: null,
    'sha-1': 'sha1',
    'sha-224': 'sha224',
    'sha-256': 'sha256',
    'sha-384': 'sha384',
    'sha-512': 'sha512',
    'ripemd-160': 'ripemd160'
};
function $d139a76c0f33caa4$var$rmd160Func(data) {
    return new $43hsM().update(data).digest();
}
function $d139a76c0f33caa4$var$getDigest(alg) {
    function shaFunc(data) {
        return $fnOyZ(alg).update(data).digest();
    }
    if (alg === 'rmd160' || alg === 'ripemd160') return $d139a76c0f33caa4$var$rmd160Func;
    if (alg === 'md5') return $hGErU;
    return shaFunc;
}
function $d139a76c0f33caa4$var$Hmac(alg, key, saltLen) {
    var hash = $d139a76c0f33caa4$var$getDigest(alg);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    if (key.length > blocksize) key = hash(key);
    else if (key.length < blocksize) key = $d139a76c0f33caa4$require$Buffer.concat([
        key,
        $d139a76c0f33caa4$var$ZEROS
    ], blocksize);
    var ipad = $d139a76c0f33caa4$require$Buffer.allocUnsafe(blocksize + $d139a76c0f33caa4$var$sizes[alg]);
    var opad = $d139a76c0f33caa4$require$Buffer.allocUnsafe(blocksize + $d139a76c0f33caa4$var$sizes[alg]);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    var ipad1 = $d139a76c0f33caa4$require$Buffer.allocUnsafe(blocksize + saltLen + 4);
    ipad.copy(ipad1, 0, 0, blocksize);
    this.ipad1 = ipad1;
    this.ipad2 = ipad;
    this.opad = opad;
    this.alg = alg;
    this.blocksize = blocksize;
    this.hash = hash;
    this.size = $d139a76c0f33caa4$var$sizes[alg];
}
$d139a76c0f33caa4$var$Hmac.prototype.run = function(data, ipad) {
    data.copy(ipad, this.blocksize);
    var h = this.hash(ipad);
    h.copy(this.opad, this.blocksize);
    return this.hash(this.opad);
};
function $d139a76c0f33caa4$var$pbkdf2(password, salt, iterations, keylen, digest) {
    $gXmAM(iterations, keylen);
    password = $evwPB(password, $byoLS, 'Password');
    salt = $evwPB(salt, $byoLS, 'Salt');
    var lowerDigest = (digest || 'sha1').toLowerCase();
    var mappedDigest = $d139a76c0f33caa4$var$mapping[lowerDigest] || lowerDigest;
    var size = $d139a76c0f33caa4$var$sizes[mappedDigest];
    if (typeof size !== 'number' || !size) throw new TypeError('Digest algorithm not supported: ' + digest);
    var hmac = new $d139a76c0f33caa4$var$Hmac(mappedDigest, password, salt.length);
    var DK = $d139a76c0f33caa4$require$Buffer.allocUnsafe(keylen);
    var block1 = $d139a76c0f33caa4$require$Buffer.allocUnsafe(salt.length + 4);
    salt.copy(block1, 0, 0, salt.length);
    var destPos = 0;
    var hLen = size;
    var l = Math.ceil(keylen / hLen);
    for(var i = 1; i <= l; i++){
        block1.writeUInt32BE(i, salt.length);
        var T = hmac.run(block1, hmac.ipad1);
        var U = T;
        for(var j = 1; j < iterations; j++){
            U = hmac.run(U, hmac.ipad2);
            for(var k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        T.copy(DK, destPos);
        destPos += hLen;
    }
    return DK;
}
module.exports = $d139a76c0f33caa4$var$pbkdf2;

});
parcelRegister("evwPB", function(module, exports) {
'use strict';

var $dmAgJ = parcelRequire("dmAgJ");
var $a8fd6d8c60e906a9$require$Buffer = $dmAgJ.Buffer;

var $dXhxR = parcelRequire("dXhxR");
var $a8fd6d8c60e906a9$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $a8fd6d8c60e906a9$var$useArrayBuffer = $a8fd6d8c60e906a9$var$useUint8Array && typeof ArrayBuffer !== 'undefined';
var $a8fd6d8c60e906a9$var$isView = $a8fd6d8c60e906a9$var$useArrayBuffer && ArrayBuffer.isView;
module.exports = function(thing, encoding, name) {
    if (typeof thing === 'string' || $a8fd6d8c60e906a9$require$Buffer.isBuffer(thing) || $a8fd6d8c60e906a9$var$useUint8Array && thing instanceof Uint8Array || $a8fd6d8c60e906a9$var$isView && $a8fd6d8c60e906a9$var$isView(thing)) return $dXhxR(thing, encoding);
    throw new TypeError(name + ' must be a string, a Buffer, a Uint8Array, or a DataView');
};

});



parcelRegister("aSNbB", function(module, exports) {
$parcel$export(module.exports, "readUInt32BE", () => $7ec519d8e957b376$export$cfaef8ed399428b0, (v) => $7ec519d8e957b376$export$cfaef8ed399428b0 = v);
$parcel$export(module.exports, "writeUInt32BE", () => $7ec519d8e957b376$export$a80c7deaea7cbd80, (v) => $7ec519d8e957b376$export$a80c7deaea7cbd80 = v);
$parcel$export(module.exports, "ip", () => $7ec519d8e957b376$export$ed7577ae6e1cd0ef, (v) => $7ec519d8e957b376$export$ed7577ae6e1cd0ef = v);
$parcel$export(module.exports, "rip", () => $7ec519d8e957b376$export$5dcbef3aa594f567, (v) => $7ec519d8e957b376$export$5dcbef3aa594f567 = v);
$parcel$export(module.exports, "pc1", () => $7ec519d8e957b376$export$5bc8001ca71ed9c5, (v) => $7ec519d8e957b376$export$5bc8001ca71ed9c5 = v);
$parcel$export(module.exports, "r28shl", () => $7ec519d8e957b376$export$3e714e2c5d5d8cb2, (v) => $7ec519d8e957b376$export$3e714e2c5d5d8cb2 = v);
$parcel$export(module.exports, "pc2", () => $7ec519d8e957b376$export$94c3e544fd062b7f, (v) => $7ec519d8e957b376$export$94c3e544fd062b7f = v);
$parcel$export(module.exports, "expand", () => $7ec519d8e957b376$export$9f77e0932fb78f72, (v) => $7ec519d8e957b376$export$9f77e0932fb78f72 = v);
$parcel$export(module.exports, "substitute", () => $7ec519d8e957b376$export$d865ce2836f5927f, (v) => $7ec519d8e957b376$export$d865ce2836f5927f = v);
$parcel$export(module.exports, "permute", () => $7ec519d8e957b376$export$95e62ad65da8b7d2, (v) => $7ec519d8e957b376$export$95e62ad65da8b7d2 = v);
$parcel$export(module.exports, "padSplit", () => $7ec519d8e957b376$export$209139ff098c441a, (v) => $7ec519d8e957b376$export$209139ff098c441a = v);
var $7ec519d8e957b376$export$cfaef8ed399428b0;
var $7ec519d8e957b376$export$a80c7deaea7cbd80;
var $7ec519d8e957b376$export$ed7577ae6e1cd0ef;
var $7ec519d8e957b376$export$5dcbef3aa594f567;
var $7ec519d8e957b376$export$5bc8001ca71ed9c5;
var $7ec519d8e957b376$export$3e714e2c5d5d8cb2;
var $7ec519d8e957b376$export$94c3e544fd062b7f;
var $7ec519d8e957b376$export$9f77e0932fb78f72;
var $7ec519d8e957b376$export$d865ce2836f5927f;
var $7ec519d8e957b376$export$95e62ad65da8b7d2;
var $7ec519d8e957b376$export$209139ff098c441a;
'use strict';
$7ec519d8e957b376$export$cfaef8ed399428b0 = function readUInt32BE(bytes, off) {
    var res = bytes[0 + off] << 24 | bytes[1 + off] << 16 | bytes[2 + off] << 8 | bytes[3 + off];
    return res >>> 0;
};
$7ec519d8e957b376$export$a80c7deaea7cbd80 = function writeUInt32BE(bytes, value, off) {
    bytes[0 + off] = value >>> 24;
    bytes[1 + off] = value >>> 16 & 0xff;
    bytes[2 + off] = value >>> 8 & 0xff;
    bytes[3 + off] = value & 0xff;
};
$7ec519d8e957b376$export$ed7577ae6e1cd0ef = function ip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >>> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >>> j + i & 1;
        }
    }
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inR >>> j + i & 1;
        }
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inL >>> j + i & 1;
        }
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$7ec519d8e957b376$export$5dcbef3aa594f567 = function rip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 0; i < 4; i++)for(var j = 24; j >= 0; j -= 8){
        outL <<= 1;
        outL |= inR >>> j + i & 1;
        outL <<= 1;
        outL |= inL >>> j + i & 1;
    }
    for(var i = 4; i < 8; i++)for(var j = 24; j >= 0; j -= 8){
        outR <<= 1;
        outR |= inR >>> j + i & 1;
        outR <<= 1;
        outR |= inL >>> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$7ec519d8e957b376$export$5bc8001ca71ed9c5 = function pc1(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    // 7, 15, 23, 31, 39, 47, 55, 63
    // 6, 14, 22, 30, 39, 47, 55, 63
    // 5, 13, 21, 29, 39, 47, 55, 63
    // 4, 12, 20, 28
    for(var i = 7; i >= 5; i--){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outL <<= 1;
        outL |= inR >> j + i & 1;
    }
    // 1, 9, 17, 25, 33, 41, 49, 57
    // 2, 10, 18, 26, 34, 42, 50, 58
    // 3, 11, 19, 27, 35, 43, 51, 59
    // 36, 44, 52, 60
    for(var i = 1; i <= 3; i++){
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outR <<= 1;
        outR |= inL >> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$7ec519d8e957b376$export$3e714e2c5d5d8cb2 = function r28shl(num, shift) {
    return num << shift & 0xfffffff | num >>> 28 - shift;
};
var $7ec519d8e957b376$var$pc2table = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
];
$7ec519d8e957b376$export$94c3e544fd062b7f = function pc2(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    var len = $7ec519d8e957b376$var$pc2table.length >>> 1;
    for(var i = 0; i < len; i++){
        outL <<= 1;
        outL |= inL >>> $7ec519d8e957b376$var$pc2table[i] & 0x1;
    }
    for(var i = len; i < $7ec519d8e957b376$var$pc2table.length; i++){
        outR <<= 1;
        outR |= inR >>> $7ec519d8e957b376$var$pc2table[i] & 0x1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$7ec519d8e957b376$export$9f77e0932fb78f72 = function expand(r, out, off) {
    var outL = 0;
    var outR = 0;
    outL = (r & 1) << 5 | r >>> 27;
    for(var i = 23; i >= 15; i -= 4){
        outL <<= 6;
        outL |= r >>> i & 0x3f;
    }
    for(var i = 11; i >= 3; i -= 4){
        outR |= r >>> i & 0x3f;
        outR <<= 6;
    }
    outR |= (r & 0x1f) << 1 | r >>> 31;
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
var $7ec519d8e957b376$var$sTable = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
];
$7ec519d8e957b376$export$d865ce2836f5927f = function substitute(inL, inR) {
    var out = 0;
    for(var i = 0; i < 4; i++){
        var b = inL >>> 18 - i * 6 & 0x3f;
        var sb = $7ec519d8e957b376$var$sTable[i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    for(var i = 0; i < 4; i++){
        var b = inR >>> 18 - i * 6 & 0x3f;
        var sb = $7ec519d8e957b376$var$sTable[256 + i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    return out >>> 0;
};
var $7ec519d8e957b376$var$permuteTable = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
];
$7ec519d8e957b376$export$95e62ad65da8b7d2 = function permute(num) {
    var out = 0;
    for(var i = 0; i < $7ec519d8e957b376$var$permuteTable.length; i++){
        out <<= 1;
        out |= num >>> $7ec519d8e957b376$var$permuteTable[i] & 0x1;
    }
    return out >>> 0;
};
$7ec519d8e957b376$export$209139ff098c441a = function padSplit(num, size, group) {
    var str = num.toString(2);
    while(str.length < size)str = '0' + str;
    var out = [];
    for(var i = 0; i < size; i += group)out.push(str.slice(i, i + group));
    return out.join(' ');
};

});

parcelRegister("jmHeI", function(module, exports) {
'use strict';

var $hILGj = parcelRequire("hILGj");
function $e1919c3740dd494b$var$Cipher(options) {
    this.options = options;
    this.type = this.options.type;
    this.blockSize = 8;
    this._init();
    this.buffer = new Array(this.blockSize);
    this.bufferOff = 0;
    this.padding = options.padding !== false;
}
module.exports = $e1919c3740dd494b$var$Cipher;
$e1919c3740dd494b$var$Cipher.prototype._init = function _init() {
// Might be overrided
};
$e1919c3740dd494b$var$Cipher.prototype.update = function update(data) {
    if (data.length === 0) return [];
    if (this.type === 'decrypt') return this._updateDecrypt(data);
    else return this._updateEncrypt(data);
};
$e1919c3740dd494b$var$Cipher.prototype._buffer = function _buffer(data, off) {
    // Append data to buffer
    var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
    for(var i = 0; i < min; i++)this.buffer[this.bufferOff + i] = data[off + i];
    this.bufferOff += min;
    // Shift next
    return min;
};
$e1919c3740dd494b$var$Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
    this._update(this.buffer, 0, out, off);
    this.bufferOff = 0;
    return this.blockSize;
};
$e1919c3740dd494b$var$Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = (this.bufferOff + data.length) / this.blockSize | 0;
    var out = new Array(count * this.blockSize);
    if (this.bufferOff !== 0) {
        inputOff += this._buffer(data, inputOff);
        if (this.bufferOff === this.buffer.length) outputOff += this._flushBuffer(out, outputOff);
    }
    // Write blocks
    var max = data.length - (data.length - inputOff) % this.blockSize;
    for(; inputOff < max; inputOff += this.blockSize){
        this._update(data, inputOff, out, outputOff);
        outputOff += this.blockSize;
    }
    // Queue rest
    for(; inputOff < data.length; inputOff++, this.bufferOff++)this.buffer[this.bufferOff] = data[inputOff];
    return out;
};
$e1919c3740dd494b$var$Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
    var out = new Array(count * this.blockSize);
    // TODO(indutny): optimize it, this is far from optimal
    for(; count > 0; count--){
        inputOff += this._buffer(data, inputOff);
        outputOff += this._flushBuffer(out, outputOff);
    }
    // Buffer rest of the input
    inputOff += this._buffer(data, inputOff);
    return out;
};
$e1919c3740dd494b$var$Cipher.prototype.final = function final(buffer) {
    var first;
    if (buffer) first = this.update(buffer);
    var last;
    if (this.type === 'encrypt') last = this._finalEncrypt();
    else last = this._finalDecrypt();
    if (first) return first.concat(last);
    else return last;
};
$e1919c3740dd494b$var$Cipher.prototype._pad = function _pad(buffer, off) {
    if (off === 0) return false;
    while(off < buffer.length)buffer[off++] = 0;
    return true;
};
$e1919c3740dd494b$var$Cipher.prototype._finalEncrypt = function _finalEncrypt() {
    if (!this._pad(this.buffer, this.bufferOff)) return [];
    var out = new Array(this.blockSize);
    this._update(this.buffer, 0, out, 0);
    return out;
};
$e1919c3740dd494b$var$Cipher.prototype._unpad = function _unpad(buffer) {
    return buffer;
};
$e1919c3740dd494b$var$Cipher.prototype._finalDecrypt = function _finalDecrypt() {
    $hILGj.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
    var out = new Array(this.blockSize);
    this._flushBuffer(out, 0);
    return this._unpad(out);
};

});
parcelRegister("hILGj", function(module, exports) {
module.exports = $ce6b884828f918cc$var$assert;
function $ce6b884828f918cc$var$assert(val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
}
$ce6b884828f918cc$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || 'Assertion failed: ' + l + ' != ' + r);
};

});


parcelRegister("a7xg7", function(module, exports) {
'use strict';

var $hILGj = parcelRequire("hILGj");

var $jcXeW = parcelRequire("jcXeW");

var $aSNbB = parcelRequire("aSNbB");

var $jmHeI = parcelRequire("jmHeI");
function $75e45b5f4acf8dd4$var$DESState() {
    this.tmp = new Array(2);
    this.keys = null;
}
function $75e45b5f4acf8dd4$var$DES(options) {
    $jmHeI.call(this, options);
    var state = new $75e45b5f4acf8dd4$var$DESState();
    this._desState = state;
    this.deriveKeys(state, options.key);
}
$jcXeW($75e45b5f4acf8dd4$var$DES, $jmHeI);
module.exports = $75e45b5f4acf8dd4$var$DES;
$75e45b5f4acf8dd4$var$DES.create = function create(options) {
    return new $75e45b5f4acf8dd4$var$DES(options);
};
var $75e45b5f4acf8dd4$var$shiftTable = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
];
$75e45b5f4acf8dd4$var$DES.prototype.deriveKeys = function deriveKeys(state, key) {
    state.keys = new Array(32);
    $hILGj.equal(key.length, this.blockSize, 'Invalid key length');
    var kL = $aSNbB.readUInt32BE(key, 0);
    var kR = $aSNbB.readUInt32BE(key, 4);
    $aSNbB.pc1(kL, kR, state.tmp, 0);
    kL = state.tmp[0];
    kR = state.tmp[1];
    for(var i = 0; i < state.keys.length; i += 2){
        var shift = $75e45b5f4acf8dd4$var$shiftTable[i >>> 1];
        kL = $aSNbB.r28shl(kL, shift);
        kR = $aSNbB.r28shl(kR, shift);
        $aSNbB.pc2(kL, kR, state.keys, i);
    }
};
$75e45b5f4acf8dd4$var$DES.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._desState;
    var l = $aSNbB.readUInt32BE(inp, inOff);
    var r = $aSNbB.readUInt32BE(inp, inOff + 4);
    // Initial Permutation
    $aSNbB.ip(l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    if (this.type === 'encrypt') this._encrypt(state, l, r, state.tmp, 0);
    else this._decrypt(state, l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    $aSNbB.writeUInt32BE(out, l, outOff);
    $aSNbB.writeUInt32BE(out, r, outOff + 4);
};
$75e45b5f4acf8dd4$var$DES.prototype._pad = function _pad(buffer, off) {
    if (this.padding === false) return false;
    var value = buffer.length - off;
    for(var i = off; i < buffer.length; i++)buffer[i] = value;
    return true;
};
$75e45b5f4acf8dd4$var$DES.prototype._unpad = function _unpad(buffer) {
    if (this.padding === false) return buffer;
    var pad = buffer[buffer.length - 1];
    for(var i = buffer.length - pad; i < buffer.length; i++)$hILGj.equal(buffer[i], pad);
    return buffer.slice(0, buffer.length - pad);
};
$75e45b5f4acf8dd4$var$DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
    var l = lStart;
    var r = rStart;
    // Apply f() x16 times
    for(var i = 0; i < state.keys.length; i += 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $aSNbB.expand(r, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $aSNbB.substitute(keyL, keyR);
        var f = $aSNbB.permute(s);
        var t = r;
        r = (l ^ f) >>> 0;
        l = t;
    }
    // Reverse Initial Permutation
    $aSNbB.rip(r, l, out, off);
};
$75e45b5f4acf8dd4$var$DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
    var l = rStart;
    var r = lStart;
    // Apply f() x16 times
    for(var i = state.keys.length - 2; i >= 0; i -= 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $aSNbB.expand(l, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $aSNbB.substitute(keyL, keyR);
        var f = $aSNbB.permute(s);
        var t = l;
        l = (r ^ f) >>> 0;
        r = t;
    }
    // Reverse Initial Permutation
    $aSNbB.rip(l, r, out, off);
};

});

parcelRegister("aI1LC", function(module, exports) {
$parcel$export(module.exports, "instantiate", () => $7cbf6251c6fd89d9$export$f9bb8d20ccc7477a, (v) => $7cbf6251c6fd89d9$export$f9bb8d20ccc7477a = v);
var $7cbf6251c6fd89d9$export$f9bb8d20ccc7477a;
'use strict';

var $hILGj = parcelRequire("hILGj");

var $jcXeW = parcelRequire("jcXeW");
var $7cbf6251c6fd89d9$var$proto = {};
function $7cbf6251c6fd89d9$var$CBCState(iv) {
    $hILGj.equal(iv.length, 8, 'Invalid IV length');
    this.iv = new Array(8);
    for(var i = 0; i < this.iv.length; i++)this.iv[i] = iv[i];
}
function $7cbf6251c6fd89d9$var$instantiate(Base) {
    function CBC(options) {
        Base.call(this, options);
        this._cbcInit();
    }
    $jcXeW(CBC, Base);
    var keys = Object.keys($7cbf6251c6fd89d9$var$proto);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        CBC.prototype[key] = $7cbf6251c6fd89d9$var$proto[key];
    }
    CBC.create = function create(options) {
        return new CBC(options);
    };
    return CBC;
}
$7cbf6251c6fd89d9$export$f9bb8d20ccc7477a = $7cbf6251c6fd89d9$var$instantiate;
$7cbf6251c6fd89d9$var$proto._cbcInit = function _cbcInit() {
    var state = new $7cbf6251c6fd89d9$var$CBCState(this.options.iv);
    this._cbcState = state;
};
$7cbf6251c6fd89d9$var$proto._update = function _update(inp, inOff, out, outOff) {
    var state = this._cbcState;
    var superProto = this.constructor.super_.prototype;
    var iv = state.iv;
    if (this.type === 'encrypt') {
        for(var i = 0; i < this.blockSize; i++)iv[i] ^= inp[inOff + i];
        superProto._update.call(this, iv, 0, out, outOff);
        for(var i = 0; i < this.blockSize; i++)iv[i] = out[outOff + i];
    } else {
        superProto._update.call(this, inp, inOff, out, outOff);
        for(var i = 0; i < this.blockSize; i++)out[outOff + i] ^= iv[i];
        for(var i = 0; i < this.blockSize; i++)iv[i] = inp[inOff + i];
    }
};

});

parcelRegister("9g7wA", function(module, exports) {
'use strict';

var $hILGj = parcelRequire("hILGj");

var $jcXeW = parcelRequire("jcXeW");

var $jmHeI = parcelRequire("jmHeI");

var $a7xg7 = parcelRequire("a7xg7");
function $6bdb71e96b274bf2$var$EDEState(type, key) {
    $hILGj.equal(key.length, 24, 'Invalid key length');
    var k1 = key.slice(0, 8);
    var k2 = key.slice(8, 16);
    var k3 = key.slice(16, 24);
    if (type === 'encrypt') this.ciphers = [
        $a7xg7.create({
            type: 'encrypt',
            key: k1
        }),
        $a7xg7.create({
            type: 'decrypt',
            key: k2
        }),
        $a7xg7.create({
            type: 'encrypt',
            key: k3
        })
    ];
    else this.ciphers = [
        $a7xg7.create({
            type: 'decrypt',
            key: k3
        }),
        $a7xg7.create({
            type: 'encrypt',
            key: k2
        }),
        $a7xg7.create({
            type: 'decrypt',
            key: k1
        })
    ];
}
function $6bdb71e96b274bf2$var$EDE(options) {
    $jmHeI.call(this, options);
    var state = new $6bdb71e96b274bf2$var$EDEState(this.type, this.options.key);
    this._edeState = state;
}
$jcXeW($6bdb71e96b274bf2$var$EDE, $jmHeI);
module.exports = $6bdb71e96b274bf2$var$EDE;
$6bdb71e96b274bf2$var$EDE.create = function create(options) {
    return new $6bdb71e96b274bf2$var$EDE(options);
};
$6bdb71e96b274bf2$var$EDE.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._edeState;
    state.ciphers[0]._update(inp, inOff, out, outOff);
    state.ciphers[1]._update(out, outOff, out, outOff);
    state.ciphers[2]._update(out, outOff, out, outOff);
};
$6bdb71e96b274bf2$var$EDE.prototype._pad = $a7xg7.prototype._pad;
$6bdb71e96b274bf2$var$EDE.prototype._unpad = $a7xg7.prototype._unpad;

});

parcelRegister("cgQSS", function(module, exports) {
$parcel$export(module.exports, "encrypt", () => $8ef0005be9809c2a$export$5b0f6292f11d1d18, (v) => $8ef0005be9809c2a$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $8ef0005be9809c2a$export$e85a0c9a1067c5d3, (v) => $8ef0005be9809c2a$export$e85a0c9a1067c5d3 = v);
var $8ef0005be9809c2a$export$5b0f6292f11d1d18;
var $8ef0005be9809c2a$export$e85a0c9a1067c5d3;
$8ef0005be9809c2a$export$5b0f6292f11d1d18 = function(self, block) {
    return self._cipher.encryptBlock(block);
};
$8ef0005be9809c2a$export$e85a0c9a1067c5d3 = function(self, block) {
    return self._cipher.decryptBlock(block);
};

});

parcelRegister("j6TXB", function(module, exports) {
$parcel$export(module.exports, "encrypt", () => $de99fc686f9b659a$export$5b0f6292f11d1d18, (v) => $de99fc686f9b659a$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $de99fc686f9b659a$export$e85a0c9a1067c5d3, (v) => $de99fc686f9b659a$export$e85a0c9a1067c5d3 = v);
var $de99fc686f9b659a$export$5b0f6292f11d1d18;
var $de99fc686f9b659a$export$e85a0c9a1067c5d3;

var $eJhey = parcelRequire("eJhey");
$de99fc686f9b659a$export$5b0f6292f11d1d18 = function(self, block) {
    var data = $eJhey(block, self._prev);
    self._prev = self._cipher.encryptBlock(data);
    return self._prev;
};
$de99fc686f9b659a$export$e85a0c9a1067c5d3 = function(self, block) {
    var pad = self._prev;
    self._prev = block;
    var out = self._cipher.decryptBlock(block);
    return $eJhey(out, pad);
};

});
parcelRegister("eJhey", function(module, exports) {

var $b0qLu = parcelRequire("b0qLu");
var $ab92a2f14b8fa122$require$Buffer = $b0qLu.Buffer;
module.exports = function xor(a, b) {
    var length = Math.min(a.length, b.length);
    var buffer = new $ab92a2f14b8fa122$require$Buffer(length);
    for(var i = 0; i < length; ++i)buffer[i] = a[i] ^ b[i];
    return buffer;
};

});


parcelRegister("3kK1N", function(module, exports) {
$parcel$export(module.exports, "encrypt", () => $26d6f18dc6283236$export$5b0f6292f11d1d18, (v) => $26d6f18dc6283236$export$5b0f6292f11d1d18 = v);
var $26d6f18dc6283236$export$5b0f6292f11d1d18;

var $dmAgJ = parcelRequire("dmAgJ");
var $26d6f18dc6283236$require$Buffer = $dmAgJ.Buffer;

var $eJhey = parcelRequire("eJhey");
function $26d6f18dc6283236$var$encryptStart(self, data, decrypt) {
    var len = data.length;
    var out = $eJhey(data, self._cache);
    self._cache = self._cache.slice(len);
    self._prev = $26d6f18dc6283236$require$Buffer.concat([
        self._prev,
        decrypt ? data : out
    ]);
    return out;
}
$26d6f18dc6283236$export$5b0f6292f11d1d18 = function(self, data, decrypt) {
    var out = $26d6f18dc6283236$require$Buffer.allocUnsafe(0);
    var len;
    while(data.length){
        if (self._cache.length === 0) {
            self._cache = self._cipher.encryptBlock(self._prev);
            self._prev = $26d6f18dc6283236$require$Buffer.allocUnsafe(0);
        }
        if (self._cache.length <= data.length) {
            len = self._cache.length;
            out = $26d6f18dc6283236$require$Buffer.concat([
                out,
                $26d6f18dc6283236$var$encryptStart(self, data.slice(0, len), decrypt)
            ]);
            data = data.slice(len);
        } else {
            out = $26d6f18dc6283236$require$Buffer.concat([
                out,
                $26d6f18dc6283236$var$encryptStart(self, data, decrypt)
            ]);
            break;
        }
    }
    return out;
};

});

parcelRegister("czb0l", function(module, exports) {
$parcel$export(module.exports, "encrypt", () => $92614a36025fab4a$export$5b0f6292f11d1d18, (v) => $92614a36025fab4a$export$5b0f6292f11d1d18 = v);
var $92614a36025fab4a$export$5b0f6292f11d1d18;

var $dmAgJ = parcelRequire("dmAgJ");
var $92614a36025fab4a$require$Buffer = $dmAgJ.Buffer;
function $92614a36025fab4a$var$encryptByte(self, byteParam, decrypt) {
    var pad = self._cipher.encryptBlock(self._prev);
    var out = pad[0] ^ byteParam;
    self._prev = $92614a36025fab4a$require$Buffer.concat([
        self._prev.slice(1),
        $92614a36025fab4a$require$Buffer.from([
            decrypt ? byteParam : out
        ])
    ]);
    return out;
}
$92614a36025fab4a$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $92614a36025fab4a$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $92614a36025fab4a$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("9woLd", function(module, exports) {
$parcel$export(module.exports, "encrypt", () => $6eea4f1e7b172c31$export$5b0f6292f11d1d18, (v) => $6eea4f1e7b172c31$export$5b0f6292f11d1d18 = v);
var $6eea4f1e7b172c31$export$5b0f6292f11d1d18;

var $dmAgJ = parcelRequire("dmAgJ");
var $6eea4f1e7b172c31$require$Buffer = $dmAgJ.Buffer;
function $6eea4f1e7b172c31$var$encryptByte(self, byteParam, decrypt) {
    var pad;
    var i = -1;
    var len = 8;
    var out = 0;
    var bit, value;
    while(++i < len){
        pad = self._cipher.encryptBlock(self._prev);
        bit = byteParam & 1 << 7 - i ? 0x80 : 0;
        value = pad[0] ^ bit;
        out += (value & 0x80) >> i % 8;
        self._prev = $6eea4f1e7b172c31$var$shiftIn(self._prev, decrypt ? bit : value);
    }
    return out;
}
function $6eea4f1e7b172c31$var$shiftIn(buffer, value) {
    var len = buffer.length;
    var i = -1;
    var out = $6eea4f1e7b172c31$require$Buffer.allocUnsafe(buffer.length);
    buffer = $6eea4f1e7b172c31$require$Buffer.concat([
        buffer,
        $6eea4f1e7b172c31$require$Buffer.from([
            value
        ])
    ]);
    while(++i < len)out[i] = buffer[i] << 1 | buffer[i + 1] >> 7;
    return out;
}
$6eea4f1e7b172c31$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $6eea4f1e7b172c31$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $6eea4f1e7b172c31$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("gDgzE", function(module, exports) {
$parcel$export(module.exports, "encrypt", () => $c1bd252244dccc8e$export$5b0f6292f11d1d18, (v) => $c1bd252244dccc8e$export$5b0f6292f11d1d18 = v);
var $c1bd252244dccc8e$export$5b0f6292f11d1d18;

var $b0qLu = parcelRequire("b0qLu");
var $c1bd252244dccc8e$require$Buffer = $b0qLu.Buffer;

var $eJhey = parcelRequire("eJhey");
function $c1bd252244dccc8e$var$getBlock(self) {
    self._prev = self._cipher.encryptBlock(self._prev);
    return self._prev;
}
$c1bd252244dccc8e$export$5b0f6292f11d1d18 = function(self, chunk) {
    while(self._cache.length < chunk.length)self._cache = $c1bd252244dccc8e$require$Buffer.concat([
        self._cache,
        $c1bd252244dccc8e$var$getBlock(self)
    ]);
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $eJhey(chunk, pad);
};

});

parcelRegister("dKqnh", function(module, exports) {
$parcel$export(module.exports, "encrypt", () => $a02407a6169b52d2$export$5b0f6292f11d1d18, (v) => $a02407a6169b52d2$export$5b0f6292f11d1d18 = v);
var $a02407a6169b52d2$export$5b0f6292f11d1d18;

var $eJhey = parcelRequire("eJhey");

var $dmAgJ = parcelRequire("dmAgJ");
var $a02407a6169b52d2$require$Buffer = $dmAgJ.Buffer;

var $7HX5Y = parcelRequire("7HX5Y");
function $a02407a6169b52d2$var$getBlock(self) {
    var out = self._cipher.encryptBlockRaw(self._prev);
    $7HX5Y(self._prev);
    return out;
}
var $a02407a6169b52d2$var$blockSize = 16;
$a02407a6169b52d2$export$5b0f6292f11d1d18 = function(self, chunk) {
    var chunkNum = Math.ceil(chunk.length / $a02407a6169b52d2$var$blockSize);
    var start = self._cache.length;
    self._cache = $a02407a6169b52d2$require$Buffer.concat([
        self._cache,
        $a02407a6169b52d2$require$Buffer.allocUnsafe(chunkNum * $a02407a6169b52d2$var$blockSize)
    ]);
    for(var i = 0; i < chunkNum; i++){
        var out = $a02407a6169b52d2$var$getBlock(self);
        var offset = start + i * $a02407a6169b52d2$var$blockSize;
        self._cache.writeUInt32BE(out[0], offset + 0);
        self._cache.writeUInt32BE(out[1], offset + 4);
        self._cache.writeUInt32BE(out[2], offset + 8);
        self._cache.writeUInt32BE(out[3], offset + 12);
    }
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $eJhey(chunk, pad);
};

});
parcelRegister("7HX5Y", function(module, exports) {
function $59ca63a62cc58b5b$var$incr32(iv) {
    var len = iv.length;
    var item;
    while(len--){
        item = iv.readUInt8(len);
        if (item === 255) iv.writeUInt8(0, len);
        else {
            item++;
            iv.writeUInt8(item, len);
            break;
        }
    }
}
module.exports = $59ca63a62cc58b5b$var$incr32;

});


parcelRegister("kHwXh", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("luYXS")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("fZ33D", function(module, exports) {
var $ba2eecae499fc223$var$r;
module.exports = function rand(len) {
    if (!$ba2eecae499fc223$var$r) $ba2eecae499fc223$var$r = new $ba2eecae499fc223$var$Rand(null);
    return $ba2eecae499fc223$var$r.generate(len);
};
function $ba2eecae499fc223$var$Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = $ba2eecae499fc223$var$Rand;
$ba2eecae499fc223$var$Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
$ba2eecae499fc223$var$Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};

if (typeof self === 'object') {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    $ba2eecae499fc223$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    $ba2eecae499fc223$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === 'object') // Old junk
    $ba2eecae499fc223$var$Rand.prototype._rand = function() {
        throw new Error('Not implemented yet');
    };
} else // Node.js or Web worker with no crypto support
try {
    var $ba2eecae499fc223$var$crypto = (parcelRequire("luYXS"));
    if (typeof $ba2eecae499fc223$var$crypto.randomBytes !== 'function') throw new Error('Not supported');
    $ba2eecae499fc223$var$Rand.prototype._rand = function _rand(n) {
        return $ba2eecae499fc223$var$crypto.randomBytes(n);
    };
} catch (e) {}

});

parcelRegister("f2OM9", function(module, exports) {

exports = module.exports = (parcelRequire("eSqcC"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("845EU"));

exports.Duplex = (parcelRequire("hjOgI"));

exports.Transform = (parcelRequire("6ysZI"));

exports.PassThrough = (parcelRequire("3aC57"));

});
parcelRegister("eSqcC", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $aVaWD = parcelRequire("aVaWD");
'use strict';

var $xBkZP = parcelRequire("xBkZP");
/*</replacement>*/ module.exports = $ad4a6f188180b09c$var$Readable;

var $bMaBy = parcelRequire("bMaBy");
/*</replacement>*/ /*<replacement>*/ var $ad4a6f188180b09c$var$Duplex;
/*</replacement>*/ $ad4a6f188180b09c$var$Readable.ReadableState = $ad4a6f188180b09c$var$ReadableState;

var $gW4Pg = parcelRequire("gW4Pg");
var $ad4a6f188180b09c$require$EE = $gW4Pg.EventEmitter;
var $ad4a6f188180b09c$var$EElistenerCount = function(emitter, type) {
    return emitter.listeners(type).length;
};

var $k7EG0 = parcelRequire("k7EG0");

var $3PVuC = parcelRequire("3PVuC");
var $ad4a6f188180b09c$require$Buffer = $3PVuC.Buffer;
var $ad4a6f188180b09c$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $ad4a6f188180b09c$var$_uint8ArrayToBuffer(chunk) {
    return $ad4a6f188180b09c$require$Buffer.from(chunk);
}
function $ad4a6f188180b09c$var$_isUint8Array(obj) {
    return $ad4a6f188180b09c$require$Buffer.isBuffer(obj) || obj instanceof $ad4a6f188180b09c$var$OurUint8Array;
}

/*</replacement>*/ /*<replacement>*/ var $ad4a6f188180b09c$var$util = Object.create((parcelRequire("5mxBc")));

$ad4a6f188180b09c$var$util.inherits = (parcelRequire("jcXeW"));

var $luYXS = parcelRequire("luYXS");
var $ad4a6f188180b09c$var$debug = void 0;
if ($luYXS && $luYXS.debuglog) $ad4a6f188180b09c$var$debug = $luYXS.debuglog('stream');
else $ad4a6f188180b09c$var$debug = function() {};

var $5wEYD = parcelRequire("5wEYD");

var $6L9ED = parcelRequire("6L9ED");
var $ad4a6f188180b09c$var$StringDecoder;
$ad4a6f188180b09c$var$util.inherits($ad4a6f188180b09c$var$Readable, $k7EG0);
var $ad4a6f188180b09c$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $ad4a6f188180b09c$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($bMaBy(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $ad4a6f188180b09c$var$ReadableState(options, stream) {
    $ad4a6f188180b09c$var$Duplex = $ad4a6f188180b09c$var$Duplex || (parcelRequire("hjOgI"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $ad4a6f188180b09c$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    var hwm = options.highWaterMark;
    var readableHwm = options.readableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $5wEYD();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$ad4a6f188180b09c$var$StringDecoder) $ad4a6f188180b09c$var$StringDecoder = (parcelRequire("3ojwL")).StringDecoder;
        this.decoder = new $ad4a6f188180b09c$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $ad4a6f188180b09c$var$Readable(options) {
    $ad4a6f188180b09c$var$Duplex = $ad4a6f188180b09c$var$Duplex || (parcelRequire("hjOgI"));
    if (!(this instanceof $ad4a6f188180b09c$var$Readable)) return new $ad4a6f188180b09c$var$Readable(options);
    this._readableState = new $ad4a6f188180b09c$var$ReadableState(options, this);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $k7EG0.call(this);
}
Object.defineProperty($ad4a6f188180b09c$var$Readable.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$ad4a6f188180b09c$var$Readable.prototype.destroy = $6L9ED.destroy;
$ad4a6f188180b09c$var$Readable.prototype._undestroy = $6L9ED.undestroy;
$ad4a6f188180b09c$var$Readable.prototype._destroy = function(err, cb) {
    this.push(null);
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$ad4a6f188180b09c$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $ad4a6f188180b09c$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $ad4a6f188180b09c$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$ad4a6f188180b09c$var$Readable.prototype.unshift = function(chunk) {
    return $ad4a6f188180b09c$var$readableAddChunk(this, chunk, null, true, false);
};
function $ad4a6f188180b09c$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $ad4a6f188180b09c$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $ad4a6f188180b09c$var$chunkInvalid(state, chunk);
        if (er) stream.emit('error', er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $ad4a6f188180b09c$require$Buffer.prototype) chunk = $ad4a6f188180b09c$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));
                else $ad4a6f188180b09c$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) stream.emit('error', new Error('stream.push() after EOF'));
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $ad4a6f188180b09c$var$addChunk(stream, state, chunk, false);
                    else $ad4a6f188180b09c$var$maybeReadMore(stream, state);
                } else $ad4a6f188180b09c$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) state.reading = false;
    }
    return $ad4a6f188180b09c$var$needMoreData(state);
}
function $ad4a6f188180b09c$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        stream.emit('data', chunk);
        stream.read(0);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $ad4a6f188180b09c$var$emitReadable(stream);
    }
    $ad4a6f188180b09c$var$maybeReadMore(stream, state);
}
function $ad4a6f188180b09c$var$chunkInvalid(state, chunk) {
    var er;
    if (!$ad4a6f188180b09c$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    return er;
}
// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function $ad4a6f188180b09c$var$needMoreData(state) {
    return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}
$ad4a6f188180b09c$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$ad4a6f188180b09c$var$Readable.prototype.setEncoding = function(enc) {
    if (!$ad4a6f188180b09c$var$StringDecoder) $ad4a6f188180b09c$var$StringDecoder = (parcelRequire("3ojwL")).StringDecoder;
    this._readableState.decoder = new $ad4a6f188180b09c$var$StringDecoder(enc);
    this._readableState.encoding = enc;
    return this;
};
// Don't raise the hwm > 8MB
var $ad4a6f188180b09c$var$MAX_HWM = 0x800000;
function $ad4a6f188180b09c$var$computeNewHighWaterMark(n) {
    if (n >= $ad4a6f188180b09c$var$MAX_HWM) n = $ad4a6f188180b09c$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $ad4a6f188180b09c$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $ad4a6f188180b09c$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$ad4a6f188180b09c$var$Readable.prototype.read = function(n) {
    $ad4a6f188180b09c$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
        $ad4a6f188180b09c$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $ad4a6f188180b09c$var$endReadable(this);
        else $ad4a6f188180b09c$var$emitReadable(this);
        return null;
    }
    n = $ad4a6f188180b09c$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $ad4a6f188180b09c$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $ad4a6f188180b09c$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $ad4a6f188180b09c$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $ad4a6f188180b09c$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $ad4a6f188180b09c$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $ad4a6f188180b09c$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $ad4a6f188180b09c$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = true;
        n = 0;
    } else state.length -= n;
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $ad4a6f188180b09c$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $ad4a6f188180b09c$var$onEofChunk(stream, state) {
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    // emit 'readable' now to make sure it gets picked up.
    $ad4a6f188180b09c$var$emitReadable(stream);
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $ad4a6f188180b09c$var$emitReadable(stream) {
    var state = stream._readableState;
    state.needReadable = false;
    if (!state.emittedReadable) {
        $ad4a6f188180b09c$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        if (state.sync) $xBkZP.nextTick($ad4a6f188180b09c$var$emitReadable_, stream);
        else $ad4a6f188180b09c$var$emitReadable_(stream);
    }
}
function $ad4a6f188180b09c$var$emitReadable_(stream) {
    $ad4a6f188180b09c$var$debug('emit readable');
    stream.emit('readable');
    $ad4a6f188180b09c$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $ad4a6f188180b09c$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $xBkZP.nextTick($ad4a6f188180b09c$var$maybeReadMore_, stream, state);
    }
}
function $ad4a6f188180b09c$var$maybeReadMore_(stream, state) {
    var len = state.length;
    while(!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark){
        $ad4a6f188180b09c$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
        else len = state.length;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$ad4a6f188180b09c$var$Readable.prototype._read = function(n) {
    this.emit('error', new Error('_read() is not implemented'));
};
$ad4a6f188180b09c$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $ad4a6f188180b09c$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $aVaWD.stdout && dest !== $aVaWD.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $xBkZP.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $ad4a6f188180b09c$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $ad4a6f188180b09c$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $ad4a6f188180b09c$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $ad4a6f188180b09c$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    // If the user pushes more data while we're writing to dest then we'll end up
    // in ondata again. However, we only want to increase awaitDrain once because
    // dest will only emit one 'drain' event for the multiple writes.
    // => Introduce a guard on increasing awaitDrain.
    var increasedAwaitDrain = false;
    src.on('data', ondata);
    function ondata(chunk) {
        $ad4a6f188180b09c$var$debug('ondata');
        increasedAwaitDrain = false;
        var ret = dest.write(chunk);
        if (false === ret && !increasedAwaitDrain) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $ad4a6f188180b09c$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $ad4a6f188180b09c$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
                increasedAwaitDrain = true;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $ad4a6f188180b09c$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($ad4a6f188180b09c$var$EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
    }
    // Make sure our error handler is attached before userland ones.
    $ad4a6f188180b09c$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $ad4a6f188180b09c$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $ad4a6f188180b09c$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $ad4a6f188180b09c$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $ad4a6f188180b09c$var$pipeOnDrain(src) {
    return function() {
        var state = src._readableState;
        $ad4a6f188180b09c$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $ad4a6f188180b09c$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $ad4a6f188180b09c$var$flow(src);
        }
    };
}
$ad4a6f188180b09c$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $ad4a6f188180b09c$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$ad4a6f188180b09c$var$Readable.prototype.on = function(ev, fn) {
    var res = $k7EG0.prototype.on.call(this, ev, fn);
    if (ev === 'data') // Start flowing on next tick if stream isn't explicitly paused
    {
        if (this._readableState.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        var state = this._readableState;
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.emittedReadable = false;
            if (!state.reading) $xBkZP.nextTick($ad4a6f188180b09c$var$nReadingNextTick, this);
            else if (state.length) $ad4a6f188180b09c$var$emitReadable(this);
        }
    }
    return res;
};
$ad4a6f188180b09c$var$Readable.prototype.addListener = $ad4a6f188180b09c$var$Readable.prototype.on;
function $ad4a6f188180b09c$var$nReadingNextTick(self1) {
    $ad4a6f188180b09c$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$ad4a6f188180b09c$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $ad4a6f188180b09c$var$debug('resume');
        state.flowing = true;
        $ad4a6f188180b09c$var$resume(this, state);
    }
    return this;
};
function $ad4a6f188180b09c$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $xBkZP.nextTick($ad4a6f188180b09c$var$resume_, stream, state);
    }
}
function $ad4a6f188180b09c$var$resume_(stream, state) {
    if (!state.reading) {
        $ad4a6f188180b09c$var$debug('resume read 0');
        stream.read(0);
    }
    state.resumeScheduled = false;
    state.awaitDrain = 0;
    stream.emit('resume');
    $ad4a6f188180b09c$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$ad4a6f188180b09c$var$Readable.prototype.pause = function() {
    $ad4a6f188180b09c$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (false !== this._readableState.flowing) {
        $ad4a6f188180b09c$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    return this;
};
function $ad4a6f188180b09c$var$flow(stream) {
    var state = stream._readableState;
    $ad4a6f188180b09c$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$ad4a6f188180b09c$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $ad4a6f188180b09c$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $ad4a6f188180b09c$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function(method) {
        return function() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $ad4a6f188180b09c$var$kProxyEvents.length; n++)stream.on($ad4a6f188180b09c$var$kProxyEvents[n], this.emit.bind(this, $ad4a6f188180b09c$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $ad4a6f188180b09c$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};
Object.defineProperty($ad4a6f188180b09c$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._readableState.highWaterMark;
    }
});
// exposed for testing purposes only.
$ad4a6f188180b09c$var$Readable._fromList = $ad4a6f188180b09c$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $ad4a6f188180b09c$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.head.data;
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = $ad4a6f188180b09c$var$fromListPartial(n, state.buffer, state.decoder);
    return ret;
}
// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $ad4a6f188180b09c$var$fromListPartial(n, list, hasStrings) {
    var ret;
    if (n < list.head.data.length) {
        // slice is the same for buffers and strings
        ret = list.head.data.slice(0, n);
        list.head.data = list.head.data.slice(n);
    } else if (n === list.head.data.length) // first chunk is a perfect match
    ret = list.shift();
    else // result spans more than one buffer
    ret = hasStrings ? $ad4a6f188180b09c$var$copyFromBufferString(n, list) : $ad4a6f188180b09c$var$copyFromBuffer(n, list);
    return ret;
}
// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $ad4a6f188180b09c$var$copyFromBufferString(n, list) {
    var p = list.head;
    var c = 1;
    var ret = p.data;
    n -= ret.length;
    while(p = p.next){
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;
        else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
            if (nb === str.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = str.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $ad4a6f188180b09c$var$copyFromBuffer(n, list) {
    var ret = $ad4a6f188180b09c$require$Buffer.allocUnsafe(n);
    var p = list.head;
    var c = 1;
    p.data.copy(ret);
    n -= p.data.length;
    while(p = p.next){
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
            if (nb === buf.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = buf.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
function $ad4a6f188180b09c$var$endReadable(stream) {
    var state = stream._readableState;
    // If we get here before consuming all the bytes, then that is a
    // bug in node.  Should never happen.
    if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
    if (!state.endEmitted) {
        state.ended = true;
        $xBkZP.nextTick($ad4a6f188180b09c$var$endReadableNT, state, stream);
    }
}
function $ad4a6f188180b09c$var$endReadableNT(state, stream) {
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
    }
}
function $ad4a6f188180b09c$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("bMaBy", function(module, exports) {
var $892c6743b565ed72$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $892c6743b565ed72$var$toString.call(arr) == '[object Array]';
};

});

parcelRegister("k7EG0", function(module, exports) {

module.exports = (parcelRequire("gW4Pg")).EventEmitter;

});

parcelRegister("3PVuC", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $b0qLu = parcelRequire("b0qLu");
var $2cb2bb6003e78d93$var$Buffer = $b0qLu.Buffer;
// alternative to using Object.keys for old browsers
function $2cb2bb6003e78d93$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($2cb2bb6003e78d93$var$Buffer.from && $2cb2bb6003e78d93$var$Buffer.alloc && $2cb2bb6003e78d93$var$Buffer.allocUnsafe && $2cb2bb6003e78d93$var$Buffer.allocUnsafeSlow) module.exports = $b0qLu;
else {
    // Copy properties from require('buffer')
    $2cb2bb6003e78d93$var$copyProps($b0qLu, module.exports);
    module.exports.Buffer = $2cb2bb6003e78d93$var$SafeBuffer;
}
function $2cb2bb6003e78d93$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $2cb2bb6003e78d93$var$Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
$2cb2bb6003e78d93$var$copyProps($2cb2bb6003e78d93$var$Buffer, $2cb2bb6003e78d93$var$SafeBuffer);
$2cb2bb6003e78d93$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $2cb2bb6003e78d93$var$Buffer(arg, encodingOrOffset, length);
};
$2cb2bb6003e78d93$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $2cb2bb6003e78d93$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$2cb2bb6003e78d93$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $2cb2bb6003e78d93$var$Buffer(size);
};
$2cb2bb6003e78d93$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $b0qLu.SlowBuffer(size);
};

});

parcelRegister("5wEYD", function(module, exports) {
'use strict';
function $405fba101b82697c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $3PVuC = parcelRequire("3PVuC");
var $405fba101b82697c$require$Buffer = $3PVuC.Buffer;

var $luYXS = parcelRequire("luYXS");
function $405fba101b82697c$var$copyBuffer(src, target, offset) {
    src.copy(target, offset);
}
module.exports = function() {
    function BufferList() {
        $405fba101b82697c$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    BufferList.prototype.push = function push(v) {
        var entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    };
    BufferList.prototype.unshift = function unshift(v) {
        var entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    };
    BufferList.prototype.shift = function shift() {
        if (this.length === 0) return;
        var ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    };
    BufferList.prototype.clear = function clear() {
        this.head = this.tail = null;
        this.length = 0;
    };
    BufferList.prototype.join = function join(s) {
        if (this.length === 0) return '';
        var p = this.head;
        var ret = '' + p.data;
        while(p = p.next)ret += s + p.data;
        return ret;
    };
    BufferList.prototype.concat = function concat(n) {
        if (this.length === 0) return $405fba101b82697c$require$Buffer.alloc(0);
        var ret = $405fba101b82697c$require$Buffer.allocUnsafe(n >>> 0);
        var p = this.head;
        var i = 0;
        while(p){
            $405fba101b82697c$var$copyBuffer(p.data, ret, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    };
    return BufferList;
}();
if ($luYXS && $luYXS.inspect && $luYXS.inspect.custom) module.exports.prototype[$luYXS.inspect.custom] = function() {
    var obj = $luYXS.inspect({
        length: this.length
    });
    return this.constructor.name + ' ' + obj;
};

});

parcelRegister("6L9ED", function(module, exports) {
'use strict';

var $xBkZP = parcelRequire("xBkZP");
/*</replacement>*/ // undocumented cb() API, needed for core, not for public API
function $4ebe9f086efe27fd$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $xBkZP.nextTick($4ebe9f086efe27fd$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $xBkZP.nextTick($4ebe9f086efe27fd$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $xBkZP.nextTick($4ebe9f086efe27fd$var$emitErrorNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $xBkZP.nextTick($4ebe9f086efe27fd$var$emitErrorNT, _this, err);
            }
        } else if (cb) cb(err);
    });
    return this;
}
function $4ebe9f086efe27fd$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $4ebe9f086efe27fd$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
module.exports = {
    destroy: $4ebe9f086efe27fd$var$destroy,
    undestroy: $4ebe9f086efe27fd$var$undestroy
};

});

parcelRegister("hjOgI", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.
'use strict';

var $xBkZP = parcelRequire("xBkZP");
/*</replacement>*/ /*<replacement>*/ var $c9bb344b129650f2$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $c9bb344b129650f2$var$Duplex;

/*<replacement>*/ var $c9bb344b129650f2$var$util = Object.create((parcelRequire("5mxBc")));

$c9bb344b129650f2$var$util.inherits = (parcelRequire("jcXeW"));

var $eSqcC = parcelRequire("eSqcC");

var $845EU = parcelRequire("845EU");
$c9bb344b129650f2$var$util.inherits($c9bb344b129650f2$var$Duplex, $eSqcC);
// avoid scope creep, the keys array can then be collected
var $c9bb344b129650f2$var$keys = $c9bb344b129650f2$var$objectKeys($845EU.prototype);
for(var $c9bb344b129650f2$var$v = 0; $c9bb344b129650f2$var$v < $c9bb344b129650f2$var$keys.length; $c9bb344b129650f2$var$v++){
    var $c9bb344b129650f2$var$method = $c9bb344b129650f2$var$keys[$c9bb344b129650f2$var$v];
    if (!$c9bb344b129650f2$var$Duplex.prototype[$c9bb344b129650f2$var$method]) $c9bb344b129650f2$var$Duplex.prototype[$c9bb344b129650f2$var$method] = $845EU.prototype[$c9bb344b129650f2$var$method];
}
function $c9bb344b129650f2$var$Duplex(options) {
    if (!(this instanceof $c9bb344b129650f2$var$Duplex)) return new $c9bb344b129650f2$var$Duplex(options);
    $eSqcC.call(this, options);
    $845EU.call(this, options);
    if (options && options.readable === false) this.readable = false;
    if (options && options.writable === false) this.writable = false;
    this.allowHalfOpen = true;
    if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
    this.once('end', $c9bb344b129650f2$var$onend);
}
Object.defineProperty($c9bb344b129650f2$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// the no-half-open enforcer
function $c9bb344b129650f2$var$onend() {
    // if we allow half-open state, or if the writable side ended,
    // then we're ok.
    if (this.allowHalfOpen || this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $xBkZP.nextTick($c9bb344b129650f2$var$onEndNT, this);
}
function $c9bb344b129650f2$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($c9bb344b129650f2$var$Duplex.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});
$c9bb344b129650f2$var$Duplex.prototype._destroy = function(err, cb) {
    this.push(null);
    this.end();
    $xBkZP.nextTick(cb, err);
};

});
parcelRegister("845EU", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $xBkZP = parcelRequire("xBkZP");
/*</replacement>*/ module.exports = $5df31629173df7e3$var$Writable;
/* <replacement> */ function $5df31629173df7e3$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $5df31629173df7e3$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $5df31629173df7e3$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $5df31629173df7e3$var$asyncWrite = (0, $xBkZP.nextTick);
/*</replacement>*/ /*<replacement>*/ var $5df31629173df7e3$var$Duplex;
/*</replacement>*/ $5df31629173df7e3$var$Writable.WritableState = $5df31629173df7e3$var$WritableState;

/*<replacement>*/ var $5df31629173df7e3$var$util = Object.create((parcelRequire("5mxBc")));

$5df31629173df7e3$var$util.inherits = (parcelRequire("jcXeW"));

/*</replacement>*/ /*<replacement>*/ var $5df31629173df7e3$var$internalUtil = {
    deprecate: (parcelRequire("kI89L"))
};

var $k7EG0 = parcelRequire("k7EG0");

var $3PVuC = parcelRequire("3PVuC");
var $5df31629173df7e3$require$Buffer = $3PVuC.Buffer;
var $5df31629173df7e3$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $5df31629173df7e3$var$_uint8ArrayToBuffer(chunk) {
    return $5df31629173df7e3$require$Buffer.from(chunk);
}
function $5df31629173df7e3$var$_isUint8Array(obj) {
    return $5df31629173df7e3$require$Buffer.isBuffer(obj) || obj instanceof $5df31629173df7e3$var$OurUint8Array;
}

var $6L9ED = parcelRequire("6L9ED");
$5df31629173df7e3$var$util.inherits($5df31629173df7e3$var$Writable, $k7EG0);
function $5df31629173df7e3$var$nop() {}

function $5df31629173df7e3$var$WritableState(options, stream) {
    $5df31629173df7e3$var$Duplex = $5df31629173df7e3$var$Duplex || (parcelRequire("hjOgI"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $5df31629173df7e3$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    var hwm = options.highWaterMark;
    var writableHwm = options.writableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $5df31629173df7e3$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $5df31629173df7e3$var$CorkedRequest(this);
}
$5df31629173df7e3$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($5df31629173df7e3$var$WritableState.prototype, 'buffer', {
            get: $5df31629173df7e3$var$internalUtil.deprecate(function() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $5df31629173df7e3$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $5df31629173df7e3$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($5df31629173df7e3$var$Writable, Symbol.hasInstance, {
        value: function(object) {
            if ($5df31629173df7e3$var$realHasInstance.call(this, object)) return true;
            if (this !== $5df31629173df7e3$var$Writable) return false;
            return object && object._writableState instanceof $5df31629173df7e3$var$WritableState;
        }
    });
} else $5df31629173df7e3$var$realHasInstance = function(object) {
    return object instanceof this;
};

function $5df31629173df7e3$var$Writable(options) {
    $5df31629173df7e3$var$Duplex = $5df31629173df7e3$var$Duplex || (parcelRequire("hjOgI"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    if (!$5df31629173df7e3$var$realHasInstance.call($5df31629173df7e3$var$Writable, this) && !(this instanceof $5df31629173df7e3$var$Duplex)) return new $5df31629173df7e3$var$Writable(options);
    this._writableState = new $5df31629173df7e3$var$WritableState(options, this);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $k7EG0.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$5df31629173df7e3$var$Writable.prototype.pipe = function() {
    this.emit('error', new Error('Cannot pipe, not readable'));
};
function $5df31629173df7e3$var$writeAfterEnd(stream, cb) {
    var er = new Error('write after end');
    // TODO: defer error events consistently everywhere, not just the cb
    stream.emit('error', er);
    $xBkZP.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $5df31629173df7e3$var$validChunk(stream, state, chunk, cb) {
    var valid = true;
    var er = false;
    if (chunk === null) er = new TypeError('May not write null values to stream');
    else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    if (er) {
        stream.emit('error', er);
        $xBkZP.nextTick(cb, er);
        valid = false;
    }
    return valid;
}
$5df31629173df7e3$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $5df31629173df7e3$var$_isUint8Array(chunk);
    if (isBuf && !$5df31629173df7e3$require$Buffer.isBuffer(chunk)) chunk = $5df31629173df7e3$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $5df31629173df7e3$var$nop;
    if (state.ended) $5df31629173df7e3$var$writeAfterEnd(this, cb);
    else if (isBuf || $5df31629173df7e3$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $5df31629173df7e3$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$5df31629173df7e3$var$Writable.prototype.cork = function() {
    var state = this._writableState;
    state.corked++;
};
$5df31629173df7e3$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $5df31629173df7e3$var$clearBuffer(this, state);
    }
};
$5df31629173df7e3$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
function $5df31629173df7e3$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $5df31629173df7e3$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($5df31629173df7e3$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $5df31629173df7e3$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $5df31629173df7e3$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $5df31629173df7e3$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $5df31629173df7e3$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $5df31629173df7e3$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $xBkZP.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $xBkZP.nextTick($5df31629173df7e3$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
        // this can emit finish, but finish must
        // always follow error
        $5df31629173df7e3$var$finishMaybe(stream, state);
    }
}
function $5df31629173df7e3$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $5df31629173df7e3$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    $5df31629173df7e3$var$onwriteStateUpdate(state);
    if (er) $5df31629173df7e3$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $5df31629173df7e3$var$needFinish(state);
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $5df31629173df7e3$var$clearBuffer(stream, state);
        if (sync) /*<replacement>*/ $5df31629173df7e3$var$asyncWrite($5df31629173df7e3$var$afterWrite, stream, state, finished, cb);
        else $5df31629173df7e3$var$afterWrite(stream, state, finished, cb);
    }
}
function $5df31629173df7e3$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $5df31629173df7e3$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $5df31629173df7e3$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $5df31629173df7e3$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $5df31629173df7e3$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $5df31629173df7e3$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $5df31629173df7e3$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $5df31629173df7e3$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$5df31629173df7e3$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new Error('_write() is not implemented'));
};
$5df31629173df7e3$var$Writable.prototype._writev = null;
$5df31629173df7e3$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $5df31629173df7e3$var$endWritable(this, state, cb);
};
function $5df31629173df7e3$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $5df31629173df7e3$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) stream.emit('error', err);
        state.prefinished = true;
        stream.emit('prefinish');
        $5df31629173df7e3$var$finishMaybe(stream, state);
    });
}
function $5df31629173df7e3$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function') {
            state.pendingcb++;
            state.finalCalled = true;
            $xBkZP.nextTick($5df31629173df7e3$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $5df31629173df7e3$var$finishMaybe(stream, state) {
    var need = $5df31629173df7e3$var$needFinish(state);
    if (need) {
        $5df31629173df7e3$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
        }
    }
    return need;
}
function $5df31629173df7e3$var$endWritable(stream, state, cb) {
    state.ending = true;
    $5df31629173df7e3$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $xBkZP.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $5df31629173df7e3$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($5df31629173df7e3$var$Writable.prototype, 'destroyed', {
    get: function() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$5df31629173df7e3$var$Writable.prototype.destroy = $6L9ED.destroy;
$5df31629173df7e3$var$Writable.prototype._undestroy = $6L9ED.undestroy;
$5df31629173df7e3$var$Writable.prototype._destroy = function(err, cb) {
    this.end();
    cb(err);
};

});


parcelRegister("3ojwL", function(module, exports) {
$parcel$export(module.exports, "StringDecoder", () => $2782c2b9d9676823$export$63a7aa211a91ed69, (v) => $2782c2b9d9676823$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $2782c2b9d9676823$export$63a7aa211a91ed69;
'use strict';

var $8C0pl = parcelRequire("8C0pl");
var $2782c2b9d9676823$require$Buffer = $8C0pl.Buffer;
/*</replacement>*/ var $2782c2b9d9676823$var$isEncoding = $2782c2b9d9676823$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $2782c2b9d9676823$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $2782c2b9d9676823$var$normalizeEncoding(enc) {
    var nenc = $2782c2b9d9676823$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($2782c2b9d9676823$require$Buffer.isEncoding === $2782c2b9d9676823$var$isEncoding || !$2782c2b9d9676823$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$2782c2b9d9676823$export$63a7aa211a91ed69 = $2782c2b9d9676823$var$StringDecoder;
function $2782c2b9d9676823$var$StringDecoder(encoding) {
    this.encoding = $2782c2b9d9676823$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $2782c2b9d9676823$var$utf16Text;
            this.end = $2782c2b9d9676823$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $2782c2b9d9676823$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $2782c2b9d9676823$var$base64Text;
            this.end = $2782c2b9d9676823$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $2782c2b9d9676823$var$simpleWrite;
            this.end = $2782c2b9d9676823$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $2782c2b9d9676823$require$Buffer.allocUnsafe(nb);
}
$2782c2b9d9676823$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$2782c2b9d9676823$var$StringDecoder.prototype.end = $2782c2b9d9676823$var$utf8End;
// Returns only complete characters in a Buffer
$2782c2b9d9676823$var$StringDecoder.prototype.text = $2782c2b9d9676823$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$2782c2b9d9676823$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $2782c2b9d9676823$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $2782c2b9d9676823$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $2782c2b9d9676823$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $2782c2b9d9676823$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $2782c2b9d9676823$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $2782c2b9d9676823$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $2782c2b9d9676823$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $2782c2b9d9676823$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $2782c2b9d9676823$var$utf8Text(buf, i) {
    var total = $2782c2b9d9676823$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $2782c2b9d9676823$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $2782c2b9d9676823$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $2782c2b9d9676823$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $2782c2b9d9676823$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $2782c2b9d9676823$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $2782c2b9d9676823$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $2782c2b9d9676823$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});
parcelRegister("8C0pl", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $b0qLu = parcelRequire("b0qLu");
var $645230540ca4f10f$var$Buffer = $b0qLu.Buffer;
// alternative to using Object.keys for old browsers
function $645230540ca4f10f$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($645230540ca4f10f$var$Buffer.from && $645230540ca4f10f$var$Buffer.alloc && $645230540ca4f10f$var$Buffer.allocUnsafe && $645230540ca4f10f$var$Buffer.allocUnsafeSlow) module.exports = $b0qLu;
else {
    // Copy properties from require('buffer')
    $645230540ca4f10f$var$copyProps($b0qLu, module.exports);
    module.exports.Buffer = $645230540ca4f10f$var$SafeBuffer;
}
function $645230540ca4f10f$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $645230540ca4f10f$var$Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
$645230540ca4f10f$var$copyProps($645230540ca4f10f$var$Buffer, $645230540ca4f10f$var$SafeBuffer);
$645230540ca4f10f$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $645230540ca4f10f$var$Buffer(arg, encodingOrOffset, length);
};
$645230540ca4f10f$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $645230540ca4f10f$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$645230540ca4f10f$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $645230540ca4f10f$var$Buffer(size);
};
$645230540ca4f10f$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $b0qLu.SlowBuffer(size);
};

});



parcelRegister("6ysZI", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $4c5c68bdd75fef13$var$Transform;

var $hjOgI = parcelRequire("hjOgI");

/*<replacement>*/ var $4c5c68bdd75fef13$var$util = Object.create((parcelRequire("5mxBc")));

$4c5c68bdd75fef13$var$util.inherits = (parcelRequire("jcXeW"));
/*</replacement>*/ $4c5c68bdd75fef13$var$util.inherits($4c5c68bdd75fef13$var$Transform, $hjOgI);
function $4c5c68bdd75fef13$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (!cb) return this.emit('error', new Error('write callback called multiple times'));
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $4c5c68bdd75fef13$var$Transform(options) {
    if (!(this instanceof $4c5c68bdd75fef13$var$Transform)) return new $4c5c68bdd75fef13$var$Transform(options);
    $hjOgI.call(this, options);
    this._transformState = {
        afterTransform: $4c5c68bdd75fef13$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $4c5c68bdd75fef13$var$prefinish);
}
function $4c5c68bdd75fef13$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function') this._flush(function(er, data) {
        $4c5c68bdd75fef13$var$done(_this, er, data);
    });
    else $4c5c68bdd75fef13$var$done(this, null, null);
}
$4c5c68bdd75fef13$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $hjOgI.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$4c5c68bdd75fef13$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    throw new Error('_transform() is not implemented');
};
$4c5c68bdd75fef13$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$4c5c68bdd75fef13$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$4c5c68bdd75fef13$var$Transform.prototype._destroy = function(err, cb) {
    var _this2 = this;
    $hjOgI.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
        _this2.emit('close');
    });
};
function $4c5c68bdd75fef13$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) stream.push(data);
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
    if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
    return stream.push(null);
}

});

parcelRegister("3aC57", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $24efd87c3383116a$var$PassThrough;

var $6ysZI = parcelRequire("6ysZI");

/*<replacement>*/ var $24efd87c3383116a$var$util = Object.create((parcelRequire("5mxBc")));

$24efd87c3383116a$var$util.inherits = (parcelRequire("jcXeW"));
/*</replacement>*/ $24efd87c3383116a$var$util.inherits($24efd87c3383116a$var$PassThrough, $6ysZI);
function $24efd87c3383116a$var$PassThrough(options) {
    if (!(this instanceof $24efd87c3383116a$var$PassThrough)) return new $24efd87c3383116a$var$PassThrough(options);
    $6ysZI.call(this, options);
}
$24efd87c3383116a$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});


parcelRegister("a59rc", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("luYXS")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, 'Invalid character in ' + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, 'Invalid character');
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') try {
        BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === 'le' ? 'LE' : 'BE';
        this['_toArrayLike' + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("cor5J", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"elliptic\",\"version\":\"6.6.1\",\"description\":\"EC cryptography\",\"main\":\"lib/elliptic.js\",\"files\":[\"lib\"],\"scripts\":{\"lint\":\"eslint lib test\",\"lint:fix\":\"npm run lint -- --fix\",\"unit\":\"istanbul test _mocha --reporter=spec test/index.js\",\"test\":\"npm run lint && npm run unit\",\"version\":\"grunt dist && git add dist/\"},\"repository\":{\"type\":\"git\",\"url\":\"git@github.com:indutny/elliptic\"},\"keywords\":[\"EC\",\"Elliptic\",\"curve\",\"Cryptography\"],\"author\":\"Fedor Indutny <fedor@indutny.com>\",\"license\":\"MIT\",\"bugs\":{\"url\":\"https://github.com/indutny/elliptic/issues\"},\"homepage\":\"https://github.com/indutny/elliptic\",\"devDependencies\":{\"brfs\":\"^2.0.2\",\"coveralls\":\"^3.1.0\",\"eslint\":\"^7.6.0\",\"grunt\":\"^1.2.1\",\"grunt-browserify\":\"^5.3.0\",\"grunt-cli\":\"^1.3.2\",\"grunt-contrib-connect\":\"^3.0.0\",\"grunt-contrib-copy\":\"^1.0.0\",\"grunt-contrib-uglify\":\"^5.0.0\",\"grunt-mocha-istanbul\":\"^5.0.2\",\"grunt-saucelabs\":\"^9.0.1\",\"istanbul\":\"^0.4.5\",\"mocha\":\"^8.0.1\"},\"dependencies\":{\"bn.js\":\"^4.11.9\",\"brorand\":\"^1.1.0\",\"hash.js\":\"^1.0.0\",\"hmac-drbg\":\"^1.0.1\",\"inherits\":\"^2.0.4\",\"minimalistic-assert\":\"^1.0.1\",\"minimalistic-crypto-utils\":\"^1.0.1\"}}");

});

parcelRegister("4PW5d", function(module, exports) {
'use strict';
var $3858faf3a261caef$var$utils = module.exports;

var $kHwXh = parcelRequire("kHwXh");

var $hILGj = parcelRequire("hILGj");

var $fZ2Y3 = parcelRequire("fZ2Y3");
$3858faf3a261caef$var$utils.assert = $hILGj;
$3858faf3a261caef$var$utils.toArray = $fZ2Y3.toArray;
$3858faf3a261caef$var$utils.zero2 = $fZ2Y3.zero2;
$3858faf3a261caef$var$utils.toHex = $fZ2Y3.toHex;
$3858faf3a261caef$var$utils.encode = $fZ2Y3.encode;
// Represent num in a w-NAF form
function $3858faf3a261caef$var$getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    var i;
    for(i = 0; i < naf.length; i += 1)naf[i] = 0;
    var ws = 1 << w + 1;
    var k = num.clone();
    for(i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
$3858faf3a261caef$var$utils.getNAF = $3858faf3a261caef$var$getNAF;
// Represent k1, k2 in a Joint Sparse Form
function $3858faf3a261caef$var$getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
$3858faf3a261caef$var$utils.getJSF = $3858faf3a261caef$var$getJSF;
function $3858faf3a261caef$var$cachedProperty(obj, name, computer) {
    var key = '_' + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
$3858faf3a261caef$var$utils.cachedProperty = $3858faf3a261caef$var$cachedProperty;
function $3858faf3a261caef$var$parseBytes(bytes) {
    return typeof bytes === 'string' ? $3858faf3a261caef$var$utils.toArray(bytes, 'hex') : bytes;
}
$3858faf3a261caef$var$utils.parseBytes = $3858faf3a261caef$var$parseBytes;
function $3858faf3a261caef$var$intFromLE(bytes) {
    return new $kHwXh(bytes, 'hex', 'le');
}
$3858faf3a261caef$var$utils.intFromLE = $3858faf3a261caef$var$intFromLE;

});
parcelRegister("fZ2Y3", function(module, exports) {
'use strict';
var $ba2edada3685b59f$var$utils = module.exports;
function $ba2edada3685b59f$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== 'string') {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === 'hex') {
        msg = msg.replace(/[^a-z0-9]+/ig, '');
        if (msg.length % 2 !== 0) msg = '0' + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
$ba2edada3685b59f$var$utils.toArray = $ba2edada3685b59f$var$toArray;
function $ba2edada3685b59f$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$ba2edada3685b59f$var$utils.zero2 = $ba2edada3685b59f$var$zero2;
function $ba2edada3685b59f$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $ba2edada3685b59f$var$zero2(msg[i].toString(16));
    return res;
}
$ba2edada3685b59f$var$utils.toHex = $ba2edada3685b59f$var$toHex;
$ba2edada3685b59f$var$utils.encode = function encode(arr, enc) {
    if (enc === 'hex') return $ba2edada3685b59f$var$toHex(arr);
    else return arr;
};

});


parcelRegister("cqacU", function(module, exports) {
'use strict';
var $90afd4b29c042587$var$curve = module.exports;

$90afd4b29c042587$var$curve.base = (parcelRequire("b9biB"));

$90afd4b29c042587$var$curve.short = (parcelRequire("cbHgY"));

$90afd4b29c042587$var$curve.mont = (parcelRequire("knWtF"));

$90afd4b29c042587$var$curve.edwards = (parcelRequire("5W0pS"));

});
parcelRegister("b9biB", function(module, exports) {
'use strict';

var $kHwXh = parcelRequire("kHwXh");

var $4PW5d = parcelRequire("4PW5d");
var $81d94cb602b82fee$var$getNAF = $4PW5d.getNAF;
var $81d94cb602b82fee$var$getJSF = $4PW5d.getJSF;
var $81d94cb602b82fee$var$assert = $4PW5d.assert;
function $81d94cb602b82fee$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new $kHwXh(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? $kHwXh.red(conf.prime) : $kHwXh.mont(this.p);
    // Useful for many curves
    this.zero = new $kHwXh(0).toRed(this.red);
    this.one = new $kHwXh(1).toRed(this.red);
    this.two = new $kHwXh(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new $kHwXh(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = $81d94cb602b82fee$var$BaseCurve;
$81d94cb602b82fee$var$BaseCurve.prototype.point = function point() {
    throw new Error('Not implemented');
};
$81d94cb602b82fee$var$BaseCurve.prototype.validate = function validate() {
    throw new Error('Not implemented');
};
$81d94cb602b82fee$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $81d94cb602b82fee$var$assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $81d94cb602b82fee$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$81d94cb602b82fee$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $81d94cb602b82fee$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $81d94cb602b82fee$var$assert(z !== 0);
        if (p.type === 'affine') {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === 'affine' ? acc.toP() : acc;
};
$81d94cb602b82fee$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $81d94cb602b82fee$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $81d94cb602b82fee$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $81d94cb602b82fee$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === 'affine') acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $81d94cb602b82fee$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$81d94cb602b82fee$var$BaseCurve.BasePoint = $81d94cb602b82fee$var$BasePoint;
$81d94cb602b82fee$var$BasePoint.prototype.eq = function eq() {
    throw new Error('Not implemented');
};
$81d94cb602b82fee$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$81d94cb602b82fee$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $4PW5d.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $81d94cb602b82fee$var$assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $81d94cb602b82fee$var$assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error('Unknown point format');
};
$81d94cb602b82fee$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$81d94cb602b82fee$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray('be', len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray('be', len));
};
$81d94cb602b82fee$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $4PW5d.encode(this._encode(compact), enc);
};
$81d94cb602b82fee$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$81d94cb602b82fee$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$81d94cb602b82fee$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$81d94cb602b82fee$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$81d94cb602b82fee$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$81d94cb602b82fee$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

});

parcelRegister("cbHgY", function(module, exports) {
'use strict';

var $4PW5d = parcelRequire("4PW5d");

var $kHwXh = parcelRequire("kHwXh");

var $jcXeW = parcelRequire("jcXeW");

var $b9biB = parcelRequire("b9biB");
var $8df8143467a035a2$var$assert = $4PW5d.assert;
function $8df8143467a035a2$var$ShortCurve(conf) {
    $b9biB.call(this, 'short', conf);
    this.a = new $kHwXh(conf.a, 16).toRed(this.red);
    this.b = new $kHwXh(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$jcXeW($8df8143467a035a2$var$ShortCurve, $b9biB);
module.exports = $8df8143467a035a2$var$ShortCurve;
$8df8143467a035a2$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new $kHwXh(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new $kHwXh(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $8df8143467a035a2$var$assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new $kHwXh(vec.a, 16),
            b: new $kHwXh(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$8df8143467a035a2$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : $kHwXh.mont(num);
    var tinv = new $kHwXh(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new $kHwXh(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$8df8143467a035a2$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new $kHwXh(1);
    var y1 = new $kHwXh(0);
    var x2 = new $kHwXh(0);
    var y2 = new $kHwXh(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$8df8143467a035a2$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$8df8143467a035a2$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $kHwXh(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$8df8143467a035a2$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$8df8143467a035a2$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $8df8143467a035a2$var$Point(curve, x, y, isRed) {
    $b9biB.BasePoint.call(this, curve, 'affine');
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new $kHwXh(x, 16);
        this.y = new $kHwXh(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$jcXeW($8df8143467a035a2$var$Point, $b9biB.BasePoint);
$8df8143467a035a2$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $8df8143467a035a2$var$Point(this, x, y, isRed);
};
$8df8143467a035a2$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $8df8143467a035a2$var$Point.fromJSON(this, obj, red);
};
$8df8143467a035a2$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$8df8143467a035a2$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$8df8143467a035a2$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === 'string') obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$8df8143467a035a2$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};
$8df8143467a035a2$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$8df8143467a035a2$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$8df8143467a035a2$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$8df8143467a035a2$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$8df8143467a035a2$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$8df8143467a035a2$var$Point.prototype.mul = function mul(k) {
    k = new $kHwXh(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$8df8143467a035a2$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$8df8143467a035a2$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$8df8143467a035a2$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$8df8143467a035a2$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$8df8143467a035a2$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $8df8143467a035a2$var$JPoint(curve, x, y, z) {
    $b9biB.BasePoint.call(this, curve, 'jacobian');
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new $kHwXh(0);
    } else {
        this.x = new $kHwXh(x, 16);
        this.y = new $kHwXh(y, 16);
        this.z = new $kHwXh(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$jcXeW($8df8143467a035a2$var$JPoint, $b9biB.BasePoint);
$8df8143467a035a2$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $8df8143467a035a2$var$JPoint(this, x, y, z);
};
$8df8143467a035a2$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$8df8143467a035a2$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$8df8143467a035a2$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$8df8143467a035a2$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$8df8143467a035a2$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$8df8143467a035a2$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$8df8143467a035a2$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$8df8143467a035a2$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$8df8143467a035a2$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$8df8143467a035a2$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$8df8143467a035a2$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new $kHwXh(k, kbase);
    return this.curve._wnafMul(this, k);
};
$8df8143467a035a2$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === 'affine') return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$8df8143467a035a2$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$8df8143467a035a2$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC JPoint Infinity>';
    return '<EC JPoint x: ' + this.x.toString(16, 2) + ' y: ' + this.y.toString(16, 2) + ' z: ' + this.z.toString(16, 2) + '>';
};
$8df8143467a035a2$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

});

parcelRegister("knWtF", function(module, exports) {
'use strict';

var $kHwXh = parcelRequire("kHwXh");

var $jcXeW = parcelRequire("jcXeW");

var $b9biB = parcelRequire("b9biB");

var $4PW5d = parcelRequire("4PW5d");
function $ed7351062e764ecd$var$MontCurve(conf) {
    $b9biB.call(this, 'mont', conf);
    this.a = new $kHwXh(conf.a, 16).toRed(this.red);
    this.b = new $kHwXh(conf.b, 16).toRed(this.red);
    this.i4 = new $kHwXh(4).toRed(this.red).redInvm();
    this.two = new $kHwXh(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
$jcXeW($ed7351062e764ecd$var$MontCurve, $b9biB);
module.exports = $ed7351062e764ecd$var$MontCurve;
$ed7351062e764ecd$var$MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function $ed7351062e764ecd$var$Point(curve, x, z) {
    $b9biB.BasePoint.call(this, curve, 'projective');
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new $kHwXh(x, 16);
        this.z = new $kHwXh(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
$jcXeW($ed7351062e764ecd$var$Point, $b9biB.BasePoint);
$ed7351062e764ecd$var$MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point($4PW5d.toArray(bytes, enc), 1);
};
$ed7351062e764ecd$var$MontCurve.prototype.point = function point(x, z) {
    return new $ed7351062e764ecd$var$Point(this, x, z);
};
$ed7351062e764ecd$var$MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $ed7351062e764ecd$var$Point.fromJSON(this, obj);
};
$ed7351062e764ecd$var$Point.prototype.precompute = function precompute() {
// No-op
};
$ed7351062e764ecd$var$Point.prototype._encode = function _encode() {
    return this.getX().toArray('be', this.curve.p.byteLength());
};
$ed7351062e764ecd$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $ed7351062e764ecd$var$Point(curve, obj[0], obj[1] || curve.one);
};
$ed7351062e764ecd$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
$ed7351062e764ecd$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
$ed7351062e764ecd$var$Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
$ed7351062e764ecd$var$Point.prototype.add = function add() {
    throw new Error('Not supported on Montgomery curve');
};
$ed7351062e764ecd$var$Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
$ed7351062e764ecd$var$Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
$ed7351062e764ecd$var$Point.prototype.mulAdd = function mulAdd() {
    throw new Error('Not supported on Montgomery curve');
};
$ed7351062e764ecd$var$Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error('Not supported on Montgomery curve');
};
$ed7351062e764ecd$var$Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
$ed7351062e764ecd$var$Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
$ed7351062e764ecd$var$Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

});

parcelRegister("5W0pS", function(module, exports) {
'use strict';

var $4PW5d = parcelRequire("4PW5d");

var $kHwXh = parcelRequire("kHwXh");

var $jcXeW = parcelRequire("jcXeW");

var $b9biB = parcelRequire("b9biB");
var $4522b13083f913f6$var$assert = $4PW5d.assert;
function $4522b13083f913f6$var$EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    $b9biB.call(this, 'edwards', conf);
    this.a = new $kHwXh(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new $kHwXh(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new $kHwXh(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    $4522b13083f913f6$var$assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
$jcXeW($4522b13083f913f6$var$EdwardsCurve, $b9biB);
module.exports = $4522b13083f913f6$var$EdwardsCurve;
$4522b13083f913f6$var$EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
$4522b13083f913f6$var$EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
$4522b13083f913f6$var$EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
$4522b13083f913f6$var$EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $kHwXh(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$4522b13083f913f6$var$EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new $kHwXh(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error('invalid point');
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error('invalid point');
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
$4522b13083f913f6$var$EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function $4522b13083f913f6$var$Point(curve, x, y, z, t) {
    $b9biB.BasePoint.call(this, curve, 'projective');
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new $kHwXh(x, 16);
        this.y = new $kHwXh(y, 16);
        this.z = z ? new $kHwXh(z, 16) : this.curve.one;
        this.t = t && new $kHwXh(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
$jcXeW($4522b13083f913f6$var$Point, $b9biB.BasePoint);
$4522b13083f913f6$var$EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $4522b13083f913f6$var$Point.fromJSON(this, obj);
};
$4522b13083f913f6$var$EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new $4522b13083f913f6$var$Point(this, x, y, z, t);
};
$4522b13083f913f6$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $4522b13083f913f6$var$Point(curve, obj[0], obj[1], obj[2]);
};
$4522b13083f913f6$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
$4522b13083f913f6$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
$4522b13083f913f6$var$Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$4522b13083f913f6$var$Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
$4522b13083f913f6$var$Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
$4522b13083f913f6$var$Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$4522b13083f913f6$var$Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
$4522b13083f913f6$var$Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
$4522b13083f913f6$var$Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
$4522b13083f913f6$var$Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
$4522b13083f913f6$var$Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
$4522b13083f913f6$var$Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
$4522b13083f913f6$var$Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
$4522b13083f913f6$var$Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
$4522b13083f913f6$var$Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
$4522b13083f913f6$var$Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
$4522b13083f913f6$var$Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
$4522b13083f913f6$var$Point.prototype.toP = $4522b13083f913f6$var$Point.prototype.normalize;
$4522b13083f913f6$var$Point.prototype.mixedAdd = $4522b13083f913f6$var$Point.prototype.add;

});


parcelRegister("6Ek6o", function(module, exports) {
'use strict';
var $4d761262b27001f1$var$curves = module.exports;

var $cHC35 = parcelRequire("cHC35");

var $cqacU = parcelRequire("cqacU");

var $4PW5d = parcelRequire("4PW5d");
var $4d761262b27001f1$var$assert = $4PW5d.assert;
function $4d761262b27001f1$var$PresetCurve(options) {
    if (options.type === 'short') this.curve = new $cqacU.short(options);
    else if (options.type === 'edwards') this.curve = new $cqacU.edwards(options);
    else this.curve = new $cqacU.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    $4d761262b27001f1$var$assert(this.g.validate(), 'Invalid curve');
    $4d761262b27001f1$var$assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
$4d761262b27001f1$var$curves.PresetCurve = $4d761262b27001f1$var$PresetCurve;
function $4d761262b27001f1$var$defineCurve(name, options) {
    Object.defineProperty($4d761262b27001f1$var$curves, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var curve = new $4d761262b27001f1$var$PresetCurve(options);
            Object.defineProperty($4d761262b27001f1$var$curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
$4d761262b27001f1$var$defineCurve('p192', {
    type: 'short',
    prime: 'p192',
    p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
    b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
    n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
    hash: $cHC35.sha256,
    gRed: false,
    g: [
        '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
        '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811'
    ]
});
$4d761262b27001f1$var$defineCurve('p224', {
    type: 'short',
    prime: 'p224',
    p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
    b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
    n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
    hash: $cHC35.sha256,
    gRed: false,
    g: [
        'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
        'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34'
    ]
});
$4d761262b27001f1$var$defineCurve('p256', {
    type: 'short',
    prime: null,
    p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
    a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
    b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
    n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
    hash: $cHC35.sha256,
    gRed: false,
    g: [
        '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
        '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5'
    ]
});
$4d761262b27001f1$var$defineCurve('p384', {
    type: 'short',
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: $cHC35.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
$4d761262b27001f1$var$defineCurve('p521', {
    type: 'short',
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: $cHC35.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
$4d761262b27001f1$var$defineCurve('curve25519', {
    type: 'mont',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '76d06',
    b: '1',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: $cHC35.sha256,
    gRed: false,
    g: [
        '9'
    ]
});
$4d761262b27001f1$var$defineCurve('ed25519', {
    type: 'edwards',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '-1',
    c: '1',
    // -121665 * (121666^(-1)) (mod P)
    d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: $cHC35.sha256,
    gRed: false,
    g: [
        '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',
        // 4/5
        '6666666666666666666666666666666666666666666666666666666666666658'
    ]
});
var $4d761262b27001f1$var$pre;

try {
    $4d761262b27001f1$var$pre = (parcelRequire("lkq84"));
} catch (e) {
    $4d761262b27001f1$var$pre = undefined;
}
$4d761262b27001f1$var$defineCurve('secp256k1', {
    type: 'short',
    prime: 'k256',
    p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
    a: '0',
    b: '7',
    n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
    h: '1',
    hash: $cHC35.sha256,
    // Precomputed endomorphism
    beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
    lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
    basis: [
        {
            a: '3086d221a7d46bcde86c90e49284eb15',
            b: '-e4437ed6010e88286f547fa90abfe4c3'
        },
        {
            a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
            b: '3086d221a7d46bcde86c90e49284eb15'
        }
    ],
    gRed: false,
    g: [
        '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
        '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
        $4d761262b27001f1$var$pre
    ]
});

});
parcelRegister("cHC35", function(module, exports) {
var $93f703e150c55e86$var$hash = module.exports;

$93f703e150c55e86$var$hash.utils = (parcelRequire("1X2xg"));

$93f703e150c55e86$var$hash.common = (parcelRequire("6wmUd"));

$93f703e150c55e86$var$hash.sha = (parcelRequire("5Jkwi"));

$93f703e150c55e86$var$hash.ripemd = (parcelRequire("9yolU"));

$93f703e150c55e86$var$hash.hmac = (parcelRequire("1BeMN"));
// Proxy hash functions to the main object
$93f703e150c55e86$var$hash.sha1 = $93f703e150c55e86$var$hash.sha.sha1;
$93f703e150c55e86$var$hash.sha256 = $93f703e150c55e86$var$hash.sha.sha256;
$93f703e150c55e86$var$hash.sha224 = $93f703e150c55e86$var$hash.sha.sha224;
$93f703e150c55e86$var$hash.sha384 = $93f703e150c55e86$var$hash.sha.sha384;
$93f703e150c55e86$var$hash.sha512 = $93f703e150c55e86$var$hash.sha.sha512;
$93f703e150c55e86$var$hash.ripemd160 = $93f703e150c55e86$var$hash.ripemd.ripemd160;

});
parcelRegister("1X2xg", function(module, exports) {
$parcel$export(module.exports, "inherits", () => $16bd449c78c94605$export$69f1b2dcda23c5f8, (v) => $16bd449c78c94605$export$69f1b2dcda23c5f8 = v);
$parcel$export(module.exports, "toArray", () => $16bd449c78c94605$export$45b10814cc054894, (v) => $16bd449c78c94605$export$45b10814cc054894 = v);
$parcel$export(module.exports, "toHex", () => $16bd449c78c94605$export$7ea66e3774a60b67, (v) => $16bd449c78c94605$export$7ea66e3774a60b67 = v);
$parcel$export(module.exports, "htonl", () => $16bd449c78c94605$export$34a52f00f601f6f1, (v) => $16bd449c78c94605$export$34a52f00f601f6f1 = v);
$parcel$export(module.exports, "toHex32", () => $16bd449c78c94605$export$812b0cbd5e8a72ab, (v) => $16bd449c78c94605$export$812b0cbd5e8a72ab = v);
$parcel$export(module.exports, "zero2", () => $16bd449c78c94605$export$f24f9e11d63bb314, (v) => $16bd449c78c94605$export$f24f9e11d63bb314 = v);
$parcel$export(module.exports, "zero8", () => $16bd449c78c94605$export$b71357c7e07ca1f1, (v) => $16bd449c78c94605$export$b71357c7e07ca1f1 = v);
$parcel$export(module.exports, "join32", () => $16bd449c78c94605$export$2e58a4b541fdcbe8, (v) => $16bd449c78c94605$export$2e58a4b541fdcbe8 = v);
$parcel$export(module.exports, "split32", () => $16bd449c78c94605$export$183b950bde9faab8, (v) => $16bd449c78c94605$export$183b950bde9faab8 = v);
$parcel$export(module.exports, "rotr32", () => $16bd449c78c94605$export$4785c77169fea59e, (v) => $16bd449c78c94605$export$4785c77169fea59e = v);
$parcel$export(module.exports, "rotl32", () => $16bd449c78c94605$export$242a185dfcffac5b, (v) => $16bd449c78c94605$export$242a185dfcffac5b = v);
$parcel$export(module.exports, "sum32", () => $16bd449c78c94605$export$58c04ae0ae31877d, (v) => $16bd449c78c94605$export$58c04ae0ae31877d = v);
$parcel$export(module.exports, "sum32_3", () => $16bd449c78c94605$export$d058ca695f8c6f11, (v) => $16bd449c78c94605$export$d058ca695f8c6f11 = v);
$parcel$export(module.exports, "sum32_4", () => $16bd449c78c94605$export$a1efd7fc3e986367, (v) => $16bd449c78c94605$export$a1efd7fc3e986367 = v);
$parcel$export(module.exports, "sum32_5", () => $16bd449c78c94605$export$bbfea4a2b5abaab4, (v) => $16bd449c78c94605$export$bbfea4a2b5abaab4 = v);
$parcel$export(module.exports, "sum64", () => $16bd449c78c94605$export$97ad4afc7de86152, (v) => $16bd449c78c94605$export$97ad4afc7de86152 = v);
$parcel$export(module.exports, "sum64_hi", () => $16bd449c78c94605$export$ce4673d9a79f6a4b, (v) => $16bd449c78c94605$export$ce4673d9a79f6a4b = v);
$parcel$export(module.exports, "sum64_lo", () => $16bd449c78c94605$export$786cc99fc6eedc0b, (v) => $16bd449c78c94605$export$786cc99fc6eedc0b = v);
$parcel$export(module.exports, "sum64_4_hi", () => $16bd449c78c94605$export$45c59b9a1848dd0, (v) => $16bd449c78c94605$export$45c59b9a1848dd0 = v);
$parcel$export(module.exports, "sum64_4_lo", () => $16bd449c78c94605$export$50d8f613e76d3034, (v) => $16bd449c78c94605$export$50d8f613e76d3034 = v);
$parcel$export(module.exports, "sum64_5_hi", () => $16bd449c78c94605$export$b8e83683c60ee162, (v) => $16bd449c78c94605$export$b8e83683c60ee162 = v);
$parcel$export(module.exports, "sum64_5_lo", () => $16bd449c78c94605$export$aeeb51790d1bcc4a, (v) => $16bd449c78c94605$export$aeeb51790d1bcc4a = v);
$parcel$export(module.exports, "rotr64_hi", () => $16bd449c78c94605$export$bb7c616f719ad9c, (v) => $16bd449c78c94605$export$bb7c616f719ad9c = v);
$parcel$export(module.exports, "rotr64_lo", () => $16bd449c78c94605$export$4d63290824f9d7df, (v) => $16bd449c78c94605$export$4d63290824f9d7df = v);
$parcel$export(module.exports, "shr64_hi", () => $16bd449c78c94605$export$2f64ceb90ef28ea1, (v) => $16bd449c78c94605$export$2f64ceb90ef28ea1 = v);
$parcel$export(module.exports, "shr64_lo", () => $16bd449c78c94605$export$8d2089d465f6d10d, (v) => $16bd449c78c94605$export$8d2089d465f6d10d = v);
var $16bd449c78c94605$export$69f1b2dcda23c5f8;
var $16bd449c78c94605$export$45b10814cc054894;
var $16bd449c78c94605$export$7ea66e3774a60b67;
var $16bd449c78c94605$export$34a52f00f601f6f1;
var $16bd449c78c94605$export$812b0cbd5e8a72ab;
var $16bd449c78c94605$export$f24f9e11d63bb314;
var $16bd449c78c94605$export$b71357c7e07ca1f1;
var $16bd449c78c94605$export$2e58a4b541fdcbe8;
var $16bd449c78c94605$export$183b950bde9faab8;
var $16bd449c78c94605$export$4785c77169fea59e;
var $16bd449c78c94605$export$242a185dfcffac5b;
var $16bd449c78c94605$export$58c04ae0ae31877d;
var $16bd449c78c94605$export$d058ca695f8c6f11;
var $16bd449c78c94605$export$a1efd7fc3e986367;
var $16bd449c78c94605$export$bbfea4a2b5abaab4;
var $16bd449c78c94605$export$97ad4afc7de86152;
var $16bd449c78c94605$export$ce4673d9a79f6a4b;
var $16bd449c78c94605$export$786cc99fc6eedc0b;
var $16bd449c78c94605$export$45c59b9a1848dd0;
var $16bd449c78c94605$export$50d8f613e76d3034;
var $16bd449c78c94605$export$b8e83683c60ee162;
var $16bd449c78c94605$export$aeeb51790d1bcc4a;
var $16bd449c78c94605$export$bb7c616f719ad9c;
var $16bd449c78c94605$export$4d63290824f9d7df;
var $16bd449c78c94605$export$2f64ceb90ef28ea1;
var $16bd449c78c94605$export$8d2089d465f6d10d;
'use strict';

var $hILGj = parcelRequire("hILGj");

var $jcXeW = parcelRequire("jcXeW");
$16bd449c78c94605$export$69f1b2dcda23c5f8 = $jcXeW;
function $16bd449c78c94605$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $16bd449c78c94605$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === 'string') {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($16bd449c78c94605$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === 'hex') {
            msg = msg.replace(/[^a-z0-9]+/ig, '');
            if (msg.length % 2 !== 0) msg = '0' + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$16bd449c78c94605$export$45b10814cc054894 = $16bd449c78c94605$var$toArray;
function $16bd449c78c94605$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $16bd449c78c94605$var$zero2(msg[i].toString(16));
    return res;
}
$16bd449c78c94605$export$7ea66e3774a60b67 = $16bd449c78c94605$var$toHex;
function $16bd449c78c94605$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$16bd449c78c94605$export$34a52f00f601f6f1 = $16bd449c78c94605$var$htonl;
function $16bd449c78c94605$var$toHex32(msg, endian) {
    var res = '';
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === 'little') w = $16bd449c78c94605$var$htonl(w);
        res += $16bd449c78c94605$var$zero8(w.toString(16));
    }
    return res;
}
$16bd449c78c94605$export$812b0cbd5e8a72ab = $16bd449c78c94605$var$toHex32;
function $16bd449c78c94605$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$16bd449c78c94605$export$f24f9e11d63bb314 = $16bd449c78c94605$var$zero2;
function $16bd449c78c94605$var$zero8(word) {
    if (word.length === 7) return '0' + word;
    else if (word.length === 6) return '00' + word;
    else if (word.length === 5) return '000' + word;
    else if (word.length === 4) return '0000' + word;
    else if (word.length === 3) return '00000' + word;
    else if (word.length === 2) return '000000' + word;
    else if (word.length === 1) return '0000000' + word;
    else return word;
}
$16bd449c78c94605$export$b71357c7e07ca1f1 = $16bd449c78c94605$var$zero8;
function $16bd449c78c94605$var$join32(msg, start, end, endian) {
    var len = end - start;
    $hILGj(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === 'big') w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$16bd449c78c94605$export$2e58a4b541fdcbe8 = $16bd449c78c94605$var$join32;
function $16bd449c78c94605$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === 'big') {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$16bd449c78c94605$export$183b950bde9faab8 = $16bd449c78c94605$var$split32;
function $16bd449c78c94605$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$16bd449c78c94605$export$4785c77169fea59e = $16bd449c78c94605$var$rotr32;
function $16bd449c78c94605$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$16bd449c78c94605$export$242a185dfcffac5b = $16bd449c78c94605$var$rotl32;
function $16bd449c78c94605$var$sum32(a, b) {
    return a + b >>> 0;
}
$16bd449c78c94605$export$58c04ae0ae31877d = $16bd449c78c94605$var$sum32;
function $16bd449c78c94605$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$16bd449c78c94605$export$d058ca695f8c6f11 = $16bd449c78c94605$var$sum32_3;
function $16bd449c78c94605$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$16bd449c78c94605$export$a1efd7fc3e986367 = $16bd449c78c94605$var$sum32_4;
function $16bd449c78c94605$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$16bd449c78c94605$export$bbfea4a2b5abaab4 = $16bd449c78c94605$var$sum32_5;
function $16bd449c78c94605$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$16bd449c78c94605$export$97ad4afc7de86152 = $16bd449c78c94605$var$sum64;
function $16bd449c78c94605$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$16bd449c78c94605$export$ce4673d9a79f6a4b = $16bd449c78c94605$var$sum64_hi;
function $16bd449c78c94605$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$16bd449c78c94605$export$786cc99fc6eedc0b = $16bd449c78c94605$var$sum64_lo;
function $16bd449c78c94605$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$16bd449c78c94605$export$45c59b9a1848dd0 = $16bd449c78c94605$var$sum64_4_hi;
function $16bd449c78c94605$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$16bd449c78c94605$export$50d8f613e76d3034 = $16bd449c78c94605$var$sum64_4_lo;
function $16bd449c78c94605$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$16bd449c78c94605$export$b8e83683c60ee162 = $16bd449c78c94605$var$sum64_5_hi;
function $16bd449c78c94605$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$16bd449c78c94605$export$aeeb51790d1bcc4a = $16bd449c78c94605$var$sum64_5_lo;
function $16bd449c78c94605$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$16bd449c78c94605$export$bb7c616f719ad9c = $16bd449c78c94605$var$rotr64_hi;
function $16bd449c78c94605$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$16bd449c78c94605$export$4d63290824f9d7df = $16bd449c78c94605$var$rotr64_lo;
function $16bd449c78c94605$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$16bd449c78c94605$export$2f64ceb90ef28ea1 = $16bd449c78c94605$var$shr64_hi;
function $16bd449c78c94605$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$16bd449c78c94605$export$8d2089d465f6d10d = $16bd449c78c94605$var$shr64_lo;

});

parcelRegister("6wmUd", function(module, exports) {
$parcel$export(module.exports, "BlockHash", () => $4bf77fd23e28a895$export$8687658379b577e6, (v) => $4bf77fd23e28a895$export$8687658379b577e6 = v);
var $4bf77fd23e28a895$export$8687658379b577e6;
'use strict';

var $1X2xg = parcelRequire("1X2xg");

var $hILGj = parcelRequire("hILGj");
function $4bf77fd23e28a895$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = 'big';
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$4bf77fd23e28a895$export$8687658379b577e6 = $4bf77fd23e28a895$var$BlockHash;
$4bf77fd23e28a895$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $1X2xg.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $1X2xg.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$4bf77fd23e28a895$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $hILGj(this.pending === null);
    return this._digest(enc);
};
$4bf77fd23e28a895$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === 'big') {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRegister("5Jkwi", function(module, exports) {
$parcel$export(module.exports, "sha1", () => $42c1129039505832$export$5091bdda49ba90f5, (v) => $42c1129039505832$export$5091bdda49ba90f5 = v);
$parcel$export(module.exports, "sha224", () => $42c1129039505832$export$97b70509d4e397ea, (v) => $42c1129039505832$export$97b70509d4e397ea = v);
$parcel$export(module.exports, "sha256", () => $42c1129039505832$export$bced8d2aada2d1c9, (v) => $42c1129039505832$export$bced8d2aada2d1c9 = v);
$parcel$export(module.exports, "sha384", () => $42c1129039505832$export$612d47d55dedde45, (v) => $42c1129039505832$export$612d47d55dedde45 = v);
$parcel$export(module.exports, "sha512", () => $42c1129039505832$export$a888d2532e6dc7bb, (v) => $42c1129039505832$export$a888d2532e6dc7bb = v);
var $42c1129039505832$export$5091bdda49ba90f5;
var $42c1129039505832$export$97b70509d4e397ea;
var $42c1129039505832$export$bced8d2aada2d1c9;
var $42c1129039505832$export$612d47d55dedde45;
var $42c1129039505832$export$a888d2532e6dc7bb;
'use strict';

$42c1129039505832$export$5091bdda49ba90f5 = (parcelRequire("cBJEY"));

$42c1129039505832$export$97b70509d4e397ea = (parcelRequire("ecqjG"));

$42c1129039505832$export$bced8d2aada2d1c9 = (parcelRequire("7nBDm"));

$42c1129039505832$export$612d47d55dedde45 = (parcelRequire("dlrcx"));

$42c1129039505832$export$a888d2532e6dc7bb = (parcelRequire("g42f8"));

});
parcelRegister("cBJEY", function(module, exports) {
'use strict';

var $1X2xg = parcelRequire("1X2xg");

var $6wmUd = parcelRequire("6wmUd");

var $2F0ai = parcelRequire("2F0ai");
var $92dc5bda78010013$var$rotl32 = $1X2xg.rotl32;
var $92dc5bda78010013$var$sum32 = $1X2xg.sum32;
var $92dc5bda78010013$var$sum32_5 = $1X2xg.sum32_5;
var $92dc5bda78010013$var$ft_1 = $2F0ai.ft_1;
var $92dc5bda78010013$var$BlockHash = $6wmUd.BlockHash;
var $92dc5bda78010013$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $92dc5bda78010013$var$SHA1() {
    if (!(this instanceof $92dc5bda78010013$var$SHA1)) return new $92dc5bda78010013$var$SHA1();
    $92dc5bda78010013$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$1X2xg.inherits($92dc5bda78010013$var$SHA1, $92dc5bda78010013$var$BlockHash);
module.exports = $92dc5bda78010013$var$SHA1;
$92dc5bda78010013$var$SHA1.blockSize = 512;
$92dc5bda78010013$var$SHA1.outSize = 160;
$92dc5bda78010013$var$SHA1.hmacStrength = 80;
$92dc5bda78010013$var$SHA1.padLength = 64;
$92dc5bda78010013$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $92dc5bda78010013$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $92dc5bda78010013$var$sum32_5($92dc5bda78010013$var$rotl32(a, 5), $92dc5bda78010013$var$ft_1(s, b, c, d), e, W[i], $92dc5bda78010013$var$sha1_K[s]);
        e = d;
        d = c;
        c = $92dc5bda78010013$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $92dc5bda78010013$var$sum32(this.h[0], a);
    this.h[1] = $92dc5bda78010013$var$sum32(this.h[1], b);
    this.h[2] = $92dc5bda78010013$var$sum32(this.h[2], c);
    this.h[3] = $92dc5bda78010013$var$sum32(this.h[3], d);
    this.h[4] = $92dc5bda78010013$var$sum32(this.h[4], e);
};
$92dc5bda78010013$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $1X2xg.toHex32(this.h, 'big');
    else return $1X2xg.split32(this.h, 'big');
};

});
parcelRegister("2F0ai", function(module, exports) {
$parcel$export(module.exports, "ft_1", () => $1eff89e6e13835e8$export$5a92649d7ddb9f63, (v) => $1eff89e6e13835e8$export$5a92649d7ddb9f63 = v);
$parcel$export(module.exports, "ch32", () => $1eff89e6e13835e8$export$c6d0d020c3a6269, (v) => $1eff89e6e13835e8$export$c6d0d020c3a6269 = v);
$parcel$export(module.exports, "maj32", () => $1eff89e6e13835e8$export$eb90c27fca05f956, (v) => $1eff89e6e13835e8$export$eb90c27fca05f956 = v);
$parcel$export(module.exports, "s0_256", () => $1eff89e6e13835e8$export$14a4a98e063b1999, (v) => $1eff89e6e13835e8$export$14a4a98e063b1999 = v);
$parcel$export(module.exports, "s1_256", () => $1eff89e6e13835e8$export$d20cecfa1564c686, (v) => $1eff89e6e13835e8$export$d20cecfa1564c686 = v);
$parcel$export(module.exports, "g0_256", () => $1eff89e6e13835e8$export$44fd472a12fc6db, (v) => $1eff89e6e13835e8$export$44fd472a12fc6db = v);
$parcel$export(module.exports, "g1_256", () => $1eff89e6e13835e8$export$1ed238bb6ea1dd47, (v) => $1eff89e6e13835e8$export$1ed238bb6ea1dd47 = v);
var $1eff89e6e13835e8$export$5a92649d7ddb9f63;
var $1eff89e6e13835e8$export$c6d0d020c3a6269;
var $1eff89e6e13835e8$export$eb90c27fca05f956;
var $1eff89e6e13835e8$export$cc992891a14496a1;
var $1eff89e6e13835e8$export$14a4a98e063b1999;
var $1eff89e6e13835e8$export$d20cecfa1564c686;
var $1eff89e6e13835e8$export$44fd472a12fc6db;
var $1eff89e6e13835e8$export$1ed238bb6ea1dd47;
'use strict';

var $1X2xg = parcelRequire("1X2xg");
var $1eff89e6e13835e8$var$rotr32 = $1X2xg.rotr32;
function $1eff89e6e13835e8$var$ft_1(s, x, y, z) {
    if (s === 0) return $1eff89e6e13835e8$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $1eff89e6e13835e8$var$p32(x, y, z);
    if (s === 2) return $1eff89e6e13835e8$var$maj32(x, y, z);
}
$1eff89e6e13835e8$export$5a92649d7ddb9f63 = $1eff89e6e13835e8$var$ft_1;
function $1eff89e6e13835e8$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$1eff89e6e13835e8$export$c6d0d020c3a6269 = $1eff89e6e13835e8$var$ch32;
function $1eff89e6e13835e8$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$1eff89e6e13835e8$export$eb90c27fca05f956 = $1eff89e6e13835e8$var$maj32;
function $1eff89e6e13835e8$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$1eff89e6e13835e8$export$cc992891a14496a1 = $1eff89e6e13835e8$var$p32;
function $1eff89e6e13835e8$var$s0_256(x) {
    return $1eff89e6e13835e8$var$rotr32(x, 2) ^ $1eff89e6e13835e8$var$rotr32(x, 13) ^ $1eff89e6e13835e8$var$rotr32(x, 22);
}
$1eff89e6e13835e8$export$14a4a98e063b1999 = $1eff89e6e13835e8$var$s0_256;
function $1eff89e6e13835e8$var$s1_256(x) {
    return $1eff89e6e13835e8$var$rotr32(x, 6) ^ $1eff89e6e13835e8$var$rotr32(x, 11) ^ $1eff89e6e13835e8$var$rotr32(x, 25);
}
$1eff89e6e13835e8$export$d20cecfa1564c686 = $1eff89e6e13835e8$var$s1_256;
function $1eff89e6e13835e8$var$g0_256(x) {
    return $1eff89e6e13835e8$var$rotr32(x, 7) ^ $1eff89e6e13835e8$var$rotr32(x, 18) ^ x >>> 3;
}
$1eff89e6e13835e8$export$44fd472a12fc6db = $1eff89e6e13835e8$var$g0_256;
function $1eff89e6e13835e8$var$g1_256(x) {
    return $1eff89e6e13835e8$var$rotr32(x, 17) ^ $1eff89e6e13835e8$var$rotr32(x, 19) ^ x >>> 10;
}
$1eff89e6e13835e8$export$1ed238bb6ea1dd47 = $1eff89e6e13835e8$var$g1_256;

});


parcelRegister("ecqjG", function(module, exports) {
'use strict';

var $1X2xg = parcelRequire("1X2xg");

var $7nBDm = parcelRequire("7nBDm");
function $a566999ab6b93eb0$var$SHA224() {
    if (!(this instanceof $a566999ab6b93eb0$var$SHA224)) return new $a566999ab6b93eb0$var$SHA224();
    $7nBDm.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$1X2xg.inherits($a566999ab6b93eb0$var$SHA224, $7nBDm);
module.exports = $a566999ab6b93eb0$var$SHA224;
$a566999ab6b93eb0$var$SHA224.blockSize = 512;
$a566999ab6b93eb0$var$SHA224.outSize = 224;
$a566999ab6b93eb0$var$SHA224.hmacStrength = 192;
$a566999ab6b93eb0$var$SHA224.padLength = 64;
$a566999ab6b93eb0$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === 'hex') return $1X2xg.toHex32(this.h.slice(0, 7), 'big');
    else return $1X2xg.split32(this.h.slice(0, 7), 'big');
};

});
parcelRegister("7nBDm", function(module, exports) {
'use strict';

var $1X2xg = parcelRequire("1X2xg");

var $6wmUd = parcelRequire("6wmUd");

var $2F0ai = parcelRequire("2F0ai");

var $hILGj = parcelRequire("hILGj");
var $55f7dfb0cd32fd90$var$sum32 = $1X2xg.sum32;
var $55f7dfb0cd32fd90$var$sum32_4 = $1X2xg.sum32_4;
var $55f7dfb0cd32fd90$var$sum32_5 = $1X2xg.sum32_5;
var $55f7dfb0cd32fd90$var$ch32 = $2F0ai.ch32;
var $55f7dfb0cd32fd90$var$maj32 = $2F0ai.maj32;
var $55f7dfb0cd32fd90$var$s0_256 = $2F0ai.s0_256;
var $55f7dfb0cd32fd90$var$s1_256 = $2F0ai.s1_256;
var $55f7dfb0cd32fd90$var$g0_256 = $2F0ai.g0_256;
var $55f7dfb0cd32fd90$var$g1_256 = $2F0ai.g1_256;
var $55f7dfb0cd32fd90$var$BlockHash = $6wmUd.BlockHash;
var $55f7dfb0cd32fd90$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $55f7dfb0cd32fd90$var$SHA256() {
    if (!(this instanceof $55f7dfb0cd32fd90$var$SHA256)) return new $55f7dfb0cd32fd90$var$SHA256();
    $55f7dfb0cd32fd90$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $55f7dfb0cd32fd90$var$sha256_K;
    this.W = new Array(64);
}
$1X2xg.inherits($55f7dfb0cd32fd90$var$SHA256, $55f7dfb0cd32fd90$var$BlockHash);
module.exports = $55f7dfb0cd32fd90$var$SHA256;
$55f7dfb0cd32fd90$var$SHA256.blockSize = 512;
$55f7dfb0cd32fd90$var$SHA256.outSize = 256;
$55f7dfb0cd32fd90$var$SHA256.hmacStrength = 192;
$55f7dfb0cd32fd90$var$SHA256.padLength = 64;
$55f7dfb0cd32fd90$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $55f7dfb0cd32fd90$var$sum32_4($55f7dfb0cd32fd90$var$g1_256(W[i - 2]), W[i - 7], $55f7dfb0cd32fd90$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $hILGj(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $55f7dfb0cd32fd90$var$sum32_5(h, $55f7dfb0cd32fd90$var$s1_256(e), $55f7dfb0cd32fd90$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $55f7dfb0cd32fd90$var$sum32($55f7dfb0cd32fd90$var$s0_256(a), $55f7dfb0cd32fd90$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $55f7dfb0cd32fd90$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $55f7dfb0cd32fd90$var$sum32(T1, T2);
    }
    this.h[0] = $55f7dfb0cd32fd90$var$sum32(this.h[0], a);
    this.h[1] = $55f7dfb0cd32fd90$var$sum32(this.h[1], b);
    this.h[2] = $55f7dfb0cd32fd90$var$sum32(this.h[2], c);
    this.h[3] = $55f7dfb0cd32fd90$var$sum32(this.h[3], d);
    this.h[4] = $55f7dfb0cd32fd90$var$sum32(this.h[4], e);
    this.h[5] = $55f7dfb0cd32fd90$var$sum32(this.h[5], f);
    this.h[6] = $55f7dfb0cd32fd90$var$sum32(this.h[6], g);
    this.h[7] = $55f7dfb0cd32fd90$var$sum32(this.h[7], h);
};
$55f7dfb0cd32fd90$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $1X2xg.toHex32(this.h, 'big');
    else return $1X2xg.split32(this.h, 'big');
};

});


parcelRegister("dlrcx", function(module, exports) {
'use strict';

var $1X2xg = parcelRequire("1X2xg");

var $g42f8 = parcelRequire("g42f8");
function $9b72561bc4002e3b$var$SHA384() {
    if (!(this instanceof $9b72561bc4002e3b$var$SHA384)) return new $9b72561bc4002e3b$var$SHA384();
    $g42f8.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$1X2xg.inherits($9b72561bc4002e3b$var$SHA384, $g42f8);
module.exports = $9b72561bc4002e3b$var$SHA384;
$9b72561bc4002e3b$var$SHA384.blockSize = 1024;
$9b72561bc4002e3b$var$SHA384.outSize = 384;
$9b72561bc4002e3b$var$SHA384.hmacStrength = 192;
$9b72561bc4002e3b$var$SHA384.padLength = 128;
$9b72561bc4002e3b$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $1X2xg.toHex32(this.h.slice(0, 12), 'big');
    else return $1X2xg.split32(this.h.slice(0, 12), 'big');
};

});
parcelRegister("g42f8", function(module, exports) {
'use strict';

var $1X2xg = parcelRequire("1X2xg");

var $6wmUd = parcelRequire("6wmUd");

var $hILGj = parcelRequire("hILGj");
var $bb1ec28394d4f5e6$var$rotr64_hi = $1X2xg.rotr64_hi;
var $bb1ec28394d4f5e6$var$rotr64_lo = $1X2xg.rotr64_lo;
var $bb1ec28394d4f5e6$var$shr64_hi = $1X2xg.shr64_hi;
var $bb1ec28394d4f5e6$var$shr64_lo = $1X2xg.shr64_lo;
var $bb1ec28394d4f5e6$var$sum64 = $1X2xg.sum64;
var $bb1ec28394d4f5e6$var$sum64_hi = $1X2xg.sum64_hi;
var $bb1ec28394d4f5e6$var$sum64_lo = $1X2xg.sum64_lo;
var $bb1ec28394d4f5e6$var$sum64_4_hi = $1X2xg.sum64_4_hi;
var $bb1ec28394d4f5e6$var$sum64_4_lo = $1X2xg.sum64_4_lo;
var $bb1ec28394d4f5e6$var$sum64_5_hi = $1X2xg.sum64_5_hi;
var $bb1ec28394d4f5e6$var$sum64_5_lo = $1X2xg.sum64_5_lo;
var $bb1ec28394d4f5e6$var$BlockHash = $6wmUd.BlockHash;
var $bb1ec28394d4f5e6$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $bb1ec28394d4f5e6$var$SHA512() {
    if (!(this instanceof $bb1ec28394d4f5e6$var$SHA512)) return new $bb1ec28394d4f5e6$var$SHA512();
    $bb1ec28394d4f5e6$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $bb1ec28394d4f5e6$var$sha512_K;
    this.W = new Array(160);
}
$1X2xg.inherits($bb1ec28394d4f5e6$var$SHA512, $bb1ec28394d4f5e6$var$BlockHash);
module.exports = $bb1ec28394d4f5e6$var$SHA512;
$bb1ec28394d4f5e6$var$SHA512.blockSize = 1024;
$bb1ec28394d4f5e6$var$SHA512.outSize = 512;
$bb1ec28394d4f5e6$var$SHA512.hmacStrength = 192;
$bb1ec28394d4f5e6$var$SHA512.padLength = 128;
$bb1ec28394d4f5e6$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $bb1ec28394d4f5e6$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $bb1ec28394d4f5e6$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $bb1ec28394d4f5e6$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $bb1ec28394d4f5e6$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $bb1ec28394d4f5e6$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $bb1ec28394d4f5e6$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$bb1ec28394d4f5e6$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $hILGj(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $bb1ec28394d4f5e6$var$s1_512_hi(eh, el);
        var c1_lo = $bb1ec28394d4f5e6$var$s1_512_lo(eh, el);
        var c2_hi = $bb1ec28394d4f5e6$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $bb1ec28394d4f5e6$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $bb1ec28394d4f5e6$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $bb1ec28394d4f5e6$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $bb1ec28394d4f5e6$var$s0_512_hi(ah, al);
        c0_lo = $bb1ec28394d4f5e6$var$s0_512_lo(ah, al);
        c1_hi = $bb1ec28394d4f5e6$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $bb1ec28394d4f5e6$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $bb1ec28394d4f5e6$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $bb1ec28394d4f5e6$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $bb1ec28394d4f5e6$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $bb1ec28394d4f5e6$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $bb1ec28394d4f5e6$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $bb1ec28394d4f5e6$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $bb1ec28394d4f5e6$var$sum64(this.h, 0, ah, al);
    $bb1ec28394d4f5e6$var$sum64(this.h, 2, bh, bl);
    $bb1ec28394d4f5e6$var$sum64(this.h, 4, ch, cl);
    $bb1ec28394d4f5e6$var$sum64(this.h, 6, dh, dl);
    $bb1ec28394d4f5e6$var$sum64(this.h, 8, eh, el);
    $bb1ec28394d4f5e6$var$sum64(this.h, 10, fh, fl);
    $bb1ec28394d4f5e6$var$sum64(this.h, 12, gh, gl);
    $bb1ec28394d4f5e6$var$sum64(this.h, 14, hh, hl);
};
$bb1ec28394d4f5e6$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $1X2xg.toHex32(this.h, 'big');
    else return $1X2xg.split32(this.h, 'big');
};
function $bb1ec28394d4f5e6$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $bb1ec28394d4f5e6$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $bb1ec28394d4f5e6$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $bb1ec28394d4f5e6$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $bb1ec28394d4f5e6$var$s0_512_hi(xh, xl) {
    var c0_hi = $bb1ec28394d4f5e6$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $bb1ec28394d4f5e6$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $bb1ec28394d4f5e6$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $bb1ec28394d4f5e6$var$s0_512_lo(xh, xl) {
    var c0_lo = $bb1ec28394d4f5e6$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $bb1ec28394d4f5e6$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $bb1ec28394d4f5e6$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $bb1ec28394d4f5e6$var$s1_512_hi(xh, xl) {
    var c0_hi = $bb1ec28394d4f5e6$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $bb1ec28394d4f5e6$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $bb1ec28394d4f5e6$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $bb1ec28394d4f5e6$var$s1_512_lo(xh, xl) {
    var c0_lo = $bb1ec28394d4f5e6$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $bb1ec28394d4f5e6$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $bb1ec28394d4f5e6$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $bb1ec28394d4f5e6$var$g0_512_hi(xh, xl) {
    var c0_hi = $bb1ec28394d4f5e6$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $bb1ec28394d4f5e6$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $bb1ec28394d4f5e6$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $bb1ec28394d4f5e6$var$g0_512_lo(xh, xl) {
    var c0_lo = $bb1ec28394d4f5e6$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $bb1ec28394d4f5e6$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $bb1ec28394d4f5e6$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $bb1ec28394d4f5e6$var$g1_512_hi(xh, xl) {
    var c0_hi = $bb1ec28394d4f5e6$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $bb1ec28394d4f5e6$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $bb1ec28394d4f5e6$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $bb1ec28394d4f5e6$var$g1_512_lo(xh, xl) {
    var c0_lo = $bb1ec28394d4f5e6$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $bb1ec28394d4f5e6$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $bb1ec28394d4f5e6$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRegister("9yolU", function(module, exports) {
$parcel$export(module.exports, "ripemd160", () => $6f4a2deb3fe253e3$export$d1cea0ee4e3f0d3e, (v) => $6f4a2deb3fe253e3$export$d1cea0ee4e3f0d3e = v);
var $6f4a2deb3fe253e3$export$d1cea0ee4e3f0d3e;
'use strict';

var $1X2xg = parcelRequire("1X2xg");

var $6wmUd = parcelRequire("6wmUd");
var $6f4a2deb3fe253e3$var$rotl32 = $1X2xg.rotl32;
var $6f4a2deb3fe253e3$var$sum32 = $1X2xg.sum32;
var $6f4a2deb3fe253e3$var$sum32_3 = $1X2xg.sum32_3;
var $6f4a2deb3fe253e3$var$sum32_4 = $1X2xg.sum32_4;
var $6f4a2deb3fe253e3$var$BlockHash = $6wmUd.BlockHash;
function $6f4a2deb3fe253e3$var$RIPEMD160() {
    if (!(this instanceof $6f4a2deb3fe253e3$var$RIPEMD160)) return new $6f4a2deb3fe253e3$var$RIPEMD160();
    $6f4a2deb3fe253e3$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = 'little';
}
$1X2xg.inherits($6f4a2deb3fe253e3$var$RIPEMD160, $6f4a2deb3fe253e3$var$BlockHash);
$6f4a2deb3fe253e3$export$d1cea0ee4e3f0d3e = $6f4a2deb3fe253e3$var$RIPEMD160;
$6f4a2deb3fe253e3$var$RIPEMD160.blockSize = 512;
$6f4a2deb3fe253e3$var$RIPEMD160.outSize = 160;
$6f4a2deb3fe253e3$var$RIPEMD160.hmacStrength = 192;
$6f4a2deb3fe253e3$var$RIPEMD160.padLength = 64;
$6f4a2deb3fe253e3$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $6f4a2deb3fe253e3$var$sum32($6f4a2deb3fe253e3$var$rotl32($6f4a2deb3fe253e3$var$sum32_4(A, $6f4a2deb3fe253e3$var$f(j, B, C, D), msg[$6f4a2deb3fe253e3$var$r[j] + start], $6f4a2deb3fe253e3$var$K(j)), $6f4a2deb3fe253e3$var$s[j]), E);
        A = E;
        E = D;
        D = $6f4a2deb3fe253e3$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $6f4a2deb3fe253e3$var$sum32($6f4a2deb3fe253e3$var$rotl32($6f4a2deb3fe253e3$var$sum32_4(Ah, $6f4a2deb3fe253e3$var$f(79 - j, Bh, Ch, Dh), msg[$6f4a2deb3fe253e3$var$rh[j] + start], $6f4a2deb3fe253e3$var$Kh(j)), $6f4a2deb3fe253e3$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $6f4a2deb3fe253e3$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $6f4a2deb3fe253e3$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $6f4a2deb3fe253e3$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $6f4a2deb3fe253e3$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $6f4a2deb3fe253e3$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $6f4a2deb3fe253e3$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$6f4a2deb3fe253e3$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $1X2xg.toHex32(this.h, 'little');
    else return $1X2xg.split32(this.h, 'little');
};
function $6f4a2deb3fe253e3$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $6f4a2deb3fe253e3$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $6f4a2deb3fe253e3$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $6f4a2deb3fe253e3$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $6f4a2deb3fe253e3$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $6f4a2deb3fe253e3$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $6f4a2deb3fe253e3$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRegister("1BeMN", function(module, exports) {
'use strict';

var $1X2xg = parcelRequire("1X2xg");

var $hILGj = parcelRequire("hILGj");
function $12a4b751cab51ac1$var$Hmac(hash, key, enc) {
    if (!(this instanceof $12a4b751cab51ac1$var$Hmac)) return new $12a4b751cab51ac1$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($1X2xg.toArray(key, enc));
}
module.exports = $12a4b751cab51ac1$var$Hmac;
$12a4b751cab51ac1$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $hILGj(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$12a4b751cab51ac1$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$12a4b751cab51ac1$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});


parcelRegister("lkq84", function(module, exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
                'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821'
            ],
            [
                '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
                '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf'
            ],
            [
                '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
                'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695'
            ],
            [
                '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
                '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9'
            ],
            [
                '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
                '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36'
            ],
            [
                '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
                '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f'
            ],
            [
                'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
                '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999'
            ],
            [
                '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
                'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09'
            ],
            [
                'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
                '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d'
            ],
            [
                'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
                'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088'
            ],
            [
                'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
                '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d'
            ],
            [
                '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
                '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8'
            ],
            [
                '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
                '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a'
            ],
            [
                '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
                '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453'
            ],
            [
                '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
                '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160'
            ],
            [
                '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
                '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0'
            ],
            [
                '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
                '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6'
            ],
            [
                '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
                '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589'
            ],
            [
                '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
                'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17'
            ],
            [
                'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
                '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda'
            ],
            [
                'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
                '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd'
            ],
            [
                '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
                '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2'
            ],
            [
                '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
                '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6'
            ],
            [
                'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
                '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f'
            ],
            [
                '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
                'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01'
            ],
            [
                'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
                '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3'
            ],
            [
                'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
                'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f'
            ],
            [
                'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
                '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7'
            ],
            [
                'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
                'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78'
            ],
            [
                'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
                '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1'
            ],
            [
                '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
                'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150'
            ],
            [
                '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
                '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82'
            ],
            [
                'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
                '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc'
            ],
            [
                '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
                'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b'
            ],
            [
                'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
                '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51'
            ],
            [
                'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
                '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45'
            ],
            [
                'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
                'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120'
            ],
            [
                '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
                '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84'
            ],
            [
                '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
                '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d'
            ],
            [
                '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
                'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d'
            ],
            [
                '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
                '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8'
            ],
            [
                'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
                '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8'
            ],
            [
                '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
                '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac'
            ],
            [
                '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
                'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f'
            ],
            [
                '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
                '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962'
            ],
            [
                'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
                '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907'
            ],
            [
                '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
                'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec'
            ],
            [
                'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
                'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d'
            ],
            [
                'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
                '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414'
            ],
            [
                '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
                'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd'
            ],
            [
                '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
                'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0'
            ],
            [
                'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
                '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811'
            ],
            [
                'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
                '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1'
            ],
            [
                'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
                '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c'
            ],
            [
                '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
                'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73'
            ],
            [
                '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
                '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd'
            ],
            [
                'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
                'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405'
            ],
            [
                '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
                'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589'
            ],
            [
                '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
                '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e'
            ],
            [
                '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
                '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27'
            ],
            [
                'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
                'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1'
            ],
            [
                '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
                '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482'
            ],
            [
                '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
                '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945'
            ],
            [
                'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
                '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573'
            ],
            [
                'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
                'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82'
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
                '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672'
            ],
            [
                '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
                'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6'
            ],
            [
                '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
                '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da'
            ],
            [
                'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
                'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37'
            ],
            [
                '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
                'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b'
            ],
            [
                'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
                'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81'
            ],
            [
                'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
                '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58'
            ],
            [
                'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
                '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77'
            ],
            [
                '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
                '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a'
            ],
            [
                '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
                '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c'
            ],
            [
                '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
                '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67'
            ],
            [
                '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
                '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402'
            ],
            [
                'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
                'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55'
            ],
            [
                'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
                '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482'
            ],
            [
                '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
                'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82'
            ],
            [
                '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
                'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396'
            ],
            [
                '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
                '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49'
            ],
            [
                '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
                '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf'
            ],
            [
                '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
                '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a'
            ],
            [
                '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
                'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7'
            ],
            [
                'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
                'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933'
            ],
            [
                '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
                '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a'
            ],
            [
                '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
                '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6'
            ],
            [
                'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
                'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37'
            ],
            [
                '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
                '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e'
            ],
            [
                'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
                'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6'
            ],
            [
                'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
                'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476'
            ],
            [
                '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
                '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40'
            ],
            [
                '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
                '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61'
            ],
            [
                '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
                '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683'
            ],
            [
                'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
                '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5'
            ],
            [
                '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
                '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b'
            ],
            [
                'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
                '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417'
            ],
            [
                '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
                'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868'
            ],
            [
                '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
                'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a'
            ],
            [
                'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
                'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6'
            ],
            [
                '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
                '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996'
            ],
            [
                '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
                'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e'
            ],
            [
                'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
                'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d'
            ],
            [
                '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
                '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2'
            ],
            [
                '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
                'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e'
            ],
            [
                '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
                '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437'
            ],
            [
                '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
                'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311'
            ],
            [
                'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
                '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4'
            ],
            [
                '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
                '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575'
            ],
            [
                '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
                'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d'
            ],
            [
                '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
                'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d'
            ],
            [
                'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
                'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629'
            ],
            [
                'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
                'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06'
            ],
            [
                '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
                '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374'
            ],
            [
                '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
                '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee'
            ],
            [
                'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
                '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1'
            ],
            [
                'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
                'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b'
            ],
            [
                '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
                '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661'
            ],
            [
                '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
                '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6'
            ],
            [
                'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
                '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e'
            ],
            [
                '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
                '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d'
            ],
            [
                'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
                'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc'
            ],
            [
                '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
                'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4'
            ],
            [
                '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
                '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c'
            ],
            [
                'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
                '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b'
            ],
            [
                'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
                '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913'
            ],
            [
                '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
                '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154'
            ],
            [
                '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
                '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865'
            ],
            [
                '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
                'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc'
            ],
            [
                '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
                'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224'
            ],
            [
                '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
                '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e'
            ],
            [
                '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
                '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6'
            ],
            [
                '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
                '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511'
            ],
            [
                '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
                'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b'
            ],
            [
                'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
                'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2'
            ],
            [
                '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
                'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c'
            ],
            [
                'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
                '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3'
            ],
            [
                'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
                '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d'
            ],
            [
                'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
                '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700'
            ],
            [
                'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
                '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4'
            ],
            [
                '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
                'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196'
            ],
            [
                '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
                '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4'
            ],
            [
                '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
                'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257'
            ],
            [
                'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
                'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13'
            ],
            [
                'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
                '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096'
            ],
            [
                'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
                'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38'
            ],
            [
                'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
                '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f'
            ],
            [
                '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
                '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448'
            ],
            [
                'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
                '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a'
            ],
            [
                'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
                '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4'
            ],
            [
                '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
                '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437'
            ],
            [
                '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
                'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7'
            ],
            [
                'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
                '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d'
            ],
            [
                'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
                '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a'
            ],
            [
                'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
                '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54'
            ],
            [
                '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
                '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77'
            ],
            [
                'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
                'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517'
            ],
            [
                '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
                'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10'
            ],
            [
                'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
                'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125'
            ],
            [
                'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
                '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e'
            ],
            [
                '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
                'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1'
            ],
            [
                'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
                '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2'
            ],
            [
                'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
                '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423'
            ],
            [
                'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
                '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8'
            ],
            [
                '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
                'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758'
            ],
            [
                '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
                'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375'
            ],
            [
                'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
                '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d'
            ],
            [
                '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
                'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec'
            ],
            [
                '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
                '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0'
            ],
            [
                '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
                'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c'
            ],
            [
                'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
                'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4'
            ],
            [
                '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
                'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f'
            ],
            [
                '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
                '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649'
            ],
            [
                '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
                'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826'
            ],
            [
                '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
                '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5'
            ],
            [
                'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
                'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87'
            ],
            [
                '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
                '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b'
            ],
            [
                'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
                '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc'
            ],
            [
                '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
                '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c'
            ],
            [
                'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
                'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f'
            ],
            [
                'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
                '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a'
            ],
            [
                'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
                'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46'
            ],
            [
                '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
                'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f'
            ],
            [
                '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
                '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03'
            ],
            [
                '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
                'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08'
            ],
            [
                '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
                '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8'
            ],
            [
                '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
                '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373'
            ],
            [
                '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
                'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3'
            ],
            [
                '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
                '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8'
            ],
            [
                '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
                '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1'
            ],
            [
                '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
                '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9'
            ]
        ]
    }
};

});


parcelRegister("hsVfi", function(module, exports) {
'use strict';

var $kHwXh = parcelRequire("kHwXh");

var $9ST7V = parcelRequire("9ST7V");

var $4PW5d = parcelRequire("4PW5d");

var $6Ek6o = parcelRequire("6Ek6o");

var $fZ33D = parcelRequire("fZ33D");
var $cb717503440323fe$var$assert = $4PW5d.assert;

var $b38P2 = parcelRequire("b38P2");

var $brMzW = parcelRequire("brMzW");
function $cb717503440323fe$var$EC(options) {
    if (!(this instanceof $cb717503440323fe$var$EC)) return new $cb717503440323fe$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === 'string') {
        $cb717503440323fe$var$assert(Object.prototype.hasOwnProperty.call($6Ek6o, options), 'Unknown curve ' + options);
        options = $6Ek6o[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $6Ek6o.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = $cb717503440323fe$var$EC;
$cb717503440323fe$var$EC.prototype.keyPair = function keyPair(options) {
    return new $b38P2(this, options);
};
$cb717503440323fe$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $b38P2.fromPrivate(this, priv, enc);
};
$cb717503440323fe$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $b38P2.fromPublic(this, pub, enc);
};
$cb717503440323fe$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $9ST7V({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8',
        entropy: options.entropy || $fZ33D(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || 'utf8',
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new $kHwXh(2));
    for(;;){
        var priv = new $kHwXh(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$cb717503440323fe$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly, bitLength) {
    var byteLength;
    if ($kHwXh.isBN(msg) || typeof msg === 'number') {
        msg = new $kHwXh(msg, 16);
        byteLength = msg.byteLength();
    } else if (typeof msg === 'object') {
        // BN assumes an array-like input and asserts length
        byteLength = msg.length;
        msg = new $kHwXh(msg, 16);
    } else {
        // BN converts the value to string
        var str = msg.toString();
        // HEX encoding
        byteLength = str.length + 1 >>> 1;
        msg = new $kHwXh(str, 16);
    }
    // Allow overriding
    if (typeof bitLength !== 'number') bitLength = byteLength * 8;
    var delta = bitLength - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$cb717503440323fe$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === 'object') {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    if (typeof msg !== 'string' && typeof msg !== 'number' && !$kHwXh.isBN(msg)) {
        $cb717503440323fe$var$assert(typeof msg === 'object' && msg && typeof msg.length === 'number', 'Expected message to be an array-like, a hex string, or a BN instance');
        $cb717503440323fe$var$assert(msg.length >>> 0 === msg.length); // non-negative 32-bit integer
        for(var i = 0; i < msg.length; i++)$cb717503440323fe$var$assert((msg[i] & 255) === msg[i]);
    }
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(msg, false, options.msgBitLength);
    // Would fail further checks, but let's make the error message clear
    $cb717503440323fe$var$assert(!msg.isNeg(), 'Can not sign a negative message');
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray('be', bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray('be', bytes);
    // Recheck nonce to be bijective to msg
    $cb717503440323fe$var$assert(new $kHwXh(nonce).eq(msg), 'Can not sign message');
    // Instantiate Hmac_DRBG
    var drbg = new $9ST7V({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8'
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new $kHwXh(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new $kHwXh(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $brMzW({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$cb717503440323fe$var$EC.prototype.verify = function verify(msg, signature, key, enc, options) {
    if (!options) options = {};
    msg = this._truncateToN(msg, false, options.msgBitLength);
    key = this.keyFromPublic(key, enc);
    signature = new $brMzW(signature, 'hex');
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$cb717503440323fe$var$EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    $cb717503440323fe$var$assert((3 & j) === j, 'The recovery param is more than two bits');
    signature = new $brMzW(signature, enc);
    var n = this.n;
    var e = new $kHwXh(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error('Unable to find sencond key candinate');
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$cb717503440323fe$var$EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new $brMzW(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error('Unable to find valid recovery factor');
};

});
parcelRegister("9ST7V", function(module, exports) {
'use strict';

var $cHC35 = parcelRequire("cHC35");

var $fZ2Y3 = parcelRequire("fZ2Y3");

var $hILGj = parcelRequire("hILGj");
function $7323eb3b5a77fa7d$var$HmacDRBG(options) {
    if (!(this instanceof $7323eb3b5a77fa7d$var$HmacDRBG)) return new $7323eb3b5a77fa7d$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $fZ2Y3.toArray(options.entropy, options.entropyEnc || 'hex');
    var nonce = $fZ2Y3.toArray(options.nonce, options.nonceEnc || 'hex');
    var pers = $fZ2Y3.toArray(options.pers, options.persEnc || 'hex');
    $hILGj(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._init(entropy, nonce, pers);
}
module.exports = $7323eb3b5a77fa7d$var$HmacDRBG;
$7323eb3b5a77fa7d$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$7323eb3b5a77fa7d$var$HmacDRBG.prototype._hmac = function hmac() {
    return new $cHC35.hmac(this.hash, this.K);
};
$7323eb3b5a77fa7d$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$7323eb3b5a77fa7d$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== 'string') {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $fZ2Y3.toArray(entropy, entropyEnc);
    add = $fZ2Y3.toArray(add, addEnc);
    $hILGj(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$7323eb3b5a77fa7d$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error('Reseed is required');
    // Optional encoding
    if (typeof enc !== 'string') {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $fZ2Y3.toArray(add, addEnc || 'hex');
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $fZ2Y3.encode(res, enc);
};

});

parcelRegister("b38P2", function(module, exports) {
'use strict';

var $kHwXh = parcelRequire("kHwXh");

var $4PW5d = parcelRequire("4PW5d");
var $80b6d16ab668baea$var$assert = $4PW5d.assert;
function $80b6d16ab668baea$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = $80b6d16ab668baea$var$KeyPair;
$80b6d16ab668baea$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $80b6d16ab668baea$var$KeyPair) return pub;
    return new $80b6d16ab668baea$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$80b6d16ab668baea$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $80b6d16ab668baea$var$KeyPair) return priv;
    return new $80b6d16ab668baea$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$80b6d16ab668baea$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: 'Invalid public key'
    };
    if (!pub.validate()) return {
        result: false,
        reason: 'Public key is not a point'
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: 'Public key * N != O'
    };
    return {
        result: true,
        reason: null
    };
};
$80b6d16ab668baea$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === 'string') {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$80b6d16ab668baea$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === 'hex') return this.priv.toString(16, 2);
    else return this.priv;
};
$80b6d16ab668baea$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new $kHwXh(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$80b6d16ab668baea$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === 'mont') $80b6d16ab668baea$var$assert(key.x, 'Need x coordinate');
        else if (this.ec.curve.type === 'short' || this.ec.curve.type === 'edwards') $80b6d16ab668baea$var$assert(key.x && key.y, 'Need both x and y coordinate');
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$80b6d16ab668baea$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $80b6d16ab668baea$var$assert(pub.validate(), 'public point not validated');
    return pub.mul(this.priv).getX();
};
// ECDSA
$80b6d16ab668baea$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$80b6d16ab668baea$var$KeyPair.prototype.verify = function verify(msg, signature, options) {
    return this.ec.verify(msg, signature, this, undefined, options);
};
$80b6d16ab668baea$var$KeyPair.prototype.inspect = function inspect() {
    return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) + ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};

});

parcelRegister("brMzW", function(module, exports) {
'use strict';

var $kHwXh = parcelRequire("kHwXh");

var $4PW5d = parcelRequire("4PW5d");
var $8557e60a713c8035$var$assert = $4PW5d.assert;
function $8557e60a713c8035$var$Signature(options, enc) {
    if (options instanceof $8557e60a713c8035$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $8557e60a713c8035$var$assert(options.r && options.s, 'Signature without r or s');
    this.r = new $kHwXh(options.r, 16);
    this.s = new $kHwXh(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = $8557e60a713c8035$var$Signature;
function $8557e60a713c8035$var$Position() {
    this.place = 0;
}
function $8557e60a713c8035$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    if (buf[p.place] === 0x00) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $8557e60a713c8035$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$8557e60a713c8035$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $4PW5d.toArray(data, enc);
    var p = new $8557e60a713c8035$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $8557e60a713c8035$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $8557e60a713c8035$var$getLength(data, p);
    if (rlen === false) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $8557e60a713c8035$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new $kHwXh(r);
    this.s = new $kHwXh(s);
    this.recoveryParam = null;
    return true;
};
function $8557e60a713c8035$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$8557e60a713c8035$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $8557e60a713c8035$var$rmPadding(r);
    s = $8557e60a713c8035$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $8557e60a713c8035$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $8557e60a713c8035$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $8557e60a713c8035$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $4PW5d.encode(res, enc);
};

});


parcelRegister("iCDtn", function(module, exports) {
'use strict';

var $cHC35 = parcelRequire("cHC35");

var $6Ek6o = parcelRequire("6Ek6o");

var $4PW5d = parcelRequire("4PW5d");
var $d8ea65177c694a28$var$assert = $4PW5d.assert;
var $d8ea65177c694a28$var$parseBytes = $4PW5d.parseBytes;

var $aMbBB = parcelRequire("aMbBB");

var $clBhP = parcelRequire("clBhP");
function $d8ea65177c694a28$var$EDDSA(curve) {
    $d8ea65177c694a28$var$assert(curve === 'ed25519', 'only tested with ed25519 so far');
    if (!(this instanceof $d8ea65177c694a28$var$EDDSA)) return new $d8ea65177c694a28$var$EDDSA(curve);
    curve = $6Ek6o[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = $cHC35.sha512;
}
module.exports = $d8ea65177c694a28$var$EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ $d8ea65177c694a28$var$EDDSA.prototype.sign = function sign(message, secret) {
    message = $d8ea65177c694a28$var$parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ $d8ea65177c694a28$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = $d8ea65177c694a28$var$parseBytes(message);
    sig = this.makeSignature(sig);
    if (sig.S().gte(sig.eddsa.curve.n) || sig.S().isNeg()) return false;
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
$d8ea65177c694a28$var$EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return $4PW5d.intFromLE(hash.digest()).umod(this.curve.n);
};
$d8ea65177c694a28$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return $aMbBB.fromPublic(this, pub);
};
$d8ea65177c694a28$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return $aMbBB.fromSecret(this, secret);
};
$d8ea65177c694a28$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof $clBhP) return sig;
    return new $clBhP(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ $d8ea65177c694a28$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray('le', this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
$d8ea65177c694a28$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = $4PW5d.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = $4PW5d.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
$d8ea65177c694a28$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray('le', this.encodingLength);
};
$d8ea65177c694a28$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return $4PW5d.intFromLE(bytes);
};
$d8ea65177c694a28$var$EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

});
parcelRegister("aMbBB", function(module, exports) {
'use strict';

var $4PW5d = parcelRequire("4PW5d");
var $7d8763b3d47b2d50$var$assert = $4PW5d.assert;
var $7d8763b3d47b2d50$var$parseBytes = $4PW5d.parseBytes;
var $7d8763b3d47b2d50$var$cachedProperty = $4PW5d.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function $7d8763b3d47b2d50$var$KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = $7d8763b3d47b2d50$var$parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = $7d8763b3d47b2d50$var$parseBytes(params.pub);
}
$7d8763b3d47b2d50$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof $7d8763b3d47b2d50$var$KeyPair) return pub;
    return new $7d8763b3d47b2d50$var$KeyPair(eddsa, {
        pub: pub
    });
};
$7d8763b3d47b2d50$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof $7d8763b3d47b2d50$var$KeyPair) return secret;
    return new $7d8763b3d47b2d50$var$KeyPair(eddsa, {
        secret: secret
    });
};
$7d8763b3d47b2d50$var$KeyPair.prototype.secret = function secret() {
    return this._secret;
};
$7d8763b3d47b2d50$var$cachedProperty($7d8763b3d47b2d50$var$KeyPair, 'pubBytes', function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
$7d8763b3d47b2d50$var$cachedProperty($7d8763b3d47b2d50$var$KeyPair, 'pub', function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
$7d8763b3d47b2d50$var$cachedProperty($7d8763b3d47b2d50$var$KeyPair, 'privBytes', function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
$7d8763b3d47b2d50$var$cachedProperty($7d8763b3d47b2d50$var$KeyPair, 'priv', function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
$7d8763b3d47b2d50$var$cachedProperty($7d8763b3d47b2d50$var$KeyPair, 'hash', function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
$7d8763b3d47b2d50$var$cachedProperty($7d8763b3d47b2d50$var$KeyPair, 'messagePrefix', function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
$7d8763b3d47b2d50$var$KeyPair.prototype.sign = function sign(message) {
    $7d8763b3d47b2d50$var$assert(this._secret, 'KeyPair can only verify');
    return this.eddsa.sign(message, this);
};
$7d8763b3d47b2d50$var$KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
$7d8763b3d47b2d50$var$KeyPair.prototype.getSecret = function getSecret(enc) {
    $7d8763b3d47b2d50$var$assert(this._secret, 'KeyPair is public only');
    return $4PW5d.encode(this.secret(), enc);
};
$7d8763b3d47b2d50$var$KeyPair.prototype.getPublic = function getPublic(enc) {
    return $4PW5d.encode(this.pubBytes(), enc);
};
module.exports = $7d8763b3d47b2d50$var$KeyPair;

});

parcelRegister("clBhP", function(module, exports) {
'use strict';

var $kHwXh = parcelRequire("kHwXh");

var $4PW5d = parcelRequire("4PW5d");
var $8fd45e86ea9bc245$var$assert = $4PW5d.assert;
var $8fd45e86ea9bc245$var$cachedProperty = $4PW5d.cachedProperty;
var $8fd45e86ea9bc245$var$parseBytes = $4PW5d.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function $8fd45e86ea9bc245$var$Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== 'object') sig = $8fd45e86ea9bc245$var$parseBytes(sig);
    if (Array.isArray(sig)) {
        $8fd45e86ea9bc245$var$assert(sig.length === eddsa.encodingLength * 2, 'Signature has invalid size');
        sig = {
            R: sig.slice(0, eddsa.encodingLength),
            S: sig.slice(eddsa.encodingLength)
        };
    }
    $8fd45e86ea9bc245$var$assert(sig.R && sig.S, 'Signature without R or S');
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof $kHwXh) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
$8fd45e86ea9bc245$var$cachedProperty($8fd45e86ea9bc245$var$Signature, 'S', function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
$8fd45e86ea9bc245$var$cachedProperty($8fd45e86ea9bc245$var$Signature, 'R', function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
$8fd45e86ea9bc245$var$cachedProperty($8fd45e86ea9bc245$var$Signature, 'Rencoded', function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
$8fd45e86ea9bc245$var$cachedProperty($8fd45e86ea9bc245$var$Signature, 'Sencoded', function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
$8fd45e86ea9bc245$var$Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
$8fd45e86ea9bc245$var$Signature.prototype.toHex = function toHex() {
    return $4PW5d.encode(this.toBytes(), 'hex').toUpperCase();
};
module.exports = $8fd45e86ea9bc245$var$Signature;

});


parcelRegister("bMLik", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("luYXS")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, 'Invalid character in ' + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, 'Invalid character');
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') try {
        BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === 'le' ? 'LE' : 'BE';
        this['_toArrayLike' + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("axirG", function(module, exports) {

var $locuy = parcelRequire("locuy");

var $jcXeW = parcelRequire("jcXeW");
var $7abb4b59fa334e00$var$api = module.exports;
$7abb4b59fa334e00$var$api.define = function define(name, body) {
    return new $7abb4b59fa334e00$var$Entity(name, body);
};
function $7abb4b59fa334e00$var$Entity(name, body) {
    this.name = name;
    this.body = body;
    this.decoders = {};
    this.encoders = {};
}

$7abb4b59fa334e00$var$Entity.prototype._createNamed = function createNamed(base) {
    var named;
    try {
        named = (parcelRequire("1FH8O")).runInThisContext('(function ' + this.name + '(entity) {\n' + '  this._initNamed(entity);\n' + '})');
    } catch (e) {
        named = function(entity) {
            this._initNamed(entity);
        };
    }
    $jcXeW(named, base);
    named.prototype._initNamed = function initnamed(entity) {
        base.call(this, entity);
    };
    return new named(this);
};
$7abb4b59fa334e00$var$Entity.prototype._getDecoder = function _getDecoder(enc) {
    enc = enc || 'der';
    // Lazily create decoder
    if (!this.decoders.hasOwnProperty(enc)) this.decoders[enc] = this._createNamed($locuy.decoders[enc]);
    return this.decoders[enc];
};
$7abb4b59fa334e00$var$Entity.prototype.decode = function decode(data, enc, options) {
    return this._getDecoder(enc).decode(data, options);
};
$7abb4b59fa334e00$var$Entity.prototype._getEncoder = function _getEncoder(enc) {
    enc = enc || 'der';
    // Lazily create encoder
    if (!this.encoders.hasOwnProperty(enc)) this.encoders[enc] = this._createNamed($locuy.encoders[enc]);
    return this.encoders[enc];
};
$7abb4b59fa334e00$var$Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
    return this._getEncoder(enc).encode(data, reporter);
};

});
parcelRegister("locuy", function(module, exports) {
var $f9258780293bb60c$var$asn1 = module.exports;

$f9258780293bb60c$var$asn1.bignum = (parcelRequire("kHwXh"));

$f9258780293bb60c$var$asn1.define = (parcelRequire("axirG")).define;

$f9258780293bb60c$var$asn1.base = (parcelRequire("dDzkS"));

$f9258780293bb60c$var$asn1.constants = (parcelRequire("3YH8n"));

$f9258780293bb60c$var$asn1.decoders = (parcelRequire("hu53k"));

$f9258780293bb60c$var$asn1.encoders = (parcelRequire("8q8h8"));

});
parcelRegister("dDzkS", function(module, exports) {
var $9eda53d27a6cb712$var$base = module.exports;

$9eda53d27a6cb712$var$base.Reporter = (parcelRequire("1gTB4")).Reporter;

$9eda53d27a6cb712$var$base.DecoderBuffer = (parcelRequire("9sTRz")).DecoderBuffer;

$9eda53d27a6cb712$var$base.EncoderBuffer = (parcelRequire("9sTRz")).EncoderBuffer;

$9eda53d27a6cb712$var$base.Node = (parcelRequire("dzdIX"));

});
parcelRegister("1gTB4", function(module, exports) {
$parcel$export(module.exports, "Reporter", () => $0ed269743e272412$export$957313a2f485e5ed, (v) => $0ed269743e272412$export$957313a2f485e5ed = v);
var $0ed269743e272412$export$957313a2f485e5ed;

var $jcXeW = parcelRequire("jcXeW");
function $0ed269743e272412$var$Reporter(options) {
    this._reporterState = {
        obj: null,
        path: [],
        options: options || {},
        errors: []
    };
}
$0ed269743e272412$export$957313a2f485e5ed = $0ed269743e272412$var$Reporter;
$0ed269743e272412$var$Reporter.prototype.isError = function isError(obj) {
    return obj instanceof $0ed269743e272412$var$ReporterError;
};
$0ed269743e272412$var$Reporter.prototype.save = function save() {
    var state = this._reporterState;
    return {
        obj: state.obj,
        pathLen: state.path.length
    };
};
$0ed269743e272412$var$Reporter.prototype.restore = function restore(data) {
    var state = this._reporterState;
    state.obj = data.obj;
    state.path = state.path.slice(0, data.pathLen);
};
$0ed269743e272412$var$Reporter.prototype.enterKey = function enterKey(key) {
    return this._reporterState.path.push(key);
};
$0ed269743e272412$var$Reporter.prototype.exitKey = function exitKey(index) {
    var state = this._reporterState;
    state.path = state.path.slice(0, index - 1);
};
$0ed269743e272412$var$Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
    var state = this._reporterState;
    this.exitKey(index);
    if (state.obj !== null) state.obj[key] = value;
};
$0ed269743e272412$var$Reporter.prototype.path = function path() {
    return this._reporterState.path.join('/');
};
$0ed269743e272412$var$Reporter.prototype.enterObject = function enterObject() {
    var state = this._reporterState;
    var prev = state.obj;
    state.obj = {};
    return prev;
};
$0ed269743e272412$var$Reporter.prototype.leaveObject = function leaveObject(prev) {
    var state = this._reporterState;
    var now = state.obj;
    state.obj = prev;
    return now;
};
$0ed269743e272412$var$Reporter.prototype.error = function error(msg) {
    var err;
    var state = this._reporterState;
    var inherited = msg instanceof $0ed269743e272412$var$ReporterError;
    if (inherited) err = msg;
    else err = new $0ed269743e272412$var$ReporterError(state.path.map(function(elem) {
        return '[' + JSON.stringify(elem) + ']';
    }).join(''), msg.message || msg, msg.stack);
    if (!state.options.partial) throw err;
    if (!inherited) state.errors.push(err);
    return err;
};
$0ed269743e272412$var$Reporter.prototype.wrapResult = function wrapResult(result) {
    var state = this._reporterState;
    if (!state.options.partial) return result;
    return {
        result: this.isError(result) ? null : result,
        errors: state.errors
    };
};
function $0ed269743e272412$var$ReporterError(path, msg) {
    this.path = path;
    this.rethrow(msg);
}
$jcXeW($0ed269743e272412$var$ReporterError, Error);
$0ed269743e272412$var$ReporterError.prototype.rethrow = function rethrow(msg) {
    this.message = msg + ' at: ' + (this.path || '(shallow)');
    if (Error.captureStackTrace) Error.captureStackTrace(this, $0ed269743e272412$var$ReporterError);
    if (!this.stack) try {
        // IE only adds stack when thrown
        throw new Error(this.message);
    } catch (e) {
        this.stack = e.stack;
    }
    return this;
};

});

parcelRegister("9sTRz", function(module, exports) {
$parcel$export(module.exports, "DecoderBuffer", () => $6e420fd45ff52ab5$export$bf9f79cdc4a49163, (v) => $6e420fd45ff52ab5$export$bf9f79cdc4a49163 = v);
$parcel$export(module.exports, "EncoderBuffer", () => $6e420fd45ff52ab5$export$8ff24f7760c7a78e, (v) => $6e420fd45ff52ab5$export$8ff24f7760c7a78e = v);
var $6e420fd45ff52ab5$export$bf9f79cdc4a49163;
var $6e420fd45ff52ab5$export$8ff24f7760c7a78e;

var $jcXeW = parcelRequire("jcXeW");

var $dDzkS = parcelRequire("dDzkS");
var $6e420fd45ff52ab5$require$Reporter = $dDzkS.Reporter;

var $b0qLu = parcelRequire("b0qLu");
var $6e420fd45ff52ab5$require$Buffer = $b0qLu.Buffer;
function $6e420fd45ff52ab5$var$DecoderBuffer(base, options) {
    $6e420fd45ff52ab5$require$Reporter.call(this, options);
    if (!$6e420fd45ff52ab5$require$Buffer.isBuffer(base)) {
        this.error('Input not Buffer');
        return;
    }
    this.base = base;
    this.offset = 0;
    this.length = base.length;
}
$jcXeW($6e420fd45ff52ab5$var$DecoderBuffer, $6e420fd45ff52ab5$require$Reporter);
$6e420fd45ff52ab5$export$bf9f79cdc4a49163 = $6e420fd45ff52ab5$var$DecoderBuffer;
$6e420fd45ff52ab5$var$DecoderBuffer.prototype.save = function save() {
    return {
        offset: this.offset,
        reporter: $6e420fd45ff52ab5$require$Reporter.prototype.save.call(this)
    };
};
$6e420fd45ff52ab5$var$DecoderBuffer.prototype.restore = function restore(save) {
    // Return skipped data
    var res = new $6e420fd45ff52ab5$var$DecoderBuffer(this.base);
    res.offset = save.offset;
    res.length = this.offset;
    this.offset = save.offset;
    $6e420fd45ff52ab5$require$Reporter.prototype.restore.call(this, save.reporter);
    return res;
};
$6e420fd45ff52ab5$var$DecoderBuffer.prototype.isEmpty = function isEmpty() {
    return this.offset === this.length;
};
$6e420fd45ff52ab5$var$DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
    if (this.offset + 1 <= this.length) return this.base.readUInt8(this.offset++, true);
    else return this.error(fail || 'DecoderBuffer overrun');
};
$6e420fd45ff52ab5$var$DecoderBuffer.prototype.skip = function skip(bytes, fail) {
    if (!(this.offset + bytes <= this.length)) return this.error(fail || 'DecoderBuffer overrun');
    var res = new $6e420fd45ff52ab5$var$DecoderBuffer(this.base);
    // Share reporter state
    res._reporterState = this._reporterState;
    res.offset = this.offset;
    res.length = this.offset + bytes;
    this.offset += bytes;
    return res;
};
$6e420fd45ff52ab5$var$DecoderBuffer.prototype.raw = function raw(save) {
    return this.base.slice(save ? save.offset : this.offset, this.length);
};
function $6e420fd45ff52ab5$var$EncoderBuffer(value, reporter) {
    if (Array.isArray(value)) {
        this.length = 0;
        this.value = value.map(function(item) {
            if (!(item instanceof $6e420fd45ff52ab5$var$EncoderBuffer)) item = new $6e420fd45ff52ab5$var$EncoderBuffer(item, reporter);
            this.length += item.length;
            return item;
        }, this);
    } else if (typeof value === 'number') {
        if (!(0 <= value && value <= 0xff)) return reporter.error('non-byte EncoderBuffer value');
        this.value = value;
        this.length = 1;
    } else if (typeof value === 'string') {
        this.value = value;
        this.length = $6e420fd45ff52ab5$require$Buffer.byteLength(value);
    } else if ($6e420fd45ff52ab5$require$Buffer.isBuffer(value)) {
        this.value = value;
        this.length = value.length;
    } else return reporter.error('Unsupported type: ' + typeof value);
}
$6e420fd45ff52ab5$export$8ff24f7760c7a78e = $6e420fd45ff52ab5$var$EncoderBuffer;
$6e420fd45ff52ab5$var$EncoderBuffer.prototype.join = function join(out, offset) {
    if (!out) out = new $6e420fd45ff52ab5$require$Buffer(this.length);
    if (!offset) offset = 0;
    if (this.length === 0) return out;
    if (Array.isArray(this.value)) this.value.forEach(function(item) {
        item.join(out, offset);
        offset += item.length;
    });
    else {
        if (typeof this.value === 'number') out[offset] = this.value;
        else if (typeof this.value === 'string') out.write(this.value, offset);
        else if ($6e420fd45ff52ab5$require$Buffer.isBuffer(this.value)) this.value.copy(out, offset);
        offset += this.length;
    }
    return out;
};

});

parcelRegister("dzdIX", function(module, exports) {

var $dDzkS = parcelRequire("dDzkS");
var $9e093097f375c273$require$Reporter = $dDzkS.Reporter;

var $dDzkS = parcelRequire("dDzkS");
var $9e093097f375c273$require$EncoderBuffer = $dDzkS.EncoderBuffer;

var $dDzkS = parcelRequire("dDzkS");
var $9e093097f375c273$require$DecoderBuffer = $dDzkS.DecoderBuffer;

var $hILGj = parcelRequire("hILGj");
// Supported tags
var $9e093097f375c273$var$tags = [
    'seq',
    'seqof',
    'set',
    'setof',
    'objid',
    'bool',
    'gentime',
    'utctime',
    'null_',
    'enum',
    'int',
    'objDesc',
    'bitstr',
    'bmpstr',
    'charstr',
    'genstr',
    'graphstr',
    'ia5str',
    'iso646str',
    'numstr',
    'octstr',
    'printstr',
    't61str',
    'unistr',
    'utf8str',
    'videostr'
];
// Public methods list
var $9e093097f375c273$var$methods = [
    'key',
    'obj',
    'use',
    'optional',
    'explicit',
    'implicit',
    'def',
    'choice',
    'any',
    'contains'
].concat($9e093097f375c273$var$tags);
// Overrided methods list
var $9e093097f375c273$var$overrided = [
    '_peekTag',
    '_decodeTag',
    '_use',
    '_decodeStr',
    '_decodeObjid',
    '_decodeTime',
    '_decodeNull',
    '_decodeInt',
    '_decodeBool',
    '_decodeList',
    '_encodeComposite',
    '_encodeStr',
    '_encodeObjid',
    '_encodeTime',
    '_encodeNull',
    '_encodeInt',
    '_encodeBool'
];
function $9e093097f375c273$var$Node(enc, parent) {
    var state = {};
    this._baseState = state;
    state.enc = enc;
    state.parent = parent || null;
    state.children = null;
    // State
    state.tag = null;
    state.args = null;
    state.reverseArgs = null;
    state.choice = null;
    state.optional = false;
    state.any = false;
    state.obj = false;
    state.use = null;
    state.useDecoder = null;
    state.key = null;
    state['default'] = null;
    state.explicit = null;
    state.implicit = null;
    state.contains = null;
    // Should create new instance on each method
    if (!state.parent) {
        state.children = [];
        this._wrap();
    }
}
module.exports = $9e093097f375c273$var$Node;
var $9e093097f375c273$var$stateProps = [
    'enc',
    'parent',
    'children',
    'tag',
    'args',
    'reverseArgs',
    'choice',
    'optional',
    'any',
    'obj',
    'use',
    'alteredUse',
    'key',
    'default',
    'explicit',
    'implicit',
    'contains'
];
$9e093097f375c273$var$Node.prototype.clone = function clone() {
    var state = this._baseState;
    var cstate = {};
    $9e093097f375c273$var$stateProps.forEach(function(prop) {
        cstate[prop] = state[prop];
    });
    var res = new this.constructor(cstate.parent);
    res._baseState = cstate;
    return res;
};
$9e093097f375c273$var$Node.prototype._wrap = function wrap() {
    var state = this._baseState;
    $9e093097f375c273$var$methods.forEach(function(method) {
        this[method] = function _wrappedMethod() {
            var clone = new this.constructor(this);
            state.children.push(clone);
            return clone[method].apply(clone, arguments);
        };
    }, this);
};
$9e093097f375c273$var$Node.prototype._init = function init(body) {
    var state = this._baseState;
    $hILGj(state.parent === null);
    body.call(this);
    // Filter children
    state.children = state.children.filter(function(child) {
        return child._baseState.parent === this;
    }, this);
    $hILGj.equal(state.children.length, 1, 'Root node can have only one child');
};
$9e093097f375c273$var$Node.prototype._useArgs = function useArgs(args) {
    var state = this._baseState;
    // Filter children and args
    var children = args.filter(function(arg) {
        return arg instanceof this.constructor;
    }, this);
    args = args.filter(function(arg) {
        return !(arg instanceof this.constructor);
    }, this);
    if (children.length !== 0) {
        $hILGj(state.children === null);
        state.children = children;
        // Replace parent to maintain backward link
        children.forEach(function(child) {
            child._baseState.parent = this;
        }, this);
    }
    if (args.length !== 0) {
        $hILGj(state.args === null);
        state.args = args;
        state.reverseArgs = args.map(function(arg) {
            if (typeof arg !== 'object' || arg.constructor !== Object) return arg;
            var res = {};
            Object.keys(arg).forEach(function(key) {
                if (key == (key | 0)) key |= 0;
                var value = arg[key];
                res[value] = key;
            });
            return res;
        });
    }
};
//
// Overrided methods
//
$9e093097f375c273$var$overrided.forEach(function(method) {
    $9e093097f375c273$var$Node.prototype[method] = function _overrided() {
        var state = this._baseState;
        throw new Error(method + ' not implemented for encoding: ' + state.enc);
    };
});
//
// Public methods
//
$9e093097f375c273$var$tags.forEach(function(tag) {
    $9e093097f375c273$var$Node.prototype[tag] = function _tagMethod() {
        var state = this._baseState;
        var args = Array.prototype.slice.call(arguments);
        $hILGj(state.tag === null);
        state.tag = tag;
        this._useArgs(args);
        return this;
    };
});
$9e093097f375c273$var$Node.prototype.use = function use(item) {
    $hILGj(item);
    var state = this._baseState;
    $hILGj(state.use === null);
    state.use = item;
    return this;
};
$9e093097f375c273$var$Node.prototype.optional = function optional() {
    var state = this._baseState;
    state.optional = true;
    return this;
};
$9e093097f375c273$var$Node.prototype.def = function def(val) {
    var state = this._baseState;
    $hILGj(state['default'] === null);
    state['default'] = val;
    state.optional = true;
    return this;
};
$9e093097f375c273$var$Node.prototype.explicit = function explicit(num) {
    var state = this._baseState;
    $hILGj(state.explicit === null && state.implicit === null);
    state.explicit = num;
    return this;
};
$9e093097f375c273$var$Node.prototype.implicit = function implicit(num) {
    var state = this._baseState;
    $hILGj(state.explicit === null && state.implicit === null);
    state.implicit = num;
    return this;
};
$9e093097f375c273$var$Node.prototype.obj = function obj() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);
    state.obj = true;
    if (args.length !== 0) this._useArgs(args);
    return this;
};
$9e093097f375c273$var$Node.prototype.key = function key(newKey) {
    var state = this._baseState;
    $hILGj(state.key === null);
    state.key = newKey;
    return this;
};
$9e093097f375c273$var$Node.prototype.any = function any() {
    var state = this._baseState;
    state.any = true;
    return this;
};
$9e093097f375c273$var$Node.prototype.choice = function choice(obj) {
    var state = this._baseState;
    $hILGj(state.choice === null);
    state.choice = obj;
    this._useArgs(Object.keys(obj).map(function(key) {
        return obj[key];
    }));
    return this;
};
$9e093097f375c273$var$Node.prototype.contains = function contains(item) {
    var state = this._baseState;
    $hILGj(state.use === null);
    state.contains = item;
    return this;
};
//
// Decoding
//
$9e093097f375c273$var$Node.prototype._decode = function decode(input, options) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return input.wrapResult(state.children[0]._decode(input, options));
    var result = state['default'];
    var present = true;
    var prevKey = null;
    if (state.key !== null) prevKey = input.enterKey(state.key);
    // Check if tag is there
    if (state.optional) {
        var tag = null;
        if (state.explicit !== null) tag = state.explicit;
        else if (state.implicit !== null) tag = state.implicit;
        else if (state.tag !== null) tag = state.tag;
        if (tag === null && !state.any) {
            // Trial and Error
            var save = input.save();
            try {
                if (state.choice === null) this._decodeGeneric(state.tag, input, options);
                else this._decodeChoice(input, options);
                present = true;
            } catch (e) {
                present = false;
            }
            input.restore(save);
        } else {
            present = this._peekTag(input, tag, state.any);
            if (input.isError(present)) return present;
        }
    }
    // Push object on stack
    var prevObj;
    if (state.obj && present) prevObj = input.enterObject();
    if (present) {
        // Unwrap explicit values
        if (state.explicit !== null) {
            var explicit = this._decodeTag(input, state.explicit);
            if (input.isError(explicit)) return explicit;
            input = explicit;
        }
        var start = input.offset;
        // Unwrap implicit and normal values
        if (state.use === null && state.choice === null) {
            if (state.any) var save = input.save();
            var body = this._decodeTag(input, state.implicit !== null ? state.implicit : state.tag, state.any);
            if (input.isError(body)) return body;
            if (state.any) result = input.raw(save);
            else input = body;
        }
        if (options && options.track && state.tag !== null) options.track(input.path(), start, input.length, 'tagged');
        if (options && options.track && state.tag !== null) options.track(input.path(), input.offset, input.length, 'content');
        // Select proper method for tag
        if (state.any) result;
        else if (state.choice === null) result = this._decodeGeneric(state.tag, input, options);
        else result = this._decodeChoice(input, options);
        if (input.isError(result)) return result;
        // Decode children
        if (!state.any && state.choice === null && state.children !== null) state.children.forEach(function decodeChildren(child) {
            // NOTE: We are ignoring errors here, to let parser continue with other
            // parts of encoded data
            child._decode(input, options);
        });
        // Decode contained/encoded by schema, only in bit or octet strings
        if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
            var data = new $9e093097f375c273$require$DecoderBuffer(result);
            result = this._getUse(state.contains, input._reporterState.obj)._decode(data, options);
        }
    }
    // Pop object
    if (state.obj && present) result = input.leaveObject(prevObj);
    // Set key
    if (state.key !== null && (result !== null || present === true)) input.leaveKey(prevKey, state.key, result);
    else if (prevKey !== null) input.exitKey(prevKey);
    return result;
};
$9e093097f375c273$var$Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
    var state = this._baseState;
    if (tag === 'seq' || tag === 'set') return null;
    if (tag === 'seqof' || tag === 'setof') return this._decodeList(input, tag, state.args[0], options);
    else if (/str$/.test(tag)) return this._decodeStr(input, tag, options);
    else if (tag === 'objid' && state.args) return this._decodeObjid(input, state.args[0], state.args[1], options);
    else if (tag === 'objid') return this._decodeObjid(input, null, null, options);
    else if (tag === 'gentime' || tag === 'utctime') return this._decodeTime(input, tag, options);
    else if (tag === 'null_') return this._decodeNull(input, options);
    else if (tag === 'bool') return this._decodeBool(input, options);
    else if (tag === 'objDesc') return this._decodeStr(input, tag, options);
    else if (tag === 'int' || tag === 'enum') return this._decodeInt(input, state.args && state.args[0], options);
    if (state.use !== null) return this._getUse(state.use, input._reporterState.obj)._decode(input, options);
    else return input.error('unknown tag: ' + tag);
};
$9e093097f375c273$var$Node.prototype._getUse = function _getUse(entity, obj) {
    var state = this._baseState;
    // Create altered use decoder if implicit is set
    state.useDecoder = this._use(entity, obj);
    $hILGj(state.useDecoder._baseState.parent === null);
    state.useDecoder = state.useDecoder._baseState.children[0];
    if (state.implicit !== state.useDecoder._baseState.implicit) {
        state.useDecoder = state.useDecoder.clone();
        state.useDecoder._baseState.implicit = state.implicit;
    }
    return state.useDecoder;
};
$9e093097f375c273$var$Node.prototype._decodeChoice = function decodeChoice(input, options) {
    var state = this._baseState;
    var result = null;
    var match = false;
    Object.keys(state.choice).some(function(key) {
        var save = input.save();
        var node = state.choice[key];
        try {
            var value = node._decode(input, options);
            if (input.isError(value)) return false;
            result = {
                type: key,
                value: value
            };
            match = true;
        } catch (e) {
            input.restore(save);
            return false;
        }
        return true;
    }, this);
    if (!match) return input.error('Choice not matched');
    return result;
};
//
// Encoding
//
$9e093097f375c273$var$Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
    return new $9e093097f375c273$require$EncoderBuffer(data, this.reporter);
};
$9e093097f375c273$var$Node.prototype._encode = function encode(data, reporter, parent) {
    var state = this._baseState;
    if (state['default'] !== null && state['default'] === data) return;
    var result = this._encodeValue(data, reporter, parent);
    if (result === undefined) return;
    if (this._skipDefault(result, reporter, parent)) return;
    return result;
};
$9e093097f375c273$var$Node.prototype._encodeValue = function encode(data, reporter, parent) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return state.children[0]._encode(data, reporter || new $9e093097f375c273$require$Reporter());
    var result = null;
    // Set reporter to share it with a child class
    this.reporter = reporter;
    // Check if data is there
    if (state.optional && data === undefined) {
        if (state['default'] !== null) data = state['default'];
        else return;
    }
    // Encode children first
    var content = null;
    var primitive = false;
    if (state.any) // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
    else if (state.choice) result = this._encodeChoice(data, reporter);
    else if (state.contains) {
        content = this._getUse(state.contains, parent)._encode(data, reporter);
        primitive = true;
    } else if (state.children) {
        content = state.children.map(function(child) {
            if (child._baseState.tag === 'null_') return child._encode(null, reporter, data);
            if (child._baseState.key === null) return reporter.error('Child should have a key');
            var prevKey = reporter.enterKey(child._baseState.key);
            if (typeof data !== 'object') return reporter.error('Child expected, but input is not object');
            var res = child._encode(data[child._baseState.key], reporter, data);
            reporter.leaveKey(prevKey);
            return res;
        }, this).filter(function(child) {
            return child;
        });
        content = this._createEncoderBuffer(content);
    } else {
        if (state.tag === 'seqof' || state.tag === 'setof') {
            // TODO(indutny): this should be thrown on DSL level
            if (!(state.args && state.args.length === 1)) return reporter.error('Too many args for : ' + state.tag);
            if (!Array.isArray(data)) return reporter.error('seqof/setof, but data is not Array');
            var child = this.clone();
            child._baseState.implicit = null;
            content = this._createEncoderBuffer(data.map(function(item) {
                var state = this._baseState;
                return this._getUse(state.args[0], data)._encode(item, reporter);
            }, child));
        } else if (state.use !== null) result = this._getUse(state.use, parent)._encode(data, reporter);
        else {
            content = this._encodePrimitive(state.tag, data);
            primitive = true;
        }
    }
    // Encode data itself
    var result;
    if (!state.any && state.choice === null) {
        var tag = state.implicit !== null ? state.implicit : state.tag;
        var cls = state.implicit === null ? 'universal' : 'context';
        if (tag === null) {
            if (state.use === null) reporter.error('Tag could be omitted only for .use()');
        } else if (state.use === null) result = this._encodeComposite(tag, primitive, cls, content);
    }
    // Wrap in explicit
    if (state.explicit !== null) result = this._encodeComposite(state.explicit, false, 'context', result);
    return result;
};
$9e093097f375c273$var$Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
    var state = this._baseState;
    var node = state.choice[data.type];
    if (!node) $hILGj(false, data.type + ' not found in ' + JSON.stringify(Object.keys(state.choice)));
    return node._encode(data.value, reporter);
};
$9e093097f375c273$var$Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
    var state = this._baseState;
    if (/str$/.test(tag)) return this._encodeStr(data, tag);
    else if (tag === 'objid' && state.args) return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
    else if (tag === 'objid') return this._encodeObjid(data, null, null);
    else if (tag === 'gentime' || tag === 'utctime') return this._encodeTime(data, tag);
    else if (tag === 'null_') return this._encodeNull();
    else if (tag === 'int' || tag === 'enum') return this._encodeInt(data, state.args && state.reverseArgs[0]);
    else if (tag === 'bool') return this._encodeBool(data);
    else if (tag === 'objDesc') return this._encodeStr(data, tag);
    else throw new Error('Unsupported tag: ' + tag);
};
$9e093097f375c273$var$Node.prototype._isNumstr = function isNumstr(str) {
    return /^[0-9 ]*$/.test(str);
};
$9e093097f375c273$var$Node.prototype._isPrintstr = function isPrintstr(str) {
    return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
};

});


parcelRegister("3YH8n", function(module, exports) {
var $2e586f3c55aa3950$var$constants = module.exports;
// Helper
$2e586f3c55aa3950$var$constants._reverse = function reverse(map) {
    var res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        var value = map[key];
        res[value] = key;
    });
    return res;
};

$2e586f3c55aa3950$var$constants.der = (parcelRequire("8N3sY"));

});
parcelRegister("8N3sY", function(module, exports) {
$parcel$export(module.exports, "tagClass", () => $666596ad682b0cba$export$3584c46ed60baee8, (v) => $666596ad682b0cba$export$3584c46ed60baee8 = v);
$parcel$export(module.exports, "tagClassByName", () => $666596ad682b0cba$export$f18596ef8d632e49, (v) => $666596ad682b0cba$export$f18596ef8d632e49 = v);
$parcel$export(module.exports, "tag", () => $666596ad682b0cba$export$2b067c6666111485, (v) => $666596ad682b0cba$export$2b067c6666111485 = v);
$parcel$export(module.exports, "tagByName", () => $666596ad682b0cba$export$f17df38a421ab9e3, (v) => $666596ad682b0cba$export$f17df38a421ab9e3 = v);
var $666596ad682b0cba$export$3584c46ed60baee8;
var $666596ad682b0cba$export$f18596ef8d632e49;
var $666596ad682b0cba$export$2b067c6666111485;
var $666596ad682b0cba$export$f17df38a421ab9e3;

var $3YH8n = parcelRequire("3YH8n");
$666596ad682b0cba$export$3584c46ed60baee8 = {
    0: 'universal',
    1: 'application',
    2: 'context',
    3: 'private'
};
$666596ad682b0cba$export$f18596ef8d632e49 = $3YH8n._reverse($666596ad682b0cba$export$3584c46ed60baee8);
$666596ad682b0cba$export$2b067c6666111485 = {
    0x00: 'end',
    0x01: 'bool',
    0x02: 'int',
    0x03: 'bitstr',
    0x04: 'octstr',
    0x05: 'null_',
    0x06: 'objid',
    0x07: 'objDesc',
    0x08: 'external',
    0x09: 'real',
    0x0a: 'enum',
    0x0b: 'embed',
    0x0c: 'utf8str',
    0x0d: 'relativeOid',
    0x10: 'seq',
    0x11: 'set',
    0x12: 'numstr',
    0x13: 'printstr',
    0x14: 't61str',
    0x15: 'videostr',
    0x16: 'ia5str',
    0x17: 'utctime',
    0x18: 'gentime',
    0x19: 'graphstr',
    0x1a: 'iso646str',
    0x1b: 'genstr',
    0x1c: 'unistr',
    0x1d: 'charstr',
    0x1e: 'bmpstr'
};
$666596ad682b0cba$export$f17df38a421ab9e3 = $3YH8n._reverse($666596ad682b0cba$export$2b067c6666111485);

});


parcelRegister("hu53k", function(module, exports) {
var $cba92860cd5317d8$var$decoders = module.exports;

$cba92860cd5317d8$var$decoders.der = (parcelRequire("lRgZ3"));

$cba92860cd5317d8$var$decoders.pem = (parcelRequire("lt3Nn"));

});
parcelRegister("lRgZ3", function(module, exports) {

var $jcXeW = parcelRequire("jcXeW");

var $locuy = parcelRequire("locuy");
var $fe9bb8da49ef9d85$var$base = $locuy.base;
var $fe9bb8da49ef9d85$var$bignum = $locuy.bignum;
// Import DER constants
var $fe9bb8da49ef9d85$var$der = $locuy.constants.der;
function $fe9bb8da49ef9d85$var$DERDecoder(entity) {
    this.enc = 'der';
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $fe9bb8da49ef9d85$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $fe9bb8da49ef9d85$var$DERDecoder;
$fe9bb8da49ef9d85$var$DERDecoder.prototype.decode = function decode(data, options) {
    if (!(data instanceof $fe9bb8da49ef9d85$var$base.DecoderBuffer)) data = new $fe9bb8da49ef9d85$var$base.DecoderBuffer(data, options);
    return this.tree._decode(data, options);
};
// Tree methods
function $fe9bb8da49ef9d85$var$DERNode(parent) {
    $fe9bb8da49ef9d85$var$base.Node.call(this, 'der', parent);
}
$jcXeW($fe9bb8da49ef9d85$var$DERNode, $fe9bb8da49ef9d85$var$base.Node);
$fe9bb8da49ef9d85$var$DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
    if (buffer.isEmpty()) return false;
    var state = buffer.save();
    var decodedTag = $fe9bb8da49ef9d85$var$derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    buffer.restore(state);
    return decodedTag.tag === tag || decodedTag.tagStr === tag || decodedTag.tagStr + 'of' === tag || any;
};
$fe9bb8da49ef9d85$var$DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
    var decodedTag = $fe9bb8da49ef9d85$var$derDecodeTag(buffer, 'Failed to decode tag of "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    var len = $fe9bb8da49ef9d85$var$derDecodeLen(buffer, decodedTag.primitive, 'Failed to get length of "' + tag + '"');
    // Failure
    if (buffer.isError(len)) return len;
    if (!any && decodedTag.tag !== tag && decodedTag.tagStr !== tag && decodedTag.tagStr + 'of' !== tag) return buffer.error('Failed to match tag: "' + tag + '"');
    if (decodedTag.primitive || len !== null) return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
    // Indefinite length... find END tag
    var state = buffer.save();
    var res = this._skipUntilEnd(buffer, 'Failed to skip indefinite length body: "' + this.tag + '"');
    if (buffer.isError(res)) return res;
    len = buffer.offset - state.offset;
    buffer.restore(state);
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};
$fe9bb8da49ef9d85$var$DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
    while(true){
        var tag = $fe9bb8da49ef9d85$var$derDecodeTag(buffer, fail);
        if (buffer.isError(tag)) return tag;
        var len = $fe9bb8da49ef9d85$var$derDecodeLen(buffer, tag.primitive, fail);
        if (buffer.isError(len)) return len;
        var res;
        if (tag.primitive || len !== null) res = buffer.skip(len);
        else res = this._skipUntilEnd(buffer, fail);
        // Failure
        if (buffer.isError(res)) return res;
        if (tag.tagStr === 'end') break;
    }
};
$fe9bb8da49ef9d85$var$DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder, options) {
    var result = [];
    while(!buffer.isEmpty()){
        var possibleEnd = this._peekTag(buffer, 'end');
        if (buffer.isError(possibleEnd)) return possibleEnd;
        var res = decoder.decode(buffer, 'der', options);
        if (buffer.isError(res) && possibleEnd) break;
        result.push(res);
    }
    return result;
};
$fe9bb8da49ef9d85$var$DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
    if (tag === 'bitstr') {
        var unused = buffer.readUInt8();
        if (buffer.isError(unused)) return unused;
        return {
            unused: unused,
            data: buffer.raw()
        };
    } else if (tag === 'bmpstr') {
        var raw = buffer.raw();
        if (raw.length % 2 === 1) return buffer.error('Decoding of string type: bmpstr length mismatch');
        var str = '';
        for(var i = 0; i < raw.length / 2; i++)str += String.fromCharCode(raw.readUInt16BE(i * 2));
        return str;
    } else if (tag === 'numstr') {
        var numstr = buffer.raw().toString('ascii');
        if (!this._isNumstr(numstr)) return buffer.error("Decoding of string type: numstr unsupported characters");
        return numstr;
    } else if (tag === 'octstr') return buffer.raw();
    else if (tag === 'objDesc') return buffer.raw();
    else if (tag === 'printstr') {
        var printstr = buffer.raw().toString('ascii');
        if (!this._isPrintstr(printstr)) return buffer.error("Decoding of string type: printstr unsupported characters");
        return printstr;
    } else if (/str$/.test(tag)) return buffer.raw().toString();
    else return buffer.error('Decoding of string type: ' + tag + ' unsupported');
};
$fe9bb8da49ef9d85$var$DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
    var result;
    var identifiers = [];
    var ident = 0;
    while(!buffer.isEmpty()){
        var subident = buffer.readUInt8();
        ident <<= 7;
        ident |= subident & 0x7f;
        if ((subident & 0x80) === 0) {
            identifiers.push(ident);
            ident = 0;
        }
    }
    if (subident & 0x80) identifiers.push(ident);
    var first = identifiers[0] / 40 | 0;
    var second = identifiers[0] % 40;
    if (relative) result = identifiers;
    else result = [
        first,
        second
    ].concat(identifiers.slice(1));
    if (values) {
        var tmp = values[result.join(' ')];
        if (tmp === undefined) tmp = values[result.join('.')];
        if (tmp !== undefined) result = tmp;
    }
    return result;
};
$fe9bb8da49ef9d85$var$DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
    var str = buffer.raw().toString();
    if (tag === 'gentime') {
        var year = str.slice(0, 4) | 0;
        var mon = str.slice(4, 6) | 0;
        var day = str.slice(6, 8) | 0;
        var hour = str.slice(8, 10) | 0;
        var min = str.slice(10, 12) | 0;
        var sec = str.slice(12, 14) | 0;
    } else if (tag === 'utctime') {
        var year = str.slice(0, 2) | 0;
        var mon = str.slice(2, 4) | 0;
        var day = str.slice(4, 6) | 0;
        var hour = str.slice(6, 8) | 0;
        var min = str.slice(8, 10) | 0;
        var sec = str.slice(10, 12) | 0;
        if (year < 70) year = 2000 + year;
        else year = 1900 + year;
    } else return buffer.error('Decoding ' + tag + ' time is not supported yet');
    return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};
$fe9bb8da49ef9d85$var$DERNode.prototype._decodeNull = function decodeNull(buffer) {
    return null;
};
$fe9bb8da49ef9d85$var$DERNode.prototype._decodeBool = function decodeBool(buffer) {
    var res = buffer.readUInt8();
    if (buffer.isError(res)) return res;
    else return res !== 0;
};
$fe9bb8da49ef9d85$var$DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
    // Bigint, return as it is (assume big endian)
    var raw = buffer.raw();
    var res = new $fe9bb8da49ef9d85$var$bignum(raw);
    if (values) res = values[res.toString(10)] || res;
    return res;
};
$fe9bb8da49ef9d85$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === 'function') entity = entity(obj);
    return entity._getDecoder('der').tree;
};
// Utility methods
function $fe9bb8da49ef9d85$var$derDecodeTag(buf, fail) {
    var tag = buf.readUInt8(fail);
    if (buf.isError(tag)) return tag;
    var cls = $fe9bb8da49ef9d85$var$der.tagClass[tag >> 6];
    var primitive = (tag & 0x20) === 0;
    // Multi-octet tag - load
    if ((tag & 0x1f) === 0x1f) {
        var oct = tag;
        tag = 0;
        while((oct & 0x80) === 0x80){
            oct = buf.readUInt8(fail);
            if (buf.isError(oct)) return oct;
            tag <<= 7;
            tag |= oct & 0x7f;
        }
    } else tag &= 0x1f;
    var tagStr = $fe9bb8da49ef9d85$var$der.tag[tag];
    return {
        cls: cls,
        primitive: primitive,
        tag: tag,
        tagStr: tagStr
    };
}
function $fe9bb8da49ef9d85$var$derDecodeLen(buf, primitive, fail) {
    var len = buf.readUInt8(fail);
    if (buf.isError(len)) return len;
    // Indefinite form
    if (!primitive && len === 0x80) return null;
    // Definite form
    if ((len & 0x80) === 0) // Short form
    return len;
    // Long form
    var num = len & 0x7f;
    if (num > 4) return buf.error('length octect is too long');
    len = 0;
    for(var i = 0; i < num; i++){
        len <<= 8;
        var j = buf.readUInt8(fail);
        if (buf.isError(j)) return j;
        len |= j;
    }
    return len;
}

});

parcelRegister("lt3Nn", function(module, exports) {

var $jcXeW = parcelRequire("jcXeW");

var $b0qLu = parcelRequire("b0qLu");
var $fa0f401e69606861$require$Buffer = $b0qLu.Buffer;

var $lRgZ3 = parcelRequire("lRgZ3");
function $fa0f401e69606861$var$PEMDecoder(entity) {
    $lRgZ3.call(this, entity);
    this.enc = 'pem';
}
$jcXeW($fa0f401e69606861$var$PEMDecoder, $lRgZ3);
module.exports = $fa0f401e69606861$var$PEMDecoder;
$fa0f401e69606861$var$PEMDecoder.prototype.decode = function decode(data, options) {
    var lines = data.toString().split(/[\r\n]+/g);
    var label = options.label.toUpperCase();
    var re = /^-----(BEGIN|END) ([^-]+)-----$/;
    var start = -1;
    var end = -1;
    for(var i = 0; i < lines.length; i++){
        var match = lines[i].match(re);
        if (match === null) continue;
        if (match[2] !== label) continue;
        if (start === -1) {
            if (match[1] !== 'BEGIN') break;
            start = i;
        } else {
            if (match[1] !== 'END') break;
            end = i;
            break;
        }
    }
    if (start === -1 || end === -1) throw new Error('PEM section not found for: ' + label);
    var base64 = lines.slice(start + 1, end).join('');
    // Remove excessive symbols
    base64.replace(/[^a-z0-9\+\/=]+/gi, '');
    var input = new $fa0f401e69606861$require$Buffer(base64, 'base64');
    return $lRgZ3.prototype.decode.call(this, input, options);
};

});


parcelRegister("8q8h8", function(module, exports) {
var $62172bc6cb2eb594$var$encoders = module.exports;

$62172bc6cb2eb594$var$encoders.der = (parcelRequire("76isd"));

$62172bc6cb2eb594$var$encoders.pem = (parcelRequire("3mzQs"));

});
parcelRegister("76isd", function(module, exports) {

var $jcXeW = parcelRequire("jcXeW");

var $b0qLu = parcelRequire("b0qLu");
var $52b76886ed85a353$require$Buffer = $b0qLu.Buffer;

var $locuy = parcelRequire("locuy");
var $52b76886ed85a353$var$base = $locuy.base;
// Import DER constants
var $52b76886ed85a353$var$der = $locuy.constants.der;
function $52b76886ed85a353$var$DEREncoder(entity) {
    this.enc = 'der';
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $52b76886ed85a353$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $52b76886ed85a353$var$DEREncoder;
$52b76886ed85a353$var$DEREncoder.prototype.encode = function encode(data, reporter) {
    return this.tree._encode(data, reporter).join();
};
// Tree methods
function $52b76886ed85a353$var$DERNode(parent) {
    $52b76886ed85a353$var$base.Node.call(this, 'der', parent);
}
$jcXeW($52b76886ed85a353$var$DERNode, $52b76886ed85a353$var$base.Node);
$52b76886ed85a353$var$DERNode.prototype._encodeComposite = function encodeComposite(tag, primitive, cls, content) {
    var encodedTag = $52b76886ed85a353$var$encodeTag(tag, primitive, cls, this.reporter);
    // Short form
    if (content.length < 0x80) {
        var header = new $52b76886ed85a353$require$Buffer(2);
        header[0] = encodedTag;
        header[1] = content.length;
        return this._createEncoderBuffer([
            header,
            content
        ]);
    }
    // Long form
    // Count octets required to store length
    var lenOctets = 1;
    for(var i = content.length; i >= 0x100; i >>= 8)lenOctets++;
    var header = new $52b76886ed85a353$require$Buffer(2 + lenOctets);
    header[0] = encodedTag;
    header[1] = 0x80 | lenOctets;
    for(var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)header[i] = j & 0xff;
    return this._createEncoderBuffer([
        header,
        content
    ]);
};
$52b76886ed85a353$var$DERNode.prototype._encodeStr = function encodeStr(str, tag) {
    if (tag === 'bitstr') return this._createEncoderBuffer([
        str.unused | 0,
        str.data
    ]);
    else if (tag === 'bmpstr') {
        var buf = new $52b76886ed85a353$require$Buffer(str.length * 2);
        for(var i = 0; i < str.length; i++)buf.writeUInt16BE(str.charCodeAt(i), i * 2);
        return this._createEncoderBuffer(buf);
    } else if (tag === 'numstr') {
        if (!this._isNumstr(str)) return this.reporter.error("Encoding of string type: numstr supports only digits and space");
        return this._createEncoderBuffer(str);
    } else if (tag === 'printstr') {
        if (!this._isPrintstr(str)) return this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark");
        return this._createEncoderBuffer(str);
    } else if (/str$/.test(tag)) return this._createEncoderBuffer(str);
    else if (tag === 'objDesc') return this._createEncoderBuffer(str);
    else return this.reporter.error('Encoding of string type: ' + tag + ' unsupported');
};
$52b76886ed85a353$var$DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
    if (typeof id === 'string') {
        if (!values) return this.reporter.error('string objid given, but no values map found');
        if (!values.hasOwnProperty(id)) return this.reporter.error('objid not found in values map');
        id = values[id].split(/[\s\.]+/g);
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    } else if (Array.isArray(id)) {
        id = id.slice();
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    }
    if (!Array.isArray(id)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(id));
    if (!relative) {
        if (id[1] >= 40) return this.reporter.error('Second objid identifier OOB');
        id.splice(0, 2, id[0] * 40 + id[1]);
    }
    // Count number of octets
    var size = 0;
    for(var i = 0; i < id.length; i++){
        var ident = id[i];
        for(size++; ident >= 0x80; ident >>= 7)size++;
    }
    var objid = new $52b76886ed85a353$require$Buffer(size);
    var offset = objid.length - 1;
    for(var i = id.length - 1; i >= 0; i--){
        var ident = id[i];
        objid[offset--] = ident & 0x7f;
        while((ident >>= 7) > 0)objid[offset--] = 0x80 | ident & 0x7f;
    }
    return this._createEncoderBuffer(objid);
};
function $52b76886ed85a353$var$two(num) {
    if (num < 10) return '0' + num;
    else return num;
}
$52b76886ed85a353$var$DERNode.prototype._encodeTime = function encodeTime(time, tag) {
    var str;
    var date = new Date(time);
    if (tag === 'gentime') str = [
        $52b76886ed85a353$var$two(date.getFullYear()),
        $52b76886ed85a353$var$two(date.getUTCMonth() + 1),
        $52b76886ed85a353$var$two(date.getUTCDate()),
        $52b76886ed85a353$var$two(date.getUTCHours()),
        $52b76886ed85a353$var$two(date.getUTCMinutes()),
        $52b76886ed85a353$var$two(date.getUTCSeconds()),
        'Z'
    ].join('');
    else if (tag === 'utctime') str = [
        $52b76886ed85a353$var$two(date.getFullYear() % 100),
        $52b76886ed85a353$var$two(date.getUTCMonth() + 1),
        $52b76886ed85a353$var$two(date.getUTCDate()),
        $52b76886ed85a353$var$two(date.getUTCHours()),
        $52b76886ed85a353$var$two(date.getUTCMinutes()),
        $52b76886ed85a353$var$two(date.getUTCSeconds()),
        'Z'
    ].join('');
    else this.reporter.error('Encoding ' + tag + ' time is not supported yet');
    return this._encodeStr(str, 'octstr');
};
$52b76886ed85a353$var$DERNode.prototype._encodeNull = function encodeNull() {
    return this._createEncoderBuffer('');
};
$52b76886ed85a353$var$DERNode.prototype._encodeInt = function encodeInt(num, values) {
    if (typeof num === 'string') {
        if (!values) return this.reporter.error('String int or enum given, but no values map');
        if (!values.hasOwnProperty(num)) return this.reporter.error('Values map doesn\'t contain: ' + JSON.stringify(num));
        num = values[num];
    }
    // Bignum, assume big endian
    if (typeof num !== 'number' && !$52b76886ed85a353$require$Buffer.isBuffer(num)) {
        var numArray = num.toArray();
        if (!num.sign && numArray[0] & 0x80) numArray.unshift(0);
        num = new $52b76886ed85a353$require$Buffer(numArray);
    }
    if ($52b76886ed85a353$require$Buffer.isBuffer(num)) {
        var size = num.length;
        if (num.length === 0) size++;
        var out = new $52b76886ed85a353$require$Buffer(size);
        num.copy(out);
        if (num.length === 0) out[0] = 0;
        return this._createEncoderBuffer(out);
    }
    if (num < 0x80) return this._createEncoderBuffer(num);
    if (num < 0x100) return this._createEncoderBuffer([
        0,
        num
    ]);
    var size = 1;
    for(var i = num; i >= 0x100; i >>= 8)size++;
    var out = new Array(size);
    for(var i = out.length - 1; i >= 0; i--){
        out[i] = num & 0xff;
        num >>= 8;
    }
    if (out[0] & 0x80) out.unshift(0);
    return this._createEncoderBuffer(new $52b76886ed85a353$require$Buffer(out));
};
$52b76886ed85a353$var$DERNode.prototype._encodeBool = function encodeBool(value) {
    return this._createEncoderBuffer(value ? 0xff : 0);
};
$52b76886ed85a353$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === 'function') entity = entity(obj);
    return entity._getEncoder('der').tree;
};
$52b76886ed85a353$var$DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
    var state = this._baseState;
    var i;
    if (state['default'] === null) return false;
    var data = dataBuffer.join();
    if (state.defaultBuffer === undefined) state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();
    if (data.length !== state.defaultBuffer.length) return false;
    for(i = 0; i < data.length; i++)if (data[i] !== state.defaultBuffer[i]) return false;
    return true;
};
// Utility methods
function $52b76886ed85a353$var$encodeTag(tag, primitive, cls, reporter) {
    var res;
    if (tag === 'seqof') tag = 'seq';
    else if (tag === 'setof') tag = 'set';
    if ($52b76886ed85a353$var$der.tagByName.hasOwnProperty(tag)) res = $52b76886ed85a353$var$der.tagByName[tag];
    else if (typeof tag === 'number' && (tag | 0) === tag) res = tag;
    else return reporter.error('Unknown tag: ' + tag);
    if (res >= 0x1f) return reporter.error('Multi-octet tag encoding unsupported');
    if (!primitive) res |= 0x20;
    res |= $52b76886ed85a353$var$der.tagClassByName[cls || 'universal'] << 6;
    return res;
}

});

parcelRegister("3mzQs", function(module, exports) {

var $jcXeW = parcelRequire("jcXeW");

var $76isd = parcelRequire("76isd");
function $272f3b435667eaa2$var$PEMEncoder(entity) {
    $76isd.call(this, entity);
    this.enc = 'pem';
}
$jcXeW($272f3b435667eaa2$var$PEMEncoder, $76isd);
module.exports = $272f3b435667eaa2$var$PEMEncoder;
$272f3b435667eaa2$var$PEMEncoder.prototype.encode = function encode(data, options) {
    var buf = $76isd.prototype.encode.call(this, data);
    var p = buf.toString('base64');
    var out = [
        '-----BEGIN ' + options.label + '-----'
    ];
    for(var i = 0; i < p.length; i += 64)out.push(p.slice(i, i + 64));
    out.push('-----END ' + options.label + '-----');
    return out.join('\n');
};

});



parcelRegister("1FH8O", function(module, exports) {
var indexOf = function(xs, item) {
    if (xs.indexOf) return xs.indexOf(item);
    else for(var i = 0; i < xs.length; i++){
        if (xs[i] === item) return i;
    }
    return -1;
};
var Object_keys = function(obj) {
    if (Object.keys) return Object.keys(obj);
    else {
        var res = [];
        for(var key in obj)res.push(key);
        return res;
    }
};
var forEach = function(xs, fn) {
    if (xs.forEach) return xs.forEach(fn);
    else for(var i = 0; i < xs.length; i++)fn(xs[i], i, xs);
};
var defineProp = function() {
    try {
        Object.defineProperty({}, '_', {});
        return function(obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            });
        };
    } catch (e) {
        return function(obj, name, value) {
            obj[name] = value;
        };
    }
}();
var globals = [
    'Array',
    'Boolean',
    'Date',
    'Error',
    'EvalError',
    'Function',
    'Infinity',
    'JSON',
    'Math',
    'NaN',
    'Number',
    'Object',
    'RangeError',
    'ReferenceError',
    'RegExp',
    'String',
    'SyntaxError',
    'TypeError',
    'URIError',
    'decodeURI',
    'decodeURIComponent',
    'encodeURI',
    'encodeURIComponent',
    'escape',
    'eval',
    'isFinite',
    'isNaN',
    'parseFloat',
    'parseInt',
    'undefined',
    'unescape'
];
function Context() {}
Context.prototype = {};
var Script = exports.Script = function NodeScript(code) {
    if (!(this instanceof Script)) return new Script(code);
    this.code = code;
};
Script.prototype.runInContext = function(context) {
    if (!(context instanceof Context)) throw new TypeError("needs a 'context' argument.");
    var iframe = document.createElement('iframe');
    if (!iframe.style) iframe.style = {};
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
    var win = iframe.contentWindow;
    var wEval = win.eval, wExecScript = win.execScript;
    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, 'null');
        wEval = win.eval;
    }
    forEach(Object_keys(context), function(key) {
        win[key] = context[key];
    });
    forEach(globals, function(key) {
        if (context[key]) win[key] = context[key];
    });
    var winKeys = Object_keys(win);
    var res = wEval.call(win, this.code);
    forEach(Object_keys(win), function(key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) context[key] = win[key];
    });
    forEach(globals, function(key) {
        if (!(key in context)) defineProp(context, key, win[key]);
    });
    document.body.removeChild(iframe);
    return res;
};
Script.prototype.runInThisContext = function() {
    return eval(this.code); // maybe...
};
Script.prototype.runInNewContext = function(context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);
    if (context) forEach(Object_keys(ctx), function(key) {
        context[key] = ctx[key];
    });
    return res;
};
forEach(Object_keys(Script.prototype), function(name) {
    exports[name] = Script[name] = function(code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});
exports.isContext = function(context) {
    return context instanceof Context;
};
exports.createScript = function(code) {
    return exports.Script(code);
};
exports.createContext = Script.createContext = function(context) {
    var copy = new Context();
    if (typeof context === 'object') forEach(Object_keys(context), function(key) {
        copy[key] = context[key];
    });
    return copy;
};

});


parcelRegister("6VRBu", function(module, exports) {
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen
'use strict';

var $locuy = parcelRequire("locuy");
var $50c1a58a7656cbec$var$Time = $locuy.define('Time', function() {
    this.choice({
        utcTime: this.utctime(),
        generalTime: this.gentime()
    });
});
var $50c1a58a7656cbec$var$AttributeTypeValue = $locuy.define('AttributeTypeValue', function() {
    this.seq().obj(this.key('type').objid(), this.key('value').any());
});
var $50c1a58a7656cbec$var$AlgorithmIdentifier = $locuy.define('AlgorithmIdentifier', function() {
    this.seq().obj(this.key('algorithm').objid(), this.key('parameters').optional(), this.key('curve').objid().optional());
});
var $50c1a58a7656cbec$var$SubjectPublicKeyInfo = $locuy.define('SubjectPublicKeyInfo', function() {
    this.seq().obj(this.key('algorithm').use($50c1a58a7656cbec$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
var $50c1a58a7656cbec$var$RelativeDistinguishedName = $locuy.define('RelativeDistinguishedName', function() {
    this.setof($50c1a58a7656cbec$var$AttributeTypeValue);
});
var $50c1a58a7656cbec$var$RDNSequence = $locuy.define('RDNSequence', function() {
    this.seqof($50c1a58a7656cbec$var$RelativeDistinguishedName);
});
var $50c1a58a7656cbec$var$Name = $locuy.define('Name', function() {
    this.choice({
        rdnSequence: this.use($50c1a58a7656cbec$var$RDNSequence)
    });
});
var $50c1a58a7656cbec$var$Validity = $locuy.define('Validity', function() {
    this.seq().obj(this.key('notBefore').use($50c1a58a7656cbec$var$Time), this.key('notAfter').use($50c1a58a7656cbec$var$Time));
});
var $50c1a58a7656cbec$var$Extension = $locuy.define('Extension', function() {
    this.seq().obj(this.key('extnID').objid(), this.key('critical').bool().def(false), this.key('extnValue').octstr());
});
var $50c1a58a7656cbec$var$TBSCertificate = $locuy.define('TBSCertificate', function() {
    this.seq().obj(this.key('version').explicit(0)['int']().optional(), this.key('serialNumber')['int'](), this.key('signature').use($50c1a58a7656cbec$var$AlgorithmIdentifier), this.key('issuer').use($50c1a58a7656cbec$var$Name), this.key('validity').use($50c1a58a7656cbec$var$Validity), this.key('subject').use($50c1a58a7656cbec$var$Name), this.key('subjectPublicKeyInfo').use($50c1a58a7656cbec$var$SubjectPublicKeyInfo), this.key('issuerUniqueID').implicit(1).bitstr().optional(), this.key('subjectUniqueID').implicit(2).bitstr().optional(), this.key('extensions').explicit(3).seqof($50c1a58a7656cbec$var$Extension).optional());
});
var $50c1a58a7656cbec$var$X509Certificate = $locuy.define('X509Certificate', function() {
    this.seq().obj(this.key('tbsCertificate').use($50c1a58a7656cbec$var$TBSCertificate), this.key('signatureAlgorithm').use($50c1a58a7656cbec$var$AlgorithmIdentifier), this.key('signatureValue').bitstr());
});
module.exports = $50c1a58a7656cbec$var$X509Certificate;

});

parcelRegister("771Iu", function(module, exports) {

var $b0qLu = parcelRequire("b0qLu");
var $52da84b84eb27239$require$Buffer = $b0qLu.Buffer;

var $hVpqU = parcelRequire("hVpqU");

var $kHwXh = parcelRequire("kHwXh");
module.exports = function createECDH(curve) {
    return new $52da84b84eb27239$var$ECDH(curve);
};
var $52da84b84eb27239$var$aliases = {
    secp256k1: {
        name: 'secp256k1',
        byteLength: 32
    },
    secp224r1: {
        name: 'p224',
        byteLength: 28
    },
    prime256v1: {
        name: 'p256',
        byteLength: 32
    },
    prime192v1: {
        name: 'p192',
        byteLength: 24
    },
    ed25519: {
        name: 'ed25519',
        byteLength: 32
    },
    secp384r1: {
        name: 'p384',
        byteLength: 48
    },
    secp521r1: {
        name: 'p521',
        byteLength: 66
    }
};
$52da84b84eb27239$var$aliases.p224 = $52da84b84eb27239$var$aliases.secp224r1;
$52da84b84eb27239$var$aliases.p256 = $52da84b84eb27239$var$aliases.secp256r1 = $52da84b84eb27239$var$aliases.prime256v1;
$52da84b84eb27239$var$aliases.p192 = $52da84b84eb27239$var$aliases.secp192r1 = $52da84b84eb27239$var$aliases.prime192v1;
$52da84b84eb27239$var$aliases.p384 = $52da84b84eb27239$var$aliases.secp384r1;
$52da84b84eb27239$var$aliases.p521 = $52da84b84eb27239$var$aliases.secp521r1;
function $52da84b84eb27239$var$ECDH(curve) {
    this.curveType = $52da84b84eb27239$var$aliases[curve];
    if (!this.curveType) this.curveType = {
        name: curve
    };
    this.curve = new $hVpqU.ec(this.curveType.name) // eslint-disable-line new-cap
    ;
    this.keys = void 0;
}
$52da84b84eb27239$var$ECDH.prototype.generateKeys = function(enc, format) {
    this.keys = this.curve.genKeyPair();
    return this.getPublicKey(enc, format);
};
$52da84b84eb27239$var$ECDH.prototype.computeSecret = function(other, inenc, enc) {
    inenc = inenc || 'utf8';
    if (!$52da84b84eb27239$require$Buffer.isBuffer(other)) other = new $52da84b84eb27239$require$Buffer(other, inenc);
    var otherPub = this.curve.keyFromPublic(other).getPublic();
    var out = otherPub.mul(this.keys.getPrivate()).getX();
    return $52da84b84eb27239$var$formatReturnValue(out, enc, this.curveType.byteLength);
};
$52da84b84eb27239$var$ECDH.prototype.getPublicKey = function(enc, format) {
    var key = this.keys.getPublic(format === 'compressed', true);
    if (format === 'hybrid') {
        if (key[key.length - 1] % 2) key[0] = 7;
        else key[0] = 6;
    }
    return $52da84b84eb27239$var$formatReturnValue(key, enc);
};
$52da84b84eb27239$var$ECDH.prototype.getPrivateKey = function(enc) {
    return $52da84b84eb27239$var$formatReturnValue(this.keys.getPrivate(), enc);
};
$52da84b84eb27239$var$ECDH.prototype.setPublicKey = function(pub, enc) {
    enc = enc || 'utf8';
    if (!$52da84b84eb27239$require$Buffer.isBuffer(pub)) pub = new $52da84b84eb27239$require$Buffer(pub, enc);
    this.keys._importPublic(pub);
    return this;
};
$52da84b84eb27239$var$ECDH.prototype.setPrivateKey = function(priv, enc) {
    enc = enc || 'utf8';
    if (!$52da84b84eb27239$require$Buffer.isBuffer(priv)) priv = new $52da84b84eb27239$require$Buffer(priv, enc);
    var _priv = new $kHwXh(priv);
    _priv = _priv.toString(16);
    this.keys = this.curve.genKeyPair();
    this.keys._importPrivate(_priv);
    return this;
};
function $52da84b84eb27239$var$formatReturnValue(bn, enc, len) {
    if (!Array.isArray(bn)) bn = bn.toArray();
    var buf = new $52da84b84eb27239$require$Buffer(bn);
    if (len && buf.length < len) {
        var zeros = new $52da84b84eb27239$require$Buffer(len - buf.length);
        zeros.fill(0);
        buf = $52da84b84eb27239$require$Buffer.concat([
            zeros,
            buf
        ]);
    }
    if (!enc) return buf;
    else return buf.toString(enc);
}

});
parcelRegister("hVpqU", function(module, exports) {
'use strict';
var $d0cb7cffeb261d92$var$elliptic = module.exports;

$d0cb7cffeb261d92$var$elliptic.version = (parcelRequire("cor5J")).version;

$d0cb7cffeb261d92$var$elliptic.utils = (parcelRequire("4PW5d"));

$d0cb7cffeb261d92$var$elliptic.rand = (parcelRequire("fZ33D"));

$d0cb7cffeb261d92$var$elliptic.curve = (parcelRequire("cqacU"));

$d0cb7cffeb261d92$var$elliptic.curves = (parcelRequire("6Ek6o"));

// Protocols
$d0cb7cffeb261d92$var$elliptic.ec = (parcelRequire("hsVfi"));

$d0cb7cffeb261d92$var$elliptic.eddsa = (parcelRequire("iCDtn"));

});


parcelRegister("2LSkK", function(module, exports) {

var $2SvhT = parcelRequire("2SvhT");

var $cN8vX = parcelRequire("cN8vX");

var $4Qxdz = parcelRequire("4Qxdz");

var $8OEaU = parcelRequire("8OEaU");

var $bh3FZ = parcelRequire("bh3FZ");

var $kHwXh = parcelRequire("kHwXh");

var $aNYQX = parcelRequire("aNYQX");

var $d6mSV = parcelRequire("d6mSV");

var $dmAgJ = parcelRequire("dmAgJ");
var $204a1e19f4494045$require$Buffer = $dmAgJ.Buffer;
module.exports = function publicEncrypt(publicKey, msg, reverse) {
    var padding;
    if (publicKey.padding) padding = publicKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $2SvhT(publicKey);
    var paddedMsg;
    if (padding === 4) paddedMsg = $204a1e19f4494045$var$oaep(key, msg);
    else if (padding === 1) paddedMsg = $204a1e19f4494045$var$pkcs1(key, msg, reverse);
    else if (padding === 3) {
        paddedMsg = new $kHwXh(msg);
        if (paddedMsg.cmp(key.modulus) >= 0) throw new Error('data too long for modulus');
    } else throw new Error('unknown padding');
    if (reverse) return $d6mSV(paddedMsg, key);
    else return $aNYQX(paddedMsg, key);
};
function $204a1e19f4494045$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var mLen = msg.length;
    var iHash = $4Qxdz('sha1').update($204a1e19f4494045$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    var hLen2 = 2 * hLen;
    if (mLen > k - hLen2 - 2) throw new Error('message too long');
    var ps = $204a1e19f4494045$require$Buffer.alloc(k - mLen - hLen2 - 2);
    var dblen = k - hLen - 1;
    var seed = $cN8vX(hLen);
    var maskedDb = $bh3FZ($204a1e19f4494045$require$Buffer.concat([
        iHash,
        ps,
        $204a1e19f4494045$require$Buffer.alloc(1, 1),
        msg
    ], dblen), $8OEaU(seed, dblen));
    var maskedSeed = $bh3FZ(seed, $8OEaU(maskedDb, hLen));
    return new $kHwXh($204a1e19f4494045$require$Buffer.concat([
        $204a1e19f4494045$require$Buffer.alloc(1),
        maskedSeed,
        maskedDb
    ], k));
}
function $204a1e19f4494045$var$pkcs1(key, msg, reverse) {
    var mLen = msg.length;
    var k = key.modulus.byteLength();
    if (mLen > k - 11) throw new Error('message too long');
    var ps;
    if (reverse) ps = $204a1e19f4494045$require$Buffer.alloc(k - mLen - 3, 0xff);
    else ps = $204a1e19f4494045$var$nonZero(k - mLen - 3);
    return new $kHwXh($204a1e19f4494045$require$Buffer.concat([
        $204a1e19f4494045$require$Buffer.from([
            0,
            reverse ? 1 : 2
        ]),
        ps,
        $204a1e19f4494045$require$Buffer.alloc(1),
        msg
    ], k));
}
function $204a1e19f4494045$var$nonZero(len) {
    var out = $204a1e19f4494045$require$Buffer.allocUnsafe(len);
    var i = 0;
    var cache = $cN8vX(len * 2);
    var cur = 0;
    var num;
    while(i < len){
        if (cur === cache.length) {
            cache = $cN8vX(len * 2);
            cur = 0;
        }
        num = cache[cur++];
        if (num) out[i++] = num;
    }
    return out;
}

});
parcelRegister("2SvhT", function(module, exports) {
'use strict';

var $6WVyr = parcelRequire("6WVyr");

var $i0fh3 = parcelRequire("i0fh3");

var $ipmg6 = parcelRequire("ipmg6");

var $3Gyxn = parcelRequire("3Gyxn");

var $gxFlu = parcelRequire("gxFlu");

var $dmAgJ = parcelRequire("dmAgJ");
var $2188e501ce2669f4$require$Buffer = $dmAgJ.Buffer;
function $2188e501ce2669f4$var$decrypt(data, password) {
    var salt = data.algorithm.decrypt.kde.kdeparams.salt;
    var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
    var algo = $i0fh3[data.algorithm.decrypt.cipher.algo.join('.')];
    var iv = data.algorithm.decrypt.cipher.iv;
    var cipherText = data.subjectPrivateKey;
    var keylen = parseInt(algo.split('-')[1], 10) / 8;
    var key = $gxFlu.pbkdf2Sync(password, salt, iters, keylen, 'sha1');
    var cipher = $3Gyxn.createDecipheriv(algo, key, iv);
    var out = [];
    out.push(cipher.update(cipherText));
    out.push(cipher['final']());
    return $2188e501ce2669f4$require$Buffer.concat(out);
}
function $2188e501ce2669f4$var$parseKeys(buffer) {
    var password;
    if (typeof buffer === 'object' && !$2188e501ce2669f4$require$Buffer.isBuffer(buffer)) {
        password = buffer.passphrase;
        buffer = buffer.key;
    }
    if (typeof buffer === 'string') buffer = $2188e501ce2669f4$require$Buffer.from(buffer);
    var stripped = $ipmg6(buffer, password);
    var type = stripped.tag;
    var data = stripped.data;
    var subtype, ndata;
    switch(type){
        case 'CERTIFICATE':
            ndata = $6WVyr.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo;
        // falls through
        case 'PUBLIC KEY':
            if (!ndata) ndata = $6WVyr.PublicKey.decode(data, 'der');
            subtype = ndata.algorithm.algorithm.join('.');
            switch(subtype){
                case '1.2.840.113549.1.1.1':
                    return $6WVyr.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der');
                case '1.2.840.10045.2.1':
                    ndata.subjectPrivateKey = ndata.subjectPublicKey;
                    return {
                        type: 'ec',
                        data: ndata
                    };
                case '1.2.840.10040.4.1':
                    ndata.algorithm.params.pub_key = $6WVyr.DSAparam.decode(ndata.subjectPublicKey.data, 'der');
                    return {
                        type: 'dsa',
                        data: ndata.algorithm.params
                    };
                default:
                    throw new Error('unknown key id ' + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case 'ENCRYPTED PRIVATE KEY':
            data = $6WVyr.EncryptedPrivateKey.decode(data, 'der');
            data = $2188e501ce2669f4$var$decrypt(data, password);
        // falls through
        case 'PRIVATE KEY':
            ndata = $6WVyr.PrivateKey.decode(data, 'der');
            subtype = ndata.algorithm.algorithm.join('.');
            switch(subtype){
                case '1.2.840.113549.1.1.1':
                    return $6WVyr.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der');
                case '1.2.840.10045.2.1':
                    return {
                        curve: ndata.algorithm.curve,
                        privateKey: $6WVyr.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
                    };
                case '1.2.840.10040.4.1':
                    ndata.algorithm.params.priv_key = $6WVyr.DSAparam.decode(ndata.subjectPrivateKey, 'der');
                    return {
                        type: 'dsa',
                        params: ndata.algorithm.params
                    };
                default:
                    throw new Error('unknown key id ' + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case 'RSA PUBLIC KEY':
            return $6WVyr.RSAPublicKey.decode(data, 'der');
        case 'RSA PRIVATE KEY':
            return $6WVyr.RSAPrivateKey.decode(data, 'der');
        case 'DSA PRIVATE KEY':
            return {
                type: 'dsa',
                params: $6WVyr.DSAPrivateKey.decode(data, 'der')
            };
        case 'EC PRIVATE KEY':
            data = $6WVyr.ECPrivateKey.decode(data, 'der');
            return {
                curve: data.parameters.value,
                privateKey: data.privateKey
            };
        default:
            throw new Error('unknown key type ' + type);
    }
}
$2188e501ce2669f4$var$parseKeys.signature = $6WVyr.signature;
module.exports = $2188e501ce2669f4$var$parseKeys;

});
parcelRegister("6WVyr", function(module, exports) {
$parcel$export(module.exports, "certificate", () => $50f4ce00bc4d8f2c$export$c98397a6eb8d0678, (v) => $50f4ce00bc4d8f2c$export$c98397a6eb8d0678 = v);
$parcel$export(module.exports, "RSAPrivateKey", () => $50f4ce00bc4d8f2c$export$f4aab6816f64fa6b, (v) => $50f4ce00bc4d8f2c$export$f4aab6816f64fa6b = v);
$parcel$export(module.exports, "RSAPublicKey", () => $50f4ce00bc4d8f2c$export$4471f5c65d097c11, (v) => $50f4ce00bc4d8f2c$export$4471f5c65d097c11 = v);
$parcel$export(module.exports, "PublicKey", () => $50f4ce00bc4d8f2c$export$ca8b6604d6ce14de, (v) => $50f4ce00bc4d8f2c$export$ca8b6604d6ce14de = v);
$parcel$export(module.exports, "PrivateKey", () => $50f4ce00bc4d8f2c$export$8f54525b330fd87b, (v) => $50f4ce00bc4d8f2c$export$8f54525b330fd87b = v);
$parcel$export(module.exports, "EncryptedPrivateKey", () => $50f4ce00bc4d8f2c$export$23cd2842b44ca3e7, (v) => $50f4ce00bc4d8f2c$export$23cd2842b44ca3e7 = v);
$parcel$export(module.exports, "DSAPrivateKey", () => $50f4ce00bc4d8f2c$export$245c9aaa9f5ce4ce, (v) => $50f4ce00bc4d8f2c$export$245c9aaa9f5ce4ce = v);
$parcel$export(module.exports, "DSAparam", () => $50f4ce00bc4d8f2c$export$8ad762e3e6399afe, (v) => $50f4ce00bc4d8f2c$export$8ad762e3e6399afe = v);
$parcel$export(module.exports, "ECPrivateKey", () => $50f4ce00bc4d8f2c$export$32ef6f92e22c6ab0, (v) => $50f4ce00bc4d8f2c$export$32ef6f92e22c6ab0 = v);
$parcel$export(module.exports, "signature", () => $50f4ce00bc4d8f2c$export$c9cd164b539ebb63, (v) => $50f4ce00bc4d8f2c$export$c9cd164b539ebb63 = v);
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.
var $50f4ce00bc4d8f2c$export$c98397a6eb8d0678;
var $50f4ce00bc4d8f2c$export$f4aab6816f64fa6b;
var $50f4ce00bc4d8f2c$export$4471f5c65d097c11;
var $50f4ce00bc4d8f2c$export$ca8b6604d6ce14de;
var $50f4ce00bc4d8f2c$export$8f54525b330fd87b;
var $50f4ce00bc4d8f2c$export$23cd2842b44ca3e7;
var $50f4ce00bc4d8f2c$export$245c9aaa9f5ce4ce;
var $50f4ce00bc4d8f2c$export$8ad762e3e6399afe;
var $50f4ce00bc4d8f2c$export$32ef6f92e22c6ab0;
var $50f4ce00bc4d8f2c$export$c9cd164b539ebb63;
'use strict';

var $locuy = parcelRequire("locuy");

$50f4ce00bc4d8f2c$export$c98397a6eb8d0678 = (parcelRequire("6VRBu"));
var $50f4ce00bc4d8f2c$var$RSAPrivateKey = $locuy.define('RSAPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('modulus')['int'](), this.key('publicExponent')['int'](), this.key('privateExponent')['int'](), this.key('prime1')['int'](), this.key('prime2')['int'](), this.key('exponent1')['int'](), this.key('exponent2')['int'](), this.key('coefficient')['int']());
});
$50f4ce00bc4d8f2c$export$f4aab6816f64fa6b = $50f4ce00bc4d8f2c$var$RSAPrivateKey;
var $50f4ce00bc4d8f2c$var$RSAPublicKey = $locuy.define('RSAPublicKey', function() {
    this.seq().obj(this.key('modulus')['int'](), this.key('publicExponent')['int']());
});
$50f4ce00bc4d8f2c$export$4471f5c65d097c11 = $50f4ce00bc4d8f2c$var$RSAPublicKey;
var $50f4ce00bc4d8f2c$var$AlgorithmIdentifier = $locuy.define('AlgorithmIdentifier', function() {
    this.seq().obj(this.key('algorithm').objid(), this.key('none').null_().optional(), this.key('curve').objid().optional(), this.key('params').seq().obj(this.key('p')['int'](), this.key('q')['int'](), this.key('g')['int']()).optional());
});
var $50f4ce00bc4d8f2c$var$PublicKey = $locuy.define('SubjectPublicKeyInfo', function() {
    this.seq().obj(this.key('algorithm').use($50f4ce00bc4d8f2c$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
$50f4ce00bc4d8f2c$export$ca8b6604d6ce14de = $50f4ce00bc4d8f2c$var$PublicKey;
var $50f4ce00bc4d8f2c$var$PrivateKeyInfo = $locuy.define('PrivateKeyInfo', function() {
    this.seq().obj(this.key('version')['int'](), this.key('algorithm').use($50f4ce00bc4d8f2c$var$AlgorithmIdentifier), this.key('subjectPrivateKey').octstr());
});
$50f4ce00bc4d8f2c$export$8f54525b330fd87b = $50f4ce00bc4d8f2c$var$PrivateKeyInfo;
var $50f4ce00bc4d8f2c$var$EncryptedPrivateKeyInfo = $locuy.define('EncryptedPrivateKeyInfo', function() {
    this.seq().obj(this.key('algorithm').seq().obj(this.key('id').objid(), this.key('decrypt').seq().obj(this.key('kde').seq().obj(this.key('id').objid(), this.key('kdeparams').seq().obj(this.key('salt').octstr(), this.key('iters')['int']())), this.key('cipher').seq().obj(this.key('algo').objid(), this.key('iv').octstr()))), this.key('subjectPrivateKey').octstr());
});
$50f4ce00bc4d8f2c$export$23cd2842b44ca3e7 = $50f4ce00bc4d8f2c$var$EncryptedPrivateKeyInfo;
var $50f4ce00bc4d8f2c$var$DSAPrivateKey = $locuy.define('DSAPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('p')['int'](), this.key('q')['int'](), this.key('g')['int'](), this.key('pub_key')['int'](), this.key('priv_key')['int']());
});
$50f4ce00bc4d8f2c$export$245c9aaa9f5ce4ce = $50f4ce00bc4d8f2c$var$DSAPrivateKey;
$50f4ce00bc4d8f2c$export$8ad762e3e6399afe = $locuy.define('DSAparam', function() {
    this['int']();
});
var $50f4ce00bc4d8f2c$var$ECParameters = $locuy.define('ECParameters', function() {
    this.choice({
        namedCurve: this.objid()
    });
});
var $50f4ce00bc4d8f2c$var$ECPrivateKey = $locuy.define('ECPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('privateKey').octstr(), this.key('parameters').optional().explicit(0).use($50f4ce00bc4d8f2c$var$ECParameters), this.key('publicKey').optional().explicit(1).bitstr());
});
$50f4ce00bc4d8f2c$export$32ef6f92e22c6ab0 = $50f4ce00bc4d8f2c$var$ECPrivateKey;
$50f4ce00bc4d8f2c$export$c9cd164b539ebb63 = $locuy.define('signature', function() {
    this.seq().obj(this.key('r')['int'](), this.key('s')['int']());
});

});

parcelRegister("i0fh3", function(module, exports) {
module.exports = JSON.parse("{\"2.16.840.1.101.3.4.1.1\":\"aes-128-ecb\",\"2.16.840.1.101.3.4.1.2\":\"aes-128-cbc\",\"2.16.840.1.101.3.4.1.3\":\"aes-128-ofb\",\"2.16.840.1.101.3.4.1.4\":\"aes-128-cfb\",\"2.16.840.1.101.3.4.1.21\":\"aes-192-ecb\",\"2.16.840.1.101.3.4.1.22\":\"aes-192-cbc\",\"2.16.840.1.101.3.4.1.23\":\"aes-192-ofb\",\"2.16.840.1.101.3.4.1.24\":\"aes-192-cfb\",\"2.16.840.1.101.3.4.1.41\":\"aes-256-ecb\",\"2.16.840.1.101.3.4.1.42\":\"aes-256-cbc\",\"2.16.840.1.101.3.4.1.43\":\"aes-256-ofb\",\"2.16.840.1.101.3.4.1.44\":\"aes-256-cfb\"}");

});

parcelRegister("ipmg6", function(module, exports) {
'use strict';
// adapted from https://github.com/apatil/pemstrip
var $d66bd3e6bb22df07$var$findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m;
var $d66bd3e6bb22df07$var$startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;
var $d66bd3e6bb22df07$var$fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m;

var $crCGb = parcelRequire("crCGb");

var $3Gyxn = parcelRequire("3Gyxn");

var $dmAgJ = parcelRequire("dmAgJ");
var $d66bd3e6bb22df07$require$Buffer = $dmAgJ.Buffer;
module.exports = function(okey, password) {
    var key = okey.toString();
    var match = key.match($d66bd3e6bb22df07$var$findProc);
    var decrypted;
    if (!match) {
        var match2 = key.match($d66bd3e6bb22df07$var$fullRegex);
        decrypted = $d66bd3e6bb22df07$require$Buffer.from(match2[2].replace(/[\r\n]/g, ''), 'base64');
    } else {
        var suite = 'aes' + match[1];
        var iv = $d66bd3e6bb22df07$require$Buffer.from(match[2], 'hex');
        var cipherText = $d66bd3e6bb22df07$require$Buffer.from(match[3].replace(/[\r\n]/g, ''), 'base64');
        var cipherKey = $crCGb(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
        var out = [];
        var cipher = $3Gyxn.createDecipheriv(suite, cipherKey, iv);
        out.push(cipher.update(cipherText));
        out.push(cipher['final']());
        decrypted = $d66bd3e6bb22df07$require$Buffer.concat(out);
    }
    var tag = key.match($d66bd3e6bb22df07$var$startRegex)[1];
    return {
        tag: tag,
        data: decrypted
    };
};

});
parcelRegister("crCGb", function(module, exports) {

var $dmAgJ = parcelRequire("dmAgJ");
var $90f602939e3531db$require$Buffer = $dmAgJ.Buffer;

var $ia0OJ = parcelRequire("ia0OJ");
/* eslint-disable camelcase */ function $90f602939e3531db$var$EVP_BytesToKey(password, salt, keyBits, ivLen) {
    if (!$90f602939e3531db$require$Buffer.isBuffer(password)) password = $90f602939e3531db$require$Buffer.from(password, 'binary');
    if (salt) {
        if (!$90f602939e3531db$require$Buffer.isBuffer(salt)) salt = $90f602939e3531db$require$Buffer.from(salt, 'binary');
        if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length');
    }
    var keyLen = keyBits / 8;
    var key = $90f602939e3531db$require$Buffer.alloc(keyLen);
    var iv = $90f602939e3531db$require$Buffer.alloc(ivLen || 0);
    var tmp = $90f602939e3531db$require$Buffer.alloc(0);
    while(keyLen > 0 || ivLen > 0){
        var hash = new $ia0OJ();
        hash.update(tmp);
        hash.update(password);
        if (salt) hash.update(salt);
        tmp = hash.digest();
        var used = 0;
        if (keyLen > 0) {
            var keyStart = key.length - keyLen;
            used = Math.min(keyLen, tmp.length);
            tmp.copy(key, keyStart, 0, used);
            keyLen -= used;
        }
        if (used < tmp.length && ivLen > 0) {
            var ivStart = iv.length - ivLen;
            var length = Math.min(ivLen, tmp.length - used);
            tmp.copy(iv, ivStart, used, used + length);
            ivLen -= length;
        }
    }
    tmp.fill(0);
    return {
        key: key,
        iv: iv
    };
}
module.exports = $90f602939e3531db$var$EVP_BytesToKey;

});

parcelRegister("3Gyxn", function(module, exports) {
$parcel$export(module.exports, "createCipheriv", () => $2af015be44c45c0d$export$2f64596b8cbf08b4, (v) => $2af015be44c45c0d$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createDecipheriv", () => $2af015be44c45c0d$export$36b6d6ef312eab39, (v) => $2af015be44c45c0d$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "getCiphers", () => $2af015be44c45c0d$export$58a258485f1e49f6, (v) => $2af015be44c45c0d$export$58a258485f1e49f6 = v);
var $2af015be44c45c0d$export$bdd223f16383713e;
var $2af015be44c45c0d$export$26e5786e8ac8e530;
var $2af015be44c45c0d$export$2f64596b8cbf08b4;
var $2af015be44c45c0d$export$20533d26f07f1ee0;
var $2af015be44c45c0d$export$12ada9414fbc594c;
var $2af015be44c45c0d$export$2ce6d8d0e8b04e1a;
var $2af015be44c45c0d$export$36b6d6ef312eab39;
var $2af015be44c45c0d$export$f5e7e39d57cd9700;
var $2af015be44c45c0d$export$dedd8dc3dc62b370;
var $2af015be44c45c0d$export$58a258485f1e49f6;

var $8GeoK = parcelRequire("8GeoK");

var $eH6eX = parcelRequire("eH6eX");

var $8BeER = parcelRequire("8BeER");
function $2af015be44c45c0d$var$getCiphers() {
    return Object.keys($8BeER);
}
$2af015be44c45c0d$export$bdd223f16383713e = $2af015be44c45c0d$export$26e5786e8ac8e530 = $8GeoK.createCipher;
$2af015be44c45c0d$export$2f64596b8cbf08b4 = $2af015be44c45c0d$export$20533d26f07f1ee0 = $8GeoK.createCipheriv;
$2af015be44c45c0d$export$12ada9414fbc594c = $2af015be44c45c0d$export$2ce6d8d0e8b04e1a = $eH6eX.createDecipher;
$2af015be44c45c0d$export$36b6d6ef312eab39 = $2af015be44c45c0d$export$f5e7e39d57cd9700 = $eH6eX.createDecipheriv;
$2af015be44c45c0d$export$dedd8dc3dc62b370 = $2af015be44c45c0d$export$58a258485f1e49f6 = $2af015be44c45c0d$var$getCiphers;

});
parcelRegister("8GeoK", function(module, exports) {
$parcel$export(module.exports, "createCipheriv", () => $651d6a25dde19b48$export$2f64596b8cbf08b4, (v) => $651d6a25dde19b48$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createCipher", () => $651d6a25dde19b48$export$bdd223f16383713e, (v) => $651d6a25dde19b48$export$bdd223f16383713e = v);
var $651d6a25dde19b48$export$2f64596b8cbf08b4;
var $651d6a25dde19b48$export$bdd223f16383713e;

var $cu5JN = parcelRequire("cu5JN");

var $cBm6t = parcelRequire("cBm6t");

var $dmAgJ = parcelRequire("dmAgJ");
var $651d6a25dde19b48$require$Buffer = $dmAgJ.Buffer;

var $dbpC5 = parcelRequire("dbpC5");

var $h4bOS = parcelRequire("h4bOS");

var $1CF0y = parcelRequire("1CF0y");

var $crCGb = parcelRequire("crCGb");

var $jcXeW = parcelRequire("jcXeW");
function $651d6a25dde19b48$var$Cipher(mode, key, iv) {
    $h4bOS.call(this);
    this._cache = new $651d6a25dde19b48$var$Splitter();
    this._cipher = new $1CF0y.AES(key);
    this._prev = $651d6a25dde19b48$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$jcXeW($651d6a25dde19b48$var$Cipher, $h4bOS);
$651d6a25dde19b48$var$Cipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get()){
        thing = this._mode.encrypt(this, chunk);
        out.push(thing);
    }
    return $651d6a25dde19b48$require$Buffer.concat(out);
};
var $651d6a25dde19b48$var$PADDING = $651d6a25dde19b48$require$Buffer.alloc(16, 0x10);
$651d6a25dde19b48$var$Cipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) {
        chunk = this._mode.encrypt(this, chunk);
        this._cipher.scrub();
        return chunk;
    }
    if (!chunk.equals($651d6a25dde19b48$var$PADDING)) {
        this._cipher.scrub();
        throw new Error('data not multiple of block length');
    }
};
$651d6a25dde19b48$var$Cipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $651d6a25dde19b48$var$Splitter() {
    this.cache = $651d6a25dde19b48$require$Buffer.allocUnsafe(0);
}
$651d6a25dde19b48$var$Splitter.prototype.add = function(data) {
    this.cache = $651d6a25dde19b48$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$651d6a25dde19b48$var$Splitter.prototype.get = function() {
    if (this.cache.length > 15) {
        var out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$651d6a25dde19b48$var$Splitter.prototype.flush = function() {
    var len = 16 - this.cache.length;
    var padBuff = $651d6a25dde19b48$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)padBuff.writeUInt8(len, i);
    return $651d6a25dde19b48$require$Buffer.concat([
        this.cache,
        padBuff
    ]);
};
function $651d6a25dde19b48$var$createCipheriv(suite, password, iv) {
    var config = $cu5JN[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    if (typeof password === 'string') password = $651d6a25dde19b48$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
    if (typeof iv === 'string') iv = $651d6a25dde19b48$require$Buffer.from(iv);
    if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
    if (config.type === 'stream') return new $dbpC5(config.module, password, iv);
    else if (config.type === 'auth') return new $cBm6t(config.module, password, iv);
    return new $651d6a25dde19b48$var$Cipher(config.module, password, iv);
}
function $651d6a25dde19b48$var$createCipher(suite, password) {
    var config = $cu5JN[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    var keys = $crCGb(password, false, config.key, config.iv);
    return $651d6a25dde19b48$var$createCipheriv(suite, keys.key, keys.iv);
}
$651d6a25dde19b48$export$2f64596b8cbf08b4 = $651d6a25dde19b48$var$createCipheriv;
$651d6a25dde19b48$export$bdd223f16383713e = $651d6a25dde19b48$var$createCipher;

});
parcelRegister("cu5JN", function(module, exports) {








var $916cbcc3cf192c68$var$modeModules = {
    ECB: (parcelRequire("cgQSS")),
    CBC: (parcelRequire("j6TXB")),
    CFB: (parcelRequire("3kK1N")),
    CFB8: (parcelRequire("czb0l")),
    CFB1: (parcelRequire("9woLd")),
    OFB: (parcelRequire("gDgzE")),
    CTR: (parcelRequire("dKqnh")),
    GCM: (parcelRequire("dKqnh"))
};

var $8BeER = parcelRequire("8BeER");
for(var $916cbcc3cf192c68$var$key in $8BeER)$8BeER[$916cbcc3cf192c68$var$key].module = $916cbcc3cf192c68$var$modeModules[$8BeER[$916cbcc3cf192c68$var$key].mode];
module.exports = $8BeER;

});
parcelRegister("8BeER", function(module, exports) {
module.exports = JSON.parse("{\"aes-128-ecb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-192-ecb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-256-ecb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-128-cbc\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-192-cbc\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-256-cbc\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes128\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes192\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes256\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-128-cfb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-192-cfb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-256-cfb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-128-cfb8\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-192-cfb8\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-256-cfb8\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-128-cfb1\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-192-cfb1\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-256-cfb1\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-128-ofb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-192-ofb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-256-ofb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-128-ctr\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-192-ctr\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-256-ctr\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-128-gcm\":{\"cipher\":\"AES\",\"key\":128,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-192-gcm\":{\"cipher\":\"AES\",\"key\":192,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-256-gcm\":{\"cipher\":\"AES\",\"key\":256,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"}}");

});


parcelRegister("cBm6t", function(module, exports) {

var $1CF0y = parcelRequire("1CF0y");

var $dmAgJ = parcelRequire("dmAgJ");
var $92ca160627702d1e$require$Buffer = $dmAgJ.Buffer;

var $h4bOS = parcelRequire("h4bOS");

var $jcXeW = parcelRequire("jcXeW");

var $3z2xR = parcelRequire("3z2xR");

var $eJhey = parcelRequire("eJhey");

var $7HX5Y = parcelRequire("7HX5Y");
function $92ca160627702d1e$var$xorTest(a, b) {
    var out = 0;
    if (a.length !== b.length) out++;
    var len = Math.min(a.length, b.length);
    for(var i = 0; i < len; ++i)out += a[i] ^ b[i];
    return out;
}
function $92ca160627702d1e$var$calcIv(self, iv, ck) {
    if (iv.length === 12) {
        self._finID = $92ca160627702d1e$require$Buffer.concat([
            iv,
            $92ca160627702d1e$require$Buffer.from([
                0,
                0,
                0,
                1
            ])
        ]);
        return $92ca160627702d1e$require$Buffer.concat([
            iv,
            $92ca160627702d1e$require$Buffer.from([
                0,
                0,
                0,
                2
            ])
        ]);
    }
    var ghash = new $3z2xR(ck);
    var len = iv.length;
    var toPad = len % 16;
    ghash.update(iv);
    if (toPad) {
        toPad = 16 - toPad;
        ghash.update($92ca160627702d1e$require$Buffer.alloc(toPad, 0));
    }
    ghash.update($92ca160627702d1e$require$Buffer.alloc(8, 0));
    var ivBits = len * 8;
    var tail = $92ca160627702d1e$require$Buffer.alloc(8);
    tail.writeUIntBE(ivBits, 0, 8);
    ghash.update(tail);
    self._finID = ghash.state;
    var out = $92ca160627702d1e$require$Buffer.from(self._finID);
    $7HX5Y(out);
    return out;
}
function $92ca160627702d1e$var$StreamCipher(mode, key, iv, decrypt) {
    $h4bOS.call(this);
    var h = $92ca160627702d1e$require$Buffer.alloc(4, 0);
    this._cipher = new $1CF0y.AES(key);
    var ck = this._cipher.encryptBlock(h);
    this._ghash = new $3z2xR(ck);
    iv = $92ca160627702d1e$var$calcIv(this, iv, ck);
    this._prev = $92ca160627702d1e$require$Buffer.from(iv);
    this._cache = $92ca160627702d1e$require$Buffer.allocUnsafe(0);
    this._secCache = $92ca160627702d1e$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._alen = 0;
    this._len = 0;
    this._mode = mode;
    this._authTag = null;
    this._called = false;
}
$jcXeW($92ca160627702d1e$var$StreamCipher, $h4bOS);
$92ca160627702d1e$var$StreamCipher.prototype._update = function(chunk) {
    if (!this._called && this._alen) {
        var rump = 16 - this._alen % 16;
        if (rump < 16) {
            rump = $92ca160627702d1e$require$Buffer.alloc(rump, 0);
            this._ghash.update(rump);
        }
    }
    this._called = true;
    var out = this._mode.encrypt(this, chunk);
    if (this._decrypt) this._ghash.update(chunk);
    else this._ghash.update(out);
    this._len += chunk.length;
    return out;
};
$92ca160627702d1e$var$StreamCipher.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data');
    var tag = $eJhey(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && $92ca160627702d1e$var$xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data');
    this._authTag = tag;
    this._cipher.scrub();
};
$92ca160627702d1e$var$StreamCipher.prototype.getAuthTag = function getAuthTag() {
    if (this._decrypt || !$92ca160627702d1e$require$Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state');
    return this._authTag;
};
$92ca160627702d1e$var$StreamCipher.prototype.setAuthTag = function setAuthTag(tag) {
    if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state');
    this._authTag = tag;
};
$92ca160627702d1e$var$StreamCipher.prototype.setAAD = function setAAD(buf) {
    if (this._called) throw new Error('Attempting to set AAD in unsupported state');
    this._ghash.update(buf);
    this._alen += buf.length;
};
module.exports = $92ca160627702d1e$var$StreamCipher;

});
parcelRegister("1CF0y", function(module, exports) {
$parcel$export(module.exports, "AES", () => $12e9265ebd9dc709$export$b80fbe1c3a2b92b5, (v) => $12e9265ebd9dc709$export$b80fbe1c3a2b92b5 = v);
// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/
var $12e9265ebd9dc709$export$b80fbe1c3a2b92b5;

var $dmAgJ = parcelRequire("dmAgJ");
var $12e9265ebd9dc709$require$Buffer = $dmAgJ.Buffer;
function $12e9265ebd9dc709$var$asUInt32Array(buf) {
    if (!$12e9265ebd9dc709$require$Buffer.isBuffer(buf)) buf = $12e9265ebd9dc709$require$Buffer.from(buf);
    var len = buf.length / 4 | 0;
    var out = new Array(len);
    for(var i = 0; i < len; i++)out[i] = buf.readUInt32BE(i * 4);
    return out;
}
function $12e9265ebd9dc709$var$scrubVec(v) {
    for(var i = 0; i < v.length; v++)v[i] = 0;
}
function $12e9265ebd9dc709$var$cryptBlock(M, keySchedule, SUB_MIX, SBOX, nRounds) {
    var SUB_MIX0 = SUB_MIX[0];
    var SUB_MIX1 = SUB_MIX[1];
    var SUB_MIX2 = SUB_MIX[2];
    var SUB_MIX3 = SUB_MIX[3];
    var s0 = M[0] ^ keySchedule[0];
    var s1 = M[1] ^ keySchedule[1];
    var s2 = M[2] ^ keySchedule[2];
    var s3 = M[3] ^ keySchedule[3];
    var t0, t1, t2, t3;
    var ksRow = 4;
    for(var round = 1; round < nRounds; round++){
        t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[s1 >>> 16 & 0xff] ^ SUB_MIX2[s2 >>> 8 & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++];
        t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[s2 >>> 16 & 0xff] ^ SUB_MIX2[s3 >>> 8 & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++];
        t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[s3 >>> 16 & 0xff] ^ SUB_MIX2[s0 >>> 8 & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++];
        t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[s0 >>> 16 & 0xff] ^ SUB_MIX2[s1 >>> 8 & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++];
        s0 = t0;
        s1 = t1;
        s2 = t2;
        s3 = t3;
    }
    t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
    t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
    t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
    t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
    t0 = t0 >>> 0;
    t1 = t1 >>> 0;
    t2 = t2 >>> 0;
    t3 = t3 >>> 0;
    return [
        t0,
        t1,
        t2,
        t3
    ];
}
// AES constants
var $12e9265ebd9dc709$var$RCON = [
    0x00,
    0x01,
    0x02,
    0x04,
    0x08,
    0x10,
    0x20,
    0x40,
    0x80,
    0x1b,
    0x36
];
var $12e9265ebd9dc709$var$G = function() {
    // Compute double table
    var d = new Array(256);
    for(var j = 0; j < 256; j++)if (j < 128) d[j] = j << 1;
    else d[j] = j << 1 ^ 0x11b;
    var SBOX = [];
    var INV_SBOX = [];
    var SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    var INV_SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    // Walk GF(2^8)
    var x = 0;
    var xi = 0;
    for(var i = 0; i < 256; ++i){
        // Compute sbox
        var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
        sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
        SBOX[x] = sx;
        INV_SBOX[sx] = x;
        // Compute multiplication
        var x2 = d[x];
        var x4 = d[x2];
        var x8 = d[x4];
        // Compute sub bytes, mix columns tables
        var t = d[sx] * 0x101 ^ sx * 0x1010100;
        SUB_MIX[0][x] = t << 24 | t >>> 8;
        SUB_MIX[1][x] = t << 16 | t >>> 16;
        SUB_MIX[2][x] = t << 8 | t >>> 24;
        SUB_MIX[3][x] = t;
        // Compute inv sub bytes, inv mix columns tables
        t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
        INV_SUB_MIX[0][sx] = t << 24 | t >>> 8;
        INV_SUB_MIX[1][sx] = t << 16 | t >>> 16;
        INV_SUB_MIX[2][sx] = t << 8 | t >>> 24;
        INV_SUB_MIX[3][sx] = t;
        if (x === 0) x = xi = 1;
        else {
            x = x2 ^ d[d[d[x8 ^ x2]]];
            xi ^= d[d[xi]];
        }
    }
    return {
        SBOX: SBOX,
        INV_SBOX: INV_SBOX,
        SUB_MIX: SUB_MIX,
        INV_SUB_MIX: INV_SUB_MIX
    };
}();
function $12e9265ebd9dc709$var$AES(key) {
    this._key = $12e9265ebd9dc709$var$asUInt32Array(key);
    this._reset();
}
$12e9265ebd9dc709$var$AES.blockSize = 16;
$12e9265ebd9dc709$var$AES.keySize = 32;
$12e9265ebd9dc709$var$AES.prototype.blockSize = $12e9265ebd9dc709$var$AES.blockSize;
$12e9265ebd9dc709$var$AES.prototype.keySize = $12e9265ebd9dc709$var$AES.keySize;
$12e9265ebd9dc709$var$AES.prototype._reset = function() {
    var keyWords = this._key;
    var keySize = keyWords.length;
    var nRounds = keySize + 6;
    var ksRows = (nRounds + 1) * 4;
    var keySchedule = [];
    for(var k = 0; k < keySize; k++)keySchedule[k] = keyWords[k];
    for(k = keySize; k < ksRows; k++){
        var t = keySchedule[k - 1];
        if (k % keySize === 0) {
            t = t << 8 | t >>> 24;
            t = $12e9265ebd9dc709$var$G.SBOX[t >>> 24] << 24 | $12e9265ebd9dc709$var$G.SBOX[t >>> 16 & 0xff] << 16 | $12e9265ebd9dc709$var$G.SBOX[t >>> 8 & 0xff] << 8 | $12e9265ebd9dc709$var$G.SBOX[t & 0xff];
            t ^= $12e9265ebd9dc709$var$RCON[k / keySize | 0] << 24;
        } else if (keySize > 6 && k % keySize === 4) t = $12e9265ebd9dc709$var$G.SBOX[t >>> 24] << 24 | $12e9265ebd9dc709$var$G.SBOX[t >>> 16 & 0xff] << 16 | $12e9265ebd9dc709$var$G.SBOX[t >>> 8 & 0xff] << 8 | $12e9265ebd9dc709$var$G.SBOX[t & 0xff];
        keySchedule[k] = keySchedule[k - keySize] ^ t;
    }
    var invKeySchedule = [];
    for(var ik = 0; ik < ksRows; ik++){
        var ksR = ksRows - ik;
        var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)];
        if (ik < 4 || ksR <= 4) invKeySchedule[ik] = tt;
        else invKeySchedule[ik] = $12e9265ebd9dc709$var$G.INV_SUB_MIX[0][$12e9265ebd9dc709$var$G.SBOX[tt >>> 24]] ^ $12e9265ebd9dc709$var$G.INV_SUB_MIX[1][$12e9265ebd9dc709$var$G.SBOX[tt >>> 16 & 0xff]] ^ $12e9265ebd9dc709$var$G.INV_SUB_MIX[2][$12e9265ebd9dc709$var$G.SBOX[tt >>> 8 & 0xff]] ^ $12e9265ebd9dc709$var$G.INV_SUB_MIX[3][$12e9265ebd9dc709$var$G.SBOX[tt & 0xff]];
    }
    this._nRounds = nRounds;
    this._keySchedule = keySchedule;
    this._invKeySchedule = invKeySchedule;
};
$12e9265ebd9dc709$var$AES.prototype.encryptBlockRaw = function(M) {
    M = $12e9265ebd9dc709$var$asUInt32Array(M);
    return $12e9265ebd9dc709$var$cryptBlock(M, this._keySchedule, $12e9265ebd9dc709$var$G.SUB_MIX, $12e9265ebd9dc709$var$G.SBOX, this._nRounds);
};
$12e9265ebd9dc709$var$AES.prototype.encryptBlock = function(M) {
    var out = this.encryptBlockRaw(M);
    var buf = $12e9265ebd9dc709$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[1], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[3], 12);
    return buf;
};
$12e9265ebd9dc709$var$AES.prototype.decryptBlock = function(M) {
    M = $12e9265ebd9dc709$var$asUInt32Array(M);
    // swap
    var m1 = M[1];
    M[1] = M[3];
    M[3] = m1;
    var out = $12e9265ebd9dc709$var$cryptBlock(M, this._invKeySchedule, $12e9265ebd9dc709$var$G.INV_SUB_MIX, $12e9265ebd9dc709$var$G.INV_SBOX, this._nRounds);
    var buf = $12e9265ebd9dc709$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[3], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[1], 12);
    return buf;
};
$12e9265ebd9dc709$var$AES.prototype.scrub = function() {
    $12e9265ebd9dc709$var$scrubVec(this._keySchedule);
    $12e9265ebd9dc709$var$scrubVec(this._invKeySchedule);
    $12e9265ebd9dc709$var$scrubVec(this._key);
};
$12e9265ebd9dc709$export$b80fbe1c3a2b92b5 = $12e9265ebd9dc709$var$AES;

});

parcelRegister("3z2xR", function(module, exports) {

var $dmAgJ = parcelRequire("dmAgJ");
var $29869d5e4b39252d$require$Buffer = $dmAgJ.Buffer;
var $29869d5e4b39252d$var$ZEROES = $29869d5e4b39252d$require$Buffer.alloc(16, 0);
function $29869d5e4b39252d$var$toArray(buf) {
    return [
        buf.readUInt32BE(0),
        buf.readUInt32BE(4),
        buf.readUInt32BE(8),
        buf.readUInt32BE(12)
    ];
}
function $29869d5e4b39252d$var$fromArray(out) {
    var buf = $29869d5e4b39252d$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0] >>> 0, 0);
    buf.writeUInt32BE(out[1] >>> 0, 4);
    buf.writeUInt32BE(out[2] >>> 0, 8);
    buf.writeUInt32BE(out[3] >>> 0, 12);
    return buf;
}
function $29869d5e4b39252d$var$GHASH(key) {
    this.h = key;
    this.state = $29869d5e4b39252d$require$Buffer.alloc(16, 0);
    this.cache = $29869d5e4b39252d$require$Buffer.allocUnsafe(0);
}
// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
$29869d5e4b39252d$var$GHASH.prototype.ghash = function(block) {
    var i = -1;
    while(++i < block.length)this.state[i] ^= block[i];
    this._multiply();
};
$29869d5e4b39252d$var$GHASH.prototype._multiply = function() {
    var Vi = $29869d5e4b39252d$var$toArray(this.h);
    var Zi = [
        0,
        0,
        0,
        0
    ];
    var j, xi, lsbVi;
    var i = -1;
    while(++i < 128){
        xi = (this.state[~~(i / 8)] & 1 << 7 - i % 8) !== 0;
        if (xi) {
            // Z_i+1 = Z_i ^ V_i
            Zi[0] ^= Vi[0];
            Zi[1] ^= Vi[1];
            Zi[2] ^= Vi[2];
            Zi[3] ^= Vi[3];
        }
        // Store the value of LSB(V_i)
        lsbVi = (Vi[3] & 1) !== 0;
        // V_i+1 = V_i >> 1
        for(j = 3; j > 0; j--)Vi[j] = Vi[j] >>> 1 | (Vi[j - 1] & 1) << 31;
        Vi[0] = Vi[0] >>> 1;
        // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
        if (lsbVi) Vi[0] = Vi[0] ^ -520093696;
    }
    this.state = $29869d5e4b39252d$var$fromArray(Zi);
};
$29869d5e4b39252d$var$GHASH.prototype.update = function(buf) {
    this.cache = $29869d5e4b39252d$require$Buffer.concat([
        this.cache,
        buf
    ]);
    var chunk;
    while(this.cache.length >= 16){
        chunk = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        this.ghash(chunk);
    }
};
$29869d5e4b39252d$var$GHASH.prototype.final = function(abl, bl) {
    if (this.cache.length) this.ghash($29869d5e4b39252d$require$Buffer.concat([
        this.cache,
        $29869d5e4b39252d$var$ZEROES
    ], 16));
    this.ghash($29869d5e4b39252d$var$fromArray([
        0,
        abl,
        0,
        bl
    ]));
    return this.state;
};
module.exports = $29869d5e4b39252d$var$GHASH;

});


parcelRegister("dbpC5", function(module, exports) {

var $1CF0y = parcelRequire("1CF0y");

var $dmAgJ = parcelRequire("dmAgJ");
var $99902bb6bca8ca58$require$Buffer = $dmAgJ.Buffer;

var $h4bOS = parcelRequire("h4bOS");

var $jcXeW = parcelRequire("jcXeW");
function $99902bb6bca8ca58$var$StreamCipher(mode, key, iv, decrypt) {
    $h4bOS.call(this);
    this._cipher = new $1CF0y.AES(key);
    this._prev = $99902bb6bca8ca58$require$Buffer.from(iv);
    this._cache = $99902bb6bca8ca58$require$Buffer.allocUnsafe(0);
    this._secCache = $99902bb6bca8ca58$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._mode = mode;
}
$jcXeW($99902bb6bca8ca58$var$StreamCipher, $h4bOS);
$99902bb6bca8ca58$var$StreamCipher.prototype._update = function(chunk) {
    return this._mode.encrypt(this, chunk, this._decrypt);
};
$99902bb6bca8ca58$var$StreamCipher.prototype._final = function() {
    this._cipher.scrub();
};
module.exports = $99902bb6bca8ca58$var$StreamCipher;

});


parcelRegister("eH6eX", function(module, exports) {
$parcel$export(module.exports, "createDecipher", () => $ab29ec0ba063b7a5$export$12ada9414fbc594c, (v) => $ab29ec0ba063b7a5$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "createDecipheriv", () => $ab29ec0ba063b7a5$export$36b6d6ef312eab39, (v) => $ab29ec0ba063b7a5$export$36b6d6ef312eab39 = v);
var $ab29ec0ba063b7a5$export$12ada9414fbc594c;
var $ab29ec0ba063b7a5$export$36b6d6ef312eab39;

var $cBm6t = parcelRequire("cBm6t");

var $dmAgJ = parcelRequire("dmAgJ");
var $ab29ec0ba063b7a5$require$Buffer = $dmAgJ.Buffer;

var $cu5JN = parcelRequire("cu5JN");

var $dbpC5 = parcelRequire("dbpC5");

var $h4bOS = parcelRequire("h4bOS");

var $1CF0y = parcelRequire("1CF0y");

var $crCGb = parcelRequire("crCGb");

var $jcXeW = parcelRequire("jcXeW");
function $ab29ec0ba063b7a5$var$Decipher(mode, key, iv) {
    $h4bOS.call(this);
    this._cache = new $ab29ec0ba063b7a5$var$Splitter();
    this._last = void 0;
    this._cipher = new $1CF0y.AES(key);
    this._prev = $ab29ec0ba063b7a5$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$jcXeW($ab29ec0ba063b7a5$var$Decipher, $h4bOS);
$ab29ec0ba063b7a5$var$Decipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get(this._autopadding)){
        thing = this._mode.decrypt(this, chunk);
        out.push(thing);
    }
    return $ab29ec0ba063b7a5$require$Buffer.concat(out);
};
$ab29ec0ba063b7a5$var$Decipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) return $ab29ec0ba063b7a5$var$unpad(this._mode.decrypt(this, chunk));
    else if (chunk) throw new Error('data not multiple of block length');
};
$ab29ec0ba063b7a5$var$Decipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $ab29ec0ba063b7a5$var$Splitter() {
    this.cache = $ab29ec0ba063b7a5$require$Buffer.allocUnsafe(0);
}
$ab29ec0ba063b7a5$var$Splitter.prototype.add = function(data) {
    this.cache = $ab29ec0ba063b7a5$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$ab29ec0ba063b7a5$var$Splitter.prototype.get = function(autoPadding) {
    var out;
    if (autoPadding) {
        if (this.cache.length > 16) {
            out = this.cache.slice(0, 16);
            this.cache = this.cache.slice(16);
            return out;
        }
    } else if (this.cache.length >= 16) {
        out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$ab29ec0ba063b7a5$var$Splitter.prototype.flush = function() {
    if (this.cache.length) return this.cache;
};
function $ab29ec0ba063b7a5$var$unpad(last) {
    var padded = last[15];
    if (padded < 1 || padded > 16) throw new Error('unable to decrypt data');
    var i = -1;
    while(++i < padded){
        if (last[i + (16 - padded)] !== padded) throw new Error('unable to decrypt data');
    }
    if (padded === 16) return;
    return last.slice(0, 16 - padded);
}
function $ab29ec0ba063b7a5$var$createDecipheriv(suite, password, iv) {
    var config = $cu5JN[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    if (typeof iv === 'string') iv = $ab29ec0ba063b7a5$require$Buffer.from(iv);
    if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
    if (typeof password === 'string') password = $ab29ec0ba063b7a5$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
    if (config.type === 'stream') return new $dbpC5(config.module, password, iv, true);
    else if (config.type === 'auth') return new $cBm6t(config.module, password, iv, true);
    return new $ab29ec0ba063b7a5$var$Decipher(config.module, password, iv);
}
function $ab29ec0ba063b7a5$var$createDecipher(suite, password) {
    var config = $cu5JN[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    var keys = $crCGb(password, false, config.key, config.iv);
    return $ab29ec0ba063b7a5$var$createDecipheriv(suite, keys.key, keys.iv);
}
$ab29ec0ba063b7a5$export$12ada9414fbc594c = $ab29ec0ba063b7a5$var$createDecipher;
$ab29ec0ba063b7a5$export$36b6d6ef312eab39 = $ab29ec0ba063b7a5$var$createDecipheriv;

});



parcelRegister("gxFlu", function(module, exports) {
$parcel$export(module.exports, "pbkdf2", () => $c0afccce58c98188$export$448fa22aedc9dbca, (v) => $c0afccce58c98188$export$448fa22aedc9dbca = v);
$parcel$export(module.exports, "pbkdf2Sync", () => $c0afccce58c98188$export$b80c7ba289c8fa56, (v) => $c0afccce58c98188$export$b80c7ba289c8fa56 = v);
var $c0afccce58c98188$export$448fa22aedc9dbca;
var $c0afccce58c98188$export$b80c7ba289c8fa56;
'use strict';

$c0afccce58c98188$export$448fa22aedc9dbca = (parcelRequire("fNsfU"));

$c0afccce58c98188$export$b80c7ba289c8fa56 = (parcelRequire("hXHsd"));

});


parcelRegister("8OEaU", function(module, exports) {

var $4Qxdz = parcelRequire("4Qxdz");

var $dmAgJ = parcelRequire("dmAgJ");
var $66b2282a394909aa$require$Buffer = $dmAgJ.Buffer;
module.exports = function(seed, len) {
    var t = $66b2282a394909aa$require$Buffer.alloc(0);
    var i = 0;
    var c;
    while(t.length < len){
        c = $66b2282a394909aa$var$i2ops(i++);
        t = $66b2282a394909aa$require$Buffer.concat([
            t,
            $4Qxdz('sha1').update(seed).update(c).digest()
        ]);
    }
    return t.slice(0, len);
};
function $66b2282a394909aa$var$i2ops(c) {
    var out = $66b2282a394909aa$require$Buffer.allocUnsafe(4);
    out.writeUInt32BE(c, 0);
    return out;
}

});

parcelRegister("bh3FZ", function(module, exports) {
module.exports = function xor(a, b) {
    var len = a.length;
    var i = -1;
    while(++i < len)a[i] ^= b[i];
    return a;
};

});

parcelRegister("aNYQX", function(module, exports) {

var $kHwXh = parcelRequire("kHwXh");

var $dmAgJ = parcelRequire("dmAgJ");
var $7dddaf23f2d119aa$require$Buffer = $dmAgJ.Buffer;
function $7dddaf23f2d119aa$var$withPublic(paddedMsg, key) {
    return $7dddaf23f2d119aa$require$Buffer.from(paddedMsg.toRed($kHwXh.mont(key.modulus)).redPow(new $kHwXh(key.publicExponent)).fromRed().toArray());
}
module.exports = $7dddaf23f2d119aa$var$withPublic;

});

parcelRegister("d6mSV", function(module, exports) {
'use strict';

var $a59rc = parcelRequire("a59rc");

var $cN8vX = parcelRequire("cN8vX");

var $dmAgJ = parcelRequire("dmAgJ");
var $989d9657dd6f7b40$require$Buffer = $dmAgJ.Buffer;
function $989d9657dd6f7b40$var$getr(priv) {
    var len = priv.modulus.byteLength();
    var r;
    do r = new $a59rc($cN8vX(len));
    while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2));
    return r;
}
function $989d9657dd6f7b40$var$blind(priv) {
    var r = $989d9657dd6f7b40$var$getr(priv);
    var blinder = r.toRed($a59rc.mont(priv.modulus)).redPow(new $a59rc(priv.publicExponent)).fromRed();
    return {
        blinder: blinder,
        unblinder: r.invm(priv.modulus)
    };
}
function $989d9657dd6f7b40$var$crt(msg, priv) {
    var blinds = $989d9657dd6f7b40$var$blind(priv);
    var len = priv.modulus.byteLength();
    var blinded = new $a59rc(msg).mul(blinds.blinder).umod(priv.modulus);
    var c1 = blinded.toRed($a59rc.mont(priv.prime1));
    var c2 = blinded.toRed($a59rc.mont(priv.prime2));
    var qinv = priv.coefficient;
    var p = priv.prime1;
    var q = priv.prime2;
    var m1 = c1.redPow(priv.exponent1).fromRed();
    var m2 = c2.redPow(priv.exponent2).fromRed();
    var h = m1.isub(m2).imul(qinv).umod(p).imul(q);
    return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike($989d9657dd6f7b40$require$Buffer, 'be', len);
}
$989d9657dd6f7b40$var$crt.getr = $989d9657dd6f7b40$var$getr;
module.exports = $989d9657dd6f7b40$var$crt;

});


parcelRegister("4Ghbm", function(module, exports) {

var $2SvhT = parcelRequire("2SvhT");

var $8OEaU = parcelRequire("8OEaU");

var $bh3FZ = parcelRequire("bh3FZ");

var $kHwXh = parcelRequire("kHwXh");

var $d6mSV = parcelRequire("d6mSV");

var $4Qxdz = parcelRequire("4Qxdz");

var $aNYQX = parcelRequire("aNYQX");

var $dmAgJ = parcelRequire("dmAgJ");
var $368869b0638e55fd$require$Buffer = $dmAgJ.Buffer;
module.exports = function privateDecrypt(privateKey, enc, reverse) {
    var padding;
    if (privateKey.padding) padding = privateKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $2SvhT(privateKey);
    var k = key.modulus.byteLength();
    if (enc.length > k || new $kHwXh(enc).cmp(key.modulus) >= 0) throw new Error('decryption error');
    var msg;
    if (reverse) msg = $aNYQX(new $kHwXh(enc), key);
    else msg = $d6mSV(enc, key);
    var zBuffer = $368869b0638e55fd$require$Buffer.alloc(k - msg.length);
    msg = $368869b0638e55fd$require$Buffer.concat([
        zBuffer,
        msg
    ], k);
    if (padding === 4) return $368869b0638e55fd$var$oaep(key, msg);
    else if (padding === 1) return $368869b0638e55fd$var$pkcs1(key, msg, reverse);
    else if (padding === 3) return msg;
    else throw new Error('unknown padding');
};
function $368869b0638e55fd$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var iHash = $4Qxdz('sha1').update($368869b0638e55fd$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    if (msg[0] !== 0) throw new Error('decryption error');
    var maskedSeed = msg.slice(1, hLen + 1);
    var maskedDb = msg.slice(hLen + 1);
    var seed = $bh3FZ(maskedSeed, $8OEaU(maskedDb, hLen));
    var db = $bh3FZ(maskedDb, $8OEaU(seed, k - hLen - 1));
    if ($368869b0638e55fd$var$compare(iHash, db.slice(0, hLen))) throw new Error('decryption error');
    var i = hLen;
    while(db[i] === 0)i++;
    if (db[i++] !== 1) throw new Error('decryption error');
    return db.slice(i);
}
function $368869b0638e55fd$var$pkcs1(key, msg, reverse) {
    var p1 = msg.slice(0, 2);
    var i = 2;
    var status = 0;
    while(msg[i++] !== 0)if (i >= msg.length) {
        status++;
        break;
    }
    var ps = msg.slice(2, i - 1);
    if (p1.toString('hex') !== '0002' && !reverse || p1.toString('hex') !== '0001' && reverse) status++;
    if (ps.length < 8) status++;
    if (status) throw new Error('decryption error');
    return msg.slice(i);
}
function $368869b0638e55fd$var$compare(a, b) {
    a = $368869b0638e55fd$require$Buffer.from(a);
    b = $368869b0638e55fd$require$Buffer.from(b);
    var dif = 0;
    var len = a.length;
    if (a.length !== b.length) {
        dif++;
        len = Math.min(a.length, b.length);
    }
    var i = -1;
    while(++i < len)dif += a[i] ^ b[i];
    return dif;
}

});

$parcel$global.rwr("kpJNO", () => { 
var $dQwsT = parcelRequire("dQwsT");
var $4339cd0fd1740902$exports = {};
'use strict';
function $4339cd0fd1740902$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($4339cd0fd1740902$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$4339cd0fd1740902$var$checkDCE();

$4339cd0fd1740902$exports = (parcelRequire("bNpl0"));



var $dQwsT = parcelRequire("dQwsT");

var $dQwsT = parcelRequire("dQwsT");
const $15f344f9545a569e$export$a7b0697657ed8bd0 = /*#__PURE__*/ (0, $dQwsT.createContext)({
    start () {},
    succeed () {},
    fail () {},
    abort () {},
    stopOnError () {},
    subscribe () {
        return ()=>{};
    },
    getExperienceState () {
        return null;
    },
    updateAttributes () {},
    attachDebugPoint () {}
});
function $15f344f9545a569e$export$f88dde183f4d31cb(WrappedComponent) {
    const withExperienceTracker = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement($15f344f9545a569e$export$a7b0697657ed8bd0.Consumer, null, (value)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement(WrappedComponent, {
                ...props,
                experienceTracker: value
            }));
    withExperienceTracker.displayName = `withExperienceTracker(${WrappedComponent.displayName || WrappedComponent.name})`;
    return withExperienceTracker;
}



var $8V6O9 = parcelRequire("8V6O9");
var $c29b43bb0df96673$exports = {};
var $8620f91002fd03c7$exports = {};
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $8620f91002fd03c7$var$getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
if ($8620f91002fd03c7$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $8620f91002fd03c7$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    $8620f91002fd03c7$exports = function whatwgRNG() {
        $8620f91002fd03c7$var$getRandomValues($8620f91002fd03c7$var$rnds8);
        return $8620f91002fd03c7$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $8620f91002fd03c7$var$rnds = new Array(16);
    $8620f91002fd03c7$exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $8620f91002fd03c7$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $8620f91002fd03c7$var$rnds;
    };
}


var $0eb3fc9f8addfeea$exports = {};
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $0eb3fc9f8addfeea$var$byteToHex = [];
for(var $0eb3fc9f8addfeea$var$i = 0; $0eb3fc9f8addfeea$var$i < 256; ++$0eb3fc9f8addfeea$var$i)$0eb3fc9f8addfeea$var$byteToHex[$0eb3fc9f8addfeea$var$i] = ($0eb3fc9f8addfeea$var$i + 0x100).toString(16).substr(1);
function $0eb3fc9f8addfeea$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $0eb3fc9f8addfeea$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join('');
}
$0eb3fc9f8addfeea$exports = $0eb3fc9f8addfeea$var$bytesToUuid;


function $c29b43bb0df96673$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == 'string') {
        buf = options === 'binary' ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $8620f91002fd03c7$exports)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $0eb3fc9f8addfeea$exports(rnds);
}
$c29b43bb0df96673$exports = $c29b43bb0df96673$var$v4;


const $a4ab9c0cf734aa2a$export$9c05e7ef9f2c8895 = (event)=>({
        // Events should match the schema defined here:
        // https://hello.atlassian.net/wiki/spaces/BIZOPS/pages/387788554/Analytics+Event+Schema+for+SLA
        source: 'ui',
        actionSubject: 'ui',
        action: event.action,
        eventType: 'operational',
        attributes: $a4ab9c0cf734aa2a$var$createExperienceTrackerAnalyticsAttributes(event)
    });
function $a4ab9c0cf734aa2a$var$createExperienceTrackerAnalyticsAttributes(event) {
    const { action: action, name: name, id: id, attributes: experienceAttributes, ...rest } = event;
    const attributes = {
        ...experienceAttributes,
        ...rest,
        task: name,
        taskId: id
    };
    if (attributes.error) {
        let error;
        if (typeof attributes.error === 'string') error = new Error(attributes.error);
        else error = attributes.error;
        delete attributes.error;
        attributes.errorName = error.name;
        if (!attributes.traceId && error.traceId) attributes.traceId = error.traceId;
        attributes.errorMessage = error.message;
    }
    attributes.browserInfo = window.navigator.userAgent;
    // Matches the analytics-web-client's apdex event
    attributes.isActiveTab = document.visibilityState === 'visible';
    return attributes;
}


/**
 *  Data Services - Analytics Web Client for E-MAU
 *  url to the JIRA ticket (https://product-fabric.atlassian.net/browse/CFEA-16)
 *  source code (https://bitbucket.org/atlassian/analytics-web-client)
 */ // import uuid from 'uuid/v4';
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
var $19dcc840d0563c39$exports = {};
var $d9eea0e8cdfffea8$exports = {};
var $64bdc94eb45399e2$exports = {};
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $64bdc94eb45399e2$var$getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
if ($64bdc94eb45399e2$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $64bdc94eb45399e2$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    $64bdc94eb45399e2$exports = function whatwgRNG() {
        $64bdc94eb45399e2$var$getRandomValues($64bdc94eb45399e2$var$rnds8);
        return $64bdc94eb45399e2$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $64bdc94eb45399e2$var$rnds = new Array(16);
    $64bdc94eb45399e2$exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $64bdc94eb45399e2$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $64bdc94eb45399e2$var$rnds;
    };
}


var $d2c7f0bf36d89b3d$exports = {};
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $d2c7f0bf36d89b3d$var$byteToHex = [];
for(var $d2c7f0bf36d89b3d$var$i = 0; $d2c7f0bf36d89b3d$var$i < 256; ++$d2c7f0bf36d89b3d$var$i)$d2c7f0bf36d89b3d$var$byteToHex[$d2c7f0bf36d89b3d$var$i] = ($d2c7f0bf36d89b3d$var$i + 0x100).toString(16).substr(1);
function $d2c7f0bf36d89b3d$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $d2c7f0bf36d89b3d$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join('');
}
$d2c7f0bf36d89b3d$exports = $d2c7f0bf36d89b3d$var$bytesToUuid;


// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $d9eea0e8cdfffea8$var$_nodeId;
var $d9eea0e8cdfffea8$var$_clockseq;
// Previous uuid creation time
var $d9eea0e8cdfffea8$var$_lastMSecs = 0;
var $d9eea0e8cdfffea8$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $d9eea0e8cdfffea8$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $d9eea0e8cdfffea8$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $d9eea0e8cdfffea8$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $64bdc94eb45399e2$exports();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $d9eea0e8cdfffea8$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $d9eea0e8cdfffea8$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $d9eea0e8cdfffea8$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $d9eea0e8cdfffea8$var$_lastMSecs + (nsecs - $d9eea0e8cdfffea8$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $d9eea0e8cdfffea8$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
    $d9eea0e8cdfffea8$var$_lastMSecs = msecs;
    $d9eea0e8cdfffea8$var$_lastNSecs = nsecs;
    $d9eea0e8cdfffea8$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $d2c7f0bf36d89b3d$exports(b);
}
$d9eea0e8cdfffea8$exports = $d9eea0e8cdfffea8$var$v1;


var $16dc794ef2e250b8$exports = {};


function $16dc794ef2e250b8$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == 'string') {
        buf = options === 'binary' ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $64bdc94eb45399e2$exports)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $d2c7f0bf36d89b3d$exports(rnds);
}
$16dc794ef2e250b8$exports = $16dc794ef2e250b8$var$v4;


var $19dcc840d0563c39$var$uuid = $16dc794ef2e250b8$exports;
$19dcc840d0563c39$var$uuid.v1 = $d9eea0e8cdfffea8$exports;
$19dcc840d0563c39$var$uuid.v4 = $16dc794ef2e250b8$exports;
$19dcc840d0563c39$exports = $19dcc840d0563c39$var$uuid;


/**
 * This file converts between Base64 and Base 64 Encoding with URL and Filename Safe Alphabet,
 * the latter of which has URL-safe characters only (drops =, + and /).
 *
 * Why not use a library? The popular libs use Buffer to be able to
 * encode any data to base64. We don't need this capability, and it causes
 * Webpack to include 30KB of a Buffer polyfill.
 * Webpack's/UglifyJS's Tree Shaking seems to be unable to drop it.
 *
 * See: RFC 4648 section 5 (https://tools.ietf.org/html/rfc4648#section-5)
 */ function $46e7d1e146db40f0$export$3b91e21dac1023c6(base64) {
    if (base64 == null) return '';
    return String(base64).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}
function $46e7d1e146db40f0$export$47c5265a25535d02(base64url) {
    if (base64url == null) return '';
    const base64 = String(base64url).replace(/-/g, '+').replace(/_/g, '/');
    const padLength = (4 - base64url.length % 4) % 4;
    const pad = '==='.slice(0, padLength);
    return base64 + pad;
}



var $b0qLu = parcelRequire("b0qLu");


const $098e0c8400fb0113$export$d3cd91e0fdbfdbc0 = ()=>({
        atob: // atob/btoa need to be bound because they throw an illegal invocation error when called as a method (obj.atob())
        typeof atob === 'function' && atob.bind(undefined) || typeof (0, $b0qLu.Buffer) !== 'undefined' && ((encoded)=>(0, $b0qLu.Buffer).from(encoded, 'base64').toString()),
        btoa: typeof btoa === 'function' && btoa.bind(undefined) || typeof (0, $b0qLu.Buffer) !== 'undefined' && ((str)=>(0, $b0qLu.Buffer).from(str).toString('base64')),
        URLSearchParams: typeof URLSearchParams === 'function' && URLSearchParams || (0, (parcelRequire("6ANHb")).URLSearchParams),
        URL: typeof URL === 'function' && URL || (0, (parcelRequire("6ANHb")).URL)
    });
let $098e0c8400fb0113$var$env;
const $098e0c8400fb0113$export$4bd44a2aa29d3d6e = ()=>$098e0c8400fb0113$var$env || ($098e0c8400fb0113$var$env = $098e0c8400fb0113$var$validateEnv($098e0c8400fb0113$export$d3cd91e0fdbfdbc0()));
const $098e0c8400fb0113$var$validateEnv = (env)=>{
    if (!(env.atob && env.btoa && env.URLSearchParams && env.URL)) throw new TypeError(`Origin-Tracing: missing environment APIs. Required: btoa(), atob(), URLSearchParams() (or in Node: Buffer, require('url').URLSearchParams).`);
    return env;
};


const $b2a65ba236e326fd$var$productShorthands = {
    confluence: 'c',
    jira: 'j',
    stride: 's',
    bitbucket: 'b',
    trello: 't'
};
function $b2a65ba236e326fd$export$c564cdbbe6da493(originData) {
    const json = JSON.stringify($b2a65ba236e326fd$export$4bc4b533a565aabe(originData));
    const base64 = (0, $098e0c8400fb0113$export$4bd44a2aa29d3d6e)().btoa(json);
    return (0, $46e7d1e146db40f0$export$3b91e21dac1023c6)(base64);
}
function $b2a65ba236e326fd$export$2f872c0f2117be69(encodedOriginString) {
    const base64 = (0, $46e7d1e146db40f0$export$47c5265a25535d02)(encodedOriginString);
    const json = (0, $098e0c8400fb0113$export$4bd44a2aa29d3d6e)().atob(base64);
    return $b2a65ba236e326fd$export$46d5cda6b884b7ab(JSON.parse(json));
}
function $b2a65ba236e326fd$export$4bc4b533a565aabe({ id: id, product: product }) {
    return {
        i: id,
        p: product && product in $b2a65ba236e326fd$var$productShorthands ? $b2a65ba236e326fd$var$productShorthands[product] : product
    };
}
function $b2a65ba236e326fd$export$46d5cda6b884b7ab(originJSONObject) {
    const originData = {};
    if (originJSONObject.i) originData.id = originJSONObject.i;
    if (originJSONObject.p) originData.product = $b2a65ba236e326fd$var$expandProductShorthand(originJSONObject.p);
    return originData;
}
function $b2a65ba236e326fd$var$expandProductShorthand(maybeShorthand) {
    const products = Object.keys($b2a65ba236e326fd$var$productShorthands);
    for(let i = 0; i < products.length; i++){
        const product = products[i];
        const shorthand = $b2a65ba236e326fd$var$productShorthands[product];
        if (maybeShorthand === shorthand) return product;
    }
    return maybeShorthand;
}



const $608a2d4ad1afcbf8$var$packageVersion = "0.0.0-use.local";
const $608a2d4ad1afcbf8$var$originParamName = 'atlOrigin';
const $608a2d4ad1afcbf8$var$originVersioningAttributes = {
    originLibrary: `origin-tracing.js@${$608a2d4ad1afcbf8$var$packageVersion}`
};
class $608a2d4ad1afcbf8$export$2e2bcd8739ae039 {
    static isValidId(value) {
        return typeof value === 'string' && /^[-_a-zA-Z0-9]{1,36}$/.test(value);
    }
    static isValidProduct(value) {
        return typeof value === 'string' && /^[-_a-zA-Z0-9]{1,20}$/.test(value);
    }
    static generateId() {
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const id = (0, $19dcc840d0563c39$exports.v4)();
        // Dash positions are fixed so they don't add to uniqueness.
        // Remove them to save space in the encoded form.
        return id.replace(/-/g, '');
    }
    static createEmpty() {
        return new $608a2d4ad1afcbf8$var$EmptyOriginTracer();
    }
    static createMalformed() {
        return new $608a2d4ad1afcbf8$var$MalformedOriginTracer();
    }
    static fromUrl(url) {
        let params = new ((0, $098e0c8400fb0113$export$4bd44a2aa29d3d6e)()).URLSearchParams();
        $608a2d4ad1afcbf8$var$replaceQuery(url, (queryString)=>{
            params = new ((0, $098e0c8400fb0113$export$4bd44a2aa29d3d6e)()).URLSearchParams(queryString);
        });
        return $608a2d4ad1afcbf8$export$2e2bcd8739ae039.fromEncoded(params.get($608a2d4ad1afcbf8$var$originParamName));
    }
    static fromEncoded(encoded) {
        if (!encoded) return $608a2d4ad1afcbf8$export$2e2bcd8739ae039.createEmpty();
        try {
            return $608a2d4ad1afcbf8$export$2e2bcd8739ae039.decode(encoded);
        } catch (e) {
            return $608a2d4ad1afcbf8$export$2e2bcd8739ae039.createMalformed();
        }
    }
    static removeFromUrl(url) {
        return $608a2d4ad1afcbf8$var$replaceQuery(url, (queryString)=>{
            const params = new ((0, $098e0c8400fb0113$export$4bd44a2aa29d3d6e)()).URLSearchParams(queryString);
            params.delete($608a2d4ad1afcbf8$var$originParamName);
            return params.toString();
        });
    }
    static decode(encodedOrigin) {
        const originData = (0, $b2a65ba236e326fd$export$2f872c0f2117be69)(encodedOrigin);
        return new $608a2d4ad1afcbf8$export$2e2bcd8739ae039(originData);
    }
    encode() {
        return (0, $b2a65ba236e326fd$export$c564cdbbe6da493)({
            id: this.id,
            product: this.product
        });
    }
    addToUrl(url) {
        return $608a2d4ad1afcbf8$var$replaceQuery(url, (originalQueryString)=>{
            const params = new ((0, $098e0c8400fb0113$export$4bd44a2aa29d3d6e)()).URLSearchParams(originalQueryString);
            params.set($608a2d4ad1afcbf8$var$originParamName, this.encode());
            return params.toString();
        });
    }
    containsOrigin(urlString) {
        const url = new ((0, $098e0c8400fb0113$export$4bd44a2aa29d3d6e)()).URL(urlString);
        const params = new URLSearchParams(url.search);
        return params.has($608a2d4ad1afcbf8$var$originParamName);
    }
    isEmpty() {
        return false;
    }
    isMalformed() {
        return !this.isEmpty() && !this.isValid();
    }
    isValid() {
        return true;
    }
    toAnalyticsAttributes({ transformValue: transformValue = (v)=>v === null ? undefined : v, hasGeneratedId: hasGeneratedId = false } = {}) {
        // `originIdGenerated` should be used in analytic events that generated this originId.
        // Subsequent events should use `originId`.
        // No two events should have the same value of originIdGenerated.
        const originIdProp = hasGeneratedId ? 'originIdGenerated' : 'originId';
        return {
            [originIdProp]: transformValue(this.id),
            originProduct: transformValue(this.product),
            ...$608a2d4ad1afcbf8$var$originVersioningAttributes
        };
    }
    validate() {
        if (!$608a2d4ad1afcbf8$export$2e2bcd8739ae039.isValidId(this.id)) throw new TypeError('Invalid Origin id');
        if (!$608a2d4ad1afcbf8$export$2e2bcd8739ae039.isValidProduct(this.product)) throw new TypeError('Missing/invalid Origin product');
    }
    constructor({ id: id = $608a2d4ad1afcbf8$export$2e2bcd8739ae039.generateId(), product: product, dangerouslySkipValidation: dangerouslySkipValidation = false }){
        this.id = void 0;
        this.product = void 0;
        this.id = id;
        this.product = product;
        if (!dangerouslySkipValidation) this.validate();
    }
}
class $608a2d4ad1afcbf8$var$EmptyOriginTracer extends $608a2d4ad1afcbf8$export$2e2bcd8739ae039 {
    isValid() {
        return false;
    }
    isEmpty() {
        return true;
    }
    toAnalyticsAttributes() {
        return {
            ...$608a2d4ad1afcbf8$var$originVersioningAttributes
        };
    }
    constructor(){
        super({
            id: null,
            product: null,
            dangerouslySkipValidation: true
        });
    }
}
class $608a2d4ad1afcbf8$var$MalformedOriginTracer extends $608a2d4ad1afcbf8$export$2e2bcd8739ae039 {
    isValid() {
        return false;
    }
    isEmpty() {
        return false;
    }
    toAnalyticsAttributes() {
        return {
            originMalformed: true,
            ...$608a2d4ad1afcbf8$var$originVersioningAttributes
        };
    }
    constructor(){
        super({
            id: null,
            product: null,
            dangerouslySkipValidation: true
        });
    }
}
function $608a2d4ad1afcbf8$var$replaceQuery(url, replacer) {
    const urlWithQueryStringRegex = /(^[^?#]*)(?:\?)?([^#]*?)(#.*|$)$/;
    // If we get passed window.location, we don't want to call window.location.replace()
    const urlString = String(url);
    return urlString.replace(urlWithQueryStringRegex, (_wholeMatch, beforeQuery, queryString, afterQuery)=>{
        let newQueryString = replacer(queryString);
        if (newQueryString) newQueryString = `?${newQueryString}`;
        return `${beforeQuery}${newQueryString}${afterQuery}`;
    });
}



var $g8V8l = parcelRequire("g8V8l");
let $c086cef45a2cc129$export$3dcce53a3755dc8c;
const $c086cef45a2cc129$export$57d3cdb500cb5402 = (agent)=>{
    if (agent) $c086cef45a2cc129$export$3dcce53a3755dc8c = agent;
    else if (typeof window !== 'undefined' && window.navigator) $c086cef45a2cc129$export$3dcce53a3755dc8c = window.navigator.userAgent;
};
const $c086cef45a2cc129$export$aad8462122ac592b = ()=>{
    $c086cef45a2cc129$export$3dcce53a3755dc8c = undefined;
};
const $c086cef45a2cc129$export$b7d78993b74f766d = ()=>{
    return $c086cef45a2cc129$export$3dcce53a3755dc8c?.indexOf('Firefox/') !== -1;
};
const $c086cef45a2cc129$export$c87f7e935aea4901 = ()=>{
    return !$c086cef45a2cc129$export$b7d78993b74f766d();
};
const $c086cef45a2cc129$export$552b0ed0b7a8f620 = ()=>{
    return $c086cef45a2cc129$export$3dcce53a3755dc8c?.indexOf('Edge/') !== -1;
};
const $c086cef45a2cc129$export$bf319670985f797f = ()=>{
    return !$c086cef45a2cc129$export$552b0ed0b7a8f620();
};
const $c086cef45a2cc129$export$7e7b1a9668aaed8 = ()=>{
    return $c086cef45a2cc129$export$3dcce53a3755dc8c?.indexOf('MSIE') !== -1 || $c086cef45a2cc129$export$3dcce53a3755dc8c?.indexOf('Trident/') !== -1 || $c086cef45a2cc129$export$552b0ed0b7a8f620();
};
const $c086cef45a2cc129$export$a9ab798d36ba46c = ()=>{
    return !$c086cef45a2cc129$export$7e7b1a9668aaed8();
};
const $c086cef45a2cc129$export$6446a186d09e379e = ()=>{
    return $c086cef45a2cc129$export$3dcce53a3755dc8c?.indexOf('Chrome/') !== -1;
};
const $c086cef45a2cc129$export$23ee57a84a15eab5 = ()=>{
    return !$c086cef45a2cc129$export$6446a186d09e379e();
};
const $c086cef45a2cc129$export$95df08bae54cb4df = ()=>{
    return $c086cef45a2cc129$export$3dcce53a3755dc8c?.indexOf('Safari/') !== -1 && $c086cef45a2cc129$export$3dcce53a3755dc8c?.indexOf('Chrome/') === -1;
};
const $c086cef45a2cc129$export$bc187e33086c8385 = ()=>{
    return !$c086cef45a2cc129$export$95df08bae54cb4df();
};
const $c086cef45a2cc129$export$7b405d3c2ef63516 = ()=>{
    return $c086cef45a2cc129$export$3dcce53a3755dc8c?.indexOf('PhantomJS') !== -1;
};
const $c086cef45a2cc129$export$f11fe2ca946efdb2 = ()=>{
    return !$c086cef45a2cc129$export$7b405d3c2ef63516();
};
const $c086cef45a2cc129$export$6d5620528cf86fa2 = ()=>{
    return !!$c086cef45a2cc129$export$3dcce53a3755dc8c && ($c086cef45a2cc129$export$3dcce53a3755dc8c?.indexOf('Confluence iOS/') !== -1 || $c086cef45a2cc129$export$3dcce53a3755dc8c?.indexOf('Confluence Android/') !== -1);
};
const $c086cef45a2cc129$export$83d89fbfd8236492 = ()=>{
    let versionMatch;
    if ($c086cef45a2cc129$export$7e7b1a9668aaed8()) versionMatch = $c086cef45a2cc129$export$3dcce53a3755dc8c?.match(/MSIE\s([\d.]+)/) || $c086cef45a2cc129$export$3dcce53a3755dc8c?.match(/rv:([\d.]+)/) || $c086cef45a2cc129$export$3dcce53a3755dc8c?.match(/Edge\/([\d.]+)/);
    else if ($c086cef45a2cc129$export$6446a186d09e379e()) versionMatch = $c086cef45a2cc129$export$3dcce53a3755dc8c?.match(/Chrome\/([\d.]+)/);
    else if ($c086cef45a2cc129$export$95df08bae54cb4df()) versionMatch = $c086cef45a2cc129$export$3dcce53a3755dc8c?.match(/Version\/([\d.]+)/);
    else if ($c086cef45a2cc129$export$b7d78993b74f766d()) versionMatch = $c086cef45a2cc129$export$3dcce53a3755dc8c?.match(/Firefox\/([\d.]+)/);
    return versionMatch && parseInt(versionMatch[1]);
};
const $c086cef45a2cc129$export$f52e1a142ed579d = ()=>{
    if ($c086cef45a2cc129$export$552b0ed0b7a8f620()) return 'MSEdge';
    if ($c086cef45a2cc129$export$7e7b1a9668aaed8()) return 'IE';
    if ($c086cef45a2cc129$export$6446a186d09e379e()) return 'Chrome';
    if ($c086cef45a2cc129$export$95df08bae54cb4df()) return 'Safari';
    if ($c086cef45a2cc129$export$b7d78993b74f766d()) return 'Firefox';
};


var $477e019f2b5e6422$export$1e511d4a378977f5;
var $477e019f2b5e6422$export$2e2bcd8739ae039;
'use strict';
$477e019f2b5e6422$export$1e511d4a378977f5 = true;
var $477e019f2b5e6422$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $477e019f2b5e6422$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $3ad7f8c8e251eaf8$exports = {};
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $3ad7f8c8e251eaf8$var$warning = function() {};
$3ad7f8c8e251eaf8$exports = $3ad7f8c8e251eaf8$var$warning;


var $477e019f2b5e6422$var$_warning2 = $477e019f2b5e6422$var$_interopRequireDefault($3ad7f8c8e251eaf8$exports);
var $4e6e23e7b818fbfc$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $4e6e23e7b818fbfc$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
$4e6e23e7b818fbfc$exports = $4e6e23e7b818fbfc$var$invariant;


var $477e019f2b5e6422$var$_invariant2 = $477e019f2b5e6422$var$_interopRequireDefault($4e6e23e7b818fbfc$exports);
var $8f47cb9e5c14e83a$export$1e511d4a378977f5;
var $8f47cb9e5c14e83a$export$c3e8bb440bd55b18;
var $8f47cb9e5c14e83a$export$90c043f1c57770b8;
'use strict';
$8f47cb9e5c14e83a$export$1e511d4a378977f5 = true;
$8f47cb9e5c14e83a$export$c3e8bb440bd55b18 = $8f47cb9e5c14e83a$export$90c043f1c57770b8 = undefined;
var $8f47cb9e5c14e83a$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $affb96385603b672$exports = {};

$parcel$defineInteropFlag($affb96385603b672$exports);
$parcel$export($affb96385603b672$exports, "default", () => $affb96385603b672$export$2e2bcd8739ae039);
function $affb96385603b672$var$isAbsolute(pathname) {
    return pathname.charAt(0) === '/';
}
// About 1.5x faster than the two-arg version of Array#splice()
function $affb96385603b672$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $affb96385603b672$var$resolvePathname(to) {
    var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var toParts = to && to.split('/') || [];
    var fromParts = from && from.split('/') || [];
    var isToAbs = to && $affb96385603b672$var$isAbsolute(to);
    var isFromAbs = from && $affb96385603b672$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $affb96385603b672$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return '/';
    var hasTrailingSlash = void 0;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === '.' || last === '..' || last === '';
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === '.') $affb96385603b672$var$spliceOne(fromParts, i);
        else if (part === '..') {
            $affb96385603b672$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $affb96385603b672$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift('..');
    if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !$affb96385603b672$var$isAbsolute(fromParts[0]))) fromParts.unshift('');
    var result = fromParts.join('/');
    if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
    return result;
}
var $affb96385603b672$export$2e2bcd8739ae039 = $affb96385603b672$var$resolvePathname;


var $8f47cb9e5c14e83a$var$_resolvePathname2 = $8f47cb9e5c14e83a$var$_interopRequireDefault($affb96385603b672$exports);
var $1251071b4f9f7ce8$exports = {};

$parcel$defineInteropFlag($1251071b4f9f7ce8$exports);
$parcel$export($1251071b4f9f7ce8$exports, "default", () => $1251071b4f9f7ce8$export$2e2bcd8739ae039);
var $1251071b4f9f7ce8$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
function $1251071b4f9f7ce8$var$valueEqual(a, b) {
    if (a === b) return true;
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $1251071b4f9f7ce8$var$valueEqual(item, b[index]);
    });
    var aType = typeof a === 'undefined' ? 'undefined' : $1251071b4f9f7ce8$var$_typeof(a);
    var bType = typeof b === 'undefined' ? 'undefined' : $1251071b4f9f7ce8$var$_typeof(b);
    if (aType !== bType) return false;
    if (aType === 'object') {
        var aValue = a.valueOf();
        var bValue = b.valueOf();
        if (aValue !== a || bValue !== b) return $1251071b4f9f7ce8$var$valueEqual(aValue, bValue);
        var aKeys = Object.keys(a);
        var bKeys = Object.keys(b);
        if (aKeys.length !== bKeys.length) return false;
        return aKeys.every(function(key) {
            return $1251071b4f9f7ce8$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $1251071b4f9f7ce8$export$2e2bcd8739ae039 = $1251071b4f9f7ce8$var$valueEqual;


var $8f47cb9e5c14e83a$var$_valueEqual2 = $8f47cb9e5c14e83a$var$_interopRequireDefault($1251071b4f9f7ce8$exports);
var $71e1af5b080b12ca$export$1e511d4a378977f5;
var $71e1af5b080b12ca$export$5b4913142e03bca8;
var $71e1af5b080b12ca$export$79c5b1569e3be9e6;
var $71e1af5b080b12ca$export$10497c7ce66fcb84;
var $71e1af5b080b12ca$export$b69e3301ce081aa3;
var $71e1af5b080b12ca$export$d95b4586d238a081;
var $71e1af5b080b12ca$export$8ccf933b0513f8d0;
var $71e1af5b080b12ca$export$fe53371bee54353d;
'use strict';
$71e1af5b080b12ca$export$1e511d4a378977f5 = true;
var $71e1af5b080b12ca$var$addLeadingSlash = $71e1af5b080b12ca$export$5b4913142e03bca8 = function addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
};
var $71e1af5b080b12ca$var$stripLeadingSlash = $71e1af5b080b12ca$export$79c5b1569e3be9e6 = function stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
};
var $71e1af5b080b12ca$var$hasBasename = $71e1af5b080b12ca$export$10497c7ce66fcb84 = function hasBasename(path, prefix) {
    return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};
var $71e1af5b080b12ca$var$stripBasename = $71e1af5b080b12ca$export$b69e3301ce081aa3 = function stripBasename(path, prefix) {
    return $71e1af5b080b12ca$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};
var $71e1af5b080b12ca$var$stripTrailingSlash = $71e1af5b080b12ca$export$d95b4586d238a081 = function stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};
var $71e1af5b080b12ca$var$parsePath = $71e1af5b080b12ca$export$8ccf933b0513f8d0 = function parsePath(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
};
var $71e1af5b080b12ca$var$createPath = $71e1af5b080b12ca$export$fe53371bee54353d = function createPath(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;
    return path;
};


function $8f47cb9e5c14e83a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $8f47cb9e5c14e83a$var$createLocation = $8f47cb9e5c14e83a$export$90c043f1c57770b8 = function createLocation(path, state, key, currentLocation) {
    var location = void 0;
    if (typeof path === 'string') {
        // Two-arg form: push(path, state)
        location = (0, $71e1af5b080b12ca$export$8ccf933b0513f8d0)(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = $8f47cb9e5c14e83a$var$_extends({}, path);
        if (location.pathname === undefined) location.pathname = '';
        if (location.search) {
            if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
        } else location.search = '';
        if (location.hash) {
            if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
        } else location.hash = '';
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== '/') location.pathname = (0, $8f47cb9e5c14e83a$var$_resolvePathname2.default)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = '/';
    return location;
};
var $8f47cb9e5c14e83a$var$locationsAreEqual = $8f47cb9e5c14e83a$export$c3e8bb440bd55b18 = function locationsAreEqual(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $8f47cb9e5c14e83a$var$_valueEqual2.default)(a.state, b.state);
};



var $b5b0f87adb64f216$exports = {};

$parcel$defineInteropFlag($b5b0f87adb64f216$exports);
$parcel$export($b5b0f87adb64f216$exports, "__esModule", () => $b5b0f87adb64f216$export$1e511d4a378977f5, (v) => $b5b0f87adb64f216$export$1e511d4a378977f5 = v);
$parcel$export($b5b0f87adb64f216$exports, "default", () => $b5b0f87adb64f216$export$2e2bcd8739ae039, (v) => $b5b0f87adb64f216$export$2e2bcd8739ae039 = v);
var $b5b0f87adb64f216$export$1e511d4a378977f5;
var $b5b0f87adb64f216$export$2e2bcd8739ae039;
'use strict';
$b5b0f87adb64f216$export$1e511d4a378977f5 = true;

var $b5b0f87adb64f216$var$_warning2 = $b5b0f87adb64f216$var$_interopRequireDefault($3ad7f8c8e251eaf8$exports);
function $b5b0f87adb64f216$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $b5b0f87adb64f216$var$createTransitionManager = function createTransitionManager() {
    var prompt = null;
    var setPrompt = function setPrompt(nextPrompt) {
        (0, $b5b0f87adb64f216$var$_warning2.default)(prompt == null, 'A history supports only one prompt at a time');
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    };
    var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
            if (typeof result === 'string') {
                if (typeof getUserConfirmation === 'function') getUserConfirmation(result, callback);
                else {
                    (0, $b5b0f87adb64f216$var$_warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');
                    callback(true);
                }
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    };
    var listeners = [];
    var appendListener = function appendListener(fn) {
        var isActive = true;
        var listener = function listener() {
            if (isActive) fn.apply(undefined, arguments);
        };
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    };
    var notifyListeners = function notifyListeners() {
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(undefined, args);
        });
    };
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
};
$b5b0f87adb64f216$export$2e2bcd8739ae039 = $b5b0f87adb64f216$var$createTransitionManager;


var $477e019f2b5e6422$var$_createTransitionManager2 = $477e019f2b5e6422$var$_interopRequireDefault($b5b0f87adb64f216$exports);
var $06fa104e4adbc166$export$1e511d4a378977f5;
var $06fa104e4adbc166$export$71594e8a50f746f4;
var $06fa104e4adbc166$export$3f65cefe8380dbea;
var $06fa104e4adbc166$export$8ff9f68337b520c0;
var $06fa104e4adbc166$export$ef38efb4b47d01db;
var $06fa104e4adbc166$export$67fc34576016d6ec;
var $06fa104e4adbc166$export$bd919e6f5f49fb48;
var $06fa104e4adbc166$export$9a5b29ff20eb48f9;
var $06fa104e4adbc166$export$aa3c5b1dd6fed00;
'use strict';
$06fa104e4adbc166$export$1e511d4a378977f5 = true;
var $06fa104e4adbc166$var$canUseDOM = $06fa104e4adbc166$export$71594e8a50f746f4 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $06fa104e4adbc166$var$addEventListener = $06fa104e4adbc166$export$3f65cefe8380dbea = function addEventListener(node, event, listener) {
    return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};
var $06fa104e4adbc166$var$removeEventListener = $06fa104e4adbc166$export$8ff9f68337b520c0 = function removeEventListener(node, event, listener) {
    return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};
var $06fa104e4adbc166$var$getConfirmation = $06fa104e4adbc166$export$ef38efb4b47d01db = function getConfirmation(message, callback) {
    return callback(window.confirm(message));
}; // eslint-disable-line no-alert
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ var $06fa104e4adbc166$var$supportsHistory = $06fa104e4adbc166$export$67fc34576016d6ec = function supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
    return window.history && 'pushState' in window.history;
};
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ var $06fa104e4adbc166$var$supportsPopStateOnHashChange = $06fa104e4adbc166$export$bd919e6f5f49fb48 = function supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf('Trident') === -1;
};
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ var $06fa104e4adbc166$var$supportsGoWithoutReloadUsingHash = $06fa104e4adbc166$export$9a5b29ff20eb48f9 = function supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf('Firefox') === -1;
};
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ var $06fa104e4adbc166$var$isExtraneousPopstateEvent = $06fa104e4adbc166$export$aa3c5b1dd6fed00 = function isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};


function $477e019f2b5e6422$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $477e019f2b5e6422$var$PopStateEvent = 'popstate';
var $477e019f2b5e6422$var$HashChangeEvent = 'hashchange';
var $477e019f2b5e6422$var$getHistoryState = function getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
};
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ var $477e019f2b5e6422$var$createBrowserHistory = function createBrowserHistory() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, $477e019f2b5e6422$var$_invariant2.default)($06fa104e4adbc166$export$71594e8a50f746f4, 'Browser history needs a DOM');
    var globalHistory = window.history;
    var canUseHistory = (0, $06fa104e4adbc166$export$67fc34576016d6ec)();
    var needsHashChangeListener = !(0, $06fa104e4adbc166$export$bd919e6f5f49fb48)();
    var _props$forceRefresh = props.forceRefresh, forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh, _props$getUserConfirm = props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === undefined ? $06fa104e4adbc166$export$ef38efb4b47d01db : _props$getUserConfirm, _props$keyLength = props.keyLength, keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;
    var basename = props.basename ? (0, $71e1af5b080b12ca$export$d95b4586d238a081)((0, $71e1af5b080b12ca$export$5b4913142e03bca8)(props.basename)) : '';
    var getDOMLocation = function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        (0, $477e019f2b5e6422$var$_warning2.default)(!basename || (0, $71e1af5b080b12ca$export$10497c7ce66fcb84)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin with the basename. Expected path "' + path + '" to begin with "' + basename + '".');
        if (basename) path = (0, $71e1af5b080b12ca$export$b69e3301ce081aa3)(path, basename);
        return (0, $8f47cb9e5c14e83a$export$90c043f1c57770b8)(path, state, key);
    };
    var createKey = function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    };
    var transitionManager = (0, $477e019f2b5e6422$var$_createTransitionManager2.default)();
    var setState = function setState(nextState) {
        $477e019f2b5e6422$var$_extends(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    };
    var handlePopState = function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ((0, $06fa104e4adbc166$export$aa3c5b1dd6fed00)(event)) return;
        handlePop(getDOMLocation(event.state));
    };
    var handleHashChange = function handleHashChange() {
        handlePop(getDOMLocation($477e019f2b5e6422$var$getHistoryState()));
    };
    var forceNextPop = false;
    var handlePop = function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    };
    var revertPop = function revertPop(fromLocation) {
        var toLocation = history.location;
        // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    };
    var initialLocation = getDOMLocation($477e019f2b5e6422$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ];
    // Public interface
    var createHref = function createHref(location) {
        return basename + (0, $71e1af5b080b12ca$export$fe53371bee54353d)(location);
    };
    var push = function push(path, state) {
        (0, $477e019f2b5e6422$var$_warning2.default)(!((typeof path === 'undefined' ? 'undefined' : $477e019f2b5e6422$var$_typeof(path)) === 'object' && path.state !== undefined && state !== undefined), "You should avoid providing a 2nd state argument to push when the 1st argument is a location-like object that already has state; it is ignored");
        var action = 'PUSH';
        var location = (0, $8f47cb9e5c14e83a$export$90c043f1c57770b8)(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else {
                (0, $477e019f2b5e6422$var$_warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');
                window.location.href = href;
            }
        });
    };
    var replace = function replace(path, state) {
        (0, $477e019f2b5e6422$var$_warning2.default)(!((typeof path === 'undefined' ? 'undefined' : $477e019f2b5e6422$var$_typeof(path)) === 'object' && path.state !== undefined && state !== undefined), "You should avoid providing a 2nd state argument to replace when the 1st argument is a location-like object that already has state; it is ignored");
        var action = 'REPLACE';
        var location = (0, $8f47cb9e5c14e83a$export$90c043f1c57770b8)(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else {
                (0, $477e019f2b5e6422$var$_warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');
                window.location.replace(href);
            }
        });
    };
    var go = function go(n) {
        globalHistory.go(n);
    };
    var goBack = function goBack() {
        return go(-1);
    };
    var goForward = function goForward() {
        return go(1);
    };
    var listenerCount = 0;
    var checkDOMListeners = function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1) {
            (0, $06fa104e4adbc166$export$3f65cefe8380dbea)(window, $477e019f2b5e6422$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) (0, $06fa104e4adbc166$export$3f65cefe8380dbea)(window, $477e019f2b5e6422$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            (0, $06fa104e4adbc166$export$8ff9f68337b520c0)(window, $477e019f2b5e6422$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) (0, $06fa104e4adbc166$export$8ff9f68337b520c0)(window, $477e019f2b5e6422$var$HashChangeEvent, handleHashChange);
        }
    };
    var isBlocked = false;
    var block = function block() {
        var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    };
    var listen = function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    };
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
};
$477e019f2b5e6422$export$2e2bcd8739ae039 = $477e019f2b5e6422$var$createBrowserHistory;



var $8V6O9 = parcelRequire("8V6O9");
let $efe75065bf034d65$var$browserHistoryListener = null;
const $efe75065bf034d65$export$39f750fd76b05ae3 = (newBrowserHistoryListener)=>{
    $efe75065bf034d65$var$browserHistoryListener = newBrowserHistoryListener;
    return ()=>{
        $efe75065bf034d65$var$browserHistoryListener = null;
    };
};
const $efe75065bf034d65$export$1ddb08151d15bc78 = (0, $8V6O9.default)(()=>{
    const browserHistory = (0, $477e019f2b5e6422$export$2e2bcd8739ae039)();
    browserHistory.listen((location, action)=>{
        $efe75065bf034d65$var$browserHistoryListener?.(location, action);
    });
    return browserHistory;
});


// The build information here are populated by the code inlined in the bootstrapping HTML
// They can be found in:
// - packages/confluence-frontend-server/templates/*
function $f3f8c1a227f13835$var$getReleaseTrack() {
    try {
        // This value overrides the track as "dev". Helpful for when
        // end-to-end tests are run from dev machine against a production instance.
        // eslint-disable-next-line check-set-storage-usage/no-unimported-storage-set
        if (sessionStorage.getItem('confluence.telemetry-dev-track-override')) return 'dev';
    } catch  {
    // no-op
    }
    return 'prod';
}
function $f3f8c1a227f13835$export$4ea39b9726d98a51() {
    const injectedBuildInfo = window.__buildInfo || {};
    let { FRONTEND_VERSION: FRONTEND_VERSION, BUILD_VARIANT: BUILD_VARIANT } = injectedBuildInfo;
    if (!FRONTEND_VERSION) FRONTEND_VERSION = '';
    if (!BUILD_VARIANT) BUILD_VARIANT = '';
    const FRONTEND_VERSION_PATTERN = /^([^-]+)-(.+)-(\d+)$/;
    const match = FRONTEND_VERSION_PATTERN.exec(FRONTEND_VERSION);
    return {
        FRONTEND_VERSION: match ? FRONTEND_VERSION : 'UNKNOWN-unknown-0',
        BRANCH_NAME: match ? match[2] : 'unknown',
        BUILD_NUMBER: match ? parseInt(match[3], 10) : 0,
        BUILD_DATE: injectedBuildInfo.BUILD_DATE || 0,
        BUILD_VARIANT: BUILD_VARIANT,
        PUBLIC_PATH: injectedBuildInfo.PUBLIC_PATH || 'unknown',
        RELEASE_TRACK: $f3f8c1a227f13835$var$getReleaseTrack(),
        IS_BIFROST: window.__IS_BIFROST__ || false
    };
}


const $cd3135dd152096aa$var$PromiseStatus = Symbol.for('PromiseStatus');
const $cd3135dd152096aa$var$PromiseValue = Symbol.for('PromiseValue');
const $cd3135dd152096aa$export$cc373701aed148fc = (promise)=>{
    const newPromise = promise.then((value)=>{
        newPromise[$cd3135dd152096aa$var$PromiseStatus] = 'resolved';
        newPromise[$cd3135dd152096aa$var$PromiseValue] = value;
        return value;
    }, (error)=>{
        newPromise[$cd3135dd152096aa$var$PromiseStatus] = 'rejected';
        newPromise[$cd3135dd152096aa$var$PromiseValue] = error;
        throw error;
    });
    newPromise[$cd3135dd152096aa$var$PromiseStatus] = 'pending';
    return newPromise;
};
const $cd3135dd152096aa$export$b1a2a6bd0c6f9666 = (liftedPromise)=>liftedPromise[$cd3135dd152096aa$var$PromiseStatus] === 'resolved';
const $cd3135dd152096aa$export$bf7199a9ebcb84a9 = (liftedPromise)=>liftedPromise[$cd3135dd152096aa$var$PromiseValue];



/* eslint-disable no-console */ function $a6897acd40ed68b1$var$getLoggerName(logSource) {
    return typeof logSource === 'string' ? logSource : logSource.displayName || logSource.name || 'Unknown';
}
class $a6897acd40ed68b1$var$Logger {
    log(strings, ...values) {
        this.logAnyLevel(1, console.log, strings, values);
    }
    debug(strings, ...values) {
        this.logAnyLevel(2, console.debug, strings, values);
    }
    info(strings, ...values) {
        this.logAnyLevel(3, console.info, strings, values);
    }
    warn(strings, ...values) {
        this.logAnyLevel(4, console.warn, strings, values);
    }
    error(strings, ...values) {
        this.logAnyLevel(5, console.error, strings, values);
    }
    logAnyLevel(logLevel, consoleFunction, strings, values) {
        try {
            if (// There's no sessionStorage in service workers.
            // We'll just enable logging from service workers for simplicity.
            typeof sessionStorage === 'undefined' || sessionStorage.getItem('confluence.enable-logging') === 'true') {
                const logLevelSetting = typeof sessionStorage !== 'undefined' && sessionStorage.getItem('confluence.log-level');
                const configuredLogLevel = parseInt(logLevelSetting || '', 10) || 1;
                if (configuredLogLevel > logLevel) return;
                const prefix = [
                    `[@${Math.round(performance.now())} ${this.name}]`
                ];
                const messages = strings.reduce((processed, str, index)=>{
                    const value = values[index];
                    const trimmedStr = str.trim()// Allow multiline strings to be indented in code but printed without indenting
                    .replace(/\n\s+/g, '\n');
                    if (trimmedStr) processed.push(trimmedStr);
                    if (index !== strings.length - 1) processed.push(typeof value === 'string' ? JSON.stringify(value) : value);
                    return processed;
                }, prefix);
                consoleFunction(...messages);
            }
        } catch (e) {
            // Catch and log.
            // We don't want to stop execution due to a logging error.
            console.error(e);
        }
    }
    constructor(logSource){
        this.name = void 0;
        this.name = $a6897acd40ed68b1$var$getLoggerName(logSource);
    }
}
const $a6897acd40ed68b1$export$2b1d391cd05230fd = (logSource)=>new $a6897acd40ed68b1$var$Logger(logSource);


// Must call this before any browser-helper functions, to ensure user agent has been set first
(0, $c086cef45a2cc129$export$57d3cdb500cb5402)();
const $3793e1e9d193543a$var$logger = (0, $a6897acd40ed68b1$export$2b1d391cd05230fd)('mobile-detection');
// Copied from com.atlassian.confluence.mobile.MobileUtils
const $3793e1e9d193543a$var$NATIVE_IOS_REGEX_STRING = 'iPhone;|iPad;|iPhone Simulator;|iPod;|iPod touch;';
const $3793e1e9d193543a$var$NATIVE_ANDROID_REGEX_STRING = 'Linux; U; Android|Android';
const $3793e1e9d193543a$var$MOBILE_USER_AGENT_REGEX = new RegExp(`(${$3793e1e9d193543a$var$NATIVE_IOS_REGEX_STRING}|${$3793e1e9d193543a$var$NATIVE_ANDROID_REGEX_STRING})`, 'i');
const $3793e1e9d193543a$var$ANDROID_CHROME = /Chrome\/[.\d]* Mobile/i;
const $3793e1e9d193543a$var$OLD_ANDROID = /Linux; U; Android (?:[23]\.\d|4\.0\.[12])/i;
const $3793e1e9d193543a$var$NATIVE_IOS = new RegExp(`(${$3793e1e9d193543a$var$NATIVE_IOS_REGEX_STRING})`, 'i');
const $3793e1e9d193543a$var$NATIVE_ANDROID = new RegExp(`(${$3793e1e9d193543a$var$NATIVE_ANDROID_REGEX_STRING})`, 'i');
const $3793e1e9d193543a$export$bb3c728251279d4a = 'mobileWebTestingMode=testing';
const $3793e1e9d193543a$export$2275282fb5681637 = 'mobile.web.desktop.override.active';
const $3793e1e9d193543a$export$abee7d877fc322c9 = ()=>{
    // Port from com.atlassian.confluence.mobile.MobileUtils#isMobileViewRequest
    const ua = window.navigator.userAgent;
    return !!ua && !$3793e1e9d193543a$var$OLD_ANDROID.test(ua) && ($3793e1e9d193543a$var$MOBILE_USER_AGENT_REGEX.test(ua) || $3793e1e9d193543a$var$ANDROID_CHROME.test(ua) || (0, $c086cef45a2cc129$export$6d5620528cf86fa2)());
};
const $3793e1e9d193543a$export$cc63546398e0df2 = ()=>window.localStorage.getItem($3793e1e9d193543a$export$2275282fb5681637) === 'true';
const $3793e1e9d193543a$export$47a2095e97aaa3d3 = ()=>{
    try {
        // TODO: Remove lint rule once storage is updated to use atlassian/browser-storage-controls or confluence/storage-manager
        // eslint-disable-next-line check-set-storage-usage/no-unimported-storage-set
        window.localStorage.setItem($3793e1e9d193543a$export$2275282fb5681637, 'true');
    } catch (err) {
        $3793e1e9d193543a$var$logger.error`Unable to set local storage. key = "${$3793e1e9d193543a$export$2275282fb5681637}", value = "true"`;
    }
};
const $3793e1e9d193543a$export$77ee453f21ed22ca = ()=>window.localStorage.removeItem($3793e1e9d193543a$export$2275282fb5681637);
function $3793e1e9d193543a$export$1adf40e7373cdd98() {
    // for testing purposes, query param forces mobile web
    if (window.location.search.includes($3793e1e9d193543a$export$bb3c728251279d4a)) return true;
    return $3793e1e9d193543a$export$abee7d877fc322c9() && !$3793e1e9d193543a$export$cc63546398e0df2();
}
const $3793e1e9d193543a$export$4483f9f8ce987764 = ()=>{
    const ua = window.navigator.userAgent;
    return !!ua && $3793e1e9d193543a$var$NATIVE_ANDROID.test(ua);
};
const $3793e1e9d193543a$export$63c82ea425a2bb3d = ()=>{
    const ua = window.navigator.userAgent;
    return !!ua && $3793e1e9d193543a$var$NATIVE_IOS.test(ua);
};


var $a35cdd272375d707$exports = {};
"use strict";
var $a35cdd272375d707$var$__createBinding = $a35cdd272375d707$exports && $a35cdd272375d707$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a35cdd272375d707$var$__exportStar = $a35cdd272375d707$exports && $a35cdd272375d707$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $a35cdd272375d707$var$__createBinding(exports1, m, p);
};
Object.defineProperty($a35cdd272375d707$exports, "__esModule", {
    value: true
});
$a35cdd272375d707$exports.StatsigClient = void 0;

var $26667d8f94fef8a7$exports = {};
"use strict";
var $26667d8f94fef8a7$var$__awaiter = $26667d8f94fef8a7$exports && $26667d8f94fef8a7$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty($26667d8f94fef8a7$exports, "__esModule", {
    value: true
});

var $b4CpS = parcelRequire("b4CpS");
var $87efe29b203a82ac$exports = {};
"use strict";
Object.defineProperty($87efe29b203a82ac$exports, "__esModule", {
    value: true
});

var $b4CpS = parcelRequire("b4CpS");
var $8971679dded26a4f$exports = {};
"use strict";
Object.defineProperty($8971679dded26a4f$exports, "__esModule", {
    value: true
});
$8971679dded26a4f$exports.V1InitializeContainer = void 0;

var $b4CpS = parcelRequire("b4CpS");
class $8971679dded26a4f$var$V1InitializeContainer {
    getGate(name) {
        return this._getResultFromLookup(this._values.feature_gates, name);
    }
    getConfig(name) {
        return this._getResultFromLookup(this._values.dynamic_configs, name);
    }
    getLayer(name) {
        return this._getResultFromLookup(this._values.layer_configs, name);
    }
    getParamStore(name) {
        return this._getResultFromLookup(this._values.param_stores, name);
    }
    getConfigList() {
        return Object.keys(this._values.dynamic_configs);
    }
    getExposureMapping() {
        return this._values.exposures;
    }
    _getResultFromLookup(lookup, name) {
        var _a, _b;
        if (!lookup) return null;
        return (_b = (_a = lookup[name]) !== null && _a !== void 0 ? _a : lookup[(0, $b4CpS._DJB2)(name)]) !== null && _b !== void 0 ? _b : null;
    }
    constructor(_values){
        this._values = _values;
    }
}
$8971679dded26a4f$exports.V1InitializeContainer = $8971679dded26a4f$var$V1InitializeContainer;


var $069293d52376d166$exports = {};
"use strict";
Object.defineProperty($069293d52376d166$exports, "__esModule", {
    value: true
});
$069293d52376d166$exports.V2InitializeContainer = void 0;

var $b4CpS = parcelRequire("b4CpS");
class $069293d52376d166$var$V2InitializeContainer {
    getGate(name) {
        var _a, _b, _c;
        const evalV2 = this._getResultFromLookup(this._values.feature_gates, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: evalV2.v === true,
            rule_id: (_a = evalV2.r) !== null && _a !== void 0 ? _a : 'default',
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            id_type: (_c = evalV2.i) !== null && _c !== void 0 ? _c : ''
        };
    }
    getConfig(name) {
        var _a, _b, _c, _d;
        const evalV2 = this._getResultFromLookup(this._values.dynamic_configs, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: (_a = this._values.values[evalV2.v]) !== null && _a !== void 0 ? _a : {},
            rule_id: evalV2.r,
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            id_type: (_c = evalV2.i) !== null && _c !== void 0 ? _c : '',
            is_user_in_experiment: evalV2.ue === true ? true : false,
            passed: evalV2.p === true,
            group_name: (_d = evalV2.gn) !== null && _d !== void 0 ? _d : undefined,
            is_experiment_active: evalV2.ea === true ? true : false,
            group: evalV2.r,
            is_device_based: evalV2.i === 'stableID'
        };
    }
    getLayer(name) {
        var _a, _b, _c, _d, _e, _f;
        const evalV2 = this._getResultFromLookup(this._values.layer_configs, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: (_a = this._values.values[evalV2.v]) !== null && _a !== void 0 ? _a : {},
            rule_id: evalV2.r,
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            is_user_in_experiment: evalV2.ue === true ? true : false,
            group_name: (_c = evalV2.gn) !== null && _c !== void 0 ? _c : undefined,
            is_experiment_active: evalV2.ea === true ? true : false,
            group: evalV2.r,
            is_device_based: evalV2.i === 'stableID',
            allocated_experiment_name: (_d = evalV2.ae) !== null && _d !== void 0 ? _d : '',
            explicit_parameters: (_e = evalV2.ep) !== null && _e !== void 0 ? _e : [],
            undelegated_secondary_exposures: (_f = evalV2.us) !== null && _f !== void 0 ? _f : [],
            parameter_rule_ids: evalV2.pr
        };
    }
    getParamStore(name) {
        return this._getResultFromLookup(this._values.param_stores, name);
    }
    getConfigList() {
        return Object.keys(this._values.dynamic_configs);
    }
    getExposureMapping() {
        return this._values.exposures;
    }
    _getResultFromLookup(lookup, name) {
        var _a, _b;
        if (!lookup) return null;
        return (_b = (_a = lookup[name]) !== null && _a !== void 0 ? _a : lookup[(0, $b4CpS._DJB2)(name)]) !== null && _b !== void 0 ? _b : null;
    }
    constructor(_values){
        this._values = _values;
    }
}
$069293d52376d166$exports.V2InitializeContainer = $069293d52376d166$var$V2InitializeContainer;


class $87efe29b203a82ac$var$EvaluationStore {
    reset() {
        this._values = null;
        this._rawValues = null;
        this._source = 'Loading';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings.clear();
    }
    finalize() {
        if (this._values) return;
        this._source = 'NoValues';
    }
    getValues() {
        return this._rawValues ? (0, $b4CpS._typedJsonParse)(this._rawValues, 'has_updates', 'EvaluationStoreValues') : null;
    }
    setValues(result, user) {
        var _a, _b;
        if (!result) return false;
        const values = (0, $b4CpS._typedJsonParse)(result.data, 'has_updates', 'EvaluationResponse');
        if (values == null) return false;
        this._source = result.source;
        if ((values === null || values === void 0 ? void 0 : values.has_updates) !== true) return true;
        const updatedLcut = (_a = values.time) !== null && _a !== void 0 ? _a : 0;
        if (updatedLcut < this._lcut) return true;
        this._rawValues = result.data;
        this._lcut = values.time;
        this._receivedAt = result.receivedAt;
        if (values.response_format === 'init-v2') this._values = new $069293d52376d166$exports.V2InitializeContainer(values);
        else this._values = new $8971679dded26a4f$exports.V1InitializeContainer(values);
        this._bootstrapMetadata = this._extractBootstrapMetadata(result.source, values);
        if (result.source && values.user) this._setWarningState(user, values);
        $b4CpS.SDKFlags.setFlags(this._sdkKey, (_b = values.sdk_flags) !== null && _b !== void 0 ? _b : {});
        return true;
    }
    getWarnings() {
        if (this._warnings.size === 0) return undefined;
        return Array.from(this._warnings);
    }
    getGate(name) {
        const res = this._values ? this._values.getGate(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getConfig(name) {
        const res = this._values ? this._values.getConfig(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getConfigList() {
        if (!this._values) return [];
        return this._values.getConfigList();
    }
    getLayer(name) {
        const res = this._values ? this._values.getLayer(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getParamStore(name) {
        const res = this._values ? this._values.getParamStore(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getSource() {
        return this._source;
    }
    getExposureMapping() {
        var _a;
        return (_a = this._values) === null || _a === void 0 ? void 0 : _a.getExposureMapping();
    }
    _extractBootstrapMetadata(source, values) {
        if (source !== 'Bootstrap') return null;
        const bootstrapMetadata = {};
        if (values.user) bootstrapMetadata.user = values.user;
        if (values.sdkInfo) bootstrapMetadata.generatorSDKInfo = values.sdkInfo;
        bootstrapMetadata.lcut = values.time;
        return bootstrapMetadata;
    }
    _getDetailedStoreResult(result) {
        return {
            result: result,
            details: this._getDetails(result == null)
        };
    }
    _setWarningState(user, values) {
        var _a, _b;
        const stableID = $b4CpS.StableID.get(this._sdkKey);
        if (((_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID) !== stableID && // don't throw if they're both undefined
        (((_b = user.customIDs) === null || _b === void 0 ? void 0 : _b.stableID) || stableID)) {
            this._warnings.add('StableIDMismatch');
            return;
        }
        if ('user' in values) {
            const bootstrapUser = values['user'];
            const userForComparison = Object.assign(Object.assign({}, user), {
                analyticsOnlyMetadata: undefined,
                privateAttributes: undefined
            });
            if ((0, $b4CpS._getFullUserHash)(userForComparison) !== (0, $b4CpS._getFullUserHash)(bootstrapUser)) this._warnings.add('PartialUserMatch');
        }
    }
    getCurrentSourceDetails() {
        if (this._source === 'Uninitialized' || this._source === 'NoValues') return {
            reason: this._source
        };
        const sourceDetails = {
            reason: this._source,
            lcut: this._lcut,
            receivedAt: this._receivedAt
        };
        if (this._warnings.size > 0) sourceDetails.warnings = Array.from(this._warnings);
        return sourceDetails;
    }
    _getDetails(isUnrecognized) {
        var _a, _b;
        const sourceDetails = this.getCurrentSourceDetails();
        let reason = sourceDetails.reason;
        const warnings = (_a = sourceDetails.warnings) !== null && _a !== void 0 ? _a : [];
        if (this._source === 'Bootstrap' && warnings.length > 0) reason = reason + warnings[0];
        if (reason !== 'Uninitialized' && reason !== 'NoValues') {
            const subreason = isUnrecognized ? 'Unrecognized' : 'Recognized';
            reason = `${reason}:${subreason}`;
        }
        const bootstrapMetadata = this._source === 'Bootstrap' ? (_b = this._bootstrapMetadata) !== null && _b !== void 0 ? _b : undefined : undefined;
        if (bootstrapMetadata) sourceDetails.bootstrapMetadata = bootstrapMetadata;
        return Object.assign(Object.assign({}, sourceDetails), {
            reason: reason
        });
    }
    constructor(_sdkKey){
        this._sdkKey = _sdkKey;
        this._rawValues = null;
        this._values = null;
        this._source = 'Uninitialized';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings = new Set();
    }
}
$87efe29b203a82ac$exports.default = $87efe29b203a82ac$var$EvaluationStore;


var $4c09e531f06eb601$exports = {};
"use strict";
var $4c09e531f06eb601$var$__awaiter = $4c09e531f06eb601$exports && $4c09e531f06eb601$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty($4c09e531f06eb601$exports, "__esModule", {
    value: true
});

var $b4CpS = parcelRequire("b4CpS");
var $928d76c813cda18f$exports = {};
"use strict";
Object.defineProperty($928d76c813cda18f$exports, "__esModule", {
    value: true
});
$928d76c813cda18f$exports._resolveDeltasResponse = void 0;

var $b4CpS = parcelRequire("b4CpS");
const $928d76c813cda18f$var$MAX_DELTAS_SORT_DEPTH = 2;
function $928d76c813cda18f$var$_resolveDeltasResponse(cache, deltasString) {
    const deltas = (0, $b4CpS._typedJsonParse)(deltasString, 'checksum', 'DeltasEvaluationResponse');
    if (!deltas) return {
        hadBadDeltaChecksum: true
    };
    const merged = $928d76c813cda18f$var$_mergeDeltasIntoCache(cache, deltas);
    const resolved = $928d76c813cda18f$var$_handleDeletedEntries(merged);
    const actualChecksum = (0, $b4CpS._DJB2Object)({
        feature_gates: resolved.feature_gates,
        dynamic_configs: resolved.dynamic_configs,
        layer_configs: resolved.layer_configs
    }, $928d76c813cda18f$var$MAX_DELTAS_SORT_DEPTH);
    const isMatch = actualChecksum === deltas.checksumV2;
    if (!isMatch) return {
        hadBadDeltaChecksum: true,
        badChecksum: actualChecksum,
        badMergedConfigs: resolved,
        badFullResponse: deltas.deltas_full_response
    };
    return JSON.stringify(resolved);
}
$928d76c813cda18f$exports._resolveDeltasResponse = $928d76c813cda18f$var$_resolveDeltasResponse;
function $928d76c813cda18f$var$_mergeDeltasIntoCache(cache, deltas) {
    return Object.assign(Object.assign(Object.assign({}, cache), deltas), {
        feature_gates: Object.assign(Object.assign({}, cache.feature_gates), deltas.feature_gates),
        layer_configs: Object.assign(Object.assign({}, cache.layer_configs), deltas.layer_configs),
        dynamic_configs: Object.assign(Object.assign({}, cache.dynamic_configs), deltas.dynamic_configs)
    });
}
function $928d76c813cda18f$var$_handleDeletedEntries(deltas) {
    const result = deltas;
    $928d76c813cda18f$var$_deleteEntriesInRecord(deltas.deleted_gates, result.feature_gates);
    delete result.deleted_gates;
    $928d76c813cda18f$var$_deleteEntriesInRecord(deltas.deleted_configs, result.dynamic_configs);
    delete result.deleted_configs;
    $928d76c813cda18f$var$_deleteEntriesInRecord(deltas.deleted_layers, result.layer_configs);
    delete result.deleted_layers;
    return result;
}
function $928d76c813cda18f$var$_deleteEntriesInRecord(keys, values) {
    keys === null || keys === void 0 || keys.forEach((key)=>{
        delete values[key];
    });
}


class $4c09e531f06eb601$var$StatsigNetwork extends $b4CpS.NetworkCore {
    fetchEvaluations(sdkKey, current, priority, user, isCacheValidFor204) {
        return $4c09e531f06eb601$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d, _e, _f;
            const cache = current ? (0, $b4CpS._typedJsonParse)(current, 'has_updates', 'InitializeResponse') : null;
            let data = {
                user: user,
                hash: (_c = (_b = (_a = this._option) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.initializeHashAlgorithm) !== null && _c !== void 0 ? _c : 'djb2',
                deltasResponseRequested: false,
                full_checksum: null
            };
            if (cache === null || cache === void 0 ? void 0 : cache.has_updates) {
                const hasHashChanged = (cache === null || cache === void 0 ? void 0 : cache.hash_used) !== ((_f = (_e = (_d = this._option) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.initializeHashAlgorithm) !== null && _f !== void 0 ? _f : 'djb2');
                data = Object.assign(Object.assign({}, data), {
                    sinceTime: isCacheValidFor204 && !hasHashChanged ? cache.time : 0,
                    previousDerivedFields: 'derived_fields' in cache && isCacheValidFor204 ? cache.derived_fields : {},
                    deltasResponseRequested: true,
                    full_checksum: cache.full_checksum,
                    partialUserMatchSinceTime: !hasHashChanged ? cache.time : 0
                });
            }
            return this._fetchEvaluations(sdkKey, cache, data, priority);
        });
    }
    _fetchEvaluations(sdkKey, cache, data, priority) {
        return $4c09e531f06eb601$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            const response = yield this.post({
                sdkKey: sdkKey,
                urlConfig: this._initializeUrlConfig,
                data: data,
                retries: 2,
                isStatsigEncodable: true,
                priority: priority
            });
            if ((response === null || response === void 0 ? void 0 : response.code) === 204) return '{"has_updates": false}';
            if ((response === null || response === void 0 ? void 0 : response.code) !== 200) return (_a = response === null || response === void 0 ? void 0 : response.body) !== null && _a !== void 0 ? _a : null;
            if ((cache === null || cache === void 0 ? void 0 : cache.has_updates) !== true || ((_b = response.body) === null || _b === void 0 ? void 0 : _b.includes('"is_delta":true')) !== true || data.deltasResponseRequested !== true) return response.body;
            const result = (0, $928d76c813cda18f$exports._resolveDeltasResponse)(cache, response.body);
            if (typeof result === 'string') return result;
            // retry without deltas
            return this._fetchEvaluations(sdkKey, cache, Object.assign(Object.assign(Object.assign({}, data), result), {
                deltasResponseRequested: false
            }), priority);
        });
    }
    constructor(options, emitter){
        super(options, emitter);
        const config = options === null || options === void 0 ? void 0 : options.networkConfig;
        this._option = options;
        this._initializeUrlConfig = new $b4CpS.UrlConfiguration($b4CpS.Endpoint._initialize, config === null || config === void 0 ? void 0 : config.initializeUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.initializeFallbackUrls);
    }
}
$4c09e531f06eb601$exports.default = $4c09e531f06eb601$var$StatsigNetwork;


var $b349836f092d0a8d$exports = {};
"use strict";
Object.defineProperty($b349836f092d0a8d$exports, "__esModule", {
    value: true
});
$b349836f092d0a8d$exports._makeParamStoreGetter = void 0;

var $b4CpS = parcelRequire("b4CpS");
const $b349836f092d0a8d$var$NO_EXPOSURE_OPT = {
    disableExposureLog: true
};
function $b349836f092d0a8d$var$_shouldLogExposure(options) {
    return options == null || options.disableExposureLog === false;
}
function $b349836f092d0a8d$var$_shouldReturnFallback(value, fallback) {
    return fallback != null && !(0, $b4CpS._isTypeMatch)(value, fallback);
}
function $b349836f092d0a8d$var$_getMappedStaticValue(param, _options) {
    return param.value;
}
function $b349836f092d0a8d$var$_getMappedGateValue(client, param, options) {
    const gate = client.getFeatureGate(param.gate_name, $b349836f092d0a8d$var$_shouldLogExposure(options) ? undefined : $b349836f092d0a8d$var$NO_EXPOSURE_OPT);
    if (gate.value) return param.pass_value;
    return param.fail_value;
}
function $b349836f092d0a8d$var$_getMappedDynamicConfigValue(client, param, fallback, options) {
    const config = client.getDynamicConfig(param.config_name, $b349836f092d0a8d$var$_shouldLogExposure(options) ? undefined : $b349836f092d0a8d$var$NO_EXPOSURE_OPT);
    const value = config.get(param.param_name);
    if ($b349836f092d0a8d$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $b349836f092d0a8d$var$_getMappedExperimentValue(client, param, fallback, options) {
    const experiment = client.getExperiment(param.experiment_name, $b349836f092d0a8d$var$_shouldLogExposure(options) ? undefined : $b349836f092d0a8d$var$NO_EXPOSURE_OPT);
    const value = experiment.get(param.param_name);
    if ($b349836f092d0a8d$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $b349836f092d0a8d$var$_getMappedLayerValue(client, param, fallback, options) {
    const layer = client.getLayer(param.layer_name, $b349836f092d0a8d$var$_shouldLogExposure(options) ? undefined : $b349836f092d0a8d$var$NO_EXPOSURE_OPT);
    const value = layer.get(param.param_name);
    if ($b349836f092d0a8d$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $b349836f092d0a8d$var$_makeParamStoreGetter(client, config, options) {
    return (paramName, fallback)=>{
        if (config == null) return fallback;
        const param = config[paramName];
        if (param == null || fallback != null && (0, $b4CpS._typeOf)(fallback) !== param.param_type) return fallback;
        switch(param.ref_type){
            case 'static':
                return $b349836f092d0a8d$var$_getMappedStaticValue(param, options);
            case 'gate':
                return $b349836f092d0a8d$var$_getMappedGateValue(client, param, options);
            case 'dynamic_config':
                return $b349836f092d0a8d$var$_getMappedDynamicConfigValue(client, param, fallback, options);
            case 'experiment':
                return $b349836f092d0a8d$var$_getMappedExperimentValue(client, param, fallback, options);
            case 'layer':
                return $b349836f092d0a8d$var$_getMappedLayerValue(client, param, fallback, options);
            default:
                return fallback;
        }
    };
}
$b349836f092d0a8d$exports._makeParamStoreGetter = $b349836f092d0a8d$var$_makeParamStoreGetter;


var $1d962d22bea1450c$exports = {};
"use strict";
var $1d962d22bea1450c$var$__awaiter = $1d962d22bea1450c$exports && $1d962d22bea1450c$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty($1d962d22bea1450c$exports, "__esModule", {
    value: true
});
$1d962d22bea1450c$exports.StatsigEvaluationsDataAdapter = void 0;

var $b4CpS = parcelRequire("b4CpS");

class $1d962d22bea1450c$var$StatsigEvaluationsDataAdapter extends $b4CpS.DataAdapterCore {
    attach(sdkKey, options, network) {
        super.attach(sdkKey, options, network);
        if (network !== null && network instanceof $4c09e531f06eb601$exports.default) this._network = network;
        else this._network = new $4c09e531f06eb601$exports.default(options !== null && options !== void 0 ? options : {});
    }
    getDataAsync(current, user, options) {
        return this._getDataAsyncImpl(current, (0, $b4CpS._normalizeUser)(user, this._options), options);
    }
    prefetchData(user, options) {
        return this._prefetchDataImpl(user, options);
    }
    setData(data) {
        const values = (0, $b4CpS._typedJsonParse)(data, 'has_updates', 'data');
        if (values && 'user' in values) super.setData(data, values.user);
        else $b4CpS.Log.error('StatsigUser not found. You may be using an older server SDK version. Please upgrade your SDK or use setDataLegacy.');
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    _fetchFromNetwork(current, user, options, isCacheValidFor204) {
        return $1d962d22bea1450c$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield (_a = this._network) === null || _a === void 0 ? void 0 : _a.fetchEvaluations(this._getSdkKey(), current, options === null || options === void 0 ? void 0 : options.priority, user, isCacheValidFor204);
            return result !== null && result !== void 0 ? result : null;
        });
    }
    _getCacheKey(user) {
        var _a;
        const key = (0, $b4CpS._getStorageKey)(this._getSdkKey(), user, (_a = this._options) === null || _a === void 0 ? void 0 : _a.customUserCacheKeyFunc);
        return `${$b4CpS.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(result, user) {
        return result.fullUserHash != null && result.fullUserHash === (0, $b4CpS._getFullUserHash)(user);
    }
    constructor(){
        super('EvaluationsDataAdapter', 'evaluations');
        this._network = null;
        this._options = null;
    }
}
$1d962d22bea1450c$exports.StatsigEvaluationsDataAdapter = $1d962d22bea1450c$var$StatsigEvaluationsDataAdapter;


class $26667d8f94fef8a7$var$StatsigClient extends $b4CpS.StatsigClientBase {
    /**
     * Retrieves an instance of the StatsigClient based on the provided SDK key.
     *  If no SDK key is provided, the method returns the most recently created instance of the StatsigClient.
     *  The method ensures that each unique SDK key corresponds to a single instance of StatsigClient, effectively implementing a singleton pattern for each key.
     *  If no instance exists for the given SDK key, a new StatsigClient instance will be created and returned.
     *
     * @param {string} [sdkKey] - Optional. The SDK key used to identify a specific instance of the StatsigClient. If omitted, the method returns the last created instance.
     * @returns {StatsigClient} Returns the StatsigClient instance associated with the given SDK key, creating a new one if needed.
     */ static instance(sdkKey) {
        const instance = (0, $b4CpS._getStatsigGlobal)().instance(sdkKey);
        if (instance instanceof $26667d8f94fef8a7$var$StatsigClient) return instance;
        $b4CpS.Log.warn((0, $b4CpS._isServerEnv)() ? 'StatsigClient.instance is not supported in server environments' : 'Unable to find StatsigClient instance');
        return new $26667d8f94fef8a7$var$StatsigClient(sdkKey !== null && sdkKey !== void 0 ? sdkKey : '', {});
    }
    /**
     * Initializes the StatsigClient using cached values. This method sets up the client synchronously by utilizing previously cached values.
     * After initialization, cache values are updated in the background for future use, either in subsequent sessions or when `updateUser` is called.
     * This is useful for quickly starting with the last-known-good configurations while refreshing data to keep settings up-to-date.
     *
     * @see {@link initializeAsync} for the asynchronous version of this method.
     */ initializeSync(options) {
        var _a;
        if (this.loadingStatus !== 'Uninitialized') return (0, $b4CpS.createUpdateDetails)(true, this._store.getSource(), -1, null, null, [
            'MultipleInitializations',
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
        this._logger.start();
        return this.updateUserSync(this._user, options);
    }
    /**
     * Initializes the StatsigClient asynchronously by first using cached values and then updating to the latest values from the network.
     * Once the network values are fetched, they replace the existing cached values. If this method's promise is not awaited,
     * there might be a transition from cached to network values during the session, which can affect consistency.
     * This method is useful when it's acceptable to begin with potentially stale data and switch to the latest configuration as it becomes available.
     *
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully initialized with the latest values from the network or a timeout (if set) is hit.
     * @see {@link initializeSync} for the synchronous version of this method.
     */ initializeAsync(options) {
        return $26667d8f94fef8a7$var$__awaiter(this, void 0, void 0, function*() {
            if (this._initializePromise) return this._initializePromise;
            this._initializePromise = this._initializeAsyncImpl(options);
            return this._initializePromise;
        });
    }
    /**
     * Synchronously updates the user in the Statsig client and switches the internal state to use cached values for the newly specified user.
     * After the initial switch to cached values, this method updates these values in the background, preparing them for future sessions or subsequent calls to updateUser.
     * This method ensures the client is quickly ready with available data.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @see {@link updateUserAsync} for the asynchronous version of this method.
     */ updateUserSync(user, options) {
        const startTime = performance.now();
        try {
            return this._updateUserSyncImpl(user, options, startTime);
        } catch (e) {
            const err = e instanceof Error ? e : new Error(String(e));
            return this._createErrorUpdateDetails(err, startTime);
        }
    }
    _updateUserSyncImpl(user, options, startTime) {
        var _a;
        const warnings = [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ];
        this._resetForUser(user);
        const result = this.dataAdapter.getDataSync(this._user);
        if (result == null) warnings.push('NoCachedValues');
        this._store.setValues(result, this._user);
        this._finalizeUpdate(result);
        const disable = options === null || options === void 0 ? void 0 : options.disableBackgroundCacheRefresh;
        if (disable === true || disable == null && (result === null || result === void 0 ? void 0 : result.source) === 'Bootstrap') return (0, $b4CpS.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
        this._runPostUpdate(result !== null && result !== void 0 ? result : null, this._user);
        return (0, $b4CpS.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
    }
    /**
     * Asynchronously updates the user in the Statsig client by initially using cached values and then fetching the latest values from the network.
     * When the latest values are fetched, they replace the cached values. If the promise returned by this method is not awaited,
     * the client's state may shift from cached to updated network values during the session, potentially affecting consistency.
     * This method is best used in scenarios where up-to-date configuration is critical and initial delays are acceptable.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully updated with the latest values from the network or a timeout (if set) is hit.
     * @see {@link updateUserSync} for the synchronous version of this method.
     */ updateUserAsync(user, options) {
        return $26667d8f94fef8a7$var$__awaiter(this, void 0, void 0, function*() {
            const startTime = performance.now();
            try {
                return yield this._updateUserAsyncImpl(user, options);
            } catch (e) {
                const err = e instanceof Error ? e : new Error(String(e));
                return this._createErrorUpdateDetails(err, startTime);
            }
        });
    }
    _updateUserAsyncImpl(user, options) {
        return $26667d8f94fef8a7$var$__awaiter(this, void 0, void 0, function*() {
            this._resetForUser(user);
            const initiator = this._user;
            $b4CpS.Diagnostics._markInitOverallStart(this._sdkKey);
            let result = this.dataAdapter.getDataSync(initiator);
            this._store.setValues(result, this._user);
            this._setStatus('Loading', result);
            result = yield this.dataAdapter.getDataAsync(result, initiator, options);
            // ensure the user hasn't changed while we were waiting
            if (initiator !== this._user) return (0, $b4CpS.createUpdateDetails)(false, this._store.getSource(), -1, new Error('User changed during update'), this._network.getLastUsedInitUrlAndReset());
            let isUsingNetworkValues = false;
            if (result != null) {
                $b4CpS.Diagnostics._markInitProcessStart(this._sdkKey);
                isUsingNetworkValues = this._store.setValues(result, this._user);
                $b4CpS.Diagnostics._markInitProcessEnd(this._sdkKey, {
                    success: isUsingNetworkValues
                });
            }
            this._finalizeUpdate(result);
            if (!isUsingNetworkValues) {
                this._errorBoundary.attachErrorIfNoneExists($b4CpS.UPDATE_DETAIL_ERROR_MESSAGES.NO_NETWORK_DATA);
                this.$emt({
                    name: 'initialization_failure'
                });
            }
            $b4CpS.Diagnostics._markInitOverallEnd(this._sdkKey, isUsingNetworkValues, this._store.getCurrentSourceDetails());
            const initDuration = $b4CpS.Diagnostics._enqueueDiagnosticsEvent(this._user, this._logger, this._sdkKey, this._options);
            return (0, $b4CpS.createUpdateDetails)(isUsingNetworkValues, this._store.getSource(), initDuration, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), this._store.getWarnings());
        });
    }
    /**
     * Retrieves a synchronous context containing data currently being used by the SDK. Represented as a {@link PrecomputedEvaluationsContext} object.
     *
     * @returns {PrecomputedEvaluationsContext} The current synchronous context for the this StatsigClient instance.
     */ getContext() {
        let user = {};
        try {
            user = JSON.parse(JSON.stringify(this._user));
        } catch (_a) {
            $b4CpS.Log.error('Failed to parse user');
        }
        return {
            sdkKey: this._sdkKey,
            options: this._options,
            values: this._store.getValues(),
            user: user,
            errorBoundary: this._errorBoundary,
            session: $b4CpS.StatsigSession.get(this._sdkKey),
            stableID: $b4CpS.StableID.get(this._sdkKey),
            sdkInstanceID: this._sdkInstanceID
        };
    }
    /**
     * Retrieves the value of a feature gate for the current user, represented as a simple boolean.
     *
     * @param {string} name - The name of the feature gate to retrieve.
     * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {boolean} - The boolean value representing the gate's current evaluation results for the user.
     */ checkGate(name, options) {
        return this.getFeatureGate(name, options).value;
    }
    /**
     * Logs an event to the internal logging system. This function allows logging by either passing a fully formed event object or by specifying the event name with optional value and metadata.
     *
     * @param {StatsigEvent|string} eventOrName - The event object conforming to the StatsigEvent interface, or the name of the event as a string.
     * @param {string|number} value - Optional. The value associated with the event, which can be a string or a number. This parameter is ignored if the first parameter is a StatsigEvent object.
     * @param {Record<string, string>} metadata - Optional. A key-value record containing metadata about the event. This is also ignored if the first parameter is an event object.
     */ logEvent(eventOrName, value, metadata) {
        const event = typeof eventOrName === 'string' ? {
            eventName: eventOrName,
            value: value,
            metadata: metadata
        } : eventOrName;
        this.$emt({
            name: 'log_event_called',
            event: event
        });
        this._logger.enqueue(Object.assign(Object.assign({}, event), {
            user: this._user,
            time: Date.now()
        }));
    }
    /**
     * Updates the user with analytics only metadata. This will override any existing analytics only metadata.
     *
     * @param {Record<string, string | number | boolean>} metadata - The metadata to add to the user.
     */ updateUserWithAnalyticsOnlyMetadata(metadata) {
        this._user = this._configureUser(Object.assign(Object.assign({}, this._user), {
            analyticsOnlyMetadata: metadata
        }), this._options);
    }
    _primeReadyRipcord() {
        this.$on('error', ()=>{
            this.loadingStatus === 'Loading' && this._finalizeUpdate(null);
        });
    }
    _initializeAsyncImpl(options) {
        return $26667d8f94fef8a7$var$__awaiter(this, void 0, void 0, function*() {
            if (!$b4CpS.Storage.isReady()) yield $b4CpS.Storage.isReadyResolver();
            this._logger.start();
            return this.updateUserAsync(this._user, options);
        });
    }
    _createErrorUpdateDetails(error, startTime) {
        var _a;
        return (0, $b4CpS.createUpdateDetails)(false, this._store.getSource(), performance.now() - startTime, error, null, [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
    }
    _finalizeUpdate(values) {
        this._store.finalize();
        this._setStatus('Ready', values);
    }
    _runPostUpdate(current, user) {
        this.dataAdapter.getDataAsync(current, user, {
            priority: 'low'
        }).catch((err)=>{
            $b4CpS.Log.error('An error occurred after update.', err);
        });
    }
    _resetForUser(user) {
        this._logger.reset();
        this._store.reset();
        this._user = this._configureUser(user, this._options);
    }
    _configureUser(originalUser, options) {
        var _a, _b, _c;
        const user = (0, $b4CpS._normalizeUser)(originalUser, options);
        const stableIdOverride = (_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (stableIdOverride) {
            const readyPromise = (_c = (_b = this.storageProvider).isReadyResolver) === null || _c === void 0 ? void 0 : _c.call(_b);
            if (readyPromise) readyPromise.then(()=>$b4CpS.StableID.setOverride(stableIdOverride, this._sdkKey), ()=>$b4CpS.StableID.setOverride(stableIdOverride, this._sdkKey));
            else $b4CpS.StableID.setOverride(stableIdOverride, this._sdkKey);
        }
        // Only attach first touch metadata if it's not empty
        if (Object.keys(this._possibleFirstTouchMetadata).length > 0) user.analyticsOnlyMetadata = Object.assign(Object.assign({}, user.analyticsOnlyMetadata), this._possibleFirstTouchMetadata);
        return user;
    }
    _getFeatureGateImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getGate(name);
        const gate = (0, $b4CpS._makeFeatureGate)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getGateOverride) === null || _b === void 0 ? void 0 : _b.call(_a, gate, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : gate;
        this._enqueueExposure(name, (0, $b4CpS._createGateExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'gate_evaluation',
            gate: result
        });
        return result;
    }
    _getDynamicConfigImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const config = (0, $b4CpS._makeDynamicConfig)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getDynamicConfigOverride) === null || _b === void 0 ? void 0 : _b.call(_a, config, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : config;
        this._enqueueExposure(name, (0, $b4CpS._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'dynamic_config_evaluation',
            dynamicConfig: result
        });
        return result;
    }
    _getExperimentImpl(name, options) {
        var _a, _b, _c, _d;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const experiment = (0, $b4CpS._makeExperiment)(name, details, evaluation);
        if (experiment.__evaluation != null) experiment.__evaluation.secondary_exposures = (0, $b4CpS._mapExposures)((_b = (_a = experiment.__evaluation) === null || _a === void 0 ? void 0 : _a.secondary_exposures) !== null && _b !== void 0 ? _b : [], this._store.getExposureMapping());
        const overridden = (_d = (_c = this.overrideAdapter) === null || _c === void 0 ? void 0 : _c.getExperimentOverride) === null || _d === void 0 ? void 0 : _d.call(_c, experiment, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : experiment;
        this._enqueueExposure(name, (0, $b4CpS._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'experiment_evaluation',
            experiment: result
        });
        return result;
    }
    _getConfigListImpl() {
        return this._store.getConfigList();
    }
    _getLayerImpl(name, options) {
        var _a, _b, _c;
        const { result: evaluation, details: details } = this._store.getLayer(name);
        const layer = (0, $b4CpS._makeLayer)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getLayerOverride) === null || _b === void 0 ? void 0 : _b.call(_a, layer, this._user, options);
        if (options === null || options === void 0 ? void 0 : options.disableExposureLog) this._logger.incrementNonExposureCount(name);
        const result = (0, $b4CpS._mergeOverride)(layer, overridden, (_c = overridden === null || overridden === void 0 ? void 0 : overridden.__value) !== null && _c !== void 0 ? _c : layer.__value, (param)=>{
            if (options === null || options === void 0 ? void 0 : options.disableExposureLog) return;
            this._enqueueExposure(name, (0, $b4CpS._createLayerParameterExposure)(this._user, result, param, this._store.getExposureMapping()), options);
        });
        this.$emt({
            name: 'layer_evaluation',
            layer: result
        });
        return result;
    }
    _getParameterStoreImpl(name, options) {
        var _a, _b;
        const { result: configuration, details: details } = this._store.getParamStore(name);
        this._logger.incrementNonExposureCount(name);
        const paramStore = {
            name: name,
            details: details,
            __configuration: configuration,
            get: (0, $b349836f092d0a8d$exports._makeParamStoreGetter)(this, configuration, options)
        };
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getParamStoreOverride) === null || _b === void 0 ? void 0 : _b.call(_a, paramStore, options);
        if (overridden != null) {
            paramStore.__configuration = overridden.config;
            paramStore.details = overridden.details;
            paramStore.get = (0, $b349836f092d0a8d$exports._makeParamStoreGetter)(this, overridden.config, options);
        }
        return paramStore;
    }
    /**
     * StatsigClient constructor
     *
     * @param {string} sdkKey A Statsig client SDK key. eg "client-xyz123..."
     * @param {StatsigUser} user StatsigUser object containing various attributes related to a user.
     * @param {StatsigOptions | null} options StatsigOptions, used to customize the behavior of the SDK.
     */ constructor(sdkKey, user, options = null){
        var _a, _b;
        $b4CpS.SDKType._setClientType(sdkKey, 'javascript-client');
        const network = new $4c09e531f06eb601$exports.default(options, (e)=>{
            this.$emt(e);
        });
        super(sdkKey, (_a = options === null || options === void 0 ? void 0 : options.dataAdapter) !== null && _a !== void 0 ? _a : new $1d962d22bea1450c$exports.StatsigEvaluationsDataAdapter(), network, options);
        this._possibleFirstTouchMetadata = {};
        /**
         * Retrieves the value of a feature gate for the current user, represented as a {@link FeatureGate} object.
         *
         * @param {string} name - The name of the feature gate to retrieve.
         * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {FeatureGate} - The {@link FeatureGate} object representing the gate's current evaluation results for the user.
         */ this.getFeatureGate = this._memoize($b4CpS.MemoPrefix._gate, this._getFeatureGateImpl.bind(this));
        /**
         * Retrieves the value of a dynamic config for the current user.
         *
         * @param {string} name The name of the dynamic config to get.
         * @param {DynamicConfigEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {DynamicConfig} - The {@link DynamicConfig} object representing the dynamic configs's current evaluation results for the user.
         */ this.getDynamicConfig = this._memoize($b4CpS.MemoPrefix._dynamicConfig, this._getDynamicConfigImpl.bind(this));
        /**
         * Retrieves the value of a experiment for the current user.
         *
         * @param {string} name The name of the experiment to get.
         * @param {ExperimentEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Experiment} - The {@link Experiment} object representing the experiments's current evaluation results for the user.
         */ this.getExperiment = this._memoize($b4CpS.MemoPrefix._experiment, this._getExperimentImpl.bind(this));
        /**
         * Retrieves the list of all Dynamic Configs and Experiments for the current user.
         *
         * @returns {string[]} The list of all Dynamic Config and Experiment names for the current user. Note - these will be hashed unless you've disabled hashing.
         * This is intended to be used for debugging.
         */ this.getConfigList = this._memoize($b4CpS.MemoPrefix._configList, this._getConfigListImpl.bind(this));
        /**
         * Retrieves the value of a layer for the current user.
         *
         * @param {string} name The name of the layer to get.
         * @param {LayerEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Layer} - The {@link Layer} object representing the layers's current evaluation results for the user.
         */ this.getLayer = this._memoize($b4CpS.MemoPrefix._layer, this._getLayerImpl.bind(this));
        /**
         * Retrieves the value of a parameter store for the current user.
         *
         * @param {string} name The name of the parameter store to get.
         * @param {ParameterStoreEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {ParameterStore} - The {@link ParameterStore} object representing the parameter store's current mappings for the user.
         */ this.getParameterStore = this._memoize($b4CpS.MemoPrefix._paramStore, this._getParameterStoreImpl.bind(this));
        this._store = new $87efe29b203a82ac$exports.default(sdkKey);
        this._network = network;
        this._user = this._configureUser(user, options);
        this._sdkInstanceID = (0, $b4CpS.getUUID)();
        const plugins = (_b = options === null || options === void 0 ? void 0 : options.plugins) !== null && _b !== void 0 ? _b : [];
        for (const plugin of plugins)plugin.bind(this);
    }
}
$26667d8f94fef8a7$exports.default = $26667d8f94fef8a7$var$StatsigClient;


$a35cdd272375d707$exports.StatsigClient = $26667d8f94fef8a7$exports.default;

$a35cdd272375d707$var$__exportStar((parcelRequire("b4CpS")), $a35cdd272375d707$exports);
const $a35cdd272375d707$var$__STATSIG__ = Object.assign((0, (parcelRequire("b4CpS"))._getStatsigGlobal)(), {
    StatsigClient: $26667d8f94fef8a7$exports.default
});
$a35cdd272375d707$exports.default = $a35cdd272375d707$var$__STATSIG__;


var $4728f262d5068dc1$exports = {};
'use strict';
var $4728f262d5068dc1$var$has = Object.prototype.hasOwnProperty, $4728f262d5068dc1$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $4728f262d5068dc1$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $4728f262d5068dc1$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $4728f262d5068dc1$var$Events().__proto__) $4728f262d5068dc1$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $4728f262d5068dc1$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $4728f262d5068dc1$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $4728f262d5068dc1$var$EE(fn, context || emitter, once), evt = $4728f262d5068dc1$var$prefix ? $4728f262d5068dc1$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $4728f262d5068dc1$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $4728f262d5068dc1$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $4728f262d5068dc1$var$EventEmitter() {
    this._events = new $4728f262d5068dc1$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $4728f262d5068dc1$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($4728f262d5068dc1$var$has.call(events, name)) names.push($4728f262d5068dc1$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $4728f262d5068dc1$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $4728f262d5068dc1$var$prefix ? $4728f262d5068dc1$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $4728f262d5068dc1$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $4728f262d5068dc1$var$prefix ? $4728f262d5068dc1$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $4728f262d5068dc1$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $4728f262d5068dc1$var$prefix ? $4728f262d5068dc1$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $4728f262d5068dc1$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $4728f262d5068dc1$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $4728f262d5068dc1$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $4728f262d5068dc1$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $4728f262d5068dc1$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $4728f262d5068dc1$var$prefix ? $4728f262d5068dc1$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $4728f262d5068dc1$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $4728f262d5068dc1$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $4728f262d5068dc1$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $4728f262d5068dc1$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $4728f262d5068dc1$var$prefix ? $4728f262d5068dc1$var$prefix + event : event;
        if (this._events[evt]) $4728f262d5068dc1$var$clearEvent(this, evt);
    } else {
        this._events = new $4728f262d5068dc1$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$4728f262d5068dc1$var$EventEmitter.prototype.off = $4728f262d5068dc1$var$EventEmitter.prototype.removeListener;
$4728f262d5068dc1$var$EventEmitter.prototype.addListener = $4728f262d5068dc1$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$4728f262d5068dc1$var$EventEmitter.prefixed = $4728f262d5068dc1$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$4728f262d5068dc1$var$EventEmitter.EventEmitter = $4728f262d5068dc1$var$EventEmitter;
$4728f262d5068dc1$exports = $4728f262d5068dc1$var$EventEmitter;


const $0432dc905c88c02c$export$a66cbd9b2289cd78 = '@all-features';
class $0432dc905c88c02c$export$2e2bcd8739ae039 {
    onGateUpdated(gateName, callback, checkGate, options) {
        const value = checkGate(gateName, {
            ...options,
            fireGateExposure: false
        });
        if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
        const wrapCallback = ()=>{
            const value = checkGate(gateName, {
                ...options,
                fireGateExposure: false
            });
            const existingValue = this.eventToValue.get(callback);
            if (existingValue !== value) {
                this.eventToValue.set(callback, value);
                callback(value);
            }
        };
        this.emitter.on(gateName, wrapCallback);
        return ()=>{
            this.emitter.off(gateName, wrapCallback);
        };
    }
    onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
        const experimentEventName = `${experimentName}.${parameterName}`;
        const value = getExperimentValue(experimentName, parameterName, defaultValue, {
            ...options,
            fireExperimentExposure: false
        });
        if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
        const wrapCallback = ()=>{
            const value = getExperimentValue(experimentName, parameterName, defaultValue, {
                ...options,
                fireExperimentExposure: false
            });
            const existingValue = this.eventToValue.get(callback);
            if (existingValue !== value) {
                this.eventToValue.set(callback, value);
                callback(value);
            }
        };
        this.emitter.on(experimentEventName, wrapCallback);
        return ()=>{
            this.emitter.off(experimentEventName, wrapCallback);
        };
    }
    onAnyUpdated(callback) {
        this.emitter.on($0432dc905c88c02c$export$a66cbd9b2289cd78, callback);
        return ()=>{
            this.emitter.off($0432dc905c88c02c$export$a66cbd9b2289cd78, callback);
        };
    }
    anyUpdated() {
        this.emitter.emit($0432dc905c88c02c$export$a66cbd9b2289cd78);
        this.emitter.eventNames().filter((name)=>name !== $0432dc905c88c02c$export$a66cbd9b2289cd78).forEach((event)=>{
            this.emitter.emit(event);
        });
    }
    constructor(){
        this.emitter = void 0;
        this.eventToValue = new Map();
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($4728f262d5068dc1$exports)))();
    }
}


const $9ed82e71b49b09c9$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $9ed82e71b49b09c9$export$f005e2e9f707cb5f = 'commercial';
const $9ed82e71b49b09c9$export$bd6b5a7802d76127 = 'fedramp-fedex';
const $9ed82e71b49b09c9$export$a739cd5aac835909 = 'stg';
const $9ed82e71b49b09c9$export$42dd0cdd351a4a9 = 'prod';
const $9ed82e71b49b09c9$export$404582bc18fe4d9e = 'dev';


function $e37c8a0a11b4bd75$export$64d6499adf9b2e51() {
    const global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    const env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $9ed82e71b49b09c9$export$ce553301d55c2fd8);
    const matches = global.location?.hostname?.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}


// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $adc938401a9f9118$export$c62558b199e46828 = /*#__PURE__*/ function(EvaluationReason) {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    EvaluationReason["Error"] = "Error";
    EvaluationReason["LocalOverride"] = "LocalOverride";
    EvaluationReason["Unrecognized"] = "Unrecognized";
    EvaluationReason["Uninitialized"] = "Uninitialized";
    EvaluationReason["NetworkNotModified"] = "NetworkNotModified";
    EvaluationReason["Network"] = "Network";
    EvaluationReason["InvalidBootstrap"] = "InvalidBootstrap";
    EvaluationReason["Bootstrap"] = "Bootstrap";
    EvaluationReason["Cache"] = "Cache";
    // For when we could not migrate the reason from the new client
    EvaluationReason["Unknown"] = "Unknown";
    return EvaluationReason;
}({});


var $b0b67edccf7bb11b$export$479e7351a733299 = /*#__PURE__*/ function(FeatureGateEnvironment) {
    FeatureGateEnvironment["Development"] = "development";
    FeatureGateEnvironment["Staging"] = "staging";
    FeatureGateEnvironment["Production"] = "production";
    return FeatureGateEnvironment;
}({});
var $b0b67edccf7bb11b$export$c42b7bbc5e7ba555 = /*#__PURE__*/ function(PerimeterType) {
    PerimeterType["COMMERCIAL"] = "commercial";
    PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    return PerimeterType;
}({});
const $b0b67edccf7bb11b$export$42f4885608027d0c = 'non_boolean';


const $891608fc6585360f$export$d119b37e5f788b43 = (options)=>({
        /**
	 * If more federal PerimeterTypes are added in the future, this should be updated so
	 * that isFedRamp() === true always returns the strictest perimeter.
	 */ perimeter: (0, $e37c8a0a11b4bd75$export$64d6499adf9b2e51)() ? (0, $b0b67edccf7bb11b$export$c42b7bbc5e7ba555).FEDRAMP_MODERATE : (0, $b0b67edccf7bb11b$export$c42b7bbc5e7ba555).COMMERCIAL,
        ...options
    });
const $891608fc6585360f$export$fa1c2bbf4100b8bc = (objectA, objectB)=>{
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    const aEntries = Object.entries(objectA);
    const bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    const ascendingKeyOrder = ([key1], [key2])=>key1.localeCompare(key2);
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(let i = 0; i < aEntries.length; i++){
        const [, aValue] = aEntries[i];
        const [, bValue] = bEntries[i];
        if (aValue !== bValue) return false;
    }
    return true;
};
const $891608fc6585360f$export$3dad1db244472f32 = (identifiers, customAttributes)=>{
    const user = {
        customIDs: identifiers,
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
const $891608fc6585360f$export$202946b690d26d22 = (options)=>{
    const { api: api, disableCurrentPageLogging: disableCurrentPageLogging, loggingIntervalMillis: loggingIntervalMillis, loggingBufferMaxSize: loggingBufferMaxSize, localMode: localMode, eventLoggingApi: eventLoggingApi, eventLoggingApiForRetries: eventLoggingApiForRetries, disableLocalStorage: disableLocalStorage, ignoreWindowUndefined: ignoreWindowUndefined, disableAllLogging: disableAllLogging, // No equivalent but is pointless anyway since our Statsig init is synchronous
    initTimeoutMs: _initTimeoutMs, // No equivalent in new client but probably not important?
    disableNetworkKeepalive: _disableNetworkKeepalive, // Needs to be implemented manually but unused according to zoekt
    overrideStableID: _overrideStableID, // No equivalent for these but can't see them actually used anywhere in old client?
    disableErrorLogging: _disableErrorLogging, disableAutoMetricsLogging: _disableAutoMetricsLogging, ...rest } = options;
    return {
        ...rest,
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    };
};
const $891608fc6585360f$var$evaluationReasonMappings = Object.entries((0, $adc938401a9f9118$export$c62558b199e46828)).map(([key, value])=>[
        key.toLowerCase(),
        value
    ]);
const $891608fc6585360f$export$18ad168d3dbac899 = (details)=>{
    const reasonLower = details.reason.toLowerCase();
    return {
        reason: $891608fc6585360f$var$evaluationReasonMappings.find(([key])=>reasonLower.includes(key))?.[1] ?? (0, $adc938401a9f9118$export$c62558b199e46828).Unknown,
        time: details.receivedAt ?? Date.now()
    };
};
const $891608fc6585360f$export$55fd683752d01e67 = (secondaryExposures)=>{
    return secondaryExposures.map((exposure)=>{
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};


class $784663aa78b9703e$export$6dc24881a3d96325 {
    static fromExperiment(experiment) {
        const config = new $784663aa78b9703e$export$6dc24881a3d96325(experiment.name, experiment.value, experiment.ruleID, (0, $891608fc6585360f$export$18ad168d3dbac899)(experiment.details), (0, $891608fc6585360f$export$55fd683752d01e67)(experiment.__evaluation?.secondary_exposures ?? []), experiment.groupName ?? undefined);
        config.experiment = experiment;
        return config;
    }
    get(key, defaultValue, typeGuard) {
        const val = this.getValue(key, defaultValue);
        if (val == null) return defaultValue;
        const expectedType = Array.isArray(defaultValue) ? 'array' : typeof defaultValue;
        const actualType = Array.isArray(val) ? 'array' : typeof val;
        if (typeGuard) {
            if (typeGuard(val)) {
                this.fireExposure(key);
                return val;
            }
            this._onDefaultValueFallback?.(this, key, expectedType, actualType);
            return defaultValue;
        }
        if (defaultValue == null || expectedType === actualType) {
            this.fireExposure(key);
            return val;
        }
        this._onDefaultValueFallback?.(this, key, expectedType, actualType);
        return defaultValue;
    }
    getValue(key, defaultValue) {
        if (key == null) return this.value;
        if (defaultValue == null) defaultValue = null;
        if (this.value[key] == null) return defaultValue;
        this.fireExposure(key);
        return this.value[key];
    }
    fireExposure(key) {
        // Call the wrapped experiment's get method to fire exposure
        if (this.experiment) this.experiment.get(key);
    }
    constructor(configName, configValue, ruleID, evaluationDetails, secondaryExposures = [], allocatedExperimentName = '', onDefaultValueFallback = null){
        this.value = void 0;
        this._name = void 0;
        this._ruleID = void 0;
        /** @deprecated - do not use, this is still exported for backwards compatibility but will be removed in the next major version  */ this._secondaryExposures = void 0;
        this._allocatedExperimentName = void 0;
        this._evaluationDetails = void 0;
        this._onDefaultValueFallback = void 0;
        this.experiment = void 0;
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
}



class $89727d6d3bb2155d$export$936d0764594b6eb3 {
    static fromLayer(layer) {
        const value = new $89727d6d3bb2155d$export$936d0764594b6eb3(layer.name, layer.__value, layer.ruleID, (0, $891608fc6585360f$export$18ad168d3dbac899)(layer.details), (_layer, parameterName)=>layer.get(parameterName), (0, $891608fc6585360f$export$55fd683752d01e67)(layer.__evaluation?.secondary_exposures ?? []), (0, $891608fc6585360f$export$55fd683752d01e67)(layer.__evaluation?.undelegated_secondary_exposures ?? []), layer.__evaluation?.allocated_experiment_name, layer.__evaluation?.explicit_parameters);
        return value;
    }
    get(key, defaultValue, typeGuard) {
        const val = this._value[key];
        if (val == null) return defaultValue;
        const logAndReturn = ()=>{
            this._logLayerParameterExposure(key);
            return val;
        };
        if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
        if (defaultValue == null) return logAndReturn();
        if (typeof val === typeof defaultValue && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
        return defaultValue;
    }
    getValue(key, defaultValue) {
        // eslint-disable-next-line eqeqeq
        if (defaultValue == undefined) defaultValue = null;
        const val = this._value[key];
        if (val != null) this._logLayerParameterExposure(key);
        return val ?? defaultValue;
    }
    _logLayerParameterExposure(parameterName) {
        this._logParameterFunction?.(this, parameterName);
    }
    constructor(name, layerValue, ruleID, evaluationDetails, logParameterFunction = null, secondaryExposures = [], undelegatedSecondaryExposures = [], allocatedExperimentName = '', explicitParameters = []){
        this._name = void 0;
        this._value = void 0;
        this._ruleID = void 0;
        /** @deprecated - do not use, this is still exported for backwards compatibility but will be removed in the next major version  */ this._secondaryExposures = void 0;
        /** @deprecated - do not use, this is still exported for backwards compatibility but will be removed in the next major version  */ this._undelegatedSecondaryExposures = void 0;
        this._allocatedExperimentName = void 0;
        this._explicitParameters = void 0;
        this._evaluationDetails = void 0;
        this._logParameterFunction = void 0;
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue ?? {}));
        this._ruleID = ruleID ?? '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
}




/// <reference types="node" />
const $09266364ca7f9e0f$export$a59f8d67326bd1cb = "0.0.0-use.local";


class $a20b2f6a19567ed0$export$286baf652d0b1206 extends Error {
    constructor(message){
        super(message);
    }
}


const $3f3d8d5a5fb9a7cc$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
const $3f3d8d5a5fb9a7cc$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
const $3f3d8d5a5fb9a7cc$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
const $3f3d8d5a5fb9a7cc$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
const $3f3d8d5a5fb9a7cc$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
const $3f3d8d5a5fb9a7cc$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
const $3f3d8d5a5fb9a7cc$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
const $3f3d8d5a5fb9a7cc$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
const $3f3d8d5a5fb9a7cc$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
const $3f3d8d5a5fb9a7cc$export$450bd8fb2a6d7ace = '/gateway/api/flags';
class $3f3d8d5a5fb9a7cc$export$2e2bcd8739ae039 {
    static async fetchClientSdk(fetcherOptions) {
        const { targetApp: targetApp } = fetcherOptions;
        const url = `/api/v2/frontend/clientSdkKey/${targetApp}`;
        try {
            return await this.fetchRequest(url, 'GET', fetcherOptions);
        } catch (error) {
            if (error instanceof Error) throw error;
            throw Error('Failed to retrieve client sdk key');
        }
    }
    static async fetchExperimentValues(fetcherOptions, identifiers, customAttributes) {
        const requestBody = {
            identifiers: identifiers,
            customAttributes: customAttributes,
            targetApp: fetcherOptions.targetApp
        };
        try {
            return await this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
        } catch (error) {
            if (error instanceof Error) throw error;
            throw Error('Failed to retrieve experiment values');
        }
    }
    static async handleResponseError(response) {
        if (!response.ok) {
            // Use text() instead of json() as the error body might not be json data
            const body = await response.text();
            throw new (0, $a20b2f6a19567ed0$export$286baf652d0b1206)(`Non 2xx response status received, status: ${response.status}, body: ${JSON.stringify(body)}`);
        }
        if (response.status === 204) throw new (0, $a20b2f6a19567ed0$export$286baf652d0b1206)('Unexpected 204 response');
    }
    static async extractResponseBody(response) {
        const value = await response.text();
        return JSON.parse(value);
    }
    static getBaseUrl(serviceEnv, useGatewayUrl = false, perimeter, isolationContextId = null) {
        if (useGatewayUrl) return $3f3d8d5a5fb9a7cc$export$450bd8fb2a6d7ace;
        if (perimeter === (0, $b0b67edccf7bb11b$export$c42b7bbc5e7ba555).FEDRAMP_MODERATE) switch(serviceEnv){
            case (0, $b0b67edccf7bb11b$export$479e7351a733299).Production:
                return $3f3d8d5a5fb9a7cc$export$18c93900db9358a4;
            case (0, $b0b67edccf7bb11b$export$479e7351a733299).Staging:
                return $3f3d8d5a5fb9a7cc$export$1a401a0da8da3565;
            default:
                throw new Error(`Invalid environment "${serviceEnv}" for "${perimeter}" perimeter`);
        }
        else if (perimeter === (0, $b0b67edccf7bb11b$export$c42b7bbc5e7ba555).COMMERCIAL) switch(serviceEnv){
            case (0, $b0b67edccf7bb11b$export$479e7351a733299).Development:
                return $3f3d8d5a5fb9a7cc$export$f058dbf75c3bc647;
            case (0, $b0b67edccf7bb11b$export$479e7351a733299).Staging:
                const apiUrl = this.getApiUrl(isolationContextId);
                if (apiUrl !== null) return apiUrl;
                return $3f3d8d5a5fb9a7cc$export$942ba04389b0d5a2;
            default:
                const prodApiUrl = this.getApiUrl(isolationContextId);
                if (prodApiUrl !== null) return prodApiUrl;
                return $3f3d8d5a5fb9a7cc$export$250a58ecde616daa;
        }
        else throw new Error(`Invalid perimeter "${perimeter}"`);
    }
    static async fetchRequest(path, method, fetcherOptions, body) {
        const baseUrl = $3f3d8d5a5fb9a7cc$export$2e2bcd8739ae039.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
        const fetchTimeout = fetcherOptions.fetchTimeoutMs || $3f3d8d5a5fb9a7cc$var$DEFAULT_REQUEST_TIMEOUT_MS;
        let abortSignal;
        if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
        else if (AbortController) {
            const abortController = new AbortController();
            abortSignal = abortController.signal;
            setTimeout(()=>abortController.abort(), fetchTimeout);
        }
        const response = await fetch(`${baseUrl}${path}`, {
            method: method,
            headers: {
                'Content-Type': 'application/json',
                'X-Client-Name': 'feature-gate-js-client',
                'X-Client-Version': (0, $09266364ca7f9e0f$export$a59f8d67326bd1cb),
                'X-API-KEY': fetcherOptions.apiKey
            },
            signal: abortSignal,
            ...body && {
                body: JSON.stringify(body)
            }
        });
        await this.handleResponseError(response);
        return await this.extractResponseBody(response);
    }
    static getApiUrl(isolationContextId) {
        const window1 = this.getWindowLocation();
        if (window1 === undefined) {
            //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
            if (!isolationContextId) return null;
            return $3f3d8d5a5fb9a7cc$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
        }
        const { protocol: protocol, hostname: hostname } = window1;
        // Match last subdomain fragment before oasis-stg.com
        const oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
        if (oasisMatch) return `${protocol}//api.${oasisMatch[1]}.${$3f3d8d5a5fb9a7cc$export$cb3cd156f70d7e94}`;
        // Match last subdomain fragment before atlassian-isolated.net
        const isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
        if (isolatedMatch) return `${protocol}//api.${isolatedMatch[1]}.${$3f3d8d5a5fb9a7cc$export$921fbc6cdfd4eee0}`;
        return null;
    }
    static getWindowLocation() {
        if (typeof window !== 'undefined' && window.location) return window.location;
        return undefined;
    }
}



class $492410a8ef69a013$export$55fffef3474104af extends (0, $a35cdd272375d707$exports.DataAdapterCore) {
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ setBootstrapData(data) {
        this.bootstrapResult = data ? {
            source: 'Bootstrap',
            data: JSON.stringify(data),
            receivedAt: Date.now(),
            stableID: (0, $a35cdd272375d707$exports.StableID).get(this._getSdkKey()),
            fullUserHash: null
        } : null;
    }
    async prefetchData(_user, _options) {}
    async getDataAsync(_current, user, _options) {
        return this.bootstrapResult && {
            ...this.bootstrapResult,
            fullUserHash: (0, $a35cdd272375d707$exports._getFullUserHash)(user)
        };
    }
    getDataSync(user) {
        return this.bootstrapResult && {
            ...this.bootstrapResult,
            fullUserHash: (0, $a35cdd272375d707$exports._getFullUserHash)(user)
        };
    }
    async _fetchFromNetwork(_current, _user, _options) {
        return null;
    }
    _getCacheKey(user) {
        // Same logic as default data adapter
        // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
        const key = (0, $a35cdd272375d707$exports._getStorageKey)(this._getSdkKey(), user);
        return `${0, $a35cdd272375d707$exports.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(_result, _user) {
        return false;
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    // Do not stringify options property since that includes this adapter and will
    // cause a circular reference when Statsig sends diagnostic events and including
    // values is not necessary and makes the result huge
    toJSON() {
        const result = {
            ...this
        };
        delete result._options;
        delete result._inMemoryCache;
        delete result.bootstrapResult;
        return result;
    }
    constructor(){
        super('NoFetchDataAdapter', 'nofetch');
        this.bootstrapResult = null;
    }
}



var $b4CpS = parcelRequire("b4CpS");
const $4a1f2f0dcf00585b$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
const $4a1f2f0dcf00585b$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
const $4a1f2f0dcf00585b$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
const $4a1f2f0dcf00585b$var$makeEmptyStore = ()=>({
        gates: {},
        configs: {},
        layers: {}
    });
const $4a1f2f0dcf00585b$var$djb2MapKey = (hash, kind)=>kind + ':' + hash;
class $4a1f2f0dcf00585b$export$bcb28fbac1def494 {
    parseStoredOverrides(localStorageKey) {
        try {
            const json = window.localStorage.getItem(localStorageKey);
            if (!json) return $4a1f2f0dcf00585b$var$makeEmptyStore();
            return JSON.parse(json);
        } catch  {
            return $4a1f2f0dcf00585b$var$makeEmptyStore();
        }
    }
    mergeOverrides(...allOverrides) {
        const merged = $4a1f2f0dcf00585b$var$makeEmptyStore();
        for (const overrides of allOverrides){
            for (const [name, value] of Object.entries(overrides.gates ?? {}))merged.gates[name] = value;
            for (const [name, value] of Object.entries(overrides.configs ?? {}))merged.configs[name] = value;
            for (const [name, value] of Object.entries(overrides.layers ?? {}))merged.layers[name] = value;
        }
        return merged;
    }
    initFromStoredOverrides() {
        const storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($4a1f2f0dcf00585b$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
        // Clear data from legacy local storage key now we've read from it.
        // This prevents things being stuck in there that are always read but never written to.
        try {
            window.localStorage.removeItem($4a1f2f0dcf00585b$var$LEGACY_LOCAL_STORAGE_KEY);
        } catch  {
        // ignored - window is not defined in non-browser environments, and we don't save things there
        // (things like SSR, etc)
        }
        // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
        // multiple hashes to continue being created. This code here removes these hashes since we've moved
        // to using a more reliable and easier to maintain map in `_djb2Map`.
        for (const container of Object.values(storedOverrides)){
            const allKeys = new Set(Object.keys(container));
            for (const name of allKeys){
                const hash = (0, $b4CpS._DJB2)(name);
                if (allKeys.has(hash)) delete container[hash];
            }
        }
        this.applyOverrides(storedOverrides);
    }
    saveOverrides() {
        try {
            window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
        } catch  {
        // ignored - window is not defined in non-browser environments, and we don't save things there
        // (things like SSR, etc)
        }
    }
    getOverrides() {
        return this.mergeOverrides(this._overrides);
    }
    applyOverrides(overrides) {
        const newOverrides = {
            ...$4a1f2f0dcf00585b$var$makeEmptyStore(),
            ...overrides
        };
        this._djb2Map.clear();
        for (const [containerName, container] of Object.entries(newOverrides))for (const [name, value] of Object.entries(container))this._djb2Map.set($4a1f2f0dcf00585b$var$djb2MapKey((0, $b4CpS._DJB2)(name), containerName), value);
        this._overrides = newOverrides;
    }
    setOverrides(overrides) {
        this.applyOverrides(overrides);
        this.saveOverrides();
    }
    overrideGate(name, value) {
        this._overrides.gates[name] = value;
        this._djb2Map.set($4a1f2f0dcf00585b$var$djb2MapKey((0, $b4CpS._DJB2)(name), 'gates'), value);
        this.saveOverrides();
    }
    removeGateOverride(name) {
        delete this._overrides.gates[name];
        this._djb2Map.delete($4a1f2f0dcf00585b$var$djb2MapKey((0, $b4CpS._DJB2)(name), 'gates'));
        this.saveOverrides();
    }
    getGateOverride(current, _user) {
        const overridden = this._overrides.gates[current.name] ?? this._djb2Map.get($4a1f2f0dcf00585b$var$djb2MapKey(current.name, 'gates'));
        if (overridden == null) return null;
        return {
            ...current,
            value: overridden,
            details: {
                ...current.details,
                reason: $4a1f2f0dcf00585b$var$LOCAL_OVERRIDE_REASON
            }
        };
    }
    overrideDynamicConfig(name, value) {
        this._overrides.configs[name] = value;
        this._djb2Map.set($4a1f2f0dcf00585b$var$djb2MapKey((0, $b4CpS._DJB2)(name), 'configs'), value);
        this.saveOverrides();
    }
    removeDynamicConfigOverride(name) {
        delete this._overrides.configs[name];
        this._djb2Map.delete($4a1f2f0dcf00585b$var$djb2MapKey((0, $b4CpS._DJB2)(name), 'configs'));
        this.saveOverrides();
    }
    getDynamicConfigOverride(current, _user) {
        return this._getConfigOverride(current, this._overrides.configs);
    }
    overrideExperiment(name, value) {
        this._overrides.configs[name] = value;
        this._djb2Map.set($4a1f2f0dcf00585b$var$djb2MapKey((0, $b4CpS._DJB2)(name), 'configs'), value);
        this.saveOverrides();
    }
    removeExperimentOverride(name) {
        delete this._overrides.configs[name];
        this._djb2Map.delete($4a1f2f0dcf00585b$var$djb2MapKey((0, $b4CpS._DJB2)(name), 'configs'));
        this.saveOverrides();
    }
    getExperimentOverride(current, _user) {
        return this._getConfigOverride(current, this._overrides.configs);
    }
    overrideLayer(name, value) {
        this._overrides.layers[name] = value;
        this._djb2Map.set($4a1f2f0dcf00585b$var$djb2MapKey((0, $b4CpS._DJB2)(name), 'layers'), value);
        this.saveOverrides();
    }
    removeLayerOverride(name) {
        delete this._overrides.layers[name];
        this._djb2Map.delete($4a1f2f0dcf00585b$var$djb2MapKey((0, $b4CpS._DJB2)(name), 'layers'));
        this.saveOverrides();
    }
    removeAllOverrides() {
        this._overrides = $4a1f2f0dcf00585b$var$makeEmptyStore();
        try {
            window.localStorage.removeItem(this._localStorageKey);
        } catch  {
        // ignored - window is not defined in non-browser environments, and we don't save things there
        // (things like SSR, etc)
        }
    }
    getLayerOverride(current, _user) {
        const overridden = this._overrides.layers[current.name] ?? this._djb2Map.get($4a1f2f0dcf00585b$var$djb2MapKey(current.name, 'layers'));
        if (overridden == null) return null;
        return {
            ...current,
            __value: overridden,
            get: (0, $b4CpS._makeTypedGet)(current.name, overridden),
            details: {
                ...current.details,
                reason: $4a1f2f0dcf00585b$var$LOCAL_OVERRIDE_REASON
            }
        };
    }
    _getConfigOverride(current, lookup) {
        const overridden = lookup[current.name] ?? this._djb2Map.get($4a1f2f0dcf00585b$var$djb2MapKey(current.name, 'configs'));
        if (overridden == null) return null;
        return {
            ...current,
            value: overridden,
            get: (0, $b4CpS._makeTypedGet)(current.name, overridden),
            details: {
                ...current.details,
                reason: $4a1f2f0dcf00585b$var$LOCAL_OVERRIDE_REASON
            }
        };
    }
    constructor(localStorageKey){
        this._overrides = void 0;
        this._localStorageKey = void 0;
        this._djb2Map = void 0;
        this._overrides = $4a1f2f0dcf00585b$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
}





const $943cf535bd11de3f$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
const $943cf535bd11de3f$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
class $943cf535bd11de3f$export$1f2bb630327ac4b6 {
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ async initialize(clientOptions, identifiers, customAttributes) {
        const clientOptionsWithDefaults = (0, $891608fc6585360f$export$d119b37e5f788b43)(clientOptions);
        if (this.initPromise) {
            if (!(0, $891608fc6585360f$export$fa1c2bbf4100b8bc)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return this.initPromise;
        }
        const startTime = performance.now();
        this.initOptions = clientOptionsWithDefaults;
        this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(()=>{
            this.initCompleted = true;
            this.initWithDefaults = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            this.fireClientEvent(startTime, totalTime, 'initialize', this.initCompleted, clientOptionsWithDefaults.apiKey);
        });
        return this.initPromise;
    }
    /**
   * @description
   * This method initializes the client using the provider given to call to fetch the bootstrap values.
   * If the client is initialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param provider {Provider}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ async initializeWithProvider(clientOptions, provider, identifiers, customAttributes) {
        const clientOptionsWithDefaults = (0, $891608fc6585360f$export$d119b37e5f788b43)(clientOptions);
        if (this.initPromise) {
            if (!(0, $891608fc6585360f$export$fa1c2bbf4100b8bc)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return this.initPromise;
        }
        const startTime = performance.now();
        this.initOptions = clientOptionsWithDefaults;
        this.provider = provider;
        this.provider.setClientVersion((0, $09266364ca7f9e0f$export$a59f8d67326bd1cb));
        if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
        this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(()=>{
            this.initCompleted = true;
            this.initWithDefaults = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            this.fireClientEvent(startTime, totalTime, 'initializeWithProvider', this.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
        });
        return this.initPromise;
    }
    applyUpdateCallback(experimentsResult) {
        try {
            if (this.initCompleted || this.initWithDefaults) {
                this.assertInitialized(this.statsigClient);
                this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                this.statsigValuesUpdated();
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn('Error when attempting to apply update', error);
        }
    }
    fireClientEvent(startTime, totalTime, action, success, apiKey) {
        this.initOptions.analyticsWebClient?.then((analyticsWebClient)=>{
            const attributes = {
                targetApp: this.initOptions.targetApp,
                clientVersion: (0, $09266364ca7f9e0f$export$a59f8d67326bd1cb),
                success: success,
                startTime: startTime,
                totalTime: totalTime,
                ...apiKey && {
                    apiKey: apiKey
                }
            };
            analyticsWebClient.sendOperationalEvent({
                action: action,
                actionSubject: 'featureGatesClient',
                attributes: attributes,
                tags: [
                    'measurement'
                ],
                source: '@atlaskit/feature-gate-js-client'
            });
        }).catch((err)=>{
            if (this.initOptions.environment !== (0, $b0b67edccf7bb11b$export$479e7351a733299).Production) // eslint-disable-next-line no-console
            console.error('Analytics web client promise did not resolve', err);
        });
    }
    async initializeFromValues(clientOptions, identifiers, customAttributes, initializeValues = {}) {
        const clientOptionsWithDefaults = (0, $891608fc6585360f$export$d119b37e5f788b43)(clientOptions);
        if (this.initPromise) {
            if (!(0, $891608fc6585360f$export$fa1c2bbf4100b8bc)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return this.initPromise;
        }
        // This makes sure the new Statsig client behaves like the old when bootstrap data is
        // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
        if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
        const startTime = performance.now();
        this.initOptions = clientOptionsWithDefaults;
        this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(()=>{
            this.initCompleted = true;
            this.initWithDefaults = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            this.fireClientEvent(startTime, totalTime, 'initializeFromValues', this.initCompleted);
        });
        return this.initPromise;
    }
    assertInitialized(statsigClient) {
        if (!statsigClient) throw new Error('Client must be initialized before using this method');
    }
    /**
   * This method updates the user using a network call to fetch the new set of values.
   * @param fetchOptions {FetcherOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   */ async updateUser(fetchOptions, identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        const fetchOptionsWithDefaults = (0, $891608fc6585360f$export$d119b37e5f788b43)(fetchOptions);
        const initializeValuesProducer = ()=>(0, $3f3d8d5a5fb9a7cc$export$2e2bcd8739ae039).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(({ experimentValues: experimentValues, customAttributes: customAttributes })=>({
                    experimentValues: experimentValues,
                    customAttributesFromFetch: customAttributes
                }));
        await this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
    }
    /**
   * This method updates the user using the provider given on initialisation to get the new set of
   * values.
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   */ async updateUserWithProvider(identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        if (!this.provider) throw new Error('Cannot update user using provider as the client was not initialised with a provider');
        await this.provider.setProfile(this.initOptions, identifiers, customAttributes);
        await this.updateUserUsingInitializeValuesProducer(()=>this.provider.getExperimentValues(), identifiers, customAttributes);
    }
    /**
   * This method updates the user given a new set of bootstrap values obtained from one of the
   * server-side SDKs.
   *
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @param initializeValues {Record<string,unknown>}
   */ async updateUserWithValues(identifiers, customAttributes, initializeValues = {}) {
        this.assertInitialized(this.statsigClient);
        const initializeValuesProducer = ()=>Promise.resolve({
                experimentValues: initializeValues,
                customAttributesFromFetch: customAttributes
            });
        await this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
    }
    initializeCalled() {
        return this.initPromise != null;
    }
    initializeCompleted() {
        return this.initCompleted;
    }
    async waitUntilInitializeCompleted() {
        if (!this.initPromise) throw new Error('The client must be initialized before you can wait until initialized.');
        if (this.initCompleted) return;
        await this.initPromise;
    }
    /**
   * Returns the value for a feature gate. Returns false if there are errors.
   * @param {string} gateName - The name of the feature gate.
   * @param {Object} options
   * @param {boolean} options.fireGateExposure
   *        Whether or not to fire the exposure event for the gate. Defaults to true.
   *        To log an exposure event manually at a later time, use {@link Client.manuallyLogGateExposure}
   *        (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   */ checkGate(gateName, options = {}) {
        try {
            this.assertInitialized(this.statsigClient);
            const { fireGateExposure: fireGateExposure = true } = options;
            return this.statsigClient.checkGate(gateName, {
                disableExposureLog: !fireGateExposure
            });
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasCheckGateErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                    gateName: gateName,
                    error: error
                });
                this.hasCheckGateErrorOccurred = true;
            }
            return false;
        }
    }
    isGateExist(gateName) {
        try {
            this.assertInitialized(this.statsigClient);
            const gate = this.statsigClient.getFeatureGate(gateName, {
                disableExposureLog: true
            });
            return !gate.details.reason.includes('Unrecognized');
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to check FeatureGate: ${error}`);
            // in case of error report true to avoid false positives.
            return true;
        }
    }
    isExperimentExist(experimentName) {
        try {
            this.assertInitialized(this.statsigClient);
            const config = this.statsigClient.getExperiment(experimentName, {
                disableExposureLog: true
            });
            return !config.details.reason.includes('Unrecognized');
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to check Experiment: ${error}`);
            // in case of error report true to avoid false positives.
            return true;
        }
    }
    /**
   * Manually log a gate exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * This is useful if you have evaluated a gate earlier via {@link Client.checkGate} where
   * <code>options.fireGateExposure</code> is false.
   * @param gateName
   */ manuallyLogGateExposure(gateName) {
        this.assertInitialized(this.statsigClient);
        // This is the approach recommended in the docs
        // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
        this.statsigClient.checkGate(gateName);
    }
    /**
   * Returns the entire config for a given experiment.
   *
   * @param {string} experimentName - The name of the experiment
   * @param {Object} options
   * @param {boolean} options.fireExperimentExposure - Whether or not to fire the exposure event
   * for the experiment. Defaults to true. To log an exposure event manually at a later time, use
   * {@link Client.manuallyLogExperimentExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * @returns The config for an experiment
   * @example
   * ```ts
   * const experimentConfig = client.getExperiment('example-experiment-name');
   * const backgroundColor: string = experimentConfig.get('backgroundColor', 'yellow');
   * ```
   */ getExperiment(experimentName, options = {}) {
        try {
            this.assertInitialized(this.statsigClient);
            const { fireExperimentExposure: fireExperimentExposure = true } = options;
            return (0, $784663aa78b9703e$export$6dc24881a3d96325).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                disableExposureLog: !fireExperimentExposure
            }));
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetExperimentErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                    experimentName: experimentName,
                    error: error
                });
                this.hasGetExperimentErrorOccurred = true;
            }
            // Return a default value
            return new (0, $784663aa78b9703e$export$6dc24881a3d96325)(experimentName, {}, '', {
                time: Date.now(),
                reason: (0, $adc938401a9f9118$export$c62558b199e46828).Error
            });
        }
    }
    /**
   * Returns the value of a given parameter in an experiment config.
   *
   * @template T
   * @param {string} experimentName - The name of the experiment
   * @param {string} parameterName - The name of the parameter to fetch from the experiment config
   * @param {T} defaultValue - The value to serve if the experiment or parameter do not exist, or
   * if the returned value does not match the expected type.
   * @param {Object} options
   * @param {boolean} options.fireExperimentExposure - Whether or not to fire the exposure event
   * for the experiment. Defaults to true. To log an exposure event manually at a later time, use
   * {@link Client.manuallyLogExperimentExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-))
   * @param {function} options.typeGuard - A function that asserts that the return value has the
   * expected type. If this function returns false, then the default value will be returned
   * instead. This can be set to protect your code from unexpected values being set remotely. By
   * default, this will be done by asserting that the default value and value are the same primitive
   * type.
   * @returns The value of the parameter if the experiment and parameter both exist, otherwise the
   * default value.
   * @example
   ``` ts
   type ValidColor = 'blue' | 'red' | 'yellow';
   type ValidColorTypeCheck = (value: unknown) => value is ValidColor;
  	 const isValidColor: ValidColorTypeCheck =
  		(value: unknown) => typeof value === 'string' && ['blue', 'red', 'yellow'].includes(value);
  	 const buttonColor: ValidColor = client.getExperimentValue(
  		'example-experiment-name',
  		'backgroundColor',
  		'yellow',
  		{
  				typeGuard: isValidColor
  		}
   );
   ```
  */ getExperimentValue(experimentName, parameterName, defaultValue, options = {}) {
        const experiment = this.getExperiment(experimentName, options);
        try {
            const { typeGuard: typeGuard } = options;
            return experiment.get(parameterName, defaultValue, typeGuard);
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetExperimentValueErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                    experimentName: experimentName,
                    defaultValue: defaultValue,
                    options: options,
                    error: error
                });
                this.hasGetExperimentValueErrorOccurred = true;
            }
            return defaultValue;
        }
    }
    /**
   * Manually log an experiment exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * This is useful if you have evaluated an experiment earlier via {@link Client.getExperimentValue} or
   * {@link Client.getExperiment} where <code>options.fireExperimentExposure</code> is false.
   * @param experimentName
   */ manuallyLogExperimentExposure(experimentName) {
        this.assertInitialized(this.statsigClient);
        // This is the approach recommended in the docs
        // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
        this.statsigClient.getExperiment(experimentName);
    }
    /**
   * Manually log a layer exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * This is useful if you have evaluated a layer earlier via {@link Client.getLayerValue} where <code>options.fireExperimentExposure</code> is false.
   * @param layerName
   * @param parameterName
   */ manuallyLogLayerExposure(layerName, parameterName) {
        this.assertInitialized(this.statsigClient);
        // This is the approach recommended in the docs
        // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
        this.statsigClient.getLayer(layerName)?.get(parameterName);
    }
    shutdownStatsig() {
        this.assertInitialized(this.statsigClient);
        this.statsigClient.shutdown();
    }
    /**
   * Adds a new override for the given gate.
   *
   * This method is additive, meaning you can call it multiple times with different gate names to
   * build your full set of overrides.
   *
   * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
   * will continue to affect every client that is initialized on the same domain after this method
   * is called. If you are using this API for testing purposes, you should call
   * {@link Client.clearGateOverride} after your tests are completed to remove this
   * localStorage entry.
   *
   * @param {string} gateName
   * @param {boolean} value
   */ overrideGate(gateName, value) {
        this.overrideAdapter.overrideGate(gateName, value);
        // Trigger a reset of the memoized gate value
        if (this.user) this.statsigClient?.updateUserSync(this.user, {
            disableBackgroundCacheRefresh: true
        });
        this.statsigValuesUpdated();
    }
    /**
   * Removes any overrides that have been set for the given gate.
   */ clearGateOverride(gateName) {
        this.overrideAdapter.removeGateOverride(gateName);
        this.statsigValuesUpdated();
    }
    /**
   * Adds a new override for the given config (or experiment).
   *
   * This method is additive, meaning you can call it multiple times with different experiment
   * names to build your full set of overrides.
   *
   * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
   * will continue to affect every client that is initialized on the same domain after this method
   * is called. If you are using this API for testing purposes, you should call
   * {@link Client.clearConfigOverride} after your tests are completed to remove this
   * localStorage entry.
   *
   * @param {string} experimentName
   * @param {object} values
   */ overrideConfig(experimentName, values) {
        this.overrideAdapter.overrideDynamicConfig(experimentName, values);
        this.statsigValuesUpdated();
    }
    /**
   * Removes any overrides that have been set for the given experiment.
   * @param {string} experimentName
   */ clearConfigOverride(experimentName) {
        this.overrideAdapter.removeDynamicConfigOverride(experimentName);
        this.statsigValuesUpdated();
    }
    /**
   * Set overrides for gates, experiments and layers in batch.
   *
   * Note that these overrides are **not** additive and will completely replace any that have been
   * added via prior calls to {@link Client.overrideConfig} or
   * {@link Client.overrideGate}.
   *
   * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
   * will continue to affect every client that is initialized on the same domain after this method
   * is called. If you are using this API for testing purposes, you should call
   * {@link Client.clearAllOverrides} after your tests are completed to remove this
   * localStorage entry.
   */ setOverrides(overrides) {
        this.overrideAdapter.setOverrides(overrides);
        this.statsigValuesUpdated();
    }
    /**
   * @returns The current overrides for gates, configs (including experiments) and layers.
   */ getOverrides() {
        return this.overrideAdapter.getOverrides();
    }
    /**
   * Clears overrides for all gates, configs (including experiments) and layers.
   */ clearAllOverrides() {
        this.overrideAdapter.removeAllOverrides();
        this.statsigValuesUpdated();
    }
    /**
   * Returns whether the given identifiers and customAttributes align with the current
   * set that is being used by the client.
   *
   * If this method returns false, then the {@link Client.updateUser},
   * {@link Client.updateUserWithValues} or {@link Client.updateUserWithProvider}
   * methods can be used to re-align these values.
   *
   * @param identifiers
   * @param customAttributes
   * @returns a flag indicating whether the clients current configuration aligns with the given values
   */ isCurrentUser(identifiers, customAttributes) {
        return (0, $891608fc6585360f$export$fa1c2bbf4100b8bc)(this.currentIdentifiers, identifiers) && (0, $891608fc6585360f$export$fa1c2bbf4100b8bc)(this.currentAttributes, customAttributes);
    }
    /**
   * Subscribe to updates where the given callback will be called with the current checkGate value
   * @param gateName
   * @param callback
   * @param options
   * @returns off function to unsubscribe from updates
   */ onGateUpdated(gateName, callback, options = {}) {
        const wrapCallback = (value)=>{
            const { fireGateExposure: fireGateExposure = true } = options;
            if (fireGateExposure) this.manuallyLogGateExposure(gateName);
            try {
                callback(value);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.warn(`Error calling callback for gate ${gateName} with value ${value}`, error);
            }
        };
        return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
    }
    /**
   * Subscribe to updates where the given callback will be called with the current experiment value
   * @param experimentName
   * @param parameterName
   * @param defaultValue
   * @param callback
   * @param options
   * @returns off function to unsubscribe from updates
   */ onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, options = {}) {
        const wrapCallback = (value)=>{
            const { fireExperimentExposure: fireExperimentExposure = true } = options;
            if (fireExperimentExposure) this.manuallyLogExperimentExposure(experimentName);
            try {
                callback(value);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.warn(`Error calling callback for experiment ${experimentName} with value ${value}`, error);
            }
        };
        return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
    }
    /**
   * Subscribe so on any update the callback will be called.
   * NOTE: The callback will be called whenever the values are updated even if the values have not
   * changed.
   * @param callback
   * @returns off function to unsubscribe from updates
   */ onAnyUpdated(callback) {
        return this.subscriptions.onAnyUpdated(callback);
    }
    /**
   * This method initializes the client using a network call to fetch the bootstrap values for the
   * given user.
   *
   * @param clientOptions
   * @param identifiers
   * @param customAttributes
   * @private
   */ async init(clientOptions, identifiers, customAttributes) {
        const fromValuesClientOptions = {
            ...clientOptions
        };
        let experimentValues;
        let customAttributesFromResult;
        try {
            // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
            // the experiment values request to be settled, and it will fall back to use default values.
            const clientSdkKeyPromise = (0, $3f3d8d5a5fb9a7cc$export$2e2bcd8739ae039).fetchClientSdk(clientOptions).then((value)=>fromValuesClientOptions.sdkKey = value.clientSdkKey);
            const experimentValuesPromise = (0, $3f3d8d5a5fb9a7cc$export$2e2bcd8739ae039).fetchExperimentValues(clientOptions, identifiers, customAttributes);
            // Only wait for the experiment values request to finish and try to initialise the client
            // with experiment values if both requests are successful. Else an error would be thrown and
            // handled by the catch
            const [, experimentValuesResult] = await Promise.all([
                clientSdkKeyPromise,
                experimentValuesPromise
            ]);
            experimentValues = experimentValuesResult.experimentValues;
            customAttributesFromResult = experimentValuesResult.customAttributes;
        } catch (error) {
            if (error instanceof Error) // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to fetch the Feature Gates client values, error: ${error?.message}`);
            // eslint-disable-next-line no-console
            console.warn(`Initialising Statsig client without values`);
            await this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
            throw error;
        }
        return this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues);
    }
    async initWithProvider(baseClientOptions, provider, identifiers, customAttributes) {
        const fromValuesClientOptions = {
            ...baseClientOptions,
            disableCurrentPageLogging: true
        };
        let experimentValues;
        let customAttributesFromResult;
        try {
            await provider.setProfile(baseClientOptions, identifiers, customAttributes);
            // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
            // the experiment values request to be settled, and it will fall back to use default values.
            const clientSdkKeyPromise = provider.getClientSdkKey().then((value)=>fromValuesClientOptions.sdkKey = value);
            const experimentValuesPromise = provider.getExperimentValues();
            // Only wait for the experiment values request to finish and try to initialise the client
            // with experiment values if both requests are successful. Else an error would be thrown and
            // handled by the catch
            const [, experimentValuesResult] = await Promise.all([
                clientSdkKeyPromise,
                experimentValuesPromise
            ]);
            experimentValues = experimentValuesResult.experimentValues;
            customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
        } catch (error) {
            if (error instanceof Error) // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to fetch the Feature Gates client values, error: ${error?.message}`);
            // eslint-disable-next-line no-console
            console.warn(`Initialising Statsig client without values`);
            await this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
            throw error;
        }
        return this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues);
    }
    /**
   * This method initializes the client using a set of boostrap values obtained from one of the
   * server-side SDKs.
   *
   * @param clientOptions
   * @param identifiers
   * @param customAttributes
   * @param initializeValues
   * @private
   */ async initFromValues(clientOptions, identifiers, customAttributes, initializeValues = {}) {
        this.overrideAdapter.initFromStoredOverrides();
        this.currentIdentifiers = identifiers;
        this.currentAttributes = customAttributes;
        const newClientOptions = (0, $891608fc6585360f$export$202946b690d26d22)(clientOptions);
        if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $943cf535bd11de3f$var$DEFAULT_CLIENT_KEY;
        if (!newClientOptions.networkConfig?.logEventUrl) newClientOptions.networkConfig = {
            ...newClientOptions.networkConfig,
            logEventUrl: $943cf535bd11de3f$var$DEFAULT_EVENT_LOGGING_API
        };
        if (newClientOptions.perimeter === (0, $b0b67edccf7bb11b$export$c42b7bbc5e7ba555).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
        newClientOptions.disableLogging = true;
        const { sdkKey: sdkKey, environment: environment, updateUserCompletionCallback: _updateUserCompletionCallback, perimeter: _perimeter, ...restClientOptions } = newClientOptions;
        this.user = (0, $891608fc6585360f$export$3dad1db244472f32)(identifiers, customAttributes);
        const statsigOptions = {
            ...restClientOptions,
            environment: {
                tier: environment
            },
            includeCurrentPageUrlWithEvents: false,
            dataAdapter: this.dataAdapter,
            overrideAdapter: this.overrideAdapter,
            logEventCompressionMode: (0, $a35cdd272375d707$exports.LogEventCompressionMode).Forced
        };
        // Statsig validates the provided stableId against their own cookie, so we either need
        // to update the cookie to match, or disable the validation completely.
        if (identifiers.stableId) (0, $a35cdd272375d707$exports.StableID).setOverride(identifiers.stableId, sdkKey);
        else statsigOptions.disableStableID = true;
        try {
            this.statsigClient = new (0, $a35cdd272375d707$exports.StatsigClient)(sdkKey, this.user, statsigOptions);
            this.dataAdapter.setBootstrapData(initializeValues);
            await this.statsigClient.initializeAsync();
        } catch (error) {
            if (error instanceof Error) // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to initialise the Statsig client, error: ${error?.message}`);
            // eslint-disable-next-line no-console
            console.warn(`Initialising Statsig client with default sdk key and without values`);
            this.statsigClient = new (0, $a35cdd272375d707$exports.StatsigClient)($943cf535bd11de3f$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
            this.dataAdapter.setBootstrapData();
            await this.statsigClient.initializeAsync();
            this.initWithDefaults = true;
            throw error;
        }
    }
    /**
   * This method updates the user for this client with the bootstrap values returned from a given
   * Promise.
   * It uses the customAttributes from fetching experiment values to update the Statsig user but
   * uses the customAttributes from given input to check if the user has changed.
   *
   * @param {Identifiers} identifiers
   * @param {CustomAttributes} customAttributes
   * @param {Promise<InitializeValues>} getInitializeValues
   * @private
   */ async updateUserUsingInitializeValuesProducer(getInitializeValues, identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        if (!this.initPromise) throw new Error('The client must be initialized before you can update the user.');
        // If the user isn't changing at all, then exit immediately
        if (this.isCurrentUser(identifiers, customAttributes)) return this.initPromise;
        // Wait for the current initialize/update to finish
        const originalInitPromise = this.initPromise;
        try {
            await this.initPromise;
        } catch (err) {
        // Proceed with the user update even if the init failed, since this update
        // may put the client back into a valid state.
        }
        const initializeValuesPromise = getInitializeValues();
        const updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes);
        // We replace the init promise here since we are essentially re-initializing the client at this
        // point. Any subsequent calls to await client.initialize() or client.updateUser()
        // will now also await this user update.
        this.initPromise = updateUserPromise.catch(async ()=>{
            // If the update failed then it changed nothing, so revert back to the original promise.
            this.initPromise = originalInitPromise;
            // Set the user profile again to revert back to the current user
            if (this.provider) await this.provider.setProfile(this.initOptions, this.currentIdentifiers, this.currentAttributes);
        });
        return updateUserPromise;
    }
    /**
   * This method updates the user on the nested Statsig client
   *
   * @param identifiers
   * @param customAttributes
   * @param initializeValuesPromise
   * @private
   */ async updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        let initializeValues, user;
        try {
            initializeValues = await initializeValuesPromise;
            user = (0, $891608fc6585360f$export$3dad1db244472f32)(identifiers, initializeValues.customAttributesFromFetch);
        } catch (err) {
            // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
            // This is not necessary for the updateUserWithValues call, because the Statsig client will
            // already invoke the callback itself.
            const errMsg = err instanceof Error ? err.message : JSON.stringify(err);
            this.initOptions.updateUserCompletionCallback?.(false, errMsg);
            throw err;
        }
        let success = true;
        let errorMessage = null;
        try {
            this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
            this.user = user;
            if (this.user) await this.statsigClient.updateUserAsync(this.user);
        } catch (err) {
            success = false;
            errorMessage = String(err);
        }
        this.initOptions?.updateUserCompletionCallback?.(success, errorMessage);
        if (success) {
            this.currentIdentifiers = identifiers;
            this.currentAttributes = customAttributes;
            this.subscriptions.anyUpdated();
        } else throw new Error('Failed to update user. An unexpected error occured.');
    }
    /**
   * @returns string version of the current package in semver style.
   */ getPackageVersion() {
        return 0, $09266364ca7f9e0f$export$a59f8d67326bd1cb;
    }
    /**
   * Returns a specified layer otherwise returns an empty layer as a default value if the layer doesn't exist.
   *
   * @param {string} layerName - The name of the layer
   * @param {Object} options
   * @param {boolean} options.fireLayerExposure - Whether or not to fire the exposure event for the
   * layer. Defaults to true. To log an exposure event manually at a later time, use
   * {@link Client.manuallyLogLayerExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * @returns A layer
   * @example
   * ```ts
   * const layer = client.getLayer('example-layer-name');
   * const exampletitle: string = layer.get("title", "Welcome to Statsig!");
   * ```
   */ getLayer(/** The name of the layer */ layerName, options = {}) {
        try {
            this.assertInitialized(this.statsigClient);
            const { fireLayerExposure: fireLayerExposure = true } = options;
            return (0, $89727d6d3bb2155d$export$936d0764594b6eb3).fromLayer(this.statsigClient.getLayer(layerName, {
                disableExposureLog: !fireLayerExposure
            }));
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetLayerErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                    layerName: layerName,
                    error: error
                });
                this.hasGetLayerErrorOccurred = true;
            }
            // Return a default value
            return (0, $89727d6d3bb2155d$export$936d0764594b6eb3).fromLayer((0, $a35cdd272375d707$exports._makeLayer)(layerName, {
                reason: 'Error'
            }, null));
        }
    }
    /**
   * Returns the value of a given parameter in a layer config.
   *
   * @template T
   * @param {string} layerName - The name of the layer
   * @param {string} parameterName - The name of the parameter to fetch from the layer config
   * @param {T} defaultValue - The value to serve if the layer or parameter do not exist, or if the
   * returned value does not match the expected type.
   * @param {Object} options
   * @param {boolean} options.fireLayerExposure - Whether or not to fire the exposure event for the
   * layer. Defaults to true. To log an exposure event manually at a later time, use
   * {@link Client.manuallyLogLayerExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-))
   * @param {function} options.typeGuard - A function that asserts that the return value has the expected type. If this function returns false, then the default value will be returned instead. This can be set to protect your code from unexpected values being set remotely. By default, this will be done by asserting that the default value and value are the same primitive type.
   * @returns The value of the parameter if the layer and parameter both exist, otherwise the default value.
   * @example
   * ``` ts
   * type ValidColor = 'blue' | 'red' | 'yellow';
   * type ValidColorTypeCheck = (value: unknown) => value is ValidColor;
   *
   * const isValidColor: ValidColorTypeCheck =
   *    (value: unknown) => typeof value === 'string' && ['blue', 'red', 'yellow'].includes(value);
   *
   * const buttonColor: ValidColor = client.getLayerValue(
   *    'example-layer-name',
   *    'backgroundColor',
   *    'yellow',
   *    {
   *        typeGuard: isValidColor
   *    }
   * );
   * ```
   */ getLayerValue(layerName, parameterName, defaultValue, options = {}) {
        const layer = this.getLayer(layerName, options);
        try {
            const { typeGuard: typeGuard } = options;
            return layer.get(parameterName, defaultValue, typeGuard);
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetLayerValueErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                    layerName: layerName,
                    defaultValue: defaultValue,
                    options: options,
                    error: error
                });
                this.hasGetLayerValueErrorOccurred = true;
            }
            return defaultValue;
        }
    }
    constructor({ localStorageKey: localStorageKey = (0, $4a1f2f0dcf00585b$export$d8474cff104280f3), overrideAdapter: overrideAdapter } = {}){
        this.statsigClient = void 0;
        this.user = void 0;
        this.initOptions = void 0;
        this.initPromise = null;
        /** True if an initialize method was called and completed successfully. */ this.initCompleted = false;
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ this.initWithDefaults = false;
        this.currentIdentifiers = void 0;
        this.currentAttributes = void 0;
        this.hasCheckGateErrorOccurred = false;
        this.hasGetExperimentErrorOccurred = false;
        this.hasGetExperimentValueErrorOccurred = false;
        this.hasGetLayerErrorOccurred = false;
        this.hasGetLayerValueErrorOccurred = false;
        this.provider = void 0;
        this.subscriptions = new (0, $0432dc905c88c02c$export$2e2bcd8739ae039)();
        this.dataAdapter = new (0, $492410a8ef69a013$export$55fffef3474104af)();
        this.overrideAdapter = void 0;
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ this.statsigValuesUpdated = ()=>{
            if (this.user) // Trigger a reset of the memoize cache
            this.statsigClient.updateUserSync(this.user, {
                disableBackgroundCacheRefresh: true
            });
            this.subscriptions.anyUpdated();
        };
        this.overrideAdapter = overrideAdapter || new (0, $4a1f2f0dcf00585b$export$bcb28fbac1def494)(localStorageKey);
    }
}






var $92d8da4ee454ac11$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ class $92d8da4ee454ac11$var$FeatureGates {
    static isGateExists(gateName) {
        return this.client.isGateExist(gateName);
    }
    static isExperimentExists(experimentName) {
        return this.client.isExperimentExist(experimentName);
    }
}
$92d8da4ee454ac11$var$_FeatureGates = $92d8da4ee454ac11$var$FeatureGates;
$92d8da4ee454ac11$var$FeatureGates.client = new (0, $943cf535bd11de3f$export$1f2bb630327ac4b6)();
$92d8da4ee454ac11$var$FeatureGates.hasCheckGateErrorOccurred = false;
$92d8da4ee454ac11$var$FeatureGates.hasGetExperimentValueErrorOccurred = false;
$92d8da4ee454ac11$var$FeatureGates.checkGate = (gateName, options)=>{
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            const overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$92d8da4ee454ac11$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            $92d8da4ee454ac11$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $92d8da4ee454ac11$var$_FeatureGates.client.checkGate(gateName, options);
};
$92d8da4ee454ac11$var$FeatureGates.getExperimentValue = (experimentName, parameterName, defaultValue, options)=>{
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            const overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$92d8da4ee454ac11$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $92d8da4ee454ac11$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $92d8da4ee454ac11$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
};
$92d8da4ee454ac11$var$FeatureGates.initializeCalled = $92d8da4ee454ac11$var$_FeatureGates.client.initializeCalled.bind($92d8da4ee454ac11$var$_FeatureGates.client);
$92d8da4ee454ac11$var$FeatureGates.initializeCompleted = $92d8da4ee454ac11$var$_FeatureGates.client.initializeCompleted.bind($92d8da4ee454ac11$var$_FeatureGates.client);
$92d8da4ee454ac11$var$FeatureGates.waitUntilInitializeCompleted = $92d8da4ee454ac11$var$_FeatureGates.client.waitUntilInitializeCompleted.bind($92d8da4ee454ac11$var$_FeatureGates.client);
$92d8da4ee454ac11$var$FeatureGates.initialize = $92d8da4ee454ac11$var$_FeatureGates.client.initialize.bind($92d8da4ee454ac11$var$_FeatureGates.client);
$92d8da4ee454ac11$var$FeatureGates.initializeWithProvider = $92d8da4ee454ac11$var$_FeatureGates.client.initializeWithProvider.bind($92d8da4ee454ac11$var$_FeatureGates.client);
$92d8da4ee454ac11$var$FeatureGates.initializeFromValues = $92d8da4ee454ac11$var$_FeatureGates.client.initializeFromValues.bind($92d8da4ee454ac11$var$_FeatureGates.client);
$92d8da4ee454ac11$var$FeatureGates.manuallyLogGateExposure = $92d8da4ee454ac11$var$_FeatureGates.client.manuallyLogGateExposure.bind($92d8da4ee454ac11$var$_FeatureGates.client);
$92d8da4ee454ac11$var$FeatureGates.getExperiment = $92d8da4ee454ac11$var$_FeatureGates.client.getExperiment.bind($92d8da4ee454ac11$var$_FeatureGates.client);
$92d8da4ee454ac11$var$FeatureGates.manuallyLogExperimentExposure = $92d8da4ee454ac11$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($92d8da4ee454ac11$var$_FeatureGates.client);
$92d8da4ee454ac11$var$FeatureGates.manuallyLogLayerExposure = $92d8da4ee454ac11$var$_FeatureGates.client.manuallyLogLayerExposure.bind($92d8da4ee454ac11$var$_FeatureGates.client);
$92d8da4ee454ac11$var$FeatureGates.shutdownStatsig = $92d8da4ee454ac11$var$_FeatureGates.client.shutdownStatsig.bind($92d8da4ee454ac11$var$_FeatureGates.client);
$92d8da4ee454ac11$var$FeatureGates.overrideGate = $92d8da4ee454ac11$var$_FeatureGates.client.overrideGate.bind($92d8da4ee454ac11$var$_FeatureGates.client);
$92d8da4ee454ac11$var$FeatureGates.clearGateOverride = $92d8da4ee454ac11$var$_FeatureGates.client.clearGateOverride.bind($92d8da4ee454ac11$var$_FeatureGates.client);
$92d8da4ee454ac11$var$FeatureGates.overrideConfig = $92d8da4ee454ac11$var$_FeatureGates.client.overrideConfig.bind($92d8da4ee454ac11$var$_FeatureGates.client);
$92d8da4ee454ac11$var$FeatureGates.clearConfigOverride = $92d8da4ee454ac11$var$_FeatureGates.client.clearConfigOverride.bind($92d8da4ee454ac11$var$_FeatureGates.client);
$92d8da4ee454ac11$var$FeatureGates.setOverrides = $92d8da4ee454ac11$var$_FeatureGates.client.setOverrides.bind($92d8da4ee454ac11$var$_FeatureGates.client);
$92d8da4ee454ac11$var$FeatureGates.getOverrides = $92d8da4ee454ac11$var$_FeatureGates.client.getOverrides.bind($92d8da4ee454ac11$var$_FeatureGates.client);
$92d8da4ee454ac11$var$FeatureGates.clearAllOverrides = $92d8da4ee454ac11$var$_FeatureGates.client.clearAllOverrides.bind($92d8da4ee454ac11$var$_FeatureGates.client);
$92d8da4ee454ac11$var$FeatureGates.isCurrentUser = $92d8da4ee454ac11$var$_FeatureGates.client.isCurrentUser.bind($92d8da4ee454ac11$var$_FeatureGates.client);
$92d8da4ee454ac11$var$FeatureGates.onGateUpdated = $92d8da4ee454ac11$var$_FeatureGates.client.onGateUpdated.bind($92d8da4ee454ac11$var$_FeatureGates.client);
$92d8da4ee454ac11$var$FeatureGates.onExperimentValueUpdated = $92d8da4ee454ac11$var$_FeatureGates.client.onExperimentValueUpdated.bind($92d8da4ee454ac11$var$_FeatureGates.client);
$92d8da4ee454ac11$var$FeatureGates.onAnyUpdated = $92d8da4ee454ac11$var$_FeatureGates.client.onAnyUpdated.bind($92d8da4ee454ac11$var$_FeatureGates.client);
$92d8da4ee454ac11$var$FeatureGates.updateUser = $92d8da4ee454ac11$var$_FeatureGates.client.updateUser.bind($92d8da4ee454ac11$var$_FeatureGates.client);
$92d8da4ee454ac11$var$FeatureGates.updateUserWithProvider = $92d8da4ee454ac11$var$_FeatureGates.client.updateUserWithProvider.bind($92d8da4ee454ac11$var$_FeatureGates.client);
$92d8da4ee454ac11$var$FeatureGates.updateUserWithValues = $92d8da4ee454ac11$var$_FeatureGates.client.updateUserWithValues.bind($92d8da4ee454ac11$var$_FeatureGates.client);
$92d8da4ee454ac11$var$FeatureGates.getPackageVersion = $92d8da4ee454ac11$var$_FeatureGates.client.getPackageVersion.bind($92d8da4ee454ac11$var$_FeatureGates.client);
$92d8da4ee454ac11$var$FeatureGates.getLayer = $92d8da4ee454ac11$var$_FeatureGates.client.getLayer.bind($92d8da4ee454ac11$var$_FeatureGates.client);
$92d8da4ee454ac11$var$FeatureGates.getLayerValue = $92d8da4ee454ac11$var$_FeatureGates.client.getLayerValue.bind($92d8da4ee454ac11$var$_FeatureGates.client);
let $92d8da4ee454ac11$var$boundFGJS = $92d8da4ee454ac11$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $92d8da4ee454ac11$var$FeatureGates;
    else {
        $92d8da4ee454ac11$var$boundFGJS = window.__FEATUREGATES_JS__;
        const boundVersion = $92d8da4ee454ac11$var$boundFGJS?.getPackageVersion?.() || '4.10.0 or earlier';
        if (boundVersion !== (0, $09266364ca7f9e0f$export$a59f8d67326bd1cb)) {
            const message = `Multiple versions of FeatureGateClients found on the current page.
      The currently bound version is ${boundVersion} when module version ${(0, $09266364ca7f9e0f$export$a59f8d67326bd1cb)} was loading.`;
            // eslint-disable-next-line no-console
            console.warn(message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $92d8da4ee454ac11$export$2e2bcd8739ae039 = $92d8da4ee454ac11$var$boundFGJS;


const $a6930482c955ad5f$export$42f4885608027d0c = 'non_boolean';


function $5ef6d681ab581e57$var$startsAsObject(value) {
    try {
        if (value.charAt(0) === '{') return true;
    } catch  {
        return false;
    }
    return false;
}
function $5ef6d681ab581e57$var$isObject(value) {
    return value && typeof value === 'object' && value.constructor === Object;
}
function $5ef6d681ab581e57$var$isString(input) {
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch  {
        // swallow any errors
        result = false;
    }
    return result;
}
function $5ef6d681ab581e57$export$7b4abba432e57989(value) {
    return $5ef6d681ab581e57$var$isString(value) && $5ef6d681ab581e57$var$startsAsObject(value) || $5ef6d681ab581e57$var$isObject(value);
}
function $5ef6d681ab581e57$export$fcc03ee4c944962f(featureFlagValue) {
    return $5ef6d681ab581e57$export$7b4abba432e57989(featureFlagValue) ? (0, $a6930482c955ad5f$export$42f4885608027d0c) : featureFlagValue;
}


const $f721e733a5f9f3b0$export$5b78c989c8db2561 = new Map();
const $f721e733a5f9f3b0$export$2a5c8df26bb89760 = new Map();
function $f721e733a5f9f3b0$export$47fade9662f71000(featureFlagName, featureFlagValue) {
    try {
        // Inform Criterion about FF being accessed
        if (globalThis.__CRITERION__ && typeof globalThis.__CRITERION__.addFeatureFlagAccessed === 'function') globalThis.__CRITERION__.addFeatureFlagAccessed(featureFlagName, featureFlagValue);
    } catch (_e) {
    // ignore the criterion error
    }
    const value = (0, $5ef6d681ab581e57$export$fcc03ee4c944962f)(featureFlagValue);
    $f721e733a5f9f3b0$export$5b78c989c8db2561.set(featureFlagName, value);
    $f721e733a5f9f3b0$export$2a5c8df26bb89760.set(featureFlagName, value);
}


const $3df4286e75ff1ab6$export$b40ec24ac8275656 = (gateName)=>{
    // eslint-disable-next-line confluence-feature-gating/use-recommended-utils
    const value = (0, $92d8da4ee454ac11$export$2e2bcd8739ae039).checkGate(gateName);
    (0, $f721e733a5f9f3b0$export$47fade9662f71000)(gateName, value);
    return value;
};







function $d4a7caa009eb781c$export$eca64eb737a4c2bc(requestInit) {
    // referrerPolicy is not supported by Edge pre Chromium:
    if (requestInit && 'referrerPolicy' in requestInit) {
        const { referrerPolicy: referrerPolicy, ...requestInitWithoutReferrerPolicy } = requestInit;
        try {
            new Request('/', {
                referrerPolicy: referrerPolicy
            });
        // The referrerPolicy seems to be supported. Leave it in requestInit.
        } catch (_) {
            // The referrerPolicy does not seem to be supported. Drop it from
            // requestInit; otherwise, the Request constructor and fetch will throw:
            requestInit = requestInitWithoutReferrerPolicy;
        }
    }
    return requestInit;
}


const $32b74afc9e827b44$export$9f229e40eb65abfc = (response)=>response?.headers?.get('x-b3-traceid') || response?.headers?.get('atl-traceid') || null;



var $dEf6I = parcelRequire("dEf6I");

var $bXCDP = parcelRequire("bXCDP");
var $brWF5 = parcelRequire("brWF5");

var $dcDKw = parcelRequire("dcDKw");
var $hmiPI = parcelRequire("hmiPI");

var $gmmZy = parcelRequire("gmmZy");

var $dEf6I = parcelRequire("dEf6I");

var $aVaWD = parcelRequire("aVaWD");
var $9b1ec3529a6f8606$var$genericMessage = "Invariant Violation";
var $9b1ec3529a6f8606$var$_a = Object.setPrototypeOf, $9b1ec3529a6f8606$var$setPrototypeOf = $9b1ec3529a6f8606$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $9b1ec3529a6f8606$var$_a;
var $9b1ec3529a6f8606$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $dEf6I.__extends)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $9b1ec3529a6f8606$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $9b1ec3529a6f8606$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $9b1ec3529a6f8606$var$genericMessage;
        $9b1ec3529a6f8606$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $9b1ec3529a6f8606$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $9b1ec3529a6f8606$export$cea12affaee22fe8(message);
}
function $9b1ec3529a6f8606$var$wrapConsoleMethod(method) {
    return function() {
        return console[method].apply(console, arguments);
    };
}
(function(invariant) {
    invariant.warn = $9b1ec3529a6f8606$var$wrapConsoleMethod("warn");
    invariant.error = $9b1ec3529a6f8606$var$wrapConsoleMethod("error");
})($9b1ec3529a6f8606$export$f5708dca728d7177 || ($9b1ec3529a6f8606$export$f5708dca728d7177 = {}));
// Code that uses ts-invariant with rollup-plugin-invariant may want to
// import this process stub to avoid errors evaluating process.env.NODE_ENV.
// However, because most ESM-to-CJS compilers will rewrite the process import
// as tsInvariant.process, which prevents proper replacement by minifiers, we
// also attempt to define the stub globally when it is not already defined.
var $9b1ec3529a6f8606$export$e54fe5b0f43758f7 = {
    env: {}
};
if (typeof $aVaWD === "object") $9b1ec3529a6f8606$export$e54fe5b0f43758f7 = $aVaWD;
else try {
    // Using Function to evaluate this assignment in global scope also escapes
    // the strict mode of the current module, thereby allowing the assignment.
    // Inspired by https://github.com/facebook/regenerator/pull/369.
    Function("stub", "process = stub")($9b1ec3529a6f8606$export$e54fe5b0f43758f7);
} catch (atLeastWeTried) {
// The assignment can fail if a Content Security Policy heavy-handedly
// forbids Function usage. In those environments, developers should take
// extra care to replace process.env.NODE_ENV in their production builds,
// or define an appropriate global.process polyfill.
}
var $9b1ec3529a6f8606$var$invariant$1 = $9b1ec3529a6f8606$export$f5708dca728d7177;
var $9b1ec3529a6f8606$export$2e2bcd8739ae039 = $9b1ec3529a6f8606$var$invariant$1;



var $kx5XW = parcelRequire("kx5XW");
var $2e58ccba3067efe5$export$bd096ddbd246c79c;
(function(NetworkStatus) {
    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    NetworkStatus[NetworkStatus["error"] = 8] = "error";
})($2e58ccba3067efe5$export$bd096ddbd246c79c || ($2e58ccba3067efe5$export$bd096ddbd246c79c = {}));
function $2e58ccba3067efe5$var$isNetworkRequestInFlight(networkStatus) {
    return networkStatus < 7;
}
var $2e58ccba3067efe5$var$Observable = function(_super) {
    (0, $dEf6I.__extends)(Observable, _super);
    function Observable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Observable.prototype[0, $gmmZy.default] = function() {
        return this;
    };
    Observable.prototype['@@observable'] = function() {
        return this;
    };
    return Observable;
}((0, $hmiPI.default));
function $2e58ccba3067efe5$var$isNonEmptyArray(value) {
    return Array.isArray(value) && value.length > 0;
}
function $2e58ccba3067efe5$export$17f5e6bd290bb15d(err) {
    return err.hasOwnProperty('graphQLErrors');
}
var $2e58ccba3067efe5$var$generateErrorMessage = function(err) {
    var message = '';
    if ($2e58ccba3067efe5$var$isNonEmptyArray(err.graphQLErrors)) err.graphQLErrors.forEach(function(graphQLError) {
        var errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
        message += "GraphQL error: " + errorMessage + "\n";
    });
    if (err.networkError) message += 'Network error: ' + err.networkError.message + '\n';
    message = message.replace(/\n$/, '');
    return message;
};
var $2e58ccba3067efe5$export$26a337512320b8c6 = function(_super) {
    (0, $dEf6I.__extends)(ApolloError, _super);
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.graphQLErrors = graphQLErrors || [];
        _this.networkError = networkError || null;
        if (!errorMessage) _this.message = $2e58ccba3067efe5$var$generateErrorMessage(_this);
        else _this.message = errorMessage;
        _this.extraInfo = extraInfo;
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error);
var $2e58ccba3067efe5$export$160bafb6ac1e0641;
(function(FetchType) {
    FetchType[FetchType["normal"] = 1] = "normal";
    FetchType[FetchType["refetch"] = 2] = "refetch";
    FetchType[FetchType["poll"] = 3] = "poll";
})($2e58ccba3067efe5$export$160bafb6ac1e0641 || ($2e58ccba3067efe5$export$160bafb6ac1e0641 = {}));
var $2e58ccba3067efe5$var$hasError = function(storeValue, policy) {
    if (policy === void 0) policy = 'none';
    return storeValue && (storeValue.networkError || policy === 'none' && $2e58ccba3067efe5$var$isNonEmptyArray(storeValue.graphQLErrors));
};
var $2e58ccba3067efe5$export$6c1b56eac59c9584 = function(_super) {
    (0, $dEf6I.__extends)(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, options = _a.options, _b = _a.shouldSubscribe, shouldSubscribe = _b === void 0 ? true : _b;
        var _this = _super.call(this, function(observer) {
            return _this.onSubscribe(observer);
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        _this.isTornDown = false;
        _this.options = options;
        _this.variables = options.variables || {};
        _this.queryId = queryManager.generateQueryId();
        _this.shouldSubscribe = shouldSubscribe;
        var opDef = (0, $bXCDP.getOperationDefinition)(options.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        _this.queryManager = queryManager;
        return _this;
    }
    ObservableQuery.prototype.result = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var observer = {
                next: function(result) {
                    resolve(result);
                    _this.observers.delete(observer);
                    if (!_this.observers.size) _this.queryManager.removeQuery(_this.queryId);
                    setTimeout(function() {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject
            };
            var subscription = _this.subscribe(observer);
        });
    };
    ObservableQuery.prototype.currentResult = function() {
        var result = this.getCurrentResult();
        if (result.data === undefined) result.data = {};
        return result;
    };
    ObservableQuery.prototype.getCurrentResult = function() {
        if (this.isTornDown) {
            var lastResult = this.lastResult;
            return {
                data: !this.lastError && lastResult && lastResult.data || void 0,
                error: this.lastError,
                loading: false,
                networkStatus: $2e58ccba3067efe5$export$bd096ddbd246c79c.error
            };
        }
        var _a = this.queryManager.getCurrentQueryResult(this), data = _a.data, partial = _a.partial;
        var queryStoreValue = this.queryManager.queryStore.get(this.queryId);
        var result;
        var fetchPolicy = this.options.fetchPolicy;
        var isNetworkFetchPolicy = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
        if (queryStoreValue) {
            var networkStatus = queryStoreValue.networkStatus;
            if ($2e58ccba3067efe5$var$hasError(queryStoreValue, this.options.errorPolicy)) return {
                data: void 0,
                loading: false,
                networkStatus: networkStatus,
                error: new $2e58ccba3067efe5$export$26a337512320b8c6({
                    graphQLErrors: queryStoreValue.graphQLErrors,
                    networkError: queryStoreValue.networkError
                })
            };
            if (queryStoreValue.variables) {
                this.options.variables = (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, this.options.variables), queryStoreValue.variables);
                this.variables = this.options.variables;
            }
            result = {
                data: data,
                loading: $2e58ccba3067efe5$var$isNetworkRequestInFlight(networkStatus),
                networkStatus: networkStatus
            };
            if (queryStoreValue.graphQLErrors && this.options.errorPolicy === 'all') result.errors = queryStoreValue.graphQLErrors;
        } else {
            var loading = isNetworkFetchPolicy || partial && fetchPolicy !== 'cache-only';
            result = {
                data: data,
                loading: loading,
                networkStatus: loading ? $2e58ccba3067efe5$export$bd096ddbd246c79c.loading : $2e58ccba3067efe5$export$bd096ddbd246c79c.ready
            };
        }
        if (!partial) this.updateLastResult((0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, result), {
            stale: false
        }));
        return (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, result), {
            partial: partial
        });
    };
    ObservableQuery.prototype.isDifferentFromLastResult = function(newResult) {
        var snapshot = this.lastResultSnapshot;
        return !(snapshot && newResult && snapshot.networkStatus === newResult.networkStatus && snapshot.stale === newResult.stale && (0, $brWF5.equal)(snapshot.data, newResult.data));
    };
    ObservableQuery.prototype.getLastResult = function() {
        return this.lastResult;
    };
    ObservableQuery.prototype.getLastError = function() {
        return this.lastError;
    };
    ObservableQuery.prototype.resetLastResults = function() {
        delete this.lastResult;
        delete this.lastResultSnapshot;
        delete this.lastError;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.resetQueryStoreErrors = function() {
        var queryStore = this.queryManager.queryStore.get(this.queryId);
        if (queryStore) {
            queryStore.networkError = null;
            queryStore.graphQLErrors = [];
        }
    };
    ObservableQuery.prototype.refetch = function(variables) {
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === 'cache-only') return Promise.reject(new (0, $9b1ec3529a6f8606$export$cea12affaee22fe8)(1));
        if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'cache-and-network') fetchPolicy = 'network-only';
        if (!(0, $brWF5.equal)(this.variables, variables)) this.variables = (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, this.variables), variables);
        if (!(0, $brWF5.equal)(this.options.variables, this.variables)) this.options.variables = (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, this.options.variables), this.variables);
        return this.queryManager.fetchQuery(this.queryId, (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, this.options), {
            fetchPolicy: fetchPolicy
        }), $2e58ccba3067efe5$export$160bafb6ac1e0641.refetch);
    };
    ObservableQuery.prototype.fetchMore = function(fetchMoreOptions) {
        var _this = this;
        (0, $9b1ec3529a6f8606$export$f5708dca728d7177)(fetchMoreOptions.updateQuery, 2);
        var combinedOptions = (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, fetchMoreOptions.query ? fetchMoreOptions : (0, $dEf6I.__assign)((0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, this.options), fetchMoreOptions), {
            variables: (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, this.variables), fetchMoreOptions.variables)
        })), {
            fetchPolicy: 'network-only'
        });
        var qid = this.queryManager.generateQueryId();
        return this.queryManager.fetchQuery(qid, combinedOptions, $2e58ccba3067efe5$export$160bafb6ac1e0641.normal, this.queryId).then(function(fetchMoreResult) {
            _this.updateQuery(function(previousResult) {
                return fetchMoreOptions.updateQuery(previousResult, {
                    fetchMoreResult: fetchMoreResult.data,
                    variables: combinedOptions.variables
                });
            });
            _this.queryManager.stopQuery(qid);
            return fetchMoreResult;
        }, function(error) {
            _this.queryManager.stopQuery(qid);
            throw error;
        });
    };
    ObservableQuery.prototype.subscribeToMore = function(options) {
        var _this = this;
        var subscription = this.queryManager.startGraphQLSubscription({
            query: options.document,
            variables: options.variables
        }).subscribe({
            next: function(subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) _this.updateQuery(function(previous, _a) {
                    var variables = _a.variables;
                    return updateQuery(previous, {
                        subscriptionData: subscriptionData,
                        variables: variables
                    });
                });
            },
            error: function(err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
            }
        });
        this.subscriptions.add(subscription);
        return function() {
            if (_this.subscriptions.delete(subscription)) subscription.unsubscribe();
        };
    };
    ObservableQuery.prototype.setOptions = function(opts) {
        var oldFetchPolicy = this.options.fetchPolicy;
        this.options = (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, this.options), opts);
        if (opts.pollInterval) this.startPolling(opts.pollInterval);
        else if (opts.pollInterval === 0) this.stopPolling();
        var fetchPolicy = opts.fetchPolicy;
        return this.setVariables(this.options.variables, oldFetchPolicy !== fetchPolicy && (oldFetchPolicy === 'cache-only' || oldFetchPolicy === 'standby' || fetchPolicy === 'network-only'), opts.fetchResults);
    };
    ObservableQuery.prototype.setVariables = function(variables, tryFetch, fetchResults) {
        if (tryFetch === void 0) tryFetch = false;
        if (fetchResults === void 0) fetchResults = true;
        this.isTornDown = false;
        variables = variables || this.variables;
        if (!tryFetch && (0, $brWF5.equal)(variables, this.variables)) return this.observers.size && fetchResults ? this.result() : Promise.resolve();
        this.variables = this.options.variables = variables;
        if (!this.observers.size) return Promise.resolve();
        return this.queryManager.fetchQuery(this.queryId, this.options);
    };
    ObservableQuery.prototype.updateQuery = function(mapFn) {
        var queryManager = this.queryManager;
        var _a = queryManager.getQueryWithPreviousResult(this.queryId), previousResult = _a.previousResult, variables = _a.variables, document = _a.document;
        var newResult = (0, $bXCDP.tryFunctionOrLogError)(function() {
            return mapFn(previousResult, {
                variables: variables
            });
        });
        if (newResult) {
            queryManager.dataStore.markUpdateQueryResult(document, variables, newResult);
            queryManager.broadcastQueries();
        }
    };
    ObservableQuery.prototype.stopPolling = function() {
        this.queryManager.stopPollingQuery(this.queryId);
        this.options.pollInterval = undefined;
    };
    ObservableQuery.prototype.startPolling = function(pollInterval) {
        $2e58ccba3067efe5$var$assertNotCacheFirstOrOnly(this);
        this.options.pollInterval = pollInterval;
        this.queryManager.startPollingQuery(this.options, this.queryId);
    };
    ObservableQuery.prototype.updateLastResult = function(newResult) {
        var previousResult = this.lastResult;
        this.lastResult = newResult;
        this.lastResultSnapshot = this.queryManager.assumeImmutableResults ? newResult : (0, $bXCDP.cloneDeep)(newResult);
        return previousResult;
    };
    ObservableQuery.prototype.onSubscribe = function(observer) {
        var _this = this;
        try {
            var subObserver = observer._subscription._observer;
            if (subObserver && !subObserver.error) subObserver.error = $2e58ccba3067efe5$var$defaultSubscriptionObserverErrorCallback;
        } catch (_a) {}
        var first = !this.observers.size;
        this.observers.add(observer);
        if (observer.next && this.lastResult) observer.next(this.lastResult);
        if (observer.error && this.lastError) observer.error(this.lastError);
        if (first) this.setUpQuery();
        return function() {
            if (_this.observers.delete(observer) && !_this.observers.size) _this.tearDownQuery();
        };
    };
    ObservableQuery.prototype.setUpQuery = function() {
        var _this = this;
        var _a = this, queryManager = _a.queryManager, queryId = _a.queryId;
        if (this.shouldSubscribe) queryManager.addObservableQuery(queryId, this);
        if (this.options.pollInterval) {
            $2e58ccba3067efe5$var$assertNotCacheFirstOrOnly(this);
            queryManager.startPollingQuery(this.options, queryId);
        }
        var onError = function(error) {
            _this.updateLastResult((0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, _this.lastResult), {
                errors: error.graphQLErrors,
                networkStatus: $2e58ccba3067efe5$export$bd096ddbd246c79c.error,
                loading: false
            }));
            $2e58ccba3067efe5$var$iterateObserversSafely(_this.observers, 'error', _this.lastError = error);
        };
        queryManager.observeQuery(queryId, this.options, {
            next: function(result) {
                if (_this.lastError || _this.isDifferentFromLastResult(result)) {
                    var previousResult_1 = _this.updateLastResult(result);
                    var _a = _this.options, query_1 = _a.query, variables = _a.variables, fetchPolicy_1 = _a.fetchPolicy;
                    if (queryManager.transform(query_1).hasClientExports) queryManager.getLocalState().addExportedVariables(query_1, variables).then(function(variables) {
                        var previousVariables = _this.variables;
                        _this.variables = _this.options.variables = variables;
                        if (!result.loading && previousResult_1 && fetchPolicy_1 !== 'cache-only' && queryManager.transform(query_1).serverQuery && !(0, $brWF5.equal)(previousVariables, variables)) _this.refetch();
                        else $2e58ccba3067efe5$var$iterateObserversSafely(_this.observers, 'next', result);
                    });
                    else $2e58ccba3067efe5$var$iterateObserversSafely(_this.observers, 'next', result);
                }
            },
            error: onError
        }).catch(onError);
    };
    ObservableQuery.prototype.tearDownQuery = function() {
        var queryManager = this.queryManager;
        this.isTornDown = true;
        queryManager.stopPollingQuery(this.queryId);
        this.subscriptions.forEach(function(sub) {
            return sub.unsubscribe();
        });
        this.subscriptions.clear();
        queryManager.removeObservableQuery(this.queryId);
        queryManager.stopQuery(this.queryId);
        this.observers.clear();
    };
    return ObservableQuery;
}($2e58ccba3067efe5$var$Observable);
function $2e58ccba3067efe5$var$defaultSubscriptionObserverErrorCallback(error) {}
function $2e58ccba3067efe5$var$iterateObserversSafely(observers, method, argument) {
    var observersWithMethod = [];
    observers.forEach(function(obs) {
        return obs[method] && observersWithMethod.push(obs);
    });
    observersWithMethod.forEach(function(obs) {
        return obs[method](argument);
    });
}
function $2e58ccba3067efe5$var$assertNotCacheFirstOrOnly(obsQuery) {
    var fetchPolicy = obsQuery.options.fetchPolicy;
    (0, $9b1ec3529a6f8606$export$f5708dca728d7177)(fetchPolicy !== 'cache-first' && fetchPolicy !== 'cache-only', 3);
}
var $2e58ccba3067efe5$var$MutationStore = function() {
    function MutationStore() {
        this.store = {};
    }
    MutationStore.prototype.getStore = function() {
        return this.store;
    };
    MutationStore.prototype.get = function(mutationId) {
        return this.store[mutationId];
    };
    MutationStore.prototype.initMutation = function(mutationId, mutation, variables) {
        this.store[mutationId] = {
            mutation: mutation,
            variables: variables || {},
            loading: true,
            error: null
        };
    };
    MutationStore.prototype.markMutationError = function(mutationId, error) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = error;
        }
    };
    MutationStore.prototype.markMutationResult = function(mutationId) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = null;
        }
    };
    MutationStore.prototype.reset = function() {
        this.store = {};
    };
    return MutationStore;
}();
var $2e58ccba3067efe5$var$QueryStore = function() {
    function QueryStore() {
        this.store = {};
    }
    QueryStore.prototype.getStore = function() {
        return this.store;
    };
    QueryStore.prototype.get = function(queryId) {
        return this.store[queryId];
    };
    QueryStore.prototype.initQuery = function(query) {
        var previousQuery = this.store[query.queryId];
        (0, $9b1ec3529a6f8606$export$f5708dca728d7177)(!previousQuery || previousQuery.document === query.document || (0, $brWF5.equal)(previousQuery.document, query.document), 19);
        var isSetVariables = false;
        var previousVariables = null;
        if (query.storePreviousVariables && previousQuery && previousQuery.networkStatus !== $2e58ccba3067efe5$export$bd096ddbd246c79c.loading) {
            if (!(0, $brWF5.equal)(previousQuery.variables, query.variables)) {
                isSetVariables = true;
                previousVariables = previousQuery.variables;
            }
        }
        var networkStatus;
        if (isSetVariables) networkStatus = $2e58ccba3067efe5$export$bd096ddbd246c79c.setVariables;
        else if (query.isPoll) networkStatus = $2e58ccba3067efe5$export$bd096ddbd246c79c.poll;
        else if (query.isRefetch) networkStatus = $2e58ccba3067efe5$export$bd096ddbd246c79c.refetch;
        else networkStatus = $2e58ccba3067efe5$export$bd096ddbd246c79c.loading;
        var graphQLErrors = [];
        if (previousQuery && previousQuery.graphQLErrors) graphQLErrors = previousQuery.graphQLErrors;
        this.store[query.queryId] = {
            document: query.document,
            variables: query.variables,
            previousVariables: previousVariables,
            networkError: null,
            graphQLErrors: graphQLErrors,
            networkStatus: networkStatus,
            metadata: query.metadata
        };
        if (typeof query.fetchMoreForQueryId === 'string' && this.store[query.fetchMoreForQueryId]) this.store[query.fetchMoreForQueryId].networkStatus = $2e58ccba3067efe5$export$bd096ddbd246c79c.fetchMore;
    };
    QueryStore.prototype.markQueryResult = function(queryId, result, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId]) return;
        this.store[queryId].networkError = null;
        this.store[queryId].graphQLErrors = $2e58ccba3067efe5$var$isNonEmptyArray(result.errors) ? result.errors : [];
        this.store[queryId].previousVariables = null;
        this.store[queryId].networkStatus = $2e58ccba3067efe5$export$bd096ddbd246c79c.ready;
        if (typeof fetchMoreForQueryId === 'string' && this.store[fetchMoreForQueryId]) this.store[fetchMoreForQueryId].networkStatus = $2e58ccba3067efe5$export$bd096ddbd246c79c.ready;
    };
    QueryStore.prototype.markQueryError = function(queryId, error, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId]) return;
        this.store[queryId].networkError = error;
        this.store[queryId].networkStatus = $2e58ccba3067efe5$export$bd096ddbd246c79c.error;
        if (typeof fetchMoreForQueryId === 'string') this.markQueryResultClient(fetchMoreForQueryId, true);
    };
    QueryStore.prototype.markQueryResultClient = function(queryId, complete) {
        var storeValue = this.store && this.store[queryId];
        if (storeValue) {
            storeValue.networkError = null;
            storeValue.previousVariables = null;
            if (complete) storeValue.networkStatus = $2e58ccba3067efe5$export$bd096ddbd246c79c.ready;
        }
    };
    QueryStore.prototype.stopQuery = function(queryId) {
        delete this.store[queryId];
    };
    QueryStore.prototype.reset = function(observableQueryIds) {
        var _this = this;
        Object.keys(this.store).forEach(function(queryId) {
            if (observableQueryIds.indexOf(queryId) < 0) _this.stopQuery(queryId);
            else _this.store[queryId].networkStatus = $2e58ccba3067efe5$export$bd096ddbd246c79c.loading;
        });
    };
    return QueryStore;
}();
function $2e58ccba3067efe5$var$capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
var $2e58ccba3067efe5$var$LocalState = function() {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.cache = cache;
        if (client) this.client = client;
        if (resolvers) this.addResolvers(resolvers);
        if (fragmentMatcher) this.setFragmentMatcher(fragmentMatcher);
    }
    LocalState.prototype.addResolvers = function(resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) resolvers.forEach(function(resolverGroup) {
            _this.resolvers = (0, $bXCDP.mergeDeep)(_this.resolvers, resolverGroup);
        });
        else this.resolvers = (0, $bXCDP.mergeDeep)(this.resolvers, resolvers);
    };
    LocalState.prototype.setResolvers = function(resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function() {
        return this.resolvers || {};
    };
    LocalState.prototype.runResolvers = function(_a) {
        var document = _a.document, remoteResult = _a.remoteResult, context = _a.context, variables = _a.variables, _b = _a.onlyRunForcedResolvers, onlyRunForcedResolvers = _b === void 0 ? false : _b;
        return (0, $dEf6I.__awaiter)(this, void 0, void 0, function() {
            return (0, $dEf6I.__generator)(this, function(_c) {
                if (document) return [
                    2,
                    this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function(localResult) {
                        return (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, remoteResult), {
                            data: localResult.result
                        });
                    })
                ];
                return [
                    2,
                    remoteResult
                ];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function(fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function() {
        return this.fragmentMatcher;
    };
    LocalState.prototype.clientQuery = function(document) {
        if ((0, $bXCDP.hasDirectives)([
            'client'
        ], document)) {
            if (this.resolvers) return document;
        }
        return null;
    };
    LocalState.prototype.serverQuery = function(document) {
        return this.resolvers ? (0, $bXCDP.removeClientSetsFromDocument)(document) : document;
    };
    LocalState.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var cache = this.cache;
        var newContext = (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, context), {
            cache: cache,
            getCacheKey: function(obj) {
                if (cache.config) return cache.config.dataIdFromObject(obj);
                else (0, $9b1ec3529a6f8606$export$f5708dca728d7177)(false, 6);
            }
        });
        return newContext;
    };
    LocalState.prototype.addExportedVariables = function(document, variables, context) {
        if (variables === void 0) variables = {};
        if (context === void 0) context = {};
        return (0, $dEf6I.__awaiter)(this, void 0, void 0, function() {
            return (0, $dEf6I.__generator)(this, function(_a) {
                if (document) return [
                    2,
                    this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function(data) {
                        return (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, variables), data.exportedVariables);
                    })
                ];
                return [
                    2,
                    (0, $dEf6I.__assign)({}, variables)
                ];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function(document) {
        var forceResolvers = false;
        (0, $kx5XW.visit)(document, {
            Directive: {
                enter: function(node) {
                    if (node.name.value === 'client' && node.arguments) {
                        forceResolvers = node.arguments.some(function(arg) {
                            return arg.name.value === 'always' && arg.value.kind === 'BooleanValue' && arg.value.value === true;
                        });
                        if (forceResolvers) return 0, $kx5XW.BREAK;
                    }
                }
            }
        });
        return forceResolvers;
    };
    LocalState.prototype.buildRootValueFromCache = function(document, variables) {
        return this.cache.diff({
            query: (0, $bXCDP.buildQueryFromSelectionSet)(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false
        }).result;
    };
    LocalState.prototype.resolveDocument = function(document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
        if (context === void 0) context = {};
        if (variables === void 0) variables = {};
        if (fragmentMatcher === void 0) fragmentMatcher = function() {
            return true;
        };
        if (onlyRunForcedResolvers === void 0) onlyRunForcedResolvers = false;
        return (0, $dEf6I.__awaiter)(this, void 0, void 0, function() {
            var mainDefinition, fragments, fragmentMap, definitionOperation, defaultOperationType, _a, cache, client, execContext;
            return (0, $dEf6I.__generator)(this, function(_b) {
                mainDefinition = (0, $bXCDP.getMainDefinition)(document);
                fragments = (0, $bXCDP.getFragmentDefinitions)(document);
                fragmentMap = (0, $bXCDP.createFragmentMap)(fragments);
                definitionOperation = mainDefinition.operation;
                defaultOperationType = definitionOperation ? $2e58ccba3067efe5$var$capitalizeFirstLetter(definitionOperation) : 'Query';
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, context), {
                        cache: cache,
                        client: client
                    }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    onlyRunForcedResolvers: onlyRunForcedResolvers
                };
                return [
                    2,
                    this.resolveSelectionSet(mainDefinition.selectionSet, rootValue, execContext).then(function(result) {
                        return {
                            result: result,
                            exportedVariables: execContext.exportedVariables
                        };
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function(selectionSet, rootValue, execContext) {
        return (0, $dEf6I.__awaiter)(this, void 0, void 0, function() {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return (0, $dEf6I.__generator)(this, function(_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [
                    rootValue
                ];
                execute = function(selection) {
                    return (0, $dEf6I.__awaiter)(_this, void 0, void 0, function() {
                        var fragment, typeCondition;
                        return (0, $dEf6I.__generator)(this, function(_a) {
                            if (!(0, $bXCDP.shouldInclude)(selection, variables)) return [
                                2
                            ];
                            if ((0, $bXCDP.isField)(selection)) return [
                                2,
                                this.resolveField(selection, rootValue, execContext).then(function(fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== 'undefined') resultsToMerge.push((_a = {}, _a[(0, $bXCDP.resultKeyNameFromField)(selection)] = fieldResult, _a));
                                })
                            ];
                            if ((0, $bXCDP.isInlineFragment)(selection)) fragment = selection;
                            else {
                                fragment = fragmentMap[selection.name.value];
                                (0, $9b1ec3529a6f8606$export$f5708dca728d7177)(fragment, 7);
                            }
                            if (fragment && fragment.typeCondition) {
                                typeCondition = fragment.typeCondition.name.value;
                                if (execContext.fragmentMatcher(rootValue, typeCondition, context)) return [
                                    2,
                                    this.resolveSelectionSet(fragment.selectionSet, rootValue, execContext).then(function(fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })
                                ];
                            }
                            return [
                                2
                            ];
                        });
                    });
                };
                return [
                    2,
                    Promise.all(selectionSet.selections.map(execute)).then(function() {
                        return (0, $bXCDP.mergeDeepArray)(resultsToMerge);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveField = function(field, rootValue, execContext) {
        return (0, $dEf6I.__awaiter)(this, void 0, void 0, function() {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return (0, $dEf6I.__generator)(this, function(_a) {
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = (0, $bXCDP.resultKeyNameFromField)(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                if (!execContext.onlyRunForcedResolvers || this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) resultPromise = Promise.resolve(resolve(rootValue, (0, $bXCDP.argumentsObjectFromField)(field, variables), execContext.context, {
                            field: field,
                            fragmentMap: execContext.fragmentMap
                        }));
                    }
                }
                return [
                    2,
                    resultPromise.then(function(result) {
                        if (result === void 0) result = defaultResult;
                        if (field.directives) field.directives.forEach(function(directive) {
                            if (directive.name.value === 'export' && directive.arguments) directive.arguments.forEach(function(arg) {
                                if (arg.name.value === 'as' && arg.value.kind === 'StringValue') execContext.exportedVariables[arg.value.value] = result;
                            });
                        });
                        if (!field.selectionSet) return result;
                        if (result == null) return result;
                        if (Array.isArray(result)) return _this.resolveSubSelectedArray(field, result, execContext);
                        if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, result, execContext);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function(field, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return _this.resolveSubSelectedArray(field, item, execContext);
            if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, item, execContext);
        }));
    };
    return LocalState;
}();
function $2e58ccba3067efe5$var$multiplex(inner) {
    var observers = new Set();
    var sub = null;
    return new $2e58ccba3067efe5$var$Observable(function(observer) {
        observers.add(observer);
        sub = sub || inner.subscribe({
            next: function(value) {
                observers.forEach(function(obs) {
                    return obs.next && obs.next(value);
                });
            },
            error: function(error) {
                observers.forEach(function(obs) {
                    return obs.error && obs.error(error);
                });
            },
            complete: function() {
                observers.forEach(function(obs) {
                    return obs.complete && obs.complete();
                });
            }
        });
        return function() {
            if (observers.delete(observer) && !observers.size && sub) {
                sub.unsubscribe();
                sub = null;
            }
        };
    });
}
function $2e58ccba3067efe5$var$asyncMap(observable, mapFn) {
    return new $2e58ccba3067efe5$var$Observable(function(observer) {
        var next = observer.next, error = observer.error, complete = observer.complete;
        var activeNextCount = 0;
        var completed = false;
        var handler = {
            next: function(value) {
                ++activeNextCount;
                new Promise(function(resolve) {
                    resolve(mapFn(value));
                }).then(function(result) {
                    --activeNextCount;
                    next && next.call(observer, result);
                    completed && handler.complete();
                }, function(e) {
                    --activeNextCount;
                    error && error.call(observer, e);
                });
            },
            error: function(e) {
                error && error.call(observer, e);
            },
            complete: function() {
                completed = true;
                if (!activeNextCount) complete && complete.call(observer);
            }
        };
        var sub = observable.subscribe(handler);
        return function() {
            return sub.unsubscribe();
        };
    });
}
var $2e58ccba3067efe5$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $2e58ccba3067efe5$var$QueryManager = function() {
    function QueryManager(_a) {
        var link = _a.link, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, store = _a.store, _c = _a.onBroadcast, onBroadcast = _c === void 0 ? function() {
            return undefined;
        } : _c, _d = _a.ssrMode, ssrMode = _d === void 0 ? false : _d, _e = _a.clientAwareness, clientAwareness = _e === void 0 ? {} : _e, localState = _a.localState, assumeImmutableResults = _a.assumeImmutableResults;
        this.mutationStore = new $2e58ccba3067efe5$var$MutationStore();
        this.queryStore = new $2e58ccba3067efe5$var$QueryStore();
        this.clientAwareness = {};
        this.idCounter = 1;
        this.queries = new Map();
        this.fetchQueryRejectFns = new Map();
        this.transformCache = new ((0, $bXCDP.canUseWeakMap) ? WeakMap : Map)();
        this.inFlightLinkObservables = new Map();
        this.pollingInfoByQueryId = new Map();
        this.link = link;
        this.queryDeduplication = queryDeduplication;
        this.dataStore = store;
        this.onBroadcast = onBroadcast;
        this.clientAwareness = clientAwareness;
        this.localState = localState || new $2e58ccba3067efe5$var$LocalState({
            cache: store.getCache()
        });
        this.ssrMode = ssrMode;
        this.assumeImmutableResults = !!assumeImmutableResults;
    }
    QueryManager.prototype.stop = function() {
        var _this = this;
        this.queries.forEach(function(_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.fetchQueryRejectFns.forEach(function(reject) {
            reject(new (0, $9b1ec3529a6f8606$export$cea12affaee22fe8)(8));
        });
    };
    QueryManager.prototype.mutate = function(_a) {
        var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueriesByName = _a.updateQueries, _b = _a.refetchQueries, refetchQueries = _b === void 0 ? [] : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, updateWithProxyFn = _a.update, _d = _a.errorPolicy, errorPolicy = _d === void 0 ? 'none' : _d, fetchPolicy = _a.fetchPolicy, _e = _a.context, context = _e === void 0 ? {} : _e;
        return (0, $dEf6I.__awaiter)(this, void 0, void 0, function() {
            var mutationId, generateUpdateQueriesInfo, self;
            var _this = this;
            return (0, $dEf6I.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        (0, $9b1ec3529a6f8606$export$f5708dca728d7177)(mutation, 9);
                        (0, $9b1ec3529a6f8606$export$f5708dca728d7177)(!fetchPolicy || fetchPolicy === 'no-cache', 10);
                        mutationId = this.generateQueryId();
                        mutation = this.transform(mutation).document;
                        this.setQuery(mutationId, function() {
                            return {
                                document: mutation
                            };
                        });
                        variables = this.getVariables(mutation, variables);
                        if (!this.transform(mutation).hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(mutation, variables, context)
                        ];
                    case 1:
                        variables = _f.sent();
                        _f.label = 2;
                    case 2:
                        generateUpdateQueriesInfo = function() {
                            var ret = {};
                            if (updateQueriesByName) _this.queries.forEach(function(_a, queryId) {
                                var observableQuery = _a.observableQuery;
                                if (observableQuery) {
                                    var queryName = observableQuery.queryName;
                                    if (queryName && $2e58ccba3067efe5$var$hasOwnProperty.call(updateQueriesByName, queryName)) ret[queryId] = {
                                        updater: updateQueriesByName[queryName],
                                        query: _this.queryStore.get(queryId)
                                    };
                                }
                            });
                            return ret;
                        };
                        this.mutationStore.initMutation(mutationId, mutation, variables);
                        this.dataStore.markMutationInit({
                            mutationId: mutationId,
                            document: mutation,
                            variables: variables,
                            updateQueries: generateUpdateQueriesInfo(),
                            update: updateWithProxyFn,
                            optimisticResponse: optimisticResponse
                        });
                        this.broadcastQueries();
                        self = this;
                        return [
                            2,
                            new Promise(function(resolve, reject) {
                                var storeResult;
                                var error;
                                self.getObservableFromLink(mutation, (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, context), {
                                    optimisticResponse: optimisticResponse
                                }), variables, false).subscribe({
                                    next: function(result) {
                                        if ((0, $bXCDP.graphQLResultHasError)(result) && errorPolicy === 'none') {
                                            error = new $2e58ccba3067efe5$export$26a337512320b8c6({
                                                graphQLErrors: result.errors
                                            });
                                            return;
                                        }
                                        self.mutationStore.markMutationResult(mutationId);
                                        if (fetchPolicy !== 'no-cache') self.dataStore.markMutationResult({
                                            mutationId: mutationId,
                                            result: result,
                                            document: mutation,
                                            variables: variables,
                                            updateQueries: generateUpdateQueriesInfo(),
                                            update: updateWithProxyFn
                                        });
                                        storeResult = result;
                                    },
                                    error: function(err) {
                                        self.mutationStore.markMutationError(mutationId, err);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse
                                        });
                                        self.broadcastQueries();
                                        self.setQuery(mutationId, function() {
                                            return {
                                                document: null
                                            };
                                        });
                                        reject(new $2e58ccba3067efe5$export$26a337512320b8c6({
                                            networkError: err
                                        }));
                                    },
                                    complete: function() {
                                        if (error) self.mutationStore.markMutationError(mutationId, error);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse
                                        });
                                        self.broadcastQueries();
                                        if (error) {
                                            reject(error);
                                            return;
                                        }
                                        if (typeof refetchQueries === 'function') refetchQueries = refetchQueries(storeResult);
                                        var refetchQueryPromises = [];
                                        if ($2e58ccba3067efe5$var$isNonEmptyArray(refetchQueries)) refetchQueries.forEach(function(refetchQuery) {
                                            if (typeof refetchQuery === 'string') self.queries.forEach(function(_a) {
                                                var observableQuery = _a.observableQuery;
                                                if (observableQuery && observableQuery.queryName === refetchQuery) refetchQueryPromises.push(observableQuery.refetch());
                                            });
                                            else {
                                                var queryOptions = {
                                                    query: refetchQuery.query,
                                                    variables: refetchQuery.variables,
                                                    fetchPolicy: 'network-only'
                                                };
                                                if (refetchQuery.context) queryOptions.context = refetchQuery.context;
                                                refetchQueryPromises.push(self.query(queryOptions));
                                            }
                                        });
                                        Promise.all(awaitRefetchQueries ? refetchQueryPromises : []).then(function() {
                                            self.setQuery(mutationId, function() {
                                                return {
                                                    document: null
                                                };
                                            });
                                            if (errorPolicy === 'ignore' && storeResult && (0, $bXCDP.graphQLResultHasError)(storeResult)) delete storeResult.errors;
                                            resolve(storeResult);
                                        });
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    QueryManager.prototype.fetchQuery = function(queryId, options, fetchType, fetchMoreForQueryId) {
        return (0, $dEf6I.__awaiter)(this, void 0, void 0, function() {
            var _a, metadata, _b, fetchPolicy, _c, context, query, variables, storeResult, isNetworkOnly, needToFetch, _d, complete, result, shouldFetch, requestId, cancel, networkResult;
            var _this = this;
            return (0, $dEf6I.__generator)(this, function(_e) {
                switch(_e.label){
                    case 0:
                        _a = options.metadata, metadata = _a === void 0 ? null : _a, _b = options.fetchPolicy, fetchPolicy = _b === void 0 ? 'cache-first' : _b, _c = options.context, context = _c === void 0 ? {} : _c;
                        query = this.transform(options.query).document;
                        variables = this.getVariables(query, options.variables);
                        if (!this.transform(query).hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(query, variables, context)
                        ];
                    case 1:
                        variables = _e.sent();
                        _e.label = 2;
                    case 2:
                        options = (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, options), {
                            variables: variables
                        });
                        isNetworkOnly = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
                        needToFetch = isNetworkOnly;
                        if (!isNetworkOnly) {
                            _d = this.dataStore.getCache().diff({
                                query: query,
                                variables: variables,
                                returnPartialData: true,
                                optimistic: false
                            }), complete = _d.complete, result = _d.result;
                            needToFetch = !complete || fetchPolicy === 'cache-and-network';
                            storeResult = result;
                        }
                        shouldFetch = needToFetch && fetchPolicy !== 'cache-only' && fetchPolicy !== 'standby';
                        if ((0, $bXCDP.hasDirectives)([
                            'live'
                        ], query)) shouldFetch = true;
                        requestId = this.idCounter++;
                        cancel = fetchPolicy !== 'no-cache' ? this.updateQueryWatch(queryId, query, options) : undefined;
                        this.setQuery(queryId, function() {
                            return {
                                document: query,
                                lastRequestId: requestId,
                                invalidated: true,
                                cancel: cancel
                            };
                        });
                        this.invalidate(fetchMoreForQueryId);
                        this.queryStore.initQuery({
                            queryId: queryId,
                            document: query,
                            storePreviousVariables: shouldFetch,
                            variables: variables,
                            isPoll: fetchType === $2e58ccba3067efe5$export$160bafb6ac1e0641.poll,
                            isRefetch: fetchType === $2e58ccba3067efe5$export$160bafb6ac1e0641.refetch,
                            metadata: metadata,
                            fetchMoreForQueryId: fetchMoreForQueryId
                        });
                        this.broadcastQueries();
                        if (shouldFetch) {
                            networkResult = this.fetchRequest({
                                requestId: requestId,
                                queryId: queryId,
                                document: query,
                                options: options,
                                fetchMoreForQueryId: fetchMoreForQueryId
                            }).catch(function(error) {
                                if ($2e58ccba3067efe5$export$17f5e6bd290bb15d(error)) throw error;
                                else {
                                    if (requestId >= _this.getQuery(queryId).lastRequestId) {
                                        _this.queryStore.markQueryError(queryId, error, fetchMoreForQueryId);
                                        _this.invalidate(queryId);
                                        _this.invalidate(fetchMoreForQueryId);
                                        _this.broadcastQueries();
                                    }
                                    throw new $2e58ccba3067efe5$export$26a337512320b8c6({
                                        networkError: error
                                    });
                                }
                            });
                            if (fetchPolicy !== 'cache-and-network') return [
                                2,
                                networkResult
                            ];
                            networkResult.catch(function() {});
                        }
                        this.queryStore.markQueryResultClient(queryId, !shouldFetch);
                        this.invalidate(queryId);
                        this.invalidate(fetchMoreForQueryId);
                        if (this.transform(query).hasForcedResolvers) return [
                            2,
                            this.localState.runResolvers({
                                document: query,
                                remoteResult: {
                                    data: storeResult
                                },
                                context: context,
                                variables: variables,
                                onlyRunForcedResolvers: true
                            }).then(function(result) {
                                _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                                _this.broadcastQueries();
                                return result;
                            })
                        ];
                        this.broadcastQueries();
                        return [
                            2,
                            {
                                data: storeResult
                            }
                        ];
                }
            });
        });
    };
    QueryManager.prototype.markQueryResult = function(queryId, result, _a, fetchMoreForQueryId) {
        var fetchPolicy = _a.fetchPolicy, variables = _a.variables, errorPolicy = _a.errorPolicy;
        if (fetchPolicy === 'no-cache') this.setQuery(queryId, function() {
            return {
                newData: {
                    result: result.data,
                    complete: true
                }
            };
        });
        else this.dataStore.markQueryResult(result, this.getQuery(queryId).document, variables, fetchMoreForQueryId, errorPolicy === 'ignore' || errorPolicy === 'all');
    };
    QueryManager.prototype.queryListenerForObserver = function(queryId, options, observer) {
        var _this = this;
        function invoke(method, argument) {
            if (observer[method]) try {
                observer[method](argument);
            } catch (e) {}
            else method;
        }
        return function(queryStoreValue, newData) {
            _this.invalidate(queryId, false);
            if (!queryStoreValue) return;
            var _a = _this.getQuery(queryId), observableQuery = _a.observableQuery, document = _a.document;
            var fetchPolicy = observableQuery ? observableQuery.options.fetchPolicy : options.fetchPolicy;
            if (fetchPolicy === 'standby') return;
            var loading = $2e58ccba3067efe5$var$isNetworkRequestInFlight(queryStoreValue.networkStatus);
            var lastResult = observableQuery && observableQuery.getLastResult();
            var networkStatusChanged = !!(lastResult && lastResult.networkStatus !== queryStoreValue.networkStatus);
            var shouldNotifyIfLoading = options.returnPartialData || !newData && queryStoreValue.previousVariables || networkStatusChanged && options.notifyOnNetworkStatusChange || fetchPolicy === 'cache-only' || fetchPolicy === 'cache-and-network';
            if (loading && !shouldNotifyIfLoading) return;
            var hasGraphQLErrors = $2e58ccba3067efe5$var$isNonEmptyArray(queryStoreValue.graphQLErrors);
            var errorPolicy = observableQuery && observableQuery.options.errorPolicy || options.errorPolicy || 'none';
            if (errorPolicy === 'none' && hasGraphQLErrors || queryStoreValue.networkError) return invoke('error', new $2e58ccba3067efe5$export$26a337512320b8c6({
                graphQLErrors: queryStoreValue.graphQLErrors,
                networkError: queryStoreValue.networkError
            }));
            try {
                var data = void 0;
                var isMissing = void 0;
                if (newData) {
                    if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'network-only') _this.setQuery(queryId, function() {
                        return {
                            newData: null
                        };
                    });
                    data = newData.result;
                    isMissing = !newData.complete;
                } else {
                    var lastError = observableQuery && observableQuery.getLastError();
                    var errorStatusChanged = errorPolicy !== 'none' && (lastError && lastError.graphQLErrors) !== queryStoreValue.graphQLErrors;
                    if (lastResult && lastResult.data && !errorStatusChanged) {
                        data = lastResult.data;
                        isMissing = false;
                    } else {
                        var diffResult = _this.dataStore.getCache().diff({
                            query: document,
                            variables: queryStoreValue.previousVariables || queryStoreValue.variables,
                            returnPartialData: true,
                            optimistic: true
                        });
                        data = diffResult.result;
                        isMissing = !diffResult.complete;
                    }
                }
                var stale = isMissing && !(options.returnPartialData || fetchPolicy === 'cache-only');
                var resultFromStore = {
                    data: stale ? lastResult && lastResult.data : data,
                    loading: loading,
                    networkStatus: queryStoreValue.networkStatus,
                    stale: stale
                };
                if (errorPolicy === 'all' && hasGraphQLErrors) resultFromStore.errors = queryStoreValue.graphQLErrors;
                invoke('next', resultFromStore);
            } catch (networkError) {
                invoke('error', new $2e58ccba3067efe5$export$26a337512320b8c6({
                    networkError: networkError
                }));
            }
        };
    };
    QueryManager.prototype.transform = function(document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var cache = this.dataStore.getCache();
            var transformed = cache.transformDocument(document);
            var forLink = (0, $bXCDP.removeConnectionDirectiveFromDocument)(cache.transformForLink(transformed));
            var clientQuery = this.localState.clientQuery(transformed);
            var serverQuery = this.localState.serverQuery(forLink);
            var cacheEntry_1 = {
                document: transformed,
                hasClientExports: (0, $bXCDP.hasClientExports)(transformed),
                hasForcedResolvers: this.localState.shouldForceResolvers(transformed),
                clientQuery: clientQuery,
                serverQuery: serverQuery,
                defaultVars: (0, $bXCDP.getDefaultValues)((0, $bXCDP.getOperationDefinition)(transformed))
            };
            var add = function(doc) {
                if (doc && !transformCache.has(doc)) transformCache.set(doc, cacheEntry_1);
            };
            add(document);
            add(transformed);
            add(clientQuery);
            add(serverQuery);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function(document, variables) {
        return (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, this.transform(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function(options, shouldSubscribe) {
        if (shouldSubscribe === void 0) shouldSubscribe = true;
        (0, $9b1ec3529a6f8606$export$f5708dca728d7177)(options.fetchPolicy !== 'standby', 11);
        options.variables = this.getVariables(options.query, options.variables);
        if (typeof options.notifyOnNetworkStatusChange === 'undefined') options.notifyOnNetworkStatusChange = false;
        var transformedOptions = (0, $dEf6I.__assign)({}, options);
        return new $2e58ccba3067efe5$export$6c1b56eac59c9584({
            queryManager: this,
            options: transformedOptions,
            shouldSubscribe: shouldSubscribe
        });
    };
    QueryManager.prototype.query = function(options) {
        var _this = this;
        (0, $9b1ec3529a6f8606$export$f5708dca728d7177)(options.query, 12);
        (0, $9b1ec3529a6f8606$export$f5708dca728d7177)(options.query.kind === 'Document', 13);
        (0, $9b1ec3529a6f8606$export$f5708dca728d7177)(!options.returnPartialData, 14);
        (0, $9b1ec3529a6f8606$export$f5708dca728d7177)(!options.pollInterval, 15);
        return new Promise(function(resolve, reject) {
            var watchedQuery = _this.watchQuery(options, false);
            _this.fetchQueryRejectFns.set("query:" + watchedQuery.queryId, reject);
            watchedQuery.result().then(resolve, reject).then(function() {
                return _this.fetchQueryRejectFns.delete("query:" + watchedQuery.queryId);
            });
        });
    };
    QueryManager.prototype.generateQueryId = function() {
        return String(this.idCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function(queryId) {
        this.stopPollingQuery(queryId);
        this.queryStore.stopQuery(queryId);
        this.invalidate(queryId);
    };
    QueryManager.prototype.addQueryListener = function(queryId, listener) {
        this.setQuery(queryId, function(_a) {
            var listeners = _a.listeners;
            listeners.add(listener);
            return {
                invalidated: false
            };
        });
    };
    QueryManager.prototype.updateQueryWatch = function(queryId, document, options) {
        var _this = this;
        var cancel = this.getQuery(queryId).cancel;
        if (cancel) cancel();
        var previousResult = function() {
            var previousResult = null;
            var observableQuery = _this.getQuery(queryId).observableQuery;
            if (observableQuery) {
                var lastResult = observableQuery.getLastResult();
                if (lastResult) previousResult = lastResult.data;
            }
            return previousResult;
        };
        return this.dataStore.getCache().watch({
            query: document,
            variables: options.variables,
            optimistic: true,
            previousResult: previousResult,
            callback: function(newData) {
                _this.setQuery(queryId, function() {
                    return {
                        invalidated: true,
                        newData: newData
                    };
                });
            }
        });
    };
    QueryManager.prototype.addObservableQuery = function(queryId, observableQuery) {
        this.setQuery(queryId, function() {
            return {
                observableQuery: observableQuery
            };
        });
    };
    QueryManager.prototype.removeObservableQuery = function(queryId) {
        var cancel = this.getQuery(queryId).cancel;
        this.setQuery(queryId, function() {
            return {
                observableQuery: null
            };
        });
        if (cancel) cancel();
    };
    QueryManager.prototype.clearStore = function() {
        this.fetchQueryRejectFns.forEach(function(reject) {
            reject(new (0, $9b1ec3529a6f8606$export$cea12affaee22fe8)(16));
        });
        var resetIds = [];
        this.queries.forEach(function(_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery) resetIds.push(queryId);
        });
        this.queryStore.reset(resetIds);
        this.mutationStore.reset();
        return this.dataStore.reset();
    };
    QueryManager.prototype.resetStore = function() {
        var _this = this;
        return this.clearStore().then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    QueryManager.prototype.reFetchObservableQueries = function(includeStandby) {
        var _this = this;
        if (includeStandby === void 0) includeStandby = false;
        var observableQueryPromises = [];
        this.queries.forEach(function(_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery) {
                var fetchPolicy = observableQuery.options.fetchPolicy;
                observableQuery.resetLastResults();
                if (fetchPolicy !== 'cache-only' && (includeStandby || fetchPolicy !== 'standby')) observableQueryPromises.push(observableQuery.refetch());
                _this.setQuery(queryId, function() {
                    return {
                        newData: null
                    };
                });
                _this.invalidate(queryId);
            }
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.observeQuery = function(queryId, options, observer) {
        this.addQueryListener(queryId, this.queryListenerForObserver(queryId, options, observer));
        return this.fetchQuery(queryId, options);
    };
    QueryManager.prototype.startQuery = function(queryId, options, listener) {
        this.addQueryListener(queryId, listener);
        this.fetchQuery(queryId, options).catch(function() {
            return undefined;
        });
        return queryId;
    };
    QueryManager.prototype.startGraphQLSubscription = function(_a) {
        var _this = this;
        var query = _a.query, fetchPolicy = _a.fetchPolicy, variables = _a.variables;
        query = this.transform(query).document;
        variables = this.getVariables(query, variables);
        var makeObservable = function(variables) {
            return _this.getObservableFromLink(query, {}, variables, false).map(function(result) {
                if (!fetchPolicy || fetchPolicy !== 'no-cache') {
                    _this.dataStore.markSubscriptionResult(result, query, variables);
                    _this.broadcastQueries();
                }
                if ((0, $bXCDP.graphQLResultHasError)(result)) throw new $2e58ccba3067efe5$export$26a337512320b8c6({
                    graphQLErrors: result.errors
                });
                return result;
            });
        };
        if (this.transform(query).hasClientExports) {
            var observablePromise_1 = this.localState.addExportedVariables(query, variables).then(makeObservable);
            return new $2e58ccba3067efe5$var$Observable(function(observer) {
                var sub = null;
                observablePromise_1.then(function(observable) {
                    return sub = observable.subscribe(observer);
                }, observer.error);
                return function() {
                    return sub && sub.unsubscribe();
                };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function(queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function(queryId) {
        this.fetchQueryRejectFns.delete("query:" + queryId);
        this.fetchQueryRejectFns.delete("fetchRequest:" + queryId);
        this.getQuery(queryId).subscriptions.forEach(function(x) {
            return x.unsubscribe();
        });
        this.queries.delete(queryId);
    };
    QueryManager.prototype.getCurrentQueryResult = function(observableQuery, optimistic) {
        if (optimistic === void 0) optimistic = true;
        var _a = observableQuery.options, variables = _a.variables, query = _a.query, fetchPolicy = _a.fetchPolicy, returnPartialData = _a.returnPartialData;
        var lastResult = observableQuery.getLastResult();
        var newData = this.getQuery(observableQuery.queryId).newData;
        if (newData && newData.complete) return {
            data: newData.result,
            partial: false
        };
        if (fetchPolicy === 'no-cache' || fetchPolicy === 'network-only') return {
            data: undefined,
            partial: false
        };
        var _b = this.dataStore.getCache().diff({
            query: query,
            variables: variables,
            previousResult: lastResult ? lastResult.data : undefined,
            returnPartialData: true,
            optimistic: optimistic
        }), result = _b.result, complete = _b.complete;
        return {
            data: complete || returnPartialData ? result : void 0,
            partial: !complete
        };
    };
    QueryManager.prototype.getQueryWithPreviousResult = function(queryIdOrObservable) {
        var observableQuery;
        if (typeof queryIdOrObservable === 'string') {
            var foundObserveableQuery = this.getQuery(queryIdOrObservable).observableQuery;
            (0, $9b1ec3529a6f8606$export$f5708dca728d7177)(foundObserveableQuery, 17);
            observableQuery = foundObserveableQuery;
        } else observableQuery = queryIdOrObservable;
        var _a = observableQuery.options, variables = _a.variables, query = _a.query;
        return {
            previousResult: this.getCurrentQueryResult(observableQuery, false).data,
            variables: variables,
            document: query
        };
    };
    QueryManager.prototype.broadcastQueries = function() {
        var _this = this;
        this.onBroadcast();
        this.queries.forEach(function(info, id) {
            if (info.invalidated) {
                const name = info && info.document && info.document.definitions && info.document.definitions[0] && info.document.definitions[0].name && info.document.definitions[0].name.value;
                const stats = typeof window !== 'undefined' && window && window.__APOLLO_STATS__ && window.__APOLLO_STATS__.broadcast;
                if (name && stats) {
                    stats[name] = stats[name] || 0;
                    stats[name]++;
                }
                info.listeners.forEach(function(listener) {
                    if (listener) listener(_this.queryStore.get(id), info.newData);
                });
            }
        });
    };
    QueryManager.prototype.getLocalState = function() {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function(query, context, variables, deduplication) {
        var _this = this;
        if (deduplication === void 0) deduplication = this.queryDeduplication;
        var observable;
        var serverQuery = this.transform(query).serverQuery;
        if (serverQuery) {
            var _a = this, inFlightLinkObservables_1 = _a.inFlightLinkObservables, link = _a.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: (0, $bXCDP.getOperationName)(serverQuery) || void 0,
                context: this.prepareContext((0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, context), {
                    forceFetch: !deduplication
                }))
            };
            context = operation.context;
            if (deduplication) {
                var byVariables_1 = inFlightLinkObservables_1.get(serverQuery) || new Map();
                inFlightLinkObservables_1.set(serverQuery, byVariables_1);
                var varJson_1 = JSON.stringify(variables);
                observable = byVariables_1.get(varJson_1);
                if (!observable) {
                    byVariables_1.set(varJson_1, observable = $2e58ccba3067efe5$var$multiplex((0, $dcDKw.execute)(link, operation)));
                    var cleanup = function() {
                        byVariables_1.delete(varJson_1);
                        if (!byVariables_1.size) inFlightLinkObservables_1.delete(serverQuery);
                        cleanupSub_1.unsubscribe();
                    };
                    var cleanupSub_1 = observable.subscribe({
                        next: cleanup,
                        error: cleanup,
                        complete: cleanup
                    });
                }
            } else observable = $2e58ccba3067efe5$var$multiplex((0, $dcDKw.execute)(link, operation));
        } else {
            observable = $2e58ccba3067efe5$var$Observable.of({
                data: {}
            });
            context = this.prepareContext(context);
        }
        var clientQuery = this.transform(query).clientQuery;
        if (clientQuery) observable = $2e58ccba3067efe5$var$asyncMap(observable, function(result) {
            return _this.localState.runResolvers({
                document: clientQuery,
                remoteResult: result,
                context: context,
                variables: variables
            });
        });
        return observable;
    };
    QueryManager.prototype.fetchRequest = function(_a) {
        var _this = this;
        var requestId = _a.requestId, queryId = _a.queryId, document = _a.document, options = _a.options, fetchMoreForQueryId = _a.fetchMoreForQueryId;
        var variables = options.variables, _b = options.errorPolicy, errorPolicy = _b === void 0 ? 'none' : _b, fetchPolicy = options.fetchPolicy;
        var resultFromStore;
        var errorsFromStore;
        return new Promise(function(resolve, reject) {
            var observable = _this.getObservableFromLink(document, options.context, variables);
            var fqrfId = "fetchRequest:" + queryId;
            _this.fetchQueryRejectFns.set(fqrfId, reject);
            var cleanup = function() {
                _this.fetchQueryRejectFns.delete(fqrfId);
                _this.setQuery(queryId, function(_a) {
                    var subscriptions = _a.subscriptions;
                    subscriptions.delete(subscription);
                });
            };
            var subscription = observable.map(function(result) {
                if (requestId >= _this.getQuery(queryId).lastRequestId) {
                    _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                    _this.queryStore.markQueryResult(queryId, result, fetchMoreForQueryId);
                    _this.invalidate(queryId);
                    _this.invalidate(fetchMoreForQueryId);
                    _this.broadcastQueries();
                }
                if (errorPolicy === 'none' && $2e58ccba3067efe5$var$isNonEmptyArray(result.errors)) return reject(new $2e58ccba3067efe5$export$26a337512320b8c6({
                    graphQLErrors: result.errors
                }));
                if (errorPolicy === 'all') errorsFromStore = result.errors;
                if (fetchMoreForQueryId || fetchPolicy === 'no-cache') resultFromStore = result.data;
                else {
                    var _a = _this.dataStore.getCache().diff({
                        variables: variables,
                        query: document,
                        optimistic: false,
                        returnPartialData: true
                    }), result_1 = _a.result, complete = _a.complete;
                    if (complete || options.returnPartialData) resultFromStore = result_1;
                }
            }).subscribe({
                error: function(error) {
                    cleanup();
                    reject(error);
                },
                complete: function() {
                    cleanup();
                    resolve({
                        data: resultFromStore,
                        errors: errorsFromStore,
                        loading: false,
                        networkStatus: $2e58ccba3067efe5$export$bd096ddbd246c79c.ready,
                        stale: false
                    });
                }
            });
            _this.setQuery(queryId, function(_a) {
                var subscriptions = _a.subscriptions;
                subscriptions.add(subscription);
            });
        });
    };
    QueryManager.prototype.getQuery = function(queryId) {
        return this.queries.get(queryId) || {
            listeners: new Set(),
            invalidated: false,
            document: null,
            newData: null,
            lastRequestId: 1,
            observableQuery: null,
            subscriptions: new Set()
        };
    };
    QueryManager.prototype.setQuery = function(queryId, updater) {
        var prev = this.getQuery(queryId);
        var newInfo = (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, prev), updater(prev));
        this.queries.set(queryId, newInfo);
    };
    QueryManager.prototype.invalidate = function(queryId, invalidated) {
        if (invalidated === void 0) invalidated = true;
        if (queryId) this.setQuery(queryId, function() {
            return {
                invalidated: invalidated
            };
        });
    };
    QueryManager.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var newContext = this.localState.prepareContext(context);
        return (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, newContext), {
            clientAwareness: this.clientAwareness
        });
    };
    QueryManager.prototype.checkInFlight = function(queryId) {
        var query = this.queryStore.get(queryId);
        return query && query.networkStatus !== $2e58ccba3067efe5$export$bd096ddbd246c79c.ready && query.networkStatus !== $2e58ccba3067efe5$export$bd096ddbd246c79c.error;
    };
    QueryManager.prototype.startPollingQuery = function(options, queryId, listener) {
        var _this = this;
        var pollInterval = options.pollInterval;
        (0, $9b1ec3529a6f8606$export$f5708dca728d7177)(pollInterval, 18);
        if (!this.ssrMode) {
            var info = this.pollingInfoByQueryId.get(queryId);
            if (!info) this.pollingInfoByQueryId.set(queryId, info = {});
            info.interval = pollInterval;
            info.options = (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, options), {
                fetchPolicy: 'network-only'
            });
            var maybeFetch_1 = function() {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    if (_this.checkInFlight(queryId)) poll_1();
                    else _this.fetchQuery(queryId, info.options, $2e58ccba3067efe5$export$160bafb6ac1e0641.poll).then(poll_1, poll_1);
                }
            };
            var poll_1 = function() {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    clearTimeout(info.timeout);
                    info.timeout = setTimeout(maybeFetch_1, info.interval);
                }
            };
            if (listener) this.addQueryListener(queryId, listener);
            poll_1();
        }
        return queryId;
    };
    QueryManager.prototype.stopPollingQuery = function(queryId) {
        this.pollingInfoByQueryId.delete(queryId);
    };
    return QueryManager;
}();
var $2e58ccba3067efe5$var$DataStore = function() {
    function DataStore(initialCache) {
        this.cache = initialCache;
    }
    DataStore.prototype.getCache = function() {
        return this.cache;
    };
    DataStore.prototype.markQueryResult = function(result, document, variables, fetchMoreForQueryId, ignoreErrors) {
        if (ignoreErrors === void 0) ignoreErrors = false;
        var writeWithErrors = !(0, $bXCDP.graphQLResultHasError)(result);
        if (ignoreErrors && (0, $bXCDP.graphQLResultHasError)(result) && result.data) writeWithErrors = true;
        if (!fetchMoreForQueryId && writeWithErrors) this.cache.write({
            result: result.data,
            dataId: 'ROOT_QUERY',
            query: document,
            variables: variables
        });
    };
    DataStore.prototype.markSubscriptionResult = function(result, document, variables) {
        if (!(0, $bXCDP.graphQLResultHasError)(result)) this.cache.write({
            result: result.data,
            dataId: 'ROOT_SUBSCRIPTION',
            query: document,
            variables: variables
        });
    };
    DataStore.prototype.markMutationInit = function(mutation) {
        var _this = this;
        if (mutation.optimisticResponse) {
            var optimistic_1;
            if (typeof mutation.optimisticResponse === 'function') optimistic_1 = mutation.optimisticResponse(mutation.variables);
            else optimistic_1 = mutation.optimisticResponse;
            this.cache.recordOptimisticTransaction(function(c) {
                var orig = _this.cache;
                _this.cache = c;
                try {
                    _this.markMutationResult({
                        mutationId: mutation.mutationId,
                        result: {
                            data: optimistic_1
                        },
                        document: mutation.document,
                        variables: mutation.variables,
                        updateQueries: mutation.updateQueries,
                        update: mutation.update
                    });
                } finally{
                    _this.cache = orig;
                }
            }, mutation.mutationId);
        }
    };
    DataStore.prototype.markMutationResult = function(mutation) {
        var _this = this;
        if (!(0, $bXCDP.graphQLResultHasError)(mutation.result)) {
            var cacheWrites_1 = [
                {
                    result: mutation.result.data,
                    dataId: 'ROOT_MUTATION',
                    query: mutation.document,
                    variables: mutation.variables
                }
            ];
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) Object.keys(updateQueries_1).forEach(function(id) {
                var _a = updateQueries_1[id], query = _a.query, updater = _a.updater;
                var _b = _this.cache.diff({
                    query: query.document,
                    variables: query.variables,
                    returnPartialData: true,
                    optimistic: false
                }), currentQueryResult = _b.result, complete = _b.complete;
                if (complete) {
                    var nextQueryResult = (0, $bXCDP.tryFunctionOrLogError)(function() {
                        return updater(currentQueryResult, {
                            mutationResult: mutation.result,
                            queryName: (0, $bXCDP.getOperationName)(query.document) || undefined,
                            queryVariables: query.variables
                        });
                    });
                    if (nextQueryResult) cacheWrites_1.push({
                        result: nextQueryResult,
                        dataId: 'ROOT_QUERY',
                        query: query.document,
                        variables: query.variables
                    });
                }
            });
            this.cache.performTransaction(function(c) {
                cacheWrites_1.forEach(function(write) {
                    return c.write(write);
                });
                var update = mutation.update;
                if (update) (0, $bXCDP.tryFunctionOrLogError)(function() {
                    return update(c, mutation.result);
                });
            });
        }
    };
    DataStore.prototype.markMutationComplete = function(_a) {
        var mutationId = _a.mutationId, optimisticResponse = _a.optimisticResponse;
        if (optimisticResponse) this.cache.removeOptimistic(mutationId);
    };
    DataStore.prototype.markUpdateQueryResult = function(document, variables, newResult) {
        this.cache.write({
            result: newResult,
            dataId: 'ROOT_QUERY',
            variables: variables,
            query: document
        });
    };
    DataStore.prototype.reset = function() {
        return this.cache.reset();
    };
    return DataStore;
}();
var $2e58ccba3067efe5$var$version = "2.6.10";
var $2e58ccba3067efe5$var$hasSuggestedDevtools = false;
var $2e58ccba3067efe5$export$13f5a5f0f1dbab88 = function() {
    function ApolloClient(options) {
        var _this = this;
        this.defaultOptions = {};
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        var cache = options.cache, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, connectToDevTools = options.connectToDevTools, _c = options.queryDeduplication, queryDeduplication = _c === void 0 ? true : _c, defaultOptions = options.defaultOptions, _d = options.assumeImmutableResults, assumeImmutableResults = _d === void 0 ? false : _d, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
        var link = options.link;
        if (!link && resolvers) link = (0, $dcDKw.ApolloLink).empty();
        if (!link || !cache) throw new (0, $9b1ec3529a6f8606$export$cea12affaee22fe8)(4);
        this.link = link;
        this.cache = cache;
        this.store = new $2e58ccba3067efe5$var$DataStore(cache);
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || {};
        this.typeDefs = typeDefs;
        if (ssrForceFetchDelay) setTimeout(function() {
            return _this.disableNetworkFetches = false;
        }, ssrForceFetchDelay);
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        var defaultConnectToDevTools = false;
        if (typeof connectToDevTools === 'undefined' ? defaultConnectToDevTools : connectToDevTools && typeof window !== 'undefined') window.__APOLLO_CLIENT__ = this;
        this.version = $2e58ccba3067efe5$var$version;
        this.localState = new $2e58ccba3067efe5$var$LocalState({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher
        });
        this.queryManager = new $2e58ccba3067efe5$var$QueryManager({
            link: this.link,
            store: this.store,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            clientAwareness: {
                name: clientAwarenessName,
                version: clientAwarenessVersion
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: function() {
                if (_this.devToolsHookCb) _this.devToolsHookCb({
                    action: {},
                    state: {
                        queries: _this.queryManager.queryStore.getStore(),
                        mutations: _this.queryManager.mutationStore.getStore()
                    },
                    dataWithOptimisticResults: _this.cache.extract(true)
                });
            }
        });
    }
    ApolloClient.prototype.stop = function() {
        this.queryManager.stop();
    };
    ApolloClient.prototype.watchQuery = function(options) {
        if (this.defaultOptions.watchQuery) options = (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, this.defaultOptions.watchQuery), options);
        if (this.disableNetworkFetches && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options = (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, options), {
            fetchPolicy: 'cache-first'
        });
        return this.queryManager.watchQuery(options);
    };
    ApolloClient.prototype.query = function(options) {
        if (this.defaultOptions.query) options = (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, this.defaultOptions.query), options);
        (0, $9b1ec3529a6f8606$export$f5708dca728d7177)(options.fetchPolicy !== 'cache-and-network', 5);
        if (this.disableNetworkFetches && options.fetchPolicy === 'network-only') options = (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, options), {
            fetchPolicy: 'cache-first'
        });
        return this.queryManager.query(options);
    };
    ApolloClient.prototype.mutate = function(options) {
        if (this.defaultOptions.mutate) options = (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, this.defaultOptions.mutate), options);
        return this.queryManager.mutate(options);
    };
    ApolloClient.prototype.subscribe = function(options) {
        return this.queryManager.startGraphQLSubscription(options);
    };
    ApolloClient.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readQuery(options, optimistic);
    };
    ApolloClient.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readFragment(options, optimistic);
    };
    ApolloClient.prototype.writeQuery = function(options) {
        var result = this.cache.writeQuery(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeFragment = function(options) {
        var result = this.cache.writeFragment(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeData = function(options) {
        var result = this.cache.writeData(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.__actionHookForDevTools = function(cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function(payload) {
        return (0, $dcDKw.execute)(this.link, payload);
    };
    ApolloClient.prototype.initQueryManager = function() {
        return this.queryManager;
    };
    ApolloClient.prototype.resetStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore();
        }).then(function() {
            return Promise.all(_this.resetStoreCallbacks.map(function(fn) {
                return fn();
            }));
        }).then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    ApolloClient.prototype.clearStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore();
        }).then(function() {
            return Promise.all(_this.clearStoreCallbacks.map(function(fn) {
                return fn();
            }));
        });
    };
    ApolloClient.prototype.onResetStore = function(cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function() {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.onClearStore = function(cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function() {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.reFetchObservableQueries = function(includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    ApolloClient.prototype.extract = function(optimistic) {
        return this.cache.extract(optimistic);
    };
    ApolloClient.prototype.restore = function(serializedState) {
        return this.cache.restore(serializedState);
    };
    ApolloClient.prototype.addResolvers = function(resolvers) {
        this.localState.addResolvers(resolvers);
    };
    ApolloClient.prototype.setResolvers = function(resolvers) {
        this.localState.setResolvers(resolvers);
    };
    ApolloClient.prototype.getResolvers = function() {
        return this.localState.getResolvers();
    };
    ApolloClient.prototype.setLocalStateFragmentMatcher = function(fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    return ApolloClient;
}();
var $2e58ccba3067efe5$export$2e2bcd8739ae039 = $2e58ccba3067efe5$export$13f5a5f0f1dbab88;


function $1c4c77440cd9ad0f$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message);
}


function $ef2bbefcdda61038$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $ef2bbefcdda61038$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $ef2bbefcdda61038$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $ef2bbefcdda61038$var$_typeof(obj);
}
function $ef2bbefcdda61038$export$2e2bcd8739ae039(value) {
    return $ef2bbefcdda61038$var$_typeof(value) == 'object' && value !== null;
}


// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $ce670c3d0cd6efc8$export$f6cdee3c26d6da57 = typeof Symbol === 'function' && Symbol.iterator != null ? Symbol.iterator : '@@iterator'; // In ES2017 (or a polyfilled) environment, this will be Symbol.asyncIterator
var $ce670c3d0cd6efc8$export$8d0083df0471478e = typeof Symbol === 'function' && Symbol.asyncIterator != null ? Symbol.asyncIterator : '@@asyncIterator'; // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $ce670c3d0cd6efc8$export$5deadc579ccc7c9c = typeof Symbol === 'function' && Symbol.toStringTag != null ? Symbol.toStringTag : '@@toStringTag';


/**
 * Represents a location in a Source.
 */ /**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */ function $54ae59158d4c6e5d$export$e7fd20fad3cf4b5f(source, position) {
    var lineRegexp = /\r\n|[\n\r]/g;
    var line = 1;
    var column = position + 1;
    var match;
    while((match = lineRegexp.exec(source.body)) && match.index < position){
        line += 1;
        column = position + 1 - (match.index + match[0].length);
    }
    return {
        line: line,
        column: column
    };
}



function $eb6d3deb3e2a68a4$export$96a9681e539deed(location) {
    return $eb6d3deb3e2a68a4$export$867940333fd9f869(location.source, (0, $54ae59158d4c6e5d$export$e7fd20fad3cf4b5f)(location.source, location.start));
}
function $eb6d3deb3e2a68a4$export$867940333fd9f869(source, sourceLocation) {
    var firstLineColumnOffset = source.locationOffset.column - 1;
    var body = $eb6d3deb3e2a68a4$var$whitespace(firstLineColumnOffset) + source.body;
    var lineIndex = sourceLocation.line - 1;
    var lineOffset = source.locationOffset.line - 1;
    var lineNum = sourceLocation.line + lineOffset;
    var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    var columnNum = sourceLocation.column + columnOffset;
    var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
    var lines = body.split(/\r\n|[\n\r]/g);
    var locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        var subLineIndex = Math.floor(columnNum / 80);
        var subLineColumnNum = columnNum % 80;
        var subLines = [];
        for(var i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + $eb6d3deb3e2a68a4$var$printPrefixedLines([
            [
                "".concat(lineNum),
                subLines[0]
            ]
        ].concat(subLines.slice(1, subLineIndex + 1).map(function(subLine) {
            return [
                '',
                subLine
            ];
        }), [
            [
                ' ',
                $eb6d3deb3e2a68a4$var$whitespace(subLineColumnNum - 1) + '^'
            ],
            [
                '',
                subLines[subLineIndex + 1]
            ]
        ]));
    }
    return locationStr + $eb6d3deb3e2a68a4$var$printPrefixedLines([
        [
            "".concat(lineNum - 1),
            lines[lineIndex - 1]
        ],
        [
            "".concat(lineNum),
            locationLine
        ],
        [
            '',
            $eb6d3deb3e2a68a4$var$whitespace(columnNum - 1) + '^'
        ],
        [
            "".concat(lineNum + 1),
            lines[lineIndex + 1]
        ]
    ]);
}
function $eb6d3deb3e2a68a4$var$printPrefixedLines(lines) {
    var existingLines = lines.filter(function(_ref) {
        var _ = _ref[0], line = _ref[1];
        return line !== undefined;
    });
    var padLen = Math.max.apply(Math, existingLines.map(function(_ref2) {
        var prefix = _ref2[0];
        return prefix.length;
    }));
    return existingLines.map(function(_ref3) {
        var prefix = _ref3[0], line = _ref3[1];
        return $eb6d3deb3e2a68a4$var$leftPad(padLen, prefix) + (line ? ' | ' + line : ' |');
    }).join('\n');
}
function $eb6d3deb3e2a68a4$var$whitespace(len) {
    return Array(len + 1).join(' ');
}
function $eb6d3deb3e2a68a4$var$leftPad(len, str) {
    return $eb6d3deb3e2a68a4$var$whitespace(len - str.length) + str;
}


function $982b88782a45b92f$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $982b88782a45b92f$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $982b88782a45b92f$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $982b88782a45b92f$var$_typeof(obj);
}
function $982b88782a45b92f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $982b88782a45b92f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $982b88782a45b92f$var$ownKeys(Object(source), true).forEach(function(key) {
            $982b88782a45b92f$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $982b88782a45b92f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $982b88782a45b92f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $982b88782a45b92f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $982b88782a45b92f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $982b88782a45b92f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $982b88782a45b92f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $982b88782a45b92f$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $982b88782a45b92f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $982b88782a45b92f$var$_setPrototypeOf(subClass, superClass);
}
function $982b88782a45b92f$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $982b88782a45b92f$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $982b88782a45b92f$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $982b88782a45b92f$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $982b88782a45b92f$var$_possibleConstructorReturn(this, result);
    };
}
function $982b88782a45b92f$var$_possibleConstructorReturn(self, call) {
    if (call && ($982b88782a45b92f$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $982b88782a45b92f$var$_assertThisInitialized(self);
}
function $982b88782a45b92f$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $982b88782a45b92f$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $982b88782a45b92f$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$982b88782a45b92f$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $982b88782a45b92f$var$_construct(Class, arguments, $982b88782a45b92f$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $982b88782a45b92f$var$_setPrototypeOf(Wrapper, Class);
    };
    return $982b88782a45b92f$var$_wrapNativeSuper(Class);
}
function $982b88782a45b92f$var$_construct(Parent, args, Class) {
    if ($982b88782a45b92f$var$_isNativeReflectConstruct()) $982b88782a45b92f$var$_construct = Reflect.construct;
    else $982b88782a45b92f$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $982b88782a45b92f$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $982b88782a45b92f$var$_construct.apply(null, arguments);
}
function $982b88782a45b92f$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $982b88782a45b92f$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $982b88782a45b92f$var$_setPrototypeOf(o, p) {
    $982b88782a45b92f$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $982b88782a45b92f$var$_setPrototypeOf(o, p);
}
function $982b88782a45b92f$var$_getPrototypeOf(o) {
    $982b88782a45b92f$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $982b88782a45b92f$var$_getPrototypeOf(o);
}
var $982b88782a45b92f$export$92d6ed0888e7cb7f = /*#__PURE__*/ function(_Error) {
    $982b88782a45b92f$var$_inherits(GraphQLError, _Error);
    var _super = $982b88782a45b92f$var$_createSuper(GraphQLError);
    /**
   * An array of { line, column } locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /**
   * The original error thrown from a field resolver during execution.
   */ /**
   * Extension fields to add to the formatted error.
   */ function GraphQLError(message, nodes, source, positions, path, originalError, extensions) {
        var _nodeLocations, _nodeLocations2, _nodeLocations3;
        var _this;
        $982b88782a45b92f$var$_classCallCheck(this, GraphQLError);
        _this = _super.call(this, message);
        _this.name = 'GraphQLError';
        _this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.
        _this.nodes = $982b88782a45b92f$var$undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
            nodes
        ] : undefined);
        var nodeLocations = [];
        for(var _i2 = 0, _ref3 = (_this$nodes = _this.nodes) !== null && _this$nodes !== void 0 ? _this$nodes : []; _i2 < _ref3.length; _i2++){
            var _this$nodes;
            var _ref4 = _ref3[_i2];
            var loc = _ref4.loc;
            if (loc != null) nodeLocations.push(loc);
        }
        nodeLocations = $982b88782a45b92f$var$undefinedIfEmpty(nodeLocations); // Compute locations in the source for the given nodes/positions.
        _this.source = source !== null && source !== void 0 ? source : (_nodeLocations = nodeLocations) === null || _nodeLocations === void 0 ? void 0 : _nodeLocations[0].source;
        _this.positions = positions !== null && positions !== void 0 ? positions : (_nodeLocations2 = nodeLocations) === null || _nodeLocations2 === void 0 ? void 0 : _nodeLocations2.map(function(loc) {
            return loc.start;
        });
        _this.locations = positions && source ? positions.map(function(pos) {
            return (0, $54ae59158d4c6e5d$export$e7fd20fad3cf4b5f)(source, pos);
        }) : (_nodeLocations3 = nodeLocations) === null || _nodeLocations3 === void 0 ? void 0 : _nodeLocations3.map(function(loc) {
            return (0, $54ae59158d4c6e5d$export$e7fd20fad3cf4b5f)(loc.source, loc.start);
        });
        _this.path = path !== null && path !== void 0 ? path : undefined;
        var originalExtensions = originalError === null || originalError === void 0 ? void 0 : originalError.extensions;
        if (extensions == null && (0, $ef2bbefcdda61038$export$2e2bcd8739ae039)(originalExtensions)) _this.extensions = $982b88782a45b92f$var$_objectSpread({}, originalExtensions);
        else _this.extensions = extensions !== null && extensions !== void 0 ? extensions : {};
         // By being enumerable, JSON.stringify will include bellow properties in the resulting output.
        // This ensures that the simplest possible GraphQL service adheres to the spec.
        Object.defineProperties($982b88782a45b92f$var$_assertThisInitialized(_this), {
            message: {
                enumerable: true
            },
            locations: {
                enumerable: _this.locations != null
            },
            path: {
                enumerable: _this.path != null
            },
            extensions: {
                enumerable: _this.extensions != null && Object.keys(_this.extensions).length > 0
            },
            name: {
                enumerable: false
            },
            nodes: {
                enumerable: false
            },
            source: {
                enumerable: false
            },
            positions: {
                enumerable: false
            },
            originalError: {
                enumerable: false
            }
        }); // Include (non-enumerable) stack trace.
        if (originalError !== null && originalError !== void 0 && originalError.stack) {
            Object.defineProperty($982b88782a45b92f$var$_assertThisInitialized(_this), 'stack', {
                value: originalError.stack,
                writable: true,
                configurable: true
            });
            return $982b88782a45b92f$var$_possibleConstructorReturn(_this);
        } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
        if (Error.captureStackTrace) Error.captureStackTrace($982b88782a45b92f$var$_assertThisInitialized(_this), GraphQLError);
        else Object.defineProperty($982b88782a45b92f$var$_assertThisInitialized(_this), 'stack', {
            value: Error().stack,
            writable: true,
            configurable: true
        });
        return _this;
    }
    $982b88782a45b92f$var$_createClass(GraphQLError, [
        {
            key: "toString",
            value: function toString() {
                return $982b88782a45b92f$export$55ee1551a3f962e6(this);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return $982b88782a45b92f$export$7b5b869ee98c16ab(this);
            } // FIXME: workaround to not break chai comparisons, should be remove in v16
        },
        {
            key: (0, $ce670c3d0cd6efc8$export$5deadc579ccc7c9c),
            get: function get() {
                return 'Object';
            }
        }
    ]);
    return GraphQLError;
}(/*#__PURE__*/ $982b88782a45b92f$var$_wrapNativeSuper(Error));
function $982b88782a45b92f$var$undefinedIfEmpty(array) {
    return array === undefined || array.length === 0 ? undefined : array;
}
function $982b88782a45b92f$export$55ee1551a3f962e6(error) {
    var output = error.message;
    if (error.nodes) for(var _i4 = 0, _error$nodes2 = error.nodes; _i4 < _error$nodes2.length; _i4++){
        var node = _error$nodes2[_i4];
        if (node.loc) output += '\n\n' + (0, $eb6d3deb3e2a68a4$export$96a9681e539deed)(node.loc);
    }
    else if (error.source && error.locations) for(var _i6 = 0, _error$locations2 = error.locations; _i6 < _error$locations2.length; _i6++){
        var location = _error$locations2[_i6];
        output += '\n\n' + (0, $eb6d3deb3e2a68a4$export$867940333fd9f869)(error.source, location);
    }
    return output;
}
function $982b88782a45b92f$export$7b5b869ee98c16ab(error) {
    var _error$message;
    error || (0, $1c4c77440cd9ad0f$export$2e2bcd8739ae039)(0, 'Received null or undefined error.');
    var message = (_error$message = error.message) !== null && _error$message !== void 0 ? _error$message : 'An unknown error occurred.';
    var locations = error.locations;
    var path = error.path;
    var extensions = error.extensions;
    return extensions && Object.keys(extensions).length > 0 ? {
        message: message,
        locations: locations,
        path: path,
        extensions: extensions
    } : {
        message: message,
        locations: locations,
        path: path
    };
} /**
 * @see https://github.com/graphql/graphql-spec/blob/master/spec/Section%207%20--%20Response.md#errors
 */ 


const $a73698f3e4fe6cd8$export$17f5e6bd290bb15d = (error)=>{
    return typeof error === 'object' && error != null && (error.hasOwnProperty('graphQLErrors') || error.hasOwnProperty('networkError'));
};
class $a73698f3e4fe6cd8$export$3ad5d0415dc12c65 extends (0, $2e58ccba3067efe5$export$26a337512320b8c6) {
    constructor(options){
        const graphQLErrors = options.graphQLErrors?.map((error)=>{
            if (error instanceof (0, $982b88782a45b92f$export$92d6ed0888e7cb7f)) return error;
            const message = error.message;
            const extensions = error.extensions;
            const path = error.path;
            const originalError = new Error(message, {
                cause: error
            });
            const graphQLError = new (0, $982b88782a45b92f$export$92d6ed0888e7cb7f)(message, undefined, undefined, undefined, path, originalError, extensions);
            Object.defineProperties(graphQLError, {
                nodes: {
                    get () {
                        throw new Error(`[Relay migration] 'nodes' is not supported yet`);
                    }
                },
                source: {
                    get () {
                        throw new Error(`[Relay migration] 'source' is not supported yet`);
                    }
                },
                positions: {
                    get () {
                        throw new Error(`[Relay migration] 'positions' is not supported yet`);
                    }
                }
            });
            return graphQLError;
        });
        super({
            ...options,
            graphQLErrors: graphQLErrors
        });
        // Fix prototype chain for instanceof checks
        // This is necessary when extending Error-based classes in JavaScript
        Object.setPrototypeOf(this, $a73698f3e4fe6cd8$export$3ad5d0415dc12c65.prototype);
    }
}



function $eb7022fe2ef8793b$export$d54488e5d0ecaef7(value) {
    return value instanceof (0, $982b88782a45b92f$export$92d6ed0888e7cb7f);
}


class $65398bb1ddc9160a$export$bae979e68e4dc802 extends Error {
    constructor(...args){
        super(...args);
        this.requestUrl = void 0;
    }
}
function $65398bb1ddc9160a$export$bda33884db3cf75b(error) {
    if (error instanceof $65398bb1ddc9160a$export$bae979e68e4dc802) return true;
    if ((0, $a73698f3e4fe6cd8$export$17f5e6bd290bb15d)(error)) {
        const { graphQLErrors: graphQLErrors, networkError: networkError } = error;
        if (networkError) // ApolloError describes a network-related error if its networkError
        // property value is truthy. These are errors that have occurred within a
        // NetworkLink of ApolloClient. Think non-experimental queries (and
        // mutations).
        return true;
        return graphQLErrors.some($65398bb1ddc9160a$export$bda33884db3cf75b);
    }
    if ((0, $eb7022fe2ef8793b$export$d54488e5d0ecaef7)(error)) {
        const { originalError: originalError } = error;
        if (originalError) return $65398bb1ddc9160a$export$bda33884db3cf75b(originalError);
    }
    return false;
}
function $65398bb1ddc9160a$export$762bd3eeab681428(error) {
    return error.cause instanceof Error && error.cause?.name === 'AbortError';
}


class $165abb9eb28d58da$export$12c8b3d0a1a46f87 extends (0, $65398bb1ddc9160a$export$bae979e68e4dc802) {
    get traceId() {
        return (0, $32b74afc9e827b44$export$9f229e40eb65abfc)(this.response);
    }
    static isBadStatusError(value) {
        return value instanceof $165abb9eb28d58da$export$12c8b3d0a1a46f87;
    }
    constructor(message, response){
        super(message);
        this.response = void 0;
        this.name = 'BadStatusError';
        this.response = response;
    }
}



class $ea3ad52d3b05fdce$export$79f50640f30c1c0e extends (0, $65398bb1ddc9160a$export$bae979e68e4dc802) {
    constructor(...args){
        super(...args);
        /**
     * If the call site of `cfetch` has indicated that `NoNetworkError`s are to be
     * ignored by handlers, then `true`; otherwise, `false` or `undefined`.
     */ this.ignore = void 0;
        /**
     * Indicates whether the error was exposed to the feature gate `platform_editor_bubble_cfe_gql_network_errors`
     * and subsequently bubbled up to the client. This property is used to track errors originating from this
     * feature gate in analytics events.
     *
     * Note: This property is temporary and may be removed during the cleanup of the feature gate.
     */ this.wasBubbledUp = void 0;
    }
}



const $47f40898ee722892$var$RATE_LIMIT_TEXT_MARK = 'rate limit exceeded';
class $47f40898ee722892$export$b5f929f4d77c16a9 extends (0, $165abb9eb28d58da$export$12c8b3d0a1a46f87) {
    constructor(message, response){
        super(`${message} ${$47f40898ee722892$var$RATE_LIMIT_TEXT_MARK}`, response);
    }
}


function $57a53db822db3688$export$bee20cbc27fea50(headers, headerName, headerValue) {
    if (Array.isArray(headers)) {
        headers.push([
            headerName,
            headerValue
        ]);
        return;
    }
    if (headers instanceof Headers) {
        headers.append(headerName, headerValue);
        return;
    }
    headers[headerName] = headerValue;
}


function $1c343939761f9a65$export$149b1181d497cd(headers, headerName) {
    if (Array.isArray(headers)) {
        const header = headers.find(([name])=>name === headerName);
        return header ? header[1] : null;
    }
    if (headers instanceof Headers) return headers.get(headerName);
    return headers[headerName] ?? null;
}


const $e8815de0e5744b4a$export$1fccf6c6ebec28fe = 'X-Atl-Experience';
const $e8815de0e5744b4a$export$ecc9e1785213e182 = 'X-Atl-Experience-Id';


class $53b31fbcee8a9542$var$FrontendNetworkTracker {
    // Called from createWrappedFetch for each individual operation
    trackGraphQLOperations(operationNames) {
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        if (typeof window === 'undefined') return;
        operationNames.forEach(()=>{
            this.stats.totalOperations++;
        });
    }
    // Called from cfetch for REST calls
    trackRestCall(_url) {
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        if (typeof window === 'undefined') return;
        this.stats.totalOperations++;
    }
    getStats() {
        return {
            ...this.stats
        };
    }
    reset() {
        this.stats = {
            totalOperations: 0
        };
    }
    constructor(){
        this.stats = {
            totalOperations: 0
        };
    }
}
const $53b31fbcee8a9542$export$9a57a9973e788640 = new $53b31fbcee8a9542$var$FrontendNetworkTracker();


const $b9f93b053c525d82$export$7fd82c6bb3f5e7d5 = async (resource, init = {})=>{
    const urlPrefix = (0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('cc-agg-migration-use-agg-endpoint') ? '/gateway/api/graphql/slow' : '/cgraphql';
    if (typeof window !== 'undefined' && window['GLOBAL_FALLBACK_ATL_EXP']) {
        if (resource instanceof Request && resource.url.startsWith(urlPrefix)) resource.headers.append((0, $e8815de0e5744b4a$export$1fccf6c6ebec28fe), resource.headers.get((0, $e8815de0e5744b4a$export$1fccf6c6ebec28fe)) || window['GLOBAL_FALLBACK_ATL_EXP']);
        else if (String(resource).startsWith(urlPrefix)) {
            init.headers = init?.headers || {};
            // For requests sending outside of exp tracker scope fallback to URL based exp name
            (0, $57a53db822db3688$export$bee20cbc27fea50)(init.headers, (0, $e8815de0e5744b4a$export$1fccf6c6ebec28fe), (0, $1c343939761f9a65$export$149b1181d497cd)(init.headers, (0, $e8815de0e5744b4a$export$1fccf6c6ebec28fe)) || window['GLOBAL_FALLBACK_ATL_EXP']);
        }
    }
    // eslint-disable-next-line prefer-const
    let { ignoreNoNetworkError: ignoreNoNetworkError, requestInit: requestInit } = $b9f93b053c525d82$var$decomposeInit(init);
    // XXX Default RequestInit's credentials to "include" but not always: if the
    // caller provided a Request as resource and no init, then us adding a
    // RequestInit can break the caller.
    if (!resource || typeof resource === 'string' || !resource.credentials) requestInit = {
        credentials: 'include',
        ...requestInit
    };
    let response;
    const { url: url } = $b9f93b053c525d82$var$getRequestInfo(resource);
    let finalUrl = url;
    let authHeaders = {};
    try {
        // Track REST calls for frontend (GraphQL is tracked separately)
        // Only track in browser environment
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        if (typeof window !== 'undefined') (0, $53b31fbcee8a9542$export$9a57a9973e788640).trackRestCall(url);
        var value, name;
        if (typeof resource === 'string') resource = finalUrl;
        else if (resource instanceof Request) {
            if (finalUrl !== url) resource = new Request(finalUrl, resource);
        } else resource = new URL(finalUrl);
        // eslint-disable-next-line check-credentials-option/has-credentials-option, no-restricted-syntax
        response = await fetch(resource, requestInit);
    } catch (e) {
        // According to the fetch spec, a network failure results in a Promise
        // rejected with a TypeError. Any Response at all will resolve the Promise,
        // with the status property revealing the HTTP status code.
        const cause = e;
        const error = new (0, $ea3ad52d3b05fdce$export$79f50640f30c1c0e)(`Network failure: ${cause}`, {
            cause: cause
        });
        error.ignore = ignoreNoNetworkError;
        error.requestUrl = $b9f93b053c525d82$var$getRequestUrl(resource);
        error.ignore || $b9f93b053c525d82$var$emit(/* response */ undefined, error);
        throw error;
    }
    // If we don't get a 2xx Response, we'll consider that an error, and we'll
    // throw an exception. If we don't, we risk developers not checking the
    // Response status, running parsing logic such as parsing JSON, and failing
    // on non-2xx HTTP status code with weird errors like:
    // * Unexpected end of JSON input
    // * Unexpected token < in JSON at position 0
    // * JSON.parse: unexpected end of data at line 1 column 1 of the JSON data
    // * etc.
    //
    // By using our own Error subclass, we can prevent such unintended running of
    // parsing logic and we allow the product easily recognize the error and apply
    // product-wide processing.
    if (!response.ok) {
        let error;
        if (response.status === 429) error = new (0, $47f40898ee722892$export$b5f929f4d77c16a9)($b9f93b053c525d82$var$getRequestUrl(resource), response);
        else error = new (0, $165abb9eb28d58da$export$12c8b3d0a1a46f87)(`Received status ${response.status}`, response);
        error.requestUrl = $b9f93b053c525d82$var$getRequestUrl(resource);
        $b9f93b053c525d82$var$emit(response, error);
        throw error;
    }
    $b9f93b053c525d82$var$emit(response, /* error */ undefined);
    return response;
};
function $b9f93b053c525d82$var$decomposeInit(init = {}) {
    const { ignoreNoNetworkError: ignoreNoNetworkError, ...requestInit } = init;
    return {
        ignoreNoNetworkError: ignoreNoNetworkError,
        requestInit: Object.getOwnPropertyNames(requestInit).length ? (0, $d4a7caa009eb781c$export$eca64eb737a4c2bc)(requestInit) : undefined
    };
}
const $b9f93b053c525d82$var$logger = (0, $a6897acd40ed68b1$export$2b1d391cd05230fd)($b9f93b053c525d82$export$7fd82c6bb3f5e7d5);
let $b9f93b053c525d82$var$subscribers = [];
/**
 * Adds a specific `subscriber` to be notified whenever any `cfetch` call
 * resolves with a `Response` and/or an `Error`. If you're calling `cfetch` and
 * are interested in the outcome of that particular call only, please await the
 * resolution of the `Promise` returned by `cfetch`.
 */ $b9f93b053c525d82$export$7fd82c6bb3f5e7d5.subscribe = (subscriber)=>{
    if (typeof subscriber !== 'function') throw new Error('Subscriber must be a function');
    $b9f93b053c525d82$var$subscribers.push(subscriber);
    return ()=>{
        $b9f93b053c525d82$var$subscribers = $b9f93b053c525d82$var$subscribers.filter((x)=>x !== subscriber);
    };
};
function $b9f93b053c525d82$var$emit(response, error) {
    $b9f93b053c525d82$var$subscribers.forEach((subscriber)=>{
        try {
            subscriber(response, error);
        } catch (e) {
            $b9f93b053c525d82$var$logger.error`Error occurred in a cfetch subscriber: ${e}`;
        }
    });
}
function $b9f93b053c525d82$var$getRequestUrl(resource) {
    return typeof resource === 'string' ? resource : resource instanceof Request ? resource.url : resource.toString();
}
/**
 * Helper function to extract URL and determine if request is GraphQL
 */ function $b9f93b053c525d82$var$getRequestInfo(resource) {
    const url = $b9f93b053c525d82$var$getRequestUrl(resource);
    const isGraphQL = url.includes('/gateway/api/graphql/slow') || url.includes('?q=') || url.includes('&q=');
    return {
        url: url,
        isGraphQL: isGraphQL
    };
}



const $ce97530b5e3fb851$export$54fe7bbc3a8667b6 = `
  query isNewUserQuery {
    isNewUser
  }
`;


const $5ffd74b04d73fde2$export$53cb6decc268273b = (attributes)=>{
    const URI = (0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('cc-agg-migration-use-agg-endpoint') ? '/gateway/api/graphql/slow' : window['GLOBAL_APOLLO_CLIENT_URI'] || '/cgraphql';
    (0, $b9f93b053c525d82$export$7fd82c6bb3f5e7d5)(`${URI}?q=isNewUserQuery`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'X-APOLLO-OPERATION-NAME': 'isNewUserQuery',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            operationName: 'isNewUserQuery',
            query: (0, $ce97530b5e3fb851$export$54fe7bbc3a8667b6)
        })
    }).then(async (res)=>{
        if (res.ok) {
            const data = await res.json();
            const isNewUser = data?.data?.isNewUser || false;
            if (!!isNewUser) {
                (0, $b9f93b053c525d82$export$7fd82c6bb3f5e7d5)('/wiki/rest/onboarding/1/store', {
                    method: 'PUT',
                    body: JSON.stringify({
                        key: 'onboarding-origin-state:attributes',
                        value: JSON.stringify(attributes)
                    }),
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
                window.dispatchEvent(new Event('onboardingAttributesUpdated'));
            }
        }
    });
};


// Must call this before any browser-helper functions, to ensure user agent has been set first
(0, $c086cef45a2cc129$export$57d3cdb500cb5402)();
let $b76dfd1db5681318$var$provideClient;
const $b76dfd1db5681318$var$analyticsWebClientPromise = (0, $cd3135dd152096aa$export$cc373701aed148fc)(new Promise((resolve)=>{
    $b76dfd1db5681318$var$provideClient = resolve;
}));
let $b76dfd1db5681318$var$provideDwellTimeHelper;
const $b76dfd1db5681318$var$dwellTimeHelperPromise = (0, $cd3135dd152096aa$export$cc373701aed148fc)(new Promise((resolve)=>{
    $b76dfd1db5681318$var$provideDwellTimeHelper = resolve;
}));
const $b76dfd1db5681318$var$GAS_V3_ROUTE = 'gateway/api/gasv3/api/v1';
const $b76dfd1db5681318$export$45a69314cf48a3eb = ({ envType: envType, originType: originType, environment: environment, platformType: platformType, locale: locale, product: product, subproduct: subproduct })=>{
    const env = // In dev, proxying to a site will give that site's environment,
    // which is not what we want
    window.location.hostname === 'localhost' ? envType.DEV : environment === 'STAGING' ? envType.STAGING : environment === 'PRODUCTION' ? envType.PROD : envType.DEV;
    return {
        env: env,
        product: product || 'confluence',
        ...subproduct ? {
            subproduct: subproduct
        } : undefined,
        version: (0, $f3f8c1a227f13835$export$4ea39b9726d98a51)().FRONTEND_VERSION,
        origin: originType.WEB,
        platform: (0, $3793e1e9d193543a$export$1adf40e7373cdd98)() ? platformType.MOBILE_WEB : platformType.WEB,
        locale: locale,
        ...(0, $g8V8l.isIsolatedCloud)() && {
            ic: (0, $g8V8l.isolationContextId)()
        }
    };
};
const $b76dfd1db5681318$export$cac1fa7ce63519ac = (cloudId, activationId)=>`ari:cloud:confluence:${cloudId}:workspace/${activationId}`;
let $b76dfd1db5681318$var$updateAmplitudeSRSession;
let $b76dfd1db5681318$var$amplitudeAttributesInjector;
const $b76dfd1db5681318$var$wrapSendMethod = (originalMethod)=>{
    return function(payload, ...args) {
        // Inject amplitude attributes if injector exists
        if ($b76dfd1db5681318$var$amplitudeAttributesInjector && payload) $b76dfd1db5681318$var$amplitudeAttributesInjector(payload);
        // Call original method
        return originalMethod.call(this, payload, ...args);
    };
};




const $b76dfd1db5681318$export$7d842b959fcdcd03 = ({ cloudId: cloudId, userId: userId, environment: environment, product: product, subproduct: subproduct, locale: locale, activationId: activationId, eventFilterOptions: eventFilterOptions = {
    shouldFilterEvents: false,
    eventMatchers: []
}, callback: callback })=>{
    let config;
    Promise.all([
        (parcelRequire("hpR1p")),
        (parcelRequire("3WMIk")),
        // This is needed for @atlassiansox/origin-tracing to work in old versions of Edge (<=16).
        // Origin Tracing needs URLSearchParams, but the API is missing from old Edge,
        // and old Edge is not served the ES5/polyfills bundle.
        typeof URLSearchParams === 'undefined' ? (parcelRequire("76Etx")) : Promise.resolve()
    ]).then(async ([analyticsWebClientModule, { buildCompressionFunction: buildCompressionFunction, canCompress: canCompress }])=>{
        const { default: AnalyticsWebClient, originType: originType, tenantType: tenantType, userType: userType, envType: envType, platformType: platformType, DwellTimeHelper: DwellTimeHelper, CompressionRule: CompressionRule } = analyticsWebClientModule;
        config = $b76dfd1db5681318$export$45a69314cf48a3eb({
            envType: envType,
            originType: originType,
            environment: environment,
            platformType: platformType,
            locale: locale,
            product: product,
            subproduct: subproduct
        });
        let analyticsWebClient;
        // COMMENTS-195 - Send an operational event when a session starts
        const handleSessionStarted = ()=>{
            analyticsWebClient && analyticsWebClient.sendOperationalEvent({
                action: 'started',
                actionSubject: 'session',
                source: 'webClient'
            });
            if ((0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('cc_engagement_amplitude_session_replay')) $b76dfd1db5681318$var$updateAmplitudeSRSession && $b76dfd1db5681318$var$updateAmplitudeSRSession(analyticsWebClient);
        };
        $b76dfd1db5681318$var$provideDwellTimeHelper(DwellTimeHelper);
        const browserHistory = (0, $efe75065bf034d65$export$1ddb08151d15bc78)();
        const settings = {
            historyReplaceFn: (url)=>{
                const { pathname: pathname, search: search, hash: hash } = new URL(url);
                // Warning: can't pass an instance of URL here as it will erase query params and hash
                // Caused: https://product-fabric.atlassian.net/browse/WS-2317
                browserHistory.replace({
                    pathname: pathname,
                    search: search,
                    hash: hash
                });
            },
            delayQueueCompressors: [
                new CompressionRule(canCompress, buildCompressionFunction())
            ],
            onNewSessionStarted: handleSessionStarted,
            apiHostProtocol: window.location.hostname === 'localhost' ? 'http' : 'https',
            ...(0, $g8V8l.isIsolatedCloud)() && {
                apiHost: `${window.location.hostname}/${$b76dfd1db5681318$var$GAS_V3_ROUTE}`
            },
            disableCookiePersistence: true
        };
        const { shouldFilterEvents: shouldFilterEvents, eventMatchers: eventMatchers } = eventFilterOptions;
        // We suppress analytics events if we're within the mobile app so that we don't
        // end up firing overlapping events from the native and web code
        if (shouldFilterEvents || (0, $c086cef45a2cc129$export$6d5620528cf86fa2)()) {
            /**
       * Don't use Stargate if we're filtering events.
       * According to the analytics-web-client package source code at https://bitbucket.org/atlassian/analytics-web-client/src/bf3bd861ee8d08759e0e79830fcb1d69156db1a5/src/analyticsWebClient.js?at=master#lines-208
       * By default, useStargate is true. On a production instance, even if we set the env to "staging" or "dev", this event will land to the huge production Redash Socrates table, such as cloud.event_operational.
       * For the purpose of preproduction performance detection, we need the analytics event to send to staging table, such as raw_dlf_stg.event_operational.
       * The staging table has much less data, so we can run data transformation job hourly, and query more real-time data. Production table is huge, so we can only run data transformation job daily.
       */ const useStargate = !shouldFilterEvents;
            const { createFilteredAWC: createFilteredAWC } = await (parcelRequire("jAaAo"));
            analyticsWebClient = createFilteredAWC(analyticsWebClientModule, config, {
                ...settings,
                useStargate: useStargate
            }, eventMatchers);
        } else analyticsWebClient = new AnalyticsWebClient(config, settings);
        analyticsWebClient.setTenantInfo(tenantType.CLOUD_ID, cloudId);
        if ((0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('cc_engagement_amplitude_session_replay')) {
            analyticsWebClient.setUpdateAmplitudeSRSession = (callback)=>{
                $b76dfd1db5681318$var$updateAmplitudeSRSession = callback || undefined;
            };
            analyticsWebClient.setAmplitudeAttributesInjector = (injector)=>{
                $b76dfd1db5681318$var$amplitudeAttributesInjector = injector || undefined;
            };
            analyticsWebClient.sendScreenEvent = $b76dfd1db5681318$var$wrapSendMethod(analyticsWebClient.sendScreenEvent);
            analyticsWebClient.sendUIEvent = $b76dfd1db5681318$var$wrapSendMethod(analyticsWebClient.sendUIEvent);
        }
        if (activationId) {
            const workspaceId = $b76dfd1db5681318$export$cac1fa7ce63519ac(cloudId, activationId);
            analyticsWebClient.setWorkspaceInfo(workspaceId);
        }
        // userId is null when the user is anonymous. In that scenario we don't
        // want to set any account ID on the analytics client.
        if (userId) analyticsWebClient.setUserInfo(userType.ATLASSIAN_ACCOUNT, userId);
        analyticsWebClient.setOriginTracingHandlers({
            atlOrigin: (encodedOrigin)=>{
                const origin = (0, $608a2d4ad1afcbf8$export$2e2bcd8739ae039).fromEncoded(encodedOrigin);
                const attributes = origin.toAnalyticsAttributes();
                if (userId) (0, $5ffd74b04d73fde2$export$53cb6decc268273b)(attributes);
                return {
                    originTracingAttributes: {
                        id: attributes.originId,
                        product: attributes.originProduct,
                        library: attributes.originLibrary
                    },
                    taskSessionId: origin.id
                };
            }
        });
        if (product === 'embeddedConfluence') {
            const href = window?.location?.href;
            if (href) {
                const url = new URL(href);
                const embeddedConfluenceSource = url.searchParams.get('embeddedConfluenceSource');
                analyticsWebClient.setUIViewedAttributes({
                    embeddedConfluenceSource: embeddedConfluenceSource || 'unknown'
                });
            }
        }
        analyticsWebClient.startUIViewedEvent();
        $b76dfd1db5681318$var$provideClient(analyticsWebClient);
        callback && callback();
    }).catch((error)=>{
        throw new Error(`Analytics Web Client ${error}, ${JSON.stringify({
            ...config
        })}`);
    });
};
const $b76dfd1db5681318$export$e9ba7ef9458d1a4a = ()=>$b76dfd1db5681318$var$analyticsWebClientPromise;
const $b76dfd1db5681318$export$68106415736c5577 = ()=>$b76dfd1db5681318$var$dwellTimeHelperPromise;


/**
 * confluence/meta is used to access dynamic metadata passed from the
 * server to JavaScript via the page HTML.
 */ /**
 *  A backing map to use if the user sets data.
 */ const $b9d7d5d25d527513$export$1591b5b8c61dbb9c = {};
const $b9d7d5d25d527513$export$357972e1dc28ee9f = (key, value)=>{
    $b9d7d5d25d527513$export$1591b5b8c61dbb9c[key] = value;
};
const $b9d7d5d25d527513$export$70f24959ef00553b = (value)=>{
    const evaluatedValue = typeof value === 'string' ? value.toLowerCase() : '';
    const booleanEnum = {
        true: true,
        false: false
    };
    return evaluatedValue in booleanEnum ? booleanEnum[evaluatedValue] : value;
};
const $b9d7d5d25d527513$export$72427a1521dd0069 = (key)=>{
    // Check if we're server-side or client-side
    if ($b9d7d5d25d527513$export$9542afab8c2a5f48()) {
        const metaEl = document.querySelector(`meta[name='ajs-${key}']`);
        if (metaEl) return $b9d7d5d25d527513$export$70f24959ef00553b(metaEl.content);
        return $b9d7d5d25d527513$export$1591b5b8c61dbb9c[key];
    }
    // Always return undefined on the server-side
    return undefined;
};
const $b9d7d5d25d527513$export$49258654c956d9af = ()=>{
    const map = {};
    if (!document?.querySelectorAll?.length) return map;
    const metas = document.querySelectorAll('meta[name^=ajs-]');
    if (metas) for(let i = 0; i < metas.length; i++){
        const { name: name, content: content } = metas[i];
        map[name.substring(4)] = content;
    }
    return Object.assign(map, $b9d7d5d25d527513$export$1591b5b8c61dbb9c);
};
const $b9d7d5d25d527513$export$594c6655c9709eda = ()=>{
    const metaData = {};
    if ($b9d7d5d25d527513$export$9542afab8c2a5f48()) {
        const metaTags = document.querySelectorAll('meta[name^=ajs-]');
        for(let i = 0; i < metaTags.length; i++){
            const { name: name, content: content } = metaTags[i];
            metaData[name.replace(/^ajs-/, '')] = content;
        }
    }
    return metaData;
};
const $b9d7d5d25d527513$export$9542afab8c2a5f48 = ()=>{
    return typeof document !== 'undefined';
};
const $b9d7d5d25d527513$export$578af21a462ae10b = ()=>{
    Object.keys($b9d7d5d25d527513$export$1591b5b8c61dbb9c).forEach((key)=>{
        delete $b9d7d5d25d527513$export$1591b5b8c61dbb9c[key];
    });
};


// Please only keep this import as a *type import* to avoid bringing in the entire lib
/**
 * The error returned if an error occurs while calling a REST API.
 */ class $b1c79be305194522$export$e704fce35c66bf42 extends Error {
    constructor({ message: message, method: method, url: url, 'status-code': statusCode }, { route: route, traceId: traceId } = {}){
        const formattedMessage = message.length ? message : `Failed to ${method} ${route || url}`;
        super(formattedMessage);
        /**
     * The URL of the failed request.
     */ this.url = void 0;
        /**
     * The attempted http request method.
     */ this.method = void 0;
        /**
     * The status code returned in the response
     */ this.statusCode = void 0;
        /**
     * The name of the requested route (without UGC/PII)
     */ this.route = void 0;
        /**
     * The traceId of the request
     */ this.traceId = void 0;
        this.url = url;
        this.route = route;
        this.method = method;
        this.statusCode = statusCode;
        this.traceId = traceId;
    }
}


function $8a3a8685062675cc$var$isApolloErrorInterop(error) {
    // theoretically this could be an `instanceof ApolloErrorInterop` check, but bringing another
    // dependency to this package for the sake of this single check seems like an overkill
    return typeof error === 'object' && error !== null && ('graphQLErrors' in error || 'networkError' in error);
}
const $8a3a8685062675cc$var$REACT_ERROR_CONTEXT_SYMBOL = Symbol('React error context');
function $8a3a8685062675cc$export$df1c6d0ba3db287e(error, context) {
    if (typeof error === 'object' && error !== null) error[$8a3a8685062675cc$var$REACT_ERROR_CONTEXT_SYMBOL] = context;
}
function $8a3a8685062675cc$export$8b5fa6128aa81e5e(error) {
    if (typeof error === 'object' && error !== null) return error[$8a3a8685062675cc$var$REACT_ERROR_CONTEXT_SYMBOL];
    return undefined;
}
const $8a3a8685062675cc$var$GRAPHQL_ERROR_CONTEXT_SYMBOL = Symbol('Graphql error context');
function $8a3a8685062675cc$export$6f0dbe4e2bbe0509(error, context) {
    if (typeof error === 'object' && error !== null) error[$8a3a8685062675cc$var$GRAPHQL_ERROR_CONTEXT_SYMBOL] = context;
}
function $8a3a8685062675cc$export$b19e649eafc62480(error) {
    if (typeof error !== 'object' || error === null) return undefined;
    if (error[$8a3a8685062675cc$var$GRAPHQL_ERROR_CONTEXT_SYMBOL]) return error[$8a3a8685062675cc$var$GRAPHQL_ERROR_CONTEXT_SYMBOL];
    // Currently the graphql error context is set on the first entry of the `graphqlErrors`
    // property of `ApolloError`. That way, `ApolloError` itself does not have the context
    // set properly. This method is a measure to overcome this and make sure that
    // we are able to retrieve the context correctly.
    return $8a3a8685062675cc$var$getGraphqlErrorAttributesFromApolloError(error);
}
function $8a3a8685062675cc$var$getGraphqlErrorAttributesFromApolloError(error) {
    if (!$8a3a8685062675cc$var$isApolloErrorInterop(error)) return undefined;
    const graphqlErrors = error.graphQLErrors;
    // the context is populated by next/packages/graphql/src/links/OnErrorLink.ts
    if (graphqlErrors && graphqlErrors.length > 0 && graphqlErrors[0][$8a3a8685062675cc$var$GRAPHQL_ERROR_CONTEXT_SYMBOL]) return graphqlErrors[0][$8a3a8685062675cc$var$GRAPHQL_ERROR_CONTEXT_SYMBOL];
    if (error.networkError) return error.networkError[$8a3a8685062675cc$var$GRAPHQL_ERROR_CONTEXT_SYMBOL];
    return undefined;
}
const $8a3a8685062675cc$var$SLA_ERROR_CONTEXT_SYMBOL = Symbol('SLA error context');
function $8a3a8685062675cc$export$d4fe004fb0aaaf4f(error) {
    if (typeof error === 'object' && error !== null) return error[$8a3a8685062675cc$var$SLA_ERROR_CONTEXT_SYMBOL];
    return undefined;
}
function $8a3a8685062675cc$export$a986f274521b30d7(error, context) {
    if (typeof error === 'object' && error !== null) error[$8a3a8685062675cc$var$SLA_ERROR_CONTEXT_SYMBOL] = context;
}
function $8a3a8685062675cc$var$getBadStatusErrorAttributes(error) {
    if (!(error instanceof (0, $165abb9eb28d58da$export$12c8b3d0a1a46f87))) return undefined;
    return {
        statusCode: error.response.status,
        traceId: (0, $32b74afc9e827b44$export$9f229e40eb65abfc)(error.response)
    };
}
function $8a3a8685062675cc$var$getConfluenceRestApiErrorAttributes(error) {
    if (!(error instanceof (0, $b1c79be305194522$export$e704fce35c66bf42))) return undefined;
    return {
        statusCode: error.statusCode,
        restMethod: error.method,
        restRoute: error.route,
        traceId: error.traceId
    };
}
const $8a3a8685062675cc$var$CONTENT_ERROR_CONTEXT_SYMBOL = Symbol('Content error context');
function $8a3a8685062675cc$export$c37ca7d37ab54fcc(error, context) {
    if (typeof error === 'object' && error !== null) error[$8a3a8685062675cc$var$CONTENT_ERROR_CONTEXT_SYMBOL] = context;
}
function $8a3a8685062675cc$export$bc010311f017b17c(error) {
    if (typeof error === 'object' && error !== null) return error[$8a3a8685062675cc$var$CONTENT_ERROR_CONTEXT_SYMBOL];
    return undefined;
}
const $8a3a8685062675cc$var$LOADABLE_ERROR_CONTEXT_SYMBOL = Symbol('Loadable error context');
function $8a3a8685062675cc$export$6f86bd8e510ff607(error, context) {
    if (typeof error === 'object' && error !== null) error[$8a3a8685062675cc$var$LOADABLE_ERROR_CONTEXT_SYMBOL] = context;
}
function $8a3a8685062675cc$export$b8f8f1e62c6397ed(error) {
    if (typeof error === 'object' && error !== null) return error[$8a3a8685062675cc$var$LOADABLE_ERROR_CONTEXT_SYMBOL];
    return undefined;
}
function $8a3a8685062675cc$export$69408b85ed2a0e77(error) {
    const traceId = $8a3a8685062675cc$export$b19e649eafc62480(error)?.traceId || $8a3a8685062675cc$export$b19e649eafc62480(error?.graphQLErrors?.[0])?.traceId;
    if (traceId) return traceId;
    // handle experimental query error
    if (error.graphQLErrors?.[0].originalError instanceof (0, $165abb9eb28d58da$export$12c8b3d0a1a46f87)) return error.graphQLErrors[0].originalError?.traceId;
    return null;
}
function $8a3a8685062675cc$export$d08bac32cb78075f(error) {
    if (!error || typeof error !== 'object') return {};
    return {
        ...$8a3a8685062675cc$export$8b5fa6128aa81e5e(error),
        ...$8a3a8685062675cc$export$b19e649eafc62480(error),
        ...$8a3a8685062675cc$export$d4fe004fb0aaaf4f(error),
        ...$8a3a8685062675cc$export$bc010311f017b17c(error),
        ...$8a3a8685062675cc$export$b8f8f1e62c6397ed(error),
        ...$8a3a8685062675cc$var$getConfluenceRestApiErrorAttributes(error),
        ...$8a3a8685062675cc$var$getBadStatusErrorAttributes(error)
    };
}


function $be53df4ecec575d8$export$1115c5277eb10d5e(traceId, spanId) {
    return {
        'X-B3-TraceId': traceId,
        'X-B3-SpanId': spanId
    };
}


const $9931f21957f7e3c2$var$state = {
    context: null
};
function $9931f21957f7e3c2$export$295213bc4d0c54ad() {
    return Array.from(new Array(16), ()=>Math.floor(Math.random() * 16).toString(16)).join('');
}
function $9931f21957f7e3c2$export$f2e521e495a88544(interactionId, experienceType) {
    $9931f21957f7e3c2$export$a1002be327997103(interactionId.replace(/-/g, ''), $9931f21957f7e3c2$export$295213bc4d0c54ad(), experienceType);
}
function $9931f21957f7e3c2$export$a1002be327997103(traceId, spanId, type) {
    $9931f21957f7e3c2$var$state.context = {
        traceId: traceId,
        spanId: spanId,
        type: type
    };
}
function $9931f21957f7e3c2$export$b6ac780db3a3cc77() {
    return $9931f21957f7e3c2$var$state.context || undefined;
}
function $9931f21957f7e3c2$export$17ab21d7be720b() {
    $9931f21957f7e3c2$var$state.context = null;
}
function $9931f21957f7e3c2$export$6e17cce6446848f9(_url) {
    if ($9931f21957f7e3c2$var$state.context === null) return null;
    const { traceId: traceId, spanId: spanId } = $9931f21957f7e3c2$var$state.context;
    return (0, $be53df4ecec575d8$export$1115c5277eb10d5e)(traceId, spanId);
}
function $9931f21957f7e3c2$export$a1e7396778592551(_url) {
    const traceHeaders = $9931f21957f7e3c2$export$6e17cce6446848f9();
    return traceHeaders ? new URLSearchParams(traceHeaders).toString().toLowerCase() : null;
}


// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead


// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
const $1866999cf2cfff96$var$TESTS_MODE = globalThis?.process?.env?.JEST_WORKER_ID !== undefined;
const $1866999cf2cfff96$var$DEBUG_MODE = !$1866999cf2cfff96$var$TESTS_MODE && globalThis?.process?.env?.NODE_ENV !== 'production';
const $1866999cf2cfff96$export$1c9f709888824e05 = (...args)=>{
    if (!$1866999cf2cfff96$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    console.debug(...args);
};



var $aVaWD = parcelRequire("aVaWD");
const $6103babb683468f0$var$pkgName = '@atlaskit/platform-feature-flags';
const $6103babb683468f0$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
const $6103babb683468f0$var$hasProcessEnv = typeof $aVaWD !== 'undefined' && typeof $aVaWD.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
const $6103babb683468f0$var$ENV_ENABLE_PLATFORM_FF = $6103babb683468f0$var$hasProcessEnv ? false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
const $6103babb683468f0$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $6103babb683468f0$var$hasProcessEnv ? false : false;
const $6103babb683468f0$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $6103babb683468f0$var$ENV_ENABLE_PLATFORM_FF || $6103babb683468f0$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
const $6103babb683468f0$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
const $6103babb683468f0$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$6103babb683468f0$var$globalVar[$6103babb683468f0$export$7e41b1b2bdee3f98] = $6103babb683468f0$var$globalVar[$6103babb683468f0$export$7e41b1b2bdee3f98] || $6103babb683468f0$var$DEFAULT_PFF_GLOBAL;
function $6103babb683468f0$export$f2b591175b3e424c(resolver) {
    $6103babb683468f0$var$globalVar[$6103babb683468f0$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $6103babb683468f0$export$6333b6aff9fc6275(flagKey) {
    if ($6103babb683468f0$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $1866999cf2cfff96$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $6103babb683468f0$var$pkgName, flagKey);
        return true;
    }
    try {
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if ($6103babb683468f0$var$globalVar[$6103babb683468f0$export$7e41b1b2bdee3f98]?.booleanResolver === undefined || $6103babb683468f0$var$globalVar[$6103babb683468f0$export$7e41b1b2bdee3f98]?.booleanResolver === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $92d8da4ee454ac11$export$2e2bcd8739ae039).checkGate(flagKey);
        const result = $6103babb683468f0$var$globalVar[$6103babb683468f0$export$7e41b1b2bdee3f98]?.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn(`${flagKey} resolved to a non-boolean value, returning false for safety`);
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $c04d14497c4aa1d8$export$ba05d765b8392e5e(flagResolver) {
    (0, $6103babb683468f0$export$f2b591175b3e424c)(flagResolver);
}
function $c04d14497c4aa1d8$export$470e5c2be1411c89(name) {
    return (0, $6103babb683468f0$export$6333b6aff9fc6275)(name);
}
function $c04d14497c4aa1d8$export$b40ec24ac8275656(name) {
    return (0, $6103babb683468f0$export$6333b6aff9fc6275)(name);
}


/**
 * A random function that passes one in rate times.
 * E.g. coinflip(2) is the same as if you flipped a coin.
 * It will pass 50% of the time
 * @param rate The change that it will pass (1 in <rate> times)
 * @returns bool, if it passes or not
 */ function $74d2fea471853068$var$coinflip(rate) {
    if (rate === 0) return false;
    else if (rate === 1) return true;
    else return Math.random() * rate <= 1;
}
var $74d2fea471853068$export$2e2bcd8739ae039 = $74d2fea471853068$var$coinflip;



let $9a2f9fc0af024eb1$var$config;
const $9a2f9fc0af024eb1$export$f9bb3bb330fb9609 = 'fy25.03';
const $9a2f9fc0af024eb1$export$d50dacda7fe6392b = 1000;
function $9a2f9fc0af024eb1$export$10d6139a8fb42158(newConfig) {
    // Handle edge cases with `enabledVCRevisions`
    const { enabledVCRevisions: enabledVCRevisions } = newConfig?.vc ?? {};
    if (typeof enabledVCRevisions?.byExperience === 'object') $9a2f9fc0af024eb1$var$config = {
        ...newConfig,
        vc: {
            ...newConfig.vc,
            enabledVCRevisions: {
                // enforce axiom about `enabledVCRevisions.all` config
                all: Array.from(new Set([
                    $9a2f9fc0af024eb1$export$f9bb3bb330fb9609,
                    ...enabledVCRevisions?.all,
                    ...Object.values(enabledVCRevisions?.byExperience).flat()
                ])),
                byExperience: {
                    ...enabledVCRevisions?.byExperience
                }
            }
        }
    };
    else $9a2f9fc0af024eb1$var$config = newConfig;
}
function $9a2f9fc0af024eb1$export$44487a86467333c3() {
    return $9a2f9fc0af024eb1$var$config;
}
const $9a2f9fc0af024eb1$var$isValidConfigArray = (array)=>{
    return Array.isArray(array) && array.length > 0;
};
function $9a2f9fc0af024eb1$export$87fbc8e01b137811(experienceKey = '') {
    try {
        if (!$9a2f9fc0af024eb1$var$config) return [];
        if ($9a2f9fc0af024eb1$var$config.vc?.enabled) {
            const { enabledVCRevisions: enabledVCRevisions } = $9a2f9fc0af024eb1$var$config.vc ?? {};
            if ($9a2f9fc0af024eb1$var$isValidConfigArray(enabledVCRevisions?.byExperience?.[experienceKey])) return enabledVCRevisions.byExperience?.[experienceKey];
            if ($9a2f9fc0af024eb1$var$isValidConfigArray(enabledVCRevisions?.all)) return enabledVCRevisions.all;
            return [
                $9a2f9fc0af024eb1$export$f9bb3bb330fb9609
            ];
        }
        return [];
    } catch  {
        return [];
    }
}
function $9a2f9fc0af024eb1$export$4babcefc81a3ef0b(revision, experienceKey) {
    return $9a2f9fc0af024eb1$export$87fbc8e01b137811(experienceKey).includes(revision);
}
function $9a2f9fc0af024eb1$export$70184d6e2c753893(experienceKey = '') {
    const enabledVCRevisions = $9a2f9fc0af024eb1$export$87fbc8e01b137811(experienceKey);
    return enabledVCRevisions[enabledVCRevisions.length - 1];
}
function $9a2f9fc0af024eb1$export$2d8f8d64dc343d7b() {
    if (!$9a2f9fc0af024eb1$var$config) return undefined;
    try {
        const stats = $9a2f9fc0af024eb1$var$config?.getReactHydrationStats?.();
        return stats ?? undefined;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('getReactHydrationStats threw an error: ', e);
        return undefined;
    }
}
function $9a2f9fc0af024eb1$export$9466a8f085fa7d4e(name, interactionKind) {
    try {
        if (!$9a2f9fc0af024eb1$var$config) return 0;
        const { killswitch: killswitch, rates: rates, rules: rules, kind: kind, autoGeneratedRate: autoGeneratedRate } = $9a2f9fc0af024eb1$var$config;
        if (killswitch != null) {
            // Specifically kill certain events
            if (killswitch.includes(name)) return 0;
        }
        const isUnknown = name === 'unknown';
        if (isUnknown) {
            if (rates?.[name] != null) return rates[name];
            // Return default rate for unknown events when no explicit rate is configured
            return $9a2f9fc0af024eb1$export$d50dacda7fe6392b;
        }
        if (rates != null) {
            // Decide the rate explicitly
            if (rates[name] != null) return rates[name];
        }
        if (rules != null) for(let i = 0; i < rules.length; i++){
            const rule = rules[i];
            const { test: test, rate: rate } = rule;
            if (test != null && rate != null) {
                const regexp = new RegExp(test, 'ig');
                if (regexp.test(name)) return rate;
            }
        }
        const isAutogenerated = name?.startsWith('auto-generated');
        if (isAutogenerated) {
            const rate = autoGeneratedRate;
            if (rate != null) return rate;
        }
        if (kind != null) {
            const rate = kind[interactionKind];
            if (rate != null) return rate;
        }
        return 0;
    } catch  {
        // Fallback
        return 0;
    }
}
function $9a2f9fc0af024eb1$export$563f73272328c0d(name, interactionType) {
    try {
        if (!$9a2f9fc0af024eb1$var$config) return 0;
        const { experimentalInteractionMetrics: experimentalInteractionMetrics } = $9a2f9fc0af024eb1$var$config;
        if (!experimentalInteractionMetrics?.enabled) return 0;
        if (experimentalInteractionMetrics.rates && typeof experimentalInteractionMetrics.rates[name] === 'number') return experimentalInteractionMetrics.rates[name];
        if (experimentalInteractionMetrics.kind && typeof experimentalInteractionMetrics.kind[interactionType] === 'number') return experimentalInteractionMetrics.kind[interactionType];
        return 0;
    } catch  {
        return 0;
    }
}
function $9a2f9fc0af024eb1$export$48f4e0d964030a96(name, interactionType) {
    return $9a2f9fc0af024eb1$var$getConfigRate(name, interactionType, 'enableVCRawDataRates');
}
function $9a2f9fc0af024eb1$export$9c69f5a724f05f38(name, interactionType) {
    if (!(0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_ufo_raw_data_thirdparty')) return false;
    return $9a2f9fc0af024eb1$export$48f4e0d964030a96(name, interactionType) > 0;
}
function $9a2f9fc0af024eb1$export$1d459f020c06ae34(name, interactionType) {
    return $9a2f9fc0af024eb1$var$getConfigRate(name, interactionType, 'postInteractionLog');
}
function $9a2f9fc0af024eb1$export$29b9ffb14861a1d(capability) {
    if ((0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_ufo_remove_deprecated_config_fields')) return 1;
    try {
        if (!$9a2f9fc0af024eb1$var$config) return 0;
        const { capability: capabilityRate } = $9a2f9fc0af024eb1$var$config;
        if (capabilityRate != null) {
            const rate = capabilityRate[capability];
            if (rate != null) return rate;
        }
        return 0;
    } catch  {
        return 0;
    }
}
function $9a2f9fc0af024eb1$var$getConfigRate(name, interactionType, configName) {
    try {
        if (!$9a2f9fc0af024eb1$var$config) return 0;
        const gotConfig = $9a2f9fc0af024eb1$var$config[configName];
        if (!gotConfig?.enabled) return 0;
        if (interactionType !== 'page_load' && interactionType !== 'transition') return 0;
        if (gotConfig.rates && typeof gotConfig.rates[name] === 'number') return gotConfig.rates[name];
        if ('kind' in gotConfig && gotConfig.kind && typeof gotConfig.kind[interactionType] === 'number') return gotConfig.kind[interactionType];
        return 0;
    } catch  {
        return 0;
    }
}
function $9a2f9fc0af024eb1$export$203bd06a99c66a0d(name, interactionType) {
    return $9a2f9fc0af024eb1$var$getConfigRate(name, interactionType, 'extraInteractionMetrics');
}
const $9a2f9fc0af024eb1$var$validTypingMethods = [
    'timeout',
    'timeoutNoAlloc',
    'mutationObserver'
];
function $9a2f9fc0af024eb1$export$7e32aae12bf9b50f() {
    const defaultMethod = 'timeout';
    try {
        if (!$9a2f9fc0af024eb1$var$config) return defaultMethod;
        const { typingMethod: typingMethod } = $9a2f9fc0af024eb1$var$config;
        if (typingMethod != null && $9a2f9fc0af024eb1$var$validTypingMethods.find((m)=>m === typingMethod)) return typingMethod;
        else return defaultMethod;
    } catch  {
        return defaultMethod;
    }
}
function $9a2f9fc0af024eb1$export$2d311b3fd18dcab1() {
    try {
        if (!$9a2f9fc0af024eb1$var$config) return [];
        const { awaitBM3TTI: awaitBM3TTI } = $9a2f9fc0af024eb1$var$config;
        if (awaitBM3TTI != null) return awaitBM3TTI;
        else return [];
    } catch  {
        return [];
    }
}
function $9a2f9fc0af024eb1$export$4f4649ef27b6f5d6() {
    try {
        if (!$9a2f9fc0af024eb1$var$config) return undefined;
        const { ufoNameOverrides: ufoNameOverrides } = $9a2f9fc0af024eb1$var$config;
        if (ufoNameOverrides != null) return ufoNameOverrides;
        return undefined;
    } catch  {
        return undefined;
    }
}
function $9a2f9fc0af024eb1$export$b150ddad71c80d77() {
    try {
        if (!$9a2f9fc0af024eb1$var$config) return undefined;
        const { minorInteractions: minorInteractions } = $9a2f9fc0af024eb1$var$config;
        return minorInteractions;
    } catch  {
        return undefined;
    }
}
function $9a2f9fc0af024eb1$export$3c170167645a0eff() {
    try {
        if (!$9a2f9fc0af024eb1$var$config) return undefined;
        const { doNotAbortActivePressInteraction: doNotAbortActivePressInteraction } = $9a2f9fc0af024eb1$var$config;
        return doNotAbortActivePressInteraction;
    } catch  {
        return undefined;
    }
}
function $9a2f9fc0af024eb1$export$d6dc9444bd15f70f() {
    try {
        if (!$9a2f9fc0af024eb1$var$config) return undefined;
        const { doNotAbortActivePressInteractionOnTransition: doNotAbortActivePressInteractionOnTransition } = $9a2f9fc0af024eb1$var$config;
        return doNotAbortActivePressInteractionOnTransition;
    } catch  {
        return undefined;
    }
}
function $9a2f9fc0af024eb1$export$20e8108b8ccdd0bd() {
    try {
        if (!$9a2f9fc0af024eb1$var$config) return undefined;
        const { finishInteractionOnTransition: finishInteractionOnTransition } = $9a2f9fc0af024eb1$var$config;
        return finishInteractionOnTransition;
    } catch  {
        return undefined;
    }
}
const $9a2f9fc0af024eb1$export$2a8604960d7d23d9 = 60000;
function $9a2f9fc0af024eb1$export$c681731847989445(ufoName) {
    try {
        if (!$9a2f9fc0af024eb1$var$config) return $9a2f9fc0af024eb1$export$2a8604960d7d23d9;
        const { interactionTimeout: interactionTimeout } = $9a2f9fc0af024eb1$var$config;
        if (interactionTimeout != null && interactionTimeout[ufoName] != null) return interactionTimeout[ufoName];
        if (interactionTimeout != null && interactionTimeout.__globalInteractionTimeout != null) return interactionTimeout.__globalInteractionTimeout;
        else return $9a2f9fc0af024eb1$export$2a8604960d7d23d9;
    } catch  {
        return $9a2f9fc0af024eb1$export$2a8604960d7d23d9;
    }
}


var $c403da8c524792f8$exports = {};
"use strict";
Object.defineProperty($c403da8c524792f8$exports, "__esModule", {
    value: true
});
$c403da8c524792f8$exports.bindAll = $c403da8c524792f8$exports.bind = void 0;
var $dc86d993ab9109cf$exports = {};
"use strict";
Object.defineProperty($dc86d993ab9109cf$exports, "__esModule", {
    value: true
});
$dc86d993ab9109cf$exports.bind = void 0;
function $dc86d993ab9109cf$var$bind(target, _a) {
    var type = _a.type, listener = _a.listener, options = _a.options;
    target.addEventListener(type, listener, options);
    return function unbind() {
        target.removeEventListener(type, listener, options);
    };
}
$dc86d993ab9109cf$exports.bind = $dc86d993ab9109cf$var$bind;


Object.defineProperty($c403da8c524792f8$exports, "bind", {
    enumerable: true,
    get: function() {
        return $dc86d993ab9109cf$exports.bind;
    }
});
var $fb75612716c388db$exports = {};
"use strict";
var $fb75612716c388db$var$__assign = $fb75612716c388db$exports && $fb75612716c388db$exports.__assign || function() {
    $fb75612716c388db$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fb75612716c388db$var$__assign.apply(this, arguments);
};
Object.defineProperty($fb75612716c388db$exports, "__esModule", {
    value: true
});
$fb75612716c388db$exports.bindAll = void 0;

function $fb75612716c388db$var$toOptions(value) {
    if (typeof value === 'undefined') return undefined;
    if (typeof value === 'boolean') return {
        capture: value
    };
    return value;
}
function $fb75612716c388db$var$getBinding(original, sharedOptions) {
    if (sharedOptions == null) return original;
    var binding = $fb75612716c388db$var$__assign($fb75612716c388db$var$__assign({}, original), {
        options: $fb75612716c388db$var$__assign($fb75612716c388db$var$__assign({}, $fb75612716c388db$var$toOptions(sharedOptions)), $fb75612716c388db$var$toOptions(original.options))
    });
    return binding;
}
function $fb75612716c388db$var$bindAll(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
        var binding = $fb75612716c388db$var$getBinding(original, sharedOptions);
        return (0, $dc86d993ab9109cf$exports.bind)(target, binding);
    });
    return function unbindAll() {
        unbinds.forEach(function(unbind) {
            return unbind();
        });
    };
}
$fb75612716c388db$exports.bindAll = $fb75612716c388db$var$bindAll;


Object.defineProperty($c403da8c524792f8$exports, "bindAll", {
    enumerable: true,
    get: function() {
        return $fb75612716c388db$exports.bindAll;
    }
});



const $609a77f2077f290f$var$timings = [];
let $609a77f2077f290f$var$wasHiddenFlag;
let $609a77f2077f290f$var$setupFlag = false;
function $609a77f2077f290f$var$isPageHidden() {
    if ('visibilityState' in document) return document.visibilityState === 'hidden';
    else // @ts-expect-error - Property 'hidden' does not exist on type 'never'.
    return document.hidden;
}
const $609a77f2077f290f$var$SIZE = 50;
let $609a77f2077f290f$var$insertIndex = 0;
function $609a77f2077f290f$var$pushHidden(isPageHiddenFlag, time) {
    $609a77f2077f290f$var$timings[$609a77f2077f290f$var$insertIndex] = {
        time: time ?? performance.now(),
        hidden: isPageHiddenFlag
    };
    $609a77f2077f290f$var$insertIndex = ($609a77f2077f290f$var$insertIndex + 1) % $609a77f2077f290f$var$SIZE;
    $609a77f2077f290f$var$wasHiddenFlag = isPageHiddenFlag;
}
function $609a77f2077f290f$var$handleChange() {
    const isPageHiddenFlag = $609a77f2077f290f$var$isPageHidden();
    if (isPageHiddenFlag) {
        if (!$609a77f2077f290f$var$wasHiddenFlag) $609a77f2077f290f$var$pushHidden(isPageHiddenFlag);
        $609a77f2077f290f$var$wasHiddenFlag = true;
    } else {
        if ($609a77f2077f290f$var$wasHiddenFlag) $609a77f2077f290f$var$pushHidden(isPageHiddenFlag);
        $609a77f2077f290f$var$wasHiddenFlag = false;
    }
}
function $609a77f2077f290f$var$setup() {
    try {
        if ((0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_ufo_use_native_page_visibility_api')) {
            const results = performance.getEntriesByType('visibility-state');
            results?.forEach((result)=>{
                $609a77f2077f290f$var$pushHidden(result.name === 'hidden', result.startTime);
            });
        }
    } catch  {
    /* do nothing */ /* note: visibility-state entry types are not available in Firefox/Safari: https://developer.mozilla.org/en-US/docs/Web/API/VisibilityStateEntry#browser_compatibility */ }
    (0, $c403da8c524792f8$exports.bind)(window, {
        type: 'pageshow',
        listener: $609a77f2077f290f$var$handleChange
    });
    (0, $c403da8c524792f8$exports.bind)(window, {
        type: 'pagehide',
        listener: $609a77f2077f290f$var$handleChange
    });
    (0, $c403da8c524792f8$exports.bind)(document, {
        type: 'visibilitychange',
        listener: $609a77f2077f290f$var$handleChange
    });
}
function $609a77f2077f290f$export$554cefe0f0373da4() {
    if (!$609a77f2077f290f$var$setupFlag) {
        const isPageHiddenFlag = $609a77f2077f290f$var$isPageHidden();
        $609a77f2077f290f$var$pushHidden(isPageHiddenFlag, 0);
        $609a77f2077f290f$var$setup();
        $609a77f2077f290f$var$setupFlag = true;
    }
}
function $609a77f2077f290f$export$768b2008623433e1(start, end) {
    // Input validation - return default for invalid inputs
    if (!Number.isFinite(start) || !Number.isFinite(end)) return 'visible';
    // Desirable default value is visible
    if ($609a77f2077f290f$var$timings.length === 0) return 'visible';
    const currentSize = $609a77f2077f290f$var$timings.length;
    let hiddenState = 'mixed';
    let startIdx = $609a77f2077f290f$var$insertIndex;
    let endIdx = $609a77f2077f290f$var$insertIndex;
    // currentSize is capped at SIZE.
    for(let i = 0; i < currentSize; i++){
        const tmpIdx = ($609a77f2077f290f$var$insertIndex + i) % currentSize;
        // Add bounds checking before accessing array element
        if ($609a77f2077f290f$var$timings[tmpIdx] && $609a77f2077f290f$var$timings[tmpIdx].time <= end) {
            endIdx = tmpIdx;
            if ($609a77f2077f290f$var$timings[tmpIdx].time <= start) startIdx = tmpIdx;
        }
    }
    // Add bounds checking before accessing timings array
    if (endIdx - startIdx === 0 && $609a77f2077f290f$var$timings[startIdx]) hiddenState = $609a77f2077f290f$var$timings[startIdx].hidden ? 'hidden' : 'visible';
    return hiddenState;
}






const $32ec1c9eefd43e20$export$199edc0307b5587f = {
    wheel: 'wheel',
    keydown: 'keydown',
    resize: 'resize'
};


function $cb142781691e200c$export$a497a1dcb4408212(document = window.document) {
    let documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch  {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}
function $cb142781691e200c$export$4f01c15d21ef9cc6(document = window.document) {
    let documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch  {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}


function $51daedf3057f5fce$export$9010aa71841a6887(window, initialViewPort, callback) {
    const unbindWheel = (0, $c403da8c524792f8$exports.bind)(window, {
        type: (0, $32ec1c9eefd43e20$export$199edc0307b5587f).wheel,
        listener: (e)=>{
            callback((0, $32ec1c9eefd43e20$export$199edc0307b5587f).wheel, e.timeStamp);
        },
        options: {
            passive: true,
            once: true
        }
    });
    const unbindKeydown = (0, $c403da8c524792f8$exports.bind)(window, {
        type: (0, $32ec1c9eefd43e20$export$199edc0307b5587f).keydown,
        listener: (e)=>{
            callback((0, $32ec1c9eefd43e20$export$199edc0307b5587f).keydown, e.timeStamp);
        },
        options: {
            once: true
        }
    });
    const unbindResize = (0, $c403da8c524792f8$exports.bind)(window, {
        type: (0, $32ec1c9eefd43e20$export$199edc0307b5587f).resize,
        listener: (e)=>{
            if ((0, $cb142781691e200c$export$a497a1dcb4408212)() !== initialViewPort.w || (0, $cb142781691e200c$export$4f01c15d21ef9cc6)() !== initialViewPort.h) {
                callback((0, $32ec1c9eefd43e20$export$199edc0307b5587f).resize, e.timeStamp);
                unbindResize();
            }
        }
    });
    return [
        unbindWheel,
        unbindKeydown,
        unbindResize
    ];
}


function $64b6f7f3a91eac32$export$72e6dda9d5859230({ revision: revision, isClean: isClean, abortReason: abortReason, VCEntries: VCEntries, componentsLog: componentsLog, interactionId: interactionId }) {
    // Pre-sort VCEntries by time for efficient lookups
    const sortedVCEntries = [
        ...VCEntries
    ].sort((a, b)=>a.time - b.time);
    // Pre-calculate max viewport percentage up to each time for efficient lookups
    const maxViewportPercentageAtTime = new Map();
    let maxSoFar = 0;
    for (const entry of sortedVCEntries){
        maxSoFar = Math.max(maxSoFar, entry.vc);
        maxViewportPercentageAtTime.set(entry.time, maxSoFar);
    }
    // Helper function to find the biggest previous viewport percentage
    const getBiggestPreviousViewportPercentage = (targetTime)=>{
        // Binary search for the largest time <= targetTime
        let left = 0;
        let right = sortedVCEntries.length - 1;
        let result = -1;
        while(left <= right){
            const mid = Math.floor((left + right) / 2);
            if (sortedVCEntries[mid].time <= targetTime) {
                result = mid;
                left = mid + 1;
            } else right = mid - 1;
        }
        return result >= 0 ? maxViewportPercentageAtTime.get(sortedVCEntries[result].time) || null : null;
    };
    const allVcLogs = [];
    // Add regular VC entries
    for (const entry of VCEntries){
        const timeLogEntries = componentsLog[entry.time];
        allVcLogs.push({
            time: entry.time,
            viewportPercentage: entry.vc,
            entries: entry.elements.map((element)=>{
                const logEntry = timeLogEntries?.find((log)=>log.targetName === element);
                return {
                    elementName: element,
                    type: logEntry?.type,
                    rect: logEntry?.intersectionRect,
                    visible: true,
                    attributeName: logEntry?.attributeName,
                    oldValue: logEntry?.oldValue,
                    newValue: logEntry?.newValue,
                    ignoreReason: logEntry?.ignoreReason
                };
            })
        });
    }
    // Add ignored elements - only process timestamps that have ignored elements
    for (const [timestamp, timeLogEntries] of Object.entries(componentsLog)){
        const ignoredElements = timeLogEntries.filter((log)=>log.ignoreReason);
        if (ignoredElements.length === 0) continue;
        const time = Number(timestamp);
        const viewportPercentage = getBiggestPreviousViewportPercentage(time);
        allVcLogs.push({
            time: time,
            viewportPercentage: viewportPercentage,
            entries: ignoredElements.map((logEntry)=>({
                    elementName: logEntry.targetName,
                    type: logEntry.type,
                    rect: logEntry.intersectionRect,
                    visible: false,
                    attributeName: logEntry.attributeName,
                    oldValue: logEntry.oldValue,
                    newValue: logEntry.newValue,
                    ignoreReason: logEntry.ignoreReason
                }))
        });
    }
    // Sort once at the end
    allVcLogs.sort((a, b)=>a.time - b.time);
    return {
        revision: revision,
        isClean: isClean,
        abortReason: abortReason,
        vcLogs: allVcLogs,
        interactionId: interactionId
    };
}




const $a00deaafab0b869b$var$VCParts = [
    '25',
    '50',
    '75',
    '80',
    '85',
    '90',
    '95',
    '98',
    '99'
];
const $a00deaafab0b869b$var$READONLY_EMPTY_ARRAY = Array.from({
    length: 0
});
// Helper function to create vcDetails object to avoid code duplication
function $a00deaafab0b869b$var$createVCDetails(calculatedVC, shouldHaveVCmetric) {
    if (!shouldHaveVCmetric || !calculatedVC || !calculatedVC.VC || !calculatedVC.VCBox) return {};
    const details = {};
    const { VC: VC, VCBox: VCBox } = calculatedVC; // Destructure once to avoid repeated property access
    for (const key of $a00deaafab0b869b$var$VCParts)details[key] = {
        t: VC[key] || -1,
        e: VCBox[key] || $a00deaafab0b869b$var$READONLY_EMPTY_ARRAY
    };
    return details;
}
function $a00deaafab0b869b$export$5c86a34c9becd6d0({ fullPrefix: fullPrefix, interaction: interaction, isVCClean: isVCClean, isEventAborted: isEventAborted, calculatedVC: calculatedVC, calculatedVCNext: calculatedVCNext, experienceKey: experienceKey, ratios: ratios }) {
    const pageVisibilityUpToTTAI = (0, $609a77f2077f290f$export$768b2008623433e1)(interaction.start, interaction.end);
    const isVisiblePageVisibleUpToTTAI = pageVisibilityUpToTTAI === 'visible';
    const shouldHaveVCmetric = isVCClean && !isEventAborted && isVisiblePageVisibleUpToTTAI;
    const availableVCRevisionPayloads = [];
    if ((0, $9a2f9fc0af024eb1$export$4babcefc81a3ef0b)('fy25.01', experienceKey)) {
        const revision = {
            revision: 'fy25.01',
            clean: isVCClean,
            'metric:vc90': shouldHaveVCmetric ? calculatedVC.VC['90'] : null,
            vcDetails: $a00deaafab0b869b$var$createVCDetails(calculatedVC, shouldHaveVCmetric)
        };
        if (shouldHaveVCmetric) revision.ratios = ratios;
        availableVCRevisionPayloads.push(revision);
    }
    if ((0, $9a2f9fc0af024eb1$export$4babcefc81a3ef0b)('fy25.02', experienceKey)) {
        const revision = {
            revision: 'fy25.02',
            clean: isVCClean,
            'metric:vc90': shouldHaveVCmetric ? calculatedVCNext.VC['90'] : null,
            vcDetails: $a00deaafab0b869b$var$createVCDetails(calculatedVCNext, shouldHaveVCmetric)
        };
        if (shouldHaveVCmetric) revision.ratios = ratios;
        availableVCRevisionPayloads.push(revision);
    }
    return {
        [`${fullPrefix}vc:rev`]: availableVCRevisionPayloads
    };
}



var $cf73c70412c0bb28$exports = {};
'use strict';

$cf73c70412c0bb28$exports = (parcelRequire("fKdKH"));


parcelRequire("dQwsT");
const $8b85e902fbcc028e$export$7674290405cc25b0 = 'data-media-vc-wrapper';
const $8b85e902fbcc028e$export$7028e9efe569888c = {
    [$8b85e902fbcc028e$export$7674290405cc25b0]: true
};
function $8b85e902fbcc028e$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $cf73c70412c0bb28$exports.jsx)("div", {
        ...$8b85e902fbcc028e$export$7028e9efe569888c,
        children: children
    });
}


function $4f6b6a84812e9b6d$export$f61fbc3b9c4a9019(node) {
    while(node){
        if (node instanceof Element && node.hasAttribute((0, $8b85e902fbcc028e$export$7674290405cc25b0))) return true;
        node = node.parentNode;
    }
    return false;
}


/**
 * Checks if a mutation record represents a non-visual style change
 * @param mutation - The mutation record to check
 * @returns boolean indicating if this is a non-visual style mutation
 *
 * A mutation is considered non-visual if:
 * - The target has data-	vc-nvs="true" attribute
 * - The changed attribute is either 'class' or 'style'
 */ function $387f610f1929929a$var$isNonVisualStyleMutation({ target: target, attributeName: attributeName }) {
    if (!(target instanceof Element)) return false;
    if (attributeName !== 'class' && attributeName !== 'style') return false;
    if (target.getAttribute('data-vc-nvs') !== 'true') return false;
    return true;
}
var $387f610f1929929a$export$2e2bcd8739ae039 = $387f610f1929929a$var$isNonVisualStyleMutation;


const $87406626d26e1e53$var$GLOBAL_RLL_HANDLERS_KEY = '__REACT_UFO_RLL_PLACEHOLDER_HANDLERS__';
class $87406626d26e1e53$export$166779fc0f49d4df {
    /**
   * Gets the global singleton instance of RLLPlaceholderHandlers.
   * Creates the instance if it doesn't exist and stores it in globalThis.
   * @returns The singleton instance of RLLPlaceholderHandlers
   */ static getInstance() {
        if (typeof globalThis !== 'undefined') {
            if (!globalThis[$87406626d26e1e53$var$GLOBAL_RLL_HANDLERS_KEY]) globalThis[$87406626d26e1e53$var$GLOBAL_RLL_HANDLERS_KEY] = new $87406626d26e1e53$export$166779fc0f49d4df();
            return globalThis[$87406626d26e1e53$var$GLOBAL_RLL_HANDLERS_KEY];
        }
        // Fallback for environments without globalThis (should be rare)
        return new $87406626d26e1e53$export$166779fc0f49d4df();
    }
    reset() {
        this.placeholders = [];
    }
    /**
   * Collects all React Loosely Lazy (RLL) placeholders from the DOM and caches their viewport intersecting rectangles.
   * RLL placeholders are marked with data-lazy-begin and data-lazy-end attributes on hidden input elements.
   * Performance optimized to batch getBoundingClientRect calls and minimize layout thrashing.
   * Only stores the intersecting portions of rectangles that are currently visible in the viewport.
   */ collectRLLPlaceholders() {
        if (typeof window === 'undefined' || typeof document === 'undefined' || typeof window.document === 'undefined') return;
        const beginElements = document.querySelectorAll('input[data-lazy-begin]');
        const beginCount = beginElements.length;
        if (beginCount === 0) return;
        // Performance optimization: pre-allocate array with estimated size
        const allElements = [];
        // Performance optimization: use traditional for loop instead of forEach
        for(let i = 0; i < beginCount; i++){
            const beginEl = beginElements[i];
            const id = beginEl.getAttribute('data-lazy-begin');
            if (!id) continue;
            const elements = this.refElements(beginEl, id);
            if (elements.length > 0) allElements.push(...elements);
        }
        // Second pass: batch all getBoundingClientRect calls to minimize reflow cycles
        const allElementsLength = allElements.length;
        if (allElementsLength > 0) {
            // Performance optimization: pre-allocate array with exact size
            const intersectingRects = [];
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            for(let i = 0; i < allElementsLength; i++){
                const rect = allElements[i].getBoundingClientRect();
                // Performance optimization: inline intersection calculation to avoid function call overhead
                const left = Math.max(rect.left, 0);
                const top = Math.max(rect.top, 0);
                const right = Math.min(rect.right, windowWidth);
                const bottom = Math.min(rect.bottom, windowHeight);
                // Check if there's a valid intersection with non-zero width and height
                if (left < right && top < bottom) intersectingRects.push(new DOMRect(left, top, right - left, bottom - top));
            }
            this.placeholders = intersectingRects;
        }
    }
    /**
   * Traverses DOM siblings to find all elements between RLL begin and end markers.
   * Based on the refElements pattern from react-loosely-lazy's platform/packages/async/react-loosely-lazy/src/collect/hydrate.ts
   * Performance optimized to minimize iterations and early exit conditions.
   *
   * @param fromEl - The input element with data-lazy-begin attribute
   * @param id - The placeholder ID to match against data-lazy-end
   * @returns Array of DOM elements between the begin/end markers
   */ refElements(fromEl, id) {
        const result = [];
        let el = fromEl.nextSibling;
        // Performance optimization: use while loop instead of recursive calls
        while(el){
            if (el.dataset?.lazyEnd === id) break;
            if (el.nodeType === Node.ELEMENT_NODE) result.push(el);
            el = el.nextSibling;
        }
        return result;
    }
    /**
   * Returns the cached intersecting viewport rectangles for all RLL placeholder elements.
   * @returns Array of DOMRect objects representing the intersecting portions of placeholders within the viewport
   */ getPlaceholders() {
        return this.placeholders;
    }
    /**
   * Checks if the given intersecting rectangle matches any of the cached RLL placeholder intersecting rectangles.
   * This is designed to be called from IntersectionObserver with the intersectionRect.
   * Performance optimized with early exits and minimal calculations.
   * @param intersectingRect - The intersecting rectangle from IntersectionObserver
   * @returns true if the intersecting rectangle matches a cached placeholder rectangle and hasn't exceeded match limit, false otherwise
   */ isRLLPlaceholderHydration(intersectingRect) {
        const placeholdersLength = this.placeholders.length;
        if (placeholdersLength === 0) return false;
        // Performance optimization: cache array length and use traditional for loop
        for(let i = 0; i < placeholdersLength; i++){
            const placeholderRect = this.placeholders[i];
            if (this.areRectsEqual(intersectingRect, placeholderRect)) return true;
        }
        return false;
    }
    /**
   * Compares two DOMRect objects for equality with ±1 pixel tolerance.
   * Performance optimized to minimize calculations and early exit on major differences.
   * @param rect1 - First rectangle to compare
   * @param rect2 - Second rectangle to compare
   * @returns true if rectangles are within 1 pixel tolerance for all properties
   */ areRectsEqual(rect1, rect2) {
        // Early exit for exact matches (most common case)
        if (rect1.left === rect2.left && rect1.top === rect2.top && rect1.right === rect2.right && rect1.bottom === rect2.bottom) return true;
        // Performance optimization: check largest differences first for early exit
        const leftDiff = rect1.left - rect2.left;
        if (leftDiff > 1 || leftDiff < -1) return false;
        const rightDiff = rect1.right - rect2.right;
        if (rightDiff > 1 || rightDiff < -1) return false;
        const topDiff = rect1.top - rect2.top;
        if (topDiff > 1 || topDiff < -1) return false;
        const bottomDiff = rect1.bottom - rect2.bottom;
        if (bottomDiff > 1 || bottomDiff < -1) return false;
        return true;
    }
    constructor(){
        this.placeholders = [];
        if (typeof window !== 'undefined' && typeof document !== 'undefined' && typeof window.document !== 'undefined') this.collectRLLPlaceholders();
    }
}



const $2980e382ee19fa1c$var$ANCESTOR_LOOKUP_LIMIT = 10;
const $2980e382ee19fa1c$var$PAGE_LAYOUT_ID = 'page-layout.root';
class $2980e382ee19fa1c$export$c0102f1a1198d10f {
    clear() {
        this.staticPlaceholders = new Map();
        this.callbacks = new Map();
        this.getSizeCallbacks = new Map();
        this.reactValidateCallbacks = new Map();
    }
    collectPlaceholdersInternal() {
        const selector = this.enablePageLayoutPlaceholder ? '[data-ssr-placeholder],[data-testid="page-layout.root"]' : '[data-ssr-placeholder]';
        const existingElements = document.querySelectorAll(selector);
        existingElements.forEach((el)=>{
            const placeholderId = el instanceof HTMLElement && this.getPlaceholderId(el);
            if (placeholderId && !this.staticPlaceholders.has(placeholderId)) {
                let width = -1;
                let height = -1;
                let x = -1;
                let y = -1;
                // Use SSR dimensions from window global if available
                const boundingClientRect = window.__SSR_PLACEHOLDERS_DIMENSIONS__?.[placeholderId];
                if (boundingClientRect) {
                    width = boundingClientRect.width;
                    height = boundingClientRect.height;
                    x = boundingClientRect.x;
                    y = boundingClientRect.y;
                } else {
                    // Fallback to current bounding rect if SSR dimensions not available
                    const rect = el.getBoundingClientRect();
                    width = rect.width;
                    height = rect.height;
                    x = rect.x;
                    y = rect.y;
                }
                this.staticPlaceholders.set(placeholderId, {
                    width: width,
                    height: height,
                    x: x,
                    y: y
                });
                this.intersectionObserver?.observe(el);
            }
        });
    }
    /**
   * Added this method to be utilised for testing purposes.
   * In production it collection placeholder should only happens on constructor
   */ collectExistingPlaceholders() {
        if (!window.document) return;
        try {
            // Collect placeholders using SSR dimensions or fallback to live dimensions
            this.collectPlaceholdersInternal();
        } catch  {
        // Silently fail if there are any issues
        } finally{
            delete window.__SSR_PLACEHOLDERS_DIMENSIONS__;
        }
    }
    isPlaceholder(element) {
        return Boolean(this.getPlaceholderId(element));
    }
    isPlaceholderReplacement(element) {
        return Boolean(this.getPlaceholderReplacementId(element));
    }
    isPlaceholderIgnored(element) {
        // data-ssr-placeholder-ignored doesn't have a value.
        return 'ssrPlaceholderIgnored' in element.dataset;
    }
    isPlaceholderV4(element) {
        let currentElement = element;
        let i = 0;
        while(currentElement && i < $2980e382ee19fa1c$var$ANCESTOR_LOOKUP_LIMIT){
            if (Boolean(this.getPlaceholderId(currentElement))) return true;
            currentElement = currentElement.parentElement;
            i++;
        }
        return false;
    }
    isPlaceholderReplacementV4(element) {
        let currentElement = element;
        let i = 0;
        while(currentElement && i < $2980e382ee19fa1c$var$ANCESTOR_LOOKUP_LIMIT){
            if (Boolean(this.getPlaceholderReplacementId(currentElement))) return true;
            currentElement = currentElement.parentElement;
            i++;
        }
        return false;
    }
    findNearestPlaceholderContainerIfIgnored(element) {
        if (!this.isPlaceholderIgnored(element)) return element;
        let ancestor = element.parentElement;
        let i = 0;
        while(ancestor && i < $2980e382ee19fa1c$var$ANCESTOR_LOOKUP_LIMIT){
            if (this.isPlaceholder(ancestor) || this.isPlaceholderReplacement(ancestor)) return ancestor;
            ancestor = ancestor.parentElement;
            i++;
        }
        return element;
    }
    findNearestPlaceholderOrContainer(element, limit = $2980e382ee19fa1c$var$ANCESTOR_LOOKUP_LIMIT) {
        let ancestor = element;
        if (this.isPlaceholderIgnored(element) && element.parentElement) ancestor = element.parentElement;
        let i = 0;
        while(ancestor && i < limit){
            if (this.isPlaceholder(ancestor) || this.isPlaceholderReplacement(ancestor)) return ancestor;
            if (ancestor.parentElement) {
                ancestor = ancestor.parentElement;
                i++;
            } else break;
        }
        return element;
    }
    // Validates placeholder match using asynchronous observation and resolves with the result
    checkIfExistedAndSizeMatching(el) {
        el = this.findNearestPlaceholderContainerIfIgnored(el);
        const id = this.getPlaceholderId(el);
        return new Promise((resolve)=>{
            if (!this.staticPlaceholders.has(id)) {
                resolve(false);
                return;
            } else {
                this.callbacks.set(id, resolve);
                this.intersectionObserver?.observe(el);
            }
        });
    }
    // Validates placeholder match synchronously using stored SSR dimensions and current bounds
    checkIfExistedAndSizeMatchingV3(el) {
        el = this.findNearestPlaceholderContainerIfIgnored(el);
        const id = this.getPlaceholderId(el);
        const placeholderRects = this.staticPlaceholders.get(id);
        if (!placeholderRects) return false;
        return this.hasSameSizePosition(placeholderRects, this.getEffectiveBoundingRect(el));
    }
    getSize(el) {
        return new Promise((resolve)=>{
            this.getSizeCallbacks.set(this.getPlaceholderId(el), resolve);
            this.intersectionObserver?.observe(el);
        });
    }
    validateReactComponentMatchToPlaceholder(el) {
        el = this.findNearestPlaceholderContainerIfIgnored(el);
        const id = this.getPlaceholderReplacementId(el);
        return new Promise((resolve)=>{
            if (!this.staticPlaceholders.has(id)) {
                resolve(false);
                return;
            } else {
                this.reactValidateCallbacks.set(id, resolve);
                this.intersectionObserver?.observe(el);
            }
        });
    }
    validateReactComponentMatchToPlaceholderV4(el) {
        el = (0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_ufo_v4_fix_nested_ssr_placeholder') ? this.findNearestPlaceholderOrContainer(el, 2) // We are using 2 due to over-eagerness of the default, only check itself and 1 ancestor
         : this.findNearestPlaceholderContainerIfIgnored(el);
        const id = this.getPlaceholderReplacementId(el);
        return this.staticPlaceholders.has(id);
    }
    hasSameSizePosition(rect, boundingClientRect) {
        if (!rect) return false;
        const horizontalCheck = Math.abs(rect.x - boundingClientRect.x) < this.EQUALITY_THRESHOLD && Math.abs(rect.width - boundingClientRect.width) < this.EQUALITY_THRESHOLD;
        const verticalCheck = Math.abs(rect.y - boundingClientRect.y) < this.EQUALITY_THRESHOLD && Math.abs(rect.height - boundingClientRect.height) < this.EQUALITY_THRESHOLD;
        return horizontalCheck && verticalCheck || false;
    }
    /**
   * Gets the effective bounding rectangle for an element, handling display: contents elements
   * by collecting dimensions from their children instead
   */ getEffectiveBoundingRect(el) {
        if ((0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_ufo_disable_vcnext_observations')) return el.getBoundingClientRect();
        const computedStyle = window.getComputedStyle(el);
        // If element has display: contents, collect bounding rect from children
        if (computedStyle.display === 'contents') {
            const children = Array.from(el.children);
            if (children.length === 0) // No children, return zero rect
            return new DOMRect(0, 0, 0, 0);
            // Calculate union of all children's bounding rects
            let minX = Infinity;
            let minY = Infinity;
            let maxX = -Infinity;
            let maxY = -Infinity;
            children.forEach((child)=>{
                const childRect = child.getBoundingClientRect();
                // Skip children with zero dimensions (likely also display: contents)
                if (childRect.width > 0 || childRect.height > 0) {
                    minX = Math.min(minX, childRect.left);
                    minY = Math.min(minY, childRect.top);
                    maxX = Math.max(maxX, childRect.right);
                    maxY = Math.max(maxY, childRect.bottom);
                }
            });
            // If no children with dimensions found, return zero rect
            if (minX === Infinity) return new DOMRect(0, 0, 0, 0);
            return new DOMRect(minX, minY, maxX - minX, maxY - minY);
        }
        // Normal element, return its bounding rect
        return el.getBoundingClientRect();
    }
    isDummyRect(rect) {
        return rect && rect.width < 0 && rect.height < 0 || false;
    }
    constructor({ enablePageLayoutPlaceholder: enablePageLayoutPlaceholder = false }){
        this.staticPlaceholders = new Map();
        this.callbacks = new Map();
        this.getSizeCallbacks = new Map();
        this.reactValidateCallbacks = new Map();
        this.intersectionObserver = void 0;
        this.EQUALITY_THRESHOLD = 1;
        this.enablePageLayoutPlaceholder = void 0;
        this.getPlaceholderId = (el)=>{
            const ssrPlaceholderId = el?.dataset?.ssrPlaceholder;
            if (!!ssrPlaceholderId) return ssrPlaceholderId;
            if (this.enablePageLayoutPlaceholder && el?.dataset.testid === $2980e382ee19fa1c$var$PAGE_LAYOUT_ID) return $2980e382ee19fa1c$var$PAGE_LAYOUT_ID;
            return '';
        };
        this.getPlaceholderReplacementId = (el)=>{
            const ssrPlaceholderReplaceId = el?.dataset?.ssrPlaceholderReplace;
            if (!!ssrPlaceholderReplaceId) return ssrPlaceholderReplaceId;
            if (this.enablePageLayoutPlaceholder && el?.dataset.testid === $2980e382ee19fa1c$var$PAGE_LAYOUT_ID) return $2980e382ee19fa1c$var$PAGE_LAYOUT_ID;
            return '';
        };
        this.intersectionObserverCallback = ({ target: target, boundingClientRect: boundingClientRect })=>{
            this.intersectionObserver?.unobserve(target);
            if (!(target instanceof HTMLElement)) // impossible case - keep typescript healthy
            return;
            const staticKey = this.getPlaceholderId(target);
            if (staticKey) {
                if (this.staticPlaceholders.has(staticKey) && this.callbacks.has(staticKey)) {
                    // validation
                    const resolve = this.callbacks.get(staticKey);
                    if (!resolve) return;
                    const rect = this.staticPlaceholders.get(staticKey);
                    const hasSameSizePosition = this.hasSameSizePosition(rect, boundingClientRect);
                    if (hasSameSizePosition || this.isDummyRect(rect)) resolve(hasSameSizePosition);
                    else requestAnimationFrame(()=>{
                        const targetRect = this.getEffectiveBoundingRect(target);
                        const hasSameSizePosition = this.hasSameSizePosition(rect, targetRect);
                        resolve(hasSameSizePosition);
                    });
                    this.callbacks.delete(staticKey);
                }
            } else {
                const key = this.getPlaceholderReplacementId(target);
                const resolve = this.reactValidateCallbacks.get(key);
                if (!resolve) return;
                const rect = this.staticPlaceholders.get(key);
                const hasSameSizePosition = this.hasSameSizePosition(rect, boundingClientRect);
                if (hasSameSizePosition || this.isDummyRect(rect)) resolve(hasSameSizePosition);
                else requestAnimationFrame(()=>{
                    const targetRect = this.getEffectiveBoundingRect(target);
                    const hasSameSizePosition = this.hasSameSizePosition(rect, targetRect);
                    resolve(hasSameSizePosition);
                });
                this.staticPlaceholders.delete(staticKey);
                this.reactValidateCallbacks.delete(staticKey);
            }
        };
        if (typeof IntersectionObserver === 'function') // Only instantiate the IntersectionObserver if it's supported
        this.intersectionObserver = new IntersectionObserver((entries)=>entries.filter((entry)=>entry.intersectionRatio > 0).forEach(this.intersectionObserverCallback));
        this.enablePageLayoutPlaceholder = enablePageLayoutPlaceholder;
        if (window.document) try {
            // Collect initial placeholders using SSR dimensions
            this.collectPlaceholdersInternal();
        } catch  {} finally{
            delete window.__SSR_PLACEHOLDERS_DIMENSIONS__;
        }
    }
}


const $d3be5e09e146fd6a$var$state = {
    normal: 1,
    waitingForFirstRender: 2,
    ignoring: 3
};
function $d3be5e09e146fd6a$var$isElementVisible(target) {
    if (!target || typeof target.checkVisibility !== 'function') return true;
    const isVisible = target.checkVisibility({
        contentVisibilityAuto: true,
        opacityProperty: true,
        visibilityProperty: true
    });
    return isVisible;
}
class $d3be5e09e146fd6a$export$b65d046240060e78 {
    isBrowserSupported() {
        return typeof window.IntersectionObserver === 'function' && typeof window.MutationObserver === 'function';
    }
    observe() {
        this.totalTime = 0;
        this.ssr = {
            state: $d3be5e09e146fd6a$var$state.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        this.mutationObserver?.observe(document.body, {
            attributeFilter: [
                'hidden',
                'style',
                'src',
                'class'
            ],
            attributeOldValue: true,
            attributes: true,
            childList: true,
            subtree: true
        });
    }
    disconnect() {
        this.mutationObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.observedMutations = new WeakMap();
        this.elementsInView.clear();
        this.callbacks.clear();
        this.ssr.reactRootElement = null;
        this.ssrPlaceholderHandler.clear();
    }
    getTotalTime() {
        return this.totalTime;
    }
    setReactRootElement(element) {
        this.ssr.reactRootElement = element;
    }
    setReactRootRenderStart(startTime = performance.now()) {
        this.ssr.renderStart = startTime;
        this.ssr.state = $d3be5e09e146fd6a$var$state.waitingForFirstRender;
    }
    setReactRootRenderStop(stopTime = performance.now()) {
        this.ssr.renderStop = stopTime;
    }
    getMutationObserver() {
        if (!this.isBrowserSupported()) return null;
        return new MutationObserver((mutations)=>{
            this.measureStart();
            mutations.forEach((mutation)=>{
                // patching element if timestamp not automatically added
                // eslint-disable-next-line no-param-reassign
                mutation.timestamp = mutation.timestamp === undefined ? performance.now() : mutation.timestamp;
                let ignoreReason = '';
                if (this.ssr.state === $d3be5e09e146fd6a$var$state.waitingForFirstRender && mutation.timestamp > this.ssr.renderStart && mutation.target === this.ssr.reactRootElement) {
                    this.ssr.state = $d3be5e09e146fd6a$var$state.ignoring;
                    if (this.ssr.renderStop === -1) // arbitrary 500ms DOM update window
                    this.ssr.renderStop = mutation.timestamp + 500;
                    ignoreReason = 'ssr-hydration';
                }
                if (this.ssr.state === $d3be5e09e146fd6a$var$state.ignoring && mutation.timestamp > this.ssr.renderStart && mutation.target === this.ssr.reactRootElement) {
                    if (mutation.timestamp <= this.ssr.renderStop) ignoreReason = 'ssr-hydration';
                    else this.ssr.state = $d3be5e09e146fd6a$var$state.normal;
                }
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach((node)=>{
                        if ((0, $4f6b6a84812e9b6d$export$f61fbc3b9c4a9019)(node)) ignoreReason = 'image';
                        if (node instanceof HTMLElement) {
                            if (this.ssrPlaceholderHandler.isPlaceholder(node) || this.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                this.ssrPlaceholderHandler.checkIfExistedAndSizeMatching(node).then((result)=>{
                                    if (result === false) this.observeElement(node, mutation, 'html', ignoreReason);
                                });
                                return;
                            }
                            if (this.ssrPlaceholderHandler.isPlaceholderReplacement(node) || this.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                this.ssrPlaceholderHandler.validateReactComponentMatchToPlaceholder(node).then((result)=>{
                                    if (result === false) this.observeElement(node, mutation, 'html', ignoreReason);
                                });
                                return;
                            }
                            this.observeElement(node, mutation, 'html', ignoreReason);
                        }
                        if (node instanceof Text && node.parentElement != null) this.observeElement(node.parentElement, mutation, 'text', ignoreReason);
                    });
                    mutation.removedNodes.forEach((node)=>{
                        if (node instanceof Element) {
                            this.elementsInView.delete(node);
                            this.intersectionObserver?.unobserve(node);
                        }
                    });
                } else if (mutation.type === 'attributes') {
                    if (mutation.target instanceof HTMLElement) {
                        const attributeName = mutation.attributeName;
                        /*
            	"MutationObserver was explicitly designed to work that way, but I can't now recall the reasoning.
            	I think it might have been something along the lines that for consistency every setAttribute call should create a record.
            	Conceptually there is after all a mutation: there is an old value replaced with a new one,
            	and whether or not they are the same doesn't really matter.
            	And Custom elements should work the same way as MutationObserver."
            	https://github.com/whatwg/dom/issues/520#issuecomment-336574796
            */ const oldValue = mutation.oldValue ?? undefined;
                        const newValue = attributeName ? mutation.target.getAttribute(attributeName) : undefined;
                        if (oldValue !== newValue) {
                            if ((0, $387f610f1929929a$export$2e2bcd8739ae039)(mutation)) ignoreReason = 'non-visual-style';
                            if ((0, $4f6b6a84812e9b6d$export$f61fbc3b9c4a9019)(mutation.target)) ignoreReason = 'image';
                            this.observeElement(mutation.target, mutation, 'attr', ignoreReason, attributeName, oldValue, newValue);
                        }
                    }
                }
            });
        });
    }
    getElementName(element) {
        try {
            const tagName = element.localName;
            const dataVCAttr = element.getAttribute('data-vc');
            const dataVC = this.selectorConfig.dataVC && dataVCAttr ? `[data-vc="${dataVCAttr}"]` : '';
            const id = this.selectorConfig.id && element.id ? `#${element.id}` : '';
            let testId = this.selectorConfig.testId ? element.getAttribute('data-testid') || element.getAttribute('data-test-id') : '';
            testId = testId ? `[testid=${testId}]` : '';
            let role = this.selectorConfig.role ? element.getAttribute('role') : '';
            role = role ? `[role=${role}]` : '';
            let classList = this.selectorConfig.className ? Array.from(element.classList).join('.') : '';
            classList = classList === '' ? '' : `.${classList}`;
            const attrs = dataVC ? dataVC : [
                id,
                testId,
                role
            ].join('');
            let idString = '';
            if (attrs === '' && classList === '') {
                const parent = element.parentElement ? this.getElementName(element.parentElement) : 'unknown';
                idString = `${parent} > ${tagName}`;
            } else idString = [
                tagName,
                attrs || classList
            ].join('');
            return idString;
        } catch  {
            return 'error';
        }
    }
    getIntersectionObserver() {
        if (!this.isBrowserSupported()) return null;
        return new IntersectionObserver((entries)=>{
            this.measureStart();
            entries.forEach(({ isIntersecting: isIntersecting, intersectionRect: ir, target: target })=>{
                const data = this.observedMutations.get(target);
                this.observedMutations.delete(target);
                if (isIntersecting && ir.width > 0 && ir.height > 0) {
                    if (!(target instanceof HTMLElement)) return;
                    if (!data?.mutation) // ignore intersection report without recent mutation
                    return;
                    if (!$d3be5e09e146fd6a$var$isElementVisible(target)) data.ignoreReason = 'not-visible';
                    if ((0, $87406626d26e1e53$export$166779fc0f49d4df).getInstance().isRLLPlaceholderHydration(ir)) data.ignoreReason = 'rll-placeholder';
                    this.callbacks.forEach((callback)=>{
                        let elementName;
                        try {
                            elementName = this.getElementName(target);
                        } catch  {
                            elementName = 'error';
                        }
                        callback(data.mutation.timestamp || performance.now(), ir, elementName, target, data.type, data.ignoreReason, data.attributeName, data.oldValue, data.newValue);
                    });
                    this.elementsInView.add(target);
                } else this.elementsInView.delete(target);
            });
            this.measureStop();
        });
    }
    measureStart() {
        this._startMeasureTimestamp = performance.now();
    }
    measureStop() {
        if (this._startMeasureTimestamp === -1) return;
        this.totalTime += performance.now() - this._startMeasureTimestamp;
        this._startMeasureTimestamp = -1;
    }
    constructor(opts){
        this.intersectionObserver = void 0;
        this.mutationObserver = void 0;
        this.observedMutations = new WeakMap();
        this.elementsInView = new Set();
        this.callbacks = new Set();
        this.totalTime = 0;
        this._startMeasureTimestamp = -1;
        this.ssrPlaceholderHandler = void 0;
        this.ssr = {
            state: $d3be5e09e146fd6a$var$state.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        this.selectorConfig = {
            id: false,
            testId: false,
            role: false,
            className: true,
            dataVC: true
        };
        this.subscribeResults = (cb)=>{
            this.callbacks.add(cb);
        };
        this.observeElement = (node, mutation, type, ignoreReason, attributeName, oldValue = null, newValue = null)=>{
            this.intersectionObserver?.observe(node);
            this.observedMutations.set(node, {
                mutation: mutation,
                ignoreReason: ignoreReason,
                type: type,
                attributeName: attributeName,
                oldValue: oldValue,
                newValue: newValue
            });
        };
        this.selectorConfig = {
            ...this.selectorConfig,
            ...opts.selectorConfig
        };
        this.intersectionObserver = this.getIntersectionObserver();
        this.mutationObserver = this.getMutationObserver();
        // Use shared SSR placeholder handler if provided, otherwise create new one
        if (opts.ssrPlaceholderHandler) this.ssrPlaceholderHandler = opts.ssrPlaceholderHandler;
        else this.ssrPlaceholderHandler = new (0, $2980e382ee19fa1c$export$c0102f1a1198d10f)({
            enablePageLayoutPlaceholder: opts.SSRConfig?.enablePageLayoutPlaceholder
        });
    }
}


const $a9a4078a79494f2d$var$abortReason = {
    scroll: 'scroll',
    keypress: 'keypress',
    resize: 'resize',
    error: 'error'
};
const $a9a4078a79494f2d$var$UNUSED_SECTOR = 0;
function $a9a4078a79494f2d$var$filterComponentsLog(log) {
    return Object.fromEntries(Object.entries(log).map(([timestamp, entries])=>[
            Number(timestamp),
            entries.map((entry)=>{
                const { __debug__element: __debug__element, ...rest } = entry;
                return rest;
            })
        ]));
}
class $a9a4078a79494f2d$export$1f70d263701b1d01 {
    start({ startTime: startTime }) {
        this.active = true;
        if (this.observers.isBrowserSupported()) {
            this.setViewportSize();
            this.resetState();
            this.startTime = startTime;
            this.attachAbortListeners();
            this.observers.subscribeResults(this.handleUpdate);
            this.observers.observe();
        } else this.setAbortReason('not-supported', startTime);
    }
    stop() {
        this.observers.disconnect();
        this.detachAbortListeners();
    }
    getIgnoredElements(componentsLog) {
        return Object.values(componentsLog).flat().filter(({ ignoreReason: ignoreReason })=>Boolean(ignoreReason)).map(({ targetName: targetName, ignoreReason: ignoreReason })=>({
                targetName: targetName,
                ignoreReason: ignoreReason
            }));
    }
    static getSSRRatio(entries, ssr) {
        if (ssr === undefined || entries.length === 0) return undefined;
        const maybeSSR = entries[0];
        if (maybeSSR.elements[0] === 'SSR') return maybeSSR.vc;
        return 0;
    }
    static calculateVC({ heatmap: heatmap, ssr: ssr = $a9a4078a79494f2d$var$UNUSED_SECTOR, componentsLog: componentsLog, viewport: viewport, fixSSRAttribution: fixSSRAttribution }) {
        const lastUpdate = {};
        let totalPainted = 0;
        const ssrTime = fixSSRAttribution ? Math.floor(ssr) : ssr;
        if (ssrTime !== $a9a4078a79494f2d$var$UNUSED_SECTOR) {
            const element = {
                __debug__element: new WeakRef(window.document?.body),
                intersectionRect: {
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    x: 0,
                    y: 0,
                    width: viewport.w,
                    height: viewport.h,
                    toJSON () {
                        return {};
                    }
                },
                targetName: 'SSR'
            };
            if (!componentsLog[ssrTime]) componentsLog[ssrTime] = [];
            componentsLog[ssrTime].push(element);
        }
        heatmap.forEach((line)=>{
            line.forEach((entry)=>{
                const rounded = Math.floor(entry === $a9a4078a79494f2d$var$UNUSED_SECTOR && ssrTime !== $a9a4078a79494f2d$var$UNUSED_SECTOR ? ssrTime : entry);
                totalPainted += rounded !== $a9a4078a79494f2d$var$UNUSED_SECTOR ? 1 : 0;
                if (rounded !== $a9a4078a79494f2d$var$UNUSED_SECTOR) lastUpdate[rounded] = lastUpdate[rounded] ? lastUpdate[rounded] + 1 : 1;
            });
        });
        const entries = Object.entries(lastUpdate).map((a)=>[
                parseInt(a[0], 10),
                a[1]
            ]).sort((a, b)=>a[0] > b[0] ? 1 : -1);
        const VC = $a9a4078a79494f2d$export$1f70d263701b1d01.makeVCReturnObj();
        const VCBox = $a9a4078a79494f2d$export$1f70d263701b1d01.makeVCReturnObj();
        entries.reduce((acc = 0, v)=>{
            const currRatio = v[1] / totalPainted;
            let VCRatio = currRatio + acc;
            const preciseCurrRatio = Math.round(100 * (v[1] / totalPainted));
            const preciseAccRatio = Math.round(acc * 100);
            VCRatio = (preciseCurrRatio + preciseAccRatio) / 100;
            const time = v[0];
            $a9a4078a79494f2d$export$1f70d263701b1d01.VCParts.forEach((key)=>{
                const value = parseInt(key, 10);
                if ((VC[key] === null || VC[key] === undefined) && VCRatio >= value / 100) {
                    VC[key] = time;
                    VCBox[key] = [
                        ...new Set(componentsLog[time]?.filter((v)=>!v.ignoreReason).map((v)=>v.targetName))
                    ];
                }
            });
            return VCRatio;
        }, 0);
        const VCEntries = entries.reduce((acc, [timestamp, entryPainted], i)=>{
            const currentlyPainted = entryPainted + (acc.abs[i - 1]?.[1] || 0);
            const currentlyPaintedRatio = Math.round(currentlyPainted / totalPainted * 1000) / 10;
            const logEntry = [
                ...new Set(componentsLog[timestamp]?.filter((v)=>!v.ignoreReason).map((v)=>v.targetName))
            ];
            const ratioDelta = (currentlyPaintedRatio - (acc.rel[i - 1]?.vc ?? 0)) / 100;
            const speedIndex = timestamp * ratioDelta;
            acc.speedIndex += speedIndex;
            acc.abs.push([
                timestamp,
                currentlyPainted
            ]);
            acc.rel.push({
                time: timestamp,
                vc: currentlyPaintedRatio,
                elements: logEntry
            });
            return acc;
        }, {
            abs: [],
            rel: [],
            speedIndex: 0
        });
        VCEntries.speedIndex = Math.round(VCEntries.speedIndex);
        return {
            VC: VC,
            VCBox: VCBox,
            VCEntries: VCEntries,
            totalPainted: totalPainted
        };
    }
    setSSRElement(element) {
        this.observers.setReactRootElement(element);
    }
    setReactRootRenderStart(startTime = performance.now()) {
        this.observers.setReactRootRenderStart(startTime);
    }
    setReactRootRenderStop(stopTime = performance.now()) {
        this.observers.setReactRootRenderStop(stopTime);
    }
    collectSSRPlaceholders() {
    // This is handled by the shared SSRPlaceholderHandlers in VCObserverWrapper
    // Individual observers don't need to implement this
    }
    setAbortReason(abort, timestamp, info = '') {
        if (this.abortReason.reason === null || this.abortReason.blocking === false) {
            this.abortReason.reason = abort;
            this.abortReason.info = info;
            this.abortReason.timestamp = timestamp;
            this.abortReason.blocking = abort !== $a9a4078a79494f2d$var$abortReason.scroll;
            if (this.abortReason.blocking) this.detachAbortListeners();
        }
    }
    resetState() {
        this.abortReason = {
            reason: null,
            info: '',
            timestamp: -1,
            blocking: false
        };
        this.detachAbortListeners();
        this.heatmap = !(0, $9a2f9fc0af024eb1$export$4babcefc81a3ef0b)('fy25.01') ? [] : this.getCleanHeatmap();
        this.heatmapNext = this.getCleanHeatmap();
        this.totalTime = 0;
        this.componentsLog = {};
        this.vcRatios = {};
    }
    getCleanHeatmap() {
        return Array(this.arraySize).fill('').map(()=>Array(this.arraySize).fill($a9a4078a79494f2d$var$UNUSED_SECTOR));
    }
    setViewportSize() {
        this.viewport.w = (0, $cb142781691e200c$export$a497a1dcb4408212)();
        this.viewport.h = (0, $cb142781691e200c$export$4f01c15d21ef9cc6)();
    }
    applyChangesToHeatMap(a, time, heatmap) {
        const { l: l, t: t, r: r, b: b } = a;
        const localHeatmap = heatmap;
        for(let row = t; row < b; row++){
            for(let col = l; col < r; col++)if (localHeatmap[row] === undefined) {
                try {
                    this.setAbortReason($a9a4078a79494f2d$var$abortReason.error, time, `index - ${row}`);
                } catch  {
                    this.setAbortReason($a9a4078a79494f2d$var$abortReason.error, time, 'row error');
                }
                return;
            } else localHeatmap[row][col] = time;
        }
    }
    static makeVCReturnObj() {
        const vc = {};
        $a9a4078a79494f2d$export$1f70d263701b1d01.VCParts.forEach((v)=>{
            vc[v] = null;
        });
        return vc;
    }
    detachAbortListeners() {
        if (this.unbind) {
            const { unbind: unbind } = this;
            for(let i = 0; i < unbind.length; i++)unbind[i]();
            this.unbind.length = 0;
        }
    }
    measureStart() {
        this._startMeasureTimestamp = performance.now();
    }
    measureStop() {
        if (this._startMeasureTimestamp === -1) return;
        this.totalTime += performance.now() - this._startMeasureTimestamp;
        this._startMeasureTimestamp = -1;
    }
    constructor(options){
        /* abort logic */ this.abortReason = {
            reason: null,
            info: '',
            timestamp: -1,
            blocking: false
        };
        this.outOfBoundaryInfo = '';
        this.viewport = {
            w: 0,
            h: 0
        };
        /* heatmap */ this.arraySize = 0;
        this.heatmap = void 0;
        this.heatmapNext = void 0;
        this.componentsLog = {};
        this.vcRatios = {};
        this.active = false;
        this.totalTime = 0;
        this.startTime = 0;
        this.observers = void 0;
        this._startMeasureTimestamp = -1;
        this.ssr = {
            reactRendered: -1
        };
        this.devToolsEnabled = void 0;
        this.oldDomUpdatesEnabled = void 0;
        this.unbind = [];
        this.isPostInteraction = void 0;
        this.getAbortReasonInfo = ()=>{
            if (this.abortReason.reason === null) return null;
            const info = this.abortReason.info !== '' ? ` ${this.abortReason.info}` : '';
            return `${this.abortReason.reason}${info}`;
        };
        this.getVCRawData = ()=>{
            this.measureStart();
            if (!this.active) {
                this.measureStop();
                return null;
            }
            this.stop();
            const abortReasonInfo = this.getAbortReasonInfo();
            this.measureStop();
            return {
                abortReasonInfo: abortReasonInfo,
                abortReason: {
                    ...this.abortReason
                },
                heatmap: this.heatmap,
                heatmapNext: this.heatmapNext,
                outOfBoundaryInfo: this.outOfBoundaryInfo,
                totalTime: Math.round(this.totalTime + this.observers.getTotalTime()),
                componentsLog: {
                    ...this.componentsLog
                },
                viewport: {
                    ...this.viewport
                },
                oldDomUpdatesEnabled: this.oldDomUpdatesEnabled,
                devToolsEnabled: this.devToolsEnabled,
                ratios: this.vcRatios
            };
        };
        this.getVCResult = async ({ start: start, stop: stop, tti: tti, prefix: prefix, ssr: ssr, vc: vc, isEventAborted: isEventAborted, experienceKey: experienceKey, interactionId: interactionId, includeSSRRatio: includeSSRRatio })=>{
            const startTime = performance.now();
            // add local measurement
            const fullPrefix = prefix !== undefined && prefix !== '' ? `${prefix}:` : '';
            const rawData = vc !== undefined ? vc : this.getVCRawData();
            if (rawData === null) return {};
            const { abortReason: abortReason, abortReasonInfo: abortReasonInfo, heatmap: heatmap, heatmapNext: heatmapNext, outOfBoundaryInfo: outOfBoundaryInfo, totalTime: totalTime, componentsLog: componentsLog, viewport: viewport, devToolsEnabled: devToolsEnabled, ratios: ratios } = rawData;
            const isTTVCv1Disabled = !(0, $9a2f9fc0af024eb1$export$4babcefc81a3ef0b)('fy25.01', experienceKey);
            if (abortReasonInfo !== null) {
                // exposing data to devtools
                try {
                    if (devToolsEnabled && !this.isPostInteraction) window.__vcNotAvailableReason = abortReasonInfo;
                } catch  {}
                const vcAbortedResultWithRevisions = {
                    [`${fullPrefix}vc:rev`]: [
                        {
                            revision: 'fy25.02',
                            clean: false,
                            'metric:vc90': null,
                            abortReason: abortReason.reason,
                            abortTimestamp: Math.round(abortReason.timestamp)
                        }
                    ]
                };
                if (!isTTVCv1Disabled) vcAbortedResultWithRevisions[`${fullPrefix}vc:rev`].push({
                    revision: 'fy25.01',
                    clean: false,
                    'metric:vc90': null,
                    abortReason: abortReason.reason,
                    abortTimestamp: Math.round(abortReason.timestamp)
                });
                return vcAbortedResultWithRevisions;
            }
            const ttvcV1Result = isTTVCv1Disabled ? {
                VC: {},
                VCBox: {},
                VCEntries: {
                    abs: [],
                    rel: [],
                    speedIndex: -1
                },
                totalPainted: -1
            } : $a9a4078a79494f2d$export$1f70d263701b1d01.calculateVC({
                heatmap: heatmap,
                ssr: ssr,
                componentsLog: {
                    ...componentsLog
                },
                viewport: viewport,
                fixSSRAttribution: includeSSRRatio
            });
            const { VC: VC, VCBox: VCBox, VCEntries: VCEntries, totalPainted: totalPainted } = ttvcV1Result;
            const _componentsLog = {};
            Object.entries(this.componentsLog).forEach(([_timestamp, value])=>{
                const timestamp = Number(_timestamp);
                if (stop > timestamp) _componentsLog[timestamp] = value;
            });
            const vcNext = $a9a4078a79494f2d$export$1f70d263701b1d01.calculateVC({
                heatmap: heatmapNext,
                ssr: ssr,
                componentsLog: _componentsLog,
                viewport: viewport,
                fixSSRAttribution: includeSSRRatio
            });
            const outOfBoundary = outOfBoundaryInfo ? {
                [`${fullPrefix}vc:oob`]: outOfBoundaryInfo
            } : {};
            //const oldDomUpdates = oldDomUpdatesEnabled ? { [`${fullPrefix}vc:old:dom`]: vcNext.VCBox } : {};
            const stopTime = performance.now();
            // exposing data to devtools
            try {
                if (!this.isPostInteraction && devToolsEnabled) {
                    const ttvcV1DevToolInfo = isTTVCv1Disabled ? undefined : {
                        entries: VCEntries.rel,
                        log: componentsLog,
                        metrics: {
                            '75': VC['75'],
                            '80': VC['80'],
                            '85': VC['85'],
                            '90': VC['90'],
                            '95': VC['95'],
                            '98': VC['98'],
                            '99': VC['99'],
                            tti: tti,
                            ttai: stop - start
                        },
                        start: start,
                        stop: stop,
                        heatmap: heatmap,
                        ratios: ratios
                    };
                    const ttvcV2DevToolInfo = {
                        entries: vcNext.VCEntries.rel,
                        log: componentsLog,
                        metrics: {
                            '75': vcNext.VC['75'],
                            '80': vcNext.VC['80'],
                            '85': vcNext.VC['85'],
                            '90': vcNext.VC['90'],
                            '95': vcNext.VC['95'],
                            '98': vcNext.VC['98'],
                            '99': vcNext.VC['99'],
                            tti: tti,
                            ttai: stop - start
                        },
                        start: start,
                        stop: stop,
                        heatmap: heatmapNext,
                        ratios: ratios
                    };
                    if (isTTVCv1Disabled) {
                        window.__vc = ttvcV2DevToolInfo;
                        window.__vcNext = ttvcV2DevToolInfo;
                    } else {
                        window.__vc = ttvcV1DevToolInfo;
                        window.__vcNext = ttvcV2DevToolInfo;
                    }
                    // Emitting a custom event to make it available in the Chrome extension
                    window.dispatchEvent(new CustomEvent('vcReady', {
                        detail: {
                            log: $a9a4078a79494f2d$var$filterComponentsLog(componentsLog),
                            entries: isTTVCv1Disabled ? vcNext.VCEntries.rel : VCEntries.rel
                        }
                    }));
                }
                if (!this.isPostInteraction) {
                    // Only create revision debug details if callbacks exist
                    const shouldCreateDebugDetails = typeof window.__ufo_devtool_onVCRevisionReady__ === 'function' || typeof window.__on_ufo_vc_debug_data_ready === 'function';
                    if (shouldCreateDebugDetails) {
                        const v1RevisionDebugDetails = (0, $64b6f7f3a91eac32$export$72e6dda9d5859230)({
                            revision: 'fy25.01',
                            isClean: !abortReasonInfo,
                            abortReason: abortReason.reason,
                            VCEntries: VCEntries.rel,
                            componentsLog: componentsLog,
                            interactionId: interactionId
                        });
                        const v2RevisionDebugDetails = (0, $64b6f7f3a91eac32$export$72e6dda9d5859230)({
                            revision: 'fy25.02',
                            isClean: !abortReasonInfo,
                            abortReason: abortReason.reason,
                            VCEntries: vcNext.VCEntries.rel,
                            componentsLog: componentsLog,
                            interactionId: interactionId
                        });
                        // Add devtool callback for both v1 and v2
                        if (typeof window.__ufo_devtool_onVCRevisionReady__ === 'function') {
                            // Handle v1 if not disabled
                            if (!isTTVCv1Disabled) window.__ufo_devtool_onVCRevisionReady__?.(v1RevisionDebugDetails);
                            // Handle v2
                            window.__ufo_devtool_onVCRevisionReady__?.(v2RevisionDebugDetails);
                        }
                        if (typeof window.__on_ufo_vc_debug_data_ready === 'function') {
                            if (!isTTVCv1Disabled) window.__on_ufo_vc_debug_data_ready?.(v1RevisionDebugDetails);
                            window.__on_ufo_vc_debug_data_ready?.(v2RevisionDebugDetails);
                        }
                    }
                }
            } catch  {
            /*  do nothing */ }
            const isVCClean = !abortReasonInfo;
            const revisionsData = (0, $a00deaafab0b869b$export$5c86a34c9becd6d0)({
                fullPrefix: fullPrefix,
                interaction: {
                    start: start,
                    end: stop
                },
                isVCClean: isVCClean,
                calculatedVC: {
                    VC: VC,
                    VCBox: VCBox
                },
                calculatedVCNext: {
                    VC: vcNext.VC,
                    VCBox: vcNext.VCBox
                },
                isEventAborted: isEventAborted,
                experienceKey: experienceKey,
                ratios: ratios
            });
            const speedIndex = {
                [`ufo:speedIndex`]: isTTVCv1Disabled ? vcNext.VCEntries.speedIndex : VCEntries.speedIndex,
                [`ufo:next:speedIndex`]: vcNext.VCEntries.speedIndex
            };
            const SSRRatio = $a9a4078a79494f2d$export$1f70d263701b1d01.getSSRRatio(VCEntries.rel, ssr);
            const SSRRatioNext = $a9a4078a79494f2d$export$1f70d263701b1d01.getSSRRatio(vcNext.VCEntries.rel, ssr);
            const SSRRatioPayload = includeSSRRatio ? {
                [`${fullPrefix}vc:ssrRatio`]: isTTVCv1Disabled ? SSRRatioNext : SSRRatio,
                [`${fullPrefix}vc:next:ssrRatio`]: SSRRatioNext
            } : {};
            if (isTTVCv1Disabled) return {
                [`${fullPrefix}vc:size`]: viewport,
                [`${fullPrefix}vc:time`]: Math.round(totalTime + (stopTime - startTime)),
                [`${fullPrefix}vc:ratios`]: ratios,
                ...outOfBoundary,
                [`${fullPrefix}vc:ignored`]: this.getIgnoredElements(componentsLog),
                ...SSRRatioPayload,
                [`${fullPrefix}vc:ssrRatio`]: SSRRatioNext,
                ...revisionsData,
                ...speedIndex
            };
            const isTTVCv3Enabled = (0, $9a2f9fc0af024eb1$export$4babcefc81a3ef0b)('fy25.03', experienceKey);
            return {
                'metrics:vc': VC,
                [`${fullPrefix}vc:state`]: true,
                [`${fullPrefix}vc:clean`]: isVCClean,
                [`${fullPrefix}vc:dom`]: VCBox,
                [`${fullPrefix}vc:updates`]: isTTVCv3Enabled ? undefined : VCEntries.rel.slice(0, 50),
                // max 50
                [`${fullPrefix}vc:size`]: viewport,
                [`${fullPrefix}vc:time`]: Math.round(totalTime + (stopTime - startTime)),
                [`${fullPrefix}vc:total`]: totalPainted,
                [`${fullPrefix}vc:ratios`]: ratios,
                [`${fullPrefix}vc:ssrRatio`]: SSRRatio,
                ...outOfBoundary,
                [`${fullPrefix}vc:next`]: vcNext.VC,
                [`${fullPrefix}vc:next:updates`]: isTTVCv3Enabled ? undefined : vcNext.VCEntries.rel.slice(0, 50),
                // max 50
                [`${fullPrefix}vc:next:dom`]: vcNext.VCBox,
                ...SSRRatioPayload,
                [`${fullPrefix}vc:ignored`]: this.getIgnoredElements(componentsLog),
                ...revisionsData,
                ...speedIndex
            };
        };
        this.handleUpdate = (rawTime, intersectionRect, targetName, element, type, ignoreReason, attributeName, oldValue, newValue)=>{
            if (this.abortReason.reason === null || this.abortReason.blocking === false) {
                const time = Math.round(rawTime - this.startTime);
                const mappedValues = this.mapPixelsToHeatmap(intersectionRect.left, intersectionRect.top, intersectionRect.width, intersectionRect.height);
                this.vcRatios[targetName] = this.getElementRatio(mappedValues);
                if (!ignoreReason) this.applyChangesToHeatMap(mappedValues, time, this.heatmapNext);
                const interaction = (0, $7390d9fffd2908eb$export$2b3954d2e8509985)();
                const isTTVCv1Disabled = !(0, $9a2f9fc0af024eb1$export$4babcefc81a3ef0b)('fy25.01', interaction?.ufoName);
                if (!isTTVCv1Disabled && (!ignoreReason || ignoreReason === 'not-visible') && type !== 'attr') this.applyChangesToHeatMap(mappedValues, time, this.heatmap);
                if (!this.componentsLog[time]) this.componentsLog[time] = [];
                this.componentsLog[time].push({
                    __debug__element: this.devToolsEnabled ? new WeakRef(element) : null,
                    type: type,
                    intersectionRect: intersectionRect,
                    targetName: targetName,
                    ignoreReason: ignoreReason,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                });
            }
        };
        this.mapPixelsToHeatmap = (left, top, width, height)=>{
            const { w: w, h: h } = this.viewport;
            const l = Math.floor(left / w * this.arraySize);
            const t = Math.floor(top / h * this.arraySize);
            const r = Math.ceil((left + width) / w * this.arraySize);
            const b = Math.ceil((top + height) / h * this.arraySize);
            // that info is temporary to get info why it goes over boundary
            if (this.outOfBoundaryInfo === '') {
                let outOfBoundaryInfo = '';
                if (r > this.arraySize) outOfBoundaryInfo += ` r ${r} ! ${left} ${width}`;
                if (b > this.arraySize) outOfBoundaryInfo += ` r ${r} ! ${top} ${height}`;
                this.outOfBoundaryInfo = outOfBoundaryInfo;
            }
            // correct values to min - 0, max - arraySize
            const result = {
                l: Math.max(0, l),
                t: Math.max(0, t),
                r: Math.min(this.arraySize, r),
                b: Math.min(this.arraySize, b)
            };
            return result;
        };
        this.getElementRatio = (mappedValues)=>{
            const { r: r, l: l, b: b, t: t } = mappedValues;
            return (r - l) * (b - t) / (this.arraySize * this.arraySize);
        };
        this.abortReasonCallback = (key, time)=>{
            switch(key){
                case 'wheel':
                    this.setAbortReason($a9a4078a79494f2d$var$abortReason.scroll, time);
                    break;
                case 'keydown':
                    // Don't abort press interactions on keydown events, as keydown is expected
                    // when users press Enter/Space to activate buttons or other interactive elements
                    if ((0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_ufo_keypress_interaction_abort')) {
                        const interaction = (0, $7390d9fffd2908eb$export$2b3954d2e8509985)();
                        if (interaction?.type === 'press') break;
                    }
                    this.setAbortReason($a9a4078a79494f2d$var$abortReason.keypress, time);
                    break;
                case 'resize':
                    this.setAbortReason($a9a4078a79494f2d$var$abortReason.resize, time);
                    break;
            }
        };
        this.attachAbortListeners = ()=>{
            this.detachAbortListeners();
            let unbinds = (0, $51daedf3057f5fce$export$9010aa71841a6887)(window, this.viewport, this.abortReasonCallback);
            if (window?.__SSR_ABORT_LISTENERS__) Object.entries(window.__SSR_ABORT_LISTENERS__.aborts).forEach(([key, time])=>{
                if (time) this.abortReasonCallback(key, time);
            });
            this.unbind = unbinds;
        };
        this.arraySize = options.heatmapSize || 200;
        this.devToolsEnabled = options.devToolsEnabled || false;
        this.oldDomUpdatesEnabled = options.oldDomUpdates || false;
        const { ssrEnablePageLayoutPlaceholder: ssrEnablePageLayoutPlaceholder, ssrPlaceholderHandler: ssrPlaceholderHandler } = options;
        this.observers = new (0, $d3be5e09e146fd6a$export$b65d046240060e78)({
            selectorConfig: options.selectorConfig || {
                id: false,
                testId: false,
                role: false,
                className: true,
                dataVC: true
            },
            SSRConfig: {
                enablePageLayoutPlaceholder: ssrEnablePageLayoutPlaceholder || false
            },
            ssrPlaceholderHandler: ssrPlaceholderHandler
        });
        this.heatmap = !(0, $9a2f9fc0af024eb1$export$4babcefc81a3ef0b)('fy25.01') ? [] : this.getCleanHeatmap();
        this.heatmapNext = this.getCleanHeatmap();
        this.isPostInteraction = options.isPostInteraction || false;
    }
}
/** config * */ $a9a4078a79494f2d$export$1f70d263701b1d01.VCParts = [
    '25',
    '50',
    '75',
    '80',
    '85',
    '90',
    '95',
    '98',
    '99'
];


const $c8b9aea0e525bbc2$var$interactionBuffer = [];
let $c8b9aea0e525bbc2$var$bufferInteractionData = (interactionId, data)=>{
    $c8b9aea0e525bbc2$var$interactionBuffer.push({
        interactionId: interactionId,
        data: data
    });
};
function $c8b9aea0e525bbc2$var$clearInteractionBuffer() {
    $c8b9aea0e525bbc2$var$interactionBuffer.length = 0;
}
function $c8b9aea0e525bbc2$var$appendInteractionData(interactionId, data) {
    $c8b9aea0e525bbc2$var$bufferInteractionData(interactionId, data);
}
function $c8b9aea0e525bbc2$export$c8a9e17ae62a073d(handler) {
    for (const { interactionId: interactionId, data: data } of $c8b9aea0e525bbc2$var$interactionBuffer)handler(interactionId, data);
    $c8b9aea0e525bbc2$var$clearInteractionBuffer();
    $c8b9aea0e525bbc2$var$bufferInteractionData = handler;
}
function $c8b9aea0e525bbc2$export$7aa99c40634ac65f(sinkFn) {
    $c8b9aea0e525bbc2$export$c8a9e17ae62a073d(sinkFn);
}
function $c8b9aea0e525bbc2$export$1aed449484dedf63(interactionId, data, endTime = performance.now()) {
    if (data.ufoName) {
        data.end = endTime;
        $c8b9aea0e525bbc2$var$appendInteractionData(interactionId, data);
        $c8b9aea0e525bbc2$var$clearInteractionBuffer();
    }
}
class $c8b9aea0e525bbc2$export$f9a59f57e0282541 {
    initialize(options) {
        if (this.vcObserver === null) this.vcObserver = new (0, $a9a4078a79494f2d$export$1f70d263701b1d01)({
            ...options,
            isPostInteraction: true
        });
        return this;
    }
    start({ startTime: startTime }) {
        this.vcObserver?.start({
            startTime: startTime
        });
    }
    constructor(){
        this.vcObserver = null;
    }
}
const $c8b9aea0e525bbc2$export$81b28dca2587ec47 = new $c8b9aea0e525bbc2$export$f9a59f57e0282541();
async function $c8b9aea0e525bbc2$export$d17d2b5c5e8d732e(interaction) {
    // Use per-interaction VC observer if available, otherwise fall back to global experimentalVC
    const vcObserver = interaction.experimentalVCObserver || $c8b9aea0e525bbc2$export$81b28dca2587ec47.vcObserver;
    const pageVisibilityUpToTTAI = (0, $609a77f2077f290f$export$768b2008623433e1)(interaction.start, interaction.end);
    if (vcObserver) {
        const prefix = 'ufo-experimental';
        const result = await vcObserver.getVCResult({
            start: interaction.start,
            stop: interaction.end,
            tti: interaction.apdex?.[0]?.stopTime,
            isEventAborted: !!interaction.abortReason,
            prefix: prefix,
            vc: interaction.vc,
            experienceKey: interaction.ufoName,
            interactionId: interaction.id,
            interactionType: interaction.type,
            isPageVisible: pageVisibilityUpToTTAI === 'visible',
            interactionAbortReason: interaction.abortReason
        });
        const VC = result?.['metrics:vc'];
        if (!VC || !result?.[`${prefix}:vc:clean`]) return result;
        if (interaction.abortReason || pageVisibilityUpToTTAI !== 'visible') return result;
        return {
            ...result,
            'metric:experimental:vc90': VC['90']
        };
    }
    return null;
}


const $54b22d01bb2a4309$var$interactionBuffer = [];
let $54b22d01bb2a4309$var$bufferInteractionData = (interactionId, data)=>{
    $54b22d01bb2a4309$var$interactionBuffer.push({
        interactionId: interactionId,
        data: data
    });
};
function $54b22d01bb2a4309$var$clearInteractionBuffer() {
    $54b22d01bb2a4309$var$interactionBuffer.length = 0;
}
function $54b22d01bb2a4309$var$appendInteractionData(interactionId, data) {
    $54b22d01bb2a4309$var$bufferInteractionData(interactionId, data);
}
function $54b22d01bb2a4309$var$installInteractionSink(handler) {
    for (const { interactionId: interactionId, data: data } of $54b22d01bb2a4309$var$interactionBuffer)handler(interactionId, data);
    $54b22d01bb2a4309$var$clearInteractionBuffer();
    $54b22d01bb2a4309$var$bufferInteractionData = handler;
}
function $54b22d01bb2a4309$export$e6a07a94f3e112d4(sinkFn) {
    $54b22d01bb2a4309$var$installInteractionSink(sinkFn);
}
function $54b22d01bb2a4309$export$74b9ce7e9d206a8(interactionId, data) {
    if (data.ufoName) {
        $54b22d01bb2a4309$var$appendInteractionData(interactionId, data);
        $54b22d01bb2a4309$var$clearInteractionBuffer();
    }
}




const $c99bbbdd35b50dc0$export$e919e900fc2d7fe8 = '2.0.0';
function $c99bbbdd35b50dc0$export$159168550e7449b8(interactionType, isPostInteractionLog) {
    if (isPostInteractionLog) return '1.0.1';
    if (interactionType !== 'page_load' && interactionType !== 'transition') return '1.0.1';
    return $c99bbbdd35b50dc0$export$e919e900fc2d7fe8;
}


function $88d1559fd568da3e$export$e08487ea3ae92adb(name) {
    return name.replace(/_/g, '-');
}
function $88d1559fd568da3e$export$1adbaf5c2363e4ae(obj) {
    return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
}
function $88d1559fd568da3e$export$1569bc0edeecbcd8(labelStacks) {
    const r = {
        n: 'segment-tree-root',
        c: {}
    };
    const config = (0, $9a2f9fc0af024eb1$export$44487a86467333c3)();
    const segmentThreshold = config?.segmentsThreshold;
    const addSegmentsMap = new Map();
    if ((0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_ufo_add_segments_count_threshold')) labelStacks.forEach((labelStack)=>{
        const stringifiedLabelStack = $88d1559fd568da3e$export$88f21baa687271f4(labelStack);
        let currentNode = r;
        for (const label of labelStack){
            const isSegment = $88d1559fd568da3e$export$1adbaf5c2363e4ae(label);
            const name = label.name;
            if (isSegment && segmentThreshold && segmentThreshold[name]) {
                const threshold = segmentThreshold[name];
                const count = addSegmentsMap.get(stringifiedLabelStack) || 0;
                if (count < threshold) addSegmentsMap.set(stringifiedLabelStack, count + 1);
                else break;
            }
            const id = isSegment ? label.segmentId : undefined;
            const key = id !== undefined ? id : name;
            const type = isSegment ? label.type : undefined;
            if (!currentNode.c) currentNode.c = {};
            if (!currentNode.c[key]) currentNode.c[key] = {
                n: name,
                ...type ? {
                    t: type
                } : {}
            };
            currentNode = currentNode.c[key];
        }
    });
    else labelStacks.forEach((labelStack)=>{
        let currentNode = r;
        labelStack.forEach((label)=>{
            const name = label.name;
            const id = $88d1559fd568da3e$export$1adbaf5c2363e4ae(label) ? label.segmentId : undefined;
            const key = id !== undefined ? id : name;
            const type = $88d1559fd568da3e$export$1adbaf5c2363e4ae(label) ? label.type : undefined;
            if (!currentNode.c) currentNode.c = {};
            if (!currentNode.c[key]) currentNode.c[key] = {
                n: name,
                ...type ? {
                    t: type
                } : {}
            };
            currentNode = currentNode.c[key];
        });
    });
    return {
        r: r
    };
}
function $88d1559fd568da3e$export$caeee352b541de1f(labelStack) {
    return labelStack.map((l)=>{
        if ($88d1559fd568da3e$export$1adbaf5c2363e4ae(l)) return `${l.name}:${l.segmentId}`;
        return l.name;
    }).join('/');
}
function $88d1559fd568da3e$export$88f21baa687271f4(labelStack) {
    return labelStack.map((l)=>{
        if ($88d1559fd568da3e$export$1adbaf5c2363e4ae(l)) return `${l.name}:segment`;
        return l.name;
    }).join('/');
}
function $88d1559fd568da3e$var$getLabelStackReference(labelStack) {
    return labelStack.map((l)=>$88d1559fd568da3e$export$1adbaf5c2363e4ae(l) ? l.segmentId : l.name).join('/');
}
function $88d1559fd568da3e$export$1787b1cd413c7e2(labelStack, startWith) {
    return $88d1559fd568da3e$export$caeee352b541de1f(labelStack).startsWith($88d1559fd568da3e$export$caeee352b541de1f(startWith));
}
function $88d1559fd568da3e$export$a0cd72da07c76b4c(labelStack, reactUFOVersion) {
    return reactUFOVersion === '2.0.0' ? $88d1559fd568da3e$var$getLabelStackReference(labelStack) : labelStack.map((ls)=>({
            n: ls.name,
            ...ls.segmentId ? {
                s: ls.segmentId
            } : {},
            ...ls.type ? {
                t: ls.type
            } : {}
        }));
}
function $88d1559fd568da3e$export$b70bcfd92c93435e(segments, interactionType) {
    if ((0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_ufo_add_segments_count_threshold')) {
        const config = (0, $9a2f9fc0af024eb1$export$44487a86467333c3)();
        const addSegmentsMap = new Map();
        const segmentThreshold = config?.segmentsThreshold;
        return segments.map(({ labelStack: labelStack, ...others })=>{
            const stringifiedLabelStack = $88d1559fd568da3e$export$88f21baa687271f4(labelStack);
            const segmentsInfo = [];
            for (const ls of labelStack){
                const isSegment = $88d1559fd568da3e$export$1adbaf5c2363e4ae(ls);
                if (isSegment && segmentThreshold && segmentThreshold[ls.name]) {
                    const threshold = segmentThreshold[ls.name];
                    const count = addSegmentsMap.get(stringifiedLabelStack) || 0;
                    if (count < threshold) addSegmentsMap.set(stringifiedLabelStack, count + 1);
                    else break;
                }
                segmentsInfo.push({
                    n: ls.name,
                    ...ls.segmentId ? {
                        s: ls.segmentId
                    } : {},
                    ...ls.type ? {
                        t: ls.type
                    } : {}
                });
            }
            return {
                ...others,
                labelStack: segmentsInfo
            };
        });
    }
    return segments.map(({ labelStack: labelStack, ...others })=>({
            ...others,
            labelStack: $88d1559fd568da3e$export$a0cd72da07c76b4c(labelStack, (0, $c99bbbdd35b50dc0$export$159168550e7449b8)(interactionType))
        }));
}





var $dQwsT = parcelRequire("dQwsT");
const $cb7ea7f0a3e09fe0$var$listeners = new Set();
// Observable interaction ID implementation
class $cb7ea7f0a3e09fe0$var$ObservableInteractionID {
    get current() {
        return this._current;
    }
    set current(newId) {
        const oldId = this._current;
        this._current = newId;
        // Notify all listeners if the ID actually changed
        if (oldId !== newId) $cb7ea7f0a3e09fe0$var$listeners.forEach((listener)=>listener(newId));
    }
    constructor(){
        this._current = null;
    }
}
// Ensures a single DefaultInteractionID instance exists across the entire application,
// even when the module is loaded multiple times in different contexts
const $cb7ea7f0a3e09fe0$var$initializeGlobalDefaultInteractionID = ()=>{
    // Return existing instance if already initialized
    if (globalThis.__UFO_DEFAULT_INTERACTION_ID__) return globalThis.__UFO_DEFAULT_INTERACTION_ID__;
    // Create and store new instance globally
    const instance = new $cb7ea7f0a3e09fe0$var$ObservableInteractionID();
    globalThis.__UFO_DEFAULT_INTERACTION_ID__ = instance;
    return instance;
};
const $cb7ea7f0a3e09fe0$export$3109542b68df9ba1 = $cb7ea7f0a3e09fe0$var$initializeGlobalDefaultInteractionID();
const $cb7ea7f0a3e09fe0$export$3e0c3023952f6774 = (listener)=>{
    $cb7ea7f0a3e09fe0$var$listeners.add(listener);
    return ()=>{
        $cb7ea7f0a3e09fe0$var$listeners.delete(listener);
    };
};
// We use a context to allow modals to have their own lifecycle
const $cb7ea7f0a3e09fe0$var$_default_1 = (0, $dQwsT.createContext)($cb7ea7f0a3e09fe0$export$3109542b68df9ba1);
var $cb7ea7f0a3e09fe0$export$2e2bcd8739ae039 = $cb7ea7f0a3e09fe0$var$_default_1;
const $cb7ea7f0a3e09fe0$export$37bca3107733ac1e = ()=>$cb7ea7f0a3e09fe0$export$3109542b68df9ba1;
const $cb7ea7f0a3e09fe0$export$9f6000531b78127e = ()=>$cb7ea7f0a3e09fe0$export$3109542b68df9ba1;




class $0be71a22067e9dfe$export$24d07287b49da906 {
    start(_) {}
    stop() {}
    getVCRawData() {
        return null;
    }
    getVCResult(_) {
        return Promise.resolve({
            'ufo:vc:noop': true
        });
    }
    setSSRElement(_) {}
    setReactRootRenderStart(_) {}
    setReactRootRenderStop(_) {}
}







class $ced6f056132d1975$export$2e2bcd8739ae039 {
    push(entry) {
        this.unorderedEntries.push(entry);
        this.sortedEntriesCache.clear();
    }
    getCacheKey(start, stop) {
        return `${start ?? 'null'}_${stop ?? 'null'}`;
    }
    getOrderedEntries({ start: start, stop: stop }) {
        const cacheKey = this.getCacheKey(start, stop);
        const cachedSortedEntries = this.sortedEntriesCache.get(cacheKey)?.deref();
        if (cachedSortedEntries) return cachedSortedEntries;
        const filteredEntries = this.unorderedEntries.filter((e)=>e.time >= (start ?? 0) && e.time <= (stop ?? performance.now()));
        const sortedEntries = filteredEntries.sort((a, b)=>a.time - b.time);
        this.sortedEntriesCache.set(cacheKey, new WeakRef(sortedEntries));
        return sortedEntries;
    }
    clear() {
        this.unorderedEntries = [];
        this.sortedEntriesCache.clear();
    }
    constructor(){
        this.unorderedEntries = void 0;
        this.sortedEntriesCache = void 0;
        this.unorderedEntries = [];
        this.sortedEntriesCache = new Map();
    }
}


const $702a42bc3154ff26$var$nameCache = new WeakMap();
function $702a42bc3154ff26$var$getElementName(selectorConfig, element) {
    if (!(element instanceof HTMLElement)) {
        let elementInstance = 'Unknown';
        // Types of elements according to LLM
        if (element instanceof Text) elementInstance = 'Text';
        else if (element instanceof DocumentFragment) elementInstance = 'DocumentFragment';
        else if (element instanceof Document) elementInstance = 'Document';
        else if (element instanceof Comment) elementInstance = 'Comment';
        else if (element instanceof ProcessingInstruction) elementInstance = 'ProcessingInstruction';
        else if (element instanceof Attr) elementInstance = 'Attr';
        else if (element instanceof CDATASection) elementInstance = 'CDATASection';
        if (element.parentElement && element.parentElement instanceof HTMLElement) {
            const parentElementSelector = $702a42bc3154ff26$var$getElementName(selectorConfig, element.parentElement);
            return `${parentElementSelector} > ${elementInstance}`;
        } else return elementInstance;
    }
    const cachedName = $702a42bc3154ff26$var$nameCache.get(element);
    if (cachedName) return cachedName;
    // Get the tag name of the element.
    const tagName = element.localName;
    const encodeValue = (s)=>{
        if (typeof encodeURIComponent !== 'function') return '';
        try {
            return encodeURIComponent(s);
        } catch  {
            return 'malformed_value';
        }
    };
    // Helper function to construct attribute selectors.
    const getAttributeSelector = (attributeName, prefix = '')=>{
        if (element && typeof element.getAttribute !== 'function') return '';
        const attrValue = element.getAttribute(attributeName);
        if (!attrValue) return '';
        const encondedAttrValue = encodeValue(attrValue);
        return `${prefix}[${attributeName}="${encondedAttrValue}"]`;
    };
    // Construct the data-vc attribute selector if specified in the config.
    const dataVC = selectorConfig.dataVC !== false ? getAttributeSelector('data-vc') : '';
    // Construct the ID selector if specified in the config and the element has an ID.
    const id = selectorConfig.id && element.id ? `#${encodeValue(element.id)}` : '';
    // Construct the test ID selector if specified in the config.
    const testId = selectorConfig.testId ? getAttributeSelector('data-testid') || getAttributeSelector('data-test-id') : '';
    // Construct the role selector if specified in the config.
    const role = selectorConfig.role ? getAttributeSelector('role') : '';
    const classNames = Array.from(element.classList).map(encodeValue).join('.');
    // Construct the class list selector if specified in the config.
    const classList = selectorConfig.className && classNames ? `.${classNames}` : '';
    // Combine primary attribute selectors (id, testId, role) into a single string.
    const primaryAttributes = [
        id,
        testId,
        role
    ].filter(Boolean).join('');
    // Use dataVC if available, otherwise use the primary attributes.
    const attributes = dataVC || primaryAttributes;
    // If no attributes or class list, recursively get the parent's name.
    if (!attributes && !classList) {
        const parentName = element.parentElement ? $702a42bc3154ff26$var$getElementName(selectorConfig, element.parentElement) : 'unknown';
        return `${parentName} > ${tagName}`;
    }
    // Return the final constructed name: tagName + attributes or classList.
    const name = `${tagName}${attributes || classList}`;
    $702a42bc3154ff26$var$nameCache.set(element, name);
    return name;
}
var $702a42bc3154ff26$export$2e2bcd8739ae039 = $702a42bc3154ff26$var$getElementName;





const $4ed8404376c54253$export$9db1624a8af791a4 = (experimentName, experimentParam, defaultValue)=>{
    // If client is not initialized, we return the default value
    if (!(0, $92d8da4ee454ac11$export$2e2bcd8739ae039).initializeCompleted()) return defaultValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $92d8da4ee454ac11$export$2e2bcd8739ae039).getExperimentValue(experimentName, experimentParam, defaultValue);
    (0, $f721e733a5f9f3b0$export$47fade9662f71000)(`${experimentName}:${experimentParam}`, experimentValue);
    return experimentValue;
};



const $22a20165129d2aad$var$isDnDStyleChange = (style)=>{
    return style.startsWith('anchor-name: --node-anchor');
};
const $22a20165129d2aad$var$parseStyleSet = (style)=>{
    if (!style) return null;
    const set = new Set();
    for (const part of style.split(';')){
        const t = part.trim();
        if (t) set.add(t);
    }
    return set;
};
/**
 * Checks if a mutation record represents a style change from Editor's
 * drag and drop feature, which don't cause visual shifts.
 * This should be removed once DnD has been fixed.
 * @param mutation - The mutation record to check
 * @returns boolean indicating if this is a DnD style mutation
 */ function $22a20165129d2aad$export$e20e7bf2c822f3df({ target: target, attributeName: attributeName, oldValue: oldValue, newValue: newValue }) {
    if (!(0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_editor_exclude_dnd_anchor_name_from_ttvc')) return false;
    if (!(target instanceof Element)) return false;
    return $22a20165129d2aad$export$7867ddcf372cd2bf({
        attributeName: attributeName,
        oldValue: oldValue,
        newValue: newValue
    });
}
function $22a20165129d2aad$export$7867ddcf372cd2bf({ attributeName: attributeName, oldValue: oldValue, newValue: newValue }) {
    if (attributeName !== 'style') return false;
    const oldStyles = $22a20165129d2aad$var$parseStyleSet(oldValue);
    const newStyles = $22a20165129d2aad$var$parseStyleSet(newValue);
    let isDnDMutation = false;
    for (const s of oldStyles ?? [])if (!newStyles?.has(s)) {
        if (!$22a20165129d2aad$var$isDnDStyleChange(s)) return false;
        isDnDMutation = true;
    }
    for (const s of newStyles ?? [])if (!oldStyles?.has(s)) {
        if (!$22a20165129d2aad$var$isDnDStyleChange(s)) return false;
        isDnDMutation = true;
    }
    return isDnDMutation;
}
var $22a20165129d2aad$export$2e2bcd8739ae039 = $22a20165129d2aad$export$e20e7bf2c822f3df;




// See https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API
async function $e72694075287d8b5$var$taskYield() {
    // This is using globalThis to allow the yield task to be used outside of a browser env
    if ('scheduler' in globalThis && // @ts-ignore
    'yield' in globalThis.scheduler) {
        // @ts-ignore
        await scheduler.yield();
        return;
    }
    let resolve = ()=>{};
    const p = new Promise((a)=>{
        resolve = a;
    });
    setTimeout(resolve, 0);
    await p;
}
var $e72694075287d8b5$export$2e2bcd8739ae039 = $e72694075287d8b5$var$taskYield;


class $e154f3d8d6f1fe64$export$3e59ac9de7402fb1 {
    /**
   * Creates a canvas instance, falling back to HTMLCanvasElement if OffscreenCanvas is not available
   */ createCanvas(width, height) {
        if (typeof OffscreenCanvas !== 'undefined') return new OffscreenCanvas(width, height);
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        return canvas;
    }
    getScaledDimensions() {
        return {
            width: this.scaledWidth,
            height: this.scaledHeight
        };
    }
    /**
   * Clears the entire canvas by removing all drawn content.
   * @private
   */ clear() {
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    }
    /**
   * Generates a unique RGB color from an incrementing counter.
   * Uses a 24-bit color space (16,777,216 possible colors).
   *
   * @private
   * @returns A unique RGB color string
   *
   * @example
   * // Example bit operations for color 0x00FF8040:
   * // Red:   (0x00FF8040 >> 16) & 0xFF = 0xFF = 255
   * // Green: (0x00FF8040 >> 8) & 0xFF  = 0x80 = 128
   * // Blue:   0x00FF8040 & 0xFF        = 0x40 = 64
   */ generateColor() {
        // Wrap around at 16,777,215 (0x00FFFFFF) to stay within 24-bit color space
        const rgbColor = this.colorCounter++ % 0x00ffffff;
        return $e154f3d8d6f1fe64$export$54591583ed0b20ce(rgbColor);
    }
    /**
   * Draws a rectangle on the canvas with a unique color and associates it with a timestamp.
   * Each drawn rectangle gets a unique color which is mapped to the provided timestamp.
   *
   * @param rect - The rectangle dimensions to draw
   * @param timestamp - The timestamp to associate with this drawing operation
   */ drawRect(rect, timestamp) {
        const color = this.generateColor();
        this.colorTimeMap.set(color, timestamp);
        this.ctx.fillStyle = color;
        if (this.scaleFactor === 1) return this.ctx.fillRect(rect.x, rect.y, rect.width, rect.height);
        const scaledX = rect.x * this.scaleX;
        const scaledY = rect.y * this.scaleY;
        const scaledWidth = rect.width * this.scaleX;
        const scaledHeight = rect.height * this.scaleY;
        this.ctx.fillRect(Math.floor(scaledX), Math.ceil(scaledY), Math.max(scaledWidth, 1), Math.max(scaledHeight, 1));
    }
    /**
   * Calculates the number of pixels drawn for each timestamp.
   * This method:
   * 1. Reads the pixel data from the canvas
   * 2. Counts pixels of each unique color
   * 3. Maps colors back to their timestamps
   * 4. Adjusts counts based on the scale factor
   *
   * @returns A Map containing timestamp to pixel count mappings
   */ async getPixelCounts() {
        const imageData = this.ctx.getImageData(0, 0, this.canvas.width, this.canvas.height);
        const timestampsAmount = this.colorTimeMap.size;
        const pixelCounts = await $e154f3d8d6f1fe64$export$fafc9be44839f9c8(imageData, this.scaleFactor, timestampsAmount);
        // Convert color counts to timestamp counts
        const timePixelCounts = new Map();
        for(let i = 0; i < pixelCounts.length; i++){
            const count = pixelCounts[i];
            if (typeof count !== 'number') continue;
            const color = i + 1;
            const rgbColor = $e154f3d8d6f1fe64$export$54591583ed0b20ce(color);
            const timestamp = this.colorTimeMap.get(rgbColor);
            if (timestamp !== undefined) timePixelCounts.set(timestamp, (timePixelCounts.get(timestamp) || 0) + count);
        }
        return timePixelCounts;
    }
    /**
   * Creates a new ViewportCanvas instance.
   * @param viewport - The dimensions of the viewport
   * @param scaleFactor - Scale factor to apply to the canvas (default: 0.5)
   * @throws {Error} If canvas context cannot be obtained
   */ constructor(viewport, scaleFactor = 1){
        /** The underlying Canvas instance (either OffscreenCanvas or HTMLCanvasElement) */ this.canvas = void 0;
        /** The 2D rendering context of the canvas */ this.ctx = void 0;
        /** Scale factor applied to the canvas (affects final pixel counts) */ this.scaleFactor = void 0;
        /** Maps unique colors to their corresponding timestamps */ this.colorTimeMap = void 0;
        /** Counter used to generate unique colors */ this.colorCounter = void 0;
        this.scaledWidth = void 0;
        this.scaledHeight = void 0;
        this.scaleX = void 0;
        this.scaleY = void 0;
        this.scaleFactor = scaleFactor;
        this.colorCounter = 1;
        this.colorTimeMap = new Map();
        const safeViewportWidth = Math.max(viewport.width, 1);
        const safeViewportHeight = Math.max(viewport.height, 1);
        // Calculate scaled dimensions
        this.scaledWidth = Math.max(Math.ceil(safeViewportWidth * scaleFactor), 1);
        this.scaledHeight = Math.max(Math.ceil(safeViewportHeight * scaleFactor), 1);
        this.scaleX = this.scaledWidth / safeViewportWidth;
        this.scaleY = this.scaledHeight / safeViewportHeight;
        // Initialize canvas with scaled dimensions
        this.canvas = this.createCanvas(this.scaledWidth, this.scaledHeight);
        const ctx = this.canvas.getContext('2d', {
            alpha: false,
            // Disable alpha channel for better performance
            willReadFrequently: true,
            // Optimize for frequent pixel reading
            colorSpace: 'srgb' // Use standard RGB color space
        });
        if (!ctx) throw new Error('Could not get canvas context');
        this.ctx = ctx;
        this.ctx.globalCompositeOperation = 'source-over';
        this.ctx.imageSmoothingEnabled = false; // Disable image smoothing for better performance
        this.clear();
    }
}
function $e154f3d8d6f1fe64$export$54591583ed0b20ce(n) {
    // Ensure the input is within the valid range for a 24-bit color
    if (n < 0 || n > 0xffffff) throw new Error('Input number must be between 0 and 16777215 (inclusive).');
    // Extract blue component (bits 0-7)
    const blue = n & 0xff;
    // Extract green component (bits 8-15)
    const green = n >> 8 & 0xff;
    // Extract red component (bits 16-23)
    const red = n >> 16 & 0xff;
    return `rgb(${red}, ${green}, ${blue})`;
}
async function $e154f3d8d6f1fe64$export$fafc9be44839f9c8(imageData, _, arraySize) {
    const data = imageData.data;
    const arr = new Uint32Array(arraySize);
    for(let i = 0; i < data.length; i += 4){
        // Check alpha
        if (data[i + 3] !== 0) {
            // Combine RGB components into a single 24-bit color value:
            // (data[i] << 16)   - Shift red component left 16 bits   (bits 16-23)
            // (data[i + 1] << 8) - Shift green component left 8 bits (bits 8-15)
            // data[i + 2]       - Blue component stays as is         (bits 0-7)
            // The | operator combines all bits together
            const color = data[i] << 16 | data[i + 1] << 8 | data[i + 2];
            const colorIndex = color - 1;
            arr[colorIndex] = (arr[colorIndex] || 0) + 1;
        }
        if (i % 10000 === 0) await (0, $e72694075287d8b5$export$2e2bcd8739ae039)();
    }
    return arr;
}


async function $f249eeefd0729305$var$calculateTTVCPercentiles({ viewport: viewport, orderedEntries: orderedEntries, percentiles: percentiles, startTime: startTime }) {
    const canvas = new (0, $e154f3d8d6f1fe64$export$3e59ac9de7402fb1)(viewport, (0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_ufo_canvas_heatmap_full_precision') ? 1 : 0.25);
    const elementMap = new Map();
    for (const entry of orderedEntries){
        if (!('rect' in entry.data)) continue;
        const rect = entry.data.rect;
        const elementName = entry.data.elementName;
        canvas.drawRect(rect, entry.time);
        if (!elementMap.has(entry.time)) elementMap.set(entry.time, new Set());
        elementMap.get(entry.time).add(elementName);
    }
    // Get pixel counts
    const timePixelCounts = await canvas.getPixelCounts();
    const canvasDimenstions = canvas.getScaledDimensions();
    const totalPixels = canvasDimenstions.width * canvasDimenstions.height;
    return $f249eeefd0729305$export$89c8da9b65eff678(timePixelCounts, elementMap, percentiles, totalPixels, startTime);
}
async function $f249eeefd0729305$export$96ea73435089b05a({ viewport: viewport, orderedEntries: orderedEntries, startTime: startTime }) {
    const canvas = new (0, $e154f3d8d6f1fe64$export$3e59ac9de7402fb1)(viewport, (0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_ufo_canvas_heatmap_full_precision') ? 1 : 0.25);
    const elementMap = new Map();
    for (const entry of orderedEntries){
        if (!('rect' in entry.data)) continue;
        const rect = entry.data.rect;
        canvas.drawRect(rect, entry.time);
        if (!elementMap.has(entry.time)) elementMap.set(entry.time, []);
        elementMap.get(entry.time).push(entry.data);
    }
    // Get pixel counts
    const timePixelCounts = await canvas.getPixelCounts();
    const canvasDimensions = canvas.getScaledDimensions();
    const totalPixels = canvasDimensions.width * canvasDimensions.height;
    return $f249eeefd0729305$export$a532ce01ea38d882(timePixelCounts, elementMap, totalPixels, startTime);
}
var $f249eeefd0729305$export$2e2bcd8739ae039 = $f249eeefd0729305$var$calculateTTVCPercentiles;
function $f249eeefd0729305$export$89c8da9b65eff678(timePixelCounts, elementMap, unorderedPercentiles, totalPixels, startTime) {
    const results = {};
    let cumulativePixels = 0;
    const percentiles = unorderedPercentiles.sort((a, b)=>a - b);
    // Sort entries by timestamp for consistent processing
    const sortedEntries = Array.from(timePixelCounts.entries()).sort(([timeA], [timeB])=>Number(timeA) - Number(timeB));
    let percentileIndex = 0;
    let domElementsBuffer = new Set();
    for (const [time, pixelCount] of sortedEntries){
        cumulativePixels += pixelCount;
        const percentCovered = cumulativePixels / totalPixels * 100;
        const elementNames = elementMap.get(time) || new Set();
        elementNames.forEach((elName)=>domElementsBuffer.add(elName));
        let matchesAnyCheckpoints = false;
        while(percentileIndex < percentiles.length && percentCovered >= percentiles[percentileIndex]){
            results[`${percentiles[percentileIndex]}`] = {
                t: Math.round(Number(time - startTime)),
                e: Array.from(domElementsBuffer)
            };
            percentileIndex++;
            matchesAnyCheckpoints = true;
        }
        if (matchesAnyCheckpoints) domElementsBuffer.clear();
        if (percentileIndex >= percentiles.length) break;
    }
    let previousResult = {
        t: 0,
        e: []
    };
    for(let i = 0; i < percentiles.length; i++){
        const percentile = percentiles[i];
        if (!(percentile in results)) results[`${percentile}`] = previousResult;
        previousResult = results[`${percentile}`];
    }
    return results;
}
function $f249eeefd0729305$export$a532ce01ea38d882(timePixelCounts, elementMap, totalPixels, startTime) {
    const results = new Array(elementMap.size);
    let cumulativePixels = 0;
    const sortedEntries = Array.from(timePixelCounts.entries()).sort(([timeA], [timeB])=>Number(timeA) - Number(timeB));
    for(let i = 0; i < sortedEntries.length; i++){
        const [time, pixelCount] = sortedEntries[i];
        cumulativePixels += pixelCount;
        const percentCovered = cumulativePixels / totalPixels * 100;
        const entryDatas = elementMap.get(time) || [];
        results[i] = {
            time: Math.round(Number(time - startTime)),
            viewportPercentage: percentCovered,
            entries: Array.from(entryDatas)
        };
    }
    return results;
}


function $127b715c30acb690$var$getViewportHeight(document = window.document) {
    let documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch  {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}
var $127b715c30acb690$export$2e2bcd8739ae039 = $127b715c30acb690$var$getViewportHeight;


function $3ff4407421d27a1c$var$getViewportWidth(document = window.document) {
    let documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch  {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}
var $3ff4407421d27a1c$export$2e2bcd8739ae039 = $3ff4407421d27a1c$var$getViewportWidth;


class $febdd312e397b58b$export$2e2bcd8739ae039 {
    filterViewportEntries(entries) {
        return entries.filter((entry)=>{
            return 'rect' in entry.data;
        });
    }
    /**
   * Calculate ratios for each element based on their viewport coverage.
   */ calculateRatios(filteredEntries) {
        const ratios = {};
        const viewportWidth = (0, $3ff4407421d27a1c$export$2e2bcd8739ae039)();
        const viewportHeight = (0, $127b715c30acb690$export$2e2bcd8739ae039)();
        const totalViewportArea = viewportWidth * viewportHeight;
        if (totalViewportArea === 0) return ratios;
        const elementRects = new Map();
        for (const entry of filteredEntries)if ('rect' in entry.data) {
            const viewportEntry = entry.data;
            elementRects.set(viewportEntry.elementName, viewportEntry.rect);
        }
        for (const [elementName, rect] of elementRects){
            const elementArea = rect.width * rect.height;
            ratios[elementName] = elementArea / totalViewportArea;
        }
        return ratios;
    }
    getLabelStacks(filteredEntries, isPostInteraction) {
        const labelStacks = {};
        for (const entry of filteredEntries)if ('elementName' in entry.data && entry.data.labelStacks) {
            if (isPostInteraction) labelStacks[entry.data.elementName] = {
                segment: entry.data.labelStacks.segment,
                labelStack: entry.data.labelStacks.labelStack
            };
            else if ((0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_ufo_add_segment_names_to_dom_offenders')) labelStacks[entry.data.elementName] = entry.data.labelStacks.labelStack;
        }
        return labelStacks;
    }
    async calculateWithDebugInfo(filteredEntries, startTime, stopTime, isPostInteraction, isVCClean, interactionType, isPageVisible, interactionId, dirtyReason, allEntries, include3p, excludeSmartAnswersInSearch, interactionAbortReason, includeSSRRatio) {
        const percentiles = [
            25,
            50,
            75,
            80,
            85,
            90,
            95,
            98,
            99,
            100
        ];
        const viewportEntries = this.filterViewportEntries(filteredEntries);
        const vcLogs = await (0, $f249eeefd0729305$export$96ea73435089b05a)({
            viewport: {
                width: (0, $3ff4407421d27a1c$export$2e2bcd8739ae039)(),
                height: (0, $127b715c30acb690$export$2e2bcd8739ae039)()
            },
            startTime: startTime,
            stopTime: stopTime,
            orderedEntries: viewportEntries
        });
        const vcDetails = {};
        let percentileIndex = 0;
        const entryDataBuffer = new Set();
        let ssrRatio = -1;
        if (vcLogs) for (const entry of vcLogs){
            const { time: time, viewportPercentage: viewportPercentage, entries: entries } = entry;
            if (includeSSRRatio && ssrRatio === -1 && entries.some((e)=>e.elementName === 'SSR')) ssrRatio = viewportPercentage;
            // Only process entries if we haven't reached all percentiles
            if (percentileIndex >= percentiles.length) break;
            // Check if this entry matches any checkpoint percentiles
            if (viewportPercentage >= percentiles[percentileIndex]) {
                const elementNames = entries.map((e)=>e.elementName);
                // Process all matching percentiles in one go
                while(percentileIndex < percentiles.length && viewportPercentage >= percentiles[percentileIndex]){
                    vcDetails[`${percentiles[percentileIndex]}`] = {
                        t: Math.round(time),
                        e: elementNames
                    };
                    percentileIndex++;
                }
                // Clear buffer after processing all matching percentiles
                entryDataBuffer.clear();
            } else // Only add to buffer if we haven't reached all percentiles
            entries.forEach((e)=>entryDataBuffer.add(e));
        }
        // Fill in any missing percentiles with the last known values
        let previousResult = {
            t: 0,
            e: []
        };
        for(let i = 0; i < percentiles.length; i++){
            const percentile = percentiles[i];
            if (!(percentile in vcDetails)) vcDetails[`${percentile}`] = previousResult;
            else previousResult = vcDetails[`${percentile}`];
        }
        let enhancedVcLogs = vcLogs ? vcLogs.map((log)=>({
                ...log,
                entries: log.entries.map((entry)=>({
                        ...entry,
                        rect: entry.rect?.toJSON(),
                        previousRect: entry.previousRect?.toJSON()
                    })),
                viewportPercentage: log.viewportPercentage
            })) : [];
        // If 3p metric enabled - calculate the debug details
        const shouldCalculate3p = include3p && (0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_ufo_enable_ttai_with_3p');
        // Only calculate enhanced debug details if devtool callbacks exist
        let shouldCalculateDebugDetails = (!isPostInteraction || shouldCalculate3p) && (typeof window?.__ufo_devtool_onVCRevisionReady__ === 'function' || typeof window?.__on_ufo_vc_debug_data_ready === 'function');
        if ((0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_ufo_fix_post_interaction_check_vc_debug')) shouldCalculateDebugDetails = !isPostInteraction && (typeof window?.__ufo_devtool_onVCRevisionReady__ === 'function' || typeof window?.__on_ufo_vc_debug_data_ready === 'function' || typeof window?.__ufo_devtool_vc_3p_debug_data === 'function');
        if (shouldCalculateDebugDetails && allEntries && vcLogs) {
            // Pre-sort vcLogs by time for efficient lookups
            const sortedVcLogs = [
                ...vcLogs
            ].sort((a, b)=>a.time - b.time);
            // Pre-calculate max viewport percentage up to each time for efficient lookups
            const maxViewportPercentageAtTime = new Map();
            let maxSoFar = 0;
            for (const log of sortedVcLogs)if (log.viewportPercentage !== null) {
                maxSoFar = Math.max(maxSoFar, log.viewportPercentage);
                maxViewportPercentageAtTime.set(log.time, maxSoFar);
            }
            // Helper function to find the biggest previous viewport percentage
            const getBiggestPreviousViewportPercentage = (targetTime)=>{
                // Binary search for the largest time <= targetTime
                let left = 0;
                let right = sortedVcLogs.length - 1;
                let result = -1;
                while(left <= right){
                    const mid = Math.floor((left + right) / 2);
                    if (sortedVcLogs[mid].time <= targetTime) {
                        result = mid;
                        left = mid + 1;
                    } else right = mid - 1;
                }
                return result >= 0 ? maxViewportPercentageAtTime.get(sortedVcLogs[result].time) || null : null;
            };
            // Group ignored entries by timestamp
            const ignoredEntriesByTime = new Map();
            for (const entry of allEntries)if ('rect' in entry.data && !this.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch)) {
                const viewportData = entry.data;
                const timestamp = Math.round(entry.time);
                if (!ignoredEntriesByTime.has(timestamp)) ignoredEntriesByTime.set(timestamp, []);
                ignoredEntriesByTime.get(timestamp)?.push({
                    ...viewportData,
                    rect: viewportData.rect?.toJSON(),
                    previousRect: viewportData.previousRect?.toJSON(),
                    ignoreReason: viewportData.visible ? viewportData.type : 'not-visible'
                });
            }
            // Add ignored entries to vcLogs
            const additionalVcLogs = [];
            for (const [timestamp, ignoredEntries] of ignoredEntriesByTime)if (ignoredEntries.length > 0) {
                const viewportPercentage = getBiggestPreviousViewportPercentage(timestamp);
                additionalVcLogs.push({
                    time: timestamp,
                    viewportPercentage: viewportPercentage,
                    entries: ignoredEntries
                });
            }
            // Combine and sort all vcLogs
            enhancedVcLogs = [
                ...enhancedVcLogs,
                ...additionalVcLogs
            ].sort((a, b)=>a.time - b.time);
        }
        // Only create debug details if callbacks exist
        let v3RevisionDebugDetails = null;
        if (shouldCalculateDebugDetails) v3RevisionDebugDetails = {
            revision: this.revisionNo,
            isClean: isVCClean && !interactionAbortReason && isPageVisible,
            abortReason: !isPageVisible ? 'browser_backgrounded' : dirtyReason ?? interactionAbortReason,
            vcLogs: enhancedVcLogs,
            interactionId: interactionId,
            interactionType: interactionType
        };
        // Handle devtool callback
        if (v3RevisionDebugDetails && typeof window?.__ufo_devtool_onVCRevisionReady__ === 'function' && !include3p) try {
            window?.__ufo_devtool_onVCRevisionReady__?.(v3RevisionDebugDetails);
        } catch (e) {
            // if any error communicating with devtool, we don't want to break the app
            // eslint-disable-next-line no-console
            console.error('Error in onVCRevisionReady', e);
        }
        if (v3RevisionDebugDetails && typeof window?.__on_ufo_vc_debug_data_ready === 'function' && !include3p) try {
            window?.__on_ufo_vc_debug_data_ready?.(v3RevisionDebugDetails);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('Error in onVCRevisionReady', e);
        }
        if (v3RevisionDebugDetails && shouldCalculate3p) try {
            // Log vc details with 3p for debugging
            window.__ufo_devtool_vc_3p_debug_data = v3RevisionDebugDetails;
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('Error in 3pDebugData', e);
        }
        return {
            vcDetails: vcDetails,
            ssrRatio: ssrRatio
        };
    }
    async calculate({ startTime: startTime, stopTime: stopTime, orderedEntries: orderedEntries, interactionId: interactionId, isPostInteraction: isPostInteraction, include3p: include3p, excludeSmartAnswersInSearch: excludeSmartAnswersInSearch, includeSSRRatio: includeSSRRatio, interactionType: interactionType, isPageVisible: isPageVisible, interactionAbortReason: interactionAbortReason }) {
        const filteredEntries = orderedEntries.filter((entry)=>{
            return this.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch);
        });
        let isVCClean;
        let dirtyReason;
        const getVCCleanStatusResult = this.getVCCleanStatus(filteredEntries);
        isVCClean = getVCCleanStatusResult.isVCClean;
        dirtyReason = getVCCleanStatusResult.dirtyReason;
        if (!isVCClean) return {
            revision: this.revisionNo,
            'metric:vc90': null,
            clean: false,
            abortReason: dirtyReason,
            abortTimestamp: getVCCleanStatusResult.abortTimestamp
        };
        const { vcDetails: vcDetails, ssrRatio: ssrRatio } = await this.calculateWithDebugInfo(filteredEntries, startTime, stopTime, isPostInteraction, isVCClean, interactionType, isPageVisible, interactionId, dirtyReason, orderedEntries, include3p, excludeSmartAnswersInSearch, interactionAbortReason, includeSSRRatio);
        const result = {
            revision: this.revisionNo,
            clean: true,
            'metric:vc90': vcDetails?.['90']?.t ?? null,
            vcDetails: vcDetails ?? undefined
        };
        result.ratios = this.calculateRatios(filteredEntries);
        if (ssrRatio !== -1) result.ssrRatio = ssrRatio;
        if (isPostInteraction || (0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_ufo_add_segment_names_to_dom_offenders')) result.labelStacks = this.getLabelStacks(filteredEntries, isPostInteraction);
        return result;
    }
    constructor(revisionNo){
        this.revisionNo = void 0;
        this.revisionNo = revisionNo;
    }
}


// TODO: AFO-3523
// Those are the attributes we have found when testing the 'fy25.03' manually.
// We still need to replace this hardcoded list with a proper automation
const $eb56f400c2d63a78$export$98812f4e79596e2b = [
    'data-drop-target-for-element',
    'data-drop-target-for-external',
    'draggable',
    'data-is-observed',
    'data-aui-version',
    'data-testid',
    'data-vc',
    'data-ssr-placeholder',
    'data-ssr-placeholder-replace',
    'data-vc-nvs',
    'data-media-vc-wrapper',
    'data-renderer-start-pos',
    'data-table-local-id',
    'spellcheck',
    'data-auto-scrollable',
    'id',
    'tabindex',
    'data-is-ttvc-ready',
    'contenteditable',
    'data-has-collab-initialised',
    'translate'
];
const $eb56f400c2d63a78$export$44331555a87fcd9e = [
    'aria-label',
    'aria-labelledby',
    'aria-describedby',
    'aria-hidden',
    'aria-expanded',
    'aria-controls',
    'aria-selected',
    'aria-checked',
    'aria-disabled',
    'aria-required',
    'aria-current',
    'aria-haspopup',
    'aria-pressed',
    'aria-atomic',
    'aria-live'
];
const $eb56f400c2d63a78$export$c4351da6279bef53 = [
    'bis_skin_checked',
    'cz-shortcut-listen',
    'monica-version',
    'data-gr-ext-installed',
    'data-dashlane-rid',
    'sapling-installed',
    'data-gptw',
    // grammarly extensions
    'data-new-gr-c-s-loaded',
    'data-gr-aaa-notch-connection-id',
    'data-gr-aaa-loaded'
];


const $51f406f690a63ed2$export$f65ca476c09acec0 = ()=>{
    if (typeof document !== 'undefined') return document;
    return null;
};


function $bef1a1a54aa9970f$export$8be86f3caab7d679(entry) {
    const { elementName: elementName } = entry.data;
    if (!elementName || elementName === 'START') return false;
    const doc = (0, $51f406f690a63ed2$export$f65ca476c09acec0)();
    if (!doc) return false;
    const smartAnswersElement = doc.getElementById('search-page-smart-answers');
    if (!smartAnswersElement) return false;
    const entryDOMElement = doc.querySelector(elementName);
    if (!entryDOMElement) return false;
    return smartAnswersElement.contains(entryDOMElement);
}


function $888d8eb690646f65$var$isViewportEntryData(data) {
    if (data) {
        const hasElementName = typeof data.elementName === 'string';
        const hasRect = typeof data.rect !== 'undefined';
        if (hasRect && hasElementName) return true;
    }
    return false;
}
var $888d8eb690646f65$export$2e2bcd8739ae039 = $888d8eb690646f65$var$isViewportEntryData;


const $f5e50bc596ea3069$var$ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize'
];
const $f5e50bc596ea3069$var$REVISION_NO = 'fy25.03';
const $f5e50bc596ea3069$var$getConsideredEntryTypes = (include3p)=>{
    const entryTypes = [
        'mutation:child-element',
        'mutation:element',
        'mutation:attribute',
        'layout-shift',
        'layout-shift:same-rect',
        'window:event'
    ];
    // If not exclude 3p elements from ttvc,
    // including the tags into the ConsideredEntryTypes so that it won't be ignored for TTVC calculation
    if (!(0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_ufo_exclude_3p_elements_from_ttvc') || include3p) {
        entryTypes.push('mutation:third-party-element');
        entryTypes.push('mutation:third-party-attribute');
    }
    if ((0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_ufo_enable_media_for_ttvc_v3')) entryTypes.push('mutation:media');
    // Still included as part of TTVC v3
    entryTypes.push('mutation:attribute:non-visual-input-name');
    return entryTypes;
};
class $f5e50bc596ea3069$export$2e2bcd8739ae039 extends (0, $febdd312e397b58b$export$2e2bcd8739ae039) {
    isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch) {
        if (!$f5e50bc596ea3069$var$getConsideredEntryTypes(include3p).includes(entry.data.type)) return false;
        if (excludeSmartAnswersInSearch && (0, $bef1a1a54aa9970f$export$8be86f3caab7d679)(entry)) return false;
        if (entry.data.type === 'mutation:media' && (0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('media-perf-uplift-mutation-fix')) {
            const entryData = entry.data;
            const attributeName = entryData.attributeName;
            if (attributeName && (/data-(test|file|context)-\S+/g.test(attributeName) || attributeName === 'data-cursor' || attributeName === 'alt' || (attributeName === 'localid' || attributeName === 'contenteditable' || attributeName === 'anchor-name') && (0, $4ed8404376c54253$export$9db1624a8af791a4)('platform_editor_media_vc_fixes', 'isEnabled', false))) return false;
            // special case for style attribute to ignore only anchor-name changes
            if ((0, $4ed8404376c54253$export$9db1624a8af791a4)('platform_editor_media_vc_fixes', 'isEnabled', false)) {
                if ((0, $22a20165129d2aad$export$7867ddcf372cd2bf)({
                    attributeName: entryData.attributeName,
                    oldValue: entryData.oldValue,
                    newValue: entryData.newValue
                })) return false;
            }
        }
        if (entry.data.type === 'mutation:attribute') {
            const entryData = entry.data;
            const attributeName = entryData.attributeName;
            if (!attributeName || (0, $eb56f400c2d63a78$export$98812f4e79596e2b).includes(attributeName)) return false;
            if (attributeName.startsWith('data-test') || (0, $eb56f400c2d63a78$export$44331555a87fcd9e).includes(attributeName) || (0, $eb56f400c2d63a78$export$c4351da6279bef53).includes(attributeName) && (0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_ufo_exclude_3p_extensions_from_ttvc')) return false;
            return true;
        }
        if ((0, $888d8eb690646f65$export$2e2bcd8739ae039)(entry.data) && !entry.data.visible) return false;
        return true;
    }
    getVCCleanStatus(filteredEntries) {
        let dirtyReason = '';
        let abortTimestamp = -1;
        const hasAbortEvent = filteredEntries.some((entry)=>{
            if (entry.data.type === 'window:event') {
                const data = entry.data;
                if ($f5e50bc596ea3069$var$ABORTING_WINDOW_EVENT.includes(data.eventType)) {
                    dirtyReason = data.eventType === 'keydown' ? 'keypress' : data.eventType;
                    abortTimestamp = Math.round(entry.time);
                    return true;
                }
            }
            return false;
        });
        if (hasAbortEvent && dirtyReason) return {
            isVCClean: false,
            dirtyReason: dirtyReason,
            abortTimestamp: abortTimestamp
        };
        return {
            isVCClean: true
        };
    }
    constructor(revisionNo){
        super(revisionNo ?? $f5e50bc596ea3069$var$REVISION_NO);
    }
}





const $d2e40858ff9ea60d$var$getConsideredEntryTypes = ()=>{
    const consideredEntryTypes = [
        'mutation:display-contents-children-element'
    ];
    if ((0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_ufo_remove_ssr_placeholder_in_ttvc_v4')) consideredEntryTypes.push('mutation:ssr-placeholder');
    consideredEntryTypes.push('mutation:display-contents-children-attribute');
    return consideredEntryTypes;
};
const $d2e40858ff9ea60d$var$getExcludedEntryTypes = ()=>{
    const excludedEntryTypes = [
        'layout-shift:same-rect',
        'mutation:attribute:non-visual-input-name'
    ];
    return excludedEntryTypes;
};
const $d2e40858ff9ea60d$var$fy26_04_excluded_attributes = [
    'data-is-hovered' // non-visual attribute
];
class $d2e40858ff9ea60d$export$2e2bcd8739ae039 extends (0, $f5e50bc596ea3069$export$2e2bcd8739ae039) {
    isEntryIncluded(entry, include3p) {
        const isEntryIncludedInV3 = super.isEntryIncluded(entry, include3p);
        if (isEntryIncludedInV3 && !$d2e40858ff9ea60d$var$getExcludedEntryTypes().includes(entry.data.type)) return true;
        const entryData = entry.data;
        const { attributeName: attributeName } = entryData;
        if (entry.data.type === 'mutation:attribute' && (!attributeName || $d2e40858ff9ea60d$var$fy26_04_excluded_attributes.includes(attributeName) && (0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_ufo_data-is-hovered-v4-exclusion'))) return false;
        if (entryData.type === 'mutation:display-contents-children-attribute' && (0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_ufo_fix_ttvc_v4_attribute_exclusions')) {
            if (!attributeName || attributeName.startsWith('data-test') || (0, $eb56f400c2d63a78$export$98812f4e79596e2b).includes(attributeName) || (0, $eb56f400c2d63a78$export$44331555a87fcd9e).includes(attributeName) || (0, $eb56f400c2d63a78$export$c4351da6279bef53).includes(attributeName)) return false;
            return true;
        }
        return $d2e40858ff9ea60d$var$getConsideredEntryTypes().includes(entry.data.type);
    }
    constructor(){
        super('fy26.04');
    }
}






const $dfa74e7e1a0c22ce$var$ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize'
];
const $dfa74e7e1a0c22ce$var$MAX_OBSERVATIONS = 100;
function $dfa74e7e1a0c22ce$var$isWindowEventEntryData(data) {
    return data.type === 'window:event' && 'eventType' in data;
}
class $dfa74e7e1a0c22ce$export$2e2bcd8739ae039 {
    getVCCleanStatus(filteredEntries) {
        let dirtyReason = '';
        let abortTimestamp = -1;
        const hasAbortEvent = filteredEntries.some((entry)=>{
            if (entry.data.type === 'window:event') {
                const data = entry.data;
                if ($dfa74e7e1a0c22ce$var$ABORTING_WINDOW_EVENT.includes(data.eventType)) {
                    dirtyReason = data.eventType === 'keydown' ? 'keypress' : data.eventType;
                    abortTimestamp = Math.round(entry.time);
                    return true;
                }
            }
            return false;
        });
        if (hasAbortEvent && dirtyReason) return {
            isVCClean: false,
            dirtyReason: dirtyReason,
            abortTimestamp: abortTimestamp
        };
        return {
            isVCClean: true
        };
    }
    async getRawData({ entries: entries, startTime: startTime, stopTime: stopTime, isPageVisible: isPageVisible }) {
        let isVCClean;
        let dirtyReason;
        const getVCCleanStatusResult = this.getVCCleanStatus(entries);
        isVCClean = getVCCleanStatusResult.isVCClean;
        dirtyReason = getVCCleanStatusResult.dirtyReason;
        if (!isPageVisible) return {
            revision: this.revisionNo,
            clean: false,
            'metric:vc90': null,
            abortReason: 'browser_backgrounded',
            abortTimestamp: -1,
            viewport: {
                w: (0, $3ff4407421d27a1c$export$2e2bcd8739ae039)(),
                h: (0, $127b715c30acb690$export$2e2bcd8739ae039)()
            }
        };
        const viewportEntries = entries.filter((entry)=>{
            return entry.time >= startTime && entry.time <= stopTime && entry.data && entry.data.visible;
        });
        const windowEventEntries = entries.filter((entry)=>{
            return entry.time >= startTime && entry.time <= stopTime && entry.data && $dfa74e7e1a0c22ce$var$isWindowEventEntryData(entry.data);
        });
        const targetNameToIdMap = new Map();
        const elementMapEntriesMap = {};
        let nextElementId = 1;
        const typeMap = new Map();
        const typeMapEntriesMap = {};
        let nextTypeId = 1;
        const attributeMap = new Map();
        const attributeEntriesMap = {};
        let nextAttributeId = 1;
        const eventTypeMap = new Map();
        const eventTypeMapEntriesMap = {};
        let nextEventTypeId = 1;
        let rawObservations = viewportEntries.map((entry)=>{
            const viewportEntry = entry.data;
            const targetName = viewportEntry.elementName || '';
            const type = viewportEntry.type || '';
            const rect = viewportEntry.rect;
            const attributeName = viewportEntry.attributeName || '';
            let eid = targetNameToIdMap.get(viewportEntry.elementName || '') || 0;
            if (eid === 0) {
                eid = nextElementId;
                nextElementId += 1;
                targetNameToIdMap.set(targetName, eid);
                elementMapEntriesMap[eid] = targetName;
            }
            let chg = typeMap.get(type || '') || 0;
            if (chg === 0) {
                chg = nextTypeId;
                nextTypeId += 1;
                typeMap.set(type, chg);
                typeMapEntriesMap[chg] = type;
            }
            let att = 0;
            if (attributeName) {
                att = attributeMap.get(attributeName) || 0;
                if (att === 0) {
                    att = nextAttributeId;
                    nextAttributeId += 1;
                    attributeMap.set(attributeName, att);
                    attributeEntriesMap[att] = attributeName;
                }
            }
            const observation = {
                t: Math.round(entry.time - startTime),
                r: [
                    Math.round(rect.left * 10) / 10,
                    Math.round(rect.top * 10) / 10,
                    Math.round(rect.right * 10) / 10,
                    Math.round(rect.bottom * 10) / 10
                ],
                chg: chg,
                eid: eid || 0,
                ...att > 0 ? {
                    att: att
                } : {}
            };
            return observation;
        });
        let rawEventObservations = windowEventEntries.map((entry)=>{
            const windowEventEntry = entry.data;
            const eventType = windowEventEntry.eventType;
            let evtId = eventTypeMap.get(eventType) || 0;
            if (evtId === 0) {
                evtId = nextEventTypeId;
                nextEventTypeId += 1;
                eventTypeMap.set(eventType, evtId);
                eventTypeMapEntriesMap[evtId] = eventType;
            }
            const eventObservation = {
                t: Math.round(entry.time - startTime),
                evt: evtId
            };
            return eventObservation;
        });
        // If the number of observations is greater than the maximum allowed, we need to trim the observations to the maximum allowed.
        // We do this by keeping the first observation and the last MAX_OBSERVATIONS observations.
        // We then collect the referenced IDs from the remaining observations and remove the unreferenced entries from the maps
        if (rawObservations.length > $dfa74e7e1a0c22ce$var$MAX_OBSERVATIONS) {
            const firstObservation = rawObservations[0];
            const lastObservations = rawObservations.slice(-$dfa74e7e1a0c22ce$var$MAX_OBSERVATIONS);
            rawObservations = [
                firstObservation,
                ...lastObservations
            ];
            // Collect referenced IDs from remaining observations
            const referencedEids = new Set();
            const referencedChgs = new Set();
            const referencedAtts = new Set();
            for (const observation of rawObservations){
                if (observation.eid > 0) referencedEids.add(observation.eid);
                if (typeof observation.chg === 'number' && observation.chg > 0) referencedChgs.add(observation.chg);
                if (observation.att !== undefined && observation.att > 0) referencedAtts.add(observation.att);
            }
            // Remove unreferenced entries from maps
            for (const eid of Object.keys(elementMapEntriesMap).map(Number))if (!referencedEids.has(eid)) delete elementMapEntriesMap[eid];
            for (const chg of Object.keys(typeMapEntriesMap).map(Number))if (!referencedChgs.has(chg)) delete typeMapEntriesMap[chg];
            for (const att of Object.keys(attributeEntriesMap).map(Number))if (!referencedAtts.has(att)) delete attributeEntriesMap[att];
        }
        // If the number of event observations is greater than the maximum allowed, we need to trim the event observations to the maximum allowed.
        // We do this by keeping the first observation and the last MAX_OBSERVATIONS observations.
        // We then collect the referenced IDs from the remaining observations and remove the unreferenced entries from the maps
        if (rawEventObservations.length > $dfa74e7e1a0c22ce$var$MAX_OBSERVATIONS) {
            const firstEventObservation = rawEventObservations[0];
            const lastEventObservations = rawEventObservations.slice(-$dfa74e7e1a0c22ce$var$MAX_OBSERVATIONS);
            rawEventObservations = [
                firstEventObservation,
                ...lastEventObservations
            ];
            // Collect referenced IDs from remaining observations
            const referencedEvts = new Set();
            for (const observation of rawEventObservations)if (observation.evt > 0) referencedEvts.add(observation.evt);
            // Remove unreferenced entries from maps
            for (const evt of Object.keys(eventTypeMapEntriesMap).map(Number))if (!referencedEvts.has(evt)) delete eventTypeMapEntriesMap[evt];
        }
        const result = {
            revision: this.revisionNo,
            clean: isVCClean,
            'metric:vc90': null,
            rawData: {
                obs: rawObservations ?? undefined,
                eid: elementMapEntriesMap ?? undefined,
                chg: typeMapEntriesMap ?? undefined,
                att: attributeEntriesMap ?? undefined,
                evts: rawEventObservations.length > 0 ? rawEventObservations : undefined,
                evt: Object.keys(eventTypeMapEntriesMap).length > 0 ? eventTypeMapEntriesMap : undefined
            },
            abortReason: dirtyReason,
            abortTimestamp: getVCCleanStatusResult.abortTimestamp,
            viewport: {
                w: (0, $3ff4407421d27a1c$export$2e2bcd8739ae039)(),
                h: (0, $127b715c30acb690$export$2e2bcd8739ae039)()
            }
        };
        return result;
    }
    constructor(){
        this.revisionNo = 'raw-handler';
    }
}







function $8d6b33325321c552$export$80d6b07c2266a1c6(rect) {
    return rect.bottom === 0 && rect.top === 0 && rect.left === 0 && rect.right === 0 && rect.x === 0 && rect.y === 0 && rect.width === 0 && rect.height === 0;
}


function $0c2a37f04743a93f$var$isValidEntry(entry) {
    return entry.isIntersecting && entry.intersectionRect.width > 0 && entry.intersectionRect.height > 0;
}
function $0c2a37f04743a93f$export$c3799d33e0ae80a5({ onEntry: onEntry, onObserved: onObserved }) {
    if (!window || typeof window.IntersectionObserver !== 'function') return null;
    const callbacksPerElement = new WeakMap();
    const intersectionObserverCallback = (entries)=>{
        const validEntries = [];
        const startTime = performance.now();
        entries.forEach((entry)=>{
            if (!(entry.target instanceof HTMLElement)) return;
            const tagOrCallback = callbacksPerElement.get(entry.target);
            if ((0, $8d6b33325321c552$export$80d6b07c2266a1c6)(entry.intersectionRect)) {
                const zeroDimensionRectangleTagCallback = (props)=>{
                    const tagOrCallbackResult = typeof tagOrCallback === 'function' ? tagOrCallback(props) : tagOrCallback;
                    // override as display-contents mutation
                    if (tagOrCallbackResult === 'mutation:element') return 'mutation:display-contents-children-element';
                    // override as display-contents mutation
                    if (tagOrCallbackResult && typeof tagOrCallbackResult !== 'string' && tagOrCallbackResult.type === 'mutation:attribute') return {
                        type: 'mutation:display-contents-children-attribute',
                        mutationData: tagOrCallbackResult.mutationData
                    };
                    return tagOrCallbackResult;
                };
                for (const child of entry.target.children){
                    observer.observe(child);
                    callbacksPerElement.set(child, zeroDimensionRectangleTagCallback);
                }
                return;
            }
            if (!$0c2a37f04743a93f$var$isValidEntry(entry)) return;
            let mutationTag = null;
            let mutationData = null;
            if (typeof tagOrCallback === 'function') {
                const tagOrCallbackResult = tagOrCallback({
                    target: entry.target,
                    rect: entry.intersectionRect
                });
                if (!tagOrCallbackResult) mutationTag = 'unknown';
                else if (typeof tagOrCallbackResult === 'string') mutationTag = tagOrCallbackResult;
                else {
                    mutationTag = tagOrCallbackResult.type;
                    mutationData = tagOrCallbackResult.mutationData;
                }
            } else if (typeof tagOrCallback === 'string') mutationTag = tagOrCallback;
            onEntry({
                target: entry.target,
                rect: entry.intersectionRect,
                time: entry.time,
                type: mutationTag ?? 'unknown',
                mutationData: mutationData
            });
            validEntries.push(new WeakRef(entry.target));
            callbacksPerElement.delete(entry.target);
            observer.unobserve(entry.target);
        });
        onObserved?.({
            time: startTime,
            elements: validEntries
        });
    };
    const observer = new IntersectionObserver(intersectionObserverCallback);
    return {
        disconnect: ()=>{
            observer.disconnect();
        },
        unobserve: (target)=>{
            observer.unobserve(target);
        },
        watchAndTag: (target, tagOrCallback)=>{
            callbacksPerElement.set(target, tagOrCallback);
            observer.observe(target);
        }
    };
}



function $d67670cbb25adf46$var$createMutationObserver({ onAttributeMutation: onAttributeMutation, onChildListMutation: onChildListMutation, onMutationFinished: onMutationFinished }) {
    if (!window || typeof window.IntersectionObserver !== 'function') return null;
    const mutationObserverCallback = (mutations)=>{
        const targets = [];
        // Use nested Maps for O(1) batching performance
        // Short-lived Maps are safe since they're discarded after each callback
        const batchedMutations = new Map();
        for (const mut of mutations){
            if (!(mut.target instanceof HTMLElement)) continue;
            if ((0, $4ed8404376c54253$export$9db1624a8af791a4)('cc_editor_vc_exclude_flags', 'isEnabled', false)) {
                // Intended for excluding out of band mutations such as tooltips on hover, and page flags
                // Currently being tested in Confluence
                // Skip elements with data-vc-oob attribute
                if (mut.target.dataset.vcOob) return;
            }
            if (mut.type === 'attributes') {
                /*
							"MutationObserver was explicitly designed to work that way, but I can't now recall the reasoning.
							I think it might have been something along the lines that for consistency every setAttribute call should create a record.
							Conceptually there is after all a mutation: there is an old value replaced with a new one,
							and whether or not they are the same doesn't really matter.
							And Custom elements should work the same way as MutationObserver."
							https://github.com/whatwg/dom/issues/520#issuecomment-336574796
						*/ const oldValue = mut.oldValue ?? undefined;
                const newValue = mut.attributeName ? mut.target.getAttribute(mut.attributeName) : undefined;
                if (oldValue !== newValue) onAttributeMutation({
                    target: mut.target,
                    attributeName: mut.attributeName ?? 'unknown',
                    oldValue: oldValue,
                    newValue: newValue
                });
                continue;
            } else if (mut.type === 'childList') {
                // In chromium browser MutationRecord has timestamp field, which we should use.
                const timestamp = Math.round(mut.timestamp || performance.now());
                // Get or create timestamp bucket
                let timestampBucket = batchedMutations.get(timestamp);
                if (!timestampBucket) {
                    timestampBucket = new Map();
                    batchedMutations.set(timestamp, timestampBucket);
                }
                // Get or create target batch within timestamp bucket
                let batch = timestampBucket.get(mut.target);
                if (!batch) {
                    batch = {
                        target: new WeakRef(mut.target),
                        addedNodes: [],
                        removedNodes: [],
                        timestamp: timestamp
                    };
                    timestampBucket.set(mut.target, batch);
                }
                // Accumulate added nodes
                (mut.addedNodes ?? []).forEach((node)=>{
                    if (node instanceof HTMLElement) batch.addedNodes.push(new WeakRef(node));
                });
                // Accumulate removed nodes
                (mut.removedNodes ?? []).forEach((node)=>{
                    if (node instanceof HTMLElement) batch.removedNodes.push(new WeakRef(node));
                });
            }
            targets.push(mut.target);
        }
        // Process all batched childList mutations
        for (const timestampBucket of batchedMutations.values())for (const batch of timestampBucket.values())onChildListMutation({
            target: batch.target,
            addedNodes: batch.addedNodes,
            removedNodes: batch.removedNodes,
            timestamp: batch.timestamp
        });
        onMutationFinished?.({
            targets: targets
        });
    };
    const observer = new MutationObserver(mutationObserverCallback);
    return observer;
}
var $d67670cbb25adf46$export$2e2bcd8739ae039 = $d67670cbb25adf46$var$createMutationObserver;


// The LayoutShiftAttribution API is returning the numbers on physical dimension
function $84e5b47d7947dcc8$export$5e3f54cad8cb65e2(rect) {
    if (typeof window.devicePixelRatio !== 'number') return rect;
    if (window.devicePixelRatio === 1) return rect;
    // eslint-disable-next-line compat/compat
    return new DOMRect(rect.x / window.devicePixelRatio, rect.y / window.devicePixelRatio, rect.width / window.devicePixelRatio, rect.height / window.devicePixelRatio);
}
function $84e5b47d7947dcc8$var$createPerformanceObserver({ onLayoutShift: onLayoutShift }) {
    if (!window || typeof window.PerformanceObserver !== 'function') return null;
    const performanceObserverCallback = (entries)=>{
        for (const entry of entries.getEntries())if (entry.entryType === 'layout-shift' && 'sources' in entry) {
            // see https://developer.mozilla.org/en-US/docs/Web/API/LayoutShiftAttribution for more info
            const changedRects = entry.sources.reduceRight((acc, attr)=>{
                acc.push({
                    rect: $84e5b47d7947dcc8$export$5e3f54cad8cb65e2(attr.currentRect),
                    previousRect: $84e5b47d7947dcc8$export$5e3f54cad8cb65e2(attr.previousRect),
                    node: attr.node
                });
                return acc;
            }, []);
            onLayoutShift({
                time: entry.startTime,
                changedRects: changedRects
            });
        }
    };
    const observer = new PerformanceObserver(performanceObserverCallback);
    return observer;
}
var $84e5b47d7947dcc8$export$2e2bcd8739ae039 = $84e5b47d7947dcc8$var$createPerformanceObserver;



// Helper function to extract component name from fiber
function $b1d01618d78bbd3f$export$2e2bcd8739ae039(fiber) {
    const type = fiber?.type;
    if (!type) return undefined;
    if (typeof type === 'function' || typeof type === 'object') return type.displayName || type.name;
    return undefined;
}


function $b11c85a1e8bc734f$export$2e2bcd8739ae039(fiber, targetComponentName, maxLevel) {
    // Stop when no more levels to traverse
    if (maxLevel <= 0) return false;
    if (!fiber) return false;
    const componentName = (0, $b1d01618d78bbd3f$export$2e2bcd8739ae039)(fiber);
    if (componentName === targetComponentName) return true;
    // Recursively traverse up the fiber tree
    return $b11c85a1e8bc734f$export$2e2bcd8739ae039(fiber.return, targetComponentName, maxLevel - 1);
}


// Helper function to find React fiber on an element
function $a1ab56d216c8013b$export$2e2bcd8739ae039(element) {
    // Use for...in loop instead of Object.keys().find() to avoid creating an array
    for(const key in element){
        if (key.startsWith('__reactFiber$') || key.startsWith('__reactInternalInstance$')) return element[key];
    }
    return null;
}


function $2e64fa1d410edefd$export$2e2bcd8739ae039(element, maxLevel, checkedNodes) {
    // Stop when no more levels to traverse
    if (maxLevel <= 0) return null;
    checkedNodes.push(element);
    const fiber = (0, $a1ab56d216c8013b$export$2e2bcd8739ae039)(element);
    if (fiber) return fiber;
    // Walk up the DOM tree to find the fiber
    const parent = element.parentElement;
    if (!parent) return null;
    // Recursively check parent
    return $2e64fa1d410edefd$export$2e2bcd8739ae039(parent, maxLevel - 1, checkedNodes);
}


const $cc934e38a8f82c8f$var$DEFAULT_MAX_LEVEL = 20;
// Cache cleanup
let $cc934e38a8f82c8f$var$callCount = 0;
const $cc934e38a8f82c8f$var$CLEANUP_THRESHOLD = 50;
function $cc934e38a8f82c8f$var$maybeCleanup(resultCache) {
    $cc934e38a8f82c8f$var$callCount++;
    if ($cc934e38a8f82c8f$var$callCount >= $cc934e38a8f82c8f$var$CLEANUP_THRESHOLD && (0, $74d2fea471853068$export$2e2bcd8739ae039)(0.3)) $cc934e38a8f82c8f$export$6a35c3789c327630(resultCache);
}
function $cc934e38a8f82c8f$export$6a35c3789c327630(resultCache) {
    resultCache = new WeakMap();
    $cc934e38a8f82c8f$var$callCount = 0;
    return resultCache;
}
function $cc934e38a8f82c8f$export$2e2bcd8739ae039(node, targetComponentName, resultCache) {
    $cc934e38a8f82c8f$var$maybeCleanup(resultCache);
    if (resultCache.has(node)) return {
        isWithin: resultCache.get(node) ?? false
    };
    let fiber = null;
    let checkedNodes = [];
    // Always use cached fiber strategy to handle non-React elements reliably
    fiber = (0, $2e64fa1d410edefd$export$2e2bcd8739ae039)(node, $cc934e38a8f82c8f$var$DEFAULT_MAX_LEVEL, checkedNodes);
    if (!fiber) {
        checkedNodes.forEach((checkedNode)=>{
            resultCache.set(checkedNode, false);
        });
        return {
            isWithin: false
        };
    }
    const isWithin = (0, $b11c85a1e8bc734f$export$2e2bcd8739ae039)(fiber, targetComponentName, $cc934e38a8f82c8f$var$DEFAULT_MAX_LEVEL);
    checkedNodes.forEach((checkedNode)=>{
        resultCache.set(checkedNode, isWithin);
    });
    return {
        isWithin: isWithin
    };
}


function $d7206a8272834e9d$export$e989c0fffaa6b27a(element) {
    if (!(element instanceof HTMLElement)) return true;
    try {
        const visible = element.checkVisibility({
            // @ts-ignore - visibilityProperty may not exist in all TS environments
            visibilityProperty: true,
            contentVisibilityAuto: true,
            opacityProperty: true
        });
        return visible;
    } catch  {
        // there is no support for checkVisibility
        return true;
    }
}


/**
 * Check if the element is in the VC ignore if no layout shift marker.
 * @param element - The element to check.
 * @returns True if the element has the data-vc-ignore-if-no-layout-shift attribute == 'true or its parent has it, false otherwise.
 */ function $99d5c16302f263fd$export$2e2bcd8739ae039(element) {
    if (!element) return false;
    return element.getAttribute('data-vc-ignore-if-no-layout-shift') === 'true' || $99d5c16302f263fd$export$2e2bcd8739ae039(element.parentElement);
}


// Detecting this is required due to a React/Chromium bug, where React itself triggers an attribute mutation for input elements
// Reference: https://atlassian.slack.com/archives/C08EK6TCUP6/p1764129900970719
function $7c1b5b762d77a036$export$80a5724ceedcfd3d({ target: target, attributeName: attributeName, oldValue: oldValue, newValue: newValue }) {
    return target instanceof HTMLInputElement && attributeName === 'name' && (oldValue === '' || newValue === '');
}


const $1b9753833a592e88$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX = 1;
function $1b9753833a592e88$export$fde63bc968551821(a, b) {
    if (!a || !b) return false;
    return Math.abs(a.width - b.width) <= $1b9753833a592e88$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.height - b.height) <= $1b9753833a592e88$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.x - b.x) <= $1b9753833a592e88$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.y - b.y) <= $1b9753833a592e88$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX;
}


const $baa34f31126eab62$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX = 1;
function $baa34f31126eab62$export$597b41700f7dcd36(a, b) {
    if (!a || !b) return false;
    return Math.abs(a.width - b.width) <= $baa34f31126eab62$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.height - b.height) <= $baa34f31126eab62$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX;
}


const $0a574ee327bab030$var$createElementMutationsWatcher = (removedNodeRects, isWithinThirdPartySegment, hasSameDeletedNode, timestamp, isTargetReactRoot, getSSRState, getSSRPlaceholderHandler)=>({ target: target, rect: rect })=>{
        if (getSSRState) {
            const ssrState = getSSRState();
            const SSRStateEnum = {
                normal: 1,
                waitingForFirstRender: 2,
                ignoring: 3
            };
            if (ssrState.state === SSRStateEnum.waitingForFirstRender && timestamp > ssrState.renderStart && isTargetReactRoot) {
                ssrState.state = SSRStateEnum.ignoring;
                if (ssrState.renderStop === -1) // arbitrary 500ms DOM update window
                ssrState.renderStop = timestamp + 500;
                return 'ssr-hydration';
            }
            if (ssrState.state === SSRStateEnum.ignoring && timestamp > ssrState.renderStart && isTargetReactRoot) {
                if (timestamp <= ssrState.renderStop) return 'ssr-hydration';
                else ssrState.state = SSRStateEnum.normal;
            }
        }
        if (getSSRPlaceholderHandler) {
            const ssrPlaceholderHandler = getSSRPlaceholderHandler();
            if (ssrPlaceholderHandler) {
                if ((ssrPlaceholderHandler.isPlaceholderV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.checkIfExistedAndSizeMatchingV3(target)) return 'mutation:ssr-placeholder';
                if ((ssrPlaceholderHandler.isPlaceholderReplacementV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.validateReactComponentMatchToPlaceholderV4(target)) return 'mutation:ssr-placeholder';
            }
        }
        if (hasSameDeletedNode && (0, $99d5c16302f263fd$export$2e2bcd8739ae039)(target)) return 'mutation:remount';
        if ((0, $4f6b6a84812e9b6d$export$f61fbc3b9c4a9019)(target)) return 'mutation:media';
        if (isWithinThirdPartySegment) return 'mutation:third-party-element';
        const isInIgnoreLsMarker = (0, $99d5c16302f263fd$export$2e2bcd8739ae039)(target);
        if (!isInIgnoreLsMarker) return 'mutation:element';
        const isRLLPlaceholder = (0, $87406626d26e1e53$export$166779fc0f49d4df).getInstance().isRLLPlaceholderHydration(rect);
        if (isRLLPlaceholder && isInIgnoreLsMarker) return 'mutation:rll-placeholder';
        const wasDeleted = removedNodeRects.some((nr)=>(0, $1b9753833a592e88$export$fde63bc968551821)(nr, rect));
        if (wasDeleted && isInIgnoreLsMarker) return 'mutation:element-replacement';
        return 'mutation:element';
    };
class $0a574ee327bab030$export$2e2bcd8739ae039 {
    initializeObservers() {
        if (this.isStarted) return;
        this.intersectionObserver = (0, $0c2a37f04743a93f$export$c3799d33e0ae80a5)({
            onEntry: this.handleIntersectionEntry
        });
        this.mutationObserver = (0, $d67670cbb25adf46$export$2e2bcd8739ae039)({
            onChildListMutation: this.handleChildListMutation,
            onAttributeMutation: this.handleAttributeMutation
        });
        this.performanceObserver = (0, $84e5b47d7947dcc8$export$2e2bcd8739ae039)({
            onLayoutShift: this.handleLayoutShift
        });
    }
    start() {
        if (this.isStarted) return;
        this.initializeObservers();
        this.mutationObserver?.observe(document.body, {
            attributeOldValue: true,
            attributes: true,
            childList: true,
            subtree: true
        });
        this.performanceObserver?.observe({
            type: 'layout-shift',
            buffered: true,
            // @ts-ignore -error
            durationThreshold: 30
        });
        this.isStarted = true;
    }
    stop() {
        if (!this.isStarted) return;
        this.mutationObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.performanceObserver?.disconnect();
        this.isStarted = false;
        // Clean up caches when stopping
        (0, $cc934e38a8f82c8f$export$6a35c3789c327630)(this.mapIs3pResult);
    }
    constructor({ onChange: onChange, getSSRState: getSSRState, getSSRPlaceholderHandler: getSSRPlaceholderHandler }){
        this.intersectionObserver = void 0;
        this.mutationObserver = void 0;
        this.performanceObserver = void 0;
        this.mapVisibleNodeRects = void 0;
        this.mapIs3pResult = void 0;
        this.onChange = void 0;
        this.isStarted = void 0;
        // SSR context functions
        this.getSSRState = void 0;
        this.getSSRPlaceholderHandler = void 0;
        this.handleIntersectionEntry = ({ target: target, rect: rect, time: time, type: type, mutationData: mutationData })=>{
            if (!target) return;
            const visible = (0, $d7206a8272834e9d$export$e989c0fffaa6b27a)(target);
            const lastElementRect = this.mapVisibleNodeRects.get(target);
            this.mapVisibleNodeRects.set(target, rect);
            this.onChange({
                time: time,
                type: type,
                elementRef: new WeakRef(target),
                visible: visible,
                rect: rect,
                previousRect: lastElementRect,
                mutationData: mutationData
            });
        };
        this.handleChildListMutation = async ({ target: target, addedNodes: addedNodes, removedNodes: removedNodes, timestamp: timestamp })=>{
            const removedNodeRects = removedNodes.map((ref)=>{
                const n = ref.deref();
                if (!n) return;
                return this.mapVisibleNodeRects.get(n);
            });
            const targetNode = target.deref();
            for (const addedNodeRef of addedNodes){
                const addedNode = addedNodeRef.deref();
                if (!addedNode) continue;
                const hasSameDeletedNode = removedNodes.find((ref)=>{
                    const n = ref.deref();
                    if (!n || !addedNode) return false;
                    return n.isEqualNode(addedNode);
                });
                const { isWithin: isWithinThirdPartySegment } = (0, $cc934e38a8f82c8f$export$2e2bcd8739ae039)(addedNode, 'UFOThirdPartySegment', this.mapIs3pResult);
                const isTargetReactRoot = targetNode === this.getSSRState?.()?.reactRootElement;
                this.intersectionObserver?.watchAndTag(addedNode, $0a574ee327bab030$var$createElementMutationsWatcher(removedNodeRects, isWithinThirdPartySegment, !!hasSameDeletedNode, timestamp, isTargetReactRoot, this.getSSRState, this.getSSRPlaceholderHandler));
            }
        };
        this.handleAttributeMutation = ({ target: target, attributeName: attributeName, oldValue: oldValue, newValue: newValue })=>{
            this.intersectionObserver?.watchAndTag(target, ({ target: target, rect: rect })=>{
                if ((0, $4f6b6a84812e9b6d$export$f61fbc3b9c4a9019)(target)) return {
                    type: 'mutation:media',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue
                    }
                };
                if ((0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_ufo_exclude_3p_attribute_changes')) {
                    const { isWithin: isWithinThirdPartySegment } = (0, $cc934e38a8f82c8f$export$2e2bcd8739ae039)(target, 'UFOThirdPartySegment', this.mapIs3pResult);
                    if (isWithinThirdPartySegment) return {
                        type: 'mutation:third-party-attribute',
                        mutationData: {
                            attributeName: attributeName,
                            oldValue: oldValue,
                            newValue: newValue
                        }
                    };
                }
                if ((0, $22a20165129d2aad$export$2e2bcd8739ae039)({
                    target: target,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                })) return {
                    type: 'mutation:attribute:non-visual-style',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue
                    }
                };
                if ((0, $387f610f1929929a$export$2e2bcd8739ae039)({
                    target: target,
                    attributeName: attributeName,
                    type: 'attributes'
                })) return {
                    type: 'mutation:attribute:non-visual-style',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue
                    }
                };
                if ((0, $7c1b5b762d77a036$export$80a5724ceedcfd3d)({
                    target: target,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                })) return {
                    type: 'mutation:attribute:non-visual-input-name',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue
                    }
                };
                const isRLLPlaceholder = (0, $87406626d26e1e53$export$166779fc0f49d4df).getInstance().isRLLPlaceholderHydration(rect);
                if (isRLLPlaceholder) return {
                    type: 'mutation:rll-placeholder',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue
                    }
                };
                const lastElementRect = this.mapVisibleNodeRects.get(target);
                if (lastElementRect && (0, $baa34f31126eab62$export$597b41700f7dcd36)(rect, lastElementRect)) return {
                    type: 'mutation:attribute:no-layout-shift',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue
                    }
                };
                return {
                    type: 'mutation:attribute',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue
                    }
                };
            });
        };
        this.handleLayoutShift = ({ time: time, changedRects: changedRects })=>{
            for (const changedRect of changedRects){
                const target = changedRect.node;
                if (target) {
                    const isSameCurrentAndPreviousRects = (0, $1b9753833a592e88$export$fde63bc968551821)(changedRect.rect, changedRect.previousRect);
                    this.onChange({
                        time: time,
                        elementRef: new WeakRef(target),
                        visible: true,
                        rect: changedRect.rect,
                        previousRect: changedRect.previousRect,
                        type: isSameCurrentAndPreviousRects ? 'layout-shift:same-rect' : 'layout-shift'
                    });
                }
            }
        };
        this.mapVisibleNodeRects = new WeakMap();
        this.mapIs3pResult = new WeakMap();
        this.onChange = onChange;
        this.isStarted = false;
        this.intersectionObserver = null;
        this.mutationObserver = null;
        this.performanceObserver = null;
        // Initialize SSR context functions
        this.getSSRState = getSSRState;
        this.getSSRPlaceholderHandler = getSSRPlaceholderHandler;
    }
}



class $f5e54f6daeeefa72$export$2e2bcd8739ae039 {
    bindEvent(type) {
        const unbindCallback = (0, $c403da8c524792f8$exports.bind)(window, {
            type: type,
            listener: (event)=>{
                if (!event.isTrusted) return;
                this.onEvent({
                    time: event.timeStamp,
                    type: type,
                    event: event
                });
            },
            options: {
                passive: true,
                once: true
            }
        });
        this.unbindFns.push(unbindCallback);
    }
    start() {
        this.bindEvent('wheel');
        this.bindEvent('scroll');
        this.bindEvent('keydown');
        this.bindEvent('resize');
    }
    stop() {
        this.unbindFns.forEach((cb)=>{
            cb();
        });
        this.unbindFns = [];
    }
    constructor(opts){
        this.unbindFns = [];
        this.onEvent = void 0;
        this.onEvent = opts.onEvent;
    }
}


const $9f73dd6b40ec972b$var$SSRState = {
    normal: 1,
    waitingForFirstRender: 2,
    ignoring: 3
};
const $9f73dd6b40ec972b$var$DEFAULT_SELECTOR_CONFIG = {
    id: false,
    testId: true,
    role: false,
    className: false,
    dataVC: true
};
class $9f73dd6b40ec972b$export$2e2bcd8739ae039 {
    start(_) {
        // Reset SSR state on start (matches old VCObserver behavior)
        this.ssr = {
            state: $9f73dd6b40ec972b$var$SSRState.normal,
            reactRootElement: null,
            // Reset to null (matches old VCObserver)
            renderStart: -1,
            renderStop: -1
        };
        this.viewportObserver?.start();
        if (window?.__SSR_ABORT_LISTENERS__) {
            const abortListeners = window.__SSR_ABORT_LISTENERS__;
            const aborts = abortListeners.aborts;
            if (aborts && typeof aborts === 'object') Object.entries(aborts).forEach(([key, time])=>{
                if (typeof time === 'number') this.entriesTimeline.push({
                    time: time,
                    data: {
                        type: 'window:event',
                        eventType: key
                    }
                });
            });
        }
        this.windowEventObserver?.start();
        this.entriesTimeline.clear();
    }
    stop() {
        this.viewportObserver?.stop();
        this.windowEventObserver?.stop();
        // Clear SSR state on stop (matches old VCObserver behavior)
        this.ssr.reactRootElement = null;
    }
    // SSR related methods
    setReactRootElement(element) {
        this.ssr.reactRootElement = element;
    }
    setReactRootRenderStart(startTime = performance.now()) {
        this.ssr.renderStart = startTime;
        this.ssr.state = $9f73dd6b40ec972b$var$SSRState.waitingForFirstRender;
    }
    setReactRootRenderStop(stopTime = performance.now()) {
        this.ssr.renderStop = stopTime;
    }
    collectSSRPlaceholders() {
    // This is handled by the shared SSRPlaceholderHandlers in VCObserverWrapper
    // Individual observers don't need to implement this
    }
    // Internal methods for ViewportObserver to access SSR state
    getSSRState() {
        return this.ssr;
    }
    getSSRPlaceholderHandler() {
        return this.ssrPlaceholderHandler;
    }
    addSSR(ssr) {
        this.entriesTimeline.push({
            time: ssr,
            data: {
                elementName: 'SSR',
                type: 'mutation:element',
                rect: {
                    height: (0, $127b715c30acb690$export$2e2bcd8739ae039)(),
                    width: (0, $3ff4407421d27a1c$export$2e2bcd8739ae039)(),
                    left: 0,
                    top: 0,
                    x: 0,
                    y: 0,
                    bottom: (0, $127b715c30acb690$export$2e2bcd8739ae039)(),
                    right: (0, $3ff4407421d27a1c$export$2e2bcd8739ae039)(),
                    toJSON () {
                        return null;
                    }
                },
                visible: true
            }
        });
    }
    async getVCResult(param) {
        const { start: start, stop: stop, interactionId: interactionId, interactionType: interactionType, interactionAbortReason: interactionAbortReason, isPageVisible: isPageVisible, include3p: include3p, includeSSRRatio: includeSSRRatio, excludeSmartAnswersInSearch: excludeSmartAnswersInSearch, includeRawData: includeRawData, rawDataStopTime: rawDataStopTime } = param;
        const results = [];
        this.addStartEntry(start);
        const feVCCalculationStartTime = performance.now();
        const calculator_fy25_03 = new (0, $f5e50bc596ea3069$export$2e2bcd8739ae039)();
        if (param.includeSSRInV3 && param.ssr) this.addSSR(param.ssr);
        const orderedEntries = this.entriesTimeline.getOrderedEntries({
            start: start,
            stop: stop
        });
        if ((0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_ufo_vcnext_to_fy26_04_revision_update')) {
            const fy25_03 = (0, $9a2f9fc0af024eb1$export$4babcefc81a3ef0b)('fy25.03') ? await calculator_fy25_03.calculate({
                orderedEntries: orderedEntries,
                startTime: start,
                stopTime: stop,
                interactionId: interactionId,
                interactionType: interactionType,
                isPostInteraction: this.isPostInteraction,
                include3p: include3p,
                excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
                includeSSRRatio: includeSSRRatio,
                isPageVisible: isPageVisible,
                interactionAbortReason: interactionAbortReason
            }) : null;
            if (fy25_03) results.push(fy25_03);
            // From TTVC v4 onwards, ensuring that SSR entry is always auto-added, whenever it is configured.
            // From the next major version release (where TTVC v4 becomes the default TTVC version), the config for `includeSSRInV3` will be deprecated
            if (param.ssr && !param.includeSSRInV3 && (0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_ufo_auto_add_ssr_entry_in_ttvc_v4')) this.addSSR(param.ssr);
            const calculator_fy26_04 = new (0, $d2e40858ff9ea60d$export$2e2bcd8739ae039)();
            const fy26_04 = (0, $9a2f9fc0af024eb1$export$4babcefc81a3ef0b)('fy26.04') || (0, $9a2f9fc0af024eb1$export$4babcefc81a3ef0b)('next') ? await calculator_fy26_04.calculate({
                orderedEntries: orderedEntries,
                startTime: start,
                stopTime: stop,
                interactionId: interactionId,
                interactionType: interactionType,
                isPostInteraction: this.isPostInteraction,
                include3p: include3p,
                includeSSRRatio: includeSSRRatio,
                isPageVisible: isPageVisible,
                interactionAbortReason: interactionAbortReason
            }) : null;
            if (fy26_04) {
                const vcNext = {
                    revision: 'next',
                    'metric:vc90': fy26_04['metric:vc90'],
                    clean: fy26_04['clean']
                };
                results.push(fy26_04);
                results.push(vcNext);
            }
        } else {
            const fy25_03 = await calculator_fy25_03.calculate({
                orderedEntries: orderedEntries,
                startTime: start,
                stopTime: stop,
                interactionId: interactionId,
                interactionType: interactionType,
                isPostInteraction: this.isPostInteraction,
                include3p: include3p,
                excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
                includeSSRRatio: includeSSRRatio,
                isPageVisible: isPageVisible,
                interactionAbortReason: interactionAbortReason
            });
            if (fy25_03) results.push(fy25_03);
            // From TTVC v4 onwards, ensuring that SSR entry is always auto-added, whenever it is configured.
            // From the next major version release (where TTVC v4 becomes the default TTVC version), the config for `includeSSRInV3` will be deprecated
            if (param.ssr && !param.includeSSRInV3 && (0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_ufo_auto_add_ssr_entry_in_ttvc_v4')) this.addSSR(param.ssr);
            const calculator_next = new (0, $d2e40858ff9ea60d$export$2e2bcd8739ae039)();
            const vcNext = await calculator_next.calculate({
                orderedEntries: orderedEntries,
                startTime: start,
                stopTime: stop,
                interactionId: interactionId,
                interactionType: interactionType,
                isPostInteraction: this.isPostInteraction,
                include3p: include3p,
                includeSSRRatio: includeSSRRatio,
                isPageVisible: isPageVisible,
                interactionAbortReason: interactionAbortReason
            });
            if (vcNext) {
                vcNext.revision = 'next';
                results.push(vcNext);
            }
        }
        const feVCCalculationEndTime = performance.now();
        if (includeRawData && (0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_ufo_enable_vc_raw_data')) {
            const rawVCCalculationStartTime = performance.now();
            const rawHandler = new (0, $dfa74e7e1a0c22ce$export$2e2bcd8739ae039)();
            // Use rawDataStopTime (end3p) when available to capture observations during 3p holds
            const rawStopTime = rawDataStopTime ?? stop;
            const rawOrderedEntries = rawDataStopTime ? this.entriesTimeline.getOrderedEntries({
                start: start,
                stop: rawStopTime
            }) : orderedEntries;
            const raw = await rawHandler.getRawData({
                entries: rawOrderedEntries,
                startTime: start,
                stopTime: rawStopTime,
                isPageVisible: isPageVisible
            });
            results.forEach((result)=>{
                delete result.vcDetails;
                delete result.ratios;
            });
            if (raw) {
                raw.rawVCTime = Number((performance.now() - rawVCCalculationStartTime).toFixed(2));
                raw.feVCTime = Number((feVCCalculationEndTime - feVCCalculationStartTime).toFixed(2));
                results.push(raw);
            }
        }
        return results;
    }
    addStartEntry(startTime) {
        this.entriesTimeline.push({
            time: startTime,
            data: {
                type: 'mutation:element',
                elementName: 'START',
                visible: true,
                rect: {
                    x: 0,
                    y: 0,
                    width: window.innerWidth,
                    height: window.innerHeight,
                    top: 0,
                    left: 0,
                    bottom: window.innerHeight,
                    right: window.innerWidth,
                    toJSON: function() {
                        return {
                            x: this.x,
                            y: this.y,
                            width: this.width,
                            height: this.height,
                            top: this.top,
                            left: this.left,
                            bottom: this.bottom,
                            right: this.right
                        };
                    }
                }
            }
        });
    }
    getElementName(element) {
        return (0, $702a42bc3154ff26$export$2e2bcd8739ae039)(this.selectorConfig, element);
    }
    constructor(config){
        this.selectorConfig = void 0;
        this.viewportObserver = null;
        this.windowEventObserver = null;
        this.entriesTimeline = void 0;
        this.isPostInteraction = void 0;
        // SSR related properties
        this.ssrPlaceholderHandler = null;
        this.ssr = {
            state: $9f73dd6b40ec972b$var$SSRState.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        this.entriesTimeline = new (0, $ced6f056132d1975$export$2e2bcd8739ae039)();
        this.isPostInteraction = config.isPostInteraction ?? false;
        this.selectorConfig = config.selectorConfig ?? $9f73dd6b40ec972b$var$DEFAULT_SELECTOR_CONFIG;
        // Use shared SSR placeholder handler if provided, otherwise create new one if feature flag is enabled
        if (config.ssrPlaceholderHandler) this.ssrPlaceholderHandler = config.ssrPlaceholderHandler;
        else this.ssrPlaceholderHandler = new (0, $2980e382ee19fa1c$export$c0102f1a1198d10f)({
            enablePageLayoutPlaceholder: config.SSRConfig?.enablePageLayoutPlaceholder ?? false
        });
        this.viewportObserver = new (0, $0a574ee327bab030$export$2e2bcd8739ae039)({
            onChange: (onChangeArg)=>{
                const { time: time, type: type, elementRef: elementRef, visible: visible, rect: rect, previousRect: previousRect, mutationData: mutationData } = onChangeArg;
                let elementName = 'unknown';
                const element = elementRef.deref();
                if (element) elementName = this.getElementName(element);
                const data = {
                    type: type,
                    elementName: elementName,
                    rect: rect,
                    previousRect: previousRect,
                    visible: visible,
                    attributeName: mutationData?.attributeName,
                    oldValue: mutationData?.oldValue,
                    newValue: mutationData?.newValue
                };
                if (element && (this.isPostInteraction || (0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_ufo_add_segment_names_to_dom_offenders'))) {
                    const labelStacks = $9f73dd6b40ec972b$var$getLabelStacks(element);
                    if (labelStacks) Object.assign(data, {
                        labelStacks: labelStacks
                    });
                }
                this.entriesTimeline.push({
                    time: time,
                    data: data
                });
            },
            // Pass SSR context to ViewportObserver
            getSSRState: ()=>this.getSSRState(),
            getSSRPlaceholderHandler: ()=>this.getSSRPlaceholderHandler()
        });
        this.windowEventObserver = new (0, $f5e54f6daeeefa72$export$2e2bcd8739ae039)({
            onEvent: ({ time: time, type: type })=>{
                // Don't abort press interactions on keydown events, as keydown is expected
                // when users press Enter/Space to activate buttons or other interactive elements
                if (type === 'keydown' && (0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_ufo_keypress_interaction_abort')) {
                    const interaction = (0, $7390d9fffd2908eb$export$2b3954d2e8509985)();
                    if (interaction?.type === 'press') return;
                }
                this.entriesTimeline.push({
                    time: time,
                    data: {
                        type: 'window:event',
                        eventType: type
                    }
                });
            }
        });
    }
}
function $9f73dd6b40ec972b$var$labelStackFromFiber(fiber) {
    const value = fiber?.child?.memoizedProps?.value;
    return Array.isArray(value?.labelStack) ? value.labelStack : [];
}
function $9f73dd6b40ec972b$var$labelStackToString(labelStack) {
    return labelStack.map((label)=>label.name).join('/');
}
function $9f73dd6b40ec972b$var$labelStackToSegment(labelStack) {
    let segmentIndex = -1;
    for(let i = labelStack.length - 1; i >= 0; i--)if (labelStack[i].segmentId) {
        segmentIndex = i;
        break;
    }
    return labelStack.slice(0, segmentIndex + 1).map((label)=>label.name).join('/');
}
function $9f73dd6b40ec972b$var$traverseFiber(fiber) {
    let segment = 'unknown';
    let labelStackString = 'unknown';
    let currentFiber = fiber;
    while(currentFiber){
        if (currentFiber.type) {
            const componentName = currentFiber.type.displayName || currentFiber.type.name;
            if (componentName === 'UFOSegment' || componentName === 'UFOLabel') {
                const labelStack = $9f73dd6b40ec972b$var$labelStackFromFiber(currentFiber);
                labelStackString = $9f73dd6b40ec972b$var$labelStackToString(labelStack) || 'unknown';
                segment = $9f73dd6b40ec972b$var$labelStackToSegment(labelStack) || 'unknown';
                break;
            }
        }
        currentFiber = currentFiber.return;
    }
    return {
        segment: segment,
        labelStack: labelStackString
    };
}
function $9f73dd6b40ec972b$var$getLabelStacks(element) {
    const reactFiberKey = Object.keys(element).find((key)=>key.startsWith('__reactFiber$'));
    if (!reactFiberKey) return null;
    const fiber = element[reactFiberKey];
    return fiber ? $9f73dd6b40ec972b$var$traverseFiber(fiber) : null;
}





var $aVaWD = parcelRequire("aVaWD");
class $d817c7e4439fbe2c$export$4a1fe1ab3c13bbf5 {
    // Helper method to process SSR abort listeners
    processSsrAbortListeners() {
        // Process any SSR abort listeners that remain
        if (window?.__SSR_ABORT_LISTENERS__) {
            // Clean up any event listeners that may have been registered during SSR
            // This is centralized here so only the wrapper handles unbinding, not individual observers
            if (window.__SSR_ABORT_LISTENERS__.unbinds && Array.isArray(window.__SSR_ABORT_LISTENERS__.unbinds)) window.__SSR_ABORT_LISTENERS__.unbinds.forEach((unbind)=>{
                if (typeof unbind === 'function') unbind();
            });
            // After all observers had a chance to process abort events,
            // we can safely delete the SSR_ABORT_LISTENERS object
            delete window.__SSR_ABORT_LISTENERS__;
        }
    }
    start({ startTime: startTime, experienceKey: experienceKey }) {
        if ((0, $9a2f9fc0af024eb1$export$4babcefc81a3ef0b)('fy25.01', experienceKey) || (0, $9a2f9fc0af024eb1$export$4babcefc81a3ef0b)('fy25.02', experienceKey)) this.oldVCObserver?.start({
            startTime: startTime
        });
        if ((0, $9a2f9fc0af024eb1$export$4babcefc81a3ef0b)('fy25.03', experienceKey)) this.newVCObserver?.start({
            startTime: startTime
        });
        // Clean up any remaining SSR abort listeners after all observers have been started
        this.processSsrAbortListeners();
    }
    stop(experienceKey) {
        if ((0, $9a2f9fc0af024eb1$export$4babcefc81a3ef0b)('fy25.01', experienceKey) || (0, $9a2f9fc0af024eb1$export$4babcefc81a3ef0b)('fy25.02', experienceKey)) this.oldVCObserver?.stop();
        if ((0, $9a2f9fc0af024eb1$export$4babcefc81a3ef0b)('fy25.03', experienceKey)) this.newVCObserver?.stop();
        (0, $87406626d26e1e53$export$166779fc0f49d4df).getInstance().reset();
        // Clear shared SSR placeholder handler
        this.ssrPlaceholderHandler.clear();
    }
    getVCRawData() {
        return this.oldVCObserver?.getVCRawData() ?? null;
    }
    async getVCResult(param) {
        const { experienceKey: experienceKey, include3p: include3p, excludeSmartAnswersInSearch: excludeSmartAnswersInSearch, includeSSRRatio: includeSSRRatio, includeRawData: includeRawData } = param;
        const v1v2Result = (0, $9a2f9fc0af024eb1$export$4babcefc81a3ef0b)('fy25.01', experienceKey) || (0, $9a2f9fc0af024eb1$export$4babcefc81a3ef0b)('fy25.02', experienceKey) ? await this.oldVCObserver?.getVCResult(param) : {};
        const v3v4Result = (0, $9a2f9fc0af024eb1$export$4babcefc81a3ef0b)('fy25.03', experienceKey) ? await this.newVCObserver?.getVCResult({
            start: param.start,
            stop: param.stop,
            interactionId: param.interactionId,
            ssr: param.ssr,
            include3p: include3p,
            excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
            includeSSRRatio: includeSSRRatio,
            interactionType: param.interactionType,
            isPageVisible: param.isPageVisible,
            interactionAbortReason: param.interactionAbortReason,
            includeRawData: includeRawData,
            includeSSRInV3: param.includeSSRInV3,
            rawDataStopTime: param.rawDataStopTime
        }) : [];
        if (!v3v4Result) return v1v2Result ?? {};
        const ssrRatio = v3v4Result[0].ssrRatio;
        return {
            ...includeSSRRatio && ssrRatio !== undefined ? {
                'ufo:vc:ssrRatio': ssrRatio
            } : {},
            ...v1v2Result,
            'ufo:vc:rev': [
                ...v1v2Result?.['ufo:vc:rev'] ?? [],
                ...v3v4Result ?? []
            ]
        };
    }
    setSSRElement(element) {
        this.oldVCObserver?.setSSRElement(element);
        this.newVCObserver?.setReactRootElement(element);
    }
    setReactRootRenderStart(startTime) {
        this.oldVCObserver?.setReactRootRenderStart(startTime || performance.now());
        this.newVCObserver?.setReactRootRenderStart(startTime || performance.now());
    }
    setReactRootRenderStop(stopTime) {
        this.oldVCObserver?.setReactRootRenderStop(stopTime || performance.now());
        this.newVCObserver?.setReactRootRenderStop(stopTime || performance.now());
    }
    collectSSRPlaceholders() {
        this.ssrPlaceholderHandler.collectExistingPlaceholders();
    }
    constructor(opts = {}){
        this.oldVCObserver = void 0;
        this.newVCObserver = void 0;
        this.ssrPlaceholderHandler = void 0;
        this.newVCObserver = null;
        this.oldVCObserver = null;
        // Initialize SSR placeholder handler once
        this.ssrPlaceholderHandler = new (0, $2980e382ee19fa1c$export$c0102f1a1198d10f)({
            enablePageLayoutPlaceholder: opts.ssrEnablePageLayoutPlaceholder ?? false
        });
        const ttvcV4RevisionName = (0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_ufo_vcnext_to_fy26_04_revision_update') ? 'fy26.04' : 'next';
        if ((0, $9a2f9fc0af024eb1$export$4babcefc81a3ef0b)('fy25.03') || (0, $9a2f9fc0af024eb1$export$4babcefc81a3ef0b)(ttvcV4RevisionName)) this.newVCObserver = new (0, $9f73dd6b40ec972b$export$2e2bcd8739ae039)({
            selectorConfig: opts.selectorConfig,
            isPostInteraction: opts.isPostInteraction,
            SSRConfig: {
                enablePageLayoutPlaceholder: opts.ssrEnablePageLayoutPlaceholder ?? false
            },
            ssrPlaceholderHandler: this.ssrPlaceholderHandler
        });
        if ((0, $9a2f9fc0af024eb1$export$4babcefc81a3ef0b)('fy25.01') || (0, $9a2f9fc0af024eb1$export$4babcefc81a3ef0b)('fy25.02')) this.oldVCObserver = new (0, $a9a4078a79494f2d$export$1f70d263701b1d01)({
            ...opts,
            ssrPlaceholderHandler: this.ssrPlaceholderHandler
        });
    }
}
// Some products set this variable to indicate it is running in SSR
let $d817c7e4439fbe2c$var$isServer = Boolean(globalThis?.__SERVER__);
// Other products set this other variable to indicate it is running in SSR
let $d817c7e4439fbe2c$var$isReactSSR = typeof $aVaWD !== 'undefined' && Boolean($aVaWD?.env?.REACT_SSR || false);
function $d817c7e4439fbe2c$export$68d57b133e88584d() {
    // SSR environment aren't supported
    if ($d817c7e4439fbe2c$var$isReactSSR || $d817c7e4439fbe2c$var$isServer) return false;
    // Legacy browsers that doesn't support WeakRef
    // aren't valid
    if (typeof globalThis?.WeakRef !== 'function') return false;
    if (typeof globalThis?.MutationObserver !== 'function' || typeof globalThis?.IntersectionObserver !== 'function' || typeof globalThis?.PerformanceObserver !== 'function') return false;
    return true;
}
function $d817c7e4439fbe2c$export$b3bc47985717b49e(opts = {}) {
    if (!globalThis.__vcObserver) {
        const shouldMockVCObserver = !$d817c7e4439fbe2c$export$68d57b133e88584d();
        globalThis.__vcObserver = shouldMockVCObserver ? new (0, $0be71a22067e9dfe$export$24d07287b49da906)() : new $d817c7e4439fbe2c$export$4a1fe1ab3c13bbf5(opts);
    }
    return globalThis.__vcObserver;
}
function $d817c7e4439fbe2c$export$c69731bddfc24d85(opts = {}) {
    const shouldMockVCObserver = !$d817c7e4439fbe2c$export$68d57b133e88584d();
    const observer = shouldMockVCObserver ? new (0, $0be71a22067e9dfe$export$24d07287b49da906)() : new $d817c7e4439fbe2c$export$4a1fe1ab3c13bbf5(opts);
    return observer;
}


const $8aa9073f90761d26$export$cc97b17ef9aeb088 = new Map();





class $c116c856a403ccf5$export$2e2bcd8739ae039 {
    initializeVCObserver(options) {
        this.vcObserver = new (0, $d817c7e4439fbe2c$export$4a1fe1ab3c13bbf5)({
            ...options,
            isPostInteraction: true
        });
    }
    startVCObserver({ startTime: startTime }, interactionId) {
        if (this.eligibleToMeasure(interactionId)) this.vcObserver?.start({
            startTime: startTime
        });
    }
    stopVCObserver() {
        this.vcObserver?.stop();
    }
    // Check if the current interaction is eligible for measurement
    eligibleToMeasure(interactionId) {
        const interaction = (0, $8aa9073f90761d26$export$cc97b17ef9aeb088).get(interactionId);
        return interaction?.type === 'page_load' || interaction?.type === 'transition';
    }
    updateFinishedInteraction(interaction) {
        if (interaction?.type === 'page_load' || interaction?.type === 'transition') this.finishedInteraction = interaction;
    }
    setLastInteractionFinishVCResult(result) {
        this.lastInteractionFinishVCResult = result;
    }
    sinkHandler(fn) {
        this.sinkHandlerFn = fn;
    }
    onInteractionComplete(id, data) {
        if (data.ufoName) {
            const updatedData = {
                ...data,
                vcObserver: this.vcObserver ?? undefined
            };
            this.sinkHandlerFn(id, updatedData, this.finishedInteraction, this.lastInteractionFinishVCResult);
        }
        this.stopVCObserver();
        (0, $7390d9fffd2908eb$export$cd7f480d6b8286c3)(id);
        this.reset();
    }
    reset() {
        this.stopVCObserver();
        if (this.finishedInteraction?.id) (0, $7390d9fffd2908eb$export$cd7f480d6b8286c3)(this.finishedInteraction.id);
        this.finishedInteraction = null;
        this.lastInteractionFinishVCResult = undefined;
    }
    stopAll(id) {
        (0, $7390d9fffd2908eb$export$cd7f480d6b8286c3)(id);
        this.reset();
    }
    constructor(){
        // Store the finished interaction (as non-3p interaction)
        this.finishedInteraction = null;
        // independent VC observer, that observes until `custom.post-interaction-logs` event is sent
        this.vcObserver = null;
        // Store the finished interaction's VC result
        this.lastInteractionFinishVCResult = void 0;
        this.sinkHandlerFn = ()=>{};
    }
}






const $169c6107ff9be48b$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT = 3000;
class $169c6107ff9be48b$export$2e2bcd8739ae039 {
    initializeVCObserver(options) {
        this.vcObserver = new (0, $d817c7e4439fbe2c$export$4a1fe1ab3c13bbf5)({
            ...options,
            isPostInteraction: true
        });
    }
    startVCObserver({ startTime: startTime }) {
        this.vcObserver?.start({
            startTime: startTime
        });
    }
    stopVCObserver() {
        this.vcObserver?.stop();
    }
    setVCObserverSSRConfig(vcObserverSSRConfig) {
        this.vcObserverSSRConfig = vcObserverSSRConfig;
    }
    /**
   * Set the VC result as per the last interaction
   * Used to compare diffs of VC updates vs post interaction VC observer
   * @param result - VC result as calculated by UFO create payload
   */ setLastInteractionFinishVCResult(result) {
        this.lastInteractionFinishVCResult = result;
    }
    /**
   * Set the fn that would be invoked to process / send the observation data
   */ sinkHandler(sinkHandlerFn) {
        this.sinkHandlerFn = sinkHandlerFn;
    }
    /**
   * Reset state of the log
   */ reset() {
        this.lastInteractionFinish = null;
        this.reactProfilerTimings = [];
        this.holdInfo = [];
        if (this.sinkTimeoutId != null) {
            clearTimeout(this.sinkTimeoutId);
            this.sinkTimeoutId = null;
        }
        this.setVCObserverSSRConfig(null);
    }
    /**
   * Check if there is data in the log
   */ hasData() {
        return this.reactProfilerTimings?.length > 0;
    }
    /**
   * Send the log if there is data
   */ async sendPostInteractionLog() {
        if (!this.lastInteractionFinish || !this.sinkHandlerFn || !this.hasData() && !(0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_ufo_always_send_post_interaction_log')) {
            this.reset();
            this.vcObserver?.stop();
            return;
        }
        const pageVisibilityState = (0, $609a77f2077f290f$export$768b2008623433e1)(this.lastInteractionFinish.start, this.lastInteractionFinish.end);
        const isPageVisible = pageVisibilityState === 'visible';
        const config = (0, $9a2f9fc0af024eb1$export$44487a86467333c3)();
        const postInteractionFinishVCResult = await this.vcObserver?.getVCResult({
            start: this.lastInteractionFinish.start,
            stop: performance.now(),
            tti: -1,
            // no need for TTI value here
            isEventAborted: !!this.lastInteractionFinish.abortReason,
            prefix: 'ufo',
            experienceKey: this.lastInteractionFinish.ufoName,
            interactionId: this.lastInteractionFinish.id,
            includeSSRInV3: config?.vc?.includeSSRInV3,
            includeSSRRatio: config?.vc?.includeSSRRatio,
            ...this.vcObserverSSRConfig,
            interactionType: this.lastInteractionFinish.type,
            isPageVisible: isPageVisible,
            interactionAbortReason: this.lastInteractionFinish.abortReason
        });
        this.vcObserver?.stop();
        this.sinkHandlerFn({
            lastInteractionFinish: this.lastInteractionFinish,
            reactProfilerTimings: this.reactProfilerTimings,
            postInteractionFinishVCResult: postInteractionFinishVCResult,
            lastInteractionFinishVCResult: this.lastInteractionFinishVCResult,
            postInteractionHoldInfo: this.holdInfo
        });
        this.reset();
    }
    /**
   * This fn should be invoked when an interaction has finished
   * Basic details about the finished interaction will be recorded
   * A timeout will be setup to send the post interaction observation after some time.
   */ onInteractionComplete({ ufoName: ufoName, start: start, end: end, id: id, abortReason: abortReason, abortedByInteractionName: abortedByInteractionName, routeName: routeName, type: type, experimentalTTAI: experimentalTTAI, experimentalVC90: experimentalVC90, errors: errors }) {
        this.lastInteractionFinish = {
            ufoName: ufoName,
            start: start,
            end: end,
            id: id,
            abortReason: abortReason,
            abortedByInteractionName: abortedByInteractionName,
            routeName: routeName,
            type: type,
            experimentalTTAI: experimentalTTAI,
            experimentalVC90: experimentalVC90,
            errors: errors
        };
        const timeout = (0, $9a2f9fc0af024eb1$export$44487a86467333c3)()?.timeWindowForLateMutationsInMilliseconds || $169c6107ff9be48b$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT;
        this.sinkTimeoutId = window.setTimeout(async ()=>{
            await this.sendPostInteractionLog();
        }, timeout);
    }
    /**
   * This fn should be invoked when a React render happens after interaction has finished
   */ addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
        if (this.lastInteractionFinish != null) this.reactProfilerTimings.push({
            type: type,
            actualDuration: actualDuration,
            baseDuration: baseDuration,
            startTime: startTime,
            commitTime: commitTime,
            labelStack: labelStack
        });
    }
    addHoldInfo(labelStack, name, start) {
        this.holdInfo.push({
            name: name,
            labelStack: labelStack,
            start: start
        });
    }
    constructor(){
        /**
     * Basic info about interaction that has just finished
     */ this.lastInteractionFinish = null;
        /**
     * Array of observed react render timings
     */ this.reactProfilerTimings = [];
        /**
     * Store the scheduled sink timeout Id so that it can be cancelled when needed
     */ this.sinkTimeoutId = null;
        this.holdInfo = [];
        /**
     * independent VC observer, that observes until `custom.post-interaction-logs` event is sent
     */ this.vcObserver = null;
        this.vcObserverSSRConfig = null;
        this.lastInteractionFinishVCResult = void 0;
        /**
     * Handler function to process / send the observation data
     */ this.sinkHandlerFn = ()=>{};
    }
}


const $7390d9fffd2908eb$var$PreviousInteractionLog = {
    name: undefined,
    isAborted: undefined
};
const $7390d9fffd2908eb$export$d8f52e8f804021e8 = new (0, $169c6107ff9be48b$export$2e2bcd8739ae039)();
const $7390d9fffd2908eb$export$481f88116dc8b7ad = new (0, $c116c856a403ccf5$export$2e2bcd8739ae039)();
const $7390d9fffd2908eb$var$interactionQueue = [];
const $7390d9fffd2908eb$var$segmentCache = new Map();
const $7390d9fffd2908eb$export$a2b14406ded37d60 = new Map(); // Temporarily store segment unmount counts
let $7390d9fffd2908eb$var$firstSegmentLoadMarked = false;
const $7390d9fffd2908eb$var$segmentObservers = [];
function $7390d9fffd2908eb$export$2b3954d2e8509985() {
    const interactionId = (0, $cb7ea7f0a3e09fe0$export$37bca3107733ac1e)();
    if (!interactionId.current) return;
    return (0, $8aa9073f90761d26$export$cc97b17ef9aeb088).get(interactionId.current);
}
function $7390d9fffd2908eb$var$isPerformanceTracingEnabled() {
    return (0, $9a2f9fc0af024eb1$export$44487a86467333c3)()?.enableAdditionalPerformanceMarks || window.__REACT_UFO_ENABLE_PERF_TRACING || false;
}
let $7390d9fffd2908eb$var$performanceEventObserver;
const $7390d9fffd2908eb$export$17afbba0f16b4b19 = ()=>{
    $7390d9fffd2908eb$var$performanceEventObserver = $7390d9fffd2908eb$var$performanceEventObserver || new PerformanceObserver((entries)=>{
        const list = entries.getEntries();
        for (let entry of list)if (entry.name === 'click') $7390d9fffd2908eb$export$e6be05b411ce21a6(entry);
    });
    return $7390d9fffd2908eb$var$performanceEventObserver;
};
const $7390d9fffd2908eb$export$e6be05b411ce21a6 = (entry)=>{
    const interaction = $7390d9fffd2908eb$export$2b3954d2e8509985();
    if (interaction?.type === 'press') {
        const responsiveness = interaction.responsiveness || {};
        // if happens there is another event interaction that has started after
        // the initial one, we don't want to replace the values if they have already
        // been set up
        responsiveness.experimentalInputToNextPaint = responsiveness.experimentalInputToNextPaint || entry.duration;
        responsiveness.inputDelay = responsiveness.experimentalInputToNextPaint || entry.processingStart - entry.startTime;
        interaction.responsiveness = responsiveness;
        // if the entry start time is lower than the one in the interaction
        // it means the interaction start time is not accurate, we assign
        // this value which will match the timestamp in the event
        if (entry.startTime < interaction.start) interaction.start = entry.startTime;
    }
};
function $7390d9fffd2908eb$var$labelStackToString(labelStack, name) {
    const stack = [
        ...labelStack ?? []
    ];
    if (name) stack.push({
        name: name
    });
    return stack.map((l)=>l.name)?.join('/');
}
function $7390d9fffd2908eb$var$labelStackToIdString(labelStack) {
    return labelStack?.map((l)=>'segmentId' in l ? `${l.name}:${l.segmentId}` : `${l.name}`)?.join('/');
}
function $7390d9fffd2908eb$var$addSegmentObserver(observer) {
    $7390d9fffd2908eb$var$segmentObservers.push(observer);
    for (const segmentInfo of $7390d9fffd2908eb$var$segmentCache.values())observer.onAdd(segmentInfo);
}
function $7390d9fffd2908eb$var$removeSegmentObserver(observer) {
    const index = $7390d9fffd2908eb$var$segmentObservers.findIndex((obs)=>obs === observer);
    if (index !== -1) $7390d9fffd2908eb$var$segmentObservers.splice(index, 1);
}
function $7390d9fffd2908eb$export$cd7f480d6b8286c3(interactionId) {
    (0, $8aa9073f90761d26$export$cc97b17ef9aeb088).delete(interactionId);
}
function $7390d9fffd2908eb$export$f6f1cf5bedf83c71(ufoName, routeName = ufoName) {
    const interaction = $7390d9fffd2908eb$export$2b3954d2e8509985();
    if (!interaction || interaction.type !== 'page_load' && interaction.type !== 'transition') return;
    interaction.ufoName = ufoName;
    interaction.routeName = routeName;
}
function $7390d9fffd2908eb$export$12f2b6cb85d59904(interactionId, data) {
    const interaction = (0, $8aa9073f90761d26$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) Object.keys(data).forEach((key)=>{
        interaction.metaData[key] = data[key];
    });
}
function $7390d9fffd2908eb$export$e4380431c2bdabee(interactionId, labelStack, data) {
    const interaction = (0, $8aa9073f90761d26$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) Object.keys(data).forEach((i)=>{
        interaction.customData.push({
            labelStack: labelStack,
            data: {
                [i]: data[i]
            }
        });
    });
}
function $7390d9fffd2908eb$export$20265b12c6625451(interactionId, key, value) {
    const interaction = (0, $8aa9073f90761d26$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction == null) return;
    // Allow null and undefined values
    if (value === null || value === undefined) {
        interaction.cohortingCustomData.set(key, value);
        return;
    }
    // Validate that the value is a primitive (number, boolean, or string)
    if (typeof value !== 'number' && typeof value !== 'boolean' && typeof value !== 'string') return;
    // Validate string length (max 50 characters)
    if (typeof value === 'string' && value.length > 50) return;
    interaction.cohortingCustomData.set(key, value);
}
function $7390d9fffd2908eb$export$27cacb7d7f3fe20a(interactionId, labelStack, data) {
    const interaction = (0, $8aa9073f90761d26$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) {
        interaction.customTimings.push({
            labelStack: labelStack,
            data: data
        });
        if ($7390d9fffd2908eb$var$isPerformanceTracingEnabled()) for (const [key, timingData] of Object.entries(data)){
            const { startTime: startTime, endTime: endTime } = timingData;
            try {
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${$7390d9fffd2908eb$var$labelStackToString(labelStack, key)} [custom_timing]`, {
                    start: startTime,
                    end: endTime,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'tertiary-light'
                        }
                    }
                });
            } catch  {
            // do nothing
            }
        }
    }
}
function $7390d9fffd2908eb$export$728e28c22a0fba4(interactionId, type, name, labelStack, time = performance.now()) {
    const interaction = (0, $8aa9073f90761d26$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) interaction.marks.push({
        type: type,
        name: name,
        labelStack: labelStack,
        time: time
    });
    if ($7390d9fffd2908eb$var$isPerformanceTracingEnabled()) performance.mark(`\u{1F6F8} ${$7390d9fffd2908eb$var$labelStackToString(labelStack, name)} [${type}]`, {
        startTime: time
    });
}
function $7390d9fffd2908eb$export$85d1eb835f669bf(interactionId, labelStack, time = performance.now()) {
    if (!(0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_mark_ufo_segment_first_load')) return;
    const interaction = (0, $8aa9073f90761d26$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null && !$7390d9fffd2908eb$var$firstSegmentLoadMarked) {
        $7390d9fffd2908eb$var$firstSegmentLoadMarked = true;
        interaction.marks.push({
            type: 'first_segment_load',
            name: 'first_segment_load',
            labelStack: labelStack,
            time: time
        });
    }
}
function $7390d9fffd2908eb$export$c4b23cc624bd2fb(type, name, labelStack, time = performance.now()) {
    (0, $8aa9073f90761d26$export$cc97b17ef9aeb088).forEach((interaction)=>{
        interaction.marks.push({
            type: type,
            name: name,
            labelStack: labelStack,
            time: time
        });
    });
    if ($7390d9fffd2908eb$var$isPerformanceTracingEnabled()) performance.mark(`\u{1F6F8} ${$7390d9fffd2908eb$var$labelStackToString(labelStack, name)} [${type}]`, {
        startTime: time
    });
}
function $7390d9fffd2908eb$export$2c1d6e17cfa9bbc7(interactionId, type, name, labelStack, start, end = performance.now(), size) {
    const interaction = (0, $8aa9073f90761d26$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) {
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
        if ($7390d9fffd2908eb$var$isPerformanceTracingEnabled()) try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${$7390d9fffd2908eb$var$labelStackToString(labelStack, name)} [${type}]`, {
                start: start,
                end: end,
                detail: {
                    devtools: {
                        track: "\uD83D\uDEF8 reactUFO detailed timings",
                        color: 'secondary'
                    }
                }
            });
        } catch  {
        // do nothing
        }
    }
}
function $7390d9fffd2908eb$export$943a8b2b5d6b1809(type, name, labelStack, start, end = performance.now(), size = 0) {
    (0, $8aa9073f90761d26$export$cc97b17ef9aeb088).forEach((interaction)=>{
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
    });
    if ($7390d9fffd2908eb$var$isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} ${$7390d9fffd2908eb$var$labelStackToString(labelStack, name)} [${type}]`, {
            start: start,
            end: end,
            detail: {
                devtools: {
                    track: "\uD83D\uDEF8 reactUFO detailed timings",
                    color: 'secondary'
                }
            }
        });
    } catch  {
    // do nothing
    }
}
function $7390d9fffd2908eb$export$9e04fe1a58571ec(moduleId, timestamp) {
    $7390d9fffd2908eb$export$c4b23cc624bd2fb('bundle_preload', moduleId, null, timestamp);
}
function $7390d9fffd2908eb$export$6f228d1fdc911d7(identifier, start, end) {
    $7390d9fffd2908eb$export$943a8b2b5d6b1809('bundle_load', identifier, null, start, end - start);
}
const $7390d9fffd2908eb$var$moduleLoadingRequests = {};
function $7390d9fffd2908eb$export$f5a8f10de74904da(input) {
    let result = input ?? '';
    result = result.replace(/^\.\/src\/packages\//, '');
    result = result.replace(/^\.\/node_modules\//, '');
    result = result.replace(/(\/src)?\/(index|main)\.(tsx|ts|js|jsx)$/, '');
    return result;
}
function $7390d9fffd2908eb$var$addHoldCriterion(id, labelStack, name, startTime) {
    if (!window.__CRITERION__?.addUFOHold) return;
    window.__CRITERION__.addUFOHold(id, $7390d9fffd2908eb$var$labelStackToString(labelStack), name, startTime);
}
function $7390d9fffd2908eb$var$removeHoldCriterion(id) {
    if (!window.__CRITERION__?.removeUFOHold) return;
    window.__CRITERION__.removeUFOHold(id);
}
function $7390d9fffd2908eb$export$7606887303596f82(interactionId, labelStack, name, experimental) {
    const interaction = (0, $8aa9073f90761d26$export$cc97b17ef9aeb088).get(interactionId);
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const id = (0, $19dcc840d0563c39$exports.v4)();
    if (!interaction && (0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_ufo_enable_late_holds_post_interaction')) // add hold timestamp to post interaction log if interaction is complete
    $7390d9fffd2908eb$export$d8f52e8f804021e8.addHoldInfo(labelStack, name, performance.now());
    if (interaction != null) {
        const start = performance.now();
        const holdActive = {
            labelStack: labelStack,
            name: name,
            start: start
        };
        if ((0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_ufo_enable_ttai_with_3p')) {
            const is3pHold = labelStack.some((l)=>'type' in l && l.type === 'third-party');
            if (is3pHold) {
                if (!interaction.hold3pActive) interaction.hold3pActive = new Map();
                interaction.hold3pActive.set(id, {
                    ...holdActive,
                    start: start
                });
            } else {
                interaction.holdActive.set(id, {
                    ...holdActive,
                    start: start
                });
                $7390d9fffd2908eb$var$addHoldCriterion(id, labelStack, name, start);
            }
        } else {
            if ((0, $9a2f9fc0af024eb1$export$44487a86467333c3)()?.experimentalInteractionMetrics?.enabled && experimental) interaction.holdExpActive.set(id, {
                ...holdActive,
                start: start
            });
            if (!experimental) interaction.holdActive.set(id, {
                ...holdActive,
                start: start
            });
            $7390d9fffd2908eb$var$addHoldCriterion(id, labelStack, name, start);
        }
        return ()=>{
            const end = performance.now();
            if ($7390d9fffd2908eb$var$isPerformanceTracingEnabled()) try {
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${$7390d9fffd2908eb$var$labelStackToString(labelStack, name)} [hold]`, {
                    start: start,
                    end: end,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'secondary-light'
                        }
                    }
                });
            } catch  {
            // do nothing
            }
            $7390d9fffd2908eb$var$removeHoldCriterion(id);
            const currentInteraction = (0, $8aa9073f90761d26$export$cc97b17ef9aeb088).get(interactionId);
            const currentHold = interaction.holdActive.get(id);
            const expHold = interaction.holdExpActive.get(id);
            if (currentInteraction != null) {
                if (currentHold != null) {
                    currentInteraction.holdInfo.push({
                        ...currentHold,
                        end: end
                    });
                    interaction.holdActive.delete(id);
                }
                if (expHold != null) {
                    currentInteraction.holdExpInfo.push({
                        ...expHold,
                        end: end
                    });
                    interaction.holdExpActive.delete(id);
                }
                if ((0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_ufo_enable_ttai_with_3p')) {
                    if (interaction.hold3pActive) {
                        const current3pHold = interaction.hold3pActive.get(id);
                        if (current3pHold != null) {
                            if (!currentInteraction.hold3pInfo) currentInteraction.hold3pInfo = [];
                            currentInteraction.hold3pInfo.push({
                                ...current3pHold,
                                end: end
                            });
                            interaction.hold3pActive.delete(id);
                        }
                    }
                }
            }
        };
    }
    return ()=>{};
}
function $7390d9fffd2908eb$export$10582acd678c213(interactionId, labelStack, name, id, ignoreOnSubmit) {
    const interaction = (0, $8aa9073f90761d26$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) {
        const start = performance.now();
        if ((0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_ufo_enable_ttai_with_3p')) {
            const is3pHold = labelStack.some((l)=>'type' in l && l.type === 'third-party');
            if (is3pHold) {
                if (!interaction.hold3pActive) interaction.hold3pActive = new Map();
                interaction.hold3pActive.set(id, {
                    labelStack: labelStack,
                    name: name,
                    start: start,
                    ignoreOnSubmit: ignoreOnSubmit
                });
            } else {
                interaction.holdActive.set(id, {
                    labelStack: labelStack,
                    name: name,
                    start: start,
                    ignoreOnSubmit: ignoreOnSubmit
                });
                $7390d9fffd2908eb$var$addHoldCriterion(id, labelStack, name, start);
            }
        } else {
            interaction.holdActive.set(id, {
                labelStack: labelStack,
                name: name,
                start: start,
                ignoreOnSubmit: ignoreOnSubmit
            });
            $7390d9fffd2908eb$var$addHoldCriterion(id, labelStack, name, start);
        }
    }
    return ()=>{};
}
function $7390d9fffd2908eb$export$4983dfbbb996f7ae(interactionId, id) {
    const interaction = (0, $8aa9073f90761d26$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) {
        const end = performance.now();
        const currentInteraction = (0, $8aa9073f90761d26$export$cc97b17ef9aeb088).get(interactionId);
        const currentHold = interaction.holdActive.get(id);
        if (currentInteraction != null && currentHold != null) {
            currentInteraction.holdInfo.push({
                ...currentHold,
                end: end
            });
            interaction.holdActive.delete(id);
            $7390d9fffd2908eb$var$removeHoldCriterion(id);
        }
        if ((0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_ufo_enable_ttai_with_3p')) {
            if (interaction.hold3pActive) {
                const current3pHold = interaction.hold3pActive.get(id);
                if (currentInteraction != null && current3pHold != null) {
                    if (!currentInteraction.hold3pInfo) currentInteraction.hold3pInfo = [];
                    currentInteraction.hold3pInfo.push({
                        ...current3pHold,
                        end: end
                    });
                    interaction.hold3pActive.delete(id);
                }
            }
        }
    }
}
function $7390d9fffd2908eb$export$2df109852219d16e(interactionId) {
    const interaction = (0, $8aa9073f90761d26$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction) return interaction.type;
    return null;
}
const $7390d9fffd2908eb$export$9591b52b33ccc510 = {
    onPreload (moduleId, _priority) {
        $7390d9fffd2908eb$export$9e04fe1a58571ec($7390d9fffd2908eb$export$f5a8f10de74904da(moduleId), performance.now());
    },
    onLoadStart (info) {
        const timeoutId = setTimeout(()=>{
            delete $7390d9fffd2908eb$var$moduleLoadingRequests[info.identifier];
        }, 30000);
        const request = {
            start: performance.now(),
            timeoutId: timeoutId
        };
        $7390d9fffd2908eb$var$moduleLoadingRequests[info.identifier] = request;
    },
    onLoadComplete (info) {
        const request = $7390d9fffd2908eb$var$moduleLoadingRequests[info.identifier];
        if (request) {
            clearTimeout(request.timeoutId);
            delete $7390d9fffd2908eb$var$moduleLoadingRequests[info.identifier];
            $7390d9fffd2908eb$export$6f228d1fdc911d7($7390d9fffd2908eb$export$f5a8f10de74904da(info.identifier), request.start, performance.now());
        }
    },
    placeholderFallBackMounted (id, moduleId) {
        const interactionId = (0, $cb7ea7f0a3e09fe0$export$37bca3107733ac1e)();
        const currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $7390d9fffd2908eb$export$10582acd678c213(currentInteractionId, [], moduleId, id);
    },
    placeholderFallBackUnmounted (id) {
        const interactionId = (0, $cb7ea7f0a3e09fe0$export$37bca3107733ac1e)();
        const currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $7390d9fffd2908eb$export$4983dfbbb996f7ae(currentInteractionId, id);
    }
};
function $7390d9fffd2908eb$export$239c33984d9b1367(interactionId, name, labelStack, errorType, errorMessage, errorStack, forcedError, errorHash, errorStatusCode) {
    const interaction = (0, $8aa9073f90761d26$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) interaction.errors.push({
        name: name,
        labelStack: labelStack,
        errorType: errorType,
        errorMessage: errorMessage,
        errorStack: errorStack,
        forcedError: forcedError,
        errorHash: errorHash,
        errorStatusCode: errorStatusCode
    });
}
function $7390d9fffd2908eb$export$7379c15afd3840fa(name, labelStack, errorType, errorMessage, errorStack, errorHash, errorStatusCode) {
    (0, $8aa9073f90761d26$export$cc97b17ef9aeb088).forEach((interaction)=>{
        interaction.errors.push({
            name: name,
            labelStack: labelStack,
            errorType: errorType,
            errorMessage: errorMessage,
            errorStack: errorStack,
            errorHash: errorHash,
            errorStatusCode: errorStatusCode
        });
    });
}
function $7390d9fffd2908eb$export$53d6f611de951a13(interactionId, labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
    if ($7390d9fffd2908eb$var$isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} ${$7390d9fffd2908eb$var$labelStackToString(labelStack)} [react-profiler] ${type}`, {
            start: startTime,
            duration: actualDuration,
            detail: {
                devtools: {
                    track: "\uD83D\uDEF8 reactUFO detailed timings",
                    color: 'secondary-dark'
                }
            }
        });
    } catch  {
    // do nothing
    }
    const interaction = (0, $8aa9073f90761d26$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) interaction.reactProfilerTimings.push({
        labelStack: labelStack,
        type: type,
        actualDuration: actualDuration,
        baseDuration: baseDuration,
        startTime: startTime,
        commitTime: commitTime
    });
    else if ((0, $9a2f9fc0af024eb1$export$44487a86467333c3)()?.postInteractionLog?.enabled) $7390d9fffd2908eb$export$d8f52e8f804021e8.addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime);
}
function $7390d9fffd2908eb$var$pushToQueue(id, data) {
    $7390d9fffd2908eb$var$interactionQueue.push({
        id: id,
        data: data
    });
}
let $7390d9fffd2908eb$var$handleInteraction = $7390d9fffd2908eb$var$pushToQueue;
function $7390d9fffd2908eb$var$callCleanUpCallbacks(interaction) {
    interaction.cleanupCallbacks.reverse().forEach((cleanUpCallback)=>{
        cleanUpCallback();
    });
}
function $7390d9fffd2908eb$var$finishInteraction(id, data, endTime = performance.now()) {
    data.end = endTime;
    try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} [${data.type}] ${data.ufoName} [ttai]`, {
            start: data.start,
            end: data.end,
            detail: {
                devtools: {
                    track: 'main metrics',
                    trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                    color: 'tertiary'
                }
            }
        });
        performance.mark(`TTAI`, {
            startTime: data.end,
            detail: {
                devtools: {
                    dataType: 'marker'
                }
            }
        });
    } catch  {
    // do nothing
    }
    if (data.featureFlags) data.featureFlags.during = Object.fromEntries((0, $f721e733a5f9f3b0$export$2a5c8df26bb89760));
    (0, $9931f21957f7e3c2$export$17ab21d7be720b)();
    $7390d9fffd2908eb$var$callCleanUpCallbacks(data);
    if ((0, $9a2f9fc0af024eb1$export$44487a86467333c3)()?.vc?.stopVCAtInteractionFinish) {
        // Use per-interaction VC observer if available, otherwise fall back to global
        const observer = data.vcObserver;
        if (observer) data.vc = observer.getVCRawData();
    }
    if (data.type === 'page_load') data.hydration = (0, $9a2f9fc0af024eb1$export$2d8f8d64dc343d7b)();
    // By this time, stop the post interaction log observer if coinflip rate is 0
    const sanitisedUfoName = (0, $88d1559fd568da3e$export$e08487ea3ae92adb)(data.ufoName);
    if (!(0, $74d2fea471853068$export$2e2bcd8739ae039)((0, $9a2f9fc0af024eb1$export$1d459f020c06ae34)(sanitisedUfoName, data.type))) $7390d9fffd2908eb$export$d8f52e8f804021e8.stopVCObserver();
    if ((0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_ufo_enable_ttai_with_3p')) {
        const sanitisedUfoName = (0, $88d1559fd568da3e$export$e08487ea3ae92adb)(data.ufoName);
        if (!(0, $74d2fea471853068$export$2e2bcd8739ae039)((0, $9a2f9fc0af024eb1$export$203bd06a99c66a0d)(sanitisedUfoName, data.type))) $7390d9fffd2908eb$export$481f88116dc8b7ad.stopAll(id);
        else if (!data.hold3pActive || data.hold3pActive.size === 0) {
            if (!(0, $9a2f9fc0af024eb1$export$44487a86467333c3)()?.experimentalInteractionMetrics?.enabled) $7390d9fffd2908eb$export$cd7f480d6b8286c3(id);
        }
    } else if (!(0, $9a2f9fc0af024eb1$export$44487a86467333c3)()?.experimentalInteractionMetrics?.enabled) $7390d9fffd2908eb$export$cd7f480d6b8286c3(id);
    $7390d9fffd2908eb$var$PreviousInteractionLog.name = data.ufoName || 'unknown';
    $7390d9fffd2908eb$var$PreviousInteractionLog.isAborted = data.abortReason != null;
    if (data.ufoName) {
        if ((0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_ufo_enable_ttai_with_3p')) {
            if ($7390d9fffd2908eb$export$481f88116dc8b7ad.finishedInteraction?.id !== id) // If this same interaction was not already handled, handle it
            $7390d9fffd2908eb$var$handleInteraction(id, data);
        } else $7390d9fffd2908eb$var$handleInteraction(id, data);
    }
    if ($7390d9fffd2908eb$var$isPerformanceTracingEnabled()) {
        const profilerTimingMap = new Map();
        data.reactProfilerTimings.forEach((profilerTiming)=>{
            const labelStackId = $7390d9fffd2908eb$var$labelStackToIdString(profilerTiming.labelStack);
            if (labelStackId) {
                const timing = profilerTimingMap.get(labelStackId) ?? {
                    labelStack: profilerTiming.labelStack
                };
                timing.start = profilerTiming.startTime < (timing.start ?? Number.MAX_SAFE_INTEGER) ? profilerTiming.startTime : timing.start;
                timing.end = profilerTiming.commitTime > (timing.end ?? Number.MIN_SAFE_INTEGER) ? profilerTiming.commitTime : timing.end;
                profilerTimingMap.set(labelStackId, timing);
            }
        });
        try {
            // for Firefox 102 and older
            for (const [, { labelStack: labelStack, start: start, end: end }] of profilerTimingMap.entries())performance.measure(`\u{1F6F8} ${$7390d9fffd2908eb$var$labelStackToString(labelStack)} [segment_ttai]`, {
                start: start,
                end: end,
                detail: {
                    devtools: {
                        track: "\uD83D\uDEF8 reactUFO detailed timings",
                        color: 'secondary-dark'
                    }
                }
            });
        } catch  {
        // do nothing
        }
    }
    try {
        // dispatch a global window event to notify the measure is completed
        window.dispatchEvent(new CustomEvent('UFO_FINISH_INTERACTION', {
            detail: data
        }));
    } catch  {
    // do nothing
    }
}
function $7390d9fffd2908eb$export$9e614a29a1ac213e(sinkFn) {
    if ($7390d9fffd2908eb$var$handleInteraction === $7390d9fffd2908eb$var$pushToQueue) {
        $7390d9fffd2908eb$var$handleInteraction = sinkFn;
        $7390d9fffd2908eb$var$interactionQueue.forEach((interaction)=>{
            sinkFn(interaction.id, interaction.data);
        });
        $7390d9fffd2908eb$var$interactionQueue.length = 0;
    }
}
function $7390d9fffd2908eb$export$8a1ba7bef607358a(sinkFn) {
    $7390d9fffd2908eb$export$d8f52e8f804021e8.sinkHandler(sinkFn);
}
// a flag to prevent multiple submitting
let $7390d9fffd2908eb$var$activeSubmitted = false;
function $7390d9fffd2908eb$export$673be905888f8839(interactionId, endTime) {
    const interaction = (0, $8aa9073f90761d26$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) {
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const noMoreExpHolds = interaction.holdExpActive.size === 0;
        const shouldUseRawDataThirdParty = (0, $9a2f9fc0af024eb1$export$9c69f5a724f05f38)(interaction.ufoName, interaction.type);
        const postInteraction = async ()=>{
            if ((0, $9a2f9fc0af024eb1$export$44487a86467333c3)()?.postInteractionLog?.enabled) {
                let experimentalVC90;
                let experimentalTTAI;
                if ((0, $9a2f9fc0af024eb1$export$44487a86467333c3)()?.experimentalInteractionMetrics?.enabled) {
                    experimentalVC90 = (await (0, $c8b9aea0e525bbc2$export$d17d2b5c5e8d732e)(interaction))?.['metric:experimental:vc90'];
                    const { start: start, end: end } = interaction;
                    experimentalTTAI = !interaction.abortReason ? Math.round(end - start) : undefined;
                }
                $7390d9fffd2908eb$export$d8f52e8f804021e8.onInteractionComplete({
                    ...interaction,
                    experimentalTTAI: experimentalTTAI,
                    experimentalVC90: experimentalVC90
                });
            }
            if ((0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_ufo_enable_ttai_with_3p')) {
                if ($7390d9fffd2908eb$export$481f88116dc8b7ad.finishedInteraction?.id !== interactionId) // If interactionExtraMetrics is not waiting for measuring this interaction
                {
                    if ((0, $9a2f9fc0af024eb1$export$44487a86467333c3)()?.experimentalInteractionMetrics?.enabled) $7390d9fffd2908eb$export$cd7f480d6b8286c3(interactionId);
                }
            } else if ((0, $9a2f9fc0af024eb1$export$44487a86467333c3)()?.experimentalInteractionMetrics?.enabled) $7390d9fffd2908eb$export$cd7f480d6b8286c3(interactionId);
            $7390d9fffd2908eb$var$activeSubmitted = false;
        };
        if ((0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_ufo_enable_ttai_with_3p')) {
            const noMoreActive3pHolds = interaction.hold3pActive?.size === 0 || interaction.hold3pActive === undefined;
            // If using raw data third party behavior, wait for 3p holds to clear
            if (shouldUseRawDataThirdParty) {
                // If there are no non-3p holds active, mark the interaction as successful
                // but don't finish until 3p holds are cleared
                if (noMoreActiveHolds && !noMoreActive3pHolds) {
                    // Mark interaction as successful by setting endTime, but don't finish yet
                    if (endTime !== undefined && interaction.end === 0) interaction.end = endTime;
                    // Wait for 3p holds to clear before finishing
                    return;
                }
                // If all holds (including 3p) are cleared, finish the interaction
                if (noMoreActiveHolds && noMoreActive3pHolds) {
                    if (!$7390d9fffd2908eb$var$activeSubmitted) {
                        // Set end3p to current time when 3p holds cleared, but ensure it's at least interaction.end
                        const currentTime = endTime ?? performance.now();
                        interaction.end3p = interaction.end !== 0 && currentTime < interaction.end ? interaction.end : currentTime;
                        $7390d9fffd2908eb$var$finishInteraction(interactionId, interaction, interaction.end !== 0 ? interaction.end : endTime);
                        if ((0, $9a2f9fc0af024eb1$export$44487a86467333c3)()?.extraInteractionMetrics?.enabled) $7390d9fffd2908eb$export$481f88116dc8b7ad.updateFinishedInteraction(interaction);
                        if ((0, $9a2f9fc0af024eb1$export$44487a86467333c3)()?.extraSearchPageInteraction?.enabled && interaction.ufoName === (0, $9a2f9fc0af024eb1$export$44487a86467333c3)()?.extraSearchPageInteraction?.searchPageMetricName) (0, $54b22d01bb2a4309$export$74b9ce7e9d206a8)(interactionId, interaction);
                        $7390d9fffd2908eb$var$activeSubmitted = true;
                    }
                    if (noMoreExpHolds) {
                        if ((0, $9a2f9fc0af024eb1$export$44487a86467333c3)()?.experimentalInteractionMetrics?.enabled) (0, $c8b9aea0e525bbc2$export$1aed449484dedf63)(interactionId, interaction, endTime || interaction.end);
                        postInteraction();
                    }
                }
                // Send separated third-party event even when feature flag is active
                if (noMoreActiveHolds && noMoreActive3pHolds) {
                    const data = {
                        ...interaction,
                        end: endTime || interaction.end
                    };
                    $7390d9fffd2908eb$export$481f88116dc8b7ad.onInteractionComplete(interactionId, data);
                }
            } else {
                // Original behavior when feature flag is not active
                if (noMoreActiveHolds && $7390d9fffd2908eb$export$481f88116dc8b7ad.finishedInteraction?.id !== interactionId) {
                    // If it's not waiting for extra metrics to complete, finish the interaction as normal
                    if (!$7390d9fffd2908eb$var$activeSubmitted) {
                        $7390d9fffd2908eb$var$finishInteraction(interactionId, interaction, endTime);
                        if ((0, $9a2f9fc0af024eb1$export$44487a86467333c3)()?.extraInteractionMetrics?.enabled) $7390d9fffd2908eb$export$481f88116dc8b7ad.updateFinishedInteraction(interaction);
                        if ((0, $9a2f9fc0af024eb1$export$44487a86467333c3)()?.extraSearchPageInteraction?.enabled && interaction.ufoName === (0, $9a2f9fc0af024eb1$export$44487a86467333c3)()?.extraSearchPageInteraction?.searchPageMetricName) (0, $54b22d01bb2a4309$export$74b9ce7e9d206a8)(interactionId, interaction);
                        $7390d9fffd2908eb$var$activeSubmitted = true;
                    }
                    if (noMoreExpHolds) {
                        if ((0, $9a2f9fc0af024eb1$export$44487a86467333c3)()?.experimentalInteractionMetrics?.enabled) (0, $c8b9aea0e525bbc2$export$1aed449484dedf63)(interactionId, interaction, endTime);
                        postInteraction();
                    }
                }
                if (noMoreActiveHolds && noMoreActive3pHolds) {
                    const data = {
                        ...interaction,
                        end: endTime
                    };
                    $7390d9fffd2908eb$export$481f88116dc8b7ad.onInteractionComplete(interactionId, data);
                }
            }
        } else if (noMoreActiveHolds) {
            if (!$7390d9fffd2908eb$var$activeSubmitted) {
                $7390d9fffd2908eb$var$finishInteraction(interactionId, interaction, endTime);
                if ((0, $9a2f9fc0af024eb1$export$44487a86467333c3)()?.extraSearchPageInteraction?.enabled && interaction.ufoName === (0, $9a2f9fc0af024eb1$export$44487a86467333c3)()?.extraSearchPageInteraction?.searchPageMetricName) (0, $54b22d01bb2a4309$export$74b9ce7e9d206a8)(interactionId, interaction);
                $7390d9fffd2908eb$var$activeSubmitted = true;
            }
            if (noMoreExpHolds) {
                if ((0, $9a2f9fc0af024eb1$export$44487a86467333c3)()?.experimentalInteractionMetrics?.enabled) (0, $c8b9aea0e525bbc2$export$1aed449484dedf63)(interactionId, interaction, endTime);
                postInteraction();
            }
        }
    }
}
function $7390d9fffd2908eb$var$callCancelCallbacks(interaction) {
    interaction.cancelCallbacks.reverse().forEach((cancelCallback)=>{
        cancelCallback();
    });
}
function $7390d9fffd2908eb$export$5def58af4fd46132(interactionId, abortReason) {
    const interaction = (0, $8aa9073f90761d26$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) {
        const shouldUseRawDataThirdParty = (0, $9a2f9fc0af024eb1$export$9c69f5a724f05f38)(interaction.ufoName, interaction.type);
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const has3pHoldsActive = interaction.hold3pActive && interaction.hold3pActive.size > 0;
        // If only third-party holds are active, finish as successful instead of aborting
        if (shouldUseRawDataThirdParty && noMoreActiveHolds && has3pHoldsActive) {
            const endTime = interaction.end !== 0 ? interaction.end : performance.now();
            interaction.end3p = performance.now();
            $7390d9fffd2908eb$var$finishInteraction(interactionId, interaction, endTime);
            $7390d9fffd2908eb$export$d8f52e8f804021e8.reset();
            $7390d9fffd2908eb$export$d8f52e8f804021e8.stopVCObserver();
            if ((0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_ufo_enable_ttai_with_3p')) $7390d9fffd2908eb$export$481f88116dc8b7ad.stopAll(interactionId);
            if ((0, $74d2fea471853068$export$2e2bcd8739ae039)((0, $9a2f9fc0af024eb1$export$563f73272328c0d)(interaction.ufoName, interaction.type))) {
                (0, $c8b9aea0e525bbc2$export$1aed449484dedf63)(interactionId, interaction, endTime);
                $7390d9fffd2908eb$export$cd7f480d6b8286c3(interactionId);
            }
            return;
        }
        $7390d9fffd2908eb$var$callCancelCallbacks(interaction);
        interaction.abortReason = abortReason;
        $7390d9fffd2908eb$var$finishInteraction(interactionId, interaction);
        $7390d9fffd2908eb$export$d8f52e8f804021e8.reset();
        $7390d9fffd2908eb$export$d8f52e8f804021e8.stopVCObserver();
        if ((0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_ufo_enable_ttai_with_3p')) $7390d9fffd2908eb$export$481f88116dc8b7ad.stopAll(interactionId);
        if ((0, $74d2fea471853068$export$2e2bcd8739ae039)((0, $9a2f9fc0af024eb1$export$563f73272328c0d)(interaction.ufoName, interaction.type))) {
            (0, $c8b9aea0e525bbc2$export$1aed449484dedf63)(interactionId, interaction);
            $7390d9fffd2908eb$export$cd7f480d6b8286c3(interactionId);
        }
    }
}
function $7390d9fffd2908eb$export$c4a545284f55edf2(interactionId, interactionName) {
    const interaction = (0, $8aa9073f90761d26$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) {
        const shouldUseRawDataThirdParty = (0, $9a2f9fc0af024eb1$export$9c69f5a724f05f38)(interaction.ufoName, interaction.type);
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const has3pHoldsActive = interaction.hold3pActive && interaction.hold3pActive.size > 0;
        // If only third-party holds are active, finish as successful instead of aborting
        if (shouldUseRawDataThirdParty && noMoreActiveHolds && has3pHoldsActive) {
            const endTime = interaction.end !== 0 ? interaction.end : performance.now();
            // Set end3p to current time, but ensure it's at least interaction.end
            interaction.end3p = performance.now();
            $7390d9fffd2908eb$var$finishInteraction(interactionId, interaction, endTime);
            $7390d9fffd2908eb$export$d8f52e8f804021e8.reset();
            $7390d9fffd2908eb$export$d8f52e8f804021e8.stopVCObserver();
            if ((0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_ufo_enable_ttai_with_3p')) $7390d9fffd2908eb$export$481f88116dc8b7ad.stopAll(interactionId);
            if ((0, $74d2fea471853068$export$2e2bcd8739ae039)((0, $9a2f9fc0af024eb1$export$563f73272328c0d)(interaction.ufoName, interaction.type))) {
                (0, $c8b9aea0e525bbc2$export$1aed449484dedf63)(interactionId, interaction, endTime);
                $7390d9fffd2908eb$export$cd7f480d6b8286c3(interactionId);
            }
            return;
        }
        $7390d9fffd2908eb$var$callCancelCallbacks(interaction);
        interaction.abortReason = 'new_interaction';
        interaction.abortedByInteractionName = interactionName;
        $7390d9fffd2908eb$var$finishInteraction(interactionId, interaction);
        $7390d9fffd2908eb$export$d8f52e8f804021e8.reset();
        $7390d9fffd2908eb$export$d8f52e8f804021e8.stopVCObserver();
        if ((0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_ufo_enable_ttai_with_3p')) $7390d9fffd2908eb$export$481f88116dc8b7ad.stopAll(interactionId);
        if ((0, $74d2fea471853068$export$2e2bcd8739ae039)((0, $9a2f9fc0af024eb1$export$563f73272328c0d)(interaction.ufoName, interaction.type))) {
            (0, $c8b9aea0e525bbc2$export$1aed449484dedf63)(interactionId, interaction);
            $7390d9fffd2908eb$export$cd7f480d6b8286c3(interactionId);
        }
    }
}
function $7390d9fffd2908eb$export$614a7af2affc5dff(abortReason, abortedByInteractionName) {
    const activeInteraction = $7390d9fffd2908eb$export$2b3954d2e8509985();
    const finishInteractions = (0, $9a2f9fc0af024eb1$export$20e8108b8ccdd0bd)();
    (0, $8aa9073f90761d26$export$cc97b17ef9aeb088).forEach((interaction, interactionId)=>{
        const isActiveInteraction = activeInteraction === interaction;
        let hasFinished = interaction.holdActive.size === 0;
        if (isActiveInteraction && abortReason === 'transition' && interaction.type === 'press' && finishInteractions?.includes(interaction.ufoName) && (0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_ufo_enable_finish_interaction_transition')) hasFinished = true;
        const shouldUseRawDataThirdParty = (0, $9a2f9fc0af024eb1$export$9c69f5a724f05f38)(interaction.ufoName, interaction.type);
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const has3pHoldsActive = interaction.hold3pActive && interaction.hold3pActive.size > 0;
        // If only third-party holds are active, finish as successful instead of aborting
        if (shouldUseRawDataThirdParty && noMoreActiveHolds && has3pHoldsActive) {
            const endTime = interaction.end !== 0 ? interaction.end : performance.now();
            interaction.end3p = performance.now();
            $7390d9fffd2908eb$var$finishInteraction(interactionId, interaction, endTime);
            $7390d9fffd2908eb$export$d8f52e8f804021e8.reset();
            $7390d9fffd2908eb$export$d8f52e8f804021e8.stopVCObserver();
            if ((0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_ufo_enable_ttai_with_3p')) $7390d9fffd2908eb$export$481f88116dc8b7ad.stopAll(interactionId);
            if ((0, $74d2fea471853068$export$2e2bcd8739ae039)((0, $9a2f9fc0af024eb1$export$563f73272328c0d)(interaction.ufoName, interaction.type))) {
                (0, $c8b9aea0e525bbc2$export$1aed449484dedf63)(interactionId, interaction, endTime);
                $7390d9fffd2908eb$export$cd7f480d6b8286c3(interactionId);
            }
            return;
        }
        if (!hasFinished) {
            $7390d9fffd2908eb$var$callCancelCallbacks(interaction);
            interaction.abortReason = abortReason;
            if (abortedByInteractionName != null) interaction.abortedByInteractionName = abortedByInteractionName;
        }
        $7390d9fffd2908eb$var$finishInteraction(interactionId, interaction);
        $7390d9fffd2908eb$export$d8f52e8f804021e8.reset();
        $7390d9fffd2908eb$export$d8f52e8f804021e8.stopVCObserver();
        if ((0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_ufo_enable_ttai_with_3p')) $7390d9fffd2908eb$export$481f88116dc8b7ad.stopAll(interactionId);
        if ((0, $74d2fea471853068$export$2e2bcd8739ae039)((0, $9a2f9fc0af024eb1$export$563f73272328c0d)(interaction.ufoName, interaction.type))) {
            (0, $c8b9aea0e525bbc2$export$1aed449484dedf63)(interactionId, interaction);
            $7390d9fffd2908eb$export$cd7f480d6b8286c3(interactionId);
        }
    });
}
function $7390d9fffd2908eb$export$7b9261a96cfe427b(id, cancelCallback) {
    const interaction = (0, $8aa9073f90761d26$export$cc97b17ef9aeb088).get(id);
    interaction?.cancelCallbacks.push(cancelCallback);
}
function $7390d9fffd2908eb$export$1a1ed1e1fdb2006b(interactionId, ufoName, type, startTime, rate, labelStack, routeName, trace = null) {
    $7390d9fffd2908eb$export$481f88116dc8b7ad.reset();
    $7390d9fffd2908eb$export$d8f52e8f804021e8.reset();
    let vcObserver;
    let previousTime = startTime;
    let timeoutTime = (0, $9a2f9fc0af024eb1$export$c681731847989445)(ufoName);
    const timerID = setTimeout(()=>{
        $7390d9fffd2908eb$export$5def58af4fd46132(interactionId, 'timeout');
    }, timeoutTime);
    function changeTimeout(newTime) {
        // we compare if the time left is lower than the new time to no
        // extend the timeout beyond the initial waiting time
        const currentTime = performance.now();
        const timeLeft = timeoutTime - (currentTime - previousTime);
        if (timeLeft < newTime) return;
        clearTimeout(this.timerID);
        const newTimerID = setTimeout(()=>{
            $7390d9fffd2908eb$export$5def58af4fd46132(interactionId, 'timeout');
        }, newTime);
        timeoutTime = newTime;
        previousTime = currentTime;
        this.timerID = newTimerID;
    }
    const addFeatureFlagsToInteraction = (0, $74d2fea471853068$export$2e2bcd8739ae039)((0, $9a2f9fc0af024eb1$export$29b9ffb14861a1d)('feature_flag_access'));
    const config = (0, $9a2f9fc0af024eb1$export$44487a86467333c3)();
    if (config && config.vc) {
        const vcOptions = {
            heatmapSize: config.vc.heatmapSize,
            oldDomUpdates: config.vc.oldDomUpdates,
            devToolsEnabled: config.vc.devToolsEnabled,
            selectorConfig: config.vc.selectorConfig,
            ssrEnablePageLayoutPlaceholder: config.vc.ssrEnablePageLayoutPlaceholder
        };
        vcObserver = (0, $d817c7e4439fbe2c$export$c69731bddfc24d85)(vcOptions);
    }
    const priorAccessedFg = type === 'press' && (0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_ufo_drop_prior_fg_interactions') ? {} : Object.fromEntries((0, $f721e733a5f9f3b0$export$5b78c989c8db2561));
    const metrics = {
        id: interactionId,
        start: startTime,
        end: 0,
        ufoName: ufoName,
        type: type,
        previousInteractionName: $7390d9fffd2908eb$var$PreviousInteractionLog.name,
        isPreviousInteractionAborted: $7390d9fffd2908eb$var$PreviousInteractionLog.isAborted === true,
        marks: [],
        customData: [],
        cohortingCustomData: new Map(),
        customTimings: [],
        spans: [],
        requestInfo: [],
        reactProfilerTimings: [],
        holdInfo: [],
        holdExpInfo: [],
        holdActive: new Map(),
        holdExpActive: new Map(),
        // measure when we execute this code
        // from this, we can measure the input delay -
        // how long the browser took to hand execution back to JS)
        measureStart: performance.now(),
        rate: rate,
        cancelCallbacks: [],
        metaData: {},
        errors: [],
        apdex: [],
        labelStack: labelStack,
        routeName: routeName ?? ufoName,
        featureFlags: addFeatureFlagsToInteraction ? {
            prior: priorAccessedFg,
            during: {}
        } : undefined,
        knownSegments: [],
        cleanupCallbacks: [],
        awaitReactProfilerCount: 0,
        redirects: [],
        timerID: timerID,
        changeTimeout: changeTimeout,
        trace: trace,
        vcObserver: vcObserver,
        hold3pActive: new Map(),
        hold3pInfo: [],
        minorInteractions: []
    };
    if (addFeatureFlagsToInteraction) (0, $f721e733a5f9f3b0$export$2a5c8df26bb89760).clear();
    (0, $8aa9073f90761d26$export$cc97b17ef9aeb088).set(interactionId, metrics);
    const segmentObserver = {
        onAdd (segment) {
            metrics.knownSegments.push(segment);
        },
        onRemove () {}
    };
    $7390d9fffd2908eb$var$addSegmentObserver(segmentObserver);
    metrics.cleanupCallbacks.push(()=>{
        $7390d9fffd2908eb$var$removeSegmentObserver(segmentObserver);
    });
    metrics.cleanupCallbacks.push(()=>{
        clearTimeout(metrics.timerID);
    });
    // Add cleanup for per-interaction VC observer
    if (vcObserver) metrics.cleanupCallbacks.push(()=>{
        vcObserver.stop(ufoName);
    });
    const awaitBM3TTIList = (0, $9a2f9fc0af024eb1$export$2d311b3fd18dcab1)();
    if (awaitBM3TTIList.includes(ufoName)) $7390d9fffd2908eb$export$10582acd678c213(interactionId, [], ufoName, ufoName, true);
    if (type === 'transition' || type === 'page_load') {
        // Use per-interaction VC observer if available, otherwise fall back to global
        const observer = vcObserver;
        if (observer) observer.start({
            startTime: startTime,
            experienceKey: ufoName
        });
        // Start post interaction observer for all if config is enabled
        // in case ufoName is updated at later time
        if ((0, $9a2f9fc0af024eb1$export$44487a86467333c3)()?.postInteractionLog?.enabled) $7390d9fffd2908eb$export$d8f52e8f804021e8.startVCObserver({
            startTime: startTime
        });
        if ((0, $74d2fea471853068$export$2e2bcd8739ae039)((0, $9a2f9fc0af024eb1$export$563f73272328c0d)(ufoName, type))) (0, $c8b9aea0e525bbc2$export$81b28dca2587ec47).start({
            startTime: startTime
        });
        if (config?.extraInteractionMetrics?.enabled && (0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_ufo_enable_ttai_with_3p')) $7390d9fffd2908eb$export$481f88116dc8b7ad.startVCObserver({
            startTime: startTime
        }, interactionId);
    }
    if (type === 'press') {
        // Use per-interaction VC observer if available, otherwise fall back to global
        const observer = vcObserver;
        if (observer) observer.start({
            startTime: startTime,
            experienceKey: ufoName
        });
    }
}
function $7390d9fffd2908eb$export$4a759336b50e86e3(event) {
    const interaction = $7390d9fffd2908eb$export$2b3954d2e8509985();
    if (interaction) {
        interaction.legacyMetrics = interaction.legacyMetrics || [];
        interaction.legacyMetrics.push(event);
        if ((interaction.type === 'page_load' || interaction.type === 'transition') && event.config?.type === 'PAGE_LOAD') $7390d9fffd2908eb$export$4983dfbbb996f7ae(interaction.id, interaction.ufoName);
    }
}
function $7390d9fffd2908eb$export$ad216cc25852d44b(apdex) {
    (0, $8aa9073f90761d26$export$cc97b17ef9aeb088).forEach((interaction, key)=>{
        interaction.apdex.push(apdex);
        try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${apdex.key} [bm3_tti]`, {
                start: apdex.startTime ?? interaction.start,
                end: apdex.stopTime,
                detail: {
                    devtools: {
                        track: 'main metrics',
                        trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                        color: 'primary-dark'
                    }
                }
            });
            performance.mark(`[bm3] TTI`, {
                startTime: apdex.stopTime,
                detail: {
                    devtools: {
                        dataType: 'marker'
                    }
                }
            });
        } catch  {
        // do nothing
        }
        if (interaction.type === 'page_load' || interaction.type === 'transition') $7390d9fffd2908eb$export$4983dfbbb996f7ae(key, interaction.ufoName);
    });
}
function $7390d9fffd2908eb$export$35220fd6cdd1b731(interactionId, apdexInfo) {
    const interaction = (0, $8aa9073f90761d26$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) {
        interaction.apdex.push(apdexInfo);
        try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${apdexInfo.key} [bm3_tti]`, {
                start: apdexInfo.startTime ?? interaction.start,
                end: apdexInfo.stopTime,
                detail: {
                    devtools: {
                        track: 'main metrics',
                        trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                        color: 'primary-dark'
                    }
                }
            });
            performance.mark(`[bm3] TTI`, {
                startTime: apdexInfo.stopTime,
                detail: {
                    devtools: {
                        dataType: 'marker'
                    }
                }
            });
        } catch  {
        // do nothing
        }
        if (interaction.type === 'page_load' || interaction.type === 'transition') $7390d9fffd2908eb$export$4983dfbbb996f7ae(interactionId, interaction.ufoName);
    }
}
function $7390d9fffd2908eb$export$57d55b4569823d8f(interactionId, labelStack, requestInfo) {
    const interaction = (0, $8aa9073f90761d26$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) interaction.requestInfo.push({
        labelStack: labelStack,
        ...requestInfo
    });
}
function $7390d9fffd2908eb$var$isSegmentLabel(obj) {
    return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
}
function $7390d9fffd2908eb$var$getSegmentCacheKey(labelStack) {
    return labelStack.map((l)=>{
        if ($7390d9fffd2908eb$var$isSegmentLabel(l)) return `${l.name}_${l.segmentId}`;
        return l.name;
    }).join('|');
}
function $7390d9fffd2908eb$export$1c43f9ac826b6462(labelStack) {
    const key = $7390d9fffd2908eb$var$getSegmentCacheKey(labelStack);
    const existingSegment = $7390d9fffd2908eb$var$segmentCache.get(key);
    if (!existingSegment) {
        const segmentInfo = {
            labelStack: labelStack
        };
        $7390d9fffd2908eb$var$segmentCache.set(key, segmentInfo);
        $7390d9fffd2908eb$var$segmentObservers.forEach((observer)=>{
            observer.onAdd(segmentInfo);
        });
    }
}
function $7390d9fffd2908eb$export$d0365e48b58231c3(labelStack) {
    const key = $7390d9fffd2908eb$var$getSegmentCacheKey(labelStack);
    const segmentInfo = $7390d9fffd2908eb$var$segmentCache.get(key);
    if (segmentInfo) {
        $7390d9fffd2908eb$var$segmentCache.delete(JSON.stringify(labelStack));
        if ((0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_ufo_segment_unmount_count')) {
            const cacheKey = (0, $88d1559fd568da3e$export$caeee352b541de1f)(labelStack);
            $7390d9fffd2908eb$export$a2b14406ded37d60.set(cacheKey, ($7390d9fffd2908eb$export$a2b14406ded37d60.get(cacheKey) || 0) + 1);
        }
        $7390d9fffd2908eb$var$segmentObservers.forEach((observer)=>{
            observer.onRemove(segmentInfo);
        });
    }
}
function $7390d9fffd2908eb$export$bbf14d79614d9818(interactionId, fromUfoName, nextUfoName, nextRouteName, time) {
    const interaction = (0, $8aa9073f90761d26$export$cc97b17ef9aeb088).get(interactionId);
    if (interaction != null) {
        interaction.ufoName = nextUfoName;
        interaction.routeName = nextRouteName;
        interaction.redirects.push({
            fromInteractionName: fromUfoName,
            time: time
        });
        if ($7390d9fffd2908eb$var$isPerformanceTracingEnabled()) {
            const prevRedirect = interaction.redirects.at(-2);
            try {
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${nextUfoName} [redirect]`, {
                    start: prevRedirect?.time ?? interaction.start,
                    end: time,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'tertiary'
                        }
                    }
                });
            } catch  {
            // do nothing
            }
        }
    }
}
const $7390d9fffd2908eb$export$6ce04c7ca6810a7e = [];
const $7390d9fffd2908eb$var$defaultLabelStack = [
    {
        name: 'custom'
    }
];
function $7390d9fffd2908eb$export$5342dcad19138a1c(name, start, end = performance.now(), size = 0, labelStack = $7390d9fffd2908eb$var$defaultLabelStack) {
    const customSpan = {
        type: 'custom',
        name: name,
        start: start,
        end: end,
        labelStack: labelStack,
        size: size
    };
    $7390d9fffd2908eb$export$6ce04c7ca6810a7e.push(customSpan);
}









var $8V6O9 = parcelRequire("8V6O9");




const $bafd16c1172e5624$var$cloudFrontRegex = /(https?):\/\/[a-z0-9]+\.cloudfront\.net\//g;
const $bafd16c1172e5624$var$cloudFrontS3Regex = /(https?):\/\/[a-z0-9]+\.cloudfront\.net\/download\//g;
// Used to match web resource URLs like this:
//   .../wiki/s/99914b932bd37a50b983c5e7c90ae93b-CDN/-1510873586/6452/236c4aa50522e3b557db968ff45d01d44604ffe1/1000.0.53/_/download/...
//   .../wiki/s/d41d8cd98f00b204e9800998ecf8427e-CDN/-783152381/h/2ddebfb80ae902fe7ab6e15441fe94e2/_/download/batch/...
//   .../wiki/s/d065fee603fdcf75115204ec65310e1c-CDN/-1510873586/6452/236c4aa50522e3b557db968ff45d01d44604ffe1/11d5083bb8bb9dac4c3a5987eeac4b5b/_/download/contextbatch/...
//   .../wiki/s/1283600969/6452/571d5459a4fbf60c255c41bb4e0d3ef3b8022627/_/download/resources/...
const $bafd16c1172e5624$var$wrmResourceRegex = /s\/[^_]+_\/download\//g;
/**
 * For values which represent a stringified JSON, tries to extract the `"message"`
 * property and returns it if found. Returned result defaults to input value.
 */ function $bafd16c1172e5624$var$tryExtractMessage(value) {
    try {
        const parsedValue = JSON.parse(value);
        return parsedValue.message || value;
    } catch (_) {
        return value;
    }
}
// Turns the culprit URL into .../wiki/download/... to remove the hash information.
function $bafd16c1172e5624$var$stripHashAndCDNHost(url) {
    return url.match($bafd16c1172e5624$var$wrmResourceRegex) ? url.replace($bafd16c1172e5624$var$wrmResourceRegex, 'download/').replace($bafd16c1172e5624$var$cloudFrontRegex, '$1://') : url;
}
function $bafd16c1172e5624$var$getErrorFingerprint(error) {
    // See docs at https://docs.sentry.io/platforms/javascript/data-management/event-grouping/sdk-fingerprinting/
    const DEFAULT_FINGERPRINT = '{{ default }}';
    if (error.message.startsWith('Quota exceeded on key') || error.message.startsWith('QuotaExceededError')) return [
        'storage-quota-error'
    ];
    if (error.message.startsWith('Maximum call stack size exceeded') || error.message.startsWith('too much recursion')) // Most (if not all) of these errors originate from editor/prosemirror, and they
    // are hard to troubleshoot. So, although they all might represent a
    // different error, we're bundling them together
    return [
        'maximum-call-stack'
    ];
    if (error.message.startsWith('Invalid position')) // These errors originate from editor/prosemirror. The rest of the message
    // is the position number itself, and Sentry seldom groups those together.
    // By giving them all the same fingerprint, we're forcing Sentry to treat all
    // of those as the occurrence of one and the same error.
    return [
        'invalid-position'
    ];
    if (error.message.match(/Loading chunk .+? failed/)) // These are webpack chunk load errors, which often have very different stack traces.
    // We're grouping them together.
    return [
        'chunk-load-error'
    ];
    if (error.message.startsWith('Error creating blueprint content:')) // Grouping those by message should work better than looking at the stack trace
    return [
        'blueprint-creation-error',
        error.message.substr(0, 100)
    ];
    if (error.message.startsWith('Error from synchrony plugin')) // These are hard to troubleshoot, so to reduce noise we group them together
    return [
        'error-from-synchrony-plugin'
    ];
    if (error.message.includes('Error fetching data from identity - Error has been logged with execution ID:')) // The "execution ID" part in these errors is always different.
    return [
        'identity-fetching-error'
    ];
    if (error.message.includes('java.net.SocketTimeoutException')) return [
        'socket-timeout'
    ];
    if (error instanceof URIError) // This will group all URI errors together, as they often have different stack traces
    return [
        'malformed-uri-error'
    ];
    if (error instanceof (0, $b1c79be305194522$export$e704fce35c66bf42) && error.route) // These errors tend to produce unpredictable messages which are hard to group.
    // So, instead of grouping by message, we'll group them by `route` and status code (which should be more predictable)
    return [
        `rest-api-${error.route}-${error.statusCode}`
    ];
    const logSafeAttributes = (0, $8a3a8685062675cc$export$d08bac32cb78075f)(error);
    if (logSafeAttributes.failedSlaExperience) {
        if (logSafeAttributes.operationName || logSafeAttributes.statusCode) // This code branch is for GraphQL/REST failures which result in experience failures.
        // Since the same backend errors can be thrown for different operations/endpoints,
        // we're applying a per-message grouping.
        // Also, we're **not** including default fingerprint here.
        return [
            `experience-${logSafeAttributes.failedSlaExperience}`,
            $bafd16c1172e5624$var$tryExtractMessage(error.message).substr(0, 100)
        ];
        else // this way SLA-affecting errors shouldn't be bundled with other types of errors
        return [
            DEFAULT_FINGERPRINT,
            `experience-${logSafeAttributes.failedSlaExperience}`
        ];
    }
    return undefined;
}
const $bafd16c1172e5624$var$dataTransformer = function(data, hint) {
    let fromWRM = false;
    let fromS3 = false;
    if (data.exception?.values) // Go through the stack trace and sanitize all the exception URLs.
    data.exception.values = data.exception.values.map((exception)=>{
        if (exception.stacktrace && exception.stacktrace.frames) exception.stacktrace.frames = exception.stacktrace.frames.map((frame)=>{
            if (frame.filename) {
                fromWRM = Boolean(frame.filename.match($bafd16c1172e5624$var$wrmResourceRegex));
                fromS3 = Boolean(frame.filename.match($bafd16c1172e5624$var$cloudFrontS3Regex));
                frame.filename = $bafd16c1172e5624$var$stripHashAndCDNHost(frame.filename);
            }
            return frame;
        });
        return exception;
    });
    if (typeof hint?.originalException === 'object' && hint?.originalException !== null) {
        data.fingerprint = $bafd16c1172e5624$var$getErrorFingerprint(hint.originalException);
        const { componentStack: _1, // this field is very big
        failedSlaExperience: _2, // this one is included as tag
        ...rest } = (0, $8a3a8685062675cc$export$d08bac32cb78075f)(hint.originalException);
        data.extra = {
            ...data.extra,
            ...rest
        };
    }
    if (fromWRM) data.logger = 'wrm';
    else if (fromS3) data.logger = 'react';
    else data.logger = 'javascript';
    // strip out url and breadcrumbs which include customer sensitive data
    if (data.request) delete data.request.url;
    delete data.breadcrumbs;
    data.transaction = ''; // transactions can have URLs in them, too
    return data;
};
// Structure: https://<PUBLIC_KEY>@o55978.ingest.sentry.io/<PROJECT_ID>
// See: https://hello.atlassian.net/wiki/spaces/OBSERVABILITY/pages/1436386358/Sentry+Cloud+-+Getting+Started#Setting-up-the-Sentry-SDK-for-your-project
function $bafd16c1172e5624$var$getSentryDsn() {
    // https://sentry.io/settings/atlassian-2y/projects/confluence/keys/
    const SENTRY_DSN_PROD = 'https://1f56d81aaaae4b1ea5ca08bca6633223@o55978.ingest.sentry.io/5988811';
    // https://sentry.io/settings/atlassian-2y/projects/confluence-staging/keys/
    const SENTRY_DSN_STAGING = 'https://ce2ea70bbd2a439793b772cc1d59e2fe@o55978.ingest.sentry.io/5988871';
    return SENTRY_DSN_PROD;
}
function $bafd16c1172e5624$var$getSentryEnvironment() {
    const SENTRY_ENV_PROD = 'CONFLUENCE';
    const SENTRY_ENV_STAGING = 'CONFLUENCE-STAGING';
    const SENTRY_ENV_HELLO = 'HELLO';
    return SENTRY_ENV_PROD;
}
function $bafd16c1172e5624$var$getSentryOptions(dsn) {
    const additionalOptions = {};
    return {
        release: (0, $f3f8c1a227f13835$export$4ea39b9726d98a51)().FRONTEND_VERSION,
        dsn: dsn,
        environment: $bafd16c1172e5624$var$getSentryEnvironment(),
        beforeSend (event, hint) {
            return $bafd16c1172e5624$var$dataTransformer(event, hint);
        },
        ignoreErrors: [
            'Transport destroyed',
            // Error being thrown by media that won't be resolved any time soon.
            'Worker was destroyed',
            // Error being thrown by media that won't be resolved any time soon.
            'Failed to connect on any of the ADC ports',
            // Error being thrown by media that won't be resolved any time soon.
            "Cannot read property 'postMessage' of undefined",
            // Error being thrown by Connect that won't be resolved any time soon.
            "Cannot read property 'postMessage' of null",
            // Error being thrown by Connect that won't be resolved any time soon.
            'd.hide is not a function',
            // From com.atlassian.auiplugin:aui-date-picker,
            /^network error/i,
            // We can't do anything about network issues
            /^network failure/i,
            // We can't do anything about network issues
            'TypeError: Failed to fetch',
            // We can't do anything about network issues
            'ResizeObserver loop limit exceeded',
            // A benign error, see https://stackoverflow.com/a/50387233/2645305
            /ResizeObserver loop completed with undelivered notifications/
        ],
        autoSessionTracking: false,
        ...additionalOptions
    };
}

const $bafd16c1172e5624$export$c2e2a07dfafd1ea2 = (0, $8V6O9.default)(async ()=>{
    // https://sentry.io/settings/atlassian-2y/projects/confluence-sla/keys/
    const SENTRY_DSN_SLA = 'https://2d329ea4a8a04cf0b19117b4675b336f@o55978.ingest.sentry.io/5988900';
    return (0, $cd3135dd152096aa$export$cc373701aed148fc)((parcelRequire("2DnMr")).then(({ BrowserClient: BrowserClient, Hub: Hub })=>{
        const client = new BrowserClient($bafd16c1172e5624$var$getSentryOptions(SENTRY_DSN_SLA));
        return new Hub(client);
    }).catch(()=>{
        // noop, there's nowhere to report this error
        return null;
    }));
});

function $bafd16c1172e5624$export$1f7656c617418e15() {
    (parcelRequire("2DnMr")).then(({ init: init })=>{
        init($bafd16c1172e5624$var$getSentryOptions($bafd16c1172e5624$var$getSentryDsn()));
    }).catch(()=>{
    // noop, there's nowhere to report this error
    });
}


/* eslint-disable no-useless-constructor */ class $bf7ff670cf416156$export$704b12ddc1dacdd2 {
    add(item) {
        this.scheduleFlush();
        this.currentBatch.push(item);
        if (this.currentBatch.length >= this.batchMaxSize) this.flush();
    }
    onFlush(callback) {
        if (!(callback instanceof Function)) throw new Error(`"onFlush" callback is supposed to be a function; saw ${typeof callback} instead`);
        this.onFlushCallbacks.add(callback);
        return {
            unsubscribe: ()=>{
                this.onFlushCallbacks.delete(callback);
            }
        };
    }
    /**
   * Forcefully flushes the batcher. Noop if current batch is empty.
   */ forceFlush() {
        // Currently force-flush is synchronous. Make sure the call sites are updated if
        // this is changed to a promise-based approach
        this.flush();
    }
    renewBatch() {
        const oldBatch = this.currentBatch;
        this.currentBatch = [];
        return oldBatch;
    }
    scheduleFlush() {
        if (!this.flushIntervalId) this.flushIntervalId = window.setInterval(this.flush, this.flushIntervalMs);
    }
    unscheduleFlush() {
        if (this.flushIntervalId) {
            window.clearInterval(this.flushIntervalId);
            this.flushIntervalId = undefined;
        }
    }
    constructor(flushIntervalMs, batchMaxSize){
        this.flushIntervalMs = flushIntervalMs;
        this.batchMaxSize = batchMaxSize;
        this.flushIntervalId = void 0;
        this.onFlushCallbacks = new Set();
        this.currentBatch = [];
        this.flush = ()=>{
            const batch = this.renewBatch();
            this.unscheduleFlush();
            if (batch.length === 0) return;
            this.onFlushCallbacks.forEach((cb)=>{
                try {
                    cb(batch);
                } catch (e) {
                    // rethrow error asynchronously to allow other callbacks to execute
                    setTimeout(()=>{
                        /* eslint-disable-next-line no-console */ console.error(`"onFlush" callback threw the below error. Please make sure your callbacks have proper error handling`);
                        throw e;
                    }, 0);
                }
            });
        };
    }
}



const $20a7f4cbd1623994$var$logger = (0, $a6897acd40ed68b1$export$2b1d391cd05230fd)('CustomMonitoringClient');

class $20a7f4cbd1623994$export$a54226afd3e3cacc {
    enableNewSentry() {
        this.newSentryEnabled = true;
    }
    enableSendErrorsToTelemetryService() {
        this.sendErrorsToTelemetryService = true;
    }
    submitError(error, errorData) {
        if (!error) return;
        if (this.errorsPerCurrentTransition === this.errorsPerTransitionLimit) // limit reached; do not submit the errors
        return;
        this.errorsPerCurrentTransition++;
        const logSafeErrorAttributes = (0, $8a3a8685062675cc$export$d08bac32cb78075f)(error);
        const { attribution: attribution } = errorData;
        let isFirstInSession = this.firstErrorInSession;
        const errorWithStackTrace = error && error.stack && error.message ? error : new Error(error && error.message || String(error));
        if ($20a7f4cbd1623994$var$isErrorIgnorableByOnCall(errorWithStackTrace, attribution, logSafeErrorAttributes)) isFirstInSession = false;
        else this.firstErrorInSession = false;
        this.incrementCounter('jsErrors', [
            `attribution:${attribution}`,
            `firstInSession:${isFirstInSession}`,
            ...logSafeErrorAttributes.operationName ? [
                `queryName:${logSafeErrorAttributes.operationName}`
            ] : []
        ]);
        const sentryTags = {
            attribution: attribution
        };
        if (this.context.slaExperience) sentryTags.slaExperience = this.context.slaExperience;
        if (this.context.pageName) sentryTags.pageName = this.context.pageName;
        if (logSafeErrorAttributes.failedSlaExperience) sentryTags.failedSlaExperience = logSafeErrorAttributes.failedSlaExperience;
        if (logSafeErrorAttributes.operationName) sentryTags.operationName = logSafeErrorAttributes.operationName;
        sentryTags.ssrRendered = Boolean(window.__SSR_RENDERED__).toString();
        if (logSafeErrorAttributes.failedSlaExperience) this.logSlaErrorToSentry(errorWithStackTrace, sentryTags).catch((sentryError)=>{
            this.logError(sentryError, {
                attribution: 'backbone'
            });
        });
        else if (this.newSentryEnabled) this.logErrorToSentry(errorWithStackTrace, sentryTags);
        this.logError(errorWithStackTrace, {
            ...errorData,
            ...logSafeErrorAttributes,
            firstInSession: isFirstInSession
        });
    }
    updateContext(update) {
        if (update.transitionId !== undefined && (update.transitionId === 0 || this.context.transitionId !== update.transitionId)) {
            this.incrementCounter('session', [
                `type:${update.transitionId === 0 ? 'initial' : 'transition'}`
            ]);
            // Next error will be first in the session when there is a initial load (transition id = 0) or a SPA transition.
            this.firstErrorInSession = true;
            this.errorsPerCurrentTransition = 0;
        }
        if (update.pageName && this.context.pageName !== update.pageName) // since the page name changed, all the events in the current batch were done
        // under an old page name. Hence we force-flush the batch, and only then set the new context.
        {
            if (this.context.pageName !== undefined) // skip force-flush if that's the first time we set pageName (i.e. initial navigation)
            this.batcher.forceFlush();
        }
        Object.assign(this.context, update);
    }
    incrementCounter(counterName, tags) {
        this.batcher.add(this.createMetric({
            type: 'increment',
            name: counterName,
            value: 1,
            tags: tags
        }));
    }
    gauge(counterName, value, tags) {
        this.batcher.add(this.createMetric({
            type: 'gauge',
            name: counterName,
            value: value,
            tags: tags
        }));
    }
    logErrorToSentry(error, tags) {
        (parcelRequire("2DnMr")).then(({ withScope: withScope, captureException: captureException })=>{
            withScope((scope)=>{
                scope.setTags(tags);
                captureException(error);
            });
        }).catch((sentryError)=>{
            this.logError(sentryError, {
                attribution: 'backbone'
            });
        });
    }
    async logSlaErrorToSentry(error, tags) {
        let sentryHub = null;
        const standaloneSentryPromise = (0, $bafd16c1172e5624$export$c2e2a07dfafd1ea2)();
        if ((0, $cd3135dd152096aa$export$b1a2a6bd0c6f9666)(standaloneSentryPromise)) sentryHub = (0, $cd3135dd152096aa$export$bf7199a9ebcb84a9)(standaloneSentryPromise);
        else sentryHub = await standaloneSentryPromise;
        if (sentryHub) sentryHub.withScope((scope)=>{
            scope.setTags(tags);
            sentryHub.captureException(error);
        });
    }
    /**
   * There is a 64kb payload limit for navigator.sendBeacon requests
   * 10 events sent max.
   * 3 fields that are being trimmed
   * That allows for 65536/10/3 = 2184.5 per field
   * we add a bit of buffer for the rest of the payload by reducing that number further to 1000
   * @param errorAttributes
   * @returns a new object with trimmed attributes if they exceed the limit determined by
   * errorBatchMsgTrimLength` which is calculated based on the following details
   */ trimAttributes(errorAttributes) {
        const attributesToTrim = [
            'error',
            'stack',
            'componentStack'
        ];
        const newErrorAttributes = {
            ...errorAttributes
        };
        if (errorAttributes.error?.startsWith?.('Minified React error #130') && (0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_frontend_untrimmed_react_errors')) {
            // Oct 2025: Log the (hopefully entire) stack for minified react error 130, to aid investigations into increased occurrences. Still trims to <64kb limit.
            newErrorAttributes.error = this.trimTextLength(newErrorAttributes.error, 2000);
            newErrorAttributes.stack = this.trimTextLength(newErrorAttributes.stack, 25000);
            newErrorAttributes.componentStack = this.trimTextLength(newErrorAttributes.componentStack, 25000);
        } else attributesToTrim.forEach((attribute)=>{
            if (newErrorAttributes[attribute]) newErrorAttributes[attribute] = this.trimTextLength(newErrorAttributes[attribute], this.errorBatchMsgTrimLength);
        });
        return newErrorAttributes;
    }
    async logError(error, additionalData) {
        try {
            const analyticsWebClientPromise = (0, $b76dfd1db5681318$export$e9ba7ef9458d1a4a)();
            let client;
            if ((0, $cd3135dd152096aa$export$b1a2a6bd0c6f9666)(analyticsWebClientPromise)) client = (0, $cd3135dd152096aa$export$bf7199a9ebcb84a9)(analyticsWebClientPromise);
            else client = await analyticsWebClientPromise;
            const errorAttributes = {
                error: error.message || String(error),
                stack: error.stack,
                browserInfo: window.navigator.userAgent,
                ssrRendered: Boolean(window.__SSR_RENDERED__),
                releaseId: (0, $f3f8c1a227f13835$export$4ea39b9726d98a51)().FRONTEND_VERSION,
                track: (0, $f3f8c1a227f13835$export$4ea39b9726d98a51)().RELEASE_TRACK,
                pageName: this.context.pageName,
                shard: this.context.shard,
                edition: this.context.edition,
                jqVer: window.jQuery?.fn?.jquery,
                activeExperiences: this.context.activeExperiences ? Array.from(this.context.activeExperiences) : undefined,
                slaExperience: this.context.slaExperience,
                ufoTraceId: (0, $9931f21957f7e3c2$export$b6ac780db3a3cc77)()?.traceId,
                ufoTraceType: (0, $9931f21957f7e3c2$export$b6ac780db3a3cc77)()?.type,
                ...additionalData
            };
            const trimmedErrorAttributes = this.trimAttributes(errorAttributes);
            const hydrationFailed = window && window.__HYDRATION_FAILED__ && (0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_prevent_hydration_ufo_abort');
            if (!hydrationFailed) (0, $7390d9fffd2908eb$export$7379c15afd3840fa)('confluence-frontend-monitoring-client', null, 'interaction unhandled error', errorAttributes.error);
            client.sendOperationalEvent({
                source: 'ui',
                action: 'unhandledError',
                actionSubject: 'ui',
                attributes: trimmedErrorAttributes
            });
            if (this.sendErrorsToTelemetryService) this.errorBatcher.add({
                event: trimmedErrorAttributes
            });
        } catch  {
        // no-op, if an error occurs here, there's really nowhere to submit it
        }
    }
    /**
   * Defines an allow-list of context attributes that will be sent as "global" tags to FE Telemetry and SignalFX with every event.
   * Tags additionally have to be allow-listed in the FE Telemetry repository. We PURPOSELY exclude certain tags (that are allowed by FE Telemetry)
   * such as "edition", as we do not want to be sending that tag for every experience event (thereby increasing metric cardinality). Instead, those tags
   * are included with specific experience events.
   * @private
   */ formatContextAsTags() {
        const tags = [];
        if (this.context.pageName) tags.push(`page:${this.context.pageName}`);
        if (this.context.tenantId) tags.push(`cloudId:${this.context.tenantId}`);
        if (this.context.shard) tags.push(`shard:${this.context.shard}`);
        if (this.context.product) tags.push(`product:${this.context.product}`);
        const { FRONTEND_VERSION: frontendVersion, RELEASE_TRACK: releaseTrack } = (0, $f3f8c1a227f13835$export$4ea39b9726d98a51)();
        if (frontendVersion) tags.push(`version:${frontendVersion}`);
        if (releaseTrack) tags.push(`track:${releaseTrack}`);
        return tags;
    }
    onBatch(batch) {
        const payload = {
            type: 'metric',
            meta: {
                globalTags: this.formatContextAsTags()
            },
            data: batch
        };
        this.send(payload);
    }
    onErrorBatch(batch) {
        const payload = {
            type: 'error',
            meta: {
                globalTags: this.formatContextAsTags()
            },
            data: batch
        };
        this.send(payload);
    }
    send(telemetryPayload) {
        try {
            $20a7f4cbd1623994$var$logger.info`Sending monitoring events: ${telemetryPayload}`;
            const reportingUrl = '/gateway/api/telemetry';
            const data = JSON.stringify(telemetryPayload);
            let isSentViaBeacon = false;
            if (navigator.sendBeacon) isSentViaBeacon = navigator.sendBeacon(reportingUrl, data);
            if (!isSentViaBeacon) {
                // resorting to XMLHttpRequest instead of fetch here so that we can submit these events *synchronously* when
                // the page unloads (`fetch` can't do that)
                const client = new XMLHttpRequest();
                const shouldBeSync = this.isWindowUnloading;
                client.open('POST', reportingUrl, !shouldBeSync);
                // we're setting the "Content-Type" header to "text/plain" to behave as closely to `sendBeacon` as possible
                client.setRequestHeader('Content-Type', 'text/plain;charset=UTF-8');
                client.send(data);
            }
        } catch (e) {
            // ignore - there's nothing we can do when monitoring is down
            $20a7f4cbd1623994$var$logger.error`Sending monitoring data failed: ${e}`;
        }
    }
    createMetric({ type: type, name: name, value: value, tags: tags = [] }) {
        return {
            type: type,
            name: name,
            value: value,
            sampleRate: 1,
            tags: tags,
            timestamp: new Date().toISOString()
        };
    }
    trimTextLength(text, trimmedLength) {
        if (!text || !trimmedLength) return text;
        if (text.length > trimmedLength) return `${text.substring(0, trimmedLength)}...`;
        return text;
    }
    constructor({ errorsPerTransitionLimit: errorsPerTransitionLimit = 1000, metricBatchMaxSize: metricBatchMaxSize = 50, metricBatchFlushIntervalMs: metricBatchFlushIntervalMs = 10000, errorBatchFlushIntervalMs: errorBatchFlushIntervalMs = 10000, errorBatchMaxSize: errorBatchMaxSize = 10, errorBatchMsgTrimLength: errorBatchMsgTrimLength = 1000 } = {}){
        this.batcher = void 0;
        this.errorBatcher = void 0;
        this.isWindowUnloading = false;
        this.context = {};
        // First error occurred in initial load or transition
        this.firstErrorInSession = true;
        this.newSentryEnabled = false;
        this.sendErrorsToTelemetryService = false;
        this.errorsPerTransitionLimit = void 0;
        this.errorsPerCurrentTransition = 0;
        this.errorBatchMsgTrimLength = void 0;
        this.errorsPerTransitionLimit = errorsPerTransitionLimit;
        this.errorBatchMsgTrimLength = errorBatchMsgTrimLength;
        this.batcher = new (0, $bf7ff670cf416156$export$704b12ddc1dacdd2)(metricBatchFlushIntervalMs, metricBatchMaxSize);
        this.errorBatcher = new (0, $bf7ff670cf416156$export$704b12ddc1dacdd2)(errorBatchFlushIntervalMs, errorBatchMaxSize);
        this.batcher.onFlush((batch)=>{
            this.onBatch(batch);
        });
        this.errorBatcher.onFlush((batch)=>{
            this.onErrorBatch(batch);
        });
        const unloadListener = ()=>{
            this.isWindowUnloading = true;
            this.batcher.forceFlush();
            this.errorBatcher.forceFlush();
        };
        window.addEventListener('pagehide', unloadListener);
    }
}
function $20a7f4cbd1623994$var$isErrorIgnorableByOnCall(error, attribution, attrs) {
    // make sure that this condition remains first, as it should override everything else
    if (Boolean(attrs.failedSlaExperience)) // non-ignorable, because it resulted in a failure of an SLA-bound experience
    return false;
    if ((0, $65398bb1ddc9160a$export$bda33884db3cf75b)(error)) // ignorable, because on-call can't do much about user-side network connectivity
    return true;
    if (attribution === 'backbone-loadable') // while we do want to report those, we don't want to overwhelm our error rate detector
    return true;
    if (error.message.includes('.PermissionException') || error.message.includes('Authorization failed: Principal has insufficient permissions') || error.message.includes('.NotFoundException') || attrs.statusCode === 401 || attrs.statusCode === 403) // on-call engineers can't do much about those errors, because they indicate a client-side issue
    return true;
    return false;
}


class $e83139af63a401f5$export$97cc0a779e2b1c0d {
    submitError() {}
    updateContext() {}
    incrementCounter() {}
    gauge() {}
}



let $d1c1e8e192b1a688$var$monitoringClient;
const $d1c1e8e192b1a688$export$39a3b7739331403b = ()=>{
    if (!$d1c1e8e192b1a688$var$monitoringClient) {
        if (/bot/i.test(window.navigator.userAgent)) // Do nothing for search engine crawlers
        $d1c1e8e192b1a688$var$monitoringClient = new (0, $e83139af63a401f5$export$97cc0a779e2b1c0d)();
        else $d1c1e8e192b1a688$var$monitoringClient = new (0, $20a7f4cbd1623994$export$a54226afd3e3cacc)();
    }
    return $d1c1e8e192b1a688$var$monitoringClient;
};
const $d1c1e8e192b1a688$export$b97a02aaddc4fced = ()=>{
    if ($d1c1e8e192b1a688$var$monitoringClient instanceof (0, $20a7f4cbd1623994$export$a54226afd3e3cacc)) $d1c1e8e192b1a688$var$monitoringClient.enableSendErrorsToTelemetryService();
};



var $dQwsT = parcelRequire("dQwsT");


var $8V6O9 = parcelRequire("8V6O9");

/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
/* eslint-disable perfectionist/sort-object-types */ /* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $aVaWD = parcelRequire("aVaWD");
function $0df6b7bbd3e15e35$export$f9ce7b637dfbe238(value) {
    return typeof value === 'boolean';
}
function $0df6b7bbd3e15e35$export$a9a18ae5ba42aeab(values) {
    function typeGuard(value) {
        return values.includes(value);
    }
    /**
	 * This is used by test utils to get the variants when running describe.each
	 */ if ($0df6b7bbd3e15e35$var$IS_TESTING_ENV) typeGuard.values = values;
    return typeGuard;
}
const $0df6b7bbd3e15e35$var$IS_TESTING_ENV = typeof $aVaWD !== 'undefined' && ($aVaWD?.env?.NODE_ENV === 'test' || $aVaWD?.env?.JEST_WORKER_ID !== undefined);


function $bead030acabac29b$export$456f1587c9c92021(config) {
    return {
        ...config,
        typeGuard: (0, $0df6b7bbd3e15e35$export$f9ce7b637dfbe238),
        defaultValue: config.defaultValue
    };
}
function $bead030acabac29b$export$fb89e8a786694d1(config) {
    const { values: values } = config;
    return {
        ...config,
        values: [
            ...values
        ],
        typeGuard: (0, $0df6b7bbd3e15e35$export$a9a18ae5ba42aeab)(config.values),
        defaultValue: config.defaultValue
    };
}


const $06020ccd06ed562c$export$6cbb856f286b07ef = {
    // new format to avoid collisions with other users when updating the file
    // Editor Platform experiments
    // lwoollard experiments
    // Added 02-12-2025
    cc_fix_hydration_ttvc: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc_fix_hydration_ttvc'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 03-09-2025
    cc_editor_limited_mode_include_lcm: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc_editor_limited_mode_include_lcm'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 03-09-2025
    cc_editor_interactivity_monitoring: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc_editor_interactivity_monitoring'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-03
    editor_tinymce_full_width_mode: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'editor_tinymce_full_width_mode'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-10
    confluence_max_width_content_appearance: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'confluence_max_width_content_appearance'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    cc_editor_insm_doc_size_stats: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc_editor_insm_doc_size_stats'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-30
    cc_editor_insm_outlier_events: (0, $bead030acabac29b$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'cc_editor_insm_outlier_events'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-12-09
    cc_editor_hover_link_overlay_css_fix: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc_editor_hover_link_overlay_css_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-17
    platform_editor_renderer_extension_width_fix: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_renderer_extension_width_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-26
    platform_editor_resizer_styles_cleanup: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_resizer_styles_cleanup'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-12
    platform_editor_media_vc_fixes: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_media_vc_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-20
    platform_editor_annotations_sync_on_docchange: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_annotations_sync_on_docchange'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-27
    platform_editor_reduce_noisy_steps_ncs: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_reduce_noisy_steps_ncs'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-24
    editor_prevent_numbered_column_too_big_jira_1: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            jira: 'editor_prevent_numbered_column_too_big_jira_1'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-02
    platform_editor_block_control_optimise_render: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_block_control_optimise_render'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-boolean': (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_boolean'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-multivariate': (0, $bead030acabac29b$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_multivariate'
        },
        param: 'variant',
        values: [
            'one',
            'two',
            'three'
        ],
        defaultValue: 'one'
    }),
    // Added 2024-08-08
    'test-new-experiments-package': (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package',
            jira: 'jira_editor_experiment_test_new_package'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-05
    support_table_in_comment: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_support_table_in_comment_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-07
    platform_editor_exp_lazy_node_views: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_exp_lazy_node_views'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-18
    platform_renderer_table_sticky_scrollbar: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_renderer_table_sticky_scrollbar'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-20
    'company-hub-config-panel-keyboard-nav': (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'company-hub-config-panel-keyboard-nav'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-10
    platform_editor_experience_tracking: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_experience_tracking'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-26
    platform_editor_prevent_toolbar_layout_shifts: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_prevent_toolbar_layout_shifts'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-01
    comment_on_bodied_extensions: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_comment_on_bodied_extensions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-14
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_advanced_layouts/setup
    advanced_layouts: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_advanced_layouts'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-3-15
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_single_column_layout/setup
    single_column_layouts: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_single_column_layout'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-08
    support_table_in_comment_jira: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            jira: 'platform_editor_support_table_in_comment_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    'platform_editor_ai-prompts-placeholder': (0, $bead030acabac29b$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_editor_ai-prompts-placeholder'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // added 2024-11-06
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_nested_tables/setup
    'nested-tables-in-tables': (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_nested_tables'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-11-26
    platform_editor_ai_unsplash_page_header: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_ai_unsplash_page_header'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-12-05
    platform_editor_blockquote_in_text_formatting_menu: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_blockquote_in_text_formatting_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_ssr_renderer: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_ssr_renderer'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-13
    platform_editor_element_drag_and_drop_multiselect: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_element_drag_and_drop_multiselect'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-19
    platform_editor_ai_edit_response_in_preview: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_ai_edit_response_in_preview'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-02-10
    platform_editor_controls: (0, $bead030acabac29b$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_editor_controls'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-08-01
    platform_editor_controls_block_controls_state_fix: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_controls_block_controls_state_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-03
    platform_editor_hydratable_ui: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_hydratable_ui'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-03-28
    platform_editor_ai_proactive_ai_nudge_parameters: (0, $bead030acabac29b$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_editor_ai_proactive_ai_nudge_parameters'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-04-14
    // https://switcheroo.atlassian.com/ui/gates/b159b45a-86d9-4f4b-b482-f9aca5b615d6/key/platform_editor_offline_editing_web
    platform_editor_offline_editing_web: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_offline_editing_web'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-15
    platform_editor_no_ssr: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_no_ssr'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-31
    platform_editor_lovability_suppress_toolbar_event: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_lovability_suppress_toolbar_event',
            jira: 'platform_editor_lovability_suppress_toolbar_event'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-17
    platform_editor_tables_drag_and_drop: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_tables_drag_and_drop'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-17
    platform_editor_tables_table_selector: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_tables_table_selector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_editor_usesharedpluginstateselector: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_usesharedpluginstateselector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_renderer_fix_analytics_memo_callback: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_renderer_fix_analytics_memo_callback'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-26
    platform_editor_stop_width_reflows: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_stop_width_reflows'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-01
    platform_editor_no_state_plugin_injection_api: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_no_state_plugin_injection_api'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-10
    platform_editor_no_cursor_on_edit_page_init: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_no_cursor_on_edit_page_init'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-14
    platform_editor_debounce_portal_provider: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_debounce_portal_provider'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-08 - Jira work sync description comment summary
    'jira-work-sync-desc-comment-summary': (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            jira: 'jira-work-sync-desc-comment-summary'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-15
    platform_editor_breakout_resizing: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_breakout_resizing'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-17
    editor_fix_embed_width_expand: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'editor_fix_embed_width_expand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-07
    platform_editor_ai_quickstart_command: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_ai_quickstart_command'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-05
    platform_editor_block_controls_perf_optimization: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_block_controls_perf_optimization'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-16
    platform_editor_enable_single_player_step_merging: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_enable_single_player_step_merging'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-02
    platform_editor_code_block_fold_gutter: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_code_block_fold_gutter'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-18
    platform_editor_ai_iw_adf_streaming: (0, $bead030acabac29b$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_editor_ai_iw_adf_streaming'
        },
        param: 'cohort',
        values: [
            'control',
            'adf_gemini25flash',
            'adf_gpt41mini'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-08-20
    platform_editor_ai_non_iw_adf_streaming: (0, $bead030acabac29b$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_editor_ai_non_iw_adf_streaming'
        },
        param: 'cohort',
        values: [
            'control',
            'adf_gemini25flash',
            'adf_gpt41mini'
        ],
        defaultValue: 'control'
    }),
    //Added 2025-07-25
    platform_editor_extension_styles: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_extension_styles'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-24
    platform_editor_find_and_replace_improvements: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_find_and_replace_improvements'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-24
    confluence_whiteboards_quick_insert: (0, $bead030acabac29b$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'confluence_whiteboards_quick_insert'
        },
        param: 'cohort',
        values: [
            'control',
            'test_blank',
            'test_diagram'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-06-26
    platform_editor_feedback_mandatory_rating: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_feedback_mandatory_rating'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-30
    platform_editor_drag_handle_aria_label: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_drag_handle_aria_label'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-07
    platform_editor_toggle_expand_on_match_found: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_toggle_expand_on_match_found'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_smart_card_otp: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_smart_card_otp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-15
    platform_editor_preview_panel_responsiveness: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'confluence_preview_panels_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-18
    platform_editor_preview_panel_linking_exp: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_preview_panel_linking_exp_conf',
            jira: 'platform_editor_preview_panel_linking_exp_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-10
    platform_editor_hoverlink_ui_fixes_exp: (0, $bead030acabac29b$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_editor_hoverlink_ui_fixes_exp'
        },
        param: 'cohort',
        values: [
            'control',
            'css_changes_only',
            'css_js_changes'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-08-17
    platform_hover_card_preview_panel: (0, $bead030acabac29b$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_hover_card_preview_panel',
            jira: 'platform_hover_card_preview_panel'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-09-17
    platform_hover_card_preview_panel_modal: (0, $bead030acabac29b$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_hover_card_preview_panel_modal',
            jira: 'platform_hover_card_preview_panel_modal'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-11-25
    smart_link_confluence_short_link_analytics: (0, $bead030acabac29b$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'smart-link-confluence-short-link-analytics',
            jira: 'smart-link-confluence-short-link-analytics'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025--8-05
    platform_editor_block_menu: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_block_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-16
    platform_editor_emoji_otp: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_emoji_otp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-23
    // Added 2025-07-24
    editor_enghealth_hyperlink_toolbar_aria_values: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'editor_enghealth_hyperlink_toolbar_aria_values'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-14
    platform_editor_add_orange_highlight_color: (0, $bead030acabac29b$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_editor_add_orange_highlight_color'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    //Added 2025-07-16
    platform_editor_toolbar_aifc: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            jira: 'platform_editor_toolbar_aifc_jira',
            confluence: 'platform_editor_toolbar_aifc_confluence'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-04
    editor_refactor_backspace_task_and_decisions: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'editor_refactor_backspace_task_and_decisions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    //Added 2025-07-16
    platform_editor_toolbar_aifc_patch_3: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            jira: 'platform_editor_toolbar_aifc_patch_3',
            confluence: 'platform_editor_toolbar_aifc_patch_3'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    //Added 2025-09-09
    platform_editor_toolbar_aifc_patch_4: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            jira: 'platform_editor_toolbar_aifc_patch_4',
            confluence: 'platform_editor_toolbar_aifc_patch_4'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-29
    platform_editor_toolbar_aifc_selection_extension: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_selection_extension',
            jira: 'platform_editor_toolbar_aifc_selection_extension'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-04
    platform_editor_floating_toolbar_button_aria_label: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_floating_toolbar_button_aria_label'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-24
    platform_editor_enghealth_table_plugin_lable_rule: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_enghealth_table_plugin_lable_rule'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-31
    platform_editor_breakout_interaction_rerender: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_breakout_interaction_rerender'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-27
    platform_editor_toolbar_aifc_responsive: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_responsive',
            jira: 'platform_editor_toolbar_aifc_responsive'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-30
    platform_editor_pasting_nested_table_fix: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_pasting_nested_table_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 20205-07-28
    platform_editor_fix_quick_insert_consistency_exp: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_fix_quick_insert_consistency_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    //Added 2025-11-19
    platform_editor_pasting_text_in_panel: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_pasting_text_in_panel'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-31
    platform_editor_fix_a11y_aria_posinset_0: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_fix_a11y_aria_posinset_0'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-30
    platform_editor_blocktaskitem_node_tenantid: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_blocktaskitem_node_tenantid'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-08
    platform_editor_blocktaskitem_patch_1: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_blocktaskitem_patch_1'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-06
    cc_editor_limited_mode: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc_editor_limited_mode'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-05
    platform_editor_native_anchor_with_dnd: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_native_anchor_with_dnd'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_native_expand_button: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_native_expand_button'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-28
    editor_enable_image_alignment_in_expand: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'editor_enable_image_alignment_in_expand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-05
    platform_editor_august_a11y: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_august_a11y'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-10
    platform_synced_block: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_synced_block',
            jira: 'platform_synced_block_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-18
    platform_editor_locale_datepicker: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_locale_datepicker'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-19
    platform_editor_breakout_resizing_vc90_fix: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_breakout_resizing_vc90_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-27
    platform_editor_toolbar_support_custom_components: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_toolbar_support_custom_components'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-25
    platform_editor_toolbar_aifc_template_editor: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_template_editor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-26
    platform_editor_toolbar_migrate_loom: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_toolbar_migrate_loom',
            jira: 'platform_editor_toolbar_migrate_loom'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-16
    platform_editor_prevent_taskitem_remount: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_prevent_taskitem_remount'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-01
    cc_editor_ai_content_mode: (0, $bead030acabac29b$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'cc_editor_ai_content_mode'
        },
        param: 'variant',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-12-04
    confluence_compact_text_format: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'confluence_compact_text_format'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-08
    platform_editor_editor_width_analytics: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_editor_width_analytics',
            jira: 'platform_editor_editor_width_analytics'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-10
    platform_editor_fix_button_name_violation_in_table: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_fix_button_name_violation_in_table'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-11
    platform_editor_quick_insert_image_wrap_right_fix: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_quick_insert_image_wrap_right_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-11
    platform_editor_add_aria_checked_to_inline_img_btn: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_add_aria_checked_to_inline_image_btn'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-16
    platform_editor_nested_table_refresh_width_fix: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_nested_table_refresh_width_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-15
    platform_editor_toolbar_aifc_patch_5: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_patch_5'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-10
    platform_use_llm_space_recommendations: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_use_llm_space_recommendations'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-15
    platform_editor_text_highlight_padding: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_text_highlight_padding'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-24
    platform_editor_lovability_user_intent: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_lovability_user_intent'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-23
    cc_editor_ttvc_release_bundle_one: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc_editor_ttvc_release_bundle_one'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-07
    platform_editor_plain_text_support: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            jira: 'platform_editor_plain_text_support',
            confluence: 'platform_editor_plain_text_support'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-26
    platform_editor_toolbar_aifc_patch_6: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_patch_6'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-01
    platform_inline_smartcard_connect_button_exp: (0, $bead030acabac29b$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_inline_smartcard_connect_button_exp',
            jira: 'platform_inline_smartcard_connect_button_exp'
        },
        param: 'cohort',
        values: [
            'control',
            'test1',
            'test2'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-10-13
    platform_editor_media_error_analytics: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_media_error_analytics'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-20
    confluence_whiteboards_quick_insert_localised: (0, $bead030acabac29b$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'confluence_whiteboards_quick_insert_localised'
        },
        param: 'cohort',
        values: [
            'control',
            'test_blank',
            'test_diagram'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-10-28
    confluence_whiteboards_quick_insert_localised_aa: (0, $bead030acabac29b$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'confluence_whiteboards_quick_insert_localised_aa'
        },
        param: 'cohort',
        values: [
            'control',
            'test_diagram'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-10-22
    platform_editor_remove_bidi_char_warning: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_remove_bidi_char_warning'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-27
    platform_editor_table_sticky_header_improvements: (0, $bead030acabac29b$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_editor_table_sticky_header_improvements'
        },
        param: 'cohort',
        values: [
            'control',
            'test_with_overflow',
            'test_without_overflow'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-11-04
    platform_editor_disable_lazy_load_media: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_disable_lazy_load_media'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-29
    platform_editor_lovability_inline_code: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_lovability_inline_code'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-05
    platform_editor_lovability_emoji_scaling: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_lovability_emoji_scaling'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-07
    cc_editor_limited_mode_table_align_bttn: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'cc_editor_limited_mode_table_align_bttn'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-18
    platform_editor_blockquote_zero_padding: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_blockquote_zero_padding'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-19
    platform_editor_lovability_navigation_fixes: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_lovability_navigation_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-27
    platform_sl_3p_unauth_paste_as_block_card: (0, $bead030acabac29b$export$fb89e8a786694d1)({
        productKeys: {
            confluence: 'platform_sl_3p_unauth_paste_as_block_card',
            jira: 'platform_sl_3p_unauth_paste_as_block_card'
        },
        values: [
            'control',
            'card_by_default_only',
            'card_by_default_and_new_design'
        ],
        param: 'cohort',
        defaultValue: 'control'
    }),
    // Added 2025-11-25
    platform_editor_remove_ncsstepmetrics_plugin: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_remove_ncsstepmetrics_plugin'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-18
    platform_editor_wait_for_space_after_ascii_emoji: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_wait_for_space_after_ascii_emoji'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-03
    platform_editor_use_pmr_for_collab_presence_non_ic: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_use_pmr_for_collab_presence_non_ic',
            jira: 'platform_editor_use_pmr_for_collab_presence_non_ic'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-03
    platform_editor_use_pmr_for_collab_presence_in_ic: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_use_pmr_for_collab_presence_in_ic',
            jira: 'platform_editor_use_pmr_for_collab_presence_in_ic'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-12
    platform_editor_toolbar_delay_render_fix: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_toolbar_delay_render_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-03
    platform_editor_nested_media_selection_fix: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_nested_media_selection_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-04
    platform_editor_scroll_gutter_fix: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_scroll_gutter_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-08
    platform_editor_add_image_editing: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_add_image_editing'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-08
    platform_editor_reduce_toolbar_vc_impact: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_reduce_toolbar_vc_impact'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-15
    platform_editor_ai_exp_inline_date_year_refresh: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_ai_exp_inline_date_year_refresh'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-15
    platform_editor_ai_exp_suggestion_date_comma_delim: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_ai_exp_suggestion_date_comma_delim'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-22
    platform_editor_localid_ime_composition_fix: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_editor_localid_ime_composition_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-18
    platform_synced_blocks_offline_check_for_block: (0, $bead030acabac29b$export$456f1587c9c92021)({
        productKeys: {
            confluence: 'platform_synced_blocks_offline_check_for_block',
            jira: 'platform_synced_blocks_offline_check_for_block'
        },
        param: 'isEnabled',
        defaultValue: false
    })
};


const $acf84f8040eb09ad$export$7e849a84a00ffd1c = {
    'example-multivariate': 'one',
    'platform_editor_ai-prompts-placeholder': 'control',
    platform_editor_ai_proactive_ai_nudge_parameters: 'control',
    platform_editor_controls: 'control',
    confluence_whiteboards_quick_insert: 'control',
    confluence_whiteboards_quick_insert_localised: 'control',
    confluence_whiteboards_quick_insert_localised_aa: 'control',
    cc_editor_ai_content_mode: 'control',
    platform_editor_add_orange_highlight_color: 'control',
    platform_editor_ai_iw_adf_streaming: 'control',
    platform_editor_ai_non_iw_adf_streaming: 'control',
    platform_hover_card_preview_panel: 'control',
    platform_hover_card_preview_panel_modal: 'control',
    smart_link_confluence_short_link_analytics: 'control',
    platform_inline_smartcard_connect_button_exp: 'control',
    cc_editor_insm_outlier_events: 'test',
    platform_editor_hoverlink_ui_fixes_exp: 'control',
    platform_editor_table_sticky_header_improvements: 'control',
    platform_sl_3p_unauth_paste_as_block_card: 'control'
};
const $acf84f8040eb09ad$export$54960937bb713f97 = {
    cc_editor_hover_link_overlay_css_fix: false,
    platform_editor_feedback_mandatory_rating: false,
    platform_editor_preview_panel_responsiveness: false,
    platform_editor_toolbar_aifc: false,
    platform_editor_block_control_optimise_render: false,
    'test-new-experiments-package': false,
    support_table_in_comment: false,
    platform_editor_exp_lazy_node_views: false,
    platform_renderer_table_sticky_scrollbar: false,
    platform_editor_prevent_toolbar_layout_shifts: false,
    comment_on_bodied_extensions: false,
    advanced_layouts: false,
    single_column_layouts: false,
    support_table_in_comment_jira: false,
    'nested-tables-in-tables': false,
    platform_editor_ai_unsplash_page_header: false,
    platform_editor_blockquote_in_text_formatting_menu: false,
    platform_editor_element_drag_and_drop_multiselect: false,
    platform_editor_ai_edit_response_in_preview: false,
    platform_editor_offline_editing_web: false,
    platform_editor_tables_drag_and_drop: false,
    platform_editor_tables_table_selector: false,
    platform_renderer_fix_analytics_memo_callback: false,
    platform_editor_stop_width_reflows: false,
    platform_editor_no_cursor_on_edit_page_init: false,
    'jira-work-sync-desc-comment-summary': false,
    platform_editor_breakout_resizing: false,
    platform_editor_ai_quickstart_command: false,
    platform_editor_block_controls_perf_optimization: false,
    platform_editor_enable_single_player_step_merging: false,
    platform_editor_find_and_replace_improvements: false,
    platform_editor_toggle_expand_on_match_found: false,
    platform_editor_reduce_noisy_steps_ncs: false,
    platform_editor_text_highlight_padding: false,
    confluence_compact_text_format: false
};


let $23abd0bdd1021e0f$export$e5d73bf4f8e2ae96 = {};
let $23abd0bdd1021e0f$export$4e849416bb5c5b52 = {};
let $23abd0bdd1021e0f$export$cf7305fc65acbf0d;
function $23abd0bdd1021e0f$export$1c2b6dbf79eb3560(product, /**
	 * Overrides are used to set the group of an experiment for testing purposes.
	 * This is useful when you want to test a specific experiment group.
	 */ groupOverrides, /**
	 * Param overrides are used to set the experiment parameters for testing purposes.
	 * This is useful when you want to tweak the experiment parameters for testing.
	 */ paramOverrides, options) {
    if (groupOverrides) {
        // When setting up overrides, we want to ensure that experiments don't end up with invalid
        // values.
        // For production usage -- this is done via the feature flag client which takes the type
        // and performs equivalent logic.
        // @ts-ignore
        groupOverrides = Object.entries(groupOverrides).reduce((acc, [key, value])=>{
            const config = (0, $06020ccd06ed562c$export$6cbb856f286b07ef)[key];
            if (config) acc = {
                ...acc,
                [key]: config.typeGuard(value) ? value : config.defaultValue
            };
            return acc;
        }, {});
        $23abd0bdd1021e0f$export$e5d73bf4f8e2ae96 = groupOverrides;
    }
    if (product === 'test' && !options?.disableTestOverrides) {
        // Enforce expectation - file overrides, then global overrides, then default to true for boolean
        // experiments, then last result use the default value
        const testOverrides = Object.fromEntries(Object.entries((0, $06020ccd06ed562c$export$6cbb856f286b07ef)).map(([key, value])=>{
            const defaultValue = typeof value.defaultValue === 'boolean' ? true : value.defaultValue;
            return [
                key,
                groupOverrides?.[key] ?? (0, $acf84f8040eb09ad$export$7e849a84a00ffd1c)[key] ?? (0, $acf84f8040eb09ad$export$54960937bb713f97)[key] ?? defaultValue
            ];
        }));
        $23abd0bdd1021e0f$export$e5d73bf4f8e2ae96 = testOverrides;
    }
    $23abd0bdd1021e0f$export$cf7305fc65acbf0d = product;
    $23abd0bdd1021e0f$export$4e849416bb5c5b52 = paramOverrides || {};
}


var $b365c19bee2011b0$export$2c20ffeba7dbc068 = /*#__PURE__*/ function(ExposureTriggerReason) {
    ExposureTriggerReason["OptIn"] = "optInExposure";
    ExposureTriggerReason["Manual"] = "manualExposure";
    ExposureTriggerReason["Default"] = "defaultExposure";
    ExposureTriggerReason["AutoExposure"] = "autoExposure";
    ExposureTriggerReason["hasCustomAttributes"] = "hasCustomAttributes";
    return ExposureTriggerReason;
}({});


const $cd316494f52abf99$export$a6cdc56e425d0d0a = (value)=>typeof value === 'object';
const $cd316494f52abf99$export$8ed1df9dbe2e9a7d = (obj)=>{
    return obj ? Object.keys(obj).length === 0 : true;
};
const $cd316494f52abf99$export$c7d37910dd25ecbf = (obj, attributes, identifier)=>{
    attributes.forEach((attribute)=>{
        if (!(attribute in obj)) {
            const title = identifier ? `${identifier}: ` : '';
            throw new Error(`${title}Missing ${attribute}`);
        }
    });
};
const $cd316494f52abf99$export$891630e169ca14a4 = (customAttributes)=>{
    const reservedAttributes = [
        'flagKey',
        'ruleId',
        'reason',
        'value',
        'errorKind'
    ];
    const keys = customAttributes ? Object.keys(customAttributes) : [];
    if (reservedAttributes.some((attribute)=>keys.includes(attribute))) throw new TypeError(`exposureData contains a reserved attribute. Reserved attributes are: ${reservedAttributes.join(', ')}`);
};
const $cd316494f52abf99$var$validateFlag = (flagKey, flag)=>{
    if ($cd316494f52abf99$export$a6cdc56e425d0d0a(flag) && 'value' in flag) return true;
};
const $cd316494f52abf99$export$410eec87ab950965 = (flags)=>{
    Object.keys(flags).forEach((key)=>$cd316494f52abf99$var$validateFlag(key, flags[key]));
};


const $8561d128cbf24ac4$export$933245d8afcc8872 = {
    kind: 'ERROR',
    errorKind: 'FLAG_NOT_FOUND'
};
class $8561d128cbf24ac4$export$2e2bcd8739ae039 {
    evaluate(defaultValue) {
        return defaultValue;
    }
    getBooleanValue(options) {
        return this.evaluate(options.default);
    }
    getVariantValue(options) {
        return this.evaluate(options.default);
    }
    getJSONValue() {
        return this.evaluate({});
    }
    getRawValue(options) {
        return this.evaluate(options.default);
    }
    getFlagEvaluation(options) {
        const value = this.evaluate(options.default);
        return {
            value: value,
            explanation: $8561d128cbf24ac4$export$933245d8afcc8872
        };
    }
    constructor(){
        // Unused but required for type
        this.evaluationCount = -1;
    }
}



class $05314358ce6a7538$export$2e2bcd8739ae039 {
    getCachedResultOrCompute(defaultValue, { shouldTrackExposureEvent: shouldTrackExposureEvent, exposureData: exposureData, oneOf: oneOf, ignoreTypes: ignoreTypes }) {
        let exposureTriggerReason = (0, $b365c19bee2011b0$export$2c20ffeba7dbc068).OptIn;
        if (shouldTrackExposureEvent === undefined) {
            shouldTrackExposureEvent = true;
            exposureTriggerReason = (0, $b365c19bee2011b0$export$2c20ffeba7dbc068).Default;
        }
        // It is very common for products to call this method many times for the same flag key,
        // as flag evaluations are often done inside action callbacks and/or inside components with many instances.
        // We can cache the result of the first evaluation to avoid doing the same validation checks on every call.
        if (this.evaluationResult === undefined) this.evaluationResult = this.computeWithValidation(defaultValue, {
            oneOf: oneOf,
            ignoreTypes: ignoreTypes
        });
        let value = this.evaluationResult.value;
        if (this.evaluationResult.didFallbackToDefaultValue) // Use the default that was passed in, just in case it's different to what it was in the initial evaluation
        value = defaultValue;
        else if (shouldTrackExposureEvent) // For backwards compability, only fire the opt-in exposure event in valid evaluations.
        this.trackExposure(this.flagKey, this.flag, exposureTriggerReason, exposureData);
        this.sendAutomaticExposure(this.flagKey, value, this.evaluationResult.explanation);
        this.evaluationCount++;
        return {
            value: value,
            explanation: this.evaluationResult.explanation
        };
    }
    computeWithValidation(defaultValue, { oneOf: oneOf, ignoreTypes: ignoreTypes }) {
        let result = {
            value: this.flag.value,
            explanation: this.flag.explanation,
            didFallbackToDefaultValue: false
        };
        if (!ignoreTypes && typeof this.flag.value !== typeof defaultValue) {
            result.value = defaultValue;
            result.didFallbackToDefaultValue = true;
            result.explanation = {
                ...result.explanation || {},
                kind: 'ERROR',
                errorKind: 'WRONG_TYPE'
            };
        } else if (oneOf !== undefined && !oneOf.includes(this.flag.value)) {
            result.value = defaultValue;
            result.didFallbackToDefaultValue = true;
            result.explanation = {
                ...result.explanation || {},
                kind: 'ERROR',
                errorKind: 'VALIDATION_ERROR'
            };
        }
        return result;
    }
    getBooleanValue(options) {
        const flag = this.getCachedResultOrCompute(options.default, {
            exposureData: options.exposureData,
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            oneOf: undefined,
            ignoreTypes: this.ignoreTypes || false
        });
        return flag.value;
    }
    getVariantValue(options) {
        const flag = this.getCachedResultOrCompute(options.default, {
            exposureData: options.exposureData,
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            oneOf: options.oneOf,
            ignoreTypes: this.ignoreTypes || false
        });
        return flag.value;
    }
    getJSONValue() {
        return this.getCachedResultOrCompute({}, {
            shouldTrackExposureEvent: false,
            ignoreTypes: this.ignoreTypes
        }).value;
    }
    getRawValue(options) {
        return this.getCachedResultOrCompute(options.default, {
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            exposureData: options.exposureData,
            oneOf: undefined,
            ignoreTypes: true
        }).value;
    }
    getFlagEvaluation(options) {
        return this.getCachedResultOrCompute(options.default, {
            shouldTrackExposureEvent: options.shouldTrackExposureEvent,
            exposureData: options.exposureData,
            ignoreTypes: this.ignoreTypes || false
        });
    }
    constructor(flagKey, flag, trackExposure, sendAutomaticExposure, ignoreTypes){
        this.evaluationCount = void 0;
        this.flagKey = void 0;
        this.flag = void 0;
        this.trackExposure = void 0;
        this.sendAutomaticExposure = void 0;
        this.ignoreTypes = void 0;
        // Makes the casting easier later on. The APIs should not leak any.
        // Should only be used in private functions.
        this.evaluationResult = void 0;
        this.flagKey = flagKey;
        this.flag = flag;
        this.evaluationCount = 0;
        this.trackExposure = trackExposure;
        this.sendAutomaticExposure = sendAutomaticExposure;
        this.ignoreTypes = ignoreTypes;
    }
}


class $d4b3fead18833166$export$2e2bcd8739ae039 {
    setFlags(flags) {
        if (!(0, $cd316494f52abf99$export$a6cdc56e425d0d0a)(flags)) return;
        Object.entries(flags).forEach(([flagKey, flag])=>{
            this.flags.set(flagKey, flag);
        });
        // Clear any cached data for flags that have been passed in again,
        // in case they have different values or explanations
        for (const flagKey of this.flagWrapperCache.keys())if (flags.hasOwnProperty(flagKey)) this.flagWrapperCache.delete(flagKey);
    }
    setAnalyticsHandler(analyticsHandler) {
        this.analyticsHandler = analyticsHandler;
    }
    setIsAutomaticExposuresEnabled(isEnabled) {
        this.isAutomaticExposuresEnabled = isEnabled;
    }
    /**
   * This method returns the wrapper object for the given flag key.
   * If the flag does not exist, this will return a stubbed flag following the null-object pattern,
   * so it is always guaranteed to return an object.
   */ getFlagWrapper(flagKey) {
        let wrapper = this.flagWrapperCache.get(flagKey);
        if (wrapper !== undefined) return wrapper;
        const flag = this.flags.get(flagKey);
        if (flag) wrapper = new (0, $05314358ce6a7538$export$2e2bcd8739ae039)(flagKey, flag, this._trackExposure.bind(this), this.sendAutomaticExposure.bind(this), this.ignoreTypes);
        else wrapper = new (0, $8561d128cbf24ac4$export$2e2bcd8739ae039)();
        this.flagWrapperCache.set(flagKey, wrapper);
        return wrapper;
    }
    clear() {
        this.flags.clear();
        this.flagWrapperCache.clear();
        this.trackedFlags.clear();
    }
    getBooleanValue(flagKey, options) {
        (0, $cd316494f52abf99$export$c7d37910dd25ecbf)(options, [
            'default'
        ], 'getBooleanValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getBooleanValue(options);
    }
    getVariantValue(flagKey, options) {
        (0, $cd316494f52abf99$export$c7d37910dd25ecbf)(options, [
            'default',
            'oneOf'
        ], 'getVariantValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getVariantValue(options);
    }
    getJSONValue(flagKey) {
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getJSONValue();
    }
    getRawValue(flagKey, options) {
        (0, $cd316494f52abf99$export$c7d37910dd25ecbf)(options, [
            'default'
        ], 'getRawValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getRawValue(options);
    }
    getFlagEvaluation(flagKey, options) {
        (0, $cd316494f52abf99$export$c7d37910dd25ecbf)(options, [
            'default'
        ], 'getRawValue');
        const wrapper = this.getFlagWrapper(flagKey);
        return wrapper.getFlagEvaluation(options);
    }
    /**
   * This method combines both the trackExposure and sendAutomaticExposure flows into
   * one endpoint. Depending on the passed in trigger reason a manual or automatic exposure
   * is sent.
   **/ trackFeatureFlag(flagKey, options = {}) {
        const triggerReason = options?.triggerReason ? options.triggerReason : (0, $b365c19bee2011b0$export$2c20ffeba7dbc068).Manual;
        const isValueSet = this.flags.has(flagKey) || 'value' in options;
        if (!isValueSet) {
            // eslint-disable-next-line no-console
            console.warn(`No value associated with the flagKey: ${flagKey} with an exposure trigger reason of: ${triggerReason}`);
            return;
        }
        // if no values for flagValue and explanation supplied then retrieve them from the flags map
        const flagValue = 'value' in options ? options.value : this.flags.get(flagKey)?.value;
        const flagExplanation = options?.explanation ? options.explanation : this.flags.get(flagKey)?.explanation;
        if (triggerReason === (0, $b365c19bee2011b0$export$2c20ffeba7dbc068).AutoExposure) this.sendAutomaticExposure(flagKey, flagValue, flagExplanation);
        else // default to fire a manual track exposure
        this._trackExposure(flagKey, {
            value: flagValue,
            explanation: flagExplanation
        }, triggerReason);
    }
    trackExposure(flagKey, flag, exposureData = {}) {
        return this._trackExposure(flagKey, flag, (0, $b365c19bee2011b0$export$2c20ffeba7dbc068).Manual, exposureData);
    }
    _trackExposure(flagKey, flag, exposureTriggerReason, exposureData) {
        if (!(flag && flag.explanation && this.shouldSendEvent(flagKey, exposureData))) return;
        (0, $cd316494f52abf99$export$891630e169ca14a4)(exposureData);
        const flagAttributes = {
            flagKey: flagKey,
            reason: flag.explanation.kind,
            ruleId: flag.explanation.ruleId,
            value: flag.value
        };
        this.sendExposureEvent(flagAttributes, exposureTriggerReason, exposureData);
    }
    shouldSendEvent(flagKey, customAttributes) {
        return this.analyticsHandler !== undefined && (!this.trackedFlags.has(flagKey) || !(0, $cd316494f52abf99$export$8ed1df9dbe2e9a7d)(customAttributes) && !this.customAttributesExposuresCache.has(flagKey));
    }
    sendAutomaticExposure(flagKey, value, flagExplanation) {
        if (!(flagExplanation && this.isAutomaticExposuresEnabled && this.shouldSendEvent(flagKey))) return;
        const flagAttributes = {
            flagKey: flagKey,
            value: value,
            reason: flagExplanation.kind || 'SIMPLE_EVAL',
            // In theory this shouldnt be necessary
            ruleId: flagExplanation.ruleId,
            errorKind: flagExplanation.errorKind
        };
        this.sendExposureEvent(flagAttributes, (0, $b365c19bee2011b0$export$2c20ffeba7dbc068).AutoExposure);
    }
    sendExposureEvent(attributes, exposureTriggerReason, customAttributes) {
        if (!this.trackedFlags.has(attributes.flagKey)) {
            const exposureEvent = {
                action: 'exposed',
                actionSubject: 'feature',
                attributes: attributes,
                tags: [
                    'measurement',
                    exposureTriggerReason
                ],
                highPriority: false,
                source: '@atlaskit/feature-flag-client'
            };
            this.analyticsHandler?.sendOperationalEvent(exposureEvent);
            this.trackedFlags.add(attributes.flagKey);
        }
        // Due to the way we've simplified our pipeline, custom attributes are dropped from exposure
        // events. In order not to break existing users of this feature immediately, we're sending an
        // extra event that won't be consumed by our pipeline, but will end up in the `cloud.*` tables.
        // See: https://hello.atlassian.net/wiki/spaces/MEASURE/pages/1838596497/AtlasKit+TAC
        if (!(0, $cd316494f52abf99$export$8ed1df9dbe2e9a7d)(customAttributes)) {
            const customeAttributesExposureEvent = {
                action: 'exposed',
                actionSubject: 'feature',
                attributes: Object.assign({}, attributes, customAttributes),
                tags: [
                    'measurement',
                    (0, $b365c19bee2011b0$export$2c20ffeba7dbc068).hasCustomAttributes,
                    exposureTriggerReason
                ],
                highPriority: true,
                source: '@atlaskit/feature-flag-client'
            };
            this.analyticsHandler?.sendOperationalEvent(customeAttributesExposureEvent);
            this.customAttributesExposuresCache.add(attributes.flagKey);
        }
    }
    getFlagStats() {
        const flagStats = {};
        for (const [flagKey, wrapper] of this.flagWrapperCache){
            const { evaluationCount: evaluationCount } = wrapper;
            flagStats[flagKey] = {
                evaluationCount: evaluationCount
            };
        }
        return flagStats;
    }
    constructor(options){
        this.flags = void 0;
        this.flagWrapperCache = void 0;
        this.analyticsHandler = void 0;
        this.isAutomaticExposuresEnabled = void 0;
        this.trackedFlags = void 0;
        this.customAttributesExposuresCache = void 0;
        this.ignoreTypes = void 0;
        (0, $cd316494f52abf99$export$c7d37910dd25ecbf)(options, [
            'analyticsHandler'
        ], 'Feature Flag Client');
        const { flags: flags, analyticsHandler: analyticsHandler, isAutomaticExposuresEnabled: isAutomaticExposuresEnabled, ignoreTypes: ignoreTypes } = options;
        this.flags = new Map();
        this.flagWrapperCache = new Map();
        this.customAttributesExposuresCache = new Set();
        this.trackedFlags = new Set();
        this.isAutomaticExposuresEnabled = isAutomaticExposuresEnabled || false;
        this.ignoreTypes = ignoreTypes || false;
        this.setFlags(flags || {});
        this.setAnalyticsHandler(analyticsHandler);
    }
}






function $7a55ff9c881e37e5$export$30a0bf30ea993fb(value) {
    if (value === 'true') return true;
    else if (value === 'false') return false;
    else if (typeof value === 'object') return JSON.stringify(value);
    return value;
}
function $7a55ff9c881e37e5$export$254798ec7ef71406(objectList, valueGetter) {
    return objectList.reduce((keyedObject, item)=>{
        keyedObject[item.id] = valueGetter(item);
        return keyedObject;
    }, {});
}
const $7a55ff9c881e37e5$export$b474714fac955e7c = (flags)=>{
    return $7a55ff9c881e37e5$export$254798ec7ef71406(flags, (item)=>$7a55ff9c881e37e5$export$30a0bf30ea993fb(item.value));
};


function $f1239c91f558df40$var$normalizeValue(rawValue) {
    if (typeof rawValue === 'object' && 'value' in rawValue) return {
        ...rawValue.explanation ? {
            explanation: {
                ...rawValue.explanation
            }
        } : {},
        value: (0, $7a55ff9c881e37e5$export$30a0bf30ea993fb)(rawValue.value)
    };
    else return {
        value: (0, $7a55ff9c881e37e5$export$30a0bf30ea993fb)(rawValue),
        explanation: undefined
    };
}
const $f1239c91f558df40$var$noopAnalyticsHandler = {
    sendOperationalEvent: (_event)=>Promise.resolve()
};
const $f1239c91f558df40$export$8c9b5e98a87ea54c = (0, $8V6O9.default)((flags, platformFlags)=>{
    const normalizedFeatureFlags = flags ? (0, $7a55ff9c881e37e5$export$254798ec7ef71406)(flags, $f1239c91f558df40$var$normalizeValue) : {};
    const normalizedPlatformFeatureFlags = platformFlags != null ? (0, $7a55ff9c881e37e5$export$254798ec7ef71406)(platformFlags, $f1239c91f558df40$var$normalizeValue) : {};
    Object.assign(normalizedFeatureFlags, normalizedPlatformFeatureFlags);
    const featureFlagClient = new (0, $d4b3fead18833166$export$2e2bcd8739ae039)({
        flags: normalizedFeatureFlags,
        analyticsHandler: $f1239c91f558df40$var$noopAnalyticsHandler
    });
    // This sets up tooling for the editor experiments
    (0, $23abd0bdd1021e0f$export$1c2b6dbf79eb3560)('confluence');
    // This sets up the platform feature flags
    (0, $c04d14497c4aa1d8$export$ba05d765b8392e5e)((flagKey)=>{
        // eslint-disable-next-line confluence-feature-gating/static-feature-gates
        if ((0, $3df4286e75ff1ab6$export$b40ec24ac8275656)(flagKey)) return true;
        return false;
    });
    const allFlags = flags.concat(platformFlags);
    const original = (0, $7a55ff9c881e37e5$export$b474714fac955e7c)(allFlags);
    return {
        originalFeatureFlags: original,
        featureFlagsWithOverrides: original,
        featureFlagClient: featureFlagClient
    };
});


const $2800afeb4fc22c91$export$3aa1d70b86d65666 = ()=>$2800afeb4fc22c91$export$48ea97dcec207a60(null);
function $2800afeb4fc22c91$export$48ea97dcec207a60(data) {
    const { originalFeatureFlags: originalFeatureFlags, featureFlagsWithOverrides: featureFlagsWithOverrides, featureFlagClient: featureFlagClient } = (0, $f1239c91f558df40$export$8c9b5e98a87ea54c)([], []);
    // nullability of `tenant` is probably a schema issue
    // `userForAnalytics.id` would probably never be null, follow up with Xiao
    const confluenceLocale = data?.user?.confluence?.locale?.replace('_', '-');
    return {
        shard: data?.tenant?.shard || '',
        cloudId: data?.tenant?.cloudId || '',
        activationId: data?.tenant?.activationId || '',
        orgId: data?.organization?.orgId || undefined,
        environment: data?.tenant?.environment || 'PRODUCTION',
        edition: data?.confluence_tenantContext?.editions?.confluence || null,
        userId: data?.user?.id || null,
        displayName: data?.user?.displayName || null,
        isLoggedIn: Boolean(data?.user?.id),
        // CCP-472: This is for JSD users who are unlicensed for
        // Confluence usage. In that case, we need to skip
        // `WatchDialogQuery` as they are causing NullPointerExceptions
        // in the BE.
        isLicensed: Boolean(data?.user?.confluence?.accountId && data?.user?.confluence?.userKey),
        accessStatus: data?.user?.confluence?.accessStatus || null,
        userIdForAnalytics: data?.userForAnalytics?.id || null,
        featureFlags: featureFlagsWithOverrides,
        featureFlagClient: featureFlagClient,
        _originalFeatureFlags: originalFeatureFlags,
        locale: confluenceLocale || 'en-US',
        timeZone: data?.user?.timeZone || null,
        tenantTimeZone: data?.confluence_tenantContext?.timeZone || null,
        isAdminHubAIEnabled: Boolean(data?.getAIConfig?.isEnabled),
        isRovoEnabled: Boolean(data?.getAIConfig?.isRovoEnabled),
        isRovoLLMEnabled: Boolean(data?.getAIConfig?.isRovoLLMEnabled),
        monolithRegion: data?.confluence_tenantContext?.monolithRegion || null
    };
}


/* eslint-disable no-dupe-class-members */ class $e2dc1797b8fbbb8b$export$31c6869b8bca23f6 {
    run(name, fn) {
        const names = Array.isArray(name) ? name : [
            name
        ];
        names.forEach((name)=>this.markMeasureStart(name));
        const result = fn();
        if (typeof result?.then === 'function') // eslint-disable-next-line @typescript-eslint/no-floating-promises
        result.finally(()=>{
            names.forEach((name)=>this.markMeasureEnd(name));
        });
        else names.forEach((name)=>this.markMeasureEnd(name));
        return result;
    }
    markMeasureStart(name, timestamp) {
        //if startTime already marked, don't mark again.
        if (this.measures[name]?.startTime) return;
        this.measures[name] = {
            startTime: Math.floor(timestamp ?? performance.now()),
            duration: 0
        };
    }
    markMeasureEnd(name, timestamp, allowEndOnly = false) {
        const entry = this.measures[name];
        if (!entry?.duration && entry?.startTime) entry.duration = Math.floor((timestamp ?? performance.now()) - entry.startTime);
        else if (!entry && allowEndOnly) // In allowEndOnly mode we take FIRST end time as duration
        this.measures[name] = {
            startTime: 0,
            duration: timestamp ?? performance.now()
        };
    }
    getMeasures() {
        return this.measures;
    }
    clearMeasures() {
        this.measures = {};
    }
    constructor(){
        this.measures = {};
    }
}


class $47c7a260b3a5dfb3$var$SSRMeasure extends (0, $e2dc1797b8fbbb8b$export$31c6869b8bca23f6) {
    fetchCountIncr() {
        this.fetchCount++;
    }
    getFetchCount() {
        return this.fetchCount;
    }
    errorCountIncr() {
        this.errorCount++;
    }
    getErrorCount() {
        return this.errorCount;
    }
    operationsCountIncr() {
        this.operationsCount++;
    }
    getOperationsCount() {
        return this.operationsCount;
    }
    setIsBifrost(isBifrost) {
        this.isBifrost = isBifrost;
    }
    getIsBifrost() {
        return this.isBifrost;
    }
    /**
   * Transform a measure name (e.g., replace 'ssr-app' with 'bifrost-ssr')
   * Override this function to customize measure names
   */ transformMeasureName(name) {
        if (this.getIsBifrost() && name.includes('ssr-app/')) {
            name = name.replace('ssr-app', 'bifrost-ssr/tesseract');
            if (window.__SSR_REACT_STREAMING__ && name.includes('/render/')) name = name.replace('render', 'stream/render');
        }
        return name;
    }
    setStartTime(startTimeOffset = 0) {
        this.startTimeOffset = startTimeOffset;
        if (!this.startTime) this.startTime = Math.floor(performance.now());
    }
    getStartTime() {
        return this.startTime;
    }
    nowFromStartTime() {
        return Math.floor(performance.now()) - this.startTime;
    }
    now() {
        return this.nowFromStartTime() + this.startTimeOffset;
    }
    setMeasureDuration(name, duration) {
        const transformedName = this.transformMeasureName(name);
        const entry = this.measures[transformedName];
        if (entry) entry.duration = duration;
    }
    addMeasure(name, duration, offsetStartByDuration = false) {
        const transformedName = this.transformMeasureName(name);
        if (this.measures[transformedName]) return;
        this.measures[transformedName] = {
            startTime: offsetStartByDuration ? this.now() - duration : this.now(),
            duration: duration
        };
    }
    markMeasureStart(name) {
        const transformedName = this.transformMeasureName(name);
        if (!this.measures[transformedName]) this.measures[transformedName] = {
            startTime: this.now(),
            duration: 0
        };
    }
    markMeasureEnd(name) {
        const transformedName = this.transformMeasureName(name);
        const entry = this.measures[transformedName];
        if (entry) entry.duration = this.now() - entry.startTime;
    }
    clearMeasures() {
        this.isBifrost = false;
        this.startTimeOffset = 0;
        this.startTime = 0;
        this.fetchCount = 0;
        this.errorCount = 0;
        this.operationsCount = 0;
        this.measures = {};
    }
    constructor(...args){
        super(...args);
        this.startTimeOffset = 0;
        this.startTime = 0;
        // fetch count (counts batched operations as one fetch)
        this.fetchCount = 0;
        // total operations (counts individual operations even in batched operations)
        this.operationsCount = 0;
        this.errorCount = 0;
        this.isBifrost = false;
    }
}
const $47c7a260b3a5dfb3$export$5467c8c7fa0f4d06 = new $47c7a260b3a5dfb3$var$SSRMeasure();




var $dQwsT = parcelRequire("dQwsT");

function $8001e21998d25cdc$export$93aea9a3d680252e(error, statusCode, statusCodeAlternative) {
    if (error) {
        if ((0, $a73698f3e4fe6cd8$export$17f5e6bd290bb15d)(error)) return error.graphQLErrors?.some((graphQLError)=>$8001e21998d25cdc$var$isStatusCodeNonApolloError(graphQLError, statusCode, statusCodeAlternative)) || $8001e21998d25cdc$var$isStatusCodeNonApolloError(error?.networkError, statusCode, statusCodeAlternative);
        return $8001e21998d25cdc$var$isStatusCodeNonApolloError(error, statusCode, statusCodeAlternative);
    }
    return false;
}
function $8001e21998d25cdc$export$4b7f1fcb987c29b8(error) {
    if (error) {
        if ((0, $a73698f3e4fe6cd8$export$17f5e6bd290bb15d)(error)) {
            for (const graphQLError of error?.graphQLErrors || []){
                const result = $8001e21998d25cdc$var$getStatusCodeNonApolloError(graphQLError);
                if (result) return result;
            }
            const networkErrorStatusCode = $8001e21998d25cdc$var$getStatusCodeNonApolloError(error?.networkError);
            if (networkErrorStatusCode) return networkErrorStatusCode;
        }
        return $8001e21998d25cdc$var$getStatusCodeNonApolloError(error);
    }
    return undefined;
}
function $8001e21998d25cdc$var$isStatusCodeNonApolloError(error, statusCode, statusCodeAlternative) {
    if (error) {
        if ($8001e21998d25cdc$export$68868794c9b58e55(error) === statusCode || statusCodeAlternative?.(error)) return true;
        const { originalError: originalError } = error;
        if (originalError) return $8001e21998d25cdc$export$93aea9a3d680252e(originalError, statusCode, statusCodeAlternative);
    }
    return false;
}
function $8001e21998d25cdc$var$getStatusCodeNonApolloError(error) {
    if (error) {
        const result = $8001e21998d25cdc$export$68868794c9b58e55(error);
        if (result) return result;
        const { originalError: originalError } = error;
        if (originalError) return $8001e21998d25cdc$export$68868794c9b58e55(originalError);
    }
    return undefined;
}
function $8001e21998d25cdc$export$68868794c9b58e55(error) {
    if (error) {
        let status = error?.response?.status;
        if (status == null) {
            const { extensions: extensions } = error;
            if (extensions) status = extensions.statusCode || extensions.http?.status;
        }
        // Coercing to string because backend is inconsistent in the response type,
        // both string and number have been seen in practice:
        return status?.toString();
    }
    return undefined;
}



var $dQwsT = parcelRequire("dQwsT");

var $dQwsT = parcelRequire("dQwsT");
const $4aa6efa966e6f6e4$export$6ae4df695e19c5 = (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createContext(()=>false);
$4aa6efa966e6f6e4$export$6ae4df695e19c5.displayName = 'KnownErrorBoundaryContext';


class $13120d3a5460a891$export$a6c66dc6b08c87fe extends (0, $dQwsT.Component) {
    componentDidCatch(error) {
        if (this.props.isKnownError(error)) {
            this.props.onError?.(error);
            this.setState({
                error: error
            });
        } else throw error;
    }
    render() {
        const { error: error } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement((0, $4aa6efa966e6f6e4$export$6ae4df695e19c5).Consumer, null, (willCatch)=>{
            this.willParentCatch = willCatch;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement((0, $4aa6efa966e6f6e4$export$6ae4df695e19c5).Provider, {
                value: this.willCatch
            }, error ? this.props.renderOnError(error) : this.props.children);
        });
    }
    constructor(...args){
        super(...args);
        this.willParentCatch = void 0;
        this.state = {
            error: null
        };
        this.willCatch = (error)=>Boolean(this.props.isKnownError(error) || this.willParentCatch?.(error));
    }
}


const $6e2aeba1bc095709$export$616870549cbd985 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement((0, $13120d3a5460a891$export$a6c66dc6b08c87fe), {
        isKnownError: $6e2aeba1bc095709$export$55152de1f925fd05,
        ...props
    });
/**
 * https://pug.jira-dev.com/wiki/spaces/CCB/pages/4709260932/GraphQL+Errors+Contract+for+Status+Code+401+and+403
 */ const $6e2aeba1bc095709$var$isLegacyUnauthorizedGraphQLError = (error)=>error?.extensions?.data?.authorized === false;
const $6e2aeba1bc095709$export$55152de1f925fd05 = (error)=>(0, $8001e21998d25cdc$export$93aea9a3d680252e)(error, '403', $6e2aeba1bc095709$var$isLegacyUnauthorizedGraphQLError);





function $4b7988ce40c8fd3c$var$onGraphqlError(error) {
    (0, $d1c1e8e192b1a688$export$39a3b7739331403b)().submitError(error, {
        attribution: 'graphql'
    });
}
// NOTE: use `Symbol.for(...)` here because this module is bundled into two separate
// chunks - preloader and main app. Creating it via `Symbol(...)` will result in two
// different symbols, so errors that are handled in the preloader won't be identified
// as handled in the main app.
const $4b7988ce40c8fd3c$var$HANDLED_ERROR_MARK_SYMBOL = Symbol.for('error marked as handled');
class $4b7988ce40c8fd3c$export$bba8f5318e9cae27 {
    scheduleErrorReporting(error) {
        const timeoutId = window.setTimeout(()=>{
            // NOTE: This is an extra measure to prevent over-reporting of an otherwise handled error.
            // When query is preloaded and errors out, the reporting is scheduled by onErrorLink from
            // both preloader and from the place where query data is processed, but `errorsToHandle`
            // would only contain the entry of the error mapped to the latest timeoutId.
            if (this.isErrorMarkedAsHandled(error)) return;
            this.errorHandler(error);
            $4b7988ce40c8fd3c$export$702f853386561b84(error);
        }, this.gracefulHandlingPeriodMs);
        this.errorsToHandle.set(error, timeoutId);
    }
    // eslint-disable-next-line no-useless-constructor
    constructor(gracefulHandlingPeriodMs, errorHandler){
        this.gracefulHandlingPeriodMs = gracefulHandlingPeriodMs;
        this.errorHandler = errorHandler;
        // map of Error to timeoutId of when the generic error handling will kick-off
        this.errorsToHandle = new Map();
        this.processError = (error)=>{
            if (error) this.scheduleErrorReporting(error);
        };
        this.isErrorMarkedAsHandled = (error)=>{
            if (!error) return false;
            if (typeof error !== 'object') return false;
            return Boolean(error[$4b7988ce40c8fd3c$var$HANDLED_ERROR_MARK_SYMBOL]);
        };
        this.markErrorAsHandled = (error)=>{
            if (!error) return;
            if ((0, $a73698f3e4fe6cd8$export$17f5e6bd290bb15d)(error)) {
                (error.graphQLErrors || []).forEach((e)=>this.markErrorAsHandled(e));
                this.markErrorAsHandled(error.networkError);
            }
            const timeoutId = this.errorsToHandle.get(error);
            if (typeof error === 'object') error[$4b7988ce40c8fd3c$var$HANDLED_ERROR_MARK_SYMBOL] = true;
            window.clearTimeout(timeoutId);
            this.errorsToHandle.delete(error);
        };
    }
}
const $4b7988ce40c8fd3c$var$GRACEFUL_ERROR_HANDLING_PERIOD_MS = 100;
// GraphqlErrorProcessor is stateful and should be a singleton. Given that this module
// is bundled into two separate chunks - preloader and main app, we need to make sure
// that the same instance is used in both places.
const $4b7988ce40c8fd3c$var$graphqlErrorProcessor = new $4b7988ce40c8fd3c$export$bba8f5318e9cae27($4b7988ce40c8fd3c$var$GRACEFUL_ERROR_HANDLING_PERIOD_MS, $4b7988ce40c8fd3c$var$onGraphqlError);
const $4b7988ce40c8fd3c$export$db43d00048f0afe4 = $4b7988ce40c8fd3c$var$GRACEFUL_ERROR_HANDLING_PERIOD_MS;
const $4b7988ce40c8fd3c$export$702f853386561b84 = $4b7988ce40c8fd3c$var$graphqlErrorProcessor.markErrorAsHandled;
const $4b7988ce40c8fd3c$export$792efb60958ecf86 = $4b7988ce40c8fd3c$var$graphqlErrorProcessor.isErrorMarkedAsHandled;
const $4b7988ce40c8fd3c$export$83457a6c00af4df7 = $4b7988ce40c8fd3c$var$graphqlErrorProcessor.processError;


/** @graphql cc **/ 
var $dEf6I = parcelRequire("dEf6I");

function $cec865aa99f5c1d2$export$bbee0c6176c019d4(source, position, description) {
    return new (0, $982b88782a45b92f$export$92d6ed0888e7cb7f)("Syntax Error: ".concat(description), undefined, source, [
        position
    ]);
}


/**
 * The set of allowed kind values for AST nodes.
 */ var $274fc6e4b3beb099$export$a84bdc57c5122798 = Object.freeze({
    // Name
    NAME: 'Name',
    // Document
    DOCUMENT: 'Document',
    OPERATION_DEFINITION: 'OperationDefinition',
    VARIABLE_DEFINITION: 'VariableDefinition',
    SELECTION_SET: 'SelectionSet',
    FIELD: 'Field',
    ARGUMENT: 'Argument',
    // Fragments
    FRAGMENT_SPREAD: 'FragmentSpread',
    INLINE_FRAGMENT: 'InlineFragment',
    FRAGMENT_DEFINITION: 'FragmentDefinition',
    // Values
    VARIABLE: 'Variable',
    INT: 'IntValue',
    FLOAT: 'FloatValue',
    STRING: 'StringValue',
    BOOLEAN: 'BooleanValue',
    NULL: 'NullValue',
    ENUM: 'EnumValue',
    LIST: 'ListValue',
    OBJECT: 'ObjectValue',
    OBJECT_FIELD: 'ObjectField',
    // Directives
    DIRECTIVE: 'Directive',
    // Types
    NAMED_TYPE: 'NamedType',
    LIST_TYPE: 'ListType',
    NON_NULL_TYPE: 'NonNullType',
    // Type System Definitions
    SCHEMA_DEFINITION: 'SchemaDefinition',
    OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',
    // Type Definitions
    SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
    OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
    FIELD_DEFINITION: 'FieldDefinition',
    INPUT_VALUE_DEFINITION: 'InputValueDefinition',
    INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
    UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
    ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
    ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
    INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',
    // Directive Definitions
    DIRECTIVE_DEFINITION: 'DirectiveDefinition',
    // Type System Extensions
    SCHEMA_EXTENSION: 'SchemaExtension',
    // Type Extensions
    SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
    OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
    INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
    UNION_TYPE_EXTENSION: 'UnionTypeExtension',
    ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
    INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension'
}); /**
 * The enum type representing the possible kind values of AST nodes.
 */ 



var $bZ4GO = parcelRequire("bZ4GO");
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $0697d866a04062ba$export$8b9d26ab11394711 = Object.freeze({
    SOF: '<SOF>',
    EOF: '<EOF>',
    BANG: '!',
    DOLLAR: '$',
    AMP: '&',
    PAREN_L: '(',
    PAREN_R: ')',
    SPREAD: '...',
    COLON: ':',
    EQUALS: '=',
    AT: '@',
    BRACKET_L: '[',
    BRACKET_R: ']',
    BRACE_L: '{',
    PIPE: '|',
    BRACE_R: '}',
    NAME: 'Name',
    INT: 'Int',
    FLOAT: 'Float',
    STRING: 'String',
    BLOCK_STRING: 'BlockString',
    COMMENT: 'Comment'
}); /**
 * The enum type representing the token kinds values.
 */ 




var $jPgXJ = parcelRequire("jPgXJ");


function $fda1cd84ea5796ec$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $fda1cd84ea5796ec$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $fda1cd84ea5796ec$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $fda1cd84ea5796ec$var$_typeof(obj);
}
var /**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 */ // See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
// See: https://webpack.js.org/guides/production/
$fda1cd84ea5796ec$export$2e2bcd8739ae039 = // eslint-disable-next-line no-shadow
function instanceOf(value, constructor) {
    return value instanceof constructor;
};


function $5c599005b6a89224$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $5c599005b6a89224$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $5c599005b6a89224$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5c599005b6a89224$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $5c599005b6a89224$export$1d2df86270c81ecb = /*#__PURE__*/ function() {
    function Source(body) {
        var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GraphQL request';
        var locationOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
            line: 1,
            column: 1
        };
        typeof body === 'string' || (0, $1c4c77440cd9ad0f$export$2e2bcd8739ae039)(0, "Body must be a string. Received: ".concat((0, $jPgXJ.default)(body), "."));
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, $1c4c77440cd9ad0f$export$2e2bcd8739ae039)(0, 'line in locationOffset is 1-indexed and must be positive.');
        this.locationOffset.column > 0 || (0, $1c4c77440cd9ad0f$export$2e2bcd8739ae039)(0, 'column in locationOffset is 1-indexed and must be positive.');
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    $5c599005b6a89224$var$_createClass(Source, [
        {
            key: (0, $ce670c3d0cd6efc8$export$5deadc579ccc7c9c),
            get: function get() {
                return 'Source';
            }
        }
    ]);
    return Source;
}();
function $5c599005b6a89224$export$75135ee9ed6e435b(source) {
    return (0, $fda1cd84ea5796ec$export$2e2bcd8739ae039)(source, $5c599005b6a89224$export$1d2df86270c81ecb);
}


/**
 * The set of allowed directive location values.
 */ var $da9694282a46a1b7$export$b45ffd2948484c41 = Object.freeze({
    // Request Definitions
    QUERY: 'QUERY',
    MUTATION: 'MUTATION',
    SUBSCRIPTION: 'SUBSCRIPTION',
    FIELD: 'FIELD',
    FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
    FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
    INLINE_FRAGMENT: 'INLINE_FRAGMENT',
    VARIABLE_DEFINITION: 'VARIABLE_DEFINITION',
    // Type System Definitions
    SCHEMA: 'SCHEMA',
    SCALAR: 'SCALAR',
    OBJECT: 'OBJECT',
    FIELD_DEFINITION: 'FIELD_DEFINITION',
    ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
    INTERFACE: 'INTERFACE',
    UNION: 'UNION',
    ENUM: 'ENUM',
    ENUM_VALUE: 'ENUM_VALUE',
    INPUT_OBJECT: 'INPUT_OBJECT',
    INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
}); /**
 * The enum type representing the directive location values.
 */ 




var $bZ4GO = parcelRequire("bZ4GO");

/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */ function $dd10f694715ed72c$export$fd88c0b652c46ccc(rawString) {
    // Expand a block string's raw value into independent lines.
    var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.
    var commonIndent = $dd10f694715ed72c$export$3c95bfdc680af0c(rawString);
    if (commonIndent !== 0) for(var i = 1; i < lines.length; i++)lines[i] = lines[i].slice(commonIndent);
     // Remove leading and trailing blank lines.
    var startLine = 0;
    while(startLine < lines.length && $dd10f694715ed72c$var$isBlank(lines[startLine]))++startLine;
    var endLine = lines.length;
    while(endLine > startLine && $dd10f694715ed72c$var$isBlank(lines[endLine - 1]))--endLine;
     // Return a string of the lines joined with U+000A.
    return lines.slice(startLine, endLine).join('\n');
}
function $dd10f694715ed72c$var$isBlank(str) {
    for(var i = 0; i < str.length; ++i){
        if (str[i] !== ' ' && str[i] !== '\t') return false;
    }
    return true;
}
function $dd10f694715ed72c$export$3c95bfdc680af0c(value) {
    var _commonIndent;
    var isFirstLine = true;
    var isEmptyLine = true;
    var indent = 0;
    var commonIndent = null;
    for(var i = 0; i < value.length; ++i)switch(value.charCodeAt(i)){
        case 13:
            //  \r
            if (value.charCodeAt(i + 1) === 10) ++i; // skip \r\n as one symbol
        // falls through
        case 10:
            //  \n
            isFirstLine = false;
            isEmptyLine = true;
            indent = 0;
            break;
        case 9:
        case 32:
            //  <space>
            ++indent;
            break;
        default:
            if (isEmptyLine && !isFirstLine && (commonIndent === null || indent < commonIndent)) commonIndent = indent;
            isEmptyLine = false;
    }
    return (_commonIndent = commonIndent) !== null && _commonIndent !== void 0 ? _commonIndent : 0;
}
function $dd10f694715ed72c$export$adb6ca997eeb1f45(value) {
    var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isSingleLine = value.indexOf('\n') === -1;
    var hasLeadingSpace = value[0] === ' ' || value[0] === '\t';
    var hasTrailingQuote = value[value.length - 1] === '"';
    var hasTrailingSlash = value[value.length - 1] === '\\';
    var printAsMultipleLines = !isSingleLine || hasTrailingQuote || hasTrailingSlash || preferMultipleLines;
    var result = ''; // Format a multi-line block quote to account for leading space.
    if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) result += '\n' + indentation;
    result += indentation ? value.replace(/\n/g, '\n' + indentation) : value;
    if (printAsMultipleLines) result += '\n';
    return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}


var $8cbf720e5e8ae755$export$6168dc8908a6c652 = /*#__PURE__*/ function() {
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   */ /**
   * The character offset at which the current line begins.
   */ function Lexer(source) {
        var startOfFileToken = new (0, $bZ4GO.Token)((0, $0697d866a04062ba$export$8b9d26ab11394711).SOF, 0, 0, 0, 0, null);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ var _proto = Lexer.prototype;
    _proto.advance = function advance() {
        this.lastToken = this.token;
        var token = this.token = this.lookahead();
        return token;
    } /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */ ;
    _proto.lookahead = function lookahead() {
        var token = this.token;
        if (token.kind !== (0, $0697d866a04062ba$export$8b9d26ab11394711).EOF) do {
            var _token$next;
            // Note: next is only mutable during parsing, so we cast to allow this.
            token = (_token$next = token.next) !== null && _token$next !== void 0 ? _token$next : token.next = $8cbf720e5e8ae755$var$readToken(this, token);
        }while (token.kind === (0, $0697d866a04062ba$export$8b9d26ab11394711).COMMENT);
        return token;
    };
    return Lexer;
}();
function $8cbf720e5e8ae755$export$59ac0f4da287406a(kind) {
    return kind === (0, $0697d866a04062ba$export$8b9d26ab11394711).BANG || kind === (0, $0697d866a04062ba$export$8b9d26ab11394711).DOLLAR || kind === (0, $0697d866a04062ba$export$8b9d26ab11394711).AMP || kind === (0, $0697d866a04062ba$export$8b9d26ab11394711).PAREN_L || kind === (0, $0697d866a04062ba$export$8b9d26ab11394711).PAREN_R || kind === (0, $0697d866a04062ba$export$8b9d26ab11394711).SPREAD || kind === (0, $0697d866a04062ba$export$8b9d26ab11394711).COLON || kind === (0, $0697d866a04062ba$export$8b9d26ab11394711).EQUALS || kind === (0, $0697d866a04062ba$export$8b9d26ab11394711).AT || kind === (0, $0697d866a04062ba$export$8b9d26ab11394711).BRACKET_L || kind === (0, $0697d866a04062ba$export$8b9d26ab11394711).BRACKET_R || kind === (0, $0697d866a04062ba$export$8b9d26ab11394711).BRACE_L || kind === (0, $0697d866a04062ba$export$8b9d26ab11394711).PIPE || kind === (0, $0697d866a04062ba$export$8b9d26ab11394711).BRACE_R;
}
function $8cbf720e5e8ae755$var$printCharCode(code) {
    return isNaN(code) ? (0, $0697d866a04062ba$export$8b9d26ab11394711).EOF : code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : "\"\\u".concat(('00' + code.toString(16).toUpperCase()).slice(-4), "\"");
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function $8cbf720e5e8ae755$var$readToken(lexer, prev) {
    var source = lexer.source;
    var body = source.body;
    var bodyLength = body.length;
    var pos = prev.end;
    while(pos < bodyLength){
        var code = body.charCodeAt(pos);
        var _line = lexer.line;
        var _col = 1 + pos - lexer.lineStart; // SourceCharacter
        switch(code){
            case 0xfeff:
            case 9:
            case 32:
            case 44:
                //  ,
                ++pos;
                continue;
            case 10:
                //  \n
                ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 13:
                //  \r
                if (body.charCodeAt(pos + 1) === 10) pos += 2;
                else ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 33:
                //  !
                return new (0, $bZ4GO.Token)((0, $0697d866a04062ba$export$8b9d26ab11394711).BANG, pos, pos + 1, _line, _col, prev);
            case 35:
                //  #
                return $8cbf720e5e8ae755$var$readComment(source, pos, _line, _col, prev);
            case 36:
                //  $
                return new (0, $bZ4GO.Token)((0, $0697d866a04062ba$export$8b9d26ab11394711).DOLLAR, pos, pos + 1, _line, _col, prev);
            case 38:
                //  &
                return new (0, $bZ4GO.Token)((0, $0697d866a04062ba$export$8b9d26ab11394711).AMP, pos, pos + 1, _line, _col, prev);
            case 40:
                //  (
                return new (0, $bZ4GO.Token)((0, $0697d866a04062ba$export$8b9d26ab11394711).PAREN_L, pos, pos + 1, _line, _col, prev);
            case 41:
                //  )
                return new (0, $bZ4GO.Token)((0, $0697d866a04062ba$export$8b9d26ab11394711).PAREN_R, pos, pos + 1, _line, _col, prev);
            case 46:
                //  .
                if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) return new (0, $bZ4GO.Token)((0, $0697d866a04062ba$export$8b9d26ab11394711).SPREAD, pos, pos + 3, _line, _col, prev);
                break;
            case 58:
                //  :
                return new (0, $bZ4GO.Token)((0, $0697d866a04062ba$export$8b9d26ab11394711).COLON, pos, pos + 1, _line, _col, prev);
            case 61:
                //  =
                return new (0, $bZ4GO.Token)((0, $0697d866a04062ba$export$8b9d26ab11394711).EQUALS, pos, pos + 1, _line, _col, prev);
            case 64:
                //  @
                return new (0, $bZ4GO.Token)((0, $0697d866a04062ba$export$8b9d26ab11394711).AT, pos, pos + 1, _line, _col, prev);
            case 91:
                //  [
                return new (0, $bZ4GO.Token)((0, $0697d866a04062ba$export$8b9d26ab11394711).BRACKET_L, pos, pos + 1, _line, _col, prev);
            case 93:
                //  ]
                return new (0, $bZ4GO.Token)((0, $0697d866a04062ba$export$8b9d26ab11394711).BRACKET_R, pos, pos + 1, _line, _col, prev);
            case 123:
                // {
                return new (0, $bZ4GO.Token)((0, $0697d866a04062ba$export$8b9d26ab11394711).BRACE_L, pos, pos + 1, _line, _col, prev);
            case 124:
                // |
                return new (0, $bZ4GO.Token)((0, $0697d866a04062ba$export$8b9d26ab11394711).PIPE, pos, pos + 1, _line, _col, prev);
            case 125:
                // }
                return new (0, $bZ4GO.Token)((0, $0697d866a04062ba$export$8b9d26ab11394711).BRACE_R, pos, pos + 1, _line, _col, prev);
            case 34:
                //  "
                if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) return $8cbf720e5e8ae755$var$readBlockString(source, pos, _line, _col, prev, lexer);
                return $8cbf720e5e8ae755$var$readString(source, pos, _line, _col, prev);
            case 45:
            case 48:
            case 49:
            case 50:
            case 51:
            case 52:
            case 53:
            case 54:
            case 55:
            case 56:
            case 57:
                //  9
                return $8cbf720e5e8ae755$var$readNumber(source, pos, code, _line, _col, prev);
            case 65:
            case 66:
            case 67:
            case 68:
            case 69:
            case 70:
            case 71:
            case 72:
            case 73:
            case 74:
            case 75:
            case 76:
            case 77:
            case 78:
            case 79:
            case 80:
            case 81:
            case 82:
            case 83:
            case 84:
            case 85:
            case 86:
            case 87:
            case 88:
            case 89:
            case 90:
            case 95:
            case 97:
            case 98:
            case 99:
            case 100:
            case 101:
            case 102:
            case 103:
            case 104:
            case 105:
            case 106:
            case 107:
            case 108:
            case 109:
            case 110:
            case 111:
            case 112:
            case 113:
            case 114:
            case 115:
            case 116:
            case 117:
            case 118:
            case 119:
            case 120:
            case 121:
            case 122:
                // z
                return $8cbf720e5e8ae755$var$readName(source, pos, _line, _col, prev);
        }
        throw (0, $cec865aa99f5c1d2$export$bbee0c6176c019d4)(source, pos, $8cbf720e5e8ae755$var$unexpectedCharacterMessage(code));
    }
    var line = lexer.line;
    var col = 1 + pos - lexer.lineStart;
    return new (0, $bZ4GO.Token)((0, $0697d866a04062ba$export$8b9d26ab11394711).EOF, bodyLength, bodyLength, line, col, prev);
}
/**
 * Report a message that an unexpected character was encountered.
 */ function $8cbf720e5e8ae755$var$unexpectedCharacterMessage(code) {
    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) return "Cannot contain the invalid character ".concat($8cbf720e5e8ae755$var$printCharCode(code), ".");
    if (code === 39) // '
    return 'Unexpected single quote character (\'), did you mean to use a double quote (")?';
    return "Cannot parse the unexpected character ".concat($8cbf720e5e8ae755$var$printCharCode(code), ".");
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */ function $8cbf720e5e8ae755$var$readComment(source, start, line, col, prev) {
    var body = source.body;
    var code;
    var position = start;
    do code = body.charCodeAt(++position);
    while (!isNaN(code) && (code > 0x001f || code === 0x0009));
    return new (0, $bZ4GO.Token)((0, $0697d866a04062ba$export$8b9d26ab11394711).COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */ function $8cbf720e5e8ae755$var$readNumber(source, start, firstCode, line, col, prev) {
    var body = source.body;
    var code = firstCode;
    var position = start;
    var isFloat = false;
    if (code === 45) // -
    code = body.charCodeAt(++position);
    if (code === 48) {
        // 0
        code = body.charCodeAt(++position);
        if (code >= 48 && code <= 57) throw (0, $cec865aa99f5c1d2$export$bbee0c6176c019d4)(source, position, "Invalid number, unexpected digit after 0: ".concat($8cbf720e5e8ae755$var$printCharCode(code), "."));
    } else {
        position = $8cbf720e5e8ae755$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 46) {
        // .
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $8cbf720e5e8ae755$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 69 || code === 101) {
        // E e
        isFloat = true;
        code = body.charCodeAt(++position);
        if (code === 43 || code === 45) // + -
        code = body.charCodeAt(++position);
        position = $8cbf720e5e8ae755$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 46 || $8cbf720e5e8ae755$var$isNameStart(code)) throw (0, $cec865aa99f5c1d2$export$bbee0c6176c019d4)(source, position, "Invalid number, expected digit but got: ".concat($8cbf720e5e8ae755$var$printCharCode(code), "."));
    return new (0, $bZ4GO.Token)(isFloat ? (0, $0697d866a04062ba$export$8b9d26ab11394711).FLOAT : (0, $0697d866a04062ba$export$8b9d26ab11394711).INT, start, position, line, col, prev, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */ function $8cbf720e5e8ae755$var$readDigits(source, start, firstCode) {
    var body = source.body;
    var position = start;
    var code = firstCode;
    if (code >= 48 && code <= 57) {
        // 0 - 9
        do code = body.charCodeAt(++position);
        while (code >= 48 && code <= 57); // 0 - 9
        return position;
    }
    throw (0, $cec865aa99f5c1d2$export$bbee0c6176c019d4)(source, position, "Invalid number, expected digit but got: ".concat($8cbf720e5e8ae755$var$printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */ function $8cbf720e5e8ae755$var$readString(source, start, line, col, prev) {
    var body = source.body;
    var position = start + 1;
    var chunkStart = position;
    var code = 0;
    var value = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position)) && // not LineTerminator
    code !== 0x000a && code !== 0x000d){
        // Closing Quote (")
        if (code === 34) {
            value += body.slice(chunkStart, position);
            return new (0, $bZ4GO.Token)((0, $0697d866a04062ba$export$8b9d26ab11394711).STRING, start, position + 1, line, col, prev, value);
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009) throw (0, $cec865aa99f5c1d2$export$bbee0c6176c019d4)(source, position, "Invalid character within String: ".concat($8cbf720e5e8ae755$var$printCharCode(code), "."));
        ++position;
        if (code === 92) {
            // \
            value += body.slice(chunkStart, position - 1);
            code = body.charCodeAt(position);
            switch(code){
                case 34:
                    value += '"';
                    break;
                case 47:
                    value += '/';
                    break;
                case 92:
                    value += '\\';
                    break;
                case 98:
                    value += '\b';
                    break;
                case 102:
                    value += '\f';
                    break;
                case 110:
                    value += '\n';
                    break;
                case 114:
                    value += '\r';
                    break;
                case 116:
                    value += '\t';
                    break;
                case 117:
                    // uXXXX
                    var charCode = $8cbf720e5e8ae755$var$uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));
                    if (charCode < 0) {
                        var invalidSequence = body.slice(position + 1, position + 5);
                        throw (0, $cec865aa99f5c1d2$export$bbee0c6176c019d4)(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
                    }
                    value += String.fromCharCode(charCode);
                    position += 4;
                    break;
                default:
                    throw (0, $cec865aa99f5c1d2$export$bbee0c6176c019d4)(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
            }
            ++position;
            chunkStart = position;
        }
    }
    throw (0, $cec865aa99f5c1d2$export$bbee0c6176c019d4)(source, position, 'Unterminated string.');
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */ function $8cbf720e5e8ae755$var$readBlockString(source, start, line, col, prev, lexer) {
    var body = source.body;
    var position = start + 3;
    var chunkStart = position;
    var code = 0;
    var rawValue = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position))){
        // Closing Triple-Quote (""")
        if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
            rawValue += body.slice(chunkStart, position);
            return new (0, $bZ4GO.Token)((0, $0697d866a04062ba$export$8b9d26ab11394711).BLOCK_STRING, start, position + 3, line, col, prev, (0, $dd10f694715ed72c$export$fd88c0b652c46ccc)(rawValue));
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) throw (0, $cec865aa99f5c1d2$export$bbee0c6176c019d4)(source, position, "Invalid character within String: ".concat($8cbf720e5e8ae755$var$printCharCode(code), "."));
        if (code === 10) {
            // new line
            ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 13) {
            // carriage return
            if (body.charCodeAt(position + 1) === 10) position += 2;
            else ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
            rawValue += body.slice(chunkStart, position) + '"""';
            position += 4;
            chunkStart = position;
        } else ++position;
    }
    throw (0, $cec865aa99f5c1d2$export$bbee0c6176c019d4)(source, position, 'Unterminated string.');
}
/**
 * Converts four hexadecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */ function $8cbf720e5e8ae755$var$uniCharCode(a, b, c, d) {
    return $8cbf720e5e8ae755$var$char2hex(a) << 12 | $8cbf720e5e8ae755$var$char2hex(b) << 8 | $8cbf720e5e8ae755$var$char2hex(c) << 4 | $8cbf720e5e8ae755$var$char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */ function $8cbf720e5e8ae755$var$char2hex(a) {
    return a >= 48 && a <= 57 ? a - 48 // 0-9
     : a >= 65 && a <= 70 ? a - 55 // A-F
     : a >= 97 && a <= 102 ? a - 87 // a-f
     : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */ function $8cbf720e5e8ae755$var$readName(source, start, line, col, prev) {
    var body = source.body;
    var bodyLength = body.length;
    var position = start + 1;
    var code = 0;
    while(position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || // _
    code >= 48 && code <= 57 || // 0-9
    code >= 65 && code <= 90 || // A-Z
    code >= 97 && code <= 122 // a-z
    ))++position;
    return new (0, $bZ4GO.Token)((0, $0697d866a04062ba$export$8b9d26ab11394711).NAME, start, position, line, col, prev, body.slice(start, position));
} // _ A-Z a-z
function $8cbf720e5e8ae755$var$isNameStart(code) {
    return code === 95 || code >= 65 && code <= 90 || code >= 97 && code <= 122;
}


function $f435c4751a3a8e47$export$98e6a39c04603d36(source, options) {
    var parser = new $f435c4751a3a8e47$export$7acfa6ed01010e37(source, options);
    return parser.parseDocument();
}
function $f435c4751a3a8e47$export$5303528d1070ff6f(source, options) {
    var parser = new $f435c4751a3a8e47$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $0697d866a04062ba$export$8b9d26ab11394711).SOF);
    var value = parser.parseValueLiteral(false);
    parser.expectToken((0, $0697d866a04062ba$export$8b9d26ab11394711).EOF);
    return value;
}
function $f435c4751a3a8e47$export$28b8f402ccc88182(source, options) {
    var parser = new $f435c4751a3a8e47$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $0697d866a04062ba$export$8b9d26ab11394711).SOF);
    var type = parser.parseTypeReference();
    parser.expectToken((0, $0697d866a04062ba$export$8b9d26ab11394711).EOF);
    return type;
}
var $f435c4751a3a8e47$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser(source, options) {
        var sourceObj = (0, $5c599005b6a89224$export$75135ee9ed6e435b)(source) ? source : new (0, $5c599005b6a89224$export$1d2df86270c81ecb)(source);
        this._lexer = new (0, $8cbf720e5e8ae755$export$6168dc8908a6c652)(sourceObj);
        this._options = options;
    }
    /**
   * Converts a name lex token into a name parse node.
   */ var _proto = Parser.prototype;
    _proto.parseName = function parseName() {
        var token = this.expectToken((0, $0697d866a04062ba$export$8b9d26ab11394711).NAME);
        return {
            kind: (0, $274fc6e4b3beb099$export$a84bdc57c5122798).NAME,
            value: token.value,
            loc: this.loc(token)
        };
    } // Implements the parsing rules in the Document section.
     /**
   * Document : Definition+
   */ ;
    _proto.parseDocument = function parseDocument() {
        var start = this._lexer.token;
        return {
            kind: (0, $274fc6e4b3beb099$export$a84bdc57c5122798).DOCUMENT,
            definitions: this.many((0, $0697d866a04062ba$export$8b9d26ab11394711).SOF, this.parseDefinition, (0, $0697d866a04062ba$export$8b9d26ab11394711).EOF),
            loc: this.loc(start)
        };
    } /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   */ ;
    _proto.parseDefinition = function parseDefinition() {
        if (this.peek((0, $0697d866a04062ba$export$8b9d26ab11394711).NAME)) switch(this._lexer.token.value){
            case 'query':
            case 'mutation':
            case 'subscription':
                return this.parseOperationDefinition();
            case 'fragment':
                return this.parseFragmentDefinition();
            case 'schema':
            case 'scalar':
            case 'type':
            case 'interface':
            case 'union':
            case 'enum':
            case 'input':
            case 'directive':
                return this.parseTypeSystemDefinition();
            case 'extend':
                return this.parseTypeSystemExtension();
        }
        else if (this.peek((0, $0697d866a04062ba$export$8b9d26ab11394711).BRACE_L)) return this.parseOperationDefinition();
        else if (this.peekDescription()) return this.parseTypeSystemDefinition();
        throw this.unexpected();
    } // Implements the parsing rules in the Operations section.
     /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */ ;
    _proto.parseOperationDefinition = function parseOperationDefinition() {
        var start = this._lexer.token;
        if (this.peek((0, $0697d866a04062ba$export$8b9d26ab11394711).BRACE_L)) return {
            kind: (0, $274fc6e4b3beb099$export$a84bdc57c5122798).OPERATION_DEFINITION,
            operation: 'query',
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        var operation = this.parseOperationType();
        var name;
        if (this.peek((0, $0697d866a04062ba$export$8b9d26ab11394711).NAME)) name = this.parseName();
        return {
            kind: (0, $274fc6e4b3beb099$export$a84bdc57c5122798).OPERATION_DEFINITION,
            operation: operation,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * OperationType : one of query mutation subscription
   */ ;
    _proto.parseOperationType = function parseOperationType() {
        var operationToken = this.expectToken((0, $0697d866a04062ba$export$8b9d26ab11394711).NAME);
        switch(operationToken.value){
            case 'query':
                return 'query';
            case 'mutation':
                return 'mutation';
            case 'subscription':
                return 'subscription';
        }
        throw this.unexpected(operationToken);
    } /**
   * VariableDefinitions : ( VariableDefinition+ )
   */ ;
    _proto.parseVariableDefinitions = function parseVariableDefinitions() {
        return this.optionalMany((0, $0697d866a04062ba$export$8b9d26ab11394711).PAREN_L, this.parseVariableDefinition, (0, $0697d866a04062ba$export$8b9d26ab11394711).PAREN_R);
    } /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseVariableDefinition = function parseVariableDefinition() {
        var start = this._lexer.token;
        return {
            kind: (0, $274fc6e4b3beb099$export$a84bdc57c5122798).VARIABLE_DEFINITION,
            variable: this.parseVariable(),
            type: (this.expectToken((0, $0697d866a04062ba$export$8b9d26ab11394711).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, $0697d866a04062ba$export$8b9d26ab11394711).EQUALS) ? this.parseValueLiteral(true) : undefined,
            directives: this.parseDirectives(true),
            loc: this.loc(start)
        };
    } /**
   * Variable : $ Name
   */ ;
    _proto.parseVariable = function parseVariable() {
        var start = this._lexer.token;
        this.expectToken((0, $0697d866a04062ba$export$8b9d26ab11394711).DOLLAR);
        return {
            kind: (0, $274fc6e4b3beb099$export$a84bdc57c5122798).VARIABLE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } /**
   * SelectionSet : { Selection+ }
   */ ;
    _proto.parseSelectionSet = function parseSelectionSet() {
        var start = this._lexer.token;
        return {
            kind: (0, $274fc6e4b3beb099$export$a84bdc57c5122798).SELECTION_SET,
            selections: this.many((0, $0697d866a04062ba$export$8b9d26ab11394711).BRACE_L, this.parseSelection, (0, $0697d866a04062ba$export$8b9d26ab11394711).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */ ;
    _proto.parseSelection = function parseSelection() {
        return this.peek((0, $0697d866a04062ba$export$8b9d26ab11394711).SPREAD) ? this.parseFragment() : this.parseField();
    } /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */ ;
    _proto.parseField = function parseField() {
        var start = this._lexer.token;
        var nameOrAlias = this.parseName();
        var alias;
        var name;
        if (this.expectOptionalToken((0, $0697d866a04062ba$export$8b9d26ab11394711).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return {
            kind: (0, $274fc6e4b3beb099$export$a84bdc57c5122798).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, $0697d866a04062ba$export$8b9d26ab11394711).BRACE_L) ? this.parseSelectionSet() : undefined,
            loc: this.loc(start)
        };
    } /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */ ;
    _proto.parseArguments = function parseArguments(isConst) {
        var item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, $0697d866a04062ba$export$8b9d26ab11394711).PAREN_L, item, (0, $0697d866a04062ba$export$8b9d26ab11394711).PAREN_R);
    } /**
   * Argument[Const] : Name : Value[?Const]
   */ ;
    _proto.parseArgument = function parseArgument() {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $0697d866a04062ba$export$8b9d26ab11394711).COLON);
        return {
            kind: (0, $274fc6e4b3beb099$export$a84bdc57c5122798).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(false),
            loc: this.loc(start)
        };
    };
    _proto.parseConstArgument = function parseConstArgument() {
        var start = this._lexer.token;
        return {
            kind: (0, $274fc6e4b3beb099$export$a84bdc57c5122798).ARGUMENT,
            name: this.parseName(),
            value: (this.expectToken((0, $0697d866a04062ba$export$8b9d26ab11394711).COLON), this.parseValueLiteral(true)),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Fragments section.
     /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */ ;
    _proto.parseFragment = function parseFragment() {
        var start = this._lexer.token;
        this.expectToken((0, $0697d866a04062ba$export$8b9d26ab11394711).SPREAD);
        var hasTypeCondition = this.expectOptionalKeyword('on');
        if (!hasTypeCondition && this.peek((0, $0697d866a04062ba$export$8b9d26ab11394711).NAME)) return {
            kind: (0, $274fc6e4b3beb099$export$a84bdc57c5122798).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false),
            loc: this.loc(start)
        };
        return {
            kind: (0, $274fc6e4b3beb099$export$a84bdc57c5122798).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */ ;
    _proto.parseFragmentDefinition = function parseFragmentDefinition() {
        var _this$_options;
        var start = this._lexer.token;
        this.expectKeyword('fragment'); // Experimental support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (((_this$_options = this._options) === null || _this$_options === void 0 ? void 0 : _this$_options.experimentalFragmentVariables) === true) return {
            kind: (0, $274fc6e4b3beb099$export$a84bdc57c5122798).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        return {
            kind: (0, $274fc6e4b3beb099$export$a84bdc57c5122798).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentName : Name but not `on`
   */ ;
    _proto.parseFragmentName = function parseFragmentName() {
        if (this._lexer.token.value === 'on') throw this.unexpected();
        return this.parseName();
    } // Implements the parsing rules in the Values section.
     /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */ ;
    _proto.parseValueLiteral = function parseValueLiteral(isConst) {
        var token = this._lexer.token;
        switch(token.kind){
            case (0, $0697d866a04062ba$export$8b9d26ab11394711).BRACKET_L:
                return this.parseList(isConst);
            case (0, $0697d866a04062ba$export$8b9d26ab11394711).BRACE_L:
                return this.parseObject(isConst);
            case (0, $0697d866a04062ba$export$8b9d26ab11394711).INT:
                this._lexer.advance();
                return {
                    kind: (0, $274fc6e4b3beb099$export$a84bdc57c5122798).INT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $0697d866a04062ba$export$8b9d26ab11394711).FLOAT:
                this._lexer.advance();
                return {
                    kind: (0, $274fc6e4b3beb099$export$a84bdc57c5122798).FLOAT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $0697d866a04062ba$export$8b9d26ab11394711).STRING:
            case (0, $0697d866a04062ba$export$8b9d26ab11394711).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, $0697d866a04062ba$export$8b9d26ab11394711).NAME:
                this._lexer.advance();
                switch(token.value){
                    case 'true':
                        return {
                            kind: (0, $274fc6e4b3beb099$export$a84bdc57c5122798).BOOLEAN,
                            value: true,
                            loc: this.loc(token)
                        };
                    case 'false':
                        return {
                            kind: (0, $274fc6e4b3beb099$export$a84bdc57c5122798).BOOLEAN,
                            value: false,
                            loc: this.loc(token)
                        };
                    case 'null':
                        return {
                            kind: (0, $274fc6e4b3beb099$export$a84bdc57c5122798).NULL,
                            loc: this.loc(token)
                        };
                    default:
                        return {
                            kind: (0, $274fc6e4b3beb099$export$a84bdc57c5122798).ENUM,
                            value: token.value,
                            loc: this.loc(token)
                        };
                }
            case (0, $0697d866a04062ba$export$8b9d26ab11394711).DOLLAR:
                if (!isConst) return this.parseVariable();
                break;
        }
        throw this.unexpected();
    };
    _proto.parseStringLiteral = function parseStringLiteral() {
        var token = this._lexer.token;
        this._lexer.advance();
        return {
            kind: (0, $274fc6e4b3beb099$export$a84bdc57c5122798).STRING,
            value: token.value,
            block: token.kind === (0, $0697d866a04062ba$export$8b9d26ab11394711).BLOCK_STRING,
            loc: this.loc(token)
        };
    } /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */ ;
    _proto.parseList = function parseList(isConst) {
        var _this = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this.parseValueLiteral(isConst);
        };
        return {
            kind: (0, $274fc6e4b3beb099$export$a84bdc57c5122798).LIST,
            values: this.any((0, $0697d866a04062ba$export$8b9d26ab11394711).BRACKET_L, item, (0, $0697d866a04062ba$export$8b9d26ab11394711).BRACKET_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   */ ;
    _proto.parseObject = function parseObject(isConst) {
        var _this2 = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this2.parseObjectField(isConst);
        };
        return {
            kind: (0, $274fc6e4b3beb099$export$a84bdc57c5122798).OBJECT,
            fields: this.any((0, $0697d866a04062ba$export$8b9d26ab11394711).BRACE_L, item, (0, $0697d866a04062ba$export$8b9d26ab11394711).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectField[Const] : Name : Value[?Const]
   */ ;
    _proto.parseObjectField = function parseObjectField(isConst) {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $0697d866a04062ba$export$8b9d26ab11394711).COLON);
        return {
            kind: (0, $274fc6e4b3beb099$export$a84bdc57c5122798).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Directives section.
     /**
   * Directives[Const] : Directive[?Const]+
   */ ;
    _proto.parseDirectives = function parseDirectives(isConst) {
        var directives = [];
        while(this.peek((0, $0697d866a04062ba$export$8b9d26ab11394711).AT))directives.push(this.parseDirective(isConst));
        return directives;
    } /**
   * Directive[Const] : @ Name Arguments[?Const]?
   */ ;
    _proto.parseDirective = function parseDirective(isConst) {
        var start = this._lexer.token;
        this.expectToken((0, $0697d866a04062ba$export$8b9d26ab11394711).AT);
        return {
            kind: (0, $274fc6e4b3beb099$export$a84bdc57c5122798).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Types section.
     /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */ ;
    _proto.parseTypeReference = function parseTypeReference() {
        var start = this._lexer.token;
        var type;
        if (this.expectOptionalToken((0, $0697d866a04062ba$export$8b9d26ab11394711).BRACKET_L)) {
            type = this.parseTypeReference();
            this.expectToken((0, $0697d866a04062ba$export$8b9d26ab11394711).BRACKET_R);
            type = {
                kind: (0, $274fc6e4b3beb099$export$a84bdc57c5122798).LIST_TYPE,
                type: type,
                loc: this.loc(start)
            };
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, $0697d866a04062ba$export$8b9d26ab11394711).BANG)) return {
            kind: (0, $274fc6e4b3beb099$export$a84bdc57c5122798).NON_NULL_TYPE,
            type: type,
            loc: this.loc(start)
        };
        return type;
    } /**
   * NamedType : Name
   */ ;
    _proto.parseNamedType = function parseNamedType() {
        var start = this._lexer.token;
        return {
            kind: (0, $274fc6e4b3beb099$export$a84bdc57c5122798).NAMED_TYPE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Type Definition section.
     /**
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
        // Many definitions begin with a description and require a lookahead.
        var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === (0, $0697d866a04062ba$export$8b9d26ab11394711).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaDefinition();
            case 'scalar':
                return this.parseScalarTypeDefinition();
            case 'type':
                return this.parseObjectTypeDefinition();
            case 'interface':
                return this.parseInterfaceTypeDefinition();
            case 'union':
                return this.parseUnionTypeDefinition();
            case 'enum':
                return this.parseEnumTypeDefinition();
            case 'input':
                return this.parseInputObjectTypeDefinition();
            case 'directive':
                return this.parseDirectiveDefinition();
        }
        throw this.unexpected(keywordToken);
    };
    _proto.peekDescription = function peekDescription() {
        return this.peek((0, $0697d866a04062ba$export$8b9d26ab11394711).STRING) || this.peek((0, $0697d866a04062ba$export$8b9d26ab11394711).BLOCK_STRING);
    } /**
   * Description : StringValue
   */ ;
    _proto.parseDescription = function parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    } /**
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   */ ;
    _proto.parseSchemaDefinition = function parseSchemaDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.many((0, $0697d866a04062ba$export$8b9d26ab11394711).BRACE_L, this.parseOperationTypeDefinition, (0, $0697d866a04062ba$export$8b9d26ab11394711).BRACE_R);
        return {
            kind: (0, $274fc6e4b3beb099$export$a84bdc57c5122798).SCHEMA_DEFINITION,
            description: description,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * OperationTypeDefinition : OperationType : NamedType
   */ ;
    _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
        var start = this._lexer.token;
        var operation = this.parseOperationType();
        this.expectToken((0, $0697d866a04062ba$export$8b9d26ab11394711).COLON);
        var type = this.parseNamedType();
        return {
            kind: (0, $274fc6e4b3beb099$export$a84bdc57c5122798).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */ ;
    _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $274fc6e4b3beb099$export$a84bdc57c5122798).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $274fc6e4b3beb099$export$a84bdc57c5122798).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */ ;
    _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
        var _this$_options2;
        if (!this.expectOptionalKeyword('implements')) return [];
        if (((_this$_options2 = this._options) === null || _this$_options2 === void 0 ? void 0 : _this$_options2.allowLegacySDLImplementsInterfaces) === true) {
            var types = []; // Optional leading ampersand
            this.expectOptionalToken((0, $0697d866a04062ba$export$8b9d26ab11394711).AMP);
            do types.push(this.parseNamedType());
            while (this.expectOptionalToken((0, $0697d866a04062ba$export$8b9d26ab11394711).AMP) || this.peek((0, $0697d866a04062ba$export$8b9d26ab11394711).NAME));
            return types;
        }
        return this.delimitedMany((0, $0697d866a04062ba$export$8b9d26ab11394711).AMP, this.parseNamedType);
    } /**
   * FieldsDefinition : { FieldDefinition+ }
   */ ;
    _proto.parseFieldsDefinition = function parseFieldsDefinition() {
        var _this$_options3;
        // Legacy support for the SDL?
        if (((_this$_options3 = this._options) === null || _this$_options3 === void 0 ? void 0 : _this$_options3.allowLegacySDLEmptyFields) === true && this.peek((0, $0697d866a04062ba$export$8b9d26ab11394711).BRACE_L) && this._lexer.lookahead().kind === (0, $0697d866a04062ba$export$8b9d26ab11394711).BRACE_R) {
            this._lexer.advance();
            this._lexer.advance();
            return [];
        }
        return this.optionalMany((0, $0697d866a04062ba$export$8b9d26ab11394711).BRACE_L, this.parseFieldDefinition, (0, $0697d866a04062ba$export$8b9d26ab11394711).BRACE_R);
    } /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */ ;
    _proto.parseFieldDefinition = function parseFieldDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        this.expectToken((0, $0697d866a04062ba$export$8b9d26ab11394711).COLON);
        var type = this.parseTypeReference();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $274fc6e4b3beb099$export$a84bdc57c5122798).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */ ;
    _proto.parseArgumentDefs = function parseArgumentDefs() {
        return this.optionalMany((0, $0697d866a04062ba$export$8b9d26ab11394711).PAREN_L, this.parseInputValueDef, (0, $0697d866a04062ba$export$8b9d26ab11394711).PAREN_R);
    } /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseInputValueDef = function parseInputValueDef() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        this.expectToken((0, $0697d866a04062ba$export$8b9d26ab11394711).COLON);
        var type = this.parseTypeReference();
        var defaultValue;
        if (this.expectOptionalToken((0, $0697d866a04062ba$export$8b9d26ab11394711).EQUALS)) defaultValue = this.parseValueLiteral(true);
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $274fc6e4b3beb099$export$a84bdc57c5122798).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $274fc6e4b3beb099$export$a84bdc57c5122798).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */ ;
    _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        return {
            kind: (0, $274fc6e4b3beb099$export$a84bdc57c5122798).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */ ;
    _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
        return this.expectOptionalToken((0, $0697d866a04062ba$export$8b9d26ab11394711).EQUALS) ? this.delimitedMany((0, $0697d866a04062ba$export$8b9d26ab11394711).PIPE, this.parseNamedType) : [];
    } /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */ ;
    _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        return {
            kind: (0, $274fc6e4b3beb099$export$a84bdc57c5122798).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * EnumValuesDefinition : { EnumValueDefinition+ }
   */ ;
    _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
        return this.optionalMany((0, $0697d866a04062ba$export$8b9d26ab11394711).BRACE_L, this.parseEnumValueDefinition, (0, $0697d866a04062ba$export$8b9d26ab11394711).BRACE_R);
    } /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   *
   * EnumValue : Name
   */ ;
    _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $274fc6e4b3beb099$export$a84bdc57c5122798).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */ ;
    _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        return {
            kind: (0, $274fc6e4b3beb099$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InputFieldsDefinition : { InputValueDefinition+ }
   */ ;
    _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
        return this.optionalMany((0, $0697d866a04062ba$export$8b9d26ab11394711).BRACE_L, this.parseInputValueDef, (0, $0697d866a04062ba$export$8b9d26ab11394711).BRACE_R);
    } /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
        var keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, $0697d866a04062ba$export$8b9d26ab11394711).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaExtension();
            case 'scalar':
                return this.parseScalarTypeExtension();
            case 'type':
                return this.parseObjectTypeExtension();
            case 'interface':
                return this.parseInterfaceTypeExtension();
            case 'union':
                return this.parseUnionTypeExtension();
            case 'enum':
                return this.parseEnumTypeExtension();
            case 'input':
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    } /**
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   */ ;
    _proto.parseSchemaExtension = function parseSchemaExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.optionalMany((0, $0697d866a04062ba$export$8b9d26ab11394711).BRACE_L, this.parseOperationTypeDefinition, (0, $0697d866a04062ba$export$8b9d26ab11394711).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return {
            kind: (0, $274fc6e4b3beb099$export$a84bdc57c5122798).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */ ;
    _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        if (directives.length === 0) throw this.unexpected();
        return {
            kind: (0, $274fc6e4b3beb099$export$a84bdc57c5122798).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */ ;
    _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $274fc6e4b3beb099$export$a84bdc57c5122798).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */ ;
    _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $274fc6e4b3beb099$export$a84bdc57c5122798).INTERFACE_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */ ;
    _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return {
            kind: (0, $274fc6e4b3beb099$export$a84bdc57c5122798).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */ ;
    _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return {
            kind: (0, $274fc6e4b3beb099$export$a84bdc57c5122798).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */ ;
    _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $274fc6e4b3beb099$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   */ ;
    _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('directive');
        this.expectToken((0, $0697d866a04062ba$export$8b9d26ab11394711).AT);
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        var repeatable = this.expectOptionalKeyword('repeatable');
        this.expectKeyword('on');
        var locations = this.parseDirectiveLocations();
        return {
            kind: (0, $274fc6e4b3beb099$export$a84bdc57c5122798).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations,
            loc: this.loc(start)
        };
    } /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */ ;
    _proto.parseDirectiveLocations = function parseDirectiveLocations() {
        return this.delimitedMany((0, $0697d866a04062ba$export$8b9d26ab11394711).PIPE, this.parseDirectiveLocation);
    } /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */ ;
    _proto.parseDirectiveLocation = function parseDirectiveLocation() {
        var start = this._lexer.token;
        var name = this.parseName();
        if ((0, $da9694282a46a1b7$export$b45ffd2948484c41)[name.value] !== undefined) return name;
        throw this.unexpected(start);
    } // Core parsing utility functions
     /**
   * Returns a location object, used to identify the place in the source that created a given parsed object.
   */ ;
    _proto.loc = function loc(startToken) {
        var _this$_options4;
        if (((_this$_options4 = this._options) === null || _this$_options4 === void 0 ? void 0 : _this$_options4.noLocation) !== true) return new (0, $bZ4GO.Location)(startToken, this._lexer.lastToken, this._lexer.source);
    } /**
   * Determines if the next token is of a given kind
   */ ;
    _proto.peek = function peek(kind) {
        return this._lexer.token.kind === kind;
    } /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectToken = function expectToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        throw (0, $cec865aa99f5c1d2$export$bbee0c6176c019d4)(this._lexer.source, token.start, "Expected ".concat($f435c4751a3a8e47$var$getTokenKindDesc(kind), ", found ").concat($f435c4751a3a8e47$var$getTokenDesc(token), "."));
    } /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and return undefined.
   */ ;
    _proto.expectOptionalToken = function expectOptionalToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        return undefined;
    } /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectKeyword = function expectKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $0697d866a04062ba$export$8b9d26ab11394711).NAME && token.value === value) this._lexer.advance();
        else throw (0, $cec865aa99f5c1d2$export$bbee0c6176c019d4)(this._lexer.source, token.start, "Expected \"".concat(value, "\", found ").concat($f435c4751a3a8e47$var$getTokenDesc(token), "."));
    } /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ ;
    _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $0697d866a04062ba$export$8b9d26ab11394711).NAME && token.value === value) {
            this._lexer.advance();
            return true;
        }
        return false;
    } /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */ ;
    _proto.unexpected = function unexpected(atToken) {
        var token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
        return (0, $cec865aa99f5c1d2$export$bbee0c6176c019d4)(this._lexer.source, token.start, "Unexpected ".concat($f435c4751a3a8e47$var$getTokenDesc(token), "."));
    } /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.any = function any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    } /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            var nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    } /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.many = function many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    } /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */ ;
    _proto.delimitedMany = function delimitedMany(delimiterKind, parseFn) {
        this.expectOptionalToken(delimiterKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (this.expectOptionalToken(delimiterKind));
        return nodes;
    };
    return Parser;
}();
/**
 * A helper function to describe a token as a string for debugging.
 */ function $f435c4751a3a8e47$var$getTokenDesc(token) {
    var value = token.value;
    return $f435c4751a3a8e47$var$getTokenKindDesc(token.kind) + (value != null ? " \"".concat(value, "\"") : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */ function $f435c4751a3a8e47$var$getTokenKindDesc(kind) {
    return (0, $8cbf720e5e8ae755$export$59ac0f4da287406a)(kind) ? "\"".concat(kind, "\"") : kind;
}


var $986f6c4727102807$var$docCache = new Map();
var $986f6c4727102807$var$fragmentSourceMap = new Map();
var $986f6c4727102807$var$printFragmentWarnings = true;
var $986f6c4727102807$var$experimentalFragmentVariables = false;
function $986f6c4727102807$var$normalize(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function $986f6c4727102807$var$cacheKeyFromLoc(loc) {
    return $986f6c4727102807$var$normalize(loc.source.body.substring(loc.start, loc.end));
}
function $986f6c4727102807$var$processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function(fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = $986f6c4727102807$var$cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = $986f6c4727102807$var$fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if ($986f6c4727102807$var$printFragmentWarnings) console.warn("Warning: fragment with name " + fragmentName + " already exists.\n" + "graphql-tag enforces all fragment names across your application to be unique; read more about\n" + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
            } else if (!sourceKeySet) $986f6c4727102807$var$fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        } else definitions.push(fragmentDefinition);
    });
    return (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, ast), {
        definitions: definitions
    });
}
function $986f6c4727102807$var$stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function(node) {
        if (node.loc) delete node.loc;
        Object.keys(node).forEach(function(key) {
            var value = node[key];
            if (value && typeof value === 'object') workSet.add(value);
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function $986f6c4727102807$var$parseDocument(source) {
    var cacheKey = $986f6c4727102807$var$normalize(source);
    if (!$986f6c4727102807$var$docCache.has(cacheKey)) {
        var parsed = (0, $f435c4751a3a8e47$export$98e6a39c04603d36)(source, {
            experimentalFragmentVariables: $986f6c4727102807$var$experimentalFragmentVariables,
            allowLegacyFragmentVariables: $986f6c4727102807$var$experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') throw new Error('Not a valid GraphQL document.');
        $986f6c4727102807$var$docCache.set(cacheKey, $986f6c4727102807$var$stripLoc($986f6c4727102807$var$processFragments(parsed)));
    }
    return $986f6c4727102807$var$docCache.get(cacheKey);
}
function $986f6c4727102807$export$72e4926bf8358653(literals) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (typeof literals === 'string') literals = [
        literals
    ];
    var result = literals[0];
    args.forEach(function(arg, i) {
        if (arg && arg.kind === 'Document') result += arg.loc.source.body;
        else result += arg;
        result += literals[i + 1];
    });
    return $986f6c4727102807$var$parseDocument(result);
}
function $986f6c4727102807$export$657554ef4dc7ac2d() {
    $986f6c4727102807$var$docCache.clear();
    $986f6c4727102807$var$fragmentSourceMap.clear();
}
function $986f6c4727102807$export$e4294e638636c6ab() {
    $986f6c4727102807$var$printFragmentWarnings = false;
}
function $986f6c4727102807$export$78cf889af350c840() {
    $986f6c4727102807$var$experimentalFragmentVariables = true;
}
function $986f6c4727102807$export$5290df9bbbd3cfa() {
    $986f6c4727102807$var$experimentalFragmentVariables = false;
}
var $986f6c4727102807$var$extras = {
    gql: $986f6c4727102807$export$72e4926bf8358653,
    resetCaches: $986f6c4727102807$export$657554ef4dc7ac2d,
    disableFragmentWarnings: $986f6c4727102807$export$e4294e638636c6ab,
    enableExperimentalFragmentVariables: $986f6c4727102807$export$78cf889af350c840,
    disableExperimentalFragmentVariables: $986f6c4727102807$export$5290df9bbbd3cfa
};
(function(gql_1) {
    gql_1.gql = $986f6c4727102807$var$extras.gql, gql_1.resetCaches = $986f6c4727102807$var$extras.resetCaches, gql_1.disableFragmentWarnings = $986f6c4727102807$var$extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = $986f6c4727102807$var$extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = $986f6c4727102807$var$extras.disableExperimentalFragmentVariables;
})($986f6c4727102807$export$72e4926bf8358653 || ($986f6c4727102807$export$72e4926bf8358653 = {}));
$986f6c4727102807$export$72e4926bf8358653["default"] = $986f6c4727102807$export$72e4926bf8358653;
var $986f6c4727102807$export$2e2bcd8739ae039 = $986f6c4727102807$export$72e4926bf8358653;


const $61c0b2c7a276da71$export$e344c3770925712a = (0, $986f6c4727102807$export$2e2bcd8739ae039)`query SiteInformationQuery{tenant{shard cloudId environment activationId}organization{orgId}userForAnalytics:confluence_atlassianUser{id}user:confluence_atlassianUser(current:true){id displayName confluence{accessStatus accountId userKey locale}timeZone}getAIConfig(product:CONFLUENCE){isEnabled isRovoEnabled isRovoLLMEnabled}confluence_tenantContext{licenseStates{confluence{ccpEntitlementId}}timeZone editions{confluence}monolithRegion}isSiteAdmin abTestCohorts experimentFeatures userCanCreateContent isNewUser siteSettings{homepage{uri title}siteTitle showApplicationTitle frontCover{frontCoverState}companyHubName}siteDescription{logoUrl}currentConfluenceUser{isAnonymous}}`;


function $b409c2781320251f$var$apolloQuery({ query: query, queryName: queryName, client: client = window.GLOBAL_APOLLO_CLIENT }) {
    if (!client) return Promise.reject(new Error(`ApolloClient not available, cannot load query ${queryName}`));
    return (0, $47c7a260b3a5dfb3$export$5467c8c7fa0f4d06).run(`ssr-app/prepare/preloadQuery/fetch:${queryName}`, async ()=>client.query({
            query: query,
            errorPolicy: 'all',
            fetchPolicy: 'cache-first',
            context: {
                single: false,
                allowOnExternalPage: true
            }
        }));
}
async function $b409c2781320251f$export$5ae208508f6870b() {
    // __SITEINFORMATION__ is either actual session data
    // or the promise that is resolving the session data
    // In the case when page is rendered by SSR, the __SITEINFORMATION__ will be populated with JSON data.
    if (window['__SITEINFORMATION__']) return window['__SITEINFORMATION__'];
    window['__SITEINFORMATION__'] = $b409c2781320251f$var$apolloQuery({
        query: (0, $61c0b2c7a276da71$export$e344c3770925712a),
        queryName: 'SiteInformationQuery'
    }).then((result)=>{
        const errors = result.errors ?? [];
        if (errors.length > 0) errors.forEach((e)=>{
            if ((0, $6e2aeba1bc095709$export$55152de1f925fd05)(e) && !!result?.data?.tenant?.cloudId) (0, $4b7988ce40c8fd3c$export$702f853386561b84)(e);
            else (0, $d1c1e8e192b1a688$export$39a3b7739331403b)().submitError(e, {
                isSiteInformationError: true,
                partialFailure: true,
                attribution: 'FATAL'
            });
        });
        return result.data;
    }).catch((error)=>{
        if (Array.isArray(error)) error.forEach((e)=>(0, $d1c1e8e192b1a688$export$39a3b7739331403b)().submitError(e, {
                isSiteInformationError: true,
                partialFailure: false,
                attribution: 'FATAL'
            }));
        else (0, $d1c1e8e192b1a688$export$39a3b7739331403b)().submitError(error, {
            isSiteInformationError: true,
            partialFailure: false,
            attribution: 'FATAL'
        });
        return null;
    });
    return window['__SITEINFORMATION__'];
}


const $b5780f5a758d6771$export$4163744babc94103 = ()=>{
    // Not using memorize here because we want to reset promise in test
    if (window['__SITEINFORMATION_PROMISE__']) return window['__SITEINFORMATION_PROMISE__'];
    return window['__SITEINFORMATION_PROMISE__'] = (0, $cd3135dd152096aa$export$cc373701aed148fc)((0, $b409c2781320251f$export$5ae208508f6870b)().then((0, $2800afeb4fc22c91$export$48ea97dcec207a60)));
};
const $b5780f5a758d6771$export$fdd2c0ba94025c3c = ()=>{
    const sessionDataPromise = $b5780f5a758d6771$export$4163744babc94103();
    if ((0, $cd3135dd152096aa$export$b1a2a6bd0c6f9666)(sessionDataPromise)) return (0, $cd3135dd152096aa$export$bf7199a9ebcb84a9)(sessionDataPromise)?.cloudId;
    else // Session data is not loaded yet, return null
    return null;
};
class $b5780f5a758d6771$export$14dde3d2ec7dfd8f extends (0, $dQwsT.Component) {
    componentWillUnmount() {
        this._mount = false;
    }
    render() {
        const { sessionData: sessionData } = this.state;
        if (sessionData) return this.props.children(sessionData);
        if (this.props.renderChildrenWhenLoading === true) return this.props.children({
            loading: true
        });
        return null;
    }
    constructor(props){
        super(props);
        this._mount = void 0;
        this.state = {};
        const promise = $b5780f5a758d6771$export$4163744babc94103();
        this._mount = true;
        if ((0, $cd3135dd152096aa$export$b1a2a6bd0c6f9666)(promise)) this.state = {
            sessionData: (0, $cd3135dd152096aa$export$bf7199a9ebcb84a9)(promise)
        };
        else promise.then((sessionData)=>{
            if (this._mount) this.setState({
                sessionData: sessionData
            });
        });
    }
}



const $a4b9a8903fd62c69$var$COMPANY_HUB_SPACE_KEY_PREFIX = '~HUB';
const $a4b9a8903fd62c69$export$5ab9c400208ad907 = (spaceKey)=>!!(spaceKey?.startsWith($a4b9a8903fd62c69$var$COMPANY_HUB_SPACE_KEY_PREFIX) && spaceKey?.endsWith('~'));
const $a4b9a8903fd62c69$export$6193f65d76fa4c00 = (sessionData)=>{
    if (!sessionData?.activationId || !sessionData?.cloudId) sessionData = (0, $cd3135dd152096aa$export$bf7199a9ebcb84a9)((0, $b5780f5a758d6771$export$4163744babc94103)());
    if (sessionData) {
        const { activationId: activationId, cloudId: cloudId } = sessionData;
        if (activationId && cloudId) return `${$a4b9a8903fd62c69$var$COMPANY_HUB_SPACE_KEY_PREFIX}-${cloudId}-${activationId}~`;
    }
    // We used to return undefined, but pretty much always we fell back to the empty string with code like `?? ''` or `|| ''`.
    // Instead of sprinkling noise like that all over, it's less complex to do the de facto fallback here.
    return '';
};
var $a4b9a8903fd62c69$export$8b92a390c1734cf9 = /*#__PURE__*/ function(FrontCoverStateEnum) {
    FrontCoverStateEnum["UNSET"] = "unset";
    FrontCoverStateEnum["HIDDEN"] = "hidden";
    FrontCoverStateEnum["EDITORS_ONLY"] = "editors_only";
    FrontCoverStateEnum["SHOWN"] = "shown";
    return FrontCoverStateEnum;
}({});
var $a4b9a8903fd62c69$export$ec1312b61cf60ef3 = /*#__PURE__*/ function(FrontCoverStateInputEnum) {
    FrontCoverStateInputEnum["UNSET"] = "UNSET";
    FrontCoverStateInputEnum["HIDDEN"] = "HIDDEN";
    FrontCoverStateInputEnum["SHOWN"] = "SHOWN";
    return FrontCoverStateInputEnum;
}({});


// Deep link visiting
const $d4b865e8cc459c1f$export$61f782d99db03c49 = 'follow-deep-link';
const $d4b865e8cc459c1f$export$ed2197e4948fef6c = 'view-macro-renderer';
const $d4b865e8cc459c1f$export$136d4e1bb3adaa98 = 'view-macro-editor';
const $d4b865e8cc459c1f$export$54747aca26cee3f8 = 'view-all-macro';
const $d4b865e8cc459c1f$export$f8afba90a5a815ad = 'view-jira-macro';
const $d4b865e8cc459c1f$export$87daa9a1b1dd910d = 'migrate-page';
const $d4b865e8cc459c1f$export$6c0a7d453b9ba427 = 'migrate-page/publish';
const $d4b865e8cc459c1f$export$b39a77dbc03575b1 = 'migrate-template';
const $d4b865e8cc459c1f$export$f94e85276e6d639f = 'add-page-comment';
const $d4b865e8cc459c1f$export$31bd7de6ca230764 = 'add-page-comment/load';
const $d4b865e8cc459c1f$export$4cb6cf73aff93e7d = 'add-page-comment/publish';
const $d4b865e8cc459c1f$export$2a99a63e28df64fd = 'edit-page-comment';
const $d4b865e8cc459c1f$export$515913089a77cb7c = 'edit-page-comment/load';
const $d4b865e8cc459c1f$export$c0906b23fa1e3b63 = 'edit-page-comment/publish';
const $d4b865e8cc459c1f$export$e9a5501ca0d5d256 = 'reply-to-page-comment';
const $d4b865e8cc459c1f$export$3fdffa656412b99a = 'reply-to-page-comment/load';
const $d4b865e8cc459c1f$export$bfebfbab40727cd6 = 'reply-to-page-comment/publish';
const $d4b865e8cc459c1f$export$91d50c2b267d0461 = 'delete-page-comment';
const $d4b865e8cc459c1f$export$24ef8c79de5598b9 = 'resolve-page-comment';
const $d4b865e8cc459c1f$export$8c6422f793f7efae = 'mark-comments-as-read';
const $d4b865e8cc459c1f$export$98dbdebd041da61c = 'mark-all-comments-as-read';
const $d4b865e8cc459c1f$export$6f58645a9a5f7936 = 'create-inline-comment';
const $d4b865e8cc459c1f$export$8180a49fb6c681b1 = 'create-inline-comment/init';
const $d4b865e8cc459c1f$export$ed5e210bce3a41a9 = 'create-inline-comment/draft-to-publish';
const $d4b865e8cc459c1f$export$db23cb60632b0aa0 = 'create-inline-comment/attach-comment';
const $d4b865e8cc459c1f$export$f8e0e16825f0d222 = 'select-inline-comment';
const $d4b865e8cc459c1f$export$2003fd9c8f509d96 = 'add-inline-comment';
const $d4b865e8cc459c1f$export$a69ecd33d83d56ce = 'add-inline-comment/load';
const $d4b865e8cc459c1f$export$eb89dbd7422d8194 = 'add-inline-comment/publish';
const $d4b865e8cc459c1f$export$29c433981d13c955 = 'edit-inline-comment';
const $d4b865e8cc459c1f$export$a557d8a611f835b = 'edit-inline-comment/load';
const $d4b865e8cc459c1f$export$e9dafdd46fb3d4ed = 'edit-inline-comment/publish';
const $d4b865e8cc459c1f$export$20fbac00cba3c8a = 'view-inline-comment';
const $d4b865e8cc459c1f$export$533f2a7cfe4f757e = 'view-inline-comment/toplevel';
const $d4b865e8cc459c1f$export$fb1f28583d577755 = 'view-inline-comment/reply';
const $d4b865e8cc459c1f$export$9d157677f817543f = 'reply-to-inline-comment';
const $d4b865e8cc459c1f$export$b4f2ad99abb89883 = 'reply-to-inline-comment/load';
const $d4b865e8cc459c1f$export$32059abd767a1104 = 'reply-to-inline-comment/publish';
const $d4b865e8cc459c1f$export$bcfccb61f33e9641 = 'delete-inline-comment';
const $d4b865e8cc459c1f$export$819fbef15068ac1d = 'resolve-inline-comment';
const $d4b865e8cc459c1f$export$996a096215f40255 = 'unresolve-inline-comment';
const $d4b865e8cc459c1f$export$c64ae72fd2ff5bed = 'resolved-inline-comments-dialog-sort';
const $d4b865e8cc459c1f$export$a32711b0e13e94b7 = 'reattach-inline-comment';
const $d4b865e8cc459c1f$export$d6f52083721d3342 = 'view-reactions';
const $d4b865e8cc459c1f$export$e6f0efe9d461092e = 'view-reaction-user-list';
const $d4b865e8cc459c1f$export$ba45b443cf775f1b = 'add-reaction';
const $d4b865e8cc459c1f$export$63f7987e2f1f8f3 = 'delete-reaction';
const $d4b865e8cc459c1f$export$aa1b3aa6132c5165 = 'add-quick-reaction';
const $d4b865e8cc459c1f$export$7321222ee6dc4c8a = 'copy-space-permissions';
const $d4b865e8cc459c1f$export$227ea80a7d6d8ef2 = 'create-page';
const $d4b865e8cc459c1f$export$1773354263fb7a1f = 'create-page/load-dialog';
const $d4b865e8cc459c1f$export$5f80ef7b2915bb38 = 'create-page/template-variable-input';
const $d4b865e8cc459c1f$export$f27db95814bbdf0 = 'create-whiteboard';
const $d4b865e8cc459c1f$export$13566a78bbba7568 = 'create-database';
const $d4b865e8cc459c1f$export$c6222c9fbf47e43b = 'create-embed';
const $d4b865e8cc459c1f$export$63a2c018dc189e0 = 'create-folder';
const $d4b865e8cc459c1f$export$9c40f417713b17ea = 'edit-page-smart-create/load';
const $d4b865e8cc459c1f$export$dd70d6707192298e = 'edit-page';
const $d4b865e8cc459c1f$export$cd96dc6a09f60949 = 'edit-legacy-page';
const $d4b865e8cc459c1f$export$b6f302e969b56ed5 = 'edit-page-embed';
const $d4b865e8cc459c1f$export$cfe717283b384dee = 'edit-page/loader'; // loader to determine editor routing (next vs. classic)
const $d4b865e8cc459c1f$export$54650b8dd9597591 = 'edit-page/load';
const $d4b865e8cc459c1f$export$9cfef550e5af515d = 'edit-legacy-page/load';
const $d4b865e8cc459c1f$export$4aed0cf42acf9c68 = 'edit-page/publish';
const $d4b865e8cc459c1f$export$770ea955fed26e20 = 'edit-legacy-page/publish';
const $d4b865e8cc459c1f$export$4abcdf78bb75330c = 'edit-page/publish-as-blog';
const $d4b865e8cc459c1f$export$92edebd76eb1ad1 = 'edit-page/close';
const $d4b865e8cc459c1f$export$1339ae8dc80b092c = 'edit-legacy-page/close';
const $d4b865e8cc459c1f$export$42ce143b9452f768 = 'edit-page/revert-draft';
const $d4b865e8cc459c1f$export$3814d28dd3802a02 = 'live-page-session';
const $d4b865e8cc459c1f$export$40fb2b7b657bf7d = 'live-page/publish';
const $d4b865e8cc459c1f$export$9e0dcc9389703292 = 'create-and-edit-page';
const $d4b865e8cc459c1f$export$b9892a850189b3e9 = 'template-edit-page';
const $d4b865e8cc459c1f$export$3604f7decc6e0567 = 'template-edit-page/load';
const $d4b865e8cc459c1f$export$1a3cf6b911b3771 = 'template-edit-page/close';
const $d4b865e8cc459c1f$export$a7f90c693668eabe = 'template-edit-page/publish';
const $d4b865e8cc459c1f$export$3c5dcebba4317c7e = 'template-edit-page/publish/template-body';
const $d4b865e8cc459c1f$export$3a8f568ddb8f3189 = 'template-edit-page/publish/template-properties';
const $d4b865e8cc459c1f$export$583391c24e8a1735 = 'in-editor-templates-load-panel';
const $d4b865e8cc459c1f$export$6afe1d2e05c85172 = 'in-editor-templates-load-panel/template-list';
const $d4b865e8cc459c1f$export$6085a8760b035f6 = 'in-editor-templates-load-panel/categories';
const $d4b865e8cc459c1f$export$cbd9dfa0a050a0e0 = 'in-editor-templates-load-panel/space-selector';
const $d4b865e8cc459c1f$export$8fcf8395eb106389 = 'in-editor-templates-update-content';
const $d4b865e8cc459c1f$export$eac277758b783558 = 'in-editor-templates-update-content/refresh-editor';
const $d4b865e8cc459c1f$export$d3b70eeb61a68ef1 = 'template-suggestions';
const $d4b865e8cc459c1f$export$89e30156af35c723 = 'view-in-product-help';
const $d4b865e8cc459c1f$export$1072a5750cf51c7e = 'search-in-product-help';
const $d4b865e8cc459c1f$export$85f8b3853315a126 = 'search-in-product-help/load';
const $d4b865e8cc459c1f$export$49e4c787a6cc62e = 'view-article-in-product-help';
const $d4b865e8cc459c1f$export$3d1292b099f0e166 = 'view-article-in-product-help/load';
const $d4b865e8cc459c1f$export$54615853abc6859 = 'template-gallery';
const $d4b865e8cc459c1f$export$82c983e2a60f2e28 = 'template-gallery/space-selector';
const $d4b865e8cc459c1f$export$61439b391c5a3aca = 'template-gallery/categories';
const $d4b865e8cc459c1f$export$81cd8bf6923e1bf1 = 'template-gallery/cards';
const $d4b865e8cc459c1f$export$b6af3a64b182b9d0 = 'template-gallery/template-detail';
const $d4b865e8cc459c1f$export$588acf29fbd8637d = 'template-gallery/template-detail-update';
const $d4b865e8cc459c1f$export$a1cf4f28febc3bee = 'template-gallery/template-detail/header';
const $d4b865e8cc459c1f$export$b802716fd0c5b93f = 'template-preview';
const $d4b865e8cc459c1f$export$e0195c05e32ed777 = 'refresh-editor-content';
const $d4b865e8cc459c1f$export$9194ae178043ade6 = 'create-content-from-template';
const $d4b865e8cc459c1f$export$1545639c80579c53 = 'blueprint-wizard-load-dialog';
const $d4b865e8cc459c1f$export$fc0c176abc30d17b = 'connect-addon';
const $d4b865e8cc459c1f$export$97b170c4be77228 = 'quick-reload';
const $d4b865e8cc459c1f$export$9625ccab45afe35a = 'quick-reload-v3';
const $d4b865e8cc459c1f$export$dbbd27df623b094f = 'restricted-page';
const $d4b865e8cc459c1f$export$8f404e4bd2a13aa = 'restricted-space-for-guest';
const $d4b865e8cc459c1f$export$727b779ceeca0a78 = 'restricted-space';
const $d4b865e8cc459c1f$export$b9ee7465c962e842 = 'restrictions-dialog';
const $d4b865e8cc459c1f$export$2e96e7e6b8da0317 = 'restrictions-dialog/load';
const $d4b865e8cc459c1f$export$6b54d78a736a983b = 'restrictions-dialog/apply';
const $d4b865e8cc459c1f$export$a66250c876dd8838 = 'publish-modal/load-restrictions';
const $d4b865e8cc459c1f$export$e64caae0c75dd921 = 'impersonation-flag';
const $d4b865e8cc459c1f$export$7ebe8ae2b3f231cb = 'inspect-permissions';
const $d4b865e8cc459c1f$export$b659623b19114e87 = 'user-access';
const $d4b865e8cc459c1f$export$9d715fddec195756 = 'upsell-edition';
const $d4b865e8cc459c1f$export$a7ffbea51ff646ee = 'upsell-edition-upflow';
const $d4b865e8cc459c1f$export$bd5028ea224c4de1 = 'archiving/archive-pages';
const $d4b865e8cc459c1f$export$e63a17e805ed8387 = 'archiving/restore-pages';
const $d4b865e8cc459c1f$export$d74c17e82f5dbc27 = 'archiving/view-space-archived-pages';
const $d4b865e8cc459c1f$export$b7a40ae431fd676d = 'archiving/view-space-archived-pages/paginate';
const $d4b865e8cc459c1f$export$b84de3b67d7aa4be = 'archiving/edit-notes-archive-pages';
const $d4b865e8cc459c1f$export$9efd42121cbefbff = 'archiving/bulk-edit-notes-archive-pages';
const $d4b865e8cc459c1f$export$c30b739e25dc756b = 'archiving/archived-page-banner';
const $d4b865e8cc459c1f$export$fc9036c892e05ff9 = 'automation-discovery/add-label';
const $d4b865e8cc459c1f$export$abe2705723fc11ac = 'automation-discovery/publish-meeting-notes';
const $d4b865e8cc459c1f$export$90d9afd417e81733 = 'automation-discovery/archive-page';
const $d4b865e8cc459c1f$export$bcf33c3d2ec343df = 'automation-discovery/hover-over-page-title';
const $d4b865e8cc459c1f$export$8b43be9232ec143f = 'automation-discovery/jira-link';
const $d4b865e8cc459c1f$export$adc097acaa5bd53a = 'automation-discovery/manual-trigger';
const $d4b865e8cc459c1f$export$184da8822d56484c = 'automation-discovery/bulk-archive';
const $d4b865e8cc459c1f$export$65a0bbd38d8f5b63 = 'automation-discovery/page-public-link';
const $d4b865e8cc459c1f$export$c7dca20d997e95ed = 'automation-manual-triggers';
const $d4b865e8cc459c1f$export$2504afae65d57ffb = 'automation-discovery/whiteboards';
const $d4b865e8cc459c1f$export$cf23f74117283d17 = 'automation-discovery/bulk-change-page-owner';
const $d4b865e8cc459c1f$export$78bf51c34f43d049 = 'automation-smart-button-run-rule';
const $d4b865e8cc459c1f$export$d0afbe071e52a5cf = 'automation-smart-button-create-rule';
const $d4b865e8cc459c1f$export$b30eb768fa4c3967 = 'automation-smart-button-edit-rule';
const $d4b865e8cc459c1f$export$2cc8139334567c4f = 'automation-smart-button-preview-rule';
const $d4b865e8cc459c1f$export$cab2a1e3c7ddbb06 = 'automation-side-nav-bar';
const $d4b865e8cc459c1f$export$a03bf7627f412dc4 = 'automation-upsell';
const $d4b865e8cc459c1f$export$a26e99521ea3a9f4 = 'delete-page';
const $d4b865e8cc459c1f$export$57cc53c6e3b9be1b = 'bulk-delete-pages';
const $d4b865e8cc459c1f$export$91d3a54b5d7e1b7f = 'bulk-change-owner';
const $d4b865e8cc459c1f$export$ba8b23dd795f5f9e = 'bulk-change-status';
const $d4b865e8cc459c1f$export$7bea875d555696ca = 'bulk-convert-page-to-live-doc';
const $d4b865e8cc459c1f$export$a837ee39f68fa2dd = 'edit-sidebar';
const $d4b865e8cc459c1f$export$e69ba0c4a7667861 = 'edit-sidebar/update';
const $d4b865e8cc459c1f$export$c6fd99844ee488c5 = 'manage-pages';
const $d4b865e8cc459c1f$export$8fc86f50c7402da0 = 'manage-pages/paginate';
const $d4b865e8cc459c1f$export$d4b4a08489e4dfe2 = 'content-manager';
const $d4b865e8cc459c1f$export$c03f98139dd9719e = 'move-page-dialog-load';
const $d4b865e8cc459c1f$export$1167cf561a6df618 = 'move-published-page';
const $d4b865e8cc459c1f$export$95c6dda6cbbf364 = 'move-blog';
const $d4b865e8cc459c1f$export$fbbc408e16c59382 = 'not-found';
const $d4b865e8cc459c1f$export$cf73dfff88c1f700 = 'view-content';
const $d4b865e8cc459c1f$export$d4712ac27cc4e72f = 'view-page';
const $d4b865e8cc459c1f$export$5e30e9d7ea54dcd2 = 'view-page-session';
const $d4b865e8cc459c1f$export$2a57468d23984a9d = 'space-overview';
const $d4b865e8cc459c1f$export$54504a2cc31519bf = 'breadcrumbs';
const $d4b865e8cc459c1f$export$68af05e1cf40b8e6 = 'breadcrumbs/dropdown';
const $d4b865e8cc459c1f$export$863ebd92a50403cf = 'view-page/title';
const $d4b865e8cc459c1f$export$df0793573ff7d63c = 'view-page/reactions';
const $d4b865e8cc459c1f$export$bdd2d0f331a38827 = 'view-page/labels'; //After confluence_frontend_labels_in_footer is rolled out, this will only beused for tiny pages which show the old view page labels experience
const $d4b865e8cc459c1f$export$def55fa9fa47c777 = 'view-page/labels/footer';
const $d4b865e8cc459c1f$export$49fde5724a27b431 = 'view-page/byline';
const $d4b865e8cc459c1f$export$7a119c18309263c = 'view-page/byline/forge';
const $d4b865e8cc459c1f$export$45c9f537ef090ccd = 'view-page/comments';
const $d4b865e8cc459c1f$export$d7d1b2bdd9bd08f4 = 'view-page/direct-comment-data-flow';
const $d4b865e8cc459c1f$export$dc03e514628af5e9 = 'view-page/edit';
const $d4b865e8cc459c1f$export$38478feb41239856 = 'view-page/content-tools';
const $d4b865e8cc459c1f$export$ef641459105e6b1a = 'view-page/content-tools/forge';
const $d4b865e8cc459c1f$export$255077470163d493 = 'view-page/context-menu';
const $d4b865e8cc459c1f$export$43081e88ffac9568 = 'view-page/context-menu/forge';
const $d4b865e8cc459c1f$export$14a39beec323232a = 'view-page/content-header'; // for old view page header
const $d4b865e8cc459c1f$export$5870dabed6d7b7fc = 'view-page/favorite';
const $d4b865e8cc459c1f$export$857306718a36d667 = 'view-page/share-button';
const $d4b865e8cc459c1f$export$b7907767002e32d = 'view-page/restrictions-button';
const $d4b865e8cc459c1f$export$aa15347df133b367 = 'view-page/comment-button';
const $d4b865e8cc459c1f$export$18cb1bed3afb8173 = 'view-page/discover-inline-comments-feature';
const $d4b865e8cc459c1f$export$b500820ed8b3aee5 = 'view-page/publish-as-blog';
const $d4b865e8cc459c1f$export$a83700d85c7e0745 = 'whiteboard-page';
const $d4b865e8cc459c1f$export$bdaf5db6d84a5581 = 'whiteboard-page/content';
const $d4b865e8cc459c1f$export$4252e8d96c415d57 = 'whiteboard-version-history-side-panel';
const $d4b865e8cc459c1f$export$b8cdecdc06b6252 = 'whiteboard-restore-version';
const $d4b865e8cc459c1f$export$90f5a89f66458e77 = 'whiteboard-version-history-restore-modal';
const $d4b865e8cc459c1f$export$f02aef641190ead6 = 'database-page';
const $d4b865e8cc459c1f$export$7140ccdb0c7b2b37 = 'database-page/content';
const $d4b865e8cc459c1f$export$857587c3b96ae00c = 'database-version-history-side-panel';
const $d4b865e8cc459c1f$export$bdbfe4dafa70ffab = 'database-restore-version';
const $d4b865e8cc459c1f$export$7cc7b880d5b3f324 = 'database-version-history-restore-modal';
const $d4b865e8cc459c1f$export$ba3b240cb9a3ffd0 = 'database-load-historical-version';
const $d4b865e8cc459c1f$export$c85a8dac7f241add = 'embed-page';
const $d4b865e8cc459c1f$export$927658f514adba70 = 'embed-page/content';
const $d4b865e8cc459c1f$export$c1092431c58e1571 = 'edit-embed';
const $d4b865e8cc459c1f$export$3485e62ad9c27d0b = 'folder-page';
const $d4b865e8cc459c1f$export$6237c6dbe5a63f05 = 'folder-page/content';
const $d4b865e8cc459c1f$export$7fd0425089f6d999 = 'content-types-header';
const $d4b865e8cc459c1f$export$47f14e5e827cfff3 = 'content-types-header/watch';
const $d4b865e8cc459c1f$export$748b7f600814978a = 'content-creation-paywall';
const $d4b865e8cc459c1f$export$5e1aeeb6f31be57a = 'record-loom-entry-point';
const $d4b865e8cc459c1f$export$c427a8b1052a6522 = 'loom-page-header-content-insertion';
const $d4b865e8cc459c1f$export$6ca90e5df7047c10 = 'loom-cross-sell';
const $d4b865e8cc459c1f$export$96f8e8997d2c8722 = 'edit-page/labels';
const $d4b865e8cc459c1f$export$e9e0897b7cf2ab3f = 'labels/add-label';
const $d4b865e8cc459c1f$export$5a4fc6855f9c48e = 'labels/create-label';
const $d4b865e8cc459c1f$export$3f19e9a9a0d72413 = 'labels/delete-label';
const $d4b865e8cc459c1f$export$39d403abc2174e5e = 'labels/search-label';
const $d4b865e8cc459c1f$export$4d573c9dfbc9337c = 'labels/recommended';
const $d4b865e8cc459c1f$export$8af5d568de2d4e43 = 'template-edit-page/labels';
const $d4b865e8cc459c1f$export$c5ef6dea1c804893 = 'template-edit-page/labels/add-label';
const $d4b865e8cc459c1f$export$fa82b911a68fea4d = 'template-edit-page/labels/create-label';
const $d4b865e8cc459c1f$export$20b2f79b83628af0 = 'template-edit-page/labels/delete-label';
const $d4b865e8cc459c1f$export$479dc90f08ae49d = 'template-edit-page/labels/search-label';
const $d4b865e8cc459c1f$export$d8e5793fc3893dd0 = 'header-items/group-load';
const $d4b865e8cc459c1f$export$66f0a82e06e92ea = 'home';
const $d4b865e8cc459c1f$export$8856e11bfa69959d = 'home/spaces';
const $d4b865e8cc459c1f$export$8ef0e6a462dfc555 = 'home/recent-pages';
const $d4b865e8cc459c1f$export$d931b261468db3be = 'home/right-panel';
const $d4b865e8cc459c1f$export$cd6478684fc4b278 = 'home/right-panel/activity';
const $d4b865e8cc459c1f$export$45cf379c9ef28a2d = 'home/right-panel/welcome-message';
const $d4b865e8cc459c1f$export$ceb391a6374fc2 = 'home/right-panel/calendars';
const $d4b865e8cc459c1f$export$799c1b543715aab4 = 'home/right-panel/apps';
const $d4b865e8cc459c1f$export$519eb6f457873738 = 'home/right-panel/forge';
const $d4b865e8cc459c1f$export$b57c8eba324f4ab1 = 'home/right-panel/recommendations';
const $d4b865e8cc459c1f$export$cf6a4f3279a69e87 = 'confluence';
const $d4b865e8cc459c1f$export$680e462c4f71cea1 = 'feed';
const $d4b865e8cc459c1f$export$d660d67b42309542 = 'home/overview';
const $d4b865e8cc459c1f$export$f987075f870b167d = 'home/overview/recent';
const $d4b865e8cc459c1f$export$6c96437f170477a4 = 'home/overview/recent/paginate';
const $d4b865e8cc459c1f$export$94f2ecf008a81b99 = 'home/recent';
const $d4b865e8cc459c1f$export$45d7f7ed7a82bcd = 'home/starred';
const $d4b865e8cc459c1f$export$ecf5fd41d4da9bf8 = 'home/watching';
const $d4b865e8cc459c1f$export$9b242f2ddcd908fc = 'home/drafts';
const $d4b865e8cc459c1f$export$5393f7f46c9e5055 = 'advanced-search';
const $d4b865e8cc459c1f$export$91a00c702eb82c2c = 'advanced-search/space-filter';
const $d4b865e8cc459c1f$export$3f0c1a8eb5419bb4 = 'advanced-search/contributor-filter';
const $d4b865e8cc459c1f$export$bda2c35d9a84e22c = 'advanced-search/smart-contributor-filter';
const $d4b865e8cc459c1f$export$ec545137ad6ac054 = 'quick-search/pre-query';
const $d4b865e8cc459c1f$export$e64dfa2771353f5c = 'recent-dropdown/visited';
const $d4b865e8cc459c1f$export$53f4f21972586e42 = 'recent-dropdown/created-by-me';
const $d4b865e8cc459c1f$export$985013c384c228e1 = 'recent-dropdown/worked-on';
const $d4b865e8cc459c1f$export$605220fac97de = 'recent-dropdown/drafts';
const $d4b865e8cc459c1f$export$7c6d9e11a2120c1b = 'recent-dropdown/starred';
const $d4b865e8cc459c1f$export$59a9c2c7ae337de7 = 'page-tree';
const $d4b865e8cc459c1f$export$bbc326cd1f124322 = 'page-tree/dnd';
const $d4b865e8cc459c1f$export$f9d04e98575a0216 = 'page-tree/quick-actions';
const $d4b865e8cc459c1f$export$cd3eec90d152a8ea = 'page-tree/rename';
const $d4b865e8cc459c1f$export$9d1f80f618a6627b = 'blog-tree';
const $d4b865e8cc459c1f$export$899513ff8720fa55 = 'blog-tree/pagination';
const $d4b865e8cc459c1f$export$d200becb25c80dc0 = 'activity/tailored';
const $d4b865e8cc459c1f$export$8729a78bfed79808 = 'activity/create-space-button';
const $d4b865e8cc459c1f$export$b0be9d71080b7c81 = 'activity/right-sidebar';
const $d4b865e8cc459c1f$export$2783f61e72caafb5 = 'feed-migration/activity/popular';
const $d4b865e8cc459c1f$export$fcff442a18d04a5d = 'feed-migration/activity/all-updates';
const $d4b865e8cc459c1f$export$357a2b9b5fb0f4e4 = 'navigation/nav-2-admin-navigation/forge';
const $d4b865e8cc459c1f$export$9b5915bb3a4fbcae = 'navigation/app-nav-global-navigation';
const $d4b865e8cc459c1f$export$e3e183dd97af67fd = 'navigation/app-nav-container-navigation';
const $d4b865e8cc459c1f$export$14b67f3e8f5e6f95 = 'navigation/app-nav-admin-navigation';
const $d4b865e8cc459c1f$export$f089f204ab93864e = 'navigation/app-nav-spaces-dropdown';
const $d4b865e8cc459c1f$export$5c3671291c82150b = 'navigation/app-nav-pages-dropdown';
const $d4b865e8cc459c1f$export$63d03b6879925116 = 'navigation/app-nav-apps-dropdown';
const $d4b865e8cc459c1f$export$fa160b39d3766fc0 = 'navigation/app-nav-notifications-dropdown';
const $d4b865e8cc459c1f$export$986139018de1521a = 'navigation/app-nav-profile-dropdown';
const $d4b865e8cc459c1f$export$6cebb7e0b005cd28 = 'space-directory';
const $d4b865e8cc459c1f$export$aeda23f4b92ccc3b = 'space-directory/your-spaces';
const $d4b865e8cc459c1f$export$4a890f75d0a61967 = 'space-directory/filter';
const $d4b865e8cc459c1f$export$39e9ebfcfd8e8bad = 'space-directory/paginate';
const $d4b865e8cc459c1f$export$de6098630f95035a = 'create-space/submit';
const $d4b865e8cc459c1f$export$9b47bc79e174bc93 = 'create-space/validate';
const $d4b865e8cc459c1f$export$1d45fd96fcd751f5 = 'onboarding/start';
const $d4b865e8cc459c1f$export$c33c0eca528dad5c = 'onboarding/invite-users';
const $d4b865e8cc459c1f$export$6d895b52727161d4 = 'onboarding/remove-invite-users';
const $d4b865e8cc459c1f$export$be07109624e8a07e = 'onboarding/create-a-space';
const $d4b865e8cc459c1f$export$d5e6e79f726e8007 = 'onboarding/choose-a-space';
const $d4b865e8cc459c1f$export$87a646b39eb224a = 'onboarding/end';
const $d4b865e8cc459c1f$export$a453322b492264d1 = 'onboarding/choose-a-space-card';
const $d4b865e8cc459c1f$export$4ead33eb5b37dee5 = 'onboarding/follow-spaces';
const $d4b865e8cc459c1f$export$59c55b717acdcf15 = 'onboarding/auto-follow-spaces';
const $d4b865e8cc459c1f$export$a09834a747086083 = 'onboarding/shared-link-spotlight';
const $d4b865e8cc459c1f$export$749c4d9c23381805 = 'onboarding/nudge';
const $d4b865e8cc459c1f$export$1aaba3dd5fd71b43 = 'onboarding-account-setup-modal';
const $d4b865e8cc459c1f$export$7989a920a6248647 = 'onboarding-jsw-xflow/admin-switcher-tour';
const $d4b865e8cc459c1f$export$55172161173a2d6e = 'onboarding-jsw-xflow/nth-switcher-tour';
const $d4b865e8cc459c1f$export$aaf55a29d2f12a6e = 'onboarding-jsw-xflow/invite-teammate-task';
const $d4b865e8cc459c1f$export$e40755126e0d0b54 = 'onboarding-editor/draft-banner';
const $d4b865e8cc459c1f$export$32b7ff7de164c7ad = 'onboarding-editor/land-in-editor-banner';
const $d4b865e8cc459c1f$export$b154482ef737e03a = 'onboarding-editor/quickstart-tutorial-task';
const $d4b865e8cc459c1f$export$d04515c6314fec11 = 'onboarding-editor/publish-modal-prompt';
const $d4b865e8cc459c1f$export$8425321c06a7c373 = 'onboarding-editor/publish-success-flag';
const $d4b865e8cc459c1f$export$f3de65caafc09b21 = 'onboarding-editor/recent-draft-spotlight';
const $d4b865e8cc459c1f$export$25e1b00b32cd992d = 'onboarding/query/labels';
const $d4b865e8cc459c1f$export$8ef86f4d4da92fa5 = 'onboarding/grace-period-banner';
const $d4b865e8cc459c1f$export$8125e64b190d01e2 = 'onboarding/storage-enforcement-banner';
const $d4b865e8cc459c1f$export$343afc350dc963df = 'onboarding/storage-enforcement-banner/dismiss';
const $d4b865e8cc459c1f$export$9491541521237449 = 'onboarding/storage-enforcement-flags';
const $d4b865e8cc459c1f$export$616864953f0d339 = 'onboarding/storage-enforcement/block-create-modal';
const $d4b865e8cc459c1f$export$61418bee30087820 = 'onboarding/home/templates-collection';
const $d4b865e8cc459c1f$export$70cb2a8c47e6afd8 = 'onboarding/home/templates-collection/create-template';
const $d4b865e8cc459c1f$export$e61bc67cff9e0f2 = 'onboarding/ibo/new-home/recent-page';
const $d4b865e8cc459c1f$export$c1f744d5e0181dd = 'onboarding/ibo/new-home/spaces';
const $d4b865e8cc459c1f$export$5ddea2545ba37329 = 'onboarding/ibo/new-home';
const $d4b865e8cc459c1f$export$c03570fb82968b7e = 'onboarding/nth-user-setup-modal';
const $d4b865e8cc459c1f$export$59679d849f29c62b = 'onboarding/onboarding-tracker';
const $d4b865e8cc459c1f$export$7893ecd5dfd2c478 = 'onboarding/onboarding-tracker/organize-space/spotlight';
const $d4b865e8cc459c1f$export$f63cf886d6298a0d = 'onboarding/onboarding-tracker/add-content/spotlight';
const $d4b865e8cc459c1f$export$7b13a63caff7cb41 = 'onboarding/onboarding-tracker/invite-people/spotlight';
const $d4b865e8cc459c1f$export$3971f3f0bdcc083 = 'onboarding/onboarding-surface-import/global-import/create-page';
const $d4b865e8cc459c1f$export$7e62e90cd8969fd8 = 'onboarding/confluence-recap-modal';
const $d4b865e8cc459c1f$export$5612c7c22aba3ae8 = 'onboarding/confluence-home-onboarding-takeover-v2';
const $d4b865e8cc459c1f$export$3edd3fbbb3bde42a = 'onboarding/nth-user-confluence-home-onboarding-takeover';
const $d4b865e8cc459c1f$export$e97003dd72490d60 = 'onboarding/confluence-home-onboarding-takeover-v2/home-nudge';
const $d4b865e8cc459c1f$export$be5f66bc85ac48a2 = 'onboarding/confluence-personalized-templates-v2';
const $d4b865e8cc459c1f$export$4ef813fe853a14e1 = 'onboarding/nth-user-home-onboarding-revamp';
const $d4b865e8cc459c1f$export$241c40e7f0f7d7b2 = 'content-action-apps/forge';
const $d4b865e8cc459c1f$export$404655cfa9ecfbc3 = 'byline-apps/forge';
const $d4b865e8cc459c1f$export$224bdd20537c043c = 'context-menu-apps/forge';
const $d4b865e8cc459c1f$export$fe9e3a7216162400 = 'settings-page-apps/forge';
const $d4b865e8cc459c1f$export$16a139fd3cad706d = 'custom-content-apps/forge';
const $d4b865e8cc459c1f$export$a333c0535291436a = 'space-page-apps/forge';
const $d4b865e8cc459c1f$export$4e660f0eec1b7b63 = 'space-settings/integrations/forge';
const $d4b865e8cc459c1f$export$42fe8757b12b9abb = 'space-settings-v2/integrations/forge';
const $d4b865e8cc459c1f$export$e4e961f07f20b1e9 = 'space-settings-v2/landing-page';
const $d4b865e8cc459c1f$export$30670c5b5576bc9d = 'global-page-apps/forge';
const $d4b865e8cc459c1f$export$de2b763dff9c90e = 'full-page-apps/forge';
const $d4b865e8cc459c1f$export$7fee035e8993093b = 'background-script-apps/forge';
const $d4b865e8cc459c1f$export$d773e3323beb4d91 = 'site-permission/space-access';
const $d4b865e8cc459c1f$export$1fdf87b44bf66203 = 'space-pages';
const $d4b865e8cc459c1f$export$eab5c9963f80520c = 'space-pages/filter';
const $d4b865e8cc459c1f$export$6af7d14b23c7ed20 = 'space-pages/paginate';
const $d4b865e8cc459c1f$export$1ae7d5b32e27dd1b = 'space-views/initial';
const $d4b865e8cc459c1f$export$92e7a42b4d134675 = 'space-views/change';
const $d4b865e8cc459c1f$export$cd0c9383cd80d210 = 'space-views/paginate';
const $d4b865e8cc459c1f$export$90dff6c3d9facebb = 'space-views/hover-page-card';
const $d4b865e8cc459c1f$export$8a00f2824cff2c5e = 'site-permissions/space-access/remove';
const $d4b865e8cc459c1f$export$30e6c2e5c854e3d7 = 'site-permissions/space-access/add';
const $d4b865e8cc459c1f$export$b07723d1eb2313ad = 'site-permissions/space-access/guest/change';
const $d4b865e8cc459c1f$export$94d2e4338cb54b2c = 'insights/page-byline';
const $d4b865e8cc459c1f$export$27bffcf643f6c238 = 'insights/page-dialog';
const $d4b865e8cc459c1f$export$460c09ff51f88f24 = 'insights/page-dialog-upsell';
const $d4b865e8cc459c1f$export$371cd738ccd37b38 = 'insights/page-analytics';
const $d4b865e8cc459c1f$export$3861bdd55a91a4a0 = 'insights/page-analytics/view-chart';
const $d4b865e8cc459c1f$export$968182ed9835d21a = 'insights/page-analytics/total-views-card';
const $d4b865e8cc459c1f$export$24ed3cf43f154734 = 'insights/page-analytics/unique-viewers-card';
const $d4b865e8cc459c1f$export$a531b5e2ff0b9747 = 'insights/page-analytics/mentioned-users-card';
const $d4b865e8cc459c1f$export$27ccd506e08e0e = 'insights/page-analytics/viewers-table';
const $d4b865e8cc459c1f$export$ec84fc419c424bb5 = 'insights/page-analytics/mentioned-users-reminder';
const $d4b865e8cc459c1f$export$8ddcb6f0d9ebf30e = 'insights/page-analytics/mentioned-users-table';
const $d4b865e8cc459c1f$export$f8f3f70f34becef9 = 'insights/page-analytics/links-inbound-total-clicks-card';
const $d4b865e8cc459c1f$export$3d388f0f7fc44c3f = 'insights/page-analytics/links-inbound-ctr-card';
const $d4b865e8cc459c1f$export$310d1207c2b3ca7d = 'insights/page-analytics/links-inbound-table';
const $d4b865e8cc459c1f$export$ab6abc47e6a1b436 = 'insights/page-analytics/links-outbound-total-clicks-card';
const $d4b865e8cc459c1f$export$a1934b3cd762057c = 'insights/page-analytics/links-outbound-ctr-card';
const $d4b865e8cc459c1f$export$11b4f841e984d2a8 = 'insights/page-analytics/links-outbound-table';
const $d4b865e8cc459c1f$export$5478a6cbf2100291 = 'insights/space-analytics';
const $d4b865e8cc459c1f$export$12f42654844570d0 = 'insights/space-analytics/overview-chart';
const $d4b865e8cc459c1f$export$40a98279383e549e = 'insights/space-analytics/popular-content-card';
const $d4b865e8cc459c1f$export$340eeaf9226a3e00 = 'insights/space-analytics/active-readers-card';
const $d4b865e8cc459c1f$export$327f825878dc4802 = 'insights/space-analytics/active-contributors-card';
const $d4b865e8cc459c1f$export$9595ac2edfb0edec = 'insights/space-analytics/content-activity-table';
const $d4b865e8cc459c1f$export$bfbd1b5517d327f6 = 'insights/space-analytics/user-activity-table';
const $d4b865e8cc459c1f$export$ae73006a481ab5bc = 'insights/space-analytics/async-export';
const $d4b865e8cc459c1f$export$e27cd103e9670e33 = 'insights/space-analytics/permissions/load';
const $d4b865e8cc459c1f$export$5a507008b468c991 = 'insights/space-analytics/permissions/update';
const $d4b865e8cc459c1f$export$8ed4273d919d1070 = 'insights/site-analytics';
const $d4b865e8cc459c1f$export$f2d660eb8a9ba56e = 'insights/site-analytics/overview-chart';
const $d4b865e8cc459c1f$export$8e5ed6a75264c549 = 'insights/site-analytics/popular-spaces-card';
const $d4b865e8cc459c1f$export$7cc392d1f03d59f9 = 'insights/site-analytics/active-readers-card';
const $d4b865e8cc459c1f$export$e5b5e8161ac66e90 = 'insights/site-analytics/popular-searches-card';
const $d4b865e8cc459c1f$export$221bc81bca00257 = 'insights/site-analytics/spaces-table';
const $d4b865e8cc459c1f$export$31b3362136d95230 = 'insights/site-analytics/users-table';
const $d4b865e8cc459c1f$export$86dcda8aa2b50b8a = 'insights/site-analytics/search-table';
const $d4b865e8cc459c1f$export$91ffba1860245927 = 'insights/site-analytics/search-panel';
const $d4b865e8cc459c1f$export$1b7a393d48199f1c = 'insights/site-analytics/search-panel/graph';
const $d4b865e8cc459c1f$export$4020b74c723b4607 = 'insights/site-analytics/search-panel/content-list';
const $d4b865e8cc459c1f$export$343c48c7798baab8 = 'insights/site-analytics/search-panel/spaces-list';
const $d4b865e8cc459c1f$export$58ad08103bb62c4b = 'insights/site-analytics/permissions/load';
const $d4b865e8cc459c1f$export$f73b370055c8cbef = 'insights/site-analytics/permissions/update';
const $d4b865e8cc459c1f$export$5d12872cd9595692 = 'bulk-space-permissions';
const $d4b865e8cc459c1f$export$ee395498ea9fc566 = 'global-perms';
const $d4b865e8cc459c1f$export$bbc6348b8482e5b1 = 'expand-group';
const $d4b865e8cc459c1f$export$f96f0a60f840676c = 'group-members-load-more';
const $d4b865e8cc459c1f$export$7b06f43e66d37bd9 = 'view-space-guest-list';
const $d4b865e8cc459c1f$export$b3639316349424 = 'team-calendar';
const $d4b865e8cc459c1f$export$b731d5eab77f5ae2 = 'team-calendar-upsell';
const $d4b865e8cc459c1f$export$6e2e950545a96fb5 = 'team-calendars/calendar/add';
const $d4b865e8cc459c1f$export$e60dce5b561d6551 = 'team-calendars/calendar/add-existing';
const $d4b865e8cc459c1f$export$25067b28cdd34cc6 = 'team-calendars/calendar/delete';
const $d4b865e8cc459c1f$export$19d86a52695ae312 = 'team-calendars/calendar/remove';
const $d4b865e8cc459c1f$export$120ce8feec0488aa = 'team-calendars/calendar/subscribe';
const $d4b865e8cc459c1f$export$dc96bc0456e09d60 = 'team-calendars/calendar/update';
const $d4b865e8cc459c1f$export$d23cc4800e46d1e6 = 'team-calendars/calendar/import';
const $d4b865e8cc459c1f$export$13b2254026213b46 = 'team-calendars/event-type/add';
const $d4b865e8cc459c1f$export$c348a46d97587ee4 = 'team-calendars/event-type/delete';
const $d4b865e8cc459c1f$export$bfd3172de881908e = 'team-calendars/event-type/update';
const $d4b865e8cc459c1f$export$e1a32de918001908 = 'team-calendars/event/add';
const $d4b865e8cc459c1f$export$36abe825d06f7b68 = 'team-calendars/event/jira-calendar';
const $d4b865e8cc459c1f$export$1be22ae521e809a9 = 'team-calendars/event/update';
const $d4b865e8cc459c1f$export$eb40d48a494923c8 = 'team-calendars/event/delete';
const $d4b865e8cc459c1f$export$66104f246f979de9 = 'team-calendars/restrictions/update';
const $d4b865e8cc459c1f$export$a245b5e8e50aca4e = 'edit-space-logo/restore';
const $d4b865e8cc459c1f$export$38c64d0e786460e8 = 'edit-space-logo/save';
const $d4b865e8cc459c1f$export$53b6eab7c794efdf = 'edit-space-logo/details-load';
const $d4b865e8cc459c1f$export$d4e50447c54e832a = 'cover-picture/unsplash-upload';
const $d4b865e8cc459c1f$export$3b296e5e8d4fbd72 = 'cover-picture/media-upload';
const $d4b865e8cc459c1f$export$75c73b1e1363abb2 = 'cover-picture/remove';
const $d4b865e8cc459c1f$export$56b59e3252d65c77 = 'view-app-suggestions';
const $d4b865e8cc459c1f$export$61ad3866e7413864 = 'conditional_publish_dialog';
const $d4b865e8cc459c1f$export$5685c80727d12c34 = 'extension_point_byline';
const $d4b865e8cc459c1f$export$4b9cf95d297cf82f = 'extension_point_space_buttons';
const $d4b865e8cc459c1f$export$811ef7c3a5f94996 = 'extension_point_home_footer';
const $d4b865e8cc459c1f$export$dfab08323861cbc1 = 'extension_point_home_header';
const $d4b865e8cc459c1f$export$aa9a33eaf0b3cefa = 'extension_point_editor_savebar';
const $d4b865e8cc459c1f$export$4933a09c775176cb = 'extension_point_page_metadata_banner';
const $d4b865e8cc459c1f$export$645909341bfebc9b = 'extension_point_page_banner';
const $d4b865e8cc459c1f$export$facf18b53398c3d7 = 'extension_point_space_settings_tabs';
const $d4b865e8cc459c1f$export$23be08d2ca73ecf = 'core-invites';
const $d4b865e8cc459c1f$export$b1dd9d960d4ea959 = 'custom-content-page-all';
const $d4b865e8cc459c1f$export$38660dec2eb2a695 = 'custom-content-space-list-view';
const $d4b865e8cc459c1f$export$7b1fe4d076a9542a = 'custom-content-page-list-view';
const $d4b865e8cc459c1f$export$ad06e79f63068f5e = 'custom-content-view';
const $d4b865e8cc459c1f$export$eef674482902ef6d = 'connections-panel-view';
const $d4b865e8cc459c1f$export$c5bcbbcb1df627e5 = 'end-of-page-recommendations';
const $d4b865e8cc459c1f$export$3b683344868f9f0a = 'notify-on-first-view';
const $d4b865e8cc459c1f$export$4fdd9934209dba0e = 'presenter-mode/view';
const $d4b865e8cc459c1f$export$40638d9b45e8ceca = 'presenter-mode/full-screen-api';
const $d4b865e8cc459c1f$export$b1f7a84b45eb9afb = 'view-public-link-site-settings';
const $d4b865e8cc459c1f$export$8294c237289049c4 = 'view-public-link-spaces-table';
const $d4b865e8cc459c1f$export$ec6e09c5fd9fa221 = 'view-public-links-page-table';
const $d4b865e8cc459c1f$export$5cc7e9470bfae723 = 'public-links-spaces-table-action';
const $d4b865e8cc459c1f$export$c102a9d514fc95ac = 'public-link-site-toggle-change';
const $d4b865e8cc459c1f$export$ff2fb656c8231637 = 'view-public-links-space-settings';
const $d4b865e8cc459c1f$export$ba803d464f49a265 = 'public-links-space-toggle-change';
const $d4b865e8cc459c1f$export$d95bcf023bd8993 = 'view-public-links-default-space-settings';
const $d4b865e8cc459c1f$export$7362876707c57af9 = 'public-links-default-space-toggle-change';
const $d4b865e8cc459c1f$export$c7ff49e7eaa45ff1 = 'view-public-link-shared-page';
const $d4b865e8cc459c1f$export$24cbec84f278c600 = 'public-link-rendered';
const $d4b865e8cc459c1f$export$5b89a66b04cea206 = 'public-link-toggle-change';
const $d4b865e8cc459c1f$export$44b7602dc9689e08 = 'public-link-disable-from-restrictions';
const $d4b865e8cc459c1f$export$eed7907041fecd69 = 'public-link-page-table-action';
const $d4b865e8cc459c1f$export$49a01ffc1a18656b = 'external-share';
const $d4b865e8cc459c1f$export$e25df1f458506fcd = 'copy-content-link';
const $d4b865e8cc459c1f$export$7c34e8285a2b9238 = 'content-history';
const $d4b865e8cc459c1f$export$b9b41dfe39f06772 = 'view-tasks';
const $d4b865e8cc459c1f$export$6be3453279e7dd85 = 'set-task-complete';
const $d4b865e8cc459c1f$export$80a3b142ba868b57 = 'change-page-owner';
const $d4b865e8cc459c1f$export$19875313f499fad9 = 'content-ownership/dialog';
const $d4b865e8cc459c1f$export$e94c6163c32592ce = 'admin-announcement-banner';
const $d4b865e8cc459c1f$export$7653dfd9fd5557b = 'admin-announcement-banner-dismissed';
const $d4b865e8cc459c1f$export$394294e59b36efb9 = 'admin-announcement-banner-settings';
const $d4b865e8cc459c1f$export$8f017785cc4bb995 = 'admin-announcement-banner-publish';
const $d4b865e8cc459c1f$export$a4d890726485d79a = 'admin-announcement-banner-turn-off';
const $d4b865e8cc459c1f$export$47d510c88b13ea8d = 'admin-announcement-banner-table';
const $d4b865e8cc459c1f$export$548adb1a2fe6e6b1 = 'space-manager';
const $d4b865e8cc459c1f$export$35f739fc0b127205 = 'space-manager-quick-action-item';
const $d4b865e8cc459c1f$export$bfe6ff6cddeed6e3 = 'importer-dashboard';
const $d4b865e8cc459c1f$export$2decaadcf840e6b3 = 'company-hub-general-settings';
const $d4b865e8cc459c1f$export$23b4a008c670d304 = 'company-hub-general-settings-your-hub';
const $d4b865e8cc459c1f$export$c6198e9d6ab9e417 = 'company-hub-general-settings-your-hub-actions';
const $d4b865e8cc459c1f$export$e1b506612f6e9657 = 'company-hub-general-settings-recent-activity';
const $d4b865e8cc459c1f$export$dfdc3f1142f40689 = 'company-hub-general-settings-hub-views';
const $d4b865e8cc459c1f$export$e9845af7b7fd8501 = 'company-hub-general-settings-most-clicks';
const $d4b865e8cc459c1f$export$237a7d3a8e219dbb = 'admin-center';
const $d4b865e8cc459c1f$export$b7b3a9d4d05ffd12 = 'admin-center-confluence-admins';
const $d4b865e8cc459c1f$export$367f60a3ad6918c1 = 'admin-center-search-count';
const $d4b865e8cc459c1f$export$9a8113803e6447cf = 'admin-center-search-ctr';
const $d4b865e8cc459c1f$export$8f37d7eb1e6f681d = 'admin-center-top-searches';
const $d4b865e8cc459c1f$export$2ad5d40786f81da0 = 'admin-center-top-unsuccessful-searches';
const $d4b865e8cc459c1f$export$e68566fb281dbb33 = 'admin-center-external-access';
const $d4b865e8cc459c1f$export$a7f1ee469fd8596c = 'admin-center-beta-features';
const $d4b865e8cc459c1f$export$8a3b06f53918d80e = 'admin-center-total-spaces';
const $d4b865e8cc459c1f$export$d4f2672a4a997be2 = 'admin-center-total-content';
const $d4b865e8cc459c1f$export$61440d1f5d765856 = 'admin-center-grouped-summary-section';
const $d4b865e8cc459c1f$export$a122d82c3b13ba99 = 'admin-center-inactive-pages';
const $d4b865e8cc459c1f$export$bf035e1987052c42 = 'admin-center-top-inactive-pages';
const $d4b865e8cc459c1f$export$1613edca53571ea3 = 'admin-center-deactivated-owner-pages';
const $d4b865e8cc459c1f$export$4ba2b40dc30760f9 = 'admin-center-top-deactivated-owner-pages';
const $d4b865e8cc459c1f$export$5d6b6234c4e9f70d = 'admin-center-content-created';
const $d4b865e8cc459c1f$export$39552d32ae5efc36 = 'admin-center-content-updated';
const $d4b865e8cc459c1f$export$a4934c826482e207 = 'admin-center-content-views';
const $d4b865e8cc459c1f$export$4c0549ea0cf0f43d = 'admin-center-top-content-views';
const $d4b865e8cc459c1f$export$6b8c8a94a6fb0b10 = 'admin-center-grouped-summary-section-v2-update';
const $d4b865e8cc459c1f$export$a4855248cbcdc638 = 'admin-center-grouped-summary-section-v2';
const $d4b865e8cc459c1f$export$f1c6b44ad858e24f = 'admin-center-search-count-summary';
const $d4b865e8cc459c1f$export$aaba8c517b5b0014 = 'admin-center-search-ctr-summary';
const $d4b865e8cc459c1f$export$3463471aa64d2a20 = 'admin-center-total-spaces-summary';
const $d4b865e8cc459c1f$export$aed49d47c6d277d2 = 'admin-center-total-content-summary';
const $d4b865e8cc459c1f$export$c89944dc251c7694 = 'admin-center-inactive-pages-num-summary';
const $d4b865e8cc459c1f$export$45d06e7b1bc06ed4 = 'admin-center-inactive-pages-percent-summary';
const $d4b865e8cc459c1f$export$50744fb70a2982a2 = 'admin-center-deactivated-owner-pages-num-summary';
const $d4b865e8cc459c1f$export$35f523c785c60e15 = 'admin-center-deactivated-owner-pages-percent-summary';
const $d4b865e8cc459c1f$export$d4f40a3c80d7fa00 = 'admin-center-content-created-summary';
const $d4b865e8cc459c1f$export$3e98f2df16d1f652 = 'admin-center-content-updated-summary';
const $d4b865e8cc459c1f$export$512d403dd28c8f13 = 'admin-center-content-views-summary';
const $d4b865e8cc459c1f$export$b5db801ede6fe9e5 = 'admin-center-public-link-views-summary';
const $d4b865e8cc459c1f$export$2df6bcfd56d7c9e8 = 'admin-center-public-links-summary';
const $d4b865e8cc459c1f$export$6c98543cf0a07a9f = 'admin-center-suggestions';
const $d4b865e8cc459c1f$export$9f5be3c30e870f46 = 'admin-center-suggestions-unassigned-guest';
const $d4b865e8cc459c1f$export$56c7132579558fc8 = 'admin-center-suggestions-inactive-pages';
const $d4b865e8cc459c1f$export$4bc17e6067981b1f = 'admin-center-suggestions-deactivated-owner-pages';
const $d4b865e8cc459c1f$export$2f62829f51afa45a = 'admin-center-suggestions-space-manager';
const $d4b865e8cc459c1f$export$19020e617b152304 = 'admin-center-suggestions-user-access';
const $d4b865e8cc459c1f$export$12a435102ccb624a = 'admin-center-suggestions-quick-action-item';
const $d4b865e8cc459c1f$export$dec2cee4628ab9c4 = 'admin-center-suggestions-metric-cta';
const $d4b865e8cc459c1f$export$88a8c07833ef47b1 = 'space-admin-center';
const $d4b865e8cc459c1f$export$fb0bb005ed2de56c = 'space-admin-center-grouped-summary-section';
const $d4b865e8cc459c1f$export$73c5a862f5073e46 = 'space-admin-center-external-access';
const $d4b865e8cc459c1f$export$4d72041a86e9e003 = 'space-admin-center-space-admins';
const $d4b865e8cc459c1f$export$724928cbf61f8819 = 'space-admin-center-content-views';
const $d4b865e8cc459c1f$export$eee5f90734589227 = 'space-admin-center-top-content-views';
const $d4b865e8cc459c1f$export$a5e95165e3a702d1 = 'space-admin-center-content-created';
const $d4b865e8cc459c1f$export$32dde1d12c499528 = 'space-admin-center-content-updated';
const $d4b865e8cc459c1f$export$147226654b32f956 = 'space-admin-center-total-content';
const $d4b865e8cc459c1f$export$648d00fafa66ae14 = 'space-admin-center-inactive-pages';
const $d4b865e8cc459c1f$export$a3fdce9bb003f0b8 = 'space-admin-center-top-inactive-pages';
const $d4b865e8cc459c1f$export$71daddda71b57298 = 'space-admin-center-deactivated-owner-pages';
const $d4b865e8cc459c1f$export$62d9e5dacf2e073d = 'space-admin-center-top-deactivated-owner-pages';
const $d4b865e8cc459c1f$export$8c3b600f7a5dce0f = 'dwell-time/start';
const $d4b865e8cc459c1f$export$b0fe8424f6f27f51 = 'trial-components/lozenge-view';
const $d4b865e8cc459c1f$export$40c0cee2cad141c5 = 'trial-components/flag-view';
const $d4b865e8cc459c1f$export$d6bad6d87d8c028f = 'trial-components/premium-insights-action-menu-item-view';
const $d4b865e8cc459c1f$export$d0e7688ec900110c = 'team-presence/avatar-group-view';
const $d4b865e8cc459c1f$export$655feba7d95d5b26 = 'team-presence/click-to-find';
const $d4b865e8cc459c1f$export$a3748c7e642ec857 = 'flywheel-feature-discovery';
const $d4b865e8cc459c1f$export$f8372d329c2aeea0 = 'quick-summary';
const $d4b865e8cc459c1f$export$31e4e6e2658a6cae = 'quick-summary-whiteboards';
const $d4b865e8cc459c1f$export$4a493e4dc06e57e7 = 'quick-summary-to-page';
const $d4b865e8cc459c1f$export$5565b0bba4d72eee = 'comments-summary';
const $d4b865e8cc459c1f$export$c17159824be2dcc1 = 'comments-panel-summary';
const $d4b865e8cc459c1f$export$8d9dfd2f17501337 = 'ai-content-catchup';
const $d4b865e8cc459c1f$export$eb38477d5de37f36 = 'ai-presentation-generation-view';
const $d4b865e8cc459c1f$export$ed3e815374d54f04 = 'ai-presentation-generation-create';
const $d4b865e8cc459c1f$export$bb8fdee2f545676e = 'ai-snippet';
const $d4b865e8cc459c1f$export$c114a6d7848b93cb = 'ai-bulk-issue-create';
const $d4b865e8cc459c1f$export$a48ee5f2c131dea3 = 'ai-audio';
const $d4b865e8cc459c1f$export$f9a8f9ac1a851fe7 = 'ai-audio-briefing';
const $d4b865e8cc459c1f$export$6086ea87dfcad89d = 'ai-audio-narration';
const $d4b865e8cc459c1f$export$daafa0ab79e187e5 = 'ai-title-generation';
const $d4b865e8cc459c1f$export$8091bb21bb2521cb = 'ai-header-image-generation';
const $d4b865e8cc459c1f$export$530e334566c01c65 = 'plan-comparison-modal';
const $d4b865e8cc459c1f$export$af3f8586c2e30e0 = 'pendo-installation';
const $d4b865e8cc459c1f$export$7f32d11b06ee25ff = 'reading-aids';
const $d4b865e8cc459c1f$export$38e6a52d8f0a641f = 'ai-definitions-autohighlight';
const $d4b865e8cc459c1f$export$9bd965a890617f5b = 'view-guest-request-to-upgrade';
const $d4b865e8cc459c1f$export$85b1366ed05e7209 = 'submit-guest-request-to-upgrade';
const $d4b865e8cc459c1f$export$7ca653e6d1fa2509 = 'view-guest-request-to-upgrade-side-nav';
const $d4b865e8cc459c1f$export$30addda68c1793d0 = 'submit-guest-request-to-upgrade-side-nav';
const $d4b865e8cc459c1f$export$aace851408b6de3e = 'submit-guest-mentions-upgrade-flow';
const $d4b865e8cc459c1f$export$611140537004e76c = 'view-guest-spaces-menu-request-to-upgrade';
const $d4b865e8cc459c1f$export$e73147035caab2f2 = 'submit-guest-spaces-menu-request-to-upgrade';
const $d4b865e8cc459c1f$export$11311af26ac8cb8b = 'restore-space';
const $d4b865e8cc459c1f$export$dec29f1de3a4a5ce = 'hard-delete-space';
const $d4b865e8cc459c1f$export$e69556d68987dda1 = 'view-space-permissions';
const $d4b865e8cc459c1f$export$a5bcda9ae1f6839a = 'edit-space-permissions';
const $d4b865e8cc459c1f$export$22c9153bc8c871f3 = 'view-app-custom-content-permissions';
const $d4b865e8cc459c1f$export$32f7f39f260e234c = 'edit-app-custom-content-permissions';
const $d4b865e8cc459c1f$export$c39bf2cb4e8cc70c = 'view-jsm-banner';
const $d4b865e8cc459c1f$export$4e373788dac39943 = 'disable-jsm-permissions';
const $d4b865e8cc459c1f$export$f7308c84ae7be9c8 = 'view-default-space-permissions';
const $d4b865e8cc459c1f$export$85cd19170159a085 = 'edit-default-space-permissions';
const $d4b865e8cc459c1f$export$3cfa8e4552e9e6ce = 'view-all-spaces-tab';
const $d4b865e8cc459c1f$export$c9f8ebbba8f73eeb = 'company-home-builder-load';
const $d4b865e8cc459c1f$export$d4d3fc5b22a2a5d2 = 'company-home-builder-edit';
const $d4b865e8cc459c1f$export$cc438f9a49eb57aa = 'company-home-builder-edit/upload';
const $d4b865e8cc459c1f$export$90e15cc4582adffa = 'company-hub-creation';
const $d4b865e8cc459c1f$export$9458ecd4beb6dc6b = 'company-hub-change-hub-name';
const $d4b865e8cc459c1f$export$7f2689ec25c432a4 = 'front-cover-load'; // TODO: rename this to COMPANY_HUB_LOAD_EXPERIENCE
const $d4b865e8cc459c1f$export$c8ff6311a26d2c8c = 'company-hub-unpublish-hub';
const $d4b865e8cc459c1f$export$f5a5045f5872d850 = 'company-hub-analytics';
const $d4b865e8cc459c1f$export$2c2b8afe13693d2b = 'company-hub-analytics-box-row';
const $d4b865e8cc459c1f$export$db8c2f7bf58fe015 = 'company-hub-analytics-chart';
const $d4b865e8cc459c1f$export$b0852f88603c392f = 'company-hub-analytics-table';
const $d4b865e8cc459c1f$export$c5e974e322d233b1 = 'company-hub-card-ai-description';
const $d4b865e8cc459c1f$export$c6d05c48b9430e3c = 'company-hub-editor';
const $d4b865e8cc459c1f$export$35975591aeab4dd6 = 'company-hub-editor/load';
const $d4b865e8cc459c1f$export$7a3dfdccebea9c7b = 'company-hub-editor/close';
const $d4b865e8cc459c1f$export$eef6122c9774ba1c = 'front-cover-publish'; // TODO: rename this to COMPANY_HUB_PUBLISH_EXPERIENCE
const $d4b865e8cc459c1f$export$b414a79d615eda80 = 'end-of-trial-modal';
const $d4b865e8cc459c1f$export$393f60effc43223a = 'end-of-trial-modal/number-of-users';
const $d4b865e8cc459c1f$export$85f2b0ac7d403e39 = 'end-of-trial-modal/guest-access';
const $d4b865e8cc459c1f$export$d28aabd131a0c82d = 'end-of-trial-modal/page-insights';
const $d4b865e8cc459c1f$export$a3809cd1b0c7c1f9 = 'end-of-trial-modal/page-restrictions';
const $d4b865e8cc459c1f$export$82fbc9c9caa0525b = 'end-of-trial-modal/osb-link';
const $d4b865e8cc459c1f$export$651b4e780cbf5647 = 'cards-image-upload';
const $d4b865e8cc459c1f$export$3e70adb2ef2d5f7a = 'admin-team-calendars-load';
const $d4b865e8cc459c1f$export$18051474a34eda87 = 'admin-team-calendars-update';
const $d4b865e8cc459c1f$export$7e4c7c98306e835d = 'standard-differentiators-onboarding';
const $d4b865e8cc459c1f$export$1230cc550a8fe90f = 'standard-differentiators-help';
const $d4b865e8cc459c1f$export$dc2f45d36e47ca3a = 'admin-general-configuration-load';
const $d4b865e8cc459c1f$export$b27bac0c0dea2a55 = 'admin-general-configuration-update';
const $d4b865e8cc459c1f$export$a3c4dc4a199ee1b8 = 'admin-general-configuration-update/favicon-upload';
const $d4b865e8cc459c1f$export$d32cd699d9dbf985 = 'notifications-site-settings-load';
const $d4b865e8cc459c1f$export$6fd7ab2f1e137193 = 'notifications-site-settings-update';
const $d4b865e8cc459c1f$export$7875e1f75aa15306 = 'admin-configure-code-macro-load';
const $d4b865e8cc459c1f$export$164e825247db8d43 = 'admin-configure-code-macro-update';
const $d4b865e8cc459c1f$export$c390f9e07c545581 = 'admin-default-space-logo-config-load';
const $d4b865e8cc459c1f$export$4090d6a71e5b3ead = 'admin-default-space-logo-config-media-service-load';
const $d4b865e8cc459c1f$export$a1986920605a1163 = 'admin-default-space-logo-config-update';
const $d4b865e8cc459c1f$export$313ad6157a5a0ea9 = 'admin-header-and-footer-load';
const $d4b865e8cc459c1f$export$dd6c028654f91f02 = 'admin-header-and-footer-update';
const $d4b865e8cc459c1f$export$bb009baa1a9cbcf0 = 'space-settings-admin-page-layout-load';
const $d4b865e8cc459c1f$export$6d0fbdff5b6fa174 = 'space-settings-admin-page-layout-update';
const $d4b865e8cc459c1f$export$8abd8604ca7982c7 = 'admin-security-configuration-load';
const $d4b865e8cc459c1f$export$21855cac8c6f3d91 = 'admin-security-configuration-update';
const $d4b865e8cc459c1f$export$faa6a1cbc50fd4a5 = 'admin-templates-and-blueprints-load';
const $d4b865e8cc459c1f$export$9cfd44509d36312b = 'admin-templates-and-blueprints-load/page-templates';
const $d4b865e8cc459c1f$export$fb29220c46f6993 = 'admin-templates-and-blueprints-load/page-blueprints';
const $d4b865e8cc459c1f$export$90402aae1ab35229 = 'admin-templates-and-blueprints-load/system-templates';
const $d4b865e8cc459c1f$export$8e008c4796774e26 = 'space-settings-admin-templates-and-blueprints-load';
const $d4b865e8cc459c1f$export$bc61a3e94ba2560e = 'admin-import-spaces-configuration-load';
const $d4b865e8cc459c1f$export$936492407dd3e3ab = 'admin-import-spaces-import';
const $d4b865e8cc459c1f$export$99f32e90f59041e7 = 'admin-trashed-spaces-load';
const $d4b865e8cc459c1f$export$1057adadb9206825 = 'admin-trashed-spaces-restore';
const $d4b865e8cc459c1f$export$9f610d573468ea4 = 'admin-trashed-spaces-hard-delete';
const $d4b865e8cc459c1f$export$86fdc512ee3200db = 'admin-color-scheme-load';
const $d4b865e8cc459c1f$export$db764d23341437ca = 'admin-color-scheme-update';
const $d4b865e8cc459c1f$export$4447822883006e0 = 'admin-application-navigator-load';
const $d4b865e8cc459c1f$export$93194ca916026abe = 'admin-application-navigator-update';
const $d4b865e8cc459c1f$export$c226034eea0cb4de = 'admin-application-navigator-add';
const $d4b865e8cc459c1f$export$22f1f1a21c7d0c50 = 'admin-themes-load';
const $d4b865e8cc459c1f$export$12093307e4f8fd56 = 'admin-themes-update';
const $d4b865e8cc459c1f$export$a48b049eb2fcbe71 = 'space-settings-admin-themes-load';
const $d4b865e8cc459c1f$export$5b92dfbf1efa2144 = 'space-settings-admin-themes-update';
const $d4b865e8cc459c1f$export$565897f0a51f5efd = 'admin-jira-macro-repair-load';
const $d4b865e8cc459c1f$export$2292c61864873ec0 = 'admin-jira-macro-repair-update';
const $d4b865e8cc459c1f$export$d8f5df97692e60be = 'admin-pdf-export-load-experience';
const $d4b865e8cc459c1f$export$e2eb28f9e03e0850 = 'admin-pdf-export-update-experience';
const $d4b865e8cc459c1f$export$ab0128b7a160aaed = 'space-settings-admin-pdf-export-load-experience';
const $d4b865e8cc459c1f$export$e65a54ac514355c1 = 'space-settings-admin-pdf-export-update-experience';
const $d4b865e8cc459c1f$export$9e6e2adcf47359af = 'space-settings-admin-pdf-export-load-experience-ncs';
const $d4b865e8cc459c1f$export$9fb76bc73314ca1e = 'space-settings-csv-export-experience';
const $d4b865e8cc459c1f$export$fde5d45e43ea2ca4 = 'export-page-tree-load';
const $d4b865e8cc459c1f$export$b9b428ecdf423548 = 'export-page-export-completed-export-and-download';
const $d4b865e8cc459c1f$export$5fa322173b52c417 = 'pdf-export-page';
const $d4b865e8cc459c1f$export$bda7d7fc953c118f = 'space-settings-legacy-content-report-experience';
const $d4b865e8cc459c1f$export$c08c7422d3e7a141 = 'admin-macro-usage-load';
const $d4b865e8cc459c1f$export$d6369a194e24ad7f = 'watch-dialog-watch';
const $d4b865e8cc459c1f$export$8012a45d3107312e = 'watch-dialog-watch-children';
const $d4b865e8cc459c1f$export$84a690fd513af1de = 'manage-watchers-dialog-unfiltered';
const $d4b865e8cc459c1f$export$7c7b27adbfa0b2a1 = 'auto-upgrade-awareness-modal';
const $d4b865e8cc459c1f$export$6d5416d96215c2a6 = 'space-settings-admin-look-and-feel-experience';
const $d4b865e8cc459c1f$export$ce75b3763db649b5 = 'user-access-update';
const $d4b865e8cc459c1f$export$ae036afd16ed2b49 = 'user-access-space-permissions-report';
const $d4b865e8cc459c1f$export$2361c2310cf691ea = 'convert-page-to-folder';
const $d4b865e8cc459c1f$export$e85b045b69985ed1 = 'share-and-restrict-button-load';
const $d4b865e8cc459c1f$export$4717394ee1c94acc = 'share-and-restrict-dialog-load';
const $d4b865e8cc459c1f$export$15b0dc8b7eaf2460 = 'share-and-restrict-dialog-save-action';
const $d4b865e8cc459c1f$export$d7fbaabd51b7e8aa = 'share-and-restrict-dialog-share-action';
const $d4b865e8cc459c1f$export$62f393504fed6ed = 'flyout-messaging';
const $d4b865e8cc459c1f$export$5409fe2736a41b4e = 'confluence-eot-premium-recommend-standard-buy';
const $d4b865e8cc459c1f$export$b3185617ebec44c9 = 'view-space-role-assignments';
const $d4b865e8cc459c1f$export$2bf4fa4e191abad2 = 'edit-space-role-assignments';
const $d4b865e8cc459c1f$export$a2e8aa26b8f23b29 = 'view-default-space-role-assignments';
const $d4b865e8cc459c1f$export$f615f6649fe944d3 = 'edit-default-space-role-assignments';
const $d4b865e8cc459c1f$export$c355f58335217bcc = 'view-site-roles';
const $d4b865e8cc459c1f$export$ea342babb9acb6bc = 'edit-site-roles';
const $d4b865e8cc459c1f$export$f6c4ac51d51b4d11 = 'space-details-load';
const $d4b865e8cc459c1f$export$e6949233f3fd16fa = 'space-details-update';
const $d4b865e8cc459c1f$export$ac4798c67f4aca63 = 'space-details-space-label-search';
const $d4b865e8cc459c1f$export$13c8bebb873a5fd2 = 'object-header';
const $d4b865e8cc459c1f$export$717078a23de7ce41 = 'sidebar-details-panel-load';
const $d4b865e8cc459c1f$export$8bb2fdea912e6360 = 'sidebar-comments-panel-load';
const $d4b865e8cc459c1f$export$785ec834db7448db = 'sidebar-comments-panel-load-open';
const $d4b865e8cc459c1f$export$9455f903a440f62b = 'sidebar-comments-panel-load-unread';
const $d4b865e8cc459c1f$export$9eb18c236ac889d2 = 'sidebar-comments-panel-load-resolved';
const $d4b865e8cc459c1f$export$e6d0321727a888ba = 'sidebar-comments-panel-load-deleted-content';
const $d4b865e8cc459c1f$export$89c31c18d20e326d = 'comments-data-background-load';
const $d4b865e8cc459c1f$export$1f5ef81ae9b1b308 = 'import-content';
const $d4b865e8cc459c1f$export$8e0f9138cc943183 = 'import-miro-users';
const $d4b865e8cc459c1f$export$c81d8b61dfed18d = 'mpucup-free-to-standard-fg-modal';
const $d4b865e8cc459c1f$export$bf23e3ec80d510d = 'content-overflow-menu';
const $d4b865e8cc459c1f$export$5167cfad2b30339a = 'mobile-macro-renderer-query';
const $d4b865e8cc459c1f$export$db5f7458e232d5f3 = 'mobile-macro-renderer';
const $d4b865e8cc459c1f$export$d4235a0083f21618 = 'permissions-audit-generation';
const $d4b865e8cc459c1f$export$a992b43898fc066a = 'permissions-audit-generation-view';
const $d4b865e8cc459c1f$export$8a6ae5f44edb5b0a = 'content-access-request-decision';


class $4b50c1dadb433c8a$export$d27a2b6293f7631c extends Error {
    constructor(message){
        super(message);
        this.name = 'ExperienceTimeoutError';
    }
}






const $ebb54c1f7b9c33e4$var$CAUGHT_SESSION_ERROR_TEXT = 'Session expired';
class $ebb54c1f7b9c33e4$export$8220cdf0bd206e05 extends (0, $165abb9eb28d58da$export$12c8b3d0a1a46f87) {
    constructor(message, response){
        super(`${message} ${$ebb54c1f7b9c33e4$var$CAUGHT_SESSION_ERROR_TEXT}`, response);
    }
}
function $ebb54c1f7b9c33e4$export$1bd7f0128d65baef(error) {
    if (!error) return false;
    if (error instanceof $ebb54c1f7b9c33e4$export$8220cdf0bd206e05) return true;
    const errorMessage = error?.message || '';
    if (errorMessage.indexOf($ebb54c1f7b9c33e4$var$CAUGHT_SESSION_ERROR_TEXT) != -1) return true;
    const errorStatusCode = error?.extensions?.statusCode;
    if (errorStatusCode == 401) return true;
    return false;
}
function $ebb54c1f7b9c33e4$export$b8c2308c7b82c3a9(error) {
    if (!error) return false;
    if ($ebb54c1f7b9c33e4$export$1bd7f0128d65baef(error)) return true;
    if ((0, $a73698f3e4fe6cd8$export$17f5e6bd290bb15d)(error)) {
        const { graphQLErrors: graphQLErrors, networkError: networkError } = error;
        if ($ebb54c1f7b9c33e4$export$1bd7f0128d65baef(networkError)) return true;
        if ((graphQLErrors || []).some($ebb54c1f7b9c33e4$export$1bd7f0128d65baef)) return true;
    }
    return false;
}



var $8V6O9 = parcelRequire("8V6O9");

const $0f301ee8607b3904$export$1e9642d012cc75d6 = {
    uuid: null,
    pageId: '',
    routeName: '',
    transitionId: 0,
    routingTimestamp: 0,
    currentSavedTimestamp: 0,
    isLivePage: null
};


const $0b946e8b990b9608$export$3dc3660453120ccc = ()=>{
    (0, $0f301ee8607b3904$export$1e9642d012cc75d6).currentSavedTimestamp = performance.now();
    const activeTrace = (0, $9931f21957f7e3c2$export$b6ac780db3a3cc77)();
    const activeTraceId = activeTrace?.traceId;
    return {
        uuid: (0, $0f301ee8607b3904$export$1e9642d012cc75d6).uuid,
        contentId: (0, $0f301ee8607b3904$export$1e9642d012cc75d6).pageId,
        isInitial: (0, $0f301ee8607b3904$export$1e9642d012cc75d6).transitionId === 0,
        isSSR: Boolean(window['__SSR_RENDERED__']),
        routingDuration: (0, $0f301ee8607b3904$export$1e9642d012cc75d6).currentSavedTimestamp - (0, $0f301ee8607b3904$export$1e9642d012cc75d6).routingTimestamp,
        ...activeTraceId ? {
            ufoTraceId: activeTraceId,
            ufoTraceType: activeTrace.type
        } : {},
        ...(0, $0f301ee8607b3904$export$1e9642d012cc75d6).isLivePage !== null ? {
            isLivePage: (0, $0f301ee8607b3904$export$1e9642d012cc75d6).isLivePage
        } : {}
    };
};
const $0b946e8b990b9608$export$eef458cd11f4b6e7 = ()=>{
    return (0, $0f301ee8607b3904$export$1e9642d012cc75d6).currentSavedTimestamp;
};
const $0b946e8b990b9608$export$8c17c676096b7909 = (routeName = '', match, transitionId, userInfo)=>{
    const contentId = match?.params?.contentId;
    const useUserInfo = userInfo.userId;
    if ((0, $0f301ee8607b3904$export$1e9642d012cc75d6).pageId !== contentId || (0, $0f301ee8607b3904$export$1e9642d012cc75d6).routeName !== routeName) {
        let savedUniqueId;
        if (useUserInfo) savedUniqueId = $0b946e8b990b9608$var$createPageLoadId(routeName, contentId, userInfo);
        else savedUniqueId = $0b946e8b990b9608$var$createUniqueId();
        (0, $0f301ee8607b3904$export$1e9642d012cc75d6).uuid = savedUniqueId;
        (0, $0f301ee8607b3904$export$1e9642d012cc75d6).routeName = routeName;
        (0, $0f301ee8607b3904$export$1e9642d012cc75d6).pageId = contentId;
        (0, $0f301ee8607b3904$export$1e9642d012cc75d6).transitionId = transitionId;
        (0, $0f301ee8607b3904$export$1e9642d012cc75d6).routingTimestamp = performance.now();
    }
};
const $0b946e8b990b9608$export$2cb0d16c23c1cda0 = (isLivePage)=>{
    (0, $0f301ee8607b3904$export$1e9642d012cc75d6).isLivePage = isLivePage;
};
// refer to https://gist.github.com/jed/982883 for uuid generation
// For Anonymous users
const $0b946e8b990b9608$var$createUniqueId = ()=>{
    return `${1e7}${-1000}${-4000}${-8000}${-100000000000}`.replace(/1|0/g, function() {
        // This is a LEGACY disable statement after rule addition. Use `Math.floor()` next time
        // eslint-disable-next-line no-bitwise
        return (0 | Math.random() * 16).toString(16);
    });
};
// For Atlassian users
const $0b946e8b990b9608$var$createPageLoadId = (routeName, contentId, userInfo)=>{
    const { userId: userId, cloudId: cloudId } = userInfo;
    routeName = routeName || 'route';
    contentId = contentId || 'page';
    // TO-DO ask Dennis if he wants to take any of these out
    return `${routeName}-${contentId}-${userId}-${cloudId}-${Date.now()}`;
};






const $ef003bca5ae3d837$var$DEFAULT_ENABLED_PARAM = 'isEnabled';
function $ef003bca5ae3d837$export$9db1624a8af791a4(experimentName, param, defaultValue) {
    // eslint-disable-next-line confluence-feature-gating/use-recommended-utils
    const value = (0, $92d8da4ee454ac11$export$2e2bcd8739ae039).getExperimentValue(experimentName, param, defaultValue);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $f721e733a5f9f3b0$export$47fade9662f71000)(`${experimentName}:${param}`, value);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return value;
}
function $ef003bca5ae3d837$export$da472ee01c19d92e(experimentName, param, defaultValue) {
    // eslint-disable-next-line confluence-feature-gating/use-recommended-utils
    const value = (0, $92d8da4ee454ac11$export$2e2bcd8739ae039).getExperimentValue(experimentName, param, defaultValue, {
        fireExperimentExposure: false
    });
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $f721e733a5f9f3b0$export$47fade9662f71000)(`${experimentName}:${param}`, value);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return value;
}
function $ef003bca5ae3d837$export$45abdb3f977b5b14(experimentName, param, comparatorValue) {
    // eslint-disable-next-line confluence-feature-gating/inline-expVal-params
    return $ef003bca5ae3d837$export$9db1624a8af791a4(experimentName, param, null) === comparatorValue;
}
function $ef003bca5ae3d837$export$d9ae946a42fe8ba9(experimentName, param, comparatorValue) {
    // eslint-disable-next-line confluence-feature-gating/inline-expVal-params
    return $ef003bca5ae3d837$export$da472ee01c19d92e(experimentName, param, null) === comparatorValue;
}
function $ef003bca5ae3d837$export$d14de861476c5d7c(experimentName) {
    (0, $92d8da4ee454ac11$export$2e2bcd8739ae039).manuallyLogExperimentExposure(experimentName);
}
function $ef003bca5ae3d837$export$336b018592dc9972(experimentName) {
    // eslint-disable-next-line confluence-feature-gating/inline-expVal-params
    return $ef003bca5ae3d837$export$45abdb3f977b5b14(experimentName, $ef003bca5ae3d837$var$DEFAULT_ENABLED_PARAM, true);
}
function $ef003bca5ae3d837$export$9a4bf900b9ee892d(experimentName) {
    // eslint-disable-next-line confluence-feature-gating/inline-expVal-params
    return $ef003bca5ae3d837$export$d9ae946a42fe8ba9(experimentName, $ef003bca5ae3d837$var$DEFAULT_ENABLED_PARAM, true);
}
class $ef003bca5ae3d837$var$ExperimentConfig {
    get(key, defaultValue, typeGuard) {
        // Check if the CRITERION override mechanism is available
        if (window && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            const overrideValue = window.__CRITERION__.getExperimentValueOverride(this._experimentName, key);
            if (overrideValue !== undefined && overrideValue !== null) {
                (0, $f721e733a5f9f3b0$export$47fade9662f71000)(`${this._experimentName}:${key}`, overrideValue);
                return overrideValue;
            }
        }
        const value = this._config.get(key, defaultValue, typeGuard);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $f721e733a5f9f3b0$export$47fade9662f71000)(`${this._experimentName}:${key}`, value);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return value;
    }
    constructor(experimentName, config){
        this._experimentName = void 0;
        this._config = void 0;
        this._experimentName = experimentName;
        this._config = config;
    }
}
const $ef003bca5ae3d837$var$cache = new Map();
function $ef003bca5ae3d837$export$677f9fa2e1ae6fec(experimentName) {
    let instance = $ef003bca5ae3d837$var$cache.get(experimentName);
    if (instance == null) {
        const config = (0, $92d8da4ee454ac11$export$2e2bcd8739ae039).getExperiment(experimentName, {
            fireExperimentExposure: false
        });
        const fireExposure = ()=>(0, $92d8da4ee454ac11$export$2e2bcd8739ae039).manuallyLogExperimentExposure(experimentName);
        instance = [
            new $ef003bca5ae3d837$var$ExperimentConfig(experimentName, config),
            fireExposure
        ];
        $ef003bca5ae3d837$var$cache.set(experimentName, instance);
    }
    return instance;
}



var $dQwsT = parcelRequire("dQwsT");

var $dQwsT = parcelRequire("dQwsT");

var $dEf6I = parcelRequire("dEf6I");

var $aVaWD = parcelRequire("aVaWD");
var $dd1b1e2ce6ee3787$var$genericMessage = "Invariant Violation";
var $dd1b1e2ce6ee3787$var$_a = Object.setPrototypeOf, $dd1b1e2ce6ee3787$var$setPrototypeOf = $dd1b1e2ce6ee3787$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $dd1b1e2ce6ee3787$var$_a;
var $dd1b1e2ce6ee3787$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $dEf6I.__extends)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $dd1b1e2ce6ee3787$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $dd1b1e2ce6ee3787$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $dd1b1e2ce6ee3787$var$genericMessage;
        $dd1b1e2ce6ee3787$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $dd1b1e2ce6ee3787$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $dd1b1e2ce6ee3787$export$cea12affaee22fe8(message);
}
function $dd1b1e2ce6ee3787$var$wrapConsoleMethod(method) {
    return function() {
        return console[method].apply(console, arguments);
    };
}
(function(invariant) {
    invariant.warn = $dd1b1e2ce6ee3787$var$wrapConsoleMethod("warn");
    invariant.error = $dd1b1e2ce6ee3787$var$wrapConsoleMethod("error");
})($dd1b1e2ce6ee3787$export$f5708dca728d7177 || ($dd1b1e2ce6ee3787$export$f5708dca728d7177 = {}));
// Code that uses ts-invariant with rollup-plugin-invariant may want to
// import this process stub to avoid errors evaluating process.env.NODE_ENV.
// However, because most ESM-to-CJS compilers will rewrite the process import
// as tsInvariant.process, which prevents proper replacement by minifiers, we
// also attempt to define the stub globally when it is not already defined.
var $dd1b1e2ce6ee3787$export$e54fe5b0f43758f7 = {
    env: {}
};
if (typeof $aVaWD === "object") $dd1b1e2ce6ee3787$export$e54fe5b0f43758f7 = $aVaWD;
else try {
    // Using Function to evaluate this assignment in global scope also escapes
    // the strict mode of the current module, thereby allowing the assignment.
    // Inspired by https://github.com/facebook/regenerator/pull/369.
    Function("stub", "process = stub")($dd1b1e2ce6ee3787$export$e54fe5b0f43758f7);
} catch (atLeastWeTried) {
// The assignment can fail if a Content Security Policy heavy-handedly
// forbids Function usage. In those environments, developers should take
// extra care to replace process.env.NODE_ENV in their production builds,
// or define an appropriate global.process polyfill.
}
var $dd1b1e2ce6ee3787$var$invariant$1 = $dd1b1e2ce6ee3787$export$f5708dca728d7177;
var $dd1b1e2ce6ee3787$export$2e2bcd8739ae039 = $dd1b1e2ce6ee3787$var$invariant$1;


var $d59a5b3e2086f96d$var$apolloContext;
function $d59a5b3e2086f96d$export$a47505d961ee3a1() {
    if (!$d59a5b3e2086f96d$var$apolloContext) $d59a5b3e2086f96d$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createContext({});
    return $d59a5b3e2086f96d$var$apolloContext;
}
function $d59a5b3e2086f96d$export$c2ee824bcc89ca6a() {
    $d59a5b3e2086f96d$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createContext({});
}
var $d59a5b3e2086f96d$export$c16b04c8a9956446 = function(_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = $d59a5b3e2086f96d$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement(ApolloContext.Consumer, null, function(context) {
        if (context === void 0) context = {};
        if (client && context.client !== client) context = Object.assign({}, context, {
            client: client
        });
        (0, $dd1b1e2ce6ee3787$export$f5708dca728d7177)(context.client, 5);
        return (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement(ApolloContext.Provider, {
            value: context
        }, children);
    });
};
var $d59a5b3e2086f96d$export$ed5ceab8c2bb5ce4 = function(props) {
    var ApolloContext = $d59a5b3e2086f96d$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement(ApolloContext.Consumer, null, function(context) {
        (0, $dd1b1e2ce6ee3787$export$f5708dca728d7177)(context && context.client, 6);
        return props.children(context.client);
    });
};
var $d59a5b3e2086f96d$export$d1d99cf900472499;
(function(DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})($d59a5b3e2086f96d$export$d1d99cf900472499 || ($d59a5b3e2086f96d$export$d1d99cf900472499 = {}));
var $d59a5b3e2086f96d$var$cache = new Map();
function $d59a5b3e2086f96d$export$5db520940cf00715(type) {
    var name;
    switch(type){
        case $d59a5b3e2086f96d$export$d1d99cf900472499.Query:
            name = 'Query';
            break;
        case $d59a5b3e2086f96d$export$d1d99cf900472499.Mutation:
            name = 'Mutation';
            break;
        case $d59a5b3e2086f96d$export$d1d99cf900472499.Subscription:
            name = 'Subscription';
            break;
    }
    return name;
}
function $d59a5b3e2086f96d$export$8f49e4af10703ce3(document) {
    var cached = $d59a5b3e2086f96d$var$cache.get(document);
    if (cached) return cached;
    var variables, type, name;
    (0, $dd1b1e2ce6ee3787$export$f5708dca728d7177)(!!document && !!document.kind, 1);
    var fragments = document.definitions.filter(function(x) {
        return x.kind === 'FragmentDefinition';
    });
    var queries = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'query';
    });
    var mutations = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'mutation';
    });
    var subscriptions = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'subscription';
    });
    (0, $dd1b1e2ce6ee3787$export$f5708dca728d7177)(!fragments.length || queries.length || mutations.length || subscriptions.length, 2);
    (0, $dd1b1e2ce6ee3787$export$f5708dca728d7177)(queries.length + mutations.length + subscriptions.length <= 1, 3);
    type = queries.length ? $d59a5b3e2086f96d$export$d1d99cf900472499.Query : $d59a5b3e2086f96d$export$d1d99cf900472499.Mutation;
    if (!queries.length && !mutations.length) type = $d59a5b3e2086f96d$export$d1d99cf900472499.Subscription;
    var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
    (0, $dd1b1e2ce6ee3787$export$f5708dca728d7177)(definitions.length === 1, 4);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === 'Name') name = definition.name.value;
    else name = 'data';
    var payload = {
        name: name,
        type: type,
        variables: variables
    };
    $d59a5b3e2086f96d$var$cache.set(document, payload);
    return payload;
}



var $dEf6I = parcelRequire("dEf6I");

var $dQwsT = parcelRequire("dQwsT");

var $2fddad6d68cdb0a2$var$_a = Object.prototype, $2fddad6d68cdb0a2$var$toString = $2fddad6d68cdb0a2$var$_a.toString, $2fddad6d68cdb0a2$var$hasOwnProperty = $2fddad6d68cdb0a2$var$_a.hasOwnProperty;
var $2fddad6d68cdb0a2$var$previousComparisons = new Map();
/**
 * Performs a deep equality check on two JavaScript values, tolerating cycles.
 */ function $2fddad6d68cdb0a2$export$411ce8e5a71e3069(a, b) {
    try {
        return $2fddad6d68cdb0a2$var$check(a, b);
    } finally{
        $2fddad6d68cdb0a2$var$previousComparisons.clear();
    }
}
function $2fddad6d68cdb0a2$var$check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) return true;
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    var aTag = $2fddad6d68cdb0a2$var$toString.call(a);
    var bTag = $2fddad6d68cdb0a2$var$toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) return false;
    switch(aTag){
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length) return false;
        // Fall through to object case...
        case '[object Object]':
            if ($2fddad6d68cdb0a2$var$previouslyCompared(a, b)) return true;
            var aKeys = Object.keys(a);
            var bKeys = Object.keys(b);
            // If `a` and `b` have a different number of enumerable keys, they
            // must be different.
            var keyCount = aKeys.length;
            if (keyCount !== bKeys.length) return false;
            // Now make sure they have the same keys.
            for(var k = 0; k < keyCount; ++k){
                if (!$2fddad6d68cdb0a2$var$hasOwnProperty.call(b, aKeys[k])) return false;
            }
            // Finally, check deep equality of all child properties.
            for(var k = 0; k < keyCount; ++k){
                var key = aKeys[k];
                if (!$2fddad6d68cdb0a2$var$check(a[key], b[key])) return false;
            }
            return true;
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a) return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == "" + b;
        case '[object Map]':
        case '[object Set]':
            if (a.size !== b.size) return false;
            if ($2fddad6d68cdb0a2$var$previouslyCompared(a, b)) return true;
            var aIterator = a.entries();
            var isMap = aTag === '[object Map]';
            while(true){
                var info = aIterator.next();
                if (info.done) break;
                // If a instanceof Set, aValue === aKey.
                var _a = info.value, aKey = _a[0], aValue = _a[1];
                // So this works the same way for both Set and Map.
                if (!b.has(aKey)) return false;
                // However, we care about deep equality of values only when dealing
                // with Map structures.
                if (isMap && !$2fddad6d68cdb0a2$var$check(aValue, b.get(aKey))) return false;
            }
            return true;
    }
    // Otherwise the values are not equal.
    return false;
}
function $2fddad6d68cdb0a2$var$previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    var bSet = $2fddad6d68cdb0a2$var$previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b)) return true;
    } else $2fddad6d68cdb0a2$var$previousComparisons.set(a, bSet = new Set);
    bSet.add(b);
    return false;
}
var $2fddad6d68cdb0a2$export$2e2bcd8739ae039 = $2fddad6d68cdb0a2$export$411ce8e5a71e3069;



var $dEf6I = parcelRequire("dEf6I");

var $aVaWD = parcelRequire("aVaWD");
var $10f76c95ff32498e$var$genericMessage = "Invariant Violation";
var $10f76c95ff32498e$var$_a = Object.setPrototypeOf, $10f76c95ff32498e$var$setPrototypeOf = $10f76c95ff32498e$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $10f76c95ff32498e$var$_a;
var $10f76c95ff32498e$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $dEf6I.__extends)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $10f76c95ff32498e$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $10f76c95ff32498e$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $10f76c95ff32498e$var$genericMessage;
        $10f76c95ff32498e$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $10f76c95ff32498e$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $10f76c95ff32498e$export$cea12affaee22fe8(message);
}
function $10f76c95ff32498e$var$wrapConsoleMethod(method) {
    return function() {
        return console[method].apply(console, arguments);
    };
}
(function(invariant) {
    invariant.warn = $10f76c95ff32498e$var$wrapConsoleMethod("warn");
    invariant.error = $10f76c95ff32498e$var$wrapConsoleMethod("error");
})($10f76c95ff32498e$export$f5708dca728d7177 || ($10f76c95ff32498e$export$f5708dca728d7177 = {}));
// Code that uses ts-invariant with rollup-plugin-invariant may want to
// import this process stub to avoid errors evaluating process.env.NODE_ENV.
// However, because most ESM-to-CJS compilers will rewrite the process import
// as tsInvariant.process, which prevents proper replacement by minifiers, we
// also attempt to define the stub globally when it is not already defined.
var $10f76c95ff32498e$export$e54fe5b0f43758f7 = {
    env: {}
};
if (typeof $aVaWD === "object") $10f76c95ff32498e$export$e54fe5b0f43758f7 = $aVaWD;
else try {
    // Using Function to evaluate this assignment in global scope also escapes
    // the strict mode of the current module, thereby allowing the assignment.
    // Inspired by https://github.com/facebook/regenerator/pull/369.
    Function("stub", "process = stub")($10f76c95ff32498e$export$e54fe5b0f43758f7);
} catch (atLeastWeTried) {
// The assignment can fail if a Content Security Policy heavy-handedly
// forbids Function usage. In those environments, developers should take
// extra care to replace process.env.NODE_ENV in their production builds,
// or define an appropriate global.process polyfill.
}
var $10f76c95ff32498e$var$invariant$1 = $10f76c95ff32498e$export$f5708dca728d7177;
var $10f76c95ff32498e$export$2e2bcd8739ae039 = $10f76c95ff32498e$var$invariant$1;


var $dca5541081837639$var$OperationData = function() {
    function OperationData(options, context) {
        this.isMounted = false;
        this.previousOptions = {};
        this.context = {};
        this.options = {};
        this.options = options || {};
        this.context = context || {};
    }
    OperationData.prototype.getOptions = function() {
        return this.options;
    };
    OperationData.prototype.setOptions = function(newOptions, storePrevious) {
        if (storePrevious === void 0) storePrevious = false;
        if (storePrevious && !(0, $2fddad6d68cdb0a2$export$411ce8e5a71e3069)(this.options, newOptions)) this.previousOptions = this.options;
        this.options = newOptions;
    };
    OperationData.prototype.unmount = function() {
        this.isMounted = false;
    };
    OperationData.prototype.refreshClient = function() {
        var client = this.options && this.options.client || this.context && this.context.client;
        (0, $10f76c95ff32498e$export$f5708dca728d7177)(!!client, 2);
        var isNew = false;
        if (client !== this.client) {
            isNew = true;
            this.client = client;
            this.cleanup();
        }
        return {
            client: this.client,
            isNew: isNew
        };
    };
    OperationData.prototype.verifyDocumentType = function(document, type) {
        var operation = (0, $d59a5b3e2086f96d$export$8f49e4af10703ce3)(document);
        var requiredOperationName = (0, $d59a5b3e2086f96d$export$5db520940cf00715)(type);
        var usedOperationName = (0, $d59a5b3e2086f96d$export$5db520940cf00715)(operation.type);
        (0, $10f76c95ff32498e$export$f5708dca728d7177)(operation.type === type, 3);
    };
    return OperationData;
}();
var $dca5541081837639$var$QueryData = function(_super) {
    (0, $dEf6I.__extends)(QueryData, _super);
    function QueryData(_a) {
        var options = _a.options, context = _a.context, forceUpdate = _a.forceUpdate;
        var _this = _super.call(this, options, context) || this;
        _this.previousData = {};
        _this.currentObservable = {};
        _this.runLazy = false;
        _this.runLazyQuery = function(options) {
            _this.cleanup();
            _this.runLazy = true;
            _this.lazyOptions = options;
            _this.forceUpdate();
        };
        _this.getExecuteResult = function() {
            var result = _this.getQueryResult();
            _this.startQuerySubscription();
            return result;
        };
        _this.obsRefetch = function(variables) {
            return _this.currentObservable.query.refetch(variables);
        };
        _this.obsFetchMore = function(fetchMoreOptions) {
            return _this.currentObservable.query.fetchMore(fetchMoreOptions);
        };
        _this.obsUpdateQuery = function(mapFn) {
            return _this.currentObservable.query.updateQuery(mapFn);
        };
        _this.obsStartPolling = function(pollInterval) {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.startPolling(pollInterval);
        };
        _this.obsStopPolling = function() {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.stopPolling();
        };
        _this.obsSubscribeToMore = function(options) {
            return _this.currentObservable.query.subscribeToMore(options);
        };
        _this.forceUpdate = forceUpdate;
        return _this;
    }
    QueryData.prototype.execute = function() {
        this.refreshClient();
        var _a = this.getOptions(), skip = _a.skip, query = _a.query;
        if (skip || query !== this.previousData.query) {
            this.removeQuerySubscription();
            this.previousData.query = query;
        }
        this.updateObservableQuery();
        if (this.isMounted) this.startQuerySubscription();
        return this.getExecuteSsrResult() || this.getExecuteResult();
    };
    QueryData.prototype.executeLazy = function() {
        return !this.runLazy ? [
            this.runLazyQuery,
            {
                loading: false,
                networkStatus: (0, $2e58ccba3067efe5$export$bd096ddbd246c79c).ready,
                called: false,
                data: undefined
            }
        ] : [
            this.runLazyQuery,
            this.execute()
        ];
    };
    QueryData.prototype.fetchData = function() {
        var options = this.getOptions();
        if (options.skip || options.ssr === false) return false;
        var obs = this.currentObservable.query;
        var currentResult = obs.getCurrentResult();
        return currentResult.loading ? obs.result() : false;
    };
    QueryData.prototype.afterExecute = function(_a) {
        var _this = this;
        var _b = (_a === void 0 ? {} : _a).lazy, lazy = _b === void 0 ? false : _b;
        this.isMounted = true;
        if (!lazy || this.runLazy) {
            this.handleErrorOrCompleted();
            setTimeout(function() {
                _this.currentObservable.query && _this.currentObservable.query.resetQueryStoreErrors();
            });
        }
        this.previousOptions = this.getOptions();
        return this.unmount.bind(this);
    };
    QueryData.prototype.cleanup = function() {
        this.removeQuerySubscription();
        delete this.currentObservable.query;
        delete this.previousData.result;
    };
    QueryData.prototype.getOptions = function() {
        var options = _super.prototype.getOptions.call(this);
        if (this.lazyOptions) {
            options.variables = (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, options.variables), this.lazyOptions.variables);
            options.context = (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, options.context), this.lazyOptions.context);
        }
        if (this.runLazy) delete options.skip;
        return options;
    };
    QueryData.prototype.getExecuteSsrResult = function() {
        var treeRenderingInitiated = this.context && this.context.renderPromises;
        var ssrDisabled = this.getOptions().ssr === false;
        var fetchDisabled = this.refreshClient().client.disableNetworkFetches;
        var ssrLoading = {
            loading: true,
            networkStatus: (0, $2e58ccba3067efe5$export$bd096ddbd246c79c).loading,
            called: true,
            data: undefined
        };
        if (ssrDisabled && (treeRenderingInitiated || fetchDisabled)) return ssrLoading;
        var result;
        if (treeRenderingInitiated) result = this.context.renderPromises.addQueryPromise(this, this.getExecuteResult) || ssrLoading;
        return result;
    };
    QueryData.prototype.prepareObservableQueryOptions = function() {
        var options = this.getOptions();
        this.verifyDocumentType(options.query, (0, $d59a5b3e2086f96d$export$d1d99cf900472499).Query);
        var displayName = options.displayName || 'Query';
        if (this.context && this.context.renderPromises && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options.fetchPolicy = 'cache-first';
        return (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, options), {
            displayName: displayName,
            context: options.context,
            metadata: {
                reactComponent: {
                    displayName: displayName
                }
            }
        });
    };
    QueryData.prototype.initializeObservableQuery = function() {
        if (this.context && this.context.renderPromises) this.currentObservable.query = this.context.renderPromises.getSSRObservable(this.getOptions());
        if (!this.currentObservable.query) {
            var observableQueryOptions = this.prepareObservableQueryOptions();
            this.previousData.observableQueryOptions = (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, observableQueryOptions), {
                children: null
            });
            this.currentObservable.query = this.refreshClient().client.watchQuery((0, $dEf6I.__assign)({}, observableQueryOptions));
            if (this.context && this.context.renderPromises) this.context.renderPromises.registerSSRObservable(this.currentObservable.query, observableQueryOptions);
        }
    };
    QueryData.prototype.updateObservableQuery = function() {
        if (!this.currentObservable.query) {
            this.initializeObservableQuery();
            return;
        }
        var newObservableQueryOptions = (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, this.prepareObservableQueryOptions()), {
            children: null
        });
        if (!(0, $2fddad6d68cdb0a2$export$411ce8e5a71e3069)(newObservableQueryOptions, this.previousData.observableQueryOptions)) {
            this.previousData.observableQueryOptions = newObservableQueryOptions;
            this.currentObservable.query.setOptions(newObservableQueryOptions).catch(function() {});
        }
    };
    QueryData.prototype.startQuerySubscription = function() {
        var _this = this;
        if (this.currentObservable.subscription || this.getOptions().skip) return;
        var obsQuery = this.currentObservable.query;
        this.currentObservable.subscription = obsQuery.subscribe({
            next: function(_a) {
                var loading = _a.loading, networkStatus = _a.networkStatus, data = _a.data;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading === loading && previousResult.networkStatus === networkStatus && (0, $2fddad6d68cdb0a2$export$411ce8e5a71e3069)(previousResult.data, data)) return;
                _this.forceUpdate();
            },
            error: function(error) {
                _this.resubscribeToQuery();
                if (!error.hasOwnProperty('graphQLErrors')) throw error;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading || !(0, $2fddad6d68cdb0a2$export$411ce8e5a71e3069)(error, _this.previousData.error)) {
                    _this.previousData.error = error;
                    _this.forceUpdate();
                }
            }
        });
    };
    QueryData.prototype.resubscribeToQuery = function() {
        this.removeQuerySubscription();
        var lastError = this.currentObservable.query.getLastError();
        var lastResult = this.currentObservable.query.getLastResult();
        this.currentObservable.query.resetLastResults();
        this.startQuerySubscription();
        Object.assign(this.currentObservable.query, {
            lastError: lastError,
            lastResult: lastResult
        });
    };
    QueryData.prototype.getQueryResult = function() {
        var result = this.observableQueryFields();
        var options = this.getOptions();
        if (options.skip) result = (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, result), {
            data: undefined,
            error: undefined,
            loading: false,
            called: true
        });
        else {
            var currentResult = this.currentObservable.query.getCurrentResult();
            var loading = currentResult.loading, partial = currentResult.partial, networkStatus = currentResult.networkStatus, errors = currentResult.errors;
            var error = currentResult.error, data = currentResult.data;
            if (errors && errors.length > 0) error = new (0, $2e58ccba3067efe5$export$26a337512320b8c6)({
                graphQLErrors: errors
            });
            result = (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, result), {
                loading: loading,
                networkStatus: networkStatus,
                error: error,
                called: true
            });
            if (loading) {
                var previousData = this.previousData.result && this.previousData.result.data;
                result.data = previousData && data ? (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, previousData), data) : previousData || data;
            } else if (error) Object.assign(result, {
                data: (this.currentObservable.query.getLastResult() || {}).data
            });
            else {
                var fetchPolicy = this.currentObservable.query.options.fetchPolicy;
                var partialRefetch = options.partialRefetch;
                if (partialRefetch && !data && partial && fetchPolicy !== 'cache-only') {
                    Object.assign(result, {
                        loading: true,
                        networkStatus: (0, $2e58ccba3067efe5$export$bd096ddbd246c79c).loading
                    });
                    result.refetch();
                    return result;
                }
                result.data = data;
            }
        }
        result.client = this.client;
        this.previousData.loading = this.previousData.result && this.previousData.result.loading || false;
        this.previousData.result = result;
        return result;
    };
    QueryData.prototype.handleErrorOrCompleted = function() {
        var obsQuery = this.currentObservable.query;
        if (!obsQuery) return;
        var _a = obsQuery.getCurrentResult(), data = _a.data, loading = _a.loading, error = _a.error;
        if (!loading) {
            var _b = this.getOptions(), query = _b.query, variables = _b.variables, onCompleted = _b.onCompleted, onError = _b.onError;
            if (this.previousOptions && !this.previousData.loading && (0, $2fddad6d68cdb0a2$export$411ce8e5a71e3069)(this.previousOptions.query, query) && (0, $2fddad6d68cdb0a2$export$411ce8e5a71e3069)(this.previousOptions.variables, variables)) return;
            if (onCompleted && !error) onCompleted(data);
            else if (onError && error) onError(error);
        }
    };
    QueryData.prototype.removeQuerySubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    QueryData.prototype.observableQueryFields = function() {
        var observable = this.currentObservable.query;
        return {
            variables: observable.variables,
            refetch: this.obsRefetch,
            fetchMore: this.obsFetchMore,
            updateQuery: this.obsUpdateQuery,
            startPolling: this.obsStartPolling,
            stopPolling: this.obsStopPolling,
            subscribeToMore: this.obsSubscribeToMore
        };
    };
    return QueryData;
}($dca5541081837639$var$OperationData);
function $dca5541081837639$var$useDeepMemo(memoFn, key) {
    var ref = (0, $dQwsT.useRef)();
    if (!ref.current || !(0, $2fddad6d68cdb0a2$export$411ce8e5a71e3069)(key, ref.current.key)) ref.current = {
        key: key,
        value: memoFn()
    };
    return ref.current.value;
}
function $dca5541081837639$var$useBaseQuery(query, options, lazy) {
    if (lazy === void 0) lazy = false;
    var context = (0, $dQwsT.useContext)((0, $d59a5b3e2086f96d$export$a47505d961ee3a1)());
    var _a = (0, $dQwsT.useReducer)(function(x) {
        return x + 1;
    }, 0), tick = _a[0], forceUpdate = _a[1];
    var updatedOptions = options ? (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, options), {
        query: query
    }) : {
        query: query
    };
    var queryDataRef = (0, $dQwsT.useRef)();
    if (!queryDataRef.current) queryDataRef.current = new $dca5541081837639$var$QueryData({
        options: updatedOptions,
        context: context,
        forceUpdate: forceUpdate
    });
    var queryData = queryDataRef.current;
    queryData.setOptions(updatedOptions);
    queryData.context = context;
    var memo = {
        options: (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, updatedOptions), {
            onError: undefined,
            onCompleted: undefined
        }),
        context: context,
        tick: tick
    };
    var result = $dca5541081837639$var$useDeepMemo(function() {
        return lazy ? queryData.executeLazy() : queryData.execute();
    }, memo);
    var queryResult = lazy ? result[1] : result;
    (0, $dQwsT.useEffect)(function() {
        return queryData.afterExecute({
            lazy: lazy
        });
    }, [
        queryResult.loading,
        queryResult.networkStatus,
        queryResult.error,
        queryResult.data
    ]);
    (0, $dQwsT.useEffect)(function() {
        return function() {
            return queryData.cleanup();
        };
    }, []);
    return result;
}
function $dca5541081837639$export$dd0a697e1782aedd(query, options) {
    return $dca5541081837639$var$useBaseQuery(query, options, false);
}
function $dca5541081837639$export$fd83eea6ecd2d8fa(query, options) {
    return $dca5541081837639$var$useBaseQuery(query, options, true);
}
var $dca5541081837639$var$MutationData = function(_super) {
    (0, $dEf6I.__extends)(MutationData, _super);
    function MutationData(_a) {
        var options = _a.options, context = _a.context, result = _a.result, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.runMutation = function(mutationFunctionOptions) {
            if (mutationFunctionOptions === void 0) mutationFunctionOptions = {};
            _this.onMutationStart();
            var mutationId = _this.generateNewMutationId();
            return _this.mutate(mutationFunctionOptions).then(function(response) {
                _this.onMutationCompleted(response, mutationId);
                return response;
            }).catch(function(error) {
                _this.onMutationError(error, mutationId);
                if (!_this.getOptions().onError) throw error;
            });
        };
        _this.verifyDocumentType(options.mutation, (0, $d59a5b3e2086f96d$export$d1d99cf900472499).Mutation);
        _this.result = result;
        _this.setResult = setResult;
        _this.mostRecentMutationId = 0;
        return _this;
    }
    MutationData.prototype.execute = function(result) {
        this.isMounted = true;
        this.verifyDocumentType(this.getOptions().mutation, (0, $d59a5b3e2086f96d$export$d1d99cf900472499).Mutation);
        result.client = this.refreshClient().client;
        return [
            this.runMutation,
            result
        ];
    };
    MutationData.prototype.afterExecute = function() {
        this.isMounted = true;
        return this.unmount.bind(this);
    };
    MutationData.prototype.cleanup = function() {};
    MutationData.prototype.mutate = function(mutationFunctionOptions) {
        var _a = this.getOptions(), mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, update = _a.update, _b = _a.context, mutationContext = _b === void 0 ? {} : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, fetchPolicy = _a.fetchPolicy;
        var mutateOptions = (0, $dEf6I.__assign)({}, mutationFunctionOptions);
        var mutateVariables = Object.assign({}, variables, mutateOptions.variables);
        delete mutateOptions.variables;
        return this.refreshClient().client.mutate((0, $dEf6I.__assign)({
            mutation: mutation,
            optimisticResponse: optimisticResponse,
            refetchQueries: mutateOptions.refetchQueries || this.getOptions().refetchQueries,
            awaitRefetchQueries: awaitRefetchQueries,
            update: update,
            context: mutationContext,
            fetchPolicy: fetchPolicy,
            variables: mutateVariables
        }, mutateOptions));
    };
    MutationData.prototype.onMutationStart = function() {
        if (!this.result.loading && !this.getOptions().ignoreResults) this.updateResult({
            loading: true,
            error: undefined,
            data: undefined,
            called: true
        });
    };
    MutationData.prototype.onMutationCompleted = function(response, mutationId) {
        var _a = this.getOptions(), onCompleted = _a.onCompleted, ignoreResults = _a.ignoreResults;
        var data = response.data, errors = response.errors;
        var error = errors && errors.length > 0 ? new (0, $2e58ccba3067efe5$export$26a337512320b8c6)({
            graphQLErrors: errors
        }) : undefined;
        var callOncomplete = function() {
            return onCompleted ? onCompleted(data) : null;
        };
        if (this.isMostRecentMutation(mutationId) && !ignoreResults) this.updateResult({
            called: true,
            loading: false,
            data: data,
            error: error
        });
        callOncomplete();
    };
    MutationData.prototype.onMutationError = function(error, mutationId) {
        var onError = this.getOptions().onError;
        if (this.isMostRecentMutation(mutationId)) this.updateResult({
            loading: false,
            error: error,
            data: undefined,
            called: true
        });
        if (onError) onError(error);
    };
    MutationData.prototype.generateNewMutationId = function() {
        return ++this.mostRecentMutationId;
    };
    MutationData.prototype.isMostRecentMutation = function(mutationId) {
        return this.mostRecentMutationId === mutationId;
    };
    MutationData.prototype.updateResult = function(result) {
        if (this.isMounted && (!this.previousResult || !(0, $2fddad6d68cdb0a2$export$411ce8e5a71e3069)(this.previousResult, result))) {
            this.setResult(result);
            this.previousResult = result;
        }
    };
    return MutationData;
}($dca5541081837639$var$OperationData);
function $dca5541081837639$export$609860bf8b0084c(mutation, options) {
    var context = (0, $dQwsT.useContext)((0, $d59a5b3e2086f96d$export$a47505d961ee3a1)());
    var _a = (0, $dQwsT.useState)({
        called: false,
        loading: false
    }), result = _a[0], setResult = _a[1];
    var updatedOptions = options ? (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, options), {
        mutation: mutation
    }) : {
        mutation: mutation
    };
    var mutationDataRef = (0, $dQwsT.useRef)();
    function getMutationDataRef() {
        if (!mutationDataRef.current) mutationDataRef.current = new $dca5541081837639$var$MutationData({
            options: updatedOptions,
            context: context,
            result: result,
            setResult: setResult
        });
        return mutationDataRef.current;
    }
    var mutationData = getMutationDataRef();
    mutationData.setOptions(updatedOptions);
    mutationData.context = context;
    (0, $dQwsT.useEffect)(function() {
        return mutationData.afterExecute();
    });
    return mutationData.execute(result);
}
var $dca5541081837639$var$SubscriptionData = function(_super) {
    (0, $dEf6I.__extends)(SubscriptionData, _super);
    function SubscriptionData(_a) {
        var options = _a.options, context = _a.context, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.currentObservable = {};
        _this.setResult = setResult;
        _this.initialize(options);
        return _this;
    }
    SubscriptionData.prototype.execute = function(result) {
        if (this.getOptions().skip === true) {
            this.cleanup();
            return {
                loading: false,
                error: undefined,
                data: undefined,
                variables: this.getOptions().variables
            };
        }
        var currentResult = result;
        if (this.refreshClient().isNew) currentResult = this.getLoadingResult();
        var shouldResubscribe = this.getOptions().shouldResubscribe;
        if (typeof shouldResubscribe === 'function') shouldResubscribe = !!shouldResubscribe(this.getOptions());
        if (shouldResubscribe !== false && this.previousOptions && Object.keys(this.previousOptions).length > 0 && (this.previousOptions.subscription !== this.getOptions().subscription || !(0, $2fddad6d68cdb0a2$export$411ce8e5a71e3069)(this.previousOptions.variables, this.getOptions().variables) || this.previousOptions.skip !== this.getOptions().skip)) {
            this.cleanup();
            currentResult = this.getLoadingResult();
        }
        this.initialize(this.getOptions());
        this.startSubscription();
        this.previousOptions = this.getOptions();
        return (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, currentResult), {
            variables: this.getOptions().variables
        });
    };
    SubscriptionData.prototype.afterExecute = function() {
        this.isMounted = true;
    };
    SubscriptionData.prototype.cleanup = function() {
        this.endSubscription();
        delete this.currentObservable.query;
    };
    SubscriptionData.prototype.initialize = function(options) {
        if (this.currentObservable.query || this.getOptions().skip === true) return;
        this.currentObservable.query = this.refreshClient().client.subscribe({
            query: options.subscription,
            variables: options.variables,
            fetchPolicy: options.fetchPolicy
        });
    };
    SubscriptionData.prototype.startSubscription = function() {
        if (this.currentObservable.subscription) return;
        this.currentObservable.subscription = this.currentObservable.query.subscribe({
            next: this.updateCurrentData.bind(this),
            error: this.updateError.bind(this),
            complete: this.completeSubscription.bind(this)
        });
    };
    SubscriptionData.prototype.getLoadingResult = function() {
        return {
            loading: true,
            error: undefined,
            data: undefined
        };
    };
    SubscriptionData.prototype.updateResult = function(result) {
        if (this.isMounted) this.setResult(result);
    };
    SubscriptionData.prototype.updateCurrentData = function(result) {
        var onSubscriptionData = this.getOptions().onSubscriptionData;
        this.updateResult({
            data: result.data,
            loading: false,
            error: undefined
        });
        if (onSubscriptionData) onSubscriptionData({
            client: this.refreshClient().client,
            subscriptionData: result
        });
    };
    SubscriptionData.prototype.updateError = function(error) {
        this.updateResult({
            error: error,
            loading: false
        });
    };
    SubscriptionData.prototype.completeSubscription = function() {
        var onSubscriptionComplete = this.getOptions().onSubscriptionComplete;
        if (onSubscriptionComplete) onSubscriptionComplete();
        this.endSubscription();
    };
    SubscriptionData.prototype.endSubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    return SubscriptionData;
}($dca5541081837639$var$OperationData);
function $dca5541081837639$export$368b4214baeb914c(subscription, options) {
    var context = (0, $dQwsT.useContext)((0, $d59a5b3e2086f96d$export$a47505d961ee3a1)());
    var updatedOptions = options ? (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, options), {
        subscription: subscription
    }) : {
        subscription: subscription
    };
    var _a = (0, $dQwsT.useState)({
        loading: !updatedOptions.skip,
        error: undefined,
        data: undefined
    }), result = _a[0], setResult = _a[1];
    var subscriptionDataRef = (0, $dQwsT.useRef)();
    function getSubscriptionDataRef() {
        if (!subscriptionDataRef.current) subscriptionDataRef.current = new $dca5541081837639$var$SubscriptionData({
            options: updatedOptions,
            context: context,
            setResult: setResult
        });
        return subscriptionDataRef.current;
    }
    var subscriptionData = getSubscriptionDataRef();
    subscriptionData.setOptions(updatedOptions, true);
    subscriptionData.context = context;
    (0, $dQwsT.useEffect)(function() {
        return subscriptionData.afterExecute();
    });
    (0, $dQwsT.useEffect)(function() {
        return subscriptionData.cleanup.bind(subscriptionData);
    }, []);
    return subscriptionData.execute(result);
}
function $dca5541081837639$export$eb9a56e7a29e494() {
    var client = (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).useContext((0, $d59a5b3e2086f96d$export$a47505d961ee3a1)()).client;
    (0, $10f76c95ff32498e$export$f5708dca728d7177)(client, 1);
    return client;
}
function $dca5541081837639$var$makeDefaultQueryInfo() {
    return {
        seen: false,
        observable: null
    };
}
var $dca5541081837639$export$260e90e395a79974 = function() {
    function RenderPromises() {
        this.queryPromises = new Map();
        this.queryInfoTrie = new Map();
    }
    RenderPromises.prototype.registerSSRObservable = function(observable, props) {
        this.lookupQueryInfo(props).observable = observable;
    };
    RenderPromises.prototype.getSSRObservable = function(props) {
        return this.lookupQueryInfo(props).observable;
    };
    RenderPromises.prototype.addQueryPromise = function(queryInstance, finish) {
        var info = this.lookupQueryInfo(queryInstance.getOptions());
        if (!info.seen) {
            this.queryPromises.set(queryInstance.getOptions(), new Promise(function(resolve) {
                resolve(queryInstance.fetchData());
            }));
            return null;
        }
        return finish();
    };
    RenderPromises.prototype.hasPromises = function() {
        return this.queryPromises.size > 0;
    };
    RenderPromises.prototype.consumeAndAwaitPromises = function() {
        var _this = this;
        var promises = [];
        this.queryPromises.forEach(function(promise, queryInstance) {
            _this.lookupQueryInfo(queryInstance).seen = true;
            promises.push(promise);
        });
        this.queryPromises.clear();
        return Promise.all(promises);
    };
    RenderPromises.prototype.lookupQueryInfo = function(props) {
        var queryInfoTrie = this.queryInfoTrie;
        var query = props.query, variables = props.variables;
        var varMap = queryInfoTrie.get(query) || new Map();
        if (!queryInfoTrie.has(query)) queryInfoTrie.set(query, varMap);
        var variablesString = JSON.stringify(variables);
        var info = varMap.get(variablesString) || $dca5541081837639$var$makeDefaultQueryInfo();
        if (!varMap.has(variablesString)) varMap.set(variablesString, info);
        return info;
    };
    return RenderPromises;
}();




var $dQwsT = parcelRequire("dQwsT");
function $74e7a60895b89e1f$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function $74e7a60895b89e1f$export$b6feb8998cd9b342(getResult, inputs) {
    var initial = (0, $dQwsT.useState)(function() {
        return {
            inputs: inputs,
            result: getResult()
        };
    })[0];
    var isFirstRun = (0, $dQwsT.useRef)(true);
    var committed = (0, $dQwsT.useRef)(initial);
    var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && $74e7a60895b89e1f$var$areInputsEqual(inputs, committed.current.inputs));
    var cache = useCache ? committed.current : {
        inputs: inputs,
        result: getResult()
    };
    (0, $dQwsT.useEffect)(function() {
        isFirstRun.current = false;
        committed.current = cache;
    }, [
        cache
    ]);
    return cache.result;
}
function $74e7a60895b89e1f$export$33752cf3ee811995(callback, inputs) {
    return $74e7a60895b89e1f$export$b6feb8998cd9b342(function() {
        return callback;
    }, inputs);
}
var $74e7a60895b89e1f$export$1538c33de8887b59 = $74e7a60895b89e1f$export$b6feb8998cd9b342;
var $74e7a60895b89e1f$export$35808ee640e87ca7 = $74e7a60895b89e1f$export$33752cf3ee811995;


/// <reference types="node" />
const $33f8faee09b93f27$export$ad4be5c2ec28cecf = (obj)=>obj instanceof $33f8faee09b93f27$export$2e2bcd8739ae039 || !!obj?._isAnalyticsEvent || // Backwards compatibility with older analytics-next packages
    obj?.constructor?.name === 'AnalyticsEvent';
class $33f8faee09b93f27$export$2e2bcd8739ae039 {
    update(updater) {
        if (typeof updater === 'function') this.payload = updater(this.payload);
        if (typeof updater === 'object') this.payload = {
            ...this.payload,
            ...updater
        };
        return this;
    }
    constructor(props){
        this.payload = void 0;
        this._isAnalyticsEvent = true;
        this.clone = ()=>{
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            const payload = {
                ...this.payload
            };
            return new $33f8faee09b93f27$export$2e2bcd8739ae039({
                payload: payload
            });
        };
        this.payload = props.payload;
    }
}


const $b7e245d3138d1b2b$export$35f8383928ba8d7 = (obj)=>obj instanceof $b7e245d3138d1b2b$export$2e2bcd8739ae039 || !!obj?._isUIAnalyticsEvent || // Backwards compatibility with older analytics-next packages
    obj?.constructor?.name === 'UIAnalyticsEvent';
class $b7e245d3138d1b2b$export$2e2bcd8739ae039 extends (0, $33f8faee09b93f27$export$2e2bcd8739ae039) {
    update(updater) {
        if (this.hasFired) return this;
        return super.update(updater);
    }
    constructor(props){
        super(props);
        this.context = void 0;
        this.handlers = void 0;
        this.hasFired = void 0;
        this._isUIAnalyticsEvent = true;
        this.clone = ()=>{
            if (this.hasFired) return null;
            const context = [
                ...this.context
            ];
            const handlers = [
                ...this.handlers
            ];
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ const payload = JSON.parse(JSON.stringify(this.payload));
            return new $b7e245d3138d1b2b$export$2e2bcd8739ae039({
                context: context,
                handlers: handlers,
                payload: payload
            });
        };
        this.fire = (channel)=>{
            if (this.hasFired) return;
            this.handlers.forEach((handler)=>handler(this, channel));
            this.hasFired = true;
        };
        this.context = props.context || [];
        this.handlers = props.handlers || [];
        this.hasFired = false;
    }
}



var $dQwsT = parcelRequire("dQwsT");

var $dQwsT = parcelRequire("dQwsT");
const $6f57106b8d65a655$var$AnalyticsNextContext = (0, $dQwsT.createContext)({
    getAtlaskitAnalyticsContext: ()=>[],
    getAtlaskitAnalyticsEventHandlers: ()=>[]
});
var $6f57106b8d65a655$export$2e2bcd8739ae039 = $6f57106b8d65a655$var$AnalyticsNextContext;


var $b3fe9d659305c7b5$export$2e2bcd8739ae039 = (0, $6f57106b8d65a655$export$2e2bcd8739ae039);


const $849ab185434fa659$export$d1f587f82ad51c4 = ()=>{
    return (0, $dQwsT.useContext)((0, $b3fe9d659305c7b5$export$2e2bcd8739ae039));
};


function $5bc6f3e28bd9f46e$export$5bf35293e545f20c() {
    const analyticsContext = (0, $849ab185434fa659$export$d1f587f82ad51c4)();
    const createAnalyticsEvent = (0, $74e7a60895b89e1f$export$33752cf3ee811995)((payload)=>{
        return new (0, $b7e245d3138d1b2b$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $dQwsT = parcelRequire("dQwsT");


/**
 * Normalizes GraphQL errors to ensure graphQLErrors is always an array
 * This prevents "error.graphQLErrors.every is not a function" errors
 */ function $0f48a177c099c909$var$normalizeGraphQLError(error) {
    if (error && !Array.isArray(error.graphQLErrors)) error.graphQLErrors = error.graphQLErrors ? [
        error.graphQLErrors
    ] : [];
    throw error;
}
/**
 * Safe wrapper around gql() that normalizes errors
 */ function $0f48a177c099c909$var$safeGql(query) {
    try {
        return (0, $986f6c4727102807$export$2e2bcd8739ae039)(query);
    } catch (error) {
        $0f48a177c099c909$var$normalizeGraphQLError(error);
    }
}
/**
 * Checks if a string value is likely a GraphQL enum value.
 * Enum values are typically all uppercase with underscores (e.g., ATLAS_DOC_FORMAT)
 *
 * NOTE: This is a heuristic because Relay's ReaderFragment doesn't include schema
 * type metadata to distinguish enum values from string literals at runtime.
 * Both are stored as plain strings in the `value` field of Literal arguments.
 *
 * Limitation: This won't correctly handle:
 * - Lowercase enum values (e.g., enum Status { active, inactive })
 * - String literals that look like enums (e.g., "CONSTANT_VALUE")
 *
 * For queries/mutations, use params.text instead which has correct formatting.
 */ function $0f48a177c099c909$var$isLikelyEnum(value) {
    // Check if the string matches enum naming conventions:
    // - Starts with uppercase letter
    // - Contains only uppercase letters, numbers, and underscores
    // - Has at least one uppercase letter
    return /^[A-Z][A-Z0-9_]*$/.test(value);
}
function $0f48a177c099c909$export$7c1c2f97801b533e(graphqlTaggedNode) {
    if (typeof graphqlTaggedNode === 'string') // For backwards-compatibility only; that's why `string` is not specified as an accepted argument type
    return $0f48a177c099c909$var$safeGql(graphqlTaggedNode);
    if ('kind' in graphqlTaggedNode && 'definitions' in graphqlTaggedNode) return graphqlTaggedNode;
    if ('kind' in graphqlTaggedNode && graphqlTaggedNode.kind === 'Fragment') return $0f48a177c099c909$var$fragmentToDocumentNode(graphqlTaggedNode);
    if (!('params' in graphqlTaggedNode)) throw new Error('[Relay Migration] unsupported tagged node provided. Please make sure you generated Relay artifacts for your operation');
    const operationText = graphqlTaggedNode.params.text;
    if (!operationText) throw new Error('[Relay Migration] The provided `ConcreteRequest` did not specify `params.text` properties that is required for Apollo deprecation. Make sure you keep the `persiste: { includeQueryText: true }` Relay compiler configuration option ');
    return $0f48a177c099c909$var$safeGql(graphqlTaggedNode.params.text);
}
function $0f48a177c099c909$var$fragmentToDocumentNode(readerFragment) {
    const selections = readerFragment.selections;
    // Helper to format a single value for GraphQL
    function formatValue(v) {
        if (typeof v === 'string') {
            // Check if this is an enum value (unquoted) or a string literal (quoted)
            if ($0f48a177c099c909$var$isLikelyEnum(v)) return v; // Enum values are not quoted
            return `"${v}"`;
        }
        return String(v);
    }
    // Format arguments for a field
    function formatArguments(args) {
        if (!args || args.length === 0) return '';
        const formattedArgs = args.map((arg)=>{
            let value;
            if (arg.kind === 'Variable') // Variable reference: $variableName
            value = `$${arg.variableName}`;
            else if (arg.kind === 'Literal') {
                // Literal value: format based on type
                if (typeof arg.value === 'string') {
                    // Check if this is an enum value (unquoted) or a string literal (quoted)
                    if ($0f48a177c099c909$var$isLikelyEnum(arg.value)) value = arg.value; // Enum values are not quoted
                    else value = `"${arg.value}"`;
                } else if (typeof arg.value === 'number' || typeof arg.value === 'boolean') value = String(arg.value);
                else if (arg.value === null) value = 'null';
                else if (Array.isArray(arg.value)) {
                    const arrayItems = arg.value.map(formatValue).join(', ');
                    value = `[${arrayItems}]`;
                } else if (typeof arg.value === 'object') {
                    // Object literal - convert to GraphQL input object syntax
                    const fields = Object.entries(arg.value).map(([k, v])=>{
                        const formattedValue = formatValue(v);
                        return `${k}: ${formattedValue}`;
                    }).join(', ');
                    value = `{${fields}}`;
                } else value = String(arg.value);
            } else value = String(arg.value);
            return `${arg.name}: ${value}`;
        });
        return `(${formattedArgs.join(', ')})`;
    }
    function selectionToString(selection) {
        const sel = selection;
        switch(sel.kind){
            case 'ScalarField':
                {
                    // Handles: id, name, email
                    // Added: Support for aliases (e.g., userName: name)
                    const alias = sel.alias ? `${sel.alias}: ` : '';
                    const args = formatArguments(sel.args || []);
                    return `${alias}${sel.name}${args}`;
                }
            case 'LinkedField':
                {
                    // Handles: nested objects like profile { avatar bio }
                    // Added: Support for arguments and aliases
                    const alias = sel.alias ? `${sel.alias}: ` : '';
                    const args = formatArguments(sel.args || []);
                    const nestedSelections = sel.selections.map(selectionToString).join(' ');
                    return `${alias}${sel.name}${args}{${nestedSelections}}`;
                }
            case 'InlineFragment':
                {
                    // Handles: ... on TypeName { fields }
                    // Why: Used for union types and interfaces to select fields based on concrete type
                    // Example: ... on InlineComment { markerRef }
                    const typeCondition = sel.type ? ` on ${sel.type}` : '';
                    const nestedSelections = sel.selections.map(selectionToString).join(' ');
                    return `...${typeCondition} {${nestedSelections}}`;
                }
            case 'FragmentSpread':
                // Handles: ...FragmentName
                // Why: Used to include other fragment definitions
                // Example: ...UserProfileFragment
                // Note: Fragment spreads with arguments (@arguments directive) are Relay-specific
                // and need to be converted to inline the fragment instead
                return `...${sel.name}`;
            case 'Condition':
                {
                    // Handles: @include(if: $var) or @skip(if: $var)
                    // Why: Conditional field inclusion based on variables
                    // Example: field @include(if: $showField)
                    const condition = sel.condition;
                    const passingValue = sel.passingValue;
                    const directiveName = passingValue ? '@include' : '@skip';
                    const directiveStr = `${directiveName}(if: $${condition})`;
                    // Apply the directive to each nested selection
                    const nestedSelections = sel.selections.map((s)=>{
                        const fieldStr = selectionToString(s);
                        // Add directive after the field but before any nested braces or directives
                        // For simple fields, just append the directive
                        // For complex fields with selections, insert before the opening brace
                        if (fieldStr.includes('{')) {
                            const braceIndex = fieldStr.indexOf('{');
                            const beforeBrace = fieldStr.slice(0, braceIndex);
                            const afterBrace = fieldStr.slice(braceIndex);
                            return `${beforeBrace} ${directiveStr} ${afterBrace}`;
                        } else return `${fieldStr} ${directiveStr}`;
                    }).join(' ');
                    return nestedSelections;
                }
            case 'Defer':
                {
                    // Handles: @defer directive for deferred fragments
                    // Why: Progressive loading of fragments
                    // Example: ... @defer { slowField }
                    const labelStr = 'label' in selection && selection.label ? `(label: "${selection.label}")` : '';
                    const nestedSelections = 'selections' in selection && selection.selections ? selection.selections.map(selectionToString).join(' ') : '';
                    const deferDirective = `... @defer${labelStr}`;
                    return `${deferDirective} {${nestedSelections}}`;
                }
            case 'ModuleImport':
                {
                    // Handles: @module and @match directives
                    // Why: Used for code-splitting and dynamic imports in Relay
                    // Note: Apollo doesn't have direct equivalent, may need custom handling
                    // This is rarely used and Apollo doesn't support it directly
                    const nestedSelections = 'selections' in selection && selection.selections ? selection.selections.map(selectionToString).join(' ') : '';
                    const docName = 'documentName' in selection && selection.documentName ? selection.documentName : 'unknown';
                    return nestedSelections || `# ModuleImport: ${docName}`;
                }
            case 'TypeDiscriminator':
                // Handles: __typename field for type discrimination
                // Why: Used by Relay for abstract types (unions/interfaces)
                // Apollo uses __typename extensively, so this should be preserved
                return '__typename';
            default:
                // Catch any other selection kinds that might exist
                // This ensures we don't silently ignore new Relay features
                throw new Error(`[Relay Migration] unimplemented fragment selection kind: ${selection.kind}`);
        }
    }
    // Note: Fragments in GraphQL don't support variable definitions
    // Variables are declared at the operation (query/mutation) level
    // and are available to all fragments within that operation.
    const selectionsStr = selections.map(selectionToString).join(' ');
    // Ensure proper spacing in GraphQL syntax
    const fragmentDef = `fragment ${readerFragment.name} on ${readerFragment.type} {
		${selectionsStr}
	}`;
    try {
        return $0f48a177c099c909$var$safeGql(fragmentDef);
    } catch (error) {
        // Add context about the generated GraphQL for debugging
        const contextError = error;
        if (contextError) {
            const originalMessage = contextError.message;
            const errorPrefix = '[Relay Migration] Failed to parse generated GraphQL fragment: ';
            const generatedGraphQL = `\nGenerated GraphQL:\n${fragmentDef}`;
            contextError.message = errorPrefix + originalMessage + generatedGraphQL;
        }
        throw error;
    }
}


const $f54dbbdd58dc6856$var$queryResults = new WeakMap();
function $f54dbbdd58dc6856$export$33c3a40e92be94b0(query, options) {
    // technically not a hash but it's good enough since variable is an plain object.
    const variablesHash = JSON.stringify(options?.variables || {});
    query = (0, $0f48a177c099c909$export$7c1c2f97801b533e)(query);
    const client = options?.client ?? window['GLOBAL_APOLLO_CLIENT'];
    let dataFromCache = null;
    try {
        if (!options?.skip) dataFromCache = client.readQuery({
            query: query,
            ...options
        });
    } catch  {}
    const [result, setResult] = (0, $dQwsT.useState)(()=>{
        return dataFromCache ? {
            data: dataFromCache,
            loading: false,
            networkStatus: (0, $2e58ccba3067efe5$export$bd096ddbd246c79c).ready
        } : {
            data: null,
            loading: true,
            networkStatus: (0, $2e58ccba3067efe5$export$bd096ddbd246c79c).loading
        };
    });
    (0, $dQwsT.useEffect)(()=>{
        if (options?.skip) return;
        // If query is previously fetched but with different variables. Re-fetch the query.
        const queryFetched = $f54dbbdd58dc6856$var$queryResults.has(query) && $f54dbbdd58dc6856$var$queryResults.get(query).has(variablesHash);
        if (result.loading || !queryFetched) {
            // Same query + variable should reuse the same promise to avoid going through expensive Apollo client.
            let queryResultPromise;
            if (queryFetched) queryResultPromise = $f54dbbdd58dc6856$var$queryResults.get(query)?.get(variablesHash);
            else {
                queryResultPromise = client.query({
                    query: query,
                    ...options
                });
                if (!$f54dbbdd58dc6856$var$queryResults.has(query)) $f54dbbdd58dc6856$var$queryResults.set(query, new Map());
                $f54dbbdd58dc6856$var$queryResults.get(query).set(variablesHash, queryResultPromise);
            }
            queryResultPromise.then((result)=>setResult(result)).catch((e)=>{
                setResult({
                    ...result,
                    loading: false,
                    networkStatus: (0, $2e58ccba3067efe5$export$bd096ddbd246c79c).ready,
                    error: e
                });
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        variablesHash
    ]);
    return result;
}



var $8jInb = parcelRequire("8jInb");

var $529b326958d1af20$export$ba064dbfe4bb66d7 = /*#__PURE__*/ function(PreferenceCategory) {
    PreferenceCategory["StrictlyNecessary"] = "STRICTLY_NECESSARY";
    PreferenceCategory["Functional"] = "FUNCTIONAL";
    PreferenceCategory["Marketing"] = "MARKETING";
    PreferenceCategory["Analytics"] = "ANALYTICS";
    PreferenceCategory["Unknown"] = "UNKNOWN";
    return PreferenceCategory;
}({});
var $529b326958d1af20$export$cdef20bac194f235 = /*#__PURE__*/ function(ConsentPreferenceV2) {
    ConsentPreferenceV2["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
    ConsentPreferenceV2["ConsentedUnderGDPR"] = "CONSENTS_SAVED_IN_GDPR_LOCALE";
    ConsentPreferenceV2["ConsentedUnderCPRA"] = "CONSENTS_SAVED_IN_CPRA_LOCALE";
    ConsentPreferenceV2["ConsentedUnderLGPD"] = "CONSENTS_SAVED_IN_LGPD_LOCALE";
    ConsentPreferenceV2["ConsentedUnderFADP"] = "CONSENTS_SAVED_IN_FADP_LOCALE";
    return ConsentPreferenceV2;
}({});
var $529b326958d1af20$export$fac80ad19b60e313 = /*#__PURE__*/ function(ContextualConsentProperty) {
    ContextualConsentProperty["ConsentsAreDefault"] = "DEFAULT_CONSENTS";
    ContextualConsentProperty["UserIsAuthenticated"] = "USER_AUTHENTICATED";
    ContextualConsentProperty["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
    return ContextualConsentProperty;
}({});
var $529b326958d1af20$export$4fda8eb914d6791c = /*#__PURE__*/ function(CachedKeysDataPropertyLegacy) {
    CachedKeysDataPropertyLegacy["LocalStorage"] = "localStorageKeys";
    CachedKeysDataPropertyLegacy["SessionStorage"] = "sessionStorageKeys";
    CachedKeysDataPropertyLegacy["Cookies"] = "keys";
    CachedKeysDataPropertyLegacy["ThirdParty"] = "thirdPartyKeys";
    return CachedKeysDataPropertyLegacy;
}({});
var $529b326958d1af20$export$5d6594a0bba4ab8a = /*#__PURE__*/ function(PrefetchedPreferenceState) {
    PrefetchedPreferenceState[PrefetchedPreferenceState["INTERNAL"] = 0] = "INTERNAL";
    return PrefetchedPreferenceState;
}({});
var $529b326958d1af20$export$2506b012eb637f61 = /*#__PURE__*/ function(CategoryStorageType) {
    CategoryStorageType["Cookies"] = "Cookies";
    CategoryStorageType["LocalStorage"] = "LocalStorage";
    CategoryStorageType["SessionStorage"] = "SessionStorage";
    CategoryStorageType["IndexedDB"] = "IndexedDB";
    return CategoryStorageType;
}({});
var $529b326958d1af20$export$96e9906d6d93a972 = /*#__PURE__*/ function(Status) {
    Status["SUCCESS"] = "SUCCESS";
    Status["BLOCKED"] = "BLOCKED";
    Status["FAILED"] = "FAILED";
    return Status;
}({});
var $529b326958d1af20$export$eefdbcf75990494a = /*#__PURE__*/ function(BSC_PACKAGE_KILLSWITCHES) {
    BSC_PACKAGE_KILLSWITCHES["MASTER_KILLSWITCH"] = "platform_moonjelly_bsc_master_killswitch";
    BSC_PACKAGE_KILLSWITCHES["UI_KILLSWITCH"] = "platform_moonjelly_bsc_ui_killswitch";
    BSC_PACKAGE_KILLSWITCHES["SSR_KILLSWITCH"] = "platform_moonjelly_bsc_ssr_killswitch";
    BSC_PACKAGE_KILLSWITCHES["WEB_STORAGE_KILLSWITCH"] = "platform_moonjelly_bsc_web_storage_killswitch";
    return BSC_PACKAGE_KILLSWITCHES;
}({});



var $b4742520f2786db9$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $b4742520f2786db9$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});

// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

// temp solution until we can get it automated
const $01e862b0a15c243f$export$2295b861f318254a = '0.1.5';


const $59849e7e64a2b10f$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};


class $bffa586db5a6e3a7$var$UFOLogger {
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($bffa586db5a6e3a7$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($bffa586db5a6e3a7$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    constructor(){
        this.enabled = false;
    }
}
$bffa586db5a6e3a7$var$UFOLogger.UFOprefix = "[ufo\uD83D\uDEF8]";
const $bffa586db5a6e3a7$export$4ab84f6f04f6566d = new $bffa586db5a6e3a7$var$UFOLogger();
const $bffa586db5a6e3a7$export$b4958caff08a0960 = (...args)=>{
    $bffa586db5a6e3a7$export$4ab84f6f04f6566d.log(...args);
};
const $bffa586db5a6e3a7$export$d53d07b6034c4560 = (...args)=>{
    $bffa586db5a6e3a7$export$4ab84f6f04f6566d.warn(...args);
};


var $9b699ba14516922a$export$96253c35c37cf96b = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var $9b699ba14516922a$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var $9b699ba14516922a$export$66b33c055cbb625e = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var $9b699ba14516922a$export$3ce489cbe02dc21b = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var $9b699ba14516922a$export$341b330828bd3906 = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var $9b699ba14516922a$export$b9b20160f581e4f8 = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
const $9b699ba14516922a$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $9b699ba14516922a$export$9f2bf58999404c75 = 'fmp';
const $9b699ba14516922a$export$837e0f79a8056912 = 'inline-response';


const $a3ddd2924d122f3f$var$MAX_EARLY_QUEUE_LENGTH = 250;
const $a3ddd2924d122f3f$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < $a3ddd2924d122f3f$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
const $a3ddd2924d122f3f$export$c1522520b417b066 = (eventStream)=>{
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) {
        (0, $bffa586db5a6e3a7$export$d53d07b6034c4560)('Global Event Stream already initialised. Ignoring new event stream setup');
        return;
    }
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
const $a3ddd2924d122f3f$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $9b699ba14516922a$export$96253c35c37cf96b).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $a3ddd2924d122f3f$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $9b699ba14516922a$export$96253c35c37cf96b).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $a3ddd2924d122f3f$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $9b699ba14516922a$export$96253c35c37cf96b).EXPERIENCE_PAYLOAD,
        payload: data
    };
};




class $580939d6b94f8b4a$var$VisibilityChangeObserver {
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
     * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
     * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
     * so for that case, you need to also include code to listen for the pagehide event.
     */ if ((0, $59849e7e64a2b10f$export$15e172712955e18f)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.started = false;
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $580939d6b94f8b4a$export$13e680397ec8f3eb = new $580939d6b94f8b4a$var$VisibilityChangeObserver();



const $b220696a3755b7b3$export$5f490af6b2b115cf = ()=>~~performance.now();


const $27466a72ee55a345$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};



const $be73b70e13c3c1d8$var$UFOStateAvailableTransitions = {
    [(0, $27466a72ee55a345$export$81b70111112841a0).NOT_STARTED.id]: [
        (0, $27466a72ee55a345$export$81b70111112841a0).STARTED.id
    ],
    [(0, $27466a72ee55a345$export$81b70111112841a0).STARTED.id]: [
        (0, $27466a72ee55a345$export$81b70111112841a0).IN_PROGRESS.id,
        (0, $27466a72ee55a345$export$81b70111112841a0).BLOCKED.id,
        (0, $27466a72ee55a345$export$81b70111112841a0).SUCCEEDED.id,
        (0, $27466a72ee55a345$export$81b70111112841a0).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $27466a72ee55a345$export$81b70111112841a0).FAILED.id,
        (0, $27466a72ee55a345$export$81b70111112841a0).ABORTED.id
    ],
    [(0, $27466a72ee55a345$export$81b70111112841a0).IN_PROGRESS.id]: [
        (0, $27466a72ee55a345$export$81b70111112841a0).BLOCKED.id,
        (0, $27466a72ee55a345$export$81b70111112841a0).SUCCEEDED.id,
        (0, $27466a72ee55a345$export$81b70111112841a0).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $27466a72ee55a345$export$81b70111112841a0).FAILED.id,
        (0, $27466a72ee55a345$export$81b70111112841a0).ABORTED.id
    ],
    [(0, $27466a72ee55a345$export$81b70111112841a0).BLOCKED.id]: [
        (0, $27466a72ee55a345$export$81b70111112841a0).RECOVERED.id,
        (0, $27466a72ee55a345$export$81b70111112841a0).ABORTED.id
    ],
    [(0, $27466a72ee55a345$export$81b70111112841a0).RECOVERED.id]: [
        (0, $27466a72ee55a345$export$81b70111112841a0).STARTED.id,
        (0, $27466a72ee55a345$export$81b70111112841a0).SUCCEEDED.id,
        (0, $27466a72ee55a345$export$81b70111112841a0).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $27466a72ee55a345$export$81b70111112841a0).FAILED.id,
        (0, $27466a72ee55a345$export$81b70111112841a0).ABORTED.id
    ],
    [(0, $27466a72ee55a345$export$81b70111112841a0).SUCCEEDED.id]: [
        (0, $27466a72ee55a345$export$81b70111112841a0).STARTED.id
    ],
    [(0, $27466a72ee55a345$export$81b70111112841a0).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $27466a72ee55a345$export$81b70111112841a0).SUCCEEDED.id,
        (0, $27466a72ee55a345$export$81b70111112841a0).FAILED.id,
        (0, $27466a72ee55a345$export$81b70111112841a0).ABORTED.id
    ],
    [(0, $27466a72ee55a345$export$81b70111112841a0).FAILED.id]: [
        (0, $27466a72ee55a345$export$81b70111112841a0).STARTED.id
    ],
    [(0, $27466a72ee55a345$export$81b70111112841a0).ABORTED.id]: [
        (0, $27466a72ee55a345$export$81b70111112841a0).STARTED.id
    ]
};
const $be73b70e13c3c1d8$export$178881f329fdb81f = (state1, state2)=>{
    return $be73b70e13c3c1d8$var$UFOStateAvailableTransitions[state1.id] && $be73b70e13c3c1d8$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};



const $742a3409ef52acee$var$getPageVisibleState = ()=>{
    return !(0, $59849e7e64a2b10f$export$15e172712955e18f)() || !window.document || window.document.visibilityState === 'visible' ? (0, $9b699ba14516922a$export$a12c67b37a306b13).VISIBLE : (0, $9b699ba14516922a$export$a12c67b37a306b13).HIDDEN;
};
const $742a3409ef52acee$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $b220696a3755b7b3$export$5f490af6b2b115cf)();
};
class $742a3409ef52acee$export$d31c89db257648c {
    async transition(newState, timestamp) {
        (0, $bffa586db5a6e3a7$export$b4958caff08a0960)('async transition', this.id, this.state.id, newState.id);
        if ((0, $be73b70e13c3c1d8$export$178881f329fdb81f)(this.state, newState)) {
            (0, $bffa586db5a6e3a7$export$b4958caff08a0960)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $27466a72ee55a345$export$81b70111112841a0).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = $742a3409ef52acee$export$c753e8669d30c8ad(timestamp);
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                this.uuid = (0, $19dcc840d0563c39$exports.v4)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = $742a3409ef52acee$export$c753e8669d30c8ad(timestamp);
                if (!this._isManualStateEnabled()) (0, $a3ddd2924d122f3f$export$6123a44dc2384540)().push((0, $a3ddd2924d122f3f$export$ee1a7bd1fc9ea85e)((0, $9b699ba14516922a$export$79bf131685ad41d7), this.handleDoneBind));
                const data = await this.exportData();
                (0, $bffa586db5a6e3a7$export$b4958caff08a0960)('this.parent', this.parent);
                (0, $a3ddd2924d122f3f$export$6123a44dc2384540)().push((0, $a3ddd2924d122f3f$export$7c957416596ca127)(data));
            }
            return true;
        }
        (0, $bffa586db5a6e3a7$export$b4958caff08a0960)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $bffa586db5a6e3a7$export$d53d07b6034c4560)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $27466a72ee55a345$export$81b70111112841a0).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $742a3409ef52acee$var$getPageVisibleState();
            (0, $580939d6b94f8b4a$export$13e680397ec8f3eb).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $bffa586db5a6e3a7$export$b4958caff08a0960)('subscribed', this.id);
                (0, $a3ddd2924d122f3f$export$6123a44dc2384540)().push((0, $a3ddd2924d122f3f$export$37863216db4b714d)((0, $9b699ba14516922a$export$79bf131685ad41d7), this.handleDoneBind));
            }
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $9b699ba14516922a$export$9f2bf58999404c75) && name !== (0, $9b699ba14516922a$export$837e0f79a8056912)) this._mark(name, timestamp);
        else (0, $bffa586db5a6e3a7$export$d53d07b6034c4560)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: $742a3409ef52acee$export$c753e8669d30c8ad(timestamp)
        });
        this.transition((0, $27466a72ee55a345$export$81b70111112841a0).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $9b699ba14516922a$export$9f2bf58999404c75), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $9b699ba14516922a$export$837e0f79a8056912), timestamp);
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $bffa586db5a6e3a7$export$d53d07b6034c4560)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!config?.force && !this._validateManualState()) return null;
        if (config?.metadata) this.addMetadata(config.metadata);
        (0, $580939d6b94f8b4a$export$13e680397ec8f3eb).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $27466a72ee55a345$export$81b70111112841a0).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $27466a72ee55a345$export$81b70111112841a0).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $27466a72ee55a345$export$81b70111112841a0).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $bffa586db5a6e3a7$export$b4958caff08a0960)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $01e862b0a15c243f$export$2295b861f318254a) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this._until = this.until ? this.until() : null;
    }
    constructor(id, config, instanceId = null){
        this.state = (0, $27466a72ee55a345$export$81b70111112841a0).NOT_STARTED;
        this.id = void 0;
        this.instanceId = null;
        // for concurrent
        this.parent = null;
        this.category = null;
        this.type = void 0;
        this.performanceType = void 0;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.featureFlags = void 0;
        this.timings = void 0;
        this.explicitTimings = {};
        // @todo move to page load experience when proper classes/inheritance prepared
        this.isSSROutputAsFMP = false;
        this.handleDoneBind = void 0;
        this.uuid = null;
        this.until = void 0;
        this._until = null;
        this.pageVisibleState = void 0;
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.performanceConfig = {};
        this.config = void 0;
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = (0, $9b699ba14516922a$export$a12c67b37a306b13).MIXED;
            (0, $580939d6b94f8b4a$export$13e680397ec8f3eb).unsubscribe(this.setPageVisibleStateToMixed);
        };
        this.id = id;
        this.category = config?.category || null;
        this.until = config?.until || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $742a3409ef52acee$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $b4742520f2786db9$export$cc26007c03242fff).PageLoad || config.performanceType === (0, $b4742520f2786db9$export$cc26007c03242fff).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
}


class $3d5759469f04fd92$export$c00d22927c60484a extends (0, $742a3409ef52acee$export$d31c89db257648c) {
}



/* eslint-disable no-console */ 

var $79Dx6 = parcelRequire("79Dx6");
var $1RuJ0 = parcelRequire("1RuJ0");


const $909997db7697abe1$export$9345d7360ffe0722 = "platform-pkg" ?? '';
const $909997db7697abe1$export$91546b032799aa40 = "0.0.0-use.local" ?? '';




class $4a357973b46934d1$export$b886edaf6623554a {
    get cachedSamplingConfig() {
        return this.cache;
    }
    set cachedSamplingConfig(value) {
        this.cache = value;
    }
    constructor(){
        this.cache = void 0;
    }
}


const $6ebbeb981785d40e$export$69a3209f1a06c04d = new (0, $4a357973b46934d1$export$b886edaf6623554a)();



var $79Dx6 = parcelRequire("79Dx6");

const $6f3320f8ddad677d$export$48d7c418edadb60c = ()=>{
    const isMissingNecessaryBrowserUtils = typeof document === 'undefined' || typeof window === 'undefined' || !Document || !Document.prototype || !Object || !Object.defineProperty;
    const isMissingBooleanFF = !(0, $c04d14497c4aa1d8$export$b40ec24ac8275656);
    const isMissingAnalyticsWebClient = !Boolean((0, $79Dx6.default));
    if (isMissingNecessaryBrowserUtils || isMissingBooleanFF || isMissingAnalyticsWebClient) return true;
    else return false;
};


const $cf3d90b74004228c$export$1138592b3c099377 = {
    usedGetCookie: 100000,
    usedGetCookieError: 1,
    usedSetCookie: 1000,
    usedSetCookieError: 1,
    usedSetStrictlyNecessaryCookie: 10000,
    usedSetStrictlyNecessaryCookieError: 1,
    usedDeleteCookie: 10,
    usedDeleteCookieError: 1,
    usedCheckThirdParty: 100000,
    checkThirdPartyError: 1,
    usedDocumentCookie: 100,
    usedDocumentCookieError: 1,
    initializeControlsError: 1,
    loadStorageControlsError: 1,
    updatePreferencesError: 1,
    fetchConsentPreferencesError: 1,
    saveConsentPreferencesError: 1,
    usedAtlBrowserStorageGetItem: 100,
    usedAtlBrowserStorageGetItemError: 1,
    usedAtlBrowserStorageSetItem: 100,
    usedAtlBrowserStorageSetItemError: 1,
    usedAtlBrowserStorageSetStrictlyNecessaryItem: 100,
    usedAtlBrowserStorageSetStrictlyNecessaryItemError: 1,
    indexDbSetRecordError: 1,
    usedCheckIfSetByPackageError: 1,
    renderConsentBannerError: 1,
    bannerAppearanceAfterDismissal: 1,
    usedAtlIndexedDBOpen: 100,
    usedAtlIndexedDBOpenError: 1,
    usedAtlIndexedDBOpenStrictlyNecessary: 100,
    usedAtlIndexedDBOpenStrictlyNecessaryError: 1
};
// This short-circuits finding a sampling ratio from the remote config. Useful for things like
// `loadStorageControlsError` which itself tries to log an event on error, causing an infinite
// recursion as each lookup fails, logging another event, etc.
const $cf3d90b74004228c$var$localOnlySamplingKeys = [
    'loadStorageControlsError'
];
async function $cf3d90b74004228c$var$loadSamplingConfig() {
    if ((0, $6ebbeb981785d40e$export$69a3209f1a06c04d).cachedSamplingConfig) return (0, $6ebbeb981785d40e$export$69a3209f1a06c04d).cachedSamplingConfig;
    if ((0, $6f3320f8ddad677d$export$48d7c418edadb60c)()) return undefined;
    const { loadCache: loadCache } = (0, $e15ac9c6b48eae37$export$3b78a1ea01f5ec28)();
    const controlsData = await loadCache((0, $529b326958d1af20$export$2506b012eb637f61).Cookies);
    const analyticsSamplingRatioConfigs = controlsData?.analyticsSamplingRatio;
    (0, $6ebbeb981785d40e$export$69a3209f1a06c04d).cachedSamplingConfig = analyticsSamplingRatioConfigs;
    return analyticsSamplingRatioConfigs;
}
async function $cf3d90b74004228c$export$b286f5e8716d11ad(analyticsEventKey) {
    if ($cf3d90b74004228c$var$localOnlySamplingKeys.includes(analyticsEventKey)) return $cf3d90b74004228c$export$1138592b3c099377[analyticsEventKey];
    const remoteSamplingConfig = await $cf3d90b74004228c$var$loadSamplingConfig();
    const samplingConfig = remoteSamplingConfig ?? $cf3d90b74004228c$export$1138592b3c099377;
    const samplingRatio = samplingConfig?.[analyticsEventKey] !== undefined ? samplingConfig[analyticsEventKey] : $cf3d90b74004228c$export$1138592b3c099377[analyticsEventKey];
    return samplingRatio;
}
function $cf3d90b74004228c$export$dc2f0946255b3f89(samplingRatio, cb) {
    /* Only run if rolling the samplingRatio-sized die lands on a 0
       ________
      /\       \
     /()\   ()  \
    /    \_______\
    \    /()     /
     \()/   ()  /
      \/_____()/
  */ const shouldRun = !Math.floor(Math.random() * samplingRatio);
    shouldRun && cb();
}
async function $cf3d90b74004228c$export$67b6e87f323cb6ad(analyticsEventKey, cb) {
    const ratio = await $cf3d90b74004228c$export$b286f5e8716d11ad(analyticsEventKey);
    $cf3d90b74004228c$export$dc2f0946255b3f89(ratio, cb);
}


const $e7919529bbee736a$var$getEnvironment = ()=>{
    const { hostname: hostname } = window.location;
    if (hostname.includes('.dev.') || hostname.includes('.stg.') || hostname.includes('.jira-dev.') || hostname.includes('.jira-stg.')) return (0, $1RuJ0.envType).STAGING;
    if (hostname.includes('localhost') || hostname.includes('ngrok') || hostname.includes('atlastunnel')) return (0, $1RuJ0.envType).DEV;
    return (0, $1RuJ0.envType).PROD;
};
const $e7919529bbee736a$export$78d7c0236b4fece9 = (path)=>{
    let subPath = '';
    if (!path) return subPath;
    const checkPath = (match)=>{
        return new RegExp(`^${match}(/|$)`).test(String(path));
    };
    if (checkPath('/wiki')) subPath = '/wiki';
    if (checkPath('/jira')) subPath = '/jira';
    if (checkPath('/compass')) subPath = '/compass';
    if (checkPath('/canvas')) subPath = '/canvas';
    if (checkPath('/servicedesk') || checkPath('/jira/servicedesk')) subPath = '/servicedesk';
    return subPath;
};
const $e7919529bbee736a$var$getProductFromDomain = (domain)=>{
    if (domain === 'https://trello.com') return 'trello';
    return null;
};
const $e7919529bbee736a$export$fce3dd735e04d566 = ()=>{
    const { origin: origin, pathname: pathname } = window.location;
    const productPath = $e7919529bbee736a$export$78d7c0236b4fece9(pathname);
    const domain = `${origin}${productPath}`;
    const product = $e7919529bbee736a$var$getProductFromDomain(domain) || productPath.slice(1);
    return {
        domain: domain,
        product: product
    };
};
const $e7919529bbee736a$var$decorateEventAttributes = (attributes)=>{
    const { domain: domain, product: product } = $e7919529bbee736a$export$fce3dd735e04d566();
    return {
        packageName: $909997db7697abe1$export$9345d7360ffe0722,
        packageVersion: $909997db7697abe1$export$91546b032799aa40,
        domain: domain,
        product: (0, $e15ac9c6b48eae37$export$3b78a1ea01f5ec28)().product?.toLowerCase() ?? product,
        ...attributes && attributes
    };
};
const $e7919529bbee736a$export$fde53e78fd93a54d = (()=>{
    let instance;
    return ()=>{
        try {
            if (!instance && (0, $e15ac9c6b48eae37$export$3b78a1ea01f5ec28)().analyticsEnabled) instance = new (0, $79Dx6.default)({
                env: $e7919529bbee736a$var$getEnvironment(),
                product: 'atlassianCookies'
            }, {
                // useLegacyUrl tells the analytics client to make calls directly to Global Analytics Service.
                // When set to false, the client will use a stargate proxy for the current URL to send events
                // to GAS. Said another way:
                // true => events are sent to https://api-private.stg.atlassian.com/gasv3/api/v1/batch
                // false => events are sent to <the current domain>/gasv3/api/v1/batch
                //
                // By default, this should be set to false.  If you need to validate that analytics events
                // are being transmitted correctly in local dev, you can temporarily enable it since localhost
                // won't be able to proxy to GAS via stargate.
                useLegacyUrl: false,
                disableCookiePersistence: true
            });
        } catch (e) {
            // Log  errors thrown in constructor initialization for the AnalyticsWebClient
            (0, $d1a5ba6794b83ea4$export$efa9a398d6368992).error(`Failed to initialize AnalyticsWebClient. ${e}`);
        }
        if (!(0, $e15ac9c6b48eae37$export$3b78a1ea01f5ec28)().analyticsEnabled) return undefined;
        // Return the instance, even if it is undefined
        return instance;
    };
})();
function $e7919529bbee736a$export$5bfe55348e7aebc1(properties) {
    (0, $cf3d90b74004228c$export$67b6e87f323cb6ad)(properties.action, ()=>$e7919529bbee736a$export$fde53e78fd93a54d()?.sendOperationalEvent({
            source: 'package',
            actionSubject: 'package',
            action: properties.action,
            attributes: $e7919529bbee736a$var$decorateEventAttributes(properties.attributes)
        }));
}
function $e7919529bbee736a$export$1aecf263098db667(properties) {
    $e7919529bbee736a$export$fde53e78fd93a54d()?.sendUIEvent({
        ...properties,
        attributes: $e7919529bbee736a$var$decorateEventAttributes(properties.attributes)
    });
}
function $e7919529bbee736a$export$22a3b1671f38a193(properties) {
    $e7919529bbee736a$export$fde53e78fd93a54d()?.sendScreenEvent({
        ...properties,
        attributes: $e7919529bbee736a$var$decorateEventAttributes(properties.attributes)
    });
}
function $e7919529bbee736a$export$1ba525b8a711eaac(properties) {
    $e7919529bbee736a$export$fde53e78fd93a54d()?.sendTrackEvent({
        ...properties,
        attributes: $e7919529bbee736a$var$decorateEventAttributes(properties.attributes)
    });
}



const $d1a5ba6794b83ea4$var$LOG_PREFIX = '[browser-storage-controls]';
class $d1a5ba6794b83ea4$export$efa9a398d6368992 {
    static info(message, metadata) {
        console.log(`${$d1a5ba6794b83ea4$var$LOG_PREFIX}: ${message}`, metadata ? JSON.stringify(metadata) : '');
    }
    static error(message, metadata) {
        console.error(`${$d1a5ba6794b83ea4$var$LOG_PREFIX}: ${message}`, metadata ? JSON.stringify(metadata) : '');
    }
    static errorWithOperationalEvent({ action: action, attributes: attributes = {}, message: message, metadata: metadata }) {
        try {
            (0, $e7919529bbee736a$export$5bfe55348e7aebc1)({
                action: action,
                attributes: {
                    error: message,
                    ...attributes
                }
            });
        } catch (e) {
            this.error(`Failed to send operational event on error: ${action}. ${e.message || ''}`);
        }
        this.error(message, metadata ? JSON.stringify(metadata) : '');
    }
    static warn(message, metadata) {
        console.warn(`${$d1a5ba6794b83ea4$var$LOG_PREFIX}: ${message}`, metadata ? JSON.stringify(metadata) : '');
    }
    /**
   * Logger for additional debugging of the package. Debug logs are only sent when the
   * atl-bsc-debug-mode cookie is set on the browser. This is evaluated via global state
   */ static debug(message, metadata) {
        if ((0, $e15ac9c6b48eae37$export$3b78a1ea01f5ec28)().packageDebugMode && (0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_moonjelly_bsc_debug_mode')) console.debug(`${$d1a5ba6794b83ea4$var$LOG_PREFIX}: DEBUG ${message}`, metadata ? JSON.stringify(metadata) : '');
    }
}



const $f0b5f186563d7d5c$export$194c34963e6f0bc6 = 'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories.json';
const $f0b5f186563d7d5c$export$b44048c6704cb5cb = 'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories_COOKIE.json';
const $f0b5f186563d7d5c$export$c55beaf8e17d7be2 = 'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories_LOCAL_STORAGE.json';
const $f0b5f186563d7d5c$export$e1db91db5e7e324f = 'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories_SESSION_STORAGE.json';
const $f0b5f186563d7d5c$export$e6aa221522e55945 = 'https://atlassian-cookies--categories.us-east-1.prod.public.atl-paas.net/categories_INDEXED_DB.json';
const $f0b5f186563d7d5c$export$abf8d23e319d4d71 = 'https://atlassian-cookies--categories.us-east-1.prod.cdn.atlassian-us-gov-mod.com/categories_COOKIE.json';
const $f0b5f186563d7d5c$export$de367b95fcc6730f = 'https://atlassian-cookies--categories.us-east-1.prod.cdn.atlassian-us-gov-mod.com/categories_LOCAL_STORAGE.json';
const $f0b5f186563d7d5c$export$d5e6ad74bf291eaf = 'https://atlassian-cookies--categories.us-east-1.prod.cdn.atlassian-us-gov-mod.com/categories_SESSION_STORAGE.json';
const $f0b5f186563d7d5c$export$826fda6999693596 = 'https://atlassian-cookies--categories.us-east-1.prod.cdn.atlassian-us-gov-mod.com/categories_INDEXED_DB.json';
const $f0b5f186563d7d5c$export$218c59d0d43946aa = {
    [(0, $529b326958d1af20$export$2506b012eb637f61).Cookies]: $f0b5f186563d7d5c$export$b44048c6704cb5cb,
    [(0, $529b326958d1af20$export$2506b012eb637f61).LocalStorage]: $f0b5f186563d7d5c$export$c55beaf8e17d7be2,
    [(0, $529b326958d1af20$export$2506b012eb637f61).SessionStorage]: $f0b5f186563d7d5c$export$e1db91db5e7e324f,
    [(0, $529b326958d1af20$export$2506b012eb637f61).IndexedDB]: $f0b5f186563d7d5c$export$e6aa221522e55945
};
const $f0b5f186563d7d5c$export$df45fb0af5b720ce = {
    commercial: $f0b5f186563d7d5c$export$218c59d0d43946aa,
    'fedramp-moderate': {
        [(0, $529b326958d1af20$export$2506b012eb637f61).Cookies]: $f0b5f186563d7d5c$export$abf8d23e319d4d71,
        [(0, $529b326958d1af20$export$2506b012eb637f61).LocalStorage]: $f0b5f186563d7d5c$export$de367b95fcc6730f,
        [(0, $529b326958d1af20$export$2506b012eb637f61).SessionStorage]: $f0b5f186563d7d5c$export$d5e6ad74bf291eaf,
        [(0, $529b326958d1af20$export$2506b012eb637f61).IndexedDB]: $f0b5f186563d7d5c$export$826fda6999693596
    }
};


class $fd598d04116f0467$export$e479342c697b82a9 {
    clearStorageControlsDataCache() {
        this.localResponseCache = undefined;
        this.localResponsePromiseCache = undefined;
        this.localResponseJsonPromiseCache = undefined;
    }
    /**
   * Unpacks the response promise from the categories CDN
   *
   * errors if that request was unsuccessful, returns the categories data otherwise
   *
   */ async handleCategoriesResponse(responsePromise) {
        if (!responsePromise) throw new Error(`Failed to fetch Cookies Cache! Cached promise was undefined`);
        const response = await responsePromise;
        if (!response.ok) throw new Error(`Failed to fetch Cookies Cache! status: ${response.status}`);
        // Checks if we've already fired the response.json() promise
        this.localResponseJsonPromiseCache = this.localResponseJsonPromiseCache || response?.json();
        return this.localResponseJsonPromiseCache;
    }
    async loadStorageControlsData() {
        const isFetchTrackingSampled = !Math.floor(Math.random() * 100);
        const shouldTrackFetch = (0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_measure_bsc_fetch_time') && isFetchTrackingSampled;
        let fetchExperience = null;
        if (shouldTrackFetch) {
            fetchExperience = new (0, $3d5759469f04fd92$export$c00d22927c60484a)('browser-storage-controls-fetch-time', {
                type: (0, $b4742520f2786db9$export$994164cf3ae1cc9a).Load,
                performanceType: (0, $b4742520f2786db9$export$cc26007c03242fff).Custom,
                platform: {
                    component: 'browser-storage-controls'
                }
            });
            fetchExperience.start();
        }
        if (this.localResponseCache) {
            if (fetchExperience) fetchExperience.success();
            return this.localResponseCache;
        } else // Always use Prod CDN for prod/local/dev/staging environments, but stub the route for automation tests
        try {
            if (!this.localResponsePromiseCache) {
                (0, $d1a5ba6794b83ea4$export$efa9a398d6368992).debug(`Loading cache ${this.cacheUrl}`);
                // invoke CDN and cache the promise
                this.localResponsePromiseCache = fetch(this.cacheUrl);
            }
            // unpack response
            this.localResponseCache = await this.handleCategoriesResponse(this.localResponsePromiseCache);
            if (fetchExperience) fetchExperience.success();
            return this.localResponseCache;
        } catch (e) {
            if (fetchExperience) fetchExperience.failure({
                metadata: {
                    error: String(e)
                }
            });
            (0, $d1a5ba6794b83ea4$export$efa9a398d6368992).errorWithOperationalEvent({
                action: 'loadStorageControlsError',
                message: e.message || ''
            });
            this.clearStorageControlsDataCache();
        }
    }
    constructor(storageType, perimeter = 'commercial'){
        this.cacheUrl = void 0;
        /**
     * Cache variable for storing categorized cookies cache
     */ this.localResponseCache = void 0;
        /**
     * Cache variable for storing a promise that's been fired by a different invocation of loadStorageControls
     *
     * Allows for many invocations to happen simultaneously, and for only one fetch to go out
     */ this.localResponsePromiseCache = void 0;
        /**
     * Cache variable for storing the promise returned from the response object's json method
     *
     * Ensures we don't invoke response.json multiple times
     */ this.localResponseJsonPromiseCache = void 0;
        if (!(0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('fedramp-cookies-controls')) switch(storageType){
            case (0, $529b326958d1af20$export$2506b012eb637f61).Cookies:
                this.cacheUrl = (0, $f0b5f186563d7d5c$export$b44048c6704cb5cb);
                break;
            case (0, $529b326958d1af20$export$2506b012eb637f61).LocalStorage:
                this.cacheUrl = (0, $f0b5f186563d7d5c$export$c55beaf8e17d7be2);
                break;
            case (0, $529b326958d1af20$export$2506b012eb637f61).SessionStorage:
                this.cacheUrl = (0, $f0b5f186563d7d5c$export$e1db91db5e7e324f);
                break;
            default:
                this.cacheUrl = (0, $f0b5f186563d7d5c$export$194c34963e6f0bc6);
        }
        else {
            // If a new perimeter type is added, but not supported by us yet, default to commercial URLs
            const cacheUrlLookup = (0, $f0b5f186563d7d5c$export$df45fb0af5b720ce)[perimeter] || (0, $f0b5f186563d7d5c$export$218c59d0d43946aa);
            this.cacheUrl = cacheUrlLookup[storageType];
        }
    }
}



let $e15ac9c6b48eae37$var$analyticsEnabledGlobalState;
let $e15ac9c6b48eae37$var$productGlobalState;
let $e15ac9c6b48eae37$var$perimeterGlobalState;
let $e15ac9c6b48eae37$var$webStorageControlsEnabledGlobalState;
let $e15ac9c6b48eae37$var$indexedDbControlsEnabledGlobalState;
let $e15ac9c6b48eae37$var$localConsentModeGlobalState;
let $e15ac9c6b48eae37$var$packageDebugModeEnabledGlobalState;
let $e15ac9c6b48eae37$var$allowUncategorizedCookiesInOverridesGlobalState;
let $e15ac9c6b48eae37$var$hasInitialized = false;
let $e15ac9c6b48eae37$var$cookiesCacheLoader;
let $e15ac9c6b48eae37$var$localStorageCacheLoader;
let $e15ac9c6b48eae37$var$sessionStorageCacheLoader;
let $e15ac9c6b48eae37$var$indexedDBCacheLoader;
let $e15ac9c6b48eae37$var$loadCache = async (storageType)=>{
    switch(storageType){
        case (0, $529b326958d1af20$export$2506b012eb637f61).Cookies:
            return await $e15ac9c6b48eae37$var$cookiesCacheLoader?.loadStorageControlsData();
        case (0, $529b326958d1af20$export$2506b012eb637f61).LocalStorage:
            return await $e15ac9c6b48eae37$var$localStorageCacheLoader?.loadStorageControlsData();
        case (0, $529b326958d1af20$export$2506b012eb637f61).SessionStorage:
            return await $e15ac9c6b48eae37$var$sessionStorageCacheLoader?.loadStorageControlsData();
        case (0, $529b326958d1af20$export$2506b012eb637f61).IndexedDB:
            return await $e15ac9c6b48eae37$var$indexedDBCacheLoader?.loadStorageControlsData();
        default:
            return undefined;
    }
};
const $e15ac9c6b48eae37$export$3b78a1ea01f5ec28 = ()=>{
    return {
        analyticsEnabled: $e15ac9c6b48eae37$var$analyticsEnabledGlobalState ?? true,
        product: $e15ac9c6b48eae37$var$productGlobalState,
        perimeter: $e15ac9c6b48eae37$var$perimeterGlobalState,
        webStorageEnabled: $e15ac9c6b48eae37$var$webStorageControlsEnabledGlobalState ?? false,
        indexedDbEnabled: $e15ac9c6b48eae37$var$indexedDbControlsEnabledGlobalState ?? false,
        localConsentMode: $e15ac9c6b48eae37$var$localConsentModeGlobalState ?? false,
        packageDebugMode: $e15ac9c6b48eae37$var$packageDebugModeEnabledGlobalState,
        allowUncategorizedCookiesInOverrides: $e15ac9c6b48eae37$var$allowUncategorizedCookiesInOverridesGlobalState ?? false,
        cookiesCacheLoader: $e15ac9c6b48eae37$var$cookiesCacheLoader,
        localStorageCacheLoader: $e15ac9c6b48eae37$var$localStorageCacheLoader,
        sessionStorageCacheLoader: $e15ac9c6b48eae37$var$sessionStorageCacheLoader,
        indexedDBCacheLoader: $e15ac9c6b48eae37$var$indexedDBCacheLoader,
        loadCache: $e15ac9c6b48eae37$var$loadCache,
        hasInitialized: $e15ac9c6b48eae37$var$hasInitialized
    };
};
const $e15ac9c6b48eae37$export$882c4530c58781d8 = ({ webStorageEnabled: webStorageEnabled, indexedDbEnabled: indexedDbEnabled, allowUncategorizedCookiesInOverrides: allowUncategorizedCookiesInOverrides, localConsentMode: localConsentMode = false, product: product = 'all', perimeter: perimeter = 'commercial', analyticsEnabled: analyticsEnabled = true } = {})=>{
    (0, $d1a5ba6794b83ea4$export$efa9a398d6368992).debug('Initialize global state invoked');
    // If the app provides a value for product only in one place,
    // we want that value to be sticky and to override the default if necessary
    if ((!$e15ac9c6b48eae37$var$productGlobalState || $e15ac9c6b48eae37$var$productGlobalState == null || $e15ac9c6b48eae37$var$productGlobalState === 'all') && product) $e15ac9c6b48eae37$var$productGlobalState = product;
    // Treating webStorageEnabled, indexedDbEnabled, and allowUncategorizedCookiesInOverrides differently
    // because they are only passed through initializeControls and
    // we don't want it to be defaulted to false via a call from the ConsentBanner
    if (webStorageEnabled !== undefined && $e15ac9c6b48eae37$var$webStorageControlsEnabledGlobalState === undefined) $e15ac9c6b48eae37$var$webStorageControlsEnabledGlobalState = webStorageEnabled && !(0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_moonjelly_bsc_master_killswitch') && !(0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_moonjelly_bsc_web_storage_killswitch');
    if (indexedDbEnabled !== undefined && $e15ac9c6b48eae37$var$indexedDbControlsEnabledGlobalState === undefined) $e15ac9c6b48eae37$var$indexedDbControlsEnabledGlobalState = indexedDbEnabled && !(0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_moonjelly_bsc_master_killswitch') && !(0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_moonjelly_bsc_web_storage_killswitch');
    if (allowUncategorizedCookiesInOverrides !== undefined && $e15ac9c6b48eae37$var$allowUncategorizedCookiesInOverridesGlobalState === undefined) $e15ac9c6b48eae37$var$allowUncategorizedCookiesInOverridesGlobalState = allowUncategorizedCookiesInOverrides;
    // All other state can only be initialized once and is defaulted if not passed on the first initialization
    if ($e15ac9c6b48eae37$var$hasInitialized) return;
    if (!(0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('fedramp-cookies-controls')) $e15ac9c6b48eae37$var$localConsentModeGlobalState = localConsentMode;
    else // Force local consent mode when in the FedRAMP Moderate perimeter because ConsentHub is
    // not hydrated in the perimeter as of this comment
    $e15ac9c6b48eae37$var$localConsentModeGlobalState = localConsentMode || perimeter === 'fedramp-moderate';
    $e15ac9c6b48eae37$var$analyticsEnabledGlobalState = analyticsEnabled;
    $e15ac9c6b48eae37$var$perimeterGlobalState = perimeter;
    $e15ac9c6b48eae37$var$cookiesCacheLoader = new (0, $fd598d04116f0467$export$e479342c697b82a9)((0, $529b326958d1af20$export$2506b012eb637f61).Cookies, perimeter);
    $e15ac9c6b48eae37$var$localStorageCacheLoader = new (0, $fd598d04116f0467$export$e479342c697b82a9)((0, $529b326958d1af20$export$2506b012eb637f61).LocalStorage, perimeter);
    $e15ac9c6b48eae37$var$sessionStorageCacheLoader = new (0, $fd598d04116f0467$export$e479342c697b82a9)((0, $529b326958d1af20$export$2506b012eb637f61).SessionStorage, perimeter);
    $e15ac9c6b48eae37$var$indexedDBCacheLoader = new (0, $fd598d04116f0467$export$e479342c697b82a9)((0, $529b326958d1af20$export$2506b012eb637f61).IndexedDB, perimeter);
    if ((0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_moonjelly_bsc_debug_mode')) $e15ac9c6b48eae37$var$packageDebugModeEnabledGlobalState = Boolean((0, (/*@__PURE__*/$parcel$interopDefault($8jInb))).get('atl-bsc-debug-mode'));
    $e15ac9c6b48eae37$var$hasInitialized = true;
};
const $e15ac9c6b48eae37$export$f86e17381f699baf = ({ loadCache: overrideLoadCache, product: overrideProduct })=>{
    if (overrideLoadCache) $e15ac9c6b48eae37$var$loadCache = overrideLoadCache;
    if (overrideProduct) $e15ac9c6b48eae37$var$productGlobalState = overrideProduct;
};
const $e15ac9c6b48eae37$export$ac7c2edd09656c05 = ()=>{
    $e15ac9c6b48eae37$var$analyticsEnabledGlobalState = undefined;
    $e15ac9c6b48eae37$var$productGlobalState = undefined;
    $e15ac9c6b48eae37$var$webStorageControlsEnabledGlobalState = undefined;
    $e15ac9c6b48eae37$var$indexedDbControlsEnabledGlobalState = undefined;
    $e15ac9c6b48eae37$var$localConsentModeGlobalState = undefined;
    $e15ac9c6b48eae37$var$packageDebugModeEnabledGlobalState = undefined;
    $e15ac9c6b48eae37$var$allowUncategorizedCookiesInOverridesGlobalState = undefined;
    $e15ac9c6b48eae37$var$cookiesCacheLoader = undefined;
    $e15ac9c6b48eae37$var$localStorageCacheLoader = undefined;
    $e15ac9c6b48eae37$var$sessionStorageCacheLoader = undefined;
    $e15ac9c6b48eae37$var$indexedDBCacheLoader = undefined;
    $e15ac9c6b48eae37$var$hasInitialized = false;
};







class $839bb944f3bf2243$export$fde2a4e0e57f47e {
    async boot() {
        if (!this.isAvailable) {
            (0, $d1a5ba6794b83ea4$export$efa9a398d6368992).warn('IndexedDB is not available');
            return;
        }
        if (this.isBooted) // Short circuit if we've already booted once
        return;
        // Only boot once, even if we've been called numerous times sequentially
        if (!this.bootUpPromiseCache) {
            this.bootUpPromiseCache = this.openDB();
            try {
                await this.bootUpPromiseCache;
                this.isBooted = true;
            } catch (e) {
                this.isBooted = false;
                (0, $d1a5ba6794b83ea4$export$efa9a398d6368992).warn('Error booting up IndexedDB.');
                throw e;
            }
        }
    }
    getIsDBAvailable() {
        return !(0, $6f3320f8ddad677d$export$48d7c418edadb60c)() && !!window.indexedDB;
    }
    async openDB() {
        return new Promise((resolve, reject)=>{
            let request = indexedDB.open(this.dbName, 2);
            request.onerror = this.onConnectionErrorHandler(reject);
            request.onsuccess = this.onConnectionSuccessHandler(request, resolve);
            request.onupgradeneeded = this.onConnectionUpgradeNeededHandler(request);
        });
    }
    async getRecord(recordKey) {
        try {
            if (!this.isBooted) await this.boot();
            if (!this.db) {
                if ((0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_set_necessary_storage_item_error_hotfix')) {
                    (0, $e7919529bbee736a$export$5bfe55348e7aebc1)({
                        action: 'indexDbSetRecordError',
                        attributes: {
                            recordKey: recordKey
                        }
                    });
                    return Promise.resolve({
                        atlSetItem: '',
                        id: recordKey
                    }); // return empty AtlIndexedDBItem object to exit code
                } else throw new Error('Database is not opened');
            }
            let fetchTransaction = this.db.transaction([
                this.storeName
            ]);
            let recordStore = fetchTransaction.objectStore(this.storeName);
            const fetchedRecord = new Promise((resolve, reject)=>{
                let request = recordStore.get(recordKey);
                request.onerror = this.onGetRecordErrorHandler(reject);
                request.onsuccess = this.onGetRecordSuccessHandler(request, resolve);
            });
            return fetchedRecord;
        } catch (e) {
            (0, $d1a5ba6794b83ea4$export$efa9a398d6368992).error(`Error fetching record from database. ${e.message || ''}`);
            throw e;
        }
    }
    async setRecord(recordKey) {
        try {
            if (!this.isBooted) await this.boot();
            if (!this.db) {
                if ((0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_set_necessary_storage_item_error_hotfix')) {
                    (0, $e7919529bbee736a$export$5bfe55348e7aebc1)({
                        action: 'indexDbSetRecordError',
                        attributes: {
                            recordKey: recordKey
                        }
                    });
                    Promise.resolve(); // return void promise to exit code and not pass a null record
                } else throw new Error('Database is not opened');
            }
            const setRecord = new Promise((resolve, reject)=>{
                let setTransaction = this.db.transaction([
                    this.storeName
                ], 'readwrite');
                let objectStore = setTransaction.objectStore(this.storeName);
                const newAtlRecord = {
                    atlSetItem: 'SET-BY-PACKAGE',
                    id: recordKey
                };
                let request = objectStore.put(newAtlRecord);
                request.onerror = this.onSetRecordErrorHandler(reject);
                request.onsuccess = this.onSetRecordSuccessHandler(resolve);
            });
            return setRecord;
        } catch (e) {
            (0, $d1a5ba6794b83ea4$export$efa9a398d6368992).warn(`Error setting record in database. ${e.message || ''}`);
            throw e;
        }
    }
    constructor(dbName, storeName){
        this.dbName = void 0;
        this.storeName = void 0;
        this.bootUpPromiseCache = void 0;
        this.db = null;
        this.isBooted = false;
        this.isAvailable = false;
        this.onConnectionErrorHandler = (reject)=>(event)=>{
                (0, $d1a5ba6794b83ea4$export$efa9a398d6368992).warn('Error opening database.');
                reject(event);
            };
        this.onConnectionSuccessHandler = (connection, resolve)=>()=>{
                this.db = connection.result;
                resolve();
            };
        this.onConnectionUpgradeNeededHandler = (request)=>()=>{
                this.db = request.result;
                this.db.createObjectStore(this.storeName, {
                    keyPath: 'id'
                });
            };
        this.onGetRecordErrorHandler = (reject)=>()=>{
                const getErrorMessage = `Failed to perform a get transaction on IndexedDB: ${this.dbName} + ${this.storeName}`;
                (0, $d1a5ba6794b83ea4$export$efa9a398d6368992).warn(getErrorMessage);
                reject(getErrorMessage);
            };
        this.onGetRecordSuccessHandler = (getRequest, resolve)=>()=>{
                resolve(getRequest.result);
            };
        this.onSetRecordErrorHandler = (reject)=>()=>{
                const errorMessage = `Failed to perform a set transaction on IndexedDB: ${this.dbName} + ${this.storeName}`;
                (0, $d1a5ba6794b83ea4$export$efa9a398d6368992).warn(errorMessage);
                reject(errorMessage);
            };
        this.onSetRecordSuccessHandler = (resolve)=>()=>{
                resolve();
            };
        this.dbName = dbName;
        this.storeName = storeName;
        this.isAvailable = this.getIsDBAvailable();
        this.isBooted = false;
        this.bootUpPromiseCache = null;
    }
}
const $839bb944f3bf2243$export$36328b3bcbe4623a = new $839bb944f3bf2243$export$fde2a4e0e57f47e('BSCIndexedDB', 'InternalStorageKeys');


var $015d452935a78a4a$export$259e3a861f28589b = /*#__PURE__*/ function(WebStorageType) {
    WebStorageType["LocalStorage"] = "LocalStorage";
    WebStorageType["SessionStorage"] = "SessionStorage";
    return WebStorageType;
}({});




const $9c73f4efe3395197$export$e612bb1301d659de = (itemKey, storageType, browserStorage)=>{
    const eventAttributes = {
        itemKey: itemKey,
        storageType: storageType
    };
    try {
        (0, $e7919529bbee736a$export$5bfe55348e7aebc1)({
            action: 'usedAtlBrowserStorageGetItem',
            attributes: eventAttributes
        });
        return browserStorage.getItem(itemKey);
    } catch (e) {
        (0, $d1a5ba6794b83ea4$export$efa9a398d6368992).errorWithOperationalEvent({
            action: 'usedAtlBrowserStorageGetItemError',
            attributes: eventAttributes,
            message: `Failed to get ${storageType} item. ${e.message || ''}`
        });
        return null;
    }
};


// eslint-disable-next-line @atlassian/tangerine/import/no-restricted-paths


const $7d0d5423d75c6245$export$10d7db8e1a856fd8 = 'atl-gdpr-consent';
const $7d0d5423d75c6245$export$435de28e5b000487 = 'atl-bsc-consent-token';
const $7d0d5423d75c6245$export$4b17acc0e875ba2a = 'atl-bsc-show-banner';
const $7d0d5423d75c6245$export$f57af01b64fc97b8 = 'atl-bsc-current-locale';
const $7d0d5423d75c6245$export$23a1e02c3c0b0d08 = 'atl-bsc-consent-token-fallback';
const $7d0d5423d75c6245$export$37073d560ecebada = 'atl-testing-consents';
const $7d0d5423d75c6245$export$5dc0026db06844f3 = 'atl-bsc-banner-dismissed-time';
const $7d0d5423d75c6245$export$b28b5d760fe14a21 = {
    [(0, $529b326958d1af20$export$ba064dbfe4bb66d7).StrictlyNecessary]: true,
    [(0, $529b326958d1af20$export$ba064dbfe4bb66d7).Functional]: true,
    [(0, $529b326958d1af20$export$ba064dbfe4bb66d7).Marketing]: true,
    [(0, $529b326958d1af20$export$ba064dbfe4bb66d7).Analytics]: true,
    [(0, $529b326958d1af20$export$ba064dbfe4bb66d7).Unknown]: true // Includes uncategorized cookies
};
const $7d0d5423d75c6245$export$4a12f9e99971760a = {
    [(0, $529b326958d1af20$export$ba064dbfe4bb66d7).StrictlyNecessary]: true,
    [(0, $529b326958d1af20$export$ba064dbfe4bb66d7).Functional]: false,
    [(0, $529b326958d1af20$export$ba064dbfe4bb66d7).Marketing]: false,
    [(0, $529b326958d1af20$export$ba064dbfe4bb66d7).Analytics]: false,
    [(0, $529b326958d1af20$export$ba064dbfe4bb66d7).Unknown]: false
};
const $7d0d5423d75c6245$export$f0fd1d13ec1d48f2 = {
    ...$7d0d5423d75c6245$export$4a12f9e99971760a,
    [(0, $529b326958d1af20$export$fac80ad19b60e313).ConsentsAreDefault]: true,
    [(0, $529b326958d1af20$export$fac80ad19b60e313).UserIsAuthenticated]: false,
    [(0, $529b326958d1af20$export$fac80ad19b60e313).ConsentDataUnavailable]: true
};
const $7d0d5423d75c6245$export$f95182b7aa141c57 = '001';
const $7d0d5423d75c6245$export$1f25427b34f9c405 = '002';
const $7d0d5423d75c6245$export$31deaeaebce525bb = '003';




var $8jInb = parcelRequire("8jInb");



function $c9efa97df427fa13$export$4be65e66cfa2648a(key) {
    if ((0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_moonjelly_bsc_master_killswitch')) // Get the cookie without package operational events
    // when master killswitch is enabled
    return key ? (0, (/*@__PURE__*/$parcel$interopDefault($8jInb))).get(key) : (0, (/*@__PURE__*/$parcel$interopDefault($8jInb))).get();
    try {
        (0, $e7919529bbee736a$export$5bfe55348e7aebc1)({
            action: 'usedGetCookie',
            attributes: {
                cookieKey: key
            }
        });
        return key ? (0, (/*@__PURE__*/$parcel$interopDefault($8jInb))).get(key) : (0, (/*@__PURE__*/$parcel$interopDefault($8jInb))).get();
    } catch (e) {
        (0, $d1a5ba6794b83ea4$export$efa9a398d6368992).errorWithOperationalEvent({
            action: 'usedGetCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use get cookie. ${e.message || ''}`
        });
    }
}




const $57fc8b6eb5c8226e$export$b5282052fc15e1ae = (genuineConsentToken)=>{
    // The existence of this cookie will make it look like fetched ConsentHub data is missing
    // You can set it to undefined yourself/empty string, or an actual default value.
    const tokenOverride = (0, $c9efa97df427fa13$export$4be65e66cfa2648a)((0, $7d0d5423d75c6245$export$37073d560ecebada));
    // Note: Clear this cookie out of your browser when you're done testing empty data sets
    // Or you'll be stuck seeing the banner and never actually consenting on the UI
    return tokenOverride || genuineConsentToken;
};


const $cb1ce9debbfeeb15$export$929f1500428a1fc8 = (value)=>{
    return Number(value).toString();
};
const $cb1ce9debbfeeb15$export$27647458f3cf29d2 = (bitValue)=>{
    if (bitValue) return !!Number(bitValue);
};




var $8jInb = parcelRequire("8jInb");







var $e612a7d2d76ebf7e$export$31140359b1e505cf = /*#__PURE__*/ function(ConsentHubKey) {
    ConsentHubKey["StrictlyNecessary"] = "strictlyNecessaryCookies";
    ConsentHubKey["Functional"] = "functionalCookies";
    ConsentHubKey["Analytics"] = "performanceCookies";
    ConsentHubKey["Marketing"] = "targetingCookies";
    ConsentHubKey["Unknown"] = "unknownCookies";
    return ConsentHubKey;
}({});


const $94be561db6d01b0b$var$isLegacyGeoTargetingV2Token = (consentToken)=>{
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV2Schema = version === (0, $7d0d5423d75c6245$export$1f25427b34f9c405);
    return isV2Schema;
};
const $94be561db6d01b0b$var$isLegacyV1Token = (consentToken)=>{
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV1Schema = version === (0, $7d0d5423d75c6245$export$f95182b7aa141c57);
    return isV1Schema;
};
const $94be561db6d01b0b$export$42b0ca8aba2631e4 = (consentToken)=>{
    if ($94be561db6d01b0b$var$isLegacyGeoTargetingV2Token(consentToken)) {
        // If we're looking at a V2 token and they have ANY saved 'consentedUnderXX' bits,
        // we know it must be a set of valid consents instead of defaults
        const consentedUnderGDPR = consentToken[8] === '1';
        const consentedUnderCPRA = consentToken[9] === '1';
        const consentedUnderLGPD = consentToken[10] === '1';
        const consentedUnderFADP = consentToken[11] === '1';
        const hasConsentedPreviously = consentedUnderGDPR || consentedUnderCPRA || consentedUnderLGPD || consentedUnderFADP;
        return hasConsentedPreviously;
    }
    return false;
};
const $94be561db6d01b0b$export$497a647f0eb30ef4 = (consentToken)=>{
    const isLegacyV1ConsentToken = $94be561db6d01b0b$var$isLegacyV1Token(consentToken);
    const isLegacyV2ConsentToken = $94be561db6d01b0b$var$isLegacyGeoTargetingV2Token(consentToken);
    if (isLegacyV1ConsentToken) // We only add a legacy `atl-gdpr-consents` cookie if a user has consented,
    // so if we see a V1 token, we know it must be a set of valid consents
    // instead of default consents
    return false;
    if (isLegacyV2ConsentToken) {
        const legacyTokenHasConsents = $94be561db6d01b0b$export$42b0ca8aba2631e4(consentToken);
        return !legacyTokenHasConsents;
    }
    // Check 'isDefaultConsentBit' bit for V003 Schema tokens
    const isDefaultTokenV3 = (0, $cb1ce9debbfeeb15$export$27647458f3cf29d2)(consentToken[7]);
    return isDefaultTokenV3;
};
const $94be561db6d01b0b$export$c42e1a74e60f4d73 = (consentsUnavailable)=>{
    const version = (0, $7d0d5423d75c6245$export$31deaeaebce525bb);
    // DEFAULT_PREFERENCES now has the default boolean baked into it, so we don't need to set it here
    const serializedBits = Object.entries((0, $7d0d5423d75c6245$export$f0fd1d13ec1d48f2)).reduce((acc, [key, val])=>{
        // Skip the STRICTLY_NECESSARY as it's always allowed
        if (key === (0, $529b326958d1af20$export$ba064dbfe4bb66d7).StrictlyNecessary) return acc;
        if (key === (0, $529b326958d1af20$export$fac80ad19b60e313).UserIsAuthenticated) {
            // If consents are missing when setting these defaults, the user will be logged out,
            // so pack this info into the consent token bits
            const userIsAuthed = !consentsUnavailable;
            return acc + (0, $cb1ce9debbfeeb15$export$929f1500428a1fc8)(userIsAuthed);
        }
        if (key === (0, $529b326958d1af20$export$fac80ad19b60e313).ConsentDataUnavailable) // If consents are missing when setting these defaults, the user will be logged out,
        // so pack this info into the consent token bits
        return acc + (0, $cb1ce9debbfeeb15$export$929f1500428a1fc8)(!!consentsUnavailable);
        return acc + (0, $cb1ce9debbfeeb15$export$929f1500428a1fc8)(val);
    }, '');
    return `${version}${serializedBits}`;
};
const $94be561db6d01b0b$export$42a0b3fb1e53e7b9 = (consents)=>{
    const version = (0, $7d0d5423d75c6245$export$31deaeaebce525bb);
    // As 'strictlyNecessaryConsent' would always be allowed, we don't store it in the cookie or use ConsentHub
    const functionalConsent = (0, $cb1ce9debbfeeb15$export$929f1500428a1fc8)(!!consents.find((key)=>key.key === (0, $e612a7d2d76ebf7e$export$31140359b1e505cf).Functional)?.granted);
    const analyticsConsent = (0, $cb1ce9debbfeeb15$export$929f1500428a1fc8)(!!consents.find((key)=>key.key === (0, $e612a7d2d76ebf7e$export$31140359b1e505cf).Analytics)?.granted);
    const marketingConsent = (0, $cb1ce9debbfeeb15$export$929f1500428a1fc8)(!!consents.find((key)=>key.key === (0, $e612a7d2d76ebf7e$export$31140359b1e505cf).Marketing)?.granted);
    const unknownConsent = (0, $cb1ce9debbfeeb15$export$929f1500428a1fc8)(!!consents.find((key)=>key.key === (0, $e612a7d2d76ebf7e$export$31140359b1e505cf).Unknown)?.granted);
    // As these consents were returned from the server, ConsentHub is obviously available, they're logged in, and aren't defaults
    const isDefaultToken = 0;
    const userIsAuthenticated = 1;
    const consentHubDataUnavailable = 0;
    return [
        version,
        functionalConsent,
        analyticsConsent,
        marketingConsent,
        unknownConsent,
        isDefaultToken,
        userIsAuthenticated,
        consentHubDataUnavailable
    ].join('');
};
const $94be561db6d01b0b$export$92ba0b2fe50f90df = ({ consents: consents })=>{
    if (!consents) {
        // When generating consents for an unauthenticated user, use the fallback token if it exists
        // This circumvents us setting defaults for them if their token has expired, but they have consented previously
        const existingFallbackToken = (0, $c9efa97df427fa13$export$4be65e66cfa2648a)((0, $7d0d5423d75c6245$export$23a1e02c3c0b0d08));
        if (existingFallbackToken) return existingFallbackToken;
        // User is unauthed, will only use local consenting, consent data will also be unavailable
        return $94be561db6d01b0b$export$c42e1a74e60f4d73(true); // e.g. 0030000101
    } else if (consents.length === 0) // User is authed but has no consents in the system, so use defaults in the interim, consentData must be available
    return $94be561db6d01b0b$export$c42e1a74e60f4d73(); // e.g. 0030000110
    else // User is authed and has consents in the system
    return $94be561db6d01b0b$export$42a0b3fb1e53e7b9(consents); // e.g. 0030110110
};
const $94be561db6d01b0b$export$bfa0c91662787fb0 = (unpackedUserPreferences, displayedTextMap)=>{
    const validConsentHubCookieConsents = [
        (0, $529b326958d1af20$export$ba064dbfe4bb66d7).StrictlyNecessary,
        (0, $529b326958d1af20$export$ba064dbfe4bb66d7).Functional,
        (0, $529b326958d1af20$export$ba064dbfe4bb66d7).Analytics,
        (0, $529b326958d1af20$export$ba064dbfe4bb66d7).Marketing,
        (0, $529b326958d1af20$export$ba064dbfe4bb66d7).Unknown
    ];
    const consentKeyMap = {
        [(0, $529b326958d1af20$export$ba064dbfe4bb66d7).StrictlyNecessary]: (0, $e612a7d2d76ebf7e$export$31140359b1e505cf).StrictlyNecessary,
        [(0, $529b326958d1af20$export$ba064dbfe4bb66d7).Functional]: (0, $e612a7d2d76ebf7e$export$31140359b1e505cf).Functional,
        [(0, $529b326958d1af20$export$ba064dbfe4bb66d7).Analytics]: (0, $e612a7d2d76ebf7e$export$31140359b1e505cf).Analytics,
        [(0, $529b326958d1af20$export$ba064dbfe4bb66d7).Marketing]: (0, $e612a7d2d76ebf7e$export$31140359b1e505cf).Marketing,
        [(0, $529b326958d1af20$export$ba064dbfe4bb66d7).Unknown]: (0, $e612a7d2d76ebf7e$export$31140359b1e505cf).Unknown
    };
    const consentRecords = validConsentHubCookieConsents.map((consentKey)=>{
        const key = consentKeyMap[consentKey];
        return {
            key: key,
            granted: !!unpackedUserPreferences[consentKey],
            gatheredTs: new Date().toISOString(),
            displayedText: displayedTextMap[consentKey]
        };
    });
    return consentRecords;
};
const $94be561db6d01b0b$export$13e4cff933f26b03 = ({ consents: consents })=>{
    if (consents && consents.length) {
        // As consents can be updated individually, we need to find the most recent timestamp to use as "most recent consent"
        const timestamps = consents.map((consent)=>{
            return new Date(consent.updatedTs).getTime();
        });
        const maxTimestamp = Math.max(...timestamps);
        const mostRecentConsentTimestamp = new Date(maxTimestamp).toISOString();
        return mostRecentConsentTimestamp;
    }
};
const $94be561db6d01b0b$export$3387347b75450ae1 = (consentTimestamp)=>{
    // Privacy has determined that we should re-prompt users for consent if they haven't
    // consented in over a year regardless, because they're legally stale/expired
    let consentedOverAYearAgo = false;
    if (consentTimestamp) {
        const oneYearAgo = new Date();
        oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
        consentedOverAYearAgo = new Date(consentTimestamp) < oneYearAgo;
    }
    return consentedOverAYearAgo;
};
const $94be561db6d01b0b$export$7133f415a79804e8 = (preferences)=>{
    if (!preferences) return false;
    const prefetchedToken = 'consentToken' in preferences && preferences.consentToken;
    const prefetchedTokenIsDefault = $94be561db6d01b0b$export$497a647f0eb30ef4(prefetchedToken || '');
    const hasLegitConsentToken = prefetchedToken && !prefetchedTokenIsDefault;
    const prefetchedConsents = 'consents' in preferences && preferences.consents;
    const hasLegitConsents = prefetchedConsents && Array.isArray(prefetchedConsents) && prefetchedConsents.length > 0;
    return Boolean(hasLegitConsentToken || hasLegitConsents);
};
class $94be561db6d01b0b$export$a79c0ea3d7c2444a extends Error {
    constructor(message, status){
        super(message);
        this.status = void 0;
        this.status = status;
        Object.setPrototypeOf(this, $94be561db6d01b0b$export$a79c0ea3d7c2444a.prototype);
        // Captures the stack trace (for environments that support it)
        if (Error.captureStackTrace) Error.captureStackTrace(this, $94be561db6d01b0b$export$a79c0ea3d7c2444a);
        this.name = 'StatusCodeError';
    }
}








const $a63d362682bf1834$export$64b31470e8522819 = (consentToken)=>{
    // A token can technically be bad data (alphanumeric instead of binary) but we should fail gracefully if so
    if (consentToken.length < 3) // Wrong format, no version
    return {
        isValid: false,
        isV001: false,
        isV002: false,
        isV003: false
    };
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV001 = version === (0, $7d0d5423d75c6245$export$f95182b7aa141c57) && consentToken.length === 7;
    const isV002 = version === (0, $7d0d5423d75c6245$export$1f25427b34f9c405) && consentToken.length === 12;
    const isV003 = version === (0, $7d0d5423d75c6245$export$31deaeaebce525bb) && consentToken.length === 10;
    // We support version 001, 002, 003 only
    const isSupportedVersion = [
        (0, $7d0d5423d75c6245$export$f95182b7aa141c57),
        (0, $7d0d5423d75c6245$export$1f25427b34f9c405),
        (0, $7d0d5423d75c6245$export$31deaeaebce525bb)
    ].includes(version);
    const isValid = isSupportedVersion && (isV001 || isV002 || isV003);
    return {
        isValid: isValid,
        isV001: isV001,
        isV002: isV002,
        isV003: isV003
    };
};
/* Schema Version 001:
---------------------------------------------------
  - Format 0000000
  - 001 (schema version 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies disabled/enabled)
*/ const $a63d362682bf1834$var$packPrefsVersion001 = (userPreferences)=>{
    const version = (0, $7d0d5423d75c6245$export$f95182b7aa141c57);
    return [
        version,
        (0, $cb1ce9debbfeeb15$export$929f1500428a1fc8)(userPreferences.FUNCTIONAL),
        (0, $cb1ce9debbfeeb15$export$929f1500428a1fc8)(userPreferences.ANALYTICS),
        (0, $cb1ce9debbfeeb15$export$929f1500428a1fc8)(userPreferences.MARKETING),
        (0, $cb1ce9debbfeeb15$export$929f1500428a1fc8)(userPreferences.UNKNOWN)
    ].join('');
};
const $a63d362682bf1834$var$unpackPrefsVersion001 = (userPreferencesCookie)=>{
    if (userPreferencesCookie.length !== 7) // Wrong length for version 001
    return;
    return {
        [(0, $529b326958d1af20$export$ba064dbfe4bb66d7).StrictlyNecessary]: true,
        [(0, $529b326958d1af20$export$ba064dbfe4bb66d7).Functional]: userPreferencesCookie[3] === '1',
        [(0, $529b326958d1af20$export$ba064dbfe4bb66d7).Analytics]: userPreferencesCookie[4] === '1',
        [(0, $529b326958d1af20$export$ba064dbfe4bb66d7).Marketing]: userPreferencesCookie[5] === '1',
        [(0, $529b326958d1af20$export$ba064dbfe4bb66d7).Unknown]: userPreferencesCookie[6] === '1'
    };
};
/* Schema Version 002 ***** DEPRECATED *****
---------------------------------------------------
  - Format 000000000000
  - 002 (schema version, 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies - disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies - disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies - disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies - disabled/enabled)
  - 0/1 (1 digit, consent records are unavailable from ConsentHub (logged out) - yes/no)
  - 0/1 (1 digit, consents saved while in GDPR locale (Europe) - yes/no)
  - 0/1 (1 digit, consents saved while in CPRA locale (CPRA will act as 'all USA' bucket) - yes/no)
  - 0/1 (1 digit, consents saved while in LGPD locale (Brazil) - yes/no)
  - 0/1 (1 digit, consents saved while in FADP locale (Switzerland) - yes/no)
*/ const $a63d362682bf1834$var$packPrefsVersion002 = (userPreferences)=>{
    // As we want to slowly kill off any V002 preferences, if we're provided one for some reason
    // internally convert it to a V003 preference to drop contextual GeoIP details
    const version = (0, $7d0d5423d75c6245$export$31deaeaebce525bb);
    const hasConsentedPreviously = userPreferences[(0, $529b326958d1af20$export$cdef20bac194f235).ConsentedUnderGDPR] || userPreferences[(0, $529b326958d1af20$export$cdef20bac194f235).ConsentedUnderCPRA] || userPreferences[(0, $529b326958d1af20$export$cdef20bac194f235).ConsentedUnderLGPD] || userPreferences[(0, $529b326958d1af20$export$cdef20bac194f235).ConsentedUnderFADP];
    const isDefaultConsentBit = !hasConsentedPreviously;
    // As we've broken out authentication insights/context from "ConsentDataUnavailable" bit in V3,
    // and it does not exist, we will backfill the value based on the previous bit state
    const existingConsentDataUnavailableBit = userPreferences[(0, $529b326958d1af20$export$fac80ad19b60e313).ConsentDataUnavailable];
    const userIsAuthenticatedBit = !existingConsentDataUnavailableBit;
    return [
        version,
        (0, $cb1ce9debbfeeb15$export$929f1500428a1fc8)(userPreferences[(0, $529b326958d1af20$export$ba064dbfe4bb66d7).Functional]),
        (0, $cb1ce9debbfeeb15$export$929f1500428a1fc8)(userPreferences[(0, $529b326958d1af20$export$ba064dbfe4bb66d7).Analytics]),
        (0, $cb1ce9debbfeeb15$export$929f1500428a1fc8)(userPreferences[(0, $529b326958d1af20$export$ba064dbfe4bb66d7).Marketing]),
        (0, $cb1ce9debbfeeb15$export$929f1500428a1fc8)(userPreferences[(0, $529b326958d1af20$export$ba064dbfe4bb66d7).Unknown]),
        (0, $cb1ce9debbfeeb15$export$929f1500428a1fc8)(isDefaultConsentBit),
        (0, $cb1ce9debbfeeb15$export$929f1500428a1fc8)(userIsAuthenticatedBit),
        (0, $cb1ce9debbfeeb15$export$929f1500428a1fc8)(existingConsentDataUnavailableBit)
    ].join('');
};
const $a63d362682bf1834$var$unpackPrefsVersion002 = (userPreferencesCookie)=>{
    // If the provided V002 token has consented anywhere, we'll drop the contextual GeoIP bits and
    // convert it to a V003 schema
    const isADefaultConsentToken = (0, $94be561db6d01b0b$export$497a647f0eb30ef4)(userPreferencesCookie);
    // Backfill the value based on the previous "ConsentDataUnavailable" bit state as we've broken this contextual info out
    const consentDataUnavailable = userPreferencesCookie[7] === '1';
    const userIsDeemedAuthenticated = !consentDataUnavailable;
    return {
        ...$a63d362682bf1834$var$unpackPrefsVersion003(userPreferencesCookie),
        [(0, $529b326958d1af20$export$fac80ad19b60e313).ConsentsAreDefault]: !!isADefaultConsentToken,
        [(0, $529b326958d1af20$export$fac80ad19b60e313).UserIsAuthenticated]: userIsDeemedAuthenticated,
        [(0, $529b326958d1af20$export$fac80ad19b60e313).ConsentDataUnavailable]: consentDataUnavailable
    };
};
/* Schema Version 003
---------------------------------------------------
  - Format 0000000000
  - 003 (schema version, 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies - disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies - disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies - disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies - disabled/enabled)
  - 0/1 (1 digit, Consent token in a default state, user has yet to consent) - no/yes)
  - 0/1 (1 digit, User is authenticated, did not 401 during save) - no/yes)
  - 0/1 (1 digit, ConsentHub records are unavailable (CH is down, errored while saving, etc) - no/yes)
*/ const $a63d362682bf1834$var$packPrefsVersion003 = (userPreferences)=>{
    const version = (0, $7d0d5423d75c6245$export$31deaeaebce525bb);
    return [
        version,
        (0, $cb1ce9debbfeeb15$export$929f1500428a1fc8)(userPreferences[(0, $529b326958d1af20$export$ba064dbfe4bb66d7).Functional]),
        (0, $cb1ce9debbfeeb15$export$929f1500428a1fc8)(userPreferences[(0, $529b326958d1af20$export$ba064dbfe4bb66d7).Analytics]),
        (0, $cb1ce9debbfeeb15$export$929f1500428a1fc8)(userPreferences[(0, $529b326958d1af20$export$ba064dbfe4bb66d7).Marketing]),
        (0, $cb1ce9debbfeeb15$export$929f1500428a1fc8)(userPreferences[(0, $529b326958d1af20$export$ba064dbfe4bb66d7).Unknown]),
        (0, $cb1ce9debbfeeb15$export$929f1500428a1fc8)(userPreferences[(0, $529b326958d1af20$export$fac80ad19b60e313).ConsentsAreDefault]),
        (0, $cb1ce9debbfeeb15$export$929f1500428a1fc8)(userPreferences[(0, $529b326958d1af20$export$fac80ad19b60e313).UserIsAuthenticated]),
        (0, $cb1ce9debbfeeb15$export$929f1500428a1fc8)(userPreferences[(0, $529b326958d1af20$export$fac80ad19b60e313).ConsentDataUnavailable])
    ].join('');
};
const $a63d362682bf1834$var$unpackPrefsVersion003 = (userPreferencesCookie)=>{
    return {
        [(0, $529b326958d1af20$export$ba064dbfe4bb66d7).StrictlyNecessary]: true,
        [(0, $529b326958d1af20$export$ba064dbfe4bb66d7).Functional]: userPreferencesCookie[3] === '1',
        [(0, $529b326958d1af20$export$ba064dbfe4bb66d7).Analytics]: userPreferencesCookie[4] === '1',
        [(0, $529b326958d1af20$export$ba064dbfe4bb66d7).Marketing]: userPreferencesCookie[5] === '1',
        [(0, $529b326958d1af20$export$ba064dbfe4bb66d7).Unknown]: userPreferencesCookie[6] === '1',
        [(0, $529b326958d1af20$export$fac80ad19b60e313).ConsentsAreDefault]: userPreferencesCookie[7] === '1',
        [(0, $529b326958d1af20$export$fac80ad19b60e313).UserIsAuthenticated]: userPreferencesCookie[8] === '1',
        [(0, $529b326958d1af20$export$fac80ad19b60e313).ConsentDataUnavailable]: userPreferencesCookie[9] === '1'
    };
};
const $a63d362682bf1834$var$V002SpecificBitKeys = [
    (0, $529b326958d1af20$export$fac80ad19b60e313).ConsentDataUnavailable,
    (0, $529b326958d1af20$export$cdef20bac194f235).ConsentedUnderGDPR,
    (0, $529b326958d1af20$export$cdef20bac194f235).ConsentedUnderCPRA,
    (0, $529b326958d1af20$export$cdef20bac194f235).ConsentedUnderLGPD,
    (0, $529b326958d1af20$export$cdef20bac194f235).ConsentedUnderFADP
];
const $a63d362682bf1834$var$V003SpecificBitKeys = [
    (0, $529b326958d1af20$export$fac80ad19b60e313).ConsentsAreDefault,
    (0, $529b326958d1af20$export$fac80ad19b60e313).UserIsAuthenticated,
    (0, $529b326958d1af20$export$fac80ad19b60e313).ConsentDataUnavailable
];
function $a63d362682bf1834$export$3199823fec979bd1(userPreferences) {
    if ((0, $e15ac9c6b48eae37$export$3b78a1ea01f5ec28)().localConsentMode) return $a63d362682bf1834$var$packPrefsVersion001(userPreferences);
    const isV002 = $a63d362682bf1834$var$V002SpecificBitKeys.every((key)=>key in userPreferences);
    if (isV002) // As V002 is deprecated, if we've been provided V002 set of "legacy" prefs, internally
    // convert them to V003 to drop the unnecessary contextual details
    return $a63d362682bf1834$var$packPrefsVersion002(userPreferences);
    const isV003 = $a63d362682bf1834$var$V003SpecificBitKeys.every((key)=>key in userPreferences);
    if (isV003) return $a63d362682bf1834$var$packPrefsVersion003(userPreferences);
    // Fallback to V001
    return $a63d362682bf1834$var$packPrefsVersion001(userPreferences);
}
function $a63d362682bf1834$export$8d213cb390bab4fa(userPreferencesCookie) {
    if ((0, $e15ac9c6b48eae37$export$3b78a1ea01f5ec28)().localConsentMode) {
        if (userPreferencesCookie.length < 3) // Wrong format, no version
        return;
        const version = userPreferencesCookie[0] + userPreferencesCookie[1] + userPreferencesCookie[2];
        if (version === (0, $7d0d5423d75c6245$export$f95182b7aa141c57)) return $a63d362682bf1834$var$unpackPrefsVersion001(userPreferencesCookie);
        return;
    }
    const { isValid: isValid, isV001: isV001, isV002: isV002, isV003: isV003 } = $a63d362682bf1834$export$64b31470e8522819(userPreferencesCookie);
    if (!isValid) // We support version 001, 002, 003 only
    return;
    if (isV001) return $a63d362682bf1834$var$unpackPrefsVersion001(userPreferencesCookie);
    if (isV002) // Deprecated, so this will unpack to 003 to drop the contextual GeoIP bits
    return $a63d362682bf1834$var$unpackPrefsVersion002(userPreferencesCookie);
    if (isV003) return $a63d362682bf1834$var$unpackPrefsVersion003(userPreferencesCookie);
}
const $a63d362682bf1834$export$67f70eb55341bd29 = (initialPreferences)=>{
    if (!initialPreferences) return true;
    const prefExistButAreEmpty = Object.keys(initialPreferences).length === 0;
    return prefExistButAreEmpty;
};
const $a63d362682bf1834$export$7962405c3ca274b1 = (initialPreferences)=>{
    if (initialPreferences !== (0, $529b326958d1af20$export$5d6594a0bba4ab8a).INTERNAL) {
        if ($a63d362682bf1834$export$67f70eb55341bd29(initialPreferences)) // Failsafe handling: Consumer failed to provide data even though they have prefetched, so we need to fetch again
        // This may occur if a consumer's prefetch requests fails, or if they fail to implement the system correctly
        return {
            prefs: undefined,
            isPrefetchedPrefsInternalState: true
        };
        // If initialPreferences is not INTERNAL on first render, we have been provided a pre-fetched
        // value, which means we don't need to make a fetch to storage or ConsentHub to get it.
        // If that preference is defined, we persist it to our local cookie set
        // If the data is a ConsentHubResponse/PrefetchedConsentCookieData, we'll need to transform it properly before consumption
        const consentToken = initialPreferences && 'consentToken' in initialPreferences && initialPreferences.consentToken;
        if (consentToken) {
            // We already have a consent cookie that was passed in, let's not override it by setting it again
            const unpackedExistingPrefs = $a63d362682bf1834$export$8d213cb390bab4fa(consentToken);
            return {
                prefs: unpackedExistingPrefs,
                isPrefetchedPrefsInternalState: !Boolean(unpackedExistingPrefs)
            };
        }
        // This type guard protects the below casting of ConsentHubResponse ensuring we have the correct shape
        if (initialPreferences && 'consents' in initialPreferences) {
            const serializedPrefetchedConsentToken = (0, $94be561db6d01b0b$export$92ba0b2fe50f90df)(initialPreferences);
            const unpackedPrefetchedPrefs = $a63d362682bf1834$export$8d213cb390bab4fa(serializedPrefetchedConsentToken);
            return {
                prefs: unpackedPrefetchedPrefs,
                isPrefetchedPrefsInternalState: !Boolean(unpackedPrefetchedPrefs)
            };
        }
    }
    // If we've fallen into this, EMPTY implies we have no data at all
    // INTERNAL implies we still need to fetch new data, so trigger a refetch
    if (initialPreferences === (0, $529b326958d1af20$export$5d6594a0bba4ab8a).INTERNAL) return {
        prefs: undefined,
        isPrefetchedPrefsInternalState: true
    };
    return {
        prefs: undefined,
        isPrefetchedPrefsInternalState: false
    };
};


const $ffc072dc9afb827a$var$getUserIsAuthenticatedBit = (consentToken)=>{
    const { isV002: isV002 } = (0, $a63d362682bf1834$export$64b31470e8522819)(consentToken);
    let userIsAuthenticatedBit = consentToken[8]; // V3 position
    if (isV002) {
        // Schema has changed in V3, V2 had this bit in a different position. Logged out users will have this bit set to 1
        const legacyV2ConsentDataUnavailableBit = consentToken[7];
        // We can backfill the UserIsAuthenticated bit by flipping the bit value. If ConsentHub was unavailable, that means they were logged out.
        userIsAuthenticatedBit = legacyV2ConsentDataUnavailableBit === '1' ? '0' : '1';
    }
    return userIsAuthenticatedBit;
};
const $ffc072dc9afb827a$var$shouldShowBannerForLoggedOutDefaultToken = (fallbackConsentToken)=>{
    // Logged out + default consents + fallback: we have a discrepancy where ConsentHub is down/unavailable, or they're just logged out,
    // but the user has actually consented previously (which essentially the only way to save to the fallback to begin with)
    if (fallbackConsentToken) {
        const fallbackUserIsAuthenticatedBit = $ffc072dc9afb827a$var$getUserIsAuthenticatedBit(fallbackConsentToken);
        const isLoggedOutFallbackConsents = !(0, $cb1ce9debbfeeb15$export$27647458f3cf29d2)(fallbackUserIsAuthenticatedBit);
        const fallbackTokenHasGenuineConsents = !(0, $94be561db6d01b0b$export$497a647f0eb30ef4)(fallbackConsentToken);
        const localOnlyUsersHasGenuineConsents = isLoggedOutFallbackConsents && fallbackTokenHasGenuineConsents;
        // If the fallback is from a logged out consent (localOnlyConsent), they're currently
        // logged out and also saved while logged out, so don't show the banner
        if (localOnlyUsersHasGenuineConsents) return !fallbackTokenHasGenuineConsents;
        const loggedOutUserPreviouslyConsentedWhileLoggedIn = !isLoggedOutFallbackConsents && fallbackTokenHasGenuineConsents;
        if (loggedOutUserPreviouslyConsentedWhileLoggedIn) // Or if it is from a logged in consent, and they've consented somewhere (they must have)
        // then we should not show the banner, as their consents aren't "stale", we're just in a situation
        // where the original token has expired so they get a default set, but we should hide the banner
        return false;
    }
    // Defaults consents + unauthed + missing a fallback, show the banner, as they haven't consented in the past year
    return true;
};
const $ffc072dc9afb827a$var$shouldShowBannerForLoggedOutUser = ({ consentToken: consentToken, fallbackConsentToken: fallbackConsentToken })=>{
    const tokenIsADefaultConsent = !!(0, $94be561db6d01b0b$export$497a647f0eb30ef4)(consentToken);
    // Handle default token flow
    if (tokenIsADefaultConsent) return $ffc072dc9afb827a$var$shouldShowBannerForLoggedOutDefaultToken(fallbackConsentToken);
    // Handle genuine token flow
    // If they're a legacy/V2 user who hasn't consented, this will have checked the V3 "is default" bit to note they've consented or not
    const localOnlyUserHasConsented = (0, $94be561db6d01b0b$export$42b0ca8aba2631e4)(consentToken) || !tokenIsADefaultConsent;
    if (localOnlyUserHasConsented) // LocalOnly users will never have a timestamp to validate against since they can't talk to ConsentHub
    // Existence of fallback consents means they've consented in the past year and do not have stale consents, do not show banner
    return fallbackConsentToken ? false : true;
    // This case should never be hit: if it's not a default, but they haven't consented... what is it? Add a catch-all "show banner"
    return true;
};
const $ffc072dc9afb827a$var$shouldShowBannerForLoggedInDefaultToken = (fallbackConsentToken)=>{
    // Defaults + fallback + logged in, but they consented while they were previously logged out:
    if (fallbackConsentToken) {
        const fallbackUserIsAuthenticatedBit = $ffc072dc9afb827a$var$getUserIsAuthenticatedBit(fallbackConsentToken);
        const isLoggedOutFallbackConsents = !(0, $cb1ce9debbfeeb15$export$27647458f3cf29d2)(fallbackUserIsAuthenticatedBit);
        const fallbackTokenHasGenuineConsents = !(0, $94be561db6d01b0b$export$497a647f0eb30ef4)(fallbackConsentToken);
        if (fallbackTokenHasGenuineConsents) {
            // Defaults + logged in user + consented <1yr ago, but while logged out
            if (isLoggedOutFallbackConsents) /*
        They've consented, and thus stored a fallback while logged out (fallback's CH bit is 1),
        then fetched from CH but get empty data (since they couldn't save to CH on their initial "save"), which sets authed consent defaults (bit 0)

        UX Problem:
        Since they have genuinely consented within the past year, the ideal UX would be to not show the banner...
        But if we do not re-prompt here in an effort to recapture their consents, the opportunity for them/us to actually get consents in the DB
        is infrequent (either via Account Privacy Page or once this fallback expires in a year).

        Example:
        While logged out, they consent in Trello, so we store the unauthed fallback token, then log in on Trello. If we hide the banner when the
        fallback exists, if that user later goes to Confluence's cookie domain (where they have no fallback), it would show the banner
        because they have no stored consents on CH, and no fallback in that domain, but are logged in. Repeat for every new domain...

        We could be fancy and save under the hood for them if they have a fallback, but to ensure we don't copy stale/different consents saved in a fallback
        to ConsentHub on their behalf, we should just re-prompt them for consents now that they're logged in. This way, they will actually
        persist their choices, and when loading other domains/products, there will be a Source of Truth to reference and not show the banner.

        Ultimately, this feels like the more "correct" way to handle this situation, as the cost of showing the banner again to officially capture
        consents feels lower than the potential cost of relying on fallbacks in all situations/across all domains for this user for the next whole year

        Result: Show the banner again and hope we officially recapture consents this time around
      */ return true;
            // Defaults + logged in user + consented <1yr ago, but while logged in
            // This scenario shouldn't happen, or if it does, it's in a phase where we haven't fetched preferences
            // yet, so hide the banner for now
            return false;
        }
        // Default token + default fallback (authed or unauthed) mean we've likely stored this
        // fallback from SSR's initialPreferences flow in. Fallbacks should not be saved with defaults intentionally
        // But sometimes we copy an existing token to the fallback via SSR flow, so let's treat this
        // as an bunk fallback, and show the banner as they haven't consented
        return true;
    }
    // Default consent token + logged in user + no fallback = they haven't consented in the past year, show banner
    return true;
};
const $ffc072dc9afb827a$var$shouldShowBannerForLoggedInUser = ({ consentToken: consentToken, consentTimestamp: consentTimestamp, fallbackConsentToken: fallbackConsentToken })=>{
    // Handle default token flow
    const tokenIsADefaultConsent = !!(0, $94be561db6d01b0b$export$497a647f0eb30ef4)(consentToken);
    if (tokenIsADefaultConsent) return $ffc072dc9afb827a$var$shouldShowBannerForLoggedInDefaultToken(fallbackConsentToken);
    // Handle genuine token flow
    if (consentTimestamp) {
        // If the user has genuine consents, and a timestamp, check if they're stale (> 1yr old), show the banner if they're stale
        const showBannerIfStale = (0, $94be561db6d01b0b$export$3387347b75450ae1)(consentTimestamp);
        return showBannerIfStale;
    }
    // Genuine consents + no timestamp— we're in a situation where we've been passed cached cookie data instead of CH response data,
    // so the only way to determine staleness is through the absence of the fallback.
    // Technically, we could assume since they've consented recently, we don't have to show the banner here but... to be safe we should
    return fallbackConsentToken ? false : true;
};
const $ffc072dc9afb827a$export$bfdb9f82a9194c1e = ({ consentToken: consentToken, consentTimestamp: consentTimestamp, fallbackConsentToken: fallbackConsents })=>{
    // Consent tokens are either a set of defaults, or genuine (persisted to the remote, or saved in an entire local-only flow via fallbacks).
    // the deciding factor is whether or not your consents are stale/fresh, either via the existence/absence of a fallback (a.k.a consented within a year or not)
    // or if the ConsentHub response data of a user's consent has a timestamp that is older than a year
    // Detect if js-cookie has been replaced with SSR-safe version (Confluence only)
    const isJsCookieSSRSafe = typeof (0, (/*@__PURE__*/$parcel$interopDefault($8jInb))).__SSR_INITIALIZE_COOKIES__ === 'function';
    const fallbackConsentToken = (0, $6f3320f8ddad677d$export$48d7c418edadb60c)() ? fallbackConsents || (isJsCookieSSRSafe ? (0, $c9efa97df427fa13$export$4be65e66cfa2648a)((0, $7d0d5423d75c6245$export$23a1e02c3c0b0d08)) : undefined) : fallbackConsents || (0, $c9efa97df427fa13$export$4be65e66cfa2648a)((0, $7d0d5423d75c6245$export$23a1e02c3c0b0d08));
    let userIsAuthenticatedBit = $ffc072dc9afb827a$var$getUserIsAuthenticatedBit(consentToken);
    const isLoggedOutConsentToken = !(0, $cb1ce9debbfeeb15$export$27647458f3cf29d2)(userIsAuthenticatedBit);
    let isBannerVisible = true; // By default, show the banner to every user
    // Unauthed/logged out user flow, should never receive a timestamp because logged out users can't communicate to ConsentHub
    if (isLoggedOutConsentToken) isBannerVisible = $ffc072dc9afb827a$var$shouldShowBannerForLoggedOutUser({
        consentToken: consentToken,
        fallbackConsentToken: fallbackConsentToken
    });
    else // Authed/logged in user flow
    isBannerVisible = $ffc072dc9afb827a$var$shouldShowBannerForLoggedInUser({
        consentToken: consentToken,
        fallbackConsentToken: fallbackConsentToken,
        consentTimestamp: consentTimestamp
    });
    return isBannerVisible;
};



var $8jInb = parcelRequire("8jInb");



const $61ba2cc24d6edc52$export$93509ff9a62ee022 = (key, value, attributes)=>{
    if ((0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_moonjelly_bsc_master_killswitch')) // Set the cookie without package operational events
    // when master killswitch is enabled
    (0, (/*@__PURE__*/$parcel$interopDefault($8jInb))).set(key, value, {
        ...attributes,
        'atl-set-cookie': true
    });
    else try {
        (0, $e7919529bbee736a$export$5bfe55348e7aebc1)({
            action: 'usedSetStrictlyNecessaryCookie',
            attributes: {
                cookieKey: key
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($8jInb))).set(key, value, {
            ...attributes,
            'atl-set-cookie': true
        });
    } catch (e) {
        (0, $d1a5ba6794b83ea4$export$efa9a398d6368992).errorWithOperationalEvent({
            action: 'usedSetStrictlyNecessaryCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use set strictly necessary cookie. ${e.message || ''}`
        });
    }
};


const $53f427308f77ca2c$export$8e560d0760f733a2 = (consentToken)=>{
    const inTenMinutes = new Date();
    inTenMinutes.setTime(inTenMinutes.getTime() + 600000);
    (0, $61ba2cc24d6edc52$export$93509ff9a62ee022)((0, $7d0d5423d75c6245$export$435de28e5b000487), consentToken, {
        expires: inTenMinutes,
        path: '/'
    });
    (0, $d1a5ba6794b83ea4$export$efa9a398d6368992).debug(`Set Consent Token ${(0, $7d0d5423d75c6245$export$435de28e5b000487)} ${consentToken}`);
};
const $53f427308f77ca2c$export$133cd762b0f705a2 = (consentToken)=>{
    const inOneYear = new Date();
    inOneYear.setFullYear(inOneYear.getFullYear() + 1);
    (0, $61ba2cc24d6edc52$export$93509ff9a62ee022)((0, $7d0d5423d75c6245$export$23a1e02c3c0b0d08), consentToken, {
        expires: inOneYear,
        path: '/'
    });
    (0, $d1a5ba6794b83ea4$export$efa9a398d6368992).debug(`set fallback consent token: ${(0, $7d0d5423d75c6245$export$23a1e02c3c0b0d08)} ${consentToken}`);
};
const $53f427308f77ca2c$export$99ecece88c58d938 = (consentToken, consentTimestamp)=>{
    // Since we have no good way to reference this as a global state object, we want to precompute and store the
    // banner visibility in a temporary, session-scope cookie (same expiry as the other cookies), which we can
    // lookup in the UI as needed
    const bannerVisibility = (0, $ffc072dc9afb827a$export$bfdb9f82a9194c1e)({
        consentToken: consentToken,
        consentTimestamp: consentTimestamp
    });
    const shouldShowBanner = (0, $cb1ce9debbfeeb15$export$929f1500428a1fc8)(!!bannerVisibility);
    const inTenMinutes = new Date();
    inTenMinutes.setTime(inTenMinutes.getTime() + 600000);
    (0, $61ba2cc24d6edc52$export$93509ff9a62ee022)((0, $7d0d5423d75c6245$export$4b17acc0e875ba2a), shouldShowBanner, {
        expires: inTenMinutes,
        path: '/'
    });
    (0, $d1a5ba6794b83ea4$export$efa9a398d6368992).debug(`set shouldShowBannerCookie: ${(0, $7d0d5423d75c6245$export$4b17acc0e875ba2a)} ${shouldShowBanner}`);
};
const $53f427308f77ca2c$export$b3365240280cb3c3 = (consentToken, consentTimestamps)=>{
    $53f427308f77ca2c$export$8e560d0760f733a2(consentToken);
    $53f427308f77ca2c$export$99ecece88c58d938(consentToken, consentTimestamps);
};






const $c50e6d87a8bb2e8f$var$BASE_CONSENTS_URL = '/gateway/api/consenthub/session';
const $c50e6d87a8bb2e8f$var$POST_CONSENTS_URL = `${$c50e6d87a8bb2e8f$var$BASE_CONSENTS_URL}/user`;
const $c50e6d87a8bb2e8f$var$GET_CONSENTS_URL = `${$c50e6d87a8bb2e8f$var$POST_CONSENTS_URL}/consents/cookies`;
const $c50e6d87a8bb2e8f$export$bd9f5bcbf9cd947c = (consentData)=>{
    if (consentData) {
        const serializedConsents = (0, $94be561db6d01b0b$export$92ba0b2fe50f90df)(consentData);
        const consentTimestamp = (0, $94be561db6d01b0b$export$13e4cff933f26b03)(consentData);
        return {
            consentToken: serializedConsents,
            consentTimestamp: consentTimestamp
        };
    }
    // Without consent data (due to server failure or unauthenticated user), set defaults illustrating that absence
    return {
        consentToken: (0, $94be561db6d01b0b$export$92ba0b2fe50f90df)({}),
        consentHubInaccessible: true
    };
};
const $c50e6d87a8bb2e8f$export$86467566615ab85e = async ()=>{
    const { origin: origin } = window.location;
    const getFromConsentHubURL = `${origin}${$c50e6d87a8bb2e8f$var$GET_CONSENTS_URL}`;
    try {
        const response = await fetch(getFromConsentHubURL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (!response.ok) throw new Error(`Failed to fetch preferences from ConsentHub with status: ${response.status}`);
        const consentData = await response.json();
        return $c50e6d87a8bb2e8f$export$bd9f5bcbf9cd947c(consentData);
    } catch (err) {
        (0, $d1a5ba6794b83ea4$export$efa9a398d6368992).errorWithOperationalEvent({
            action: 'fetchConsentPreferencesError',
            message: err.message || ''
        });
        return $c50e6d87a8bb2e8f$export$bd9f5bcbf9cd947c();
    }
};
const $c50e6d87a8bb2e8f$var$buildConsentRequestBody = (unpackedUserPreferences, displayedTextMap)=>{
    const { origin: origin, pathname: pathname } = window.location;
    const deserializedConsents = (0, $94be561db6d01b0b$export$bfa0c91662787fb0)(unpackedUserPreferences, displayedTextMap);
    // Type guard here so TS knows we're working with ConsentPreferenceV003
    const action = 'CONSENT_DATA_UNAVAILABLE' in unpackedUserPreferences && unpackedUserPreferences.CONSENT_DATA_UNAVAILABLE ? 'FORM_FILL' : 'UPDATE_PREFERENCES';
    const consentRequestBody = {
        action: action,
        consents: deserializedConsents,
        formUrl: `${origin}${pathname}`,
        locale: 'UNKNOWN',
        site: 'atlassian',
        source: 'COOKIE_PREFERENCES'
    };
    return JSON.stringify(consentRequestBody);
};
const $c50e6d87a8bb2e8f$export$f8422650c3dec8b2 = async (unpackedUserPreferences, displayedTextMap)=>{
    const saveToConsentHubURL = `${window.location.origin}${$c50e6d87a8bb2e8f$var$POST_CONSENTS_URL}`;
    try {
        const response = await fetch(saveToConsentHubURL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: $c50e6d87a8bb2e8f$var$buildConsentRequestBody(unpackedUserPreferences, displayedTextMap)
        });
        // Saving is an async API (we don't know if the save succeeds) so returns 202 Accepted.
        // 401 = User is unauthenticated
        // 5xx = ConsentHub is unavailable
        if (!response.ok || response.status !== 202 && response.status !== 200) {
            const errMsg = `Failed to save preferences to ConsentHub with status: ${response.status}`;
            const errWithStatusCode = new (0, $94be561db6d01b0b$export$a79c0ea3d7c2444a)(errMsg, response.status);
            throw errWithStatusCode;
        }
    } catch (err) {
        (0, $d1a5ba6794b83ea4$export$efa9a398d6368992).errorWithOperationalEvent({
            action: 'saveConsentPreferencesError',
            message: err.message || ''
        });
        // Re-throw to any encapsulating logic, a la `setConsentToken()`
        throw err;
    }
};



const $088a3ca8ff55be32$export$c515de1cc9cebc71 = async (fallbackConsentToken)=>{
    // Fetches preferences from ConsentHub and returns serialized token data if possible
    const consentData = await (0, $c50e6d87a8bb2e8f$export$86467566615ab85e)();
    let { consentToken: consentToken, consentTimestamp: consentTimestamp, consentHubInaccessible: consentHubInaccessible } = consentData;
    let { isValid: isValid } = (0, $a63d362682bf1834$export$64b31470e8522819)(consentToken);
    if (isValid && consentHubInaccessible) {
        if (fallbackConsentToken) // `consentHubInaccessible`: ConsentHub request failed (e.g. service is down/bad request/etc). Attempt to use
        // any previously set consents in the interim if we have them.
        consentToken = fallbackConsentToken;
        else if ((0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_moonjelly_bsc_fallback_token_audit')) {
            const version = (0, $7d0d5423d75c6245$export$31deaeaebce525bb);
            const consents = consentToken.slice(3, 7);
            // V003 BSC bits set to reflect default consent token status, authenticated user status,
            // and unavailable consentHub records status)
            const serviceBits = '111';
            // Temporary: Sets a default token with V003 properties
            // when ConsentHub is inaccessible and there is not fallback token. This
            // will ensure the banner isn't shown when ConsentHub is down.
            consentToken = `${version}${consents}${serviceBits}`;
        } else // Temporary: Sets the default token to have true consentedUnderXXXX bits
        // when ConsentHub is inaccessible and there is not fallback token. This
        // will ensure the banner isn't shown when ConsentHub is down.
        consentToken = `${consentToken.slice(0, 8)}1111`;
    }
    return isValid ? {
        consentToken: consentToken,
        consentTimestamp: consentTimestamp
    } : undefined;
};


const $bbb3ce32b8916955$export$f1b8f2ca713fca08 = async ()=>{
    const fallbackConsentToken = (0, $c9efa97df427fa13$export$4be65e66cfa2648a)((0, $7d0d5423d75c6245$export$23a1e02c3c0b0d08));
    const consentData = await (0, $088a3ca8ff55be32$export$c515de1cc9cebc71)(fallbackConsentToken);
    if (consentData) {
        const { consentToken: consentToken, consentTimestamp: consentTimestamp } = consentData;
        /*** TESTING OVERRIDES ***/ const potentiallyOverriddenConsentToken = (0, $57fc8b6eb5c8226e$export$b5282052fc15e1ae)(consentToken);
        const testingConsentOverride = (0, $c9efa97df427fa13$export$4be65e66cfa2648a)((0, $7d0d5423d75c6245$export$37073d560ecebada));
        const hasTestingConsents = !!(testingConsentOverride || testingConsentOverride === '');
        if (hasTestingConsents) {
            // If testing, set the cookies accordingly so we can test with any overridden token data.
            (0, $53f427308f77ca2c$export$99ecece88c58d938)(potentiallyOverriddenConsentToken);
            (0, $53f427308f77ca2c$export$8e560d0760f733a2)(potentiallyOverriddenConsentToken);
            // Unfortunately, if you've previously saved to ConsentHub, that data will always resolve, so to simulate ConsentHub
            // being down, or the token data being bunk/invalid, we must set the testing token to an empty string. This will
            // return undefined here and skip any unpacking of the token. Otherwise, it will use the overridden token value.
            return potentiallyOverriddenConsentToken === '' ? undefined : potentiallyOverriddenConsentToken;
        }
        // At this point, all data should be valid and overridden for testing as needed, so set those cookies!
        (0, $53f427308f77ca2c$export$b3365240280cb3c3)(potentiallyOverriddenConsentToken, consentTimestamp);
        return consentToken;
    }
    return undefined;
};




async function $e2892338578089b5$export$1de6a888ae076ff8() {
    // when localConsentMode is on, don't make calls to ConsentHub
    if ((0, $e15ac9c6b48eae37$export$3b78a1ea01f5ec28)().localConsentMode) {
        const packedPrefs = (0, $c9efa97df427fa13$export$4be65e66cfa2648a)((0, $7d0d5423d75c6245$export$10d7db8e1a856fd8));
        if (!packedPrefs) return undefined;
        return (0, $a63d362682bf1834$export$8d213cb390bab4fa)(packedPrefs);
    } else {
        let packedLocalPrefs = (0, $c9efa97df427fa13$export$4be65e66cfa2648a)((0, $7d0d5423d75c6245$export$435de28e5b000487));
        if (!packedLocalPrefs) {
            const consentToken = await (0, $bbb3ce32b8916955$export$f1b8f2ca713fca08)();
            if ((0, $6f3320f8ddad677d$export$48d7c418edadb60c)() && consentToken) window.__COOKIE_CONSENT_PREFERENCES__ = Object.assign(window.__COOKIE_CONSENT_PREFERENCES__ || {}, {
                consentToken: consentToken
            });
            return consentToken ? (0, $a63d362682bf1834$export$8d213cb390bab4fa)(consentToken) : undefined;
        }
        return (0, $a63d362682bf1834$export$8d213cb390bab4fa)(packedLocalPrefs);
    }
}




const $142e2464d1092f3f$export$2c141b1c00f3e482 = (itemKey, startsWith)=>{
    // Setup initial pattern step and position
    let currentStep = startsWith;
    let position = 0;
    // Iterate through item key symbol by symbol
    while(position < itemKey.length){
        // The value of item character at the position
        const currentStepValue = currentStep[itemKey[position]];
        // If there is no match for item symbol in cache, this means there is no
        // pattern match for the item key
        if (currentStepValue === undefined) return null;
        // If current step value is a number, this means we reached the end of the pattern
        // and should return category number
        if (typeof currentStepValue === 'number') return currentStepValue;
        // Continue to going through pattern
        currentStep = currentStepValue;
        position++;
    }
    // No pattern match - all patterns longer or shorter than item key
    return null;
};
const $142e2464d1092f3f$export$c4a1dd71bbd8954c = (itemKey, endsWith)=>{
    // Return category number if str is found in the trie, otherwise return undefined
    const trieSearch = (str)=>{
        let currentStep = endsWith;
        let foundString = '';
        let terminalNumber;
        for(let i = 0; i < str.length; i++){
            const char = str[i];
            currentStep = currentStep[char];
            if (currentStep === undefined) break;
            foundString += char;
            if (typeof currentStep === 'number') {
                terminalNumber = currentStep;
                break;
            }
        }
        if (foundString === str) // Trie contained the complete string
        return terminalNumber;
        else // Trie did not contain the complete string
        return undefined;
    };
    let position = 0;
    // Iterate through item key symbol by symbol
    while(position < itemKey.length){
        const remainderMatch = trieSearch(itemKey.slice(position));
        if (remainderMatch !== undefined) return remainderMatch;
        position++;
    }
    return null;
};
const $142e2464d1092f3f$export$69d5b68d01f4a366 = (itemKey, storageControlsData, productName)=>{
    const downcasedProduct = productName?.toLowerCase();
    let itemCategoryNumber = null;
    const { categories: categories, patterns: patterns } = storageControlsData;
    let productKeys = {
        ...storageControlsData['keys']['all'],
        ...downcasedProduct ? storageControlsData['keys'][downcasedProduct] : {}
    };
    const productStartsWithPatterns = {
        ...patterns.startsWith['all'],
        ...downcasedProduct ? patterns.startsWith[downcasedProduct] : {}
    };
    const productEndsWithPatterns = {
        ...patterns.endsWith['all'],
        ...downcasedProduct ? patterns.endsWith[downcasedProduct] : {}
    };
    // Find direct match in keys
    if (Object.keys(productKeys).includes(itemKey)) itemCategoryNumber = productKeys[itemKey];
    else {
        // Find pattern match or null
        itemCategoryNumber = $142e2464d1092f3f$export$2c141b1c00f3e482(itemKey, productStartsWithPatterns);
        if (itemCategoryNumber === null) itemCategoryNumber = $142e2464d1092f3f$export$c4a1dd71bbd8954c(itemKey, productEndsWithPatterns);
    }
    const numToCategoryMap = {
        [categories.STRICTLY_NECESSARY]: (0, $529b326958d1af20$export$ba064dbfe4bb66d7).StrictlyNecessary,
        [categories.FUNCTIONAL]: (0, $529b326958d1af20$export$ba064dbfe4bb66d7).Functional,
        [categories.ANALYTICS]: (0, $529b326958d1af20$export$ba064dbfe4bb66d7).Analytics,
        [categories.MARKETING]: (0, $529b326958d1af20$export$ba064dbfe4bb66d7).Marketing,
        [categories.UNKNOWN]: (0, $529b326958d1af20$export$ba064dbfe4bb66d7).Unknown
    };
    return itemCategoryNumber !== null ? numToCategoryMap[itemCategoryNumber] : null;
};
const $142e2464d1092f3f$export$ec8ce5237293e4a4 = async (itemKey, storageType, productName)=>{
    const storageControlsData = await (0, $e15ac9c6b48eae37$export$3b78a1ea01f5ec28)().loadCache(storageType);
    if (!storageControlsData) return null;
    else return $142e2464d1092f3f$export$69d5b68d01f4a366(itemKey, storageControlsData, productName);
};
const $142e2464d1092f3f$export$e7a3dca206fec6e2 = async ({ itemKey: itemKey, allowedCallback: allowedCallback = ()=>{}, blockedCallback: blockedCallback = ()=>{}, storageType: storageType, productName: productName })=>{
    let shouldProcessItem;
    const itemCategory = await $142e2464d1092f3f$export$ec8ce5237293e4a4(itemKey, storageType, productName);
    if (itemCategory === (0, $529b326958d1af20$export$ba064dbfe4bb66d7).StrictlyNecessary) shouldProcessItem = true;
    else {
        const preferences = await (0, $e2892338578089b5$export$1de6a888ae076ff8)();
        let hasPreferencesForCategory = false;
        if (!!preferences) {
            if (!!itemCategory) hasPreferencesForCategory = preferences[itemCategory];
        }
        shouldProcessItem = hasPreferencesForCategory;
    }
    if (shouldProcessItem) allowedCallback?.();
    else blockedCallback?.({
        itemHasCategory: itemCategory != null
    });
    return shouldProcessItem;
};






const $4cd24cb534dbb0d7$export$5ee8760f703d9d62 = async (itemKey, value, storageType, productName, browserStorage)=>{
    // user belongs to an org that opted into cookies management and we should respect their preferences
    // Flag enabled, user belongs to an org that opted into cookies management and we should respect their preferences
    const shouldSetItem = await (0, $142e2464d1092f3f$export$e7a3dca206fec6e2)({
        itemKey: itemKey,
        storageType: storageType === (0, $015d452935a78a4a$export$259e3a861f28589b).LocalStorage ? (0, $529b326958d1af20$export$2506b012eb637f61).LocalStorage : (0, $529b326958d1af20$export$2506b012eb637f61).SessionStorage,
        productName: productName
    });
    const eventAttributes = {
        wasRejected: !shouldSetItem,
        itemKey: itemKey,
        storageType: storageType
    };
    try {
        (0, $e7919529bbee736a$export$5bfe55348e7aebc1)({
            action: 'usedAtlBrowserStorageSetItem',
            attributes: eventAttributes
        });
        if (shouldSetItem) {
            // Store the item as a record in our IDB service to track that we've seen it before.
            // That way, when we can confirm/deny that this has been set by our service when we check again.
            // If it fails for some reason, it will be caught before actually setting the item
            await (0, $839bb944f3bf2243$export$36328b3bcbe4623a).setRecord(itemKey);
            browserStorage.setItem(itemKey, value);
            return (0, $529b326958d1af20$export$96e9906d6d93a972).SUCCESS;
        } else return (0, $529b326958d1af20$export$96e9906d6d93a972).BLOCKED;
    } catch (e) {
        (0, $d1a5ba6794b83ea4$export$efa9a398d6368992).errorWithOperationalEvent({
            action: 'usedAtlBrowserStorageSetItemError',
            attributes: eventAttributes,
            message: `Failed to set ${storageType} item. ${e.message || ''}`
        });
        return (0, $529b326958d1af20$export$96e9906d6d93a972).BLOCKED;
    }
};






const $ee5c4d3126e347a6$export$f1b0c189562aa9fd = (itemKey, value, storageType, browserStorage)=>{
    // Flag disabled, allow all items.
    const eventAttributes = {
        itemKey: itemKey,
        storageType: storageType
    };
    try {
        (0, $e7919529bbee736a$export$5bfe55348e7aebc1)({
            action: 'usedAtlBrowserStorageSetStrictlyNecessaryItem',
            attributes: eventAttributes
        });
        // Store the item as a record in our IDB service to track that we've seen it before.
        // That way, when we can confirm/deny that this has been set by our service when we check again.
        // If it fails for some reason, it will be caught before actually setting the item
        // As setting Strictly Necessary requires synchronous operation, wait on the promise in an OG fashion
        (0, $839bb944f3bf2243$export$36328b3bcbe4623a).setRecord(itemKey).then(()=>{
        // NOTE: Should this just no-op/be removed? It already set and returned the item theoretically since this main func is sync
        }).catch((e)=>{
            // code to address HOT-122970
            if ((0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform_set_necessary_storage_item_error_hotfix')) (0, $e7919529bbee736a$export$5bfe55348e7aebc1)({
                action: 'indexDbSetRecordError',
                attributes: eventAttributes
            });
            else // Rethrow to the above catch clause since this is async within a sync func
            throw new Error(e.message || '');
        });
        browserStorage.setItem(itemKey, value);
        return (0, $529b326958d1af20$export$96e9906d6d93a972).SUCCESS;
    } catch (e) {
        (0, $d1a5ba6794b83ea4$export$efa9a398d6368992).errorWithOperationalEvent({
            action: 'usedAtlBrowserStorageSetStrictlyNecessaryItemError',
            attributes: eventAttributes,
            message: `Failed to set strictly necessary ${storageType} item. ${e.message || ''}`
        });
        return (0, $529b326958d1af20$export$96e9906d6d93a972).FAILED;
    }
};


class $548b5fa8d036d961$export$8e4a3cf07a10930b {
    get isWebStorageEnabled() {
        // Note: outside of user configuration, webStoragedEnabled is also feature gated by
        // 1. platform_moonjelly_bsc_master_killswitch
        // 2. platform_moonjelly_bsc_web_storage_killswitch
        if ((0, $e15ac9c6b48eae37$export$3b78a1ea01f5ec28)().webStorageEnabled) return true;
        (0, $d1a5ba6794b83ea4$export$efa9a398d6368992).debug('WebStorage config is disabled, cannot proceed.');
        return false;
    }
    // Core API
    getItem(key) {
        if (!this.isWebStorageEnabled) return this.storage.getItem(key);
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $d1a5ba6794b83ea4$export$efa9a398d6368992).warn(`${this.storageType} is unavailable. Failed to get item ${key}`);
            return null;
        }
        const retrievedItem = (0, $9c73f4efe3395197$export$e612bb1301d659de)(key, this.storageType, this.storage);
        return retrievedItem;
    }
    async setItem(key, value) {
        if (!this.isWebStorageEnabled) {
            this.storage.setItem(key, value);
            return;
        }
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $d1a5ba6794b83ea4$export$efa9a398d6368992).warn(`${this.storageType} is unavailable. Failed to set item ${key}`);
            return;
        }
        const globalStateProduct = (0, $e15ac9c6b48eae37$export$3b78a1ea01f5ec28)().product;
        const itemSetStatus = await (0, $4cd24cb534dbb0d7$export$5ee8760f703d9d62)(key, value, this.storageType, globalStateProduct, this.storage);
        (0, $d1a5ba6794b83ea4$export$efa9a398d6368992).debug(`${itemSetStatus === (0, $529b326958d1af20$export$96e9906d6d93a972).SUCCESS ? 'Successfully' : 'Failed to'} set item ${key} with value ${value}`);
    }
    setStrictlyNecessaryItem(key, value) {
        if (!this.isWebStorageEnabled) {
            this.storage.setItem(key, value);
            return;
        }
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $d1a5ba6794b83ea4$export$efa9a398d6368992).warn(`${this.storageType} is unavailable. Failed to set strictly necessary item ${key}`);
            return;
        }
        const itemSetStatus = (0, $ee5c4d3126e347a6$export$f1b0c189562aa9fd)(key, value, this.storageType, this.storage);
        (0, $d1a5ba6794b83ea4$export$efa9a398d6368992).debug(`${itemSetStatus === (0, $529b326958d1af20$export$96e9906d6d93a972).SUCCESS ? 'Successfully' : 'Failed to'} set strictly necessary item ${key} with value ${value}`);
    }
    // Native Utilities
    removeItem(key) {
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $d1a5ba6794b83ea4$export$efa9a398d6368992).warn(`${this.storageType} is unavailable. Failed to remove item ${key}`);
            return;
        }
        this.storage.removeItem(key);
    }
    key(index) {
        if (!this.isAvailable) return null;
        return this.storage.key(index);
    }
    length() {
        if (!this.isAvailable) return 0;
        return this.storage.length;
    }
    clear() {
        if (!this.isAvailable) return;
        this.storage.clear();
    }
    // Utilities
    isStorageAvailable() {
        if ((0, $6f3320f8ddad677d$export$48d7c418edadb60c)()) return false;
        try {
            const x = '__storage_test__';
            this.storage.setItem(x, x);
            this.storage.removeItem(x);
            return true;
        } catch (e) {
            return e instanceof DOMException && // everything except Firefox
            (e.code === 22 || // Firefox
            e.code === 1014 || // test name field too, because code might not be present
            // everything except Firefox
            e.name === 'QuotaExceededError' || // Firefox
            e.name === 'NS_ERROR_DOM_QUOTA_REACHED') && // acknowledge QuotaExceededError only if there's something already stored
            this.storage && this.storage.length !== 0;
        }
    }
    constructor(storage, storageType){
        this.storage = void 0;
        this.storageType = void 0;
        this.isAvailable = false;
        this.checkIfSetByPackage = async ({ itemKey: itemKey, isSetCallback: isSetCallback = ()=>{}, isNotSetCallback: isNotSetCallback = ()=>{} })=>{
            // As IDB is asynchronous in nature, when this in invoked, we need to rely on the callbacks
            // to actually do something with the result.
            try {
                const record = await (0, $839bb944f3bf2243$export$36328b3bcbe4623a).getRecord(itemKey);
                if (record) {
                    isSetCallback();
                    return true;
                } else {
                    isNotSetCallback();
                    return false;
                }
            } catch (e) {
                // If it fails to pull from IDB, we can't validate that it's been set by our package or not, so log the error
                // and assume it hasn't been set by our package. This will only impact our analytics correctness.
                (0, $d1a5ba6794b83ea4$export$efa9a398d6368992).errorWithOperationalEvent({
                    action: 'usedCheckIfSetByPackageError',
                    message: `IDB lookup failed to check if item was set by package. ${e.message || ''}`,
                    attributes: {
                        itemKey: itemKey
                    }
                });
                isNotSetCallback();
                return false;
            }
        };
        this.storage = storage;
        this.storageType = storageType;
        this.isAvailable = this.isStorageAvailable();
    }
}
const $548b5fa8d036d961$export$c8cc3ffd3f2c1d2f = new $548b5fa8d036d961$export$8e4a3cf07a10930b(window?.localStorage, (0, $015d452935a78a4a$export$259e3a861f28589b).LocalStorage);
const $548b5fa8d036d961$export$edbae459bdf957a5 = new $548b5fa8d036d961$export$8e4a3cf07a10930b(window?.sessionStorage, (0, $015d452935a78a4a$export$259e3a861f28589b).SessionStorage);
const $548b5fa8d036d961$export$14921bfc334334c0 = (type)=>{
    return ({
        [(0, $015d452935a78a4a$export$259e3a861f28589b).LocalStorage]: $548b5fa8d036d961$export$c8cc3ffd3f2c1d2f,
        [(0, $015d452935a78a4a$export$259e3a861f28589b).SessionStorage]: $548b5fa8d036d961$export$edbae459bdf957a5
    })[type];
};



/* eslint-disable check-set-storage-usage/no-unimported-storage-set */ 



const $0a711c922c37c686$export$359ef83116415c8a = (0, $986f6c4727102807$export$2e2bcd8739ae039)`mutation UpdateLocalStorageMutation($storageinput:LocalStorageInput!$stringKeys:[String]!){updateLocalStorage(localStorage:$storageinput){stringValues(keys:$stringKeys){key value}}}`;


const $55aebbd7cffee8f3$export$ed97f33186d4b816 = {
    DISCOVER_ROUTE: 'discover.route.last',
    GLOBAL_SIDEBAR_PANEL: 'sidebar.global.panel',
    EDITOR_SURVEY_LAST_SUBMITTED: 'editor.survey.last.submitted',
    SUPERADMIN_SURVEY_REQUESTED: 'superadmin.survey.requested',
    SUPERADMIN_SURVEY_SUBMITTED: 'superadmin.survey.submitted',
    SUPERADMIN_SESSION_EXPIRED: 'superadmin.session.expired',
    RESTRICTED_PAGE_CONFIRMED: 'restricted.page.confirmed',
    HOME_ONBOARDING: 'home.onboarding',
    PAGE_JUST_CONVERTED: 'migration.page.just.converted',
    NAVIGATION_CLASSIC_OPT_OUT: 'navigation.classic.opt.out',
    NAVIGATION_HOME_OPT_OUT: 'navigation.home.opt.out',
    NAVIGATION_DEFAULT_OPTED_OUT: 'navigation.default.opted.out',
    NAVIGATION_OPT_IN_SEEN_SPOTLIGHT: 'navigation.opt.in.seen.spotlight',
    NAVIGATION_CLICKED_LOUD_OPT_IN_OR_VIEWED_FLAG: 'navigation.clicked.loud.opt.in.or.viewed.flag',
    NOTIFICATION_SPOTLIGHT_VIEWED: 'notification.spotlight.viewed',
    HOME_SECTION_COLLAPSED: 'home.section.collapsed',
    RECENTLY_WATCHED_SPACE: 'recentlyWatchedSpace',
    GROWTH_EXPERIMENT_REQUEST_UPGRADE_SENT: 'growth.experiment.request.upgrade.sent',
    GROWTH_EXPERIMENT_UPGRADE_DISMISSED_COUNT: 'growth.experiment.engagedUpgrade.dismissed.count',
    GROWTH_EXPERIMENT_UPGRADE_LAST_DISMISSED_DATE: 'growth.experiment.engagedUpgrade.last.dismissed.date',
    LOCAL_STORAGE_DISPLAYS_NEXT_AT_KEY: 'growth.experiment.engagedBilling.displays.next.at',
    LOCAL_STORAGE_HAS_BILLING_DETAILS: 'growth.experiment.engagedBilling.has.billing.details',
    LOCAL_STORAGE_BILLING_API_NEXT_CALLED_AT_KEY: 'growth.experiment.engagedBilling.billing.api.next.called.at',
    LOCAL_STORAGE_CONTENT_VIEW_CLOSEST_ELEMENT_SCROLL_POSITION: 'ce.content.view.best.element.scroll.position',
    CONFLUENCE_SLACK_APP_IS_ENABLED: 'growth.experiment.confluence.slack-is-enabled',
    INVITE_ON_LINK_INSERT_DISMISSAL_COUNT: 'growth.experiment.confluence.invite-on-link-insert-dismissal-count',
    INVITE_ON_LINK_INSERT_OPT_OUT: 'growth.experiment.confluence.invite-on-link-insert-opt-out',
    CROSS_JOIN_NUDGES_V3_VISITED_KEY: 'growth.experiment.confluence.cross-join-nudges-v3-visited',
    CROSS_JOIN_NUDGES_JPD_VISITED_KEY: 'growth.experiment.confluence.cross-join-nudges-jpd-visited',
    CROSS_JOIN_NUDGES_MSR_VISITED_KEY: 'growth.experiment.confluence.cross-join-nudges-msr-visited',
    CROSS_JOIN_NUDGES_MSR_USER_OPT_OUT: 'growth.experiment.confluence.cross-join-nudges-msr-opt-out',
    CROSS_JOIN_NUDGES_MSR_VISITED_COUNT: 'growth.experiment.confluence.cross-join-nudges-msr-visited-count',
    CROSS_JOIN_NUDGES_V3_VISITED_COUNT: 'growth.experiment.confluence.cross-join-nudges-v3-visited-count',
    CROSS_JOIN_NUDGES_JPD_VISITED_COUNT: 'growth.experiment.confluence.cross-join-nudges-jpd-visited-count',
    CROSS_JOIN_NUDGES_V3_USER_OPT_OUT: 'growth.experiment.confluence.cross-join-nudges-v3-opt-out',
    CROSS_JOIN_NUDGES_JPD_USER_OPT_OUT: 'growth.experiment.confluence.cross-join-nudges-jpd-opt-out',
    CROSS_JOIN_NUDGES_ELIGIBILITY_KEY: 'growth.experiment.confluence.cross-join-nudges-eligibility',
    CROSS_JOIN_NUDGES_EVENT_CACHE_KEY: 'growth.experiment.confluence.cross-join-nudges-event-cache',
    CROSS_JOIN_NUDGES_LOOM_EVENT_CACHE_KEY: 'growth.experiment.confluence.cross-join-nudges-loom-event-cache',
    CROSS_JOIN_THIRD_PARTY_NUDGES_VISITED_KEY: 'growth.experiment.confluence.cross-join-third-party-nudges-v2-visited',
    CROSS_JOIN_THIRD_PARTY_NUDGES_VISITED_COUNT: 'growth.experiment.confluence.cross-join-third-party-nudges-v2-visited-count',
    CROSS_JOIN_NUDGES_LOOM_VISITED_KEY: 'growth.experiment.confluence.cross-join-nudges-loom-visited',
    CROSS_JOIN_NUDGES_LOOM_VISITED_COUNT: 'growth.experiment.confluence.cross-join-nudges-loom-visited-count',
    CROSS_JOIN_NUDGES_LOOM_OPT_OUT: 'growth.experiment.confluence.cross-join-nudges-loom-opt-out',
    /**
   * The width of the right panel on Home
   */ HOME_SIDEBAR_WIDTH: 'home.sidebar.width',
    /**
   * Used to store starred/favorited feature flags for the dev tools panel
   */ STARRED_FEATURE_FLAGS: 'confluence-frontend-next.starredFeatureFlags',
    /**
   * Indicates that "Copy space permissions" (implemented by
   * @confluence/copy-space-permissions) has completed i.e. space permissions
   * have been copied.
   */ COPIED_SPACE_PERMISSIONS: 'copied.space.permissions',
    PERSIST_SCROLL_POSITION_IN_VIEW_PAGE: 'editor-persit-scroll-position',
    ID_START_CONTENT_IN_VIEW_PAGE: 'main-content',
    FABRIC_PAGE_OPTIN_MIGRATION_BANNER: 'fabric.page.optin.migration.banner.discovery.feature',
    FABRIC_TEMPLATE_MIGRATION_SUCCESS_FLAG: 'fabric-template-migration.success.flag',
    FABRIC_TEMPLATE_MIGRATION_ERROR_FLAG: 'fabric-template-migration.error.flag',
    BYLINE_APPS_SHOW_ALL: 'byline.apps.show-all',
    SPACENAV_APPS_SHOW_ALL: 'spacenav.apps.show-all',
    HIDE_BULK_CONFIRMATION_DIALOG_LOCAL_STORAGE_KEY: 'archive-pages.bulk-archive.confirmation-dialog.opt-out',
    ONBOARDING_STEP_INDEX: 'onboarding.account.setup.step.index',
    ONBOARDING_STEP_HAS_TEAM_NAME: 'onboarding.account.setup.step.hasTeamName',
    ONBOARDING_FORM_VALUES: 'onboarding.account.setup.form.values',
    RIGHT_SIDEBAR: 'right.sidebar',
    CONNECT_APP_ANALYTICS: 'ecosystem.confluence.connect.analytics',
    /**
   * Auto Convert TinyMCE pages
   */ EDITOR_REVERTED: 'autoconverted.pages.reverted',
    BLOGPOST_PERMISSIONS_NOTICE: 'blogpost.permissions.notice.error',
    QUERY_OVERRIDES: 'query.overrides',
    CANVAS_SERVER: 'canvas-server',
    CANVAS_RELAY: 'canvas-relay',
    CANVAS_FRONTEND_VERSION: 'canvas-frontend-version',
    // Below are cc-automation keys for in-context discoverability messages
    AUTOMATION_DISCOVER_ARCHIVE_FROM_OVERFLOW_MENU: 'automation.discover.archive-from-overflow-menu',
    AUTOMATION_DISCOVER_ARCHIVE_FROM_HOVER_OVER_PAGE_TITLE: 'automation.discover.archive-from-hover-over-page-title',
    AUTOMATION_DISCOVER_BULK_ARCHIVE: 'automation.discover.bulk-archive',
    AUTOMATION_DISCOVER_BULK_CHANGE_PAGE_OWNER: 'automation.discover.bulk-change-page-owner',
    AUTOMATION_DISCOVER_ADD_LABEL_TO_PAGE: 'automation.discover.add-label-to-page',
    AUTOMATION_DISCOVER_MEETING_NOTES_TEMPLATE: 'automation.discover.meeting-notes-template',
    AUTOMATION_DISCOVER_JIRA_LINK: 'automation.discover.jira-link',
    AUTOMATION_DISCOVER_MANUAL_TRIGGER: 'automation.discover.manual.trigger',
    AUTOMATION_DISCOVER_MANUAL_RULE_COUNT: 'automation.discover.manual.rule.count',
    AUTOMTION_DISCOVER_MANUAL_RULE_SMART_BUTTON: 'automation.discover.manual.rule.smart.button',
    AUTOMATION_DISCOVER_PAGE_PUBLIC_LINK: 'automation.discover.page-public-link',
    AUTOMATION_DISCOVER_GLOBAL_PUBLIC_LINK: 'automation.discover.global-public-link',
    AUTOMATION_DISCOVER_SPACE_ASSIGNED_BULK: 'automation.discover.space-assigned-bulk',
    AUTOMATION_DISCOVER_SPACE_ASSIGNED_INDIVIDUAL: 'automation.discover.space-assigned-individual',
    AUTOMATION_DISCOVER_GLOBAL_DEFAULT_SPACE: 'automation.discover.global-default-space',
    AUTOMATION_DISCOVER_VERIFIED_CONTENT: 'automation.discover.verified.content',
    AUTOMATION_DISCOVER_WHITE_BOARDS: 'automation.discover.publish.white.boards',
    AUTOMATION_DISCOVER_SHARE_SLACK: 'automation.discover.share.slack',
    AUTOMATION_DISCOVER_SET_CONTENT_STATE: 'automation.discover.set-content-state',
    AUTOMATION_DISCOVER_PRODUCT_REQUIREMENTS: 'automation.discover.product-requirements',
    AUTOMATION_DISCOVER_FEEDBACK_ANALYSIS: 'automation.discover.feedback-analysis',
    AUTOMATION_DISCOVER_RELEASE_NOTES: 'automation.discover.release-notes',
    AUTOMATION_ONBOARDING: 'automation.onboarding',
    AUTOMATION_EXECUTION_LIMIT: 'automation.execution.limit',
    SPACE_SETTINGS_NAV_SECTIONS_EXPANDED_STATES: 'space-settings-nav.sections.expand-states',
    SITE_SETTINGS_NAV_SECTIONS_EXPANDED_STATES: 'site-settings-nav.sections.expand-states',
    /**
   * Comment Drafts
   */ COMMENT_DRAFTS_PAGE_CREATE: 'comments.drafts.page.create',
    COMMENT_DRAFTS_PAGE_EDIT: 'comments.drafts.page.edit',
    COMMENT_DRAFTS_PAGE_REPLY: 'comments.drafts.page.reply',
    COMMENT_DRAFTS_INLINE_CREATE: 'comments.drafts.inline.comments.create',
    COMMENT_DRAFTS_INLINE_EDIT: 'comments.drafts.inline.comments.edit',
    COMMENT_DRAFTS_INLINE_REPLY: 'comments.drafts.inline.reply',
    COMMENT_DRAFTS_EDITOR_INLINE_CREATE: 'comments.drafts.editor.inline.create',
    COMMENT_DRAFTS_EDITOR_INLINE_EDIT: 'comments.drafts.editor.inline.edit',
    COMMENT_DRAFTS_EDITOR_INLINE_REPLY: 'comments.drafts.editor.inline.reply',
    LOOM_BETA_ENABLED: 'loom.beta.enabled',
    BROWSER_BANNER_CLOSED_BY_USER: 'devloop.browser-support-warning.closed',
    /**
   * Home Feeds
   */ HOME_FOLLOWING_FEED_SESSION_ID: 'home.follow-feed.sessionId',
    HOME_POPULAR_FEED_SESSION_ID: 'home.popular-feed.sessionId',
    HOME_FOLLOWING_FEED_SORTING: 'home.follow-feed.sorting',
    HOME_POPULAR_FEED_TIME_GRANULARITY: 'home.popular-feed.time-granularity',
    /**
   * Live Pages
   */ LIVE_PAGES_IN_PRODUCT_PROMPT_MODAL_LAST_DISMISSED: 'live-pages.in-product-prompt.modal.last-dismissed',
    LIVE_PAGES_IN_PRODUCT_PROMPT_BANNER_SPACE_SETTINGS_LAST_DISMISSED: 'live-pages.in-product-prompt.banner.space-settings.last-dismissed',
    LIVE_PAGES_IN_PRODUCT_PROMPT_BANNER_MISSION_CONTROL_LAST_DISMISSED: 'live-pages.in-product-prompt.banner.mission-control.last-dismissed',
    LIVE_PAGES_MODE_SWITCHING_FLAG_SHOWN: 'live-pages.mode-switcher.flag.shown',
    LIVE_PAGES_OPEN_BETA_PROMPT_MODAL_FIRST_SEEN: 'live-pages.open-beta-prompt-modal.first-seen',
    LIVE_PAGES_OPEN_BETA_PROMPT_GLOBAL_BANNER_FIRST_DISMISSED: 'live-pages.open-beta-prompt-global-banner.first-dismissed',
    LIVE_DOCS_HAS_INIT_MODERNIZE: 'live-docs.has-init-modernize',
    LIVE_DOCS_HAS_INIT_MODERNIZE_POST_EXP: 'live-docs.has-init-modernize-post-exp',
    LIVE_DOCS_NEW_LOZENGE_SHOWN_TRACKER: 'live-docs.new-lozenge-shown-tracker',
    /**
   * AI First Creation
   */ HAS_INIT_AIFC_EXP: 'ai-first-creation.has-init-aifc-exp',
    CREATE_WITH_ROVO_MODAL_CLOSE_FEEDBACK_FLAG_LAST_SHOWN: 'create-with-rovo-modal-close-feedback-flag.last-shown',
    CREATE_WITH_ROVO_UPDATE_COMPLETE_FEEDBACK_FLAG_LAST_SHOWN: 'create-with-rovo-update-complete-feedback-flag.last-shown',
    /**
   * Confluence Notes
   */ NOTES_FLOATING_POSITION: 'confluence-notes.floating-position',
    UNIVERSAL_SHORTCUTS_HIDE_PROMPT_UNTIL: 'universal-shortcuts.deprecated-shortcut-flag.hide-until',
    // Bold new pages experiment
    UNREAD_PAGES_VISITED: 'bold-new-pages.experiment.unread-pages.visited',
    // Mention Reminders experiment
    MENTION_REMINDERS_SENT: 'mention-reminders.experiment.sent',
    // Nav 4 Site/Space settings back button URL
    NAV4_SETTINGS_BACK_BUTTON_URL: 'navigation.settings.back-button.url',
    // Nav 4 opt out cache
    NAV4_OPT_OUT_CACHE: 'navigation.opt-out',
    // Nav 4 admin opt in cache
    NAV4_ADMIN_OPT_IN_CACHE: 'navigation.admin.opt-in',
    // Nav 4 misaligned nav versions flag
    NAV4_MISALIGNED_NAV_VERSIONS_FLAG: 'navigation.misaligned.nav.versions.flag',
    // EOT Banner experiment
    EOT_BANNER_DISMISS_UNTIL: 'eot-banner.dismiss-until',
    // Issue Create
    ISSUE_CREATE_WITH_AI: 'issue-create.with-ai',
    // AI Unsplash Header Experiment
    AI_UNSPLASH_HEADER_ACCEPTED: 'ai-unsplash.header.accepted',
    //Notify User On 1st View expeirment
    NOTIFY_USERS_ON_FIRST_VIEW_MUTATION_FIRED: 'notify-users-on-first-view.mutation.fired',
    NAVDEX_STORAGE_KEY: 'navigationSession',
    // Super Admin Timeout
    SUPER_ADMIN_TIMEOUT: 'confluence.super.admin.timeout',
    // Premium Onboarding
    PTO_PHASE_TWO_SPOTLIGHT_TARGET: 'pto-phase-two-spotlight',
    // Have I Seen It prefix
    HAVE_I_SEEN_IT_PREFIX: 'cf_hisi_',
    // Migrations
    IMPORT_CONTENT_TIMESTAMP: 'importContentTimestamp',
    // Page Experience
    AE_TABLE_COPIED: 'copied',
    AE_TABLE_COPIED_COLS: 'copiedCols',
    LAST_TAB_SUFFIX: 'last-tab',
    // AI Audio Playback Speed
    AI_AUDIO_PLAYBACK_SPEED: 'ai.audio.playback-speed',
    AI_AUDIO_BRIEFING_CUSTOMIZATION: 'ai.audio.briefing.customization',
    // EditorTeamCreatedFlag
    RETROSPECTIVE_BLUEPRINT_TEAM_CREATED: 'retrospective-blueprint.team.created',
    RETROSPECTIVE_BLUEPRINT_TEAM_USED: 'retrospective-blueprint.team.used',
    // Confluence Custom Origins
    CONFLUENCE_CUSTOM_ORIGINS: 'confluenceCustomOrigins',
    // Dev and Testing
    HIDE_FEATURE_FLAG_ICON: 'confluence-frontend-next.hideFeatureFlagIcon',
    FE_FIXTURE_PARAMS: '__confluence-frontend-fixture-params',
    TEST_FAILURES_LINK_MODE: 'testFailuresLink.mode',
    TEST_FAILURES_LINK_OPERATIONS_PREFIX: 'testFailuresLink.operations.',
    // Disable Engagement for tests
    DISABLE_ENGAGEMENT_FOR_TESTS: 'confluence.disable-engagement-for-tests',
    // Jira Crossflow Experiment
    JIRA_ACCESS_REQUESTED: 'jira_access_requested',
    JIRA_TRIAL_REQUESTED: 'jira_trial_requested',
    // Feature Discovery Override
    FEATURE_DISCOVERY_OVERRIDE_PREFIX: 'featureDiscoveryOverride-',
    // Realtime Access Requests:
    LAST_SHOWN_REALTIME_REQUEST_CREATED_AT: 'lastShownRealtimeRequestCreatedAt',
    LAST_TIME_ACCESS_REQUESTS_DIALOG_WAS_OPENED: 'lastTimeAccessRequestsDialogWasOpened',
    // Chrome Extension
    CONFLUENCE_SSR_OUTLINE_PRIORITY: 'confluence.ssr-outline-priority',
    CONFLUENCE_SSR_OUTLINE_ENABLED: 'confluence.ssr-outline-enabled',
    CONFLUENCE_LOADABLE_STEP_OVER_ENABLED: 'confluence.loadable-step-over-enabled'
};
const $55aebbd7cffee8f3$export$84dce893719feb44 = {
    //keys stored on backend start with persisted
    PERSISTED_LEFT_SIDEBAR_WIDTH: 'persisted.left.sidebar.width',
    PERSISTED_LEFT_SIDEBAR_COLLAPSED: 'persisted.left.sidebar.collapsed',
    PERSISTED_GROWTH_PERSISTENT_UPGRADE_PRETRIAL_BANNER: 'persisted.growth.persistent.upgrade.preTrial.banner',
    PERSISTED_SPACE_NAV_SECTIONS_EXPANDED_STATES: 'persisted.space-nav.sections.expand-states',
    // The next time to show the External Collaboration Guest Satisfaction Survey to this guest user
    PERSISTED_GUEST_SURVEY_NEXT_TIME_TO_SHOW: 'persisted.guest.survey.next.time.to.show',
    // Overrided feature flags. These are persisted to the server so they can be
    // used when rendering in SSR
    PERSISTED_OVERRIDE_FEATURE_FLAGS: 'persisted.enterprise-experience.override.feature.flags',
    PERSISTED_OVERRIDES_STATSIG: 'persisted.enterprise-experience.override.statsig',
    PERSISTED_ADMIN_ANNOUNCEMENT_BANNER: 'persisted.admin.announcement.banner',
    PERSISTED_ADMIN_ANNOUNCEMENT_BANNER_MIGRATOR_PROMPT: 'persisted.admin.announcement.banner.migrator.prompt',
    PERSISTED_STORAGE_ENFORCEMENT_BANNER: 'persisted.storage.enforcement.banner',
    // Public Links Modals
    PERSISTED_RESTRICTIONS_DIALOG_PUBLIC_LINKS_MODAL: 'persisted.restrictions.dialog.public.links.modal',
    PERSISTED_SHARE_DIALOG_PUBLIC_LINKS_TOGGLE_ON_MODAL: 'persisted.share.dialog.public.links.toggle.on.modal',
    PERSISTED_SHARE_DIALOG_PUBLIC_LINKS_TOGGLE_ON_MODAL_SMART_SECTIONS: 'persisted.share.dialog.public.links.toggle.on.modal.smart.sections',
    PERSISTED_SHARE_DIALOG_PUBLIC_LINKS_TOGGLE_OFF_MODAL: 'persisted.share.dialog.public.links.toggle.off.modal',
    // Public Links Edit Whiteboard Banner
    PERSISTED_PUBLIC_LINKS_EDIT_WHITEBOARD_BANNER: 'persisted.public.links.edit.whiteboard.banner',
    // Theming
    PERSISTED_USER_THEME_PREFERENCE: 'persisted.ecosystem.user.theme.preference',
    // Premium feature highlight
    PERSISTED_PREMIUM_FEATURE_HIGHLIGHT: 'persisted.premium.feature.highlight',
    // Reading Aids
    PERSISTED_READING_AIDS_AUTO_HIGHLIGHT: 'persisted.reading.aids.auto.highlight',
    // Bold new pages experiment
    PERSISTED_BOLD_NEW_PAGES_SATISFACTION_SURVEY_HAS_SEEN: 'persisted.bold-new-pages.experiment.satisfaction-survey.has-seen',
    // Previously trialed premium users experiment
    PERSISTED_PREVIOUSLY_TRIALED_PREMIUM_USERS_DISMISSED: 'persisted.previously.trialed.premium.users.banner.dismissed',
    // Quick Summary Experiment
    PERSISTED_QUICK_SUMMARY_REQUEST_SENT: 'persisted.growth.quick-summary-request-sent',
    // AIFC Banner Persistence
    PERSISTED_SMART_CREATE_FEEDBACK_BANNER_LAST_DISMISSED: 'persisted.smart-create.feedback-banner.last-dismissed',
    // Editor Controls
    PERSISTED_EDITOR_CONTROLS_ONBOARDING_BANNER_NEW_PINNING_DISMISSED: 'persisted.editor-controls.onboarding-banner-new-pinning.dismissed',
    //Bite Sized Generic Premium Messages
    PERSISTED_BITE_SIZED_PREMIUM_MESSAGES_GENERIC_CADENCE: 'persisted.bite-sized.premium-messages.generic.cadence',
    //Bite Sized Automation Premium Messages
    PERSISTED_BITE_SIZED_PREMIUM_MESSAGES_AUTOMATION_CADENCE: 'persisted.bite-sized.premium-messages.automation.cadence',
    //Role Based Access Control
    PERSISTED_RBAC_TRACKING: 'persisted.rbac.tracking',
    // Loom cross_flow ad-control not interested preference
    PERSISTED_LOOM_CROSS_FLOW_AD_CONTROL_NOT_INTERESTED: 'persisted.loom-cross-flow.ad-control.not-interested',
    // Status of exposure to a series of spotlight pulse outlines
    // highlighting Loom entrypoints to cross-sell-eligible customers
    PERSISTED_LOOM_CROSS_SELL_DISCOVERABILITY_PULSES_HAVE_ENDED: 'persisted.loom-cross-sell.discoverability-pulses.have-ended',
    // Jira Cloud ID preference for site picker on Jira Issue Create
    PERSISTED_JIRA_CLOUD_ID_PREFERENCE: 'persisted.jira-cloud-id.preference',
    // Selected site, project and issue type from the configure view on bulk AI Jira Issue Create
    PERSISTED_BULK_CREATE_JIRA_CONFIG_FOR_USER: 'persisted.bulk-create.jira.config.for.user',
    // Selected site, project and issue type from the single work create form
    PERSISTED_SINGLE_CREATE_JIRA_CONFIG_FOR_USER: 'persisted.single-create.jira.config.for.user',
    PERSISTED_SHOULD_USE_GIC_EMBED: 'persisted.should-use-gic-embed',
    // Importers
    PERSISTED_IMPORT_FEEDBACK_DISABLED: 'persisted.imports.import-feedback-disabled',
    PERSISTED_RT_PAID_FEATURE_EDUCATION_SPOTLIGHT_SEEN: 'persisted.rt-paid-feature-education.spotlight.seen',
    // Search Platform QuickFind Ghost Text
    PERSISTED_PLATFORM_QUICKFIND_GHOSTTEXT: 'persisted.platform.quickfind.ghosttext',
    PERSISTED_LEGACY_CONTENT_REPORT_TASK_ID: 'persisted.legacy-content.report.task-id'
};



const $abd639c20d964dca$export$94c92810ef76851 = 'atlassian';
const $abd639c20d964dca$export$cae0fbb99c422e2 = 'frontend';
const $abd639c20d964dca$export$1b311d1dfe8a9349 = 'localStorage';
const $abd639c20d964dca$export$16f5e866917d6fd1 = 'sessionStorage';


const $505af0297173c4d6$var$serverCacheKeyRegex = /[^A-Za-z0-9\-._\/]/g;
const $505af0297173c4d6$export$7c5eda5500a5f08d = (userId)=>{
    const keys = [];
    let prefix = `${(0, $abd639c20d964dca$export$1b311d1dfe8a9349)}/${(0, $abd639c20d964dca$export$94c92810ef76851)}.${userId}.${(0, $abd639c20d964dca$export$cae0fbb99c422e2)}`;
    prefix = prefix.replace($505af0297173c4d6$var$serverCacheKeyRegex, '_');
    Object.keys((0, $55aebbd7cffee8f3$export$84dce893719feb44)).forEach((key)=>keys.push(`${prefix}.${(0, $55aebbd7cffee8f3$export$84dce893719feb44)[key]}`));
    return keys;
};
const $505af0297173c4d6$export$902ba6ec74c93f9d = (key, cacheKey)=>{
    if (Object.values((0, $55aebbd7cffee8f3$export$84dce893719feb44)).indexOf(key) > -1) cacheKey = cacheKey.replace($505af0297173c4d6$var$serverCacheKeyRegex, '_');
    return cacheKey;
};


const $a0a079aa648eb079$var$logger = (0, $a6897acd40ed68b1$export$2b1d391cd05230fd)('storage-manager');
const $a0a079aa648eb079$var$localStorageMigrationEntriesKey = 'localstorage-migration-entries';
function $a0a079aa648eb079$export$4fc2001188ec893d(error) {
    if (error && 'code' in error) switch(error.code){
        case 22:
            return true;
        case 1014:
            // Firefox
            if (error.name === 'NS_ERROR_DOM_QUOTA_REACHED') return true;
            break;
        default:
            return false;
    }
    return false;
}
function $a0a079aa648eb079$export$b4ff986ecbd5f7f2(value) {
    if (!value) return value;
    try {
        return JSON.parse(value);
    } catch (_) {
        return value;
    }
}
class $a0a079aa648eb079$export$93525d6e221593cb {
    /**
   * PRIVATE Does not trigger Init
   * creates a prefix for a value
   */ _getPrefix(seconds) {
        const milliseconds = (seconds || 0) * 1000;
        if (!milliseconds) return '';
        return Date.now() + milliseconds + this._delimiter;
    }
    constructor(storageManager, prefix, id, storagePrefix, { userId: userId, isLicensed: isLicensed }){
        this._storageManager = void 0;
        this._delimiter = '#';
        this._namespace = void 0;
        this._userId = void 0;
        this._isLicensedUser = void 0;
        this._hasQuotaErrorBeenSubmitted = false;
        this._persistSetValue = (originalKey, value, persistKey)=>{
            // there is a cyclic dependency with @confluence/graphql
            // communicate local/session storage update to cc-bandana
            if (Object.values((0, $55aebbd7cffee8f3$export$84dce893719feb44)).indexOf(originalKey) > -1 && !sessionStorage.getItem('confluence.disable-persisted-storage-for-tests') && window['GLOBAL_APOLLO_CLIENT'] && this._userId && this._isLicensedUser) {
                const mutationVariables = {
                    storageinput: {
                        stringValues: [
                            {
                                key: persistKey,
                                value: value
                            }
                        ]
                    },
                    stringKeys: [
                        persistKey
                    ]
                };
                window['GLOBAL_APOLLO_CLIENT'].mutate({
                    mutation: (0, $0a711c922c37c686$export$359ef83116415c8a),
                    variables: mutationVariables
                }).catch((e)=>{
                    this._submitError(e, `Error updating user preferences with key ${originalKey} and value ${value}: ${e}`);
                });
            }
        };
        /**
     * Gets the item stored in local storage for the given key. null is returned if it doesn't exist.
     * Note that this method will always return a string representation of what is stored.
     */ this.getItem = (key)=>{
            if (!this._storageManager) {
                $a0a079aa648eb079$var$logger.warn`Local/session storage not supported on browser`;
                return null;
            }
            try {
                const cacheKey = (0, $505af0297173c4d6$export$902ba6ec74c93f9d)(key, `${this._namespace}.${key}`);
                let item;
                if ((0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_browser_storage_controls')) item = this._storageManager.getItem(key);
                else {
                    item = this._storageManager.getItem(cacheKey);
                    /**
           * Currently some keys from independent usages of native local/session storage
          	 were adding keys without namespace. This helps cleanup those keys and return the
          	values for those keys if they exist
          * Once we stop seeing increments in counter in metrics for localStorageMigrationEntriesKey
          		we can remove this logic*/ if (!item) {
                        item = this._storageManager.getItem(key);
                        if (item) {
                            this._incrementLocalStorageMigrationEntries();
                            this.setItem(key, item);
                            this._storageManager.removeItem(`${key}`);
                        }
                    }
                }
                if (item) {
                    item = $a0a079aa648eb079$export$b4ff986ecbd5f7f2(item);
                    let match;
                    const prefixMatch = /(\d+)#/;
                    if (typeof item === 'string' && (match = prefixMatch.exec(item))) {
                        const itemWithStrippedExpirationPrefix = item.replace(match[0], '');
                        const expirationTimestamp = parseInt(match[1], 10);
                        const isExpired = !isNaN(expirationTimestamp) && Date.now() > expirationTimestamp;
                        if (isExpired) {
                            this.removeItem(key);
                            return null;
                        }
                        return itemWithStrippedExpirationPrefix;
                    }
                    return item;
                }
                return null;
            } catch (e) {
                this._submitError(e, `Error getting value from storage manager for key:${key} : ${e}`);
                return null;
            }
        };
        this.getAndRemoveItem = (key)=>{
            if (!this._storageManager) {
                $a0a079aa648eb079$var$logger.warn`Local/session storage not supported on browser`;
                return null;
            }
            try {
                const item = this.getItem(key);
                if (item) {
                    this.removeItem(key);
                    return item;
                }
                return null;
            } catch (e) {
                this._submitError(e, `Error getting and removing value from storage manager for key:${key} : ${e}`);
                return null;
            }
        };
        /**
     * Get all the items in local storage that are bound to the given context.
     */ this.getAllItems = ()=>{
            const items = {};
            if (!this._storageManager) {
                $a0a079aa648eb079$var$logger.warn`Local/session storage not supported on browser`;
                return items;
            }
            const length = this._storageManager.length;
            // Currently getAllItems is unsupported if _storageManager is AtlBrowserStorage,
            // which retrieves length differently
            if (typeof length !== 'number') return items;
            try {
                for(let i = 0; i < length; i++){
                    const itemKey = this._storageManager.key(i);
                    if (itemKey && itemKey.includes(`${this._namespace}.`)) {
                        const keyWithoutNamespace = itemKey.split(`${this._namespace}.`)[1];
                        const rawItemValue = this._storageManager.getItem(itemKey);
                        items[keyWithoutNamespace] = $a0a079aa648eb079$export$b4ff986ecbd5f7f2(rawItemValue);
                    }
                }
                return items;
            } catch (e) {
                this._submitError(e, `Error getting all items from storage manager : ${e}`);
                return items;
            }
        };
        /**
     * Returns a boolean to let you know if we contain a key that matches, and has not expired.
     */ this.doesContain = (key)=>{
            if (!this._storageManager) {
                $a0a079aa648eb079$var$logger.warn`Local/session storage not supported on browser`;
                return false;
            }
            try {
                const value = this.getItem(key);
                return typeof value === 'boolean' ? !value : !!value;
            } catch (e) {
                this._submitError(e, `Error getting value from storage manager for key ${key}: ${e}`);
                return false;
            }
        };
        /**
     * Gets the item stored in local storage for the given key and returns the boolean value of it.
     * It correctly convert the "true" and "false" strings to return true/false booleans.
     */ this.getItemAsBoolean = (key)=>{
            if (!this._storageManager) {
                $a0a079aa648eb079$var$logger.warn`Local/session storage not supported on browser`;
                return false;
            }
            try {
                const value = this.getItem(key);
                if (value && typeof value === 'string' && value.indexOf('false') >= 0) return false;
                if (value && typeof value === 'string' && value.indexOf('true') >= 0) return true;
                return !!value;
            } catch (e) {
                this._submitError(e, `Error getting value as boolean from storage manager for key ${key}: ${e}`);
                return false;
            }
        };
        /**
     * synchronously sets a value
     * @param expire expiration time in seconds
     * @returns {string}
     */ this.setItem = (key, value, expire)=>{
            if (!this._storageManager) {
                $a0a079aa648eb079$var$logger.warn`Local/session storage not supported on browser`;
                return null;
            }
            try {
                const cacheKey = (0, $505af0297173c4d6$export$902ba6ec74c93f9d)(key, `${this._namespace}.${key}`);
                // If it's not an object then append prefix.
                if (typeof value !== 'object') value = `${this._getPrefix(expire)}${value}`;
                value = JSON.stringify(value);
                // Use original key to call AtlBrowserStorage setItem, because only the original key is registered
                if ((0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_browser_storage_controls')) {
                    const processSetItem = this._storageManager.setItem(key, value);
                    processSetItem?.then(()=>{
                        // Currently AtlBrowserStorage setItem does not return SUCCESS or BLOCKED,
                        // so we check the successful status by calling getItem
                        // only persist the value if the setItem was successful
                        const isSuccessful = this._storageManager && this._storageManager.getItem(key);
                        if (isSuccessful) this._persistSetValue(key, value, cacheKey);
                    });
                } else {
                    this._storageManager.setItem(cacheKey, value);
                    this._persistSetValue(key, value, cacheKey);
                }
                return JSON.parse(value);
            } catch (e) {
                if ($a0a079aa648eb079$export$4fc2001188ec893d(e)) {
                    // for "quota exceeded" errors we're re-massaging the error message to exclude `this._namespace`
                    // DOMException properties are read-only, so we can't just modify them inline, see https://developer.mozilla.org/en-US/docs/Web/API/DOMException
                    if (!this._hasQuotaErrorBeenSubmitted) {
                        // we'll only submit "quota exceeded" error to the monitoring systems once per user session -- there isn't really a need to submit all such errors.
                        this._submitError(new Error(`Quota exceeded on key "${key}"`));
                        this._hasQuotaErrorBeenSubmitted = true;
                    }
                    $a0a079aa648eb079$var$logger.error`Storage quota exceeded when for key ${key} and value ${value}; original error: ${e}`;
                } else this._submitError(e, `Error setting value from storage manager with key ${key} and value ${value}: ${e}`);
                return null;
            }
        };
        /**
     * Removes a Key from the Store
     */ this.removeItem = (key)=>{
            if (!this._storageManager) {
                $a0a079aa648eb079$var$logger.warn`Local/session storage not supported on browser`;
                return;
            }
            try {
                const cacheKey = (0, $505af0297173c4d6$export$902ba6ec74c93f9d)(key, `${this._namespace}.${key}`);
                if ((0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_browser_storage_controls')) this._storageManager.removeItem(`${key}`);
                else this._storageManager.removeItem(`${cacheKey}`);
                return;
            } catch (e) {
                this._submitError(e, `Error removing value from storage manager for key ${key}: ${e}`);
                return;
            }
        };
        this.initializeFromServer = (results)=>{
            if (!Array.isArray(results)) return;
            if (sessionStorage.getItem('confluence.disable-persisted-storage-for-tests')) return;
            try {
                if ((0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_browser_storage_controls')) results.forEach((val)=>{
                    const originalKey = val?.key?.replace(`${this._namespace}.`, '');
                    if (this._storageManager && originalKey) this._storageManager.setItem(originalKey, val.value);
                });
                else results.forEach((val)=>this._storageManager && this._storageManager.setItem(val.key, val.value));
            } catch (e) {
                if ($a0a079aa648eb079$export$4fc2001188ec893d(e)) this._submitError(new Error('Quota exceeded on intializing persisted values from server'));
                else this._submitError(e, `Error setting value from storage manager while initializing persisted values from server: ${e}`);
            }
        };
        this._submitError = (e, message)=>{
            if (message) $a0a079aa648eb079$var$logger.error`${message}`;
            (0, $d1c1e8e192b1a688$export$39a3b7739331403b)().submitError(e, {
                attribution: 'unknown'
            });
        };
        this._incrementLocalStorageMigrationEntries = ()=>{
            (0, $d1c1e8e192b1a688$export$39a3b7739331403b)().incrementCounter($a0a079aa648eb079$var$localStorageMigrationEntriesKey);
        };
        this._storageManager = storageManager;
        this._namespace = userId ? `${storagePrefix}/${prefix}.${userId}.${id}` : `${storagePrefix}/null`;
        this._userId = userId;
        this._isLicensedUser = isLicensed ?? false;
    }
}







var $b4b9136780ae841d$export$c32b36f46293e67b = /*#__PURE__*/ function(MicrosEnvironmentType) {
    MicrosEnvironmentType["local"] = "local";
    MicrosEnvironmentType["dev"] = "dev";
    MicrosEnvironmentType["staging"] = "staging";
    MicrosEnvironmentType["prod"] = "prod";
    return MicrosEnvironmentType;
}({});
const $b4b9136780ae841d$export$6dd1bbd39f571125 = ()=>false;
const $b4b9136780ae841d$export$23da1d24a38b0bde = ()=>globalThis.ssrContext.environmentType === "staging";
const $b4b9136780ae841d$export$64471597a28217e6 = ()=>$b4b9136780ae841d$export$6dd1bbd39f571125() || $b4b9136780ae841d$export$23da1d24a38b0bde() || globalThis.ssrContext.environmentType === "dev";
const $b4b9136780ae841d$export$4bd44a2aa29d3d6e = ()=>globalThis.ssrContext.environment;
const $b4b9136780ae841d$export$1038046b28a1d92e = ()=>globalThis.ssrContext.environmentType;
const $b4b9136780ae841d$export$94e128262c4fa6c3 = ()=>globalThis.ssrContext.entryScriptVersionId;


const $4ecd5830b37ff119$export$72dc662ac05b1fbb = `
  query LocalStorageQuery($stringKeys: [String]!) {
    localStorage {
      stringValues(keys: $stringKeys) {
        key
        value
      }
    }
  }
`;



async function $2123323c5a3599df$export$efc60d6604f5fc7a({ userId: userId, isLicensed: isLicensed }) {
    if (window['__REMOTE_LOCAL_STORAGE__']) return window['__REMOTE_LOCAL_STORAGE__'];
    const URI = (0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('cc-agg-migration-use-agg-endpoint') ? '/gateway/api/graphql/slow' : window['GLOBAL_APOLLO_CLIENT_URI'] || '/cgraphql';
    return window['__REMOTE_LOCAL_STORAGE__'] = (0, $47c7a260b3a5dfb3$export$5467c8c7fa0f4d06).run('ssr-app/prepare/preloadQuery/fetch:LocalStorageQuery', async ()=>{
        let result = null;
        try {
            if (isLicensed && userId) {
                const variables = {
                    stringKeys: (0, $505af0297173c4d6$export$7c5eda5500a5f08d)(userId)
                };
                const res = await (0, $b9f93b053c525d82$export$7fd82c6bb3f5e7d5)(`${URI}?q=LocalStorageQuery`, {
                    method: 'POST',
                    credentials: 'include',
                    headers: {
                        'X-APOLLO-OPERATION-NAME': 'LocalStorageQuery',
                        'Content-Type': 'application/json',
                        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
                        ...Boolean(undefined) && Boolean(undefined) && !(0, $b4b9136780ae841d$export$6dd1bbd39f571125)() ? {
                            'x-ssr-asap-audience': 'cc-graphql'
                        } : {}
                    },
                    body: JSON.stringify({
                        operationName: 'LocalStorageQuery',
                        query: (0, $4ecd5830b37ff119$export$72dc662ac05b1fbb),
                        variables: variables
                    })
                });
                if (res.ok) {
                    const { data: data } = await res.json();
                    result = data?.localStorage?.stringValues;
                }
            }
        } catch (e) {}
        return window['__REMOTE_LOCAL_STORAGE__'] = result;
    });
}


// check if local and session storage are valid
const $8b7debc8685a2ab6$var$isStorageValid = (storage)=>{
    try {
        return typeof storage !== 'undefined' && 'setItem' in storage && // in IE8 typeof localStorage.setItem === 'object'
        !!storage.setItem;
    } catch (e) {
        return false;
    }
};
const $8b7debc8685a2ab6$var$getStorage = (type)=>{
    if (typeof window === 'object' && $8b7debc8685a2ab6$var$isStorageValid(window[type])) return window[type];
    return null;
};
let $8b7debc8685a2ab6$export$7691d7c35a352a10;
let $8b7debc8685a2ab6$export$fb051bd2501e65b3;
const $8b7debc8685a2ab6$export$68017d60ff81319c = async (initializationData)=>{
    let confluenceLocalStorage = null;
    let confluenceSessionStorage = null;
    if ((0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_browser_storage_controls')) {
        confluenceLocalStorage = (0, $548b5fa8d036d961$export$c8cc3ffd3f2c1d2f);
        confluenceSessionStorage = (0, $548b5fa8d036d961$export$edbae459bdf957a5);
    } else {
        confluenceLocalStorage = $8b7debc8685a2ab6$var$getStorage('localStorage');
        confluenceSessionStorage = $8b7debc8685a2ab6$var$getStorage('sessionStorage');
    }
    $8b7debc8685a2ab6$export$7691d7c35a352a10 = new (0, $a0a079aa648eb079$export$93525d6e221593cb)(confluenceLocalStorage, (0, $abd639c20d964dca$export$94c92810ef76851), (0, $abd639c20d964dca$export$cae0fbb99c422e2), (0, $abd639c20d964dca$export$1b311d1dfe8a9349), initializationData);
    $8b7debc8685a2ab6$export$fb051bd2501e65b3 = new (0, $a0a079aa648eb079$export$93525d6e221593cb)(confluenceSessionStorage, (0, $abd639c20d964dca$export$94c92810ef76851), (0, $abd639c20d964dca$export$cae0fbb99c422e2), (0, $abd639c20d964dca$export$16f5e866917d6fd1), initializationData);
    const result = await (0, $2123323c5a3599df$export$efc60d6604f5fc7a)(initializationData);
    if (result) $8b7debc8685a2ab6$export$7691d7c35a352a10.initializeFromServer(result);
};





function $91b99f9a21467aa8$export$74f458e787dc59ff() {
    if ((0, $ef003bca5ae3d837$export$9db1624a8af791a4)('confluence_enable_react-compiler-runtime-1', 'isEnabled', false)) return true;
    return false;
}


var $90332d3d6df1e1ff$exports = {};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @lightSyntaxTransform
 * @noflow
 * @nolint
 * @preventMunge
 * @preserve-invariant-messages
 */ "use no memo";
"use strict";
var $90332d3d6df1e1ff$var$__create = Object.create;
var $90332d3d6df1e1ff$var$__defProp = Object.defineProperty;
var $90332d3d6df1e1ff$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $90332d3d6df1e1ff$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $90332d3d6df1e1ff$var$__getProtoOf = Object.getPrototypeOf;
var $90332d3d6df1e1ff$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $90332d3d6df1e1ff$var$__export = (target, all)=>{
    for(var name in all)$90332d3d6df1e1ff$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $90332d3d6df1e1ff$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $90332d3d6df1e1ff$var$__getOwnPropNames(from))if (!$90332d3d6df1e1ff$var$__hasOwnProp.call(to, key) && key !== except) $90332d3d6df1e1ff$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $90332d3d6df1e1ff$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $90332d3d6df1e1ff$var$__toESM = (mod, isNodeMode, target)=>(target = mod != null ? $90332d3d6df1e1ff$var$__create($90332d3d6df1e1ff$var$__getProtoOf(mod)) : {}, $90332d3d6df1e1ff$var$__copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? $90332d3d6df1e1ff$var$__defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod));
var $90332d3d6df1e1ff$var$__toCommonJS = (mod)=>$90332d3d6df1e1ff$var$__copyProps($90332d3d6df1e1ff$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
// src/index.ts
var $90332d3d6df1e1ff$var$index_exports = {};
$90332d3d6df1e1ff$var$__export($90332d3d6df1e1ff$var$index_exports, {
    $dispatcherGuard: ()=>$90332d3d6df1e1ff$var$$dispatcherGuard,
    $makeReadOnly: ()=>$90332d3d6df1e1ff$var$$makeReadOnly,
    $reset: ()=>$90332d3d6df1e1ff$var$$reset,
    $structuralCheck: ()=>$90332d3d6df1e1ff$var$$structuralCheck,
    c: ()=>$90332d3d6df1e1ff$var$c,
    clearRenderCounterRegistry: ()=>$90332d3d6df1e1ff$var$clearRenderCounterRegistry,
    renderCounterRegistry: ()=>$90332d3d6df1e1ff$var$renderCounterRegistry,
    useRenderCounter: ()=>$90332d3d6df1e1ff$var$useRenderCounter
});
$90332d3d6df1e1ff$exports = $90332d3d6df1e1ff$var$__toCommonJS($90332d3d6df1e1ff$var$index_exports);

var $90332d3d6df1e1ff$var$React = $90332d3d6df1e1ff$var$__toESM((parcelRequire("dQwsT")));
var { useRef: $90332d3d6df1e1ff$var$useRef, useEffect: $90332d3d6df1e1ff$var$useEffect, isValidElement: $90332d3d6df1e1ff$var$isValidElement } = $90332d3d6df1e1ff$var$React;
var $90332d3d6df1e1ff$var$_a;
var $90332d3d6df1e1ff$var$ReactSecretInternals = //@ts-ignore
($90332d3d6df1e1ff$var$_a = $90332d3d6df1e1ff$var$React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE) != null ? $90332d3d6df1e1ff$var$_a : $90332d3d6df1e1ff$var$React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
var $90332d3d6df1e1ff$var$$empty = Symbol.for("react.memo_cache_sentinel");
var $90332d3d6df1e1ff$var$_a2;
var $90332d3d6df1e1ff$var$c = // @ts-expect-error
typeof (($90332d3d6df1e1ff$var$_a2 = $90332d3d6df1e1ff$var$React.__COMPILER_RUNTIME) == null ? void 0 : $90332d3d6df1e1ff$var$_a2.c) === "function" ? // @ts-expect-error
$90332d3d6df1e1ff$var$React.__COMPILER_RUNTIME.c : function c2(size) {
    return $90332d3d6df1e1ff$var$React.useMemo(()=>{
        const $ = new Array(size);
        for(let ii = 0; ii < size; ii++)$[ii] = $90332d3d6df1e1ff$var$$empty;
        $[$90332d3d6df1e1ff$var$$empty] = true;
        return $;
    }, []);
};
var $90332d3d6df1e1ff$var$LazyGuardDispatcher = {};
[
    "readContext",
    "useCallback",
    "useContext",
    "useEffect",
    "useImperativeHandle",
    "useInsertionEffect",
    "useLayoutEffect",
    "useMemo",
    "useReducer",
    "useRef",
    "useState",
    "useDebugValue",
    "useDeferredValue",
    "useTransition",
    "useMutableSource",
    "useSyncExternalStore",
    "useId",
    "unstable_isNewReconciler",
    "getCacheSignal",
    "getCacheForType",
    "useCacheRefresh"
].forEach((name)=>{
    $90332d3d6df1e1ff$var$LazyGuardDispatcher[name] = ()=>{
        throw new Error(`[React] Unexpected React hook call (${name}) from a React compiled function. Check that all hooks are called directly and named according to convention ('use[A-Z]') `);
    };
});
var $90332d3d6df1e1ff$var$originalDispatcher = null;
$90332d3d6df1e1ff$var$LazyGuardDispatcher["useMemoCache"] = (count)=>{
    if ($90332d3d6df1e1ff$var$originalDispatcher == null) throw new Error("React Compiler internal invariant violation: unexpected null dispatcher");
    else return $90332d3d6df1e1ff$var$originalDispatcher.useMemoCache(count);
};
function $90332d3d6df1e1ff$var$setCurrent(newDispatcher) {
    $90332d3d6df1e1ff$var$ReactSecretInternals.ReactCurrentDispatcher.current = newDispatcher;
    return $90332d3d6df1e1ff$var$ReactSecretInternals.ReactCurrentDispatcher.current;
}
var $90332d3d6df1e1ff$var$guardFrames = [];
function $90332d3d6df1e1ff$var$$dispatcherGuard(kind) {
    const curr = $90332d3d6df1e1ff$var$ReactSecretInternals.ReactCurrentDispatcher.current;
    if (kind === 0 /* PushGuardContext */ ) {
        $90332d3d6df1e1ff$var$guardFrames.push(curr);
        if ($90332d3d6df1e1ff$var$guardFrames.length === 1) $90332d3d6df1e1ff$var$originalDispatcher = curr;
        if (curr === $90332d3d6df1e1ff$var$LazyGuardDispatcher) throw new Error(`[React] Unexpected call to custom hook or component from a React compiled function. Check that (1) all hooks are called directly and named according to convention ('use[A-Z]') and (2) components are returned as JSX instead of being directly invoked.`);
        $90332d3d6df1e1ff$var$setCurrent($90332d3d6df1e1ff$var$LazyGuardDispatcher);
    } else if (kind === 1 /* PopGuardContext */ ) {
        const lastFrame = $90332d3d6df1e1ff$var$guardFrames.pop();
        if (lastFrame == null) throw new Error("React Compiler internal error: unexpected null in guard stack");
        if ($90332d3d6df1e1ff$var$guardFrames.length === 0) $90332d3d6df1e1ff$var$originalDispatcher = null;
        $90332d3d6df1e1ff$var$setCurrent(lastFrame);
    } else if (kind === 2 /* PushExpectHook */ ) {
        $90332d3d6df1e1ff$var$guardFrames.push(curr);
        $90332d3d6df1e1ff$var$setCurrent($90332d3d6df1e1ff$var$originalDispatcher);
    } else if (kind === 3 /* PopExpectHook */ ) {
        const lastFrame = $90332d3d6df1e1ff$var$guardFrames.pop();
        if (lastFrame == null) throw new Error("React Compiler internal error: unexpected null in guard stack");
        $90332d3d6df1e1ff$var$setCurrent(lastFrame);
    } else throw new Error("React Compiler internal error: unreachable block" + kind);
}
function $90332d3d6df1e1ff$var$$reset($) {
    for(let ii = 0; ii < $.length; ii++)$[ii] = $90332d3d6df1e1ff$var$$empty;
}
function $90332d3d6df1e1ff$var$$makeReadOnly() {
    throw new Error("TODO: implement $makeReadOnly in react-compiler-runtime");
}
var $90332d3d6df1e1ff$var$renderCounterRegistry = /* @__PURE__ */ new Map();
function $90332d3d6df1e1ff$var$clearRenderCounterRegistry() {
    for (const counters of $90332d3d6df1e1ff$var$renderCounterRegistry.values())counters.forEach((counter)=>{
        counter.count = 0;
    });
}
function $90332d3d6df1e1ff$var$registerRenderCounter(name, val) {
    let counters = $90332d3d6df1e1ff$var$renderCounterRegistry.get(name);
    if (counters == null) {
        counters = /* @__PURE__ */ new Set();
        $90332d3d6df1e1ff$var$renderCounterRegistry.set(name, counters);
    }
    counters.add(val);
}
function $90332d3d6df1e1ff$var$removeRenderCounter(name, val) {
    const counters = $90332d3d6df1e1ff$var$renderCounterRegistry.get(name);
    if (counters == null) return;
    counters.delete(val);
}
function $90332d3d6df1e1ff$var$useRenderCounter(name) {
    const val = $90332d3d6df1e1ff$var$useRef(null);
    if (val.current != null) val.current.count += 1;
    $90332d3d6df1e1ff$var$useEffect(()=>{
        if (val.current == null) {
            const counter = {
                count: 0
            };
            $90332d3d6df1e1ff$var$registerRenderCounter(name, counter);
            val.current = counter;
        }
        return ()=>{
            if (val.current !== null) $90332d3d6df1e1ff$var$removeRenderCounter(name, val.current);
        };
    });
}
var $90332d3d6df1e1ff$var$seenErrors = /* @__PURE__ */ new Set();
function $90332d3d6df1e1ff$var$$structuralCheck(oldValue, newValue, variableName, fnName, kind, loc) {
    function error(l, r, path, depth) {
        const str = `${fnName}:${loc} [${kind}] ${variableName}${path} changed from ${l} to ${r} at depth ${depth}`;
        if ($90332d3d6df1e1ff$var$seenErrors.has(str)) return;
        $90332d3d6df1e1ff$var$seenErrors.add(str);
        console.error(str);
    }
    const depthLimit = 2;
    function recur(oldValue2, newValue2, path, depth) {
        if (depth > depthLimit) return;
        else if (oldValue2 === newValue2) return;
        else if (typeof oldValue2 !== typeof newValue2) error(`type ${typeof oldValue2}`, `type ${typeof newValue2}`, path, depth);
        else if (typeof oldValue2 === "object") {
            const oldArray = Array.isArray(oldValue2);
            const newArray = Array.isArray(newValue2);
            if (oldValue2 === null && newValue2 !== null) error("null", `type ${typeof newValue2}`, path, depth);
            else if (newValue2 === null) error(`type ${typeof oldValue2}`, "null", path, depth);
            else if (oldValue2 instanceof Map) {
                if (!(newValue2 instanceof Map)) error(`Map instance`, `other value`, path, depth);
                else if (oldValue2.size !== newValue2.size) error(`Map instance with size ${oldValue2.size}`, `Map instance with size ${newValue2.size}`, path, depth);
                else {
                    for (const [k, v] of oldValue2)if (!newValue2.has(k)) error(`Map instance with key ${k}`, `Map instance without key ${k}`, path, depth);
                    else recur(v, newValue2.get(k), `${path}.get(${k})`, depth + 1);
                }
            } else if (newValue2 instanceof Map) error("other value", `Map instance`, path, depth);
            else if (oldValue2 instanceof Set) {
                if (!(newValue2 instanceof Set)) error(`Set instance`, `other value`, path, depth);
                else if (oldValue2.size !== newValue2.size) error(`Set instance with size ${oldValue2.size}`, `Set instance with size ${newValue2.size}`, path, depth);
                else {
                    for (const v of newValue2)if (!oldValue2.has(v)) error(`Set instance without element ${v}`, `Set instance with element ${v}`, path, depth);
                }
            } else if (newValue2 instanceof Set) error("other value", `Set instance`, path, depth);
            else if (oldArray || newArray) {
                if (oldArray !== newArray) error(`type ${oldArray ? "array" : "object"}`, `type ${newArray ? "array" : "object"}`, path, depth);
                else if (oldValue2.length !== newValue2.length) error(`array with length ${oldValue2.length}`, `array with length ${newValue2.length}`, path, depth);
                else for(let ii = 0; ii < oldValue2.length; ii++)recur(oldValue2[ii], newValue2[ii], `${path}[${ii}]`, depth + 1);
            } else if ($90332d3d6df1e1ff$var$isValidElement(oldValue2) || $90332d3d6df1e1ff$var$isValidElement(newValue2)) {
                if ($90332d3d6df1e1ff$var$isValidElement(oldValue2) !== $90332d3d6df1e1ff$var$isValidElement(newValue2)) error(`type ${$90332d3d6df1e1ff$var$isValidElement(oldValue2) ? "React element" : "object"}`, `type ${$90332d3d6df1e1ff$var$isValidElement(newValue2) ? "React element" : "object"}`, path, depth);
                else if (oldValue2.type !== newValue2.type) error(`React element of type ${oldValue2.type}`, `React element of type ${newValue2.type}`, path, depth);
                else recur(oldValue2.props, newValue2.props, `[props of ${path}]`, depth + 1);
            } else {
                for(const key in newValue2)if (!(key in oldValue2)) error(`object without key ${key}`, `object with key ${key}`, path, depth);
                for(const key in oldValue2)if (!(key in newValue2)) error(`object with key ${key}`, `object without key ${key}`, path, depth);
                else recur(oldValue2[key], newValue2[key], `${path}.${key}`, depth + 1);
            }
        } else if (typeof oldValue2 === "function") return;
        else if (isNaN(oldValue2) || isNaN(newValue2)) {
            if (isNaN(oldValue2) !== isNaN(newValue2)) error(`${isNaN(oldValue2) ? "NaN" : "non-NaN value"}`, `${isNaN(newValue2) ? "NaN" : "non-NaN value"}`, path, depth);
        } else if (oldValue2 !== newValue2) error(oldValue2, newValue2, path, depth);
    }
    recur(oldValue, newValue, "", 0);
}



var $9pfwj = parcelRequire("9pfwj");

var $dQwsT = parcelRequire("dQwsT");

var $dQwsT = parcelRequire("dQwsT");
var $08f286eca1f2bd54$exports = {};
'use strict';

$08f286eca1f2bd54$exports = (parcelRequire("6oozB"));



var $dQwsT = parcelRequire("dQwsT");
const $306672eb477c319b$var$supports = {
    scheduling () {
        return typeof window !== 'undefined' && typeof MessageChannel === 'function';
    }
};
var $306672eb477c319b$export$2e2bcd8739ae039 = $306672eb477c319b$var$supports;



var $dQwsT = parcelRequire("dQwsT");
const $c592f8e826637ea0$var$defaultMutator = (prevState, partialState)=>{
    // Merge the partial state and the previous state.
    return Object.assign({}, prevState, partialState);
};
const $c592f8e826637ea0$var$defaults = {
    batchUpdates: 'useSyncExternalStore' in (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))),
    devtools: false,
    middlewares: new Set(),
    mutator: $c592f8e826637ea0$var$defaultMutator
};
var $c592f8e826637ea0$export$2e2bcd8739ae039 = $c592f8e826637ea0$var$defaults;


const $87966d65a56a48ea$var$namedMutator = (storeState, actionName)=>function() {
        storeState.mutator.actionName = actionName;
        return storeState.mutator(...arguments);
    };
const $87966d65a56a48ea$var$warnings = new WeakMap();
const $87966d65a56a48ea$export$5f944353e69b9bf3 = (storeState, actionFn, actionKey, config, actions)=>{
    const callThunk = (instance, thunkFn, actionName)=>thunkFn({
            setState: (0, $c592f8e826637ea0$export$2e2bcd8739ae039).devtools ? $87966d65a56a48ea$var$namedMutator(instance.storeState, actionName) : instance.storeState.mutator,
            getState: instance.storeState.getState,
            get actions () {
                if (!$87966d65a56a48ea$var$warnings.has(actionFn)) $87966d65a56a48ea$var$warnings.set(actionFn, console.warn(`react-sweet-state 'actions' property has been deprecated and will be removed in the next mayor. ` + `Please check action '${actionName}' of Store '${instance.storeState.key}' and use 'dispatch' instead`));
                return actions;
            },
            dispatch: (tFn)=>callThunk(instance, tFn, `${actionName}.dispatch`)
        }, config.props());
    return function() {
        return callThunk({
            storeState: storeState,
            actions: actions
        }, actionFn(...arguments), actionKey);
    };
};
const $87966d65a56a48ea$export$5ee1d46cd0883a22 = function bindActions(actions, storeState, config, boundActions) {
    if (boundActions === void 0) boundActions = null;
    return Object.keys(actions).reduce((acc, k)=>{
        acc[k] = $87966d65a56a48ea$export$5f944353e69b9bf3(storeState, actions[k], k, config, boundActions || acc);
        return acc;
    }, {});
};



// Mostly copied from fbjs/packages/fbjs/src/core/shallowEqual.js
// enhanced with keys cache as might get called multiple times with same args
const $234874cb82722593$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $234874cb82722593$var$CACHE = new WeakMap();
function $234874cb82722593$export$2e2bcd8739ae039(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    if (Array.isArray(objA) && Array.isArray(objB)) {
        // do array comparison
        if (objA.length !== objB.length) return false;
        for(let i = 0; i < objA.length; i++){
            if (objA[i] !== objB[i]) return false;
        }
        return true;
    } else {
        // Handle Date, RegExp, String, Number, ... and complex objects
        const strA = '' + objA;
        const strB = '' + objB;
        if (strA !== strB || strA[0] === '[' && strA !== '[object Object]') return false;
         // do object comparison
        let keysA;
        if ($234874cb82722593$var$CACHE.has(objA)) keysA = $234874cb82722593$var$CACHE.get(objA);
        else {
            keysA = Object.keys(objA);
            $234874cb82722593$var$CACHE.set(objA, keysA);
        }
        let keysB;
        if ($234874cb82722593$var$CACHE.has(objB)) keysB = $234874cb82722593$var$CACHE.get(objB);
        else {
            keysB = Object.keys(objB);
            $234874cb82722593$var$CACHE.set(objB, keysB);
        }
        if (keysA.length !== keysB.length) return false;
         // Test for A's keys different from B.
        for(let i = 0; i < keysA.length; i++){
            if (!$234874cb82722593$var$hasOwnProperty.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
        }
        return true;
    }
}


const $a608d95a23f7f112$var$updateMiddleware = (storeState)=>(next)=>(arg)=>{
            let output;
            const state = storeState.getState();
            const nextState = next(state, arg, (out)=>{
                output = out;
            });
            if (!(0, $234874cb82722593$export$2e2bcd8739ae039)(nextState, state)) storeState.setState(nextState);
            return output;
        };
var $a608d95a23f7f112$export$2e2bcd8739ae039 = $a608d95a23f7f112$var$updateMiddleware;


const $8b163ddd3f615f0a$var$applyMiddleware = (storeState, middlewares)=>Array.from(middlewares).concat((0, $a608d95a23f7f112$export$2e2bcd8739ae039)).reduceRight((next, mw)=>mw(storeState)(next), (0, $c592f8e826637ea0$export$2e2bcd8739ae039).mutator);
var $8b163ddd3f615f0a$export$2e2bcd8739ae039 = $8b163ddd3f615f0a$var$applyMiddleware;



const $39911b43c24532d7$var$connectDevTools = (storeState, config)=>{
    const devTools = window.__REDUX_DEVTOOLS_EXTENSION__.connect(Object.assign({
        name: `Store ${storeState.key}`,
        serialize: true,
        trace: true
    }, config));
    devTools.init(storeState.getState());
    devTools.subscribe((message)=>{
        if (message.type === 'DISPATCH') switch(message.payload.type){
            case 'RESET':
                storeState.resetState();
                devTools.init(storeState.getState());
                return;
            case 'COMMIT':
                devTools.init(storeState.getState());
                return;
            case 'ROLLBACK':
                storeState.setState(JSON.parse(message.state));
                devTools.init(storeState.getState());
                return;
            case 'JUMP_TO_STATE':
            case 'JUMP_TO_ACTION':
                storeState.setState(JSON.parse(message.state));
                return;
        }
        else if (message.type === 'ACTION') {
            let action = JSON.parse(message.payload);
            storeState.setState(action.payload);
        }
    });
    return devTools;
};
const $39911b43c24532d7$var$withDevtools = (createStoreState)=>function() {
        const storeState = createStoreState(...arguments);
        if ((0, $c592f8e826637ea0$export$2e2bcd8739ae039).devtools && window && window.__REDUX_DEVTOOLS_EXTENSION__) {
            const origMutator = storeState.mutator;
            let devTools;
            const devtoolMutator = (arg)=>{
                const result = origMutator(arg);
                try {
                    if (!devTools) {
                        const config = typeof (0, $c592f8e826637ea0$export$2e2bcd8739ae039).devtools === 'function' ? (0, $c592f8e826637ea0$export$2e2bcd8739ae039).devtools(storeState) : {};
                        devTools = $39911b43c24532d7$var$connectDevTools(storeState, config);
                    }
                    devTools.send({
                        type: storeState.mutator.actionName,
                        payload: arg
                    }, storeState.getState(), {}, storeState.key);
                } catch (err) {
                /* ignore devtools errors */ }
                return result;
            };
            storeState.mutator = devtoolMutator;
        }
        return storeState;
    };
var $39911b43c24532d7$export$2e2bcd8739ae039 = $39911b43c24532d7$var$withDevtools;




/* eslint-disable import/no-unresolved */ 

var $LXjOh = parcelRequire("LXjOh");


let $15e754b8a38d4f8c$var$isInsideBatchedSchedule = false;
function $15e754b8a38d4f8c$export$712ea50be43a7858(fn) {
    // if we are in node/tests or nested schedule
    if (!(0, $c592f8e826637ea0$export$2e2bcd8739ae039).batchUpdates || !(0, $306672eb477c319b$export$2e2bcd8739ae039).scheduling() || $15e754b8a38d4f8c$var$isInsideBatchedSchedule) return (0, $4339cd0fd1740902$exports.unstable_batchedUpdates)(fn);
    $15e754b8a38d4f8c$var$isInsideBatchedSchedule = true; // Use ImmediatePriority as it has -1ms timeout
    // https://github.com/facebook/react/blob/main/packages/scheduler/src/forks/Scheduler.js#L65
    return (0, $LXjOh.unstable_scheduleCallback)((0, $LXjOh.unstable_ImmediatePriority), function scheduleBatchedUpdates() {
        (0, $4339cd0fd1740902$exports.unstable_batchedUpdates)(fn);
        $15e754b8a38d4f8c$var$isInsideBatchedSchedule = false;
    });
}



const $878608da52795b5a$var$QUEUE = [];
let $878608da52795b5a$var$scheduled;
function $878608da52795b5a$export$2e2bcd8739ae039(fn) {
    // if we are in node/tests or feature disabled, make updates sync batched
    if (!(0, $c592f8e826637ea0$export$2e2bcd8739ae039).batchUpdates || !(0, $306672eb477c319b$export$2e2bcd8739ae039).scheduling()) return (0, $15e754b8a38d4f8c$export$712ea50be43a7858)(()=>fn()); // Add to queue if not already there
    // so we avoid multiple notifications to same store listeners
    if (!$878608da52795b5a$var$QUEUE.includes(fn)) $878608da52795b5a$var$QUEUE.push(fn); // if something already started schedule, skip
    if ($878608da52795b5a$var$scheduled) return;
    $878608da52795b5a$var$scheduled = (0, $15e754b8a38d4f8c$export$712ea50be43a7858)(()=>{
        let queueFn;
        while(queueFn = $878608da52795b5a$var$QUEUE.shift())queueFn();
        $878608da52795b5a$var$scheduled = null;
    });
}


function $3124748e7e041628$var$createStoreState(key, initialState) {
    let listeners = new Set();
    let currentState = initialState;
    const storeState = {
        key: key,
        getState () {
            return currentState;
        },
        setState (nextState) {
            currentState = nextState; // Instead of notifying all handlers immediately, we wait next tick
            // so multiple actions affecting the same store gets combined
            (0, $878608da52795b5a$export$2e2bcd8739ae039)(storeState.notify);
        },
        resetState () {
            storeState.setState(initialState);
        },
        notify () {
            for (const listener of listeners)listener(storeState.getState());
        },
        subscribe (listener) {
            listeners.add(listener);
            return function unsubscribe() {
                listeners.delete(listener);
            };
        },
        listeners () {
            return listeners;
        }
    };
    storeState.mutator = (0, $8b163ddd3f615f0a$export$2e2bcd8739ae039)(storeState, (0, $c592f8e826637ea0$export$2e2bcd8739ae039).middlewares);
    return storeState;
}
var $3124748e7e041628$export$2e2bcd8739ae039 = (0, $39911b43c24532d7$export$2e2bcd8739ae039)($3124748e7e041628$var$createStoreState);


const $157295519b762f36$export$e4d628ba0054221b = '__global__';
class $157295519b762f36$export$acb47f32da33501e {
    constructor(defaultScope){
        var _this = this;
        if (defaultScope === void 0) defaultScope = $157295519b762f36$export$e4d628ba0054221b;
        this.stores = new Map();
        this.initStore = (key, Store, config)=>{
            const { initialState: initialState, actions: actions } = Store;
            if (Store.containedBy && !config.contained(Store)) {
                const err = new Error(`Store ${Store.key} should be contained by a container but it is used globally. ` + `While it might still work, it will likely cause unexpected behaviours.`);
                if ((0, $306672eb477c319b$export$2e2bcd8739ae039).scheduling()) Promise.reject(err);
                else throw err;
            }
            const storeState = (0, $3124748e7e041628$export$2e2bcd8739ae039)(key, initialState);
            let boundActions;
            const store = {
                storeState: storeState,
                // these are used only when container-less, so we generate them on-demand
                get actions () {
                    if (!boundActions) boundActions = (0, $87966d65a56a48ea$export$5ee1d46cd0883a22)(actions, storeState, config);
                    return boundActions;
                }
            };
            this.stores.set(key, store);
            return store;
        };
        this.hasStore = function(Store, scopeId) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            const key = _this.generateKey(Store, scopeId);
            return _this.stores.has(key);
        };
        this.getStore = function(Store, scopeId, config) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            if (config === void 0) config = {
                props: ()=>({}),
                contained: ()=>false
            };
            const key = _this.generateKey(Store, scopeId);
            return _this.stores.get(key) || config && _this.initStore(key, Store, config);
        };
        this.deleteStore = function(Store, scopeId) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            const key = _this.generateKey(Store, scopeId);
            _this.stores.delete(key);
        };
        this.generateKey = (Store, scopeId)=>`${Store.key}@${scopeId}`;
        this.defaultScope = defaultScope;
    }
}
const $157295519b762f36$export$9d726ae4880b1060 = new $157295519b762f36$export$acb47f32da33501e();


const $52a623ae27065435$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createContext({
    globalRegistry: (0, $157295519b762f36$export$9d726ae4880b1060),
    retrieveStore: (Store)=>(0, $157295519b762f36$export$9d726ae4880b1060).getStore(Store)
}, ()=>0);



function $3056b88ff4074ed0$var$exactEqual(objA, objB) {
    return objA === objB;
}
function $3056b88ff4074ed0$var$areArgumentsEqual(propsMode, prev, next) {
    if (prev === null || next === null || prev.length !== next.length) return false; // If propsMode and 2 arguments, means it is an input selector
    // and we check for shallow equality on 2nd one to optimise props
    if (propsMode && prev.length === 2) return prev[0] === next[0] && (0, $234874cb82722593$export$2e2bcd8739ae039)(prev[1], next[1]);
    for(let i = 0; i < prev.length; i++){
        if (!$3056b88ff4074ed0$var$exactEqual(prev[i], next[i])) return false;
    }
    return true;
}
function $3056b88ff4074ed0$export$2e2bcd8739ae039(resultFn, propsMode) {
    if (propsMode === void 0) propsMode = false;
    let lastArgs = [];
    let lastResult;
    let calledOnce = false;
    const result = function result() {
        if (calledOnce && $3056b88ff4074ed0$var$areArgumentsEqual(propsMode, arguments, lastArgs)) return lastResult;
        const nextResult = resultFn.apply(this, arguments);
        if (!propsMode && (0, $234874cb82722593$export$2e2bcd8739ae039)(nextResult, lastResult)) return lastResult;
        lastResult = nextResult;
        calledOnce = true;
        lastArgs = arguments;
        return lastResult;
    };
    return result;
}


function $2842c9d9216d1caf$export$595d22ed68ca2841() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    const resultFunc = funcs.pop();
    const dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    const memoizedResultFunc = (0, $3056b88ff4074ed0$export$2e2bcd8739ae039)(function() {
        return resultFunc.apply(null, arguments);
    }); // this memoisation is optimised for 2 arguments (state, props)
    const selector = (0, $3056b88ff4074ed0$export$2e2bcd8739ae039)(function() {
        // calculate all dependencies results
        const params = [];
        for(let i = 0; i < dependencies.length; i++)params.push(dependencies[i].apply(null, arguments));
         // then call the final func with all them as arguments
        return memoizedResultFunc.apply(null, params);
    }, true); // expose so we can create per scope selectors
    // API compatible with reselect@^4
    selector.resultFunc = resultFunc;
    selector.dependencies = dependencies;
    return selector;
}
function $2842c9d9216d1caf$export$d2c200d79fc82f8c(selector) {
    const isReselector = typeof selector.resultFunc === 'function' && Array.isArray(selector.dependencies);
    const dependencies = isReselector ? selector.dependencies : [
        (s)=>s,
        (_, p)=>p
    ];
    const resultFunc = isReselector ? selector.resultFunc : selector;
    return $2842c9d9216d1caf$export$595d22ed68ca2841(dependencies, resultFunc);
}
const $2842c9d9216d1caf$var$cache = new WeakMap();
function $2842c9d9216d1caf$export$38d24f3c60944dd5(selector, storeState, hasProps) {
    if (!hasProps) {
        if (!$2842c9d9216d1caf$var$cache.has(storeState)) $2842c9d9216d1caf$var$cache.set(storeState, new WeakMap());
        const scopeSelectors = $2842c9d9216d1caf$var$cache.get(storeState);
        if (!scopeSelectors.has(selector)) scopeSelectors.set(selector, $2842c9d9216d1caf$export$d2c200d79fc82f8c(selector));
        return scopeSelectors.get(selector);
    }
    return $2842c9d9216d1caf$export$d2c200d79fc82f8c(selector);
}


const $e5abef9dd5b4fd0a$var$EMPTY_SELECTOR = ()=>undefined;
const $e5abef9dd5b4fd0a$var$DEFAULT_SELECTOR = (state)=>state;
function $e5abef9dd5b4fd0a$export$e7f733c8fc2b8a24(Store, _temp) {
    let { selector: selector } = _temp === void 0 ? {} : _temp;
    return function useSweetState(propsArg) {
        const { retrieveStore: retrieveStore } = (0, $dQwsT.useContext)((0, $52a623ae27065435$export$841858b892ce1f4c));
        const { storeState: storeState, actions: actions } = retrieveStore(Store);
        const hasPropsArg = propsArg !== undefined;
        const propsArgRef = (0, $dQwsT.useRef)(propsArg);
        propsArgRef.current = propsArg;
        const stateSelector = (0, $dQwsT.useMemo)(()=>selector ? (0, $2842c9d9216d1caf$export$38d24f3c60944dd5)(selector, storeState, hasPropsArg) : selector === null ? $e5abef9dd5b4fd0a$var$EMPTY_SELECTOR : $e5abef9dd5b4fd0a$var$DEFAULT_SELECTOR, [
            hasPropsArg,
            storeState
        ]);
        const forceUpdate = (0, $dQwsT.useState)({})[1];
        const getSnapshot = (0, $dQwsT.useCallback)(()=>{
            // parent scope has changed and notify was explicitly triggered by the container
            // we need to force the hook to re-render to listen new storeState
            if (retrieveStore(Store).storeState !== storeState) forceUpdate({});
            const state = storeState.getState();
            return stateSelector(state, propsArgRef.current);
        }, [
            retrieveStore,
            storeState,
            stateSelector,
            forceUpdate
        ]);
        const currentState = (0, $08f286eca1f2bd54$exports.useSyncExternalStore)(storeState.subscribe, getSnapshot, getSnapshot);
        return [
            currentState,
            actions
        ];
    };
}
function $e5abef9dd5b4fd0a$export$7c643e1d6648e418(Store) {
    const useHook = $e5abef9dd5b4fd0a$export$e7f733c8fc2b8a24(Store, {
        selector: null
    });
    return function useSweetStateActions() {
        return useHook()[1];
    };
}
function $e5abef9dd5b4fd0a$export$6e4e5611de132e85(Store, _temp2) {
    let { selector: selector } = _temp2 === void 0 ? {} : _temp2;
    const useHook = $e5abef9dd5b4fd0a$export$e7f733c8fc2b8a24(Store, {
        selector: selector
    });
    return function useSweetStateState(propsArg) {
        return useHook(propsArg)[0];
    };
}


var $dQwsT = parcelRequire("dQwsT");
var $bcac6686bd205804$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcac6686bd205804$var$ReactIs, $bcac6686bd205804$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$bcac6686bd205804$exports = (parcelRequire("8FP0N"))();





const $c1ae699835888772$var$_excluded = [
    "children"
], $c1ae699835888772$var$_excluded2 = [
    "scope",
    "isGlobal"
];
function $c1ae699835888772$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $c1ae699835888772$var$noop = ()=>()=>{};
function $c1ae699835888772$export$26ae5ca175b4ec5a(StoreOrOptions, _temp) {
    if (StoreOrOptions === void 0) StoreOrOptions = {};
    let { onInit: _onInit = $c1ae699835888772$var$noop, onUpdate: onUpdate = $c1ae699835888772$var$noop, onCleanup: onCleanup = $c1ae699835888772$var$noop, displayName: displayName = '' } = _temp === void 0 ? {} : _temp;
    if ('key' in StoreOrOptions) {
        const Store = StoreOrOptions;
        const dn = displayName || `Container(${Store.key.split('__')[0]})`;
        return $c1ae699835888772$var$createFunctionContainer({
            displayName: dn,
            // compat fields
            override: {
                Store: Store,
                handlers: Object.assign({}, _onInit !== $c1ae699835888772$var$noop && {
                    onInit: ()=>_onInit()
                }, onCleanup !== $c1ae699835888772$var$noop && {
                    onDestroy: ()=>onCleanup()
                }, onUpdate !== $c1ae699835888772$var$noop && {
                    onContainerUpdate: ()=>onUpdate()
                })
            }
        });
    }
    return $c1ae699835888772$var$createFunctionContainer(StoreOrOptions);
}
function $c1ae699835888772$var$useRegistry(scope, isGlobal, _ref) {
    let { globalRegistry: globalRegistry } = _ref;
    return (0, $dQwsT.useMemo)(()=>{
        const isLocal = !scope && !isGlobal;
        return isLocal ? new (0, $157295519b762f36$export$acb47f32da33501e)('__local__') : globalRegistry;
    }, [
        scope,
        isGlobal,
        globalRegistry
    ]);
}
function $c1ae699835888772$var$useContainedStore(scope, registry, propsRef, check, override) {
    // Store contained scopes in a map, but throwing it away on scope change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const containedStores = (0, $dQwsT.useMemo)(()=>new Map(), [
        scope
    ]);
    const getContainedStore = (0, $dQwsT.useCallback)((Store)=>{
        let containedStore = containedStores.get(Store); // first time it gets called we add store to contained map bound
        // so we can provide props to actions (only triggered by children)
        if (!containedStore) {
            const isExisting = registry.hasStore(Store, scope);
            const config = {
                props: ()=>propsRef.current.sub,
                contained: check
            };
            const { storeState: storeState } = registry.getStore(Store, scope, config);
            const actions = (0, $87966d65a56a48ea$export$5ee1d46cd0883a22)(Store.actions, storeState, config);
            const handlers = (0, $87966d65a56a48ea$export$5ee1d46cd0883a22)(Object.assign({}, Store.handlers, override == null ? void 0 : override.handlers), storeState, config, actions);
            containedStore = {
                storeState: storeState,
                actions: actions,
                handlers: handlers,
                unsubscribe: undefined
            };
            containedStores.set(Store, containedStore); // Signal store is contained and ready now, so by the time
            // consumers subscribe we already have updated the store (if needed).
            // Also if override maintain legacy behaviour, triggered on every mount
            if (!isExisting || override) handlers.onInit == null || handlers.onInit();
        }
        return containedStore;
    }, [
        containedStores,
        scope,
        registry,
        propsRef,
        check,
        override
    ]);
    return [
        containedStores,
        getContainedStore
    ];
}
function $c1ae699835888772$var$useApi(check, getContainedStore, _ref2) {
    let { globalRegistry: globalRegistry, retrieveStore: retrieveStore } = _ref2;
    const retrieveRef = (0, $dQwsT.useRef)();
    retrieveRef.current = (Store)=>check(Store) ? getContainedStore(Store) : retrieveStore(Store); // This api is "frozen", as changing it will trigger re-render across all consumers
    // so we link retrieveStore dynamically and manually call notify() on scope change
    return (0, $dQwsT.useMemo)(()=>({
            globalRegistry: globalRegistry,
            retrieveStore: (s)=>retrieveRef.current(s)
        }), [
        globalRegistry
    ]);
}
function $c1ae699835888772$var$createFunctionContainer(_temp2) {
    let { displayName: displayName, override: override } = _temp2 === void 0 ? {} : _temp2;
    const check = (store)=>override ? store === override.Store : store.containedBy === FunctionContainer;
    function FunctionContainer(props) {
        const { children: children } = props, restProps = $c1ae699835888772$var$_objectWithoutPropertiesLoose(props, $c1ae699835888772$var$_excluded);
        const { scope: scope, isGlobal: isGlobal } = restProps, subProps = $c1ae699835888772$var$_objectWithoutPropertiesLoose(restProps, $c1ae699835888772$var$_excluded2);
        const ctx = (0, $dQwsT.useContext)((0, $52a623ae27065435$export$841858b892ce1f4c));
        const registry = $c1ae699835888772$var$useRegistry(scope, isGlobal, ctx); // Store props in a ref to avoid re-binding actions when they change and re-rendering all
        // consumers unnecessarily. The update is handled by an effect on the component instead
        const propsRef = (0, $dQwsT.useRef)({
            prev: null,
            next: restProps,
            sub: subProps
        });
        propsRef.current = {
            prev: propsRef.current.next,
            next: restProps,
            sub: subProps // TODO remove on next major
        };
        const [containedStores, getContainedStore] = $c1ae699835888772$var$useContainedStore(scope, registry, propsRef, check, override); // Use a stable object as is passed as value to context Provider
        const api = $c1ae699835888772$var$useApi(check, getContainedStore, ctx); // This listens for custom props change, and so we trigger container update actions
        // before the re-render gets to consumers (hence why side effect on render).
        // We do not use React hooks because num of restProps might change and react will throws
        if (!(0, $234874cb82722593$export$2e2bcd8739ae039)(propsRef.current.next, propsRef.current.prev)) containedStores.forEach((_ref3)=>{
            let { handlers: handlers } = _ref3;
            handlers.onContainerUpdate == null || handlers.onContainerUpdate(propsRef.current.next, propsRef.current.prev);
        });
         // Every time we add/remove a contained store, we ensure we are subscribed to the updates
        // as an effect to properly handle strict mode
        (0, $dQwsT.useEffect)(()=>{
            containedStores.forEach((containedStore)=>{
                if (!containedStore.unsubscribe) {
                    const unsub = containedStore.storeState.subscribe(()=>containedStore.handlers.onUpdate == null ? void 0 : containedStore.handlers.onUpdate());
                    containedStore.unsubscribe = ()=>{
                        unsub();
                        containedStore.unsubscribe = undefined;
                    };
                }
            });
        }, [
            containedStores,
            containedStores.size
        ]); // We support renderding "bootstrap" containers without children with override API
        // so in this case we call getCS to initialize the store globally asap
        if (override && !containedStores.size && (scope || isGlobal)) getContainedStore(override.Store);
         // This listens for scope change or component unmount, to notify all consumers
        // so all work is done on cleanup
        (0, $dQwsT.useEffect)(()=>{
            return ()=>{
                containedStores.forEach((_ref4, Store)=>{
                    let { storeState: storeState, handlers: handlers, unsubscribe: unsubscribe } = _ref4;
                    // Detatch container from subscription
                    unsubscribe == null || unsubscribe(); // Trigger a forced update on all subscribers as we opted out from context
                    // Some might have already re-rendered naturally, but we "force update" all anyway.
                    // This is sub-optimal as if there are other containers with the same
                    // old scope id we will re-render those too, but still better than context
                    storeState.notify(); // Given unsubscription is handled by useSyncExternalStore, we have no control on when
                    // React decides to do it. So we schedule on next tick to run last
                    Promise.resolve().then(()=>{
                        var _registry$getStore;
                        if (!storeState.listeners().size && // ensure registry has not already created a new store with same scope
                        storeState === ((_registry$getStore = registry.getStore(Store, scope, null)) == null ? void 0 : _registry$getStore.storeState)) {
                            handlers.onDestroy == null || handlers.onDestroy(); // We only delete scoped stores, as global shall persist and local are auto-deleted
                            if (!isGlobal) registry.deleteStore(Store, scope);
                        }
                    });
                }); // no need to reset containedStores as the map is already bound to scope
            };
        }, [
            registry,
            scope,
            isGlobal,
            containedStores
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement((0, $52a623ae27065435$export$841858b892ce1f4c).Provider, {
            value: api
        }, children);
    }
    FunctionContainer.displayName = displayName || `Container`;
    FunctionContainer.propTypes = {
        children: (0, (/*@__PURE__*/$parcel$interopDefault($bcac6686bd205804$exports))).node,
        scope: (0, (/*@__PURE__*/$parcel$interopDefault($bcac6686bd205804$exports))).string,
        isGlobal: (0, (/*@__PURE__*/$parcel$interopDefault($bcac6686bd205804$exports))).bool
    };
    return FunctionContainer;
}

/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $baf7be6ab54a67da$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}


function $5883d878da5aa419$var$createKey(initialState, actions, name) {
    const src = !name ? Object.keys(actions).reduce((acc, k)=>acc + actions[k].toString(), '') : '';
    return [
        name,
        (0, $baf7be6ab54a67da$export$2e2bcd8739ae039)(src + JSON.stringify(initialState))
    ].filter(Boolean).join('__');
}
function $5883d878da5aa419$export$f51a9068ac82ea43(_ref) {
    let { name: name = '', initialState: initialState, actions: actions, containedBy: containedBy, handlers: handlers = {} } = _ref;
    let key;
    return {
        get key () {
            // lazy evaluate key on first access
            return key || (key = $5883d878da5aa419$var$createKey(initialState, actions, name));
        },
        initialState: initialState,
        actions: actions,
        containedBy: containedBy,
        handlers: handlers
    };
}


const $8156ed1d073cd4cd$var$_excluded = [
    "children"
];
function $8156ed1d073cd4cd$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $8156ed1d073cd4cd$var$hasAdditionalProps(props) {
    for(let i in props)return true;
    return false;
}
function $8156ed1d073cd4cd$export$48f338a7e080595c(Store, _temp) {
    let { selector: selector, displayName: displayName = '' } = _temp === void 0 ? {} : _temp;
    const useStore = (0, $e5abef9dd5b4fd0a$export$e7f733c8fc2b8a24)(Store, {
        selector: selector
    });
    const Subscriber = function Subscriber(_ref) {
        let { children: children } = _ref, rest = $8156ed1d073cd4cd$var$_objectWithoutPropertiesLoose(_ref, $8156ed1d073cd4cd$var$_excluded);
        const api = useStore($8156ed1d073cd4cd$var$hasAdditionalProps(rest) ? rest : undefined);
        return children(...api);
    };
    Subscriber.displayName = displayName || `Subscriber(${Store.key.split('__')[0]})`;
    return Subscriber;
}


// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead






// The UFORouteName object is a global singleton
const $70cde0f2b3f65548$var$UFORouteName = {
    current: null
};
var $70cde0f2b3f65548$export$2e2bcd8739ae039 = $70cde0f2b3f65548$var$UFORouteName;


const $be6e488d05bb1745$var$AWAITING_PAGELOAD_NAME = 'awaiting_pageload_name';
function $be6e488d05bb1745$var$traceUFOPageLoad(ufoName, routeName = ufoName) {
    const activeInteraction = (0, $7390d9fffd2908eb$export$2b3954d2e8509985)();
    if (activeInteraction && !ufoName) return;
    (0, $70cde0f2b3f65548$export$2e2bcd8739ae039).current = routeName || null;
    const rate = ufoName ? (0, $9a2f9fc0af024eb1$export$9466a8f085fa7d4e)(ufoName, 'page_load') : 1;
    const enabledBySamplingRate = (0, $74d2fea471853068$export$2e2bcd8739ae039)(rate);
    if (enabledBySamplingRate && !activeInteraction) {
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const newId = (0, $19dcc840d0563c39$exports.v4)();
        (0, $cb7ea7f0a3e09fe0$export$3109542b68df9ba1).current = newId;
        (0, $7390d9fffd2908eb$export$1a1ed1e1fdb2006b)(newId, ufoName || '', 'page_load', 0, rate, null, routeName, (0, $9931f21957f7e3c2$export$b6ac780db3a3cc77)());
        if (!ufoName) // if no name is provided we add a hold to the interaction, it is removed if the name is provided while the interaction is holding
        (0, $7390d9fffd2908eb$export$10582acd678c213)(newId, [], $be6e488d05bb1745$var$AWAITING_PAGELOAD_NAME, $be6e488d05bb1745$var$AWAITING_PAGELOAD_NAME, true);
    } else if (!enabledBySamplingRate && activeInteraction && activeInteraction.type === 'page_load') // if there is an active interaction it will be aborted without initialising a new one because the coinflip returned false
    (0, $7390d9fffd2908eb$export$5def58af4fd46132)(activeInteraction.id, 'excluded_by_sampling');
    else if (ufoName && activeInteraction && !activeInteraction.ufoName && activeInteraction.type === 'page_load') {
        (0, $7390d9fffd2908eb$export$f6f1cf5bedf83c71)(ufoName, routeName);
        (0, $7390d9fffd2908eb$export$4983dfbbb996f7ae)(activeInteraction.id, $be6e488d05bb1745$var$AWAITING_PAGELOAD_NAME);
    }
}
var $be6e488d05bb1745$export$2e2bcd8739ae039 = $be6e488d05bb1745$var$traceUFOPageLoad;
function $be6e488d05bb1745$export$d0f99433cd4f4028(ufoName, routeName = ufoName) {
    const interaction = (0, $7390d9fffd2908eb$export$2b3954d2e8509985)();
    if (!interaction || interaction.type !== 'page_load' && interaction.type !== 'transition') return;
    if (ufoName) {
        const rate = (0, $9a2f9fc0af024eb1$export$9466a8f085fa7d4e)(ufoName, 'page_load');
        (0, $7390d9fffd2908eb$export$f6f1cf5bedf83c71)(ufoName, routeName);
        if ((0, $74d2fea471853068$export$2e2bcd8739ae039)(rate)) (0, $70cde0f2b3f65548$export$2e2bcd8739ae039).current = ufoName;
        else (0, $7390d9fffd2908eb$export$5def58af4fd46132)(interaction.id, 'excluded_by_sampling');
    }
    (0, $7390d9fffd2908eb$export$4983dfbbb996f7ae)(interaction.id, $be6e488d05bb1745$var$AWAITING_PAGELOAD_NAME);
}


const $a55430c99df8268f$var$nullNoop = ()=>null;
const $a55430c99df8268f$var$objNoop = ()=>({});
const $a55430c99df8268f$var$stringNoop = ()=>'';
const $a55430c99df8268f$var$voidNoop = ()=>{};
const $a55430c99df8268f$var$RouteStore = (0, $5883d878da5aa419$export$f51a9068ac82ea43)({
    initialState: {
        getHref: $a55430c99df8268f$var$stringNoop,
        history: null,
        location: null,
        match: null,
        transitionId: null,
        toUrl: $a55430c99df8268f$var$stringNoop,
        matchRoute: $a55430c99df8268f$var$nullNoop,
        matchSupportedRoute: $a55430c99df8268f$var$nullNoop,
        getQueryParams: $a55430c99df8268f$var$objNoop,
        setQueryParams: $a55430c99df8268f$var$voidNoop,
        getHash: $a55430c99df8268f$var$stringNoop,
        setHash: $a55430c99df8268f$var$voidNoop,
        replace: $a55430c99df8268f$var$voidNoop,
        routes: [],
        push: $a55430c99df8268f$var$voidNoop,
        open: $a55430c99df8268f$var$nullNoop,
        onPageReload: $a55430c99df8268f$var$voidNoop,
        preloadRoute: $a55430c99df8268f$var$voidNoop
    },
    actions: {
        push (...args) {
            return ({ getState: getState })=>getState().push(...args);
        },
        replace (...args) {
            return ({ getState: getState })=>getState().replace(...args);
        },
        setQueryParams: (query, replace)=>({ getState: getState })=>getState().setQueryParams(query, replace),
        setHash: (hash)=>({ getState: getState })=>getState().setHash(hash),
        getLatestRouteData: ()=>({ getState: getState })=>{
                const match = getState().match;
                return {
                    routeName: match?.name,
                    routeParams: match?.params ?? {},
                    hash: getState().location?.hash?.substring(1) ?? '',
                    href: getState().getHref(),
                    queryParams: (0, $9pfwj.parse)(getState().location?.search ?? '', true)?.query,
                    toUrl: match?.toUrl?.bind(match) ?? function() {
                        return '';
                    }
                };
            },
        overrideUFORouteName: (newName)=>({ getState: getState })=>{
                (0, $be6e488d05bb1745$export$d0f99433cd4f4028)(newName, getState().match?.name);
            },
        preloadRoute: (matchOrUrl, options)=>({ getState: getState })=>getState().preloadRoute(matchOrUrl, options)
    },
    name: 'RouteState'
});
const $a55430c99df8268f$export$52c04f66b1983f2a = (0, $c1ae699835888772$export$26ae5ca175b4ec5a)($a55430c99df8268f$var$RouteStore, {
    onInit: ()=>({ setState: setState }, routeState)=>{
            setState(routeState);
        },
    onUpdate: ()=>({ setState: setState }, routeState)=>{
            setState(routeState);
        }
});
const $a55430c99df8268f$export$d4f74eb8532c85b4 = (0, $8156ed1d073cd4cd$export$48f338a7e080595c)($a55430c99df8268f$var$RouteStore);
/**
 * `useAllRouteActions` exposes all RouteState actions for internal use.
 * This is used to limit which route actions are publicly exposed.
 */ const $a55430c99df8268f$var$useAllRouteActions = (0, $e5abef9dd5b4fd0a$export$7c643e1d6648e418)($a55430c99df8268f$var$RouteStore);
const $a55430c99df8268f$export$2467ee40aa778f80 = (0, $91b99f9a21467aa8$export$74f458e787dc59ff)() ? ()=>{
    const $ = (0, $90332d3d6df1e1ff$exports.c)(7);
    const { push: push, replace: replace, setQueryParams: setQueryParams, setHash: setHash, overrideUFORouteName: overrideUFORouteName, preloadRoute: preloadRoute } = $a55430c99df8268f$var$useAllRouteActions();
    let t0;
    if ($[0] !== overrideUFORouteName || $[1] !== preloadRoute || $[2] !== push || $[3] !== replace || $[4] !== setHash || $[5] !== setQueryParams) {
        t0 = {
            push: push,
            replace: replace,
            setQueryParams: setQueryParams,
            setHash: setHash,
            overrideUFORouteName: overrideUFORouteName,
            preloadRoute: preloadRoute
        };
        $[0] = overrideUFORouteName;
        $[1] = preloadRoute;
        $[2] = push;
        $[3] = replace;
        $[4] = setHash;
        $[5] = setQueryParams;
        $[6] = t0;
    } else t0 = $[6];
    return t0;
} : ()=>{
    const { push: push, replace: replace, setQueryParams: setQueryParams, setHash: setHash, overrideUFORouteName: overrideUFORouteName, preloadRoute: preloadRoute } = $a55430c99df8268f$var$useAllRouteActions();
    return {
        push: /** See {@link RouteActionsType.push} for documentation */ push,
        replace: /** See {@link RouteActionsType.replace} for documentation */ replace,
        setQueryParams: /** See {@link RouteActionsType.setQueryParams} for documentation */ setQueryParams,
        setHash: /** See {@link RouteActionsType.setHash} for documentation */ setHash,
        overrideUFORouteName: /** See {@link RouteActionsType.overrideUFORouteName} for documentation */ overrideUFORouteName,
        preloadRoute: /** See {@link RouteActionsType.preloadRoute} for documentation */ preloadRoute
    };
};
const $a55430c99df8268f$export$a434162a7524cfb3 = (routeParam)=>(0, $e5abef9dd5b4fd0a$export$6e4e5611de132e85)($a55430c99df8268f$var$RouteStore, {
        selector: (state)=>state?.match?.params?.[routeParam]
    });
const $a55430c99df8268f$export$a3421b85303fa9de = (queryParam)=>$a55430c99df8268f$export$a7bf969075a175d2(queryParam, (parseResult)=>$a55430c99df8268f$var$singleQueryParamParser(parseResult));
const $a55430c99df8268f$export$2c2c4e775b5e6393 = (queryParam)=>$a55430c99df8268f$export$a7bf969075a175d2(queryParam, (parseResult)=>{
        if (parseResult === '') return [];
        else if (typeof parseResult === 'string') return [
            parseResult
        ];
        return parseResult;
    });
const $a55430c99df8268f$export$a7bf969075a175d2 = (queryParam, customParser)=>(0, $e5abef9dd5b4fd0a$export$6e4e5611de132e85)($a55430c99df8268f$var$RouteStore, {
        selector: (state)=>{
            const parseResult = (0, $9pfwj.parse)(state.location?.search ?? '', true)?.query?.[queryParam];
            return customParser(parseResult);
        }
    });
const $a55430c99df8268f$export$b1482fdc3ffb1b4a = (0, $e5abef9dd5b4fd0a$export$6e4e5611de132e85)($a55430c99df8268f$var$RouteStore, {
    selector: (state)=>{
        const hash = state.location?.hash;
        return hash ? hash.substring(1) : '';
    }
});
const $a55430c99df8268f$export$244d8f2aa1ab504f = (0, $e5abef9dd5b4fd0a$export$6e4e5611de132e85)($a55430c99df8268f$var$RouteStore, {
    selector: (state, { selector: selector })=>{
        return selector(state.match?.url);
    }
});
const $a55430c99df8268f$export$30aadaab39fae199 = (0, $e5abef9dd5b4fd0a$export$6e4e5611de132e85)($a55430c99df8268f$var$RouteStore, {
    selector: (state, { selector: selector })=>{
        return selector(state.match?.name);
    }
});
function $a55430c99df8268f$var$singleQueryParamParser(parseResult) {
    return Array.isArray(parseResult) ? parseResult?.[0] : parseResult;
}
const $a55430c99df8268f$export$85e000103cdf6a77 = (0, $91b99f9a21467aa8$export$74f458e787dc59ff)() ? function useIsOnRoute(route) {
    const $ = (0, $90332d3d6df1e1ff$exports.c)(2);
    let t0;
    if ($[0] !== route) {
        t0 = {
            selector: (matchName)=>matchName === route.name
        };
        $[0] = route;
        $[1] = t0;
    } else t0 = $[1];
    return $a55430c99df8268f$export$30aadaab39fae199(t0);
} : function useIsOnRoute(route) {
    return $a55430c99df8268f$export$30aadaab39fae199({
        selector: (matchName)=>matchName === route.name
    });
};
const $a55430c99df8268f$export$c9f0d094e50e1bbc = ()=>{
    const { getLatestRouteData: getLatestRouteData } = $a55430c99df8268f$var$useAllRouteActions();
    return (0, $dQwsT.useMemo)(()=>({
            get current () {
                return getLatestRouteData();
            }
        }), [
        getLatestRouteData
    ]);
};
const $a55430c99df8268f$export$7926129229271134 = (0, $e5abef9dd5b4fd0a$export$6e4e5611de132e85)($a55430c99df8268f$var$RouteStore, {
    selector: (state)=>state.transitionId ?? 0
});
const $a55430c99df8268f$export$632429935326e9d2 = (0, $e5abef9dd5b4fd0a$export$6e4e5611de132e85)($a55430c99df8268f$var$RouteStore, {
    selector: (state)=>!!state.transitionId
});
const $a55430c99df8268f$export$3420e1dc2c4a518c = (0, $e5abef9dd5b4fd0a$export$6e4e5611de132e85)($a55430c99df8268f$var$RouteStore, {
    selector: (state)=>state.history
});
const $a55430c99df8268f$export$d2ec911fa7f74821 = (0, $e5abef9dd5b4fd0a$export$6e4e5611de132e85)($a55430c99df8268f$var$RouteStore, {
    selector: (state)=>state.matchRoute
});
const $a55430c99df8268f$export$ce9ea1d788472f7b = (0, $e5abef9dd5b4fd0a$export$6e4e5611de132e85)($a55430c99df8268f$var$RouteStore, {
    selector: (state, { selector: selector })=>{
        return selector(state.location?.pathname);
    }
});





var $dQwsT = parcelRequire("dQwsT");

var $dQwsT = parcelRequire("dQwsT");
const $b83cd251b8885388$export$47bf0d5265bb1324 = (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createContext(// The app should not be making use of `SessionDataContext` until it's loaded.
// It *should* be safe to assert the presence of SessionData by this point.
undefined);
$b83cd251b8885388$export$47bf0d5265bb1324.displayName = 'SessionDataContext';


const $b9304229d48cfce4$export$3571dffcff931902 = ()=>(0, $dQwsT.useContext)((0, $b83cd251b8885388$export$47bf0d5265bb1324));


/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $5bd4bcd7bfa59eea$export$9d38595f26d62a61 = /*#__PURE__*/ function(AccessStatus) {
    AccessStatus["ANONYMOUS_ACCESS"] = "ANONYMOUS_ACCESS";
    AccessStatus["EXTERNAL_COLLABORATOR_ACCESS"] = "EXTERNAL_COLLABORATOR_ACCESS";
    AccessStatus["EXTERNAL_SHARE_ACCESS"] = "EXTERNAL_SHARE_ACCESS";
    AccessStatus["LICENSED_ADMIN_ACCESS"] = "LICENSED_ADMIN_ACCESS";
    AccessStatus["LICENSED_USE_ACCESS"] = "LICENSED_USE_ACCESS";
    AccessStatus["NOT_PERMITTED"] = "NOT_PERMITTED";
    AccessStatus["UNLICENSED_AUTHENTICATED_ACCESS"] = "UNLICENSED_AUTHENTICATED_ACCESS";
    return AccessStatus;
}({});
var $5bd4bcd7bfa59eea$export$68577d543b14ae02 = /*#__PURE__*/ function(ConfluenceEdition) {
    ConfluenceEdition["FREE"] = "FREE";
    ConfluenceEdition["PREMIUM"] = "PREMIUM";
    ConfluenceEdition["STANDARD"] = "STANDARD";
    return ConfluenceEdition;
}({});
var $5bd4bcd7bfa59eea$export$7dc6752a22ab011a = /*#__PURE__*/ function(Environment) {
    Environment["DEVELOPMENT"] = "DEVELOPMENT";
    Environment["PRODUCTION"] = "PRODUCTION";
    Environment["STAGING"] = "STAGING";
    return Environment;
}({});


const $80551c4b709c6d15$export$cad4fa6c249bffe = ()=>{
    if ((0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_nav4_ga_phase_2')) //if phase 2 is enabled ignore all opt out
    return true;
    // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    if ((0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_nav_4')) //fire the query if nav4 is enabled
    return false;
    if ((0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_nav4_ga_phase_1')) //if nav4 is disabled, but phase 1 is enabled, check the opt status
    return false; //should still skip if admin opt in is enabled
    return true;
};
const $80551c4b709c6d15$var$hasAccess = (accessStatus)=>![
        (0, $5bd4bcd7bfa59eea$export$9d38595f26d62a61).ANONYMOUS_ACCESS,
        (0, $5bd4bcd7bfa59eea$export$9d38595f26d62a61).UNLICENSED_AUTHENTICATED_ACCESS,
        null
    ].includes(accessStatus);
const $80551c4b709c6d15$export$d7e12273c5b6a967 = ()=>{
    const { accessStatus: accessStatus } = (0, $b9304229d48cfce4$export$3571dffcff931902)();
    // Should skip for anonymous and unlicensed users as userPreferences will return error in those cases
    return {
        shouldSkipOptOutQuery: !$80551c4b709c6d15$var$hasAccess(accessStatus) || $80551c4b709c6d15$export$cad4fa6c249bffe()
    };
};


const $045fd194f5429cb1$var$OPT_OUT_CACHE_EXPIRATION_SECONDS = 31536000; // 1 year
const $045fd194f5429cb1$export$77dd43be45cef9eb = ({ onCompleted: onCompleted, onError: onError } = {})=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $5bc6f3e28bd9f46e$export$5bf35293e545f20c)();
    // useNav4OptOutMutation does not seem to return a response, success state is tracked with a hook instead
    const [isAdminUpdateSuccessful, setAdminUpdateSuccessful] = (0, $dQwsT.useState)(null);
    const { shouldSkipOptOutQuery: shouldSkipOptOutQuery } = (0, $80551c4b709c6d15$export$d7e12273c5b6a967)();
    const { loading: loading, data: data, error: queryError } = (0, $f54dbbdd58dc6856$export$33c3a40e92be94b0)((0, $986f6c4727102807$export$2e2bcd8739ae039)`query useNav4OptOutQuery{userPreferences{nav4OptOut}}`, {
        skip: shouldSkipOptOutQuery
    });
    // Expected error - query will fail for anonymous and unlicensed users
    if (queryError?.message.includes('Cannot find authenticated user.')) (0, $4b7988ce40c8fd3c$export$702f853386561b84)(queryError);
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const [updateNav4OptOutServer] = (0, $dca5541081837639$export$609860bf8b0084c)((0, $986f6c4727102807$export$2e2bcd8739ae039)`mutation useNav4OptOutMutation($nav4OptOut:Boolean!){updateUserPreferences(userPreferences:{nav4OptOut:$nav4OptOut}){nav4OptOut}}`);
    const neverOptedOut = !loading && data?.userPreferences?.nav4OptOut === null;
    const { setQueryParams: setQueryParams } = (0, $a55430c99df8268f$export$2467ee40aa778f80)();
    const updateNav4OptOut = (0, $dQwsT.useCallback)(async (newNav4OptOut)=>{
        updateNav4OptOutServer({
            variables: {
                nav4OptOut: newNav4OptOut
            }
        }).then(()=>{
            $045fd194f5429cb1$var$updateNav4OptOutCache(newNav4OptOut);
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'changed',
                    actionSubject: 'navigationVersion',
                    source: 'nav4OptOut',
                    attributes: {
                        originalNavVersion: newNav4OptOut ? '4' : '3',
                        newNavVersion: newNav4OptOut ? '3' : '4'
                    }
                }
            }).fire();
            if (newNav4OptOut && neverOptedOut && !(0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_nav4_ga_phase_1')) // If this is the first time opting out, reload with query param to trigger Nav4OptOutSpotlight
            setQueryParams({
                navOptOut: 'true'
            });
            setAdminUpdateSuccessful(true);
            onCompleted?.();
        }).catch((error)=>{
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'changeFailed',
                    actionSubject: 'navigationVersion',
                    source: 'nav4OptOut',
                    attributes: {
                        error: error
                    }
                }
            }).fire();
            setAdminUpdateSuccessful(false);
            onError?.(error);
        });
    }, [
        updateNav4OptOutServer,
        createAnalyticsEvent,
        neverOptedOut,
        setQueryParams,
        onCompleted,
        onError
    ]);
    const optOutCache = $045fd194f5429cb1$var$parseCacheValue((0, $8b7debc8685a2ab6$export$7691d7c35a352a10)?.getItem((0, $55aebbd7cffee8f3$export$ed97f33186d4b816).NAV4_OPT_OUT_CACHE));
    const optOutServer = data?.userPreferences?.nav4OptOut;
    const nav4OptOut = ((0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_nav_4') || (0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_nav4_ga_phase_1')) && (loading ? optOutCache : optOutServer);
    (0, $dQwsT.useEffect)(()=>{
        if (!loading && optOutServer !== optOutCache) $045fd194f5429cb1$var$updateNav4OptOutCache(optOutServer);
    }, [
        loading,
        optOutCache,
        optOutServer
    ]);
    return {
        nav4OptOut: nav4OptOut,
        updateNav4OptOut: updateNav4OptOut,
        isAdminUpdateSuccessful: isAdminUpdateSuccessful
    };
};
const $045fd194f5429cb1$var$parseCacheValue = (cacheValue)=>{
    if (cacheValue === 'true') return true;
    else if (cacheValue === 'false') return false;
    else return undefined;
};
const $045fd194f5429cb1$export$913ff9805687cd8 = ()=>{
    return (0, $8b7debc8685a2ab6$export$7691d7c35a352a10)?.getItem((0, $55aebbd7cffee8f3$export$ed97f33186d4b816).NAV4_OPT_OUT_CACHE) === 'true';
};
const $045fd194f5429cb1$export$aca664b5b089bc42 = ()=>{
    return (0, $8b7debc8685a2ab6$export$7691d7c35a352a10)?.getItem((0, $55aebbd7cffee8f3$export$ed97f33186d4b816).NAV4_OPT_OUT_CACHE) === 'false';
};
const $045fd194f5429cb1$var$updateNav4OptOutCache = (nav4OptOut)=>{
    if (nav4OptOut) (0, $8b7debc8685a2ab6$export$7691d7c35a352a10).setItem((0, $55aebbd7cffee8f3$export$ed97f33186d4b816).NAV4_OPT_OUT_CACHE, true, $045fd194f5429cb1$var$OPT_OUT_CACHE_EXPIRATION_SECONDS);
    else if (nav4OptOut === false) // if explicitly set to false, we need to save to check in phase_1 since false means "opt-in"
    (0, $8b7debc8685a2ab6$export$7691d7c35a352a10).setItem((0, $55aebbd7cffee8f3$export$ed97f33186d4b816).NAV4_OPT_OUT_CACHE, false, $045fd194f5429cb1$var$OPT_OUT_CACHE_EXPIRATION_SECONDS);
    else // the value is null and has never been set
    (0, $8b7debc8685a2ab6$export$7691d7c35a352a10)?.removeItem((0, $55aebbd7cffee8f3$export$ed97f33186d4b816).NAV4_OPT_OUT_CACHE);
};



const $c2de76413cb8f3c4$export$827babb08d748504 = ()=>{
    if ((0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_nav4_ga_phase_2')) return 2;
    if ((0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_nav4_ga_phase_1')) return 1;
    return 0;
};




const $b1e60184bb3ec7e1$var$OPT_OUT_CACHE_EXPIRATION_SECONDS = 31536000; // 1 year
const $b1e60184bb3ec7e1$export$2157f431c298ed22 = (nav4AdminOptIn)=>{
    if (nav4AdminOptIn) (0, $8b7debc8685a2ab6$export$7691d7c35a352a10).setItem((0, $55aebbd7cffee8f3$export$ed97f33186d4b816).NAV4_ADMIN_OPT_IN_CACHE, true, $b1e60184bb3ec7e1$var$OPT_OUT_CACHE_EXPIRATION_SECONDS);
    else // the value is null and has never been set
    (0, $8b7debc8685a2ab6$export$7691d7c35a352a10)?.removeItem((0, $55aebbd7cffee8f3$export$ed97f33186d4b816).NAV4_ADMIN_OPT_IN_CACHE);
};
const $b1e60184bb3ec7e1$export$4b020a7ac475108f = ()=>{
    return (0, $8b7debc8685a2ab6$export$7691d7c35a352a10)?.getItem((0, $55aebbd7cffee8f3$export$ed97f33186d4b816).NAV4_ADMIN_OPT_IN_CACHE) === 'true';
};


const $f35f58e56b56de67$export$2af1f7a69c1ab0ad = ()=>{
    const currentGAPhase = (0, $c2de76413cb8f3c4$export$827babb08d748504)();
    if (currentGAPhase === 2) return true;
    if ((0, $045fd194f5429cb1$export$913ff9805687cd8)()) return false;
    return(// checks both site opt-in and admin only opt-in
    (0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_nav_4') || (0, $ef003bca5ae3d837$export$9db1624a8af791a4)('confluence_jira_nav4_new_customers', 'willShowNav4', false) || currentGAPhase === 1 && ((0, $b1e60184bb3ec7e1$export$4b020a7ac475108f)() || (0, $045fd194f5429cb1$export$aca664b5b089bc42)()));
};




var $8V6O9 = parcelRequire("8V6O9");

class $12387e80c2ebd079$export$a00c080e726db0b {
    initialize() {
        if (typeof document === 'undefined') return {
            teardown: ()=>{}
        };
        if (document.hidden) // if the tab is active, `onVisibilityChange` will result in invariant violation
        this.onVisibilityChange();
        document.addEventListener('visibilitychange', this.onVisibilityChange);
        return {
            teardown: ()=>{
                document.removeEventListener('visibilitychange', this.onVisibilityChange);
            }
        };
    }
    getInactiveMillisecondsSince(timestamp) {
        let inactivityDuration = 0;
        // for-loop will allow us to perform an early exit
        for (const [start, end] of this.inactivityIntervals){
            // cases:
            // - timestamp < start     < end        : Relevant
            // - start     < timestamp < end        : Relevant
            // - start     < timestamp ; end=null   : Relevant
            // - start     < end       < timestamp  : Irrelevant
            const inactivityEnd = end || window.performance.now();
            if (timestamp > inactivityEnd) break;
            inactivityDuration += inactivityEnd - Math.max(start, timestamp);
        }
        return inactivityDuration;
    }
    constructor({ maxIntervalsToStore: maxIntervalsToStore } = {}){
        /**
     * Stores intervals in reverse order (that is, latest interval will be the first item in the array).
     * The items in this array are tuples of [intervalStartTimestamp, intervalEndTimestamp].
     * If `intervalEndTimestamp` is `null`, that means that tab is still inactive.
     * Example value (number would actually be timestamps, but they are exemplified differently for ease of understanding):
     * ```js
     * // if the tab is currently active, but was hidden before
     * [ [500, 600], [300, 400], [100, 200] ]
     *
     * // while the tab is still inactive
     * [ [500, null], [100, 200] ]
     *
     * // if the tab has never been hidden
     * [ ]
     * ```
     */ this.inactivityIntervals = [];
        this.logger = (0, $a6897acd40ed68b1$export$2b1d391cd05230fd)('TabInactivityTracker');
        // in order to not increase memory footprint indefinitely, we'll cap the maximum amount of items
        this.maxIntervalsToStore = void 0;
        this.onVisibilityChange = ()=>{
            if (!document.hidden) {
                // we were inactive before, which means that there is an "unfinished" interval
                // we'll finish it after verifying invariants
                if (this.inactivityIntervals.length === 0 || this.inactivityIntervals[0][1] != null) this.logger.error`Invariant violation: tab is currently active, but inactivity intervals are in inconsistent state`;
                else this.inactivityIntervals[0][1] = window.performance.now();
            } else {
                if (this.inactivityIntervals.length >= this.maxIntervalsToStore) // we're about to add a new interval; but we're also at max array capacity, so we'll
                // intentionally lose the most dated items in the array in the hope that they won't be needed anymore.
                this.inactivityIntervals.splice(this.maxIntervalsToStore - 1);
                // tab just became inactive; we'll create a new "unfinished" interval
                this.inactivityIntervals.unshift([
                    window.performance.now(),
                    null
                ]);
            }
        };
        const DEFAULT_MAX_INTERVALS_TO_STORE = 100;
        this.maxIntervalsToStore = typeof maxIntervalsToStore === 'number' ? maxIntervalsToStore : DEFAULT_MAX_INTERVALS_TO_STORE;
    }
}
const $12387e80c2ebd079$export$39c3eb20723b04b = (0, $8V6O9.default)(()=>{
    const tracker = new $12387e80c2ebd079$export$a00c080e726db0b();
    tracker.initialize();
    return tracker;
});



var $8V6O9 = parcelRequire("8V6O9");
class $93bba6ebad0146b8$export$51cec848073e2e7a {
    start() {
        let lastFreezeStart;
        if (typeof document !== 'undefined') {
            document.addEventListener('freeze', ()=>{
                lastFreezeStart = performance.now();
            });
            document.addEventListener('resume', ()=>{
                // probably zero chance of it happening, but still
                if (typeof lastFreezeStart !== 'number') return;
                const now = performance.now();
                for (const callback of this.callbacks.values())callback(now - lastFreezeStart);
            });
        }
    }
    subscribe(name, callback) {
        // We are not subscribe and unsubscribe with callback's reference.
        // Because there are known cases that experiences are not properly stopped.
        // In order prevent from memory leak here we are using the name as the key since the variation is bounded.
        this.callbacks.set(name, callback);
    }
    unsubscribe(name) {
        this.callbacks.delete(name);
    }
    constructor(){
        this.callbacks = new Map();
    }
}
const $93bba6ebad0146b8$export$40336562f0f00c2a = (0, $8V6O9.default)(()=>new $93bba6ebad0146b8$export$51cec848073e2e7a());



// Whenever we want to target view-page experience, we should ensure we're targeting all correlated view-page experiences.
// This is more complete and helps avoid bugs related to view-content experience forwarding to view-page.
const $b56cd77aa456103d$var$VIEW_PAGE_EXPERIENCES = [
    (0, $d4b865e8cc459c1f$export$d4712ac27cc4e72f),
    (0, $d4b865e8cc459c1f$export$cf73dfff88c1f700),
    (0, $d4b865e8cc459c1f$export$5e30e9d7ea54dcd2)
];
// Experience timeouts by default are considered taskFails. Certain experiences should instead treat timeouts as aborts, to reduce unnecessary noise and improve SLI accuracy.
const $b56cd77aa456103d$var$EXPERIENCE_TIMEOUTS_TO_ABORT = [
    (0, $d4b865e8cc459c1f$export$227ea80a7d6d8ef2),
    ...$b56cd77aa456103d$var$VIEW_PAGE_EXPERIENCES,
    (0, $d4b865e8cc459c1f$export$a83700d85c7e0745),
    (0, $d4b865e8cc459c1f$export$bdaf5db6d84a5581),
    (0, $d4b865e8cc459c1f$export$2a57468d23984a9d)
];
// Errors that are thrown by client side and can be ignored, this is to avoid treating these as fails that can impact SLOs.
// ideally we can show the user a flag that shows something is wrong, please avoid adding to this list unless absolutely necessary.
const $b56cd77aa456103d$var$IGNORABLE_CLIENT_SIDE_ERRORS = [
    "can't access dead object"
];
/**
 * A list of experiences that should have debugMessages attached to abort events.
 *
 * This is not a safe default, as at time of addition ~20% of experiences
 * with some events having ~90% abort rates with high volume (>10k per 15m)
 *
 * If adding -- ensure you first review the event and abort volume.
 */ const $b56cd77aa456103d$var$EXPERIENCES_TO_DEBUG_ON_ABORT = [
    (0, $d4b865e8cc459c1f$export$f8e0e16825f0d222)
];
class $b56cd77aa456103d$export$c90b54e658fc4d7c {
    succeed(attributes, publishDebugPoints) {
        if (this.hasStopped) return;
        this.onSuccess && this.onSuccess();
        this.stop({
            action: 'taskSuccess',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getAbsoluteDuration(),
            activeDuration: this.getDurationAdjustedForActive(),
            adjustedDuration: this.getDurationAdjustedForTabActivity(),
            ...publishDebugPoints && {
                debugPoints: this.debugPoints
            },
            attributes: {
                ...(0, $0b946e8b990b9608$export$3dc3660453120ccc)(),
                ...this.getFeatureGateAttributes(),
                ...this.attributes,
                ...attributes
            }
        });
    }
    fail({ error: error, attributes: attributes }) {
        if (this.hasStopped) return;
        if (error?.message && $b56cd77aa456103d$var$IGNORABLE_CLIENT_SIDE_ERRORS.includes(error.message)) {
            this.abort({
                reason: 'Aborted because of client side error',
                attributes: {
                    ...attributes,
                    clientSideError: error.message
                }
            });
            return;
        }
        this.onFailure && this.onFailure();
        this.stop({
            action: 'taskFail',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getAbsoluteDuration(),
            activeDuration: this.getDurationAdjustedForActive(),
            adjustedDuration: this.getDurationAdjustedForTabActivity(),
            debugPoints: this.debugPoints,
            error: error,
            attributes: {
                ...(0, $0b946e8b990b9608$export$3dc3660453120ccc)(),
                ...this.getFeatureGateAttributes(),
                ...this.attributes,
                ...attributes
            }
        });
    }
    abort({ reason: reason, attributes: attributes, checkForTimeout: checkForTimeout = true, publishDebugPoints: /**
     * @deprecated
     * This will not attach debug points in the event that the experience in scenarios where
     * the abort is not coming from consumer code (e.g. when the experience is stopped due
     * to a new experience starting).
     */ publishDebugPoints = false }) {
        if (this.hasStopped) return;
        const adjustedDuration = this.getDurationAdjustedForTabActivity();
        const isTimeout = checkForTimeout && this.timeout != null && adjustedDuration >= this.timeout;
        // Check if the experience should have failed due to timeout
        if (isTimeout) // We want to abort timeouts from view-page and create-page to improve SLO reliability accuracy as they're not guaranteed to be correlated to real user impact. For more info see MODES-4806.
        {
            if (!$b56cd77aa456103d$var$EXPERIENCE_TIMEOUTS_TO_ABORT.includes(this.name)) {
                this.fail({
                    attributes: {
                        originalAbortReason: reason,
                        ...attributes
                    },
                    error: new (0, $4b50c1dadb433c8a$export$d27a2b6293f7631c)(`${this.name} failed to complete in ${this.timeout}ms`)
                });
                return;
            }
        }
        this.onAbort && this.onAbort();
        this.stop({
            action: 'taskAbort',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getAbsoluteDuration(),
            activeDuration: this.getDurationAdjustedForActive(),
            adjustedDuration: adjustedDuration,
            ...$b56cd77aa456103d$var$EXPERIENCES_TO_DEBUG_ON_ABORT.includes(this.name) ? {
                debugPoints: this.debugPoints
            } : {},
            ...publishDebugPoints && {
                debugPoints: this.debugPoints
            },
            reason: isTimeout ? `ExperienceTimeout: ${this.name} failed to complete in ${this.timeout}ms` : reason,
            checkForTimeout: checkForTimeout,
            attributes: {
                originalAbortReason: isTimeout ? reason : undefined,
                ...(0, $0b946e8b990b9608$export$3dc3660453120ccc)(),
                ...this.getFeatureGateAttributes(),
                ...this.attributes,
                ...attributes
            }
        });
    }
    /**
   * Called on experience to stop it with the same action (success / failure / abort) and attributes as another event.
   * For example, compound experience (e.g. edit-page) is failed if sub-experience (e.g. edit-page/publish) fails.
   */ stopOn(event, extraAttributes = {}) {
        if (!event) return;
        if (event.action === 'taskSuccess') this.succeed({});
        else if (event.action === 'taskAbort') this.abort({
            reason: event.reason,
            attributes: {
                ...extraAttributes,
                stoppedOn: event.name,
                stoppedOnPath: this.getStoppedOnPath(event)
            },
            checkForTimeout: event.checkForTimeout
        });
        else if (event.action === 'taskFail') this.fail({
            error: event.error,
            attributes: {
                ...extraAttributes,
                stoppedOn: event.name,
                stoppedOnPath: this.getStoppedOnPath(event)
            }
        });
    }
    updateAttributes(attributes) {
        this.attributes = {
            ...this.attributes,
            ...attributes
        };
    }
    attachDebugPoint(message, attributes = {}) {
        if (this.debugPoints?.some((debugPoint)=>debugPoint.message === message)) // Avoid adding duplicate debug points
        return;
        this.debugPoints.push({
            timestamp: new Date().toISOString(),
            now: window.performance.now(),
            message: message,
            attributes: attributes
        });
    }
    getState() {
        return {
            taskId: this.id,
            timeout: this.timeout,
            hasStopped: this.hasStopped,
            stopState: this.stopState,
            startTime: this.startTime,
            name: this.name,
            attributes: this.attributes
        };
    }
    get hasStopped() {
        return this.stopState !== null;
    }
    stop(event) {
        this.stopState = event.action;
        if (this.onStop) this.onStop(event);
        (0, $93bba6ebad0146b8$export$40336562f0f00c2a)().unsubscribe(this.name);
    }
    getAbsoluteDuration() {
        return Math.round(window.performance.now() - this.startTime);
    }
    getDurationAdjustedForTabActivity() {
        return this.getAbsoluteDuration() - (0, $12387e80c2ebd079$export$39c3eb20723b04b)().getInactiveMillisecondsSince(this.startTime);
    }
    getDurationAdjustedForActive() {
        return this.getAbsoluteDuration() - this.freezeTime;
    }
    getStoppedOnPath(event) {
        if (!event.attributes?.stoppedOnPath) return event.name;
        return `${event.name},${event.attributes.stoppedOnPath}`;
    }
    constructor({ name: name, id: id, timeout: timeout, startTime: startTime = window.performance.now(), attributes: attributes, onStart: onStart, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort }){
        this.name = void 0;
        this.id = void 0;
        this.timeout = void 0;
        this.freezeTime = 0;
        this.stopState = null;
        this.startTime = void 0;
        this.attributes = void 0;
        this.onStop = void 0;
        this.onSuccess = void 0;
        this.onFailure = void 0;
        this.onAbort = void 0;
        this.debugPoints = [];
        // Include certain broad-impact feature gates in experience events
        this.getFeatureGateAttributes = (0, $8V6O9.default)(()=>{
            return {
                isContentWrapperEnabled: (0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_frontend_content_wrapper'),
                isNav4Enabled: (0, $f35f58e56b56de67$export$2af1f7a69c1ab0ad)()
            };
        });
        this.name = name;
        this.id = id;
        this.timeout = timeout;
        this.startTime = startTime;
        this.attributes = attributes;
        this.onSuccess = onSuccess;
        this.onFailure = onFailure;
        this.onAbort = onAbort;
        const startEvent = {
            action: 'taskStart',
            name: name,
            id: id,
            startTime: startTime,
            timeout: timeout,
            attributes: {
                ...(0, $0b946e8b990b9608$export$3dc3660453120ccc)(),
                ...attributes,
                ...this.getFeatureGateAttributes()
            }
        };
        if (onStart) this.onStop = onStart(startEvent);
        (0, $93bba6ebad0146b8$export$40336562f0f00c2a)().subscribe(name, (time)=>{
            this.freezeTime += time;
        });
    }
}




const $b4f5dc9bddcbc766$export$16e3f1b03b231b35 = (event)=>event.action === 'taskSuccess' || event.action === 'taskAbort' || event.action === 'taskFail';
const $b4f5dc9bddcbc766$export$57069f5b2ecc9128 = (event, ...names)=>names.includes(event.name);
const $b4f5dc9bddcbc766$export$7895096fcdde5712 = (event, key, value)=>Boolean(event.attributes?.hasOwnProperty(key) && event.attributes[key] === value);



const $db2847de8e87cb6c$var$EDIT_PAGE_SUBEXPERIENCES = [
    (0, $d4b865e8cc459c1f$export$54650b8dd9597591),
    (0, $d4b865e8cc459c1f$export$92edebd76eb1ad1),
    (0, $d4b865e8cc459c1f$export$4aed0cf42acf9c68)
];
const $db2847de8e87cb6c$var$COMPANY_HUB_EDITOR_SUBEXPERIENCES = [
    (0, $d4b865e8cc459c1f$export$35975591aeab4dd6),
    (0, $d4b865e8cc459c1f$export$7a3dfdccebea9c7b),
    (0, $d4b865e8cc459c1f$export$eef6122c9774ba1c)
];
const $db2847de8e87cb6c$export$b4cbec267823a12e = ()=>{
    (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$9e0dcc9389703292),
        collect: $db2847de8e87cb6c$export$bb44f104e3c54dae
    });
};
const $db2847de8e87cb6c$export$bb44f104e3c54dae = (events, experience)=>{
    experience.stopOn($db2847de8e87cb6c$export$e2067cc0ba855137(events, 'taskSuccess'));
    experience.stopOn($db2847de8e87cb6c$export$e2067cc0ba855137(events, 'taskFail'));
};
const $db2847de8e87cb6c$export$e2067cc0ba855137 = (events, action)=>{
    return events.find((event)=>event.action === action && (0, $b4f5dc9bddcbc766$export$57069f5b2ecc9128)(event, (0, $d4b865e8cc459c1f$export$dd70d6707192298e)));
};
const $db2847de8e87cb6c$export$2b69dcd5daaf6a2c = ()=>{
    const tracker = (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)();
    const editPageExperienceState = tracker.getExperienceState((0, $d4b865e8cc459c1f$export$dd70d6707192298e));
    const isEditPageRunning = editPageExperienceState && !editPageExperienceState.hasStopped;
    if (!isEditPageRunning) return false;
    // Validate all subexperiences are healthy. If any experience is unhealthy, `every` will immediately return false, otherwise true
    return $db2847de8e87cb6c$var$EDIT_PAGE_SUBEXPERIENCES.every((subexperience)=>{
        const subexperienceState = tracker.getExperienceState(subexperience);
        // Subexperience has not run, so edit-page is still healthy
        if (!subexperienceState) return true;
        // Subexperience has not run for current edit-page's contentId, so edit-page is still healthy
        if (subexperienceState.attributes?.contentId !== editPageExperienceState.attributes?.contentId) return true;
        // Subexperience has run and has finished successfully, so edit-page is still healthy
        if (subexperienceState.stopState === 'taskSuccess') return true;
        // Subexperience has run and has not finished successfully, so edit-page is unhealthy
        return false;
    });
};
const $db2847de8e87cb6c$export$c15dc70f74e1c751 = ()=>{
    const tracker = (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)();
    const hubEditorExperienceState = tracker.getExperienceState((0, $d4b865e8cc459c1f$export$c6d05c48b9430e3c));
    const isHubEditorRunning = hubEditorExperienceState && !hubEditorExperienceState.hasStopped;
    if (!isHubEditorRunning) return false;
    // Validate all subexperiences are healthy. If any experience is unhealthy, `every` will immediately return false, otherwise true
    return $db2847de8e87cb6c$var$COMPANY_HUB_EDITOR_SUBEXPERIENCES.every((subexperience)=>{
        const subexperienceState = tracker.getExperienceState(subexperience);
        // Subexperience has not run, so hub editor experience is still healthy
        if (!subexperienceState) return true;
        // Subexperience has run and has finished successfully, so hub editor experience is still healthy
        if (subexperienceState.stopState === 'taskSuccess') return true;
        // Subexperience has run and has not finished successfully, so hub editor experience is unhealthy
        return false;
    });
};



// eslint-disable-next-line import/no-cycle

const $4554f58440667b87$export$11699410c9e76883 = ({ parentExperience: parentExperience, subExperiences: subExperiences })=>{
    const tracker = (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)();
    const parentExperienceState = tracker.getExperienceState(parentExperience);
    const isParentExperienceRunning = parentExperienceState && !parentExperienceState.hasStopped;
    if (!isParentExperienceRunning) return false;
    const parentExperienceContentId = String(parentExperienceState.attributes?.contentId);
    return $4554f58440667b87$var$areSubExperiencesHealthy({
        parentExperienceContentId: parentExperienceContentId,
        subExperiences: subExperiences
    });
};
const $4554f58440667b87$var$areSubExperiencesHealthy = ({ parentExperienceContentId: parentExperienceContentId, subExperiences: subExperiences = [] })=>{
    const tracker = (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)();
    // Validate all subExperiences are healthy. If any experience is unhealthy, `every` will immediately return false, otherwise true
    return subExperiences.every((subExperience)=>{
        const subExperienceState = tracker.getExperienceState(subExperience);
        // Subexperience has not run, so parent is still healthy
        if (!subExperienceState) return true;
        // Subexperience has not run for current parentExperience's contentId, so parentExperience is still healthy
        const isSubExperienceForDifferentContent = parentExperienceContentId !== subExperienceState.attributes?.contentId;
        if (isSubExperienceForDifferentContent) return true;
        const hasSubExperienceCompletedSuccessfully = subExperienceState.stopState === 'taskSuccess';
        if (hasSubExperienceCompletedSuccessfully) return true;
        // Subexperience has run and has not finished successfully, so parentExperience is unhealthy
        return false;
    });
};


const $59f627305e19cfab$export$77dd5573732a240c = ()=>(0, $4554f58440667b87$export$11699410c9e76883)({
        parentExperience: (0, $d4b865e8cc459c1f$export$5e30e9d7ea54dcd2),
        subExperiences: [
            (0, $d4b865e8cc459c1f$export$d4712ac27cc4e72f)
        ]
    });
const $59f627305e19cfab$export$41f7b734fb3e4a50 = ({ id: id, tracker: tracker, attributes: attributes, startTime: startTime })=>{
    tracker.start({
        name: (0, $d4b865e8cc459c1f$export$5e30e9d7ea54dcd2),
        id: id,
        startTime: startTime,
        attributes: attributes,
        collect: (events, experience)=>{
            const viewExperienceLoadingFailed = events.find(({ action: action, name: name })=>action === 'taskFail' && name === (0, $d4b865e8cc459c1f$export$d4712ac27cc4e72f));
            const viewExperienceLoadingAborted = events.find(({ action: action, name: name })=>action === 'taskAbort' && name === (0, $d4b865e8cc459c1f$export$d4712ac27cc4e72f));
            if (viewExperienceLoadingFailed) experience.fail({
                error: new Error('View page load experience failed')
            });
            else if (viewExperienceLoadingAborted) experience.abort({
                reason: 'View page load experience aborted'
            });
        }
    });
};



function $09236c8503a0584b$var$getExperienceStopReason(error) {
    // message text check is a stop-gap measure due to re-packaging of errors. refactoring is underway.
    if ((0, $ebb54c1f7b9c33e4$export$b8c2308c7b82c3a9)(error)) return `Aborted because of session expiration error: ${error.toString()}`;
    if ((0, $65398bb1ddc9160a$export$bda33884db3cf75b)(error)) return `Aborted because of network error: ${error.toString()}`;
    return undefined;
}
class $09236c8503a0584b$export$12b6b072930fd68f {
    start({ name: name, id: id = (0, (/*@__PURE__*/$parcel$interopDefault($c29b43bb0df96673$exports)))(), timeout: timeout, startTime: startTime, attributes: attributes, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort, collect: collect }) {
        const current = this.experiences[name];
        // Do not restart an experience that has the same id and is still running
        if (current && current.id === id && !current.hasStopped) return;
        // Before replacing a current experience, abort it to ensure it is cleaned up.
        if (current && !current.hasStopped) current.abort({
            reason: 'Aborted because the same experience was started with a new id',
            attributes: {
                newTaskId: id
            }
        });
        const experience = new (0, $b56cd77aa456103d$export$c90b54e658fc4d7c)({
            name: name,
            id: id,
            timeout: timeout,
            startTime: startTime,
            attributes: attributes,
            onSuccess: onSuccess,
            onFailure: onFailure,
            onAbort: onAbort,
            onStart: (startEvent)=>{
                this.emit(startEvent);
                let disposeCollectSubscription = ()=>{};
                if (collect) {
                    const events = [];
                    disposeCollectSubscription = this.subscribe((event)=>{
                        // Ignore already running experiences that started before this
                        // experience started
                        if (event.action === 'taskStart' || events.some((previousEvent)=>previousEvent.name === event.name && previousEvent.action === 'taskStart')) {
                            events.push(event);
                            collect(events, experience);
                        }
                    });
                }
                return (stopEvent)=>{
                    disposeCollectSubscription();
                    this.emit(stopEvent);
                };
            }
        });
        this.experiences[name] = experience;
    }
    succeed({ name: name, attributes: attributes, publishDebugPoints: publishDebugPoints }) {
        const current = this.experiences[name];
        if (!current) return;
        current.succeed(attributes, publishDebugPoints);
    }
    fail({ name: name, error: error, attributes: attributes }) {
        Object.values(this.experiences).forEach((current)=>{
            if (name != null && current.name !== name) return;
            current.fail({
                error: error,
                attributes: attributes
            });
        });
    }
    abort({ name: name, reason: reason, attributes: attributes, checkForTimeout: checkForTimeout, publishDebugPoints: publishDebugPoints }) {
        Object.values(this.experiences).forEach((experience)=>{
            if (name != null && experience.name !== name) return;
            experience.abort({
                reason: reason,
                checkForTimeout: checkForTimeout,
                attributes: attributes,
                publishDebugPoints: publishDebugPoints
            });
        });
    }
    stopOnError({ error: error, name: name, attributes: attributes }) {
        const reason = $09236c8503a0584b$var$getExperienceStopReason(error);
        if (reason) {
            this.abort({
                name: name,
                reason: reason,
                checkForTimeout: false,
                attributes: attributes
            });
            return;
        }
        this.fail({
            name: name,
            error: error,
            attributes: attributes
        });
    }
    subscribe(subscriber) {
        if (typeof subscriber !== 'function') throw new Error('Subscriber must be a function');
        this.subscribers.push(subscriber);
        return ()=>{
            this.subscribers = this.subscribers.filter((x)=>x !== subscriber);
        };
    }
    getExperienceState(experienceName) {
        return this.experiences[experienceName] ? this.experiences[experienceName].getState() : null;
    }
    updateAttributes({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.updateAttributes(attributes);
    }
    attachDebugPoint({ name: name, message: message, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.attachDebugPoint(message, attributes);
    }
    emit(event) {
        this.logger.debug`${event.action} ${event}`;
        this.subscribers.forEach((subscriber)=>{
            try {
                subscriber(event);
            } catch (e) {
                this.logger.error`Error occurred in ExperienceTracker subscriber ${e} when handling event ${event}`;
            }
        });
    }
    constructor(){
        this.experiences = {};
        this.subscribers = [];
        this.logger = (0, $a6897acd40ed68b1$export$2b1d391cd05230fd)('ExperienceTracker');
        (0, $93bba6ebad0146b8$export$40336562f0f00c2a)().start();
        if (typeof window !== 'undefined') window.addEventListener('pagehide', ()=>{
            const livePageEditExperienceState = this.getExperienceState((0, $d4b865e8cc459c1f$export$dd70d6707192298e));
            const livePageSessionExperienceState = this.getExperienceState((0, $d4b865e8cc459c1f$export$3814d28dd3802a02));
            const experiencesToSucceed = [
                {
                    name: (0, $d4b865e8cc459c1f$export$dd70d6707192298e),
                    successCondition: livePageEditExperienceState && !livePageEditExperienceState.hasStopped && livePageEditExperienceState.attributes?.isLivePage
                },
                {
                    name: (0, $d4b865e8cc459c1f$export$dd70d6707192298e),
                    successCondition: (0, $db2847de8e87cb6c$export$2b69dcd5daaf6a2c)()
                },
                {
                    name: (0, $d4b865e8cc459c1f$export$5e30e9d7ea54dcd2),
                    successCondition: (0, $59f627305e19cfab$export$77dd5573732a240c)()
                },
                {
                    name: (0, $d4b865e8cc459c1f$export$3814d28dd3802a02),
                    successCondition: livePageSessionExperienceState && !livePageSessionExperienceState.hasStopped
                }
            ];
            experiencesToSucceed.forEach(({ name: name, successCondition: successCondition })=>{
                if (successCondition) this.succeed({
                    name: name
                });
            });
            // Abort the rest of our experiences.
            this.abort({
                reason: 'Window unloading'
            });
        });
    }
}



const $fb98a59fbc7d7496$var$SLA_EXPERIENCES = new Set([
    // Currently not SLA experience, but will be in the future
    (0, $d4b865e8cc459c1f$export$f8e0e16825f0d222),
    (0, $d4b865e8cc459c1f$export$6f58645a9a5f7936),
    (0, $d4b865e8cc459c1f$export$20fbac00cba3c8a),
    // SLA experiences ⬇️
    (0, $d4b865e8cc459c1f$export$f94e85276e6d639f),
    (0, $d4b865e8cc459c1f$export$227ea80a7d6d8ef2),
    (0, $d4b865e8cc459c1f$export$dd70d6707192298e),
    (0, $d4b865e8cc459c1f$export$d4712ac27cc4e72f)
]);
const $fb98a59fbc7d7496$var$activeSlaExperiences = new Map();
const $fb98a59fbc7d7496$var$activeExperiences = new Set();
const $fb98a59fbc7d7496$var$currentRoute = {
    routeName: '',
    successfulExperiences: new Set()
};
const $fb98a59fbc7d7496$var$previousRoute = {
    routeName: '',
    successfulExperiences: new Set()
};
function $fb98a59fbc7d7496$export$6369eb07eb8a8518({ action: action, name: name, id: id, attributes: attributes = {} }) {
    const isSlaExperience = $fb98a59fbc7d7496$var$SLA_EXPERIENCES.has(name);
    if (action === 'taskStart') {
        if (isSlaExperience) {
            // Create a unique experience ID for request headers
            attributes.uniqueExperienceId = (0, (/*@__PURE__*/$parcel$interopDefault($c29b43bb0df96673$exports)))();
            $fb98a59fbc7d7496$var$activeSlaExperiences.set(name, {
                id: id,
                attributes: attributes
            });
        }
        $fb98a59fbc7d7496$var$activeExperiences.add(name);
    } else {
        if (isSlaExperience) {
            // Extract unique experience ID to attach to event attributes for analytics/monitoring logs
            attributes.uniqueExperienceId = $fb98a59fbc7d7496$var$activeSlaExperiences.get(name)?.attributes?.uniqueExperienceId;
            $fb98a59fbc7d7496$var$activeSlaExperiences.delete(name);
        }
        $fb98a59fbc7d7496$var$activeExperiences.delete(name);
        if (action === 'taskSuccess') $fb98a59fbc7d7496$var$currentRoute.successfulExperiences.add(name);
    }
    const slaExperience = $fb98a59fbc7d7496$export$1e7d0a9a962cdd28();
    const experiences = $fb98a59fbc7d7496$var$activeExperiences.size > 0 ? $fb98a59fbc7d7496$var$activeExperiences : null;
    if (slaExperience || experiences) {
        const updatedContext = {};
        if (experiences) updatedContext.activeExperiences = $fb98a59fbc7d7496$var$activeExperiences;
        if (slaExperience) updatedContext.slaExperience = slaExperience.name;
        (0, $d1c1e8e192b1a688$export$39a3b7739331403b)().updateContext(updatedContext);
    }
}
function $fb98a59fbc7d7496$export$1e7d0a9a962cdd28() {
    if ($fb98a59fbc7d7496$var$activeSlaExperiences.size === 0) return null;
    const experienceEntry = Array.from($fb98a59fbc7d7496$var$activeSlaExperiences).pop();
    return {
        ...experienceEntry[1],
        name: experienceEntry[0]
    };
}
const $fb98a59fbc7d7496$export$a1fa58e5690a5a9a = (0, $8V6O9.default)(()=>{
    const tracker = new (0, $09236c8503a0584b$export$12b6b072930fd68f)();
    // Do nothing for search engine crawlers
    if (/bot/i.test(window.navigator.userAgent)) return tracker;
    tracker.subscribe((event)=>{
        //
        // View Page SLA Split
        //
        if (event.name === (0, $d4b865e8cc459c1f$export$cf73dfff88c1f700)) {
            $fb98a59fbc7d7496$var$splitViewContentExperience(tracker, event);
            // View-content was introduced only to split space-overview out of
            // view-page, because view-page is covered by Premium SLA and
            // space-overview was not satisfactorily reliable. View-content is not
            // allowlisted in cc-fe-telemetry so submitting through MonitoringClient
            // below is a waste. Sending through AnalyticsWebClient is a waste too
            // since view-content is not tracked as an SLO and it could be derived
            // from view-page and space-overview which are tracked as separate SLOs
            // already anyway. Splunk found 23 million view-content events in the last
            // 24 hours which is about 3% of experience-tracker events.
            return;
        }
        $fb98a59fbc7d7496$export$6369eb07eb8a8518(event);
        //
        // AnalyticsWebClient
        //
        (0, $b76dfd1db5681318$export$e9ba7ef9458d1a4a)().then((client)=>{
            client.sendOperationalEvent((0, $a4ab9c0cf734aa2a$export$9c05e7ef9f2c8895)($fb98a59fbc7d7496$var$provideGenericAttributes(event)));
        });
        //
        // MonitoringClient
        //
        const isTimeoutError = event.action === 'taskFail' && event?.error?.name === 'ExperienceTimeoutError' || event.action === 'taskAbort' && typeof event?.reason === 'string' && event.reason.startsWith('ExperienceTimeout');
        const isPermissionError = event.name === (0, $d4b865e8cc459c1f$export$dd70d6707192298e) && event.action === 'taskAbort' && (event.reason?.includes?.('401') || event.reason?.includes?.('403'));
        const tags = [
            `action:${event.action}`,
            `isActiveTab:${document.visibilityState === 'visible'}`,
            ...event.action === 'taskFail' || event.action === 'taskAbort' ? [
                `isTimeoutError:${isTimeoutError}`
            ] : [],
            ...event.name === (0, $d4b865e8cc459c1f$export$dd70d6707192298e) && event.action === 'taskAbort' ? [
                `isPermissionError:${isPermissionError}`
            ] : []
        ];
        if (event.attributes) for(const a in event.attributes)tags.push(`${a}:${event.attributes[a]}`);
        if (event.action === 'taskFail' && $fb98a59fbc7d7496$var$SLA_EXPERIENCES.has(event.name)) {
            // in this section, we submit information about SLA-affecting experience failures.
            // We don't submit timeout errors to monitoring systems however; they would be submitted to Analytics instead.
            // cc-fe-telemetry will filter these additional tags before sending to SFX, these are only for "Raw TelemetryEvent" Splunk logs
            if (event?.error?.message) tags.push(`error:${event.error.message}`);
            // Supply additional information from alternative sources, for case where SessionDataQuery is not available
            tags.push(`hostname:${window.location.hostname}`);
            tags.push(`tenantIdMeta:${(0, $b9d7d5d25d527513$export$72427a1521dd0069)('cloud-id')}`);
            (0, $d1c1e8e192b1a688$export$39a3b7739331403b)().incrementCounter(`experience-tracker:${event.name}`, tags);
            if (!(event.error instanceof (0, $4b50c1dadb433c8a$export$d27a2b6293f7631c))) {
                (0, $8a3a8685062675cc$export$c37ca7d37ab54fcc)(event.error, {
                    objectId: event.attributes?.contentId
                });
                (0, $8a3a8685062675cc$export$a986f274521b30d7)(event.error, {
                    failedSlaExperience: event.name,
                    experienceId: event.attributes?.uniqueExperienceId ?? event.id
                });
                (0, $d1c1e8e192b1a688$export$39a3b7739331403b)().submitError(event.error, {
                    attribution: 'sla'
                });
            }
        } else (0, $d1c1e8e192b1a688$export$39a3b7739331403b)().incrementCounter(`experience-tracker:${event.name}`, tags);
    });
    return tracker;
});
function $fb98a59fbc7d7496$export$720dc4209419df4e(name, error, attributes) {
    $fb98a59fbc7d7496$export$a1fa58e5690a5a9a().stopOnError({
        name: name,
        error: error,
        attributes: attributes
    });
}
const $fb98a59fbc7d7496$export$1c9cdc2685ab8d2 = (tracker, event, name = event.name)=>{
    switch(event.action){
        case 'taskStart':
            tracker.start({
                ...event,
                name: name
            });
            break;
        case 'taskSuccess':
            tracker.succeed({
                ...event,
                name: name
            });
            break;
        case 'taskFail':
            tracker.fail({
                ...event,
                name: name
            });
            break;
        case 'taskAbort':
            tracker.abort({
                ...event,
                name: name
            });
    }
};
function $fb98a59fbc7d7496$export$e8918c537d57dc96(routeName) {
    $fb98a59fbc7d7496$var$previousRoute.routeName = $fb98a59fbc7d7496$var$currentRoute.routeName;
    $fb98a59fbc7d7496$var$previousRoute.successfulExperiences = $fb98a59fbc7d7496$var$currentRoute.successfulExperiences;
    $fb98a59fbc7d7496$var$currentRoute.routeName = routeName;
    $fb98a59fbc7d7496$var$currentRoute.successfulExperiences = new Set();
}
function $fb98a59fbc7d7496$export$5259f71d975e46f5() {
    return {
        ...$fb98a59fbc7d7496$var$previousRoute
    };
}
const $fb98a59fbc7d7496$var$splitViewContentExperience = (tracker, event)=>{
    let name;
    if (event.attributes?.contentType === 'space') {
        name = (0, $d4b865e8cc459c1f$export$2a57468d23984a9d);
        const spaceKey = event.attributes?.spaceKey;
        if (typeof spaceKey === 'string' && (0, $a4b9a8903fd62c69$export$5ab9c400208ad907)(spaceKey)) name = (0, $d4b865e8cc459c1f$export$7f2689ec25c432a4);
    } else {
        name = (0, $d4b865e8cc459c1f$export$d4712ac27cc4e72f);
        if (event.action === 'taskStart') (0, $59f627305e19cfab$export$41f7b734fb3e4a50)({
            tracker: tracker,
            attributes: {
                ...event.attributes
            },
            startTime: event.startTime,
            id: event.id
        });
    }
    $fb98a59fbc7d7496$export$1c9cdc2685ab8d2(tracker, event, name);
};
/**
 * Extend the ExperienceEvent with Confluence-specific additional attributes based on available data and type of event.
 *
 * @param event ExperienceEvent
 * @returns ExperienceEvent with additional attributes
 */ const $fb98a59fbc7d7496$var$provideGenericAttributes = (event)=>{
    const errorTraceId = event.action === 'taskFail' && !!event?.error ? (0, $8a3a8685062675cc$export$d08bac32cb78075f)(event.error)?.traceId : undefined;
    // Expected that condition will be extended with && for other attributes added in the future
    if (!errorTraceId) return event;
    event.attributes = {
        ...!!errorTraceId && {
            traceId: errorTraceId
        },
        ...event.attributes
    };
    return event;
};




var $6ANHb = parcelRequire("6ANHb");

const $7dd419c244a11d60$export$cdb0163d35da79f3 = '__EP_REACT_PROPS_OBSERVABLE_OBJECT__';


// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

const $e9e2bcccb1f9baee$export$ab9998995666ebe3 = 'embedded-confluence-iframe';
const $e9e2bcccb1f9baee$export$f2fe03976fe13de = ()=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    return `${$e9e2bcccb1f9baee$export$ab9998995666ebe3}-${(0, $19dcc840d0563c39$exports.v4)()}`;
};
const $e9e2bcccb1f9baee$export$45b0adb7f9689286 = 'passThroughProps';
const $e9e2bcccb1f9baee$export$78cada8c8749e264 = 'propsUpdated';
const $e9e2bcccb1f9baee$export$b75934a6b56fd9ba = 'experienceForwarding';


const $fec428bb735add06$export$8195e508b27d5978 = ()=>Boolean(window?.frameElement?.[0, $7dd419c244a11d60$export$cdb0163d35da79f3]) || window?.name.includes((0, $e9e2bcccb1f9baee$export$ab9998995666ebe3));


const $213017de3b9c3542$export$9c21f25960873ecb = (location)=>{
    if (!location) location = window.location;
    const { query: query } = (0, (/*@__PURE__*/$parcel$interopDefault($6ANHb))).parse(location.search, true);
    return query.embedded === 'true' || Boolean(query.parentProduct) || (0, $fec428bb735add06$export$8195e508b27d5978)();
};





const $6d6794975d4b2dd0$var$fetchGet = (resource)=>{
    // eslint-disable-next-line no-restricted-syntax
    return fetch(resource, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        }
    });
};
const $6d6794975d4b2dd0$var$fetchPartialSessionDataFromAlternateSources = ()=>{
    const fetchUserIdFromIdentity = async ()=>{
        const response = await $6d6794975d4b2dd0$var$fetchGet('/gateway/api/me');
        const responseData = await response.json();
        return responseData?.account_id;
    };
    const fetchTenantIdFromEdge = async ()=>{
        const response = await $6d6794975d4b2dd0$var$fetchGet('/_edge/tenant_info');
        const responseData = await response.json();
        return responseData?.cloudId;
    };
    const isStagingEnvironment = [
        'branch',
        'staging',
        'stg-fedm',
        'dev'
    ].includes("production");
    return Promise.all([
        fetchUserIdFromIdentity(),
        fetchTenantIdFromEdge()
    ]).then(([userId, cloudId])=>{
        return {
            cloudId: cloudId,
            userId: userId,
            environment: isStagingEnvironment ? 'STAGING' : 'PRODUCTION'
        };
    });
};
const $6d6794975d4b2dd0$export$66b82bc0ee0db41d = ()=>{
    return $6d6794975d4b2dd0$var$fetchPartialSessionDataFromAlternateSources().then((data)=>{
        const { cloudId: cloudId, userId: userId, environment: environment } = data;
        const isEmbeddedConfluence = (0, $213017de3b9c3542$export$9c21f25960873ecb)();
        const product = isEmbeddedConfluence ? 'embeddedConfluence' : 'confluence';
        /*
			 * Analytics Web Client initialization
			 *
			 * `initializeAnalyticsClient` is an asynchronous function. We start it but do not await it here. This allows the
			 * Error App UI, visible to the user, to be rendered ASAP
			 *
			 * The app relies on the consumers of the Analytics Client to await it when they use getAnalyticsWebClient.
			 */ (0, $b76dfd1db5681318$export$7d842b959fcdcd03)({
            cloudId: cloudId,
            userId: userId,
            environment: environment,
            product: product
        });
        // Monitoring context initialization
        (0, $d1c1e8e192b1a688$export$39a3b7739331403b)().updateContext({
            tenantId: cloudId,
            product: product
        });
        // Storage manager initialization
        return (0, $8b7debc8685a2ab6$export$68017d60ff81319c)({
            userId: userId ?? ''
        });
    }).catch(()=>{
    // Unfortunately if we can't initialize the analytics client, we can't log the error
    });
};



var $dQwsT = parcelRequire("dQwsT");
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $dEf6I = parcelRequire("dEf6I");

var $dQwsT = parcelRequire("dQwsT");

var $dQwsT = parcelRequire("dQwsT");

var $dEf6I = parcelRequire("dEf6I");

var $dQwsT = parcelRequire("dQwsT");
var $9a700870d8fe9f94$exports = {};
'use strict';
var $518a8d25422133c1$exports = {};
'use strict';

$518a8d25422133c1$exports = (parcelRequire("90GGF"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $9a700870d8fe9f94$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $9a700870d8fe9f94$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $9a700870d8fe9f94$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $9a700870d8fe9f94$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $9a700870d8fe9f94$var$TYPE_STATICS = {};
$9a700870d8fe9f94$var$TYPE_STATICS[$518a8d25422133c1$exports.ForwardRef] = $9a700870d8fe9f94$var$FORWARD_REF_STATICS;
$9a700870d8fe9f94$var$TYPE_STATICS[$518a8d25422133c1$exports.Memo] = $9a700870d8fe9f94$var$MEMO_STATICS;
function $9a700870d8fe9f94$var$getStatics(component) {
    // React v16.11 and below
    if ($518a8d25422133c1$exports.isMemo(component)) return $9a700870d8fe9f94$var$MEMO_STATICS;
     // React v16.12 and above
    return $9a700870d8fe9f94$var$TYPE_STATICS[component['$$typeof']] || $9a700870d8fe9f94$var$REACT_STATICS;
}
var $9a700870d8fe9f94$var$defineProperty = Object.defineProperty;
var $9a700870d8fe9f94$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $9a700870d8fe9f94$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $9a700870d8fe9f94$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $9a700870d8fe9f94$var$getPrototypeOf = Object.getPrototypeOf;
var $9a700870d8fe9f94$var$objectPrototype = Object.prototype;
function $9a700870d8fe9f94$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($9a700870d8fe9f94$var$objectPrototype) {
            var inheritedComponent = $9a700870d8fe9f94$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $9a700870d8fe9f94$var$objectPrototype) $9a700870d8fe9f94$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $9a700870d8fe9f94$var$getOwnPropertyNames(sourceComponent);
        if ($9a700870d8fe9f94$var$getOwnPropertySymbols) keys = keys.concat($9a700870d8fe9f94$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $9a700870d8fe9f94$var$getStatics(targetComponent);
        var sourceStatics = $9a700870d8fe9f94$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$9a700870d8fe9f94$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $9a700870d8fe9f94$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $9a700870d8fe9f94$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$9a700870d8fe9f94$exports = $9a700870d8fe9f94$var$hoistNonReactStatics;



var $dEf6I = parcelRequire("dEf6I");

var $dQwsT = parcelRequire("dQwsT");
/**
 * Cannot do Math.log(x) / Math.log(10) bc if IEEE floating point issue
 * @param x number
 */ function $d9dfc91177f936a8$export$f535bb00660c42db(x) {
    // Cannot count string length via Number.toString because it may use scientific notation
    // for very small or very large numbers.
    return Math.floor(Math.log(x) * Math.LOG10E);
}
function $d9dfc91177f936a8$export$76d90c956114f2c2(s, times) {
    if (typeof s.repeat === 'function') return s.repeat(times);
    var arr = new Array(times);
    for(var i = 0; i < arr.length; i++)arr[i] = s;
    return arr.join('');
}
function $d9dfc91177f936a8$export$489176b9ebc725cc(map, pl, field, value) {
    if (!map.get(pl)) map.set(pl, Object.create(null));
    var slots = map.get(pl);
    slots[field] = value;
}
function $d9dfc91177f936a8$export$d21499e79b5c28e2(map, pl, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var k = _a[_i];
        $d9dfc91177f936a8$export$489176b9ebc725cc(map, pl, k, props[k]);
    }
}
function $d9dfc91177f936a8$export$3fae2929ed23c202(map, pl, field) {
    return $d9dfc91177f936a8$export$ca4e2274c058dd9f(map, pl, field)[field];
}
function $d9dfc91177f936a8$export$ca4e2274c058dd9f(map, pl) {
    var fields = [];
    for(var _i = 2; _i < arguments.length; _i++)fields[_i - 2] = arguments[_i];
    var slots = map.get(pl);
    if (!slots) throw new TypeError("".concat(pl, " InternalSlot has not been initialized"));
    return fields.reduce(function(all, f) {
        all[f] = slots[f];
        return all;
    }, Object.create(null));
}
function $d9dfc91177f936a8$export$25c75e09b890f24e(patternPart) {
    return patternPart.type === 'literal';
}
function $d9dfc91177f936a8$export$fdab3c20aae16ddf(target, name, _a) {
    var value = _a.value;
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value
    });
}
var $d9dfc91177f936a8$export$9049a02e759202e4 = /-u(?:-[0-9a-z]{2,8})+/gi;
function $d9dfc91177f936a8$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}



var $dEf6I = parcelRequire("dEf6I");
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $dEf6I = parcelRequire("dEf6I");

var $dEf6I = parcelRequire("dEf6I");
var $a5bd10e1e47e30d8$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($a5bd10e1e47e30d8$export$896afd8541959ee5 || ($a5bd10e1e47e30d8$export$896afd8541959ee5 = {}));



var $dEf6I = parcelRequire("dEf6I");

var $202e72aad5f79509$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($202e72aad5f79509$export$b87f371cbc396fcf || ($202e72aad5f79509$export$b87f371cbc396fcf = {}));
var $202e72aad5f79509$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($202e72aad5f79509$export$906452485466fa53 || ($202e72aad5f79509$export$906452485466fa53 = {}));
function $202e72aad5f79509$export$cfa10c5697238752(el) {
    return el.type === $202e72aad5f79509$export$b87f371cbc396fcf.literal;
}
function $202e72aad5f79509$export$4f55724281bdfaf9(el) {
    return el.type === $202e72aad5f79509$export$b87f371cbc396fcf.argument;
}
function $202e72aad5f79509$export$e11187b219e191e1(el) {
    return el.type === $202e72aad5f79509$export$b87f371cbc396fcf.number;
}
function $202e72aad5f79509$export$32d811605da75f40(el) {
    return el.type === $202e72aad5f79509$export$b87f371cbc396fcf.date;
}
function $202e72aad5f79509$export$34ec46f596b1702f(el) {
    return el.type === $202e72aad5f79509$export$b87f371cbc396fcf.time;
}
function $202e72aad5f79509$export$dcfe1c11d168b5a1(el) {
    return el.type === $202e72aad5f79509$export$b87f371cbc396fcf.select;
}
function $202e72aad5f79509$export$6c796d116f0a4fbc(el) {
    return el.type === $202e72aad5f79509$export$b87f371cbc396fcf.plural;
}
function $202e72aad5f79509$export$c0ece297bdd0c082(el) {
    return el.type === $202e72aad5f79509$export$b87f371cbc396fcf.pound;
}
function $202e72aad5f79509$export$5c83de34745812b(el) {
    return el.type === $202e72aad5f79509$export$b87f371cbc396fcf.tag;
}
function $202e72aad5f79509$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === 'object' && el.type === $202e72aad5f79509$export$906452485466fa53.number);
}
function $202e72aad5f79509$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === 'object' && el.type === $202e72aad5f79509$export$906452485466fa53.dateTime);
}
function $202e72aad5f79509$export$f0ac572c1121c662(value) {
    return {
        type: $202e72aad5f79509$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $202e72aad5f79509$export$425e864b0ba114f1(value, style) {
    return {
        type: $202e72aad5f79509$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}


// @generated from regex-gen.ts
var $b0922d646f9f7547$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $b0922d646f9f7547$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;


/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $756c9c62c803ea46$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $756c9c62c803ea46$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($756c9c62c803ea46$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = [
                    'numeric',
                    '2-digit',
                    'short',
                    'long',
                    'narrow'
                ][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'short' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) throw new RangeError('`e..eee` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            case 'c':
                if (len < 4) throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            // Period
            case 'a':
                result.hour12 = true;
                break;
            case 'b':
            case 'B':
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            // Second
            case 's':
                result.second = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z':
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z':
            case 'O':
            case 'v':
            case 'V':
            case 'X':
            case 'x':
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}



var $dEf6I = parcelRequire("dEf6I");
// @generated from regex-gen.ts
var $4515cd96ccfdf1fb$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;


function $43f9504d448840fb$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error('Number skeleton cannot be empty');
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $4515cd96ccfdf1fb$export$2b8db14d8bcaece7)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) throw new Error('Invalid number skeleton');
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error('Invalid number skeleton');
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $43f9504d448840fb$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var $43f9504d448840fb$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $43f9504d448840fb$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $43f9504d448840fb$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $43f9504d448840fb$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $43f9504d448840fb$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') result.roundingPriority = 'morePrecision';
    else if (str[str.length - 1] === 's') result.roundingPriority = 'lessPrecision';
    str.replace($43f9504d448840fb$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === '+') result.minimumSignificantDigits = g1.length;
        else if (g1[0] === '#') result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function $43f9504d448840fb$var$parseSign(str) {
    switch(str){
        case 'sign-auto':
            return {
                signDisplay: 'auto'
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting'
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always'
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting'
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero'
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting'
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never'
            };
    }
}
function $43f9504d448840fb$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering'
        };
        stem = stem.slice(2);
    } else if (stem[0] === 'E') {
        result = {
            notation: 'scientific'
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        } else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!$43f9504d448840fb$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error('Malformed concise eng/scientific notation');
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $43f9504d448840fb$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $43f9504d448840fb$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $43f9504d448840fb$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = $43f9504d448840fb$var$icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = (0, $dEf6I.__assign)((0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, result), {
                    notation: 'scientific'
                }), token.options.reduce(function(all, opt) {
                    return (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, all), $43f9504d448840fb$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'engineering':
                result = (0, $dEf6I.__assign)((0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, result), {
                    notation: 'engineering'
                }), token.options.reduce(function(all, opt) {
                    return (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, all), $43f9504d448840fb$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) throw new RangeError('integer-width stems only accept a single optional option');
                token.options[0].replace($43f9504d448840fb$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error('We currently do not support maximum integer digits');
                    else if (g5) throw new Error('We currently do not support exact integer digits');
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($43f9504d448840fb$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($43f9504d448840fb$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError('Fraction-precision stems only accept a single optional option');
            token.stem.replace($43f9504d448840fb$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === '#') result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') result = (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, result), {
                trailingZeroDisplay: 'stripIfInteger'
            });
            else if (opt) result = (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, result), $43f9504d448840fb$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($43f9504d448840fb$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, result), $43f9504d448840fb$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $43f9504d448840fb$var$parseSign(token.stem);
        if (signOpts) result = (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $43f9504d448840fb$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}




// @generated from time-data-gen.ts
// prettier-ignore  
var $7557cdb9b2d7a6d9$export$a8c9209db4084317 = {
    "AX": [
        "H"
    ],
    "BQ": [
        "H"
    ],
    "CP": [
        "H"
    ],
    "CZ": [
        "H"
    ],
    "DK": [
        "H"
    ],
    "FI": [
        "H"
    ],
    "ID": [
        "H"
    ],
    "IS": [
        "H"
    ],
    "ML": [
        "H"
    ],
    "NE": [
        "H"
    ],
    "RU": [
        "H"
    ],
    "SE": [
        "H"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "AS": [
        "h",
        "H"
    ],
    "BT": [
        "h",
        "H"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "GH": [
        "h",
        "H"
    ],
    "IN": [
        "h",
        "H"
    ],
    "LS": [
        "h",
        "H"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PW": [
        "h",
        "H"
    ],
    "SO": [
        "h",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WS": [
        "h",
        "H"
    ],
    "001": [
        "H",
        "h"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "AR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CL": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CU": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BO": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-EC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-PE": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "GT": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "HN": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MX": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "NI": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "PY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "SV": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "UY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "JP": [
        "H",
        "h",
        "K"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BO": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "EC": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "PE": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ]
};


function $801da8f0eda57737$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = '';
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = $801da8f0eda57737$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === 'J') skeletonCopy += 'H';
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $801da8f0eda57737$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case 'h24':
            return 'k';
        case 'h23':
            return 'H';
        case 'h12':
            return 'h';
        case 'h11':
            return 'K';
        default:
            throw new Error('Invalid hourCycle');
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') regionTag = locale.maximize().region;
    var hourCycles = (0, $7557cdb9b2d7a6d9$export$a8c9209db4084317)[regionTag || ''] || (0, $7557cdb9b2d7a6d9$export$a8c9209db4084317)[languageTag || ''] || (0, $7557cdb9b2d7a6d9$export$a8c9209db4084317)["".concat(languageTag, "-001")] || (0, $7557cdb9b2d7a6d9$export$a8c9209db4084317)['001'];
    return hourCycles[0];
}


var $9e7ee4906fbe8525$var$_a;
var $9e7ee4906fbe8525$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $b0922d646f9f7547$export$523451f94304dd6c).source, "*"));
var $9e7ee4906fbe8525$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $b0922d646f9f7547$export$523451f94304dd6c).source, "*$"));
function $9e7ee4906fbe8525$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $9e7ee4906fbe8525$var$hasNativeStartsWith = !!String.prototype.startsWith;
var $9e7ee4906fbe8525$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $9e7ee4906fbe8525$var$hasNativeFromEntries = !!Object.fromEntries;
var $9e7ee4906fbe8525$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $9e7ee4906fbe8525$var$hasTrimStart = !!String.prototype.trimStart;
var $9e7ee4906fbe8525$var$hasTrimEnd = !!String.prototype.trimEnd;
var $9e7ee4906fbe8525$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $9e7ee4906fbe8525$var$isSafeInteger = $9e7ee4906fbe8525$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === 'number' && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $9e7ee4906fbe8525$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $9e7ee4906fbe8525$var$re = $9e7ee4906fbe8525$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $9e7ee4906fbe8525$var$REGEX_SUPPORTS_U_AND_Y = (($9e7ee4906fbe8525$var$_a = $9e7ee4906fbe8525$var$re.exec('a')) === null || $9e7ee4906fbe8525$var$_a === void 0 ? void 0 : $9e7ee4906fbe8525$var$_a[0]) === 'a';
} catch (_) {
    $9e7ee4906fbe8525$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $9e7ee4906fbe8525$var$startsWith = $9e7ee4906fbe8525$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $9e7ee4906fbe8525$var$fromCodePoint = $9e7ee4906fbe8525$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = '';
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + ' is not a valid code point');
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $9e7ee4906fbe8525$var$fromEntries = // native
$9e7ee4906fbe8525$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $9e7ee4906fbe8525$var$codePointAt = $9e7ee4906fbe8525$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $9e7ee4906fbe8525$var$trimStart = $9e7ee4906fbe8525$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($9e7ee4906fbe8525$var$SPACE_SEPARATOR_START_REGEX, '');
};
var $9e7ee4906fbe8525$var$trimEnd = $9e7ee4906fbe8525$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($9e7ee4906fbe8525$var$SPACE_SEPARATOR_END_REGEX, '');
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $9e7ee4906fbe8525$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $9e7ee4906fbe8525$var$matchIdentifierAtIndex;
if ($9e7ee4906fbe8525$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $9e7ee4906fbe8525$var$IDENTIFIER_PREFIX_RE_1 = $9e7ee4906fbe8525$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    $9e7ee4906fbe8525$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $9e7ee4906fbe8525$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $9e7ee4906fbe8525$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
} else // IE11
$9e7ee4906fbe8525$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $9e7ee4906fbe8525$var$codePointAt(s, index);
        if (c === undefined || $9e7ee4906fbe8525$var$_isWhiteSpace(c) || $9e7ee4906fbe8525$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $9e7ee4906fbe8525$var$fromCodePoint.apply(void 0, match);
};
var $9e7ee4906fbe8525$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error('parser can only be used once');
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $202e72aad5f79509$export$b87f371cbc396fcf).pound,
                    location: $9e7ee4906fbe8525$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $a5bd10e1e47e30d8$export$896afd8541959ee5).UNMATCHED_CLOSING_TAG, $9e7ee4906fbe8525$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $9e7ee4906fbe8525$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) // Self closing tag
        return {
            val: {
                type: (0, $202e72aad5f79509$export$b87f371cbc396fcf).literal,
                value: "<".concat(tagName, "/>"),
                location: $9e7ee4906fbe8525$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !$9e7ee4906fbe8525$var$_isAlpha(this.char())) return this.error((0, $a5bd10e1e47e30d8$export$896afd8541959ee5).INVALID_TAG, $9e7ee4906fbe8525$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $a5bd10e1e47e30d8$export$896afd8541959ee5).UNMATCHED_CLOSING_TAG, $9e7ee4906fbe8525$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf('>')) return this.error((0, $a5bd10e1e47e30d8$export$896afd8541959ee5).INVALID_TAG, $9e7ee4906fbe8525$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $202e72aad5f79509$export$b87f371cbc396fcf).tag,
                        value: tagName,
                        children: children,
                        location: $9e7ee4906fbe8525$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $a5bd10e1e47e30d8$export$896afd8541959ee5).UNCLOSED_TAG, $9e7ee4906fbe8525$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $a5bd10e1e47e30d8$export$896afd8541959ee5).INVALID_TAG, $9e7ee4906fbe8525$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $9e7ee4906fbe8525$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $9e7ee4906fbe8525$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $202e72aad5f79509$export$b87f371cbc396fcf).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$9e7ee4906fbe8525$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $9e7ee4906fbe8525$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal') || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $9e7ee4906fbe8525$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $a5bd10e1e47e30d8$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $9e7ee4906fbe8525$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $a5bd10e1e47e30d8$export$896afd8541959ee5).EMPTY_ARGUMENT, $9e7ee4906fbe8525$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $a5bd10e1e47e30d8$export$896afd8541959ee5).MALFORMED_ARGUMENT, $9e7ee4906fbe8525$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $a5bd10e1e47e30d8$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $9e7ee4906fbe8525$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $202e72aad5f79509$export$b87f371cbc396fcf).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $9e7ee4906fbe8525$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $a5bd10e1e47e30d8$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $9e7ee4906fbe8525$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $a5bd10e1e47e30d8$export$896afd8541959ee5).MALFORMED_ARGUMENT, $9e7ee4906fbe8525$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $9e7ee4906fbe8525$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $9e7ee4906fbe8525$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $a5bd10e1e47e30d8$export$896afd8541959ee5).EXPECT_ARGUMENT_TYPE, $9e7ee4906fbe8525$var$createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time':
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $9e7ee4906fbe8525$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $a5bd10e1e47e30d8$export$896afd8541959ee5).EXPECT_ARGUMENT_STYLE, $9e7ee4906fbe8525$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $9e7ee4906fbe8525$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $9e7ee4906fbe8525$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $9e7ee4906fbe8525$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $9e7ee4906fbe8525$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $202e72aad5f79509$export$b87f371cbc396fcf).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $a5bd10e1e47e30d8$export$896afd8541959ee5).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $801da8f0eda57737$export$29c5368be8904d27)(skeleton, this.locale);
                        var style = {
                            type: (0, $202e72aad5f79509$export$906452485466fa53).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $756c9c62c803ea46$export$f7b99fb377fe69fa)(dateTimePattern) : {}
                        };
                        var type = argType === 'date' ? (0, $202e72aad5f79509$export$b87f371cbc396fcf).date : (0, $202e72aad5f79509$export$b87f371cbc396fcf).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number' ? (0, $202e72aad5f79509$export$b87f371cbc396fcf).number : argType === 'date' ? (0, $202e72aad5f79509$export$b87f371cbc396fcf).date : (0, $202e72aad5f79509$export$b87f371cbc396fcf).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case 'plural':
            case 'selectordinal':
            case 'select':
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) return this.error((0, $a5bd10e1e47e30d8$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_OPTIONS, $9e7ee4906fbe8525$var$createLocation(typeEndPosition_1, (0, $dEf6I.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) return this.error((0, $a5bd10e1e47e30d8$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $9e7ee4906fbe8525$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $a5bd10e1e47e30d8$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $a5bd10e1e47e30d8$export$896afd8541959ee5).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $9e7ee4906fbe8525$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') return {
                    val: {
                        type: (0, $202e72aad5f79509$export$b87f371cbc396fcf).select,
                        value: value,
                        options: $9e7ee4906fbe8525$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $202e72aad5f79509$export$b87f371cbc396fcf).plural,
                        value: value,
                        options: $9e7ee4906fbe8525$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $a5bd10e1e47e30d8$export$896afd8541959ee5).INVALID_ARGUMENT_TYPE, $9e7ee4906fbe8525$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $a5bd10e1e47e30d8$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $9e7ee4906fbe8525$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $a5bd10e1e47e30d8$export$896afd8541959ee5).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $9e7ee4906fbe8525$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $43f9504d448840fb$export$71cee2f16fba2480)(skeleton);
        } catch (e) {
            return this.error((0, $a5bd10e1e47e30d8$export$896afd8541959ee5).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $202e72aad5f79509$export$906452485466fa53).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $43f9504d448840fb$export$47c6f8480bda3e11)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $a5bd10e1e47e30d8$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $a5bd10e1e47e30d8$export$896afd8541959ee5).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $9e7ee4906fbe8525$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === 'select' ? (0, $a5bd10e1e47e30d8$export$896afd8541959ee5).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $a5bd10e1e47e30d8$export$896afd8541959ee5).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === 'other') hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) return this.error(parentArgType === 'select' ? (0, $a5bd10e1e47e30d8$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $a5bd10e1e47e30d8$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $9e7ee4906fbe8525$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $9e7ee4906fbe8525$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === 'select' ? (0, $a5bd10e1e47e30d8$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $a5bd10e1e47e30d8$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR, $9e7ee4906fbe8525$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $a5bd10e1e47e30d8$export$896afd8541959ee5).MISSING_OTHER_CLAUSE, $9e7ee4906fbe8525$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) ;
        else if (this.bumpIf('-')) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $9e7ee4906fbe8525$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$9e7ee4906fbe8525$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error('out of bound');
        var code = $9e7ee4906fbe8525$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($9e7ee4906fbe8525$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $9e7ee4906fbe8525$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $9e7ee4906fbe8525$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $9e7ee4906fbe8525$var$_isAlphaOrSlash(codepoint) {
    return $9e7ee4906fbe8525$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $9e7ee4906fbe8525$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $9e7ee4906fbe8525$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $9e7ee4906fbe8525$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}



function $65e33ca811c467da$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $202e72aad5f79509$export$dcfe1c11d168b5a1)(el) || (0, $202e72aad5f79509$export$6c796d116f0a4fbc)(el)) for(var k in el.options){
            delete el.options[k].location;
            $65e33ca811c467da$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $202e72aad5f79509$export$e11187b219e191e1)(el) && (0, $202e72aad5f79509$export$3f9a19cd4152eda3)(el.style)) delete el.style.location;
        else if (((0, $202e72aad5f79509$export$32d811605da75f40)(el) || (0, $202e72aad5f79509$export$34ec46f596b1702f)(el)) && (0, $202e72aad5f79509$export$7680c41f1a55f4cf)(el.style)) delete el.style.location;
        else if ((0, $202e72aad5f79509$export$5c83de34745812b)(el)) $65e33ca811c467da$var$pruneLocation(el.children);
    });
}
function $65e33ca811c467da$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $dEf6I.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $9e7ee4906fbe8525$export$7acfa6ed01010e37)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $a5bd10e1e47e30d8$export$896afd8541959ee5)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $65e33ca811c467da$var$pruneLocation(result.val);
    return result.val;
}


//
// Main
//
function $6ec12e3f5fa36c04$export$2e2bcd8739ae039(fn, options) {
    var cache = options && options.cache ? options.cache : $6ec12e3f5fa36c04$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $6ec12e3f5fa36c04$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $6ec12e3f5fa36c04$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $6ec12e3f5fa36c04$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $6ec12e3f5fa36c04$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $6ec12e3f5fa36c04$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $6ec12e3f5fa36c04$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $6ec12e3f5fa36c04$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $6ec12e3f5fa36c04$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $6ec12e3f5fa36c04$var$monadic : $6ec12e3f5fa36c04$var$variadic;
    return $6ec12e3f5fa36c04$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $6ec12e3f5fa36c04$var$strategyVariadic(fn, options) {
    return $6ec12e3f5fa36c04$var$assemble(fn, this, $6ec12e3f5fa36c04$var$variadic, options.cache.create(), options.serializer);
}
function $6ec12e3f5fa36c04$var$strategyMonadic(fn, options) {
    return $6ec12e3f5fa36c04$var$assemble(fn, this, $6ec12e3f5fa36c04$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $6ec12e3f5fa36c04$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $6ec12e3f5fa36c04$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$6ec12e3f5fa36c04$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$6ec12e3f5fa36c04$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $6ec12e3f5fa36c04$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $6ec12e3f5fa36c04$var$ObjectWithoutPrototypeCache();
    }
};
var $6ec12e3f5fa36c04$export$c5491a8691a23b9e = {
    variadic: $6ec12e3f5fa36c04$var$strategyVariadic,
    monadic: $6ec12e3f5fa36c04$var$strategyMonadic
};




var $dEf6I = parcelRequire("dEf6I");
var $416f155282bf95d7$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($416f155282bf95d7$export$d4e71bc0b80dc0fb || ($416f155282bf95d7$export$d4e71bc0b80dc0fb = {}));
var $416f155282bf95d7$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $dEf6I.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $416f155282bf95d7$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $dEf6I.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), $416f155282bf95d7$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($416f155282bf95d7$export$7369836851cc1329);
var $416f155282bf95d7$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $dEf6I.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), $416f155282bf95d7$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($416f155282bf95d7$export$7369836851cc1329);
var $416f155282bf95d7$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $dEf6I.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), $416f155282bf95d7$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($416f155282bf95d7$export$7369836851cc1329);


var $d8c3f17367458324$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($d8c3f17367458324$export$49694c2877b44c57 || ($d8c3f17367458324$export$49694c2877b44c57 = {}));
function $d8c3f17367458324$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $d8c3f17367458324$export$49694c2877b44c57.literal || part.type !== $d8c3f17367458324$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $d8c3f17367458324$export$df0c12a2d414a163(el) {
    return typeof el === 'function';
}
function $d8c3f17367458324$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $202e72aad5f79509$export$cfa10c5697238752)(els[0])) return [
        {
            type: $d8c3f17367458324$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $202e72aad5f79509$export$cfa10c5697238752)(el)) {
            result.push({
                type: $d8c3f17367458324$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $202e72aad5f79509$export$c0ece297bdd0c082)(el)) {
            if (typeof currentPluralValue === 'number') result.push({
                type: $d8c3f17367458324$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $416f155282bf95d7$export$8bfc137e4d23fdf0)(varName, originalMessage);
        var value = values[varName];
        if ((0, $202e72aad5f79509$export$4f55724281bdfaf9)(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') value = typeof value === 'string' || typeof value === 'number' ? String(value) : '';
            result.push({
                type: typeof value === 'string' ? $d8c3f17367458324$export$49694c2877b44c57.literal : $d8c3f17367458324$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $202e72aad5f79509$export$32d811605da75f40)(el)) {
            var style = typeof el.style === 'string' ? formats.date[el.style] : (0, $202e72aad5f79509$export$7680c41f1a55f4cf)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $d8c3f17367458324$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $202e72aad5f79509$export$34ec46f596b1702f)(el)) {
            var style = typeof el.style === 'string' ? formats.time[el.style] : (0, $202e72aad5f79509$export$7680c41f1a55f4cf)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $d8c3f17367458324$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $202e72aad5f79509$export$e11187b219e191e1)(el)) {
            var style = typeof el.style === 'string' ? formats.number[el.style] : (0, $202e72aad5f79509$export$3f9a19cd4152eda3)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $d8c3f17367458324$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $202e72aad5f79509$export$5c83de34745812b)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$d8c3f17367458324$export$df0c12a2d414a163(formatFn)) throw new (0, $416f155282bf95d7$export$cbc0db47c750f7c9)(value_1, 'function', originalMessage);
            var parts = $d8c3f17367458324$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === 'string' ? $d8c3f17367458324$export$49694c2877b44c57.literal : $d8c3f17367458324$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $202e72aad5f79509$export$dcfe1c11d168b5a1)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $416f155282bf95d7$export$565c3afc07dfa382)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $d8c3f17367458324$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $202e72aad5f79509$export$6c796d116f0a4fbc)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $416f155282bf95d7$export$7369836851cc1329)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $416f155282bf95d7$export$d4e71bc0b80dc0fb).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $416f155282bf95d7$export$565c3afc07dfa382)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $d8c3f17367458324$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $d8c3f17367458324$var$mergeLiteral(result);
}


// -- MessageFormat --------------------------------------------------------
function $990a55d7cb84037c$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $dEf6I.__assign)((0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $990a55d7cb84037c$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $990a55d7cb84037c$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $dEf6I.__assign)({}, defaultConfig));
}
function $990a55d7cb84037c$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $990a55d7cb84037c$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $6ec12e3f5fa36c04$export$2e2bcd8739ae039)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $dEf6I.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $990a55d7cb84037c$var$createFastMemoizeCache(cache.number),
            strategy: (0, $6ec12e3f5fa36c04$export$c5491a8691a23b9e).variadic
        }),
        getDateTimeFormat: (0, $6ec12e3f5fa36c04$export$2e2bcd8739ae039)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $dEf6I.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $990a55d7cb84037c$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $6ec12e3f5fa36c04$export$c5491a8691a23b9e).variadic
        }),
        getPluralRules: (0, $6ec12e3f5fa36c04$export$2e2bcd8739ae039)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $dEf6I.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $990a55d7cb84037c$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $6ec12e3f5fa36c04$export$c5491a8691a23b9e).variadic
        })
    };
}
var $990a55d7cb84037c$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        var _this = this;
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $d8c3f17367458324$export$49694c2877b44c57).literal || typeof all[all.length - 1] !== 'string') all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || '';
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $d8c3f17367458324$export$275d4a3bb5f66fda)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            return {
                locale: _this.resolvedLocale.toString()
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, {
                ignoreTag: opts === null || opts === void 0 ? void 0 : opts.ignoreTag,
                locale: this.resolvedLocale
            });
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError('A message must be provided as a String or AST.');
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $990a55d7cb84037c$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $990a55d7cb84037c$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $65e33ca811c467da$export$98e6a39c04603d36);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: 'currency'
            },
            percent: {
                style: 'percent'
            }
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit'
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            }
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric'
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            }
        }
    };
    return IntlMessageFormat;
}();


//
// Main
//
function $50bee53cc3953b47$export$2e2bcd8739ae039(fn, options) {
    var cache = options && options.cache ? options.cache : $50bee53cc3953b47$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $50bee53cc3953b47$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $50bee53cc3953b47$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $50bee53cc3953b47$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $50bee53cc3953b47$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $50bee53cc3953b47$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $50bee53cc3953b47$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $50bee53cc3953b47$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $50bee53cc3953b47$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $50bee53cc3953b47$var$monadic : $50bee53cc3953b47$var$variadic;
    return $50bee53cc3953b47$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $50bee53cc3953b47$var$strategyVariadic(fn, options) {
    return $50bee53cc3953b47$var$assemble(fn, this, $50bee53cc3953b47$var$variadic, options.cache.create(), options.serializer);
}
function $50bee53cc3953b47$var$strategyMonadic(fn, options) {
    return $50bee53cc3953b47$var$assemble(fn, this, $50bee53cc3953b47$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $50bee53cc3953b47$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $50bee53cc3953b47$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$50bee53cc3953b47$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$50bee53cc3953b47$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $50bee53cc3953b47$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $50bee53cc3953b47$var$ObjectWithoutPrototypeCache();
    }
};
var $50bee53cc3953b47$export$c5491a8691a23b9e = {
    variadic: $50bee53cc3953b47$var$strategyVariadic,
    monadic: $50bee53cc3953b47$var$strategyMonadic
};



var $dEf6I = parcelRequire("dEf6I");
var $0944942e84c0710e$export$557d6acb76e8a244;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})($0944942e84c0710e$export$557d6acb76e8a244 || ($0944942e84c0710e$export$557d6acb76e8a244 = {}));
var $0944942e84c0710e$export$c016d36112f6ddf8 = /** @class */ function(_super) {
    (0, $dEf6I.__extends)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, " \n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : '')) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === 'function') // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
var $0944942e84c0710e$export$549f97e137a05c90 = /** @class */ function(_super) {
    (0, $dEf6I.__extends)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, $0944942e84c0710e$export$557d6acb76e8a244.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}($0944942e84c0710e$export$c016d36112f6ddf8);
var $0944942e84c0710e$export$3ca04dd7fb305893 = /** @class */ function(_super) {
    (0, $dEf6I.__extends)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, $0944942e84c0710e$export$557d6acb76e8a244.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}($0944942e84c0710e$export$c016d36112f6ddf8);
var $0944942e84c0710e$export$c1eaf877d81384b6 = /** @class */ function(_super) {
    (0, $dEf6I.__extends)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, $0944942e84c0710e$export$557d6acb76e8a244.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}($0944942e84c0710e$export$c016d36112f6ddf8);
var $0944942e84c0710e$export$e3b7eee1dbc44895 = /** @class */ function(_super) {
    (0, $dEf6I.__extends)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        return _super.call(this, $0944942e84c0710e$export$557d6acb76e8a244.FORMAT_ERROR, "".concat(message, " \nLocale: ").concat(locale, "\n"), exception) || this;
    }
    return IntlFormatError;
}($0944942e84c0710e$export$c016d36112f6ddf8);
var $0944942e84c0710e$export$74a601a3d3f31621 = /** @class */ function(_super) {
    (0, $dEf6I.__extends)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, " \nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, " \n"), locale, exception) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MessageFormatError;
}($0944942e84c0710e$export$e3b7eee1dbc44895);
var $0944942e84c0710e$export$2ddcb436d0aa3688 = /** @class */ function(_super) {
    (0, $dEf6I.__extends)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, $0944942e84c0710e$export$557d6acb76e8a244.MISSING_TRANSLATION, "Missing message: \"".concat(descriptor.id, "\" for locale \"").concat(locale, "\", using ").concat(descriptor.defaultMessage ? 'default message' : 'id', " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}($0944942e84c0710e$export$c016d36112f6ddf8);


function $bd2157defde87cf4$export$d697c39a2985a4c(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
var $bd2157defde87cf4$var$defaultErrorHandler = function(error) {};
var $bd2157defde87cf4$var$defaultWarnHandler = function(warning) {};
var $bd2157defde87cf4$export$b52f8d6fc0d47415 = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: 'en',
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $bd2157defde87cf4$var$defaultErrorHandler,
    onWarn: $bd2157defde87cf4$var$defaultWarnHandler
};
function $bd2157defde87cf4$export$51c4f4e973f2dc00() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function $bd2157defde87cf4$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $bd2157defde87cf4$export$c3f4cd5551df13fd(cache) {
    if (cache === void 0) cache = $bd2157defde87cf4$export$51c4f4e973f2dc00();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, $50bee53cc3953b47$export$2e2bcd8739ae039)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $dEf6I.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $bd2157defde87cf4$var$createFastMemoizeCache(cache.dateTime),
        strategy: (0, $50bee53cc3953b47$export$c5491a8691a23b9e).variadic
    });
    var getNumberFormat = (0, $50bee53cc3953b47$export$2e2bcd8739ae039)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $dEf6I.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $bd2157defde87cf4$var$createFastMemoizeCache(cache.number),
        strategy: (0, $50bee53cc3953b47$export$c5491a8691a23b9e).variadic
    });
    var getPluralRules = (0, $50bee53cc3953b47$export$2e2bcd8739ae039)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $dEf6I.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $bd2157defde87cf4$var$createFastMemoizeCache(cache.pluralRules),
        strategy: (0, $50bee53cc3953b47$export$c5491a8691a23b9e).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $50bee53cc3953b47$export$2e2bcd8739ae039)(function(message, locales, overrideFormats, opts) {
            return new (0, $990a55d7cb84037c$export$d342343268debc40)(message, locales, overrideFormats, (0, $dEf6I.__assign)({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: $bd2157defde87cf4$var$createFastMemoizeCache(cache.message),
            strategy: (0, $50bee53cc3953b47$export$c5491a8691a23b9e).variadic
        }),
        getRelativeTimeFormat: (0, $50bee53cc3953b47$export$2e2bcd8739ae039)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, $dEf6I.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $bd2157defde87cf4$var$createFastMemoizeCache(cache.relativeTime),
            strategy: (0, $50bee53cc3953b47$export$c5491a8691a23b9e).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $50bee53cc3953b47$export$2e2bcd8739ae039)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, (0, $dEf6I.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $bd2157defde87cf4$var$createFastMemoizeCache(cache.list),
            strategy: (0, $50bee53cc3953b47$export$c5491a8691a23b9e).variadic
        }),
        getDisplayNames: (0, $50bee53cc3953b47$export$2e2bcd8739ae039)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, (0, $dEf6I.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $bd2157defde87cf4$var$createFastMemoizeCache(cache.displayNames),
            strategy: (0, $50bee53cc3953b47$export$c5491a8691a23b9e).variadic
        })
    };
}
function $bd2157defde87cf4$export$4ee1db8ce44a209b(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, $0944942e84c0710e$export$549f97e137a05c90)("No ".concat(type, " format named: ").concat(name)));
}


function $ffccc38ccafa9e00$export$45c4bbf6e55bba1f(intl) {
    (0, $d9dfc91177f936a8$export$f5708dca728d7177)(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var $ffccc38ccafa9e00$export$b52f8d6fc0d47415 = (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, (0, $bd2157defde87cf4$export$b52f8d6fc0d47415)), {
    textComponent: $dQwsT.Fragment
});
function $ffccc38ccafa9e00$export$cfec03d26465fa63(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn($dQwsT.Children.toArray(parts));
    };
}
function $ffccc38ccafa9e00$export$d36bdfa510afb180(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}


function $fd82be28c43fef71$var$getDisplayName(Component) {
    return Component.displayName || Component.name || 'Component';
}
// TODO: We should provide initial value here
var $fd82be28c43fef71$var$IntlContext = $dQwsT.createContext(null);
var $fd82be28c43fef71$var$IntlConsumer = $fd82be28c43fef71$var$IntlContext.Consumer, $fd82be28c43fef71$var$IntlProvider = $fd82be28c43fef71$var$IntlContext.Provider;
var $fd82be28c43fef71$export$2881499e37b75b9a = $fd82be28c43fef71$var$IntlProvider;
var $fd82be28c43fef71$export$841858b892ce1f4c = $fd82be28c43fef71$var$IntlContext;
function $fd82be28c43fef71$export$2e2bcd8739ae039(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? 'intl' : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function(props) {
        return $dQwsT.createElement($fd82be28c43fef71$var$IntlConsumer, null, function(intl) {
            var _a;
            if (enforceContext) (0, $ffccc38ccafa9e00$export$45c4bbf6e55bba1f)(intl);
            var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
            return $dQwsT.createElement(WrappedComponent, (0, $dEf6I.__assign)({}, props, intlProp, {
                ref: forwardRef ? props.forwardedRef : null
            }));
        });
    };
    WithIntl.displayName = "injectIntl(".concat($fd82be28c43fef71$var$getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) return (0, (/*@__PURE__*/$parcel$interopDefault($9a700870d8fe9f94$exports)))($dQwsT.forwardRef(function(props, ref) {
        return $dQwsT.createElement(WithIntl, (0, $dEf6I.__assign)({}, props, {
            forwardedRef: ref
        }));
    }), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($9a700870d8fe9f94$exports)))(WithIntl, WrappedComponent);
}



function $a689ac47403fe3e1$export$2e2bcd8739ae039() {
    var intl = $dQwsT.useContext((0, $fd82be28c43fef71$export$841858b892ce1f4c));
    (0, $ffccc38ccafa9e00$export$45c4bbf6e55bba1f)(intl);
    return intl;
}



function $cf944c5aa6db0974$var$areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0, $dEf6I.__rest)(prevProps, [
        "values"
    ]);
    var nextValues = nextProps.values, nextOtherProps = (0, $dEf6I.__rest)(nextProps, [
        "values"
    ]);
    return (0, $ffccc38ccafa9e00$export$d36bdfa510afb180)(nextValues, values) && (0, $ffccc38ccafa9e00$export$d36bdfa510afb180)(otherProps, nextOtherProps);
}
function $cf944c5aa6db0974$var$FormattedMessage(props) {
    var intl = (0, $a689ac47403fe3e1$export$2e2bcd8739ae039)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? $dQwsT.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = {
        id: id,
        description: description,
        defaultMessage: defaultMessage
    };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag
    });
    if (typeof children === 'function') return children(Array.isArray(nodes) ? nodes : [
        nodes
    ]);
    if (Component) return $dQwsT.createElement(Component, null, $dQwsT.Children.toArray(nodes));
    return $dQwsT.createElement($dQwsT.Fragment, null, nodes);
}
$cf944c5aa6db0974$var$FormattedMessage.displayName = 'FormattedMessage';
var $cf944c5aa6db0974$var$MemoizedFormattedMessage = $dQwsT.memo($cf944c5aa6db0974$var$FormattedMessage, $cf944c5aa6db0974$var$areEqual);
$cf944c5aa6db0974$var$MemoizedFormattedMessage.displayName = 'MemoizedFormattedMessage';
var $cf944c5aa6db0974$export$2e2bcd8739ae039 = $cf944c5aa6db0974$var$MemoizedFormattedMessage;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $dEf6I = parcelRequire("dEf6I");

var $dQwsT = parcelRequire("dQwsT");



var $dEf6I = parcelRequire("dEf6I");




var $704e8230eddf6b2d$var$NUMBER_FORMAT_OPTIONS = [
    'localeMatcher',
    'style',
    'currency',
    'currencyDisplay',
    'unit',
    'unitDisplay',
    'useGrouping',
    'minimumIntegerDigits',
    'minimumFractionDigits',
    'maximumFractionDigits',
    'minimumSignificantDigits',
    'maximumSignificantDigits',
    // ES2020 NumberFormat
    'compactDisplay',
    'currencyDisplay',
    'currencySign',
    'notation',
    'signDisplay',
    'unit',
    'unitDisplay',
    'numberingSystem'
];
function $704e8230eddf6b2d$export$a7f9565e3c81cd54(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, $bd2157defde87cf4$export$4ee1db8ce44a209b)(formats, 'number', format, onError) || {};
    var filteredOptions = (0, $bd2157defde87cf4$export$d697c39a2985a4c)(options, $704e8230eddf6b2d$var$NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function $704e8230eddf6b2d$export$f5dd818bff069720(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $704e8230eddf6b2d$export$a7f9565e3c81cd54(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new (0, $0944942e84c0710e$export$c016d36112f6ddf8)((0, $0944942e84c0710e$export$557d6acb76e8a244).FORMAT_ERROR, 'Error formatting number.', e));
    }
    return String(value);
}
function $704e8230eddf6b2d$export$6871080848f10b2f(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $704e8230eddf6b2d$export$a7f9565e3c81cd54(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new (0, $0944942e84c0710e$export$c016d36112f6ddf8)((0, $0944942e84c0710e$export$557d6acb76e8a244).FORMAT_ERROR, 'Error formatting number.', e));
    }
    return [];
}





var $f170bf6ae1c01c11$var$RELATIVE_TIME_FORMAT_OPTIONS = [
    'numeric',
    'style'
];
function $f170bf6ae1c01c11$var$getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, $bd2157defde87cf4$export$4ee1db8ce44a209b)(formats, 'relative', format, onError) || {};
    var filteredOptions = (0, $bd2157defde87cf4$export$d697c39a2985a4c)(options, $f170bf6ae1c01c11$var$RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function $f170bf6ae1c01c11$export$b4ea3b48dcf921f6(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = 'second';
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new (0, $416f155282bf95d7$export$7369836851cc1329)("Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-relativetimeformat\"\n", (0, $416f155282bf95d7$export$d4e71bc0b80dc0fb).MISSING_INTL_API));
    try {
        return $f170bf6ae1c01c11$var$getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new (0, $0944942e84c0710e$export$e3b7eee1dbc44895)('Error formatting relative time.', config.locale, e));
    }
    return String(value);
}



var $dEf6I = parcelRequire("dEf6I");


var $d40299055c9f00be$var$DATE_TIME_FORMAT_OPTIONS = [
    'localeMatcher',
    'formatMatcher',
    'timeZone',
    'hour12',
    'weekday',
    'era',
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'timeZoneName',
    'hourCycle',
    'dateStyle',
    'timeStyle',
    'calendar',
    // 'dayPeriod',
    'numberingSystem'
];
function $d40299055c9f00be$export$a7f9565e3c81cd54(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, timeZone && {
        timeZone: timeZone
    }), format && (0, $bd2157defde87cf4$export$4ee1db8ce44a209b)(formats, type, format, onError));
    var filteredOptions = (0, $bd2157defde87cf4$export$d697c39a2985a4c)(options, $d40299055c9f00be$var$DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === 'time' && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, filteredOptions), {
        hour: 'numeric',
        minute: 'numeric'
    });
    return getDateTimeFormat(locale, filteredOptions);
}
function $d40299055c9f00be$export$3ae94a2503e890a1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $d40299055c9f00be$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $0944942e84c0710e$export$c016d36112f6ddf8)((0, $0944942e84c0710e$export$557d6acb76e8a244).FORMAT_ERROR, 'Error formatting date.', e));
    }
    return String(date);
}
function $d40299055c9f00be$export$3203edd9e5edd663(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $d40299055c9f00be$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $0944942e84c0710e$export$c016d36112f6ddf8)((0, $0944942e84c0710e$export$557d6acb76e8a244).FORMAT_ERROR, 'Error formatting time.', e));
    }
    return String(date);
}
function $d40299055c9f00be$export$a7fc3a91cb2ec376(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var timeZone = config.timeZone, locale = config.locale, onError = config.onError;
    var filteredOptions = (0, $bd2157defde87cf4$export$d697c39a2985a4c)(options, $d40299055c9f00be$var$DATE_TIME_FORMAT_OPTIONS, timeZone ? {
        timeZone: timeZone
    } : {});
    try {
        return getDateTimeFormat(locale, filteredOptions).formatRange(from, to);
    } catch (e) {
        onError(new (0, $0944942e84c0710e$export$c016d36112f6ddf8)((0, $0944942e84c0710e$export$557d6acb76e8a244).FORMAT_ERROR, 'Error formatting date time range.', e));
    }
    return String(from);
}
function $d40299055c9f00be$export$dc1f059bce486b1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $d40299055c9f00be$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).formatToParts(date);
    } catch (e) {
        config.onError(new (0, $0944942e84c0710e$export$c016d36112f6ddf8)((0, $0944942e84c0710e$export$557d6acb76e8a244).FORMAT_ERROR, 'Error formatting date.', e));
    }
    return [];
}
function $d40299055c9f00be$export$af6e5d7a5c73edeb(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $d40299055c9f00be$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).formatToParts(date);
    } catch (e) {
        config.onError(new (0, $0944942e84c0710e$export$c016d36112f6ddf8)((0, $0944942e84c0710e$export$557d6acb76e8a244).FORMAT_ERROR, 'Error formatting time.', e));
    }
    return [];
}





var $945b961e73517a42$var$PLURAL_FORMAT_OPTIONS = [
    'localeMatcher',
    'type'
];
function $945b961e73517a42$export$bbbd05c900f3568d(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new (0, $416f155282bf95d7$export$7369836851cc1329)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $416f155282bf95d7$export$d4e71bc0b80dc0fb).MISSING_INTL_API));
    var filteredOptions = (0, $bd2157defde87cf4$export$d697c39a2985a4c)(options, $945b961e73517a42$var$PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new (0, $0944942e84c0710e$export$e3b7eee1dbc44895)('Error formatting plural.', locale, e));
    }
    return 'other';
}



var $dEf6I = parcelRequire("dEf6I");
/**
 * Cannot do Math.log(x) / Math.log(10) bc if IEEE floating point issue
 * @param x number
 */ function $f3ab26094310a214$export$f535bb00660c42db(x) {
    // Cannot count string length via Number.toString because it may use scientific notation
    // for very small or very large numbers.
    return Math.floor(Math.log(x) * Math.LOG10E);
}
function $f3ab26094310a214$export$76d90c956114f2c2(s, times) {
    if (typeof s.repeat === 'function') return s.repeat(times);
    var arr = new Array(times);
    for(var i = 0; i < arr.length; i++)arr[i] = s;
    return arr.join('');
}
function $f3ab26094310a214$export$489176b9ebc725cc(map, pl, field, value) {
    if (!map.get(pl)) map.set(pl, Object.create(null));
    var slots = map.get(pl);
    slots[field] = value;
}
function $f3ab26094310a214$export$d21499e79b5c28e2(map, pl, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var k = _a[_i];
        $f3ab26094310a214$export$489176b9ebc725cc(map, pl, k, props[k]);
    }
}
function $f3ab26094310a214$export$3fae2929ed23c202(map, pl, field) {
    return $f3ab26094310a214$export$ca4e2274c058dd9f(map, pl, field)[field];
}
function $f3ab26094310a214$export$ca4e2274c058dd9f(map, pl) {
    var fields = [];
    for(var _i = 2; _i < arguments.length; _i++)fields[_i - 2] = arguments[_i];
    var slots = map.get(pl);
    if (!slots) throw new TypeError("".concat(pl, " InternalSlot has not been initialized"));
    return fields.reduce(function(all, f) {
        all[f] = slots[f];
        return all;
    }, Object.create(null));
}
function $f3ab26094310a214$export$25c75e09b890f24e(patternPart) {
    return patternPart.type === 'literal';
}
function $f3ab26094310a214$export$fdab3c20aae16ddf(target, name, _a) {
    var value = _a.value;
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value
    });
}
var $f3ab26094310a214$export$9049a02e759202e4 = /-u(?:-[0-9a-z]{2,8})+/gi;
function $f3ab26094310a214$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}





var $dEf6I = parcelRequire("dEf6I");
var $77832b0de927d8a6$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($77832b0de927d8a6$export$896afd8541959ee5 || ($77832b0de927d8a6$export$896afd8541959ee5 = {}));



var $dEf6I = parcelRequire("dEf6I");

var $ca93e31e6d19b1d5$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($ca93e31e6d19b1d5$export$b87f371cbc396fcf || ($ca93e31e6d19b1d5$export$b87f371cbc396fcf = {}));
var $ca93e31e6d19b1d5$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($ca93e31e6d19b1d5$export$906452485466fa53 || ($ca93e31e6d19b1d5$export$906452485466fa53 = {}));
function $ca93e31e6d19b1d5$export$cfa10c5697238752(el) {
    return el.type === $ca93e31e6d19b1d5$export$b87f371cbc396fcf.literal;
}
function $ca93e31e6d19b1d5$export$4f55724281bdfaf9(el) {
    return el.type === $ca93e31e6d19b1d5$export$b87f371cbc396fcf.argument;
}
function $ca93e31e6d19b1d5$export$e11187b219e191e1(el) {
    return el.type === $ca93e31e6d19b1d5$export$b87f371cbc396fcf.number;
}
function $ca93e31e6d19b1d5$export$32d811605da75f40(el) {
    return el.type === $ca93e31e6d19b1d5$export$b87f371cbc396fcf.date;
}
function $ca93e31e6d19b1d5$export$34ec46f596b1702f(el) {
    return el.type === $ca93e31e6d19b1d5$export$b87f371cbc396fcf.time;
}
function $ca93e31e6d19b1d5$export$dcfe1c11d168b5a1(el) {
    return el.type === $ca93e31e6d19b1d5$export$b87f371cbc396fcf.select;
}
function $ca93e31e6d19b1d5$export$6c796d116f0a4fbc(el) {
    return el.type === $ca93e31e6d19b1d5$export$b87f371cbc396fcf.plural;
}
function $ca93e31e6d19b1d5$export$c0ece297bdd0c082(el) {
    return el.type === $ca93e31e6d19b1d5$export$b87f371cbc396fcf.pound;
}
function $ca93e31e6d19b1d5$export$5c83de34745812b(el) {
    return el.type === $ca93e31e6d19b1d5$export$b87f371cbc396fcf.tag;
}
function $ca93e31e6d19b1d5$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === 'object' && el.type === $ca93e31e6d19b1d5$export$906452485466fa53.number);
}
function $ca93e31e6d19b1d5$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === 'object' && el.type === $ca93e31e6d19b1d5$export$906452485466fa53.dateTime);
}
function $ca93e31e6d19b1d5$export$f0ac572c1121c662(value) {
    return {
        type: $ca93e31e6d19b1d5$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $ca93e31e6d19b1d5$export$425e864b0ba114f1(value, style) {
    return {
        type: $ca93e31e6d19b1d5$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}


// @generated from regex-gen.ts
var $5ad05931577b3253$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $5ad05931577b3253$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;



// @generated from time-data-gen.ts
// prettier-ignore  
var $9574e3ee2e7d4073$export$a8c9209db4084317 = {
    "AX": [
        "H"
    ],
    "BQ": [
        "H"
    ],
    "CP": [
        "H"
    ],
    "CZ": [
        "H"
    ],
    "DK": [
        "H"
    ],
    "FI": [
        "H"
    ],
    "ID": [
        "H"
    ],
    "IS": [
        "H"
    ],
    "ML": [
        "H"
    ],
    "NE": [
        "H"
    ],
    "RU": [
        "H"
    ],
    "SE": [
        "H"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "AS": [
        "h",
        "H"
    ],
    "BT": [
        "h",
        "H"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "GH": [
        "h",
        "H"
    ],
    "IN": [
        "h",
        "H"
    ],
    "LS": [
        "h",
        "H"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PW": [
        "h",
        "H"
    ],
    "SO": [
        "h",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WS": [
        "h",
        "H"
    ],
    "001": [
        "H",
        "h"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "AR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CL": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CU": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BO": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-EC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-PE": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "GT": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "HN": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MX": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "NI": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "PY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "SV": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "UY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "JP": [
        "H",
        "h",
        "K"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BO": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "EC": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "PE": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ]
};


function $5d41f5efe20db3ee$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = '';
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = $5d41f5efe20db3ee$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === 'J') skeletonCopy += 'H';
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $5d41f5efe20db3ee$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case 'h24':
            return 'k';
        case 'h23':
            return 'H';
        case 'h12':
            return 'h';
        case 'h11':
            return 'K';
        default:
            throw new Error('Invalid hourCycle');
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') regionTag = locale.maximize().region;
    var hourCycles = (0, $9574e3ee2e7d4073$export$a8c9209db4084317)[regionTag || ''] || (0, $9574e3ee2e7d4073$export$a8c9209db4084317)[languageTag || ''] || (0, $9574e3ee2e7d4073$export$a8c9209db4084317)["".concat(languageTag, "-001")] || (0, $9574e3ee2e7d4073$export$a8c9209db4084317)['001'];
    return hourCycles[0];
}


var $bb8a1d1f4a1e7b34$var$_a;
var $bb8a1d1f4a1e7b34$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $5ad05931577b3253$export$523451f94304dd6c).source, "*"));
var $bb8a1d1f4a1e7b34$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $5ad05931577b3253$export$523451f94304dd6c).source, "*$"));
function $bb8a1d1f4a1e7b34$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $bb8a1d1f4a1e7b34$var$hasNativeStartsWith = !!String.prototype.startsWith;
var $bb8a1d1f4a1e7b34$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $bb8a1d1f4a1e7b34$var$hasNativeFromEntries = !!Object.fromEntries;
var $bb8a1d1f4a1e7b34$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $bb8a1d1f4a1e7b34$var$hasTrimStart = !!String.prototype.trimStart;
var $bb8a1d1f4a1e7b34$var$hasTrimEnd = !!String.prototype.trimEnd;
var $bb8a1d1f4a1e7b34$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $bb8a1d1f4a1e7b34$var$isSafeInteger = $bb8a1d1f4a1e7b34$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === 'number' && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $bb8a1d1f4a1e7b34$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $bb8a1d1f4a1e7b34$var$re = $bb8a1d1f4a1e7b34$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $bb8a1d1f4a1e7b34$var$REGEX_SUPPORTS_U_AND_Y = (($bb8a1d1f4a1e7b34$var$_a = $bb8a1d1f4a1e7b34$var$re.exec('a')) === null || $bb8a1d1f4a1e7b34$var$_a === void 0 ? void 0 : $bb8a1d1f4a1e7b34$var$_a[0]) === 'a';
} catch (_) {
    $bb8a1d1f4a1e7b34$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $bb8a1d1f4a1e7b34$var$startsWith = $bb8a1d1f4a1e7b34$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $bb8a1d1f4a1e7b34$var$fromCodePoint = $bb8a1d1f4a1e7b34$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = '';
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + ' is not a valid code point');
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $bb8a1d1f4a1e7b34$var$fromEntries = // native
$bb8a1d1f4a1e7b34$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $bb8a1d1f4a1e7b34$var$codePointAt = $bb8a1d1f4a1e7b34$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $bb8a1d1f4a1e7b34$var$trimStart = $bb8a1d1f4a1e7b34$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($bb8a1d1f4a1e7b34$var$SPACE_SEPARATOR_START_REGEX, '');
};
var $bb8a1d1f4a1e7b34$var$trimEnd = $bb8a1d1f4a1e7b34$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($bb8a1d1f4a1e7b34$var$SPACE_SEPARATOR_END_REGEX, '');
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $bb8a1d1f4a1e7b34$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $bb8a1d1f4a1e7b34$var$matchIdentifierAtIndex;
if ($bb8a1d1f4a1e7b34$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $bb8a1d1f4a1e7b34$var$IDENTIFIER_PREFIX_RE_1 = $bb8a1d1f4a1e7b34$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    $bb8a1d1f4a1e7b34$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $bb8a1d1f4a1e7b34$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $bb8a1d1f4a1e7b34$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
} else // IE11
$bb8a1d1f4a1e7b34$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $bb8a1d1f4a1e7b34$var$codePointAt(s, index);
        if (c === undefined || $bb8a1d1f4a1e7b34$var$_isWhiteSpace(c) || $bb8a1d1f4a1e7b34$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $bb8a1d1f4a1e7b34$var$fromCodePoint.apply(void 0, match);
};
var $bb8a1d1f4a1e7b34$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error('parser can only be used once');
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $ca93e31e6d19b1d5$export$b87f371cbc396fcf).pound,
                    location: $bb8a1d1f4a1e7b34$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $77832b0de927d8a6$export$896afd8541959ee5).UNMATCHED_CLOSING_TAG, $bb8a1d1f4a1e7b34$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $bb8a1d1f4a1e7b34$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) // Self closing tag
        return {
            val: {
                type: (0, $ca93e31e6d19b1d5$export$b87f371cbc396fcf).literal,
                value: "<".concat(tagName, "/>"),
                location: $bb8a1d1f4a1e7b34$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !$bb8a1d1f4a1e7b34$var$_isAlpha(this.char())) return this.error((0, $77832b0de927d8a6$export$896afd8541959ee5).INVALID_TAG, $bb8a1d1f4a1e7b34$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $77832b0de927d8a6$export$896afd8541959ee5).UNMATCHED_CLOSING_TAG, $bb8a1d1f4a1e7b34$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf('>')) return this.error((0, $77832b0de927d8a6$export$896afd8541959ee5).INVALID_TAG, $bb8a1d1f4a1e7b34$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $ca93e31e6d19b1d5$export$b87f371cbc396fcf).tag,
                        value: tagName,
                        children: children,
                        location: $bb8a1d1f4a1e7b34$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $77832b0de927d8a6$export$896afd8541959ee5).UNCLOSED_TAG, $bb8a1d1f4a1e7b34$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $77832b0de927d8a6$export$896afd8541959ee5).INVALID_TAG, $bb8a1d1f4a1e7b34$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $bb8a1d1f4a1e7b34$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $bb8a1d1f4a1e7b34$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $ca93e31e6d19b1d5$export$b87f371cbc396fcf).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$bb8a1d1f4a1e7b34$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $bb8a1d1f4a1e7b34$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal') || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $bb8a1d1f4a1e7b34$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $77832b0de927d8a6$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $bb8a1d1f4a1e7b34$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $77832b0de927d8a6$export$896afd8541959ee5).EMPTY_ARGUMENT, $bb8a1d1f4a1e7b34$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $77832b0de927d8a6$export$896afd8541959ee5).MALFORMED_ARGUMENT, $bb8a1d1f4a1e7b34$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $77832b0de927d8a6$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $bb8a1d1f4a1e7b34$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $ca93e31e6d19b1d5$export$b87f371cbc396fcf).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $bb8a1d1f4a1e7b34$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $77832b0de927d8a6$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $bb8a1d1f4a1e7b34$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $77832b0de927d8a6$export$896afd8541959ee5).MALFORMED_ARGUMENT, $bb8a1d1f4a1e7b34$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $bb8a1d1f4a1e7b34$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $bb8a1d1f4a1e7b34$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $77832b0de927d8a6$export$896afd8541959ee5).EXPECT_ARGUMENT_TYPE, $bb8a1d1f4a1e7b34$var$createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time':
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $bb8a1d1f4a1e7b34$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $77832b0de927d8a6$export$896afd8541959ee5).EXPECT_ARGUMENT_STYLE, $bb8a1d1f4a1e7b34$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $bb8a1d1f4a1e7b34$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $bb8a1d1f4a1e7b34$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $bb8a1d1f4a1e7b34$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $bb8a1d1f4a1e7b34$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $ca93e31e6d19b1d5$export$b87f371cbc396fcf).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $77832b0de927d8a6$export$896afd8541959ee5).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $5d41f5efe20db3ee$export$29c5368be8904d27)(skeleton, this.locale);
                        var style = {
                            type: (0, $ca93e31e6d19b1d5$export$906452485466fa53).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $756c9c62c803ea46$export$f7b99fb377fe69fa)(dateTimePattern) : {}
                        };
                        var type = argType === 'date' ? (0, $ca93e31e6d19b1d5$export$b87f371cbc396fcf).date : (0, $ca93e31e6d19b1d5$export$b87f371cbc396fcf).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number' ? (0, $ca93e31e6d19b1d5$export$b87f371cbc396fcf).number : argType === 'date' ? (0, $ca93e31e6d19b1d5$export$b87f371cbc396fcf).date : (0, $ca93e31e6d19b1d5$export$b87f371cbc396fcf).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case 'plural':
            case 'selectordinal':
            case 'select':
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) return this.error((0, $77832b0de927d8a6$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_OPTIONS, $bb8a1d1f4a1e7b34$var$createLocation(typeEndPosition_1, (0, $dEf6I.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) return this.error((0, $77832b0de927d8a6$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $bb8a1d1f4a1e7b34$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $77832b0de927d8a6$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $77832b0de927d8a6$export$896afd8541959ee5).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $bb8a1d1f4a1e7b34$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') return {
                    val: {
                        type: (0, $ca93e31e6d19b1d5$export$b87f371cbc396fcf).select,
                        value: value,
                        options: $bb8a1d1f4a1e7b34$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $ca93e31e6d19b1d5$export$b87f371cbc396fcf).plural,
                        value: value,
                        options: $bb8a1d1f4a1e7b34$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $77832b0de927d8a6$export$896afd8541959ee5).INVALID_ARGUMENT_TYPE, $bb8a1d1f4a1e7b34$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $77832b0de927d8a6$export$896afd8541959ee5).EXPECT_ARGUMENT_CLOSING_BRACE, $bb8a1d1f4a1e7b34$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $77832b0de927d8a6$export$896afd8541959ee5).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $bb8a1d1f4a1e7b34$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $43f9504d448840fb$export$71cee2f16fba2480)(skeleton);
        } catch (e) {
            return this.error((0, $77832b0de927d8a6$export$896afd8541959ee5).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $ca93e31e6d19b1d5$export$906452485466fa53).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $43f9504d448840fb$export$47c6f8480bda3e11)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $77832b0de927d8a6$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $77832b0de927d8a6$export$896afd8541959ee5).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $bb8a1d1f4a1e7b34$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === 'select' ? (0, $77832b0de927d8a6$export$896afd8541959ee5).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $77832b0de927d8a6$export$896afd8541959ee5).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === 'other') hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) return this.error(parentArgType === 'select' ? (0, $77832b0de927d8a6$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $77832b0de927d8a6$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $bb8a1d1f4a1e7b34$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $bb8a1d1f4a1e7b34$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === 'select' ? (0, $77832b0de927d8a6$export$896afd8541959ee5).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $77832b0de927d8a6$export$896afd8541959ee5).EXPECT_PLURAL_ARGUMENT_SELECTOR, $bb8a1d1f4a1e7b34$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $77832b0de927d8a6$export$896afd8541959ee5).MISSING_OTHER_CLAUSE, $bb8a1d1f4a1e7b34$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) ;
        else if (this.bumpIf('-')) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $bb8a1d1f4a1e7b34$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$bb8a1d1f4a1e7b34$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error('out of bound');
        var code = $bb8a1d1f4a1e7b34$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($bb8a1d1f4a1e7b34$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $bb8a1d1f4a1e7b34$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $bb8a1d1f4a1e7b34$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $bb8a1d1f4a1e7b34$var$_isAlphaOrSlash(codepoint) {
    return $bb8a1d1f4a1e7b34$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $bb8a1d1f4a1e7b34$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $bb8a1d1f4a1e7b34$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $bb8a1d1f4a1e7b34$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}



function $1f0acadc888b32e2$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $ca93e31e6d19b1d5$export$dcfe1c11d168b5a1)(el) || (0, $ca93e31e6d19b1d5$export$6c796d116f0a4fbc)(el)) for(var k in el.options){
            delete el.options[k].location;
            $1f0acadc888b32e2$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $ca93e31e6d19b1d5$export$e11187b219e191e1)(el) && (0, $ca93e31e6d19b1d5$export$3f9a19cd4152eda3)(el.style)) delete el.style.location;
        else if (((0, $ca93e31e6d19b1d5$export$32d811605da75f40)(el) || (0, $ca93e31e6d19b1d5$export$34ec46f596b1702f)(el)) && (0, $ca93e31e6d19b1d5$export$7680c41f1a55f4cf)(el.style)) delete el.style.location;
        else if ((0, $ca93e31e6d19b1d5$export$5c83de34745812b)(el)) $1f0acadc888b32e2$var$pruneLocation(el.children);
    });
}
function $1f0acadc888b32e2$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $dEf6I.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $bb8a1d1f4a1e7b34$export$7acfa6ed01010e37)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $77832b0de927d8a6$export$896afd8541959ee5)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $1f0acadc888b32e2$var$pruneLocation(result.val);
    return result.val;
}


function $d209cc6f2efb26ec$var$setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = (0, $dEf6I.__assign)({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function $d209cc6f2efb26ec$var$deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function $d209cc6f2efb26ec$var$deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = (0, $990a55d7cb84037c$export$d342343268debc40).formats;
    return (0, $dEf6I.__assign)((0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, mfFormats), f1), {
        date: $d209cc6f2efb26ec$var$deepMergeOptions($d209cc6f2efb26ec$var$setTimeZoneInOptions(mfFormats.date, timeZone), $d209cc6f2efb26ec$var$setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: $d209cc6f2efb26ec$var$deepMergeOptions($d209cc6f2efb26ec$var$setTimeZoneInOptions(mfFormats.time, timeZone), $d209cc6f2efb26ec$var$setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
function $d209cc6f2efb26ec$export$25868d1e8e76735f(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ''
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, $f3ab26094310a214$export$f5708dca728d7177)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, $ca93e31e6d19b1d5$export$b87f371cbc396fcf).literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === 'string' && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, defaultRichTextElements), values || {});
    formats = $d209cc6f2efb26ec$var$deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = $d209cc6f2efb26ec$var$deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === '') return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new (0, $0944942e84c0710e$export$2ddcb436d0aa3688)(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new (0, $0944942e84c0710e$export$74a601a3d3f31621)("Error formatting default message for: \"".concat(id, "\", rendering default message verbatim"), locale, messageDescriptor, e));
            return typeof defaultMessage === 'string' ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0, $dEf6I.__assign)({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $0944942e84c0710e$export$74a601a3d3f31621)("Error formatting message: \"".concat(id, "\", using ").concat(defaultMessage ? 'default message' : 'id', " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $0944942e84c0710e$export$74a601a3d3f31621)("Error formatting the default message for: \"".concat(id, "\", rendering message verbatim"), locale, messageDescriptor, e));
    }
    if (typeof message === 'string') return message;
    if (typeof defaultMessage === 'string') return defaultMessage;
    return id;
}



var $dEf6I = parcelRequire("dEf6I");



var $991f163aa116c66e$var$LIST_FORMAT_OPTIONS = [
    'localeMatcher',
    'type',
    'style'
];
var $991f163aa116c66e$var$now = Date.now();
function $991f163aa116c66e$var$generateToken(i) {
    return "".concat($991f163aa116c66e$var$now, "_").concat(i, "_").concat($991f163aa116c66e$var$now);
}
function $991f163aa116c66e$export$e8b8be48b45905bb(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = $991f163aa116c66e$export$6f284aad1934db69(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== 'string') all.push(val);
        else if (typeof all[all.length - 1] === 'string') all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results;
}
function $991f163aa116c66e$export$6f284aad1934db69(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new (0, $416f155282bf95d7$export$7369836851cc1329)("Intl.ListFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-listformat\"\n", (0, $416f155282bf95d7$export$d4e71bc0b80dc0fb).MISSING_INTL_API));
    var filteredOptions = (0, $bd2157defde87cf4$export$d697c39a2985a4c)(options, $991f163aa116c66e$var$LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = values.map(function(v, i) {
            if (typeof v === 'object') {
                var id = $991f163aa116c66e$var$generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === 'literal' ? part : (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new (0, $0944942e84c0710e$export$c016d36112f6ddf8)((0, $0944942e84c0710e$export$557d6acb76e8a244).FORMAT_ERROR, 'Error formatting list.', e));
    }
    // @ts-ignore
    return values;
}





var $1a9774981ea63455$var$DISPLAY_NAMES_OPTONS = [
    'localeMatcher',
    'style',
    'type',
    'fallback'
];
function $1a9774981ea63455$export$62fe1a4d9e891fa2(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new (0, $416f155282bf95d7$export$7369836851cc1329)("Intl.DisplayNames is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-displaynames\"\n", (0, $416f155282bf95d7$export$d4e71bc0b80dc0fb).MISSING_INTL_API));
    var filteredOptions = (0, $bd2157defde87cf4$export$d697c39a2985a4c)(options, $1a9774981ea63455$var$DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new (0, $0944942e84c0710e$export$c016d36112f6ddf8)((0, $0944942e84c0710e$export$557d6acb76e8a244).FORMAT_ERROR, 'Error formatting display name.', e));
    }
}


function $0b2d3ec5a1355939$var$messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === 'string';
}
function $0b2d3ec5a1355939$var$verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && $0b2d3ec5a1355939$var$messagesContainString(config.messages || {})) config.onWarn("[@formatjs/intl] \"defaultRichTextElements\" was specified but \"message\" was not pre-compiled. \nPlease consider using \"@formatjs/cli\" to pre-compile your messages for performance.\nFor more details see https://formatjs.io/docs/getting-started/message-distribution");
}
function $0b2d3ec5a1355939$export$7e4cbedfdd7b4c0d(config, cache) {
    var formatters = (0, $bd2157defde87cf4$export$c3f4cd5551df13fd)(cache);
    var resolvedConfig = (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, (0, $bd2157defde87cf4$export$b52f8d6fc0d47415)), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new (0, $0944942e84c0710e$export$3ca04dd7fb305893)("\"locale\" was not configured, using \"".concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details")));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || 'en';
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $0944942e84c0710e$export$c1eaf877d81384b6)("Missing locale data for locale: \"".concat(locale, "\" in Intl.NumberFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $0944942e84c0710e$export$c1eaf877d81384b6)("Missing locale data for locale: \"".concat(locale, "\" in Intl.DateTimeFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    $0b2d3ec5a1355939$var$verifyConfigMessages(resolvedConfig);
    return (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: (0, $704e8230eddf6b2d$export$f5dd818bff069720).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: (0, $704e8230eddf6b2d$export$6871080848f10b2f).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: (0, $f170bf6ae1c01c11$export$b4ea3b48dcf921f6).bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: (0, $d40299055c9f00be$export$3ae94a2503e890a1).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: (0, $d40299055c9f00be$export$dc1f059bce486b1).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: (0, $d40299055c9f00be$export$3203edd9e5edd663).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: (0, $d40299055c9f00be$export$a7fc3a91cb2ec376).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: (0, $d40299055c9f00be$export$af6e5d7a5c73edeb).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: (0, $945b961e73517a42$export$bbbd05c900f3568d).bind(null, resolvedConfig, formatters.getPluralRules),
        formatMessage: (0, $d209cc6f2efb26ec$export$25868d1e8e76735f).bind(null, resolvedConfig, formatters),
        $t: (0, $d209cc6f2efb26ec$export$25868d1e8e76735f).bind(null, resolvedConfig, formatters),
        formatList: (0, $991f163aa116c66e$export$e8b8be48b45905bb).bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: (0, $991f163aa116c66e$export$6f284aad1934db69).bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: (0, $1a9774981ea63455$export$62fe1a4d9e891fa2).bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}



function $0fa5d5e8583b67a0$var$processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
function $0fa5d5e8583b67a0$var$assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce(function(acc, k) {
        var v = values[k];
        acc[k] = (0, $d8c3f17367458324$export$df0c12a2d414a163)(v) ? (0, $ffccc38ccafa9e00$export$cfec03d26465fa63)(v) : v;
        return acc;
    }, {});
}
var $0fa5d5e8583b67a0$var$formatMessage = function(config, formatters, descriptor, rawValues) {
    var rest = [];
    for(var _i = 4; _i < arguments.length; _i++)rest[_i - 4] = arguments[_i];
    var values = $0fa5d5e8583b67a0$var$assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = (0, $d209cc6f2efb26ec$export$25868d1e8e76735f).apply(void 0, (0, $dEf6I.__spreadArray)([
        config,
        formatters,
        descriptor,
        values
    ], rest, false));
    if (Array.isArray(chunks)) return $dQwsT.Children.toArray(chunks);
    return chunks;
};
var $0fa5d5e8583b67a0$export$7e4cbedfdd7b4c0d = function(_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0, $dEf6I.__rest)(_a, [
        "defaultRichTextElements"
    ]);
    var defaultRichTextElements = $0fa5d5e8583b67a0$var$assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = (0, $0b2d3ec5a1355939$export$7e4cbedfdd7b4c0d)((0, $dEf6I.__assign)((0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, (0, $ffccc38ccafa9e00$export$b52f8d6fc0d47415)), config), {
        defaultRichTextElements: defaultRichTextElements
    }), cache);
    return (0, $dEf6I.__assign)((0, $dEf6I.__assign)({}, coreIntl), {
        formatMessage: $0fa5d5e8583b67a0$var$formatMessage.bind(null, {
            locale: coreIntl.locale,
            timeZone: coreIntl.timeZone,
            fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
            formats: coreIntl.formats,
            defaultLocale: coreIntl.defaultLocale,
            defaultFormats: coreIntl.defaultFormats,
            messages: coreIntl.messages,
            onError: coreIntl.onError,
            defaultRichTextElements: defaultRichTextElements
        }, coreIntl.formatters)
    });
};
var $0fa5d5e8583b67a0$var$IntlProvider = /** @class */ function(_super) {
    (0, $dEf6I.__extends)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0, $bd2157defde87cf4$export$51c4f4e973f2dc00)();
        _this.state = {
            cache: _this.cache,
            intl: $0fa5d5e8583b67a0$export$7e4cbedfdd7b4c0d($0fa5d5e8583b67a0$var$processIntlConfig(_this.props), _this.cache),
            prevConfig: $0fa5d5e8583b67a0$var$processIntlConfig(_this.props)
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function(props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = $0fa5d5e8583b67a0$var$processIntlConfig(props);
        if (!(0, $ffccc38ccafa9e00$export$d36bdfa510afb180)(prevConfig, config)) return {
            intl: $0fa5d5e8583b67a0$export$7e4cbedfdd7b4c0d(config, cache),
            prevConfig: config
        };
        return null;
    };
    IntlProvider.prototype.render = function() {
        (0, $ffccc38ccafa9e00$export$45c4bbf6e55bba1f)(this.state.intl);
        return $dQwsT.createElement((0, $fd82be28c43fef71$export$2881499e37b75b9a), {
            value: this.state.intl
        }, this.props.children);
    };
    IntlProvider.displayName = 'IntlProvider';
    IntlProvider.defaultProps = (0, $ffccc38ccafa9e00$export$b52f8d6fc0d47415);
    return IntlProvider;
}($dQwsT.PureComponent);
var $0fa5d5e8583b67a0$export$2e2bcd8739ae039 = $0fa5d5e8583b67a0$var$IntlProvider;


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 

var $dQwsT = parcelRequire("dQwsT");
const $3724dce2f1169af0$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $3724dce2f1169af0$var$ATOMIC_GROUP_LENGTH = 5;
function $3724dce2f1169af0$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(' ') === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(' ');
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $3724dce2f1169af0$var$UNDERSCORE_UNICODE ? $3724dce2f1169af0$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = '';
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + ' ';
    }
    return str.slice(0, -1);
}


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ parcelRequire("dQwsT");
const $da450fbda6efdaee$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $da450fbda6efdaee$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};



const $9dcd58cdca0b79b5$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $3724dce2f1169af0$export$2e2bcd8739ae039)(actualStyles);
};


function $9bf909683cec5f1a$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $da450fbda6efdaee$export$c4df1cb0c2b4d77c)();
        },
        cssMap () {
            throw (0, $da450fbda6efdaee$export$c4df1cb0c2b4d77c)();
        },
        cx: $9dcd58cdca0b79b5$export$a274e22fb40f762e,
        XCSSProp () {
            throw (0, $da450fbda6efdaee$export$c4df1cb0c2b4d77c)();
        }
    };
}


const $a4d0eec0446fa72f$var$strictApi = (0, $9bf909683cec5f1a$export$39716b4af53f4ad)();
const $a4d0eec0446fa72f$export$dbf350e5966cf602 = $a4d0eec0446fa72f$var$strictApi.css;
const $a4d0eec0446fa72f$export$eb1ecd84a24ee424 = $a4d0eec0446fa72f$var$strictApi.cssMap;
$a4d0eec0446fa72f$var$strictApi.cssMap;
const $a4d0eec0446fa72f$export$a274e22fb40f762e = $a4d0eec0446fa72f$var$strictApi.cx;
const $a4d0eec0446fa72f$var$XCSSProp = $a4d0eec0446fa72f$var$strictApi.XCSSProp;



/* anchor.tsx generated by @compiled/babel-plugin v0.36.1 */ 

var $dQwsT = parcelRequire("dQwsT");

var $0eb8d075c37eacea$var$isProduction = true;
var $0eb8d075c37eacea$var$prefix = 'Invariant failed';
function $0eb8d075c37eacea$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($0eb8d075c37eacea$var$isProduction) throw new Error($0eb8d075c37eacea$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($0eb8d075c37eacea$var$prefix, ": ").concat(provided) : $0eb8d075c37eacea$var$prefix;
    throw new Error(value);
}



var $dQwsT = parcelRequire("dQwsT");


var $dQwsT = parcelRequire("dQwsT");
const $cd6077b5072f32b2$export$1d27a74659855e44 = (value)=>{
    const ref = (0, $dQwsT.useRef)(value);
    ref.current = value;
    return ref;
};


function $a4690f6d1efb312e$export$a4687b0234b40e28({ fn: fn, action: action, componentName: componentName, actionSubject: actionSubject, packageName: packageName, packageVersion: packageVersion, analyticsData: analyticsData }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $5bc6f3e28bd9f46e$export$5bf35293e545f20c)();
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    const dataRef = (0, $cd6077b5072f32b2$export$1d27a74659855e44)(analyticsData);
    const fnRef = (0, $cd6077b5072f32b2$export$1d27a74659855e44)(fn);
    const handler = (0, $dQwsT.useCallback)((value)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        const context = {
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion,
            ...dataRef.current
        };
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}



var $dQwsT = parcelRequire("dQwsT");


var $dQwsT = parcelRequire("dQwsT");
const $075274731269bfdc$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $dQwsT.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $075274731269bfdc$var$RouterLinkProvider = ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $cf73c70412c0bb28$exports.jsx)($075274731269bfdc$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
var $075274731269bfdc$export$2e2bcd8739ae039 = $075274731269bfdc$var$RouterLinkProvider;


/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ const $659750a264ea5917$var$useRouterLink = ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $dQwsT.useContext)((0, $075274731269bfdc$export$2931e0ee690eee88));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $659750a264ea5917$export$2e2bcd8739ae039 = $659750a264ea5917$var$useRouterLink;


/**
 * An empty function which does nothing.
 */ function $2262e55146c1c62b$export$2e2bcd8739ae039() {}




var $dQwsT = parcelRequire("dQwsT");

var $dQwsT = parcelRequire("dQwsT");

var $dQwsT = parcelRequire("dQwsT");
/**
 * generates a UID factory
 * @internal
 * @example
 * const uid = generateUID();
 * uid(object) = 1;
 * uid(object) = 1;
 * uid(anotherObject) = 2;
 */ const $b6c4ad1493bd1df0$export$bdbb4cbb3078e58d = ()=>{
    let counter = 1;
    const map = new WeakMap();
    /**
     * @borrows {uid}
     */ const uid = (item, index)=>{
        if (typeof item === 'number' || typeof item === 'string') return index ? `idx-${index}` : `val-${item}`;
        if (!map.has(item)) {
            map.set(item, counter++);
            return uid(item);
        }
        return 'uid' + map.get(item);
    };
    return uid;
};
const $b6c4ad1493bd1df0$export$e2a22331486dcca0 = $b6c4ad1493bd1df0$export$bdbb4cbb3078e58d();


const $cd3eba3421b8ee7d$export$1921362e86c73c88 = (prefix = '')=>({
        value: 1,
        prefix: prefix,
        uid: (0, $b6c4ad1493bd1df0$export$bdbb4cbb3078e58d)()
    });
const $cd3eba3421b8ee7d$export$e575061ef2a070eb = $cd3eba3421b8ee7d$export$1921362e86c73c88();
const $cd3eba3421b8ee7d$export$b4d5da5f34fb77ad = $dQwsT.createContext($cd3eba3421b8ee7d$export$1921362e86c73c88());
const $cd3eba3421b8ee7d$export$218c8c3169c024d2 = (source)=>source.value++;
const $cd3eba3421b8ee7d$export$36e24695f02d4503 = (source)=>source ? source.prefix : '';


const $c1e3595914fdac54$var$generateUID = (context)=>{
    const quartz = context || (0, $cd3eba3421b8ee7d$export$e575061ef2a070eb);
    const prefix = (0, $cd3eba3421b8ee7d$export$36e24695f02d4503)(quartz);
    const id = (0, $cd3eba3421b8ee7d$export$218c8c3169c024d2)(quartz);
    const uid = prefix + id;
    const gen = (item)=>uid + quartz.uid(item);
    return {
        uid: uid,
        gen: gen
    };
};
const $c1e3595914fdac54$var$useUIDState = ()=>{
    const context = (0, $dQwsT.useContext)((0, $cd3eba3421b8ee7d$export$b4d5da5f34fb77ad));
    const [uid] = (0, $dQwsT.useState)(()=>$c1e3595914fdac54$var$generateUID(context));
    return uid;
};
const $c1e3595914fdac54$export$87d05f07e65211f1 = ()=>{
    const { uid: uid } = $c1e3595914fdac54$var$useUIDState();
    return uid;
};
const $c1e3595914fdac54$export$bb5ca5fba6fb4f1f = ()=>{
    const { gen: gen } = $c1e3595914fdac54$var$useUIDState();
    return gen;
};



// @ts-ignore - useId is not accessible in React 16
const $150411bf60f3c857$var$react18UseId = (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).useId ?? undefined;
function $150411bf60f3c857$export$f680877a34711e37() {
    if ($150411bf60f3c857$var$react18UseId && (0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform-dst-react-18-use-id')) {
        if ((0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform-dst-react-18-use-id-selector-safe')) // tl;dr: React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`
        // in hundreds of tests. So we replace it with a safe string of `_` to match future
        // React 19 functionality: https://github.com/facebook/react/pull/33422
        return $150411bf60f3c857$var$react18UseId().replace(/[:«»]/g, '_');
        return $150411bf60f3c857$var$react18UseId();
    }
    return `uid${(0, $c1e3595914fdac54$export$87d05f07e65211f1)()}`;
}
const $150411bf60f3c857$export$6be90bcb437e928f = /*#__PURE__*/ (0, $dQwsT.forwardRef)(({ children: children, postfix: postfix = '', prefix: prefix = '' }, ref)=>{
    const id = `${prefix}${$150411bf60f3c857$export$f680877a34711e37()}${postfix}`;
    (0, $dQwsT.useEffect)(()=>{
        if (!ref) return;
        switch(typeof ref){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error(`Unreachable case for unsupported type of ref "${typeof ref}"`);
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, $cf73c70412c0bb28$exports.jsx)((0, $cf73c70412c0bb28$exports.Fragment), {
        children: typeof children === 'function' ? children({
            id: id
        }) : children
    });
});
function $150411bf60f3c857$export$6ee17796e3d70de2() {
    if ($150411bf60f3c857$var$react18UseId && (0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform-dst-react-18-use-id')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks -- cleanup with feature gating
        const uid = $150411bf60f3c857$export$f680877a34711e37();
        return (id)=>`${uid}-${id.toString()}`;
    }
    return (0, $c1e3595914fdac54$export$bb5ca5fba6fb4f1f)();
}



var $dQwsT = parcelRequire("dQwsT");
const $3b4511bc7338e41a$var$_default_1 = (0, $dQwsT.createContext)(null);
var $3b4511bc7338e41a$export$2e2bcd8739ae039 = $3b4511bc7338e41a$var$_default_1;


/* visually-hidden.tsx generated by @compiled/babel-plugin v0.36.1 */ 
parcelRequire("dQwsT");

const $25078314a75fe57e$var$visuallyHiddenStyles = null; /**
                                    * __Visually hidden__
                                    *
                                    * A composable element to apply a visually hidden effect to children.
                                    * Useful for accessibility compliance.
                                    *
                                    * @example
                                    * ```jsx
                                    * import VisuallyHidden from '@atlaskit/visually-hidden';
                                    *
                                    * export default () => (
                                    *   <div style={{ border: '1px solid black' }}>
                                    *      There is text hidden between the brackets [
                                    *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
                                    *   </div>
                                    * );
                                    * ```
                                    */ 
const $25078314a75fe57e$var$VisuallyHidden = ({ children: children, testId: testId, role: role, id: id })=>{
    return /*#__PURE__*/ (0, $cf73c70412c0bb28$exports.jsx)("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $3724dce2f1169af0$export$2e2bcd8739ae039)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _uiztglyw _o5721q9c"
        ]),
        children: children
    });
};
$25078314a75fe57e$var$VisuallyHidden.displayName = 'VisuallyHidden';
var $25078314a75fe57e$export$2e2bcd8739ae039 = $25078314a75fe57e$var$VisuallyHidden;


/* focusable.tsx generated by @compiled/babel-plugin v0.36.1 */ 

var $dQwsT = parcelRequire("dQwsT");

const $93b0a37527250118$var$focusRingStyles = null;
const $93b0a37527250118$var$insetFocusRingStyles = null;
const $93b0a37527250118$var$Focusable = /*#__PURE__*/ (0, $dQwsT.forwardRef)(({ as: Component = 'button', children: children, isInset: isInset, testId: testId, style: style, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    return /*#__PURE__*/ (0, $cf73c70412c0bb28$exports.jsx)(Component, {
        ...safeHtmlAttributes,
        ref: ref,
        className: (0, $3724dce2f1169af0$export$2e2bcd8739ae039)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu1v1w _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId,
        children: children
    });
});
var $93b0a37527250118$export$2e2bcd8739ae039 = $93b0a37527250118$var$Focusable;


const $7aed3225970bef37$var$styles = {
    root: "_4bfu1r31 _1hms8stv _ajmmnqa1 _vchhusvi",
    position: "_kqswh2mm"
};
const $7aed3225970bef37$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
const $7aed3225970bef37$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/; /**
                                                              * __Anchor__
                                                              *
                                                              * A primitive for building custom anchor links.
                                                              *
                                                              * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
                                                              * - [Code](https://atlassian.design/components/primitives/anchor/code)
                                                              * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
                                                              */ 
const $7aed3225970bef37$var$AnchorNoRef = ({ href: href, children: children, onClick: providedOnClick = (0, $2262e55146c1c62b$export$2e2bcd8739ae039), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, style: style, target: target, testId: testId, xcss: xcss, newWindowLabel: newWindowLabel = '(opens new window)', ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $dQwsT.useContext)((0, $3b4511bc7338e41a$export$2e2bcd8739ae039));
    const handleClick = (0, $dQwsT.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const opensNewWindowLabelId = (0, $150411bf60f3c857$export$f680877a34711e37)();
    const onClick = (0, $a4690f6d1efb312e$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: analyticsContext,
        actionSubject: 'link'
    }); // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const RouterLink = (0, $659750a264ea5917$export$2e2bcd8739ae039)();
    const isExternal = typeof href === 'string' && $7aed3225970bef37$var$IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === 'string' && $7aed3225970bef37$var$IS_NON_HTTP_BASED.test(href); /**
                                                                                    * Renders a router link if:
                                                                                    *
                                                                                    * - a link component is set in the app provider
                                                                                    * - it's not an external link (starting with `http://` or `https://`)
                                                                                    * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
                                                                                    */ 
    const isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    const hrefObjectUsedWithoutRouterLink = RouterLink === undefined && typeof href === 'object';
    (0, $0eb8d075c37eacea$export$2e2bcd8739ae039)(!hrefObjectUsedWithoutRouterLink, `@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider`);
    const Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ (0, $cf73c70412c0bb28$exports.jsxs)((0, $93b0a37527250118$export$2e2bcd8739ae039 // @ts-expect-error we don't allow `a` on Focusable for makers as they should use Anchor instead
    ), {
        as: Component,
        className: xcss,
        style: style,
        ref: ref,
        ...safeHtmlAttributes,
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? `${ariaLabel} , ${newWindowLabel}` : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? `${ariaLabelledBy} ${opensNewWindowLabelId}` : ariaLabelledBy,
        xcss: (0, $9dcd58cdca0b79b5$export$a274e22fb40f762e)($7aed3225970bef37$var$styles.root, $7aed3225970bef37$var$styles.position, xcss),
        testId: testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined,
        children: [
            children,
            target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ (0, $cf73c70412c0bb28$exports.jsx)((0, $25078314a75fe57e$export$2e2bcd8739ae039), {
                id: opensNewWindowLabelId,
                children: `, ${newWindowLabel}`
            })
        ]
    });
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ const $7aed3225970bef37$var$Anchor = /*#__PURE__*/ (0, $dQwsT.forwardRef)($7aed3225970bef37$var$AnchorNoRef);
var $7aed3225970bef37$export$2e2bcd8739ae039 = $7aed3225970bef37$var$Anchor;

/* box.tsx generated by @compiled/babel-plugin v0.36.1 */ 

var $dQwsT = parcelRequire("dQwsT");


var $dQwsT = parcelRequire("dQwsT");
const $d678fb33316e4a75$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $dQwsT.createContext)('elevation.surface');
const $d678fb33316e4a75$export$1aeb4f6b93c4540d = ()=>{
    return (0, $dQwsT.useContext)($d678fb33316e4a75$export$1ca2a26fecb070ae);
};
$d678fb33316e4a75$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';


const $4e3d6d07899abb6e$var$baseStyles = null;
const $4e3d6d07899abb6e$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhkkuup",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1gf0",
    'color.background.accent.lime.subtler.pressed': "_bfhk2kxc",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhk1jbd",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhkh0j0",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhknbir",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkaffd",
    'color.background.accent.red.subtler.pressed': "_bfhk1j5a",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1fnn",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhk1cl6",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtlest.hovered': "_bfhk19yr",
    'color.background.accent.orange.subtlest.pressed': "_bfhkf90x",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtler.hovered': "_bfhk1ei0",
    'color.background.accent.orange.subtler.pressed': "_bfhkdpo3",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.subtle.hovered': "_bfhk9mfs",
    'color.background.accent.orange.subtle.pressed': "_bfhkaxpp",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.orange.bolder.hovered': "_bfhk12qo",
    'color.background.accent.orange.bolder.pressed': "_bfhk1fyq",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtlest.hovered': "_bfhkaetg",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk1o1l",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtler.hovered': "_bfhk1uw7",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1r9w",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.subtle.hovered': "_bfhk819w",
    'color.background.accent.yellow.subtle.pressed': "_bfhk1jx0",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk1okt",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkyfny",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhk1e2h",
    'color.background.accent.green.subtler.pressed': "_bfhkybhx",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk1g86",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1j68",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1cxp",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkkwwr",
    'color.background.accent.teal.subtler.pressed': "_bfhk1jb0",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk16zl",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhktor0",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtlest.hovered': "_bfhkdaj9",
    'color.background.accent.blue.subtlest.pressed': "_bfhkxm0g",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtler.hovered': "_bfhk815t",
    'color.background.accent.blue.subtler.pressed': "_bfhkrwxf",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.subtle.hovered': "_bfhk9pr4",
    'color.background.accent.blue.subtle.pressed': "_bfhknpx7",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.blue.bolder.hovered': "_bfhk1vbm",
    'color.background.accent.blue.bolder.pressed': "_bfhk1xwi",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtlest.hovered': "_bfhkkca2",
    'color.background.accent.purple.subtlest.pressed': "_bfhk1jbm",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtler.hovered': "_bfhkattl",
    'color.background.accent.purple.subtler.pressed': "_bfhk3nfk",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.subtle.hovered': "_bfhk8bp1",
    'color.background.accent.purple.subtle.pressed': "_bfhk1cd2",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.purple.bolder.hovered': "_bfhk1af5",
    'color.background.accent.purple.bolder.pressed': "_bfhk6cze",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1ckf",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1axx",
    'color.background.accent.magenta.subtler.pressed': "_bfhk42ri",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk6c15",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkeawv",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtlest.hovered': "_bfhkwejn",
    'color.background.accent.gray.subtlest.pressed': "_bfhk18ut",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtler.hovered': "_bfhk10ef",
    'color.background.accent.gray.subtler.pressed': "_bfhk1rk9",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.subtle.hovered': "_bfhk1nv3",
    'color.background.accent.gray.subtle.pressed': "_bfhkq9tj",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.accent.gray.bolder.hovered': "_bfhkbyip",
    'color.background.accent.gray.bolder.pressed': "_bfhk1van",
    'color.background.disabled': "_bfhkby5v",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhkl4ek",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.hovered': "_bfhkplhp",
    'color.background.neutral.pressed': "_bfhk1gdz",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk1dpa",
    'color.background.neutral.subtle.pressed': "_bfhkfcek",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.neutral.bold.hovered': "_bfhk1ibz",
    'color.background.neutral.bold.pressed': "_bfhkof27",
    'color.background.selected': "_bfhk15s3",
    'color.background.selected.hovered': "_bfhkufnl",
    'color.background.selected.pressed': "_bfhknozp",
    'color.background.selected.bold': "_bfhkjmqp",
    'color.background.selected.bold.hovered': "_bfhk1q28",
    'color.background.selected.bold.pressed': "_bfhk12kk",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.subtlest.hovered': "_bfhk3v15",
    'color.background.brand.subtlest.pressed': "_bfhku02c",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.bold.hovered': "_bfhkhf2y",
    'color.background.brand.bold.pressed': "_bfhkg6ey",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.brand.boldest.hovered': "_bfhklefx",
    'color.background.brand.boldest.pressed': "_bfhk16k6",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1r4b",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk13a9",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.hovered': "_bfhk19zu",
    'color.background.warning.pressed': "_bfhkzr32",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.warning.bold.hovered': "_bfhk1spp",
    'color.background.warning.bold.pressed': "_bfhk4m4m",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.hovered': "_bfhk1vfx",
    'color.background.success.pressed': "_bfhk1wl5",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.success.bold.hovered': "_bfhky7x8",
    'color.background.success.bold.pressed': "_bfhkwcbh",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.hovered': "_bfhk12eq",
    'color.background.discovery.pressed': "_bfhk18vq",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.discovery.bold.hovered': "_bfhkfqeg",
    'color.background.discovery.bold.pressed': "_bfhk1f1m",
    'color.background.information': "_bfhk19ip",
    'color.background.information.hovered': "_bfhk86z5",
    'color.background.information.pressed': "_bfhk1c1j",
    'color.background.information.bold': "_bfhkx4w0",
    'color.background.information.bold.hovered': "_bfhkq2ii",
    'color.background.information.bold.pressed': "_bfhkf89v",
    'color.blanket': "_bfhk1i5c",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkizff",
    'color.skeleton.subtle': "_bfhkvkf5",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk19i6",
    'elevation.surface.pressed': "_bfhk13ro",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk6o2t",
    'elevation.surface.overlay.pressed': "_bfhkm8nx",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk116u",
    'elevation.surface.raised.pressed': "_bfhk14aj",
    'elevation.surface.sunken': "_bfhkhfxm",
    'utility.elevation.surface.current': "_bfhkchd4"
};
const $4e3d6d07899abb6e$var$CURRENT_SURFACE_CSS_VAR = `--ds-elevation-surface-current`;
const $4e3d6d07899abb6e$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l19i6",
    'elevation.surface.pressed': "_1q1l13ro",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l6o2t",
    'elevation.surface.overlay.pressed': "_1q1lm8nx",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l116u",
    'elevation.surface.raised.pressed': "_1q1l14aj",
    'elevation.surface.sunken': "_1q1lhfxm"
};
const $4e3d6d07899abb6e$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
const $4e3d6d07899abb6e$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
const $4e3d6d07899abb6e$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
const $4e3d6d07899abb6e$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
}; /**
    * __Box__
    *
    * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
    * Renders a `div` by default.
    *
    * - [Examples](https://atlassian.design/components/primitives/box/examples)
    * - [Code](https://atlassian.design/components/primitives/box/code)
    * - [Usage](https://atlassian.design/components/primitives/box/usage)
    */ 
const $4e3d6d07899abb6e$var$Box = /*#__PURE__*/ (0, $dQwsT.forwardRef)(({ as: Component = 'div', children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock = padding, paddingBlockStart: paddingBlockStart = paddingBlock, paddingBlockEnd: paddingBlockEnd = paddingBlock, paddingInline: paddingInline = padding, paddingInlineStart: paddingInlineStart = paddingInline, paddingInlineEnd: paddingInlineEnd = paddingInline, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const node = /*#__PURE__*/ (0, $cf73c70412c0bb28$exports.jsx)(Component // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    , {
        style: style,
        ref: ref,
        className: (0, $3724dce2f1169af0$export$2e2bcd8739ae039)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $4e3d6d07899abb6e$var$backgroundColorMap[backgroundColor],
            backgroundColor && $4e3d6d07899abb6e$var$isSurfaceToken(backgroundColor) && $4e3d6d07899abb6e$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $4e3d6d07899abb6e$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $4e3d6d07899abb6e$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $4e3d6d07899abb6e$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $4e3d6d07899abb6e$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ]),
        ...safeHtmlAttributes,
        "data-testid": testId,
        children: children
    });
    if (backgroundColor) return /*#__PURE__*/ (0, $cf73c70412c0bb28$exports.jsx)((0, $d678fb33316e4a75$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor,
        children: node
    });
    return node;
} // @ts-ignore This typescript error has been surpessed while locally enrolling `@atlaskit/primitives` into Jira
);
var $4e3d6d07899abb6e$export$2e2bcd8739ae039 = $4e3d6d07899abb6e$var$Box;
function $4e3d6d07899abb6e$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $4e3d6d07899abb6e$var$setSurfaceTokenMap;
}


const $edb9e3b208e8e155$var$styles = {
    visitedLink: "_ect41gqc _10531ra0 _1ien1ra0 _n0fx1ra0 _1vhv17z1",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz13af _ect41gqc _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1r31 _1bnxglyw _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h12zz",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _ect41gqc _syazazsu _1a3b1r31 _4fprglyw _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _ect41gqc _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n41q9y _kqswh2mm _152ttb3r"
};
const $edb9e3b208e8e155$var$iconStyles = null;
const $edb9e3b208e8e155$var$LinkWithoutRef = ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: preventedClassName, // @ts-expect-error
style: preventedStyle, ...htmlAttributes }, ref)=>{
    return /*#__PURE__*/ (0, $cf73c70412c0bb28$exports.jsxs)((0, $7aed3225970bef37$export$2e2bcd8739ae039 // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    ), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        xcss: (0, $a4d0eec0446fa72f$export$a274e22fb40f762e)(appearance === 'default' && $edb9e3b208e8e155$var$styles.defaultAppearance, appearance === 'subtle' && $edb9e3b208e8e155$var$styles.subtleAppearance, appearance === 'inverse' && $edb9e3b208e8e155$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $edb9e3b208e8e155$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel,
        children: [
            children,
            target === '_blank' && /*#__PURE__*/ (0, $cf73c70412c0bb28$exports.jsxs)((0, $4e3d6d07899abb6e$export$2e2bcd8739ae039), {
                as: "span",
                xcss: $edb9e3b208e8e155$var$styles.iconWrapper,
                testId: testId && `${testId}__icon`,
                children: [
                    "\uFEFF",
                    (0, $c04d14497c4aa1d8$export$b40ec24ac8275656)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $cf73c70412c0bb28$exports.jsx)("svg", {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "none",
                        className: (0, $3724dce2f1169af0$export$2e2bcd8739ae039)([
                            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
                        ]),
                        children: /*#__PURE__*/ (0, $cf73c70412c0bb28$exports.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                            fill: "currentColor"
                        })
                    }) : /*#__PURE__*/ (0, $cf73c70412c0bb28$exports.jsxs)("svg", {
                        width: "20",
                        height: "20",
                        viewBox: "0 0 20 20",
                        fill: "currentColor",
                        className: (0, $3724dce2f1169af0$export$2e2bcd8739ae039)([
                            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $cf73c70412c0bb28$exports.jsx)("path", {
                                d: "M17.5715 3.95926L10.7587 10.772C10.5546 10.9692 10.2811 11.0784 9.99723 11.0759C9.71338 11.0734 9.44185 10.9596 9.24113 10.7589C9.04041 10.5581 8.92655 10.2866 8.92409 10.0027C8.92162 9.7189 9.03074 9.44543 9.22794 9.24125L16.0407 2.4285H14.3237C14.0366 2.4285 13.7613 2.31444 13.5582 2.11142C13.3552 1.90839 13.2411 1.63303 13.2411 1.34591C13.2411 1.05879 13.3552 0.783424 13.5582 0.580399C13.7613 0.377373 14.0366 0.263314 14.3237 0.263314H18.4981C18.5509 0.254962 18.6043 0.250507 18.658 0.250041C18.8017 0.248792 18.9443 0.276183 19.0773 0.330617C19.2104 0.385051 19.3313 0.465437 19.4329 0.567084C19.5346 0.668732 19.6149 0.789606 19.6694 0.922652C19.7238 1.0557 19.7512 1.19825 19.75 1.342C19.7495 1.3956 19.7451 1.44896 19.7367 1.50165V5.67628C19.7367 5.9634 19.6227 6.23877 19.4196 6.44179C19.2166 6.64482 18.9412 6.75888 18.6541 6.75888C18.367 6.75888 18.0916 6.64482 17.8886 6.44179C17.6856 6.23877 17.5715 5.9634 17.5715 5.67628V3.95926Z"
                            }),
                            /*#__PURE__*/ (0, $cf73c70412c0bb28$exports.jsx)("path", {
                                d: "M2.41519 17.5848V2.4285H8.91076V0.263314H2.41194C1.22001 0.263314 0.25 1.23007 0.25 2.42201V17.5913C0.250574 18.1638 0.47834 18.7127 0.883283 19.1175C1.28823 19.5222 1.83724 19.7497 2.40978 19.75H17.5769C17.8608 19.7499 18.1418 19.6938 18.404 19.585C18.6662 19.4762 18.9044 19.3168 19.105 19.116C19.3055 18.9151 19.4646 18.6767 19.573 18.4143C19.6814 18.152 19.737 17.8708 19.7367 17.587V11.0893H17.5715V17.5848H2.41519Z"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}; // Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $edb9e3b208e8e155$var$Link = /*#__PURE__*/ (0, $dQwsT.forwardRef)($edb9e3b208e8e155$var$LinkWithoutRef);
var $edb9e3b208e8e155$export$2e2bcd8739ae039 = $edb9e3b208e8e155$var$Link;



var $bda1dd775425f725$exports = {};
$bda1dd775425f725$exports = JSON.parse("{}");



var $dEf6I = parcelRequire("dEf6I");

var $dQwsT = parcelRequire("dQwsT");

var $c48624597a52a983$var$DisplayName;
(function(DisplayName) {
    DisplayName["formatDate"] = "FormattedDate";
    DisplayName["formatTime"] = "FormattedTime";
    DisplayName["formatNumber"] = "FormattedNumber";
    DisplayName["formatList"] = "FormattedList";
    // Note that this DisplayName is the locale display name, not to be confused with
    // the name of the enum, which is for React component display name in dev tools.
    DisplayName["formatDisplayName"] = "FormattedDisplayName";
})($c48624597a52a983$var$DisplayName || ($c48624597a52a983$var$DisplayName = {}));
var $c48624597a52a983$var$DisplayNameParts;
(function(DisplayNameParts) {
    DisplayNameParts["formatDate"] = "FormattedDateParts";
    DisplayNameParts["formatTime"] = "FormattedTimeParts";
    DisplayNameParts["formatNumber"] = "FormattedNumberParts";
    DisplayNameParts["formatList"] = "FormattedListParts";
})($c48624597a52a983$var$DisplayNameParts || ($c48624597a52a983$var$DisplayNameParts = {}));
var $c48624597a52a983$export$54d4989ed3eea1ea = function(props) {
    var intl = (0, $a689ac47403fe3e1$export$2e2bcd8739ae039)();
    var value = props.value, children = props.children, formatProps = (0, $dEf6I.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatNumberToParts(value, formatProps));
};
$c48624597a52a983$export$54d4989ed3eea1ea.displayName = 'FormattedNumberParts';
var $c48624597a52a983$export$5ac259c7da6d2188 = function(props) {
    var intl = (0, $a689ac47403fe3e1$export$2e2bcd8739ae039)();
    var value = props.value, children = props.children, formatProps = (0, $dEf6I.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatListToParts(value, formatProps));
};
$c48624597a52a983$export$54d4989ed3eea1ea.displayName = 'FormattedNumberParts';
function $c48624597a52a983$export$7448277f6036d2ab(name) {
    var ComponentParts = function(props) {
        var intl = (0, $a689ac47403fe3e1$export$2e2bcd8739ae039)();
        var value = props.value, children = props.children, formatProps = (0, $dEf6I.__rest)(props, [
            "value",
            "children"
        ]);
        var date = typeof value === 'string' ? new Date(value || 0) : value;
        var formattedParts = name === 'formatDate' ? intl.formatDateToParts(date, formatProps) : intl.formatTimeToParts(date, formatProps);
        return children(formattedParts);
    };
    ComponentParts.displayName = $c48624597a52a983$var$DisplayNameParts[name];
    return ComponentParts;
}
function $c48624597a52a983$export$b37e14176d001dec(name) {
    var Component = function(props) {
        var intl = (0, $a689ac47403fe3e1$export$2e2bcd8739ae039)();
        var value = props.value, children = props.children, formatProps = (0, $dEf6I.__rest)(props, [
            "value",
            "children"
        ]);
        // TODO: fix TS type definition for localeMatcher upstream
        var formattedValue = intl[name](value, formatProps);
        if (typeof children === 'function') return children(formattedValue);
        var Text = intl.textComponent || $dQwsT.Fragment;
        return $dQwsT.createElement(Text, null, formattedValue);
    };
    Component.displayName = $c48624597a52a983$var$DisplayName[name];
    return Component;
}










function $393c912844fd6a4e$export$1adfeb024f5185b(msgs) {
    return msgs;
}
function $393c912844fd6a4e$export$747d244ee58120dd(msg) {
    return msg;
}
var $393c912844fd6a4e$export$40ae3194919d16b = (0, $c48624597a52a983$export$b37e14176d001dec)('formatDate');
var $393c912844fd6a4e$export$5b390a54f8a846f7 = (0, $c48624597a52a983$export$b37e14176d001dec)('formatTime');
var $393c912844fd6a4e$export$db80edc1e6b2f63d = (0, $c48624597a52a983$export$b37e14176d001dec)('formatNumber');
var $393c912844fd6a4e$export$f52b44e459e6e71d = (0, $c48624597a52a983$export$b37e14176d001dec)('formatList');
var $393c912844fd6a4e$export$c2336ea5aaab92fa = (0, $c48624597a52a983$export$b37e14176d001dec)('formatDisplayName');
var $393c912844fd6a4e$export$7fdc7d2c91ce149b = (0, $c48624597a52a983$export$7448277f6036d2ab)('formatDate');
var $393c912844fd6a4e$export$ec35873761676c2a = (0, $c48624597a52a983$export$7448277f6036d2ab)('formatTime');


const $dedcfc2f6a9befa5$export$a7357cdd1f0b0168 = (0, $393c912844fd6a4e$export$1adfeb024f5185b)({
    title: {
        id: "error-app.title",
        defaultMessage: "Something went wrong."
    },
    subTitle: {
        id: "error-app.sub-title",
        defaultMessage: "We\u2019re moving mountains to get it sorted."
    },
    detail: {
        id: "error-app.detail",
        defaultMessage: "View our {link} and subscribe for service updates."
    },
    linkName: {
        id: "error-app.link-name",
        defaultMessage: "status page"
    }
});


var $247e6edda61d6492$exports = {};
$247e6edda61d6492$exports = new URL("something-went-wrong.afc195d1.svg", import.meta.url).toString();


var $6c3ea85769e86bf0$exports = {};
$6c3ea85769e86bf0$exports = new URL("atlassianLogo.598181d7.svg", import.meta.url).toString();


const $e435e378975f2891$export$b5ed68f0a0a58a22 = ()=>{
    const DEFAULT_LOCALE = 'en-US';
    const locale = navigator.languages[0] || navigator.language || DEFAULT_LOCALE;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement((0, $0fa5d5e8583b67a0$export$2e2bcd8739ae039), {
        locale: locale,
        messages: (0, (/*@__PURE__*/$parcel$interopDefault($bda1dd775425f725$exports))),
        defaultLocale: "en-US"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement("div", {
        style: {
            padding: '19px',
            background: '#F4F5F7',
            margin: '0'
        }
    }, (0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('dst-a11y__replace-anchor-with-link__page-experienc') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement((0, $edb9e3b208e8e155$export$2e2bcd8739ae039), {
        href: "https://www.atlassian.com"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement("img", {
        alt: "Atlassian",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6c3ea85769e86bf0$exports))),
        style: {
            width: '145px',
            height: '18px'
        }
    })) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement("a", {
        href: "https://www.atlassian.com"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement("img", {
        alt: "Atlassian",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6c3ea85769e86bf0$exports))),
        style: {
            width: '145px',
            height: '18px'
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement("div", {
        style: {
            background: '#fff',
            padding: '60px 0',
            textAlign: 'center'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($247e6edda61d6492$exports))),
        alt: "",
        style: {
            marginLeft: -20,
            width: '380px',
            height: '246px'
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement("h1", {
        style: {
            color: '#253858',
            font: 'bold 36px Helvetica, Arial',
            marginTop: '50px',
            marginBottom: '24px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement((0, $cf944c5aa6db0974$export$2e2bcd8739ae039), (0, $dedcfc2f6a9befa5$export$a7357cdd1f0b0168).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement("h2", {
        style: {
            color: '#253858',
            font: 'bold 20px Helvetica, Arial',
            margin: '16px 0px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement((0, $cf944c5aa6db0974$export$2e2bcd8739ae039), (0, $dedcfc2f6a9befa5$export$a7357cdd1f0b0168).subTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement("p", {
        style: {
            color: '#42526E',
            font: 'normal 20px/28px Helvetica, Arial',
            margin: '20px 0'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement((0, $cf944c5aa6db0974$export$2e2bcd8739ae039), {
        ...(0, $dedcfc2f6a9befa5$export$a7357cdd1f0b0168).detail,
        values: {
            link: // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement("a", {
                target: "_blank",
                id: "statusPageHref",
                href: "https://status.atlassian.com",
                style: {
                    textDecoration: 'underline'
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement((0, $cf944c5aa6db0974$export$2e2bcd8739ae039), (0, $dedcfc2f6a9befa5$export$a7357cdd1f0b0168).linkName))
        }
    }))));
};



var $dQwsT = parcelRequire("dQwsT");



var $9pfwj = parcelRequire("9pfwj");

var $dQwsT = parcelRequire("dQwsT");
function $51499c5681cecc99$export$2e2bcd8739ae039(t, e) {
    return $51499c5681cecc99$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $51499c5681cecc99$export$2e2bcd8739ae039(t, e);
}


function $d7acb3e295736ade$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $51499c5681cecc99$export$2e2bcd8739ae039)(t, o);
}



var $dQwsT = parcelRequire("dQwsT");

function $bc67908a809e92e6$export$2e2bcd8739ae039() {
    return $bc67908a809e92e6$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $bc67908a809e92e6$export$2e2bcd8739ae039.apply(null, arguments);
}


function $847e6ae3d441f389$var$isAbsolute(pathname) {
    return pathname.charAt(0) === '/';
}
// About 1.5x faster than the two-arg version of Array#splice()
function $847e6ae3d441f389$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $847e6ae3d441f389$var$resolvePathname(to, from) {
    if (from === undefined) from = '';
    var toParts = to && to.split('/') || [];
    var fromParts = from && from.split('/') || [];
    var isToAbs = to && $847e6ae3d441f389$var$isAbsolute(to);
    var isFromAbs = from && $847e6ae3d441f389$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $847e6ae3d441f389$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return '/';
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === '.' || last === '..' || last === '';
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === '.') $847e6ae3d441f389$var$spliceOne(fromParts, i);
        else if (part === '..') {
            $847e6ae3d441f389$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $847e6ae3d441f389$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift('..');
    if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !$847e6ae3d441f389$var$isAbsolute(fromParts[0]))) fromParts.unshift('');
    var result = fromParts.join('/');
    if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
    return result;
}
var $847e6ae3d441f389$export$2e2bcd8739ae039 = $847e6ae3d441f389$var$resolvePathname;


function $3be3b26921a32038$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $3be3b26921a32038$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $3be3b26921a32038$var$valueEqual(item, b[index]);
    });
    if (typeof a === 'object' || typeof b === 'object') {
        var aValue = $3be3b26921a32038$var$valueOf(a);
        var bValue = $3be3b26921a32038$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $3be3b26921a32038$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $3be3b26921a32038$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $3be3b26921a32038$export$2e2bcd8739ae039 = $3be3b26921a32038$var$valueEqual;




function $1bedf0feab9c8550$var$addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
}
function $1bedf0feab9c8550$var$stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
}
function $1bedf0feab9c8550$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function $1bedf0feab9c8550$var$stripBasename(path, prefix) {
    return $1bedf0feab9c8550$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $1bedf0feab9c8550$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function $1bedf0feab9c8550$export$8ccf933b0513f8d0(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
}
function $1bedf0feab9c8550$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
    return path;
}
function $1bedf0feab9c8550$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === 'string') {
        // Two-arg form: push(path, state)
        location = $1bedf0feab9c8550$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $bc67908a809e92e6$export$2e2bcd8739ae039)({}, path);
        if (location.pathname === undefined) location.pathname = '';
        if (location.search) {
            if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
        } else location.search = '';
        if (location.hash) {
            if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
        } else location.hash = '';
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== '/') location.pathname = (0, $847e6ae3d441f389$export$2e2bcd8739ae039)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = '/';
    return location;
}
function $1bedf0feab9c8550$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $3be3b26921a32038$export$2e2bcd8739ae039)(a.state, b.state);
}
function $1bedf0feab9c8550$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
            if (typeof result === 'string') {
                if (typeof getUserConfirmation === 'function') getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $1bedf0feab9c8550$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $1bedf0feab9c8550$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $1bedf0feab9c8550$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
    return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $1bedf0feab9c8550$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $1bedf0feab9c8550$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $1bedf0feab9c8550$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}
var $1bedf0feab9c8550$var$PopStateEvent = 'popstate';
var $1bedf0feab9c8550$var$HashChangeEvent = 'hashchange';
function $1bedf0feab9c8550$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $1bedf0feab9c8550$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$1bedf0feab9c8550$var$canUseDOM && (0, $0eb8d075c37eacea$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canUseHistory = $1bedf0feab9c8550$var$supportsHistory();
    var needsHashChangeListener = !$1bedf0feab9c8550$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $1bedf0feab9c8550$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $1bedf0feab9c8550$var$stripTrailingSlash($1bedf0feab9c8550$var$addLeadingSlash(props.basename)) : '';
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $1bedf0feab9c8550$var$stripBasename(path, basename);
        return $1bedf0feab9c8550$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $1bedf0feab9c8550$var$createTransitionManager();
    function setState(nextState) {
        (0, $bc67908a809e92e6$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($1bedf0feab9c8550$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($1bedf0feab9c8550$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($1bedf0feab9c8550$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $1bedf0feab9c8550$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $1bedf0feab9c8550$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $1bedf0feab9c8550$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($1bedf0feab9c8550$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($1bedf0feab9c8550$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($1bedf0feab9c8550$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($1bedf0feab9c8550$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $1bedf0feab9c8550$var$HashChangeEvent$1 = 'hashchange';
var $1bedf0feab9c8550$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === '!' ? path : '!/' + $1bedf0feab9c8550$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === '!' ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $1bedf0feab9c8550$var$stripLeadingSlash,
        decodePath: $1bedf0feab9c8550$var$addLeadingSlash
    },
    slash: {
        encodePath: $1bedf0feab9c8550$var$addLeadingSlash,
        decodePath: $1bedf0feab9c8550$var$addLeadingSlash
    }
};
function $1bedf0feab9c8550$var$stripHash(url) {
    var hashIndex = url.indexOf('#');
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $1bedf0feab9c8550$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf('#');
    return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}
function $1bedf0feab9c8550$var$pushHashPath(path) {
    window.location.hash = path;
}
function $1bedf0feab9c8550$var$replaceHashPath(path) {
    window.location.replace($1bedf0feab9c8550$var$stripHash(window.location.href) + '#' + path);
}
function $1bedf0feab9c8550$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$1bedf0feab9c8550$var$canUseDOM && (0, $0eb8d075c37eacea$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $1bedf0feab9c8550$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $1bedf0feab9c8550$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
    var basename = props.basename ? $1bedf0feab9c8550$var$stripTrailingSlash($1bedf0feab9c8550$var$addLeadingSlash(props.basename)) : '';
    var _HashPathCoders$hashT = $1bedf0feab9c8550$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($1bedf0feab9c8550$var$getHashPath());
        if (basename) path = $1bedf0feab9c8550$var$stripBasename(path, basename);
        return $1bedf0feab9c8550$export$90c043f1c57770b8(path);
    }
    var transitionManager = $1bedf0feab9c8550$var$createTransitionManager();
    function setState(nextState) {
        (0, $bc67908a809e92e6$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $1bedf0feab9c8550$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $1bedf0feab9c8550$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $1bedf0feab9c8550$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($1bedf0feab9c8550$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($1bedf0feab9c8550$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $1bedf0feab9c8550$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $1bedf0feab9c8550$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $1bedf0feab9c8550$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector('base');
        var href = '';
        if (baseTag && baseTag.getAttribute('href')) href = $1bedf0feab9c8550$var$stripHash(window.location.href);
        return href + '#' + encodePath(basename + $1bedf0feab9c8550$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $1bedf0feab9c8550$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $1bedf0feab9c8550$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $1bedf0feab9c8550$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $1bedf0feab9c8550$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($1bedf0feab9c8550$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $1bedf0feab9c8550$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $1bedf0feab9c8550$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $1bedf0feab9c8550$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $1bedf0feab9c8550$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($1bedf0feab9c8550$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($1bedf0feab9c8550$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($1bedf0feab9c8550$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $1bedf0feab9c8550$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $1bedf0feab9c8550$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        '/'
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $1bedf0feab9c8550$var$createTransitionManager();
    function setState(nextState) {
        (0, $bc67908a809e92e6$export$2e2bcd8739ae039)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $1bedf0feab9c8550$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === 'string' ? $1bedf0feab9c8550$export$90c043f1c57770b8(entry, undefined, createKey()) : $1bedf0feab9c8550$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $1bedf0feab9c8550$export$fe53371bee54353d;
    function push(path, state) {
        var action = 'PUSH';
        var location = $1bedf0feab9c8550$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $1bedf0feab9c8550$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $1bedf0feab9c8550$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = 'POP';
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: 'POP',
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}





var $bfe00e9b290b9978$exports = {};
var $3c60cad13bfe9faf$exports = {};
$3c60cad13bfe9faf$exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == '[object Array]';
};


/**
 * Expose `pathToRegexp`.
 */ $bfe00e9b290b9978$exports = $bfe00e9b290b9978$var$pathToRegexp;
$bfe00e9b290b9978$exports.parse = $bfe00e9b290b9978$var$parse;
$bfe00e9b290b9978$exports.compile = $bfe00e9b290b9978$var$compile;
$bfe00e9b290b9978$exports.tokensToFunction = $bfe00e9b290b9978$var$tokensToFunction;
$bfe00e9b290b9978$exports.tokensToRegExp = $bfe00e9b290b9978$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $bfe00e9b290b9978$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    '(\\\\.)',
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $bfe00e9b290b9978$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = '';
    var defaultDelimiter = options && options.delimiter || '/';
    var res;
    while((res = $bfe00e9b290b9978$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = '';
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === '+' || modifier === '*';
        var optional = modifier === '?' || modifier === '*';
        var delimiter = prefix || defaultDelimiter;
        var pattern = capture || group;
        var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '');
        tokens.push({
            name: name || key++,
            prefix: prefix || '',
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $bfe00e9b290b9978$var$escapeGroup(pattern) : asterisk ? '.*' : $bfe00e9b290b9978$var$restrictBacktrack(delimiter, prevText)
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
function $bfe00e9b290b9978$var$restrictBacktrack(delimiter, prevText) {
    if (!prevText || prevText.indexOf(delimiter) > -1) return '[^' + $bfe00e9b290b9978$var$escapeString(delimiter) + ']+?';
    return $bfe00e9b290b9978$var$escapeString(prevText) + '|(?:(?!' + $bfe00e9b290b9978$var$escapeString(prevText) + ')[^' + $bfe00e9b290b9978$var$escapeString(delimiter) + '])+?';
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $bfe00e9b290b9978$var$compile(str, options) {
    return $bfe00e9b290b9978$var$tokensToFunction($bfe00e9b290b9978$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $bfe00e9b290b9978$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $bfe00e9b290b9978$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $bfe00e9b290b9978$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', $bfe00e9b290b9978$var$flags(options));
    return function(obj, opts) {
        var path = '';
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $bfe00e9b290b9978$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($3c60cad13bfe9faf$exports(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $bfe00e9b290b9978$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $bfe00e9b290b9978$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $bfe00e9b290b9978$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, '\\$1');
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $bfe00e9b290b9978$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $bfe00e9b290b9978$var$flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $bfe00e9b290b9978$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $bfe00e9b290b9978$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $bfe00e9b290b9978$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($bfe00e9b290b9978$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp('(?:' + parts.join('|') + ')', $bfe00e9b290b9978$var$flags(options));
    return $bfe00e9b290b9978$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $bfe00e9b290b9978$var$stringToRegexp(path, keys, options) {
    return $bfe00e9b290b9978$var$tokensToRegExp($bfe00e9b290b9978$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $bfe00e9b290b9978$var$tokensToRegExp(tokens, keys, options) {
    if (!$3c60cad13bfe9faf$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = '';
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === 'string') route += $bfe00e9b290b9978$var$escapeString(token);
        else {
            var prefix = $bfe00e9b290b9978$var$escapeString(token.prefix);
            var capture = '(?:' + token.pattern + ')';
            keys.push(token);
            if (token.repeat) capture += '(?:' + prefix + capture + ')*';
            if (token.optional) {
                if (!token.partial) capture = '(?:' + prefix + '(' + capture + '))?';
                else capture = prefix + '(' + capture + ')?';
            } else capture = prefix + '(' + capture + ')';
            route += capture;
        }
    }
    var delimiter = $bfe00e9b290b9978$var$escapeString(options.delimiter || '/');
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
    if (end) route += '$';
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
    return $bfe00e9b290b9978$var$attachKeys(new RegExp('^' + route, $bfe00e9b290b9978$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $bfe00e9b290b9978$var$pathToRegexp(path, keys, options) {
    if (!$3c60cad13bfe9faf$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $bfe00e9b290b9978$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($3c60cad13bfe9faf$exports(path)) return $bfe00e9b290b9978$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $bfe00e9b290b9978$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}


var $580b3d4a4d64a95d$exports = {};
'use strict';

$580b3d4a4d64a95d$exports = (parcelRequire("2wchC"));


function $cde7c38ff0269a2e$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}



var $26d486920449aa9d$var$MAX_SIGNED_31_BIT_INT = 1073741823;
var $26d486920449aa9d$var$commonjsGlobal = typeof globalThis !== "undefined" // 'global proper'
 ? globalThis : typeof window !== "undefined" ? window // Browser
 : typeof $parcel$global !== "undefined" ? $parcel$global // node.js
 : {};
function $26d486920449aa9d$var$getUniqueId() {
    var key = "__global_unique_id__";
    return $26d486920449aa9d$var$commonjsGlobal[key] = ($26d486920449aa9d$var$commonjsGlobal[key] || 0) + 1;
} // Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function $26d486920449aa9d$var$objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else // eslint-disable-next-line no-self-compare
    return x !== x && y !== y;
}
function $26d486920449aa9d$var$createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function $26d486920449aa9d$var$onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function $26d486920449aa9d$var$createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + $26d486920449aa9d$var$getUniqueId() + "__";
    var Provider = /*#__PURE__*/ function(_React$Component) {
        (0, $d7acb3e295736ade$export$2e2bcd8739ae039)(Provider, _React$Component);
        function Provider() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.emitter = $26d486920449aa9d$var$createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if ($26d486920449aa9d$var$objectIs(oldValue, newValue)) changedBits = 0; // No change
                else {
                    changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : $26d486920449aa9d$var$MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($bcac6686bd205804$exports))).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_React$Component2) {
        (0, $d7acb3e295736ade$export$2e2bcd8739ae039)(Consumer, _React$Component2);
        function Consumer() {
            var _this2;
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            _this2 = _React$Component2.call.apply(_React$Component2, [
                this
            ].concat(args)) || this;
            _this2.observedBits = void 0;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $26d486920449aa9d$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $26d486920449aa9d$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return $26d486920449aa9d$var$onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($bcac6686bd205804$exports))).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
// MIT License
var $26d486920449aa9d$var$createContext = (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createContext || $26d486920449aa9d$var$createReactContext;
// TODO: Replace with React.createContext once we can assume React 16+
var $26d486920449aa9d$var$createNamedContext = function createNamedContext(name) {
    var context = $26d486920449aa9d$var$createContext();
    context.displayName = name;
    return context;
};
var $26d486920449aa9d$export$c213558b66925821 = /*#__PURE__*/ $26d486920449aa9d$var$createNamedContext("Router-History");
var $26d486920449aa9d$export$63baa8ccbe60bb07 = /*#__PURE__*/ $26d486920449aa9d$var$createNamedContext("Router");
/**
 * The public API for putting history on context.
 */ var $26d486920449aa9d$export$55185c17a0fcbe46 = /*#__PURE__*/ function(_React$Component) {
    (0, $d7acb3e295736ade$export$2e2bcd8739ae039)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        this._isMounted = true;
        if (this.unlisten) // Any pre-mount location changes have been captured at
        // this point, so unregister the listener.
        this.unlisten();
        if (!this.props.staticContext) this.unlisten = this.props.history.listen(function(location) {
            if (_this2._isMounted) _this2.setState({
                location: location
            });
        });
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
            this._isMounted = false;
            this._pendingLocation = null;
        }
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement($26d486920449aa9d$export$63baa8ccbe60bb07.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement($26d486920449aa9d$export$c213558b66925821.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var $26d486920449aa9d$export$ae46f04cfaffe093 = /*#__PURE__*/ function(_React$Component) {
    (0, $d7acb3e295736ade$export$2e2bcd8739ae039)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $1bedf0feab9c8550$export$2b76ad033c6e6d08)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement($26d486920449aa9d$export$55185c17a0fcbe46, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).Component);
var $26d486920449aa9d$var$Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, $d7acb3e295736ade$export$2e2bcd8739ae039)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function $26d486920449aa9d$export$83716a4aa1642908(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement($26d486920449aa9d$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $0eb8d075c37eacea$export$2e2bcd8739ae039)(false);
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement($26d486920449aa9d$var$Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var $26d486920449aa9d$var$messageType;
var $26d486920449aa9d$var$cache = {};
var $26d486920449aa9d$var$cacheLimit = 10000;
var $26d486920449aa9d$var$cacheCount = 0;
function $26d486920449aa9d$var$compilePath(path) {
    if ($26d486920449aa9d$var$cache[path]) return $26d486920449aa9d$var$cache[path];
    var generator = (0, (/*@__PURE__*/$parcel$interopDefault($bfe00e9b290b9978$exports))).compile(path);
    if ($26d486920449aa9d$var$cacheCount < $26d486920449aa9d$var$cacheLimit) {
        $26d486920449aa9d$var$cache[path] = generator;
        $26d486920449aa9d$var$cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function $26d486920449aa9d$export$82476f982757e71e(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : $26d486920449aa9d$var$compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function $26d486920449aa9d$export$2d8d895a0a0f636e(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement($26d486920449aa9d$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $0eb8d075c37eacea$export$2e2bcd8739ae039)(false);
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, $1bedf0feab9c8550$export$90c043f1c57770b8)(computedMatch ? typeof to === "string" ? $26d486920449aa9d$export$82476f982757e71e(to, computedMatch.params) : (0, $bc67908a809e92e6$export$2e2bcd8739ae039)({}, to, {
            pathname: $26d486920449aa9d$export$82476f982757e71e(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement($26d486920449aa9d$var$Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, $1bedf0feab9c8550$export$90c043f1c57770b8)(prevProps.to);
                if (!(0, $1bedf0feab9c8550$export$c3e8bb440bd55b18)(prevLocation, (0, $bc67908a809e92e6$export$2e2bcd8739ae039)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
var $26d486920449aa9d$var$cache$1 = {};
var $26d486920449aa9d$var$cacheLimit$1 = 10000;
var $26d486920449aa9d$var$cacheCount$1 = 0;
function $26d486920449aa9d$var$compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = $26d486920449aa9d$var$cache$1[cacheKey] || ($26d486920449aa9d$var$cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, (/*@__PURE__*/$parcel$interopDefault($bfe00e9b290b9978$exports)))(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if ($26d486920449aa9d$var$cacheCount$1 < $26d486920449aa9d$var$cacheLimit$1) {
        pathCache[path] = result;
        $26d486920449aa9d$var$cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function $26d486920449aa9d$export$81336c211d5ff295(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = $26d486920449aa9d$var$compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function $26d486920449aa9d$var$isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).Children.count(children) === 0;
}
function $26d486920449aa9d$var$evalChildrenDev(children, props, path) {
    var value = children(props);
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var $26d486920449aa9d$export$e7b0ac011bb776c6 = /*#__PURE__*/ function(_React$Component) {
    (0, $d7acb3e295736ade$export$2e2bcd8739ae039)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement($26d486920449aa9d$export$63baa8ccbe60bb07.Consumer, null, function(context$1) {
            !context$1 && (0, $0eb8d075c37eacea$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? $26d486920449aa9d$export$81336c211d5ff295(location.pathname, _this.props) : context$1.match;
            var props = (0, $bc67908a809e92e6$export$2e2bcd8739ae039)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && $26d486920449aa9d$var$isEmptyChildren(children)) children = null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement($26d486920449aa9d$export$63baa8ccbe60bb07.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
        });
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).Component);
function $26d486920449aa9d$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $26d486920449aa9d$var$addBasename(basename, location) {
    if (!basename) return location;
    return (0, $bc67908a809e92e6$export$2e2bcd8739ae039)({}, location, {
        pathname: $26d486920449aa9d$var$addLeadingSlash(basename) + location.pathname
    });
}
function $26d486920449aa9d$var$stripBasename(basename, location) {
    if (!basename) return location;
    var base = $26d486920449aa9d$var$addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, $bc67908a809e92e6$export$2e2bcd8739ae039)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function $26d486920449aa9d$var$createURL(location) {
    return typeof location === "string" ? location : (0, $1bedf0feab9c8550$export$fe53371bee54353d)(location);
}
function $26d486920449aa9d$var$staticHandler(methodName) {
    return function() {
        (0, $0eb8d075c37eacea$export$2e2bcd8739ae039)(false);
    };
}
function $26d486920449aa9d$var$noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var $26d486920449aa9d$export$cac06da4d76d935b = /*#__PURE__*/ function(_React$Component) {
    (0, $d7acb3e295736ade$export$2e2bcd8739ae039)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return $26d486920449aa9d$var$noop;
        };
        _this.handleBlock = function() {
            return $26d486920449aa9d$var$noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = $26d486920449aa9d$var$addBasename(basename, (0, $1bedf0feab9c8550$export$90c043f1c57770b8)(location));
        context.url = $26d486920449aa9d$var$createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, $cde7c38ff0269a2e$export$2e2bcd8739ae039)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return $26d486920449aa9d$var$addLeadingSlash(basename + $26d486920449aa9d$var$createURL(path));
            },
            action: "POP",
            location: $26d486920449aa9d$var$stripBasename(basename, (0, $1bedf0feab9c8550$export$90c043f1c57770b8)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: $26d486920449aa9d$var$staticHandler("go"),
            goBack: $26d486920449aa9d$var$staticHandler("goBack"),
            goForward: $26d486920449aa9d$var$staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement($26d486920449aa9d$export$55185c17a0fcbe46, (0, $bc67908a809e92e6$export$2e2bcd8739ae039)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var $26d486920449aa9d$export$b5d5cf8927ab7262 = /*#__PURE__*/ function(_React$Component) {
    (0, $d7acb3e295736ade$export$2e2bcd8739ae039)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement($26d486920449aa9d$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $0eb8d075c37eacea$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).Children.forEach(_this.props.children, function(child) {
                if (match == null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? $26d486920449aa9d$export$81336c211d5ff295(location.pathname, (0, $bc67908a809e92e6$export$2e2bcd8739ae039)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).Component);
/**
 * A public higher-order component to access the imperative API
 */ function $26d486920449aa9d$export$369b6b2b30582e8e(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, $cde7c38ff0269a2e$export$2e2bcd8739ae039)(props, [
            "wrappedComponentRef"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement($26d486920449aa9d$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $0eb8d075c37eacea$export$2e2bcd8739ae039)(false);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement(Component, (0, $bc67908a809e92e6$export$2e2bcd8739ae039)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return (0, (/*@__PURE__*/$parcel$interopDefault($9a700870d8fe9f94$exports)))(C, Component);
}
var $26d486920449aa9d$var$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).useContext;
function $26d486920449aa9d$export$3420e1dc2c4a518c() {
    return $26d486920449aa9d$var$useContext($26d486920449aa9d$export$c213558b66925821);
}
function $26d486920449aa9d$export$45d76561a5302f2b() {
    return $26d486920449aa9d$var$useContext($26d486920449aa9d$export$63baa8ccbe60bb07).location;
}
function $26d486920449aa9d$export$99eaa27ddbbb95ef() {
    var match = $26d486920449aa9d$var$useContext($26d486920449aa9d$export$63baa8ccbe60bb07).match;
    return match ? match.params : {};
}
function $26d486920449aa9d$export$632be4bb944c1bc7(path) {
    var location = $26d486920449aa9d$export$45d76561a5302f2b();
    var match = $26d486920449aa9d$var$useContext($26d486920449aa9d$export$63baa8ccbe60bb07).match;
    return path ? $26d486920449aa9d$export$81336c211d5ff295(location.pathname, path) : match;
}
var $26d486920449aa9d$var$global$1, $26d486920449aa9d$var$key, $26d486920449aa9d$var$buildNames, $26d486920449aa9d$var$initialBuildName, $26d486920449aa9d$var$secondaryBuildName;


var $22a439cf29d896aa$exports = {};

var $drHoi = parcelRequire("drHoi");
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $22a439cf29d896aa$var$isEqual(value, other) {
    return $drHoi(value, other);
}
$22a439cf29d896aa$exports = $22a439cf29d896aa$var$isEqual;



var $dQwsT = parcelRequire("dQwsT");

var $7c281faca52954ed$export$2e2bcd8739ae039 = (0, $3b4511bc7338e41a$export$2e2bcd8739ae039);
function $7c281faca52954ed$export$11bcb6e9af2aca35() {
    return (0, $dQwsT.useContext)((0, $3b4511bc7338e41a$export$2e2bcd8739ae039));
}




var $9pfwj = parcelRequire("9pfwj");
var $d1eb3a273f38a09c$exports = {};
var $64f03a34f4d0ab67$exports = {};
var $dfa43ad867415f15$exports = {};

var $dCh9z = parcelRequire("dCh9z");

var $21GRl = parcelRequire("21GRl");
var $00edad240fe63642$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $00edad240fe63642$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$00edad240fe63642$exports = $00edad240fe63642$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $dfa43ad867415f15$var$baseMatches(source) {
    var matchData = $21GRl(source);
    if (matchData.length == 1 && matchData[0][2]) return $00edad240fe63642$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $dCh9z(object, source, matchData);
    };
}
$dfa43ad867415f15$exports = $dfa43ad867415f15$var$baseMatches;


var $3db061906c3e7a02$exports = {};

var $drHoi = parcelRequire("drHoi");
var $4f5b8961b6311e54$exports = {};
var $82970fa89f7ad560$exports = {};
var $4c7af6d47eeb9687$exports = {};

var $fbNtz = parcelRequire("fbNtz");
var $389b9a74d44555de$exports = {};

var $fbNtz = parcelRequire("fbNtz");
var $4063256310cd7bd5$exports = {};

var $kvoUC = parcelRequire("kvoUC");

var $eyoXy = parcelRequire("eyoXy");
/** `Object#toString` result references. */ var $4063256310cd7bd5$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $4063256310cd7bd5$var$isSymbol(value) {
    return typeof value == 'symbol' || $eyoXy(value) && $kvoUC(value) == $4063256310cd7bd5$var$symbolTag;
}
$4063256310cd7bd5$exports = $4063256310cd7bd5$var$isSymbol;


/** Used to match property names within property paths. */ var $389b9a74d44555de$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $389b9a74d44555de$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $389b9a74d44555de$var$isKey(value, object) {
    if ($fbNtz(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $4063256310cd7bd5$exports(value)) return true;
    return $389b9a74d44555de$var$reIsPlainProp.test(value) || !$389b9a74d44555de$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$389b9a74d44555de$exports = $389b9a74d44555de$var$isKey;


var $1217670d810ef936$exports = {};
var $08ddf9147a445af0$exports = {};
var $48adecb6943aa97b$exports = {};

var $eYj3i = parcelRequire("eYj3i");
/** Error message constants. */ var $48adecb6943aa97b$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $48adecb6943aa97b$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($48adecb6943aa97b$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($48adecb6943aa97b$var$memoize.Cache || $eYj3i);
    return memoized;
}
// Expose `MapCache`.
$48adecb6943aa97b$var$memoize.Cache = $eYj3i;
$48adecb6943aa97b$exports = $48adecb6943aa97b$var$memoize;


/** Used as the maximum memoize cache size. */ var $08ddf9147a445af0$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $08ddf9147a445af0$var$memoizeCapped(func) {
    var result = $48adecb6943aa97b$exports(func, function(key) {
        if (cache.size === $08ddf9147a445af0$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$08ddf9147a445af0$exports = $08ddf9147a445af0$var$memoizeCapped;


/** Used to match property names within property paths. */ var $1217670d810ef936$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $1217670d810ef936$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $1217670d810ef936$var$stringToPath = $08ddf9147a445af0$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($1217670d810ef936$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($1217670d810ef936$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
$1217670d810ef936$exports = $1217670d810ef936$var$stringToPath;


var $8b3d4a0aee483cb7$exports = {};
var $fd8d25d736253b6a$exports = {};

var $3N6ME = parcelRequire("3N6ME");
var $ddec6105b4e18cc5$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $ddec6105b4e18cc5$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$ddec6105b4e18cc5$exports = $ddec6105b4e18cc5$var$arrayMap;



var $fbNtz = parcelRequire("fbNtz");

/** Used as references for various `Number` constants. */ var $fd8d25d736253b6a$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $fd8d25d736253b6a$var$symbolProto = $3N6ME ? $3N6ME.prototype : undefined, $fd8d25d736253b6a$var$symbolToString = $fd8d25d736253b6a$var$symbolProto ? $fd8d25d736253b6a$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $fd8d25d736253b6a$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($fbNtz(value)) // Recursively convert values (susceptible to call stack limits).
    return $ddec6105b4e18cc5$exports(value, $fd8d25d736253b6a$var$baseToString) + '';
    if ($4063256310cd7bd5$exports(value)) return $fd8d25d736253b6a$var$symbolToString ? $fd8d25d736253b6a$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$fd8d25d736253b6a$var$INFINITY ? '-0' : result;
}
$fd8d25d736253b6a$exports = $fd8d25d736253b6a$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $8b3d4a0aee483cb7$var$toString(value) {
    return value == null ? '' : $fd8d25d736253b6a$exports(value);
}
$8b3d4a0aee483cb7$exports = $8b3d4a0aee483cb7$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $4c7af6d47eeb9687$var$castPath(value, object) {
    if ($fbNtz(value)) return value;
    return $389b9a74d44555de$exports(value, object) ? [
        value
    ] : $1217670d810ef936$exports($8b3d4a0aee483cb7$exports(value));
}
$4c7af6d47eeb9687$exports = $4c7af6d47eeb9687$var$castPath;


var $3ef010825e7ace55$exports = {};

/** Used as references for various `Number` constants. */ var $3ef010825e7ace55$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $3ef010825e7ace55$var$toKey(value) {
    if (typeof value == 'string' || $4063256310cd7bd5$exports(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$3ef010825e7ace55$var$INFINITY ? '-0' : result;
}
$3ef010825e7ace55$exports = $3ef010825e7ace55$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $82970fa89f7ad560$var$baseGet(object, path) {
    path = $4c7af6d47eeb9687$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$3ef010825e7ace55$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$82970fa89f7ad560$exports = $82970fa89f7ad560$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $4f5b8961b6311e54$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $82970fa89f7ad560$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$4f5b8961b6311e54$exports = $4f5b8961b6311e54$var$get;


var $7e488a85206047fc$exports = {};
var $80be534fe37219a4$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $80be534fe37219a4$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$80be534fe37219a4$exports = $80be534fe37219a4$var$baseHasIn;


var $0c40e2fe15331aa6$exports = {};


var $g325N = parcelRequire("g325N");

var $fbNtz = parcelRequire("fbNtz");

var $c5rP7 = parcelRequire("c5rP7");

var $2goBK = parcelRequire("2goBK");

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $0c40e2fe15331aa6$var$hasPath(object, path, hasFunc) {
    path = $4c7af6d47eeb9687$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $3ef010825e7ace55$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $2goBK(length) && $c5rP7(key, length) && ($fbNtz(object) || $g325N(object));
}
$0c40e2fe15331aa6$exports = $0c40e2fe15331aa6$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $7e488a85206047fc$var$hasIn(object, path) {
    return object != null && $0c40e2fe15331aa6$exports(object, path, $80be534fe37219a4$exports);
}
$7e488a85206047fc$exports = $7e488a85206047fc$var$hasIn;




var $2jRqb = parcelRequire("2jRqb");


/** Used to compose bitmasks for value comparisons. */ var $3db061906c3e7a02$var$COMPARE_PARTIAL_FLAG = 1, $3db061906c3e7a02$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $3db061906c3e7a02$var$baseMatchesProperty(path, srcValue) {
    if ($389b9a74d44555de$exports(path) && $2jRqb(srcValue)) return $00edad240fe63642$exports($3ef010825e7ace55$exports(path), srcValue);
    return function(object) {
        var objValue = $4f5b8961b6311e54$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $7e488a85206047fc$exports(object, path) : $drHoi(srcValue, objValue, $3db061906c3e7a02$var$COMPARE_PARTIAL_FLAG | $3db061906c3e7a02$var$COMPARE_UNORDERED_FLAG);
    };
}
$3db061906c3e7a02$exports = $3db061906c3e7a02$var$baseMatchesProperty;


var $bf6ed353044ea5ae$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $bf6ed353044ea5ae$var$identity(value) {
    return value;
}
$bf6ed353044ea5ae$exports = $bf6ed353044ea5ae$var$identity;



var $fbNtz = parcelRequire("fbNtz");
var $79521b3ee3143a71$exports = {};
var $478e318b1df57c34$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $478e318b1df57c34$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$478e318b1df57c34$exports = $478e318b1df57c34$var$baseProperty;


var $1203e8596d9f1f41$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $1203e8596d9f1f41$var$basePropertyDeep(path) {
    return function(object) {
        return $82970fa89f7ad560$exports(object, path);
    };
}
$1203e8596d9f1f41$exports = $1203e8596d9f1f41$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $79521b3ee3143a71$var$property(path) {
    return $389b9a74d44555de$exports(path) ? $478e318b1df57c34$exports($3ef010825e7ace55$exports(path)) : $1203e8596d9f1f41$exports(path);
}
$79521b3ee3143a71$exports = $79521b3ee3143a71$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $64f03a34f4d0ab67$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $bf6ed353044ea5ae$exports;
    if (typeof value == 'object') return $fbNtz(value) ? $3db061906c3e7a02$exports(value[0], value[1]) : $dfa43ad867415f15$exports(value);
    return $79521b3ee3143a71$exports(value);
}
$64f03a34f4d0ab67$exports = $64f03a34f4d0ab67$var$baseIteratee;


var $67c59ff2d443521b$exports = {};
/** Error message constants. */ var $67c59ff2d443521b$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that negates the result of the predicate `func`. The
 * `func` predicate is invoked with the `this` binding and arguments of the
 * created function.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} predicate The predicate to negate.
 * @returns {Function} Returns the new negated function.
 * @example
 *
 * function isEven(n) {
 *   return n % 2 == 0;
 * }
 *
 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
 * // => [1, 3, 5]
 */ function $67c59ff2d443521b$var$negate(predicate) {
    if (typeof predicate != 'function') throw new TypeError($67c59ff2d443521b$var$FUNC_ERROR_TEXT);
    return function() {
        var args = arguments;
        switch(args.length){
            case 0:
                return !predicate.call(this);
            case 1:
                return !predicate.call(this, args[0]);
            case 2:
                return !predicate.call(this, args[0], args[1]);
            case 3:
                return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
    };
}
$67c59ff2d443521b$exports = $67c59ff2d443521b$var$negate;


var $29dd67a103817144$exports = {};


var $e7f52d01691503db$exports = {};

var $3268e40a6fd91c9c$exports = {};
var $0d24fc8202d610fb$exports = {};
var $2a0e852067a065f7$exports = {};
var $0777fa9efe1be3a4$exports = {};

var $5SDfn = parcelRequire("5SDfn");
var $0777fa9efe1be3a4$var$defineProperty = function() {
    try {
        var func = $5SDfn(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
$0777fa9efe1be3a4$exports = $0777fa9efe1be3a4$var$defineProperty;


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $2a0e852067a065f7$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $0777fa9efe1be3a4$exports) $0777fa9efe1be3a4$exports(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
$2a0e852067a065f7$exports = $2a0e852067a065f7$var$baseAssignValue;



var $7je7Y = parcelRequire("7je7Y");
/** Used for built-in method references. */ var $0d24fc8202d610fb$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0d24fc8202d610fb$var$hasOwnProperty = $0d24fc8202d610fb$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $0d24fc8202d610fb$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($0d24fc8202d610fb$var$hasOwnProperty.call(object, key) && $7je7Y(objValue, value)) || value === undefined && !(key in object)) $2a0e852067a065f7$exports(object, key, value);
}
$0d24fc8202d610fb$exports = $0d24fc8202d610fb$var$assignValue;




var $c5rP7 = parcelRequire("c5rP7");

var $26Qmy = parcelRequire("26Qmy");

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $3268e40a6fd91c9c$var$baseSet(object, path, value, customizer) {
    if (!$26Qmy(object)) return object;
    path = $4c7af6d47eeb9687$exports(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = $3ef010825e7ace55$exports(path[index]), newValue = value;
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = $26Qmy(objValue) ? objValue : $c5rP7(path[index + 1]) ? [] : {};
        }
        $0d24fc8202d610fb$exports(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
$3268e40a6fd91c9c$exports = $3268e40a6fd91c9c$var$baseSet;



/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function $e7f52d01691503db$var$basePickBy(object, paths, predicate) {
    var index = -1, length = paths.length, result = {};
    while(++index < length){
        var path = paths[index], value = $82970fa89f7ad560$exports(object, path);
        if (predicate(value, path)) $3268e40a6fd91c9c$exports(result, $4c7af6d47eeb9687$exports(path, object), value);
    }
    return result;
}
$e7f52d01691503db$exports = $e7f52d01691503db$var$basePickBy;


var $3ea15658da5695b0$exports = {};

var $gmZWg = parcelRequire("gmZWg");
var $c9716c866ac6e533$exports = {};

var $9wjbG = parcelRequire("9wjbG");
var $f7fe2366ba78703d$exports = {};

var $1wrPY = parcelRequire("1wrPY");
/** Built-in value references. */ var $f7fe2366ba78703d$var$getPrototype = $1wrPY(Object.getPrototypeOf, Object);
$f7fe2366ba78703d$exports = $f7fe2366ba78703d$var$getPrototype;



var $32BHM = parcelRequire("32BHM");

var $4Gdri = parcelRequire("4Gdri");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $c9716c866ac6e533$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $c9716c866ac6e533$var$getSymbolsIn = !$c9716c866ac6e533$var$nativeGetSymbols ? $4Gdri : function(object) {
    var result = [];
    while(object){
        $9wjbG(result, $32BHM(object));
        object = $f7fe2366ba78703d$exports(object);
    }
    return result;
};
$c9716c866ac6e533$exports = $c9716c866ac6e533$var$getSymbolsIn;


var $adfe5adb75b1d345$exports = {};

var $2h6kh = parcelRequire("2h6kh");
var $5a0c461ea150cee7$exports = {};

var $26Qmy = parcelRequire("26Qmy");

var $lL06J = parcelRequire("lL06J");
var $fe929e8073850c99$exports = {};
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $fe929e8073850c99$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
$fe929e8073850c99$exports = $fe929e8073850c99$var$nativeKeysIn;


/** Used for built-in method references. */ var $5a0c461ea150cee7$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $5a0c461ea150cee7$var$hasOwnProperty = $5a0c461ea150cee7$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $5a0c461ea150cee7$var$baseKeysIn(object) {
    if (!$26Qmy(object)) return $fe929e8073850c99$exports(object);
    var isProto = $lL06J(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$5a0c461ea150cee7$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
$5a0c461ea150cee7$exports = $5a0c461ea150cee7$var$baseKeysIn;



var $2xBvu = parcelRequire("2xBvu");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $adfe5adb75b1d345$var$keysIn(object) {
    return $2xBvu(object) ? $2h6kh(object, true) : $5a0c461ea150cee7$exports(object);
}
$adfe5adb75b1d345$exports = $adfe5adb75b1d345$var$keysIn;


/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $3ea15658da5695b0$var$getAllKeysIn(object) {
    return $gmZWg(object, $adfe5adb75b1d345$exports, $c9716c866ac6e533$exports);
}
$3ea15658da5695b0$exports = $3ea15658da5695b0$var$getAllKeysIn;


/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */ function $29dd67a103817144$var$pickBy(object, predicate) {
    if (object == null) return {};
    var props = $ddec6105b4e18cc5$exports($3ea15658da5695b0$exports(object), function(prop) {
        return [
            prop
        ];
    });
    predicate = $64f03a34f4d0ab67$exports(predicate);
    return $e7f52d01691503db$exports(object, props, function(value, path) {
        return predicate(value, path[0]);
    });
}
$29dd67a103817144$exports = $29dd67a103817144$var$pickBy;


/**
 * The opposite of `_.pickBy`; this method creates an object composed of
 * the own and inherited enumerable string keyed properties of `object` that
 * `predicate` doesn't return truthy for. The predicate is invoked with two
 * arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omitBy(object, _.isNumber);
 * // => { 'b': '2' }
 */ function $d1eb3a273f38a09c$var$omitBy(object, predicate) {
    return $29dd67a103817144$exports(object, $67c59ff2d443521b$exports($64f03a34f4d0ab67$exports(predicate)));
}
$d1eb3a273f38a09c$exports = $d1eb3a273f38a09c$var$omitBy;


var $a8508b37e9152005$exports = {};
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */ function $a8508b37e9152005$var$isNil(value) {
    return value == null;
}
$a8508b37e9152005$exports = $a8508b37e9152005$var$isNil;


const $a1f0c4d0ab868c5f$export$8c6bf2df244e6a99 = '/wiki';
const $a1f0c4d0ab868c5f$var$SPACE_ROOT = 'spaces';
const $a1f0c4d0ab868c5f$export$ad28e141050c1e34 = (title)=>{
    if (!title) return;
    const slug = title// replace groups of reservered chars with a space
    // From https://www.ietf.org/rfc/rfc3986.txt
    // unreserved  = ALPHA / DIGIT / "-" / "." / "_" / "~"
    .replaceAll(/[^A-Za-z0-9\-._~]+/g, ' ')// trim the edges
    .trim()// replace spaces with '+'
    .replaceAll(' ', '+');
    // guard against relative url attacks
    if (slug === '.' || slug === '..') return undefined;
    return slug || undefined;
};
const $a1f0c4d0ab868c5f$export$cbc5b385481fb319 = (href, query)=>{
    const parsedUrl = {
        ...(0, $9pfwj.parse)(href, true),
        search: undefined
    };
    parsedUrl.query = {
        ...parsedUrl.query,
        ...query
    };
    parsedUrl.query = (0, (/*@__PURE__*/$parcel$interopDefault($d1eb3a273f38a09c$exports)))(parsedUrl.query, (0, (/*@__PURE__*/$parcel$interopDefault($a8508b37e9152005$exports))));
    return (0, $9pfwj.format)(parsedUrl);
};
const $a1f0c4d0ab868c5f$export$8189558ac52562eb = (params, href)=>{
    const parsedUrl = {
        ...(0, $9pfwj.parse)(href, true),
        search: undefined
    };
    params.forEach((paramName)=>delete parsedUrl.query[paramName]);
    return (0, $9pfwj.format)(parsedUrl);
};
const $a1f0c4d0ab868c5f$var$removeAllAnchorsFromUrl = (href)=>{
    return href.split('#')[0];
};
const $a1f0c4d0ab868c5f$var$removeAllQueryParamsFromUrl = (href)=>{
    return href.split('?')[0];
};
const $a1f0c4d0ab868c5f$export$64f436133a65fc62 = (href)=>{
    return $a1f0c4d0ab868c5f$var$removeAllAnchorsFromUrl($a1f0c4d0ab868c5f$var$removeAllQueryParamsFromUrl(href));
};
const $a1f0c4d0ab868c5f$export$cefcfecf0835bcd9 = (spaceKey, path = '')=>{
    spaceKey = encodeURIComponent(spaceKey);
    let spacePath = (typeof path === 'string' ? path : path.pathname) || '';
    if (spacePath.startsWith($a1f0c4d0ab868c5f$export$8c6bf2df244e6a99)) spacePath = spacePath.substring($a1f0c4d0ab868c5f$export$8c6bf2df244e6a99.length);
    if (spacePath.startsWith('/')) spacePath = spacePath.substring(1);
    const link = `${$a1f0c4d0ab868c5f$export$8c6bf2df244e6a99}/${$a1f0c4d0ab868c5f$var$SPACE_ROOT}/${spaceKey}${spacePath ? `/${spacePath}` : ''}`;
    if (typeof path === 'string') return link;
    return {
        ...path,
        pathname: link
    };
};
const $a1f0c4d0ab868c5f$var$getBlogRoute = (spaceKey)=>$a1f0c4d0ab868c5f$export$cefcfecf0835bcd9(spaceKey, 'blog');
const $a1f0c4d0ab868c5f$var$getPagesRoute = (spaceKey)=>$a1f0c4d0ab868c5f$export$cefcfecf0835bcd9(spaceKey, 'pages');
const $a1f0c4d0ab868c5f$export$6b45500787cf696 = (spaceKey, id, contentType, createdDate, slug)=>{
    const trailingSlug = slug ? `/${slug}` : '';
    switch(contentType){
        case 'blogpost':
            if (!createdDate) // When use_graphql_to_publish_pages_and_blogs is enabled, createDate does not exist
            return `${$a1f0c4d0ab868c5f$var$getBlogRoute(spaceKey)}/${id}${trailingSlug}`;
            else {
                const [yy, mm, dd] = createdDate.slice(0, 10).split('-');
                return `${$a1f0c4d0ab868c5f$var$getBlogRoute(spaceKey)}/${yy}/${mm}/${dd}/${id}${trailingSlug}`;
            }
        case 'page':
            return `${$a1f0c4d0ab868c5f$var$getPagesRoute(spaceKey)}/${id}${trailingSlug}`;
        default:
            throw new Error(`Expected content type 'blogpost' or 'page', but received '${contentType}'`);
    }
};
const $a1f0c4d0ab868c5f$export$257d483fa4a3254f = /^(http(s)?:)?\/\//;
const $a1f0c4d0ab868c5f$export$bfc29523388820d7 = (url, isContextAware)=>isContextAware && url.toString().indexOf($a1f0c4d0ab868c5f$export$8c6bf2df244e6a99) !== 0 ? $a1f0c4d0ab868c5f$export$8c6bf2df244e6a99 : '';
const $a1f0c4d0ab868c5f$export$6a80a340d4e68de1 = (url, isContextAware)=>{
    if ($a1f0c4d0ab868c5f$export$257d483fa4a3254f.test(url)) return url;
    else return `${$a1f0c4d0ab868c5f$export$bfc29523388820d7(url, isContextAware)}${url}`;
};
const $a1f0c4d0ab868c5f$export$feb8df2d5227ff6c = (urn)=>urn.charAt(0) === '#';



var $9pfwj = parcelRequire("9pfwj");

function $45cec8fdf0833adb$export$b5d8fba258cc9e89(pattern, url) {
    const parsed = (0, $9pfwj.parse)(url, true);
    const pathname = parsed.pathname || '';
    let match = (0, $26d486920449aa9d$export$81336c211d5ff295)(pathname, {
        path: pattern,
        exact: true
    });
    // some of our routes need query params to match
    if (!match) match = (0, $26d486920449aa9d$export$81336c211d5ff295)(`${pathname}${parsed.search}`, {
        path: pattern,
        exact: true
    });
    if (!match) return null;
    // URI decode params
    const decodedParams = {};
    if (match.params) for (const [key, value] of Object.entries(match.params)){
        let decodedValue = value;
        if (typeof value !== 'undefined') {
            try {
                // decodeURIComponent("%") throws "URI malformed" error
                decodedValue = decodeURIComponent(value);
            } catch (e) {}
            decodedParams[key] = decodedValue;
        }
    }
    return {
        url: url,
        pathname: pathname,
        search: parsed.search || '',
        hash: parsed.hash || '',
        pattern: pattern,
        params: decodedParams,
        query: parsed.query || ''
    };
}



var $9pfwj = parcelRequire("9pfwj");
/**
 * Tokenize input string.
 */ function $0a74c1009df8d3b3$var$lexer(str) {
    var tokens = [];
    var i = 0;
    while(i < str.length){
        var char = str[i];
        if (char === "*" || char === "+" || char === "?") {
            tokens.push({
                type: "MODIFIER",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "\\") {
            tokens.push({
                type: "ESCAPED_CHAR",
                index: i++,
                value: str[i++]
            });
            continue;
        }
        if (char === "{") {
            tokens.push({
                type: "OPEN",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "}") {
            tokens.push({
                type: "CLOSE",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === ":") {
            var name = "";
            var j = i + 1;
            while(j < str.length){
                var code = str.charCodeAt(j);
                if (// `0-9`
                code >= 48 && code <= 57 || // `A-Z`
                code >= 65 && code <= 90 || // `a-z`
                code >= 97 && code <= 122 || // `_`
                code === 95) {
                    name += str[j++];
                    continue;
                }
                break;
            }
            if (!name) throw new TypeError("Missing parameter name at ".concat(i));
            tokens.push({
                type: "NAME",
                index: i,
                value: name
            });
            i = j;
            continue;
        }
        if (char === "(") {
            var count = 1;
            var pattern = "";
            var j = i + 1;
            if (str[j] === "?") throw new TypeError("Pattern cannot start with \"?\" at ".concat(j));
            while(j < str.length){
                if (str[j] === "\\") {
                    pattern += str[j++] + str[j++];
                    continue;
                }
                if (str[j] === ")") {
                    count--;
                    if (count === 0) {
                        j++;
                        break;
                    }
                } else if (str[j] === "(") {
                    count++;
                    if (str[j + 1] !== "?") throw new TypeError("Capturing groups are not allowed at ".concat(j));
                }
                pattern += str[j++];
            }
            if (count) throw new TypeError("Unbalanced pattern at ".concat(i));
            if (!pattern) throw new TypeError("Missing pattern at ".concat(i));
            tokens.push({
                type: "PATTERN",
                index: i,
                value: pattern
            });
            i = j;
            continue;
        }
        tokens.push({
            type: "CHAR",
            index: i,
            value: str[i++]
        });
    }
    tokens.push({
        type: "END",
        index: i,
        value: ""
    });
    return tokens;
}
function $0a74c1009df8d3b3$export$98e6a39c04603d36(str, options) {
    if (options === void 0) options = {};
    var tokens = $0a74c1009df8d3b3$var$lexer(str);
    var _a = options.prefixes, prefixes = _a === void 0 ? "./" : _a, _b = options.delimiter, delimiter = _b === void 0 ? "/#?" : _b;
    var result = [];
    var key = 0;
    var i = 0;
    var path = "";
    var tryConsume = function(type) {
        if (i < tokens.length && tokens[i].type === type) return tokens[i++].value;
    };
    var mustConsume = function(type) {
        var value = tryConsume(type);
        if (value !== undefined) return value;
        var _a = tokens[i], nextType = _a.type, index = _a.index;
        throw new TypeError("Unexpected ".concat(nextType, " at ").concat(index, ", expected ").concat(type));
    };
    var consumeText = function() {
        var result = "";
        var value;
        while(value = tryConsume("CHAR") || tryConsume("ESCAPED_CHAR"))result += value;
        return result;
    };
    var isSafe = function(value) {
        for(var _i = 0, delimiter_1 = delimiter; _i < delimiter_1.length; _i++){
            var char = delimiter_1[_i];
            if (value.indexOf(char) > -1) return true;
        }
        return false;
    };
    var safePattern = function(prefix) {
        var prev = result[result.length - 1];
        var prevText = prefix || (prev && typeof prev === "string" ? prev : "");
        if (prev && !prevText) throw new TypeError("Must have text between two parameters, missing text after \"".concat(prev.name, "\""));
        if (!prevText || isSafe(prevText)) return "[^".concat($0a74c1009df8d3b3$var$escapeString(delimiter), "]+?");
        return "(?:(?!".concat($0a74c1009df8d3b3$var$escapeString(prevText), ")[^").concat($0a74c1009df8d3b3$var$escapeString(delimiter), "])+?");
    };
    while(i < tokens.length){
        var char = tryConsume("CHAR");
        var name = tryConsume("NAME");
        var pattern = tryConsume("PATTERN");
        if (name || pattern) {
            var prefix = char || "";
            if (prefixes.indexOf(prefix) === -1) {
                path += prefix;
                prefix = "";
            }
            if (path) {
                result.push(path);
                path = "";
            }
            result.push({
                name: name || key++,
                prefix: prefix,
                suffix: "",
                pattern: pattern || safePattern(prefix),
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        var value = char || tryConsume("ESCAPED_CHAR");
        if (value) {
            path += value;
            continue;
        }
        if (path) {
            result.push(path);
            path = "";
        }
        var open = tryConsume("OPEN");
        if (open) {
            var prefix = consumeText();
            var name_1 = tryConsume("NAME") || "";
            var pattern_1 = tryConsume("PATTERN") || "";
            var suffix = consumeText();
            mustConsume("CLOSE");
            result.push({
                name: name_1 || (pattern_1 ? key++ : ""),
                pattern: name_1 && !pattern_1 ? safePattern(prefix) : pattern_1,
                prefix: prefix,
                suffix: suffix,
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        mustConsume("END");
    }
    return result;
}
function $0a74c1009df8d3b3$export$ef7acd7185315e22(str, options) {
    return $0a74c1009df8d3b3$export$5b9bad9e403cf3d9($0a74c1009df8d3b3$export$98e6a39c04603d36(str, options), options);
}
function $0a74c1009df8d3b3$export$5b9bad9e403cf3d9(tokens, options) {
    if (options === void 0) options = {};
    var reFlags = $0a74c1009df8d3b3$var$flags(options);
    var _a = options.encode, encode = _a === void 0 ? function(x) {
        return x;
    } : _a, _b = options.validate, validate = _b === void 0 ? true : _b;
    // Compile all the tokens into regexps.
    var matches = tokens.map(function(token) {
        if (typeof token === "object") return new RegExp("^(?:".concat(token.pattern, ")$"), reFlags);
    });
    return function(data) {
        var path = "";
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data ? data[token.name] : undefined;
            var optional = token.modifier === "?" || token.modifier === "*";
            var repeat = token.modifier === "*" || token.modifier === "+";
            if (Array.isArray(value)) {
                if (!repeat) throw new TypeError("Expected \"".concat(token.name, "\" to not repeat, but got an array"));
                if (value.length === 0) {
                    if (optional) continue;
                    throw new TypeError("Expected \"".concat(token.name, "\" to not be empty"));
                }
                for(var j = 0; j < value.length; j++){
                    var segment = encode(value[j], token);
                    if (validate && !matches[i].test(segment)) throw new TypeError("Expected all \"".concat(token.name, "\" to match \"").concat(token.pattern, "\", but got \"").concat(segment, "\""));
                    path += token.prefix + segment + token.suffix;
                }
                continue;
            }
            if (typeof value === "string" || typeof value === "number") {
                var segment = encode(String(value), token);
                if (validate && !matches[i].test(segment)) throw new TypeError("Expected \"".concat(token.name, "\" to match \"").concat(token.pattern, "\", but got \"").concat(segment, "\""));
                path += token.prefix + segment + token.suffix;
                continue;
            }
            if (optional) continue;
            var typeOfMessage = repeat ? "an array" : "a string";
            throw new TypeError("Expected \"".concat(token.name, "\" to be ").concat(typeOfMessage));
        }
        return path;
    };
}
function $0a74c1009df8d3b3$export$4659b591c19bdf3d(str, options) {
    var keys = [];
    var re = $0a74c1009df8d3b3$export$71304158c7e35877(str, keys, options);
    return $0a74c1009df8d3b3$export$968e97c88708237a(re, keys, options);
}
function $0a74c1009df8d3b3$export$968e97c88708237a(re, keys, options) {
    if (options === void 0) options = {};
    var _a = options.decode, decode = _a === void 0 ? function(x) {
        return x;
    } : _a;
    return function(pathname) {
        var m = re.exec(pathname);
        if (!m) return false;
        var path = m[0], index = m.index;
        var params = Object.create(null);
        var _loop_1 = function(i) {
            if (m[i] === undefined) return "continue";
            var key = keys[i - 1];
            if (key.modifier === "*" || key.modifier === "+") params[key.name] = m[i].split(key.prefix + key.suffix).map(function(value) {
                return decode(value, key);
            });
            else params[key.name] = decode(m[i], key);
        };
        for(var i = 1; i < m.length; i++)_loop_1(i);
        return {
            path: path,
            index: index,
            params: params
        };
    };
}
/**
 * Escape a regular expression string.
 */ function $0a74c1009df8d3b3$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
}
/**
 * Get the flags for a regexp from the options.
 */ function $0a74c1009df8d3b3$var$flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 */ function $0a74c1009df8d3b3$var$regexpToRegexp(path, keys) {
    if (!keys) return path;
    var groupsRegex = /\((?:\?<(.*?)>)?(?!\?)/g;
    var index = 0;
    var execResult = groupsRegex.exec(path.source);
    while(execResult){
        keys.push({
            // Use parenthesized substring match if available, index otherwise
            name: execResult[1] || index++,
            prefix: "",
            suffix: "",
            modifier: "",
            pattern: ""
        });
        execResult = groupsRegex.exec(path.source);
    }
    return path;
}
/**
 * Transform an array into a regexp.
 */ function $0a74c1009df8d3b3$var$arrayToRegexp(paths, keys, options) {
    var parts = paths.map(function(path) {
        return $0a74c1009df8d3b3$export$71304158c7e35877(path, keys, options).source;
    });
    return new RegExp("(?:".concat(parts.join("|"), ")"), $0a74c1009df8d3b3$var$flags(options));
}
/**
 * Create a path regexp from string input.
 */ function $0a74c1009df8d3b3$var$stringToRegexp(path, keys, options) {
    return $0a74c1009df8d3b3$export$9a9303716def6456($0a74c1009df8d3b3$export$98e6a39c04603d36(path, options), keys, options);
}
function $0a74c1009df8d3b3$export$9a9303716def6456(tokens, keys, options) {
    if (options === void 0) options = {};
    var _a = options.strict, strict = _a === void 0 ? false : _a, _b = options.start, start = _b === void 0 ? true : _b, _c = options.end, end = _c === void 0 ? true : _c, _d = options.encode, encode = _d === void 0 ? function(x) {
        return x;
    } : _d, _e = options.delimiter, delimiter = _e === void 0 ? "/#?" : _e, _f = options.endsWith, endsWith = _f === void 0 ? "" : _f;
    var endsWithRe = "[".concat($0a74c1009df8d3b3$var$escapeString(endsWith), "]|$");
    var delimiterRe = "[".concat($0a74c1009df8d3b3$var$escapeString(delimiter), "]");
    var route = start ? "^" : "";
    // Iterate over the tokens and create our regexp string.
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        if (typeof token === "string") route += $0a74c1009df8d3b3$var$escapeString(encode(token));
        else {
            var prefix = $0a74c1009df8d3b3$var$escapeString(encode(token.prefix));
            var suffix = $0a74c1009df8d3b3$var$escapeString(encode(token.suffix));
            if (token.pattern) {
                if (keys) keys.push(token);
                if (prefix || suffix) {
                    if (token.modifier === "+" || token.modifier === "*") {
                        var mod = token.modifier === "*" ? "?" : "";
                        route += "(?:".concat(prefix, "((?:").concat(token.pattern, ")(?:").concat(suffix).concat(prefix, "(?:").concat(token.pattern, "))*)").concat(suffix, ")").concat(mod);
                    } else route += "(?:".concat(prefix, "(").concat(token.pattern, ")").concat(suffix, ")").concat(token.modifier);
                } else {
                    if (token.modifier === "+" || token.modifier === "*") throw new TypeError("Can not repeat \"".concat(token.name, "\" without a prefix and suffix"));
                    route += "(".concat(token.pattern, ")").concat(token.modifier);
                }
            } else route += "(?:".concat(prefix).concat(suffix, ")").concat(token.modifier);
        }
    }
    if (end) {
        if (!strict) route += "".concat(delimiterRe, "?");
        route += !options.endsWith ? "$" : "(?=".concat(endsWithRe, ")");
    } else {
        var endToken = tokens[tokens.length - 1];
        var isEndDelimited = typeof endToken === "string" ? delimiterRe.indexOf(endToken[endToken.length - 1]) > -1 : endToken === undefined;
        if (!strict) route += "(?:".concat(delimiterRe, "(?=").concat(endsWithRe, "))?");
        if (!isEndDelimited) route += "(?=".concat(delimiterRe, "|").concat(endsWithRe, ")");
    }
    return new RegExp(route, $0a74c1009df8d3b3$var$flags(options));
}
function $0a74c1009df8d3b3$export$71304158c7e35877(path, keys, options) {
    if (path instanceof RegExp) return $0a74c1009df8d3b3$var$regexpToRegexp(path, keys);
    if (Array.isArray(path)) return $0a74c1009df8d3b3$var$arrayToRegexp(path, keys, options);
    return $0a74c1009df8d3b3$var$stringToRegexp(path, keys, options);
}


const $48a0bef41abd109a$export$1758be3e5622c165 = (pattern, params = {}, options = {})=>{
    const toPath = (0, $0a74c1009df8d3b3$export$ef7acd7185315e22)(pattern, {
        encode: decodeURIComponent
    });
    const path = toPath(params);
    const parsed = (0, $9pfwj.parse)(path, true);
    return (0, $9pfwj.format)({
        pathname: parsed.pathname,
        query: {
            ...parsed.query,
            ...options.query || {}
        },
        hash: options.hash
    });
};


class $08784ba8c1603e4f$export$e7b0ac011bb776c6 {
    static matchFirst(routes, url) {
        for (const route of routes){
            if (!(route instanceof $08784ba8c1603e4f$export$e7b0ac011bb776c6)) continue;
            const matchResult = route.match(url);
            if (matchResult) return matchResult;
        }
        return null;
    }
    match(url) {
        const urlMatch = (0, $45cec8fdf0833adb$export$b5d8fba258cc9e89)(this.pattern, url);
        if (urlMatch) {
            if (this.condition && !this.condition(urlMatch)) return null;
            return {
                ...urlMatch,
                name: this.name
            };
        }
        return null;
    }
    toUrl(params, options) {
        return (0, $48a0bef41abd109a$export$1758be3e5622c165)(this.pattern, params, options);
    }
    constructor(props){
        this.name = void 0;
        this.ufoName = void 0;
        this.bifrost = void 0;
        this.pattern = void 0;
        this.condition = void 0;
        this.isTransition = void 0;
        this.name = props.name;
        this.ufoName = props.ufoName;
        this.bifrost = props.bifrost;
        this.pattern = props.pattern;
        this.condition = props.condition ? props.condition : ()=>true;
        this.isTransition = (previous, current)=>{
            if (!previous) return true;
            if (props.isTransition) return previous.name === current.name ? props.isTransition(previous, current) : true;
            return previous.pathname !== current.pathname;
        };
    }
}


/* eslint-disable confluence-feature-gating/inline-usage */ /* eslint-disable confluence-feature-gating/inline-expVal-params */ 
var $dQwsT = parcelRequire("dQwsT");

var $60657141d996856e$export$7debb50ef11d5e0b;
(function(util) {
    util.assertEqual = (val)=>val;
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})($60657141d996856e$export$7debb50ef11d5e0b || ($60657141d996856e$export$7debb50ef11d5e0b = {}));
var $60657141d996856e$export$4aa2142c225fd5c7;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return {
            ...first,
            ...second
        };
    };
})($60657141d996856e$export$4aa2142c225fd5c7 || ($60657141d996856e$export$4aa2142c225fd5c7 = {}));
const $60657141d996856e$export$5716da67bfaa244d = $60657141d996856e$export$7debb50ef11d5e0b.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const $60657141d996856e$export$3e9057828ebd5c7a = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return $60657141d996856e$export$5716da67bfaa244d.undefined;
        case "string":
            return $60657141d996856e$export$5716da67bfaa244d.string;
        case "number":
            return isNaN(data) ? $60657141d996856e$export$5716da67bfaa244d.nan : $60657141d996856e$export$5716da67bfaa244d.number;
        case "boolean":
            return $60657141d996856e$export$5716da67bfaa244d.boolean;
        case "function":
            return $60657141d996856e$export$5716da67bfaa244d.function;
        case "bigint":
            return $60657141d996856e$export$5716da67bfaa244d.bigint;
        case "symbol":
            return $60657141d996856e$export$5716da67bfaa244d.symbol;
        case "object":
            if (Array.isArray(data)) return $60657141d996856e$export$5716da67bfaa244d.array;
            if (data === null) return $60657141d996856e$export$5716da67bfaa244d.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return $60657141d996856e$export$5716da67bfaa244d.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return $60657141d996856e$export$5716da67bfaa244d.map;
            if (typeof Set !== "undefined" && data instanceof Set) return $60657141d996856e$export$5716da67bfaa244d.set;
            if (typeof Date !== "undefined" && data instanceof Date) return $60657141d996856e$export$5716da67bfaa244d.date;
            return $60657141d996856e$export$5716da67bfaa244d.object;
        default:
            return $60657141d996856e$export$5716da67bfaa244d.unknown;
    }
};
const $60657141d996856e$export$5ba560653e4a1035 = $60657141d996856e$export$7debb50ef11d5e0b.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const $60657141d996856e$export$913eddeaf297cfea = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class $60657141d996856e$export$f98dac4b251ab333 extends Error {
    get errors() {
        return this.issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    static assert(value) {
        if (!(value instanceof $60657141d996856e$export$f98dac4b251ab333)) throw new Error(`Not a ZodError: ${value}`);
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, $60657141d996856e$export$7debb50ef11d5e0b.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
            fieldErrors[sub.path[0]].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors: formErrors,
            fieldErrors: fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
}
$60657141d996856e$export$f98dac4b251ab333.create = (issues)=>{
    const error = new $60657141d996856e$export$f98dac4b251ab333(issues);
    return error;
};
const $60657141d996856e$export$341b0b6e0a6f5099 = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case $60657141d996856e$export$5ba560653e4a1035.invalid_type:
            if (issue.received === $60657141d996856e$export$5716da67bfaa244d.undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case $60657141d996856e$export$5ba560653e4a1035.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, $60657141d996856e$export$7debb50ef11d5e0b.jsonStringifyReplacer)}`;
            break;
        case $60657141d996856e$export$5ba560653e4a1035.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${$60657141d996856e$export$7debb50ef11d5e0b.joinValues(issue.keys, ", ")}`;
            break;
        case $60657141d996856e$export$5ba560653e4a1035.invalid_union:
            message = `Invalid input`;
            break;
        case $60657141d996856e$export$5ba560653e4a1035.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${$60657141d996856e$export$7debb50ef11d5e0b.joinValues(issue.options)}`;
            break;
        case $60657141d996856e$export$5ba560653e4a1035.invalid_enum_value:
            message = `Invalid enum value. Expected ${$60657141d996856e$export$7debb50ef11d5e0b.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case $60657141d996856e$export$5ba560653e4a1035.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case $60657141d996856e$export$5ba560653e4a1035.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case $60657141d996856e$export$5ba560653e4a1035.invalid_date:
            message = `Invalid date`;
            break;
        case $60657141d996856e$export$5ba560653e4a1035.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else $60657141d996856e$export$7debb50ef11d5e0b.assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case $60657141d996856e$export$5ba560653e4a1035.too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case $60657141d996856e$export$5ba560653e4a1035.too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case $60657141d996856e$export$5ba560653e4a1035.custom:
            message = `Invalid input`;
            break;
        case $60657141d996856e$export$5ba560653e4a1035.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case $60657141d996856e$export$5ba560653e4a1035.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case $60657141d996856e$export$5ba560653e4a1035.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            $60657141d996856e$export$7debb50ef11d5e0b.assertNever(issue);
    }
    return {
        message: message
    };
};
let $60657141d996856e$var$overrideErrorMap = $60657141d996856e$export$341b0b6e0a6f5099;
function $60657141d996856e$export$1097a8289cfd22d7(map) {
    $60657141d996856e$var$overrideErrorMap = map;
}
function $60657141d996856e$export$32f27c719778d4c4() {
    return $60657141d996856e$var$overrideErrorMap;
}
const $60657141d996856e$export$244a85fde9c419ed = (params)=>{
    const { data: data, path: path, errorMaps: errorMaps, issueData: issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = {
        ...issueData,
        path: fullPath
    };
    if (issueData.message !== undefined) return {
        ...issueData,
        path: fullPath,
        message: issueData.message
    };
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data: data,
        defaultError: errorMessage
    }).message;
    return {
        ...issueData,
        path: fullPath,
        message: errorMessage
    };
};
const $60657141d996856e$export$1526d2e05f74572 = [];
function $60657141d996856e$export$db7caee60e5d514d(ctx, issueData) {
    const overrideMap = $60657141d996856e$export$32f27c719778d4c4();
    const issue = $60657141d996856e$export$244a85fde9c419ed({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            overrideMap,
            overrideMap === $60657141d996856e$export$341b0b6e0a6f5099 ? undefined : $60657141d996856e$export$341b0b6e0a6f5099
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
class $60657141d996856e$export$5b20a5c3d05c1f6f {
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return $60657141d996856e$export$9a105a556e65c2c0;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs){
            const key = await pair.key;
            const value = await pair.value;
            syncPairs.push({
                key: key,
                value: value
            });
        }
        return $60657141d996856e$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key: key, value: value } = pair;
            if (key.status === "aborted") return $60657141d996856e$export$9a105a556e65c2c0;
            if (value.status === "aborted") return $60657141d996856e$export$9a105a556e65c2c0;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
    constructor(){
        this.value = "valid";
    }
}
const $60657141d996856e$export$9a105a556e65c2c0 = Object.freeze({
    status: "aborted"
});
const $60657141d996856e$export$325a211da9693fcf = (value)=>({
        status: "dirty",
        value: value
    });
const $60657141d996856e$export$c6813a8d51f77eaf = (value)=>({
        status: "valid",
        value: value
    });
const $60657141d996856e$export$afa861e3c5730743 = (x)=>x.status === "aborted";
const $60657141d996856e$export$910b6cdd390341b3 = (x)=>x.status === "dirty";
const $60657141d996856e$export$1ea939691cdc45b8 = (x)=>x.status === "valid";
const $60657141d996856e$export$aefee5ebe1dcfd9e = (x)=>typeof Promise !== "undefined" && x instanceof Promise;
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $60657141d996856e$var$__classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $60657141d996856e$var$__classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
typeof SuppressedError === "function" && SuppressedError;
var $60657141d996856e$var$errorUtil;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message: message
        } : message || {};
    errorUtil.toString = (message)=>typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})($60657141d996856e$var$errorUtil || ($60657141d996856e$var$errorUtil = {}));
var $60657141d996856e$var$_ZodEnum_cache, $60657141d996856e$var$_ZodNativeEnum_cache;
class $60657141d996856e$var$ParseInputLazyPath {
    get path() {
        if (!this._cachedPath.length) {
            if (this._key instanceof Array) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
}
const $60657141d996856e$var$handleResult = (ctx, result)=>{
    if ($60657141d996856e$export$1ea939691cdc45b8(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new $60657141d996856e$export$f98dac4b251ab333(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function $60657141d996856e$var$processCreateParams(params) {
    if (!params) return {};
    const { errorMap: errorMap, invalid_type_error: invalid_type_error, required_error: required_error, description: description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description: description
    };
    const customMap = (iss, ctx)=>{
        var _a, _b;
        const { message: message } = params;
        if (iss.code === "invalid_enum_value") return {
            message: message !== null && message !== void 0 ? message : ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: (_a = message !== null && message !== void 0 ? message : required_error) !== null && _a !== void 0 ? _a : ctx.defaultError
        };
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        return {
            message: (_b = message !== null && message !== void 0 ? message : invalid_type_error) !== null && _b !== void 0 ? _b : ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description: description
    };
}
class $60657141d996856e$export$19342e026b58ebb7 {
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return $60657141d996856e$export$3e9057828ebd5c7a(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: $60657141d996856e$export$3e9057828ebd5c7a(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new $60657141d996856e$export$5b20a5c3d05c1f6f(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: $60657141d996856e$export$3e9057828ebd5c7a(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ($60657141d996856e$export$aefee5ebe1dcfd9e(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        var _a;
        const ctx = {
            common: {
                issues: [],
                async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $60657141d996856e$export$3e9057828ebd5c7a(data)
        };
        const result = this._parseSync({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        return $60657141d996856e$var$handleResult(ctx, result);
    }
    "~validate"(data) {
        var _a, _b;
        const ctx = {
            common: {
                issues: [],
                async: !!this["~standard"].async
            },
            path: [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $60657141d996856e$export$3e9057828ebd5c7a(data)
        };
        if (!this["~standard"].async) try {
            const result = this._parseSync({
                data: data,
                path: [],
                parent: ctx
            });
            return $60657141d996856e$export$1ea939691cdc45b8(result) ? {
                value: result.value
            } : {
                issues: ctx.common.issues
            };
        } catch (err) {
            if ((_b = (_a = err === null || err === void 0 ? void 0 : err.message) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes("encountered")) this["~standard"].async = true;
            ctx.common = {
                issues: [],
                async: true
            };
        }
        return this._parseAsync({
            data: data,
            path: [],
            parent: ctx
        }).then((result)=>$60657141d996856e$export$1ea939691cdc45b8(result) ? {
                value: result.value
            } : {
                issues: ctx.common.issues
            });
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                async: true
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $60657141d996856e$export$3e9057828ebd5c7a(data)
        };
        const maybeAsyncResult = this._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        const result = await ($60657141d996856e$export$aefee5ebe1dcfd9e(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return $60657141d996856e$var$handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message: message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue({
                    code: $60657141d996856e$export$5ba560653e4a1035.custom,
                    ...getIssueProperties(val)
                });
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new $60657141d996856e$export$a60af00cc0ce2582({
            schema: this,
            typeName: $60657141d996856e$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "refinement",
                refinement: refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    optional() {
        return $60657141d996856e$export$aa56fec1e9d629b8.create(this, this._def);
    }
    nullable() {
        return $60657141d996856e$export$aaac0b8b429cef5.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return $60657141d996856e$export$7acfc3e64785411.create(this);
    }
    promise() {
        return $60657141d996856e$export$3f196b0127d6e50a.create(this, this._def);
    }
    or(option) {
        return $60657141d996856e$export$a8b236cb5070a311.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return $60657141d996856e$export$c02deaf0bb5203d4.create(this, incoming, this._def);
    }
    transform(transform) {
        return new $60657141d996856e$export$a60af00cc0ce2582({
            ...$60657141d996856e$var$processCreateParams(this._def),
            schema: this,
            typeName: $60657141d996856e$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "transform",
                transform: transform
            }
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new $60657141d996856e$export$bb19b37874861e7e({
            ...$60657141d996856e$var$processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: $60657141d996856e$export$558106ce543bd011.ZodDefault
        });
    }
    brand() {
        return new $60657141d996856e$export$66b0c798a395271f({
            typeName: $60657141d996856e$export$558106ce543bd011.ZodBranded,
            type: this,
            ...$60657141d996856e$var$processCreateParams(this._def)
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new $60657141d996856e$export$75a44ec6249ac76b({
            ...$60657141d996856e$var$processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: $60657141d996856e$export$558106ce543bd011.ZodCatch
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description: description
        });
    }
    pipe(target) {
        return $60657141d996856e$export$a3c3ef8a0e95c6da.create(this, target);
    }
    readonly() {
        return $60657141d996856e$export$5d1f7ef05c4e493a.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
        this["~standard"] = {
            version: 1,
            vendor: "zod",
            validate: (data)=>this["~validate"](data)
        };
    }
}
const $60657141d996856e$var$cuidRegex = /^c[^\s-]{8,}$/i;
const $60657141d996856e$var$cuid2Regex = /^[0-9a-z]+$/;
const $60657141d996856e$var$ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/i;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const $60657141d996856e$var$uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
const $60657141d996856e$var$nanoidRegex = /^[a-z0-9_-]{21}$/i;
const $60657141d996856e$var$jwtRegex = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/;
const $60657141d996856e$var$durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const $60657141d996856e$var$emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const $60657141d996856e$var$_emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let $60657141d996856e$var$emojiRegex;
// faster, simpler, safer
const $60657141d996856e$var$ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
const $60657141d996856e$var$ipv4CidrRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/;
// const ipv6Regex =
// /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
const $60657141d996856e$var$ipv6Regex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/;
const $60657141d996856e$var$ipv6CidrRegex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/;
// https://stackoverflow.com/questions/7860392/determine-if-string-is-in-base64-using-javascript
const $60657141d996856e$var$base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
// https://base64.guru/standards/base64url
const $60657141d996856e$var$base64urlRegex = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/;
// simple
// const dateRegexSource = `\\d{4}-\\d{2}-\\d{2}`;
// no leap year validation
// const dateRegexSource = `\\d{4}-((0[13578]|10|12)-31|(0[13-9]|1[0-2])-30|(0[1-9]|1[0-2])-(0[1-9]|1\\d|2\\d))`;
// with leap year validation
const $60657141d996856e$var$dateRegexSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
const $60657141d996856e$var$dateRegex = new RegExp(`^${$60657141d996856e$var$dateRegexSource}$`);
function $60657141d996856e$var$timeRegexSource(args) {
    // let regex = `\\d{2}:\\d{2}:\\d{2}`;
    let regex = `([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d`;
    if (args.precision) regex = `${regex}\\.\\d{${args.precision}}`;
    else if (args.precision == null) regex = `${regex}(\\.\\d+)?`;
    return regex;
}
function $60657141d996856e$var$timeRegex(args) {
    return new RegExp(`^${$60657141d996856e$var$timeRegexSource(args)}$`);
}
// Adapted from https://stackoverflow.com/a/3143231
function $60657141d996856e$export$a4b563879add27a(args) {
    let regex = `${$60657141d996856e$var$dateRegexSource}T${$60657141d996856e$var$timeRegexSource(args)}`;
    const opts = [];
    opts.push(args.local ? `Z?` : `Z`);
    if (args.offset) opts.push(`([+-]\\d{2}:?\\d{2})`);
    regex = `${regex}(${opts.join("|")})`;
    return new RegExp(`^${regex}$`);
}
function $60657141d996856e$var$isValidIP(ip, version) {
    if ((version === "v4" || !version) && $60657141d996856e$var$ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && $60657141d996856e$var$ipv6Regex.test(ip)) return true;
    return false;
}
function $60657141d996856e$var$isValidJWT(jwt, alg) {
    if (!$60657141d996856e$var$jwtRegex.test(jwt)) return false;
    try {
        const [header] = jwt.split(".");
        // Convert base64url to base64
        const base64 = header.replace(/-/g, "+").replace(/_/g, "/").padEnd(header.length + (4 - header.length % 4) % 4, "=");
        const decoded = JSON.parse(atob(base64));
        if (typeof decoded !== "object" || decoded === null) return false;
        if (!decoded.typ || !decoded.alg) return false;
        if (alg && decoded.alg !== alg) return false;
        return true;
    } catch (_a) {
        return false;
    }
}
function $60657141d996856e$var$isValidCidr(ip, version) {
    if ((version === "v4" || !version) && $60657141d996856e$var$ipv4CidrRegex.test(ip)) return true;
    if ((version === "v6" || !version) && $60657141d996856e$var$ipv6CidrRegex.test(ip)) return true;
    return false;
}
class $60657141d996856e$export$1230eb29b8d3b502 extends $60657141d996856e$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $60657141d996856e$export$5716da67bfaa244d.string) {
            const ctx = this._getOrReturnCtx(input);
            $60657141d996856e$export$db7caee60e5d514d(ctx, {
                code: $60657141d996856e$export$5ba560653e4a1035.invalid_type,
                expected: $60657141d996856e$export$5716da67bfaa244d.string,
                received: ctx.parsedType
            });
            return $60657141d996856e$export$9a105a556e65c2c0;
        }
        const status = new $60657141d996856e$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $60657141d996856e$export$db7caee60e5d514d(ctx, {
                        code: $60657141d996856e$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $60657141d996856e$export$db7caee60e5d514d(ctx, {
                        code: $60657141d996856e$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) $60657141d996856e$export$db7caee60e5d514d(ctx, {
                        code: $60657141d996856e$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) $60657141d996856e$export$db7caee60e5d514d(ctx, {
                        code: $60657141d996856e$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!$60657141d996856e$var$emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $60657141d996856e$export$db7caee60e5d514d(ctx, {
                        validation: "email",
                        code: $60657141d996856e$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!$60657141d996856e$var$emojiRegex) $60657141d996856e$var$emojiRegex = new RegExp($60657141d996856e$var$_emojiRegex, "u");
                if (!$60657141d996856e$var$emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $60657141d996856e$export$db7caee60e5d514d(ctx, {
                        validation: "emoji",
                        code: $60657141d996856e$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!$60657141d996856e$var$uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $60657141d996856e$export$db7caee60e5d514d(ctx, {
                        validation: "uuid",
                        code: $60657141d996856e$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "nanoid") {
                if (!$60657141d996856e$var$nanoidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $60657141d996856e$export$db7caee60e5d514d(ctx, {
                        validation: "nanoid",
                        code: $60657141d996856e$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!$60657141d996856e$var$cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $60657141d996856e$export$db7caee60e5d514d(ctx, {
                        validation: "cuid",
                        code: $60657141d996856e$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!$60657141d996856e$var$cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $60657141d996856e$export$db7caee60e5d514d(ctx, {
                        validation: "cuid2",
                        code: $60657141d996856e$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!$60657141d996856e$var$ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $60657141d996856e$export$db7caee60e5d514d(ctx, {
                        validation: "ulid",
                        code: $60657141d996856e$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch (_a) {
                ctx = this._getOrReturnCtx(input, ctx);
                $60657141d996856e$export$db7caee60e5d514d(ctx, {
                    validation: "url",
                    code: $60657141d996856e$export$5ba560653e4a1035.invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $60657141d996856e$export$db7caee60e5d514d(ctx, {
                        validation: "regex",
                        code: $60657141d996856e$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $60657141d996856e$export$db7caee60e5d514d(ctx, {
                        code: $60657141d996856e$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $60657141d996856e$export$db7caee60e5d514d(ctx, {
                        code: $60657141d996856e$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $60657141d996856e$export$db7caee60e5d514d(ctx, {
                        code: $60657141d996856e$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = $60657141d996856e$export$a4b563879add27a(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $60657141d996856e$export$db7caee60e5d514d(ctx, {
                        code: $60657141d996856e$export$5ba560653e4a1035.invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "date") {
                const regex = $60657141d996856e$var$dateRegex;
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $60657141d996856e$export$db7caee60e5d514d(ctx, {
                        code: $60657141d996856e$export$5ba560653e4a1035.invalid_string,
                        validation: "date",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "time") {
                const regex = $60657141d996856e$var$timeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $60657141d996856e$export$db7caee60e5d514d(ctx, {
                        code: $60657141d996856e$export$5ba560653e4a1035.invalid_string,
                        validation: "time",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "duration") {
                if (!$60657141d996856e$var$durationRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $60657141d996856e$export$db7caee60e5d514d(ctx, {
                        validation: "duration",
                        code: $60657141d996856e$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!$60657141d996856e$var$isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $60657141d996856e$export$db7caee60e5d514d(ctx, {
                        validation: "ip",
                        code: $60657141d996856e$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "jwt") {
                if (!$60657141d996856e$var$isValidJWT(input.data, check.alg)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $60657141d996856e$export$db7caee60e5d514d(ctx, {
                        validation: "jwt",
                        code: $60657141d996856e$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cidr") {
                if (!$60657141d996856e$var$isValidCidr(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $60657141d996856e$export$db7caee60e5d514d(ctx, {
                        validation: "cidr",
                        code: $60657141d996856e$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64") {
                if (!$60657141d996856e$var$base64Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $60657141d996856e$export$db7caee60e5d514d(ctx, {
                        validation: "base64",
                        code: $60657141d996856e$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64url") {
                if (!$60657141d996856e$var$base64urlRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $60657141d996856e$export$db7caee60e5d514d(ctx, {
                        validation: "base64url",
                        code: $60657141d996856e$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $60657141d996856e$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _regex(regex, validation, message) {
        return this.refinement((data)=>regex.test(data), {
            validation: validation,
            code: $60657141d996856e$export$5ba560653e4a1035.invalid_string,
            ...$60657141d996856e$var$errorUtil.errToObj(message)
        });
    }
    _addCheck(check) {
        return new $60657141d996856e$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    email(message) {
        return this._addCheck({
            kind: "email",
            ...$60657141d996856e$var$errorUtil.errToObj(message)
        });
    }
    url(message) {
        return this._addCheck({
            kind: "url",
            ...$60657141d996856e$var$errorUtil.errToObj(message)
        });
    }
    emoji(message) {
        return this._addCheck({
            kind: "emoji",
            ...$60657141d996856e$var$errorUtil.errToObj(message)
        });
    }
    uuid(message) {
        return this._addCheck({
            kind: "uuid",
            ...$60657141d996856e$var$errorUtil.errToObj(message)
        });
    }
    nanoid(message) {
        return this._addCheck({
            kind: "nanoid",
            ...$60657141d996856e$var$errorUtil.errToObj(message)
        });
    }
    cuid(message) {
        return this._addCheck({
            kind: "cuid",
            ...$60657141d996856e$var$errorUtil.errToObj(message)
        });
    }
    cuid2(message) {
        return this._addCheck({
            kind: "cuid2",
            ...$60657141d996856e$var$errorUtil.errToObj(message)
        });
    }
    ulid(message) {
        return this._addCheck({
            kind: "ulid",
            ...$60657141d996856e$var$errorUtil.errToObj(message)
        });
    }
    base64(message) {
        return this._addCheck({
            kind: "base64",
            ...$60657141d996856e$var$errorUtil.errToObj(message)
        });
    }
    base64url(message) {
        // base64url encoding is a modification of base64 that can safely be used in URLs and filenames
        return this._addCheck({
            kind: "base64url",
            ...$60657141d996856e$var$errorUtil.errToObj(message)
        });
    }
    jwt(options) {
        return this._addCheck({
            kind: "jwt",
            ...$60657141d996856e$var$errorUtil.errToObj(options)
        });
    }
    ip(options) {
        return this._addCheck({
            kind: "ip",
            ...$60657141d996856e$var$errorUtil.errToObj(options)
        });
    }
    cidr(options) {
        return this._addCheck({
            kind: "cidr",
            ...$60657141d996856e$var$errorUtil.errToObj(options)
        });
    }
    datetime(options) {
        var _a, _b;
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            local: false,
            message: options
        });
        return this._addCheck({
            kind: "datetime",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false,
            local: (_b = options === null || options === void 0 ? void 0 : options.local) !== null && _b !== void 0 ? _b : false,
            ...$60657141d996856e$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    date(message) {
        return this._addCheck({
            kind: "date",
            message: message
        });
    }
    time(options) {
        if (typeof options === "string") return this._addCheck({
            kind: "time",
            precision: null,
            message: options
        });
        return this._addCheck({
            kind: "time",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            ...$60657141d996856e$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    duration(message) {
        return this._addCheck({
            kind: "duration",
            ...$60657141d996856e$var$errorUtil.errToObj(message)
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...$60657141d996856e$var$errorUtil.errToObj(message)
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options === null || options === void 0 ? void 0 : options.position,
            ...$60657141d996856e$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...$60657141d996856e$var$errorUtil.errToObj(message)
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...$60657141d996856e$var$errorUtil.errToObj(message)
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...$60657141d996856e$var$errorUtil.errToObj(message)
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...$60657141d996856e$var$errorUtil.errToObj(message)
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...$60657141d996856e$var$errorUtil.errToObj(message)
        });
    }
    /**
     * Equivalent to `.min(1)`
     */ nonempty(message) {
        return this.min(1, $60657141d996856e$var$errorUtil.errToObj(message));
    }
    trim() {
        return new $60657141d996856e$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "trim"
                }
            ]
        });
    }
    toLowerCase() {
        return new $60657141d996856e$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toLowerCase"
                }
            ]
        });
    }
    toUpperCase() {
        return new $60657141d996856e$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toUpperCase"
                }
            ]
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isDate() {
        return !!this._def.checks.find((ch)=>ch.kind === "date");
    }
    get isTime() {
        return !!this._def.checks.find((ch)=>ch.kind === "time");
    }
    get isDuration() {
        return !!this._def.checks.find((ch)=>ch.kind === "duration");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isNANOID() {
        return !!this._def.checks.find((ch)=>ch.kind === "nanoid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get isCIDR() {
        return !!this._def.checks.find((ch)=>ch.kind === "cidr");
    }
    get isBase64() {
        return !!this._def.checks.find((ch)=>ch.kind === "base64");
    }
    get isBase64url() {
        // base64url encoding is a modification of base64 that can safely be used in URLs and filenames
        return !!this._def.checks.find((ch)=>ch.kind === "base64url");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$60657141d996856e$export$1230eb29b8d3b502.create = (params)=>{
    var _a;
    return new $60657141d996856e$export$1230eb29b8d3b502({
        checks: [],
        typeName: $60657141d996856e$export$558106ce543bd011.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$60657141d996856e$var$processCreateParams(params)
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function $60657141d996856e$var$floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / Math.pow(10, decCount);
}
class $60657141d996856e$export$5b070a55c0c43e09 extends $60657141d996856e$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $60657141d996856e$export$5716da67bfaa244d.number) {
            const ctx = this._getOrReturnCtx(input);
            $60657141d996856e$export$db7caee60e5d514d(ctx, {
                code: $60657141d996856e$export$5ba560653e4a1035.invalid_type,
                expected: $60657141d996856e$export$5716da67bfaa244d.number,
                received: ctx.parsedType
            });
            return $60657141d996856e$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $60657141d996856e$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!$60657141d996856e$export$7debb50ef11d5e0b.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $60657141d996856e$export$db7caee60e5d514d(ctx, {
                        code: $60657141d996856e$export$5ba560653e4a1035.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $60657141d996856e$export$db7caee60e5d514d(ctx, {
                        code: $60657141d996856e$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $60657141d996856e$export$db7caee60e5d514d(ctx, {
                        code: $60657141d996856e$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if ($60657141d996856e$var$floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $60657141d996856e$export$db7caee60e5d514d(ctx, {
                        code: $60657141d996856e$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $60657141d996856e$export$db7caee60e5d514d(ctx, {
                        code: $60657141d996856e$export$5ba560653e4a1035.not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $60657141d996856e$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $60657141d996856e$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $60657141d996856e$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $60657141d996856e$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $60657141d996856e$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $60657141d996856e$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $60657141d996856e$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $60657141d996856e$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: $60657141d996856e$var$errorUtil.toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: $60657141d996856e$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: $60657141d996856e$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: $60657141d996856e$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: $60657141d996856e$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $60657141d996856e$var$errorUtil.toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: $60657141d996856e$var$errorUtil.toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: $60657141d996856e$var$errorUtil.toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: $60657141d996856e$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && $60657141d996856e$export$7debb50ef11d5e0b.isInteger(ch.value));
    }
    get isFinite() {
        let max = null, min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
}
$60657141d996856e$export$5b070a55c0c43e09.create = (params)=>{
    return new $60657141d996856e$export$5b070a55c0c43e09({
        checks: [],
        typeName: $60657141d996856e$export$558106ce543bd011.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$60657141d996856e$var$processCreateParams(params)
    });
};
class $60657141d996856e$export$67d741fd70ff98f4 extends $60657141d996856e$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) try {
            input.data = BigInt(input.data);
        } catch (_a) {
            return this._getInvalidInput(input);
        }
        const parsedType = this._getType(input);
        if (parsedType !== $60657141d996856e$export$5716da67bfaa244d.bigint) return this._getInvalidInput(input);
        let ctx = undefined;
        const status = new $60657141d996856e$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $60657141d996856e$export$db7caee60e5d514d(ctx, {
                        code: $60657141d996856e$export$5ba560653e4a1035.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $60657141d996856e$export$db7caee60e5d514d(ctx, {
                        code: $60657141d996856e$export$5ba560653e4a1035.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $60657141d996856e$export$db7caee60e5d514d(ctx, {
                        code: $60657141d996856e$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $60657141d996856e$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _getInvalidInput(input) {
        const ctx = this._getOrReturnCtx(input);
        $60657141d996856e$export$db7caee60e5d514d(ctx, {
            code: $60657141d996856e$export$5ba560653e4a1035.invalid_type,
            expected: $60657141d996856e$export$5716da67bfaa244d.bigint,
            received: ctx.parsedType
        });
        return $60657141d996856e$export$9a105a556e65c2c0;
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $60657141d996856e$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $60657141d996856e$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $60657141d996856e$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $60657141d996856e$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $60657141d996856e$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $60657141d996856e$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $60657141d996856e$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: $60657141d996856e$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: $60657141d996856e$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: $60657141d996856e$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: $60657141d996856e$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $60657141d996856e$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
}
$60657141d996856e$export$67d741fd70ff98f4.create = (params)=>{
    var _a;
    return new $60657141d996856e$export$67d741fd70ff98f4({
        checks: [],
        typeName: $60657141d996856e$export$558106ce543bd011.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$60657141d996856e$var$processCreateParams(params)
    });
};
class $60657141d996856e$export$723d146f80596191 extends $60657141d996856e$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $60657141d996856e$export$5716da67bfaa244d.boolean) {
            const ctx = this._getOrReturnCtx(input);
            $60657141d996856e$export$db7caee60e5d514d(ctx, {
                code: $60657141d996856e$export$5ba560653e4a1035.invalid_type,
                expected: $60657141d996856e$export$5716da67bfaa244d.boolean,
                received: ctx.parsedType
            });
            return $60657141d996856e$export$9a105a556e65c2c0;
        }
        return $60657141d996856e$export$c6813a8d51f77eaf(input.data);
    }
}
$60657141d996856e$export$723d146f80596191.create = (params)=>{
    return new $60657141d996856e$export$723d146f80596191({
        typeName: $60657141d996856e$export$558106ce543bd011.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$60657141d996856e$var$processCreateParams(params)
    });
};
class $60657141d996856e$export$e974be33bdc55521 extends $60657141d996856e$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $60657141d996856e$export$5716da67bfaa244d.date) {
            const ctx = this._getOrReturnCtx(input);
            $60657141d996856e$export$db7caee60e5d514d(ctx, {
                code: $60657141d996856e$export$5ba560653e4a1035.invalid_type,
                expected: $60657141d996856e$export$5716da67bfaa244d.date,
                received: ctx.parsedType
            });
            return $60657141d996856e$export$9a105a556e65c2c0;
        }
        if (isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            $60657141d996856e$export$db7caee60e5d514d(ctx, {
                code: $60657141d996856e$export$5ba560653e4a1035.invalid_date
            });
            return $60657141d996856e$export$9a105a556e65c2c0;
        }
        const status = new $60657141d996856e$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $60657141d996856e$export$db7caee60e5d514d(ctx, {
                        code: $60657141d996856e$export$5ba560653e4a1035.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $60657141d996856e$export$db7caee60e5d514d(ctx, {
                        code: $60657141d996856e$export$5ba560653e4a1035.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else $60657141d996856e$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new $60657141d996856e$export$e974be33bdc55521({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: $60657141d996856e$var$errorUtil.toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: $60657141d996856e$var$errorUtil.toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
$60657141d996856e$export$e974be33bdc55521.create = (params)=>{
    return new $60657141d996856e$export$e974be33bdc55521({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: $60657141d996856e$export$558106ce543bd011.ZodDate,
        ...$60657141d996856e$var$processCreateParams(params)
    });
};
class $60657141d996856e$export$bcc3b40f6b638044 extends $60657141d996856e$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $60657141d996856e$export$5716da67bfaa244d.symbol) {
            const ctx = this._getOrReturnCtx(input);
            $60657141d996856e$export$db7caee60e5d514d(ctx, {
                code: $60657141d996856e$export$5ba560653e4a1035.invalid_type,
                expected: $60657141d996856e$export$5716da67bfaa244d.symbol,
                received: ctx.parsedType
            });
            return $60657141d996856e$export$9a105a556e65c2c0;
        }
        return $60657141d996856e$export$c6813a8d51f77eaf(input.data);
    }
}
$60657141d996856e$export$bcc3b40f6b638044.create = (params)=>{
    return new $60657141d996856e$export$bcc3b40f6b638044({
        typeName: $60657141d996856e$export$558106ce543bd011.ZodSymbol,
        ...$60657141d996856e$var$processCreateParams(params)
    });
};
class $60657141d996856e$export$4e780e961c30340d extends $60657141d996856e$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $60657141d996856e$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $60657141d996856e$export$db7caee60e5d514d(ctx, {
                code: $60657141d996856e$export$5ba560653e4a1035.invalid_type,
                expected: $60657141d996856e$export$5716da67bfaa244d.undefined,
                received: ctx.parsedType
            });
            return $60657141d996856e$export$9a105a556e65c2c0;
        }
        return $60657141d996856e$export$c6813a8d51f77eaf(input.data);
    }
}
$60657141d996856e$export$4e780e961c30340d.create = (params)=>{
    return new $60657141d996856e$export$4e780e961c30340d({
        typeName: $60657141d996856e$export$558106ce543bd011.ZodUndefined,
        ...$60657141d996856e$var$processCreateParams(params)
    });
};
class $60657141d996856e$export$a96281f914484f2d extends $60657141d996856e$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $60657141d996856e$export$5716da67bfaa244d.null) {
            const ctx = this._getOrReturnCtx(input);
            $60657141d996856e$export$db7caee60e5d514d(ctx, {
                code: $60657141d996856e$export$5ba560653e4a1035.invalid_type,
                expected: $60657141d996856e$export$5716da67bfaa244d.null,
                received: ctx.parsedType
            });
            return $60657141d996856e$export$9a105a556e65c2c0;
        }
        return $60657141d996856e$export$c6813a8d51f77eaf(input.data);
    }
}
$60657141d996856e$export$a96281f914484f2d.create = (params)=>{
    return new $60657141d996856e$export$a96281f914484f2d({
        typeName: $60657141d996856e$export$558106ce543bd011.ZodNull,
        ...$60657141d996856e$var$processCreateParams(params)
    });
};
class $60657141d996856e$export$b9d1edb536b4e4eb extends $60657141d996856e$export$19342e026b58ebb7 {
    _parse(input) {
        return $60657141d996856e$export$c6813a8d51f77eaf(input.data);
    }
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
}
$60657141d996856e$export$b9d1edb536b4e4eb.create = (params)=>{
    return new $60657141d996856e$export$b9d1edb536b4e4eb({
        typeName: $60657141d996856e$export$558106ce543bd011.ZodAny,
        ...$60657141d996856e$var$processCreateParams(params)
    });
};
class $60657141d996856e$export$ef3b1bb1630977ae extends $60657141d996856e$export$19342e026b58ebb7 {
    _parse(input) {
        return $60657141d996856e$export$c6813a8d51f77eaf(input.data);
    }
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
}
$60657141d996856e$export$ef3b1bb1630977ae.create = (params)=>{
    return new $60657141d996856e$export$ef3b1bb1630977ae({
        typeName: $60657141d996856e$export$558106ce543bd011.ZodUnknown,
        ...$60657141d996856e$var$processCreateParams(params)
    });
};
class $60657141d996856e$export$1e576a20c3ce9fb5 extends $60657141d996856e$export$19342e026b58ebb7 {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        $60657141d996856e$export$db7caee60e5d514d(ctx, {
            code: $60657141d996856e$export$5ba560653e4a1035.invalid_type,
            expected: $60657141d996856e$export$5716da67bfaa244d.never,
            received: ctx.parsedType
        });
        return $60657141d996856e$export$9a105a556e65c2c0;
    }
}
$60657141d996856e$export$1e576a20c3ce9fb5.create = (params)=>{
    return new $60657141d996856e$export$1e576a20c3ce9fb5({
        typeName: $60657141d996856e$export$558106ce543bd011.ZodNever,
        ...$60657141d996856e$var$processCreateParams(params)
    });
};
class $60657141d996856e$export$7d39f5df85f21031 extends $60657141d996856e$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $60657141d996856e$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $60657141d996856e$export$db7caee60e5d514d(ctx, {
                code: $60657141d996856e$export$5ba560653e4a1035.invalid_type,
                expected: $60657141d996856e$export$5716da67bfaa244d.void,
                received: ctx.parsedType
            });
            return $60657141d996856e$export$9a105a556e65c2c0;
        }
        return $60657141d996856e$export$c6813a8d51f77eaf(input.data);
    }
}
$60657141d996856e$export$7d39f5df85f21031.create = (params)=>{
    return new $60657141d996856e$export$7d39f5df85f21031({
        typeName: $60657141d996856e$export$558106ce543bd011.ZodVoid,
        ...$60657141d996856e$var$processCreateParams(params)
    });
};
class $60657141d996856e$export$7acfc3e64785411 extends $60657141d996856e$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx, status: status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== $60657141d996856e$export$5716da67bfaa244d.array) {
            $60657141d996856e$export$db7caee60e5d514d(ctx, {
                code: $60657141d996856e$export$5ba560653e4a1035.invalid_type,
                expected: $60657141d996856e$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $60657141d996856e$export$9a105a556e65c2c0;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                $60657141d996856e$export$db7caee60e5d514d(ctx, {
                    code: tooBig ? $60657141d996856e$export$5ba560653e4a1035.too_big : $60657141d996856e$export$5ba560653e4a1035.too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                $60657141d996856e$export$db7caee60e5d514d(ctx, {
                    code: $60657141d996856e$export$5ba560653e4a1035.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                $60657141d996856e$export$db7caee60e5d514d(ctx, {
                    code: $60657141d996856e$export$5ba560653e4a1035.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new $60657141d996856e$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return $60657141d996856e$export$5b20a5c3d05c1f6f.mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new $60657141d996856e$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return $60657141d996856e$export$5b20a5c3d05c1f6f.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new $60657141d996856e$export$7acfc3e64785411({
            ...this._def,
            minLength: {
                value: minLength,
                message: $60657141d996856e$var$errorUtil.toString(message)
            }
        });
    }
    max(maxLength, message) {
        return new $60657141d996856e$export$7acfc3e64785411({
            ...this._def,
            maxLength: {
                value: maxLength,
                message: $60657141d996856e$var$errorUtil.toString(message)
            }
        });
    }
    length(len, message) {
        return new $60657141d996856e$export$7acfc3e64785411({
            ...this._def,
            exactLength: {
                value: len,
                message: $60657141d996856e$var$errorUtil.toString(message)
            }
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$60657141d996856e$export$7acfc3e64785411.create = (schema, params)=>{
    return new $60657141d996856e$export$7acfc3e64785411({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: $60657141d996856e$export$558106ce543bd011.ZodArray,
        ...$60657141d996856e$var$processCreateParams(params)
    });
};
function $60657141d996856e$var$deepPartialify(schema) {
    if (schema instanceof $60657141d996856e$export$736315c5b55efbad) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = $60657141d996856e$export$aa56fec1e9d629b8.create($60657141d996856e$var$deepPartialify(fieldSchema));
        }
        return new $60657141d996856e$export$736315c5b55efbad({
            ...schema._def,
            shape: ()=>newShape
        });
    } else if (schema instanceof $60657141d996856e$export$7acfc3e64785411) return new $60657141d996856e$export$7acfc3e64785411({
        ...schema._def,
        type: $60657141d996856e$var$deepPartialify(schema.element)
    });
    else if (schema instanceof $60657141d996856e$export$aa56fec1e9d629b8) return $60657141d996856e$export$aa56fec1e9d629b8.create($60657141d996856e$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $60657141d996856e$export$aaac0b8b429cef5) return $60657141d996856e$export$aaac0b8b429cef5.create($60657141d996856e$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $60657141d996856e$export$e2a18bb771d8e6a3) return $60657141d996856e$export$e2a18bb771d8e6a3.create(schema.items.map((item)=>$60657141d996856e$var$deepPartialify(item)));
    else return schema;
}
class $60657141d996856e$export$736315c5b55efbad extends $60657141d996856e$export$19342e026b58ebb7 {
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = $60657141d996856e$export$7debb50ef11d5e0b.objectKeys(shape);
        return this._cached = {
            shape: shape,
            keys: keys
        };
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $60657141d996856e$export$5716da67bfaa244d.object) {
            const ctx = this._getOrReturnCtx(input);
            $60657141d996856e$export$db7caee60e5d514d(ctx, {
                code: $60657141d996856e$export$5ba560653e4a1035.invalid_type,
                expected: $60657141d996856e$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $60657141d996856e$export$9a105a556e65c2c0;
        }
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const { shape: shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof $60657141d996856e$export$1e576a20c3ce9fb5 && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new $60657141d996856e$var$ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof $60657141d996856e$export$1e576a20c3ce9fb5) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    $60657141d996856e$export$db7caee60e5d514d(ctx, {
                        code: $60657141d996856e$export$5ba560653e4a1035.unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new $60657141d996856e$var$ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                const value = await pair.value;
                syncPairs.push({
                    key: key,
                    value: value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return $60657141d996856e$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
        });
        else return $60657141d996856e$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        $60657141d996856e$var$errorUtil.errToObj;
        return new $60657141d996856e$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strict",
            ...message !== undefined ? {
                errorMap: (issue, ctx)=>{
                    var _a, _b, _c, _d;
                    const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                    if (issue.code === "unrecognized_keys") return {
                        message: (_d = $60657141d996856e$var$errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
                    };
                    return {
                        message: defaultError
                    };
                }
            } : {}
        });
    }
    strip() {
        return new $60657141d996856e$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strip"
        });
    }
    passthrough() {
        return new $60657141d996856e$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "passthrough"
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new $60657141d996856e$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>({
                    ...this._def.shape(),
                    ...augmentation
                })
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new $60657141d996856e$export$736315c5b55efbad({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>({
                    ...this._def.shape(),
                    ...merging._def.shape()
                }),
            typeName: $60657141d996856e$export$558106ce543bd011.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new $60657141d996856e$export$736315c5b55efbad({
            ...this._def,
            catchall: index
        });
    }
    pick(mask) {
        const shape = {};
        $60657141d996856e$export$7debb50ef11d5e0b.objectKeys(mask).forEach((key)=>{
            if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        });
        return new $60657141d996856e$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    omit(mask) {
        const shape = {};
        $60657141d996856e$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (!mask[key]) shape[key] = this.shape[key];
        });
        return new $60657141d996856e$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    /**
     * @deprecated
     */ deepPartial() {
        return $60657141d996856e$var$deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        $60657141d996856e$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        });
        return new $60657141d996856e$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    required(mask) {
        const newShape = {};
        $60657141d996856e$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (mask && !mask[key]) newShape[key] = this.shape[key];
            else {
                const fieldSchema = this.shape[key];
                let newField = fieldSchema;
                while(newField instanceof $60657141d996856e$export$aa56fec1e9d629b8)newField = newField._def.innerType;
                newShape[key] = newField;
            }
        });
        return new $60657141d996856e$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    keyof() {
        return $60657141d996856e$var$createZodEnum($60657141d996856e$export$7debb50ef11d5e0b.objectKeys(this.shape));
    }
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
}
$60657141d996856e$export$736315c5b55efbad.create = (shape, params)=>{
    return new $60657141d996856e$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: $60657141d996856e$export$1e576a20c3ce9fb5.create(),
        typeName: $60657141d996856e$export$558106ce543bd011.ZodObject,
        ...$60657141d996856e$var$processCreateParams(params)
    });
};
$60657141d996856e$export$736315c5b55efbad.strictCreate = (shape, params)=>{
    return new $60657141d996856e$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: $60657141d996856e$export$1e576a20c3ce9fb5.create(),
        typeName: $60657141d996856e$export$558106ce543bd011.ZodObject,
        ...$60657141d996856e$var$processCreateParams(params)
    });
};
$60657141d996856e$export$736315c5b55efbad.lazycreate = (shape, params)=>{
    return new $60657141d996856e$export$736315c5b55efbad({
        shape: shape,
        unknownKeys: "strip",
        catchall: $60657141d996856e$export$1e576a20c3ce9fb5.create(),
        typeName: $60657141d996856e$export$558106ce543bd011.ZodObject,
        ...$60657141d996856e$var$processCreateParams(params)
    });
};
class $60657141d996856e$export$a8b236cb5070a311 extends $60657141d996856e$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new $60657141d996856e$export$f98dac4b251ab333(result.ctx.common.issues));
            $60657141d996856e$export$db7caee60e5d514d(ctx, {
                code: $60657141d996856e$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $60657141d996856e$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = {
                ...ctx,
                common: {
                    ...ctx.common,
                    issues: []
                },
                parent: null
            };
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: []
                    },
                    parent: null
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result: result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new $60657141d996856e$export$f98dac4b251ab333(issues));
            $60657141d996856e$export$db7caee60e5d514d(ctx, {
                code: $60657141d996856e$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $60657141d996856e$export$9a105a556e65c2c0;
        }
    }
    get options() {
        return this._def.options;
    }
}
$60657141d996856e$export$a8b236cb5070a311.create = (types, params)=>{
    return new $60657141d996856e$export$a8b236cb5070a311({
        options: types,
        typeName: $60657141d996856e$export$558106ce543bd011.ZodUnion,
        ...$60657141d996856e$var$processCreateParams(params)
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const $60657141d996856e$var$getDiscriminator = (type)=>{
    if (type instanceof $60657141d996856e$export$378d0cfce37406e6) return $60657141d996856e$var$getDiscriminator(type.schema);
    else if (type instanceof $60657141d996856e$export$a60af00cc0ce2582) return $60657141d996856e$var$getDiscriminator(type.innerType());
    else if (type instanceof $60657141d996856e$export$7e44096782a165d3) return [
        type.value
    ];
    else if (type instanceof $60657141d996856e$export$d325d1f0e1c20179) return type.options;
    else if (type instanceof $60657141d996856e$export$370b2e8d6d6f5c56) // eslint-disable-next-line ban/ban
    return $60657141d996856e$export$7debb50ef11d5e0b.objectValues(type.enum);
    else if (type instanceof $60657141d996856e$export$bb19b37874861e7e) return $60657141d996856e$var$getDiscriminator(type._def.innerType);
    else if (type instanceof $60657141d996856e$export$4e780e961c30340d) return [
        undefined
    ];
    else if (type instanceof $60657141d996856e$export$a96281f914484f2d) return [
        null
    ];
    else if (type instanceof $60657141d996856e$export$aa56fec1e9d629b8) return [
        undefined,
        ...$60657141d996856e$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $60657141d996856e$export$aaac0b8b429cef5) return [
        null,
        ...$60657141d996856e$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $60657141d996856e$export$66b0c798a395271f) return $60657141d996856e$var$getDiscriminator(type.unwrap());
    else if (type instanceof $60657141d996856e$export$5d1f7ef05c4e493a) return $60657141d996856e$var$getDiscriminator(type.unwrap());
    else if (type instanceof $60657141d996856e$export$75a44ec6249ac76b) return $60657141d996856e$var$getDiscriminator(type._def.innerType);
    else return [];
};
class $60657141d996856e$export$5ef2424805ac76a3 extends $60657141d996856e$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $60657141d996856e$export$5716da67bfaa244d.object) {
            $60657141d996856e$export$db7caee60e5d514d(ctx, {
                code: $60657141d996856e$export$5ba560653e4a1035.invalid_type,
                expected: $60657141d996856e$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $60657141d996856e$export$9a105a556e65c2c0;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            $60657141d996856e$export$db7caee60e5d514d(ctx, {
                code: $60657141d996856e$export$5ba560653e4a1035.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return $60657141d996856e$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = $60657141d996856e$var$getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues.length) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new $60657141d996856e$export$5ef2424805ac76a3({
            typeName: $60657141d996856e$export$558106ce543bd011.ZodDiscriminatedUnion,
            discriminator: discriminator,
            options: options,
            optionsMap: optionsMap,
            ...$60657141d996856e$var$processCreateParams(params)
        });
    }
}
function $60657141d996856e$var$mergeValues(a, b) {
    const aType = $60657141d996856e$export$3e9057828ebd5c7a(a);
    const bType = $60657141d996856e$export$3e9057828ebd5c7a(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === $60657141d996856e$export$5716da67bfaa244d.object && bType === $60657141d996856e$export$5716da67bfaa244d.object) {
        const bKeys = $60657141d996856e$export$7debb50ef11d5e0b.objectKeys(b);
        const sharedKeys = $60657141d996856e$export$7debb50ef11d5e0b.objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        for (const key of sharedKeys){
            const sharedValue = $60657141d996856e$var$mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === $60657141d996856e$export$5716da67bfaa244d.array && bType === $60657141d996856e$export$5716da67bfaa244d.array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = $60657141d996856e$var$mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === $60657141d996856e$export$5716da67bfaa244d.date && bType === $60657141d996856e$export$5716da67bfaa244d.date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class $60657141d996856e$export$c02deaf0bb5203d4 extends $60657141d996856e$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if ($60657141d996856e$export$afa861e3c5730743(parsedLeft) || $60657141d996856e$export$afa861e3c5730743(parsedRight)) return $60657141d996856e$export$9a105a556e65c2c0;
            const merged = $60657141d996856e$var$mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                $60657141d996856e$export$db7caee60e5d514d(ctx, {
                    code: $60657141d996856e$export$5ba560653e4a1035.invalid_intersection_types
                });
                return $60657141d996856e$export$9a105a556e65c2c0;
            }
            if ($60657141d996856e$export$910b6cdd390341b3(parsedLeft) || $60657141d996856e$export$910b6cdd390341b3(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
$60657141d996856e$export$c02deaf0bb5203d4.create = (left, right, params)=>{
    return new $60657141d996856e$export$c02deaf0bb5203d4({
        left: left,
        right: right,
        typeName: $60657141d996856e$export$558106ce543bd011.ZodIntersection,
        ...$60657141d996856e$var$processCreateParams(params)
    });
};
class $60657141d996856e$export$e2a18bb771d8e6a3 extends $60657141d996856e$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $60657141d996856e$export$5716da67bfaa244d.array) {
            $60657141d996856e$export$db7caee60e5d514d(ctx, {
                code: $60657141d996856e$export$5ba560653e4a1035.invalid_type,
                expected: $60657141d996856e$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $60657141d996856e$export$9a105a556e65c2c0;
        }
        if (ctx.data.length < this._def.items.length) {
            $60657141d996856e$export$db7caee60e5d514d(ctx, {
                code: $60657141d996856e$export$5ba560653e4a1035.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return $60657141d996856e$export$9a105a556e65c2c0;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            $60657141d996856e$export$db7caee60e5d514d(ctx, {
                code: $60657141d996856e$export$5ba560653e4a1035.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new $60657141d996856e$var$ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return $60657141d996856e$export$5b20a5c3d05c1f6f.mergeArray(status, results);
        });
        else return $60657141d996856e$export$5b20a5c3d05c1f6f.mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new $60657141d996856e$export$e2a18bb771d8e6a3({
            ...this._def,
            rest: rest
        });
    }
}
$60657141d996856e$export$e2a18bb771d8e6a3.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new $60657141d996856e$export$e2a18bb771d8e6a3({
        items: schemas,
        typeName: $60657141d996856e$export$558106ce543bd011.ZodTuple,
        rest: null,
        ...$60657141d996856e$var$processCreateParams(params)
    });
};
class $60657141d996856e$export$a2acc09968cb4b7f extends $60657141d996856e$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $60657141d996856e$export$5716da67bfaa244d.object) {
            $60657141d996856e$export$db7caee60e5d514d(ctx, {
                code: $60657141d996856e$export$5ba560653e4a1035.invalid_type,
                expected: $60657141d996856e$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $60657141d996856e$export$9a105a556e65c2c0;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new $60657141d996856e$var$ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new $60657141d996856e$var$ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
            alwaysSet: key in ctx.data
        });
        if (ctx.common.async) return $60657141d996856e$export$5b20a5c3d05c1f6f.mergeObjectAsync(status, pairs);
        else return $60657141d996856e$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof $60657141d996856e$export$19342e026b58ebb7) return new $60657141d996856e$export$a2acc09968cb4b7f({
            keyType: first,
            valueType: second,
            typeName: $60657141d996856e$export$558106ce543bd011.ZodRecord,
            ...$60657141d996856e$var$processCreateParams(third)
        });
        return new $60657141d996856e$export$a2acc09968cb4b7f({
            keyType: $60657141d996856e$export$1230eb29b8d3b502.create(),
            valueType: first,
            typeName: $60657141d996856e$export$558106ce543bd011.ZodRecord,
            ...$60657141d996856e$var$processCreateParams(second)
        });
    }
}
class $60657141d996856e$export$163b6a2b712d9542 extends $60657141d996856e$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $60657141d996856e$export$5716da67bfaa244d.map) {
            $60657141d996856e$export$db7caee60e5d514d(ctx, {
                code: $60657141d996856e$export$5ba560653e4a1035.invalid_type,
                expected: $60657141d996856e$export$5716da67bfaa244d.map,
                received: ctx.parsedType
            });
            return $60657141d996856e$export$9a105a556e65c2c0;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new $60657141d996856e$var$ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new $60657141d996856e$var$ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return $60657141d996856e$export$9a105a556e65c2c0;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return $60657141d996856e$export$9a105a556e65c2c0;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
$60657141d996856e$export$163b6a2b712d9542.create = (keyType, valueType, params)=>{
    return new $60657141d996856e$export$163b6a2b712d9542({
        valueType: valueType,
        keyType: keyType,
        typeName: $60657141d996856e$export$558106ce543bd011.ZodMap,
        ...$60657141d996856e$var$processCreateParams(params)
    });
};
class $60657141d996856e$export$977057706f816712 extends $60657141d996856e$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $60657141d996856e$export$5716da67bfaa244d.set) {
            $60657141d996856e$export$db7caee60e5d514d(ctx, {
                code: $60657141d996856e$export$5ba560653e4a1035.invalid_type,
                expected: $60657141d996856e$export$5716da67bfaa244d.set,
                received: ctx.parsedType
            });
            return $60657141d996856e$export$9a105a556e65c2c0;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                $60657141d996856e$export$db7caee60e5d514d(ctx, {
                    code: $60657141d996856e$export$5ba560653e4a1035.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                $60657141d996856e$export$db7caee60e5d514d(ctx, {
                    code: $60657141d996856e$export$5ba560653e4a1035.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return $60657141d996856e$export$9a105a556e65c2c0;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new $60657141d996856e$var$ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new $60657141d996856e$export$977057706f816712({
            ...this._def,
            minSize: {
                value: minSize,
                message: $60657141d996856e$var$errorUtil.toString(message)
            }
        });
    }
    max(maxSize, message) {
        return new $60657141d996856e$export$977057706f816712({
            ...this._def,
            maxSize: {
                value: maxSize,
                message: $60657141d996856e$var$errorUtil.toString(message)
            }
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$60657141d996856e$export$977057706f816712.create = (valueType, params)=>{
    return new $60657141d996856e$export$977057706f816712({
        valueType: valueType,
        minSize: null,
        maxSize: null,
        typeName: $60657141d996856e$export$558106ce543bd011.ZodSet,
        ...$60657141d996856e$var$processCreateParams(params)
    });
};
class $60657141d996856e$export$d4602ba55673f53c extends $60657141d996856e$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $60657141d996856e$export$5716da67bfaa244d.function) {
            $60657141d996856e$export$db7caee60e5d514d(ctx, {
                code: $60657141d996856e$export$5ba560653e4a1035.invalid_type,
                expected: $60657141d996856e$export$5716da67bfaa244d.function,
                received: ctx.parsedType
            });
            return $60657141d996856e$export$9a105a556e65c2c0;
        }
        function makeArgsIssue(args, error) {
            return $60657141d996856e$export$244a85fde9c419ed({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $60657141d996856e$export$32f27c719778d4c4(),
                    $60657141d996856e$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $60657141d996856e$export$5ba560653e4a1035.invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return $60657141d996856e$export$244a85fde9c419ed({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $60657141d996856e$export$32f27c719778d4c4(),
                    $60657141d996856e$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $60657141d996856e$export$5ba560653e4a1035.invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof $60657141d996856e$export$3f196b0127d6e50a) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $60657141d996856e$export$c6813a8d51f77eaf(async function(...args) {
                const error = new $60657141d996856e$export$f98dac4b251ab333([]);
                const parsedArgs = await me._def.args.parseAsync(args, params).catch((e)=>{
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        } else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $60657141d996856e$export$c6813a8d51f77eaf(function(...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) throw new $60657141d996856e$export$f98dac4b251ab333([
                    makeArgsIssue(args, parsedArgs.error)
                ]);
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) throw new $60657141d996856e$export$f98dac4b251ab333([
                    makeReturnsIssue(result, parsedReturns.error)
                ]);
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new $60657141d996856e$export$d4602ba55673f53c({
            ...this._def,
            args: $60657141d996856e$export$e2a18bb771d8e6a3.create(items).rest($60657141d996856e$export$ef3b1bb1630977ae.create())
        });
    }
    returns(returnType) {
        return new $60657141d996856e$export$d4602ba55673f53c({
            ...this._def,
            returns: returnType
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new $60657141d996856e$export$d4602ba55673f53c({
            args: args ? args : $60657141d996856e$export$e2a18bb771d8e6a3.create([]).rest($60657141d996856e$export$ef3b1bb1630977ae.create()),
            returns: returns || $60657141d996856e$export$ef3b1bb1630977ae.create(),
            typeName: $60657141d996856e$export$558106ce543bd011.ZodFunction,
            ...$60657141d996856e$var$processCreateParams(params)
        });
    }
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
}
class $60657141d996856e$export$378d0cfce37406e6 extends $60657141d996856e$export$19342e026b58ebb7 {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
$60657141d996856e$export$378d0cfce37406e6.create = (getter, params)=>{
    return new $60657141d996856e$export$378d0cfce37406e6({
        getter: getter,
        typeName: $60657141d996856e$export$558106ce543bd011.ZodLazy,
        ...$60657141d996856e$var$processCreateParams(params)
    });
};
class $60657141d996856e$export$7e44096782a165d3 extends $60657141d996856e$export$19342e026b58ebb7 {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            $60657141d996856e$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $60657141d996856e$export$5ba560653e4a1035.invalid_literal,
                expected: this._def.value
            });
            return $60657141d996856e$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
$60657141d996856e$export$7e44096782a165d3.create = (value, params)=>{
    return new $60657141d996856e$export$7e44096782a165d3({
        value: value,
        typeName: $60657141d996856e$export$558106ce543bd011.ZodLiteral,
        ...$60657141d996856e$var$processCreateParams(params)
    });
};
function $60657141d996856e$var$createZodEnum(values, params) {
    return new $60657141d996856e$export$d325d1f0e1c20179({
        values: values,
        typeName: $60657141d996856e$export$558106ce543bd011.ZodEnum,
        ...$60657141d996856e$var$processCreateParams(params)
    });
}
class $60657141d996856e$export$d325d1f0e1c20179 extends $60657141d996856e$export$19342e026b58ebb7 {
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $60657141d996856e$export$db7caee60e5d514d(ctx, {
                expected: $60657141d996856e$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $60657141d996856e$export$5ba560653e4a1035.invalid_type
            });
            return $60657141d996856e$export$9a105a556e65c2c0;
        }
        if (!$60657141d996856e$var$__classPrivateFieldGet(this, $60657141d996856e$var$_ZodEnum_cache, "f")) $60657141d996856e$var$__classPrivateFieldSet(this, $60657141d996856e$var$_ZodEnum_cache, new Set(this._def.values), "f");
        if (!$60657141d996856e$var$__classPrivateFieldGet(this, $60657141d996856e$var$_ZodEnum_cache, "f").has(input.data)) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $60657141d996856e$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $60657141d996856e$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $60657141d996856e$export$9a105a556e65c2c0;
        }
        return $60657141d996856e$export$c6813a8d51f77eaf(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values, newDef = this._def) {
        return $60657141d996856e$export$d325d1f0e1c20179.create(values, {
            ...this._def,
            ...newDef
        });
    }
    exclude(values, newDef = this._def) {
        return $60657141d996856e$export$d325d1f0e1c20179.create(this.options.filter((opt)=>!values.includes(opt)), {
            ...this._def,
            ...newDef
        });
    }
    constructor(){
        super(...arguments);
        $60657141d996856e$var$_ZodEnum_cache.set(this, void 0);
    }
}
$60657141d996856e$var$_ZodEnum_cache = new WeakMap();
$60657141d996856e$export$d325d1f0e1c20179.create = $60657141d996856e$var$createZodEnum;
class $60657141d996856e$export$370b2e8d6d6f5c56 extends $60657141d996856e$export$19342e026b58ebb7 {
    _parse(input) {
        const nativeEnumValues = $60657141d996856e$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== $60657141d996856e$export$5716da67bfaa244d.string && ctx.parsedType !== $60657141d996856e$export$5716da67bfaa244d.number) {
            const expectedValues = $60657141d996856e$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $60657141d996856e$export$db7caee60e5d514d(ctx, {
                expected: $60657141d996856e$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $60657141d996856e$export$5ba560653e4a1035.invalid_type
            });
            return $60657141d996856e$export$9a105a556e65c2c0;
        }
        if (!$60657141d996856e$var$__classPrivateFieldGet(this, $60657141d996856e$var$_ZodNativeEnum_cache, "f")) $60657141d996856e$var$__classPrivateFieldSet(this, $60657141d996856e$var$_ZodNativeEnum_cache, new Set($60657141d996856e$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values)), "f");
        if (!$60657141d996856e$var$__classPrivateFieldGet(this, $60657141d996856e$var$_ZodNativeEnum_cache, "f").has(input.data)) {
            const expectedValues = $60657141d996856e$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $60657141d996856e$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $60657141d996856e$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $60657141d996856e$export$9a105a556e65c2c0;
        }
        return $60657141d996856e$export$c6813a8d51f77eaf(input.data);
    }
    get enum() {
        return this._def.values;
    }
    constructor(){
        super(...arguments);
        $60657141d996856e$var$_ZodNativeEnum_cache.set(this, void 0);
    }
}
$60657141d996856e$var$_ZodNativeEnum_cache = new WeakMap();
$60657141d996856e$export$370b2e8d6d6f5c56.create = (values, params)=>{
    return new $60657141d996856e$export$370b2e8d6d6f5c56({
        values: values,
        typeName: $60657141d996856e$export$558106ce543bd011.ZodNativeEnum,
        ...$60657141d996856e$var$processCreateParams(params)
    });
};
class $60657141d996856e$export$3f196b0127d6e50a extends $60657141d996856e$export$19342e026b58ebb7 {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $60657141d996856e$export$5716da67bfaa244d.promise && ctx.common.async === false) {
            $60657141d996856e$export$db7caee60e5d514d(ctx, {
                code: $60657141d996856e$export$5ba560653e4a1035.invalid_type,
                expected: $60657141d996856e$export$5716da67bfaa244d.promise,
                received: ctx.parsedType
            });
            return $60657141d996856e$export$9a105a556e65c2c0;
        }
        const promisified = ctx.parsedType === $60657141d996856e$export$5716da67bfaa244d.promise ? ctx.data : Promise.resolve(ctx.data);
        return $60657141d996856e$export$c6813a8d51f77eaf(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
$60657141d996856e$export$3f196b0127d6e50a.create = (schema, params)=>{
    return new $60657141d996856e$export$3f196b0127d6e50a({
        type: schema,
        typeName: $60657141d996856e$export$558106ce543bd011.ZodPromise,
        ...$60657141d996856e$var$processCreateParams(params)
    });
};
class $60657141d996856e$export$a60af00cc0ce2582 extends $60657141d996856e$export$19342e026b58ebb7 {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === $60657141d996856e$export$558106ce543bd011.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg)=>{
                $60657141d996856e$export$db7caee60e5d514d(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.async) return Promise.resolve(processed).then(async (processed)=>{
                if (status.value === "aborted") return $60657141d996856e$export$9a105a556e65c2c0;
                const result = await this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return $60657141d996856e$export$9a105a556e65c2c0;
                if (result.status === "dirty") return $60657141d996856e$export$325a211da9693fcf(result.value);
                if (status.value === "dirty") return $60657141d996856e$export$325a211da9693fcf(result.value);
                return result;
            });
            else {
                if (status.value === "aborted") return $60657141d996856e$export$9a105a556e65c2c0;
                const result = this._def.schema._parseSync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return $60657141d996856e$export$9a105a556e65c2c0;
                if (result.status === "dirty") return $60657141d996856e$export$325a211da9693fcf(result.value);
                if (status.value === "dirty") return $60657141d996856e$export$325a211da9693fcf(result.value);
                return result;
            }
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return $60657141d996856e$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return $60657141d996856e$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!$60657141d996856e$export$1ea939691cdc45b8(base)) return base;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!$60657141d996856e$export$1ea939691cdc45b8(base)) return base;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        $60657141d996856e$export$7debb50ef11d5e0b.assertNever(effect);
    }
}
$60657141d996856e$export$a60af00cc0ce2582.create = (schema, effect, params)=>{
    return new $60657141d996856e$export$a60af00cc0ce2582({
        schema: schema,
        typeName: $60657141d996856e$export$558106ce543bd011.ZodEffects,
        effect: effect,
        ...$60657141d996856e$var$processCreateParams(params)
    });
};
$60657141d996856e$export$a60af00cc0ce2582.createWithPreprocess = (preprocess, schema, params)=>{
    return new $60657141d996856e$export$a60af00cc0ce2582({
        schema: schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: $60657141d996856e$export$558106ce543bd011.ZodEffects,
        ...$60657141d996856e$var$processCreateParams(params)
    });
};
class $60657141d996856e$export$aa56fec1e9d629b8 extends $60657141d996856e$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $60657141d996856e$export$5716da67bfaa244d.undefined) return $60657141d996856e$export$c6813a8d51f77eaf(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$60657141d996856e$export$aa56fec1e9d629b8.create = (type, params)=>{
    return new $60657141d996856e$export$aa56fec1e9d629b8({
        innerType: type,
        typeName: $60657141d996856e$export$558106ce543bd011.ZodOptional,
        ...$60657141d996856e$var$processCreateParams(params)
    });
};
class $60657141d996856e$export$aaac0b8b429cef5 extends $60657141d996856e$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $60657141d996856e$export$5716da67bfaa244d.null) return $60657141d996856e$export$c6813a8d51f77eaf(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$60657141d996856e$export$aaac0b8b429cef5.create = (type, params)=>{
    return new $60657141d996856e$export$aaac0b8b429cef5({
        innerType: type,
        typeName: $60657141d996856e$export$558106ce543bd011.ZodNullable,
        ...$60657141d996856e$var$processCreateParams(params)
    });
};
class $60657141d996856e$export$bb19b37874861e7e extends $60657141d996856e$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === $60657141d996856e$export$5716da67bfaa244d.undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
$60657141d996856e$export$bb19b37874861e7e.create = (type, params)=>{
    return new $60657141d996856e$export$bb19b37874861e7e({
        innerType: type,
        typeName: $60657141d996856e$export$558106ce543bd011.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default,
        ...$60657141d996856e$var$processCreateParams(params)
    });
};
class $60657141d996856e$export$75a44ec6249ac76b extends $60657141d996856e$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: []
            }
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx
            }
        });
        if ($60657141d996856e$export$aefee5ebe1dcfd9e(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new $60657141d996856e$export$f98dac4b251ab333(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new $60657141d996856e$export$f98dac4b251ab333(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
$60657141d996856e$export$75a44ec6249ac76b.create = (type, params)=>{
    return new $60657141d996856e$export$75a44ec6249ac76b({
        innerType: type,
        typeName: $60657141d996856e$export$558106ce543bd011.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch,
        ...$60657141d996856e$var$processCreateParams(params)
    });
};
class $60657141d996856e$export$26ccfa0145e8511f extends $60657141d996856e$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $60657141d996856e$export$5716da67bfaa244d.nan) {
            const ctx = this._getOrReturnCtx(input);
            $60657141d996856e$export$db7caee60e5d514d(ctx, {
                code: $60657141d996856e$export$5ba560653e4a1035.invalid_type,
                expected: $60657141d996856e$export$5716da67bfaa244d.nan,
                received: ctx.parsedType
            });
            return $60657141d996856e$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
$60657141d996856e$export$26ccfa0145e8511f.create = (params)=>{
    return new $60657141d996856e$export$26ccfa0145e8511f({
        typeName: $60657141d996856e$export$558106ce543bd011.ZodNaN,
        ...$60657141d996856e$var$processCreateParams(params)
    });
};
const $60657141d996856e$export$cf2deea74cde46b4 = Symbol("zod_brand");
class $60657141d996856e$export$66b0c798a395271f extends $60657141d996856e$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class $60657141d996856e$export$a3c3ef8a0e95c6da extends $60657141d996856e$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return $60657141d996856e$export$9a105a556e65c2c0;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return $60657141d996856e$export$325a211da9693fcf(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return $60657141d996856e$export$9a105a556e65c2c0;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new $60657141d996856e$export$a3c3ef8a0e95c6da({
            in: a,
            out: b,
            typeName: $60657141d996856e$export$558106ce543bd011.ZodPipeline
        });
    }
}
class $60657141d996856e$export$5d1f7ef05c4e493a extends $60657141d996856e$export$19342e026b58ebb7 {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        const freeze = (data)=>{
            if ($60657141d996856e$export$1ea939691cdc45b8(data)) data.value = Object.freeze(data.value);
            return data;
        };
        return $60657141d996856e$export$aefee5ebe1dcfd9e(result) ? result.then((data)=>freeze(data)) : freeze(result);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$60657141d996856e$export$5d1f7ef05c4e493a.create = (type, params)=>{
    return new $60657141d996856e$export$5d1f7ef05c4e493a({
        innerType: type,
        typeName: $60657141d996856e$export$558106ce543bd011.ZodReadonly,
        ...$60657141d996856e$var$processCreateParams(params)
    });
};
////////////////////////////////////////
////////////////////////////////////////
//////////                    //////////
//////////      z.custom      //////////
//////////                    //////////
////////////////////////////////////////
////////////////////////////////////////
function $60657141d996856e$var$cleanParams(params, data) {
    const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
        message: params
    } : params;
    const p2 = typeof p === "string" ? {
        message: p
    } : p;
    return p2;
}
function $60657141d996856e$export$4c00f665f0d4b443(check, _params = {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal) {
    if (check) return $60657141d996856e$export$b9d1edb536b4e4eb.create().superRefine((data, ctx)=>{
        var _a, _b;
        const r = check(data);
        if (r instanceof Promise) return r.then((r)=>{
            var _a, _b;
            if (!r) {
                const params = $60657141d996856e$var$cleanParams(_params, data);
                const _fatal = (_b = (_a = params.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
                ctx.addIssue({
                    code: "custom",
                    ...params,
                    fatal: _fatal
                });
            }
        });
        if (!r) {
            const params = $60657141d996856e$var$cleanParams(_params, data);
            const _fatal = (_b = (_a = params.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
            ctx.addIssue({
                code: "custom",
                ...params,
                fatal: _fatal
            });
        }
        return;
    });
    return $60657141d996856e$export$b9d1edb536b4e4eb.create();
}
const $60657141d996856e$export$1ee8ee30835eab8b = {
    object: $60657141d996856e$export$736315c5b55efbad.lazycreate
};
var $60657141d996856e$export$558106ce543bd011;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})($60657141d996856e$export$558106ce543bd011 || ($60657141d996856e$export$558106ce543bd011 = {}));
const $60657141d996856e$export$3d916e7c22dbd8b5 = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>$60657141d996856e$export$4c00f665f0d4b443((data)=>data instanceof cls, params);
const $60657141d996856e$export$22b082955e083ec3 = $60657141d996856e$export$1230eb29b8d3b502.create;
const $60657141d996856e$export$98e628dec113755e = $60657141d996856e$export$5b070a55c0c43e09.create;
const $60657141d996856e$export$9e06de0973666692 = $60657141d996856e$export$26ccfa0145e8511f.create;
const $60657141d996856e$export$a0f65b52274bcc00 = $60657141d996856e$export$67d741fd70ff98f4.create;
const $60657141d996856e$export$4a21f16c33752377 = $60657141d996856e$export$723d146f80596191.create;
const $60657141d996856e$export$324d90190a8b822a = $60657141d996856e$export$e974be33bdc55521.create;
const $60657141d996856e$export$8f701197936bc2a6 = $60657141d996856e$export$bcc3b40f6b638044.create;
const $60657141d996856e$export$1db45310990710a5 = $60657141d996856e$export$4e780e961c30340d.create;
const $60657141d996856e$export$7b1b591b262c240 = $60657141d996856e$export$a96281f914484f2d.create;
const $60657141d996856e$export$4154a199d7d90455 = $60657141d996856e$export$b9d1edb536b4e4eb.create;
const $60657141d996856e$export$19282c40b967aec6 = $60657141d996856e$export$ef3b1bb1630977ae.create;
const $60657141d996856e$export$b3e22bcfd64c1022 = $60657141d996856e$export$1e576a20c3ce9fb5.create;
const $60657141d996856e$export$490e536ee7389aeb = $60657141d996856e$export$7d39f5df85f21031.create;
const $60657141d996856e$export$2f23118c22fb2630 = $60657141d996856e$export$7acfc3e64785411.create;
const $60657141d996856e$export$be5493f9613cbbe = $60657141d996856e$export$736315c5b55efbad.create;
const $60657141d996856e$export$8fb0df5f40d0b477 = $60657141d996856e$export$736315c5b55efbad.strictCreate;
const $60657141d996856e$export$971dd5b0dfd021b6 = $60657141d996856e$export$a8b236cb5070a311.create;
const $60657141d996856e$export$4b888e40c4ee26dd = $60657141d996856e$export$5ef2424805ac76a3.create;
const $60657141d996856e$export$bc86dfbf7795668c = $60657141d996856e$export$c02deaf0bb5203d4.create;
const $60657141d996856e$export$65e3907585753458 = $60657141d996856e$export$e2a18bb771d8e6a3.create;
const $60657141d996856e$export$e5185e241753e543 = $60657141d996856e$export$a2acc09968cb4b7f.create;
const $60657141d996856e$export$871de8747c9eaa88 = $60657141d996856e$export$163b6a2b712d9542.create;
const $60657141d996856e$export$adaa4cf7ef1b65be = $60657141d996856e$export$977057706f816712.create;
const $60657141d996856e$export$44e51c8aac7c2deb = $60657141d996856e$export$d4602ba55673f53c.create;
const $60657141d996856e$export$488013bae63b21da = $60657141d996856e$export$378d0cfce37406e6.create;
const $60657141d996856e$export$c8ec6e1ec9fefcb0 = $60657141d996856e$export$7e44096782a165d3.create;
const $60657141d996856e$export$78a99c8d44d72635 = $60657141d996856e$export$d325d1f0e1c20179.create;
const $60657141d996856e$export$6fe7eca19ebe5199 = $60657141d996856e$export$370b2e8d6d6f5c56.create;
const $60657141d996856e$export$c957ef27a0ebfd4 = $60657141d996856e$export$3f196b0127d6e50a.create;
const $60657141d996856e$export$dc573d8a6576cdb3 = $60657141d996856e$export$a60af00cc0ce2582.create;
const $60657141d996856e$export$516e28dec6a4b6d4 = $60657141d996856e$export$aa56fec1e9d629b8.create;
const $60657141d996856e$export$133fc36489ac9add = $60657141d996856e$export$aaac0b8b429cef5.create;
const $60657141d996856e$export$fc37fe19dfda43ee = $60657141d996856e$export$a60af00cc0ce2582.createWithPreprocess;
const $60657141d996856e$export$43f28b24e1eb8181 = $60657141d996856e$export$a3c3ef8a0e95c6da.create;
const $60657141d996856e$export$3b3d07727c5b702c = ()=>$60657141d996856e$export$22b082955e083ec3().optional();
const $60657141d996856e$export$eb150471a61fced6 = ()=>$60657141d996856e$export$98e628dec113755e().optional();
const $60657141d996856e$export$269251733cdcbbf1 = ()=>$60657141d996856e$export$4a21f16c33752377().optional();
const $60657141d996856e$export$8c14e57e778d3873 = {
    string: (arg)=>$60657141d996856e$export$1230eb29b8d3b502.create({
            ...arg,
            coerce: true
        }),
    number: (arg)=>$60657141d996856e$export$5b070a55c0c43e09.create({
            ...arg,
            coerce: true
        }),
    boolean: (arg)=>$60657141d996856e$export$723d146f80596191.create({
            ...arg,
            coerce: true
        }),
    bigint: (arg)=>$60657141d996856e$export$67d741fd70ff98f4.create({
            ...arg,
            coerce: true
        }),
    date: (arg)=>$60657141d996856e$export$e974be33bdc55521.create({
            ...arg,
            coerce: true
        })
};
const $60657141d996856e$export$96c94437c95d7862 = $60657141d996856e$export$9a105a556e65c2c0;
var $60657141d996856e$export$2e2bcd8739ae039 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    defaultErrorMap: $60657141d996856e$export$341b0b6e0a6f5099,
    setErrorMap: $60657141d996856e$export$1097a8289cfd22d7,
    getErrorMap: $60657141d996856e$export$32f27c719778d4c4,
    makeIssue: $60657141d996856e$export$244a85fde9c419ed,
    EMPTY_PATH: $60657141d996856e$export$1526d2e05f74572,
    addIssueToContext: $60657141d996856e$export$db7caee60e5d514d,
    ParseStatus: $60657141d996856e$export$5b20a5c3d05c1f6f,
    INVALID: $60657141d996856e$export$9a105a556e65c2c0,
    DIRTY: $60657141d996856e$export$325a211da9693fcf,
    OK: $60657141d996856e$export$c6813a8d51f77eaf,
    isAborted: $60657141d996856e$export$afa861e3c5730743,
    isDirty: $60657141d996856e$export$910b6cdd390341b3,
    isValid: $60657141d996856e$export$1ea939691cdc45b8,
    isAsync: $60657141d996856e$export$aefee5ebe1dcfd9e,
    get util () {
        return $60657141d996856e$export$7debb50ef11d5e0b;
    },
    get objectUtil () {
        return $60657141d996856e$export$4aa2142c225fd5c7;
    },
    ZodParsedType: $60657141d996856e$export$5716da67bfaa244d,
    getParsedType: $60657141d996856e$export$3e9057828ebd5c7a,
    ZodType: $60657141d996856e$export$19342e026b58ebb7,
    datetimeRegex: $60657141d996856e$export$a4b563879add27a,
    ZodString: $60657141d996856e$export$1230eb29b8d3b502,
    ZodNumber: $60657141d996856e$export$5b070a55c0c43e09,
    ZodBigInt: $60657141d996856e$export$67d741fd70ff98f4,
    ZodBoolean: $60657141d996856e$export$723d146f80596191,
    ZodDate: $60657141d996856e$export$e974be33bdc55521,
    ZodSymbol: $60657141d996856e$export$bcc3b40f6b638044,
    ZodUndefined: $60657141d996856e$export$4e780e961c30340d,
    ZodNull: $60657141d996856e$export$a96281f914484f2d,
    ZodAny: $60657141d996856e$export$b9d1edb536b4e4eb,
    ZodUnknown: $60657141d996856e$export$ef3b1bb1630977ae,
    ZodNever: $60657141d996856e$export$1e576a20c3ce9fb5,
    ZodVoid: $60657141d996856e$export$7d39f5df85f21031,
    ZodArray: $60657141d996856e$export$7acfc3e64785411,
    ZodObject: $60657141d996856e$export$736315c5b55efbad,
    ZodUnion: $60657141d996856e$export$a8b236cb5070a311,
    ZodDiscriminatedUnion: $60657141d996856e$export$5ef2424805ac76a3,
    ZodIntersection: $60657141d996856e$export$c02deaf0bb5203d4,
    ZodTuple: $60657141d996856e$export$e2a18bb771d8e6a3,
    ZodRecord: $60657141d996856e$export$a2acc09968cb4b7f,
    ZodMap: $60657141d996856e$export$163b6a2b712d9542,
    ZodSet: $60657141d996856e$export$977057706f816712,
    ZodFunction: $60657141d996856e$export$d4602ba55673f53c,
    ZodLazy: $60657141d996856e$export$378d0cfce37406e6,
    ZodLiteral: $60657141d996856e$export$7e44096782a165d3,
    ZodEnum: $60657141d996856e$export$d325d1f0e1c20179,
    ZodNativeEnum: $60657141d996856e$export$370b2e8d6d6f5c56,
    ZodPromise: $60657141d996856e$export$3f196b0127d6e50a,
    ZodEffects: $60657141d996856e$export$a60af00cc0ce2582,
    ZodTransformer: $60657141d996856e$export$a60af00cc0ce2582,
    ZodOptional: $60657141d996856e$export$aa56fec1e9d629b8,
    ZodNullable: $60657141d996856e$export$aaac0b8b429cef5,
    ZodDefault: $60657141d996856e$export$bb19b37874861e7e,
    ZodCatch: $60657141d996856e$export$75a44ec6249ac76b,
    ZodNaN: $60657141d996856e$export$26ccfa0145e8511f,
    BRAND: $60657141d996856e$export$cf2deea74cde46b4,
    ZodBranded: $60657141d996856e$export$66b0c798a395271f,
    ZodPipeline: $60657141d996856e$export$a3c3ef8a0e95c6da,
    ZodReadonly: $60657141d996856e$export$5d1f7ef05c4e493a,
    custom: $60657141d996856e$export$4c00f665f0d4b443,
    Schema: $60657141d996856e$export$19342e026b58ebb7,
    ZodSchema: $60657141d996856e$export$19342e026b58ebb7,
    late: $60657141d996856e$export$1ee8ee30835eab8b,
    get ZodFirstPartyTypeKind () {
        return $60657141d996856e$export$558106ce543bd011;
    },
    coerce: $60657141d996856e$export$8c14e57e778d3873,
    any: $60657141d996856e$export$4154a199d7d90455,
    array: $60657141d996856e$export$2f23118c22fb2630,
    bigint: $60657141d996856e$export$a0f65b52274bcc00,
    boolean: $60657141d996856e$export$4a21f16c33752377,
    date: $60657141d996856e$export$324d90190a8b822a,
    discriminatedUnion: $60657141d996856e$export$4b888e40c4ee26dd,
    effect: $60657141d996856e$export$dc573d8a6576cdb3,
    'enum': $60657141d996856e$export$78a99c8d44d72635,
    'function': $60657141d996856e$export$44e51c8aac7c2deb,
    'instanceof': $60657141d996856e$export$3d916e7c22dbd8b5,
    intersection: $60657141d996856e$export$bc86dfbf7795668c,
    lazy: $60657141d996856e$export$488013bae63b21da,
    literal: $60657141d996856e$export$c8ec6e1ec9fefcb0,
    map: $60657141d996856e$export$871de8747c9eaa88,
    nan: $60657141d996856e$export$9e06de0973666692,
    nativeEnum: $60657141d996856e$export$6fe7eca19ebe5199,
    never: $60657141d996856e$export$b3e22bcfd64c1022,
    'null': $60657141d996856e$export$7b1b591b262c240,
    nullable: $60657141d996856e$export$133fc36489ac9add,
    number: $60657141d996856e$export$98e628dec113755e,
    object: $60657141d996856e$export$be5493f9613cbbe,
    oboolean: $60657141d996856e$export$269251733cdcbbf1,
    onumber: $60657141d996856e$export$eb150471a61fced6,
    optional: $60657141d996856e$export$516e28dec6a4b6d4,
    ostring: $60657141d996856e$export$3b3d07727c5b702c,
    pipeline: $60657141d996856e$export$43f28b24e1eb8181,
    preprocess: $60657141d996856e$export$fc37fe19dfda43ee,
    promise: $60657141d996856e$export$c957ef27a0ebfd4,
    record: $60657141d996856e$export$e5185e241753e543,
    set: $60657141d996856e$export$adaa4cf7ef1b65be,
    strictObject: $60657141d996856e$export$8fb0df5f40d0b477,
    string: $60657141d996856e$export$22b082955e083ec3,
    symbol: $60657141d996856e$export$8f701197936bc2a6,
    transformer: $60657141d996856e$export$dc573d8a6576cdb3,
    tuple: $60657141d996856e$export$65e3907585753458,
    'undefined': $60657141d996856e$export$1db45310990710a5,
    union: $60657141d996856e$export$971dd5b0dfd021b6,
    unknown: $60657141d996856e$export$19282c40b967aec6,
    'void': $60657141d996856e$export$490e536ee7389aeb,
    NEVER: $60657141d996856e$export$96c94437c95d7862,
    ZodIssueCode: $60657141d996856e$export$5ba560653e4a1035,
    quotelessJson: $60657141d996856e$export$913eddeaf297cfea,
    ZodError: $60657141d996856e$export$f98dac4b251ab333
});


var $5464ab60026cc5fb$export$c5fb415882705cf4 = /*#__PURE__*/ function(ConfigError) {
    ConfigError["NotFound"] = "not_found";
    ConfigError["InvalidState"] = "state_invalid";
    ConfigError["IncorrectType"] = "incorrect_type";
    return ConfigError;
}({});
const $5464ab60026cc5fb$export$e94ee64b2671e155 = (0, $60657141d996856e$export$2e2bcd8739ae039).record((0, $60657141d996856e$export$2e2bcd8739ae039).string(), (0, $60657141d996856e$export$2e2bcd8739ae039).object({
    value: (0, $60657141d996856e$export$2e2bcd8739ae039).union([
        (0, $60657141d996856e$export$2e2bcd8739ae039).boolean(),
        (0, $60657141d996856e$export$2e2bcd8739ae039).string(),
        (0, $60657141d996856e$export$2e2bcd8739ae039).number(),
        (0, $60657141d996856e$export$2e2bcd8739ae039).string().array(),
        (0, $60657141d996856e$export$2e2bcd8739ae039).number().array()
    ])
}));
const $5464ab60026cc5fb$export$e38f7b10db0e126a = (0, $60657141d996856e$export$2e2bcd8739ae039).tuple([
    // list of boolean configs which are on
    (0, $60657141d996856e$export$2e2bcd8739ae039).string().array(),
    // list of string config tuples
    (0, $60657141d996856e$export$2e2bcd8739ae039).array((0, $60657141d996856e$export$2e2bcd8739ae039).string()).refine((arr)=>arr.length % 2 === 0),
    // list of number config tuples
    (0, $60657141d996856e$export$2e2bcd8739ae039).array((0, $60657141d996856e$export$2e2bcd8739ae039).union([
        (0, $60657141d996856e$export$2e2bcd8739ae039).string(),
        (0, $60657141d996856e$export$2e2bcd8739ae039).number()
    ])).refine((arr)=>{
        if (arr.length % 2 !== 0) return false;
        for(let i = 0; i < arr.length; i += 2){
            if (typeof arr[i] !== 'string') return false;
            if (typeof arr[i + 1] !== 'number') return false;
        }
        return true;
    }),
    // list of string list config tuples
    (0, $60657141d996856e$export$2e2bcd8739ae039).array((0, $60657141d996856e$export$2e2bcd8739ae039).union([
        (0, $60657141d996856e$export$2e2bcd8739ae039).string(),
        (0, $60657141d996856e$export$2e2bcd8739ae039).string().array()
    ])).refine((arr)=>{
        if (arr.length % 2 !== 0) return false;
        for(let i = 0; i < arr.length; i += 2){
            const key = arr[i];
            const val = arr[i + 1];
            if (typeof key !== 'string') return false;
            if (!Array.isArray(val) || !val.every((x)=>typeof x === 'string')) return false;
        }
        return true;
    }),
    // list of number list config tuples
    (0, $60657141d996856e$export$2e2bcd8739ae039).array((0, $60657141d996856e$export$2e2bcd8739ae039).union([
        (0, $60657141d996856e$export$2e2bcd8739ae039).string(),
        (0, $60657141d996856e$export$2e2bcd8739ae039).number().array()
    ])).refine((arr)=>{
        if (arr.length % 2 !== 0) return false;
        for(let i = 0; i < arr.length; i += 2){
            const key = arr[i];
            const val = arr[i + 1];
            if (typeof key !== 'string') return false;
            if (!Array.isArray(val) || !val.every((x)=>typeof x === 'number')) return false;
        }
        return true;
    })
]);
const $5464ab60026cc5fb$export$960d45de79bd7d81 = (0, $60657141d996856e$export$2e2bcd8739ae039).union([
    $5464ab60026cc5fb$export$e94ee64b2671e155,
    $5464ab60026cc5fb$export$e38f7b10db0e126a
]);
const $5464ab60026cc5fb$export$ac2e9c88ba5d7cbb = (0, $60657141d996856e$export$2e2bcd8739ae039).map((0, $60657141d996856e$export$2e2bcd8739ae039).string(), (0, $60657141d996856e$export$2e2bcd8739ae039).object({
    value: (0, $60657141d996856e$export$2e2bcd8739ae039).union([
        (0, $60657141d996856e$export$2e2bcd8739ae039).boolean(),
        (0, $60657141d996856e$export$2e2bcd8739ae039).string(),
        (0, $60657141d996856e$export$2e2bcd8739ae039).number(),
        (0, $60657141d996856e$export$2e2bcd8739ae039).string().array(),
        (0, $60657141d996856e$export$2e2bcd8739ae039).number().array()
    ])
}));
function $5464ab60026cc5fb$var$pairs(arr, fn) {
    for(let i = 0; i < arr.length; i += 2){
        const key = arr[i];
        const val = arr[i + 1];
        if (typeof key !== 'string') throw new Error(`Expected a string while iterating pairs, got: ${arr[i]}`);
        fn(key, val);
    }
}
function $5464ab60026cc5fb$export$c29ba52779f58587(minimal) {
    const map = new Map();
    minimal[0].forEach((boolean)=>map.set(boolean, {
            value: true
        }));
    $5464ab60026cc5fb$var$pairs(minimal[1], (a, b)=>map.set(a, {
            value: b
        }));
    $5464ab60026cc5fb$var$pairs(minimal[2], (a, b)=>map.set(a, {
            value: b
        }));
    $5464ab60026cc5fb$var$pairs(minimal[3], (a, b)=>map.set(a, {
            value: b
        }));
    $5464ab60026cc5fb$var$pairs(minimal[4], (a, b)=>map.set(a, {
            value: b
        }));
    return map;
}
function $5464ab60026cc5fb$export$be5b69ecb011d7cc(standard) {
    const map = new Map();
    Object.entries(standard).forEach(([key, value])=>map.set(key, value));
    return map;
}
function $5464ab60026cc5fb$export$460f06addafd9f86(map) {
    const minimal = [
        [],
        [],
        [],
        [],
        []
    ];
    for (const [key, { value: value }] of map.entries())switch(typeof value){
        case 'boolean':
            if (value) minimal[0].push(key);
            break;
        case 'string':
            minimal[1].push(key, value);
            break;
        case 'number':
            minimal[2].push(key, value);
            break;
        default:
            if (!Array.isArray(value)) throw new Error(`Unexpected configuration value: ${value}`);
            const allStrings = value.every((x)=>typeof x === 'string');
            if (allStrings) {
                minimal[3].push(key, value);
                break;
            }
            const allNumbers = value.every((x)=>typeof x === 'number');
            if (allNumbers) {
                minimal[4].push(key, value);
                break;
            }
            throw new Error(`Unexpected configuration value: ${value}`);
    }
    return minimal;
}
function $5464ab60026cc5fb$export$9d0101ad8235e092(map) {
    return Object.fromEntries(map.entries());
}


class $aa44b783f88fc33a$export$f9c837a54db411d extends Error {
    constructor(message, cause){
        super(message), this.cause = cause;
    }
}
function $aa44b783f88fc33a$var$safeParse(json) {
    try {
        return {
            data: (0, $5464ab60026cc5fb$export$960d45de79bd7d81).parse(JSON.parse(json)),
            success: true
        };
    } catch (error) {
        if (error instanceof Error) return {
            success: false,
            error: error
        };
        return {
            success: false,
            error: new $aa44b783f88fc33a$export$f9c837a54db411d('An unknown error occurred during parsing', error)
        };
    }
}
class $aa44b783f88fc33a$export$2be5653e4dada0a3 {
    static fromValues(values, options) {
        const result = $aa44b783f88fc33a$var$safeParse(values);
        if (!result.success) {
            const parseError = new $aa44b783f88fc33a$export$f9c837a54db411d('Failed to deserialize config', result.error);
            if (options?.throw) throw parseError;
            // eslint-disable-next-line no-console
            console.error(parseError);
            return $aa44b783f88fc33a$export$2be5653e4dada0a3.empty();
        }
        return this.fromData(result.data);
    }
    static fromData(data) {
        return new $aa44b783f88fc33a$export$2be5653e4dada0a3(Array.isArray(data) ? (0, $5464ab60026cc5fb$export$c29ba52779f58587)(data) : (0, $5464ab60026cc5fb$export$be5b69ecb011d7cc)(data));
    }
    static empty() {
        return new $aa44b783f88fc33a$export$2be5653e4dada0a3(new Map());
    }
    toJson(format) {
        switch(format){
            case 'standard':
                return JSON.stringify((0, $5464ab60026cc5fb$export$9d0101ad8235e092)(this.config));
            case 'minimal':
                return JSON.stringify((0, $5464ab60026cc5fb$export$460f06addafd9f86)(this.config));
        }
    }
    getBoolean(configName) {
        const config = this.config.get(configName);
        if (!config) return {
            error: (0, $5464ab60026cc5fb$export$c5fb415882705cf4).NotFound
        };
        const { value: value } = config;
        if (typeof value !== 'boolean') return {
            error: (0, $5464ab60026cc5fb$export$c5fb415882705cf4).IncorrectType,
            received: value
        };
        return {
            value: value
        };
    }
    getString(configName) {
        const config = this.config.get(configName);
        if (!config) return {
            error: (0, $5464ab60026cc5fb$export$c5fb415882705cf4).NotFound
        };
        const { value: value } = config;
        if (typeof value !== 'string') return {
            error: (0, $5464ab60026cc5fb$export$c5fb415882705cf4).IncorrectType,
            received: value
        };
        return {
            value: value
        };
    }
    getNumber(configName) {
        const config = this.config.get(configName);
        if (!config) return {
            error: (0, $5464ab60026cc5fb$export$c5fb415882705cf4).NotFound
        };
        const { value: value } = config;
        if (typeof value !== 'number') return {
            error: (0, $5464ab60026cc5fb$export$c5fb415882705cf4).IncorrectType,
            received: value
        };
        return {
            value: value
        };
    }
    getStringList(configName) {
        const config = this.config.get(configName);
        if (!config) return {
            error: (0, $5464ab60026cc5fb$export$c5fb415882705cf4).NotFound
        };
        const { value: value } = config;
        if (!Array.isArray(value) || !value.every((x)=>typeof x === 'string')) return {
            error: (0, $5464ab60026cc5fb$export$c5fb415882705cf4).IncorrectType,
            received: value
        };
        return {
            value: value
        };
    }
    getNumberList(configName) {
        const config = this.config.get(configName);
        if (!config) return {
            error: (0, $5464ab60026cc5fb$export$c5fb415882705cf4).NotFound
        };
        const { value: value } = config;
        if (!Array.isArray(value) || !value.every((x)=>typeof x === 'number')) return {
            error: (0, $5464ab60026cc5fb$export$c5fb415882705cf4).IncorrectType,
            received: value
        };
        return {
            value: value
        };
    }
    constructor(config){
        this.config = config;
    }
}



class $c902d434d02f07d8$var$StatsigConfigurations {
    static initialize(instance) {
        this.configCollection = instance;
        if ((0, $92d8da4ee454ac11$export$2e2bcd8739ae039).initializeCompleted()) this.initializeOverrides();
    }
    static initializeFromValues(configCollectionValues) {
        if (typeof configCollectionValues === 'string') // @deprecated
        this.initialize((0, $aa44b783f88fc33a$export$2be5653e4dada0a3).fromValues(configCollectionValues));
        else this.initialize((0, $aa44b783f88fc33a$export$2be5653e4dada0a3).fromData(configCollectionValues));
    }
    static initializeOverrides() {
        const featureGateOverrides = (0, $92d8da4ee454ac11$export$2e2bcd8739ae039).getOverrides();
        this.configOverrides = Object.entries(featureGateOverrides.configs).reduce((overrideConfigs, [name, value])=>{
            // We currently use FeatureGates library for Statsig gate and experiment overrides.
            // Experiment overrides are stored in the same configs object, so we need to extract the
            // overrides for dynamic configs.
            if (Object.keys(value).length === 1 && value.hasOwnProperty('value')) overrideConfigs[name] = value;
            return overrideConfigs;
        }, {});
    }
    static getValueOrDefault(getFunction, configName, defaultVal) {
        if (this.configOverrides && Object.keys(this.configOverrides).length > 0) {
            const override = this.configOverrides[configName];
            if (override && typeof override.value === typeof defaultVal) return override.value;
        }
        if (!this.configCollection) return defaultVal;
        const configResult = getFunction.call(this.configCollection, configName);
        if (!configResult || 'error' in configResult || !('value' in configResult)) return defaultVal;
        return configResult.value;
    }
    static isKillSwitchOn(configName) {
        return this.getValueOrDefault(this.configCollection?.getBoolean, configName, false);
    }
    static getBoolean(configName, defaultVal) {
        return this.getValueOrDefault(this.configCollection?.getBoolean, configName, defaultVal);
    }
    static getString(configName, defaultVal) {
        return this.getValueOrDefault(this.configCollection?.getString, configName, defaultVal);
    }
    static getNumber(configName, defaultVal) {
        return this.getValueOrDefault(this.configCollection?.getNumber, configName, defaultVal);
    }
    static getStringList(configName, defaultVal) {
        return this.getValueOrDefault(this.configCollection?.getStringList, configName, defaultVal);
    }
    static getNumberList(configName, defaultVal) {
        return this.getValueOrDefault(this.configCollection?.getNumberList, configName, defaultVal);
    }
}
/* eslint-disable import/no-default-export */ $c902d434d02f07d8$var$StatsigConfigurations.configCollection = void 0;
$c902d434d02f07d8$var$StatsigConfigurations.configOverrides = void 0;
var $c902d434d02f07d8$export$2e2bcd8739ae039 = $c902d434d02f07d8$var$StatsigConfigurations;


const $bf8e248a69b7feca$export$4e7bc78665a3b140 = ({ children: children })=>{
    if (!(0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_artificial_regression')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement((0, $dQwsT.Fragment), null, children);
    // Add a small CPU block based on severity to create visible jank
    let waste = 0;
    const timeStart = performance.now();
    // 500ms is a magic number that we use to create a visible regression
    const duration = (0, $c902d434d02f07d8$export$2e2bcd8739ae039).getNumber('confluence_artificial_regression_ms', 500);
    while(performance.now() < timeStart + duration)waste += Math.sqrt(waste + 1);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement("div", {
        id: `artificial-rerender-regression-component-regressed-by-${duration}ms`,
        "data-testid": "artificial-rerender-regression-component"
    }, children);
};





var $dQwsT = parcelRequire("dQwsT");
/* eslint-disable prefer-template */ 
const $bc1f03695ae1c02a$export$8c6bf2df244e6a99 = '/wiki';


const $a24239c0837f4ae7$export$e6eb0c6cf0c4b7e3 = 'force_transition';
const $a24239c0837f4ae7$export$b5402fcece797a50 = (prevMatch, currentMatch)=>{
    const currentForceTransitionId = currentMatch?.query?.[$a24239c0837f4ae7$export$e6eb0c6cf0c4b7e3];
    const previousForceTransitionId = prevMatch?.query?.[$a24239c0837f4ae7$export$e6eb0c6cf0c4b7e3];
    return Boolean(currentForceTransitionId && currentForceTransitionId !== previousForceTransitionId);
};


// Please do NOT remove /*@__PURE__*/ in this file.
// These comments hints Terser (webpack's minifier) to remove the definition if they are not used.
//
// Please do NOT change string concatenation to string interpolation.
// String interpolations are compiled to "".concat("").concat("") because even the latest edge don't support them natively.
// This made minifier give up removing the dead code because it can't ensure the function call won't have side effects.
//
// Please keep these optimizations here and follow the existing one if you need to add new ones.
const $0d518026f9d519cf$var$contentTransition = (prev, curr)=>prev.params.contentId !== curr.params.contentId;
const $0d518026f9d519cf$var$spaceTransition = (prev, curr)=>prev.params.spaceKey !== curr.params.spaceKey;
const $0d518026f9d519cf$export$9e15ff8aa6bc996f = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'BASE',
    pattern: '/'
});
const $0d518026f9d519cf$export$2fd309376969662f = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'WIKI',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99),
    bifrost: {
        group: 'default',
        bundling: {
            packageName: 'HomeRoute',
            whichExportToUse: 'HomeRoute'
        },
        enabled: false,
        indexHtml: 'error-app.html',
        trafficToBifrostFeatureFlag: 'bifrost-gateway-wiki-home-route-killswitch',
        exact: true
    }
});
const $0d518026f9d519cf$export$a7c5707626fc90f = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'HOME',
    ufoName: 'confluence-home',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/home/:view?',
    bifrost: {
        group: 'default',
        bundling: {
            packageName: 'HomeRoute',
            whichExportToUse: 'HomeRoute'
        },
        enabled: true,
        indexHtml: 'error-app.html',
        trafficToBifrostFeatureFlag: 'bifrost-gateway-wiki-home-route-killswitch'
    }
});
const $0d518026f9d519cf$export$6ccd7dc0d5aa30b0 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'TEMPLATE_GALLERY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/templates'
});
const $0d518026f9d519cf$export$7d65e474be175151 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'CALENDAR',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/calendar/mycalendar.action'
});
const $0d518026f9d519cf$export$ec8a7da990877da3 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'MY_CALENDAR',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/mycalendar'
});
const $0d518026f9d519cf$export$e492b3d04985e9fb = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'MULTIPLE_SUBCALENDAR',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/multiCalendars'
});
const $0d518026f9d519cf$export$57fb93d8931ad943 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'EMBEDDED_MULTIPLE_SUBCALENDAR',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/embedded/multiCalendars'
});
const $0d518026f9d519cf$export$aa473411bddb7e17 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'QUESTIONS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/plugins/servlet/ac/com.atlassian.confluence.plugins.confluence-questions/globalQuestionsViewer\\?ac.com.atlassian.confluence.plugins.confluence-questions.pattern=/questions/ask'
});
const $0d518026f9d519cf$export$42bb8ba9cae96927 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'QUESTIONS_NATIVE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/questions'
});
const $0d518026f9d519cf$export$1e92de3a3dba0876 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'QUESTION_NATIVE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/questions/:spaceKey/:questionId',
    /**
   * this will incorrectly match QUESTIONS_TOPIC_NATIVE
   * condition is used to prevent this
   */ condition: ({ params: params })=>Boolean(params.spaceKey && params.spaceKey !== 'topics')
});
const $0d518026f9d519cf$export$dec9f53c339ce8f8 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'QUESTIONS_TOPICS_NATIVE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/questions/topics'
});
const $0d518026f9d519cf$export$f80d02217688b484 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'QUESTIONS_TOPIC_NATIVE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/questions/topics/:topicName'
});
const $0d518026f9d519cf$export$fdfdf584a0978d20 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'QUESTIONS_EXPERTS_NATIVE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/questions/experts'
});
const $0d518026f9d519cf$export$6a85914fb9ca80a2 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'CONTENT_HISTORY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/history/:contentId(\\d+)/:contentSlug?'
});
const $0d518026f9d519cf$export$1f238fcead086ec3 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'CONTENT_HISTORY_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/viewpreviousversions.action'
});
const $0d518026f9d519cf$export$b74c113024023274 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'EDIT_PAGE',
    ufoName: 'edit-page',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/:contentType(pages)/edit/:contentId(\\d+)'
});
const $0d518026f9d519cf$export$45222bf0cb32d6e2 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'EDIT_BLOG',
    ufoName: 'edit-page',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/:contentType(blog)/edit/:contentId(\\d+)'
});
const $0d518026f9d519cf$export$7b1285e36c635f1f = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'EDIT_PAGE_V2',
    ufoName: 'edit-page',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/:contentType(pages)/edit-v2/:contentId(\\d+)',
    isTransition: $0d518026f9d519cf$var$contentTransition,
    bifrost: {
        group: 'default',
        bundling: {
            packageName: 'EditPageRoute',
            whichExportToUse: 'EditPageRoute'
        },
        enabled: false,
        indexHtml: 'error-app.html',
        trafficToBifrostFeatureFlag: 'bifrost-gateway-edit-page-route-killswitch',
        exact: true
    }
});
const $0d518026f9d519cf$export$36dcea4e08feb5c9 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'EDIT_BLOG_V2',
    ufoName: 'edit-page',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/:contentType(blog)/edit-v2/:contentId(\\d+)',
    isTransition: $0d518026f9d519cf$var$contentTransition
});
const $0d518026f9d519cf$export$e63a462ee45b57cf = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'EDIT_PAGE_EMBED',
    ufoName: 'edit-page-embed',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/:contentType(pages)/edit-embed/:contentId(\\d+)'
});
const $0d518026f9d519cf$export$bd17e6e353522e0d = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'EDIT_PAGE_SMART_CREATE',
    ufoName: 'edit-page-smart-create',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/:contentType(pages)/edit-smart-create/:contentId(\\d+)'
});
const $0d518026f9d519cf$export$4fe224de953acb46 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SMART_CREATE',
    ufoName: 'space-smart-create',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/space-smart-create'
});
const $0d518026f9d519cf$export$54edf7c16c47aeef = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'CREATE_CONTENT',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/create-content/:contentType'
});
const $0d518026f9d519cf$export$d6ae9e544e98926f = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'CREATE_PAGE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/:contentType(pages)/create'
});
const $0d518026f9d519cf$export$e8253e1b7e500d1c = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'CREATE_BLOG',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/:contentType(blog)/create'
});
const $0d518026f9d519cf$export$9a4ff2d809fc4156 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'DELETE_PAGE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/removepage.action\\?pageId=:contentId(\\d+)'
});
const $0d518026f9d519cf$export$19c176cd0a878008 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ONBOARDING',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/welcome'
});
const $0d518026f9d519cf$export$439074745692fe65 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_DIRECTORY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces'
});
const $0d518026f9d519cf$export$2de9a69f9b51bb83 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/viewspacesummary.action\\?key=:spaceKey([^&]+)'
});
const $0d518026f9d519cf$export$10f0439b47c8fdaf = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_REORDERPAGES',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/reorderpages.action\\?key=:spaceKey([^&]+)'
});
const $0d518026f9d519cf$export$d0ac6fa12f3acafa = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_HIDDEN_PAGES',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/listorphanedpages.action\\?key=:spaceKey([^&]+)'
});
const $0d518026f9d519cf$export$35123576da2e521 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_UNDEFINED_PAGES',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/listundefinedpages.action\\?key=:spaceKey([^&]+)'
});
const $0d518026f9d519cf$export$e18ccd8ffafdf3dd = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_ATTACHMENTS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/listattachmentsforspace.action\\?key=:spaceKey([^&]+)'
});
const $0d518026f9d519cf$export$9c4e8cdcbbacdf8f = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_APPLICATION_LINKS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + 'spaces/listentitylinks.action'
});
const $0d518026f9d519cf$export$f85f59869a8dbbf8 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_RSS_FEEDS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + 'spaces/listrssfeeds.action'
});
const $0d518026f9d519cf$export$d87089dbdd7eeaf3 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_OVERVIEW_REDIRECT_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/viewspace.action\\?key=:spaceKey([^&]+)'
});
const $0d518026f9d519cf$export$dd174db99b3e6fea = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'DELETE_SPACE_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/doremovespace.action\\?key=:spaceKey([^&]+)'
});
const $0d518026f9d519cf$export$ef26ce515f06bc5e = Object.assign(/*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_INDEX',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey',
    /**
   * /spaces/:spaceKey will incorrectly match /spaces/something.action.
   * In that case the request should be sent to Monolith.
   */ condition: ({ params: params })=>Boolean(params.spaceKey && !params.spaceKey.endsWith('.action')),
    isTransition: $0d518026f9d519cf$var$spaceTransition,
    bifrost: {
        group: 'default',
        bundling: {
            packageName: 'SpaceOverviewRoute',
            whichExportToUse: 'SpaceOverviewRouteForSSR'
        },
        enabled: false,
        indexHtml: 'error-app.html',
        trafficToBifrostFeatureFlag: 'bifrost-gateway-space-overview-route-killswitch'
    }
}), {
    /**
   * Used for optimization purposes. See SPACE_OVERVIEW for more detail.
   */ HOMEPAGE_ID_QUERY_KEY: 'homepageId'
});
const $0d518026f9d519cf$export$65b723bb995d4fb6 = Object.assign(/*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_OVERVIEW',
    ufoName: 'space-overview',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/overview',
    isTransition: $0d518026f9d519cf$var$spaceTransition,
    bifrost: {
        group: 'default',
        bundling: {
            packageName: 'SpaceOverviewRoute',
            whichExportToUse: 'SpaceOverviewRouteForSSR'
        },
        enabled: false,
        indexHtml: 'error-app.html',
        trafficToBifrostFeatureFlag: 'bifrost-gateway-space-overview-route-killswitch'
    }
}), {
    /**
   * The key/name of the optional space overview URL query parameter which was
   * introduced for optimization purposes only and is used by
   * `@confluence/query-preloaders` to preload space
   * homepage-related queries.
   */ HOMEPAGE_ID_QUERY_KEY: 'homepageId'
});
const $0d518026f9d519cf$export$1009a7f2cc1ac09f = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'HUB',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/hub'
});
const $0d518026f9d519cf$export$4dd08bdd46db5924 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'HUB_EDIT',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/hub/edit'
});
const $0d518026f9d519cf$export$ada7925da580b561 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'COMPANY_HUB',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/company-hub'
});
const $0d518026f9d519cf$export$29df24b01e938adf = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'COMPANY_HUB_ANALYTICS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/company-hub/analytics'
});
const $0d518026f9d519cf$export$e003e97fab6b4368 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'COMPANY_HUB_EDIT',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/company-hub/edit'
});
const $0d518026f9d519cf$export$5f7be6e90830de0c = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'COMPANY_HUB_SETTINGS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/company-hub/settings/:tab(general)?'
});
const $0d518026f9d519cf$export$9257b5b55c8e2555 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'VIEW_PAGE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/pages/:contentId(\\d+)/:contentSlug?',
    isTransition: (previousMatch, currentMatch)=>(0, $a24239c0837f4ae7$export$b5402fcece797a50)(previousMatch, currentMatch) || $0d518026f9d519cf$var$contentTransition(previousMatch, currentMatch),
    bifrost: {
        group: 'default',
        bundling: {
            packageName: 'ViewPageRoute',
            whichExportToUse: 'ViewPageRoute'
        },
        enabled: false,
        indexHtml: 'error-app.html',
        trafficToBifrostFeatureFlag: 'bifrost-gateway-view-page-route-killswitch'
    }
});
const $0d518026f9d519cf$export$475fdaba8e6145bb = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'NEXT_VIEW_PAGE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/next-pages/:contentId(\\d+)/:contentSlug?',
    isTransition: $0d518026f9d519cf$var$contentTransition
});
const $0d518026f9d519cf$export$347d3b5edaae00e0 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'BLOG_HOME',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/blog'
});
const $0d518026f9d519cf$export$91f49e7b30a9d34 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'VIEW_BLOG',
    ufoName: 'blog',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/blog/:contentId(\\d+)/:contentSlug?',
    isTransition: $0d518026f9d519cf$var$contentTransition,
    bifrost: {
        group: 'default',
        bundling: {
            packageName: 'ViewBlogRoute',
            whichExportToUse: 'ViewBlogRoute'
        },
        enabled: false,
        indexHtml: 'error-app.html',
        trafficToBifrostFeatureFlag: 'bifrost-gateway-view-blog-route-killswitch'
    }
});
const $0d518026f9d519cf$export$c259921a01da55b4 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'WHITEBOARD_HOME',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/whiteboard'
});
const $0d518026f9d519cf$export$5b90ced7e51bcea0 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'WHITEBOARD_BOARD',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/whiteboard/:contentId'
});
const $0d518026f9d519cf$export$7d8684a463b78f54 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'CONTACT_ADMINISTRATOR',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/contact-administrators'
});
const $0d518026f9d519cf$export$eb54044908e4e0bd = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_SETTINGS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin'
});
const $0d518026f9d519cf$export$506a1a071415f2e = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_GLOBAL_AUTOMATION',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/automation'
});
const $0d518026f9d519cf$export$4e4c6a9eb23f65ec = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_EDIT_EXTERNAL_SHARING',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/public-links'
});
const $0d518026f9d519cf$export$37055aaa9d88b944 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_FORGE_APPS_REDIRECT',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/forge\\?id=:id(.+)'
});
const $0d518026f9d519cf$export$b17d28dbf200fde0 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_FORGE_APPS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/forge/apps/:appId([0-9a-z-]+)/:envId([0-9a-z-]+)/:forgeManifestRoute([0-9a-z-]+)?/:appRoutePath*'
});
const $0d518026f9d519cf$export$5bfa1fef1b53dfdd = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_NEW_GLOBAL_PERMISSIONS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/permissions/global'
});
const $0d518026f9d519cf$export$dd6de41f650dae89 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_COMPANY_HUB_PERMISSIONS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/permissions/hub/:tab(groups|users|guests)?'
});
const $0d518026f9d519cf$export$8c6393d6207d929 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_COMPANY_HOME_BUILDER',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/look-and-feel/company-home-builder'
});
const $0d518026f9d519cf$export$9397e0d80cf06055 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_CUSTOMIZE_NAVIGATION',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/look-and-feel/customize-navigation'
});
const $0d518026f9d519cf$export$f107e7a692a3a54e = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_NEW_GLOBAL_PERMISSIONS_USER_DETAILS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/permissions/global/user/:accountId'
});
const $0d518026f9d519cf$export$5bbec961de23dce7 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_SITE_SPACE_PERMISSIONS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/permissions/space-permissions/:tab(defaults|allspaces|roles)?'
});
const $0d518026f9d519cf$export$f0e8d063cba10e9c = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_AUDIT_LOG',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/auditlogging.action'
});
const $0d518026f9d519cf$export$3039840c47d9a13d = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_BROWSE_SHORTCUTS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/browseshortcuts.action'
});
const $0d518026f9d519cf$export$e1e5a41fa357e66f = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_CREATE_SHORTCUT',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/createshortcut.action'
});
const $0d518026f9d519cf$export$4fcc3f53642c593a = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_REMOVE_SHORTCUT',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/removeshortcut.action'
});
const $0d518026f9d519cf$export$7234e6926944adc0 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_DARK_FEATURES',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/darkfeatures.action'
});
const $0d518026f9d519cf$export$b86d7bd984fb9727 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_ENABLE_DARK_FEATURE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/enabledarkfeature.action'
});
const $0d518026f9d519cf$export$1afd9317831e345e = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_DISABLE_DARK_FEATURE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/disabledarkfeature.action'
});
const $0d518026f9d519cf$export$9e8d02f6bdb565e9 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_BETA_FEATURES',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/betafeatures'
});
const $0d518026f9d519cf$export$f03a4adc711219ed = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_NEW_FEATURES',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/newfeatures'
});
const $0d518026f9d519cf$export$af040d7344c912d1 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_LIVE_EDIT',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/liveedit'
});
const $0d518026f9d519cf$export$70e53b90503ea1b9 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_NBM_MIGRATION',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/nbm-migration'
});
const $0d518026f9d519cf$export$3b3f3d2739d7f93 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_NBM_MIGRATION_SCAN',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/nbm-migration/:scanId'
});
const $0d518026f9d519cf$export$d255d2f418d43162 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_NBM_MIGRATION_UNSUPPORTED',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/nbm-migration/:scanId/unsupported'
});
const $0d518026f9d519cf$export$f313d05bcfc41be4 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_NBM_MIGRATION_UNVERIFIED',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/nbm-migration/:scanId/unverified'
});
const $0d518026f9d519cf$export$688990fbefa748b3 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_DC_SCRIPT_MIGRATION',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/script-migration'
});
const $0d518026f9d519cf$export$99ff0b9560c4fd04 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_NBM_PERFORMANCE_REPORT',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/nbm-performance-report'
});
const $0d518026f9d519cf$export$ff52f9b0a0f68578 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_NBM_PERFORMANCE_REPORT_SCAN',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/nbm-performance-report/:scanId'
});
const $0d518026f9d519cf$export$2925d036bbc38c7 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_CALENDAR',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/calendars\\?src=sidebar&openAddCalDialog=true'
});
const $0d518026f9d519cf$export$351b62e6f5786a73 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_CALENDARS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/calendars'
});
const $0d518026f9d519cf$export$4a2048bb71da8b4b = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_CALENDARS_SUBCALENDAR',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/calendars/:subCalendarId'
});
const $0d518026f9d519cf$export$7de5b687836953bd = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_EMBEDDED_SUBCALENDAR',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/embedded/calendars/:subCalendarId'
});
const $0d518026f9d519cf$export$27b2e48e28163360 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'DISCOVER',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/discover'
});
const $0d518026f9d519cf$export$f178fb5b1e822288 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ALL_UPDATES',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/discover/all-updates'
});
const $0d518026f9d519cf$export$777796688df78f56 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'POPULAR',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/discover/popular'
});
const $0d518026f9d519cf$export$3907c7d8e57f70ba = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'MY_WORK_HOME',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/my'
});
const $0d518026f9d519cf$export$fe97ee265fd89939 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'MY_WORK_DRAFTS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/my/drafts'
});
const $0d518026f9d519cf$export$b71609db3dda2696 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'MY_WORK_RECENT',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/my/recent-work'
});
const $0d518026f9d519cf$export$730392c243a0a367 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'MY_RECENTLY_VISITED',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/my/recently-visited'
});
const $0d518026f9d519cf$export$85bd3cea0cecb26c = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'MY_SAVED_FOR_LATER',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/my/saved-for-later'
});
const $0d518026f9d519cf$export$c8a37c9f76d4d03f = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'RECENT_PAGES',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/recent'
});
const $0d518026f9d519cf$export$771b75a6ca136f91 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'RECENT_VISITED',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/recent/visited'
});
const $0d518026f9d519cf$export$8e4a8343b1614a02 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'RECENT_DRAFTS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/recent/draft'
});
const $0d518026f9d519cf$export$2c9cf254b3b24ff = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'RECENT_SAVED',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/recent/saved'
});
const $0d518026f9d519cf$export$d925029e7ceadd51 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'TEMPLATE_MIGRATION_PREVIEW',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/template/migration/preview\\?templateId=:contentId([0-9a-z-]+)'
});
const $0d518026f9d519cf$export$e84c491e2d88d9f6 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'EDIT_TEMPLATE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/templates/edit/:contentId([0-9a-z-]+)'
});
const $0d518026f9d519cf$export$4ce9d0d8218b9d84 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SITE_SETTINGS_EDIT_TEMPLATE_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/templates2/editpagetemplate.action',
    condition: ({ query: query })=>Boolean(query.entityId && Object.keys(query).length === 1)
});
const $0d518026f9d519cf$export$a990a60696f54618 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'EDIT_TEMPLATE_BLUEPRINT',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/templates/edit/:pluginKey/:moduleKey'
});
const $0d518026f9d519cf$export$f8d71dcb352ebe8c = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'EDIT_DEFAULT_BLUEPRINT_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/plugins/createcontent/edit-template.action',
    condition: ({ query: query })=>Boolean(query.key && query.contentTemplateRefId && Object.keys(query).length === 2) || Boolean(query.contentTemplateRefId && Object.keys(query).length === 1)
});
const $0d518026f9d519cf$export$b45af2e1d7abb289 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SITE_SETTINGS_EDIT_SYSTEM_TEMPLATE_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/plugins/createcontent/edit-template.action',
    condition: ({ query: query })=>Boolean(query.pluginKey && query.moduleKey && Object.keys(query).length === 2)
});
const $0d518026f9d519cf$export$c0a209b0b0b16c75 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'EDIT_TEMPLATE_SPACE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/templates/edit/:contentId([0-9a-z-]+)'
});
const $0d518026f9d519cf$export$dcee5dee04648c93 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'CREATE_TEMPLATE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/templates/create'
});
const $0d518026f9d519cf$export$793ade69cc97583f = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'CREATE_TEMPLATE_SITE_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/templates2/createpagetemplate.action'
});
const $0d518026f9d519cf$export$499f432aa493cdd2 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'CREATE_TEMPLATE_SPACE_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/templates2/createpagetemplate.action',
    condition: ({ query: query })=>Boolean(query.key && Object.keys(query).length === 1)
});
const $0d518026f9d519cf$export$dcda7f8b6fe54ba = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'CREATE_TEMPLATE_SPACE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/templates/create'
});
const $0d518026f9d519cf$export$9e430f65574f5333 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'HELLO_WORLD',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/hello-world'
});
const $0d518026f9d519cf$export$e9d78b13bbb4e56f = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'DASHBOARD_ACTION_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/dashboard.action'
});
const $0d518026f9d519cf$export$d7be6003270f6c2d = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPA_ACTION_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spa.action'
});
const $0d518026f9d519cf$export$b49467be269d2629 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'INDEX_ACTION_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/index.action'
});
const $0d518026f9d519cf$export$e52245e856f5c06 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'CREATE_PAGE_ACTION_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/createpage.action'
});
const $0d518026f9d519cf$export$926e3916067d7530 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'CREATE_BLOG_ACTION_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/createblogpost.action'
});
const $0d518026f9d519cf$export$e720b1e170b46aae = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'CREATE_PAGE_VARIABLES_ACTION_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/createpage-entervariables.action'
});
const $0d518026f9d519cf$export$6c7b95dcf08f3a6d = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'RESUME_DRAFT_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/resumedraft.action'
});
const $0d518026f9d519cf$export$b010f02787df1e6 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'COPY_PAGE_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/copypage.action'
});
const $0d518026f9d519cf$export$ecc28d15af39a8b2 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'VIEW_PAGE_ACTION_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/viewpage.action',
    // viewpage.action should be served from Monolith when it has pageVersion query
    condition: ({ query: query })=>Boolean(query.pageId && Object.keys(query).length === 1)
});
const $0d518026f9d519cf$export$482db086bc8c2289 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_OVERVIEW_INDEX_ACTION_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/overview/index.action'
});
const $0d518026f9d519cf$export$3afea7266d0d139b = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_INDEX_ACTION_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/index.action'
});
const $0d518026f9d519cf$export$4eb80c3a4e6fbe0f = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_PAGES',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/pages'
});
const $0d518026f9d519cf$export$bd2c9bb170b3681d = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'VIEW_BLOG_DATE_LEGACY',
    ufoName: 'blog',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/blog/:year(\\d+)/:month(\\d+)/:day(\\d+)/:contentId(\\d+)/:contentSlug?',
    isTransition: $0d518026f9d519cf$var$contentTransition,
    bifrost: {
        group: 'default',
        bundling: {
            packageName: 'ViewBlogRoute',
            whichExportToUse: 'ViewBlogRoute'
        },
        enabled: false,
        indexHtml: 'error-app.html',
        trafficToBifrostFeatureFlag: 'bifrost-gateway-view-blog-route-killswitch'
    }
});
const $0d518026f9d519cf$export$5c9eaf42f32252ea = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ACTION_REDIRECT_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/(.*).action',
    condition: ({ query: query })=>query.key == null
});
const $0d518026f9d519cf$export$7ae0ea91a2dfc4d9 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADVANCED_SEARCH_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/dosearchsite.action'
});
const $0d518026f9d519cf$export$3bd4ec9f05d79904 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADVANCED_SEARCH',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/search',
    bifrost: {
        group: 'default',
        bundling: {
            packageName: 'AdvancedSearchRoute',
            whichExportToUse: 'AdvancedSearchRoute'
        },
        enabled: false,
        indexHtml: 'error-app.html',
        trafficToBifrostFeatureFlag: 'bifrost-gateway-search-route-killswitch'
    }
});
const $0d518026f9d519cf$export$2bc30aa6642650c = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'LABELLED_CONTENT',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/label/:spaceKey/:labelName(.+)'
});
const $0d518026f9d519cf$export$d593e642a326a501 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'EXTERNAL_SHARE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/external/:contentId?/:externalToken'
});
const $0d518026f9d519cf$export$1fa935672762674c = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SHAREABLE_LINK',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/shareable/:shareToken'
});
const $0d518026f9d519cf$export$6490fab56523ceda = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'PDF_EXPORT_PAGE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pdf/spaces/:spaceKey/pages/:contentId(\\d+)'
});
const $0d518026f9d519cf$export$dcb1d1a9cda087b1 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'PDF_EXPORT_SPACE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pdf/spaces/:spaceKey/pages/overview'
});
const $0d518026f9d519cf$export$6b2db7909585abd7 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'LEGACY_SPACE_PDF_EXPORT',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/flyingpdf/flyingpdf.action\\?key=:spaceKey([^&]+)'
});
const $0d518026f9d519cf$export$2dd65cdecd8b05d7 = new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'EXPORT_SPACE_CSV',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/exportspacecsv.action\\?key=:spaceKey'
});
const $0d518026f9d519cf$export$d78f611c1ddf7234 = new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'EXPORT_SPACE_XML',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/exportspacexml.action\\?key=:spaceKey'
});
const $0d518026f9d519cf$export$9dc7f7e5e1435bc = new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'EXPORT_SPACE_HTML',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/exportspacehtml.action\\?key=:spaceKey'
});
const $0d518026f9d519cf$export$1bc544543b946246 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'VIEW_PAGE_MOBILE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/mobile/spaces/:spaceKey/pages/:contentId(\\d+)/:contentSlug?'
});
const $0d518026f9d519cf$export$d387bb8ca9ce25d1 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'VIEW_BLOG_MOBILE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/mobile/spaces/:spaceKey/blog/:year(\\d+)/:month(\\d+)/:day(\\d+)/:contentId(\\d+)/:contentSlug?'
});
const $0d518026f9d519cf$export$3d8579587b62bb96 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'MOBILE_MACRO_RENDERER',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/mobileapp/macro/:contentId(\\d+)'
});
const $0d518026f9d519cf$export$f7bf92a6467c1557 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'PEOPLE_DIRECTORY_SEARCH',
    pattern: '/people/search'
});
const $0d518026f9d519cf$export$ed260c82a3e70a6a = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'CONFLUENCE_PEOPLE_DIRECTORY_SEARCH',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/people/search'
});
const $0d518026f9d519cf$export$a90430d7f36bfe9e = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'MARKETPLACE_FIND_APPS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/marketplace(.*)'
});
const $0d518026f9d519cf$export$22bb05181a4b1501 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'MARKETPLACE_APP_REQUESTS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/marketplace/manage/app-requests'
});
const $0d518026f9d519cf$export$cb73aa9f5b7d1ea0 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'MARKETPLACE_MANAGE_PROMOTIONS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/marketplace/manage/promotions'
});
const $0d518026f9d519cf$export$df78b182760b42f4 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'PEOPLE_DIRECTORY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/people/([\\w:-]+)*'
});
const $0d518026f9d519cf$export$2d3703cff5d9a27 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_RESTRICTED_PAGES',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/listpermissionpages.action'
});
const $0d518026f9d519cf$export$60773cf116cf5f30 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_ARCHIVED_PAGES',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/archivedpages'
});
const $0d518026f9d519cf$export$40e965fb568c3c83 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'PAGE_DIFF_BY_VERSION',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/diffpagesbyversion.action'
});
const $0d518026f9d519cf$export$cb80c94a905e11b6 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SITE_ANALYTICS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/analytics/:tab(overview|spaces|users|search)?'
});
const $0d518026f9d519cf$export$93b558a6e07dbdac = new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SITE_ANALYTICS_PERMISSIONS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/analytics/permissions'
});
const $0d518026f9d519cf$export$67acd8a63f03bc8 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_ANALYTICS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/analytics/:tab(overview|content|users)?'
});
const $0d518026f9d519cf$export$6b9c632e635b4d77 = new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_ANALYTICS_PERMISSIONS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/analytics/permissions'
});
const $0d518026f9d519cf$export$37a588b556645c19 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'PAGE_ANALYTICS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/analytics/:contentId(\\d+)/:tab(overview|mentions|links)?'
});
const $0d518026f9d519cf$export$aded01fc53d469df = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_QUESTIONS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/display/:spaceKey/customcontent/list/ac%3Acom.atlassian.confluence.plugins.confluence-questions%3Aquestion'
});
const $0d518026f9d519cf$export$cdd412f0619f2d7e = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_QUESTIONS_NATIVE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/questions'
});
const $0d518026f9d519cf$export$aa72b945229db170 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_QUESTION_NATIVE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/questions/:questionId'
});
const $0d518026f9d519cf$export$f0c4a6dc3b3437aa = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_CUSTOM_CONTENT_LIST',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/display/:spaceKey/customcontent/list/:type'
});
const $0d518026f9d519cf$export$1a5e481ee166ad7c = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'CUSTOM_CONTENT_VIEW',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/display/:spaceKey/customcontent/:contentId(\\d+)'
});
const $0d518026f9d519cf$export$f39a30a3a5635bab = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_BULK_TOOLS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/bulktools'
});
const $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH = (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/settings';
const $0d518026f9d519cf$export$3101773a7a844077 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_LANDING_PAGE',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/home'
});
const $0d518026f9d519cf$export$f03524b1e395be4a = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_LANDING_PAGE_ALT',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH
});
const $0d518026f9d519cf$export$38b94ff4631b44df = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_AUTOMATION',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/automation'
});
const $0d518026f9d519cf$export$5f63ad7e18293ec2 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_DETAILS',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/details'
});
const $0d518026f9d519cf$export$26dfba554adbf87e = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_ARCHIVE_SPACE',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/archiveSpace'
});
const $0d518026f9d519cf$export$1b93424785e5f745 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_TRASH_SPACE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/removespace.action\\?key=:spaceKey([^&]+)'
});
const $0d518026f9d519cf$export$2cc9af506d64ef72 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_EDITOR_CONVERSION',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/editorConversion'
});
const $0d518026f9d519cf$export$693d9b367ae8d0f7 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_RELATED_PAGES',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/relatedPages'
});
const $0d518026f9d519cf$export$22f8e464aee70413 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_EDIT_FEATURES',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/editFeatures'
});
const $0d518026f9d519cf$export$345aea7dc51bac8a = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_TEMPLATES',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/settings/look-and-feel/templates'
});
const $0d518026f9d519cf$export$499a561f6d1a011 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_EDIT_TEMPLATE_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/templates2/editpagetemplate.action',
    condition: ({ query: query })=>Boolean(query.entityId && query.key && Object.keys(query).length === 2)
});
const $0d518026f9d519cf$export$4f46a1e4250ebe18 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_LOOK_AND_FEEL_SETTINGS',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/look-and-feel/:tab(themes|templates|page-layout|pdf-export)'
});
const $0d518026f9d519cf$export$e64d4514fc584fbe = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_PERMISSIONS_SETTINGS',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/permissions/:tab(groups|users|guests|anonymous|public-links|analytics|apps)?'
});
const $0d518026f9d519cf$export$323161697c5fa666 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ROLE_BASED_ACCESS_CONTROL_HUB',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/roles-hub'
});
const $0d518026f9d519cf$export$2f6a532274e0cd9d = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_PERMISSIONS_APPS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/addonpermissions.action\\?key=:spaceKey([^&]+)'
});
const $0d518026f9d519cf$export$a007a4f7553ffc16 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'EDIT_SPACE_PERMISSIONS_APPS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/editaddonpermissions.action\\?key=:spaceKey([^&]+)'
});
const $0d518026f9d519cf$export$629e966630a1f92e = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_MEMBERS',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/members'
});
const $0d518026f9d519cf$export$f0e860396acf6277 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_FORGE_APPS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/apps/:appId([0-9a-z-]+)/:envId([0-9a-z-]+)/:forgeManifestRoute([0-9a-z-]+)/:appRoutePath*'
});
const $0d518026f9d519cf$export$4442c9c7bb716896 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'GLOBAL_PAGE_FORGE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/apps/:appId([0-9a-z-]+)/:envId([0-9a-z-]+)/:forgeManifestRoute([0-9a-z-]+)/:appRoutePath*'
});
const $0d518026f9d519cf$export$ffd880217e61385f = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_FORGE_APPS',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/apps/:appId([0-9a-z-]+)/:envId([0-9a-z-]+)/:forgeManifestRoute([0-9a-z-]+)?/:appRoutePath*'
});
const $0d518026f9d519cf$export$8bf619366f9e74f2 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_AVATARS_AND_STATUS',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/avatarsAndStatus'
});
const $0d518026f9d519cf$export$a85b9c60514cd043 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_CONTENT_STATE',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/contentStatuses'
});
const $0d518026f9d519cf$export$19b893a9e64dac94 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_DATA_CLASSIFICATION',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/classifications'
});
const $0d518026f9d519cf$export$3d39129bec795227 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_WATERMARK_CONFIGURATION',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/watermark'
});
const $0d518026f9d519cf$export$939b28e9f8987d97 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_EXPORT_SPACE_UNAVAILABLE',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/exportSpaceUnavailable'
});
const $0d518026f9d519cf$export$3582accdd821993a = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_EXPORT',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/export'
});
const $0d518026f9d519cf$export$871ac71d42c178c5 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_LEGACY_CONTENT',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/legacy-content'
});
const $0d518026f9d519cf$export$b8adcf19ff927cec = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_EXPORT_SPACE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/exportspacewelcome.action\\?key=:spaceKey([^&]+)'
});
const $0d518026f9d519cf$export$751ae19fa150b7c = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_TRASH',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/viewtrash.action\\?key=:spaceKey([^&]+)'
});
const $0d518026f9d519cf$export$526ccce5d32f7beb = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'MOBILE_TAKEOVER_PAGE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/mobileapp'
});
const $0d518026f9d519cf$export$ed19a29c446e24d8 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'DEFAULT_ADMIN_MANAGE_APPS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/plugins/servlet/upm'
});
const $0d518026f9d519cf$export$7de52f6cc232129e = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_APP_AUDIT_LOGS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/plugins/servlet/upm/log'
});
const $0d518026f9d519cf$export$81cfd93b1b89cd07 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_SETTINGS_TEMPLATE_LIST_PAGE_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/pages/templates2/listpagetemplates.action\\?key=:spaceKey([^&]+)'
});
const $0d518026f9d519cf$export$31745f3bff21cd = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_TEMPLATES_AND_BLUEPRINTS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/templates-and-blueprints'
});
const $0d518026f9d519cf$export$7af7a1e753a92264 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_APPLICATION_NAVIGATOR',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/application-navigator'
});
const $0d518026f9d519cf$export$28e7e683f23a58d3 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'CUSTOM_CONTENTS_ON_PAGE_LIST',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/display/:spaceKey/pages/:contentId(\\d+)/customcontents/:type?'
});
const $0d518026f9d519cf$export$3ce513606c31c918 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_ANNOUNCEMENT_BANNER_RENDERER',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/announcements/:id(.*)?'
});
const $0d518026f9d519cf$export$dfa725d05e18145e = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'USER_ACCESS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/user-access'
});
const $0d518026f9d519cf$export$8674e83405059790 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'PERMISSIONS_EXPORT',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/permissions-export'
});
const $0d518026f9d519cf$export$8b5e82a6ff458b36 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'PERMISSIONS_COMBINATIONS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/permissions-combinations'
});
const $0d518026f9d519cf$export$652395dc5ff9b416 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'IMPORTER_STATUS_DASHBOARD',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/importer-status-dashboard'
});
const $0d518026f9d519cf$export$4d1bccc78b263a8e = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'SPACE_MANAGER',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/space-manager'
});
const $0d518026f9d519cf$export$df327d9b56ca6b7c = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_CENTER',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/center'
});
const $0d518026f9d519cf$export$53f195d79ef3d4dd = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_CENTER_SPACE',
    pattern: $0d518026f9d519cf$var$SPACE_SETTINGS_CONTEXT_PATH + '/mission-control'
});
const $0d518026f9d519cf$export$23e7002e5e9ef89e = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_TEAM_CALENDARS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/teamcalendars'
});
const $0d518026f9d519cf$export$2a17c68caa9b9a01 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_TEAM_CONTROLS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/permissions/team-controls'
});
const $0d518026f9d519cf$export$299af9061dea1f09 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_CONFIGURATION',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/configuration'
});
const $0d518026f9d519cf$export$eb5a785192323bd3 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_DEFAULT_SPACE_LOGO',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/default-space-logo'
});
const $0d518026f9d519cf$export$168f3acd059931e0 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_HEADER_AND_FOOTER',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/header-and-footer'
});
const $0d518026f9d519cf$export$3bcebf4f1e82d3ad = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_SECURITY_CONFIGURATION',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/security-configuration'
});
const $0d518026f9d519cf$export$42599f111394c36c = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_SPACE_REPORTS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/space-reports'
});
const $0d518026f9d519cf$export$e05db3c2f69bd3ae = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_COLOR_SCHEME',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/color-scheme'
});
const $0d518026f9d519cf$export$4c6bf75100b3b72 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_CODE_MACRO_CONFIGURATION',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/code-macro-configuration'
});
const $0d518026f9d519cf$export$70914a626e2f0488 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_TRASHED_SPACES',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/trashed-spaces'
});
const $0d518026f9d519cf$export$3d0698fcdc33631d = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_IMPORT_SPACES',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/space-import'
});
const $0d518026f9d519cf$export$85c61af9d225a707 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_JIRA_MACRO_REPAIR',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/jira-macro-repair'
});
const $0d518026f9d519cf$export$c0d0d3f98d45e5f1 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_MACRO_USAGE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/macro-usage'
});
const $0d518026f9d519cf$export$69df75bd8c217ade = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_MACRO_USAGE_LEGACY',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/pluginusage.action'
});
const $0d518026f9d519cf$export$e8beba40e140a443 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_THEMES',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/themes'
});
const $0d518026f9d519cf$export$c471be73599ccae1 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_PDF_EXPORT',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/pdf-export'
});
const $0d518026f9d519cf$export$bb9816d0c0dcd6e6 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_WATERMARK_CONFIGURATION',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/watermark'
});
const $0d518026f9d519cf$export$94f5f2b71458cc90 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'NEW_AUDIT_LOG',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/audit-log'
});
const $0d518026f9d519cf$export$9859a7a7049d0585 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'DATABASE_CUSTOM_OVERVIEW',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/custom/database/overview'
});
const $0d518026f9d519cf$export$90480461935b54cc = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'DATABASE_CUSTOM_VIEW',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/custom/database/:contentId(\\d+)'
});
const $0d518026f9d519cf$export$851ba2be5095d586 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'DATABASE_VIEW',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/database/:contentId'
});
const $0d518026f9d519cf$export$84b5e15197aaaa12 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'EMBED_VIEW',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/embed/:contentId'
});
const $0d518026f9d519cf$export$4dcf771d1a1901ef = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'FOLDER_VIEW',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/folder/:contentId'
});
const $0d518026f9d519cf$export$752c480a913a6712 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_BULK_PERMISSIONS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/permissions/bulk-permissions'
});
const $0d518026f9d519cf$export$16172a64bcdb79f8 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ADMIN_NOTIFICATIONS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/notifications'
});
const $0d518026f9d519cf$export$59a52cdd0906f4cb = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'TOPICS',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/topics/:topicId'
});
const $0d518026f9d519cf$export$57a75dda1f25b360 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'PREMIUM_ADMIN_FEATURES_EXPERIMENT',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/admin/premium-admin-features'
});
const $0d518026f9d519cf$export$3ebf2fc23df50648 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'ATTACHMENTS_PAGE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/spaces/:spaceKey/attachments/:contentId(\\d+)?'
});
const $0d518026f9d519cf$export$96e9320cb2b14c85 = /*@__PURE__*/ new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
    name: 'AI_SEARCH_PAGE',
    pattern: (0, $bc1f03695ae1c02a$export$8c6bf2df244e6a99) + '/ai-search/'
});



var $dQwsT = parcelRequire("dQwsT");
const $4b72a15528d34979$var$nullNoop = ()=>null;
const $4b72a15528d34979$var$objNoop = ()=>({});
const $4b72a15528d34979$var$stringNoop = ()=>'';
const $4b72a15528d34979$var$voidNoop = ()=>{};
const $4b72a15528d34979$export$779e8f71c6bb38c = (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createContext({
    getHref: $4b72a15528d34979$var$stringNoop,
    history: null,
    location: null,
    match: null,
    transitionId: null,
    toUrl: $4b72a15528d34979$var$stringNoop,
    matchRoute: $4b72a15528d34979$var$nullNoop,
    matchSupportedRoute: $4b72a15528d34979$var$nullNoop,
    getQueryParams: $4b72a15528d34979$var$objNoop,
    setQueryParams: $4b72a15528d34979$var$voidNoop,
    getHash: $4b72a15528d34979$var$stringNoop,
    setHash: $4b72a15528d34979$var$voidNoop,
    replace: $4b72a15528d34979$var$voidNoop,
    routes: [],
    push: $4b72a15528d34979$var$voidNoop,
    open: $4b72a15528d34979$var$nullNoop,
    onPageReload: $4b72a15528d34979$var$voidNoop,
    preloadRoute: $4b72a15528d34979$var$voidNoop
});
$4b72a15528d34979$export$779e8f71c6bb38c.displayName = 'RoutesContext';


const $1262eee5c487dee7$export$cf1af05a5f90ab81 = (0, $91b99f9a21467aa8$export$74f458e787dc59ff)() ? function GlobalAnchorHandler() {
    $1262eee5c487dee7$var$useAnchorEventListener("click", $1262eee5c487dee7$var$spaTransitionOnAnchorClick, false);
    $1262eee5c487dee7$var$useAnchorEventListener("mousedown", $1262eee5c487dee7$var$preloadRouteOnMouseDown, true);
    $1262eee5c487dee7$var$useAnchorEventListener("preloadOnHover", $1262eee5c487dee7$var$preloadRouteOnMouseHover, true);
    return null;
} : function GlobalAnchorHandler() {
    $1262eee5c487dee7$var$useAnchorEventListener('click', $1262eee5c487dee7$var$spaTransitionOnAnchorClick, false);
    $1262eee5c487dee7$var$useAnchorEventListener('mousedown', $1262eee5c487dee7$var$preloadRouteOnMouseDown, true);
    $1262eee5c487dee7$var$useAnchorEventListener('preloadOnHover', $1262eee5c487dee7$var$preloadRouteOnMouseHover, true);
    return null;
};
function $1262eee5c487dee7$var$createAnchorEventListener(eventListener, routesContext) {
    return (e)=>{
        // Some code already handled this
        if (e.defaultPrevented) return;
        const details = $1262eee5c487dee7$export$bd34341d1dc0003f(e, routesContext);
        if (details) eventListener(e, routesContext, details);
    };
}
function $1262eee5c487dee7$var$isContentEditable(element) {
    return element instanceof HTMLElement && element.isContentEditable;
}
function $1262eee5c487dee7$export$bd34341d1dc0003f(e, routesContext) {
    if (e.type === 'preloadOnHover') {
        const detail = e.detail;
        if (detail?.preloadUrl) {
            const { preloadUrl: preloadUrl, ...preloadOptions } = detail;
            return {
                href: preloadUrl,
                ...preloadOptions
            };
        }
        return;
    }
    if (!('button' in e) || e['button'] !== 0 /* main button */ ) return;
    // Don't handle if modifier keys used
    if (e['ctrlKey'] || e['shiftKey'] || e['altKey'] || e['metaKey']) return;
    const { target: target } = e;
    if (!target || !(target instanceof Element)) return;
    // This might be the child of an anchor (such as the span inside of a smart card),
    // so check for a parent anchor.
    const anchor = target.closest('a');
    if (!anchor) return;
    //ignore hash links, they're handled by scroll handlers that also listen to document click
    if (!(anchor instanceof HTMLAnchorElement) || 'hash' in anchor && anchor['hash']) return;
    // Links in contenteditable elements are not clickable
    // https://product-fabric.atlassian.net/browse/CEMS-951
    // Checking closest 'contentEditable' for anchor,
    // In case there are "contenteditable=false" in between target and anchor.
    // Also check the property, since contenteditable="false" is possible
    const closestContentEditableFromAnchor = anchor.closest('[contenteditable]');
    const closestContentEditableFromTarget = target.closest('[contenteditable]');
    if ($1262eee5c487dee7$var$isContentEditable(closestContentEditableFromAnchor) || $1262eee5c487dee7$var$isContentEditable(closestContentEditableFromTarget)) return;
    const noGlobalAnchorHandler = target.closest('[data-no-global-anchor-handler]');
    if (noGlobalAnchorHandler) return;
    // Only handle anchors with relevant targets
    if (anchor.target && anchor.target !== '_self') return;
    const { href: href } = anchor;
    if (!href) return;
    // CONFCLOUD-69367
    // skip copy page legacy to allow user to edit page title
    // CEMS-1140
    // skip create page legacy to allow user to create a page using newer working fabric creation
    if (!routesContext || typeof routesContext.matchRoute !== 'function') return;
    const match = routesContext.matchRoute(href);
    if (match && (match.name === (0, $0d518026f9d519cf$export$b010f02787df1e6).name || match.name === (0, $0d518026f9d519cf$export$e52245e856f5c06).name)) return;
    return {
        href: href
    };
}
function $1262eee5c487dee7$var$preloadRouteOnMouseDown(_, { preloadRoute: preloadRoute }, { href: href }) {
    preloadRoute(href);
}
function $1262eee5c487dee7$var$preloadRouteOnMouseHover(_, { preloadRoute: preloadRoute }, { href: href, ...preloadOptions }) {
    preloadRoute(href, preloadOptions);
}
function $1262eee5c487dee7$var$spaTransitionOnAnchorClick(e, { push: push }, { href: href }) {
    e.preventDefault();
    push(href, Boolean((0, $0d518026f9d519cf$export$d593e642a326a501).match(window.location.pathname)));
}
const $1262eee5c487dee7$var$useAnchorEventListener = (0, $91b99f9a21467aa8$export$74f458e787dc59ff)() ? function useAnchorEventListener(type, anchorEventListener, useCapture) {
    const $ = (0, $90332d3d6df1e1ff$exports.c)(8);
    const routesContext = (0, $dQwsT.useContext)((0, $4b72a15528d34979$export$779e8f71c6bb38c));
    let t0;
    if ($[0] !== anchorEventListener || $[1] !== routesContext) {
        t0 = $1262eee5c487dee7$var$createAnchorEventListener(anchorEventListener, routesContext);
        $[0] = anchorEventListener;
        $[1] = routesContext;
        $[2] = t0;
    } else t0 = $[2];
    const eventListener = t0;
    let t1;
    let t2;
    if ($[3] !== eventListener || $[4] !== type || $[5] !== useCapture) {
        t1 = ()=>{
            if (eventListener) window.addEventListener(type, eventListener, useCapture);
            return ()=>{
                if (eventListener) window.removeEventListener(type, eventListener, useCapture);
            };
        };
        t2 = [
            eventListener,
            type,
            useCapture
        ];
        $[3] = eventListener;
        $[4] = type;
        $[5] = useCapture;
        $[6] = t1;
        $[7] = t2;
    } else {
        t1 = $[6];
        t2 = $[7];
    }
    (0, $dQwsT.useEffect)(t1, t2);
} : function useAnchorEventListener(type, anchorEventListener, useCapture) {
    const routesContext = (0, $dQwsT.useContext)((0, $4b72a15528d34979$export$779e8f71c6bb38c));
    const eventListener = (0, $dQwsT.useMemo)(()=>$1262eee5c487dee7$var$createAnchorEventListener(anchorEventListener, routesContext), [
        anchorEventListener,
        routesContext
    ]);
    (0, $dQwsT.useEffect)(()=>{
        if (eventListener) window.addEventListener(type, eventListener, useCapture);
        return ()=>{
            if (eventListener) window.removeEventListener(type, eventListener, useCapture);
        };
    }, [
        eventListener,
        type,
        useCapture
    ]);
};





var $dQwsT = parcelRequire("dQwsT");
const $32f18ec2049bb41d$var$GlobalPromptContext = /*#__PURE__*/ (0, $dQwsT.createContext)(null);
const $32f18ec2049bb41d$export$71d99832f5dd52ec = (0, $91b99f9a21467aa8$export$74f458e787dc59ff)() ? ()=>{
    return (0, $dQwsT.useContext)($32f18ec2049bb41d$var$GlobalPromptContext);
} : ()=>(0, $dQwsT.useContext)($32f18ec2049bb41d$var$GlobalPromptContext);
const $32f18ec2049bb41d$export$a082affa499ae96f = (0, $91b99f9a21467aa8$export$74f458e787dc59ff)() ? (t0)=>{
    const $ = (0, $90332d3d6df1e1ff$exports.c)(5);
    const { children: children, globalPromptHandler: globalPromptHandler } = t0;
    let t1;
    if ($[0] !== globalPromptHandler) {
        t1 = {
            globalPromptHandler: globalPromptHandler
        };
        $[0] = globalPromptHandler;
        $[1] = t1;
    } else t1 = $[1];
    const contextValue = t1;
    let t2;
    if ($[2] !== children || $[3] !== contextValue) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement($32f18ec2049bb41d$var$GlobalPromptContext.Provider, {
            value: contextValue
        }, children);
        $[2] = children;
        $[3] = contextValue;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ children: children, globalPromptHandler: globalPromptHandler })=>{
    const contextValue = (0, $dQwsT.useMemo)(()=>({
            globalPromptHandler: globalPromptHandler
        }), [
        globalPromptHandler
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement($32f18ec2049bb41d$var$GlobalPromptContext.Provider, {
        value: contextValue
    }, children);
};



class $b7f189155d041ca2$export$aea2bc6590a5ea49 {
    /**
   * Registers a prompt string with its associated callback function.
   * This should be used in place of react-router's Prompt functionality. When registered, the callback
   * will be executed on every route change attempt, blocking the route change (the transition).
   *
   * The callback should return:
   * - true to show the prompt and block navigation
   * - false to allow navigation without prompting
   *
   * User interaction flow:
   * - If callback returns true, the user will see a browser confirmation dialog (window.confirm) with the provided message.
   * - If user clicks "OK", the route change continues and the prompt is automatically cleared.
   * - If user clicks "Cancel", the route change is prevented and the prompt remains active.
   * - If the route change is successful even if prompt wasn't shown, the prompt state is cleared automatically.
   *
   * Technical Reminders:
   * - When registering a prompt, ensure your implementation clears the prompt if it is no longer needed, by invoking clear().
   * - There can only be a maximum of one prompt registered at a time. Ensure your code flow won't conflict with existing use cases of registerPrompt.
   *
   * @param {Object} params - The parameters for the prompt registration.
   * @param {string} params.promptString - The message displayed in the browser confirmation dialog.
   * @param {PromptCallback} params.callback - A function that receives route transition info and returns true to show the confirmation dialog, false to allow navigation without prompting.
   */ registerPrompt({ promptString: promptString, callback: callback, onConfirm: onConfirm, onCancel: onCancel }) {
        this.promptString = promptString;
        this.promptCallback = callback;
        this.onConfirm = onConfirm ?? null;
        this.onCancel = onCancel ?? null;
    }
    /**
   * Clears the currently stored prompt string and callback, resetting the handler state.
   * This is done automatically on successful route change, but you should invoke it if you registered the prompt and no longer need it.
   */ clear() {
        this.promptString = null;
        this.promptCallback = null;
        this.onConfirm = null;
        this.onCancel = null;
    }
    /**
   * Gets the current prompt string if it exists and the callback returns true.
   *
   * @param {Object} args - The route transition arguments.
   * @param {RouteMatch | null} args.previousMatch - The previous route match.
   * @param {RouteMatch} args.nextMatch - The next route match.
   * @returns {string | null} The prompt string if conditions are met, null otherwise.
   */ getPromptString(args) {
        if (!this.promptString || !this.promptCallback) return null;
        try {
            const shouldPrompt = this.promptCallback({
                previousMatch: args.previousMatch,
                nextMatch: args.nextMatch
            });
            return shouldPrompt ? this.promptString : null;
        } catch (error) {
            this.logger.error`Error executing prompt callback: ${error}`;
            return null;
        }
    }
    /**
   * Triggers the prompt if it exists and the prompt callback returns true.
   *
   * @param {Object} args - The route transition arguments.
   * @param {RouteMatch | null} args.previousMatch - The previous route match.
   * @param {RouteMatch} args.nextMatch - The next route match.
   * @returns {Object} Returns {isPromptBlocking: true} if transition should be blocked because prompt was shown and user canceled,
   *                   otherwise returns {isPromptBlocking: false}
   */ triggerPrompt({ previousMatch: previousMatch, nextMatch: nextMatch }) {
        if (!this.promptString) return {
            isPromptBlocking: false
        };
        const promptString = this.getPromptString({
            previousMatch: previousMatch,
            nextMatch: nextMatch
        });
        if (promptString) {
            const userConfirmed = window.confirm(promptString);
            if (userConfirmed) {
                this.onConfirm?.();
                this.clear();
            } else {
                this.onCancel?.();
                // User cancelled, block the transition
                return {
                    isPromptBlocking: true
                };
            }
        }
        return {
            isPromptBlocking: false
        };
    }
    constructor(){
        this.logger = (0, $a6897acd40ed68b1$export$2b1d391cd05230fd)('GlobalPromptHandler');
        this.promptString = null;
        this.promptCallback = null;
        this.onConfirm = null;
        this.onCancel = null;
    }
}





var $8V6O9 = parcelRequire("8V6O9");


class $e7d32f2c649e2db9$export$46a841557056026b extends Error {
    constructor(message){
        super(message);
        this.name = 'ExternalRejectionError';
    }
}
class $e7d32f2c649e2db9$export$2f8f0e0ec8218c4b {
    /**
   * Registers a transition callback that will be awaited on a route change.
   * The callback will only be invoked if the `onlyCalledIfFunc` returns true or if `onlyCalledIfFunc` is not provided. e.g. To check that a contentId is what you expect it should be. `onlyCalledIfFunc` should be very performant as it will run every route change.
   *
   * PERFORMANCE WARNING: `onlyCalledIfFunc` is executed every route change, and `callback` promise is awaited every time `onlyCalledIfFunc` returns `true` (or if it doesn't exist).
   *                      If either of these functions are not very performant, it could cause undesirable performance degradation on every transition.
   *                      Try to avoid any time-intensive invocations, especially in `onlyCalledIfFunc`. `onlyCalledIfFunc` ideally only runs a condition the `match` that it's passed, e.g. to check `match.params.contentId` or `match.pathname`.
   *                      BEFORE REGISTERING A NEW TRANSITION CALLBACK, you must be confident that the negative performance impact is acceptable.
   *
   * @example registerTransitionCallback({
   *     id: 'unique-id-related-to-my-code',
   *     callback: ({match}) => {
   *         // Do preloading logic, must return a promise
   *         return new Promise((resolve) => {
   *             const nextContentId = match.params?.contentId;
   *             // do logic that is a hard pre-requisite for next route and cannot be lazy/concurrently loaded, ideally shouldn't be slow
   *             resolve(); // route change gets unblocked after these callback promises are resolved
   *         }
   *     },
   *     onlyCalledIfFunc: ({match}) => {
   *         // Optional but recommended
   *         const nextContentId = match.params?.contentId;
   *         // Do very quick logic, ideally no logic that we need to wait for, this function is run every route change
   *         if (isLiveDoc(contentId)) {
   *             return true;
   *         } else {
   *             return false;
   *         }
   *     },
   *     onPerformanceMetricStart: ({match}) => {
   *         // Optional but recommended
   *         const nextContentId = match.params?.contentId;
   *         // Should be used to quickly start any page load performance metrics that you want to track for this route change
   *         // If you don't use this, your existing page load metric will likely start after the preloading and after the route change.
   *         // We want page load metrics to start before preloading, not after.
   *     },
   *     onRouteContinueCallback: async ({match}) => {
   *		   // Optional, must return a promise (i.e. or be async)
   *         const nextContentId = match.params?.contentId;
   *         // Do very quick logic that will run only if we're about to transition routes, runs after callback promise.
   *         // Can be used to do logic that you want to ensure doesn't occur on outdated route changes, e.g. connecting to nextContentId's collab provider
   *     },
   * });
   *
   * @param {Object} params - The parameters for the transition callback.
   * @param {string} params.id - A unique identifier used to inform other components the callback was run, to clean up outdated promises, and to prevent duplicate callback registrations.
   * @param {TransitionCallback} params.callback - The callback function to be executed during a route transition. Must return a promise.
   * @param {OnlyCalledIfFunc} params.onlyCalledIfFunc - A function that determines whether the callback should be called.
   * @param {OnRouteContinueCallback} params.onRouteContinueCallback - Callback function that must return a promise. This is called right after the transition callback promises finish but before we continue the route transition, the returned promise blocks route transition. This function won't be called if route has changed before callback promise resolves.
   * @param {OnPerformanceMetricStartCallback} params.onPerformanceMetricStart - Callback function to start performance metrics. Called as we start running the transition callback promises.
   * @returns {boolean} - Returns `true` if the transition callback was registered, `false` if it was not registered (due to already being registered or being mid-transition).
   */ registerTransitionCallback({ id: id, callback: callback, onlyCalledIfFunc: onlyCalledIfFunc, onRouteContinueCallback: onRouteContinueCallback, onPerformanceMetricStart: onPerformanceMetricStart }) {
        // We want to keep transition callbacks unique to guarantee we aren't duplicating work, so we tie callbacks to an ID. If there are multiple registrations of the same callback ID, we ignore registration attempts if we're already registered.
        // We don't allow registering transition callbacks while transitioning, to avoid race conditions leading to infinite route change loops.
        if (this.transitionProcessingState !== 'not_processing' || this.callbacks.has(id)) return false;
        this.callbacks.set(id, {
            callback: callback,
            onlyCalledIfFunc: onlyCalledIfFunc,
            onRouteContinueCallback: onRouteContinueCallback,
            onPerformanceMetricStart: onPerformanceMetricStart
        });
        return true;
    }
    /**
   * Processes transition callbacks during a route change, checking if we need to create promises from callbacks, and waiting for them to resolve/reject before continuing the route change.
   * `processTransitionCallback` will set `this.isTransitionCallbackRunning` to true, preventing callback registration. RouteManager is responsible for clearing it via `onTransitionComplete`.
   *
   * @param {{ match: Match; onRouteContinue: () => void; transitionId: number; interactionContext?: UFOInteractionContextType | null }} args - The arguments containing the route `match` object, RouteManager `transitionId`, the `onRouteContinue` continuation function, and optional UFO interaction context.
   *                                                                                     `onRouteContinue` is called once promises resolve and should finish executing the route change.
   * @returns {boolean} - Returns `true` if processing transition callback and transition should not continue (until promise finishes and calls onRouteContinue).
   *                      Returns `false` if not processing transition callback and routeChangeHandler should continue running.
   */ processTransitionCallback({ match: match, transitionId: transitionId, onRouteContinue: onRouteContinue, interactionContext: interactionContext, startPageLoadMetrics: startPageLoadMetrics }) {
        try {
            if (!this.callbacks.size) {
                // Update latest route details to keep this.getCurrentRouteCallbackIds() is accurate. If transitionId has changed, accurately reflect that there are no callbackIds for that route change.
                if (transitionId !== this.currentRouteDetails.transitionId) this.currentRouteDetails = {
                    transitionId: transitionId,
                    callbackIds: [],
                    pathname: match?.pathname || ''
                };
                return {
                    isProcessingCallback: false
                };
            }
            this.transitionProcessingState = 'processing';
            const previousPathname = this.latestPathname;
            this.latestPathname = match?.pathname;
            if (this.latestPathname !== previousPathname) // Cancel all currently running promises because we're going to a different route. Helps prevent multiple quick route changes from causing race condition that could send user to outdated route change.
            // If needed, `getCallbackPromises` below will create new promises for the latest route.
            this.cancelActivePromises();
            const { callbackIds: callbackIds } = this.getCallbackIds({
                match: match
            });
            const { callbackPromises: callbackPromises, callbackPromiseIds: callbackPromiseIds, callbackPromiseObjects: callbackPromiseObjects } = this.getCallbackPromises({
                match: match,
                callbackIds: callbackIds
            });
            // Cancel outdated actively running promises that aren't for the latest callbackIds
            this.cleanupOutdatedCallbacks(callbackIds);
            if (!callbackPromises.length) {
                // If there are no callback promises, route change will immediately continue. Reset our callbacks state as we don't want registered callbacks to linger once the user leaves the route. Callbacks should be registered on page/etc load if needed.
                // EDGE CASE: If the user is on a live doc and quickly clicks a non-live-doc like a view page, then quickly clicks back into a live doc before the view page has loaded, the preload-live-doc callback may have been removed, slowing down load time into that live doc.
                //            We'll solve for this in the future by always checking if we should preload a live doc on any route change, by never unregistering that callback
                this.reset();
                return {
                    isProcessingCallback: false
                };
            }
            // Start browser metrics page load
            startPageLoadMetrics?.(match?.name ?? '', match?.ufoName, transitionId, match?.params?.contentId);
            // Ensure UFO page load metric continues tracking the page load from start of preloading. If we don't hold here, UFO metric finishes prematurely on route change.
            // We should stop holding right after the route change is completed.
            const ufoStopHold = interactionContext?.hold?.('GlobalTransitionPreloader');
            callbackPromiseObjects.forEach(({ onPerformanceMetricStart: onPerformanceMetricStart })=>{
                onPerformanceMetricStart?.({
                    match: match
                });
            });
            // Timeout for all promises to prevent indefinite waiting
            const TIMEOUT_MS = 10000; // 10 seconds
            // Flag to prevent race conditions between timeout and promise completion
            // Only one of them should trigger the route transition
            let hasRouteTransitionCompleted = false;
            // Set up timeout
            const timeoutId = setTimeout(()=>{
                // Only execute if route transition hasn't been completed by promise resolution
                if (!hasRouteTransitionCompleted) {
                    hasRouteTransitionCompleted = true;
                    this.logger.error`Callback promises timed out after ${TIMEOUT_MS}ms, forcing route transition`;
                    this.reset();
                    onRouteContinue();
                    (0, $b76dfd1db5681318$export$e9ba7ef9458d1a4a)().then((analyticsWebClient)=>{
                        analyticsWebClient.sendOperationalEvent({
                            action: 'confluence_live_doc_smooth_transition_timeout',
                            actionSubject: 'callback_promises_timed_out',
                            attributes: {
                                callbackPromiseIds: callbackPromiseIds.join(',')
                            },
                            source: 'GlobalTransitionPreloader'
                        });
                    });
                }
            }, TIMEOUT_MS); // Handle all the promises and then send the user to the next route if appropriate.
            Promise.allSettled(callbackPromises).then((promiseResults)=>{
                // Only proceed if timeout hasn't already triggered the route transition
                if (hasRouteTransitionCompleted) return;
                // Mark that we're handling the route transition to prevent timeout from also executing
                hasRouteTransitionCompleted = true;
                // Clear timeout if callbacks completed first
                clearTimeout(timeoutId);
                const onRouteContinueCallbacks = [];
                let externallyRejectedCount = 0;
                promiseResults.forEach((result, index)=>{
                    if (result.status === 'rejected') {
                        if (callbackPromiseObjects[index].isExternallyRejected) externallyRejectedCount++;
                        else this.logger.error`There was an error with a transition callback promise: ${result.reason}, active callbackPromiseIds: ${callbackPromiseIds.join(',')}`;
                    } else {
                        const { onRouteContinueCallback: onRouteContinueCallback } = callbackPromiseObjects[index];
                        if (onRouteContinueCallback) onRouteContinueCallbacks.push(onRouteContinueCallback);
                    }
                });
                if (externallyRejectedCount < callbackPromises.length) {
                    const onRouteContinueCallbackPromises = onRouteContinueCallbacks.map((callback)=>callback({
                            match: match
                        }));
                    // Only update state if most promises weren't externally rejected (indicating this is still the current transition)
                    this.currentRouteDetails.callbackIds = callbackPromiseIds;
                    this.currentRouteDetails.transitionId = transitionId;
                    this.currentRouteDetails.pathname = match?.pathname || '';
                    this.transitionProcessingState = 'processing_completed';
                    // On successful next route, we clear the currently registered callbacks. Callbacks should be registered on page/etc load if needed.
                    this.callbacks = new Map();
                    this.activelyRunningCallbackPromises = {};
                    Promise.allSettled(onRouteContinueCallbackPromises).then(()=>{
                        // If all promises have been externally rejected, that means these promises are for an outdated route change, the user has since changed routes again, so we don't want to redirect the user to the route.
                        // This avoids race condition scenarios where user goes from Doc A -> Doc B -> Doc C, but ends up on Doc B because its promises finished after Doc C's promises.
                        // On successful next route, we clear the currently registered callbacks. Callbacks should be registered on page/etc load if needed.
                        this.callbacks = new Map();
                        this.activelyRunningCallbackPromises = {};
                        onRouteContinue();
                    });
                }
            });
            return {
                isProcessingCallback: true,
                ufoStopHold: ufoStopHold ? ()=>ufoStopHold?.() : undefined
            };
        } catch (error) {
            this.logger.error`There was an error running processTransitionCallback: ${error}, registered callbackIds: ${Array.from(this.callbacks.keys()).join(',')}`;
        }
        return {
            isProcessingCallback: false
        };
    }
    /**
   * Retrieve callback IDs that ran on the current route. Can be useful to determine if your page was already preloaded or not.
   * Recommended to only run this if you are finished transitioning. If you may be mid-transition (unlikely unless using Prompt), use `getRouteCallbackIdsByMatch`.
   *
   * @returns {string[]} - List of registered transition callback IDs that ran on current route when transitioning into it
   */ getCurrentRouteCallbackIds() {
        return [
            ...this.currentRouteDetails.callbackIds
        ];
    }
    /**
   * Retrieve callback IDs that will be run on the specified match. This function looks at this.transitionProcessingState to determine which callback IDs to return.
   * Recommended to only run this if you may be mid-transition, otherwise `getCurrentRouteCallbackIds` is preferable.
   * Can be useful to determine if the match will be preloaded or not during transition, e.g. to determine whether a Prompt callback shows prompt.
   *
   * @returns {string[]} - List of registered transition callback IDs that will run speciifed match when transitioning into it
   */ getRouteCallbackIdsByMatch(match) {
        if (!match?.pathname) return [];
        /**
     *  - If GlobalTransitionPreloader.processTransitionCallback is processing the same match as the specified match:
     *    - If we're mid-transition ('processing'), we use the memoized callback IDs that were set when `processingTransitionCallback` called `getCallbackIds`.
     *      - If memoized callback IDs don't exist (e.g. calling this too quickly right after processingTransitionCallback is called), we fetch the callback IDs for the specified match.
     *    - If we're finished processing ('processing_completed') but haven't finished transitioning yet, we use the current route callback IDs.
     *
     *  - If the specified match is different from the match being processed, or if we are not processing a match ('not_processing'), then we fetch the callback IDs for the specified match.
     */ if (this.transitionProcessingState === 'processing' && this.cachedCallbackIds?.callbackIds && this.cachedCallbackIds?.pathname === match.pathname) return [
            ...this.cachedCallbackIds.callbackIds
        ];
        else if (this.transitionProcessingState === 'processing_completed' && this.currentRouteDetails.pathname === match.pathname) return [
            ...this.currentRouteDetails.callbackIds
        ];
        else return this.getCallbackIds({
            match: match
        }).callbackIds;
    }
    /**
   * Resets the preloader to its initial state by clearing all registered callbacks,
   * canceling any actively running promises, and resetting internal state.
   * This can be useful for cleanup or testing scenarios.
   */ reset() {
        this.cancelActivePromises();
        this.callbacks = new Map();
        this.activelyRunningCallbackPromises = {};
        this.latestPathname = '';
        this.currentRouteDetails.callbackIds = [];
        this.currentRouteDetails.pathname = '';
        this.cachedCallbackIds = null;
        // If we started processing, mark as processing completed. We only set to not_processing in onTransitionComplete, to disallow registering callbacks mid-transition.
        if (this.transitionProcessingState !== 'not_processing') this.transitionProcessingState = 'processing_completed';
    }
    /**
   * Router is responsible for running this function when the route has technically changed (routeChangeHandler).
   @param {number} transitionId - The transition ID of the route that has completed, coming from RouteManager
   */ onTransitionComplete(transitionId) {
        // When GlobalTransitionPreloader processes transition callbacks, it sets its transition running flag to true.
        // When it's done processing transition callbacks and the route has changed, we should clear the transition running flag.
        // This is used to prevent race conditions caused by problematic globalTransitionPreloader callback registrations during route changes.
        // For instance: If a callback is registered mid-transition, then when `routeBlockHandler` is called a second time by `onRouteContinue`,
        //               processTransitionCallback may try to process it after it has already processed it, leading to an infinite loop.
        this.transitionProcessingState = 'not_processing';
        this.cachedCallbackIds = null;
        // Transition ID from RouteManager is stored in this.currentRouteDetails before we call `routeChangeHandler`.
        // If we processed a transition callback, it'll always be one behind RouteManager
        // If transition IDs are misaligned and currentRouteDetails.callbackIds is non-empty, we're in an invalid state likely due to routeBlockHandler/processTransitionCallback unexpectedly not being triggered
        // If we're in this invalid state, reset the current route details callback IDs to prevent components from thinking we're in a preloaded state when we're not.
        if (this.currentRouteDetails.transitionId !== transitionId && this.currentRouteDetails.callbackIds.length > 0) {
            this.logger.error`GlobalTransitionPreloader is in an invalid state, transitionId mismatch, callbackIds are non-empty. Resetting callbackIds. Invalid callbackIds are: ${this.currentRouteDetails.callbackIds.join(',')}`;
            this.currentRouteDetails.callbackIds = [];
        }
    }
    /**
   * Generates an array of callback ids that should be processed before the next transition, filtering out
   * callbacks which are not supposed to run based on their `onlyCalledIfFunc` evaluation.
   * Caches most recent array of callback IDs as `this.cachedCallbackIds`
   * @param { match: Match } params The params for the method including the match object.
   * @returns { callbackIds: Array<string> } An object containing an array of callback ids that should be processed
   */ getCallbackIds({ match: match }) {
        const callbackIds = [];
        if (!this.callbacks.size) {
            this.cachedCallbackIds = {
                pathname: match.pathname,
                callbackIds: []
            };
            return {
                callbackIds: callbackIds
            };
        }
        this.callbacks.forEach(({ onlyCalledIfFunc: onlyCalledIfFunc }, callbackId)=>{
            // Call our `onlyCalledIfFunc` if it's set, we're only waiting for this callback promise if it's `true` or if it's not set.
            const isCallAllowed = onlyCalledIfFunc ? onlyCalledIfFunc({
                match: match
            }) : true;
            if (isCallAllowed) callbackIds.push(callbackId);
        });
        // Cache the result for the most recent invocation, may be fetched by `getRouteCallbackIdsByMatch` when we're mid-transition, avoids additional onlyCalledIfFunc calls.
        this.cachedCallbackIds = {
            pathname: match.pathname,
            callbackIds: [
                ...callbackIds
            ]
        };
        return {
            callbackIds: callbackIds
        };
    }
    /**
   * Creates an array of promises from registered callbacks that should be executed
   * during a route transition. This method checks conditions under which each callback
   * should be called and manages the lifecycle of the promises.
   * Will clean up outdated promises.
   *
   * @private
   * @param { match: Match, callbackIds: Array<string> } params - The parameters for the method, containing the match object and callback IDs.
   * @returns { callbackPromises: Array<Promise<void>>, callbackPromiseIds: Array<string> } An object containing an array of promises and their corresponding IDs.
   */ getCallbackPromises({ match: match, callbackIds: callbackIds }) {
        const callbackPromises = [];
        const callbackPromiseIds = []; // Recommendation is to use this to help provide context to promise errors
        const callbackPromiseObjects = [];
        callbackIds.forEach((callbackId)=>{
            const callbackConfig = this.callbacks.get(callbackId);
            if (!callbackConfig) return; // This should never happen
            const { callback: callback, onRouteContinueCallback: onRouteContinueCallback, onPerformanceMetricStart: onPerformanceMetricStart } = callbackConfig;
            const activeCallbackPromise = this.activelyRunningCallbackPromises[callbackId];
            // If we want to trigger a callback promise, return the already running one if we have it, otherwise create a new one.
            if (activeCallbackPromise) {
                callbackPromises.push(activeCallbackPromise.promise);
                callbackPromiseIds.push(callbackId);
                callbackPromiseObjects.push(activeCallbackPromise);
            } else {
                // Start the promise and store the promise and its reject function in state (this.processTransitionCallback may call `reject` if the user changes route)
                let callbackPromiseReject;
                const callbackPromise = new Promise((resolve, reject)=>{
                    callbackPromiseReject = reject;
                    callback({
                        match: match
                    }).then(resolve).catch(reject);
                });
                callbackPromises.push(callbackPromise);
                callbackPromiseIds.push(callbackId);
                const callbackPromiseObject = {
                    promise: callbackPromise,
                    onRouteContinueCallback: onRouteContinueCallback,
                    onPerformanceMetricStart: onPerformanceMetricStart,
                    reject: (reason)=>callbackPromiseReject(new $e7d32f2c649e2db9$export$46a841557056026b(reason)),
                    isExternallyRejected: false
                };
                callbackPromiseObjects.push(callbackPromiseObject);
                this.activelyRunningCallbackPromises[callbackId] = callbackPromiseObject;
            }
        });
        return {
            callbackPromises: callbackPromises,
            callbackPromiseIds: callbackPromiseIds,
            callbackPromiseObjects: callbackPromiseObjects
        };
    }
    /**
   * Cancels all actively running callback promises by rejecting them and marking as externally rejected
   */ cancelActivePromises() {
        Object.entries(this.activelyRunningCallbackPromises).forEach(([callbackId, { reject: reject }])=>{
            reject();
            this.activelyRunningCallbackPromises[callbackId].isExternallyRejected = true;
            delete this.activelyRunningCallbackPromises[callbackId];
        });
    }
    /**
   * Cleans up any callback promises that are no longer valid for the current route.
   * @param validCallbackIds - The callback ids that are valid for the current route.
   */ cleanupOutdatedCallbacks(validCallbackIds) {
        Object.keys(this.activelyRunningCallbackPromises).forEach((activelyRunningCallbackId)=>{
            if (!validCallbackIds.includes(activelyRunningCallbackId)) {
                const activeCallbackPromise = this.activelyRunningCallbackPromises[activelyRunningCallbackId];
                if (activeCallbackPromise) {
                    activeCallbackPromise.reject?.();
                    activeCallbackPromise.isExternallyRejected = true;
                    delete this.activelyRunningCallbackPromises[activelyRunningCallbackId];
                }
            }
        });
    }
    constructor(){
        this.logger = (0, $a6897acd40ed68b1$export$2b1d391cd05230fd)('GlobalTransitionPreloader');
        this.callbacks = new Map();
        this.activelyRunningCallbackPromises = {};
        this.latestPathname = '';
        this.currentRouteDetails = {
            transitionId: -1,
            callbackIds: [],
            pathname: ''
        };
        this.transitionProcessingState = 'not_processing';
        this.cachedCallbackIds = null;
    }
}


const $c22be97ab4c2d58d$export$9675c02ec7fc88a8 = (0, $8V6O9.default)(()=>{
    return new (0, $e7d32f2c649e2db9$export$2f8f0e0ec8218c4b)();
});


const $64a554d15bd769f3$var$NOOP = ()=>{};
function $64a554d15bd769f3$export$b6024a131a1561d9(routes, url) {
    // routes can be module from "import" which is not iterable
    const iterableRoutes = Object.values(routes);
    for (const route of iterableRoutes){
        if (!(route instanceof (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6))) continue;
        const match = route.match(url);
        if (match) // FIXME `route` is a `class` instance so it is not 100% safe to spread!
        // But we've been running with it for quite some time, we're not aware of
        // actual problems and I'm only discovering it now while translating to
        // TypeScript.
        //
        // @ts-ignore
        return {
            ...route,
            ...match
        };
    }
    return null;
}
const $64a554d15bd769f3$export$5050caba5e109cc4 = (queryParams)=>{
    const array = Object.entries(queryParams);
    return array.length ? array.reduce((accumulator, current, index)=>`${accumulator + current[0]}=${encodeURIComponent(current[1])}${index < array.length - 1 ? '&' : ''}`, '?') : '';
};
const $64a554d15bd769f3$var$routeActionHistoryMap = {
    PUSH: ({ location: location1, history: history })=>history.push(location1),
    REPLACE: ({ location: location1, history: history })=>history.replace(location1),
    POP: ({ history: history })=>history.go(-1)
};
class $64a554d15bd769f3$var$RouteManagerInner extends (0, $dQwsT.Component) {
    componentDidMount() {
        const { location: location1, history: history } = this.props;
        const initialMatch = this.matchSupportedRoute(`${location1.pathname}${location1.search}${location1.hash}`);
        let previousMatch = initialMatch;
        const routeChangeHandler = (location1, action)=>{
            // we de-structure `onTransition` prop here instead of in enclosing scope
            // because otherwise changes to `onTransition` props will be ignored (as this function
            // will have a "cached" version of it via closure).
            const { onTransition: onTransition } = this.props;
            // New logic determine if it is a transition by calling isTransition on route.
            const match = this.matchSupportedRoute(`${location1.pathname}${location1.search}${location1.hash}`);
            if (onTransition && match && match.isTransition(previousMatch, match)) {
                if (action === 'PUSH' || action === 'POP') this.transitionId++;
                onTransition(match, this.transitionId, action);
                // Clear any prompt on successful route change
                this.globalPromptHandler.clear();
                // Inform GlobalTransitionPreloader that the transition is complete, allowing app to continue registering GlobalTransitionPreloader callbacks.
                const globalTransitionPreloader = (0, $c22be97ab4c2d58d$export$9675c02ec7fc88a8)();
                globalTransitionPreloader.onTransitionComplete(this.transitionId);
                // Call the pending UFO stop hold function if it exists, then clear it to prevent multiple calls
                if (this.pendingUfoStopHold) {
                    this.pendingUfoStopHold();
                    this.pendingUfoStopHold = undefined;
                }
                // Delete the SSR streaming global on route navigation to prevent it from affecting
                // suspense boundary rendering decisions during client-side navigation
                if (typeof window !== 'undefined' && window.__SSR_REACT_STREAMING__) delete window.__SSR_REACT_STREAMING__;
            }
            previousMatch = match;
        };
        // Return false to cancel transition (route will not change). Otherwise transition continues. Does not support waiting for promises - if we need to do that we should return false and have the promise re-invoke the route change when ready.
        const routeBlockHandler = (location1, action)=>{
            try {
                const match = this.matchSupportedRoute(`${location1.pathname}${location1.search}${location1.hash}`);
                const isTransition = match && match.isTransition(previousMatch, match);
                if (isTransition) {
                    // Check for global prompt. (This replaces react-router's <Prompt> component)
                    const { isPromptBlocking: isPromptBlocking } = this.globalPromptHandler.triggerPrompt({
                        previousMatch: previousMatch,
                        nextMatch: match
                    });
                    if (isPromptBlocking) return false;
                    // Check if we have a transition callback promise that should resolve before continuing transition.
                    // Do not support POP (back/forward) - too many edge cases caused by trying to partially support it.
                    const globalTransitionPreloader = (0, $c22be97ab4c2d58d$export$9675c02ec7fc88a8)();
                    if (action !== 'POP') {
                        const isProcessingTransitionPromise = globalTransitionPreloader.processTransitionCallback?.({
                            match: match,
                            onRouteContinue: ()=>{
                                $64a554d15bd769f3$var$routeActionHistoryMap[action?.toUpperCase()]?.({
                                    location: location1,
                                    history: history
                                });
                            },
                            // transitionId 0 is reserved for initial page load, so we never want to pass it as we're transitioning.
                            // We add 1 to avoid erronously being treated as initial page load. Router state will also add 1 once transition finishes.
                            transitionId: this.transitionId + 1,
                            interactionContext: this.props.interactionContext,
                            startPageLoadMetrics: this.props.startPageLoadMetrics
                        });
                        if (isProcessingTransitionPromise.isProcessingCallback) {
                            // Store the ufoStopHold function to be called in routeChangeHandler
                            this.pendingUfoStopHold = isProcessingTransitionPromise.ufoStopHold;
                            return false;
                        }
                    } else // If user does POP action, reset global transition preloader to ensure no transition callbacks are processed.
                    globalTransitionPreloader.reset();
                }
            } catch  {
            // Everything in this function should have its own try-catch/error handling, but in case of an unexpected error, the user shouldn't be blocked from navigating.
            }
        };
        if (this.props.setBrowserHistoryListener) {
            // Ensure RouteManager's `listen` handler is called before the listen handler registered by ConnectedRouter and redux action
            this.unlistenToHistory = this.props.setBrowserHistoryListener(routeChangeHandler);
            if ((0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_frontend_transition_preloading_system')) this.unlistenToHistoryBlock = history.block(routeBlockHandler);
        } else if ((0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_frontend_transition_preloading_system')) this.unlistenToHistory = history.block((location1, action)=>{
            const routeBlockHandlerResult = routeBlockHandler(location1, action);
            if (routeBlockHandlerResult === false) return false;
            else routeChangeHandler(location1, action);
        });
        else this.unlistenToHistory = history.block(routeChangeHandler);
    }
    componentWillUnmount() {
        this.unlistenToHistory?.();
        this.unlistenToHistoryBlock?.();
    }
    mapRoutes(routeComponents) {
        const supportedRoutes = Object.keys(routeComponents);
        return supportedRoutes.map((name)=>{
            const route = this.getRoute(name);
            const mappedRoute = new (0, $08784ba8c1603e4f$export$e7b0ac011bb776c6)({
                name: route.name,
                ufoName: route.ufoName,
                pattern: route.pattern,
                condition: route.condition,
                isTransition: route.isTransition
            });
            // @ts-ignore FIXME Who's using `component` on "mapped" `Route`?
            mappedRoute['component'] = routeComponents[name];
            return mappedRoute;
        });
    }
    getRoute(name) {
        const { namedRoutes: namedRoutes } = this.props;
        const route = namedRoutes[name];
        if (!route) throw new Error(`Unknown route name: ${name}`);
        return route;
    }
    matchAndRenderComponent(match) {
        const { notFound: notFound, routeComponents: routeComponents } = this.props;
        if (match === null) return notFound ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement(notFound) : null;
        else {
            window.performance.mark('CFP-63.route-component-render');
            const memoizedComponent = this.memoizedRouteComponents.get(routeComponents[match.name]);
            return memoizedComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement(memoizedComponent, match) : null;
        }
    }
    getHref() {
        return location.pathname + location.search;
    }
    render() {
        const { children: children } = this.props;
        const routesContextValue = this.getRoutesContextValue();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement((0, $32f18ec2049bb41d$export$a082affa499ae96f), {
            globalPromptHandler: this.globalPromptHandler
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement((0, $a55430c99df8268f$export$52c04f66b1983f2a), routesContextValue, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement((0, $4b72a15528d34979$export$779e8f71c6bb38c).Provider, {
            value: routesContextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement((0, $bf8e248a69b7feca$export$4e7bc78665a3b140), null, this.matchAndRenderComponent(routesContextValue.match), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement((0, $dQwsT.Fragment), null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement((0, $1262eee5c487dee7$export$cf1af05a5f90ab81), null)))));
    }
    constructor(props){
        super(props);
        this.pendingUfoStopHold = void 0;
        this.memoizedRouteComponents = new WeakMap();
        this.globalPromptHandler = new (0, $b7f189155d041ca2$export$aea2bc6590a5ea49)();
        // transitionId is incremented on every push/pop to distinguish a deliberate
        // user navigation from an automatic redirect (replace). An id of 0 indicates that
        // we are currently on the initial load.
        //
        // Ideally this would be in component state, since it is passed down through context,
        // and should trigger a re-render when changed.
        // However, we don't want to re-render with the updated value until the location
        // changes, which unfortunately is controlled by <ConnectedRouter>.
        // At the same time, this state cannot be purely derived from location changes,
        // since we need to look at the action that caused the update.
        // When we remove react-router and can make both state changes atomically then
        // this can move into component state alongside the current location.
        this.transitionId = 0;
        this.pendingQueryParams = {};
        /**
     * Mapping components to named routes
     */ this.routes = this.mapRoutes(this.props.routeComponents);
        this.toUrl = (name, params = {})=>{
            const href = params['href'];
            if (href) return href;
            if (!name) return '';
            const query = params.query || {};
            const hash = params.hash || '';
            return this.getRoute(name).toUrl(params, {
                query: query,
                hash: hash
            });
        };
        this.matchRoute = (url)=>{
            const { namedRoutes: namedRoutes } = this.props;
            return $64a554d15bd769f3$export$b6024a131a1561d9(namedRoutes, url);
        };
        this.matchSupportedRoute = (url)=>{
            const parsed = (0, $9pfwj.parse)(url);
            // Note here we are using location from window not from withRouter
            // history's location doesn't have host field
            // See https://github.com/ReactTraining/react-router/blob/master/packages/react-router/docs/api/history.md
            //What is this doing?
            if (parsed.host && parsed.host !== window.location.host) return null;
            return $64a554d15bd769f3$export$b6024a131a1561d9(this.routes, url);
        };
        this.replace = (url, forceReload = false)=>{
            const { history: history, onPageReload: onPageReload = $64a554d15bd769f3$var$RouteManagerInner.defaultProps.onPageReload } = this.props;
            let match;
            if (!forceReload && (match = this.matchSupportedRoute(url))) // replace only supports pushing a path.
            // here the url might be a full URL that has same domain
            history.replace((0, $9pfwj.format)({
                pathname: match.pathname,
                search: match.search,
                hash: match.hash
            }));
            else {
                onPageReload(url, true);
                // eslint-disable-next-line no-restricted-syntax
                window.location.replace(url);
            }
        };
        this.open = (url, target, features)=>window.open(url, target, features);
        this.defaultPush = (url, forceReload = false)=>{
            const { history: history, onPageReload: onPageReload = $64a554d15bd769f3$var$RouteManagerInner.defaultProps.onPageReload, location: location1 } = this.props;
            let match;
            if (!forceReload && (match = this.matchSupportedRoute((0, $a1f0c4d0ab868c5f$export$feb8df2d5227ff6c)(url) ? (0, $9pfwj.format)({
                pathname: location1.pathname,
                search: location1.search,
                hash: url
            }) : url))) // push only supports pushing a path.
            // here the url might be a full URL that has same domain
            history.push((0, $9pfwj.format)({
                pathname: match.pathname,
                search: match.search,
                hash: match.hash
            }));
            else {
                onPageReload(url, false);
                // eslint-disable-next-line no-restricted-syntax
                window.location.assign(url);
            }
        };
        this.push = (url, forceReload = false)=>{
            const { routePolicy: routePolicy } = this.props;
            if (routePolicy) return routePolicy.push({
                ...this.getRoutesContextValue(),
                push: this.defaultPush
            }, url, forceReload);
            return this.defaultPush(url, forceReload);
        };
        this.getQueryParams = ()=>{
            const { location: location1 } = this.props;
            return (0, $9pfwj.parse)(location1.search, true).query;
        };
        this.setQueryParams = (query, replace = false)=>{
            if (query && typeof query === 'object') {
                const { history: history } = this.props;
                const queryParams = {
                    ...this.getQueryParams(),
                    ...this.pendingQueryParams,
                    ...query
                };
                Object.keys(queryParams).forEach((key)=>{
                    if (queryParams[key] === null || queryParams[key] === undefined) delete queryParams[key];
                });
                const search = this.buildQueryString(queryParams);
                (replace ? history.replace : history.push)({
                    search: search
                });
                Object.assign(this.pendingQueryParams, query);
                // https://github.com/ReactTraining/history/issues/767#issuecomment-573358882
                setTimeout(()=>this.pendingQueryParams = {});
            }
        };
        this.buildQueryString = $64a554d15bd769f3$export$5050caba5e109cc4;
        this.getHash = ()=>{
            const { location: location1 } = this.props;
            return location1.hash ? location1.hash.substring(1) : '';
        };
        this.setHash = (hash)=>{
            const { history: history, location: location1 } = this.props;
            history.replace({
                ...location1,
                hash: hash
            });
        };
        this.preloadRoute = (matchOrUrl, options)=>{
            // URL match and string are among the most common representations in our
            // codebase. RouteManager owns converting between them so reduce the
            // strain on the caller and accept both:
            const match = typeof matchOrUrl === 'string' ? this.matchSupportedRoute(matchOrUrl) : matchOrUrl;
            if (match) {
                const previousMatch = this.matchSupportedRoute(this.getHref());
                const { onPreload: onPreload } = this.props;
                if (onPreload) onPreload(match, previousMatch, options);
            }
        };
        this.getRoutesContextValue = ()=>{
            const { history: history, location: location1, onPageReload: onPageReload } = this.props;
            return {
                getHref: this.getHref,
                history: history,
                location: location1,
                match: this.matchSupportedRoute(`${location1.pathname}${location1.search}${location1.hash}`),
                transitionId: this.transitionId,
                toUrl: this.toUrl,
                matchRoute: this.matchRoute,
                matchSupportedRoute: this.matchSupportedRoute,
                getQueryParams: this.getQueryParams,
                setQueryParams: this.setQueryParams,
                getHash: this.getHash,
                setHash: this.setHash,
                replace: this.replace,
                routes: this.routes,
                push: this.push,
                open: this.open,
                onPageReload: onPageReload || $64a554d15bd769f3$var$NOOP,
                preloadRoute: this.preloadRoute
            };
        };
        const { location: _location, onInitialize: onInitialize, routeComponents: routeComponents } = this.props;
        // Keep a component => memo(component) mapping so later in matchAndRenderComponent we can render the memoized one.
        // We are not re-creating the routeComponents object because several items in the object may share the same reference.
        // If that is the case then our memoized component should sharing the same reference as well.
        for(const key in routeComponents){
            const component = routeComponents[key];
            if (!this.memoizedRouteComponents.has(component)) this.memoizedRouteComponents.set(component, /*#__PURE__*/ (0, $dQwsT.memo)(component, (0, (/*@__PURE__*/$parcel$interopDefault($22a439cf29d896aa$exports)))));
        }
        const _match = this.matchSupportedRoute(`${_location.pathname}${_location.search}${_location.hash}`);
        if (onInitialize) onInitialize(_match, this.transitionId);
    }
}
$64a554d15bd769f3$var$RouteManagerInner.defaultProps = {
    routeComponents: {},
    namedRoutes: {},
    onPageReload: $64a554d15bd769f3$var$NOOP
};
const $64a554d15bd769f3$var$withInteractionContext = (ChildComponent)=>{
    if (!(0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_frontend_transition_preloading_system')) return ChildComponent;
    const WithInteractionContextComponent = (0, $91b99f9a21467aa8$export$74f458e787dc59ff)() ? (props)=>{
        const $ = (0, $90332d3d6df1e1ff$exports.c)(2);
        let t0;
        if ($[0] !== props) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement((0, $7c281faca52954ed$export$2e2bcd8739ae039).Consumer, null, (interactionContext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement(ChildComponent, {
                    ...props,
                    interactionContext: interactionContext
                }));
            $[0] = props;
            $[1] = t0;
        } else t0 = $[1];
        return t0;
    } : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement((0, $7c281faca52954ed$export$2e2bcd8739ae039).Consumer, null, (interactionContext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement(ChildComponent, {
                ...props,
                interactionContext: interactionContext
            }));
    WithInteractionContextComponent.displayName = `withInteractionContext(${ChildComponent.displayName || ChildComponent.name})`;
    return WithInteractionContextComponent;
};
const $64a554d15bd769f3$export$1b5af09f58fb97da = (0, $26d486920449aa9d$export$369b6b2b30582e8e)($64a554d15bd769f3$var$withInteractionContext($64a554d15bd769f3$var$RouteManagerInner));
const $64a554d15bd769f3$export$3b81431e16eb41b6 = $64a554d15bd769f3$var$withInteractionContext;




const $4b957fb9fbb0eafa$export$d4971375353d0454 = [
    $0d518026f9d519cf$export$9e15ff8aa6bc996f,
    $0d518026f9d519cf$export$2fd309376969662f,
    $0d518026f9d519cf$export$a7c5707626fc90f,
    $0d518026f9d519cf$export$6ccd7dc0d5aa30b0,
    $0d518026f9d519cf$export$7d65e474be175151,
    $0d518026f9d519cf$export$ec8a7da990877da3,
    $0d518026f9d519cf$export$aa473411bddb7e17,
    $0d518026f9d519cf$export$42bb8ba9cae96927,
    $0d518026f9d519cf$export$dec9f53c339ce8f8,
    $0d518026f9d519cf$export$f80d02217688b484,
    $0d518026f9d519cf$export$fdfdf584a0978d20,
    $0d518026f9d519cf$export$1e92de3a3dba0876,
    $0d518026f9d519cf$export$6a85914fb9ca80a2,
    $0d518026f9d519cf$export$1f238fcead086ec3,
    $0d518026f9d519cf$export$b74c113024023274,
    $0d518026f9d519cf$export$45222bf0cb32d6e2,
    $0d518026f9d519cf$export$7b1285e36c635f1f,
    $0d518026f9d519cf$export$36dcea4e08feb5c9,
    $0d518026f9d519cf$export$e63a462ee45b57cf,
    $0d518026f9d519cf$export$bd17e6e353522e0d,
    $0d518026f9d519cf$export$54edf7c16c47aeef,
    $0d518026f9d519cf$export$d6ae9e544e98926f,
    $0d518026f9d519cf$export$e8253e1b7e500d1c,
    $0d518026f9d519cf$export$9a4ff2d809fc4156,
    $0d518026f9d519cf$export$19c176cd0a878008,
    $0d518026f9d519cf$export$439074745692fe65,
    $0d518026f9d519cf$export$2de9a69f9b51bb83,
    $0d518026f9d519cf$export$10f0439b47c8fdaf,
    $0d518026f9d519cf$export$d87089dbdd7eeaf3,
    $0d518026f9d519cf$export$dd174db99b3e6fea,
    $0d518026f9d519cf$export$ef26ce515f06bc5e,
    $0d518026f9d519cf$export$65b723bb995d4fb6,
    $0d518026f9d519cf$export$4fe224de953acb46,
    $0d518026f9d519cf$export$1009a7f2cc1ac09f,
    $0d518026f9d519cf$export$4dd08bdd46db5924,
    $0d518026f9d519cf$export$ada7925da580b561,
    $0d518026f9d519cf$export$29df24b01e938adf,
    $0d518026f9d519cf$export$e003e97fab6b4368,
    $0d518026f9d519cf$export$5f7be6e90830de0c,
    $0d518026f9d519cf$export$9257b5b55c8e2555,
    $0d518026f9d519cf$export$475fdaba8e6145bb,
    $0d518026f9d519cf$export$347d3b5edaae00e0,
    $0d518026f9d519cf$export$91f49e7b30a9d34,
    $0d518026f9d519cf$export$c259921a01da55b4,
    $0d518026f9d519cf$export$5b90ced7e51bcea0,
    $0d518026f9d519cf$export$7d8684a463b78f54,
    $0d518026f9d519cf$export$eb54044908e4e0bd,
    $0d518026f9d519cf$export$506a1a071415f2e,
    $0d518026f9d519cf$export$4e4c6a9eb23f65ec,
    $0d518026f9d519cf$export$37055aaa9d88b944,
    $0d518026f9d519cf$export$b17d28dbf200fde0,
    $0d518026f9d519cf$export$5bfa1fef1b53dfdd,
    $0d518026f9d519cf$export$dd6de41f650dae89,
    $0d518026f9d519cf$export$8c6393d6207d929,
    $0d518026f9d519cf$export$9397e0d80cf06055,
    $0d518026f9d519cf$export$f107e7a692a3a54e,
    $0d518026f9d519cf$export$5bbec961de23dce7,
    $0d518026f9d519cf$export$2f6a532274e0cd9d,
    $0d518026f9d519cf$export$a007a4f7553ffc16,
    $0d518026f9d519cf$export$f0e8d063cba10e9c,
    $0d518026f9d519cf$export$3039840c47d9a13d,
    $0d518026f9d519cf$export$e1e5a41fa357e66f,
    $0d518026f9d519cf$export$4fcc3f53642c593a,
    $0d518026f9d519cf$export$7234e6926944adc0,
    $0d518026f9d519cf$export$b86d7bd984fb9727,
    $0d518026f9d519cf$export$1afd9317831e345e,
    $0d518026f9d519cf$export$9e8d02f6bdb565e9,
    $0d518026f9d519cf$export$f03a4adc711219ed,
    $0d518026f9d519cf$export$af040d7344c912d1,
    $0d518026f9d519cf$export$2925d036bbc38c7,
    $0d518026f9d519cf$export$351b62e6f5786a73,
    $0d518026f9d519cf$export$4a2048bb71da8b4b,
    $0d518026f9d519cf$export$7de5b687836953bd,
    $0d518026f9d519cf$export$e492b3d04985e9fb,
    $0d518026f9d519cf$export$57fb93d8931ad943,
    $0d518026f9d519cf$export$27b2e48e28163360,
    $0d518026f9d519cf$export$f178fb5b1e822288,
    $0d518026f9d519cf$export$777796688df78f56,
    $0d518026f9d519cf$export$3907c7d8e57f70ba,
    $0d518026f9d519cf$export$fe97ee265fd89939,
    $0d518026f9d519cf$export$b71609db3dda2696,
    $0d518026f9d519cf$export$730392c243a0a367,
    $0d518026f9d519cf$export$85bd3cea0cecb26c,
    $0d518026f9d519cf$export$c8a37c9f76d4d03f,
    $0d518026f9d519cf$export$771b75a6ca136f91,
    $0d518026f9d519cf$export$8e4a8343b1614a02,
    $0d518026f9d519cf$export$2c9cf254b3b24ff,
    $0d518026f9d519cf$export$d925029e7ceadd51,
    $0d518026f9d519cf$export$e84c491e2d88d9f6,
    $0d518026f9d519cf$export$a990a60696f54618,
    $0d518026f9d519cf$export$c0a209b0b0b16c75,
    $0d518026f9d519cf$export$dcee5dee04648c93,
    $0d518026f9d519cf$export$dcda7f8b6fe54ba,
    $0d518026f9d519cf$export$9e430f65574f5333,
    $0d518026f9d519cf$export$e9d78b13bbb4e56f,
    $0d518026f9d519cf$export$d7be6003270f6c2d,
    $0d518026f9d519cf$export$b49467be269d2629,
    $0d518026f9d519cf$export$e52245e856f5c06,
    $0d518026f9d519cf$export$926e3916067d7530,
    $0d518026f9d519cf$export$e720b1e170b46aae,
    $0d518026f9d519cf$export$6c7b95dcf08f3a6d,
    $0d518026f9d519cf$export$b010f02787df1e6,
    $0d518026f9d519cf$export$ecc28d15af39a8b2,
    $0d518026f9d519cf$export$482db086bc8c2289,
    $0d518026f9d519cf$export$3afea7266d0d139b,
    $0d518026f9d519cf$export$4eb80c3a4e6fbe0f,
    $0d518026f9d519cf$export$bd2c9bb170b3681d,
    $0d518026f9d519cf$export$5c9eaf42f32252ea,
    $0d518026f9d519cf$export$7ae0ea91a2dfc4d9,
    $0d518026f9d519cf$export$3bd4ec9f05d79904,
    $0d518026f9d519cf$export$d593e642a326a501,
    $0d518026f9d519cf$export$1fa935672762674c,
    $0d518026f9d519cf$export$6490fab56523ceda,
    $0d518026f9d519cf$export$dcb1d1a9cda087b1,
    $0d518026f9d519cf$export$6b2db7909585abd7,
    $0d518026f9d519cf$export$2dd65cdecd8b05d7,
    $0d518026f9d519cf$export$d78f611c1ddf7234,
    $0d518026f9d519cf$export$9dc7f7e5e1435bc,
    $0d518026f9d519cf$export$3582accdd821993a,
    $0d518026f9d519cf$export$871ac71d42c178c5,
    $0d518026f9d519cf$export$1bc544543b946246,
    $0d518026f9d519cf$export$d387bb8ca9ce25d1,
    $0d518026f9d519cf$export$f7bf92a6467c1557,
    $0d518026f9d519cf$export$ed260c82a3e70a6a,
    $0d518026f9d519cf$export$a90430d7f36bfe9e,
    $0d518026f9d519cf$export$22bb05181a4b1501,
    $0d518026f9d519cf$export$cb73aa9f5b7d1ea0,
    $0d518026f9d519cf$export$df78b182760b42f4,
    $0d518026f9d519cf$export$2d3703cff5d9a27,
    $0d518026f9d519cf$export$60773cf116cf5f30,
    $0d518026f9d519cf$export$40e965fb568c3c83,
    $0d518026f9d519cf$export$cb80c94a905e11b6,
    $0d518026f9d519cf$export$93b558a6e07dbdac,
    $0d518026f9d519cf$export$67acd8a63f03bc8,
    $0d518026f9d519cf$export$6b9c632e635b4d77,
    $0d518026f9d519cf$export$37a588b556645c19,
    $0d518026f9d519cf$export$aded01fc53d469df,
    $0d518026f9d519cf$export$cdd412f0619f2d7e,
    $0d518026f9d519cf$export$aa72b945229db170,
    $0d518026f9d519cf$export$f0c4a6dc3b3437aa,
    $0d518026f9d519cf$export$1a5e481ee166ad7c,
    $0d518026f9d519cf$export$f39a30a3a5635bab,
    $0d518026f9d519cf$export$3101773a7a844077,
    $0d518026f9d519cf$export$f03524b1e395be4a,
    $0d518026f9d519cf$export$38b94ff4631b44df,
    $0d518026f9d519cf$export$26dfba554adbf87e,
    $0d518026f9d519cf$export$1b93424785e5f745,
    $0d518026f9d519cf$export$f0e860396acf6277,
    $0d518026f9d519cf$export$4442c9c7bb716896,
    $0d518026f9d519cf$export$ffd880217e61385f,
    $0d518026f9d519cf$export$8bf619366f9e74f2,
    $0d518026f9d519cf$export$a85b9c60514cd043,
    $0d518026f9d519cf$export$19b893a9e64dac94,
    $0d518026f9d519cf$export$3d39129bec795227,
    $0d518026f9d519cf$export$b8adcf19ff927cec,
    $0d518026f9d519cf$export$939b28e9f8987d97,
    $0d518026f9d519cf$export$d0ac6fa12f3acafa,
    $0d518026f9d519cf$export$693d9b367ae8d0f7,
    $0d518026f9d519cf$export$35123576da2e521,
    $0d518026f9d519cf$export$e18ccd8ffafdf3dd,
    $0d518026f9d519cf$export$9c4e8cdcbbacdf8f,
    $0d518026f9d519cf$export$f85f59869a8dbbf8,
    $0d518026f9d519cf$export$2cc9af506d64ef72,
    $0d518026f9d519cf$export$4f46a1e4250ebe18,
    $0d518026f9d519cf$export$751ae19fa150b7c,
    $0d518026f9d519cf$export$526ccce5d32f7beb,
    $0d518026f9d519cf$export$3d8579587b62bb96,
    $0d518026f9d519cf$export$ed19a29c446e24d8,
    $0d518026f9d519cf$export$7de52f6cc232129e,
    $0d518026f9d519cf$export$81cfd93b1b89cd07,
    $0d518026f9d519cf$export$31745f3bff21cd,
    $0d518026f9d519cf$export$7af7a1e753a92264,
    $0d518026f9d519cf$export$28e7e683f23a58d3,
    $0d518026f9d519cf$export$e64d4514fc584fbe,
    $0d518026f9d519cf$export$323161697c5fa666,
    $0d518026f9d519cf$export$dfa725d05e18145e,
    $0d518026f9d519cf$export$8674e83405059790,
    $0d518026f9d519cf$export$8b5e82a6ff458b36,
    $0d518026f9d519cf$export$3ce513606c31c918,
    $0d518026f9d519cf$export$652395dc5ff9b416,
    $0d518026f9d519cf$export$4d1bccc78b263a8e,
    $0d518026f9d519cf$export$df327d9b56ca6b7c,
    $0d518026f9d519cf$export$53f195d79ef3d4dd,
    $0d518026f9d519cf$export$23e7002e5e9ef89e,
    $0d518026f9d519cf$export$2a17c68caa9b9a01,
    $0d518026f9d519cf$export$299af9061dea1f09,
    $0d518026f9d519cf$export$eb5a785192323bd3,
    $0d518026f9d519cf$export$168f3acd059931e0,
    $0d518026f9d519cf$export$3bcebf4f1e82d3ad,
    $0d518026f9d519cf$export$42599f111394c36c,
    $0d518026f9d519cf$export$4c6bf75100b3b72,
    $0d518026f9d519cf$export$e05db3c2f69bd3ae,
    $0d518026f9d519cf$export$851ba2be5095d586,
    $0d518026f9d519cf$export$9859a7a7049d0585,
    $0d518026f9d519cf$export$90480461935b54cc,
    $0d518026f9d519cf$export$84b5e15197aaaa12,
    $0d518026f9d519cf$export$4dcf771d1a1901ef,
    $0d518026f9d519cf$export$22f8e464aee70413,
    $0d518026f9d519cf$export$752c480a913a6712,
    $0d518026f9d519cf$export$16172a64bcdb79f8,
    $0d518026f9d519cf$export$70914a626e2f0488,
    $0d518026f9d519cf$export$85c61af9d225a707,
    $0d518026f9d519cf$export$3d0698fcdc33631d,
    $0d518026f9d519cf$export$c0d0d3f98d45e5f1,
    $0d518026f9d519cf$export$69df75bd8c217ade,
    $0d518026f9d519cf$export$70e53b90503ea1b9,
    $0d518026f9d519cf$export$3b3f3d2739d7f93,
    $0d518026f9d519cf$export$d255d2f418d43162,
    $0d518026f9d519cf$export$f313d05bcfc41be4,
    $0d518026f9d519cf$export$688990fbefa748b3,
    $0d518026f9d519cf$export$99ff0b9560c4fd04,
    $0d518026f9d519cf$export$ff52f9b0a0f68578,
    $0d518026f9d519cf$export$629e966630a1f92e,
    $0d518026f9d519cf$export$e8beba40e140a443,
    $0d518026f9d519cf$export$c471be73599ccae1,
    $0d518026f9d519cf$export$bb9816d0c0dcd6e6,
    $0d518026f9d519cf$export$793ade69cc97583f,
    $0d518026f9d519cf$export$499f432aa493cdd2,
    $0d518026f9d519cf$export$4ce9d0d8218b9d84,
    $0d518026f9d519cf$export$345aea7dc51bac8a,
    $0d518026f9d519cf$export$499a561f6d1a011,
    $0d518026f9d519cf$export$59a52cdd0906f4cb,
    $0d518026f9d519cf$export$2bc30aa6642650c,
    $0d518026f9d519cf$export$b45af2e1d7abb289,
    $0d518026f9d519cf$export$f8d71dcb352ebe8c,
    $0d518026f9d519cf$export$5f63ad7e18293ec2,
    $0d518026f9d519cf$export$57a75dda1f25b360,
    $0d518026f9d519cf$export$3ebf2fc23df50648,
    $0d518026f9d519cf$export$96e9320cb2b14c85,
    $0d518026f9d519cf$export$94f5f2b71458cc90
].reduce((acc, route)=>{
    acc[route.name] = route;
    return acc;
}, {});



var $0ab7059d2555b0c2$exports = {};

var $71a5afe22d2c4a3e$exports = {};

var $dT1PE = parcelRequire("dT1PE");
var $c2660f1b644e5ba0$exports = {};
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $c2660f1b644e5ba0$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
$c2660f1b644e5ba0$exports = $c2660f1b644e5ba0$var$arrayEach;



var $b1f5f973f18eabc3$exports = {};
var $eec18ae330365b90$exports = {};


/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $eec18ae330365b90$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $2a0e852067a065f7$exports(object, key, newValue);
        else $0d24fc8202d610fb$exports(object, key, newValue);
    }
    return object;
}
$eec18ae330365b90$exports = $eec18ae330365b90$var$copyObject;



var $8wWbF = parcelRequire("8wWbF");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $b1f5f973f18eabc3$var$baseAssign(object, source) {
    return object && $eec18ae330365b90$exports(source, $8wWbF(source), object);
}
$b1f5f973f18eabc3$exports = $b1f5f973f18eabc3$var$baseAssign;


var $272185f87237a860$exports = {};


/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $272185f87237a860$var$baseAssignIn(object, source) {
    return object && $eec18ae330365b90$exports(source, $adfe5adb75b1d345$exports(source), object);
}
$272185f87237a860$exports = $272185f87237a860$var$baseAssignIn;



var $4ZAD9 = parcelRequire("4ZAD9");
var $a480978e2c9bd711$exports = {};
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $a480978e2c9bd711$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
$a480978e2c9bd711$exports = $a480978e2c9bd711$var$copyArray;


var $818f31946cd9861e$exports = {};


var $32BHM = parcelRequire("32BHM");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $818f31946cd9861e$var$copySymbols(source, object) {
    return $eec18ae330365b90$exports(source, $32BHM(source), object);
}
$818f31946cd9861e$exports = $818f31946cd9861e$var$copySymbols;


var $a3a7cc7cb4dea7d2$exports = {};


/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $a3a7cc7cb4dea7d2$var$copySymbolsIn(source, object) {
    return $eec18ae330365b90$exports(source, $c9716c866ac6e533$exports(source), object);
}
$a3a7cc7cb4dea7d2$exports = $a3a7cc7cb4dea7d2$var$copySymbolsIn;



var $7RhIc = parcelRequire("7RhIc");


var $1gSOv = parcelRequire("1gSOv");
var $b9dba1ebea00e819$exports = {};
/** Used for built-in method references. */ var $b9dba1ebea00e819$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b9dba1ebea00e819$var$hasOwnProperty = $b9dba1ebea00e819$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $b9dba1ebea00e819$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $b9dba1ebea00e819$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
$b9dba1ebea00e819$exports = $b9dba1ebea00e819$var$initCloneArray;


var $2b5a0da92d038a2e$exports = {};
var $6ed1982656ee2b3f$exports = {};

var $3t08V = parcelRequire("3t08V");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $6ed1982656ee2b3f$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $3t08V(result).set(new $3t08V(arrayBuffer));
    return result;
}
$6ed1982656ee2b3f$exports = $6ed1982656ee2b3f$var$cloneArrayBuffer;


var $518aad06890034a1$exports = {};

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $518aad06890034a1$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $6ed1982656ee2b3f$exports(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
$518aad06890034a1$exports = $518aad06890034a1$var$cloneDataView;


var $0659716444d3f673$exports = {};
/** Used to match `RegExp` flags from their coerced string values. */ var $0659716444d3f673$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $0659716444d3f673$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $0659716444d3f673$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
$0659716444d3f673$exports = $0659716444d3f673$var$cloneRegExp;


var $255c1647574f7d28$exports = {};

var $3N6ME = parcelRequire("3N6ME");
/** Used to convert symbols to primitives and strings. */ var $255c1647574f7d28$var$symbolProto = $3N6ME ? $3N6ME.prototype : undefined, $255c1647574f7d28$var$symbolValueOf = $255c1647574f7d28$var$symbolProto ? $255c1647574f7d28$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $255c1647574f7d28$var$cloneSymbol(symbol) {
    return $255c1647574f7d28$var$symbolValueOf ? Object($255c1647574f7d28$var$symbolValueOf.call(symbol)) : {};
}
$255c1647574f7d28$exports = $255c1647574f7d28$var$cloneSymbol;


var $96655af9c48a5397$exports = {};

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $96655af9c48a5397$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $6ed1982656ee2b3f$exports(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
$96655af9c48a5397$exports = $96655af9c48a5397$var$cloneTypedArray;


/** `Object#toString` result references. */ var $2b5a0da92d038a2e$var$boolTag = '[object Boolean]', $2b5a0da92d038a2e$var$dateTag = '[object Date]', $2b5a0da92d038a2e$var$mapTag = '[object Map]', $2b5a0da92d038a2e$var$numberTag = '[object Number]', $2b5a0da92d038a2e$var$regexpTag = '[object RegExp]', $2b5a0da92d038a2e$var$setTag = '[object Set]', $2b5a0da92d038a2e$var$stringTag = '[object String]', $2b5a0da92d038a2e$var$symbolTag = '[object Symbol]';
var $2b5a0da92d038a2e$var$arrayBufferTag = '[object ArrayBuffer]', $2b5a0da92d038a2e$var$dataViewTag = '[object DataView]', $2b5a0da92d038a2e$var$float32Tag = '[object Float32Array]', $2b5a0da92d038a2e$var$float64Tag = '[object Float64Array]', $2b5a0da92d038a2e$var$int8Tag = '[object Int8Array]', $2b5a0da92d038a2e$var$int16Tag = '[object Int16Array]', $2b5a0da92d038a2e$var$int32Tag = '[object Int32Array]', $2b5a0da92d038a2e$var$uint8Tag = '[object Uint8Array]', $2b5a0da92d038a2e$var$uint8ClampedTag = '[object Uint8ClampedArray]', $2b5a0da92d038a2e$var$uint16Tag = '[object Uint16Array]', $2b5a0da92d038a2e$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $2b5a0da92d038a2e$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $2b5a0da92d038a2e$var$arrayBufferTag:
            return $6ed1982656ee2b3f$exports(object);
        case $2b5a0da92d038a2e$var$boolTag:
        case $2b5a0da92d038a2e$var$dateTag:
            return new Ctor(+object);
        case $2b5a0da92d038a2e$var$dataViewTag:
            return $518aad06890034a1$exports(object, isDeep);
        case $2b5a0da92d038a2e$var$float32Tag:
        case $2b5a0da92d038a2e$var$float64Tag:
        case $2b5a0da92d038a2e$var$int8Tag:
        case $2b5a0da92d038a2e$var$int16Tag:
        case $2b5a0da92d038a2e$var$int32Tag:
        case $2b5a0da92d038a2e$var$uint8Tag:
        case $2b5a0da92d038a2e$var$uint8ClampedTag:
        case $2b5a0da92d038a2e$var$uint16Tag:
        case $2b5a0da92d038a2e$var$uint32Tag:
            return $96655af9c48a5397$exports(object, isDeep);
        case $2b5a0da92d038a2e$var$mapTag:
            return new Ctor;
        case $2b5a0da92d038a2e$var$numberTag:
        case $2b5a0da92d038a2e$var$stringTag:
            return new Ctor(object);
        case $2b5a0da92d038a2e$var$regexpTag:
            return $0659716444d3f673$exports(object);
        case $2b5a0da92d038a2e$var$setTag:
            return new Ctor;
        case $2b5a0da92d038a2e$var$symbolTag:
            return $255c1647574f7d28$exports(object);
    }
}
$2b5a0da92d038a2e$exports = $2b5a0da92d038a2e$var$initCloneByTag;


var $6f33d73fa79abe6d$exports = {};
var $cb72ee166be8d5c0$exports = {};

var $26Qmy = parcelRequire("26Qmy");
/** Built-in value references. */ var $cb72ee166be8d5c0$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $cb72ee166be8d5c0$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$26Qmy(proto)) return {};
        if ($cb72ee166be8d5c0$var$objectCreate) return $cb72ee166be8d5c0$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
$cb72ee166be8d5c0$exports = $cb72ee166be8d5c0$var$baseCreate;




var $lL06J = parcelRequire("lL06J");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $6f33d73fa79abe6d$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !$lL06J(object) ? $cb72ee166be8d5c0$exports($f7fe2366ba78703d$exports(object)) : {};
}
$6f33d73fa79abe6d$exports = $6f33d73fa79abe6d$var$initCloneObject;



var $fbNtz = parcelRequire("fbNtz");

var $j2cWv = parcelRequire("j2cWv");
var $4e09cf9b85aea52e$exports = {};
var $c957a50f6bfada64$exports = {};

var $1gSOv = parcelRequire("1gSOv");

var $eyoXy = parcelRequire("eyoXy");
/** `Object#toString` result references. */ var $c957a50f6bfada64$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $c957a50f6bfada64$var$baseIsMap(value) {
    return $eyoXy(value) && $1gSOv(value) == $c957a50f6bfada64$var$mapTag;
}
$c957a50f6bfada64$exports = $c957a50f6bfada64$var$baseIsMap;



var $iSOZZ = parcelRequire("iSOZZ");

var $1QIyT = parcelRequire("1QIyT");
/* Node.js helper references. */ var $4e09cf9b85aea52e$var$nodeIsMap = $1QIyT && $1QIyT.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $4e09cf9b85aea52e$var$isMap = $4e09cf9b85aea52e$var$nodeIsMap ? $iSOZZ($4e09cf9b85aea52e$var$nodeIsMap) : $c957a50f6bfada64$exports;
$4e09cf9b85aea52e$exports = $4e09cf9b85aea52e$var$isMap;



var $26Qmy = parcelRequire("26Qmy");
var $2d50e386c7ec4757$exports = {};
var $4a04746993bcb229$exports = {};

var $1gSOv = parcelRequire("1gSOv");

var $eyoXy = parcelRequire("eyoXy");
/** `Object#toString` result references. */ var $4a04746993bcb229$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $4a04746993bcb229$var$baseIsSet(value) {
    return $eyoXy(value) && $1gSOv(value) == $4a04746993bcb229$var$setTag;
}
$4a04746993bcb229$exports = $4a04746993bcb229$var$baseIsSet;



var $iSOZZ = parcelRequire("iSOZZ");

var $1QIyT = parcelRequire("1QIyT");
/* Node.js helper references. */ var $2d50e386c7ec4757$var$nodeIsSet = $1QIyT && $1QIyT.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $2d50e386c7ec4757$var$isSet = $2d50e386c7ec4757$var$nodeIsSet ? $iSOZZ($2d50e386c7ec4757$var$nodeIsSet) : $4a04746993bcb229$exports;
$2d50e386c7ec4757$exports = $2d50e386c7ec4757$var$isSet;



var $8wWbF = parcelRequire("8wWbF");

/** Used to compose bitmasks for cloning. */ var $71a5afe22d2c4a3e$var$CLONE_DEEP_FLAG = 1, $71a5afe22d2c4a3e$var$CLONE_FLAT_FLAG = 2, $71a5afe22d2c4a3e$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $71a5afe22d2c4a3e$var$argsTag = '[object Arguments]', $71a5afe22d2c4a3e$var$arrayTag = '[object Array]', $71a5afe22d2c4a3e$var$boolTag = '[object Boolean]', $71a5afe22d2c4a3e$var$dateTag = '[object Date]', $71a5afe22d2c4a3e$var$errorTag = '[object Error]', $71a5afe22d2c4a3e$var$funcTag = '[object Function]', $71a5afe22d2c4a3e$var$genTag = '[object GeneratorFunction]', $71a5afe22d2c4a3e$var$mapTag = '[object Map]', $71a5afe22d2c4a3e$var$numberTag = '[object Number]', $71a5afe22d2c4a3e$var$objectTag = '[object Object]', $71a5afe22d2c4a3e$var$regexpTag = '[object RegExp]', $71a5afe22d2c4a3e$var$setTag = '[object Set]', $71a5afe22d2c4a3e$var$stringTag = '[object String]', $71a5afe22d2c4a3e$var$symbolTag = '[object Symbol]', $71a5afe22d2c4a3e$var$weakMapTag = '[object WeakMap]';
var $71a5afe22d2c4a3e$var$arrayBufferTag = '[object ArrayBuffer]', $71a5afe22d2c4a3e$var$dataViewTag = '[object DataView]', $71a5afe22d2c4a3e$var$float32Tag = '[object Float32Array]', $71a5afe22d2c4a3e$var$float64Tag = '[object Float64Array]', $71a5afe22d2c4a3e$var$int8Tag = '[object Int8Array]', $71a5afe22d2c4a3e$var$int16Tag = '[object Int16Array]', $71a5afe22d2c4a3e$var$int32Tag = '[object Int32Array]', $71a5afe22d2c4a3e$var$uint8Tag = '[object Uint8Array]', $71a5afe22d2c4a3e$var$uint8ClampedTag = '[object Uint8ClampedArray]', $71a5afe22d2c4a3e$var$uint16Tag = '[object Uint16Array]', $71a5afe22d2c4a3e$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $71a5afe22d2c4a3e$var$cloneableTags = {};
$71a5afe22d2c4a3e$var$cloneableTags[$71a5afe22d2c4a3e$var$argsTag] = $71a5afe22d2c4a3e$var$cloneableTags[$71a5afe22d2c4a3e$var$arrayTag] = $71a5afe22d2c4a3e$var$cloneableTags[$71a5afe22d2c4a3e$var$arrayBufferTag] = $71a5afe22d2c4a3e$var$cloneableTags[$71a5afe22d2c4a3e$var$dataViewTag] = $71a5afe22d2c4a3e$var$cloneableTags[$71a5afe22d2c4a3e$var$boolTag] = $71a5afe22d2c4a3e$var$cloneableTags[$71a5afe22d2c4a3e$var$dateTag] = $71a5afe22d2c4a3e$var$cloneableTags[$71a5afe22d2c4a3e$var$float32Tag] = $71a5afe22d2c4a3e$var$cloneableTags[$71a5afe22d2c4a3e$var$float64Tag] = $71a5afe22d2c4a3e$var$cloneableTags[$71a5afe22d2c4a3e$var$int8Tag] = $71a5afe22d2c4a3e$var$cloneableTags[$71a5afe22d2c4a3e$var$int16Tag] = $71a5afe22d2c4a3e$var$cloneableTags[$71a5afe22d2c4a3e$var$int32Tag] = $71a5afe22d2c4a3e$var$cloneableTags[$71a5afe22d2c4a3e$var$mapTag] = $71a5afe22d2c4a3e$var$cloneableTags[$71a5afe22d2c4a3e$var$numberTag] = $71a5afe22d2c4a3e$var$cloneableTags[$71a5afe22d2c4a3e$var$objectTag] = $71a5afe22d2c4a3e$var$cloneableTags[$71a5afe22d2c4a3e$var$regexpTag] = $71a5afe22d2c4a3e$var$cloneableTags[$71a5afe22d2c4a3e$var$setTag] = $71a5afe22d2c4a3e$var$cloneableTags[$71a5afe22d2c4a3e$var$stringTag] = $71a5afe22d2c4a3e$var$cloneableTags[$71a5afe22d2c4a3e$var$symbolTag] = $71a5afe22d2c4a3e$var$cloneableTags[$71a5afe22d2c4a3e$var$uint8Tag] = $71a5afe22d2c4a3e$var$cloneableTags[$71a5afe22d2c4a3e$var$uint8ClampedTag] = $71a5afe22d2c4a3e$var$cloneableTags[$71a5afe22d2c4a3e$var$uint16Tag] = $71a5afe22d2c4a3e$var$cloneableTags[$71a5afe22d2c4a3e$var$uint32Tag] = true;
$71a5afe22d2c4a3e$var$cloneableTags[$71a5afe22d2c4a3e$var$errorTag] = $71a5afe22d2c4a3e$var$cloneableTags[$71a5afe22d2c4a3e$var$funcTag] = $71a5afe22d2c4a3e$var$cloneableTags[$71a5afe22d2c4a3e$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $71a5afe22d2c4a3e$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $71a5afe22d2c4a3e$var$CLONE_DEEP_FLAG, isFlat = bitmask & $71a5afe22d2c4a3e$var$CLONE_FLAT_FLAG, isFull = bitmask & $71a5afe22d2c4a3e$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$26Qmy(value)) return value;
    var isArr = $fbNtz(value);
    if (isArr) {
        result = $b9dba1ebea00e819$exports(value);
        if (!isDeep) return $a480978e2c9bd711$exports(value, result);
    } else {
        var tag = $1gSOv(value), isFunc = tag == $71a5afe22d2c4a3e$var$funcTag || tag == $71a5afe22d2c4a3e$var$genTag;
        if ($j2cWv(value)) return $4ZAD9(value, isDeep);
        if (tag == $71a5afe22d2c4a3e$var$objectTag || tag == $71a5afe22d2c4a3e$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $6f33d73fa79abe6d$exports(value);
            if (!isDeep) return isFlat ? $a3a7cc7cb4dea7d2$exports(value, $272185f87237a860$exports(result, value)) : $818f31946cd9861e$exports(value, $b1f5f973f18eabc3$exports(result, value));
        } else {
            if (!$71a5afe22d2c4a3e$var$cloneableTags[tag]) return object ? value : {};
            result = $2b5a0da92d038a2e$exports(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $dT1PE);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($2d50e386c7ec4757$exports(value)) value.forEach(function(subValue) {
        result.add($71a5afe22d2c4a3e$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($4e09cf9b85aea52e$exports(value)) value.forEach(function(subValue, key) {
        result.set(key, $71a5afe22d2c4a3e$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $3ea15658da5695b0$exports : $7RhIc : isFlat ? $adfe5adb75b1d345$exports : $8wWbF;
    var props = isArr ? undefined : keysFunc(value);
    $c2660f1b644e5ba0$exports(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $0d24fc8202d610fb$exports(result, key, $71a5afe22d2c4a3e$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
$71a5afe22d2c4a3e$exports = $71a5afe22d2c4a3e$var$baseClone;


var $4cb20b357fbc5289$exports = {};

var $02b97b10a4160b20$exports = {};
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $02b97b10a4160b20$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
$02b97b10a4160b20$exports = $02b97b10a4160b20$var$last;


var $a75aca7d96328efc$exports = {};

var $bcefec761509be9b$exports = {};
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $bcefec761509be9b$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
$bcefec761509be9b$exports = $bcefec761509be9b$var$baseSlice;


/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $a75aca7d96328efc$var$parent(object, path) {
    return path.length < 2 ? object : $82970fa89f7ad560$exports(object, $bcefec761509be9b$exports(path, 0, -1));
}
$a75aca7d96328efc$exports = $a75aca7d96328efc$var$parent;



/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $4cb20b357fbc5289$var$baseUnset(object, path) {
    path = $4c7af6d47eeb9687$exports(path, object);
    object = $a75aca7d96328efc$exports(object, path);
    return object == null || delete object[$3ef010825e7ace55$exports($02b97b10a4160b20$exports(path))];
}
$4cb20b357fbc5289$exports = $4cb20b357fbc5289$var$baseUnset;




var $b9ec780dfc485acf$exports = {};
var $892c418d04ea9d14$exports = {};

var $kvoUC = parcelRequire("kvoUC");


var $eyoXy = parcelRequire("eyoXy");
/** `Object#toString` result references. */ var $892c418d04ea9d14$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $892c418d04ea9d14$var$funcProto = Function.prototype, $892c418d04ea9d14$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $892c418d04ea9d14$var$funcToString = $892c418d04ea9d14$var$funcProto.toString;
/** Used to check objects for own properties. */ var $892c418d04ea9d14$var$hasOwnProperty = $892c418d04ea9d14$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $892c418d04ea9d14$var$objectCtorString = $892c418d04ea9d14$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $892c418d04ea9d14$var$isPlainObject(value) {
    if (!$eyoXy(value) || $kvoUC(value) != $892c418d04ea9d14$var$objectTag) return false;
    var proto = $f7fe2366ba78703d$exports(value);
    if (proto === null) return true;
    var Ctor = $892c418d04ea9d14$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $892c418d04ea9d14$var$funcToString.call(Ctor) == $892c418d04ea9d14$var$objectCtorString;
}
$892c418d04ea9d14$exports = $892c418d04ea9d14$var$isPlainObject;


/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $b9ec780dfc485acf$var$customOmitClone(value) {
    return $892c418d04ea9d14$exports(value) ? undefined : value;
}
$b9ec780dfc485acf$exports = $b9ec780dfc485acf$var$customOmitClone;


var $7e52b49a631e3fd5$exports = {};
var $a477100fb4112fe1$exports = {};
var $84cd513277a9ef09$exports = {};

var $9wjbG = parcelRequire("9wjbG");
var $741f59f21cb4391f$exports = {};

var $3N6ME = parcelRequire("3N6ME");

var $g325N = parcelRequire("g325N");

var $fbNtz = parcelRequire("fbNtz");
/** Built-in value references. */ var $741f59f21cb4391f$var$spreadableSymbol = $3N6ME ? $3N6ME.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $741f59f21cb4391f$var$isFlattenable(value) {
    return $fbNtz(value) || $g325N(value) || !!($741f59f21cb4391f$var$spreadableSymbol && value && value[$741f59f21cb4391f$var$spreadableSymbol]);
}
$741f59f21cb4391f$exports = $741f59f21cb4391f$var$isFlattenable;


/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $84cd513277a9ef09$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $741f59f21cb4391f$exports);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $84cd513277a9ef09$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $9wjbG(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
$84cd513277a9ef09$exports = $84cd513277a9ef09$var$baseFlatten;


/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $a477100fb4112fe1$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $84cd513277a9ef09$exports(array, 1) : [];
}
$a477100fb4112fe1$exports = $a477100fb4112fe1$var$flatten;


var $8148bb13ac3abacf$exports = {};
var $5ca96b98d4464868$exports = {};
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $5ca96b98d4464868$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
$5ca96b98d4464868$exports = $5ca96b98d4464868$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $8148bb13ac3abacf$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $8148bb13ac3abacf$var$overRest(func, start, transform) {
    start = $8148bb13ac3abacf$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $8148bb13ac3abacf$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $5ca96b98d4464868$exports(func, this, otherArgs);
    };
}
$8148bb13ac3abacf$exports = $8148bb13ac3abacf$var$overRest;


var $93c9a78b50b27b08$exports = {};
var $cf835d9742031ece$exports = {};
var $9e7b8c657833bf5a$exports = {};
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $9e7b8c657833bf5a$var$constant(value) {
    return function() {
        return value;
    };
}
$9e7b8c657833bf5a$exports = $9e7b8c657833bf5a$var$constant;




/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $cf835d9742031ece$var$baseSetToString = !$0777fa9efe1be3a4$exports ? $bf6ed353044ea5ae$exports : function(func, string) {
    return $0777fa9efe1be3a4$exports(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': $9e7b8c657833bf5a$exports(string),
        'writable': true
    });
};
$cf835d9742031ece$exports = $cf835d9742031ece$var$baseSetToString;


var $33c197ca25869cd1$exports = {};
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $33c197ca25869cd1$var$HOT_COUNT = 800, $33c197ca25869cd1$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $33c197ca25869cd1$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $33c197ca25869cd1$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $33c197ca25869cd1$var$nativeNow(), remaining = $33c197ca25869cd1$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $33c197ca25869cd1$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
$33c197ca25869cd1$exports = $33c197ca25869cd1$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $93c9a78b50b27b08$var$setToString = $33c197ca25869cd1$exports($cf835d9742031ece$exports);
$93c9a78b50b27b08$exports = $93c9a78b50b27b08$var$setToString;


/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $7e52b49a631e3fd5$var$flatRest(func) {
    return $93c9a78b50b27b08$exports($8148bb13ac3abacf$exports(func, undefined, $a477100fb4112fe1$exports), func + '');
}
$7e52b49a631e3fd5$exports = $7e52b49a631e3fd5$var$flatRest;



/** Used to compose bitmasks for cloning. */ var $0ab7059d2555b0c2$var$CLONE_DEEP_FLAG = 1, $0ab7059d2555b0c2$var$CLONE_FLAT_FLAG = 2, $0ab7059d2555b0c2$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $0ab7059d2555b0c2$var$omit = $7e52b49a631e3fd5$exports(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = $ddec6105b4e18cc5$exports(paths, function(path) {
        path = $4c7af6d47eeb9687$exports(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    $eec18ae330365b90$exports(object, $3ea15658da5695b0$exports(object), result);
    if (isDeep) result = $71a5afe22d2c4a3e$exports(result, $0ab7059d2555b0c2$var$CLONE_DEEP_FLAG | $0ab7059d2555b0c2$var$CLONE_FLAT_FLAG | $0ab7059d2555b0c2$var$CLONE_SYMBOLS_FLAG, $b9ec780dfc485acf$exports);
    var length = paths.length;
    while(length--)$4cb20b357fbc5289$exports(result, paths[length]);
    return result;
});
$0ab7059d2555b0c2$exports = $0ab7059d2555b0c2$var$omit;




// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead







function $f71d904ca421f6b2$var$traceUFOInteraction(name, interactionType, startTime) {
    const rate = (0, $9a2f9fc0af024eb1$export$9466a8f085fa7d4e)(name, interactionType);
    const pressInteractionsList = (0, $9a2f9fc0af024eb1$export$3c170167645a0eff)();
    const minorInteractions = (pressInteractionsList ?? []).concat((0, $9a2f9fc0af024eb1$export$b150ddad71c80d77)() ?? []);
    if (minorInteractions.includes(name)) {
        const activeInteraction = (0, $7390d9fffd2908eb$export$2b3954d2e8509985)();
        activeInteraction?.minorInteractions?.push({
            name: name,
            startTime: startTime ?? performance.now()
        });
        return;
    } else (0, $7390d9fffd2908eb$export$614a7af2affc5dff)('new_interaction', name);
    if ((0, $74d2fea471853068$export$2e2bcd8739ae039)(rate)) {
        const startTimestamp = startTime ?? performance.now();
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const newId = (0, $19dcc840d0563c39$exports.v4)();
        (0, $cb7ea7f0a3e09fe0$export$3109542b68df9ba1).current = newId;
        // covered experiences with tracing instrumentation:
        // inline-result.inline-card-create-submit
        (0, $9931f21957f7e3c2$export$f2e521e495a88544)(newId, interactionType);
        (0, $7390d9fffd2908eb$export$1a1ed1e1fdb2006b)(newId, name, interactionType === 'hover' ? 'press' : interactionType, startTimestamp, rate, [], (0, $70cde0f2b3f65548$export$2e2bcd8739ae039).current, (0, $9931f21957f7e3c2$export$b6ac780db3a3cc77)());
    }
}
var $f71d904ca421f6b2$export$2e2bcd8739ae039 = $f71d904ca421f6b2$var$traceUFOInteraction;


function $7c098619eb9ad053$var$traceUFOPress(name, timestamp) {
    return (0, $f71d904ca421f6b2$export$2e2bcd8739ae039)(name, 'press', timestamp);
}
var $7c098619eb9ad053$export$2e2bcd8739ae039 = $7c098619eb9ad053$var$traceUFOPress;



var $b0809950592c8add$exports = {};
var $db155982079085a7$exports = {};


// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $db155982079085a7$var$_nodeId;
var $db155982079085a7$var$_clockseq;
// Previous uuid creation time
var $db155982079085a7$var$_lastMSecs = 0;
var $db155982079085a7$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $db155982079085a7$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $db155982079085a7$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $db155982079085a7$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $8620f91002fd03c7$exports();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $db155982079085a7$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $db155982079085a7$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $db155982079085a7$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $db155982079085a7$var$_lastMSecs + (nsecs - $db155982079085a7$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $db155982079085a7$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
    $db155982079085a7$var$_lastMSecs = msecs;
    $db155982079085a7$var$_lastNSecs = nsecs;
    $db155982079085a7$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $0eb3fc9f8addfeea$exports(b);
}
$db155982079085a7$exports = $db155982079085a7$var$v1;



var $b0809950592c8add$var$uuid = $c29b43bb0df96673$exports;
$b0809950592c8add$var$uuid.v1 = $db155982079085a7$exports;
$b0809950592c8add$var$uuid.v4 = $c29b43bb0df96673$exports;
$b0809950592c8add$exports = $b0809950592c8add$var$uuid;


// @ts-ignore
var $4ef10afabec0a287$exports = {};
$parcel$export($4ef10afabec0a287$exports, "randomBytes", () => $4ef10afabec0a287$export$5f828d93ff035aa8, (v) => $4ef10afabec0a287$export$5f828d93ff035aa8 = v);
$parcel$export($4ef10afabec0a287$exports, "rng", () => $4ef10afabec0a287$export$cd94982b18c6332c, (v) => $4ef10afabec0a287$export$cd94982b18c6332c = v);
$parcel$export($4ef10afabec0a287$exports, "pseudoRandomBytes", () => $4ef10afabec0a287$export$1d518568e4f529b0, (v) => $4ef10afabec0a287$export$1d518568e4f529b0 = v);
$parcel$export($4ef10afabec0a287$exports, "prng", () => $4ef10afabec0a287$export$5285b6d41c912b41, (v) => $4ef10afabec0a287$export$5285b6d41c912b41 = v);
$parcel$export($4ef10afabec0a287$exports, "createHash", () => $4ef10afabec0a287$export$2fb37efbf6ae0c0e, (v) => $4ef10afabec0a287$export$2fb37efbf6ae0c0e = v);
$parcel$export($4ef10afabec0a287$exports, "Hash", () => $4ef10afabec0a287$export$ab85ecd77ce6a5cd, (v) => $4ef10afabec0a287$export$ab85ecd77ce6a5cd = v);
$parcel$export($4ef10afabec0a287$exports, "createHmac", () => $4ef10afabec0a287$export$da39cf97e1eb7c91, (v) => $4ef10afabec0a287$export$da39cf97e1eb7c91 = v);
$parcel$export($4ef10afabec0a287$exports, "Hmac", () => $4ef10afabec0a287$export$52a9039d7177394f, (v) => $4ef10afabec0a287$export$52a9039d7177394f = v);
$parcel$export($4ef10afabec0a287$exports, "getHashes", () => $4ef10afabec0a287$export$f7201db400317331, (v) => $4ef10afabec0a287$export$f7201db400317331 = v);
$parcel$export($4ef10afabec0a287$exports, "pbkdf2", () => $4ef10afabec0a287$export$448fa22aedc9dbca, (v) => $4ef10afabec0a287$export$448fa22aedc9dbca = v);
$parcel$export($4ef10afabec0a287$exports, "pbkdf2Sync", () => $4ef10afabec0a287$export$b80c7ba289c8fa56, (v) => $4ef10afabec0a287$export$b80c7ba289c8fa56 = v);
$parcel$export($4ef10afabec0a287$exports, "Cipher", () => $4ef10afabec0a287$export$26e5786e8ac8e530, (v) => $4ef10afabec0a287$export$26e5786e8ac8e530 = v);
$parcel$export($4ef10afabec0a287$exports, "createCipher", () => $4ef10afabec0a287$export$bdd223f16383713e, (v) => $4ef10afabec0a287$export$bdd223f16383713e = v);
$parcel$export($4ef10afabec0a287$exports, "Cipheriv", () => $4ef10afabec0a287$export$20533d26f07f1ee0, (v) => $4ef10afabec0a287$export$20533d26f07f1ee0 = v);
$parcel$export($4ef10afabec0a287$exports, "createCipheriv", () => $4ef10afabec0a287$export$2f64596b8cbf08b4, (v) => $4ef10afabec0a287$export$2f64596b8cbf08b4 = v);
$parcel$export($4ef10afabec0a287$exports, "Decipher", () => $4ef10afabec0a287$export$2ce6d8d0e8b04e1a, (v) => $4ef10afabec0a287$export$2ce6d8d0e8b04e1a = v);
$parcel$export($4ef10afabec0a287$exports, "createDecipher", () => $4ef10afabec0a287$export$12ada9414fbc594c, (v) => $4ef10afabec0a287$export$12ada9414fbc594c = v);
$parcel$export($4ef10afabec0a287$exports, "Decipheriv", () => $4ef10afabec0a287$export$f5e7e39d57cd9700, (v) => $4ef10afabec0a287$export$f5e7e39d57cd9700 = v);
$parcel$export($4ef10afabec0a287$exports, "createDecipheriv", () => $4ef10afabec0a287$export$36b6d6ef312eab39, (v) => $4ef10afabec0a287$export$36b6d6ef312eab39 = v);
$parcel$export($4ef10afabec0a287$exports, "getCiphers", () => $4ef10afabec0a287$export$58a258485f1e49f6, (v) => $4ef10afabec0a287$export$58a258485f1e49f6 = v);
$parcel$export($4ef10afabec0a287$exports, "listCiphers", () => $4ef10afabec0a287$export$dedd8dc3dc62b370, (v) => $4ef10afabec0a287$export$dedd8dc3dc62b370 = v);
$parcel$export($4ef10afabec0a287$exports, "DiffieHellmanGroup", () => $4ef10afabec0a287$export$971862a2fcb1bb40, (v) => $4ef10afabec0a287$export$971862a2fcb1bb40 = v);
$parcel$export($4ef10afabec0a287$exports, "createDiffieHellmanGroup", () => $4ef10afabec0a287$export$c6ff6a88acbeaf40, (v) => $4ef10afabec0a287$export$c6ff6a88acbeaf40 = v);
$parcel$export($4ef10afabec0a287$exports, "getDiffieHellman", () => $4ef10afabec0a287$export$fdc27893e98845cc, (v) => $4ef10afabec0a287$export$fdc27893e98845cc = v);
$parcel$export($4ef10afabec0a287$exports, "createDiffieHellman", () => $4ef10afabec0a287$export$6671fb9a1323bed, (v) => $4ef10afabec0a287$export$6671fb9a1323bed = v);
$parcel$export($4ef10afabec0a287$exports, "DiffieHellman", () => $4ef10afabec0a287$export$d74daf141a551db, (v) => $4ef10afabec0a287$export$d74daf141a551db = v);
$parcel$export($4ef10afabec0a287$exports, "createSign", () => $4ef10afabec0a287$export$45df7cae684751af, (v) => $4ef10afabec0a287$export$45df7cae684751af = v);
$parcel$export($4ef10afabec0a287$exports, "Sign", () => $4ef10afabec0a287$export$1db683ad541682f6, (v) => $4ef10afabec0a287$export$1db683ad541682f6 = v);
$parcel$export($4ef10afabec0a287$exports, "createVerify", () => $4ef10afabec0a287$export$6f65485f87568e37, (v) => $4ef10afabec0a287$export$6f65485f87568e37 = v);
$parcel$export($4ef10afabec0a287$exports, "Verify", () => $4ef10afabec0a287$export$91a8e56769aeb334, (v) => $4ef10afabec0a287$export$91a8e56769aeb334 = v);
$parcel$export($4ef10afabec0a287$exports, "createECDH", () => $4ef10afabec0a287$export$2d4117e99c2179e4, (v) => $4ef10afabec0a287$export$2d4117e99c2179e4 = v);
$parcel$export($4ef10afabec0a287$exports, "publicEncrypt", () => $4ef10afabec0a287$export$512823e338ddb1b7, (v) => $4ef10afabec0a287$export$512823e338ddb1b7 = v);
$parcel$export($4ef10afabec0a287$exports, "privateEncrypt", () => $4ef10afabec0a287$export$9d0e0c0c4a8d30f3, (v) => $4ef10afabec0a287$export$9d0e0c0c4a8d30f3 = v);
$parcel$export($4ef10afabec0a287$exports, "publicDecrypt", () => $4ef10afabec0a287$export$b9d55ff329113abd, (v) => $4ef10afabec0a287$export$b9d55ff329113abd = v);
$parcel$export($4ef10afabec0a287$exports, "privateDecrypt", () => $4ef10afabec0a287$export$7efb24e2fddf99b9, (v) => $4ef10afabec0a287$export$7efb24e2fddf99b9 = v);
$parcel$export($4ef10afabec0a287$exports, "randomFill", () => $4ef10afabec0a287$export$bb1abf2ce84fc7e8, (v) => $4ef10afabec0a287$export$bb1abf2ce84fc7e8 = v);
$parcel$export($4ef10afabec0a287$exports, "randomFillSync", () => $4ef10afabec0a287$export$2f7171e78e524d5e, (v) => $4ef10afabec0a287$export$2f7171e78e524d5e = v);
$parcel$export($4ef10afabec0a287$exports, "createCredentials", () => $4ef10afabec0a287$export$e1d879b482f37d98, (v) => $4ef10afabec0a287$export$e1d879b482f37d98 = v);
$parcel$export($4ef10afabec0a287$exports, "constants", () => $4ef10afabec0a287$export$1a988e7317c65621, (v) => $4ef10afabec0a287$export$1a988e7317c65621 = v);
// eslint-disable-next-line no-multi-assign
var $4ef10afabec0a287$export$5f828d93ff035aa8;
var $4ef10afabec0a287$export$cd94982b18c6332c;
var $4ef10afabec0a287$export$1d518568e4f529b0;
var $4ef10afabec0a287$export$5285b6d41c912b41;
// eslint-disable-next-line no-multi-assign
var $4ef10afabec0a287$export$2fb37efbf6ae0c0e;
var $4ef10afabec0a287$export$ab85ecd77ce6a5cd;
// eslint-disable-next-line no-multi-assign
var $4ef10afabec0a287$export$da39cf97e1eb7c91;
var $4ef10afabec0a287$export$52a9039d7177394f;
var $4ef10afabec0a287$export$f7201db400317331;
var $4ef10afabec0a287$export$448fa22aedc9dbca;
var $4ef10afabec0a287$export$b80c7ba289c8fa56;
var $4ef10afabec0a287$export$26e5786e8ac8e530;
var $4ef10afabec0a287$export$bdd223f16383713e;
var $4ef10afabec0a287$export$20533d26f07f1ee0;
var $4ef10afabec0a287$export$2f64596b8cbf08b4;
var $4ef10afabec0a287$export$2ce6d8d0e8b04e1a;
var $4ef10afabec0a287$export$12ada9414fbc594c;
var $4ef10afabec0a287$export$f5e7e39d57cd9700;
var $4ef10afabec0a287$export$36b6d6ef312eab39;
var $4ef10afabec0a287$export$58a258485f1e49f6;
var $4ef10afabec0a287$export$dedd8dc3dc62b370;
var $4ef10afabec0a287$export$971862a2fcb1bb40;
var $4ef10afabec0a287$export$c6ff6a88acbeaf40;
var $4ef10afabec0a287$export$fdc27893e98845cc;
var $4ef10afabec0a287$export$6671fb9a1323bed;
var $4ef10afabec0a287$export$d74daf141a551db;
var $4ef10afabec0a287$export$45df7cae684751af;
var $4ef10afabec0a287$export$1db683ad541682f6;
var $4ef10afabec0a287$export$6f65485f87568e37;
var $4ef10afabec0a287$export$91a8e56769aeb334;
var $4ef10afabec0a287$export$2d4117e99c2179e4;
var $4ef10afabec0a287$export$512823e338ddb1b7;
var $4ef10afabec0a287$export$9d0e0c0c4a8d30f3;
var $4ef10afabec0a287$export$b9d55ff329113abd;
var $4ef10afabec0a287$export$7efb24e2fddf99b9;
var $4ef10afabec0a287$export$bb1abf2ce84fc7e8;
var $4ef10afabec0a287$export$2f7171e78e524d5e;
var $4ef10afabec0a287$export$e1d879b482f37d98;
var $4ef10afabec0a287$export$1a988e7317c65621;
'use strict';

$4ef10afabec0a287$export$5f828d93ff035aa8 = $4ef10afabec0a287$export$cd94982b18c6332c = $4ef10afabec0a287$export$1d518568e4f529b0 = $4ef10afabec0a287$export$5285b6d41c912b41 = (parcelRequire("cN8vX"));

$4ef10afabec0a287$export$2fb37efbf6ae0c0e = $4ef10afabec0a287$export$ab85ecd77ce6a5cd = (parcelRequire("4Qxdz"));

$4ef10afabec0a287$export$da39cf97e1eb7c91 = $4ef10afabec0a287$export$52a9039d7177394f = (parcelRequire("iyMeE"));
var $c53b26f975827720$exports = {};
'use strict';

$c53b26f975827720$exports = (parcelRequire("lisa3"));


var $4ef10afabec0a287$var$algoKeys = Object.keys($c53b26f975827720$exports);
var $4ef10afabec0a287$var$hashes = [
    'sha1',
    'sha224',
    'sha256',
    'sha384',
    'sha512',
    'md5',
    'rmd160'
].concat($4ef10afabec0a287$var$algoKeys);
$4ef10afabec0a287$export$f7201db400317331 = function() {
    return $4ef10afabec0a287$var$hashes;
};

var $gxFlu = parcelRequire("gxFlu");
$4ef10afabec0a287$export$448fa22aedc9dbca = $gxFlu.pbkdf2;
$4ef10afabec0a287$export$b80c7ba289c8fa56 = $gxFlu.pbkdf2Sync;
var $29be82dd6585da61$export$bdd223f16383713e;
var $29be82dd6585da61$export$26e5786e8ac8e530;
var $29be82dd6585da61$export$2f64596b8cbf08b4;
var $29be82dd6585da61$export$20533d26f07f1ee0;
var $29be82dd6585da61$export$12ada9414fbc594c;
var $29be82dd6585da61$export$2ce6d8d0e8b04e1a;
var $29be82dd6585da61$export$36b6d6ef312eab39;
var $29be82dd6585da61$export$f5e7e39d57cd9700;
var $29be82dd6585da61$export$dedd8dc3dc62b370;
var $29be82dd6585da61$export$58a258485f1e49f6;
var $6aa46e1de1e00265$exports = {};

var $h4bOS = parcelRequire("h4bOS");
var $dc0249462be79f5b$export$eab97d15b1788b8d;
var $dc0249462be79f5b$export$26e5786e8ac8e530;
var $dc0249462be79f5b$export$cc8859615686b300;
var $dc0249462be79f5b$export$8ad3f227af08fcc5;
var $dc0249462be79f5b$export$947646e34766044f;
'use strict';

$dc0249462be79f5b$export$eab97d15b1788b8d = (parcelRequire("aSNbB"));

$dc0249462be79f5b$export$26e5786e8ac8e530 = (parcelRequire("jmHeI"));

$dc0249462be79f5b$export$cc8859615686b300 = (parcelRequire("a7xg7"));

$dc0249462be79f5b$export$8ad3f227af08fcc5 = (parcelRequire("aI1LC"));

$dc0249462be79f5b$export$947646e34766044f = (parcelRequire("9g7wA"));



var $jcXeW = parcelRequire("jcXeW");

var $dmAgJ = parcelRequire("dmAgJ");
var $6aa46e1de1e00265$require$Buffer = $dmAgJ.Buffer;
var $6aa46e1de1e00265$var$modes = {
    'des-ede3-cbc': $dc0249462be79f5b$export$8ad3f227af08fcc5.instantiate($dc0249462be79f5b$export$947646e34766044f),
    'des-ede3': $dc0249462be79f5b$export$947646e34766044f,
    'des-ede-cbc': $dc0249462be79f5b$export$8ad3f227af08fcc5.instantiate($dc0249462be79f5b$export$947646e34766044f),
    'des-ede': $dc0249462be79f5b$export$947646e34766044f,
    'des-cbc': $dc0249462be79f5b$export$8ad3f227af08fcc5.instantiate($dc0249462be79f5b$export$cc8859615686b300),
    'des-ecb': $dc0249462be79f5b$export$cc8859615686b300
};
$6aa46e1de1e00265$var$modes.des = $6aa46e1de1e00265$var$modes['des-cbc'];
$6aa46e1de1e00265$var$modes.des3 = $6aa46e1de1e00265$var$modes['des-ede3-cbc'];
$6aa46e1de1e00265$exports = $6aa46e1de1e00265$var$DES;
$jcXeW($6aa46e1de1e00265$var$DES, $h4bOS);
function $6aa46e1de1e00265$var$DES(opts) {
    $h4bOS.call(this);
    var modeName = opts.mode.toLowerCase();
    var mode = $6aa46e1de1e00265$var$modes[modeName];
    var type;
    if (opts.decrypt) type = 'decrypt';
    else type = 'encrypt';
    var key = opts.key;
    if (!$6aa46e1de1e00265$require$Buffer.isBuffer(key)) key = $6aa46e1de1e00265$require$Buffer.from(key);
    if (modeName === 'des-ede' || modeName === 'des-ede-cbc') key = $6aa46e1de1e00265$require$Buffer.concat([
        key,
        key.slice(0, 8)
    ]);
    var iv = opts.iv;
    if (!$6aa46e1de1e00265$require$Buffer.isBuffer(iv)) iv = $6aa46e1de1e00265$require$Buffer.from(iv);
    this._des = mode.create({
        key: key,
        iv: iv,
        type: type
    });
}
$6aa46e1de1e00265$var$DES.prototype._update = function(data) {
    return $6aa46e1de1e00265$require$Buffer.from(this._des.update(data));
};
$6aa46e1de1e00265$var$DES.prototype._final = function() {
    return $6aa46e1de1e00265$require$Buffer.from(this._des.final());
};



var $3Gyxn = parcelRequire("3Gyxn");

var $cu5JN = parcelRequire("cu5JN");
var $1ef463c71bb27ca0$exports = {};
$parcel$export($1ef463c71bb27ca0$exports, "des-ecb", () => $1ef463c71bb27ca0$export$116f8a5cee447347, (v) => $1ef463c71bb27ca0$export$116f8a5cee447347 = v);
$parcel$export($1ef463c71bb27ca0$exports, "des-cbc", () => $1ef463c71bb27ca0$export$7483c4066bfb7ae9, (v) => $1ef463c71bb27ca0$export$7483c4066bfb7ae9 = v);
$parcel$export($1ef463c71bb27ca0$exports, "des", () => $1ef463c71bb27ca0$export$e7a565d2e588bb06, (v) => $1ef463c71bb27ca0$export$e7a565d2e588bb06 = v);
$parcel$export($1ef463c71bb27ca0$exports, "des-ede3-cbc", () => $1ef463c71bb27ca0$export$aaa2f54a426f3eb8, (v) => $1ef463c71bb27ca0$export$aaa2f54a426f3eb8 = v);
$parcel$export($1ef463c71bb27ca0$exports, "des3", () => $1ef463c71bb27ca0$export$eba20568dde4ada, (v) => $1ef463c71bb27ca0$export$eba20568dde4ada = v);
$parcel$export($1ef463c71bb27ca0$exports, "des-ede3", () => $1ef463c71bb27ca0$export$d3b5e5996938f5ae, (v) => $1ef463c71bb27ca0$export$d3b5e5996938f5ae = v);
$parcel$export($1ef463c71bb27ca0$exports, "des-ede-cbc", () => $1ef463c71bb27ca0$export$57c08356130bc99b, (v) => $1ef463c71bb27ca0$export$57c08356130bc99b = v);
$parcel$export($1ef463c71bb27ca0$exports, "des-ede", () => $1ef463c71bb27ca0$export$c7169791d5c1e65d, (v) => $1ef463c71bb27ca0$export$c7169791d5c1e65d = v);
var $1ef463c71bb27ca0$export$116f8a5cee447347;
var $1ef463c71bb27ca0$export$7483c4066bfb7ae9;
var $1ef463c71bb27ca0$export$e7a565d2e588bb06;
var $1ef463c71bb27ca0$export$aaa2f54a426f3eb8;
var $1ef463c71bb27ca0$export$eba20568dde4ada;
var $1ef463c71bb27ca0$export$d3b5e5996938f5ae;
var $1ef463c71bb27ca0$export$57c08356130bc99b;
var $1ef463c71bb27ca0$export$c7169791d5c1e65d;
$1ef463c71bb27ca0$export$116f8a5cee447347 = {
    key: 8,
    iv: 0
};
$1ef463c71bb27ca0$export$7483c4066bfb7ae9 = $1ef463c71bb27ca0$export$e7a565d2e588bb06 = {
    key: 8,
    iv: 8
};
$1ef463c71bb27ca0$export$aaa2f54a426f3eb8 = $1ef463c71bb27ca0$export$eba20568dde4ada = {
    key: 24,
    iv: 8
};
$1ef463c71bb27ca0$export$d3b5e5996938f5ae = {
    key: 24,
    iv: 0
};
$1ef463c71bb27ca0$export$57c08356130bc99b = {
    key: 16,
    iv: 8
};
$1ef463c71bb27ca0$export$c7169791d5c1e65d = {
    key: 16,
    iv: 0
};



var $crCGb = parcelRequire("crCGb");
function $29be82dd6585da61$var$createCipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($cu5JN[suite]) {
        keyLen = $cu5JN[suite].key;
        ivLen = $cu5JN[suite].iv;
    } else if ($1ef463c71bb27ca0$exports[suite]) {
        keyLen = $1ef463c71bb27ca0$exports[suite].key * 8;
        ivLen = $1ef463c71bb27ca0$exports[suite].iv;
    } else throw new TypeError('invalid suite type');
    var keys = $crCGb(password, false, keyLen, ivLen);
    return $29be82dd6585da61$var$createCipheriv(suite, keys.key, keys.iv);
}
function $29be82dd6585da61$var$createDecipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($cu5JN[suite]) {
        keyLen = $cu5JN[suite].key;
        ivLen = $cu5JN[suite].iv;
    } else if ($1ef463c71bb27ca0$exports[suite]) {
        keyLen = $1ef463c71bb27ca0$exports[suite].key * 8;
        ivLen = $1ef463c71bb27ca0$exports[suite].iv;
    } else throw new TypeError('invalid suite type');
    var keys = $crCGb(password, false, keyLen, ivLen);
    return $29be82dd6585da61$var$createDecipheriv(suite, keys.key, keys.iv);
}
function $29be82dd6585da61$var$createCipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($cu5JN[suite]) return $3Gyxn.createCipheriv(suite, key, iv);
    if ($1ef463c71bb27ca0$exports[suite]) return new $6aa46e1de1e00265$exports({
        key: key,
        iv: iv,
        mode: suite
    });
    throw new TypeError('invalid suite type');
}
function $29be82dd6585da61$var$createDecipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($cu5JN[suite]) return $3Gyxn.createDecipheriv(suite, key, iv);
    if ($1ef463c71bb27ca0$exports[suite]) return new $6aa46e1de1e00265$exports({
        key: key,
        iv: iv,
        mode: suite,
        decrypt: true
    });
    throw new TypeError('invalid suite type');
}
function $29be82dd6585da61$var$getCiphers() {
    return Object.keys($1ef463c71bb27ca0$exports).concat($3Gyxn.getCiphers());
}
$29be82dd6585da61$export$bdd223f16383713e = $29be82dd6585da61$export$26e5786e8ac8e530 = $29be82dd6585da61$var$createCipher;
$29be82dd6585da61$export$2f64596b8cbf08b4 = $29be82dd6585da61$export$20533d26f07f1ee0 = $29be82dd6585da61$var$createCipheriv;
$29be82dd6585da61$export$12ada9414fbc594c = $29be82dd6585da61$export$2ce6d8d0e8b04e1a = $29be82dd6585da61$var$createDecipher;
$29be82dd6585da61$export$36b6d6ef312eab39 = $29be82dd6585da61$export$f5e7e39d57cd9700 = $29be82dd6585da61$var$createDecipheriv;
$29be82dd6585da61$export$dedd8dc3dc62b370 = $29be82dd6585da61$export$58a258485f1e49f6 = $29be82dd6585da61$var$getCiphers;


$4ef10afabec0a287$export$26e5786e8ac8e530 = $29be82dd6585da61$export$26e5786e8ac8e530;
$4ef10afabec0a287$export$bdd223f16383713e = $29be82dd6585da61$export$bdd223f16383713e;
$4ef10afabec0a287$export$20533d26f07f1ee0 = $29be82dd6585da61$export$20533d26f07f1ee0;
$4ef10afabec0a287$export$2f64596b8cbf08b4 = $29be82dd6585da61$export$2f64596b8cbf08b4;
$4ef10afabec0a287$export$2ce6d8d0e8b04e1a = $29be82dd6585da61$export$2ce6d8d0e8b04e1a;
$4ef10afabec0a287$export$12ada9414fbc594c = $29be82dd6585da61$export$12ada9414fbc594c;
$4ef10afabec0a287$export$f5e7e39d57cd9700 = $29be82dd6585da61$export$f5e7e39d57cd9700;
$4ef10afabec0a287$export$36b6d6ef312eab39 = $29be82dd6585da61$export$36b6d6ef312eab39;
$4ef10afabec0a287$export$58a258485f1e49f6 = $29be82dd6585da61$export$58a258485f1e49f6;
$4ef10afabec0a287$export$dedd8dc3dc62b370 = $29be82dd6585da61$export$dedd8dc3dc62b370;
var $0d4f7eedacca308f$export$971862a2fcb1bb40;
var $0d4f7eedacca308f$export$c6ff6a88acbeaf40;
var $0d4f7eedacca308f$export$fdc27893e98845cc;
var $0d4f7eedacca308f$export$6671fb9a1323bed;
var $0d4f7eedacca308f$export$d74daf141a551db;

var $b0qLu = parcelRequire("b0qLu");
var $0d4f7eedacca308f$require$Buffer = $b0qLu.Buffer;
var $725f43d61e375a6a$exports = {};

var $cN8vX = parcelRequire("cN8vX");
$725f43d61e375a6a$exports = $725f43d61e375a6a$var$findPrime;
$725f43d61e375a6a$var$findPrime.simpleSieve = $725f43d61e375a6a$var$simpleSieve;
$725f43d61e375a6a$var$findPrime.fermatTest = $725f43d61e375a6a$var$fermatTest;

var $kHwXh = parcelRequire("kHwXh");
var $725f43d61e375a6a$var$TWENTYFOUR = new $kHwXh(24);
var $2a266485996e700f$exports = {};

var $kHwXh = parcelRequire("kHwXh");

var $fZ33D = parcelRequire("fZ33D");
function $2a266485996e700f$var$MillerRabin(rand) {
    this.rand = rand || new $fZ33D.Rand();
}
$2a266485996e700f$exports = $2a266485996e700f$var$MillerRabin;
$2a266485996e700f$var$MillerRabin.create = function create(rand) {
    return new $2a266485996e700f$var$MillerRabin(rand);
};
$2a266485996e700f$var$MillerRabin.prototype._randbelow = function _randbelow(n) {
    var len = n.bitLength();
    var min_bytes = Math.ceil(len / 8);
    // Generage random bytes until a number less than n is found.
    // This ensures that 0..n-1 have an equal probability of being selected.
    do var a = new $kHwXh(this.rand.generate(min_bytes));
    while (a.cmp(n) >= 0);
    return a;
};
$2a266485996e700f$var$MillerRabin.prototype._randrange = function _randrange(start, stop) {
    // Generate a random number greater than or equal to start and less than stop.
    var size = stop.sub(start);
    return start.add(this._randbelow(size));
};
$2a266485996e700f$var$MillerRabin.prototype.test = function test(n, k, cb) {
    var len = n.bitLength();
    var red = $kHwXh.mont(n);
    var rone = new $kHwXh(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    var prime = true;
    for(; k > 0; k--){
        var a = this._randrange(new $kHwXh(2), n1);
        if (cb) cb(a);
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return false;
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) return false;
    }
    return prime;
};
$2a266485996e700f$var$MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
    var len = n.bitLength();
    var red = $kHwXh.mont(n);
    var rone = new $kHwXh(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    for(; k > 0; k--){
        var a = this._randrange(new $kHwXh(2), n1);
        var g = n.gcd(a);
        if (g.cmpn(1) !== 0) return g;
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return x.fromRed().subn(1).gcd(n);
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) {
            x = x.redSqr();
            return x.fromRed().subn(1).gcd(n);
        }
    }
    return false;
};


var $725f43d61e375a6a$var$millerRabin = new $2a266485996e700f$exports();
var $725f43d61e375a6a$var$ONE = new $kHwXh(1);
var $725f43d61e375a6a$var$TWO = new $kHwXh(2);
var $725f43d61e375a6a$var$FIVE = new $kHwXh(5);
var $725f43d61e375a6a$var$SIXTEEN = new $kHwXh(16);
var $725f43d61e375a6a$var$EIGHT = new $kHwXh(8);
var $725f43d61e375a6a$var$TEN = new $kHwXh(10);
var $725f43d61e375a6a$var$THREE = new $kHwXh(3);
var $725f43d61e375a6a$var$SEVEN = new $kHwXh(7);
var $725f43d61e375a6a$var$ELEVEN = new $kHwXh(11);
var $725f43d61e375a6a$var$FOUR = new $kHwXh(4);
var $725f43d61e375a6a$var$TWELVE = new $kHwXh(12);
var $725f43d61e375a6a$var$primes = null;
function $725f43d61e375a6a$var$_getPrimes() {
    if ($725f43d61e375a6a$var$primes !== null) return $725f43d61e375a6a$var$primes;
    var limit = 0x100000;
    var res = [];
    res[0] = 2;
    for(var i = 1, k = 3; k < limit; k += 2){
        var sqrt = Math.ceil(Math.sqrt(k));
        for(var j = 0; j < i && res[j] <= sqrt; j++)if (k % res[j] === 0) break;
        if (i !== j && res[j] <= sqrt) continue;
        res[i++] = k;
    }
    $725f43d61e375a6a$var$primes = res;
    return res;
}
function $725f43d61e375a6a$var$simpleSieve(p) {
    var primes = $725f43d61e375a6a$var$_getPrimes();
    for(var i = 0; i < primes.length; i++)if (p.modn(primes[i]) === 0) {
        if (p.cmpn(primes[i]) === 0) return true;
        else return false;
    }
    return true;
}
function $725f43d61e375a6a$var$fermatTest(p) {
    var red = $kHwXh.mont(p);
    return $725f43d61e375a6a$var$TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}
function $725f43d61e375a6a$var$findPrime(bits, gen) {
    if (bits < 16) {
        // this is what openssl does
        if (gen === 2 || gen === 5) return new $kHwXh([
            0x8c,
            0x7b
        ]);
        else return new $kHwXh([
            0x8c,
            0x27
        ]);
    }
    gen = new $kHwXh(gen);
    var num, n2;
    while(true){
        num = new $kHwXh($cN8vX(Math.ceil(bits / 8)));
        while(num.bitLength() > bits)num.ishrn(1);
        if (num.isEven()) num.iadd($725f43d61e375a6a$var$ONE);
        if (!num.testn(1)) num.iadd($725f43d61e375a6a$var$TWO);
        if (!gen.cmp($725f43d61e375a6a$var$TWO)) while(num.mod($725f43d61e375a6a$var$TWENTYFOUR).cmp($725f43d61e375a6a$var$ELEVEN))num.iadd($725f43d61e375a6a$var$FOUR);
        else if (!gen.cmp($725f43d61e375a6a$var$FIVE)) while(num.mod($725f43d61e375a6a$var$TEN).cmp($725f43d61e375a6a$var$THREE))num.iadd($725f43d61e375a6a$var$FOUR);
        n2 = num.shrn(1);
        if ($725f43d61e375a6a$var$simpleSieve(n2) && $725f43d61e375a6a$var$simpleSieve(num) && $725f43d61e375a6a$var$fermatTest(n2) && $725f43d61e375a6a$var$fermatTest(num) && $725f43d61e375a6a$var$millerRabin.test(n2) && $725f43d61e375a6a$var$millerRabin.test(num)) return num;
    }
}


var $7628d6222f882640$exports = {};
$7628d6222f882640$exports = JSON.parse("{\"modp1\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff\"},\"modp2\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff\"},\"modp5\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff\"},\"modp14\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff\"},\"modp15\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff\"},\"modp16\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff\"},\"modp17\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff\"},\"modp18\":{\"gen\":\"02\",\"prime\":\"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\"}}");


var $bab85fa24477e5c0$exports = {};

var $b0qLu = parcelRequire("b0qLu");
var $bab85fa24477e5c0$require$Buffer = $b0qLu.Buffer;

var $kHwXh = parcelRequire("kHwXh");

var $bab85fa24477e5c0$var$millerRabin = new $2a266485996e700f$exports();
var $bab85fa24477e5c0$var$TWENTYFOUR = new $kHwXh(24);
var $bab85fa24477e5c0$var$ELEVEN = new $kHwXh(11);
var $bab85fa24477e5c0$var$TEN = new $kHwXh(10);
var $bab85fa24477e5c0$var$THREE = new $kHwXh(3);
var $bab85fa24477e5c0$var$SEVEN = new $kHwXh(7);


var $cN8vX = parcelRequire("cN8vX");
$bab85fa24477e5c0$exports = $bab85fa24477e5c0$var$DH;
function $bab85fa24477e5c0$var$setPublicKey(pub, enc) {
    enc = enc || 'utf8';
    if (!$bab85fa24477e5c0$require$Buffer.isBuffer(pub)) pub = new $bab85fa24477e5c0$require$Buffer(pub, enc);
    this._pub = new $kHwXh(pub);
    return this;
}
function $bab85fa24477e5c0$var$setPrivateKey(priv, enc) {
    enc = enc || 'utf8';
    if (!$bab85fa24477e5c0$require$Buffer.isBuffer(priv)) priv = new $bab85fa24477e5c0$require$Buffer(priv, enc);
    this._priv = new $kHwXh(priv);
    return this;
}
var $bab85fa24477e5c0$var$primeCache = {};
function $bab85fa24477e5c0$var$checkPrime(prime, generator) {
    var gen = generator.toString('hex');
    var hex = [
        gen,
        prime.toString(16)
    ].join('_');
    if (hex in $bab85fa24477e5c0$var$primeCache) return $bab85fa24477e5c0$var$primeCache[hex];
    var error = 0;
    if (prime.isEven() || !$725f43d61e375a6a$exports.simpleSieve || !$725f43d61e375a6a$exports.fermatTest(prime) || !$bab85fa24477e5c0$var$millerRabin.test(prime)) {
        //not a prime so +1
        error += 1;
        if (gen === '02' || gen === '05') // we'd be able to check the generator
        // it would fail so +8
        error += 8;
        else //we wouldn't be able to test the generator
        // so +4
        error += 4;
        $bab85fa24477e5c0$var$primeCache[hex] = error;
        return error;
    }
    if (!$bab85fa24477e5c0$var$millerRabin.test(prime.shrn(1))) //not a safe prime
    error += 2;
    var rem;
    switch(gen){
        case '02':
            if (prime.mod($bab85fa24477e5c0$var$TWENTYFOUR).cmp($bab85fa24477e5c0$var$ELEVEN)) // unsuidable generator
            error += 8;
            break;
        case '05':
            rem = prime.mod($bab85fa24477e5c0$var$TEN);
            if (rem.cmp($bab85fa24477e5c0$var$THREE) && rem.cmp($bab85fa24477e5c0$var$SEVEN)) // prime mod 10 needs to equal 3 or 7
            error += 8;
            break;
        default:
            error += 4;
    }
    $bab85fa24477e5c0$var$primeCache[hex] = error;
    return error;
}
function $bab85fa24477e5c0$var$DH(prime, generator, malleable) {
    this.setGenerator(generator);
    this.__prime = new $kHwXh(prime);
    this._prime = $kHwXh.mont(this.__prime);
    this._primeLen = prime.length;
    this._pub = undefined;
    this._priv = undefined;
    this._primeCode = undefined;
    if (malleable) {
        this.setPublicKey = $bab85fa24477e5c0$var$setPublicKey;
        this.setPrivateKey = $bab85fa24477e5c0$var$setPrivateKey;
    } else this._primeCode = 8;
}
Object.defineProperty($bab85fa24477e5c0$var$DH.prototype, 'verifyError', {
    enumerable: true,
    get: function() {
        if (typeof this._primeCode !== 'number') this._primeCode = $bab85fa24477e5c0$var$checkPrime(this.__prime, this.__gen);
        return this._primeCode;
    }
});
$bab85fa24477e5c0$var$DH.prototype.generateKeys = function() {
    if (!this._priv) this._priv = new $kHwXh($cN8vX(this._primeLen));
    this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
    return this.getPublicKey();
};
$bab85fa24477e5c0$var$DH.prototype.computeSecret = function(other) {
    other = new $kHwXh(other);
    other = other.toRed(this._prime);
    var secret = other.redPow(this._priv).fromRed();
    var out = new $bab85fa24477e5c0$require$Buffer(secret.toArray());
    var prime = this.getPrime();
    if (out.length < prime.length) {
        var front = new $bab85fa24477e5c0$require$Buffer(prime.length - out.length);
        front.fill(0);
        out = $bab85fa24477e5c0$require$Buffer.concat([
            front,
            out
        ]);
    }
    return out;
};
$bab85fa24477e5c0$var$DH.prototype.getPublicKey = function getPublicKey(enc) {
    return $bab85fa24477e5c0$var$formatReturnValue(this._pub, enc);
};
$bab85fa24477e5c0$var$DH.prototype.getPrivateKey = function getPrivateKey(enc) {
    return $bab85fa24477e5c0$var$formatReturnValue(this._priv, enc);
};
$bab85fa24477e5c0$var$DH.prototype.getPrime = function(enc) {
    return $bab85fa24477e5c0$var$formatReturnValue(this.__prime, enc);
};
$bab85fa24477e5c0$var$DH.prototype.getGenerator = function(enc) {
    return $bab85fa24477e5c0$var$formatReturnValue(this._gen, enc);
};
$bab85fa24477e5c0$var$DH.prototype.setGenerator = function(gen, enc) {
    enc = enc || 'utf8';
    if (!$bab85fa24477e5c0$require$Buffer.isBuffer(gen)) gen = new $bab85fa24477e5c0$require$Buffer(gen, enc);
    this.__gen = gen;
    this._gen = new $kHwXh(gen);
    return this;
};
function $bab85fa24477e5c0$var$formatReturnValue(bn, enc) {
    var buf = new $bab85fa24477e5c0$require$Buffer(bn.toArray());
    if (!enc) return buf;
    else return buf.toString(enc);
}


function $0d4f7eedacca308f$var$getDiffieHellman(mod) {
    var prime = new $0d4f7eedacca308f$require$Buffer($7628d6222f882640$exports[mod].prime, 'hex');
    var gen = new $0d4f7eedacca308f$require$Buffer($7628d6222f882640$exports[mod].gen, 'hex');
    return new $bab85fa24477e5c0$exports(prime, gen);
}
var $0d4f7eedacca308f$var$ENCODINGS = {
    'binary': true,
    'hex': true,
    'base64': true
};
function $0d4f7eedacca308f$var$createDiffieHellman(prime, enc, generator, genc) {
    if ($0d4f7eedacca308f$require$Buffer.isBuffer(enc) || $0d4f7eedacca308f$var$ENCODINGS[enc] === undefined) return $0d4f7eedacca308f$var$createDiffieHellman(prime, 'binary', enc, generator);
    enc = enc || 'binary';
    genc = genc || 'binary';
    generator = generator || new $0d4f7eedacca308f$require$Buffer([
        2
    ]);
    if (!$0d4f7eedacca308f$require$Buffer.isBuffer(generator)) generator = new $0d4f7eedacca308f$require$Buffer(generator, genc);
    if (typeof prime === 'number') return new $bab85fa24477e5c0$exports($725f43d61e375a6a$exports(prime, generator), generator, true);
    if (!$0d4f7eedacca308f$require$Buffer.isBuffer(prime)) prime = new $0d4f7eedacca308f$require$Buffer(prime, enc);
    return new $bab85fa24477e5c0$exports(prime, generator, true);
}
$0d4f7eedacca308f$export$971862a2fcb1bb40 = $0d4f7eedacca308f$export$c6ff6a88acbeaf40 = $0d4f7eedacca308f$export$fdc27893e98845cc = $0d4f7eedacca308f$var$getDiffieHellman;
$0d4f7eedacca308f$export$6671fb9a1323bed = $0d4f7eedacca308f$export$d74daf141a551db = $0d4f7eedacca308f$var$createDiffieHellman;


$4ef10afabec0a287$export$971862a2fcb1bb40 = $0d4f7eedacca308f$export$971862a2fcb1bb40;
$4ef10afabec0a287$export$c6ff6a88acbeaf40 = $0d4f7eedacca308f$export$c6ff6a88acbeaf40;
$4ef10afabec0a287$export$fdc27893e98845cc = $0d4f7eedacca308f$export$fdc27893e98845cc;
$4ef10afabec0a287$export$6671fb9a1323bed = $0d4f7eedacca308f$export$6671fb9a1323bed;
$4ef10afabec0a287$export$d74daf141a551db = $0d4f7eedacca308f$export$d74daf141a551db;
var $b12f50751aee259f$exports = {};
'use strict';

var $dmAgJ = parcelRequire("dmAgJ");
var $b12f50751aee259f$require$Buffer = $dmAgJ.Buffer;

var $4Qxdz = parcelRequire("4Qxdz");

var $f2OM9 = parcelRequire("f2OM9");

var $jcXeW = parcelRequire("jcXeW");
var $9ad790349cfcf60f$exports = {};
'use strict';

var $dmAgJ = parcelRequire("dmAgJ");
var $9ad790349cfcf60f$require$Buffer = $dmAgJ.Buffer;

var $iyMeE = parcelRequire("iyMeE");

var $d6mSV = parcelRequire("d6mSV");

var $hVpqU = parcelRequire("hVpqU");
var $9ad790349cfcf60f$require$EC = $hVpqU.ec;

var $bMLik = parcelRequire("bMLik");

var $2SvhT = parcelRequire("2SvhT");
var $fbc56e89ccf31b74$exports = {};
$fbc56e89ccf31b74$exports = JSON.parse("{\"1.3.132.0.10\":\"secp256k1\",\"1.3.132.0.33\":\"p224\",\"1.2.840.10045.3.1.1\":\"p192\",\"1.2.840.10045.3.1.7\":\"p256\",\"1.3.132.0.34\":\"p384\",\"1.3.132.0.35\":\"p521\"}");


var $9ad790349cfcf60f$var$RSA_PKCS1_PADDING = 1;
function $9ad790349cfcf60f$var$sign(hash, key, hashType, signType, tag) {
    var priv = $2SvhT(key);
    if (priv.curve) {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
        return $9ad790349cfcf60f$var$ecSign(hash, priv);
    } else if (priv.type === 'dsa') {
        if (signType !== 'dsa') throw new Error('wrong private key type');
        return $9ad790349cfcf60f$var$dsaSign(hash, priv, hashType);
    }
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
    if (key.padding !== undefined && key.padding !== $9ad790349cfcf60f$var$RSA_PKCS1_PADDING) throw new Error('illegal or unsupported padding mode');
    hash = $9ad790349cfcf60f$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = priv.modulus.byteLength();
    var pad = [
        0,
        1
    ];
    while(hash.length + pad.length + 1 < len)pad.push(0xff);
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    var out = $d6mSV(pad, priv);
    return out;
}
function $9ad790349cfcf60f$var$ecSign(hash, priv) {
    var curveId = $fbc56e89ccf31b74$exports[priv.curve.join('.')];
    if (!curveId) throw new Error('unknown curve ' + priv.curve.join('.'));
    var curve = new $9ad790349cfcf60f$require$EC(curveId);
    var key = curve.keyFromPrivate(priv.privateKey);
    var out = key.sign(hash);
    return $9ad790349cfcf60f$require$Buffer.from(out.toDER());
}
function $9ad790349cfcf60f$var$dsaSign(hash, priv, algo) {
    var x = priv.params.priv_key;
    var p = priv.params.p;
    var q = priv.params.q;
    var g = priv.params.g;
    var r = new $bMLik(0);
    var k;
    var H = $9ad790349cfcf60f$var$bits2int(hash, q).mod(q);
    var s = false;
    var kv = $9ad790349cfcf60f$var$getKey(x, q, hash, algo);
    while(s === false){
        k = $9ad790349cfcf60f$var$makeKey(q, kv, algo);
        r = $9ad790349cfcf60f$var$makeR(g, k, p, q);
        s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
        if (s.cmpn(0) === 0) {
            s = false;
            r = new $bMLik(0);
        }
    }
    return $9ad790349cfcf60f$var$toDER(r, s);
}
function $9ad790349cfcf60f$var$toDER(r, s) {
    r = r.toArray();
    s = s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    var total = r.length + s.length + 4;
    var res = [
        0x30,
        total,
        0x02,
        r.length
    ];
    res = res.concat(r, [
        0x02,
        s.length
    ], s);
    return $9ad790349cfcf60f$require$Buffer.from(res);
}
function $9ad790349cfcf60f$var$getKey(x, q, hash, algo) {
    x = $9ad790349cfcf60f$require$Buffer.from(x.toArray());
    if (x.length < q.byteLength()) {
        var zeros = $9ad790349cfcf60f$require$Buffer.alloc(q.byteLength() - x.length);
        x = $9ad790349cfcf60f$require$Buffer.concat([
            zeros,
            x
        ]);
    }
    var hlen = hash.length;
    var hbits = $9ad790349cfcf60f$var$bits2octets(hash, q);
    var v = $9ad790349cfcf60f$require$Buffer.alloc(hlen);
    v.fill(1);
    var k = $9ad790349cfcf60f$require$Buffer.alloc(hlen);
    k = $iyMeE(algo, k).update(v).update($9ad790349cfcf60f$require$Buffer.from([
        0
    ])).update(x).update(hbits).digest();
    v = $iyMeE(algo, k).update(v).digest();
    k = $iyMeE(algo, k).update(v).update($9ad790349cfcf60f$require$Buffer.from([
        1
    ])).update(x).update(hbits).digest();
    v = $iyMeE(algo, k).update(v).digest();
    return {
        k: k,
        v: v
    };
}
function $9ad790349cfcf60f$var$bits2int(obits, q) {
    var bits = new $bMLik(obits);
    var shift = (obits.length << 3) - q.bitLength();
    if (shift > 0) bits.ishrn(shift);
    return bits;
}
function $9ad790349cfcf60f$var$bits2octets(bits, q) {
    bits = $9ad790349cfcf60f$var$bits2int(bits, q);
    bits = bits.mod(q);
    var out = $9ad790349cfcf60f$require$Buffer.from(bits.toArray());
    if (out.length < q.byteLength()) {
        var zeros = $9ad790349cfcf60f$require$Buffer.alloc(q.byteLength() - out.length);
        out = $9ad790349cfcf60f$require$Buffer.concat([
            zeros,
            out
        ]);
    }
    return out;
}
function $9ad790349cfcf60f$var$makeKey(q, kv, algo) {
    var t;
    var k;
    do {
        t = $9ad790349cfcf60f$require$Buffer.alloc(0);
        while(t.length * 8 < q.bitLength()){
            kv.v = $iyMeE(algo, kv.k).update(kv.v).digest();
            t = $9ad790349cfcf60f$require$Buffer.concat([
                t,
                kv.v
            ]);
        }
        k = $9ad790349cfcf60f$var$bits2int(t, q);
        kv.k = $iyMeE(algo, kv.k).update(kv.v).update($9ad790349cfcf60f$require$Buffer.from([
            0
        ])).digest();
        kv.v = $iyMeE(algo, kv.k).update(kv.v).digest();
    }while (k.cmp(q) !== -1);
    return k;
}
function $9ad790349cfcf60f$var$makeR(g, k, p, q) {
    return g.toRed($bMLik.mont(p)).redPow(k).fromRed().mod(q);
}
$9ad790349cfcf60f$exports = $9ad790349cfcf60f$var$sign;
$9ad790349cfcf60f$exports.getKey = $9ad790349cfcf60f$var$getKey;
$9ad790349cfcf60f$exports.makeKey = $9ad790349cfcf60f$var$makeKey;


var $a1db3b35b0294473$exports = {};
'use strict';

var $dmAgJ = parcelRequire("dmAgJ");
var $a1db3b35b0294473$require$Buffer = $dmAgJ.Buffer;

var $bMLik = parcelRequire("bMLik");

var $hVpqU = parcelRequire("hVpqU");
var $a1db3b35b0294473$require$EC = $hVpqU.ec;

var $2SvhT = parcelRequire("2SvhT");

function $a1db3b35b0294473$var$verify(sig, hash, key, signType, tag) {
    var pub = $2SvhT(key);
    if (pub.type === 'ec') {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
        return $a1db3b35b0294473$var$ecVerify(sig, hash, pub);
    } else if (pub.type === 'dsa') {
        if (signType !== 'dsa') throw new Error('wrong public key type');
        return $a1db3b35b0294473$var$dsaVerify(sig, hash, pub);
    }
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
    hash = $a1db3b35b0294473$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = pub.modulus.byteLength();
    var pad = [
        1
    ];
    var padNum = 0;
    while(hash.length + pad.length + 2 < len){
        pad.push(0xff);
        padNum += 1;
    }
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    pad = $a1db3b35b0294473$require$Buffer.from(pad);
    var red = $bMLik.mont(pub.modulus);
    sig = new $bMLik(sig).toRed(red);
    sig = sig.redPow(new $bMLik(pub.publicExponent));
    sig = $a1db3b35b0294473$require$Buffer.from(sig.fromRed().toArray());
    var out = padNum < 8 ? 1 : 0;
    len = Math.min(sig.length, pad.length);
    if (sig.length !== pad.length) out = 1;
    i = -1;
    while(++i < len)out |= sig[i] ^ pad[i];
    return out === 0;
}
function $a1db3b35b0294473$var$ecVerify(sig, hash, pub) {
    var curveId = $fbc56e89ccf31b74$exports[pub.data.algorithm.curve.join('.')];
    if (!curveId) throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.'));
    var curve = new $a1db3b35b0294473$require$EC(curveId);
    var pubkey = pub.data.subjectPrivateKey.data;
    return curve.verify(hash, sig, pubkey);
}
function $a1db3b35b0294473$var$dsaVerify(sig, hash, pub) {
    var p = pub.data.p;
    var q = pub.data.q;
    var g = pub.data.g;
    var y = pub.data.pub_key;
    var unpacked = $2SvhT.signature.decode(sig, 'der');
    var s = unpacked.s;
    var r = unpacked.r;
    $a1db3b35b0294473$var$checkValue(s, q);
    $a1db3b35b0294473$var$checkValue(r, q);
    var montp = $bMLik.mont(p);
    var w = s.invm(q);
    var v = g.toRed(montp).redPow(new $bMLik(hash).mul(w).mod(q)).fromRed().mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed()).mod(p).mod(q);
    return v.cmp(r) === 0;
}
function $a1db3b35b0294473$var$checkValue(b, q) {
    if (b.cmpn(0) <= 0) throw new Error('invalid sig');
    if (b.cmp(q) >= 0) throw new Error('invalid sig');
}
$a1db3b35b0294473$exports = $a1db3b35b0294473$var$verify;



var $lisa3 = parcelRequire("lisa3");
Object.keys($lisa3).forEach(function(key) {
    $lisa3[key].id = $b12f50751aee259f$require$Buffer.from($lisa3[key].id, 'hex');
    $lisa3[key.toLowerCase()] = $lisa3[key];
});
function $b12f50751aee259f$var$Sign(algorithm) {
    $f2OM9.Writable.call(this);
    var data = $lisa3[algorithm];
    if (!data) throw new Error('Unknown message digest');
    this._hashType = data.hash;
    this._hash = $4Qxdz(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$jcXeW($b12f50751aee259f$var$Sign, $f2OM9.Writable);
$b12f50751aee259f$var$Sign.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$b12f50751aee259f$var$Sign.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === 'string' ? $b12f50751aee259f$require$Buffer.from(data, enc) : data);
    return this;
};
$b12f50751aee259f$var$Sign.prototype.sign = function signMethod(key, enc) {
    this.end();
    var hash = this._hash.digest();
    var sig = $9ad790349cfcf60f$exports(hash, key, this._hashType, this._signType, this._tag);
    return enc ? sig.toString(enc) : sig;
};
function $b12f50751aee259f$var$Verify(algorithm) {
    $f2OM9.Writable.call(this);
    var data = $lisa3[algorithm];
    if (!data) throw new Error('Unknown message digest');
    this._hash = $4Qxdz(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$jcXeW($b12f50751aee259f$var$Verify, $f2OM9.Writable);
$b12f50751aee259f$var$Verify.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$b12f50751aee259f$var$Verify.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === 'string' ? $b12f50751aee259f$require$Buffer.from(data, enc) : data);
    return this;
};
$b12f50751aee259f$var$Verify.prototype.verify = function verifyMethod(key, sig, enc) {
    var sigBuffer = typeof sig === 'string' ? $b12f50751aee259f$require$Buffer.from(sig, enc) : sig;
    this.end();
    var hash = this._hash.digest();
    return $a1db3b35b0294473$exports(sigBuffer, hash, key, this._signType, this._tag);
};
function $b12f50751aee259f$var$createSign(algorithm) {
    return new $b12f50751aee259f$var$Sign(algorithm);
}
function $b12f50751aee259f$var$createVerify(algorithm) {
    return new $b12f50751aee259f$var$Verify(algorithm);
}
$b12f50751aee259f$exports = {
    Sign: $b12f50751aee259f$var$createSign,
    Verify: $b12f50751aee259f$var$createVerify,
    createSign: $b12f50751aee259f$var$createSign,
    createVerify: $b12f50751aee259f$var$createVerify
};


$4ef10afabec0a287$export$45df7cae684751af = $b12f50751aee259f$exports.createSign;
$4ef10afabec0a287$export$1db683ad541682f6 = $b12f50751aee259f$exports.Sign;
$4ef10afabec0a287$export$6f65485f87568e37 = $b12f50751aee259f$exports.createVerify;
$4ef10afabec0a287$export$91a8e56769aeb334 = $b12f50751aee259f$exports.Verify;

$4ef10afabec0a287$export$2d4117e99c2179e4 = (parcelRequire("771Iu"));
var $8f7888a04d21037e$export$512823e338ddb1b7;
var $8f7888a04d21037e$export$7efb24e2fddf99b9;
var $8f7888a04d21037e$export$9d0e0c0c4a8d30f3;
var $8f7888a04d21037e$export$b9d55ff329113abd;

$8f7888a04d21037e$export$512823e338ddb1b7 = (parcelRequire("2LSkK"));

$8f7888a04d21037e$export$7efb24e2fddf99b9 = (parcelRequire("4Ghbm"));
$8f7888a04d21037e$export$9d0e0c0c4a8d30f3 = function privateEncrypt(key, buf) {
    return $8f7888a04d21037e$export$512823e338ddb1b7(key, buf, true);
};
$8f7888a04d21037e$export$b9d55ff329113abd = function publicDecrypt(key, buf) {
    return $8f7888a04d21037e$export$7efb24e2fddf99b9(key, buf, true);
};


$4ef10afabec0a287$export$512823e338ddb1b7 = $8f7888a04d21037e$export$512823e338ddb1b7;
$4ef10afabec0a287$export$9d0e0c0c4a8d30f3 = $8f7888a04d21037e$export$9d0e0c0c4a8d30f3;
$4ef10afabec0a287$export$b9d55ff329113abd = $8f7888a04d21037e$export$b9d55ff329113abd;
$4ef10afabec0a287$export$7efb24e2fddf99b9 = $8f7888a04d21037e$export$7efb24e2fddf99b9;
var $06ed738dcc2bae3d$export$bb1abf2ce84fc7e8;
var $06ed738dcc2bae3d$export$2f7171e78e524d5e;

var $aVaWD = parcelRequire("aVaWD");
'use strict';
function $06ed738dcc2bae3d$var$oldBrowser() {
    throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11');
}

var $dmAgJ = parcelRequire("dmAgJ");

var $cN8vX = parcelRequire("cN8vX");
var $06ed738dcc2bae3d$var$Buffer = $dmAgJ.Buffer;
var $06ed738dcc2bae3d$var$kBufferMaxLength = $dmAgJ.kMaxLength;
var $06ed738dcc2bae3d$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
var $06ed738dcc2bae3d$var$kMaxUint32 = Math.pow(2, 32) - 1;
function $06ed738dcc2bae3d$var$assertOffset(offset, length) {
    if (typeof offset !== 'number' || offset !== offset) throw new TypeError('offset must be a number');
    if (offset > $06ed738dcc2bae3d$var$kMaxUint32 || offset < 0) throw new TypeError('offset must be a uint32');
    if (offset > $06ed738dcc2bae3d$var$kBufferMaxLength || offset > length) throw new RangeError('offset out of range');
}
function $06ed738dcc2bae3d$var$assertSize(size, offset, length) {
    if (typeof size !== 'number' || size !== size) throw new TypeError('size must be a number');
    if (size > $06ed738dcc2bae3d$var$kMaxUint32 || size < 0) throw new TypeError('size must be a uint32');
    if (size + offset > length || size > $06ed738dcc2bae3d$var$kBufferMaxLength) throw new RangeError('buffer too small');
}
if ($06ed738dcc2bae3d$var$crypto && $06ed738dcc2bae3d$var$crypto.getRandomValues || false) {
    $06ed738dcc2bae3d$export$bb1abf2ce84fc7e8 = $06ed738dcc2bae3d$var$randomFill;
    $06ed738dcc2bae3d$export$2f7171e78e524d5e = $06ed738dcc2bae3d$var$randomFillSync;
} else {
    $06ed738dcc2bae3d$export$bb1abf2ce84fc7e8 = $06ed738dcc2bae3d$var$oldBrowser;
    $06ed738dcc2bae3d$export$2f7171e78e524d5e = $06ed738dcc2bae3d$var$oldBrowser;
}
function $06ed738dcc2bae3d$var$randomFill(buf, offset, size, cb) {
    if (!$06ed738dcc2bae3d$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof offset === 'function') {
        cb = offset;
        offset = 0;
        size = buf.length;
    } else if (typeof size === 'function') {
        cb = size;
        size = buf.length - offset;
    } else if (typeof cb !== 'function') throw new TypeError('"cb" argument must be a function');
    $06ed738dcc2bae3d$var$assertOffset(offset, buf.length);
    $06ed738dcc2bae3d$var$assertSize(size, offset, buf.length);
    return $06ed738dcc2bae3d$var$actualFill(buf, offset, size, cb);
}
function $06ed738dcc2bae3d$var$actualFill(buf, offset, size, cb) {
    var ourBuf = buf.buffer;
    var uint = new Uint8Array(ourBuf, offset, size);
    $06ed738dcc2bae3d$var$crypto.getRandomValues(uint);
    if (cb) {
        $aVaWD.nextTick(function() {
            cb(null, buf);
        });
        return;
    }
    return buf;
    if (cb) {
        $cN8vX(size, function(err, bytes) {
            if (err) return cb(err);
            bytes.copy(buf, offset);
            cb(null, buf);
        });
        return;
    }
    var bytes = $cN8vX(size);
    bytes.copy(buf, offset);
    return buf;
}
function $06ed738dcc2bae3d$var$randomFillSync(buf, offset, size) {
    if (typeof offset === 'undefined') offset = 0;
    if (!$06ed738dcc2bae3d$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    $06ed738dcc2bae3d$var$assertOffset(offset, buf.length);
    if (size === undefined) size = buf.length - offset;
    $06ed738dcc2bae3d$var$assertSize(size, offset, buf.length);
    return $06ed738dcc2bae3d$var$actualFill(buf, offset, size);
}


$4ef10afabec0a287$export$bb1abf2ce84fc7e8 = $06ed738dcc2bae3d$export$bb1abf2ce84fc7e8;
$4ef10afabec0a287$export$2f7171e78e524d5e = $06ed738dcc2bae3d$export$2f7171e78e524d5e;
$4ef10afabec0a287$export$e1d879b482f37d98 = function() {
    throw new Error('sorry, createCredentials is not implemented yet\nwe accept pull requests\nhttps://github.com/browserify/crypto-browserify');
};
$4ef10afabec0a287$export$1a988e7317c65621 = {
    DH_CHECK_P_NOT_SAFE_PRIME: 2,
    DH_CHECK_P_NOT_PRIME: 1,
    DH_UNABLE_TO_CHECK_GENERATOR: 4,
    DH_NOT_SUITABLE_GENERATOR: 8,
    NPN_ENABLED: 1,
    ALPN_ENABLED: 1,
    RSA_PKCS1_PADDING: 1,
    RSA_SSLV23_PADDING: 2,
    RSA_NO_PADDING: 3,
    RSA_PKCS1_OAEP_PADDING: 4,
    RSA_X931_PADDING: 5,
    RSA_PKCS1_PSS_PADDING: 6,
    POINT_CONVERSION_COMPRESSED: 2,
    POINT_CONVERSION_UNCOMPRESSED: 4,
    POINT_CONVERSION_HYBRID: 6
};


function $4304bf458d474c32$var$hash(algorithm, data, asBytes = false) {
    const hash1 = (0, (/*@__PURE__*/$parcel$interopDefault($4ef10afabec0a287$exports))).createHash(algorithm);
    hash1.update(data);
    if (asBytes) return Array.from(hash1.digest());
    return hash1.digest('hex');
}
function $4304bf458d474c32$export$7904c6256691057a(data) {
    return $4304bf458d474c32$var$hash('sha256', data);
}
function $4304bf458d474c32$export$5fdf8c875acfc1b3(data) {
    return $4304bf458d474c32$var$hash('sha256', data, true);
}
function $4304bf458d474c32$export$bf9b056bcf5cf86a(data) {
    return $4304bf458d474c32$var$hash('sha1', data);
}


let $a6bc5eeab5e36340$var$SESSION_SALT;
const $a6bc5eeab5e36340$export$237ebf1f4974c28e = ()=>{
    $a6bc5eeab5e36340$var$SESSION_SALT = (0, (/*@__PURE__*/$parcel$interopDefault($b0809950592c8add$exports)))();
};
const $a6bc5eeab5e36340$var$toStringArray = (arr)=>`[${arr.map((item)=>$a6bc5eeab5e36340$var$toString(item)).join(',')}]`;
const $a6bc5eeab5e36340$var$toString = (o)=>{
    if (o === null) return 'null';
    if (Array.isArray(o)) return $a6bc5eeab5e36340$var$toStringArray(o);
    if (typeof o == 'object') return $a6bc5eeab5e36340$export$66b1d6a1029e925d(o);
    if (typeof o == 'string') return `"${o}"`;
    return `${o.toString()}`;
};
const $a6bc5eeab5e36340$export$66b1d6a1029e925d = (o)=>{
    if (!$a6bc5eeab5e36340$var$SESSION_SALT) $a6bc5eeab5e36340$export$237ebf1f4974c28e();
    const strToHash = `${Object.entries(o).filter(([_, value])=>typeof value !== 'undefined').sort((a, b)=>a[0].localeCompare(b[0])).map(([key, value])=>`${key}:${$a6bc5eeab5e36340$var$toString(value)}`).join()},${$a6bc5eeab5e36340$var$SESSION_SALT}`;
    return (0, $4304bf458d474c32$export$7904c6256691057a)(strToHash);
};


function $7716b8280f14075e$export$69b4b1e5f81fb1ea(queryParams, paramName) {
    const value = queryParams?.[paramName];
    return Array.isArray(value) ? value[0] : value;
}
function $7716b8280f14075e$export$a44568e95e5c4a5c(queryParams, paramName, defaultValue) {
    const value = $7716b8280f14075e$export$69b4b1e5f81fb1ea(queryParams, paramName);
    const intValue = parseInt(value ?? '', 10);
    return isNaN(intValue) ? defaultValue : intValue;
}







var $414efa7e97a6adf9$export$5e180a90f8d3e374 = /*#__PURE__*/ function(ExperienceTimeout) {
    ExperienceTimeout[ExperienceTimeout["DEFAULT"] = 60000] = "DEFAULT";
    ExperienceTimeout[ExperienceTimeout["CREATE_CONTENT"] = 30000] = "CREATE_CONTENT";
    ExperienceTimeout[ExperienceTimeout["CREATE_DIALOG_LOAD"] = 60000] = "CREATE_DIALOG_LOAD";
    ExperienceTimeout[ExperienceTimeout["MACRO_LOAD"] = 60000] = "MACRO_LOAD";
    ExperienceTimeout[ExperienceTimeout["CREATE_COMMENT_PUBLISH"] = 15000] = "CREATE_COMMENT_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["EDITOR_LOAD"] = 25000] = "EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["EDITOR_PUBLISH"] = 60000] = "EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["LIVE_PAGE_PUBLISH"] = 30000] = "LIVE_PAGE_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_LOAD"] = 90000] = "TEMPLATE_EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_PUBLISH"] = 60000] = "TEMPLATE_EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATE_PANEL_LOAD"] = 20000] = "IN_EDITOR_TEMPLATE_PANEL_LOAD";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR"] = 90000] = "IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR";
    ExperienceTimeout[ExperienceTimeout["HOME"] = 20000] = "HOME";
    ExperienceTimeout[ExperienceTimeout["NAVIGATION_LOAD"] = 30000] = "NAVIGATION_LOAD";
    ExperienceTimeout[ExperienceTimeout["PAGE_LOAD"] = 60000] = "PAGE_LOAD";
    ExperienceTimeout[ExperienceTimeout["SELECT_INLINE_COMMMENT"] = 30000] = "SELECT_INLINE_COMMMENT";
    ExperienceTimeout[ExperienceTimeout["VIEW_INLINE_COMMENT"] = 30000] = "VIEW_INLINE_COMMENT";
    ExperienceTimeout[ExperienceTimeout["SPACE_DIRECTORY"] = 60000] = "SPACE_DIRECTORY";
    ExperienceTimeout[ExperienceTimeout["SPACE_VIEWS"] = 20000] = "SPACE_VIEWS";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE"] = 20000] = "TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_PREVIEW"] = 20000] = "TEMPLATE_PREVIEW";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_SUGGESTIONS"] = 20000] = "TEMPLATE_SUGGESTIONS";
    ExperienceTimeout[ExperienceTimeout["LOOM_PAGE_HEADER_CONTENT_INSERTION"] = 20000] = "LOOM_PAGE_HEADER_CONTENT_INSERTION";
    return ExperienceTimeout;
}({});




const $e8536e8f091b0e90$export$feb7963ae429f97f = (experienceNames)=>{
    const experienceNameSet = new Set(experienceNames);
    return (events, experience)=>{
        // Fail as soon as any sub-experience is failed or aborted
        experience.stopOn(events.find((event)=>experienceNameSet.has(event.name) && (event.action === 'taskFail' || event.action === 'taskAbort')), {
            incompleteSubExperiences: [
                ...experienceNameSet
            ].join(', ')
        });
        // If there's a success remove the experience from the set
        // of experiences we're waiting for.
        events.forEach((event)=>{
            if ((0, $b4f5dc9bddcbc766$export$16e3f1b03b231b35)(event)) experienceNameSet.delete(event.name);
        });
        // Experience is considered complete if all sub-experiences
        // are complete.
        if (experienceNameSet.size === 0) experience.succeed();
    };
};
const $e8536e8f091b0e90$export$79dbdd3e43727beb = (experienceNames)=>(events, experience)=>experience.stopOn(events.find((event)=>(0, $b4f5dc9bddcbc766$export$16e3f1b03b231b35)(event) && (0, $b4f5dc9bddcbc766$export$57069f5b2ecc9128)(event, ...experienceNames)));









const $403f7817f2b75a1a$var$homeSubExperiences = [
    (0, $d4b865e8cc459c1f$export$d660d67b42309542),
    (0, $d4b865e8cc459c1f$export$94f2ecf008a81b99),
    (0, $d4b865e8cc459c1f$export$45d7f7ed7a82bcd),
    (0, $d4b865e8cc459c1f$export$ecf5fd41d4da9bf8),
    (0, $d4b865e8cc459c1f$export$9b242f2ddcd908fc)
];
function $403f7817f2b75a1a$var$collectHomeNav3(events, experience) {
    const homeExperiences = new Set($403f7817f2b75a1a$var$homeSubExperiences);
    // stop as soon as any sub-experience is failed or aborted
    experience.stopOn(events.find((event)=>(event.action === 'taskFail' || event.action === 'taskAbort') && (homeExperiences.has(event.name) || event.name === (0, $d4b865e8cc459c1f$export$8856e11bfa69959d))));
    // if any of the view experiences succeed AND the spaces experience succeeds, the root home experience should succeed
    let viewExperienceDidSucceed = false;
    let spacesExperienceDidSucceed = false;
    events.forEach((event)=>{
        if ((0, $b4f5dc9bddcbc766$export$16e3f1b03b231b35)(event)) {
            if (homeExperiences.has(event.name)) viewExperienceDidSucceed = true;
            if (event.name === (0, $d4b865e8cc459c1f$export$8856e11bfa69959d) && event.action === 'taskSuccess') spacesExperienceDidSucceed = true;
        }
    });
    if (viewExperienceDidSucceed && spacesExperienceDidSucceed) experience.succeed();
}
function $403f7817f2b75a1a$export$4278268ff5675d74() {
    const isNav4Enabled = (0, $f35f58e56b56de67$export$2af1f7a69c1ab0ad)();
    (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$66f0a82e06e92ea),
        collect: isNav4Enabled ? (0, $e8536e8f091b0e90$export$79dbdd3e43727beb)($403f7817f2b75a1a$var$homeSubExperiences) : $403f7817f2b75a1a$var$collectHomeNav3
    });
}


const $26ff900bc5da1ddf$var$noPermissionOrNotFoundExperiences = [
    (0, $d4b865e8cc459c1f$export$fbbc408e16c59382),
    (0, $d4b865e8cc459c1f$export$dbbd27df623b094f),
    (0, $d4b865e8cc459c1f$export$727b779ceeca0a78),
    (0, $d4b865e8cc459c1f$export$8f404e4bd2a13aa)
];
const $26ff900bc5da1ddf$var$stopOnNoPermissionOrNotFound = (0, $e8536e8f091b0e90$export$79dbdd3e43727beb)($26ff900bc5da1ddf$var$noPermissionOrNotFoundExperiences);
const $26ff900bc5da1ddf$var$stopOnConnectAddon = (0, $e8536e8f091b0e90$export$79dbdd3e43727beb)([
    (0, $d4b865e8cc459c1f$export$fc0c176abc30d17b)
]);
/**
 * Stores the new experiences started due to SPA transition
 */ const $26ff900bc5da1ddf$var$namesStartedInPreviousRoute = [];
/**
 *  Specifies routes that signify completion for each experience.
 *  Used with experienceTracker's collect function to monitor progress of experiences.
 *  For example, 'create page' experience is considered complete when it leads to 'edit page'.
 */ const $26ff900bc5da1ddf$var$redirectRoutesForExperiences = {
    [(0, $d4b865e8cc459c1f$export$227ea80a7d6d8ef2)]: [
        (0, $0d518026f9d519cf$export$7b1285e36c635f1f).name,
        (0, $0d518026f9d519cf$export$36dcea4e08feb5c9).name,
        (0, $0d518026f9d519cf$export$b74c113024023274).name,
        (0, $0d518026f9d519cf$export$45222bf0cb32d6e2).name,
        (0, $0d518026f9d519cf$export$9257b5b55c8e2555).name // CREATE_PAGE_EXPERIENCE -> VIEW_PAGE means a live page was created
    ],
    [(0, $d4b865e8cc459c1f$export$f27db95814bbdf0)]: [
        (0, $0d518026f9d519cf$export$5b90ced7e51bcea0).name
    ],
    [(0, $d4b865e8cc459c1f$export$13566a78bbba7568)]: [
        (0, $0d518026f9d519cf$export$851ba2be5095d586).name
    ],
    [(0, $d4b865e8cc459c1f$export$c6222c9fbf47e43b)]: [
        (0, $0d518026f9d519cf$export$84b5e15197aaaa12).name
    ]
};
const $26ff900bc5da1ddf$var$EXPERIENCES_TO_ABORT_ON_ROUTE_CHANGE = [
    (0, $d4b865e8cc459c1f$export$20fbac00cba3c8a)
];
const $26ff900bc5da1ddf$export$4b786e0ae0cc0857 = {
    [(0, $0d518026f9d519cf$export$65b723bb995d4fb6).name]: 'space',
    [(0, $0d518026f9d519cf$export$ada7925da580b561).name]: 'space',
    [(0, $0d518026f9d519cf$export$e63a462ee45b57cf).name]: 'page',
    [(0, $0d518026f9d519cf$export$7b1285e36c635f1f).name]: 'page',
    [(0, $0d518026f9d519cf$export$36dcea4e08feb5c9).name]: 'blog',
    [(0, $0d518026f9d519cf$export$9257b5b55c8e2555).name]: 'page',
    [(0, $0d518026f9d519cf$export$91f49e7b30a9d34).name]: 'blog',
    [(0, $0d518026f9d519cf$export$bd2c9bb170b3681d).name]: 'blog'
};
const $26ff900bc5da1ddf$export$5396770e9da36673 = (routeName)=>{
    switch(routeName){
        case (0, $0d518026f9d519cf$export$45222bf0cb32d6e2).name:
        case (0, $0d518026f9d519cf$export$b74c113024023274).name:
        case (0, $0d518026f9d519cf$export$d6ae9e544e98926f).name:
            return 'TINY';
        default:
            return 'FABRIC';
    }
};
function $26ff900bc5da1ddf$export$cac1117e2433d80e(match, transitionId, sessionData) {
    if (!match) return;
    const tracker = (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)();
    // Moves current route data to previous route data to ensure `getExperienceTracker.ts getPreviousRouteExperienceData()` works correctly
    (0, $fb98a59fbc7d7496$export$e8918c537d57dc96)(match.name);
    // Live page's edit-page and session experience starts after the route has finished loading and unsubscribed from the tracker, so it's not in the `startExperienceForRoute` function's namesStartedInPreviousRoute array. We will handle finishing it separately in `finishLivePageExperiences`.
    // It's important that `finishLivePageExperiences` is invoked before we attempt to succeed EDIT_PAGE_EXPERIENCE below, as `finishLivePageExperiences` is responsible for succeeding EDIT_PAGE_EXPERIENCE on live pages while setting the experience attribute `isLivePage
    $26ff900bc5da1ddf$var$finishLivePageExperiences();
    $26ff900bc5da1ddf$var$namesStartedInPreviousRoute.forEach((name)=>{
        const allowedRoutes = $26ff900bc5da1ddf$var$redirectRoutesForExperiences[name];
        // For create content routes, we do not want to abort if it is routing to correct page.
        // But, if it is a create experience and routing to a page is is not supposed to be going to,
        // we can assume something is wrong and we abort it.
        if (allowedRoutes && allowedRoutes.includes(match.name)) return;
        if (// If we were on edit-page or view-page/session experience and leave to another route, we should succeed that experience, not abort it.
        name === (0, $d4b865e8cc459c1f$export$dd70d6707192298e) && (0, $db2847de8e87cb6c$export$2b69dcd5daaf6a2c)() || name === (0, $d4b865e8cc459c1f$export$c6d05c48b9430e3c) && (0, $db2847de8e87cb6c$export$c15dc70f74e1c751)() || name === (0, $d4b865e8cc459c1f$export$5e30e9d7ea54dcd2) && (0, $59f627305e19cfab$export$77dd5573732a240c)()) {
            tracker.succeed({
                name: name
            });
            return;
        }
        // For all other situations, we still abort.
        tracker.abort({
            name: name,
            reason: 'Aborted due to SPA started a new experience'
        });
    });
    $26ff900bc5da1ddf$var$namesStartedInPreviousRoute.length = 0;
    const unsubscribe = tracker.subscribe((e)=>{
        if (e.action === 'taskStart') $26ff900bc5da1ddf$var$namesStartedInPreviousRoute.push(e.name);
    });
    if ((0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_frontend_abort_exp_on_route_change')) $26ff900bc5da1ddf$var$EXPERIENCES_TO_ABORT_ON_ROUTE_CHANGE.forEach((name)=>{
        $26ff900bc5da1ddf$var$namesStartedInPreviousRoute.push(name);
    });
    switch(match.name){
        case (0, $0d518026f9d519cf$export$e003e97fab6b4368).name:
            $26ff900bc5da1ddf$var$startCompanyHubEditor(transitionId, sessionData);
            break;
        case (0, $0d518026f9d519cf$export$e63a462ee45b57cf).name:
        case (0, $0d518026f9d519cf$export$7b1285e36c635f1f).name:
        case (0, $0d518026f9d519cf$export$36dcea4e08feb5c9).name:
        case (0, $0d518026f9d519cf$export$b74c113024023274).name:
        case (0, $0d518026f9d519cf$export$45222bf0cb32d6e2).name:
        case (0, $0d518026f9d519cf$export$d6ae9e544e98926f).name:
        case (0, $0d518026f9d519cf$export$4dd08bdd46db5924).name:
            $26ff900bc5da1ddf$var$startEditPage(match, transitionId, sessionData);
            break;
        case (0, $0d518026f9d519cf$export$9257b5b55c8e2555).name:
        case (0, $0d518026f9d519cf$export$91f49e7b30a9d34).name:
        case (0, $0d518026f9d519cf$export$bd2c9bb170b3681d).name:
            $26ff900bc5da1ddf$var$startViewContent(match.params.contentId, transitionId, $26ff900bc5da1ddf$export$4b786e0ae0cc0857[match.name], match.query, sessionData);
            break;
        case (0, $0d518026f9d519cf$export$bd17e6e353522e0d).name:
            $26ff900bc5da1ddf$var$startEditPageSmartCreate(match);
            break;
        case (0, $0d518026f9d519cf$export$5bfa1fef1b53dfdd).name:
            $26ff900bc5da1ddf$var$startViewPublicLinkGlobalSettings(match.query.tab, match.query.space, transitionId);
            break;
        case (0, $0d518026f9d519cf$export$d593e642a326a501).name:
            $26ff900bc5da1ddf$var$startViewPublicLinkSharedPage(match.params.id, transitionId);
            break;
        case (0, $0d518026f9d519cf$export$65b723bb995d4fb6).name:
            $26ff900bc5da1ddf$var$startViewContent(match.params.spaceKey, transitionId, $26ff900bc5da1ddf$export$4b786e0ae0cc0857[match.name], match.query, sessionData, {
                spaceKey: match.params.spaceKey,
                isLandingPage: match.search === '?mode=global'
            });
            break;
        case (0, $0d518026f9d519cf$export$ada7925da580b561).name:
            const spaceKey = (0, $a4b9a8903fd62c69$export$6193f65d76fa4c00)(sessionData) || '';
            $26ff900bc5da1ddf$var$startViewContent(spaceKey, transitionId, $26ff900bc5da1ddf$export$4b786e0ae0cc0857[match.name], match.query, sessionData, {
                spaceKey: spaceKey
            });
            break;
        case (0, $0d518026f9d519cf$export$a7c5707626fc90f).name:
            (0, $403f7817f2b75a1a$export$4278268ff5675d74)();
            break;
        case (0, $0d518026f9d519cf$export$c0a209b0b0b16c75).name:
        case (0, $0d518026f9d519cf$export$e84c491e2d88d9f6).name:
            $26ff900bc5da1ddf$var$startTemplateEditPage(match.params.contentId, transitionId);
            break;
        case (0, $0d518026f9d519cf$export$dcda7f8b6fe54ba).name:
        case (0, $0d518026f9d519cf$export$dcee5dee04648c93).name:
            $26ff900bc5da1ddf$var$startTemplateEditPage(/* id */ undefined, transitionId);
            break;
        case (0, $0d518026f9d519cf$export$3bd4ec9f05d79904).name:
            $26ff900bc5da1ddf$var$startAdvancedSearch(match);
            break;
        case (0, $0d518026f9d519cf$export$60773cf116cf5f30).name:
            $26ff900bc5da1ddf$var$startArchivedPagesList();
            break;
        case (0, $0d518026f9d519cf$export$f39a30a3a5635bab).name:
            $26ff900bc5da1ddf$var$startContentManager();
            break;
        case (0, $0d518026f9d519cf$export$439074745692fe65).name:
            $26ff900bc5da1ddf$var$startSpaceDirectory();
            break;
        case (0, $0d518026f9d519cf$export$6ccd7dc0d5aa30b0).name:
            $26ff900bc5da1ddf$var$startTemplateGallery();
            break;
        case (0, $0d518026f9d519cf$export$4eb80c3a4e6fbe0f).name:
            $26ff900bc5da1ddf$var$startSpacePages();
            break;
        case (0, $0d518026f9d519cf$export$5b90ced7e51bcea0).name:
            $26ff900bc5da1ddf$var$startWhiteboardBoard(match);
            break;
        case (0, $0d518026f9d519cf$export$851ba2be5095d586).name:
            $26ff900bc5da1ddf$var$startDatabaseView(match.params.contentId);
            break;
        case (0, $0d518026f9d519cf$export$84b5e15197aaaa12).name:
            $26ff900bc5da1ddf$var$startEmbedPageView(match.params.contentId);
            break;
        case (0, $0d518026f9d519cf$export$4dcf771d1a1901ef).name:
            $26ff900bc5da1ddf$var$startFolderView(match.params.contentId);
            break;
        case (0, $0d518026f9d519cf$export$e64d4514fc584fbe).name:
            //Adding the other space perms uplift tabs at a later date.
            if (match.params.tab === 'public-links') $26ff900bc5da1ddf$var$startViewPublicLinksSpaceSettings();
            break;
        case (0, $0d518026f9d519cf$export$3ce513606c31c918).name:
            $26ff900bc5da1ddf$var$startViewAdminAnnouncementBannerSettings();
            break;
        case (0, $0d518026f9d519cf$export$4d1bccc78b263a8e).name:
            $26ff900bc5da1ddf$var$startSpaceManager();
            break;
        case (0, $0d518026f9d519cf$export$8c6393d6207d929).name:
        case (0, $0d518026f9d519cf$export$9397e0d80cf06055).name:
            $26ff900bc5da1ddf$var$startCompanyHomeBuilderLoad();
            break;
    }
    const startCreateOperations = ()=>{
        const subType = typeof match?.query?.subType === 'string' ? match.query.subType : null;
        if (match.name === (0, $0d518026f9d519cf$export$54edf7c16c47aeef).name) $26ff900bc5da1ddf$var$startCreateContent(match, sessionData, subType);
        else if (match.query.createDialog) {
            $26ff900bc5da1ddf$var$startCreatePage(String(transitionId), transitionId, subType);
            (0, $db2847de8e87cb6c$export$b4cbec267823a12e)();
        }
    };
    startCreateOperations();
    unsubscribe();
}
function $26ff900bc5da1ddf$var$startCreatePage(id, transitionId, subType) {
    const experienceTracker = (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)();
    experienceTracker.start({
        name: (0, $d4b865e8cc459c1f$export$227ea80a7d6d8ef2),
        id: id,
        attributes: {
            isLivePage: subType?.toLowerCase() === 'live'
        },
        startTime: transitionId === 0 ? 0 : undefined,
        collect (events, experience) {
            experience.stopOn(events.find((event)=>event.action === 'taskFail' && (0, $b4f5dc9bddcbc766$export$57069f5b2ecc9128)(event, (0, $d4b865e8cc459c1f$export$1773354263fb7a1f), (0, $d4b865e8cc459c1f$export$5f80ef7b2915bb38))));
            experience.stopOn(events.find((event)=>event.action === 'taskSuccess' && (0, $b4f5dc9bddcbc766$export$57069f5b2ecc9128)(event, (0, $d4b865e8cc459c1f$export$5f80ef7b2915bb38))));
            experience.stopOn(events.find((event)=>event.action === 'taskAbort' && (0, $b4f5dc9bddcbc766$export$57069f5b2ecc9128)(event, (0, $d4b865e8cc459c1f$export$5f80ef7b2915bb38))));
        }
    });
    experienceTracker.start({
        name: (0, $d4b865e8cc459c1f$export$1773354263fb7a1f),
        id: id,
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).CREATE_DIALOG_LOAD
    });
}
function $26ff900bc5da1ddf$export$b9a409823a06b924(experienceName) {
    const activeTrace = (0, $9931f21957f7e3c2$export$b6ac780db3a3cc77)();
    if (!activeTrace) (0, $7c098619eb9ad053$export$2e2bcd8739ae039)(experienceName.replace(/\//g, '-'));
}
function $26ff900bc5da1ddf$export$478e84e2cc5ff22d(compoundExperience, editorLoadExperience, editorPublishExperience) {
    const experienceTracker = (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)();
    const compoundTaskId = (0, (/*@__PURE__*/$parcel$interopDefault($c29b43bb0df96673$exports)))();
    const compoundExperienceAttributes = {
        ...compoundExperience.attributes,
        compoundTaskId: compoundTaskId
    };
    experienceTracker.start({
        ...compoundExperience,
        id: compoundTaskId,
        attributes: compoundExperienceAttributes,
        collect: (events, experience)=>{
            experience.stopOn(events.find(({ action: action, name: name })=>action === 'taskFail' && name === editorLoadExperience.name));
            experience.stopOn(events.find(({ action: action, name: name })=>(action === 'taskSuccess' || action === 'taskFail') && name === editorPublishExperience.name));
            if (compoundExperience.collect) compoundExperience.collect(events, experience);
        }
    });
    experienceTracker.start({
        ...editorLoadExperience,
        id: editorLoadExperience.id || compoundExperience.id,
        timeout: editorLoadExperience.timeout || (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).EDITOR_LOAD,
        attributes: compoundExperienceAttributes,
        collect: editorLoadExperience.collect
    });
}
function $26ff900bc5da1ddf$export$7df6656d8508e8da(subExperience) {
    const experienceTracker = (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)();
    // Initialize attributes from the original subExperience
    const attributes = {
        ...subExperience.attributes
    };
    // Extract the compound experience name from the sub-experience name if it follows
    // the naming convention "<compound_experience_name>/<sub_experience>"
    const subExperienceName = subExperience.name;
    const nameParts = subExperienceName.split('/');
    // Only attempt to get compound experience if the name includes a separator
    if (nameParts.length > 1) {
        const compoundExperienceName = nameParts[0];
        const compoundExperienceState = experienceTracker.getExperienceState(compoundExperienceName);
        // If compound experience exists, inherit its compoundTaskId
        if (compoundExperienceState) // Link the compound experience's compoundTaskId if available
        {
            if (compoundExperienceState.attributes?.compoundTaskId) attributes.compoundTaskId = compoundExperienceState.attributes.compoundTaskId;
        }
    }
    // Start the sub-experience with the attributes (original or enhanced with compoundTaskId)
    experienceTracker.start({
        ...subExperience,
        attributes: attributes
    });
}
const $26ff900bc5da1ddf$var$stopOnCloseForEditPage = (events, experience, loadExperienceName, closeExperienceName)=>{
    const loadStopExperience = events.find((event)=>event.name === loadExperienceName && (0, $b4f5dc9bddcbc766$export$16e3f1b03b231b35)(event));
    const closeStopExperience = events.find((event)=>event.name === closeExperienceName && (0, $b4f5dc9bddcbc766$export$16e3f1b03b231b35)(event));
    if (!closeStopExperience) return;
    // prettier-ignore
    if ((!loadStopExperience || loadStopExperience.action !== "taskSuccess") && closeStopExperience.action === "taskSuccess") // loading incomplete or failed, therefore editing session was broken and close doesn't indicate a success
    experience.abort({
        reason: "Editor closed before load completed",
        attributes: {
            loadExperienceState: loadStopExperience?.action ?? "incomplete"
        }
    });
    else experience.stopOn(closeStopExperience);
};
function $26ff900bc5da1ddf$var$startEditPageSmartCreate(match) {
    (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$9c40f417713b17ea),
        id: match.params.contentId,
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).DEFAULT,
        collect: (events, experience)=>{
            const hasNoPermissionOrNotFoundEvent = events.find((event)=>(0, $b4f5dc9bddcbc766$export$16e3f1b03b231b35)(event) && (0, $b4f5dc9bddcbc766$export$57069f5b2ecc9128)(event, ...$26ff900bc5da1ddf$var$noPermissionOrNotFoundExperiences));
            if (hasNoPermissionOrNotFoundEvent) experience.fail({
                error: new Error(`${hasNoPermissionOrNotFoundEvent.name} experience resulted in ${hasNoPermissionOrNotFoundEvent.action} - unexpected for the smart create editor`)
            });
        }
    });
}
function $26ff900bc5da1ddf$var$startEditPage(match, transitionId, sessionData) {
    const isLegacyEditor = $26ff900bc5da1ddf$export$5396770e9da36673(match?.name ?? '') === 'TINY';
    let editPageExperienceName = (0, $d4b865e8cc459c1f$export$dd70d6707192298e);
    if (match.name === (0, $0d518026f9d519cf$export$e63a462ee45b57cf).name) editPageExperienceName = (0, $d4b865e8cc459c1f$export$b6f302e969b56ed5);
    else if (isLegacyEditor) editPageExperienceName = (0, $d4b865e8cc459c1f$export$cd96dc6a09f60949);
    $26ff900bc5da1ddf$export$478e84e2cc5ff22d(/* compoundExperience */ {
        name: editPageExperienceName,
        id: match.params.contentId,
        startTime: transitionId === 0 ? 0 : undefined,
        attributes: {
            editor: $26ff900bc5da1ddf$export$5396770e9da36673(match.name),
            contentType: $26ff900bc5da1ddf$export$4b786e0ae0cc0857[match.name],
            edition: sessionData?.edition,
            shard: sessionData?.shard,
            isCompanyHub: match?.name === (0, $0d518026f9d519cf$export$e003e97fab6b4368).name || match?.name === (0, $0d518026f9d519cf$export$4dd08bdd46db5924).name,
            contentId: match.params.contentId
        },
        // override with full-page-editor specific stop/collect behaviour
        collect: (events, experience)=>{
            $26ff900bc5da1ddf$var$stopOnNoPermissionOrNotFound(events, experience);
            const loadExperienceName = isLegacyEditor ? (0, $d4b865e8cc459c1f$export$9cfef550e5af515d) : (0, $d4b865e8cc459c1f$export$54650b8dd9597591);
            const closeExperienceName = isLegacyEditor ? (0, $d4b865e8cc459c1f$export$1339ae8dc80b092c) : (0, $d4b865e8cc459c1f$export$92edebd76eb1ad1);
            $26ff900bc5da1ddf$var$stopOnCloseForEditPage(events, experience, loadExperienceName, closeExperienceName);
        }
    }, /* editorLoadExperience */ {
        name: isLegacyEditor ? (0, $d4b865e8cc459c1f$export$9cfef550e5af515d) : (0, $d4b865e8cc459c1f$export$54650b8dd9597591),
        collect: (events, experience)=>{
            $26ff900bc5da1ddf$var$stopOnNoPermissionOrNotFound(events, experience);
            const closeExperienceName = isLegacyEditor ? (0, $d4b865e8cc459c1f$export$1339ae8dc80b092c) : (0, $d4b865e8cc459c1f$export$92edebd76eb1ad1);
            const closeExperience = events.find((event)=>(0, $b4f5dc9bddcbc766$export$16e3f1b03b231b35)(event) && event.name === closeExperienceName);
            if (closeExperience) experience.abort({
                reason: 'Editor closed before load completed',
                attributes: {
                    closeExperienceState: closeExperience?.action ?? 'incomplete'
                }
            });
        }
    }, /* editorPublishExperience */ {
        name: isLegacyEditor ? (0, $d4b865e8cc459c1f$export$770ea955fed26e20) : (0, $d4b865e8cc459c1f$export$4aed0cf42acf9c68)
    });
}
function $26ff900bc5da1ddf$var$startCompanyHubEditor(transitionId, sessionData) {
    $26ff900bc5da1ddf$export$478e84e2cc5ff22d(/* compoundExperience */ {
        name: (0, $d4b865e8cc459c1f$export$c6d05c48b9430e3c),
        startTime: transitionId === 0 ? 0 : undefined,
        attributes: {
            editor: 'FABRIC',
            contentType: 'space',
            edition: sessionData?.edition,
            shard: sessionData?.shard,
            isCompanyHub: true
        },
        collect: (events, experience)=>{
            $26ff900bc5da1ddf$var$stopOnNoPermissionOrNotFound(events, experience);
            $26ff900bc5da1ddf$var$stopOnCloseForEditPage(events, experience, (0, $d4b865e8cc459c1f$export$35975591aeab4dd6), (0, $d4b865e8cc459c1f$export$7a3dfdccebea9c7b));
        }
    }, /* editorLoadExperience */ {
        name: (0, $d4b865e8cc459c1f$export$35975591aeab4dd6),
        collect: (events, experience)=>{
            $26ff900bc5da1ddf$var$stopOnNoPermissionOrNotFound(events, experience);
        }
    }, /* editorPublishExperience */ {
        name: (0, $d4b865e8cc459c1f$export$eef6122c9774ba1c)
    });
}
function $26ff900bc5da1ddf$var$startViewContent(id, transitionId, contentType, query, sessionData, attributes) {
    // WS-3261 - We need to track if the view is coming from an external source (email notification, Slack, etc.)
    const isFromExternal = Boolean(query && query.atlOrigin);
    // Track APDEX part of the content (title and content itself)
    (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$cf73dfff88c1f700),
        id: id,
        startTime: transitionId === 0 ? 0 : undefined,
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).PAGE_LOAD,
        attributes: {
            contentType: contentType,
            isFromExternal: isFromExternal,
            edition: sessionData?.edition,
            shard: sessionData?.shard,
            ...attributes
        },
        collect: (events, experience)=>{
            $26ff900bc5da1ddf$var$stopOnNoPermissionOrNotFound(events, experience);
            $26ff900bc5da1ddf$var$stopOnConnectAddon(events, experience);
        }
    });
}
function $26ff900bc5da1ddf$var$startViewPublicLinkGlobalSettings(tab, space, transitionId) {
    if (tab === 'public-links' && !space) (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$b1f7a84b45eb9afb),
        id: 'public-links',
        startTime: transitionId === 0 ? 0 : undefined,
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).PAGE_LOAD
    });
}
function $26ff900bc5da1ddf$var$startViewPublicLinksSpaceSettings() {
    (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$ff2fb656c8231637),
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).PAGE_LOAD
    });
}
function $26ff900bc5da1ddf$var$startViewPublicLinkSharedPage(id, transitionId) {
    (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$c7ff49e7eaa45ff1),
        id: id,
        startTime: transitionId === 0 ? 0 : undefined,
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).PAGE_LOAD
    });
}
function $26ff900bc5da1ddf$var$startTemplateEditPage(id, transitionId) {
    $26ff900bc5da1ddf$export$478e84e2cc5ff22d(/* compoundExperience */ {
        name: (0, $d4b865e8cc459c1f$export$b9892a850189b3e9),
        id: id,
        startTime: transitionId === 0 ? 0 : undefined,
        collect: (events, experience)=>{
            experience.stopOn(events.find((event)=>(0, $b4f5dc9bddcbc766$export$16e3f1b03b231b35)(event) && event.name === (0, $d4b865e8cc459c1f$export$1a3cf6b911b3771)));
        }
    }, /* editorLoadExperience */ {
        name: (0, $d4b865e8cc459c1f$export$3604f7decc6e0567),
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).TEMPLATE_EDITOR_LOAD
    }, /* editorPublishExperience */ {
        name: (0, $d4b865e8cc459c1f$export$a7f90c693668eabe)
    });
}
function $26ff900bc5da1ddf$var$startAdvancedSearch(match) {
    (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$5393f7f46c9e5055),
        id: (0, $a6bc5eeab5e36340$export$66b1d6a1029e925d)((0, (/*@__PURE__*/$parcel$interopDefault($0ab7059d2555b0c2$exports)))(match.query, [
            'search_id'
        ]))
    });
}
function $26ff900bc5da1ddf$var$startArchivedPagesList() {
    (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$d74c17e82f5dbc27)
    });
}
function $26ff900bc5da1ddf$var$startContentManager() {
    (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$d4b4a08489e4dfe2)
    });
}
function $26ff900bc5da1ddf$var$startSpaceDirectory() {
    (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$6cebb7e0b005cd28),
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).SPACE_DIRECTORY
    });
}
function $26ff900bc5da1ddf$var$startTemplateGallery() {
    const TemplateGallerySubExperiences = [
        (0, $d4b865e8cc459c1f$export$61439b391c5a3aca),
        (0, $d4b865e8cc459c1f$export$82c983e2a60f2e28),
        (0, $d4b865e8cc459c1f$export$81cd8bf6923e1bf1),
        (0, $d4b865e8cc459c1f$export$b6af3a64b182b9d0)
    ];
    const collectTemplateGalleryLoadExperiences = (events, experience)=>{
        (0, $e8536e8f091b0e90$export$feb7963ae429f97f)(TemplateGallerySubExperiences)(events, experience);
    };
    const stopOnRestrictedPage = (0, $e8536e8f091b0e90$export$feb7963ae429f97f)([
        (0, $d4b865e8cc459c1f$export$dbbd27df623b094f)
    ]);
    (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$54615853abc6859),
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).DEFAULT,
        collect: (events, experience)=>{
            collectTemplateGalleryLoadExperiences(events, experience);
            stopOnRestrictedPage(events, experience);
        }
    });
}
function $26ff900bc5da1ddf$var$startSpacePages() {
    (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$1fdf87b44bf66203)
    });
}
function $26ff900bc5da1ddf$var$startCreateContent(match, sessionData, subType) {
    const queryParams = match.query;
    const isPersonalSpace = queryParams.spaceKey?.[0] !== undefined ? (queryParams.spaceKey[0] === '~').toString() : 'unknown';
    const flow = (0, $7716b8280f14075e$export$69b4b1e5f81fb1ea)(queryParams, 'source') || 'createContentRoute';
    if (match.params.contentType === 'whiteboard') (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$f27db95814bbdf0),
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).CREATE_CONTENT,
        attributes: {
            flow: flow,
            isPersonalSpace: isPersonalSpace
        },
        collect: (events, experience)=>{
            const whiteboardExperienceStart = events.find((event)=>event.action === 'taskStart' && event.name === (0, $d4b865e8cc459c1f$export$a83700d85c7e0745));
            if (whiteboardExperienceStart) experience.succeed();
        }
    });
    else if (match.params.contentType === 'database') (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$13566a78bbba7568),
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).CREATE_CONTENT,
        attributes: {
            flow: flow,
            isPersonalSpace: isPersonalSpace
        },
        collect: (events, experience)=>{
            const databaseExperienceStart = events.find((event)=>event.action === 'taskStart' && event.name === (0, $d4b865e8cc459c1f$export$f02aef641190ead6));
            if (databaseExperienceStart) experience.succeed();
        }
    });
    else if (match.params.contentType === 'smartLinkEmbed') (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$c6222c9fbf47e43b),
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).CREATE_CONTENT,
        attributes: {
            flow: flow,
            isPersonalSpace: isPersonalSpace
        },
        collect: (events, experience)=>{
            const smartLinkEmbedExperienceStart = events.find((event)=>event.action === 'taskStart' && event.name === (0, $d4b865e8cc459c1f$export$c85a8dac7f241add));
            if (smartLinkEmbedExperienceStart) experience.succeed();
        }
    });
    else if ([
        'page',
        'blog'
    ].includes(match.params.contentType)) (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$227ea80a7d6d8ef2),
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).CREATE_CONTENT,
        attributes: {
            contentType: match.params.contentType,
            flow: flow,
            isCreateContentRoute: true,
            isPersonalSpace: isPersonalSpace,
            edition: sessionData?.edition,
            shard: sessionData?.shard,
            isLivePage: subType?.toLowerCase() === 'live'
        },
        collect: (events, experience)=>{
            const editPageStarted = events.find((event)=>event.action === 'taskStart' && (event.name === (0, $d4b865e8cc459c1f$export$dd70d6707192298e) || event.name === (0, $d4b865e8cc459c1f$export$cd96dc6a09f60949)));
            if (editPageStarted) experience.succeed();
        }
    });
}
function $26ff900bc5da1ddf$var$startWhiteboardBoard(match) {
    const embeddedWhiteboardSubExperiences = [
        (0, $d4b865e8cc459c1f$export$bdaf5db6d84a5581)
    ];
    const whiteboardSubExperiences = [
        (0, $d4b865e8cc459c1f$export$bdaf5db6d84a5581),
        (0, $d4b865e8cc459c1f$export$7fd0425089f6d999),
        (0, $d4b865e8cc459c1f$export$5870dabed6d7b7fc),
        (0, $d4b865e8cc459c1f$export$47f14e5e827cfff3)
    ];
    const objectHeaderWhiteboardSubExperiences = [
        (0, $d4b865e8cc459c1f$export$bdaf5db6d84a5581),
        (0, $d4b865e8cc459c1f$export$7fd0425089f6d999)
    ];
    const subExperiences = (0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_frontend_content_wrapper') ? objectHeaderWhiteboardSubExperiences : whiteboardSubExperiences;
    const isEmbedded = (0, $213017de3b9c3542$export$9c21f25960873ecb)();
    const contentId = match.params.contentId;
    $26ff900bc5da1ddf$var$startSubExperiencesForMainExperience(contentId, (0, $d4b865e8cc459c1f$export$a83700d85c7e0745), isEmbedded ? embeddedWhiteboardSubExperiences : subExperiences);
}
function $26ff900bc5da1ddf$var$startDatabaseView(contentId) {
    const databaseSubExperiences = [
        (0, $d4b865e8cc459c1f$export$7140ccdb0c7b2b37),
        (0, $d4b865e8cc459c1f$export$7fd0425089f6d999),
        (0, $d4b865e8cc459c1f$export$5870dabed6d7b7fc)
    ];
    const objectHeaderDatabaseSubExperiences = [
        (0, $d4b865e8cc459c1f$export$7140ccdb0c7b2b37),
        (0, $d4b865e8cc459c1f$export$7fd0425089f6d999)
    ];
    const subExperiences = (0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_frontend_content_wrapper') ? objectHeaderDatabaseSubExperiences : databaseSubExperiences;
    const embeddedDatabaseSubExperiences = [
        (0, $d4b865e8cc459c1f$export$7140ccdb0c7b2b37)
    ];
    const isEmbedded = (0, $213017de3b9c3542$export$9c21f25960873ecb)();
    $26ff900bc5da1ddf$var$startSubExperiencesForMainExperience(contentId, (0, $d4b865e8cc459c1f$export$f02aef641190ead6), isEmbedded ? embeddedDatabaseSubExperiences : subExperiences);
}
function $26ff900bc5da1ddf$var$startSubExperiencesForMainExperience(contentId, mainExperience, subExperiences) {
    (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: mainExperience,
        collect: (events, experience)=>{
            (0, $e8536e8f091b0e90$export$feb7963ae429f97f)(subExperiences)(events, experience);
            $26ff900bc5da1ddf$var$stopOnNoPermissionOrNotFound(events, experience);
        },
        id: contentId,
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).DEFAULT
    });
    subExperiences.forEach((name)=>{
        (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
            name: name,
            id: contentId
        });
    });
}
function $26ff900bc5da1ddf$var$startEmbedPageView(contentId) {
    const embedPageSubExperiences = [
        (0, $d4b865e8cc459c1f$export$927658f514adba70),
        (0, $d4b865e8cc459c1f$export$7fd0425089f6d999),
        (0, $d4b865e8cc459c1f$export$5870dabed6d7b7fc)
    ];
    const objectHeaderEmbedSubExperiences = [
        (0, $d4b865e8cc459c1f$export$927658f514adba70),
        (0, $d4b865e8cc459c1f$export$7fd0425089f6d999)
    ];
    const subExperiences = (0, $3df4286e75ff1ab6$export$b40ec24ac8275656)('confluence_frontend_content_wrapper') ? objectHeaderEmbedSubExperiences : embedPageSubExperiences;
    (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$c85a8dac7f241add),
        collect: (events, experience)=>{
            (0, $e8536e8f091b0e90$export$feb7963ae429f97f)(subExperiences)(events, experience);
            $26ff900bc5da1ddf$var$stopOnNoPermissionOrNotFound(events, experience);
        },
        id: contentId,
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).DEFAULT
    });
    embedPageSubExperiences.forEach((name)=>{
        (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
            name: name,
            id: contentId
        });
    });
}
function $26ff900bc5da1ddf$var$startFolderView(contentId) {
    const folderSubExperiences = [
        (0, $d4b865e8cc459c1f$export$6237c6dbe5a63f05)
    ];
    (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$3485e62ad9c27d0b),
        collect: (events, experience)=>{
            (0, $e8536e8f091b0e90$export$feb7963ae429f97f)(folderSubExperiences)(events, experience);
            $26ff900bc5da1ddf$var$stopOnNoPermissionOrNotFound(events, experience);
        },
        id: contentId,
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).DEFAULT
    });
    folderSubExperiences.forEach((name)=>{
        (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
            name: name,
            id: contentId
        });
    });
}
function $26ff900bc5da1ddf$var$startViewAdminAnnouncementBannerSettings() {
    (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$394294e59b36efb9),
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).DEFAULT
    });
}
function $26ff900bc5da1ddf$var$startSpaceManager() {
    (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$548adb1a2fe6e6b1),
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).DEFAULT
    });
}
function $26ff900bc5da1ddf$var$startCompanyHomeBuilderLoad() {
    (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)().start({
        name: (0, $d4b865e8cc459c1f$export$c9f8ebbba8f73eeb),
        timeout: (0, $414efa7e97a6adf9$export$5e180a90f8d3e374).DEFAULT
    });
}
function $26ff900bc5da1ddf$var$finishLivePageExperiences() {
    const tracker = (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)();
    const livePageExperiencesToSucceed = [
        (0, $d4b865e8cc459c1f$export$dd70d6707192298e),
        (0, $d4b865e8cc459c1f$export$3814d28dd3802a02)
    ];
    livePageExperiencesToSucceed.forEach((experience)=>{
        const experienceState = tracker.getExperienceState(experience);
        // We want to identify if it's actively running, and if so, succeed it. This aligns with how we succeed non-live-page experiences on transition.
        // We validate the `isLivePage` attribute is `true` before succeeding, to avoid undesirably succeeding edit-page here when it's not a live page
        if (experienceState && !experienceState?.hasStopped && experienceState?.attributes?.isLivePage) tracker.succeed({
            name: experience
        });
    });
}


const $3016628fdaa9d06d$var$routeNamesThatRedirectToHome = [
    (0, $0d518026f9d519cf$export$9e15ff8aa6bc996f).name,
    (0, $0d518026f9d519cf$export$2fd309376969662f).name,
    (0, $0d518026f9d519cf$export$f178fb5b1e822288).name,
    (0, $0d518026f9d519cf$export$e9d78b13bbb4e56f).name
];
const $3016628fdaa9d06d$export$265842b0d6c0fe29 = (url, entryPoint)=>{
    const experienceTracker = (0, $dQwsT.useContext)((0, $15f344f9545a569e$export$a7b0697657ed8bd0));
    (0, $dQwsT.useEffect)(()=>{
        let routeMatch = (0, $64a554d15bd769f3$export$b6024a131a1561d9)((0, $4b957fb9fbb0eafa$export$d4971375353d0454), url);
        // If the route redirects to /home, convert the URL to a HOME URL
        if (!!routeMatch?.name && $3016628fdaa9d06d$var$routeNamesThatRedirectToHome.includes(routeMatch?.name)) {
            const routeQuery = routeMatch?.query;
            const routeHash = routeMatch?.hash;
            const homeUrl = (0, $0d518026f9d519cf$export$a7c5707626fc90f).toUrl(undefined, {
                query: routeQuery,
                hash: routeHash
            });
            routeMatch = (0, $64a554d15bd769f3$export$b6024a131a1561d9)((0, $4b957fb9fbb0eafa$export$d4971375353d0454), homeUrl);
        }
        if (routeMatch) {
            (0, $26ff900bc5da1ddf$export$cac1117e2433d80e)(routeMatch, 0);
            experienceTracker.fail({
                error: new Error('FATAL ERROR: Error SPA rendered'),
                attributes: {
                    entryPoint: entryPoint ?? 'unknown'
                }
            });
        }
    }, [
        experienceTracker,
        url,
        entryPoint
    ]);
};


const $279e71d7cd30ff83$export$f13ee9e4cfc1cf45 = ({ entryPoint: entryPoint })=>{
    const [isInitialized, setInitialized] = (0, $dQwsT.useState)(false);
    (0, $dQwsT.useEffect)(()=>{
        (0, $6d6794975d4b2dd0$export$66b82bc0ee0db41d)().then(()=>{
            setInitialized(true);
        });
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement((0, $15f344f9545a569e$export$a7b0697657ed8bd0).Provider, {
        value: (0, $fb98a59fbc7d7496$export$a1fa58e5690a5a9a)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement((0, $e435e378975f2891$export$b5ed68f0a0a58a22), null), isInitialized ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement($279e71d7cd30ff83$var$ExperienceFailureForRoot, {
        entryPoint: entryPoint
    }) : null);
};
const $279e71d7cd30ff83$var$ExperienceFailureForRoot = ({ entryPoint: entryPoint })=>{
    (0, $dQwsT.useEffect)(()=>{
        (0, $b76dfd1db5681318$export$e9ba7ef9458d1a4a)().then((client)=>client.sendScreenEvent({
                name: 'standaloneErrorApp'
            }));
    }, []);
    // eslint-disable-next-line no-restricted-syntax
    (0, $3016628fdaa9d06d$export$265842b0d6c0fe29)(window.location.href, entryPoint);
    return null;
};




/**
 * Please note this package is pre-compiled so you are required to
 * run `yarn build` and check-in the generated files in `prebuild` folder.
 */ /**
 * DO NOT ADD ANY ADDITIONAL LOGIC IN THIS FILE.
 * THIS FILE IS NOT ALWAYS LOADED WITH THE ERROR APP.
 *
 * If you need to add any logic to the error app, add it in the `ErrorApp` component or one of its children
 *
 * The Error App can either be rendered by EITHER:
 * 1. loading the prebuilt HTML, which requires this JS file (cc-proxy does this), or
 * 2. directly rendering the (loadable) <ErrorApp> component, which circumvents this JS file (the main
 * CFE SPA does this in `confluence-frontend-server/src/index.js`)
 */ // eslint-disable-next-line react/no-deprecated
(0, (/*@__PURE__*/$parcel$interopDefault($4339cd0fd1740902$exports))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dQwsT))).createElement((0, $279e71d7cd30ff83$export$f13ee9e4cfc1cf45), {
    entryPoint: "standaloneErrorApp"
}), document.getElementById('confluence-ui'));
 }, ["ktrqQ"]);

$parcel$global.rlb("kpJNO")
//# sourceMappingURL=error-app.528cf1ba.js.map
